/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(63);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouter = __webpack_require__(28);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	__webpack_require__(645);
	
	var _routes = __webpack_require__(640);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _configureStore = __webpack_require__(556);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _configureLanguages = __webpack_require__(555);
	
	var _configureLanguages2 = _interopRequireDefault(_configureLanguages);
	
	__webpack_require__(831);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(845); /* eslint-disable import/default */
	
	
	var store = (0, _configureStore2.default)();
	
	// determine the user browser language and set accordingly
	var browserLanguage = window.navigator.language;
	browserLanguage = browserLanguage.substring(0, 2);
	//if(browserLanguage === 'de')
	//{
	browserLanguage = 'de-DE';
	//} else {
	//	browserLanguage = 'en-US';
	//}
	
	// Configure the i18n translations
	(0, _configureLanguages2.default)(store, browserLanguage);
	
	// Create an enhanced history that syncs navigation events with the store
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	(0, _reactDom.render)(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(_reactRouter.Router, { history: history, routes: _routes2.default })
	), document.getElementById('app'));

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(162);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(967)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)(module)))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(10)
	  , core      = __webpack_require__(58)
	  , hide      = __webpack_require__(35)
	  , redefine  = __webpack_require__(36)
	  , ctx       = __webpack_require__(59)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.i18nReducer = exports.loadTranslations = exports.setLocale = exports.LOAD_TRANSLATIONS = exports.SET_LOCALE = exports.Localize = exports.Translate = exports.I18n = undefined;
	
	var _actions = __webpack_require__(482);
	
	Object.defineProperty(exports, 'SET_LOCALE', {
	  enumerable: true,
	  get: function get() {
	    return _actions.SET_LOCALE;
	  }
	});
	Object.defineProperty(exports, 'LOAD_TRANSLATIONS', {
	  enumerable: true,
	  get: function get() {
	    return _actions.LOAD_TRANSLATIONS;
	  }
	});
	Object.defineProperty(exports, 'setLocale', {
	  enumerable: true,
	  get: function get() {
	    return _actions.setLocale;
	  }
	});
	Object.defineProperty(exports, 'loadTranslations', {
	  enumerable: true,
	  get: function get() {
	    return _actions.loadTranslations;
	  }
	});
	
	var _reducer = __webpack_require__(1035);
	
	Object.defineProperty(exports, 'i18nReducer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reducer).default;
	  }
	});
	exports.syncTranslationWithStore = syncTranslationWithStore;
	
	var _reactI18nify = __webpack_require__(1031);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.I18n = _reactI18nify.I18n;
	exports.Translate = _reactI18nify.Translate;
	exports.Localize = _reactI18nify.Localize;
	function syncTranslationWithStore(store) {
	  _reactI18nify.I18n.setTranslationsGetter(function () {
	    try {
	      return store.getState().i18n.translations;
	    } catch (e) {
	      console.error('Error getting translations from store!');
	    }
	  });
	  _reactI18nify.I18n.setLocaleGetter(function () {
	    try {
	      return store.getState().i18n.locale;
	    } catch (e) {
	      console.error('Error getting locale from store!');
	    }
	  });
	}

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;
	
	var _flattenNames = __webpack_require__(1133);
	
	var _flattenNames2 = _interopRequireDefault(_flattenNames);
	
	var _mergeClasses = __webpack_require__(1135);
	
	var _mergeClasses2 = _interopRequireDefault(_mergeClasses);
	
	var _autoprefix = __webpack_require__(1130);
	
	var _autoprefix2 = _interopRequireDefault(_autoprefix);
	
	var _hover2 = __webpack_require__(1132);
	
	var _hover3 = _interopRequireDefault(_hover2);
	
	var _active = __webpack_require__(1131);
	
	var _active2 = _interopRequireDefault(_active);
	
	var _loop2 = __webpack_require__(1134);
	
	var _loop3 = _interopRequireDefault(_loop2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.hover = _hover3.default;
	exports.handleHover = _hover3.default;
	exports.handleActive = _active2.default;
	exports.loop = _loop3.default;
	var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
	  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    activations[_key - 1] = arguments[_key];
	  }
	
	  var activeNames = (0, _flattenNames2.default)(activations);
	  var merged = (0, _mergeClasses2.default)(classes, activeNames);
	  return (0, _autoprefix2.default)(merged);
	};
	
	exports.default = ReactCSS;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(15);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1036);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(1037);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule reactProdInvariant
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 10 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(39);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(535);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1185);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1184);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1183);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(534);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(536);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 14 */
[1196, 169, 579, 267, 580, 268],
/* 15 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 16 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(139)('wks')
	  , uid        = __webpack_require__(85)
	  , Symbol     = __webpack_require__(10).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Alpha = __webpack_require__(986);
	
	Object.defineProperty(exports, 'Alpha', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Checkboard = __webpack_require__(479);
	
	Object.defineProperty(exports, 'Checkboard', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkboard).default;
	  }
	});
	
	var _EditableInput = __webpack_require__(987);
	
	Object.defineProperty(exports, 'EditableInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EditableInput).default;
	  }
	});
	
	var _Hue = __webpack_require__(988);
	
	Object.defineProperty(exports, 'Hue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Saturation = __webpack_require__(989);
	
	Object.defineProperty(exports, 'Saturation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Saturation).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(480);
	
	Object.defineProperty(exports, 'ColorWrap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Swatch = __webpack_require__(990);
	
	Object.defineProperty(exports, 'Swatch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatch).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(486);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(485);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(1041);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(1040);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(13)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(7)
	  , IE8_DOM_DEFINE = __webpack_require__(295)
	  , toPrimitive    = __webpack_require__(52)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(21) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentTree
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMProperty = __webpack_require__(104);
	var ReactDOMComponentFlags = __webpack_require__(501);
	
	var invariant = __webpack_require__(6);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(68)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(1194);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.values = exports.untouch = exports.unregisterField = exports.touch = exports.SubmissionError = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.reset = exports.registerField = exports.reduxForm = exports.reducer = exports.propTypes = exports.hasSubmitFailed = exports.hasSubmitSucceeded = exports.isSubmitting = exports.isValid = exports.isPristine = exports.isInvalid = exports.isDirty = exports.initialize = exports.getFormSubmitErrors = exports.getFormAsyncErrors = exports.getFormSyncErrors = exports.getFormInitialValues = exports.getFormValues = exports.formValueSelector = exports.focus = exports.FormSection = exports.Form = exports.FieldArray = exports.Fields = exports.Field = exports.destroy = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = exports.actionTypes = undefined;
	
	var _createAll2 = __webpack_require__(1146);
	
	var _createAll3 = _interopRequireDefault(_createAll2);
	
	var _plain = __webpack_require__(75);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _createAll = (0, _createAll3.default)(_plain2.default);
	
	var actionTypes = _createAll.actionTypes,
	    arrayInsert = _createAll.arrayInsert,
	    arrayMove = _createAll.arrayMove,
	    arrayPop = _createAll.arrayPop,
	    arrayPush = _createAll.arrayPush,
	    arrayRemove = _createAll.arrayRemove,
	    arrayRemoveAll = _createAll.arrayRemoveAll,
	    arrayShift = _createAll.arrayShift,
	    arraySplice = _createAll.arraySplice,
	    arraySwap = _createAll.arraySwap,
	    arrayUnshift = _createAll.arrayUnshift,
	    autofill = _createAll.autofill,
	    blur = _createAll.blur,
	    change = _createAll.change,
	    destroy = _createAll.destroy,
	    Field = _createAll.Field,
	    Fields = _createAll.Fields,
	    FieldArray = _createAll.FieldArray,
	    Form = _createAll.Form,
	    FormSection = _createAll.FormSection,
	    focus = _createAll.focus,
	    formValueSelector = _createAll.formValueSelector,
	    getFormValues = _createAll.getFormValues,
	    getFormInitialValues = _createAll.getFormInitialValues,
	    getFormSyncErrors = _createAll.getFormSyncErrors,
	    getFormAsyncErrors = _createAll.getFormAsyncErrors,
	    getFormSubmitErrors = _createAll.getFormSubmitErrors,
	    initialize = _createAll.initialize,
	    isDirty = _createAll.isDirty,
	    isInvalid = _createAll.isInvalid,
	    isPristine = _createAll.isPristine,
	    isValid = _createAll.isValid,
	    isSubmitting = _createAll.isSubmitting,
	    hasSubmitSucceeded = _createAll.hasSubmitSucceeded,
	    hasSubmitFailed = _createAll.hasSubmitFailed,
	    propTypes = _createAll.propTypes,
	    reducer = _createAll.reducer,
	    reduxForm = _createAll.reduxForm,
	    registerField = _createAll.registerField,
	    reset = _createAll.reset,
	    setSubmitFailed = _createAll.setSubmitFailed,
	    setSubmitSucceeded = _createAll.setSubmitSucceeded,
	    startAsyncValidation = _createAll.startAsyncValidation,
	    startSubmit = _createAll.startSubmit,
	    stopAsyncValidation = _createAll.stopAsyncValidation,
	    stopSubmit = _createAll.stopSubmit,
	    submit = _createAll.submit,
	    SubmissionError = _createAll.SubmissionError,
	    touch = _createAll.touch,
	    unregisterField = _createAll.unregisterField,
	    untouch = _createAll.untouch,
	    values = _createAll.values;
	exports.actionTypes = actionTypes;
	exports.arrayInsert = arrayInsert;
	exports.arrayMove = arrayMove;
	exports.arrayPop = arrayPop;
	exports.arrayPush = arrayPush;
	exports.arrayRemove = arrayRemove;
	exports.arrayRemoveAll = arrayRemoveAll;
	exports.arrayShift = arrayShift;
	exports.arraySplice = arraySplice;
	exports.arraySwap = arraySwap;
	exports.arrayUnshift = arrayUnshift;
	exports.autofill = autofill;
	exports.blur = blur;
	exports.change = change;
	exports.destroy = destroy;
	exports.Field = Field;
	exports.Fields = Fields;
	exports.FieldArray = FieldArray;
	exports.Form = Form;
	exports.FormSection = FormSection;
	exports.focus = focus;
	exports.formValueSelector = formValueSelector;
	exports.getFormValues = getFormValues;
	exports.getFormInitialValues = getFormInitialValues;
	exports.getFormSyncErrors = getFormSyncErrors;
	exports.getFormAsyncErrors = getFormAsyncErrors;
	exports.getFormSubmitErrors = getFormSubmitErrors;
	exports.initialize = initialize;
	exports.isDirty = isDirty;
	exports.isInvalid = isInvalid;
	exports.isPristine = isPristine;
	exports.isValid = isValid;
	exports.isSubmitting = isSubmitting;
	exports.hasSubmitSucceeded = hasSubmitSucceeded;
	exports.hasSubmitFailed = hasSubmitFailed;
	exports.propTypes = propTypes;
	exports.reducer = reducer;
	exports.reduxForm = reduxForm;
	exports.registerField = registerField;
	exports.reset = reset;
	exports.setSubmitFailed = setSubmitFailed;
	exports.setSubmitSucceeded = setSubmitSucceeded;
	exports.startAsyncValidation = startAsyncValidation;
	exports.startSubmit = startSubmit;
	exports.stopAsyncValidation = stopAsyncValidation;
	exports.stopSubmit = stopSubmit;
	exports.submit = submit;
	exports.SubmissionError = SubmissionError;
	exports.touch = touch;
	exports.unregisterField = unregisterField;
	exports.untouch = untouch;
	exports.values = values;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(45);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(72);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(228);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(102);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1049);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(487);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1043);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1062);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1044);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1045);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(488);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1047);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(1042);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(1046);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(1048);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(1061);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(158);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(1050);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(1059);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(493);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1052);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1053);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1057);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(490);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 29 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ACCESS_CARE_SHEETS = exports.ACCESS_CARE_SHEETS = 'AccessCareSheets';
	var ACCESS_LABELS = exports.ACCESS_LABELS = 'AccessLabels';
	var MANAGE_ARTICLES = exports.MANAGE_ARTICLES = 'ManageArticles';
	var MANAGE_LOGO = exports.MANAGE_LOGO = 'ManageLogo';
	var MANAGE_CARE_SHEET_ADS = exports.MANAGE_CARE_SHEET_ADS = 'ManageCareSheetAds';

/***/ },
/* 30 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 31 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 32 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setGridSorting = setGridSorting;
	exports.setLabelIndex = setLabelIndex;
	exports.selectLabel = selectLabel;
	exports.getPetLabelList = getPetLabelList;
	exports.petLabelListReload = petLabelListReload;
	exports.petLabelPriceUpdate = petLabelPriceUpdate;
	exports.toggleSelectedPetType = toggleSelectedPetType;
	exports.searchPetLabels = searchPetLabels;
	exports.clearSearchResults = clearSearchResults;
	exports.selectPetLabel = selectPetLabel;
	exports.deselectPetLabel = deselectPetLabel;
	exports.clearActiveLabel = clearActiveLabel;
	exports.getPetLabel = getPetLabel;
	exports.getDefinitions = getDefinitions;
	exports.selectLabelSize = selectLabelSize;
	exports.saveLabelToSheet = saveLabelToSheet;
	exports.quickSaveLabelToSheet = quickSaveLabelToSheet;
	exports.hideLabelModal = hideLabelModal;
	exports.clearLabelSheet = clearLabelSheet;
	exports.togglePLU = togglePLU;
	exports.deleteLabel = deleteLabel;
	exports.editLabel = editLabel;
	exports.getCustomDefinitions = getCustomDefinitions;
	exports.selectCustomLabel = selectCustomLabel;
	exports.getArticleList = getArticleList;
	exports.updateLabelArticle = updateLabelArticle;
	exports.sortArticles = sortArticles;
	exports.clearArticleFilters = clearArticleFilters;
	exports.addArticleFilter = addArticleFilter;
	exports.addArticleMapping = addArticleMapping;
	exports.deleteArticleMapping = deleteArticleMapping;
	exports.uploadExcelFile = uploadExcelFile;
	exports.saveLabelStyles = saveLabelStyles;
	exports.uploadLogo = uploadLogo;
	exports.savePageSetup = savePageSetup;
	exports.createCalibrationLink = createCalibrationLink;
	exports.disableLabelAdd = disableLabelAdd;
	exports.enableLabelAdd = enableLabelAdd;
	exports.saveLabelSettings = saveLabelSettings;
	
	var _axios = __webpack_require__(122);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _v = __webpack_require__(1193);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _apiEndpoints = __webpack_require__(76);
	
	var endpoints = _interopRequireWildcard(_apiEndpoints);
	
	var _actionTypes = __webpack_require__(269);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _selectors = __webpack_require__(57);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _customer$selectors = _customer2.default.selectors,
	    getActiveSubscriptionId = _customer$selectors.getActiveSubscriptionId,
	    getUserName = _customer$selectors.getUserName;
	function setGridSorting(isSorting) {
	  return {
	    type: types.SET_GRID_SORTING,
	    payload: {
	      isSorting: isSorting
	    }
	  };
	}
	
	function setLabelIndex(oldIndex, newIndex) {
	  return function (dispatch) {
	    dispatch({
	      type: types.SET_LABEL_INDEX,
	      payload: {
	        oldIndex: oldIndex,
	        newIndex: newIndex
	      }
	    });
	    dispatch(prepareComposition());
	  };
	}
	
	function selectLabel(index) {
	  return {
	    type: types.SELECT_LABEL,
	    payload: {
	      index: index
	    }
	  };
	}
	
	function getPetLabelList() {
	  return function (dispatch, getStore) {
	    dispatch({
	      type: types.GET_LABEL_PET_LIST
	    });
	
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    _axios2.default.get(endpoints.LABEL_ALL_PETS + '?subscriptionID=' + subscriptionId).then(function (response) {
	      // Clear nulls
	      response.data.forEach(function (petLabel) {
	        Object.keys(petLabel).forEach(function (key) {
	          if (petLabel[key] === null) {
	            petLabel[key] = '';
	          }
	        });
	      });
	
	      dispatch(petLabelListReceived(response.data));
	      dispatch(parsePetTypes(response.data));
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function petLabelListReceived(petLabels) {
	  return function (dispatch) {
	    dispatch({
	      type: types.PET_LABEL_LIST_RECEIVED,
	      payload: {
	        petLabels: petLabels
	      }
	    });
	  };
	}
	
	function petLabelListReload(isValid) {
	  return function (dispatch) {
	    dispatch({
	      type: types.PET_LABEL_LIST_RELOAD,
	      payload: {
	        isValid: isValid
	      }
	    });
	  };
	}
	
	function petLabelPriceUpdate(label, price) {
	  return function (dispatch) {
	    dispatch({
	      type: types.PET_LABEL_PRICE_UPDATE,
	      payload: {
	        label: label,
	        price: price
	      }
	    });
	  };
	}
	
	function parsePetTypes(petLabelList) {
	  return function (dispatch) {
	    var petTypeSet = new Set([]);
	    petLabelList.forEach(function (petLabel) {
	      petTypeSet.add(petLabel.PetType);
	    });
	
	    var petTypeList = [];
	    petTypeSet.forEach(function (petType) {
	      petTypeList.push(petType);
	    });
	
	    dispatch({
	      type: types.PET_TYPES_ADDED,
	      payload: {
	        petTypes: petTypeList,
	        selectedPetTypes: petTypeList
	      }
	    });
	  };
	}
	
	function toggleSelectedPetType(petType) {
	  return function (dispatch) {
	    dispatch({
	      type: types.TOGGLE_SELECTED_PET_TYPE,
	      payload: {
	        petType: petType
	      }
	    });
	    dispatch(filterPetLabels());
	  };
	}
	
	function setSearchPhrase(searchPhrase) {
	  return {
	    type: types.LABELS_SEARCH_PHRASE,
	    payload: {
	      searchPhrase: searchPhrase
	    }
	  };
	}
	
	function searchPetLabels(searchPhrase) {
	  return function (dispatch) {
	    dispatch(setSearchPhrase(searchPhrase));
	    dispatch(filterPetLabels());
	  };
	}
	
	function filterPetLabels() {
	  return {
	    type: types.FILTER_PET_LABELS
	  };
	}
	
	function clearSearchResults() {
	  return {
	    type: types.CLEAR_SEARCH_RESULTS
	  };
	}
	
	function selectPetLabel(petLabelId, articleMappingId) {
	  return {
	    type: types.SELECT_PET_LABEL,
	    payload: {
	      petLabelId: petLabelId,
	      articleMappingId: articleMappingId
	    }
	  };
	}
	
	function deselectPetLabel() {
	  return {
	    type: types.DESELECT_PET_LABEL
	  };
	}
	
	function clearActiveLabel() {
	  return {
	    type: types.CLEAR_ACTIVE_LABEL
	  };
	}
	
	function getPetLabel(petLabelId, activePageSize, articleMappingId) {
	  return function (dispatch, getStore) {
	    dispatch({
	      type: types.GET_PET_LABEL
	    });
	
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    _axios2.default.get(endpoints.LABEL_PET + '?subscriptionID=' + subscriptionId + '&labelName=' + activePageSize + '&petID=' + petLabelId + '&articleMappingEntryID=' + articleMappingId).then(function (response) {
	      dispatch({
	        type: types.PET_LABEL_RECEIVED,
	        payload: {
	          petLabel: response.data
	        }
	      });
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function getDefinitions() {
	  return function (dispatch, getStore) {
	    dispatch({
	      type: types.GET_LABEL_DEFINITIONS
	    });
	
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    _axios2.default.get(endpoints.LABEL_DEFINITIONS + '?subscriptionID=' + subscriptionId).then(function (response) {
	      dispatch({
	        type: types.LABEL_DEFINITIONS_RECEIVED,
	        payload: {
	          definitions: response.data
	        }
	      });
	      dispatch(selectLabelSize(response.data[0].LabelName));
	      dispatch(getCustomDefinitions(response.data[0].LabelName));
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function selectLabelSize(labelSize) {
	  return function (dispatch) {
	    var pdfId = (0, _v2.default)();
	    dispatch({
	      type: types.SELECT_LABEL_SIZE,
	      payload: {
	        labelSize: labelSize,
	        pdfId: pdfId
	      }
	    });
	    dispatch(prepareComposition());
	  };
	}
	
	function saveLabelToSheet(activePageSize, activePetLabel, fieldMapping, activePLU, values) {
	  return function (dispatch, getStore) {
	    var label = JSON.parse(JSON.stringify(activePetLabel));
	    label.Line1 = values.line1;
	    label.Line2 = values.line2;
	    label.Price = values.price;
	    label.Barcode = values.barcode;
	    label.PLUCodeTitle = values.pluKey;
	
	    if (activePLU) {
	      label.PLUCode = values.plu;
	    } else {
	      label.PLUCode = null;
	    }
	
	    fieldMapping.forEach(function (mapping) {
	      var field = label.DetailFields.find(function (detailField) {
	        return detailField.Key === mapping.name;
	      });
	      field.OverwrittenKey = values[mapping.key];
	      field.OverwrittenValue = values[mapping.value];
	    });
	
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    var articleMappingID = activePetLabel.ArticleMappingEntryID;
	    _axios2.default.post(endpoints.LABEL_CREATE_AS_JPG + '?subscriptionID=' + subscriptionId + '&labelName=' + activePageSize + '&articleMappingEntryID=' + articleMappingID, label, { responseType: 'blob' }).then(function (response) {
	      var urlCreator = window.URL || window.webkitURL;
	      var imageUrl = urlCreator.createObjectURL(response.data);
	      dispatch({
	        type: types.SAVE_LABEL_TO_SHEET,
	        payload: {
	          imageUrl: imageUrl,
	          label: label
	        }
	      });
	
	      if (values.price) dispatch(petLabelPriceUpdate(activePetLabel, values.price));
	
	      dispatch(clearSearchResults());
	      dispatch(deselectPetLabel());
	      dispatch(clearActiveLabel());
	      dispatch(prepareComposition());
	      dispatch((0, _reactRouterRedux.push)('/labels'));
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function quickSaveLabelToSheet(activePageSize, activePetLabel, price, activePLU) {
	  return function (dispatch, getStore) {
	    var label = JSON.parse(JSON.stringify(activePetLabel));
	    label.Price = price;
	
	    if (activePLU) {
	      label.PLUCode = activePetLabel.PLUCode;
	    } else {
	      label.PLUCode = null;
	    }
	
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    var articleMappingID = activePetLabel.ArticleMappingEntryID;
	
	    _axios2.default.get(endpoints.LABEL_PET + '?subscriptionID=' + subscriptionId + '&labelName=' + activePageSize + '&petID=' + activePetLabel.Id + '&articleMappingEntryID=' + activePetLabel.ArticleMappingEntryID).then(function (response) {
	      label.DetailFields = response.data.DetailFields;
	      //
	      label.Line1 = response.data.Line1;
	      label.Line2 = response.data.Line2;
	      label.PLUCodeTitle = response.data.PLUCodeTitle;
	      //
	      _axios2.default.post(endpoints.LABEL_CREATE_AS_JPG + '?subscriptionID=' + subscriptionId + '&labelName=' + activePageSize + '&articleMappingEntryID=' + articleMappingID, label, { responseType: 'blob' }).then(function (response) {
	        var urlCreator = window.URL || window.webkitURL;
	        var imageUrl = urlCreator.createObjectURL(response.data);
	
	        dispatch({
	          type: types.SAVE_LABEL_TO_SHEET,
	          payload: {
	            imageUrl: imageUrl,
	            label: label
	          }
	        });
	
	        if (price) dispatch(petLabelPriceUpdate(activePetLabel, price));
	
	        dispatch(prepareComposition());
	        dispatch({
	          type: types.SHOW_LABEL_MODAL
	        });
	
	        dispatch({
	          type: types.SELECT_NEXT_LABEL
	        });
	      }).catch(function () {
	        dispatch({ type: types.SHOW_ERROR_MODAL });
	      });
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function hideLabelModal() {
	  return {
	    type: types.HIDE_LABEL_MODAL
	  };
	}
	
	function clearLabelSheet() {
	  return function (dispatch) {
	    dispatch({ type: types.CLEAR_LABEL_SHEET });
	    dispatch(prepareComposition());
	  };
	}
	
	function togglePLU() {
	  return function (dispatch) {
	    dispatch({ type: types.TOGGLE_PLU_ACTIVE });
	    dispatch(clearLabelSheet());
	  };
	}
	
	function deleteLabel(gridIndex) {
	  return function (dispatch) {
	    dispatch({
	      type: types.DELETE_LABEL_FROM_SHEET,
	      payload: {
	        gridIndex: gridIndex
	      }
	    });
	    dispatch(prepareComposition());
	  };
	}
	
	function editLabel(gridIndex) {
	  return function (dispatch) {
	    dispatch({
	      type: types.EDIT_EXISTING_LABEL,
	      payload: {
	        gridIndex: gridIndex
	      }
	    });
	    dispatch((0, _reactRouterRedux.push)('/edit_label'));
	  };
	}
	
	function getCustomDefinitions(activePageSize) {
	  return function (dispatch, getStore) {
	    dispatch({
	      type: types.GET_CUSTOM_DEFINITIONS
	    });
	
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    _axios2.default.get(endpoints.LABEL_CUSTOM_DEFINITIONS + '?subscriptionID=' + subscriptionId + '&labelName=' + activePageSize).then(function (response) {
	      dispatch({
	        type: types.CUSTOM_DEFINITIONS_RECEIVED,
	        payload: {
	          definitions: response.data
	        }
	      });
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function selectCustomLabel(petType) {
	  return {
	    type: types.SELECT_CUSTOM_LABEL,
	    payload: {
	      petType: petType
	    }
	  };
	}
	
	function prepareComposition() {
	  return function (dispatch, getStore) {
	    var labelSheet = [];
	    var storeLabels = (0, _selectors.getLabels)(getStore());
	    storeLabels.forEach(function (label, index) {
	      if (label.hasOwnProperty('data')) {
	        var finalLabel = {
	          Key: index,
	          Value: label.data
	        };
	        labelSheet.push(finalLabel);
	      }
	    });
	
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    var activePageSize = (0, _selectors.getActivePageSize)(getStore());
	    var pdfId = (0, _selectors.getPdfId)(getStore());
	
	    _axios2.default.post(endpoints.LABEL_PREPARE_COMPOSITION + '?subscriptionID=' + subscriptionId + '&labelName=' + activePageSize + '&urlkey=' + pdfId, labelSheet).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function getArticleList() {
	  return function (dispatch, getStore) {
	    dispatch({
	      type: types.GET_ARTICLE_LIST
	    });
	
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    _axios2.default.get(endpoints.LABEL_ALL_PETS + '?subscriptionID=' + subscriptionId + '&excludeInternalBarcodes=true').then(function (response) {
	      // Clear nulls
	      response.data.forEach(function (petLabel) {
	        Object.keys(petLabel).forEach(function (key) {
	          if (petLabel[key] === null) {
	            petLabel[key] = '';
	          }
	        });
	      });
	
	      dispatch(articleListReceived(response.data));
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function articleListReceived(petLabels) {
	  return {
	    type: types.ARTICLE_LIST_RECEIVED,
	    payload: {
	      petLabels: petLabels
	    }
	  };
	}
	
	function updateLabelArticle(petLabel, key, value) {
	  return function (dispatch, getStore) {
	    var label = JSON.parse(JSON.stringify(petLabel));
	    label[key] = value;
	
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    var updatedMapping = {
	      SubscriptionId: subscriptionId,
	      ArticleMappingEntryID: label.ArticleMappingEntryID,
	      PetId: label.Id,
	      CustomerName: label.CustomerName,
	      Price: label.Price,
	      PLUCode: label.PLUCode,
	      Barcode: label.Barcode
	    };
	
	    _axios2.default.post('' + endpoints.ARTICLE_UPDATE_MAPPING, updatedMapping).then(function (response) {
	      var responseLabel = JSON.parse(JSON.stringify(response.data));
	      Object.keys(responseLabel).forEach(function (key) {
	        if (responseLabel[key] === null) {
	          responseLabel[key] = '';
	        }
	      });
	
	      dispatch({
	        type: types.UPDATE_LABEL_ARTICLE,
	        payload: {
	          label: responseLabel
	        }
	      });
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	
	    // This is to keep the value from flashing before we receive the server response.
	    dispatch({
	      type: types.UPDATE_LABEL_ARTICLE,
	      payload: {
	        label: label
	      }
	    });
	  };
	}
	
	function sortArticles(sortColumn, sortDirection) {
	  return {
	    type: types.SORT_ARTICLE_COLUMN,
	    payload: {
	      sortColumn: sortColumn,
	      sortDirection: sortDirection
	    }
	  };
	}
	
	function clearArticleFilters() {
	  return {
	    type: types.CLEAR_ARTICLE_FILTERS
	  };
	}
	
	function addArticleFilter(column, value) {
	  return {
	    type: types.ADD_ARTICLE_FILTER,
	    payload: {
	      column: column,
	      value: value
	    }
	  };
	}
	
	function addArticleMapping(baseArticle) {
	  return function (dispatch, getStore) {
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    var updatedMapping = {
	      SubscriptionId: subscriptionId,
	      PetId: baseArticle.Id,
	      CustomerName: baseArticle.CustomerName,
	      Price: baseArticle.Price,
	      PLUCode: baseArticle.PLUCode,
	      Barcode: baseArticle.Barcode
	    };
	
	    _axios2.default.post('' + endpoints.ARTICLE_ADD_MAPPING, updatedMapping).then(function (response) {
	
	      var responseLabel = JSON.parse(JSON.stringify(response.data));
	      Object.keys(responseLabel).forEach(function (key) {
	        if (responseLabel[key] === null) {
	          responseLabel[key] = '';
	        }
	      });
	
	      dispatch({
	        type: types.ADD_ARTICLE_MAPPING,
	        payload: {
	          article: responseLabel
	        }
	      });
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function deleteArticleMapping(article) {
	  return function (dispatch, getStore) {
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    var removeMapping = {
	      SubscriptionId: subscriptionId,
	      ArticleMappingEntryID: article.ArticleMappingEntryID,
	      PetId: article.Id
	    };
	
	    _axios2.default.post('' + endpoints.ARTICLE_DELETE_MAPPING, removeMapping).then(function () {
	      dispatch({
	        type: types.DELETE_ARTICLE_MAPPING,
	        payload: {
	          article: article
	        }
	      });
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function uploadExcelFile(file) {
	  return function (dispatch, getStore) {
	    dispatch({
	      type: types.UPLOAD_EXCEL_MAPPINGS
	    });
	
	    var fd = new FormData();
	    fd.append('filename', file);
	    var config = { headers: { 'Content-Type': 'multipart/form-data' } };
	
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    _axios2.default.post(endpoints.ARTICLE_EXCEL_UPLOAD + '?subscriptionID=' + subscriptionId, fd, config).then(function () {
	      dispatch({
	        type: types.UPLOAD_MAPPINGS_SUCCESS
	      });
	
	      dispatch(getArticleList());
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function saveLabelStyles(activeDefinition, styleElements) {
	  return function (dispatch, getStore) {
	    var definitionElements = JSON.parse(JSON.stringify(activeDefinition.StyleElements));
	    for (var index = 0; index < definitionElements.length; index++) {
	      switch (definitionElements[index].Name) {
	        case 'labelborder':
	          {
	            definitionElements[index].ColorCode = styleElements.labelBorderColor;
	            break;
	          }
	        case 'background':
	          {
	            definitionElements[index].ColorCode = styleElements.labelBgColor;
	            break;
	          }
	        case 'headerbackground':
	          {
	            definitionElements[index].ColorCode = styleElements.headerBgColor;
	            break;
	          }
	        case 'headercolor':
	          {
	            definitionElements[index].ColorCode = styleElements.headerFontColor;
	            break;
	          }
	        case 'detailtitlebackground':
	          {
	            definitionElements[index].ColorCode = styleElements.detailBgColor;
	            break;
	          }
	        case 'detailtitlecolor':
	          {
	            definitionElements[index].ColorCode = styleElements.detailFontColor;
	            break;
	          }
	        case 'detailvaluebackground':
	          {
	            definitionElements[index].ColorCode = styleElements.valueBgColor;
	            break;
	          }
	        case 'detailvaluecolor':
	          {
	            definitionElements[index].ColorCode = styleElements.valueFontColor;
	            break;
	          }
	        case 'pricecolor':
	          {
	            definitionElements[index].ColorCode = styleElements.priceFontColor;
	            break;
	          }
	        case 'pricebackground':
	          {
	            definitionElements[index].ColorCode = styleElements.priceBgColor;
	            break;
	          }
	        case 'pluprice':
	          {
	            definitionElements[index].ColorCode = styleElements.pluFontColor;
	            break;
	          }
	        case 'barcodebackground':
	          {
	            definitionElements[index].ColorCode = styleElements.barCodeBgColor;
	            break;
	          }
	        case 'imageborder':
	          {
	            definitionElements[index].ColorCode = styleElements.imageBorderColor;
	            break;
	          }
	        case 'rightbackground':
	          {
	            definitionElements[index].ColorCode = styleElements.rightPanelBgColor;
	            break;
	          }
	      }
	    }
	
	    var styles = {
	      'Styles': {}
	    };
	    styles.Styles[activeDefinition.LabelName] = definitionElements;
	
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    _axios2.default.post(endpoints.CUSTOMIZE_LABEL_SETTINGS + '?subscriptionID=' + subscriptionId, styles).then(function (response) {
	      dispatch({
	        type: types.UPDATE_LABEL_STYLES,
	        payload: {
	          LabelStyles: response.data.LabelSettings.Styles
	        }
	      });
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function uploadLogo(activePageSize, file) {
	  return function (dispatch, getStore) {
	    var subscriptionId = getActiveSubscriptionId(getStore());
	
	    var fd = new FormData();
	    fd.append('filename', file);
	    var config = { headers: { 'Content-Type': 'multipart/form-data' } };
	
	    _axios2.default.post(endpoints.UPLOAD_LABEL_LOGO + '?subscriptionID=' + subscriptionId + '&labelName=' + activePageSize, fd, config).then(function (response) {
	      dispatch({
	        type: types.UPDATE_LABEL_LOGOS,
	        payload: {
	          LabelLogos: response.data.Logos
	        }
	      });
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function savePageSetup(activePageSize, verticalOffset, horizontalOffset) {
	  return function (dispatch, getStore) {
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    var pageOffsets = {
	      'PageRenderingPositionOffset': {
	        'PosX': horizontalOffset,
	        'PosY': verticalOffset
	      }
	    };
	
	    _axios2.default.post(endpoints.CUSTOMIZE_LABEL_SETTINGS + '?subscriptionID=' + subscriptionId, pageOffsets).then(function (response) {
	      dispatch({
	        type: types.UPDATE_LABEL_OFFSET,
	        payload: {
	          pageOffset: response.data.LabelSettings.PageRenderingPositionOffset
	        }
	      });
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function createCalibrationLink() {
	  return function (dispatch, getStore) {
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    var userName = getUserName(getStore());
	    var pdfLink = endpoints.CALIBRATION_GET_PDF + '?subscriptionID=' + subscriptionId + '&userid=' + userName;
	
	    dispatch({
	      type: types.CALIBRATION_PDF_LINK,
	      payload: {
	        link: pdfLink
	      }
	    });
	  };
	}
	
	function disableLabelAdd() {
	  return {
	    type: types.DISABLE_LABEL_ADD
	  };
	}
	
	function enableLabelAdd() {
	  return {
	    type: types.ENABLE_LABEL_ADD
	  };
	}
	
	function saveLabelSettings(isPaperSizeLetter, usePLUCode, useUSMetrics, labelTitleOrder, verticalOffset, horizontalOffset) {
	  return function (dispatch, getStore) {
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    var updateData = {
	      'PageRenderingPositionOffset': {
	        'PosX': horizontalOffset,
	        'PosY': verticalOffset
	      },
	      'IsPaperSizeLetter': isPaperSizeLetter,
	      'UsePLUCode': usePLUCode,
	      'UseUSMetrics': useUSMetrics,
	      'LabelTitleOrder': labelTitleOrder
	    };
	
	    _axios2.default.post(endpoints.CUSTOMIZE_LABEL_SETTINGS + '?subscriptionID=' + subscriptionId, updateData).then(function (response) {
	      dispatch({
	        type: types.UPDATE_LABEL_OFFSET,
	        payload: {
	          pageOffset: response.data.LabelSettings.PageRenderingPositionOffset,
	
	          isPaperSizeLetter: response.data.LabelSettings.IsPaperSizeLetter,
	
	          usePLUCode: response.data.LabelSettings.UsePLUCode,
	
	          useUSMetrics: response.data.LabelSettings.UseUSMetrics,
	
	          labelTitleOrder: response.data.LabelSettings.LabelTitleOrder
	
	        }
	      });
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}

/***/ },
/* 34 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(22)
	  , createDesc = __webpack_require__(67);
	module.exports = __webpack_require__(21) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(10)
	  , hide      = __webpack_require__(35)
	  , has       = __webpack_require__(32)
	  , SRC       = __webpack_require__(85)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(58).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	  , fails   = __webpack_require__(13)
	  , defined = __webpack_require__(45)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(109)
	  , defined = __webpack_require__(45);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 39 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(260);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(110)
	  , createDesc     = __webpack_require__(67)
	  , toIObject      = __webpack_require__(38)
	  , toPrimitive    = __webpack_require__(52)
	  , has            = __webpack_require__(32)
	  , IE8_DOM_DEFINE = __webpack_require__(295)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(21) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(32)
	  , toObject    = __webpack_require__(27)
	  , IE_PROTO    = __webpack_require__(190)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 43 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 44 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 45 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(13);
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(342);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstrumentation
	 */
	
	'use strict';
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormInput = function FormInput(_ref) {
	  var className = _ref.className,
	      input = _ref.input,
	      placeholder = _ref.placeholder,
	      ref = _ref.ref,
	      type = _ref.type,
	      id = _ref.id;
	  return _react2.default.createElement('input', _extends({}, input, {
	    id: id,
	    type: type,
	    className: className,
	    placeholder: placeholder,
	    ref: ref
	  }));
	};
	
	exports.default = FormInput;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(59)
	  , IObject  = __webpack_require__(109)
	  , toObject = __webpack_require__(27)
	  , toLength = __webpack_require__(24)
	  , asc      = __webpack_require__(648);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(3)
	  , core    = __webpack_require__(58)
	  , fails   = __webpack_require__(13);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(15);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactCurrentOwner = __webpack_require__(74);
	
	var warning = __webpack_require__(11);
	var canDefineProperty = __webpack_require__(515);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	    var shadowChildren = Array.isArray(props.children) ? props.children.slice(0) : props.children;
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      Object.defineProperty(element, '_shadowChildren', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: shadowChildren
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._shadowChildren = shadowChildren;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	ReactElement.REACT_ELEMENT_TYPE = REACT_ELEMENT_TYPE;
	
	module.exports = ReactElement;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(16);
	
	var CallbackQueue = __webpack_require__(496);
	var PooledClass = __webpack_require__(73);
	var ReactFeatureFlags = __webpack_require__(504);
	var ReactReconciler = __webpack_require__(106);
	var Transaction = __webpack_require__(121);
	
	var invariant = __webpack_require__(6);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.props === component._renderedComponent._currentElement) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var _Mathround=Math.round,_Mathmin=Math.min,_Mathmax=Math.max;(function(d,g){ true?g(exports,__webpack_require__(1),__webpack_require__(63),__webpack_require__(975),__webpack_require__(974)):'function'==typeof define&&define.amd?define(['exports','react','react-dom','react-addons-transition-group','react-addons-css-transition-group'],g):g(d.Reactstrap=d.Reactstrap||{},d.React,d.ReactDOM,d.React.addons.TransitionGroup,d.React.addons.CSSTransitionGroup)})(this,function(d,g,m,h,y){'use strict';function v(){throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs')}function N(Qr,ei){return ei={exports:{}},Qr(ei,ei.exports),ei.exports}function C(Qr){var ei={};return ei='top'===Qr||'top center'===Qr?{attachment:'bottom center',targetAttachment:'top center'}:'bottom'===Qr||'bottom center'===Qr?{attachment:'top center',targetAttachment:'bottom center'}:'left'===Qr||'left center'===Qr?{attachment:'middle right',targetAttachment:'middle left'}:'right'===Qr||'right center'===Qr?{attachment:'middle left',targetAttachment:'middle right'}:'top left'===Qr?{attachment:'bottom left',targetAttachment:'top left'}:'top right'===Qr?{attachment:'bottom right',targetAttachment:'top right'}:'bottom left'===Qr?{attachment:'top left',targetAttachment:'bottom left'}:'bottom right'===Qr?{attachment:'top right',targetAttachment:'bottom right'}:'right top'===Qr?{attachment:'top left',targetAttachment:'top right'}:'right bottom'===Qr?{attachment:'bottom left',targetAttachment:'bottom right'}:'left top'===Qr?{attachment:'top right',targetAttachment:'top left'}:'left bottom'===Qr?{attachment:'bottom right',targetAttachment:'bottom left'}:{attachment:'top center',targetAttachment:'bottom center'},ei}function M(){var Qr=document.createElement('div');Qr.style.position='absolute',Qr.style.top='-9999px',Qr.style.width='50px',Qr.style.height='50px',Qr.style.overflow='scroll',document.body.appendChild(Qr);var ei=Qr.offsetWidth-Qr.clientWidth;return document.body.removeChild(Qr),ei}function _(Qr){document.body.style.paddingRight=0<Qr?Qr+'px':null}function O(){return document.body.clientWidth<window.innerWidth}function E(){return parseInt(window.getComputedStyle(document.body,null).getPropertyValue('padding-right')||0,10)}function P(){var Qr=M(),ei=document.querySelectorAll('.navbar-fixed-top, .navbar-fixed-bottom, .is-fixed')[0],ti=ei?parseInt(ei.style.paddingRight||0,10):0;O()&&_(ti+Qr)}function w(Qr,ei){return ei?Qr.split(' ').map(function(ti){return ei[ti]||ti}).join(' '):Qr}function D(Qr,ei,ti){switch(ti.length){case 0:return Qr.call(ei);case 1:return Qr.call(ei,ti[0]);case 2:return Qr.call(ei,ti[0],ti[1]);case 3:return Qr.call(ei,ti[0],ti[1],ti[2]);}return Qr.apply(ei,ti)}function A(Qr,ei){var ti=Qr?Qr.length:0;return!!ti&&-1<R(Qr,ei,0)}function L(Qr,ei,ti){for(var oi=-1,si=Qr?Qr.length:0;++oi<si;)if(ti(ei,Qr[oi]))return!0;return!1}function S(Qr,ei){for(var ti=-1,oi=Qr?Qr.length:0,si=Array(oi);++ti<oi;)si[ti]=ei(Qr[ti],ti,Qr);return si}function z(Qr,ei){for(var ti=-1,oi=ei.length,si=Qr.length;++ti<oi;)Qr[si+ti]=ei[ti];return Qr}function I(Qr,ei,ti,oi){for(var si=Qr.length,ai=ti+(oi?1:-1);oi?ai--:++ai<si;)if(ei(Qr[ai],ai,Qr))return ai;return-1}function R(Qr,ei,ti){if(ei!==ei)return I(Qr,B,ti);for(var oi=ti-1,si=Qr.length;++oi<si;)if(Qr[oi]===ei)return oi;return-1}function B(Qr){return Qr!==Qr}function W(Qr,ei){for(var ti=-1,oi=Array(Qr);++ti<Qr;)oi[ti]=ei(ti);return oi}function U(Qr){return function(ei){return Qr(ei)}}function H(Qr,ei){return Qr.has(ei)}function q(Qr,ei){return null==Qr?void 0:Qr[ei]}function G(Qr){var ei=!1;if(null!=Qr&&'function'!=typeof Qr.toString)try{ei=!!(Qr+'')}catch(ti){}return ei}function F(Qr,ei){return function(ti){return Qr(ei(ti))}}function V(Qr){var ei=-1,ti=Qr?Qr.length:0;for(this.clear();++ei<ti;){var oi=Qr[ei];this.set(oi[0],oi[1])}}function J(Qr){var ei=-1,ti=Qr?Qr.length:0;for(this.clear();++ei<ti;){var oi=Qr[ei];this.set(oi[0],oi[1])}}function ae(Qr){var ei=-1,ti=Qr?Qr.length:0;for(this.clear();++ei<ti;){var oi=Qr[ei];this.set(oi[0],oi[1])}}function pe(Qr){var ei=-1,ti=Qr?Qr.length:0;for(this.__data__=new ae;++ei<ti;)this.add(Qr[ei])}function ge(Qr,ei){var ti=jo(Qr)||ze(Qr)?W(Qr.length,String):[],oi=ti.length;for(var ai in Qr)(ei||bo.call(Qr,ai))&&!(!!oi&&('length'==ai||Pe(ai,oi)))&&ti.push(ai);return ti}function fe(Qr,ei){for(var ti=Qr.length;ti--;)if(Se(Qr[ti][0],ei))return ti;return-1}function me(Qr,ei,ti,oi){var si=-1,ai=A,ni=!0,li=Qr.length,ri=[],ii=ei.length;if(!li)return ri;ti&&(ei=S(ei,U(ti))),oi?(ai=L,ni=!1):ei.length>=Xt&&(ai=H,ni=!1,ei=new pe(ei));outer:for(;++si<li;){var di=Qr[si],pi=ti?ti(di):di;if(di=oi||0!==di?di:0,ni&&pi===pi){for(var ci=ii;ci--;)if(ei[ci]===pi)continue outer;ri.push(di)}else ai(ei,pi,oi)||ri.push(di)}return ri}function he(Qr,ei,ti,oi,si){var ai=-1,ni=Qr.length;for(ti||(ti=Ee),si||(si=[]);++ai<ni;){var li=Qr[ai];0<ei&&ti(li)?1<ei?he(li,ei-1,ti,oi,si):z(si,li):!oi&&(si[si.length]=li)}return si}function be(Qr,ei,ti){var oi=ei(Qr);return jo(Qr)?oi:z(oi,ti(Qr))}function ye(Qr){if(!Ue(Qr)||xe(Qr))return!1;var ei=Be(Qr)||G(Qr)?vo:no;return ei.test(Le(Qr))}function ve(Qr){if(!Ue(Qr))return De(Qr);var ei=je(Qr),ti=[];for(var oi in Qr)('constructor'!=oi||!ei&&bo.call(Qr,oi))&&ti.push(oi);return ti}function Te(Qr,ei){return Qr=Object(Qr),Ne(Qr,ei,function(ti,oi){return oi in Qr})}function Ne(Qr,ei,ti){for(var oi=-1,si=ei.length,ai={};++oi<si;){var ni=ei[oi],li=Qr[ni];ti(li,ni)&&(ai[ni]=li)}return ai}function Ce(Qr){return be(Qr,Ge,xo)}function Me(Qr,ei){var ti=Qr.__data__;return we(ei)?ti['string'==typeof ei?'string':'hash']:ti.map}function Oe(Qr,ei){var ti=q(Qr,ei);return ye(ti)?ti:void 0}function Ee(Qr){return jo(Qr)||ze(Qr)||!!(Mo&&Qr&&Qr[Mo])}function Pe(Qr,ei){return ei=null==ei?Jt:ei,!!ei&&('number'==typeof Qr||lo.test(Qr))&&-1<Qr&&0==Qr%1&&Qr<ei}function we(Qr){var ei='undefined'==typeof Qr?'undefined':et(Qr);return'string'==ei||'number'==ei||'symbol'==ei||'boolean'==ei?'__proto__'!==Qr:null===Qr}function xe(Qr){return!!mo&&mo in Qr}function je(Qr){var ei=Qr&&Qr.constructor,ti='function'==typeof ei&&ei.prototype||go;return Qr===ti}function De(Qr){var ei=[];if(null!=Qr)for(var ti in Object(Qr))ei.push(ti);return ei}function Ae(Qr){if('string'==typeof Qr||qe(Qr))return Qr;var ei=Qr+'';return'0'==ei&&1/Qr==-Zt?'-0':ei}function Le(Qr){if(null!=Qr){try{return ho.call(Qr)}catch(ei){}try{return Qr+''}catch(ei){}}return''}function Se(Qr,ei){return Qr===ei||Qr!==Qr&&ei!==ei}function ze(Qr){return Re(Qr)&&bo.call(Qr,'callee')&&(!ko.call(Qr,'callee')||yo.call(Qr)==Qt)}function Ie(Qr){return null!=Qr&&We(Qr.length)&&!Be(Qr)}function Re(Qr){return He(Qr)&&Ie(Qr)}function Be(Qr){var ei=Ue(Qr)?yo.call(Qr):'';return ei==eo||ei==oo}function We(Qr){return'number'==typeof Qr&&-1<Qr&&0==Qr%1&&Qr<=Jt}function Ue(Qr){var ei='undefined'==typeof Qr?'undefined':et(Qr);return!!Qr&&('object'==ei||'function'==ei)}function He(Qr){return!!Qr&&'object'==('undefined'==typeof Qr?'undefined':et(Qr))}function qe(Qr){return'symbol'==('undefined'==typeof Qr?'undefined':et(Qr))||He(Qr)&&yo.call(Qr)==so}function Ge(Qr){return Ie(Qr)?ge(Qr,!0):ve(Qr)}function Fe(){return[]}function Ye(Qr){var ei='undefined'==typeof Qr?'undefined':et(Qr);return!!Qr&&('object'==ei||'function'==ei)}function $e(Qr){var ei='undefined'==typeof Qr?'undefined':et(Qr);return!!Qr&&('object'==ei||'function'==ei)}function Xe(Qr){return!!Qr&&'object'==('undefined'==typeof Qr?'undefined':et(Qr))}function Ke(Qr){return'symbol'==('undefined'==typeof Qr?'undefined':et(Qr))||Xe(Qr)&&Tn.call(Qr)==un}function Je(Qr,ei){var ti=Qr.className,oi=Qr.cssModule,si=Qr.tabId,ai=Qr.tag,ni=lt(Qr,['className','cssModule','tabId','tag']),li=w(it('tab-pane',ti,{active:si===ei.activeTabId}),oi);return g.createElement(ai,at({},ni,{className:li}))}g='default'in g?g['default']:g,m='default'in m?m['default']:m,h='default'in h?h['default']:h,y='default'in y?y['default']:y;var Qe='undefined'==typeof window?'undefined'==typeof global?'undefined'==typeof self?{}:self:global:window,et='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(Qr){return typeof Qr}:function(Qr){return Qr&&'function'==typeof Symbol&&Qr.constructor===Symbol&&Qr!==Symbol.prototype?'symbol':typeof Qr},tt=function(Qr,ei){if(!(Qr instanceof ei))throw new TypeError('Cannot call a class as a function')},ot=function(){function Qr(ei,ti){for(var si,oi=0;oi<ti.length;oi++)si=ti[oi],si.enumerable=si.enumerable||!1,si.configurable=!0,'value'in si&&(si.writable=!0),Object.defineProperty(ei,si.key,si)}return function(ei,ti,oi){return ti&&Qr(ei.prototype,ti),oi&&Qr(ei,oi),ei}}(),st=function(Qr,ei,ti){return ei in Qr?Object.defineProperty(Qr,ei,{value:ti,enumerable:!0,configurable:!0,writable:!0}):Qr[ei]=ti,Qr},at=Object.assign||function(Qr){for(var ti,ei=1;ei<arguments.length;ei++)for(var oi in ti=arguments[ei],ti)Object.prototype.hasOwnProperty.call(ti,oi)&&(Qr[oi]=ti[oi]);return Qr},nt=function(Qr,ei){if('function'!=typeof ei&&null!==ei)throw new TypeError('Super expression must either be null or a function, not '+typeof ei);Qr.prototype=Object.create(ei&&ei.prototype,{constructor:{value:Qr,enumerable:!1,writable:!0,configurable:!0}}),ei&&(Object.setPrototypeOf?Object.setPrototypeOf(Qr,ei):Qr.__proto__=ei)},lt=function(Qr,ei){var ti={};for(var oi in Qr)0<=ei.indexOf(oi)||Object.prototype.hasOwnProperty.call(Qr,oi)&&(ti[oi]=Qr[oi]);return ti},rt=function(Qr,ei){if(!Qr)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return ei&&('object'==typeof ei||'function'==typeof ei)?ei:Qr},it=N(function(Qr){(function(){'use strict';function ei(){for(var ai,oi=[],si=0;si<arguments.length;si++)if(ai=arguments[si],ai){var ni='undefined'==typeof ai?'undefined':et(ai);if('string'===ni||'number'===ni)oi.push(ai);else if(Array.isArray(ai))oi.push(ei.apply(null,ai));else if('object'===ni)for(var li in ai)ti.call(ai,li)&&ai[li]&&oi.push(li)}return oi.join(' ')}var ti={}.hasOwnProperty;Qr.exports?Qr.exports=ei:window.classNames=ei})()}),dt=['top','bottom','left','right','top left','top center','top right','right top','right middle','right bottom','bottom right','bottom center','bottom left','left top','left middle','left bottom'],pt=g.PropTypes,ct={tag:pt.oneOfType([pt.func,pt.string]),fluid:pt.bool,className:pt.string,cssModule:pt.object},gt=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.fluid,ai=ei.tag,ni=lt(ei,['className','cssModule','fluid','tag']),li=w(it(ti,si?'container-fluid':'container'),oi);return g.createElement(ai,at({},ni,{className:li}))};gt.propTypes=ct,gt.defaultProps={tag:'div'};var ft=g.PropTypes,mt={tag:ft.oneOfType([ft.func,ft.string]),noGutters:ft.bool,className:ft.string,cssModule:ft.object},bt=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.noGutters,ai=ei.tag,ni=lt(ei,['className','cssModule','noGutters','tag']),li=w(it(ti,si?'no-gutters':null,'row'),oi);return g.createElement(ai,at({},ni,{className:li}))};bt.propTypes=mt,bt.defaultProps={tag:'div'};var yt=function(Qr){var ei='undefined'==typeof Qr?'undefined':et(Qr);return!!Qr&&('object'==ei||'function'==ei)},vt=g.PropTypes,Nt=vt.oneOfType([vt.number,vt.string]),kt=vt.oneOfType([vt.bool,vt.number,vt.string,vt.shape({size:vt.oneOfType([vt.bool,vt.number,vt.string]),push:Nt,pull:Nt,offset:Nt})]),Ct={tag:vt.oneOfType([vt.func,vt.string]),xs:kt,sm:kt,md:kt,lg:kt,xl:kt,className:vt.string,cssModule:vt.object,widths:vt.array},_t=function(ei,ti,oi){if(!0===oi||''===oi)return ei?'col':'col-'+ti;return'auto'===oi?ei?'col-auto':'col-'+ti+'-auto':ei?'col-'+oi:'col-'+ti+'-'+oi},Ot=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.widths,ai=ei.tag,ni=lt(ei,['className','cssModule','widths','tag']),li=[];si.forEach(function(ii,di){var pi=ei[ii];if(di||void 0!==pi||(pi=!0),delete ni[ii],!!pi){var ui,ci=!di;if(yt(pi)){var gi,fi=ci?'-':'-'+ii+'-';ui=_t(ci,ii,pi.size),li.push(w(it((gi={},st(gi,ui,pi.size||''===pi.size),st(gi,'push'+fi+pi.push,pi.push||0===pi.push),st(gi,'pull'+fi+pi.pull,pi.pull||0===pi.pull),st(gi,'offset'+fi+pi.offset,pi.offset||0===pi.offset),gi))),oi)}else ui=_t(ci,ii,pi),li.push(ui)}});var ri=w(it(ti,li),oi);return g.createElement(ai,at({},ni,{className:ri}))};Ot.propTypes=Ct,Ot.defaultProps={tag:'div',widths:['xs','sm','md','lg','xl']};var Et=g.PropTypes,Pt={light:Et.bool,inverse:Et.bool,full:Et.bool,fixed:Et.string,sticky:Et.string,color:Et.string,role:Et.string,tag:Et.oneOfType([Et.func,Et.string]),className:Et.string,cssModule:Et.object,toggleable:Et.oneOfType([Et.bool,Et.string])},xt=function(ei){if(!1===ei)return!1;return!0===ei||'xs'===ei?'navbar-toggleable':'navbar-toggleable-'+ei},jt=function(ei){var ti,oi=ei.toggleable,si=ei.className,ai=ei.cssModule,ni=ei.light,li=ei.inverse,ri=ei.full,ii=ei.fixed,di=ei.sticky,pi=ei.color,ci=ei.tag,ui=lt(ei,['toggleable','className','cssModule','light','inverse','full','fixed','sticky','color','tag']),gi=w(it(si,'navbar',xt(oi),(ti={'navbar-light':ni,'navbar-inverse':li},st(ti,'bg-'+pi,pi),st(ti,'navbar-full',ri),st(ti,'fixed-'+ii,ii),st(ti,'sticky-'+di,di),ti)),ai);return g.createElement(ci,at({},ui,{className:gi}))};jt.propTypes=Pt,jt.defaultProps={tag:'nav',role:'navigation',toggleable:!1};var Dt=g.PropTypes,At={tag:Dt.oneOfType([Dt.func,Dt.string]),className:Dt.string,cssModule:Dt.object},St=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'navbar-brand'),oi);return g.createElement(si,at({},ai,{className:ni}))};St.propTypes=At,St.defaultProps={tag:'a'};var zt=g.PropTypes,It={tag:zt.oneOfType([zt.func,zt.string]),type:zt.string,className:zt.string,cssModule:zt.object,children:zt.node,right:zt.bool,left:zt.bool},Bt=g.createElement('span',{className:'navbar-toggler-icon'}),Wt=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.children,ai=ei.right,ni=ei.left,li=ei.tag,ri=lt(ei,['className','cssModule','children','right','left','tag']),ii=w(it(ti,'navbar-toggler',ai&&'navbar-toggler-right',ni&&'navbar-toggler-left'),oi);return g.createElement(li,at({},ri,{className:ii}),si||Bt)};Wt.propTypes=It,Wt.defaultProps={tag:'button',type:'button'};var Ut=g.PropTypes,Ht={tabs:Ut.bool,pills:Ut.bool,vertical:Ut.bool,navbar:Ut.bool,tag:Ut.oneOfType([Ut.func,Ut.string]),className:Ut.string,cssModule:Ut.object},Gt=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tabs,ai=ei.pills,ni=ei.vertical,li=ei.navbar,ri=ei.tag,ii=lt(ei,['className','cssModule','tabs','pills','vertical','navbar','tag']),di=w(it(ti,li?'navbar-nav':'nav',{'nav-tabs':si,'nav-pills':ai,'flex-column':ni}),oi);return g.createElement(ri,at({},ii,{className:di}))};Gt.propTypes=Ht,Gt.defaultProps={tag:'ul'};var Ft=g.PropTypes,Vt={tag:Ft.oneOfType([Ft.func,Ft.string]),className:Ft.string,cssModule:Ft.object},$t=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'nav-item'),oi);return g.createElement(si,at({},ai,{className:ni}))};$t.propTypes=Vt,$t.defaultProps={tag:'li'};var Xt=200,Kt='__lodash_hash_undefined__',Zt=1/0,Jt=9007199254740991,Qt='[object Arguments]',eo='[object Function]',oo='[object GeneratorFunction]',so='[object Symbol]',ao=/[\\^$.*+?()[\]{}|]/g,no=/^\[object .+?Constructor\]$/,lo=/^(?:0|[1-9]\d*)$/,ro='object'==et(Qe)&&Qe&&Qe.Object===Object&&Qe,io='object'==('undefined'==typeof self?'undefined':et(self))&&self&&self.Object===Object&&self,po=ro||io||Function('return this')(),co=Array.prototype,uo=Function.prototype,go=Object.prototype,fo=po['__core-js_shared__'],mo=function(){var Qr=/[^.]+$/.exec(fo&&fo.keys&&fo.keys.IE_PROTO||'');return Qr?'Symbol(src)_1.'+Qr:''}(),ho=uo.toString,bo=go.hasOwnProperty,yo=go.toString,vo=RegExp('^'+ho.call(bo).replace(ao,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$'),To=po.Symbol,No=F(Object.getPrototypeOf,Object),ko=go.propertyIsEnumerable,Co=co.splice,Mo=To?To.isConcatSpreadable:void 0,_o=Object.getOwnPropertySymbols,Oo=_Mathmax,Eo=Oe(po,'Map'),Po=Oe(Object,'create');V.prototype.clear=function(){this.__data__=Po?Po(null):{}},V.prototype['delete']=function(Qr){return this.has(Qr)&&delete this.__data__[Qr]},V.prototype.get=function(Qr){var ei=this.__data__;if(Po){var ti=ei[Qr];return ti===Kt?void 0:ti}return bo.call(ei,Qr)?ei[Qr]:void 0},V.prototype.has=function(Qr){var ei=this.__data__;return Po?ei[Qr]!==void 0:bo.call(ei,Qr)},V.prototype.set=function(Qr,ei){var ti=this.__data__;return ti[Qr]=Po&&void 0===ei?Kt:ei,this},J.prototype.clear=function(){this.__data__=[]},J.prototype['delete']=function(Qr){var ei=this.__data__,ti=fe(ei,Qr);if(0>ti)return!1;var oi=ei.length-1;return ti==oi?ei.pop():Co.call(ei,ti,1),!0},J.prototype.get=function(Qr){var ei=this.__data__,ti=fe(ei,Qr);return 0>ti?void 0:ei[ti][1]},J.prototype.has=function(Qr){return-1<fe(this.__data__,Qr)},J.prototype.set=function(Qr,ei){var ti=this.__data__,oi=fe(ti,Qr);return 0>oi?ti.push([Qr,ei]):ti[oi][1]=ei,this},ae.prototype.clear=function(){this.__data__={hash:new V,map:new(Eo||J),string:new V}},ae.prototype['delete']=function(Qr){return Me(this,Qr)['delete'](Qr)},ae.prototype.get=function(Qr){return Me(this,Qr).get(Qr)},ae.prototype.has=function(Qr){return Me(this,Qr).has(Qr)},ae.prototype.set=function(Qr,ei){return Me(this,Qr).set(Qr,ei),this},pe.prototype.add=pe.prototype.push=function(Qr){return this.__data__.set(Qr,Kt),this},pe.prototype.has=function(Qr){return this.__data__.has(Qr)};var wo=_o?F(_o,Object):Fe,xo=_o?function(Qr){for(var ei=[];Qr;)z(ei,wo(Qr)),Qr=No(Qr);return ei}:Fe,jo=Array.isArray,Do=function(Qr,ei){return ei=Oo(void 0===ei?Qr.length-1:ei,0),function(){for(var ti=arguments,oi=-1,si=Oo(ti.length-ei,0),ai=Array(si);++oi<si;)ai[oi]=ti[ei+oi];oi=-1;for(var ni=Array(ei+1);++oi<ei;)ni[oi]=ti[oi];return ni[ei]=ai,D(Qr,this,ni)}}(function(Qr,ei){return null==Qr?{}:(ei=S(he(ei,1),Ae),Te(Qr,me(Ce(Qr),ei)))}),Ao=Do,zo=Object.prototype,Io=zo.toString,Ro=function(Qr){var ei=Ye(Qr)?Io.call(Qr):'';return ei=='[object Function]'||ei=='[object GeneratorFunction]'},Bo=N(function(Qr){(function(ti){Qr.exports=ti()})(function(){return function ai(ni,li,ri){function ii(ci,ui){if(!li[ci]){if(!ni[ci]){var gi='function'==typeof v&&v;if(!ui&&gi)return gi(ci,!0);if(di)return di(ci,!0);var fi=new Error('Cannot find module \''+ci+'\'');throw fi.code='MODULE_NOT_FOUND',fi}var mi=li[ci]={exports:{}};ni[ci][0].call(mi.exports,function(hi){var bi=ni[ci][1][hi];return ii(bi?bi:hi)},mi,mi.exports,ai,ni,li,ri)}return li[ci].exports}for(var di='function'==typeof v&&v,pi=0;pi<ri.length;pi++)ii(ri[pi]);return ii}({1:[function(ai){'use strict';var ii=ai('./utils'),di=function(fi){return fi&&fi.__esModule?fi:{'default':fi}}(ii),pi=di['default'].Utils,ci=pi.getBounds,ui=pi.updateClasses,gi=pi.defer;di['default'].modules.push({position:function(mi){var hi=this,bi=mi.top,yi=mi.left,vi=this.cache('element-bounds',function(){return ci(hi.element)}),Ti=vi.height,Ni=vi.width,ki=this.getTargetBounds(),Ci=bi+Ti,Mi=yi+Ni,Oi=[];bi<=ki.bottom&&Ci>=ki.top&&['left','right'].forEach(function(xi){var ji=ki[xi];(ji===yi||ji===Mi)&&Oi.push(xi)}),yi<=ki.right&&Mi>=ki.left&&['top','bottom'].forEach(function(xi){var ji=ki[xi];(ji===bi||ji===Ci)&&Oi.push(xi)});var Ei=[],Pi=[];return Ei.push(this.getClass('abutted')),['left','top','right','bottom'].forEach(function(xi){Ei.push(hi.getClass('abutted')+'-'+xi)}),Oi.length&&Pi.push(this.getClass('abutted')),Oi.forEach(function(xi){Pi.push(hi.getClass('abutted')+'-'+xi)}),gi(function(){!1===hi.options.addTargetClasses||ui(hi.target,Pi,Ei),ui(hi.element,Pi,Ei)}),!0}})},{'./utils':5}],2:[function(ai){'use strict';function ii(yi,vi){return'scrollParent'===vi?vi=yi.scrollParents[0]:'window'===vi&&(vi=[pageXOffset,pageYOffset,innerWidth+pageXOffset,innerHeight+pageYOffset]),vi===document&&(vi=vi.documentElement),'undefined'!=typeof vi.nodeType&&function(){var Ti=vi,Ni=gi(vi),ki=Ni,Ci=getComputedStyle(vi);if(vi=[ki.left,ki.top,Ni.width+ki.left,Ni.height+ki.top],Ti.ownerDocument!==document){var Mi=Ti.ownerDocument.defaultView;vi[0]+=Mi.pageXOffset,vi[1]+=Mi.pageYOffset,vi[2]+=Mi.pageXOffset,vi[3]+=Mi.pageYOffset}bi.forEach(function(Oi,Ei){Oi=Oi[0].toUpperCase()+Oi.substr(1),'Top'===Oi||'Left'===Oi?vi[Ei]+=parseFloat(Ci['border'+Oi+'Width']):vi[Ei]-=parseFloat(Ci['border'+Oi+'Width'])})}(),vi}var di=function(){function yi(vi,Ti){var Ni=[],ki=!0,Ci=!1,Mi;try{for(var Ei,Oi=vi[Symbol.iterator]();!(ki=(Ei=Oi.next()).done)&&(Ni.push(Ei.value),!(Ti&&Ni.length===Ti));ki=!0);}catch(Pi){Ci=!0,Mi=Pi}finally{try{!ki&&Oi['return']&&Oi['return']()}finally{if(Ci)throw Mi}}return Ni}return function(vi,Ti){if(Array.isArray(vi))return vi;if(Symbol.iterator in Object(vi))return yi(vi,Ti);throw new TypeError('Invalid attempt to destructure non-iterable instance')}}(),pi=ai('./utils'),ci=function(yi){return yi&&yi.__esModule?yi:{'default':yi}}(pi),ui=ci['default'].Utils,gi=ui.getBounds,fi=ui.extend,mi=ui.updateClasses,hi=ui.defer,bi=['left','top','right','bottom'];ci['default'].modules.push({position:function(vi){var Ti=this,Ni=vi.top,ki=vi.left,Ci=vi.targetAttachment;if(!this.options.constraints)return!0;var Mi=this.cache('element-bounds',function(){return gi(Ti.element)}),Oi=Mi.height,Ei=Mi.width;if(0===Ei&&0===Oi&&'undefined'!=typeof this.lastSize){var Pi=this.lastSize;Ei=Pi.width,Oi=Pi.height}var wi=this.cache('target-bounds',function(){return Ti.getTargetBounds()}),xi=wi.height,ji=wi.width,Di=[this.getClass('pinned'),this.getClass('out-of-bounds')];this.options.constraints.forEach(function(zi){var Ii=zi.outOfBoundsClass,Ri=zi.pinnedClass;Ii&&Di.push(Ii),Ri&&Di.push(Ri)}),Di.forEach(function(zi){['left','top','right','bottom'].forEach(function(Ii){Di.push(zi+'-'+Ii)})});var Ai=[],Li=fi({},Ci),Si=fi({},this.attachment);return this.options.constraints.forEach(function(zi){var Ii=zi.to,Ri=zi.attachment,Bi=zi.pin;'undefined'==typeof Ri&&(Ri='');var Wi,Ui;if(0<=Ri.indexOf(' ')){var Hi=Ri.split(' '),qi=di(Hi,2);Ui=qi[0],Wi=qi[1]}else Wi=Ui=Ri;var Gi=ii(Ti,Ii);('target'===Ui||'both'===Ui)&&(Ni<Gi[1]&&'top'===Li.top&&(Ni+=xi,Li.top='bottom'),Ni+Oi>Gi[3]&&'bottom'===Li.top&&(Ni-=xi,Li.top='top')),'together'===Ui&&('top'===Li.top&&('bottom'===Si.top&&Ni<Gi[1]?(Ni+=xi,Li.top='bottom',Ni+=Oi,Si.top='top'):'top'===Si.top&&Ni+Oi>Gi[3]&&Ni-(Oi-xi)>=Gi[1]&&(Ni-=Oi-xi,Li.top='bottom',Si.top='bottom')),'bottom'===Li.top&&('top'===Si.top&&Ni+Oi>Gi[3]?(Ni-=xi,Li.top='top',Ni-=Oi,Si.top='bottom'):'bottom'===Si.top&&Ni<Gi[1]&&Ni+(2*Oi-xi)<=Gi[3]&&(Ni+=Oi-xi,Li.top='top',Si.top='top')),'middle'===Li.top&&(Ni+Oi>Gi[3]&&'top'===Si.top?(Ni-=Oi,Si.top='bottom'):Ni<Gi[1]&&'bottom'===Si.top&&(Ni+=Oi,Si.top='top'))),('target'===Wi||'both'===Wi)&&(ki<Gi[0]&&'left'===Li.left&&(ki+=ji,Li.left='right'),ki+Ei>Gi[2]&&'right'===Li.left&&(ki-=ji,Li.left='left')),'together'===Wi&&(ki<Gi[0]&&'left'===Li.left?'right'===Si.left?(ki+=ji,Li.left='right',ki+=Ei,Si.left='left'):'left'===Si.left&&(ki+=ji,Li.left='right',ki-=Ei,Si.left='right'):ki+Ei>Gi[2]&&'right'===Li.left?'left'===Si.left?(ki-=ji,Li.left='left',ki-=Ei,Si.left='right'):'right'===Si.left&&(ki-=ji,Li.left='left',ki+=Ei,Si.left='left'):'center'===Li.left&&(ki+Ei>Gi[2]&&'left'===Si.left?(ki-=Ei,Si.left='right'):ki<Gi[0]&&'right'===Si.left&&(ki+=Ei,Si.left='left'))),('element'===Ui||'both'===Ui)&&(Ni<Gi[1]&&'bottom'===Si.top&&(Ni+=Oi,Si.top='top'),Ni+Oi>Gi[3]&&'top'===Si.top&&(Ni-=Oi,Si.top='bottom')),('element'===Wi||'both'===Wi)&&(ki<Gi[0]&&('right'===Si.left?(ki+=Ei,Si.left='left'):'center'===Si.left&&(ki+=Ei/2,Si.left='left')),ki+Ei>Gi[2]&&('left'===Si.left?(ki-=Ei,Si.left='right'):'center'===Si.left&&(ki-=Ei/2,Si.left='right'))),'string'==typeof Bi?Bi=Bi.split(',').map(function(Yi){return Yi.trim()}):!0===Bi&&(Bi=['top','left','right','bottom']),Bi=Bi||[];var Fi=[],Vi=[];Ni<Gi[1]&&(0<=Bi.indexOf('top')?(Ni=Gi[1],Fi.push('top')):Vi.push('top')),Ni+Oi>Gi[3]&&(0<=Bi.indexOf('bottom')?(Ni=Gi[3]-Oi,Fi.push('bottom')):Vi.push('bottom')),ki<Gi[0]&&(0<=Bi.indexOf('left')?(ki=Gi[0],Fi.push('left')):Vi.push('left')),ki+Ei>Gi[2]&&(0<=Bi.indexOf('right')?(ki=Gi[2]-Ei,Fi.push('right')):Vi.push('right')),Fi.length&&function(){var Yi;Yi='undefined'==typeof Ti.options.pinnedClass?Ti.getClass('pinned'):Ti.options.pinnedClass,Ai.push(Yi),Fi.forEach(function($i){Ai.push(Yi+'-'+$i)})}(),Vi.length&&function(){var Yi;Yi='undefined'==typeof Ti.options.outOfBoundsClass?Ti.getClass('out-of-bounds'):Ti.options.outOfBoundsClass,Ai.push(Yi),Vi.forEach(function($i){Ai.push(Yi+'-'+$i)})}(),(0<=Fi.indexOf('left')||0<=Fi.indexOf('right'))&&(Si.left=Li.left=!1),(0<=Fi.indexOf('top')||0<=Fi.indexOf('bottom'))&&(Si.top=Li.top=!1),(Li.top!==Ci.top||Li.left!==Ci.left||Si.top!==Ti.attachment.top||Si.left!==Ti.attachment.left)&&(Ti.updateAttachClasses(Si,Li),Ti.trigger('update',{attachment:Si,targetAttachment:Li}))}),hi(function(){!1===Ti.options.addTargetClasses||mi(Ti.target,Ai,Di),mi(Ti.element,Ai,Di)}),{top:Ni,left:ki}}})},{'./utils':5}],3:[function(ai){'use strict';var ii=function(){function ci(ui,gi){var fi=[],mi=!0,hi=!1,bi;try{for(var vi,yi=ui[Symbol.iterator]();!(mi=(vi=yi.next()).done)&&(fi.push(vi.value),!(gi&&fi.length===gi));mi=!0);}catch(Ti){hi=!0,bi=Ti}finally{try{!mi&&yi['return']&&yi['return']()}finally{if(hi)throw bi}}return fi}return function(ui,gi){if(Array.isArray(ui))return ui;if(Symbol.iterator in Object(ui))return ci(ui,gi);throw new TypeError('Invalid attempt to destructure non-iterable instance')}}(),di=ai('./utils'),pi=function(ci){return ci&&ci.__esModule?ci:{'default':ci}}(di);pi['default'].modules.push({position:function(ui){var gi=ui.top,fi=ui.left;if(this.options.shift){var mi=this.options.shift;'function'==typeof this.options.shift&&(mi=this.options.shift.call(this,{top:gi,left:fi}));var hi,bi;if('string'==typeof mi){mi=mi.split(' '),mi[1]=mi[1]||mi[0];var yi=mi,vi=ii(yi,2);hi=vi[0],bi=vi[1],hi=parseFloat(hi,10),bi=parseFloat(bi,10)}else hi=mi.top,bi=mi.left;return gi+=hi,fi+=bi,{top:gi,left:fi}}}})},{'./utils':5}],4:[function(ai,ni,li){'use strict';function ii(Fi,Vi){if(!(Fi instanceof Vi))throw new TypeError('Cannot call a class as a function')}function di(Fi,Vi){if('function'!=typeof Vi&&null!==Vi)throw new TypeError('Super expression must either be null or a function, not '+('undefined'==typeof Vi?'undefined':et(Vi)));Fi.prototype=Object.create(Vi&&Vi.prototype,{constructor:{value:Fi,enumerable:!1,writable:!0,configurable:!0}}),Vi&&(Object.setPrototypeOf?Object.setPrototypeOf(Fi,Vi):Fi.__proto__=Vi)}function pi(Fi,Vi){var Yi=2>=arguments.length||arguments[2]===void 0?1:arguments[2];return Fi+Yi>=Vi&&Vi>=Fi-Yi}function ci(){return'undefined'!=typeof performance&&'undefined'!=typeof performance.now?performance.now():+new Date}function ui(){for(var Fi={top:0,left:0},Vi=arguments.length,Yi=Array(Vi),$i=0;$i<Vi;$i++)Yi[$i]=arguments[$i];return Yi.forEach(function(Xi){var Ki=Xi.top,Zi=Xi.left;'string'==typeof Ki&&(Ki=parseFloat(Ki,10)),'string'==typeof Zi&&(Zi=parseFloat(Zi,10)),Fi.top+=Ki,Fi.left+=Zi}),Fi}function gi(Fi,Vi){return'string'==typeof Fi.left&&-1!==Fi.left.indexOf('%')&&(Fi.left=parseFloat(Fi.left,10)/100*Vi.width),'string'==typeof Fi.top&&-1!==Fi.top.indexOf('%')&&(Fi.top=parseFloat(Fi.top,10)/100*Vi.height),Fi}Object.defineProperty(li,'__esModule',{value:!0});var fi=function(){function Fi(Vi,Yi){var $i=[],Xi=!0,Ki=!1,Zi;try{for(var Qi,Ji=Vi[Symbol.iterator]();!(Xi=(Qi=Ji.next()).done)&&($i.push(Qi.value),!(Yi&&$i.length===Yi));Xi=!0);}catch(ed){Ki=!0,Zi=ed}finally{try{!Xi&&Ji['return']&&Ji['return']()}finally{if(Ki)throw Zi}}return $i}return function(Vi,Yi){if(Array.isArray(Vi))return Vi;if(Symbol.iterator in Object(Vi))return Fi(Vi,Yi);throw new TypeError('Invalid attempt to destructure non-iterable instance')}}(),mi=function(){function Fi(Vi,Yi){for(var Xi,$i=0;$i<Yi.length;$i++)Xi=Yi[$i],Xi.enumerable=Xi.enumerable||!1,Xi.configurable=!0,'value'in Xi&&(Xi.writable=!0),Object.defineProperty(Vi,Xi.key,Xi)}return function(Vi,Yi,$i){return Yi&&Fi(Vi.prototype,Yi),$i&&Fi(Vi,$i),Vi}}(),hi=function(Vi,Yi,$i){var Xi=!0;_function:for(;Xi;){var Ki=Vi,Zi=Yi,Ji=$i;Xi=!1,null===Ki&&(Ki=Function.prototype);var Qi=Object.getOwnPropertyDescriptor(Ki,Zi);if(Qi===void 0){var ed=Object.getPrototypeOf(Ki);if(null===ed)return;Vi=ed,Yi=Zi,$i=Ji,Xi=!0,Qi=ed=void 0;continue _function}else{if('value'in Qi)return Qi.value;var td=Qi.get;return void 0===td?void 0:td.call(Ji)}}},bi=ai('./utils'),yi=function(Fi){return Fi&&Fi.__esModule?Fi:{'default':Fi}}(bi);ai('./constraint'),ai('./abutment'),ai('./shift');var vi=yi['default'].Utils,Ti=vi.getScrollParents,Ni=vi.getBounds,ki=vi.getOffsetParent,Ci=vi.extend,Mi=vi.addClass,Oi=vi.removeClass,Ei=vi.updateClasses,Pi=vi.defer,wi=vi.flush,xi=vi.getScrollBarSize,ji=vi.removeUtilElements,Di=vi.Evented,Ai=function(){if('undefined'==typeof document)return'';for(var $i,Fi=document.createElement('div'),Vi=['transform','WebkitTransform','OTransform','MozTransform','msTransform'],Yi=0;Yi<Vi.length;++Yi)if($i=Vi[Yi],void 0!==Fi.style[$i])return $i}(),Li=[],Si=function(){Li.forEach(function(Vi){Vi.position(!1)}),wi()};(function(){var Fi=null,Vi=null,Yi=null,$i=function Xi(){return'undefined'!=typeof Vi&&16<Vi?(Vi=_Mathmin(Vi-16,250),void(Yi=setTimeout(Xi,250))):void('undefined'!=typeof Fi&&10>ci()-Fi||(null!=Yi&&(clearTimeout(Yi),Yi=null),Fi=ci(),Si(),Vi=ci()-Fi))};'undefined'!=typeof window&&'undefined'!=typeof window.addEventListener&&['resize','scroll','touchmove'].forEach(function(Xi){window.addEventListener(Xi,$i)})})();var zi={center:'center',left:'right',right:'left'},Ii={middle:'middle',top:'bottom',bottom:'top'},Ri={top:0,left:0,middle:'50%',center:'50%',bottom:'100%',right:'100%'},Bi=function(Vi,Yi){var $i=Vi.left,Xi=Vi.top;return'auto'===$i&&($i=zi[Yi.left]),'auto'===Xi&&(Xi=Ii[Yi.top]),{left:$i,top:Xi}},Wi=function(Vi){var Yi=Vi.left,$i=Vi.top;return'undefined'!=typeof Ri[Vi.left]&&(Yi=Ri[Vi.left]),'undefined'!=typeof Ri[Vi.top]&&($i=Ri[Vi.top]),{left:Yi,top:$i}},Ui=function(Vi){var Yi=Vi.split(' '),$i=fi(Yi,2),Xi=$i[0],Ki=$i[1];return{top:Xi,left:Ki}},Hi=Ui,qi=function(Fi){function Vi(Yi){var $i=this;ii(this,Vi),hi(Object.getPrototypeOf(Vi.prototype),'constructor',this).call(this),this.position=this.position.bind(this),Li.push(this),this.history=[],this.setOptions(Yi,!1),yi['default'].modules.forEach(function(Xi){'undefined'!=typeof Xi.initialize&&Xi.initialize.call($i)}),this.position()}return di(Vi,Fi),mi(Vi,[{key:'getClass',value:function(){var $i=0>=arguments.length||void 0===arguments[0]?'':arguments[0],Xi=this.options.classes;return'undefined'!=typeof Xi&&Xi[$i]?this.options.classes[$i]:this.options.classPrefix?this.options.classPrefix+'-'+$i:$i}},{key:'setOptions',value:function($i){var Xi=this,Ki=1>=arguments.length||void 0===arguments[1]||arguments[1];this.options=Ci({offset:'0 0',targetOffset:'0 0',targetAttachment:'auto auto',classPrefix:'tether'},$i);var Ji=this.options,Qi=Ji.element,ed=Ji.target,td=Ji.targetModifier;if(this.element=Qi,this.target=ed,this.targetModifier=td,'viewport'===this.target?(this.target=document.body,this.targetModifier='visible'):'scroll-handle'===this.target&&(this.target=document.body,this.targetModifier='scroll-handle'),['element','target'].forEach(function(od){if('undefined'==typeof Xi[od])throw new Error('Tether Error: Both element and target must be defined');'undefined'==typeof Xi[od].jquery?'string'==typeof Xi[od]&&(Xi[od]=document.querySelector(Xi[od])):Xi[od]=Xi[od][0]}),Mi(this.element,this.getClass('element')),!1===this.options.addTargetClasses||Mi(this.target,this.getClass('target')),!this.options.attachment)throw new Error('Tether Error: You must provide an attachment');this.targetAttachment=Hi(this.options.targetAttachment),this.attachment=Hi(this.options.attachment),this.offset=Ui(this.options.offset),this.targetOffset=Ui(this.options.targetOffset),'undefined'!=typeof this.scrollParents&&this.disable(),this.scrollParents='scroll-handle'===this.targetModifier?[this.target]:Ti(this.target),!1===this.options.enabled||this.enable(Ki)}},{key:'getTargetBounds',value:function(){if('undefined'!=typeof this.targetModifier){if('visible'===this.targetModifier){if(this.target===document.body)return{top:pageYOffset,left:pageXOffset,height:innerHeight,width:innerWidth};var $i=Ni(this.target),Xi={height:$i.height,width:$i.width,top:$i.top,left:$i.left};return Xi.height=_Mathmin(Xi.height,$i.height-(pageYOffset-$i.top)),Xi.height=_Mathmin(Xi.height,$i.height-($i.top+$i.height-(pageYOffset+innerHeight))),Xi.height=_Mathmin(innerHeight,Xi.height),Xi.height-=2,Xi.width=_Mathmin(Xi.width,$i.width-(pageXOffset-$i.left)),Xi.width=_Mathmin(Xi.width,$i.width-($i.left+$i.width-(pageXOffset+innerWidth))),Xi.width=_Mathmin(innerWidth,Xi.width),Xi.width-=2,Xi.top<pageYOffset&&(Xi.top=pageYOffset),Xi.left<pageXOffset&&(Xi.left=pageXOffset),Xi}if('scroll-handle'===this.targetModifier){var $i=void 0,Ki=this.target;Ki===document.body?(Ki=document.documentElement,$i={left:pageXOffset,top:pageYOffset,height:innerHeight,width:innerWidth}):$i=Ni(Ki);var Zi=getComputedStyle(Ki),Ji=Ki.scrollWidth>Ki.clientWidth||0<=[Zi.overflow,Zi.overflowX].indexOf('scroll')||this.target!==document.body,Qi=0;Ji&&(Qi=15);var ed=$i.height-parseFloat(Zi.borderTopWidth)-parseFloat(Zi.borderBottomWidth)-Qi,Xi={width:15,height:0.975*ed*(ed/Ki.scrollHeight),left:$i.left+$i.width-parseFloat(Zi.borderLeftWidth)-15},td=0;408>ed&&this.target===document.body&&(td=-1.1e-4*Math.pow(ed,2)-0.00727*ed+22.58),this.target!==document.body&&(Xi.height=_Mathmax(Xi.height,24));var od=this.target.scrollTop/(Ki.scrollHeight-ed);return Xi.top=od*(ed-Xi.height-td)+$i.top+parseFloat(Zi.borderTopWidth),this.target===document.body&&(Xi.height=_Mathmax(Xi.height,24)),Xi}}else return Ni(this.target)}},{key:'clearCache',value:function(){this._cache={}}},{key:'cache',value:function($i,Xi){return'undefined'==typeof this._cache&&(this._cache={}),'undefined'==typeof this._cache[$i]&&(this._cache[$i]=Xi.call(this)),this._cache[$i]}},{key:'enable',value:function(){var $i=this,Xi=0>=arguments.length||void 0===arguments[0]||arguments[0];!1===this.options.addTargetClasses||Mi(this.target,this.getClass('enabled')),Mi(this.element,this.getClass('enabled')),this.enabled=!0,this.scrollParents.forEach(function(Ki){Ki!==$i.target.ownerDocument&&Ki.addEventListener('scroll',$i.position)}),Xi&&this.position()}},{key:'disable',value:function(){var $i=this;Oi(this.target,this.getClass('enabled')),Oi(this.element,this.getClass('enabled')),this.enabled=!1,'undefined'!=typeof this.scrollParents&&this.scrollParents.forEach(function(Xi){Xi.removeEventListener('scroll',$i.position)})}},{key:'destroy',value:function(){var $i=this;this.disable(),Li.forEach(function(Xi,Ki){Xi===$i&&Li.splice(Ki,1)}),0===Li.length&&ji()}},{key:'updateAttachClasses',value:function($i,Xi){var Ki=this;$i=$i||this.attachment,Xi=Xi||this.targetAttachment;'undefined'!=typeof this._addAttachClasses&&this._addAttachClasses.length&&this._addAttachClasses.splice(0,this._addAttachClasses.length),'undefined'==typeof this._addAttachClasses&&(this._addAttachClasses=[]);var Ji=this._addAttachClasses;$i.top&&Ji.push(this.getClass('element-attached')+'-'+$i.top),$i.left&&Ji.push(this.getClass('element-attached')+'-'+$i.left),Xi.top&&Ji.push(this.getClass('target-attached')+'-'+Xi.top),Xi.left&&Ji.push(this.getClass('target-attached')+'-'+Xi.left);var Qi=[];['left','top','bottom','right','middle','center'].forEach(function(ed){Qi.push(Ki.getClass('element-attached')+'-'+ed),Qi.push(Ki.getClass('target-attached')+'-'+ed)}),Pi(function(){'undefined'==typeof Ki._addAttachClasses||(Ei(Ki.element,Ki._addAttachClasses,Qi),!1!==Ki.options.addTargetClasses&&Ei(Ki.target,Ki._addAttachClasses,Qi),delete Ki._addAttachClasses)})}},{key:'position',value:function(){var $i=this,Xi=0>=arguments.length||void 0===arguments[0]||arguments[0];if(this.enabled){this.clearCache();var Ki=Bi(this.targetAttachment,this.attachment);this.updateAttachClasses(this.attachment,Ki);var Zi=this.cache('element-bounds',function(){return Ni($i.element)}),Ji=Zi.width,Qi=Zi.height;if(0===Ji&&0===Qi&&'undefined'!=typeof this.lastSize){var ed=this.lastSize;Ji=ed.width,Qi=ed.height}else this.lastSize={width:Ji,height:Qi};var td=this.cache('target-bounds',function(){return $i.getTargetBounds()}),od=td,sd=gi(Wi(this.attachment),{width:Ji,height:Qi}),ad=gi(Wi(Ki),od),nd=gi(this.offset,{width:Ji,height:Qi}),ld=gi(this.targetOffset,od);sd=ui(sd,nd),ad=ui(ad,ld);for(var rd=td.left+ad.left-sd.left,dd=td.top+ad.top-sd.top,pd=0;pd<yi['default'].modules.length;++pd){var cd=yi['default'].modules[pd],ud=cd.position.call(this,{left:rd,top:dd,targetAttachment:Ki,targetPos:td,elementPos:Zi,offset:sd,targetOffset:ad,manualOffset:nd,manualTargetOffset:ld,scrollbarSize:hd,attachment:this.attachment});if(!1===ud)return!1;if('undefined'==typeof ud||'object'!==('undefined'==typeof ud?'undefined':et(ud)))continue;else dd=ud.top,rd=ud.left}var hd,gd={page:{top:dd,left:rd},viewport:{top:dd-pageYOffset,bottom:pageYOffset-dd-Qi+innerHeight,left:rd-pageXOffset,right:pageXOffset-rd-Ji+innerWidth}},fd=this.target.ownerDocument,md=fd.defaultView;return fd.body.scrollWidth>md.innerWidth&&(hd=this.cache('scrollbar-size',xi),gd.viewport.bottom-=hd.height),fd.body.scrollHeight>md.innerHeight&&(hd=this.cache('scrollbar-size',xi),gd.viewport.right-=hd.width),(-1===['','static'].indexOf(fd.body.style.position)||-1===['','static'].indexOf(fd.body.parentElement.style.position))&&(gd.page.bottom=fd.body.scrollHeight-dd-Qi,gd.page.right=fd.body.scrollWidth-rd-Ji),'undefined'==typeof this.options.optimizations||!1===this.options.optimizations.moveElement||'undefined'!=typeof this.targetModifier||function(){var bd=$i.cache('target-offsetparent',function(){return ki($i.target)}),yd=$i.cache('target-offsetparent-bounds',function(){return Ni(bd)}),vd=getComputedStyle(bd),Td=yd,Nd={};if(['Top','Left','Bottom','Right'].forEach(function(Md){Nd[Md.toLowerCase()]=parseFloat(vd['border'+Md+'Width'])}),yd.right=fd.body.scrollWidth-yd.left-Td.width+Nd.right,yd.bottom=fd.body.scrollHeight-yd.top-Td.height+Nd.bottom,gd.page.top>=yd.top+Nd.top&&gd.page.bottom>=yd.bottom&&gd.page.left>=yd.left+Nd.left&&gd.page.right>=yd.right){var kd=bd.scrollTop,Cd=bd.scrollLeft;gd.offset={top:gd.page.top-yd.top+kd-Nd.top,left:gd.page.left-yd.left+Cd-Nd.left}}}(),this.move(gd),this.history.unshift(gd),3<this.history.length&&this.history.pop(),Xi&&wi(),!0}}},{key:'move',value:function($i){var Xi=this;if('undefined'!=typeof this.element.parentNode){var Ki={};for(var Zi in $i)for(var Ji in Ki[Zi]={},$i[Zi]){for(var td,Qi=!1,ed=0;ed<this.history.length;++ed)if(td=this.history[ed],'undefined'!=typeof td[Zi]&&!pi(td[Zi][Ji],$i[Zi][Ji])){Qi=!0;break}Qi||(Ki[Zi][Ji]=!0)}var od={top:'',left:'',right:'',bottom:''},sd=function(gd,fd){var md='undefined'!=typeof Xi.options.optimizations,hd=md?Xi.options.optimizations.gpu:null;if(!1!==hd){var bd,yd;gd.top?(od.top=0,bd=fd.top):(od.bottom=0,bd=-fd.bottom),gd.left?(od.left=0,yd=fd.left):(od.right=0,yd=-fd.right),od[Ai]='translateX('+_Mathround(yd)+'px) translateY('+_Mathround(bd)+'px)','msTransform'!==Ai&&(od[Ai]+=' translateZ(0)')}else gd.top?od.top=fd.top+'px':od.bottom=fd.bottom+'px',gd.left?od.left=fd.left+'px':od.right=fd.right+'px'},ad=!1;if((Ki.page.top||Ki.page.bottom)&&(Ki.page.left||Ki.page.right)?(od.position='absolute',sd(Ki.page,$i.page)):(Ki.viewport.top||Ki.viewport.bottom)&&(Ki.viewport.left||Ki.viewport.right)?(od.position='fixed',sd(Ki.viewport,$i.viewport)):'undefined'!=typeof Ki.offset&&Ki.offset.top&&Ki.offset.left?function(){od.position='absolute';var ud=Xi.cache('target-offsetparent',function(){return ki(Xi.target)});ki(Xi.element)!==ud&&Pi(function(){Xi.element.parentNode.removeChild(Xi.element),ud.appendChild(Xi.element)}),sd(Ki.offset,$i.offset),ad=!0}():(od.position='absolute',sd({top:!0,left:!0},$i.page)),!ad){for(var nd=!0,ld=this.element.parentNode;ld&&1===ld.nodeType&&'BODY'!==ld.tagName;){if('static'!==getComputedStyle(ld).position){nd=!1;break}ld=ld.parentNode}nd||(this.element.parentNode.removeChild(this.element),this.element.ownerDocument.body.appendChild(this.element))}var rd={},dd=!1;for(var Ji in od){var pd=od[Ji],cd=this.element.style[Ji];cd!==pd&&(dd=!0,rd[Ji]=pd)}dd&&Pi(function(){Ci(Xi.element.style,rd),Xi.trigger('repositioned')})}}}]),Vi}(Di);qi.modules=[],yi['default'].position=Si;var Gi=Ci(qi,yi['default']);li['default']=Gi,ni.exports=li['default']},{'./abutment':1,'./constraint':2,'./shift':3,'./utils':5}],5:[function(ai,ni,li){'use strict';function ri(Di,Ai){if(!(Di instanceof Ai))throw new TypeError('Cannot call a class as a function')}function ii(Di){var Ai=Di.getBoundingClientRect(),Li={};for(var Si in Ai)Li[Si]=Ai[Si];if(Di.ownerDocument!==document){var zi=Di.ownerDocument.defaultView.frameElement;if(zi){var Ii=ii(zi);Li.top+=Ii.top,Li.bottom+=Ii.top,Li.left+=Ii.left,Li.right+=Ii.left}}return Li}function fi(){var Di=0>=arguments.length||void 0===arguments[0]?{}:arguments[0],Ai=[];return Array.prototype.push.apply(Ai,arguments),Ai.slice(1).forEach(function(Li){if(Li)for(var Si in Li)({}).hasOwnProperty.call(Li,Si)&&(Di[Si]=Li[Si])}),Di}function mi(Di,Ai){if('undefined'!=typeof Di.classList)Ai.split(' ').forEach(function(zi){zi.trim()&&Di.classList.remove(zi)});else{var Li=new RegExp('(^| )'+Ai.split(' ').join('|')+'( |$)','gi'),Si=yi(Di).replace(Li,' ');vi(Di,Si)}}function hi(Di,Ai){if('undefined'!=typeof Di.classList)Ai.split(' ').forEach(function(Si){Si.trim()&&Di.classList.add(Si)});else{mi(Di,Ai);var Li=yi(Di)+(' '+Ai);vi(Di,Li)}}function bi(Di,Ai){if('undefined'!=typeof Di.classList)return Di.classList.contains(Ai);var Li=yi(Di);return new RegExp('(^| )'+Ai+'( |$)','gi').test(Li)}function yi(Di){return Di.className instanceof Di.ownerDocument.defaultView.SVGAnimatedString?Di.className.baseVal:Di.className}function vi(Di,Ai){Di.setAttribute('class',Ai)}Object.defineProperty(li,'__esModule',{value:!0});var Ni=function(){function Di(Ai,Li){for(var zi,Si=0;Si<Li.length;Si++)zi=Li[Si],zi.enumerable=zi.enumerable||!1,zi.configurable=!0,'value'in zi&&(zi.writable=!0),Object.defineProperty(Ai,zi.key,zi)}return function(Ai,Li,Si){return Li&&Di(Ai.prototype,Li),Si&&Di(Ai,Si),Ai}}(),ki={modules:[]},Ci=null,Mi=function(){var Di=0;return function(){return++Di}}(),Oi={},Ei=function(){var Ai=Ci;Ai||(Ai=document.createElement('div'),Ai.setAttribute('data-tether-id',Mi()),fi(Ai.style,{top:0,left:0,position:'absolute'}),document.body.appendChild(Ai),Ci=Ai);var Li=Ai.getAttribute('data-tether-id');return'undefined'==typeof Oi[Li]&&(Oi[Li]=ii(Ai),wi(function(){delete Oi[Li]})),Oi[Li]},Pi=[],wi=function(Ai){Pi.push(Ai)},ji=function(){function Di(){ri(this,Di)}return Ni(Di,[{key:'on',value:function(Li,Si,zi){var Ii=3>=arguments.length||void 0===arguments[3]?!1:arguments[3];'undefined'==typeof this.bindings&&(this.bindings={}),'undefined'==typeof this.bindings[Li]&&(this.bindings[Li]=[]),this.bindings[Li].push({handler:Si,ctx:zi,once:Ii})}},{key:'once',value:function(Li,Si,zi){this.on(Li,Si,zi,!0)}},{key:'off',value:function(Li,Si){if('undefined'!=typeof this.bindings&&'undefined'!=typeof this.bindings[Li])if('undefined'==typeof Si)delete this.bindings[Li];else for(var zi=0;zi<this.bindings[Li].length;)this.bindings[Li][zi].handler===Si?this.bindings[Li].splice(zi,1):++zi}},{key:'trigger',value:function(Li){if('undefined'!=typeof this.bindings&&this.bindings[Li]){for(var Si=0,zi=arguments.length,Ii=Array(1<zi?zi-1:0),Ri=1;Ri<zi;Ri++)Ii[Ri-1]=arguments[Ri];for(;Si<this.bindings[Li].length;){var Bi=this.bindings[Li][Si],Wi=Bi.handler,Ui=Bi.ctx,Hi=Bi.once,qi=Ui;'undefined'==typeof qi&&(qi=this),Wi.apply(qi,Ii),Hi?this.bindings[Li].splice(Si,1):++Si}}}}]),Di}();ki.Utils={getActualBoundingClientRect:ii,getScrollParents:function(Di){var Ai=getComputedStyle(Di)||{},Li=Ai.position,Si=[];if('fixed'===Li)return[Di];for(var Ii,zi=Di;(zi=zi.parentNode)&&zi&&1===zi.nodeType;){Ii=void 0;try{Ii=getComputedStyle(zi)}catch(Hi){}if('undefined'==typeof Ii||null===Ii)return Si.push(zi),Si;var Ri=Ii,Bi=Ri.overflow,Wi=Ri.overflowX,Ui=Ri.overflowY;/(auto|scroll)/.test(Bi+Ui+Wi)&&('absolute'!==Li||0<=['relative','absolute','fixed'].indexOf(Ii.position))&&Si.push(zi)}return Si.push(Di.ownerDocument.body),Di.ownerDocument!==document&&Si.push(Di.ownerDocument.defaultView),Si},getBounds:function(Di){var Ai;Di===document?(Ai=document,Di=document.documentElement):Ai=Di.ownerDocument;var Li=Ai.documentElement,Si=ii(Di),zi=Ei();return Si.top-=zi.top,Si.left-=zi.left,'undefined'==typeof Si.width&&(Si.width=document.body.scrollWidth-Si.left-Si.right),'undefined'==typeof Si.height&&(Si.height=document.body.scrollHeight-Si.top-Si.bottom),Si.top-=Li.clientTop,Si.left-=Li.clientLeft,Si.right=Ai.body.clientWidth-Si.width-Si.left,Si.bottom=Ai.body.clientHeight-Si.height-Si.top,Si},getOffsetParent:function(Di){return Di.offsetParent||document.documentElement},extend:fi,addClass:hi,removeClass:mi,hasClass:bi,updateClasses:function(Di,Ai,Li){Li.forEach(function(Si){-1===Ai.indexOf(Si)&&bi(Di,Si)&&mi(Di,Si)}),Ai.forEach(function(Si){bi(Di,Si)||hi(Di,Si)})},defer:wi,flush:function(){for(var Ai;Ai=Pi.pop();)Ai()},uniqueId:Mi,Evented:ji,getScrollBarSize:function(){var Di=document.createElement('div');Di.style.width='100%',Di.style.height='200px';var Ai=document.createElement('div');fi(Ai.style,{position:'absolute',top:0,left:0,pointerEvents:'none',visibility:'hidden',width:'200px',height:'150px',overflow:'hidden'}),Ai.appendChild(Di),document.body.appendChild(Ai);var Li=Di.offsetWidth;Ai.style.overflow='scroll';var Si=Di.offsetWidth;Li===Si&&(Si=Ai.clientWidth),document.body.removeChild(Ai);var zi=Li-Si;return{width:zi,height:zi}},removeUtilElements:function(){Ci&&document.body.removeChild(Ci),Ci=null}},li['default']=ki,ni.exports=li['default']},{}]},{},[4])(4)})}),Wo=function(Qr){return Qr&&Qr.__esModule?Qr['default']:Qr}(Bo),Uo=g.PropTypes,Ho={children:Uo.node.isRequired,className:Uo.string,arrow:Uo.string,disabled:Uo.bool,isOpen:Uo.bool.isRequired,toggle:Uo.func.isRequired,tether:Uo.object.isRequired,tetherRef:Uo.func,style:Uo.node,cssModule:Uo.object},Go=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.handleDocumentClick=oi.handleDocumentClick.bind(oi),oi.toggle=oi.toggle.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'componentDidMount',value:function(){this.handleProps()}},{key:'componentDidUpdate',value:function(oi){this.props.isOpen===oi.isOpen?this._element&&this.renderIntoSubtree():this.handleProps()}},{key:'componentWillUnmount',value:function(){this.hide()}},{key:'getTarget',value:function(){var oi=this.props.tether.target;return Ro(oi)?oi():oi}},{key:'getTetherConfig',value:function(){var oi=at({},this.props.tether);return oi.element=this._element,oi.target=this.getTarget(),oi}},{key:'handleDocumentClick',value:function(oi){var si=this._element;oi.target!==si&&si.contains(oi.target)||this.toggle()}},{key:'handleProps',value:function(){this.props.isOpen?this.show():this.hide()}},{key:'hide',value:function(){document.removeEventListener('click',this.handleDocumentClick,!0),this._element&&(document.body.removeChild(this._element),m.unmountComponentAtNode(this._element),this._element=null),this._tether&&(this._tether.destroy(),this._tether=null,this.props.tetherRef(this._tether))}},{key:'show',value:function(){document.addEventListener('click',this.handleDocumentClick,!0),this._element=document.createElement('div'),this._element.className=this.props.className,document.body.appendChild(this._element),this.renderIntoSubtree(),this._tether=new Wo(this.getTetherConfig()),this.props.tetherRef(this._tether),this._tether.position(),this._element.childNodes[0].focus()}},{key:'toggle',value:function(oi){return this.props.disabled?oi&&oi.preventDefault():this.props.toggle()}},{key:'renderIntoSubtree',value:function(){m.unstable_renderSubtreeIntoContainer(this,this.renderChildren(),this._element)}},{key:'renderChildren',value:function(){var oi=this.props,si=oi.children,ai=oi.style;return g.cloneElement(si,{style:ai})}},{key:'render',value:function(){return null}}]),ei}(g.Component);Go.propTypes=Ho,Go.defaultProps={isOpen:!1,tetherRef:function(){}};var Fo=g.PropTypes,Vo={tag:Fo.oneOfType([Fo.func,Fo.string]),children:Fo.node.isRequired,right:Fo.bool,className:Fo.string,cssModule:Fo.object},$o={isOpen:Fo.bool.isRequired},Xo=function(ei,ti){var oi=ei.className,si=ei.cssModule,ai=ei.right,ni=ei.tag,li=lt(ei,['className','cssModule','right','tag']),ri=w(it(oi,'dropdown-menu',{'dropdown-menu-right':ai}),si);return g.createElement(ni,at({},li,{tabIndex:'-1','aria-hidden':!ti.isOpen,role:'menu',className:ri}))};Xo.propTypes=Vo,Xo.defaultProps={tag:'div'},Xo.contextTypes=$o;var Ko=g.PropTypes,Zo={disabled:Ko.bool,dropup:Ko.bool,group:Ko.bool,isOpen:Ko.bool,size:Ko.string,tag:Ko.string,tether:Ko.oneOfType([Ko.object,Ko.bool]),toggle:Ko.func,children:Ko.node,className:Ko.string,cssModule:Ko.object},Qo={toggle:Ko.func.isRequired,isOpen:Ko.bool.isRequired},es={classPrefix:'bs-tether',classes:{element:'dropdown',enabled:'show'},constraints:[{to:'scrollParent',attachment:'together none'},{to:'window',attachment:'together none'}]},ts=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.addEvents=oi.addEvents.bind(oi),oi.getTetherConfig=oi.getTetherConfig.bind(oi),oi.handleDocumentClick=oi.handleDocumentClick.bind(oi),oi.removeEvents=oi.removeEvents.bind(oi),oi.toggle=oi.toggle.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'getChildContext',value:function(){return{toggle:this.props.toggle,isOpen:this.props.isOpen}}},{key:'componentDidMount',value:function(){this.handleProps()}},{key:'componentDidUpdate',value:function(oi){this.props.isOpen!==oi.isOpen&&this.handleProps()}},{key:'componentWillUnmount',value:function(){this.removeEvents()}},{key:'getTetherTarget',value:function(){var oi=m.findDOMNode(this);return oi.querySelector('[data-toggle="dropdown"]')}},{key:'getTetherConfig',value:function(oi){var si=this,ni='top',li='left',ri='bottom',ii='left';return oi.right&&(li='right',ii='right'),this.props.dropup&&(ni='bottom',ri='top'),at({},es,{attachment:ni+' '+li,targetAttachment:ri+' '+ii,target:function(){return si.getTetherTarget()}},this.props.tether)}},{key:'addEvents',value:function(){document.addEventListener('click',this.handleDocumentClick,!0)}},{key:'removeEvents',value:function(){document.removeEventListener('click',this.handleDocumentClick,!0)}},{key:'handleDocumentClick',value:function(oi){var si=m.findDOMNode(this);si.contains(oi.target)&&si!==oi.target||this.toggle()}},{key:'handleProps',value:function(){this.props.tether||(this.props.isOpen?this.addEvents():this.removeEvents())}},{key:'toggle',value:function(oi){return this.props.disabled?oi&&oi.preventDefault():this.props.toggle()}},{key:'renderChildren',value:function(){var oi=this,si=this.props,ai=si.tether,ni=si.children,li=lt(si,['tether','children']);return li.toggle=this.toggle,g.Children.map(g.Children.toArray(ni),function(ri){if(ai&&ri.type===Xo){var ii=oi.getTetherConfig(ri.props);return g.createElement(Go,at({},li,{tether:ii}),ri)}return ri})}},{key:'render',value:function(){var oi,si=Ao(this.props,['toggle','tether']),ai=si.className,ni=si.cssModule,li=si.dropup,ri=si.group,ii=si.size,di=si.tag,pi=si.isOpen,ci=lt(si,['className','cssModule','dropup','group','size','tag','isOpen']),ui=w(it(ai,(oi={'btn-group':ri},st(oi,'btn-group-'+ii,!!ii),st(oi,'dropdown',!ri),st(oi,'show',pi),st(oi,'dropup',li),oi)),ni);return g.createElement(di,at({},ci,{className:ui}),this.renderChildren())}}]),ei}(g.Component);ts.propTypes=Zo,ts.defaultProps={isOpen:!1,tag:'div'},ts.childContextTypes=Qo;var os=g.PropTypes,ss={children:os.node,tag:os.oneOfType([os.func,os.string]),className:os.string,cssModule:os.object},ns=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'nav-item'),oi);return g.createElement(ts,at({},ai,{tag:si,className:ni}))};ns.propTypes=ss,ns.defaultProps={tag:'li'};var ls=g.PropTypes,rs={tag:ls.oneOfType([ls.func,ls.string]),getRef:ls.oneOfType([ls.func,ls.string]),disabled:ls.bool,active:ls.bool,className:ls.string,cssModule:ls.object,onClick:ls.func,href:ls.any},ds=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.onClick=oi.onClick.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'onClick',value:function(oi){return this.props.disabled?void oi.preventDefault():void('#'===this.props.href&&oi.preventDefault(),this.props.onClick&&this.props.onClick(oi))}},{key:'render',value:function(){var oi=this.props,si=oi.className,ai=oi.cssModule,ni=oi.active,li=oi.tag,ri=oi.getRef,ii=lt(oi,['className','cssModule','active','tag','getRef']),di=w(it(si,'nav-link',{disabled:ii.disabled,active:ni}),ai);return g.createElement(li,at({},ii,{ref:ri,onClick:this.onClick,className:di}))}}]),ei}(g.Component);ds.propTypes=rs,ds.defaultProps={tag:'a'};var ps=g.PropTypes,cs={tag:ps.string,className:ps.string,cssModule:ps.object},gs=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'breadcrumb'),oi);return g.createElement(si,at({},ai,{className:ni}))};gs.propTypes=cs,gs.defaultProps={tag:'ol'};var fs=g.PropTypes,ms={tag:fs.oneOfType([fs.func,fs.string]),active:fs.bool,className:fs.string,cssModule:fs.object},bs=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.active,ai=ei.tag,ni=lt(ei,['className','cssModule','active','tag']),li=w(it(ti,!!si&&'active','breadcrumb-item'),oi);return g.createElement(ai,at({},ni,{className:li}))};bs.propTypes=ms,bs.defaultProps={tag:'li'};var ys=g.PropTypes,vs={active:ys.bool,block:ys.bool,color:ys.string,disabled:ys.bool,outline:ys.bool,tag:ys.oneOfType([ys.func,ys.string]),getRef:ys.oneOfType([ys.func,ys.string]),onClick:ys.func,size:ys.string,children:ys.node,className:ys.string,cssModule:ys.object},Ns=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.onClick=oi.onClick.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'onClick',value:function(oi){return this.props.disabled?void oi.preventDefault():void(this.props.onClick&&this.props.onClick(oi))}},{key:'render',value:function(){var oi=this.props,si=oi.active,ai=oi.block,ni=oi.className,li=oi.cssModule,ri=oi.color,ii=oi.outline,di=oi.size,pi=oi.tag,ci=oi.getRef,ui=lt(oi,['active','block','className','cssModule','color','outline','size','tag','getRef']),gi=w(it(ni,'btn','btn'+(ii?'-outline':'')+'-'+ri,!!di&&'btn-'+di,!!ai&&'btn-block',{active:si,disabled:this.props.disabled}),li);return ui.href&&'button'===pi&&(pi='a'),g.createElement(pi,at({type:'button'===pi&&ui.onClick?'button':void 0},ui,{className:gi,ref:ci,onClick:this.onClick}))}}]),ei}(g.Component);Ns.propTypes=vs,Ns.defaultProps={color:'secondary',tag:'button'};var ks=g.PropTypes,Cs={children:ks.node},Ms=function(ei){return g.createElement(ts,at({},ei,{group:!0}))};Ms.propTypes=Cs;var Os=g.PropTypes,Es={tag:Os.oneOfType([Os.func,Os.string]),'aria-label':Os.string,className:Os.string,cssModule:Os.object,role:Os.string,size:Os.string,vertical:Os.bool},ws=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.size,ai=ei.vertical,ni=ei.tag,li=lt(ei,['className','cssModule','size','vertical','tag']),ri=w(it(ti,!!si&&'btn-group-'+si,ai?'btn-group-vertical':'btn-group'),oi);return g.createElement(ni,at({},li,{className:ri}))};ws.propTypes=Es,ws.defaultProps={tag:'div',role:'group'};var xs=g.PropTypes,js={tag:xs.oneOfType([xs.func,xs.string]),'aria-label':xs.string,className:xs.string,cssModule:xs.object,role:xs.string},As=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'btn-toolbar'),oi);return g.createElement(si,at({},ai,{className:ni}))};As.propTypes=js,As.defaultProps={tag:'div',role:'toolbar'};var Ls=g.PropTypes,Ss={children:Ls.node,disabled:Ls.bool,divider:Ls.bool,tag:Ls.oneOfType([Ls.func,Ls.string]),header:Ls.bool,onClick:Ls.func,className:Ls.string,cssModule:Ls.object,toggle:Ls.bool},zs={toggle:Ls.func},Rs=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.onClick=oi.onClick.bind(oi),oi.getTabIndex=oi.getTabIndex.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'onClick',value:function(oi){return this.props.disabled||this.props.header||this.props.divider?void oi.preventDefault():void(this.props.onClick&&this.props.onClick(oi),this.props.toggle&&this.context.toggle())}},{key:'getTabIndex',value:function(){return this.props.disabled||this.props.header||this.props.divider?'-1':'0'}},{key:'render',value:function(){var oi=this.getTabIndex(),si=Ao(this.props,['toggle']),ai=si.className,ni=si.cssModule,li=si.divider,ri=si.tag,ii=si.header,di=lt(si,['className','cssModule','divider','tag','header']),pi=w(it(ai,{disabled:di.disabled,'dropdown-item':!li&&!ii,'dropdown-header':ii,'dropdown-divider':li}),ni);return'button'===ri&&(ii?ri='h6':li?ri='div':di.href&&(ri='a')),g.createElement(ri,at({type:'button'===ri&&(di.onClick||this.props.toggle)?'button':void 0},di,{tabIndex:oi,className:pi,onClick:this.onClick}))}}]),ei}(g.Component);Rs.propTypes=Ss,Rs.defaultProps={tag:'button',toggle:!0},Rs.contextTypes=zs;var Bs=g.PropTypes,Ws={caret:Bs.bool,children:Bs.node,className:Bs.string,cssModule:Bs.object,disabled:Bs.bool,onClick:Bs.func,'data-toggle':Bs.string,'aria-haspopup':Bs.bool,split:Bs.bool,tag:Bs.oneOfType([Bs.func,Bs.string]),nav:Bs.bool},Hs={isOpen:Bs.bool.isRequired,toggle:Bs.func.isRequired},qs=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.onClick=oi.onClick.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'onClick',value:function(oi){return this.props.disabled?void oi.preventDefault():void(this.props.nav&&!this.props.tag&&oi.preventDefault(),this.props.onClick&&this.props.onClick(oi),this.context.toggle())}},{key:'render',value:function(){var gi,oi=this.props,si=oi.className,ai=oi.cssModule,ni=oi.caret,li=oi.split,ri=oi.nav,ii=oi.tag,di=lt(oi,['className','cssModule','caret','split','nav','tag']),pi=di['aria-label']||'Toggle Dropdown',ci=w(it(si,{'dropdown-toggle':ni||li,'dropdown-toggle-split':li,active:this.context.isOpen,'nav-link':ri}),ai),ui=di.children||g.createElement('span',{className:'sr-only'},pi);return ri&&!ii?(gi='a',di.href='#'):ii?gi=ii:gi=Ns,g.createElement(gi,at({},di,{className:ci,onClick:this.onClick,'aria-haspopup':'true','aria-expanded':this.context.isOpen,children:ui}))}}]),ei}(g.Component);qs.propTypes=Ws,qs.defaultProps={'data-toggle':'dropdown','aria-haspopup':!0,color:'secondary'},qs.contextTypes=Hs;var Gs=g.PropTypes,Fs={baseClass:Gs.string,baseClassIn:Gs.string,tag:Gs.oneOfType([Gs.func,Gs.string]),className:Gs.string,cssModule:Gs.object,transitionAppearTimeout:Gs.number,transitionEnterTimeout:Gs.number,transitionLeaveTimeout:Gs.number,transitionAppear:Gs.bool,transitionEnter:Gs.bool,transitionLeave:Gs.bool,onLeave:Gs.func,onEnter:Gs.func},Ys=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.state={mounted:!ti.transitionAppear},oi.onLeave=oi.onLeave.bind(oi),oi.onEnter=oi.onEnter.bind(oi),oi.timers=[],oi}return nt(ei,Qr),ot(ei,[{key:'componentWillUnmount',value:function(){this.timers.forEach(function(oi){return clearTimeout(oi)})}},{key:'onEnter',value:function(oi){var si=this;return function(){oi(),si.props.onEnter&&si.props.onEnter()}}},{key:'onLeave',value:function(oi){var si=this;return function(){oi(),si.props.onLeave&&si.props.onLeave()}}},{key:'componentWillAppear',value:function(oi){this.props.transitionAppear||this.onEnter(oi)(),this.timers.push(setTimeout(this.onEnter(oi),this.props.transitionAppearTimeout))}},{key:'componentDidAppear',value:function(){this.setState({mounted:!0})}},{key:'componentWillEnter',value:function(oi){this.props.transitionEnter||this.onEnter(oi)(),this.timers.push(setTimeout(this.onEnter(oi),this.props.transitionEnterTimeout))}},{key:'componentDidEnter',value:function(){this.setState({mounted:!0})}},{key:'componentWillLeave',value:function(oi){this.setState({mounted:!1}),this.props.transitionLeave||this.onLeave(oi)(),this.timers.push(setTimeout(this.onLeave(oi),this.props.transitionLeaveTimeout))}},{key:'render',value:function(){var oi=this.props,si=oi.baseClass,ai=oi.baseClassIn,ni=oi.className,li=oi.cssModule,ri=oi.tag,ii=Ao(this.props,Object.keys(Fs)),di=w(it(ni,si,!!this.state.mounted&&ai),li);return g.createElement(ri,at({},ii,{className:di}))}}]),ei}(g.Component);Ys.propTypes=Fs,Ys.defaultProps={tag:'div',baseClass:'fade',baseClassIn:'show',transitionAppearTimeout:0,transitionEnterTimeout:0,transitionLeaveTimeout:0,transitionAppear:!0,transitionEnter:!0,transitionLeave:!0};var $s=g.PropTypes,Xs={color:$s.string,pill:$s.bool,tag:$s.oneOfType([$s.func,$s.string]),children:$s.node,className:$s.string,cssModule:$s.object},Zs=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.color,ai=ei.pill,ni=ei.tag,li=lt(ei,['className','cssModule','color','pill','tag']),ri=w(it(ti,'badge','badge-'+si,!!ai&&'badge-pill'),oi);return g.createElement(ni,at({},li,{className:ri}))};Zs.propTypes=Xs,Zs.defaultProps={color:'default',pill:!1,tag:'span'};var Js=g.PropTypes,Qs={tag:Js.oneOfType([Js.func,Js.string]),inverse:Js.bool,color:Js.string,block:Js.bool,outline:Js.bool,className:Js.string,cssModule:Js.object},ta=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.color,ai=ei.block,ni=ei.inverse,li=ei.outline,ri=ei.tag,ii=lt(ei,['className','cssModule','color','block','inverse','outline','tag']),di=w(it(ti,'card',!!ni&&'card-inverse',!!ai&&'card-block',!!si&&'card'+(li?'-outline':'')+'-'+si),oi);return g.createElement(ri,at({},ii,{className:di}))};ta.propTypes=Qs,ta.defaultProps={tag:'div'};var oa=g.PropTypes,sa={tag:oa.oneOfType([oa.func,oa.string]),className:oa.string,cssModule:oa.object},na=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-group'),oi);return g.createElement(si,at({},ai,{className:ni}))};na.propTypes=sa,na.defaultProps={tag:'div'};var la=g.PropTypes,ra={tag:la.oneOfType([la.func,la.string]),className:la.string,cssModule:la.object},da=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-deck'),oi);return g.createElement(si,at({},ai,{className:ni}))};da.propTypes=ra,da.defaultProps={tag:'div'};var pa=g.PropTypes,ca={tag:pa.oneOfType([pa.func,pa.string]),className:pa.string,cssModule:pa.object},ga=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-columns'),oi);return g.createElement(si,at({},ai,{className:ni}))};ga.propTypes=ca,ga.defaultProps={tag:'div'};var fa=g.PropTypes,ma={tag:fa.oneOfType([fa.func,fa.string]),className:fa.string,cssModule:fa.object},ba=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-block'),oi);return g.createElement(si,at({},ai,{className:ni}))};ba.propTypes=ma,ba.defaultProps={tag:'div'};var ya=g.PropTypes,va={tag:ya.oneOfType([ya.func,ya.string]),getRef:ya.oneOfType([ya.func,ya.string]),className:ya.string,cssModule:ya.object},Na=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=ei.getRef,ni=lt(ei,['className','cssModule','tag','getRef']),li=w(it(ti,'card-link'),oi);return g.createElement(si,at({},ni,{ref:ai,className:li}))};Na.propTypes=va,Na.defaultProps={tag:'a'};var ka=g.PropTypes,Ca={tag:ka.oneOfType([ka.func,ka.string]),className:ka.string,cssModule:ka.object},_a=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-footer'),oi);return g.createElement(si,at({},ai,{className:ni}))};_a.propTypes=Ca,_a.defaultProps={tag:'div'};var Oa=g.PropTypes,Ea={tag:Oa.oneOfType([Oa.func,Oa.string]),className:Oa.string,cssModule:Oa.object},wa=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-header'),oi);return g.createElement(si,at({},ai,{className:ni}))};wa.propTypes=Ea,wa.defaultProps={tag:'div'};var xa=g.PropTypes,ja={tag:xa.oneOfType([xa.func,xa.string]),top:xa.bool,bottom:xa.bool,className:xa.string,cssModule:xa.object},Aa=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.top,ai=ei.bottom,ni=ei.tag,li=lt(ei,['className','cssModule','top','bottom','tag']),ri='card-img';si&&(ri='card-img-top'),ai&&(ri='card-img-bottom');var ii=w(it(ti,ri),oi);return g.createElement(ni,at({},li,{className:ii}))};Aa.propTypes=ja,Aa.defaultProps={tag:'img'};var La=g.PropTypes,Sa={tag:La.oneOfType([La.func,La.string]),className:La.string,cssModule:La.object},Ia=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-img-overlay'),oi);return g.createElement(si,at({},ai,{className:ni}))};Ia.propTypes=Sa,Ia.defaultProps={tag:'div'};var Ra=g.PropTypes,Ba={tag:Ra.oneOfType([Ra.func,Ra.string]),className:Ra.string,cssModule:Ra.object},Ua=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-subtitle'),oi);return g.createElement(si,at({},ai,{className:ni}))};Ua.propTypes=Ba,Ua.defaultProps={tag:'h6'};var Ha=g.PropTypes,qa={tag:Ha.oneOfType([Ha.func,Ha.string]),className:Ha.string,cssModule:Ha.object},Fa=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-text'),oi);return g.createElement(si,at({},ai,{className:ni}))};Fa.propTypes=qa,Fa.defaultProps={tag:'p'};var Va=g.PropTypes,Ya={tag:Va.oneOfType([Va.func,Va.string]),className:Va.string,cssModule:Va.object},Xa=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-title'),oi);return g.createElement(si,at({},ai,{className:ni}))};Xa.propTypes=Ya,Xa.defaultProps={tag:'h4'};var Ka=g.PropTypes,Za={placement:g.PropTypes.oneOf(dt),target:Ka.string.isRequired,isOpen:Ka.bool,tether:Ka.object,tetherRef:Ka.func,className:Ka.string,cssModule:Ka.object,toggle:Ka.func},Qa={classPrefix:'bs-tether',classes:{element:!1,enabled:'show'},constraints:[{to:'scrollParent',attachment:'together none'},{to:'window',attachment:'together none'}]},en=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.getTetherConfig=oi.getTetherConfig.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'getTetherConfig',value:function(){var oi=C(this.props.placement);return at({},Qa,oi,{target:'#'+this.props.target},this.props.tether)}},{key:'render',value:function(){if(!this.props.isOpen)return null;var oi=this.getTetherConfig(),si=w(it('popover-inner',this.props.className),this.props.cssModule),ai=Ao(this.props,Object.keys(Za));return g.createElement(Go,{className:w('popover',this.props.cssModule),tether:oi,tetherRef:this.props.tetherRef,isOpen:this.props.isOpen,toggle:this.props.toggle},g.createElement('div',at({},ai,{className:si})))}}]),ei}(g.Component);en.propTypes=Za,en.defaultProps={isOpen:!1,placement:'bottom',toggle:function(){}};var tn=g.PropTypes,sn={tag:tn.oneOfType([tn.func,tn.string]),className:tn.string,cssModule:tn.object},nn=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'popover-title'),oi);return g.createElement(si,at({},ai,{className:ni}))};nn.propTypes=sn,nn.defaultProps={tag:'h3'};var ln=g.PropTypes,rn={tag:ln.oneOfType([ln.func,ln.string]),className:ln.string,cssModule:ln.object},pn=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'popover-content'),oi);return g.createElement(si,at({},ai,{className:ni}))};pn.propTypes=rn,pn.defaultProps={tag:'div'};var cn=0/0,un='[object Symbol]',gn=/^\s+|\s+$/g,mn=/^[-+]0x[0-9a-f]+$/i,hn=/^0b[01]+$/i,bn=/^0o[0-7]+$/i,yn=parseInt,vn=Object.prototype,Tn=vn.toString,Nn=function(Qr){if('number'==typeof Qr)return Qr;if(Ke(Qr))return cn;if($e(Qr)){var ei='function'==typeof Qr.valueOf?Qr.valueOf():Qr;Qr=$e(ei)?ei+'':ei}if('string'!=typeof Qr)return 0===Qr?Qr:+Qr;Qr=Qr.replace(gn,'');var ti=hn.test(Qr);return ti||bn.test(Qr)?yn(Qr.slice(2),ti?2:8):mn.test(Qr)?cn:+Qr},kn=g.PropTypes,Cn={children:kn.node,bar:kn.bool,multi:kn.bool,tag:kn.string,value:kn.oneOfType([kn.string,kn.number]),max:kn.oneOfType([kn.string,kn.number]),animated:kn.bool,striped:kn.bool,color:kn.string,className:kn.string,barClassName:kn.string,cssModule:kn.object},On=function(ei){var ti=ei.children,oi=ei.className,si=ei.barClassName,ai=ei.cssModule,ni=ei.value,li=ei.max,ri=ei.animated,ii=ei.striped,di=ei.color,pi=ei.bar,ci=ei.multi,ui=ei.tag,gi=lt(ei,['children','className','barClassName','cssModule','value','max','animated','striped','color','bar','multi','tag']),fi=100*(Nn(ni)/Nn(li)),mi=w(it(oi,'progress'),ai),hi=w(it('progress-bar',pi?oi||si:si,ri?'progress-bar-animated':null,di?'bg-'+di:null,ii||ri?'progress-bar-striped':null),ai),bi=ci?ti:g.createElement('div',{className:hi,style:{width:fi+'%'},role:'progressbar','aria-valuenow':ni,'aria-valuemin':'0','aria-valuemax':li,children:ti});return pi?bi:g.createElement(ui,at({},gi,{className:mi,children:bi}))};On.propTypes=Cn,On.defaultProps={tag:'div',value:0,max:100};var En=g.PropTypes,Pn={isOpen:En.bool,size:En.string,toggle:En.func,keyboard:En.bool,backdrop:En.oneOfType([En.bool,En.oneOf(['static'])]),onEnter:En.func,onExit:En.func,children:En.node,className:En.string,wrapClassName:En.string,modalClassName:En.string,backdropClassName:En.string,contentClassName:En.string,cssModule:En.object,zIndex:En.oneOfType([En.number,En.string])},xn=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.originalBodyPadding=null,oi.isBodyOverflowing=!1,oi.togglePortal=oi.togglePortal.bind(oi),oi.handleBackdropClick=oi.handleBackdropClick.bind(oi),oi.handleEscape=oi.handleEscape.bind(oi),oi.destroy=oi.destroy.bind(oi),oi.onEnter=oi.onEnter.bind(oi),oi.onExit=oi.onExit.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'componentDidMount',value:function(){this.props.isOpen&&this.togglePortal()}},{key:'componentDidUpdate',value:function(oi){this.props.isOpen===oi.isOpen?this._element&&this.renderIntoSubtree():this.togglePortal()}},{key:'componentWillUnmount',value:function(){this.onExit()}},{key:'onEnter',value:function(){this.props.onEnter&&this.props.onEnter()}},{key:'onExit',value:function(){this.destroy(),this.props.onExit&&this.props.onExit()}},{key:'handleEscape',value:function(oi){this.props.keyboard&&27===oi.keyCode&&this.props.toggle&&this.props.toggle()}},{key:'handleBackdropClick',value:function(oi){if(!0===this.props.backdrop){var si=this._dialog;oi.target&&!si.contains(oi.target)&&this.props.toggle&&this.props.toggle()}}},{key:'togglePortal',value:function(){this.props.isOpen?(this._focus=!0,this.show()):this.hide()}},{key:'destroy',value:function(){this._element&&(m.unmountComponentAtNode(this._element),document.body.removeChild(this._element),this._element=null);var oi=document.body.className.replace('modal-open','');document.body.className=w(it(oi).trim(),this.props.cssModule),_(this.originalBodyPadding)}},{key:'hide',value:function(){this.renderIntoSubtree()}},{key:'show',value:function(){var oi=document.body.className;this._element=document.createElement('div'),this._element.setAttribute('tabindex','-1'),this._element.style.position='relative',this._element.style.zIndex=this.props.zIndex,this.originalBodyPadding=E(),P(),document.body.appendChild(this._element),document.body.className=w(it(oi,'modal-open'),this.props.cssModule),this.renderIntoSubtree()}},{key:'renderIntoSubtree',value:function(){m.unstable_renderSubtreeIntoContainer(this,this.renderChildren(),this._element),this._focus&&(this._dialog.parentNode.focus(),this._focus=!1)}},{key:'renderChildren',value:function(){var oi=this,si=Ao(this.props,['toggle','keyboard','onEnter','onExit','zIndex']),ai=si.className,ni=si.wrapClassName,li=si.modalClassName,ri=si.backdropClassName,ii=si.contentClassName,di=si.cssModule,pi=si.isOpen,ci=si.size,ui=si.backdrop,gi=si.children,fi=lt(si,['className','wrapClassName','modalClassName','backdropClassName','contentClassName','cssModule','isOpen','size','backdrop','children']);return g.createElement(h,{component:'div',className:w(ni)},pi&&g.createElement(Ys,{key:'modal-dialog',onEnter:this.onEnter,onLeave:this.onExit,transitionAppearTimeout:300,transitionEnterTimeout:300,transitionLeaveTimeout:300,onClickCapture:this.handleBackdropClick,onKeyUp:this.handleEscape,cssModule:di,className:w(it('modal',li),di),style:{display:'block'},tabIndex:'-1'},g.createElement('div',at({className:w(it('modal-dialog',ai,st({},'modal-'+ci,ci)),di),role:'document',ref:function(hi){return oi._dialog=hi}},fi),g.createElement('div',{className:w(it('modal-content',ii),di)},gi))),pi&&ui&&g.createElement(Ys,{key:'modal-backdrop',transitionAppearTimeout:150,transitionEnterTimeout:150,transitionLeaveTimeout:150,cssModule:di,className:w(it('modal-backdrop',ri),di)}))}},{key:'render',value:function(){return null}}]),ei}(g.Component);xn.propTypes=Pn,xn.defaultProps={isOpen:!1,backdrop:!0,keyboard:!0,zIndex:1050};var jn=g.PropTypes,Dn={tag:jn.oneOfType([jn.func,jn.string]),wrapTag:jn.oneOfType([jn.func,jn.string]),toggle:jn.func,className:jn.string,cssModule:jn.object,children:jn.node},Ln=function(ei){var ti,oi=ei.className,si=ei.cssModule,ai=ei.children,ni=ei.toggle,li=ei.tag,ri=ei.wrapTag,ii=lt(ei,['className','cssModule','children','toggle','tag','wrapTag']),di=w(it(oi,'modal-header'),si);return ni&&(ti=g.createElement('button',{type:'button',onClick:ni,className:'close','aria-label':'Close'},g.createElement('span',{'aria-hidden':'true'},'\xD7'))),g.createElement(ri,at({},ii,{className:di}),g.createElement(li,{className:w('modal-title',si)},ai),ti)};Ln.propTypes=Dn,Ln.defaultProps={tag:'h4',wrapTag:'div'};var Sn=g.PropTypes,zn={tag:Sn.oneOfType([Sn.func,Sn.string]),className:Sn.string,cssModule:Sn.object},Rn=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'modal-body'),oi);return g.createElement(si,at({},ai,{className:ni}))};Rn.propTypes=zn,Rn.defaultProps={tag:'div'};var Bn=g.PropTypes,Wn={tag:Bn.oneOfType([Bn.func,Bn.string]),className:Bn.string,cssModule:Bn.object},Hn=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'modal-footer'),oi);return g.createElement(si,at({},ai,{className:ni}))};Hn.propTypes=Wn,Hn.defaultProps={tag:'div'};var qn=g.PropTypes,Gn={placement:g.PropTypes.oneOf(dt),target:qn.oneOfType([qn.string,qn.object]).isRequired,isOpen:qn.bool,disabled:qn.bool,tether:qn.object,tetherRef:qn.func,className:qn.string,cssModule:qn.object,toggle:qn.func,autohide:qn.bool,delay:qn.oneOfType([qn.shape({show:qn.number,hide:qn.number}),qn.number])},Fn={show:0,hide:250},Yn={classPrefix:'bs-tether',classes:{element:!1,enabled:'show'},constraints:[{to:'scrollParent',attachment:'together none'},{to:'window',attachment:'together none'}]},$n=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.addTargetEvents=oi.addTargetEvents.bind(oi),oi.getTarget=oi.getTarget.bind(oi),oi.getTetherConfig=oi.getTetherConfig.bind(oi),oi.handleDocumentClick=oi.handleDocumentClick.bind(oi),oi.removeTargetEvents=oi.removeTargetEvents.bind(oi),oi.toggle=oi.toggle.bind(oi),oi.onMouseOverTooltip=oi.onMouseOverTooltip.bind(oi),oi.onMouseLeaveTooltip=oi.onMouseLeaveTooltip.bind(oi),oi.onMouseOverTooltipContent=oi.onMouseOverTooltipContent.bind(oi),oi.onMouseLeaveTooltipContent=oi.onMouseLeaveTooltipContent.bind(oi),oi.show=oi.show.bind(oi),oi.hide=oi.hide.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'componentDidMount',value:function(){this._target=this.getTarget(),this.addTargetEvents()}},{key:'componentWillUnmount',value:function(){this.removeTargetEvents()}},{key:'onMouseOverTooltip',value:function(){this._hideTimeout&&this.clearHideTimeout(),this._showTimeout=setTimeout(this.show,this.getDelay('show'))}},{key:'onMouseLeaveTooltip',value:function(){this._showTimeout&&this.clearShowTimeout(),this._hideTimeout=setTimeout(this.hide,this.getDelay('hide'))}},{key:'onMouseOverTooltipContent',value:function(){this.props.autohide||this._hideTimeout&&this.clearHideTimeout()}},{key:'onMouseLeaveTooltipContent',value:function(){this.props.autohide||(this._showTimeout&&this.clearShowTimeout(),this._hideTimeout=setTimeout(this.hide,this.getDelay('hide')))}},{key:'getDelay',value:function(oi){var si=this.props.delay;return'object'===('undefined'==typeof si?'undefined':et(si))?isNaN(si[oi])?Fn[oi]:si[oi]:si}},{key:'getTarget',value:function(){var oi=this.props.target;return'object'===('undefined'==typeof oi?'undefined':et(oi))?oi:document.getElementById(oi)}},{key:'getTetherConfig',value:function(){var oi=C(this.props.placement);return at({},Yn,oi,{target:this.getTarget},this.props.tether)}},{key:'show',value:function(){this.props.isOpen||(this.clearShowTimeout(),this.toggle())}},{key:'hide',value:function(){this.props.isOpen&&(this.clearHideTimeout(),this.toggle())}},{key:'clearShowTimeout',value:function(){clearTimeout(this._showTimeout),this._showTimeout=void 0}},{key:'clearHideTimeout',value:function(){clearTimeout(this._hideTimeout),this._hideTimeout=void 0}},{key:'handleDocumentClick',value:function(oi){(oi.target===this._target||this._target.contains(oi.target))&&(this._hideTimeout&&this.clearHideTimeout(),!this.props.isOpen&&this.toggle())}},{key:'addTargetEvents',value:function(){this._target.addEventListener('mouseover',this.onMouseOverTooltip,!0),this._target.addEventListener('mouseout',this.onMouseLeaveTooltip,!0),document.addEventListener('click',this.handleDocumentClick,!0)}},{key:'removeTargetEvents',value:function(){this._target.removeEventListener('mouseover',this.onMouseOverTooltip,!0),this._target.removeEventListener('mouseout',this.onMouseLeaveTooltip,!0),document.removeEventListener('click',this.handleDocumentClick,!0)}},{key:'toggle',value:function(oi){return this.props.disabled?oi&&oi.preventDefault():this.props.toggle()}},{key:'render',value:function(){if(!this.props.isOpen)return null;var oi=Ao(this.props,Object.keys(Gn)),si=w(it('tooltip-inner',this.props.className),this.props.cssModule),ai=this.getTetherConfig();return g.createElement(Go,{className:'tooltip',tether:ai,tetherRef:this.props.tetherRef,isOpen:this.props.isOpen,toggle:this.toggle},g.createElement('div',at({},oi,{className:si,onMouseOver:this.onMouseOverTooltipContent,onMouseLeave:this.onMouseLeaveTooltipContent})))}}]),ei}(g.Component);$n.propTypes=Gn,$n.defaultProps={isOpen:!1,placement:'bottom',delay:Fn,autohide:!0,toggle:function(){}};var Xn=g.PropTypes,Kn={className:Xn.string,cssModule:Xn.object,size:Xn.string,bordered:Xn.bool,striped:Xn.bool,inverse:Xn.bool,hover:Xn.bool,reflow:Xn.bool,responsive:Xn.bool,tag:Xn.oneOfType([Xn.func,Xn.string]),responsiveTag:Xn.oneOfType([Xn.func,Xn.string])},Jn=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.size,ai=ei.bordered,ni=ei.striped,li=ei.inverse,ri=ei.hover,ii=ei.reflow,di=ei.responsive,pi=ei.tag,ci=ei.responsiveTag,ui=lt(ei,['className','cssModule','size','bordered','striped','inverse','hover','reflow','responsive','tag','responsiveTag']),gi=w(it(ti,'table',!!si&&'table-'+si,!!ai&&'table-bordered',!!ni&&'table-striped',!!li&&'table-inverse',!!ri&&'table-hover',!!ii&&'table-reflow'),oi),fi=g.createElement(pi,at({},ui,{className:gi}));return di?g.createElement(ci,{className:'table-responsive'},fi):fi};Jn.propTypes=Kn,Jn.defaultProps={tag:'table',responsiveTag:'div'};var Qn=g.PropTypes,tl={tag:Qn.oneOfType([Qn.func,Qn.string]),flush:Qn.bool,className:Qn.string,cssModule:Qn.object},sl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=ei.flush,ni=lt(ei,['className','cssModule','tag','flush']),li=w(it(ti,'list-group',!!ai&&'list-group-flush'),oi);return g.createElement(si,at({},ni,{className:li}))};sl.propTypes=tl,sl.defaultProps={tag:'ul'};var al=g.PropTypes,nl={children:al.node,inline:al.bool,tag:al.oneOfType([al.func,al.string]),getRef:al.oneOfType([al.func,al.string]),className:al.string,cssModule:al.object},rl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.inline,ai=ei.tag,ni=ei.getRef,li=lt(ei,['className','cssModule','inline','tag','getRef']),ri=w(it(ti,!!si&&'form-inline'),oi);return g.createElement(ai,at({},li,{ref:ni,className:ri}))};rl.propTypes=nl,rl.defaultProps={tag:'form'};var il=g.PropTypes,dl={children:il.node,tag:il.string,className:il.string,cssModule:il.object},cl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'form-control-feedback'),oi);return g.createElement(si,at({},ai,{className:ni}))};cl.propTypes=dl,cl.defaultProps={tag:'div'};var ul=g.PropTypes,gl={children:ul.node,row:ul.bool,check:ul.bool,disabled:ul.bool,tag:ul.string,color:ul.string,className:ul.string,cssModule:ul.object},ml=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.row,ai=ei.disabled,ni=ei.color,li=ei.check,ri=ei.tag,ii=lt(ei,['className','cssModule','row','disabled','color','check','tag']),di=w(it(ti,!!ni&&'has-'+ni,!!si&&'row',li?'form-check':'form-group',li&&ai&&'disabled'),oi);return g.createElement(ri,at({},ii,{className:di}))};ml.propTypes=gl,ml.defaultProps={tag:'div'};var hl=g.PropTypes,bl={children:hl.node,inline:hl.bool,tag:hl.string,color:hl.string,className:hl.string,cssModule:hl.object},vl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.inline,ai=ei.color,ni=ei.tag,li=lt(ei,['className','cssModule','inline','color','tag']),ri=w(it(ti,!si&&'form-text',!!ai&&'text-'+ai),oi);return g.createElement(ni,at({},li,{className:ri}))};vl.propTypes=bl,vl.defaultProps={tag:'small'};var Tl=g.PropTypes,Nl={children:Tl.node,type:Tl.string,size:Tl.string,state:Tl.string,tag:Tl.oneOfType([Tl.func,Tl.string]),getRef:Tl.oneOfType([Tl.func,Tl.string]),static:Tl.bool,addon:Tl.bool,className:Tl.string,cssModule:Tl.object},Cl=function(Qr){function ei(){return tt(this,ei),rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).apply(this,arguments))}return nt(ei,Qr),ot(ei,[{key:'render',value:function(){var oi=this.props,si=oi.className,ai=oi.cssModule,ni=oi.type,li=oi.size,ri=oi.state,ii=oi.tag,di=oi.addon,pi=oi.static,ci=oi.getRef,ui=lt(oi,['className','cssModule','type','size','state','tag','addon','static','getRef']),gi=-1<['radio','checkbox'].indexOf(ni),bi='select'===ni||'textarea'===ni?ni:'input',yi='form-control';pi?(yi+='-static',bi=ii):'file'===ni?yi+='-file':gi&&(di?yi=null:yi='form-check-input');var vi=w(it(si,!!ri&&'form-control-'+ri,!!li&&'form-control-'+li,yi),ai);return'input'===bi&&(ui.type=ni),g.createElement(bi,at({},ui,{ref:ci,className:vi}))}}]),ei}(g.Component);Cl.propTypes=Nl,Cl.defaultProps={tag:'p',type:'text'};var Ml=g.PropTypes,_l={tag:Ml.oneOfType([Ml.func,Ml.string]),size:Ml.string,className:Ml.string,cssModule:Ml.object},El=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=ei.size,ni=lt(ei,['className','cssModule','tag','size']),li=w(it(ti,'input-group',ai?'input-group-'+ai:null),oi);return g.createElement(si,at({},ni,{className:li}))};El.propTypes=_l,El.defaultProps={tag:'div'};var Pl=g.PropTypes,wl={tag:Pl.oneOfType([Pl.func,Pl.string]),className:Pl.string,cssModule:Pl.object},jl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'input-group-addon'),oi);return g.createElement(si,at({},ai,{className:ni}))};jl.propTypes=wl,jl.defaultProps={tag:'div'};var Dl=g.PropTypes,Al={tag:Dl.oneOfType([Dl.func,Dl.string]),children:Dl.node,groupClassName:Dl.string,groupAttributes:Dl.object,className:Dl.string,cssModule:Dl.object},Sl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=ei.children,ni=ei.groupClassName,li=ei.groupAttributes,ri=lt(ei,['className','cssModule','tag','children','groupClassName','groupAttributes']);if('string'==typeof ai){var ii=w(it(ni,'input-group-btn'),oi);return g.createElement(si,at({},li,{className:ii}),g.createElement(Ns,at({},ri,{className:ti,children:ai})))}var di=w(it(ti,'input-group-btn'),oi);return g.createElement(si,at({},ri,{className:di,children:ai}))};Sl.propTypes=Al,Sl.defaultProps={tag:'div'};var zl=g.PropTypes,Il=['xs','sm','md','lg','xl'],Rl=zl.oneOfType([zl.number,zl.string]),Bl=zl.oneOfType([zl.string,zl.number,zl.shape({size:Rl,push:Rl,pull:Rl,offset:Rl})]),Wl={children:zl.node,hidden:zl.bool,check:zl.bool,inline:zl.bool,disabled:zl.bool,size:zl.string,for:zl.string,tag:zl.string,className:zl.string,cssModule:zl.object,xs:Bl,sm:Bl,md:Bl,lg:Bl,xl:Bl},Hl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.hidden,ai=ei.tag,ni=ei.check,li=ei.inline,ri=ei.disabled,ii=ei.size,di=ei.for,pi=lt(ei,['className','cssModule','hidden','tag','check','inline','disabled','size','for']),ci=[];Il.forEach(function(gi){var fi=ei[gi];if(delete pi[gi],fi&&fi.size){var mi;ci.push(w(it((mi={},st(mi,'col-'+gi+'-'+fi.size,fi.size),st(mi,'push-'+gi+'-'+fi.push,fi.push),st(mi,'pull-'+gi+'-'+fi.pull,fi.pull),st(mi,'offset-'+gi+'-'+fi.offset,fi.offset),mi))),oi)}else fi&&ci.push('col-'+gi+'-'+fi)});var ui=w(it(ti,!!si&&'sr-only',!!ni&&'form-check-'+(li?'inline':'label'),ni&&li&&ri&&'disabled',!!ii&&'col-form-label-'+ii,ci,!!ci.length&&'col-form-label'),oi);return g.createElement(ai,at({htmlFor:di},pi,{className:ui}))};Hl.propTypes=Wl,Hl.defaultProps={tag:'label'};var ql=g.PropTypes,Gl={body:ql.bool,bottom:ql.bool,children:ql.node,className:ql.string,cssModule:ql.object,heading:ql.bool,left:ql.bool,list:ql.bool,middle:ql.bool,object:ql.bool,right:ql.bool,tag:ql.oneOfType([ql.func,ql.string]),top:ql.bool},Fl=function(ei){var ti=ei.body,oi=ei.bottom,si=ei.className,ai=ei.cssModule,ni=ei.heading,li=ei.left,ri=ei.list,ii=ei.middle,di=ei.object,pi=ei.right,ci=ei.tag,ui=ei.top,gi=lt(ei,['body','bottom','className','cssModule','heading','left','list','middle','object','right','tag','top']),fi;fi=ni?'h4':li||pi?'a':di?'img':ri?'ul':'div';var mi=ci||fi,hi=w(it(si,{'media-body':ti,'media-heading':ni,'media-left':li,'media-right':pi,'media-top':ui,'media-bottom':oi,'media-middle':ii,'media-object':di,'media-list':ri,media:!ti&&!ni&&!li&&!pi&&!ui&&!oi&&!ii&&!di&&!ri}),ai);return g.createElement(mi,at({},gi,{className:hi}))};Fl.propTypes=Gl;var Vl=g.PropTypes,Yl={children:Vl.node,className:Vl.string,cssModule:Vl.object,size:Vl.string,tag:Vl.oneOfType([Vl.func,Vl.string])},Xl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.size,ai=ei.tag,ni=lt(ei,['className','cssModule','size','tag']),li=w(it(ti,'pagination',st({},'pagination-'+si,!!si)),oi);return g.createElement(ai,at({},ni,{className:li}))};Xl.propTypes=Yl,Xl.defaultProps={tag:'ul'};var Kl=g.PropTypes,Zl={active:Kl.bool,children:Kl.node,className:Kl.string,cssModule:Kl.object,disabled:Kl.bool,tag:Kl.oneOfType([Kl.func,Kl.string])},Ql=function(ei){var ti=ei.active,oi=ei.className,si=ei.cssModule,ai=ei.disabled,ni=ei.tag,li=lt(ei,['active','className','cssModule','disabled','tag']),ri=w(it(oi,'page-item',{active:ti,disabled:ai}),si);return g.createElement(ni,at({},li,{className:ri}))};Ql.propTypes=Zl,Ql.defaultProps={tag:'li'};var er=g.PropTypes,tr={'aria-label':er.string,children:er.node,className:er.string,cssModule:er.object,next:er.bool,previous:er.bool,tag:er.oneOfType([er.func,er.string])},sr=function(ei){var ii,ti=ei.className,oi=ei.cssModule,si=ei.next,ai=ei.previous,ni=ei.tag,li=lt(ei,['className','cssModule','next','previous','tag']),ri=w(it(ti,'page-link'),oi);ai?ii='Previous':si&&(ii='Next');var pi,di=ei['aria-label']||ii;ai?pi='\xAB':si&&(pi='\xBB');var ci=ei.children;return(ai||si)&&(ci=[g.createElement('span',{'aria-hidden':'true',key:'caret'},ci||pi),g.createElement('span',{className:'sr-only',key:'sr'},di)]),g.createElement(ni,at({},li,{className:ri,'aria-label':di}),ci)};sr.propTypes=tr,sr.defaultProps={tag:'a'};var ar=g.PropTypes,nr=g.Component,lr={tag:ar.oneOfType([ar.func,ar.string]),activeTab:ar.any,className:ar.string,cssModule:ar.object},ir={activeTabId:ar.any},dr=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.state={activeTab:oi.props.activeTab},oi}return nt(ei,Qr),ot(ei,[{key:'getChildContext',value:function(){return{activeTabId:this.state.activeTab}}},{key:'componentWillReceiveProps',value:function(oi){this.state.activeTab!==oi.activeTab&&this.setState({activeTab:oi.activeTab})}},{key:'render',value:function(){var oi=this.props,si=oi.className,ai=oi.cssModule,ni=oi.tag,li=Ao(this.props,Object.keys(lr)),ri=w(it('tab-content',si),ai);return g.createElement(ni,at({},li,{className:ri}))}}]),ei}(nr);dr.propTypes=lr,dr.defaultProps={tag:'div'},dr.childContextTypes=ir;var pr=g.PropTypes,cr={tag:pr.oneOfType([pr.func,pr.string]),className:pr.string,cssModule:pr.object,tabId:pr.any},gr={activeTabId:pr.any};Je.propTypes=cr,Je.defaultProps={tag:'div'},Je.contextTypes=gr;var fr=g.PropTypes,mr={tag:fr.oneOfType([fr.func,fr.string]),fluid:fr.bool,className:fr.string,cssModule:fr.object},br=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=ei.fluid,ni=lt(ei,['className','cssModule','tag','fluid']),li=w(it(ti,'jumbotron',!!ai&&'jumbotron-fluid'),oi);return g.createElement(si,at({},ni,{className:li}))};br.propTypes=mr,br.defaultProps={tag:'div'};var yr=g.PropTypes,vr=function(ei){var ti=ei.children;return g.Children.toArray(ti)[0]||null},Tr={children:yr.node,className:yr.string,cssModule:yr.object,color:yr.string,isOpen:yr.bool,toggle:yr.func,tag:yr.oneOfType([yr.func,yr.string]),transitionAppearTimeout:yr.number,transitionEnterTimeout:yr.number,transitionLeaveTimeout:yr.number},kr=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=ei.color,ni=ei.isOpen,li=ei.toggle,ri=ei.children,ii=ei.transitionAppearTimeout,di=ei.transitionEnterTimeout,pi=ei.transitionLeaveTimeout,ci=lt(ei,['className','cssModule','tag','color','isOpen','toggle','children','transitionAppearTimeout','transitionEnterTimeout','transitionLeaveTimeout']),ui=w(it(ti,'alert','alert-'+ai,{'alert-dismissible':li}),oi),gi=g.createElement(si,at({},ci,{className:ui,role:'alert'}),li?g.createElement('button',{type:'button',className:'close','aria-label':'Close',onClick:li},g.createElement('span',{'aria-hidden':'true'},'\xD7')):null,ri);return g.createElement(y,{component:vr,transitionName:{appear:'fade',appearActive:'show',enter:'fade',enterActive:'show',leave:'fade',leaveActive:'out'},transitionAppear:0<ii,transitionAppearTimeout:ii,transitionEnter:0<di,transitionEnterTimeout:di,transitionLeave:0<pi,transitionLeaveTimeout:pi},ni?gi:null)};kr.propTypes=Tr,kr.defaultProps={color:'success',isOpen:!0,tag:'div',transitionAppearTimeout:150,transitionEnterTimeout:150,transitionLeaveTimeout:150};var Cr=g.PropTypes,Mr=g.Component,_r='SHOW',Or='SHOWN',Er='HIDE',Pr='HIDDEN',wr={isOpen:Cr.bool,className:Cr.node,tag:Cr.oneOfType([Cr.func,Cr.string]),cssModule:Cr.object,navbar:Cr.bool,delay:Cr.oneOfType([Cr.shape({show:Cr.number,hide:Cr.number}),Cr.number]),onOpened:Cr.func,onClosed:Cr.func},xr={show:350,hide:350},Dr=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.state={collapse:ti.isOpen?Or:Pr,height:null},oi.element=null,oi}return nt(ei,Qr),ot(ei,[{key:'componentWillReceiveProps',value:function(oi){var si=this,ai=oi.isOpen,ni=this.state.collapse;ai&&ni===Pr?this.setState({collapse:_r},function(){si.setState({height:si.getHeight()}),si.transitionTag=setTimeout(function(){si.setState({collapse:Or,height:null})},si.getDelay('show'))}):!ai&&ni===Or&&(this.setState({height:this.getHeight()},function(){si.setState({collapse:Er,height:si.getHeight()},function(){si.setState({height:0})})}),this.transitionTag=setTimeout(function(){si.setState({collapse:Pr,height:null})},this.getDelay('hide')))}},{key:'componentDidUpdate',value:function(oi,si){this.state.collapse===Or&&si&&si.collapse!==Or&&this.props.onOpened(),this.state.collapse===Pr&&si&&si.collapse!==Pr&&this.props.onClosed()}},{key:'componentWillUnmount',value:function(){clearTimeout(this.transitionTag)}},{key:'getDelay',value:function(oi){var si=this.props.delay;return'object'===('undefined'==typeof si?'undefined':et(si))?isNaN(si[oi])?xr[oi]:si[oi]:si}},{key:'getHeight',value:function(){return this.element.scrollHeight}},{key:'render',value:function(){var ui,oi=this,si=Ao(this.props,['isOpen','delay','onOpened','onClosed']),ai=si.navbar,ni=si.className,li=si.cssModule,ri=si.tag,ii=lt(si,['navbar','className','cssModule','tag']),di=this.state,pi=di.collapse,ci=di.height;ui=pi===_r?'collapsing':pi===Or?'collapse show':pi===Er?'collapsing':pi===Pr?'collapse':'collapse';var gi=w(it(ni,ui,ai&&'navbar-collapse'),li),fi=null===ci?null:{height:ci};return g.createElement(ri,at({},ii,{style:at({},ii.style,fi),className:gi,ref:function(hi){oi.element=hi}}))}}]),ei}(Mr);Dr.propTypes=wr,Dr.defaultProps={isOpen:!1,tag:'div',delay:xr,onOpened:function(){},onClosed:function(){}};var Ar=g.PropTypes,Lr={tag:Ar.oneOfType([Ar.func,Ar.string]),active:Ar.bool,disabled:Ar.bool,color:Ar.string,action:Ar.bool,className:Ar.any},zr=function(ei){ei.preventDefault()},Ir=function(ei){var ti=ei.className,oi=ei.tag,si=ei.active,ai=ei.disabled,ni=ei.action,li=ei.color,ri=lt(ei,['className','tag','active','disabled','action','color']),ii=it(ti,!!si&&'active',!!ai&&'disabled',!!ni&&'list-group-item-action',!!li&&'list-group-item-'+li,'list-group-item');return ai&&(ri.onClick=zr),g.createElement(oi,at({},ri,{className:ii}))};Ir.propTypes=Lr,Ir.defaultProps={tag:'li'};var Rr=g.PropTypes,Br={tag:Rr.oneOfType([Rr.func,Rr.string]),className:Rr.any},Ur=function(ei){var ti=ei.className,oi=ei.tag,si=lt(ei,['className','tag']),ai=it(ti,'list-group-item-heading');return g.createElement(oi,at({},si,{className:ai}))};Ur.propTypes=Br,Ur.defaultProps={tag:'h5'};var Hr=g.PropTypes,qr={tag:Hr.oneOfType([Hr.func,Hr.string]),className:Hr.any},Fr=function(ei){var ti=ei.className,oi=ei.tag,si=lt(ei,['className','tag']),ai=it(ti,'list-group-item-text');return g.createElement(oi,at({},si,{className:ai}))};Fr.propTypes=qr,Fr.defaultProps={tag:'p'};var Vr=g.Component,Yr={UncontrolledAlert:kr,UncontrolledButtonDropdown:Ms,UncontrolledDropdown:ts,UncontrolledNavDropdown:ns,UncontrolledTooltip:$n};Object.keys(Yr).forEach(function(Qr){var ei=Yr[Qr],oi=function(si){function ai(ni){tt(this,ai);var li=rt(this,(ai.__proto__||Object.getPrototypeOf(ai)).call(this,ni));return li.state={isOpen:ei===kr},li.toggle=li.toggle.bind(li),li}return nt(ai,si),ot(ai,[{key:'toggle',value:function(){this.setState({isOpen:!this.state.isOpen})}},{key:'render',value:function(){return g.createElement(ei,at({isOpen:this.state.isOpen,toggle:this.toggle},this.props))}}]),ai}(Vr);oi.displayName=Qr,Yr[Qr]=oi});var $r=Yr.UncontrolledAlert,Xr=Yr.UncontrolledButtonDropdown,Kr=Yr.UncontrolledDropdown,Zr=Yr.UncontrolledNavDropdown,Jr=Yr.UncontrolledTooltip;d.Alert=kr,d.Container=gt,d.Row=bt,d.Col=Ot,d.Navbar=jt,d.NavbarBrand=St,d.NavbarToggler=Wt,d.Nav=Gt,d.NavItem=$t,d.NavDropdown=ns,d.NavLink=ds,d.Breadcrumb=gs,d.BreadcrumbItem=bs,d.Button=Ns,d.ButtonDropdown=Ms,d.ButtonGroup=ws,d.ButtonToolbar=As,d.Dropdown=ts,d.DropdownItem=Rs,d.DropdownMenu=Xo,d.DropdownToggle=qs,d.Fade=Ys,d.Badge=Zs,d.Card=ta,d.CardLink=Na,d.CardGroup=na,d.CardDeck=da,d.CardColumns=ga,d.CardBlock=ba,d.CardFooter=_a,d.CardHeader=wa,d.CardImg=Aa,d.CardImgOverlay=Ia,d.CardSubtitle=Ua,d.CardText=Fa,d.CardTitle=Xa,d.Popover=en,d.PopoverContent=pn,d.PopoverTitle=nn,d.Progress=On,d.Modal=xn,d.ModalHeader=Ln,d.ModalBody=Rn,d.ModalFooter=Hn,d.TetherContent=Go,d.Tooltip=$n,d.Table=Jn,d.ListGroup=sl,d.Form=rl,d.FormFeedback=cl,d.FormGroup=ml,d.FormText=vl,d.Input=Cl,d.InputGroup=El,d.InputGroupAddon=jl,d.InputGroupButton=Sl,d.Label=Hl,d.Media=Fl,d.Pagination=Xl,d.PaginationItem=Ql,d.PaginationLink=sr,d.TabContent=dr,d.TabPane=Je,d.Jumbotron=br,d.Collapse=Dr,d.ListGroupItem=Ir,d.ListGroupItemText=Fr,d.ListGroupItemHeading=Ur,d.UncontrolledAlert=$r,d.UncontrolledButtonDropdown=Xr,d.UncontrolledDropdown=Kr,d.UncontrolledNavDropdown=Zr,d.UncontrolledTooltip=Jr,Object.defineProperty(d,'__esModule',{value:!0})});
	//# sourceMappingURL=reactstrap.min.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getEmptyLabels = exports.getFieldPositions = exports.getCustomDefinition = exports.getActiveLogo = exports.getActiveLabelSize = exports.getActiveDefinition = exports.isLabelAddEnabled = exports.isLabelModalOpen = exports.getCalibrationLink = exports.getStyleElements = exports.areArticlesValid = exports.getShownArticles = exports.getArticles = exports.getPdfId = exports.getSelectedCustomType = exports.getCustomDefinitions = exports.getActivePetLabel = exports.getSelectedArticleMappingId = exports.getSelectedPetLabelId = exports.getActivePageSize = exports.getLabelDefinitions = exports.areDefinitionsValid = exports.getSelectedGridIndex = exports.getSearchPhrase = exports.getSearchResults = exports.getSelectedPetTypes = exports.getPetTypes = exports.getPetLabels = exports.arePetLabelsValid = exports.isGridSorting = exports.getLabels = undefined;
	
	var _reselect = __webpack_require__(537);
	
	var _constants = __webpack_require__(272);
	
	var getLabels = exports.getLabels = function getLabels(state) {
		return state[_constants.NAME].list;
	};
	
	var isGridSorting = exports.isGridSorting = function isGridSorting(state) {
		return state[_constants.NAME].grid.isSorting;
	};
	
	var arePetLabelsValid = exports.arePetLabelsValid = function arePetLabelsValid(state) {
		return state[_constants.NAME].petLabelsValid;
	};
	var getPetLabels = exports.getPetLabels = function getPetLabels(state) {
		return state[_constants.NAME].petLabels;
	};
	
	var getPetTypes = exports.getPetTypes = function getPetTypes(state) {
		return state[_constants.NAME].search.petTypes;
	};
	var getSelectedPetTypes = exports.getSelectedPetTypes = function getSelectedPetTypes(state) {
		return state[_constants.NAME].search.selectedPetTypes;
	};
	var getSearchResults = exports.getSearchResults = function getSearchResults(state) {
		return state[_constants.NAME].search.results;
	};
	var getSearchPhrase = exports.getSearchPhrase = function getSearchPhrase(state) {
		return state[_constants.NAME].search.phrase;
	};
	
	var getSelectedGridIndex = exports.getSelectedGridIndex = function getSelectedGridIndex(state) {
		return state[_constants.NAME].selected.gridIndex;
	};
	
	var areDefinitionsValid = exports.areDefinitionsValid = function areDefinitionsValid(state) {
		return state[_constants.NAME].definitionsValid;
	};
	var getLabelDefinitions = exports.getLabelDefinitions = function getLabelDefinitions(state) {
		return state[_constants.NAME].definitions;
	};
	
	var getActivePageSize = exports.getActivePageSize = function getActivePageSize(state) {
		return state[_constants.NAME].activeSize;
	};
	
	var getSelectedPetLabelId = exports.getSelectedPetLabelId = function getSelectedPetLabelId(state) {
		return state[_constants.NAME].selected.petLabelId;
	};
	var getSelectedArticleMappingId = exports.getSelectedArticleMappingId = function getSelectedArticleMappingId(state) {
		return state[_constants.NAME].selected.articleMappingId;
	};
	var getActivePetLabel = exports.getActivePetLabel = function getActivePetLabel(state) {
		return state[_constants.NAME].active.petLabel;
	};
	
	var getCustomDefinitions = exports.getCustomDefinitions = function getCustomDefinitions(state) {
		return state[_constants.NAME].customDefinitions;
	};
	var getSelectedCustomType = exports.getSelectedCustomType = function getSelectedCustomType(state) {
		return state[_constants.NAME].selectedCustomType;
	};
	
	var getPdfId = exports.getPdfId = function getPdfId(state) {
		return state[_constants.NAME].pdfId;
	};
	
	var getArticles = exports.getArticles = function getArticles(state) {
		return state[_constants.NAME].articles;
	};
	var getShownArticles = exports.getShownArticles = function getShownArticles(state) {
		return state[_constants.NAME].shownArticles;
	};
	var areArticlesValid = exports.areArticlesValid = function areArticlesValid(state) {
		return state[_constants.NAME].articlesValid;
	};
	
	var getStyleElements = exports.getStyleElements = function getStyleElements(state) {
		return state[_constants.NAME].styleElements;
	};
	
	var getCalibrationLink = exports.getCalibrationLink = function getCalibrationLink(state) {
		return state[_constants.NAME].calibrationLink;
	};
	
	var isLabelModalOpen = exports.isLabelModalOpen = function isLabelModalOpen(state) {
		return state[_constants.NAME].labelModalOpen;
	};
	var isLabelAddEnabled = exports.isLabelAddEnabled = function isLabelAddEnabled(state) {
		return state[_constants.NAME].labelAddEnabled;
	};
	
	var getActiveDefinition = exports.getActiveDefinition = (0, _reselect.createSelector)(getLabelDefinitions, getActivePageSize, function (labelDefinitions, activePageSize) {
		return labelDefinitions.find(function (definition) {
			return definition.LabelName === activePageSize;
		});
	});
	
	var getActiveLabelSize = exports.getActiveLabelSize = (0, _reselect.createSelector)(getActiveDefinition, function (activeDefinition) {
		if (!activeDefinition) {
			return {};
		}
		return {
			width: activeDefinition.Width,
			height: activeDefinition.Height
		};
	});
	
	var getActiveLogo = exports.getActiveLogo = (0, _reselect.createSelector)(getActiveDefinition, function (activeDefinition) {
		if (!activeDefinition) {
			return '';
		}
		return activeDefinition.LogoUrl;
	});
	
	var getCustomDefinition = exports.getCustomDefinition = (0, _reselect.createSelector)(getSelectedCustomType, getCustomDefinitions, function (petType, definitions) {
		return definitions[petType];
	});
	
	var getFieldPositions = exports.getFieldPositions = (0, _reselect.createSelector)(getActiveDefinition, getActivePetLabel, function (activeDefinition, activePetLabel) {
		if (!activeDefinition || !activePetLabel) {
			return [];
		}
	
		return activeDefinition.FieldMappings.filter(function (mapping) {
			return mapping.PetType === activePetLabel.PetType;
		});
	});
	
	var getEmptyLabels = exports.getEmptyLabels = (0, _reselect.createSelector)(getLabels, function (labels) {
		var count = 0;
		labels.forEach(function (label) {
			if (Object.keys(label).length === 0) {
				count++;
			}
		});
		return count;
	});

/***/ },
/* 58 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(34);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(311)
	  , $export = __webpack_require__(3)
	  , shared  = __webpack_require__(139)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(314)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(21)){
	  var LIBRARY             = __webpack_require__(78)
	    , global              = __webpack_require__(10)
	    , fails               = __webpack_require__(13)
	    , $export             = __webpack_require__(3)
	    , $typed              = __webpack_require__(140)
	    , $buffer             = __webpack_require__(197)
	    , ctx                 = __webpack_require__(59)
	    , anInstance          = __webpack_require__(77)
	    , propertyDesc        = __webpack_require__(67)
	    , hide                = __webpack_require__(35)
	    , redefineAll         = __webpack_require__(82)
	    , toInteger           = __webpack_require__(68)
	    , toLength            = __webpack_require__(24)
	    , toIndex             = __webpack_require__(84)
	    , toPrimitive         = __webpack_require__(52)
	    , has                 = __webpack_require__(32)
	    , same                = __webpack_require__(308)
	    , classof             = __webpack_require__(108)
	    , isObject            = __webpack_require__(15)
	    , toObject            = __webpack_require__(27)
	    , isArrayIter         = __webpack_require__(182)
	    , create              = __webpack_require__(79)
	    , getPrototypeOf      = __webpack_require__(42)
	    , gOPN                = __webpack_require__(80).f
	    , getIterFn           = __webpack_require__(199)
	    , uid                 = __webpack_require__(85)
	    , wks                 = __webpack_require__(17)
	    , createArrayMethod   = __webpack_require__(50)
	    , createArrayIncludes = __webpack_require__(130)
	    , speciesConstructor  = __webpack_require__(191)
	    , ArrayIterators      = __webpack_require__(200)
	    , Iterators           = __webpack_require__(95)
	    , $iterDetect         = __webpack_require__(136)
	    , setSpecies          = __webpack_require__(83)
	    , arrayFill           = __webpack_require__(175)
	    , arrayCopyWithin     = __webpack_require__(288)
	    , $DP                 = __webpack_require__(22)
	    , $GOPD               = __webpack_require__(41)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.red = undefined;
	
	var _each = __webpack_require__(949);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _tinycolor = __webpack_require__(1027);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  simpleCheckForValidColor: function simpleCheckForValidColor(data) {
	    var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'a', 'v'];
	    var checked = 0;
	    var passed = 0;
	    (0, _each2.default)(keysToCheck, function (letter) {
	      if (data[letter]) {
	        checked += 1;
	        if (!isNaN(data[letter])) {
	          passed += 1;
	        }
	      }
	    });
	    return checked === passed ? data : false;
	  },
	  toState: function toState(data, oldHue) {
	    var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
	    var hsl = color.toHsl();
	    var hsv = color.toHsv();
	    var rgb = color.toRgb();
	    var hex = color.toHex();
	    if (hsl.s === 0) {
	      hsl.h = oldHue || 0;
	      hsv.h = oldHue || 0;
	    }
	    var transparent = hex === '000000' && rgb.a === 0;
	
	    return {
	      hsl: hsl,
	      hex: transparent ? 'transparent' : '#' + hex,
	      rgb: rgb,
	      hsv: hsv,
	      oldHue: data.h || oldHue || hsl.h,
	      source: data.source
	    };
	  },
	  isValidHex: function isValidHex(hex) {
	    return (0, _tinycolor2.default)(hex).isValid();
	  }
	};
	var red = exports.red = {
	  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
	  hex: '#ff0000',
	  rgb: { r: 255, g: 0, b: 0, a: 1 },
	  hsv: { h: 0, s: 1, v: 1, a: 1 }
	};

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(500);


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(141);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var PooledClass = __webpack_require__(73);
	
	var emptyFunction = __webpack_require__(39);
	var warning = __webpack_require__(11);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(85)('meta')
	  , isObject = __webpack_require__(15)
	  , has      = __webpack_require__(32)
	  , setDesc  = __webpack_require__(22).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(13)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 67 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 68 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 69 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 70 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(148),
	    baseIteratee = __webpack_require__(112),
	    baseMap = __webpack_require__(333),
	    isArray = __webpack_require__(31);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 74 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _splice = __webpack_require__(1175);
	
	var _splice2 = _interopRequireDefault(_splice);
	
	var _getIn = __webpack_require__(533);
	
	var _getIn2 = _interopRequireDefault(_getIn);
	
	var _setIn = __webpack_require__(1174);
	
	var _setIn2 = _interopRequireDefault(_setIn);
	
	var _deepEqual = __webpack_require__(1171);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _deleteIn = __webpack_require__(1172);
	
	var _deleteIn2 = _interopRequireDefault(_deleteIn);
	
	var _keys = __webpack_require__(1173);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var structure = {
	  empty: {},
	  emptyList: [],
	  getIn: _getIn2.default,
	  setIn: _setIn2.default,
	  deepEqual: _deepEqual2.default,
	  deleteIn: _deleteIn2.default,
	  fromJS: function fromJS(value) {
	    return value;
	  },
	  keys: _keys2.default,
	  size: function size(array) {
	    return array ? array.length : 0;
	  },
	  splice: _splice2.default,
	  toJS: function toJS(value) {
	    return value;
	  }
	};
	
	exports.default = structure;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// const productionHost = 'http://localapi.petdata.at:8081';
	// const developmentHost = 'http://localapi.petdata.at:8081';
	var productionHost = 'https://api.petdata.at';
	var developmentHost = 'https://api.petdata.at';
	var remoteUrl =  true ? productionHost : developmentHost;
	
	var AUTH_TOKEN = exports.AUTH_TOKEN = remoteUrl + '/Token';
	var CUSTOMER_MYCONTEXT = exports.CUSTOMER_MYCONTEXT = remoteUrl + '/api/Customer/MyContext';
	
	var CUSTOMER_ALLUSERS = exports.CUSTOMER_ALLUSERS = remoteUrl + '/api/Customer/AllUsers';
	var REGISTER_USER = exports.REGISTER_USER = remoteUrl + '/api/Customer/RegisterUser';
	var UPDATE_USER = exports.UPDATE_USER = remoteUrl + '/api/Customer/UpdateUserSettings';
	
	var CARESHEET_SETTINGS = exports.CARESHEET_SETTINGS = remoteUrl + '/api/CareSheet/Settings';
	var CARESHEET_SETTINGS_AD = exports.CARESHEET_SETTINGS_AD = remoteUrl + '/api/CareSheet/Settings/Ad';
	var CARESHEET_SETTINGS_LOGO = exports.CARESHEET_SETTINGS_LOGO = remoteUrl + '/api/CareSheet/Settings/Logo';
	var CARESHEET_SETTINGS_INFO = exports.CARESHEET_SETTINGS_INFO = remoteUrl + '/api/CareSheet/Settings/Info';
	var CARESHEET_LISTING = exports.CARESHEET_LISTING = remoteUrl + '/api/CareSheet/CareSheets';
	var CARESHEET_AS_PDF = exports.CARESHEET_AS_PDF = remoteUrl + '/api/CareSheet/CareSheetAsPDF';
	
	var LABEL_ALL_PETS = exports.LABEL_ALL_PETS = remoteUrl + '/api/Label/AllPets';
	var LABEL_DEFINITIONS = exports.LABEL_DEFINITIONS = remoteUrl + '/api/Label/LabelDefinitions';
	var LABEL_PET = exports.LABEL_PET = remoteUrl + '/api/Label/Pet';
	var LABEL_CREATE_AS_JPG = exports.LABEL_CREATE_AS_JPG = remoteUrl + '/api/Label/CreateLabelAsJPG';
	
	var LABEL_CUSTOM_DEFINITIONS = exports.LABEL_CUSTOM_DEFINITIONS = remoteUrl + '/api/Label/CustomLabelDefinition';
	
	var LABEL_PREPARE_COMPOSITION = exports.LABEL_PREPARE_COMPOSITION = remoteUrl + '/api/Label/PrepareComposition';
	var LABEL_GET_PDF = exports.LABEL_GET_PDF = remoteUrl + '/api/Label/LabelPDF';
	
	var ARTICLE_UPDATE_MAPPING = exports.ARTICLE_UPDATE_MAPPING = remoteUrl + '/api/Article/UpdateArticleMapping';
	var ARTICLE_ADD_MAPPING = exports.ARTICLE_ADD_MAPPING = remoteUrl + '/api/Article/AddArticleMapping';
	var ARTICLE_DELETE_MAPPING = exports.ARTICLE_DELETE_MAPPING = remoteUrl + '/api/Article/RemoveArticleMappings';
	
	var ARTICLE_EXCEL_DOWNLOAD = exports.ARTICLE_EXCEL_DOWNLOAD = remoteUrl + '/api/Article/ExportPetArticleMappingsAsExcel';
	var ARTICLE_EXCEL_UPLOAD = exports.ARTICLE_EXCEL_UPLOAD = remoteUrl + '/api/Article/ImportPetArticleMappingsFromExcel';
	
	var CUSTOMIZE_LABEL_SETTINGS = exports.CUSTOMIZE_LABEL_SETTINGS = remoteUrl + '/api/Label/LabelSettings';
	var UPLOAD_LABEL_LOGO = exports.UPLOAD_LABEL_LOGO = remoteUrl + '/api/Label/LabelLogo';
	
	var CALIBRATION_GET_PDF = exports.CALIBRATION_GET_PDF = remoteUrl + '/api/Label/CalibrationPDF';
	
	var CHANGE_USER_PASSWORD = exports.CHANGE_USER_PASSWORD = remoteUrl + '/api/Customer/ChangePasswordForUser';
	
	var CHANGE_PASSWORD = exports.CHANGE_PASSWORD = remoteUrl + '/api/Customer/ChangePassword';
	var FORGOT_PASSWORD = exports.FORGOT_PASSWORD = remoteUrl + '/api/Customer/ForgotPassword';
	
	var SIGNUP_EN = exports.SIGNUP_EN = 'https://www.petdata.at/';
	var SIGNUP_DE = exports.SIGNUP_DE = 'https://www.petdata.at/';
	
	var ORDER_MANAGEMENT_LINK = exports.ORDER_MANAGEMENT_LINK = remoteUrl + '/api/Customer/OrderManagementLink';

/***/ },
/* 77 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ },
/* 78 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(7)
	  , dPs         = __webpack_require__(301)
	  , enumBugKeys = __webpack_require__(178)
	  , IE_PROTO    = __webpack_require__(190)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(177)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(180).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(303)
	  , hiddenKeys = __webpack_require__(178).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(303)
	  , enumBugKeys = __webpack_require__(178);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(36);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(10)
	  , dP          = __webpack_require__(22)
	  , DESCRIPTORS = __webpack_require__(21)
	  , SPECIES     = __webpack_require__(17)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(68)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 85 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(99),
	    getRawTag = __webpack_require__(909),
	    objectToString = __webpack_require__(936);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(875),
	    getValue = __webpack_require__(910);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(219),
	    isLength = __webpack_require__(220);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 91 */
/***/ function(module, exports) {

	/***
	   Copyright 2013 Teun Duynstee
	
	   Licensed under the Apache License, Version 2.0 (the "License");
	   you may not use this file except in compliance with the License.
	   You may obtain a copy of the License at
	
	     http://www.apache.org/licenses/LICENSE-2.0
	
	   Unless required by applicable law or agreed to in writing, software
	   distributed under the License is distributed on an "AS IS" BASIS,
	   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   See the License for the specific language governing permissions and
	   limitations under the License.
	*/
	module.exports = (function() {
	
	    function identity(v){return v;}
	
	    function ignoreCase(v){return typeof(v)==="string" ? v.toLowerCase() : v;}
	
	    function makeCompareFunction(f, opt){
	        opt = typeof(opt)==="number" ? {direction:opt} : opt||{};
	        if(typeof(f)!="function"){
	            var prop = f;
	            // make unary function
	            f = function(v1){return !!v1[prop] ? v1[prop] : "";}
	        }
	        if(f.length === 1) {
	            // f is a unary function mapping a single item to its sort score
	            var uf = f;
	            var preprocess = opt.ignoreCase?ignoreCase:identity;
	            f = function(v1,v2) {return preprocess(uf(v1)) < preprocess(uf(v2)) ? -1 : preprocess(uf(v1)) > preprocess(uf(v2)) ? 1 : 0;}
	        }
	        if(opt.direction === -1) return function(v1,v2){return -f(v1,v2)};
	        return f;
	    }
	
	    /* adds a secondary compare function to the target function (`this` context)
	       which is applied in case the first one returns 0 (equal)
	       returns a new compare function, which has a `thenBy` method as well */
	    function tb(func, opt) {
	        var x = typeof(this) == "function" ? this : false;
	        var y = makeCompareFunction(func, opt);
	        var f = x ? function(a, b) {
	                        return x(a,b) || y(a,b);
	                    }
	                  : y;
	        f.thenBy = tb;
	        return f;
	    }
	    return tb;
	})();


/***/ },
/* 92 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(17)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(35)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(59)
	  , call        = __webpack_require__(297)
	  , isArrayIter = __webpack_require__(182)
	  , anObject    = __webpack_require__(7)
	  , toLength    = __webpack_require__(24)
	  , getIterFn   = __webpack_require__(199)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ },
/* 95 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(22).f
	  , has = __webpack_require__(32)
	  , TAG = __webpack_require__(17)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	  , defined = __webpack_require__(45)
	  , fails   = __webpack_require__(13)
	  , spaces  = __webpack_require__(195)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ },
/* 98 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(47);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(87),
	    isObjectLike = __webpack_require__(70);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(325),
	    baseKeys = __webpack_require__(877),
	    isArrayLike = __webpack_require__(89);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMLazyTree
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(231);
	var setInnerHTML = __webpack_require__(166);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(245);
	var setTextContent = __webpack_require__(525);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(6);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 105 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1104);
	var ReactInstrumentation = __webpack_require__(48);
	
	var warning = __webpack_require__(11);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _actions = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref2 = _react2.default.createElement('span', { className: 'lnr lnr-cross float-right', 'aria-hidden': 'true' });
	
	var CloseButton = function (_React$Component) {
	  _inherits(CloseButton, _React$Component);
	
	  function CloseButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CloseButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CloseButton.__proto__ || Object.getPrototypeOf(CloseButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
	      _this.props.actions.clearSearchResults();
	      _this.props.actions.deselectPetLabel();
	      _this.props.actions.clearActiveLabel();
	      _this.props.actions.push(_this.props.url);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CloseButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'close', onClick: this.handleClick },
	        _ref2
	      );
	    }
	  }]);
	
	  return CloseButton;
	}(_react2.default.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ clearActiveLabel: _actions.clearActiveLabel, clearSearchResults: _actions.clearSearchResults, deselectPetLabel: _actions.deselectPetLabel, push: _reactRouterRedux.push }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(CloseButton);

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(44)
	  , TAG = __webpack_require__(17)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(44);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 110 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(879),
	    baseMatchesProperty = __webpack_require__(880),
	    identity = __webpack_require__(116),
	    isArray = __webpack_require__(31),
	    property = __webpack_require__(960);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(328),
	    baseAssignValue = __webpack_require__(150);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(100);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 115 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 116 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(87),
	    getPrototype = __webpack_require__(213),
	    isObjectLike = __webpack_require__(70);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var EventPluginRegistry = __webpack_require__(232);
	var EventPluginUtils = __webpack_require__(233);
	var ReactErrorUtils = __webpack_require__(239);
	
	var accumulateInto = __webpack_require__(514);
	var forEachAccumulated = __webpack_require__(517);
	var invariant = __webpack_require__(6);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(64);
	var EventPluginHub = __webpack_require__(118);
	var EventPluginUtils = __webpack_require__(233);
	
	var accumulateInto = __webpack_require__(514);
	var forEachAccumulated = __webpack_require__(517);
	var warning = __webpack_require__(11);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(65);
	
	var getEventTarget = __webpack_require__(248);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(538);

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCareSheetSettings = getCareSheetSettings;
	exports.selectAd = selectAd;
	exports.deselectAd = deselectAd;
	exports.deleteAd = deleteAd;
	exports.uploadAd = uploadAd;
	exports.saveStoreSettings = saveStoreSettings;
	exports.uploadLogo = uploadLogo;
	exports.getCareSheets = getCareSheets;
	exports.toggleSelectedPetType = toggleSelectedPetType;
	exports.searchCareSheets = searchCareSheets;
	exports.clearSearchResults = clearSearchResults;
	
	var _axios = __webpack_require__(122);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _apiEndpoints = __webpack_require__(76);
	
	var endpoints = _interopRequireWildcard(_apiEndpoints);
	
	var _actionTypes = __webpack_require__(261);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getActiveSubscriptionId = _customer2.default.selectors.getActiveSubscriptionId;
	function getCareSheetSettings() {
	  return function (dispatch, getStore) {
	    dispatch({
	      type: types.GET_CARESHEET_SETTINGS
	    });
	
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    _axios2.default.get(endpoints.CARESHEET_SETTINGS + '?subscriptionID=' + subscriptionId).then(function (response) {
	      dispatch(settingsReceived(response.data));
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function settingsReceived(settings) {
	  var petTypeAds = [];
	  var ads = settings.PetTypeAds;
	  Object.keys(ads).forEach(function (key) {
	    var petTypeAd = {
	      petType: key,
	      imageUrl: ads[key],
	      isValid: ads[key] !== null ? true : false
	    };
	    petTypeAds.push(petTypeAd);
	  });
	
	  var petTypePreviews = [];
	  var previews = settings.PetTypePreviews;
	  Object.keys(previews).forEach(function (key) {
	    var petTypePreview = {
	      petType: key,
	      previewUrl: previews[key]
	    };
	    petTypePreviews.push(petTypePreview);
	  });
	
	  return {
	    type: types.CARESHEET_SETTINGS_RECEIVED,
	    payload: {
	      ads: petTypeAds,
	      previews: petTypePreviews,
	      store: {
	        infoLine1: settings.InfoLine1,
	        infoLine2: settings.InfoLine2,
	        infoLine3: settings.InfoLine3,
	        infoLine4: settings.InfoLine4,
	        useLogo: settings.UseLogo,
	        logoUrl: settings.LogoUrl,
	        previewUrl: settings.PreviewCareSheetUrl
	      }
	    }
	  };
	}
	
	function selectAd(ad) {
	  return {
	    type: types.AD_SELECTED,
	    payload: {
	      ad: ad
	    }
	  };
	}
	
	function deselectAd() {
	  return {
	    type: types.AD_DESELECTED
	  };
	}
	
	function deleteAd(ad) {
	  return function (dispatch, getStore) {
	    // TODO: should we dispatch a delete attempt?
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    var queryString = '?subscriptionID=' + subscriptionId + '&petType=' + ad.petType;
	    _axios2.default.delete('' + endpoints.CARESHEET_SETTINGS_AD + queryString).then(function (response) {
	      dispatch({
	        type: types.AD_DELETED
	      });
	      dispatch(settingsReceived(response.data));
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function uploadAd(ad, file) {
	  return function (dispatch, getStore) {
	    var fd = new FormData();
	    fd.append('filename', file);
	    var config = { headers: { 'Content-Type': 'multipart/form-data' } };
	
	    var subscriptionId = getActiveSubscriptionId(getStore());
	    var queryString = '?subscriptionID=' + subscriptionId + '&petType=' + ad.petType;
	
	    _axios2.default.post('' + endpoints.CARESHEET_SETTINGS_AD + queryString, fd, config).then(function (response) {
	      dispatch(settingsReceived(response.data));
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function saveStoreSettings(storeInfo) {
	  return function (dispatch, getStore) {
	    var subscriptionId = getActiveSubscriptionId(getStore());
	
	    var storeInfoPost = {
	      'InfoLine1': storeInfo.line1,
	      'InfoLine2': storeInfo.line2,
	      'InfoLine3': storeInfo.line3,
	      'InfoLine4': storeInfo.line4,
	      'UseLogo': storeInfo.useLogo
	    };
	
	    return new Promise(function (resolve, reject) {
	      _axios2.default.post(endpoints.CARESHEET_SETTINGS_INFO + '?subscriptionID=' + subscriptionId, storeInfoPost).then(function (response) {
	        dispatch(settingsReceived(response.data));
	        resolve();
	      }).catch(function () {
	        dispatch({ type: types.SHOW_ERROR_MODAL });
	        reject();
	      });
	    });
	  };
	}
	
	function uploadLogo(file) {
	  return function (dispatch, getStore) {
	    var subscriptionId = getActiveSubscriptionId(getStore());
	
	    var fd = new FormData();
	    fd.append('filename', file);
	    var config = { headers: { 'Content-Type': 'multipart/form-data' } };
	
	    _axios2.default.post(endpoints.CARESHEET_SETTINGS_LOGO + '?subscriptionID=' + subscriptionId, fd, config).then(function (response) {
	      dispatch(settingsReceived(response.data));
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function getCareSheets() {
	  return function (dispatch, getStore) {
	    var subscriptionId = getActiveSubscriptionId(getStore());
	
	    _axios2.default.get(endpoints.CARESHEET_LISTING + '?subscriptionID=' + subscriptionId).then(function (response) {
	      dispatch(careSheetListReceived(response.data));
	      dispatch(parsePetTypes(response.data));
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function careSheetListReceived(careSheetList) {
	  return function (dispatch) {
	    dispatch({
	      type: types.CARESHEET_LIST_RECEIVED,
	      payload: {
	        caresheets: careSheetList
	      }
	    });
	  };
	}
	
	function parsePetTypes(careSheetList) {
	  return function (dispatch) {
	    var petTypeSet = new Set([]);
	    careSheetList.forEach(function (careSheet) {
	      petTypeSet.add(careSheet.Type);
	    });
	
	    var petTypeList = [];
	    petTypeSet.forEach(function (petType) {
	      petTypeList.push(petType);
	    });
	
	    dispatch({
	      type: types.PET_TYPES_ADDED,
	      payload: {
	        petTypes: petTypeList,
	        selectedPetTypes: petTypeList
	      }
	    });
	  };
	}
	
	function toggleSelectedPetType(petType) {
	  return function (dispatch) {
	    dispatch({
	      type: types.TOGGLE_SELECTED_PET_TYPE,
	      payload: {
	        petType: petType
	      }
	    });
	    dispatch(filterCareSheets());
	  };
	}
	
	function setSearchPhrase(searchPhrase) {
	  return {
	    type: types.CARESHEET_SEARCH_PHRASE,
	    payload: {
	      searchPhrase: searchPhrase
	    }
	  };
	}
	
	function filterCareSheets() {
	  return {
	    type: types.FILTER_CARESHEETS
	  };
	}
	
	function searchCareSheets(searchPhrase) {
	  return function (dispatch) {
	    dispatch(setSearchPhrase(searchPhrase));
	    dispatch(filterCareSheets());
	  };
	}
	
	function clearSearchResults() {
	  return {
	    type: types.CLEAR_SEARCH_RESULTS
	  };
	}

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSearchPhrase = exports.getSearchResults = exports.getSelectedPetTypes = exports.getPetTypes = exports.areCareSheetsValid = exports.getStoreSettings = exports.getSelectedAd = exports.areSettingsValid = exports.getPreviews = exports.getAds = undefined;
	
	var _constants = __webpack_require__(262);
	
	var getAds = exports.getAds = function getAds(state) {
	  return state[_constants.NAME].settings.ads;
	};
	var getPreviews = exports.getPreviews = function getPreviews(state) {
	  return state[_constants.NAME].settings.previews;
	};
	var areSettingsValid = exports.areSettingsValid = function areSettingsValid(state) {
	  return state[_constants.NAME].settings.valid;
	};
	var getSelectedAd = exports.getSelectedAd = function getSelectedAd(state) {
	  return state[_constants.NAME].settings.selectedAd;
	};
	var getStoreSettings = exports.getStoreSettings = function getStoreSettings(state) {
	  return state[_constants.NAME].settings.store;
	};
	
	var areCareSheetsValid = exports.areCareSheetsValid = function areCareSheetsValid(state) {
	  return state[_constants.NAME].valid;
	};
	
	var getPetTypes = exports.getPetTypes = function getPetTypes(state) {
	  return state[_constants.NAME].search.petTypes;
	};
	var getSelectedPetTypes = exports.getSelectedPetTypes = function getSelectedPetTypes(state) {
	  return state[_constants.NAME].search.selectedPetTypes;
	};
	var getSearchResults = exports.getSearchResults = function getSearchResults(state) {
	  return state[_constants.NAME].search.results;
	};
	var getSearchPhrase = exports.getSearchPhrase = function getSearchPhrase(state) {
	  return state[_constants.NAME].search.phrase;
	};

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormMultiline = function FormMultiline(_ref) {
	  var className = _ref.className,
	      input = _ref.input,
	      placeholder = _ref.placeholder,
	      ref = _ref.ref,
	      type = _ref.type,
	      rows = _ref.rows,
	      cols = _ref.cols;
	  return _react2.default.createElement('textarea', _extends({}, input, {
	    type: type,
	    className: className,
	    placeholder: placeholder,
	    ref: ref,
	    rows: rows,
	    cols: cols
	  }));
	};
	
	exports.default = FormMultiline;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(63);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _FormInput = __webpack_require__(49);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BarCodeField = function (_React$Component) {
	  _inherits(BarCodeField, _React$Component);
	
	  function BarCodeField(props) {
	    _classCallCheck(this, BarCodeField);
	
	    var _this = _possibleConstructorReturn(this, (BarCodeField.__proto__ || Object.getPrototypeOf(BarCodeField)).call(this, props));
	
	    _this.handleHideBarcode = function () {
	      _this.setState({ showField: false });
	    };
	
	    _this.handleShowBarcode = function () {
	      _this.setState({ showField: true }, function () {
	        _reactDom2.default.findDOMNode(_this.refs.barcode).focus();
	      });
	    };
	
	    _this.state = {
	      showField: false
	    };
	    return _this;
	  }
	
	  _createClass(BarCodeField, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        this.state.showField === false && _react2.default.createElement('div', { className: 'barcode float-right', onClick: this.handleShowBarcode }),
	        this.state.showField && _react2.default.createElement(_reduxForm.Field, { name: 'barcode',
	          component: _FormInput2.default,
	          type: 'text',
	          className: 'form-control float-right txt-barcode',
	          placeholder: _reactReduxI18n.I18n.t('ENTER_BARCODE'),
	          onBlur: this.handleHideBarcode,
	          ref: 'barcode'
	        })
	      );
	    }
	  }]);
	
	  return BarCodeField;
	}(_react2.default.Component);
	
	exports.default = BarCodeField;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.toggleNavBar = toggleNavBar;
	exports.closeNavBar = closeNavBar;
	exports.transitionComplete = transitionComplete;
	exports.showSelectStoreModal = showSelectStoreModal;
	exports.hideSelectStoreModal = hideSelectStoreModal;
	exports.showChangePasswordModal = showChangePasswordModal;
	exports.hideChangePasswordModal = hideChangePasswordModal;
	exports.hideErrorModal = hideErrorModal;
	
	var _actionTypes = __webpack_require__(274);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function toggleNavBar() {
		return {
			type: types.NAV_BAR_TOGGLE
		};
	}
	
	function closeNavBar() {
		return {
			type: types.NAV_BAR_CLOSE
		};
	}
	
	function transitionComplete() {
		return {
			type: types.NAV_BAR_TRANSITIONED
		};
	}
	
	function showSelectStoreModal() {
		return {
			type: types.SHOW_SELECT_STORE_MODAL
		};
	}
	
	function hideSelectStoreModal() {
		return {
			type: types.HIDE_SELECT_STORE_MODAL
		};
	}
	
	function showChangePasswordModal() {
		return {
			type: types.SHOW_CHANGE_PASSWORD_MODAL
		};
	}
	
	function hideChangePasswordModal() {
		return {
			type: types.HIDE_CHANGE_PASSWORD_MODAL
		};
	}
	
	function hideErrorModal() {
		return {
			type: types.HIDE_ERROR_MODAL
		};
	}

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAllUsers = getAllUsers;
	exports.initializePermissionTable = initializePermissionTable;
	exports.selectUser = selectUser;
	exports.deselectUser = deselectUser;
	exports.registerUser = registerUser;
	exports.saveUser = saveUser;
	exports.toggleUserPermission = toggleUserPermission;
	exports.savePasswordChange = savePasswordChange;
	
	var _axios = __webpack_require__(122);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _apiEndpoints = __webpack_require__(76);
	
	var endpoints = _interopRequireWildcard(_apiEndpoints);
	
	var _userPermissions = __webpack_require__(29);
	
	var permissions = _interopRequireWildcard(_userPermissions);
	
	var _actionTypes = __webpack_require__(282);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSubscriptions = _customer2.default.selectors.getSubscriptions;
	function getAllUsers() {
	  return function (dispatch) {
	    _axios2.default.get(endpoints.CUSTOMER_ALLUSERS).then(function (response) {
	      dispatch(allUsersReceived(response));
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}
	
	function allUsersReceived(response) {
	  return function (dispatch, getState) {
	    var userList = [];
	    var users = response.data;
	    users.forEach(function (user) {
	
	      var userSubscriptionList = createPermissionTable(getState());
	      var remoteSubscriptionList = user.SubscriptionPermissions;
	
	      userSubscriptionList.forEach(function (userSubscription) {
	        var currentSubscription = remoteSubscriptionList.find(function (remoteSubscription) {
	          return remoteSubscription.SubscriptionId === userSubscription.id;
	        });
	        if (currentSubscription !== undefined) {
	          userSubscription.permissions = {
	            accessCareSheets: currentSubscription.Permissions.includes(permissions.ACCESS_CARE_SHEETS),
	            accessLabels: currentSubscription.Permissions.includes(permissions.ACCESS_LABELS),
	            manageArticles: currentSubscription.Permissions.includes(permissions.MANAGE_ARTICLES),
	            manageLogo: currentSubscription.Permissions.includes(permissions.MANAGE_LOGO),
	            manageCareSheetAds: currentSubscription.Permissions.includes(permissions.MANAGE_CARE_SHEET_ADS)
	          };
	        }
	      });
	
	      var userInfo = {
	        userName: user.Username,
	        firstName: user.Firstname,
	        lastName: user.Lastname,
	        isActive: user.IsActive,
	        subscriptions: userSubscriptionList
	      };
	      userList.push(userInfo);
	    });
	
	    dispatch({
	      type: types.ALL_USERS_RECEIVED,
	      payload: {
	        users: userList
	      }
	    });
	  };
	}
	
	function initializePermissionTable() {
	  return function (dispatch, getState) {
	    var subscriptionList = createPermissionTable(getState());
	    dispatch({
	      type: types.INITIALIZE_PERMISSION_TABLE,
	      payload: {
	        subscriptions: subscriptionList
	      }
	    });
	  };
	}
	
	function createPermissionTable(state) {
	  var masterSubscriptionList = getSubscriptions(state);
	  var subscriptionList = [];
	  masterSubscriptionList.forEach(function (subscription) {
	    var emptySubscription = {
	      id: subscription.id,
	      name: subscription.name,
	      permissions: {
	        accessCareSheets: false,
	        accessLabels: false,
	        manageArticles: false,
	        manageLogo: false,
	        manageCareSheetAds: false
	      }
	    };
	    subscriptionList.push(emptySubscription);
	  });
	  return subscriptionList;
	}
	
	function selectUser(user) {
	  return {
	    type: types.SELECT_USER,
	    payload: {
	      selectedUser: user
	    }
	  };
	}
	
	function deselectUser() {
	  return {
	    type: types.DESELECT_USER
	  };
	}
	
	function registerUser(userInfo, permissionTable) {
	  return function (dispatch) {
	    dispatch({
	      type: types.REGISTER_USER_ATTEMPT
	    });
	
	    initializePermissionTable();
	
	    var userInfoPost = {
	      'Email': userInfo.email,
	      'Password': userInfo.password,
	      'ConfirmPassword': userInfo.confirmPassword,
	      'Firstname': userInfo.firstName,
	      'Lastname': userInfo.lastName,
	      'IsActive': true
	    };
	
	    return new Promise(function (resolve, reject) {
	      _axios2.default.post(endpoints.REGISTER_USER, userInfoPost).then(function () {
	        var newUserInfo = {
	          firstName: userInfo.firstName,
	          lastName: userInfo.lastName,
	          status: true
	        };
	        return dispatch(updateUser(userInfo.email, newUserInfo, permissionTable));
	      }).catch(function () {
	        dispatch({ type: types.SHOW_ERROR_MODAL });
	        reject();
	      });
	    });
	  };
	}
	
	function createPermissionsArray(permissionTable) {
	  var subscriptionPermissions = [];
	  permissionTable.forEach(function (subscription) {
	    var _subscription$permiss = subscription.permissions,
	        accessCareSheets = _subscription$permiss.accessCareSheets,
	        accessLabels = _subscription$permiss.accessLabels,
	        manageArticles = _subscription$permiss.manageArticles,
	        manageLogo = _subscription$permiss.manageLogo,
	        manageCareSheetAds = _subscription$permiss.manageCareSheetAds;
	
	    var subPermissions = [];
	    if (accessCareSheets) {
	      subPermissions.push(permissions.ACCESS_CARE_SHEETS);
	    }
	    if (accessLabels) {
	      subPermissions.push(permissions.ACCESS_LABELS);
	    }
	    if (manageArticles) {
	      subPermissions.push(permissions.MANAGE_ARTICLES);
	    }
	    if (manageLogo) {
	      subPermissions.push(permissions.MANAGE_LOGO);
	    }
	    if (manageCareSheetAds) {
	      subPermissions.push(permissions.MANAGE_CARE_SHEET_ADS);
	    }
	
	    var prepSubscription = {
	      'SubscriptionName': subscription.name,
	      'SubscriptionId': subscription.id,
	      'Permissions': subPermissions
	    };
	
	    subscriptionPermissions.push(prepSubscription);
	  });
	  return subscriptionPermissions;
	}
	
	function createUpdateUserArray(userName, userInfo, permissionTable) {
	  var subscriptionPermissions = createPermissionsArray(permissionTable);
	  var user = {
	    'Username': userName,
	    'Firstname': userInfo.firstName,
	    'Lastname': userInfo.lastName,
	    'IsActive': userInfo.status,
	    'SubscriptionPermissions': subscriptionPermissions
	  };
	  var userArray = [];
	  userArray.push(user);
	  return userArray;
	}
	
	function updateUser(userName, userInfo, permissionTable) {
	  return function (dispatch) {
	    var userArray = createUpdateUserArray(userName, userInfo, permissionTable);
	    return new Promise(function (resolve, reject) {
	      _axios2.default.post(endpoints.UPDATE_USER, userArray).then(function (response) {
	        dispatch(allUsersReceived(response));
	        dispatch((0, _reactRouterRedux.push)('/users'));
	        resolve();
	      }).catch(function () {
	        dispatch({ type: types.SHOW_ERROR_MODAL });
	        reject();
	      });
	    });
	  };
	}
	
	function saveUser(userName, userInfo, permissionTable) {
	  return function (dispatch) {
	    dispatch({
	      type: types.SAVE_USER_ATTEMPT
	    });
	
	    return dispatch(updateUser(userName, userInfo, permissionTable));
	  };
	}
	
	function toggleUserPermission(subscriptionId, permissionType) {
	  return {
	    type: types.TOGGLE_USER_PERMISSION,
	    payload: {
	      subscriptionId: subscriptionId,
	      permissionType: permissionType
	    }
	  };
	}
	
	function savePasswordChange(username, password) {
	  return function (dispatch) {
	    var passwordData = {
	      UserName: username,
	      NewPassword: password,
	      ConfirmPassword: password
	    };
	
	    _axios2.default.post(endpoints.CHANGE_USER_PASSWORD, passwordData).then(function () {
	      dispatch({
	        type: types.USER_PASSWORD_CHANGED
	      });
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSelectedPermissions = exports.getSelectedUser = exports.areUsersValid = exports.getUsers = undefined;
	
	var _constants = __webpack_require__(285);
	
	var getUsers = exports.getUsers = function getUsers(state) {
	  return state[_constants.NAME].list;
	};
	var areUsersValid = exports.areUsersValid = function areUsersValid(state) {
	  return state[_constants.NAME].valid;
	};
	var getSelectedUser = exports.getSelectedUser = function getSelectedUser(state) {
	  return state[_constants.NAME].selected.user;
	};
	var getSelectedPermissions = exports.getSelectedPermissions = function getSelectedPermissions(state) {
	  return state[_constants.NAME].selected.permissions;
	};

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(38)
	  , toLength  = __webpack_require__(24)
	  , toIndex   = __webpack_require__(84);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(10)
	  , $export           = __webpack_require__(3)
	  , redefine          = __webpack_require__(36)
	  , redefineAll       = __webpack_require__(82)
	  , meta              = __webpack_require__(66)
	  , forOf             = __webpack_require__(94)
	  , anInstance        = __webpack_require__(77)
	  , isObject          = __webpack_require__(15)
	  , fails             = __webpack_require__(13)
	  , $iterDetect       = __webpack_require__(136)
	  , setToStringTag    = __webpack_require__(96)
	  , inheritIfRequired = __webpack_require__(181);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(35)
	  , redefine = __webpack_require__(36)
	  , fails    = __webpack_require__(13)
	  , defined  = __webpack_require__(45)
	  , wks      = __webpack_require__(17);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(7);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },
/* 134 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(15)
	  , cof      = __webpack_require__(44)
	  , MATCH    = __webpack_require__(17)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(17)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(78)|| !__webpack_require__(13)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(10)[K];
	});

/***/ },
/* 138 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10)
	  , hide   = __webpack_require__(35)
	  , uid    = __webpack_require__(85)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function keyMirror(obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/paracheirodon_innesi.jpg";

/***/ },
/* 143 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(973);
	
	var _runTransitionHook = __webpack_require__(204);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(86);
	
	var _deprecate = __webpack_require__(203);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 145 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(922),
	    listCacheDelete = __webpack_require__(923),
	    listCacheGet = __webpack_require__(924),
	    listCacheHas = __webpack_require__(925),
	    listCacheSet = __webpack_require__(926);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(146),
	    stackClear = __webpack_require__(942),
	    stackDelete = __webpack_require__(943),
	    stackGet = __webpack_require__(944),
	    stackHas = __webpack_require__(945),
	    stackSet = __webpack_require__(946);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 148 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(115);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(340);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(920);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(88);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(872),
	    isObjectLike = __webpack_require__(70);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(47),
	    stubFalse = __webpack_require__(962);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)(module)))

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(325),
	    baseKeysIn = __webpack_require__(878),
	    isArrayLike = __webpack_require__(89);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(148),
	    copyArray = __webpack_require__(212),
	    isArray = __webpack_require__(31),
	    isSymbol = __webpack_require__(100),
	    stringToPath = __webpack_require__(353),
	    toKey = __webpack_require__(114),
	    toString = __webpack_require__(360);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ },
/* 157 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(159);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(1056);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(72);
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 160 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.arrayMove = arrayMove;
	exports.omit = omit;
	exports.closest = closest;
	exports.limit = limit;
	exports.getElementMargin = getElementMargin;
	exports.provideDisplayName = provideDisplayName;
	function arrayMove(arr, previousIndex, newIndex) {
	  var array = arr.slice(0);
	  if (newIndex >= array.length) {
	    var k = newIndex - array.length;
	    while (k-- + 1) {
	      array.push(undefined);
	    }
	  }
	  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
	  return array;
	}
	
	function omit(obj) {
	  for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    keysToOmit[_key - 1] = arguments[_key];
	  }
	
	  return Object.keys(obj).reduce(function (acc, key) {
	    if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
	    return acc;
	  }, {});
	}
	
	var events = exports.events = {
	  start: ['touchstart', 'mousedown'],
	  move: ['touchmove', 'mousemove'],
	  end: ['touchend', 'touchcancel', 'mouseup']
	};
	
	var vendorPrefix = exports.vendorPrefix = function () {
	  if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
	  // fix for:
	  //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	  //    window.getComputedStyle() returns null inside an iframe with display: none
	  // in this case return an array with a fake mozilla style in it.
	  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
	  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];
	
	  switch (pre) {
	    case 'ms':
	      return 'ms';
	    default:
	      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
	  }
	}();
	
	function closest(el, fn) {
	  while (el) {
	    if (fn(el)) return el;
	    el = el.parentNode;
	  }
	}
	
	function limit(min, max, value) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	function getCSSPixelValue(stringValue) {
	  if (stringValue.substr(-2) === 'px') {
	    return parseFloat(stringValue);
	  }
	  return 0;
	}
	
	function getElementMargin(element) {
	  var style = window.getComputedStyle(element);
	
	  return {
	    top: getCSSPixelValue(style.marginTop),
	    right: getCSSPixelValue(style.marginRight),
	    bottom: getCSSPixelValue(style.marginBottom),
	    left: getCSSPixelValue(style.marginLeft)
	  };
	}
	
	function provideDisplayName(prefix, Component) {
	  var componentName = Component.displayName || Component.name;
	
	  return componentName ? prefix + '(' + componentName + ')' : prefix;
	}

/***/ },
/* 161 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DisabledInputUtils
	 */
	
	'use strict';
	
	var disableableMouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var DisabledInputUtils = {
	  getHostProps: function (inst, props) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var hostProps = {};
	    for (var key in props) {
	      if (!disableableMouseListenerNames[key] && props.hasOwnProperty(key)) {
	        hostProps[key] = props[key];
	      }
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = DisabledInputUtils;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactChildren = __webpack_require__(498);
	var ReactComponent = __webpack_require__(236);
	var ReactPureComponent = __webpack_require__(1102);
	var ReactClass = __webpack_require__(499);
	var ReactDOMFactories = __webpack_require__(1085);
	var ReactElement = __webpack_require__(54);
	var ReactPropTypes = __webpack_require__(510);
	var ReactVersion = __webpack_require__(512);
	
	var onlyChild = __webpack_require__(524);
	var warning = __webpack_require__(11);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var EventConstants = __webpack_require__(64);
	var EventPluginRegistry = __webpack_require__(232);
	var ReactEventEmitterMixin = __webpack_require__(1096);
	var ViewportMetrics = __webpack_require__(513);
	
	var getVendorPrefixedEventName = __webpack_require__(521);
	var isEventSupported = __webpack_require__(249);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(120);
	var ViewportMetrics = __webpack_require__(513);
	
	var getEventModifierState = __webpack_require__(247);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 165 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	var DOMNamespaces = __webpack_require__(231);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(245);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 167 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatName;
	function formatName(context, name) {
	  var sectionPrefix = context._reduxForm.sectionPrefix;
	
	  return !sectionPrefix ? name : sectionPrefix + "." + name;
	}

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(40);
	var normalizeHeaderName = __webpack_require__(552);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(256);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(256);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(157)))

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.login = login;
	exports.logout = logout;
	exports.showDemoModal = showDemoModal;
	exports.hideDemoModal = hideDemoModal;
	exports.getCustomerContext = getCustomerContext;
	exports.attemptTokenLogin = attemptTokenLogin;
	exports.setActiveSubscription = setActiveSubscription;
	exports.savePasswordChange = savePasswordChange;
	exports.forgotPassword = forgotPassword;
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _axios = __webpack_require__(122);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(970);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _apiEndpoints = __webpack_require__(76);
	
	var endpoints = _interopRequireWildcard(_apiEndpoints);
	
	var _actionTypes = __webpack_require__(264);
	
	var _actionTypes2 = __webpack_require__(266);
	
	var types = _interopRequireWildcard(_actionTypes2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function login(credentials) {
	  return function (dispatch) {
	    dispatch({
	      type: types.CUSTOMER_LOGIN_ATTEMPT
	    });
	
	    var credentialsQuery = _qs2.default.stringify({
	      'grant_type': 'password',
	      'username': credentials.email,
	      'password': credentials.password
	    });
	
	    return new Promise(function (resolve, reject) {
	      _axios2.default.post(endpoints.AUTH_TOKEN, credentialsQuery).then(function (response) {
	        var accountInfo = {
	          token: response.data.access_token,
	          userName: response.data.Username,
	          fullName: response.data.Firstname + ' ' + response.data.Lastname,
	          isActive: response.data.IsActive,
	          isDemoUser: response.data.IsDemoUser,
	          isMasterUser: response.data.IsMasterUser,
	          remember: credentials.remember
	        };
	
	        dispatch(loginSuccess(accountInfo));
	        resolve();
	      }).catch(function (error) {
	        if (error.response) {
	          dispatch(loginFailed());
	        } else {
	          dispatch({ type: types.SHOW_ERROR_MODAL });
	        }
	        reject();
	      });
	    });
	  };
	}
	
	function logout() {
	  return function (dispatch) {
	    localStorage.setItem('token', '');
	    dispatch({ type: types.CUSTOMER_LOGOUT });
	    dispatch({ type: _actionTypes.CLEAR_APPLICATION_STATE });
	    dispatch((0, _reactRouterRedux.push)('/'));
	  };
	}
	
	//demo actions
	
	function showDemoModal() {
	
	  return function (dispatch) {
	
	    dispatch({ type: types.SHOW_DEMO_MODAL });
	  };
	}
	
	function hideDemoModal() {
	  return function (dispatch) {
	    dispatch({ type: types.HIDE_DEMO_MODAL });
	  };
	}
	
	function loginSuccess(accountInfo) {
	  return function (dispatch) {
	    var rememberUserName = '';
	    if (accountInfo.remember) {
	      rememberUserName = accountInfo.userName;
	    }
	    localStorage.setItem('rememberUserName', rememberUserName);
	    localStorage.setItem('token', accountInfo.token);
	
	    dispatch({
	      type: types.CUSTOMER_LOGIN_SUCCESS,
	      payload: accountInfo
	    });
	
	    dispatch(getCustomerContext());
	  };
	}
	
	function loginFailed() {
	  return {
	    type: types.CUSTOMER_LOGIN_FAIL
	  };
	}
	
	function bindAxiosTokenInterceptor() {
	  _axios2.default.interceptors.request.use(function (config) {
	    var token = localStorage.token;
	    if (token !== null) {
	      config.headers.Authorization = 'bearer ' + token;
	    }
	    return config;
	  }, function (error) {
	    return Promise.reject(error);
	  });
	}
	
	function getCustomerContext() {
	  return function (dispatch) {
	    _axios2.default.get(endpoints.CUSTOMER_MYCONTEXT).then(function (response) {
	      var subscriptionList = [];
	      var subscriptions = response.data.Subscriptions;
	      subscriptions.forEach(function (subscription) {
	        var pageOffset = {
	          PosX: 0,
	          PosY: 0
	        };
	
	        var isPaperSizeLetter = false;
	        var usePLUCode = true;
	        var useUSMetrics = false;
	        var labelTitleOrder = 0;
	
	        if (subscription.Subscription.LabelSettings.PageRenderingPositionOffset !== null) {
	          pageOffset = subscription.Subscription.LabelSettings.PageRenderingPositionOffset;
	        }
	
	        if (subscription.Subscription.LabelSettings.IsPaperSizeLetter !== null) {
	          isPaperSizeLetter = subscription.Subscription.LabelSettings.IsPaperSizeLetter;
	        }
	
	        if (subscription.Subscription.LabelSettings.UsePLUCode !== null) {
	          usePLUCode = subscription.Subscription.LabelSettings.UsePLUCode;
	        }
	
	        if (subscription.Subscription.LabelSettings.UseUSMetrics !== null) {
	          useUSMetrics = subscription.Subscription.LabelSettings.UseUSMetrics;
	        }
	
	        if (subscription.Subscription.LabelSettings.LabelTitleOrder !== null) {
	          labelTitleOrder = subscription.Subscription.LabelSettings.LabelTitleOrder;
	        }
	
	        var sub = {
	          id: subscription.Subscription.ID,
	          name: subscription.Subscription.Name,
	          locale: 'en-US', // TODO: HACK HACK HACK: We don't need this soon, going to use browser locale
	          permissions: subscription.Permissions,
	          excelKey: subscription.Subscription.ArticleMappingExcelKey,
	          styles: subscription.Subscription.LabelSettings.Styles,
	          logos: subscription.Subscription.LabelSettings.Logos,
	          pageOffset: pageOffset,
	          useUSMetrics: useUSMetrics,
	          usePLUCode: usePLUCode,
	          isPaperSizeLetter: isPaperSizeLetter,
	          labelTitleOrder: labelTitleOrder,
	          language: subscription.Subscription.Channel.Language,
	
	          manualBilling: subscription.Subscription.ManualBilling,
	          supportsCareSheets: subscription.Subscription.Channel.SupportsCaresheets
	        };
	        subscriptionList.push(sub);
	      });
	
	      var activeSubscriptionId = subscriptionList.length > 0 ? subscriptionList[0].id : 0;
	      var contextInfo = {
	        userName: response.data.Username,
	        fullName: response.data.Firstname + ' ' + response.data.Lastname,
	        isActive: response.data.IsActive,
	        isDemoUser: response.data.IsDemoUser,
	        isMasterUser: response.data.IsMasterUser,
	        subscriptionList: subscriptionList,
	        activeSubscriptionId: activeSubscriptionId
	      };
	
	      //set local after login
	      var lan = response.data.Subscriptions["0"].Subscription.Channel.Language;
	
	      if (lan === 'German') dispatch((0, _reactReduxI18n.setLocale)('de-DE'));else dispatch((0, _reactReduxI18n.setLocale)('en-US'));
	
	      _axios2.default.get(endpoints.ORDER_MANAGEMENT_LINK + '?subscriptionID=' + contextInfo.activeSubscriptionId).then(function (response) {
	        contextInfo.managementLink = response.data;
	
	        dispatch({
	          type: types.CUSTOMER_CONTEXT_RECEIVED,
	          payload: contextInfo
	        });
	      });
	    }).catch(function (error) {
	      if (error.response) {
	        // The token authorization has failed and so we need to logout the user and kick them back to login.
	        dispatch(logout());
	      } else {
	        dispatch({ type: types.SHOW_ERROR_MODAL });
	      }
	    });
	  };
	}
	
	// Attempt to use a stored token if one is available in localStorage
	function attemptTokenLogin() {
	  return function (dispatch) {
	    bindAxiosTokenInterceptor();
	    var token = localStorage.token;
	    if (token !== '' && token !== undefined) {
	      dispatch(getCustomerContext());
	      dispatch({ type: types.TOKEN_LOGIN_SUCCESS });
	    }
	  };
	}
	
	function setActiveSubscription(subscriptionId) {
	  return function (dispatch) {
	    _axios2.default.get(endpoints.ORDER_MANAGEMENT_LINK + '?subscriptionID=' + subscriptionId).then(function (response) {
	      dispatch({
	        type: types.SET_ACTIVE_SUBSCRIPTION,
	        payload: {
	          activeSubscriptionId: subscriptionId,
	          managementLink: response.data
	        }
	      });
	    });
	  };
	}
	
	function savePasswordChange(oldPassword, newPassword) {
	  return function (dispatch) {
	    return new Promise(function (resolve, reject) {
	      var passwordData = {
	        OldPassword: oldPassword,
	        NewPassword: newPassword,
	        ConfirmPassword: newPassword
	      };
	
	      _axios2.default.post(endpoints.CHANGE_PASSWORD, passwordData).then(function () {
	        dispatch({ type: types.PASSWORD_CHANGE_SUCCESS });
	        resolve();
	      }).catch(function () {
	        reject();
	      });
	    });
	  };
	}
	
	function forgotPassword(username) {
	  return function (dispatch) {
	    var passwordData = {
	      UsernameOrEmail: username
	    };
	
	    _axios2.default.post(endpoints.FORGOT_PASSWORD, passwordData).then(function () {
	      dispatch({ type: types.FORGOT_PASSWORD_SENT });
	    }).catch(function () {
	      dispatch({ type: types.SHOW_ERROR_MODAL });
	    });
	  };
	}

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _BarCodeField = __webpack_require__(126);
	
	var _BarCodeField2 = _interopRequireDefault(_BarCodeField);
	
	var _FormInput = __webpack_require__(49);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormMultiline = __webpack_require__(125);
	
	var _FormMultiline2 = _interopRequireDefault(_FormMultiline);
	
	var _PLUField = __webpack_require__(271);
	
	var _PLUField2 = _interopRequireDefault(_PLUField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement(_PLUField2.default, null);
	
	var _ref3 = _react2.default.createElement(_BarCodeField2.default, null);
	
	var LabelCol2Form = function LabelCol2Form(_ref) {
	  var activePLU = _ref.activePLU,
	      detailFields = _ref.detailFields,
	      handleSubmit = _ref.handleSubmit,
	      logoUrl = _ref.logoUrl,
	      onCancel = _ref.onCancel,
	      petLabel = _ref.petLabel,
	      submitButtonText = _ref.submitButtonText;
	
	  var fields = detailFields.map(function (detailField, index) {
	    var keyName = 'Key' + index;
	    var valueName = 'Value' + index;
	    return _react2.default.createElement(
	      'tr',
	      { key: index },
	      _react2.default.createElement(
	        'td',
	        { className: 'category' },
	        _react2.default.createElement(_reduxForm.Field, { name: keyName,
	          component: _FormInput2.default,
	          type: 'text',
	          className: 'form-control'
	        })
	      ),
	      _react2.default.createElement(
	        'td',
	        { className: 'info' },
	        _react2.default.createElement(_reduxForm.Field, { name: valueName,
	          component: _FormInput2.default,
	          type: 'text',
	          className: 'form-control'
	        })
	      )
	    );
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'row' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-lg-12' },
	      _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	          'div',
	          { className: 'label-main' },
	          _react2.default.createElement(
	            'div',
	            { className: 'label-title' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'line1',
	              component: _FormInput2.default,
	              type: 'text',
	              className: 'form-control',
	              placeholder: _reactReduxI18n.I18n.t('ENTER_NAME')
	            }),
	            _react2.default.createElement(_reduxForm.Field, { name: 'line2',
	              component: _FormInput2.default,
	              type: 'text',
	              className: 'form-control latin-name',
	              placeholder: _reactReduxI18n.I18n.t('ENTER_LATIN_NAME')
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'label-content' },
	            _react2.default.createElement('img', { src: petLabel.ImageUrl, className: 'float-left' }),
	            _react2.default.createElement(
	              'table',
	              { className: 'float-left', cellPadding: '0', cellSpacing: '0' },
	              _react2.default.createElement(
	                'tbody',
	                null,
	                fields,
	                activePLU && _ref2
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'label-footer' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'price',
	              component: _FormMultiline2.default,
	              type: 'text',
	              rows: '2',
	              className: 'form-control float-left txt-price',
	              placeholder: _reactReduxI18n.I18n.t('ENTER_PRICE')
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'label-logo' },
	              _react2.default.createElement('img', { src: logoUrl })
	            ),
	            _ref3
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row no-gutters bottom-buttons' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 text-right' },
	            onCancel !== undefined && _react2.default.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-secondary', onClick: onCancel },
	              _reactReduxI18n.I18n.t('CANCEL')
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'submit', className: 'btn btn-primary' },
	              submitButtonText
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _reduxForm.reduxForm)()(LabelCol2Form);

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _BarCodeField = __webpack_require__(126);
	
	var _BarCodeField2 = _interopRequireDefault(_BarCodeField);
	
	var _FormInput = __webpack_require__(49);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormMultiline = __webpack_require__(125);
	
	var _FormMultiline2 = _interopRequireDefault(_FormMultiline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'label-footer' },
	  _react2.default.createElement(_BarCodeField2.default, { className: 'barcode' })
	);
	
	var LabelCol4Form = function (_React$Component) {
	  _inherits(LabelCol4Form, _React$Component);
	
	  function LabelCol4Form() {
	    _classCallCheck(this, LabelCol4Form);
	
	    return _possibleConstructorReturn(this, (LabelCol4Form.__proto__ || Object.getPrototypeOf(LabelCol4Form)).apply(this, arguments));
	  }
	
	  _createClass(LabelCol4Form, [{
	    key: 'renderDetailField',
	    value: function renderDetailField(leftIndex, rightIndex) {
	      var leftKeyName = 'Key' + leftIndex;
	      var leftValueName = 'Value' + leftIndex;
	
	      var rightKeyName = 'Key' + rightIndex;
	      var rightValueName = 'Value' + rightIndex;
	
	      return _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(
	          'tr',
	          { key: leftIndex },
	          _react2.default.createElement(
	            'td',
	            { className: 'category' },
	            _react2.default.createElement(_reduxForm.Field, { name: leftKeyName,
	              component: _FormInput2.default,
	              type: 'text',
	              className: 'form-control'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'info' },
	            _react2.default.createElement(_reduxForm.Field, { name: leftValueName,
	              component: _FormInput2.default,
	              type: 'text',
	              className: 'form-control'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'category' },
	            _react2.default.createElement(_reduxForm.Field, { name: rightKeyName,
	              component: _FormInput2.default,
	              type: 'text',
	              className: 'form-control'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'info' },
	            _react2.default.createElement(_reduxForm.Field, { name: rightValueName,
	              component: _FormInput2.default,
	              type: 'text',
	              className: 'form-control'
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activePLU = _props.activePLU,
	          handleSubmit = _props.handleSubmit,
	          logoUrl = _props.logoUrl,
	          onCancel = _props.onCancel,
	          petLabel = _props.petLabel,
	          submitButtonText = _props.submitButtonText;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-12' },
	          _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit },
	            _react2.default.createElement(
	              'div',
	              { className: 'four-col label-main' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label-logo' },
	                _react2.default.createElement('img', { src: logoUrl })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'label-title' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'line1',
	                  component: _FormInput2.default,
	                  type: 'text',
	                  className: 'form-control',
	                  placeholder: _reactReduxI18n.I18n.t('ENTER_NAME')
	                }),
	                _react2.default.createElement(_reduxForm.Field, { name: 'line2',
	                  component: _FormInput2.default,
	                  type: 'text',
	                  className: 'form-control latin-name',
	                  placeholder: _reactReduxI18n.I18n.t('ENTER_LATIN_NAME')
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'label-right-col' },
	                _react2.default.createElement('img', { src: petLabel.ImageUrl }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'price' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'price',
	                    component: _FormMultiline2.default,
	                    type: 'text',
	                    className: 'form-control txt-price',
	                    placeholder: _reactReduxI18n.I18n.t('ENTER_PRICE')
	                  })
	                ),
	                activePLU && _react2.default.createElement(
	                  'div',
	                  { className: 'plu' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'plu',
	                    component: _FormInput2.default,
	                    type: 'text',
	                    className: 'form-control',
	                    placeholder: _reactReduxI18n.I18n.t('ENTER_PLU')
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'label-content' },
	                _react2.default.createElement(
	                  'table',
	                  { cellPadding: '0', cellSpacing: '0' },
	                  this.renderDetailField(0, 1),
	                  this.renderDetailField(2, 3),
	                  this.renderDetailField(4, 5)
	                )
	              ),
	              _ref
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row no-gutters bottom-buttons' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 text-right' },
	                onCancel !== undefined && _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'btn btn-secondary', onClick: onCancel },
	                  _reactReduxI18n.I18n.t('CANCEL')
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'submit', className: 'btn btn-primary' },
	                  submitButtonText
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LabelCol4Form;
	}(_react2.default.Component);
	
	exports.default = (0, _reduxForm.reduxForm)()(LabelCol4Form);

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _BarCodeField = __webpack_require__(126);
	
	var _BarCodeField2 = _interopRequireDefault(_BarCodeField);
	
	var _FormInput = __webpack_require__(49);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormMultiline = __webpack_require__(125);
	
	var _FormMultiline2 = _interopRequireDefault(_FormMultiline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _react2.default.createElement('div', { className: 'plu-empty' });
	
	var _ref2 = _react2.default.createElement(
	  'div',
	  { className: 'label-footer' },
	  _react2.default.createElement(_BarCodeField2.default, { className: 'barcode' })
	);
	
	var LabelCol4LrgForm = function (_React$Component) {
	  _inherits(LabelCol4LrgForm, _React$Component);
	
	  function LabelCol4LrgForm() {
	    _classCallCheck(this, LabelCol4LrgForm);
	
	    return _possibleConstructorReturn(this, (LabelCol4LrgForm.__proto__ || Object.getPrototypeOf(LabelCol4LrgForm)).apply(this, arguments));
	  }
	
	  _createClass(LabelCol4LrgForm, [{
	    key: 'renderDetailField',
	    value: function renderDetailField(leftIndex, rightIndex) {
	      var leftKeyName = 'Key' + leftIndex;
	      var leftValueName = 'Value' + leftIndex;
	
	      var rightKeyName = 'Key' + rightIndex;
	      var rightValueName = 'Value' + rightIndex;
	
	      return _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(
	          'tr',
	          { key: leftIndex },
	          _react2.default.createElement(
	            'td',
	            { className: 'category' },
	            _react2.default.createElement(_reduxForm.Field, { name: leftKeyName,
	              component: _FormInput2.default,
	              type: 'text',
	              className: 'form-control'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'info' },
	            _react2.default.createElement(_reduxForm.Field, { name: leftValueName,
	              component: _FormInput2.default,
	              type: 'text',
	              className: 'form-control'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'category' },
	            _react2.default.createElement(_reduxForm.Field, { name: rightKeyName,
	              component: _FormInput2.default,
	              type: 'text',
	              className: 'form-control'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'info' },
	            _react2.default.createElement(_reduxForm.Field, { name: rightValueName,
	              component: _FormInput2.default,
	              type: 'text',
	              className: 'form-control'
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activePLU = _props.activePLU,
	          handleSubmit = _props.handleSubmit,
	          logoUrl = _props.logoUrl,
	          onCancel = _props.onCancel,
	          petLabel = _props.petLabel,
	          submitButtonText = _props.submitButtonText;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-12' },
	          _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit },
	            _react2.default.createElement(
	              'div',
	              { className: 'four-col four-col-lrg label-main' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label-title' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'label-left-img' },
	                  _react2.default.createElement('img', { src: petLabel.ImageUrl })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'title-fields' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'line1',
	                    component: _FormInput2.default,
	                    type: 'text',
	                    className: 'form-control',
	                    placeholder: _reactReduxI18n.I18n.t('ENTER_NAME')
	                  }),
	                  _react2.default.createElement(_reduxForm.Field, { name: 'line2',
	                    component: _FormInput2.default,
	                    type: 'text',
	                    className: 'form-control latin-name',
	                    placeholder: _reactReduxI18n.I18n.t('ENTER_LATIN_NAME')
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'label-right-col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'label-logo' },
	                  _react2.default.createElement('img', { src: logoUrl })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'price' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'price',
	                    component: _FormMultiline2.default,
	                    type: 'text',
	                    className: 'form-control txt-price',
	                    placeholder: _reactReduxI18n.I18n.t('ENTER_PRICE')
	                  })
	                ),
	                activePLU && _react2.default.createElement(
	                  'div',
	                  { className: 'plu' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'plu',
	                    component: _FormInput2.default,
	                    type: 'text',
	                    className: 'form-control',
	                    placeholder: _reactReduxI18n.I18n.t('ENTER_PLU')
	                  })
	                ),
	                !activePLU && _ref,
	                _ref2
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'label-content' },
	                _react2.default.createElement(
	                  'table',
	                  { cellPadding: '0', cellSpacing: '0' },
	                  this.renderDetailField(0, 1),
	                  this.renderDetailField(2, 3),
	                  this.renderDetailField(4, 5),
	                  this.renderDetailField(6, 7),
	                  this.renderDetailField(8, 9),
	                  this.renderDetailField(10, 11),
	                  this.renderDetailField(12, 13)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row no-gutters bottom-buttons' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 text-right' },
	                onCancel !== undefined && _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'btn btn-secondary', onClick: onCancel },
	                  _reactReduxI18n.I18n.t('CANCEL')
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'submit', className: 'btn btn-primary' },
	                  submitButtonText
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LabelCol4LrgForm;
	}(_react2.default.Component);
	
	exports.default = (0, _reduxForm.reduxForm)()(LabelCol4LrgForm);

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isErrorOpen = exports.isChangePasswordOpen = exports.isSelectStoreOpen = exports.isNavbarTransitioning = exports.isNavbarCollapsed = undefined;
	
	var _constants = __webpack_require__(278);
	
	var isNavbarCollapsed = exports.isNavbarCollapsed = function isNavbarCollapsed(state) {
	  return state[_constants.NAME].collapsed;
	};
	var isNavbarTransitioning = exports.isNavbarTransitioning = function isNavbarTransitioning(state) {
	  return state[_constants.NAME].transitioning;
	};
	var isSelectStoreOpen = exports.isSelectStoreOpen = function isSelectStoreOpen(state) {
	  return state[_constants.NAME].selectStoreOpen;
	};
	var isChangePasswordOpen = exports.isChangePasswordOpen = function isChangePasswordOpen(state) {
	  return state[_constants.NAME].changePasswordOpen;
	};
	var isErrorOpen = exports.isErrorOpen = function isErrorOpen(state) {
	  return state[_constants.NAME].errorOpen;
	};

/***/ },
/* 174 */
[1197, 625, 281, 626],
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(27)
	  , toIndex  = __webpack_require__(84)
	  , toLength = __webpack_require__(24);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(22)
	  , createDesc      = __webpack_require__(67);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(15)
	  , document = __webpack_require__(10).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 178 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(17)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(10).document && document.documentElement;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(15)
	  , setPrototypeOf = __webpack_require__(189).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(95)
	  , ITERATOR   = __webpack_require__(17)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(44);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(79)
	  , descriptor     = __webpack_require__(67)
	  , setToStringTag = __webpack_require__(96)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(35)(IteratorPrototype, __webpack_require__(17)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(78)
	  , $export        = __webpack_require__(3)
	  , redefine       = __webpack_require__(36)
	  , hide           = __webpack_require__(35)
	  , has            = __webpack_require__(32)
	  , Iterators      = __webpack_require__(95)
	  , $iterCreate    = __webpack_require__(184)
	  , setToStringTag = __webpack_require__(96)
	  , getPrototypeOf = __webpack_require__(42)
	  , ITERATOR       = __webpack_require__(17)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 186 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 187 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(10)
	  , macrotask = __webpack_require__(196).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(44)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(15)
	  , anObject = __webpack_require__(7);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(59)(Function.call, __webpack_require__(41).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(139)('keys')
	  , uid    = __webpack_require__(85);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(7)
	  , aFunction = __webpack_require__(34)
	  , SPECIES   = __webpack_require__(17)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(68)
	  , defined   = __webpack_require__(45);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(135)
	  , defined  = __webpack_require__(45);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(68)
	  , defined   = __webpack_require__(45);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 195 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(59)
	  , invoke             = __webpack_require__(134)
	  , html               = __webpack_require__(180)
	  , cel                = __webpack_require__(177)
	  , global             = __webpack_require__(10)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(44)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(10)
	  , DESCRIPTORS    = __webpack_require__(21)
	  , LIBRARY        = __webpack_require__(78)
	  , $typed         = __webpack_require__(140)
	  , hide           = __webpack_require__(35)
	  , redefineAll    = __webpack_require__(82)
	  , fails          = __webpack_require__(13)
	  , anInstance     = __webpack_require__(77)
	  , toInteger      = __webpack_require__(68)
	  , toLength       = __webpack_require__(24)
	  , gOPN           = __webpack_require__(80).f
	  , dP             = __webpack_require__(22).f
	  , arrayFill      = __webpack_require__(175)
	  , setToStringTag = __webpack_require__(96)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(10)
	  , core           = __webpack_require__(58)
	  , LIBRARY        = __webpack_require__(78)
	  , wksExt         = __webpack_require__(310)
	  , defineProperty = __webpack_require__(22).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(108)
	  , ITERATOR  = __webpack_require__(17)('iterator')
	  , Iterators = __webpack_require__(95);
	module.exports = __webpack_require__(58).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(93)
	  , step             = __webpack_require__(298)
	  , Iterators        = __webpack_require__(95)
	  , toIObject        = __webpack_require__(38);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(185)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 201 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 202 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 205 */
/***/ function(module, exports) {

	module.exports = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(88),
	    root = __webpack_require__(47);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(927),
	    mapCacheDelete = __webpack_require__(928),
	    mapCacheGet = __webpack_require__(929),
	    mapCacheHas = __webpack_require__(930),
	    mapCacheSet = __webpack_require__(931);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 208 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(330),
	    keys = __webpack_require__(101);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(873),
	    isObjectLike = __webpack_require__(70);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(323);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 212 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(351);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(863),
	    stubArray = __webpack_require__(358);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 215 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(31),
	    isSymbol = __webpack_require__(100);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 217 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(209),
	    castFunction = __webpack_require__(336);
	
	/**
	 * Iterates over own enumerable string keyed properties of an object and
	 * invokes `iteratee` for each property. The iteratee is invoked with three
	 * arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwnRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, castFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(87),
	    isObject = __webpack_require__(43);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 220 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(87),
	    isArray = __webpack_require__(31),
	    isObjectLike = __webpack_require__(70);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(876),
	    baseUnary = __webpack_require__(335),
	    nodeUtil = __webpack_require__(935);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(969)();
	}


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true,
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _libComponentsRaised = __webpack_require__(1023);
	
	var _libComponentsRaised2 = _interopRequireDefault(_libComponentsRaised);
	
	var _libComponentsTile = __webpack_require__(1026);
	
	var _libComponentsTile2 = _interopRequireDefault(_libComponentsTile);
	
	var _libComponentsTabs = __webpack_require__(1025);
	
	var _libComponentsTabs2 = _interopRequireDefault(_libComponentsTabs);
	
	exports.Raised = _libComponentsRaised2['default'];
	exports.Tile = _libComponentsTile2['default'];
	exports.Tabs = _libComponentsTabs2['default'];


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Base = function (_React$Component) {
	  _inherits(Base, _React$Component);
	
	  function Base() {
	    _classCallCheck(this, Base);
	
	    return _possibleConstructorReturn(this, (Base.__proto__ || Object.getPrototypeOf(Base)).apply(this, arguments));
	  }
	
	  _createClass(Base, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      Base.instances.push(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      Base.instances.splice(Base.instances.indexOf(this), 1);
	    }
	  }], [{
	    key: 'rerenderAll',
	    value: function rerenderAll() {
	      Base.instances.forEach(function (instance) {
	        return instance.forceUpdate();
	      });
	    }
	  }]);
	
	  return Base;
	}(_react2.default.Component);
	
	Base.instances = [];
	exports.default = Base;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(968);
	
	var _intl = __webpack_require__(850);
	
	var _intl2 = _interopRequireDefault(_intl);
	
	var _formatMissingTranslation = __webpack_require__(1034);
	
	var _formatMissingTranslation2 = _interopRequireDefault(_formatMissingTranslation);
	
	var _Base = __webpack_require__(225);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  _localeKey: 'en',
	  _translationsObject: {},
	  _getTranslations: null,
	  _getLocale: null,
	
	  get _translations() {
	    return this._getTranslations ? this._getTranslations() : this._translationsObject;
	  },
	
	  set _translations(translations) {
	    this._translationsObject = translations;
	  },
	
	  get _locale() {
	    return this._getLocale ? this._getLocale() : this._localeKey;
	  },
	
	  set _locale(locale) {
	    this._localeKey = locale;
	  },
	
	  setLocale: function setLocale(locale) {
	    var rerenderComponents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    this._locale = locale;
	    if (rerenderComponents) {
	      this.forceComponentsUpdate();
	    }
	  },
	  setTranslations: function setTranslations(translations) {
	    var rerenderComponents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    this._translations = translations;
	    if (rerenderComponents) {
	      this.forceComponentsUpdate();
	    }
	  },
	
	
	  /**
	   * @deprecated
	   */
	  loadTranslations: function loadTranslations(translations) {
	    this.setTranslations(translations);
	  },
	  setTranslationsGetter: function setTranslationsGetter(fn) {
	    if (typeof fn !== 'function') {
	      throw new Error('Translations getter must be a function');
	    }
	    this._getTranslations = fn;
	  },
	  setLocaleGetter: function setLocaleGetter(fn) {
	    if (typeof fn !== 'function') {
	      throw new Error('Locale getter must be a function');
	    }
	    this._getLocale = fn;
	  },
	  t: function t(key) {
	    var replacements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return this._translate(key, replacements);
	  },
	  l: function l(value, options) {
	    return this._localize(value, options);
	  },
	  _replace: function _replace(translation, replacements) {
	    var replaced = translation;
	    Object.keys(replacements).forEach(function (replacement) {
	      replaced = replaced.split('%{' + replacement + '}').join(replacements[replacement]);
	    });
	    return replaced;
	  },
	  _translate: function _translate(key) {
	    var _this = this;
	
	    var replacements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var translation = '';
	    try {
	      var translationLocale = this._translations[this._locale] ? this._locale : this._locale.split('-')[0];
	      translation = this._fetchTranslation(this._translations, translationLocale + '.' + key, replacements.count);
	    } catch (err) {
	      return (0, _formatMissingTranslation2.default)(key);
	    }
	    if (typeof translation === 'string') {
	      return this._replace(translation, replacements);
	    }
	    Object.keys(translation).forEach(function (translationKey) {
	      translation[translationKey] = _this._replace(translation[translationKey], replacements);
	    });
	    return translation;
	  },
	  _localize: function _localize(value) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (options.dateFormat) {
	      _moment2.default.locale(this._locale);
	      return (0, _moment2.default)(value).format(this.t(options.dateFormat));
	    }
	    if (typeof value === 'number') {
	      if (global.Intl) {
	        if (!(Intl.NumberFormat && Intl.NumberFormat.supportedLocalesOf(this._locale).length === 1)) {
	          Intl.NumberFormat = _intl2.default.NumberFormat;
	        }
	      } else {
	        global.Intl = _intl2.default;
	      }
	      return new Intl.NumberFormat(this._locale, options).format(value);
	    }
	    return value;
	  },
	  _fetchTranslation: function _fetchTranslation(translations, key) {
	    var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	    var _index = key.indexOf('.');
	    if (typeof translations === 'undefined') {
	      throw new Error('not found');
	    }
	    if (_index > -1) {
	      return this._fetchTranslation(translations[key.substring(0, _index)], key.substr(_index + 1), count);
	    }
	    if (count !== null) {
	      if (translations[key + '_' + count]) {
	        // when key = 'items_3' if count is 3
	        return translations[key + '_' + count];
	      }
	      if (count !== 1 && translations[key + '_plural']) {
	        // when count is not simply singular, return _plural
	        return translations[key + '_plural'];
	      }
	    }
	    if (translations[key]) {
	      return translations[key];
	    }
	    throw new Error('not found');
	  },
	  forceComponentsUpdate: function forceComponentsUpdate() {
	    _Base2.default.rerenderAll();
	  }
	}; /* eslint no-underscore-dangle: "off" */
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 227 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _deprecateObjectProperties = __webpack_require__(159);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(90);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1054);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1051);
	
	var _isActive2 = __webpack_require__(1058);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1055);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1060);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(103);
	var Danger = __webpack_require__(1071);
	var ReactMultiChildUpdateTypes = __webpack_require__(508);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactInstrumentation = __webpack_require__(48);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(245);
	var setInnerHTML = __webpack_require__(166);
	var setTextContent = __webpack_require__(525);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID, 'replace text', stringText);
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation(prevInstance._debugID, 'replace with', markup.toString());
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(nextInstance._debugID, 'mount', markup.toString());
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'insert child', { toIndex: update.toIndex, content: update.content.toString() });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'move child', { fromIndex: update.fromIndex, toIndex: update.toIndex });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace children', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace text', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'remove child', { fromIndex: update.fromIndex });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 231 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMNamespaces
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var EventConstants = __webpack_require__(64);
	var ReactErrorUtils = __webpack_require__(239);
	
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(11);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 234 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyEscapeUtils
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactPropTypes = __webpack_require__(510);
	var ReactPropTypeLocations = __webpack_require__(242);
	var ReactPropTypesSecret = __webpack_require__(243);
	
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(11);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop, null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactNoopUpdateQueue = __webpack_require__(240);
	
	var canDefineProperty = __webpack_require__(515);
	var emptyObject = __webpack_require__(111);
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(11);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(6);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentTreeHook
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(74);
	
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(11);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var itemMap;
	var rootIDSet;
	
	var itemByKey;
	var rootByKey;
	
	if (canUseCollections) {
	  itemMap = new Map();
	  rootIDSet = new Set();
	} else {
	  itemByKey = {};
	  rootByKey = {};
	}
	
	var unmountedIDs = [];
	
	// Use non-numeric keys to prevent V8 performance issues:
	// https://github.com/facebook/react/pull/7232
	function getKeyFromID(id) {
	  return '.' + id;
	}
	function getIDFromKey(key) {
	  return parseInt(key.substr(1), 10);
	}
	
	function get(id) {
	  if (canUseCollections) {
	    return itemMap.get(id);
	  } else {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  }
	}
	
	function remove(id) {
	  if (canUseCollections) {
	    itemMap['delete'](id);
	  } else {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  }
	}
	
	function create(id, element, parentID) {
	  var item = {
	    element: element,
	    parentID: parentID,
	    text: null,
	    childIDs: [],
	    isMounted: false,
	    updateCount: 0
	  };
	
	  if (canUseCollections) {
	    itemMap.set(id, item);
	  } else {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  }
	}
	
	function addRoot(id) {
	  if (canUseCollections) {
	    rootIDSet.add(id);
	  } else {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  }
	}
	
	function removeRoot(id) {
	  if (canUseCollections) {
	    rootIDSet['delete'](id);
	  } else {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  }
	}
	
	function getRegisteredIDs() {
	  if (canUseCollections) {
	    return Array.from(itemMap.keys());
	  } else {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  }
	}
	
	function getRootIDs() {
	  if (canUseCollections) {
	    return Array.from(rootIDSet.keys());
	  } else {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  }
	}
	
	function purgeDeep(id) {
	  var item = get(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    remove(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + name + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = get(id);
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = get(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent ID is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    create(id, element, parentID);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = get(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = get(id);
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = get(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = get(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = get(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var type = topElement.type;
	      var name = typeof type === 'function' ? type.displayName || type.name : type;
	      var owner = topElement._owner;
	      info += describeComponentFrame(name || 'Unknown', topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = get(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = get(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = get(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = get(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = get(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRegisteredIDs: getRegisteredIDs,
	
	  getRootIDs: getRootIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(11);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(141);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 243 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypesSecret
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(74);
	var ReactInstanceMap = __webpack_require__(105);
	var ReactInstrumentation = __webpack_require__(48);
	var ReactUpdates = __webpack_require__(55);
	
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(11);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 245 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createMicrosoftUnsafeLocalFunction
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 246 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 247 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 248 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 250 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(74);
	var ReactElement = __webpack_require__(54);
	
	var getIteratorFn = __webpack_require__(519);
	var invariant = __webpack_require__(6);
	var KeyEscapeUtils = __webpack_require__(234);
	var warning = __webpack_require__(11);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var emptyFunction = __webpack_require__(39);
	var warning = __webpack_require__(11);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 253 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ARRAY_INSERT = exports.ARRAY_INSERT = '@@redux-form/ARRAY_INSERT';
	var ARRAY_MOVE = exports.ARRAY_MOVE = '@@redux-form/ARRAY_MOVE';
	var ARRAY_POP = exports.ARRAY_POP = '@@redux-form/ARRAY_POP';
	var ARRAY_PUSH = exports.ARRAY_PUSH = '@@redux-form/ARRAY_PUSH';
	var ARRAY_REMOVE = exports.ARRAY_REMOVE = '@@redux-form/ARRAY_REMOVE';
	var ARRAY_REMOVE_ALL = exports.ARRAY_REMOVE_ALL = '@@redux-form/ARRAY_REMOVE_ALL';
	var ARRAY_SHIFT = exports.ARRAY_SHIFT = '@@redux-form/ARRAY_SHIFT';
	var ARRAY_SPLICE = exports.ARRAY_SPLICE = '@@redux-form/ARRAY_SPLICE';
	var ARRAY_UNSHIFT = exports.ARRAY_UNSHIFT = '@@redux-form/ARRAY_UNSHIFT';
	var ARRAY_SWAP = exports.ARRAY_SWAP = '@@redux-form/ARRAY_SWAP';
	var AUTOFILL = exports.AUTOFILL = '@@redux-form/AUTOFILL';
	var BLUR = exports.BLUR = '@@redux-form/BLUR';
	var CHANGE = exports.CHANGE = '@@redux-form/CHANGE';
	var CLEAR_SUBMIT = exports.CLEAR_SUBMIT = '@@redux-form/CLEAR_SUBMIT';
	var CLEAR_ASYNC_ERROR = exports.CLEAR_ASYNC_ERROR = '@redux-form/CLEAR_ASYNC_ERROR';
	var DESTROY = exports.DESTROY = '@@redux-form/DESTROY';
	var FOCUS = exports.FOCUS = '@@redux-form/FOCUS';
	var INITIALIZE = exports.INITIALIZE = '@@redux-form/INITIALIZE';
	var REGISTER_FIELD = exports.REGISTER_FIELD = '@@redux-form/REGISTER_FIELD';
	var RESET = exports.RESET = '@@redux-form/RESET';
	var SET_SUBMIT_FAILED = exports.SET_SUBMIT_FAILED = '@@redux-form/SET_SUBMIT_FAILED';
	var SET_SUBMIT_SUCCEEDED = exports.SET_SUBMIT_SUCCEEDED = '@@redux-form/SET_SUBMIT_SUCCEEDED';
	var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = '@@redux-form/START_ASYNC_VALIDATION';
	var START_SUBMIT = exports.START_SUBMIT = '@@redux-form/START_SUBMIT';
	var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = '@@redux-form/STOP_ASYNC_VALIDATION';
	var STOP_SUBMIT = exports.STOP_SUBMIT = '@@redux-form/STOP_SUBMIT';
	var SUBMIT = exports.SUBMIT = '@@redux-form/SUBMIT';
	var TOUCH = exports.TOUCH = '@@redux-form/TOUCH';
	var UNREGISTER_FIELD = exports.UNREGISTER_FIELD = '@@redux-form/UNREGISTER_FIELD';
	var UNTOUCH = exports.UNTOUCH = '@@redux-form/UNTOUCH';
	var UPDATE_SYNC_ERRORS = exports.UPDATE_SYNC_ERRORS = '@@redux-form/UPDATE_SYNC_ERRORS';
	var UPDATE_SYNC_WARNINGS = exports.UPDATE_SYNC_WARNINGS = '@@redux-form/UPDATE_SYNC_WARNINGS';

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasError = __webpack_require__(1156);
	
	var _hasError2 = _interopRequireDefault(_hasError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsValid = function createIsValid(structure) {
	  var getIn = structure.getIn,
	      keys = structure.keys;
	
	  var hasError = (0, _hasError2.default)(structure);
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    return function (state) {
	      var formState = getFormState(state);
	      var syncError = getIn(formState, form + '.syncError');
	      if (syncError) {
	        return false;
	      }
	      if (!ignoreSubmitErrors) {
	        var error = getIn(formState, form + '.error');
	        if (error) {
	          return false;
	        }
	      }
	      var syncErrors = getIn(formState, form + '.syncErrors');
	      var asyncErrors = getIn(formState, form + '.asyncErrors');
	      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
	      if (!syncErrors && !asyncErrors && !submitErrors) {
	        return true;
	      }
	
	      var registeredFields = getIn(formState, form + '.registeredFields');
	      if (!registeredFields) {
	        return true;
	      }
	
	      return !keys(registeredFields).filter(function (name) {
	        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
	      }).some(function (name) {
	        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
	      });
	    };
	  };
	};
	
	exports.default = createIsValid;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(356);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
	  // https://lodash.com/docs/4.17.4#isEqualWith
	  if (stack) {
	    // Shallow compares
	    // For 1st level, stack === undefined.
	    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
	    // For 2nd level and up, stack !== undefined.
	    //   -> Compare by === operator
	    return objectValue === otherValue;
	  }
	};
	
	var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
	  return !(0, _isEqualWith3.default)(instance.props, nextProps, customizer) || !(0, _isEqualWith3.default)(instance.state, nextState, customizer);
	};
	
	exports.default = shallowCompare;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	var settle = __webpack_require__(544);
	var buildURL = __webpack_require__(547);
	var parseHeaders = __webpack_require__(553);
	var isURLSameOrigin = __webpack_require__(551);
	var createError = __webpack_require__(259);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(546);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(549);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 257 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 258 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(543);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ },
/* 260 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 261 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CARESHEET_SETTINGS_RECEIVED = exports.CARESHEET_SETTINGS_RECEIVED = 'petdata/CARESHEET_SETTINGS_RECEIVED';
	var GET_CARESHEET_SETTINGS = exports.GET_CARESHEET_SETTINGS = 'petdata/GET_CARESHEET_SETTINGS';
	
	var AD_SELECTED = exports.AD_SELECTED = 'petdata/AD_SELECTED';
	var AD_DESELECTED = exports.AD_DESELECTED = 'petdata/AD_DESELECTED';
	var AD_DELETED = exports.AD_DELETED = 'petdata/AD_DELETED';
	
	var SAVE_INFO_SUCCESS = exports.SAVE_INFO_SUCCESS = 'petdata/SAVE_INFO_SUCCESS';
	
	var CARESHEET_LIST_RECEIVED = exports.CARESHEET_LIST_RECEIVED = 'petdata/CARESHEET_LIST_RECEIVED';
	var PET_TYPES_ADDED = exports.PET_TYPES_ADDED = 'petdata/caresheets/PET_TYPES_ADDED';
	
	var TOGGLE_SELECTED_PET_TYPE = exports.TOGGLE_SELECTED_PET_TYPE = 'petdata/caresheets/TOGGLE_SELECTED_PET_TYPE';
	
	var FILTER_CARESHEETS = exports.FILTER_CARESHEETS = 'petdata/FILTER_CARESHEETS';
	var CLEAR_SEARCH_RESULTS = exports.CLEAR_SEARCH_RESULTS = 'petdata/caresheets/CLEAR_SEARCH_RESULTS';
	var CARESHEET_SEARCH_PHRASE = exports.CARESHEET_SEARCH_PHRASE = 'petdata/CARESHEET_SEARCH_PHRASE';
	
	var DOWNLOAD_CARE_SHEET = exports.DOWNLOAD_CARE_SHEET = 'petdata/DOWNLOAD_CARE_SHEET';
	
	var SHOW_ERROR_MODAL = exports.SHOW_ERROR_MODAL = 'petdata/SHOW_ERROR_MODAL';

/***/ },
/* 262 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NAME = exports.NAME = 'caresheets';

/***/ },
/* 263 */
[1196, 123, 573, 262, 574, 124],
/* 264 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CLEAR_APPLICATION_STATE = exports.CLEAR_APPLICATION_STATE = 'petdata/CLEAR_APPLICATION_STATE';

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(63);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-cond-assign */
	/* eslint-disable no-console */
	
	
	var findDOMNode = _reactDom2.default.findDOMNode;
	
	
	var CLIENT_SIZE_KEYS = { x: 'clientWidth', y: 'clientHeight' };
	var CLIENT_START_KEYS = { x: 'clientTop', y: 'clientLeft' };
	var INNER_SIZE_KEYS = { x: 'innerWidth', y: 'innerHeight' };
	var OFFSET_SIZE_KEYS = { x: 'offsetWidth', y: 'offsetHeight' };
	var OFFSET_START_KEYS = { x: 'offsetLeft', y: 'offsetTop' };
	var OVERFLOW_KEYS = { x: 'overflowX', y: 'overflowY' };
	var SCROLL_SIZE_KEYS = { x: 'scrollWidth', y: 'scrollHeight' };
	var SCROLL_START_KEYS = { x: 'scrollLeft', y: 'scrollTop' };
	var SIZE_KEYS = { x: 'width', y: 'height' };
	
	var NOOP = function NOOP() {};
	
	// If a browser doesn't support the `options` argument to
	// add/removeEventListener, we need to check, otherwise we will
	// accidentally set `capture` with a truthy value.
	var PASSIVE = function () {
	  if (typeof window === 'undefined') return false;
	  var hasSupport = false;
	  try {
	    document.createElement('div').addEventListener('test', NOOP, {
	      get passive() {
	        hasSupport = true;
	        return false;
	      }
	    });
	  } catch (e) {
	    console.log(e);
	  }
	  return hasSupport;
	}() ? { passive: true } : false;
	
	var UNSTABLE_MESSAGE = 'ReactList failed to reach a stable state.';
	var MAX_SYNC_UPDATES = 100;
	
	var isEqualSubset = function isEqualSubset(a, b) {
	  for (var key in b) {
	    if (a[key] !== b[key]) return false;
	  }return true;
	};
	
	var ReactList = function (_Component) {
	  _inherits(ReactList, _Component);
	
	  function ReactList(props) {
	    _classCallCheck(this, ReactList);
	
	    var _this = _possibleConstructorReturn(this, (ReactList.__proto__ || Object.getPrototypeOf(ReactList)).call(this, props));
	
	    var initialIndex = props.initialIndex;
	
	    var itemsPerRow = 1;
	
	    var _this$constrain = _this.constrain(initialIndex, 0, itemsPerRow, props),
	        from = _this$constrain.from,
	        size = _this$constrain.size;
	
	    _this.state = { from: from, size: size, itemsPerRow: itemsPerRow };
	    _this.cache = {};
	    _this.prevPrevState = {};
	    _this.unstable = false;
	    _this.updateCounter = 0;
	    return _this;
	  }
	
	  _createClass(ReactList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateFrame = this.updateFrame.bind(this);
	      window.addEventListener('resize', this.updateFrame);
	      this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      var _state = this.state,
	          from = _state.from,
	          size = _state.size,
	          itemsPerRow = _state.itemsPerRow;
	
	      this.maybeSetState(this.constrain(from, size, itemsPerRow, next), NOOP);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      // If the list has reached an unstable state, prevent an infinite loop.
	      if (this.unstable) return;
	
	      if (++this.updateCounter > MAX_SYNC_UPDATES) {
	        this.unstable = true;
	        return console.error(UNSTABLE_MESSAGE);
	      }
	
	      if (!this.updateCounterTimeoutId) {
	        this.updateCounterTimeoutId = setTimeout(function () {
	          _this2.updateCounter = 0;
	          delete _this2.updateCounterTimeoutId;
	        }, 0);
	      }
	
	      this.updateFrame();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateFrame);
	      this.scrollParent.removeEventListener('scroll', this.updateFrame, PASSIVE);
	      this.scrollParent.removeEventListener('mousewheel', NOOP, PASSIVE);
	    }
	  }, {
	    key: 'maybeSetState',
	    value: function maybeSetState(b, cb) {
	      if (isEqualSubset(this.state, b)) return cb();
	
	      this.setState(b, cb);
	    }
	  }, {
	    key: 'getOffset',
	    value: function getOffset(el) {
	      var axis = this.props.axis;
	
	      var offset = el[CLIENT_START_KEYS[axis]] || 0;
	      var offsetKey = OFFSET_START_KEYS[axis];
	      do {
	        offset += el[offsetKey] || 0;
	      } while (el = el.offsetParent);
	      return offset;
	    }
	  }, {
	    key: 'getScrollParent',
	    value: function getScrollParent() {
	      var _props = this.props,
	          axis = _props.axis,
	          scrollParentGetter = _props.scrollParentGetter;
	
	      if (scrollParentGetter) return scrollParentGetter();
	      var el = findDOMNode(this);
	      var overflowKey = OVERFLOW_KEYS[axis];
	      while (el = el.parentElement) {
	        switch (window.getComputedStyle(el)[overflowKey]) {
	          case 'auto':case 'scroll':case 'overlay':
	            return el;
	        }
	      }
	      return window;
	    }
	  }, {
	    key: 'getScroll',
	    value: function getScroll() {
	      var scrollParent = this.scrollParent;
	      var axis = this.props.axis;
	
	      var scrollKey = SCROLL_START_KEYS[axis];
	      var actual = scrollParent === window ?
	      // Firefox always returns document.body[scrollKey] as 0 and Chrome/Safari
	      // always return document.documentElement[scrollKey] as 0, so take
	      // whichever has a value.
	      document.body[scrollKey] || document.documentElement[scrollKey] : scrollParent[scrollKey];
	      var max = this.getScrollSize() - this.getViewportSize();
	      var scroll = Math.max(0, Math.min(actual, max));
	      var el = findDOMNode(this);
	      return this.getOffset(scrollParent) + scroll - this.getOffset(el);
	    }
	  }, {
	    key: 'setScroll',
	    value: function setScroll(offset) {
	      var scrollParent = this.scrollParent;
	      var axis = this.props.axis;
	
	      offset += this.getOffset(findDOMNode(this));
	      if (scrollParent === window) return window.scrollTo(0, offset);
	
	      offset -= this.getOffset(this.scrollParent);
	      scrollParent[SCROLL_START_KEYS[axis]] = offset;
	    }
	  }, {
	    key: 'getViewportSize',
	    value: function getViewportSize() {
	      var scrollParent = this.scrollParent;
	      var axis = this.props.axis;
	
	      return scrollParent === window ? window[INNER_SIZE_KEYS[axis]] : scrollParent[CLIENT_SIZE_KEYS[axis]];
	    }
	  }, {
	    key: 'getScrollSize',
	    value: function getScrollSize() {
	      var scrollParent = this.scrollParent;
	      var _document = document,
	          body = _document.body,
	          documentElement = _document.documentElement;
	
	      var key = SCROLL_SIZE_KEYS[this.props.axis];
	      return scrollParent === window ? Math.max(body[key], documentElement[key]) : scrollParent[key];
	    }
	  }, {
	    key: 'hasDeterminateSize',
	    value: function hasDeterminateSize() {
	      var _props2 = this.props,
	          itemSizeGetter = _props2.itemSizeGetter,
	          type = _props2.type;
	
	      return type === 'uniform' || itemSizeGetter;
	    }
	  }, {
	    key: 'getStartAndEnd',
	    value: function getStartAndEnd() {
	      var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.threshold;
	
	      var scroll = this.getScroll();
	      var start = Math.max(0, scroll - threshold);
	      var end = scroll + this.getViewportSize() + threshold;
	      if (this.hasDeterminateSize()) {
	        end = Math.min(end, this.getSpaceBefore(this.props.length));
	      }
	      return { start: start, end: end };
	    }
	  }, {
	    key: 'getItemSizeAndItemsPerRow',
	    value: function getItemSizeAndItemsPerRow() {
	      var _props3 = this.props,
	          axis = _props3.axis,
	          useStaticSize = _props3.useStaticSize;
	      var _state2 = this.state,
	          itemSize = _state2.itemSize,
	          itemsPerRow = _state2.itemsPerRow;
	
	      if (useStaticSize && itemSize && itemsPerRow) {
	        return { itemSize: itemSize, itemsPerRow: itemsPerRow };
	      }
	
	      var itemEls = findDOMNode(this.items).children;
	      if (!itemEls.length) return {};
	
	      var firstEl = itemEls[0];
	
	      // Firefox has a problem where it will return a *slightly* (less than
	      // thousandths of a pixel) different size for the same element between
	      // renders. This can cause an infinite render loop, so only change the
	      // itemSize when it is significantly different.
	      var firstElSize = firstEl[OFFSET_SIZE_KEYS[axis]];
	      var delta = Math.abs(firstElSize - itemSize);
	      if (isNaN(delta) || delta >= 1) itemSize = firstElSize;
	
	      if (!itemSize) return {};
	
	      var startKey = OFFSET_START_KEYS[axis];
	      var firstStart = firstEl[startKey];
	      itemsPerRow = 1;
	      for (var item = itemEls[itemsPerRow]; item && item[startKey] === firstStart; item = itemEls[itemsPerRow]) {
	        ++itemsPerRow;
	      }return { itemSize: itemSize, itemsPerRow: itemsPerRow };
	    }
	  }, {
	    key: 'updateFrame',
	    value: function updateFrame(cb) {
	      this.updateScrollParent();
	      if (typeof cb != 'function') cb = NOOP;
	      switch (this.props.type) {
	        case 'simple':
	          return this.updateSimpleFrame(cb);
	        case 'variable':
	          return this.updateVariableFrame(cb);
	        case 'uniform':
	          return this.updateUniformFrame(cb);
	      }
	    }
	  }, {
	    key: 'updateScrollParent',
	    value: function updateScrollParent() {
	      var prev = this.scrollParent;
	      this.scrollParent = this.getScrollParent();
	      if (prev === this.scrollParent) return;
	      if (prev) {
	        prev.removeEventListener('scroll', this.updateFrame);
	        prev.removeEventListener('mousewheel', NOOP);
	      }
	      this.scrollParent.addEventListener('scroll', this.updateFrame, PASSIVE);
	      this.scrollParent.addEventListener('mousewheel', NOOP, PASSIVE);
	    }
	  }, {
	    key: 'updateSimpleFrame',
	    value: function updateSimpleFrame(cb) {
	      var _getStartAndEnd = this.getStartAndEnd(),
	          end = _getStartAndEnd.end;
	
	      var itemEls = findDOMNode(this.items).children;
	      var elEnd = 0;
	
	      if (itemEls.length) {
	        var axis = this.props.axis;
	
	        var firstItemEl = itemEls[0];
	        var lastItemEl = itemEls[itemEls.length - 1];
	        elEnd = this.getOffset(lastItemEl) + lastItemEl[OFFSET_SIZE_KEYS[axis]] - this.getOffset(firstItemEl);
	      }
	
	      if (elEnd > end) return cb();
	
	      var _props4 = this.props,
	          pageSize = _props4.pageSize,
	          length = _props4.length;
	
	      var size = Math.min(this.state.size + pageSize, length);
	      this.maybeSetState({ size: size }, cb);
	    }
	  }, {
	    key: 'updateVariableFrame',
	    value: function updateVariableFrame(cb) {
	      if (!this.props.itemSizeGetter) this.cacheSizes();
	
	      var _getStartAndEnd2 = this.getStartAndEnd(),
	          start = _getStartAndEnd2.start,
	          end = _getStartAndEnd2.end;
	
	      var _props5 = this.props,
	          length = _props5.length,
	          pageSize = _props5.pageSize;
	
	      var space = 0;
	      var from = 0;
	      var size = 0;
	      var maxFrom = length - 1;
	
	      while (from < maxFrom) {
	        var itemSize = this.getSizeOf(from);
	        if (itemSize == null || space + itemSize > start) break;
	        space += itemSize;
	        ++from;
	      }
	
	      var maxSize = length - from;
	
	      while (size < maxSize && space < end) {
	        var _itemSize = this.getSizeOf(from + size);
	        if (_itemSize == null) {
	          size = Math.min(size + pageSize, maxSize);
	          break;
	        }
	        space += _itemSize;
	        ++size;
	      }
	
	      this.maybeSetState({ from: from, size: size }, cb);
	    }
	  }, {
	    key: 'updateUniformFrame',
	    value: function updateUniformFrame(cb) {
	      var _getItemSizeAndItemsP = this.getItemSizeAndItemsPerRow(),
	          itemSize = _getItemSizeAndItemsP.itemSize,
	          itemsPerRow = _getItemSizeAndItemsP.itemsPerRow;
	
	      if (!itemSize || !itemsPerRow) return cb();
	
	      var _getStartAndEnd3 = this.getStartAndEnd(),
	          start = _getStartAndEnd3.start,
	          end = _getStartAndEnd3.end;
	
	      var _constrain = this.constrain(Math.floor(start / itemSize) * itemsPerRow, (Math.ceil((end - start) / itemSize) + 1) * itemsPerRow, itemsPerRow, this.props),
	          from = _constrain.from,
	          size = _constrain.size;
	
	      return this.maybeSetState({ itemsPerRow: itemsPerRow, from: from, itemSize: itemSize, size: size }, cb);
	    }
	  }, {
	    key: 'getSpaceBefore',
	    value: function getSpaceBefore(index) {
	      var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (cache[index] != null) return cache[index];
	
	      // Try the static itemSize.
	      var _state3 = this.state,
	          itemSize = _state3.itemSize,
	          itemsPerRow = _state3.itemsPerRow;
	
	      if (itemSize) {
	        return cache[index] = Math.floor(index / itemsPerRow) * itemSize;
	      }
	
	      // Find the closest space to index there is a cached value for.
	      var from = index;
	      while (from > 0 && cache[--from] == null) {}
	
	      // Finally, accumulate sizes of items from - index.
	      var space = cache[from] || 0;
	      for (var i = from; i < index; ++i) {
	        cache[i] = space;
	        var _itemSize2 = this.getSizeOf(i);
	        if (_itemSize2 == null) break;
	        space += _itemSize2;
	      }
	
	      return cache[index] = space;
	    }
	  }, {
	    key: 'cacheSizes',
	    value: function cacheSizes() {
	      var cache = this.cache;
	      var from = this.state.from;
	
	      var itemEls = findDOMNode(this.items).children;
	      var sizeKey = OFFSET_SIZE_KEYS[this.props.axis];
	      for (var i = 0, l = itemEls.length; i < l; ++i) {
	        cache[from + i] = itemEls[i][sizeKey];
	      }
	    }
	  }, {
	    key: 'getSizeOf',
	    value: function getSizeOf(index) {
	      var cache = this.cache,
	          items = this.items;
	      var _props6 = this.props,
	          axis = _props6.axis,
	          itemSizeGetter = _props6.itemSizeGetter,
	          itemSizeEstimator = _props6.itemSizeEstimator,
	          type = _props6.type;
	      var _state4 = this.state,
	          from = _state4.from,
	          itemSize = _state4.itemSize,
	          size = _state4.size;
	
	      // Try the static itemSize.
	
	      if (itemSize) return itemSize;
	
	      // Try the itemSizeGetter.
	      if (itemSizeGetter) return itemSizeGetter(index);
	
	      // Try the cache.
	      if (index in cache) return cache[index];
	
	      // Try the DOM.
	      if (type === 'simple' && index >= from && index < from + size && items) {
	        var itemEl = findDOMNode(items).children[index - from];
	        if (itemEl) return itemEl[OFFSET_SIZE_KEYS[axis]];
	      }
	
	      // Try the itemSizeEstimator.
	      if (itemSizeEstimator) return itemSizeEstimator(index, cache);
	    }
	  }, {
	    key: 'constrain',
	    value: function constrain(from, size, itemsPerRow, _ref) {
	      var length = _ref.length,
	          type = _ref.type;
	
	      if (type === 'uniform') size = Math.max(size, 1);
	      var mod = size % itemsPerRow;
	      if (mod) size += itemsPerRow - mod;
	      if (size > length) size = length;
	      from = type === 'simple' || !from ? 0 : Math.max(Math.min(from, length - size), 0);
	
	      if (mod = from % itemsPerRow) {
	        from -= mod;
	        size += mod;
	      }
	
	      return { from: from, size: size };
	    }
	  }, {
	    key: 'scrollTo',
	    value: function scrollTo(index) {
	      if (index != null) this.setScroll(this.getSpaceBefore(index));
	    }
	  }, {
	    key: 'scrollAround',
	    value: function scrollAround(index) {
	      var current = this.getScroll();
	      var bottom = this.getSpaceBefore(index);
	      var top = bottom - this.getViewportSize() + this.getSizeOf(index);
	      var min = Math.min(top, bottom);
	      var max = Math.max(top, bottom);
	      if (current <= min) return this.setScroll(min);
	      if (current > max) return this.setScroll(max);
	    }
	  }, {
	    key: 'getVisibleRange',
	    value: function getVisibleRange() {
	      var _state5 = this.state,
	          from = _state5.from,
	          size = _state5.size;
	
	      var _getStartAndEnd4 = this.getStartAndEnd(0),
	          start = _getStartAndEnd4.start,
	          end = _getStartAndEnd4.end;
	
	      var cache = {};
	      var first = void 0,
	          last = void 0;
	      for (var i = from; i < from + size; ++i) {
	        var itemStart = this.getSpaceBefore(i, cache);
	        var itemEnd = itemStart + this.getSizeOf(i);
	        if (first == null && itemEnd > start) first = i;
	        if (first != null && itemStart < end) last = i;
	      }
	      return [first, last];
	    }
	  }, {
	    key: 'renderItems',
	    value: function renderItems() {
	      var _this3 = this;
	
	      var _props7 = this.props,
	          itemRenderer = _props7.itemRenderer,
	          itemsRenderer = _props7.itemsRenderer;
	      var _state6 = this.state,
	          from = _state6.from,
	          size = _state6.size;
	
	      var items = [];
	      for (var i = 0; i < size; ++i) {
	        items.push(itemRenderer(from + i, i));
	      }return itemsRenderer(items, function (c) {
	        return _this3.items = c;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props8 = this.props,
	          axis = _props8.axis,
	          length = _props8.length,
	          type = _props8.type,
	          useTranslate3d = _props8.useTranslate3d;
	      var _state7 = this.state,
	          from = _state7.from,
	          itemsPerRow = _state7.itemsPerRow;
	
	
	      var items = this.renderItems();
	      if (type === 'simple') return items;
	
	      var style = { position: 'relative' };
	      var cache = {};
	      var bottom = Math.ceil(length / itemsPerRow) * itemsPerRow;
	      var size = this.getSpaceBefore(bottom, cache);
	      if (size) {
	        style[SIZE_KEYS[axis]] = size;
	        if (axis === 'x') style.overflowX = 'hidden';
	      }
	      var offset = this.getSpaceBefore(from, cache);
	      var x = axis === 'x' ? offset : 0;
	      var y = axis === 'y' ? offset : 0;
	      var transform = useTranslate3d ? 'translate3d(' + x + 'px, ' + y + 'px, 0)' : 'translate(' + x + 'px, ' + y + 'px)';
	      var listStyle = {
	        msTransform: transform,
	        WebkitTransform: transform,
	        transform: transform
	      };
	      return _react2.default.createElement(
	        'div',
	        { style: style },
	        _react2.default.createElement(
	          'div',
	          { style: listStyle },
	          items
	        )
	      );
	    }
	  }]);
	
	  return ReactList;
	}(_react.Component);
	
	ReactList.displayName = 'ReactList';
	ReactList.defaultProps = {
	  axis: 'y',
	  itemRenderer: function itemRenderer(index, key) {
	    return _react2.default.createElement(
	      'div',
	      { key: key },
	      index
	    );
	  },
	  itemsRenderer: function itemsRenderer(items, ref) {
	    return _react2.default.createElement(
	      'div',
	      { ref: ref, className: 'flex-fix' },
	      items
	    );
	  },
	  length: 0,
	  pageSize: 10,
	  threshold: 100,
	  type: 'simple',
	  useStaticSize: false,
	  useTranslate3d: false
	};
	exports.default = ReactList;

/***/ },
/* 266 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CUSTOMER_LOGIN_ATTEMPT = exports.CUSTOMER_LOGIN_ATTEMPT = 'petdata/CUSTOMER_LOGIN_ATTEMPT';
	var CUSTOMER_LOGIN_SUCCESS = exports.CUSTOMER_LOGIN_SUCCESS = 'petdata/CUSTOMER_LOGIN_SUCCESS';
	var CUSTOMER_LOGIN_FAIL = exports.CUSTOMER_LOGIN_FAIL = 'petdata/CUSTOMER_LOGIN_FAIL';
	var CUSTOMER_LOGOUT = exports.CUSTOMER_LOGOUT = 'petdata/CUSTOMER_LOGOUT';
	
	var CUSTOMER_CONTEXT_RECEIVED = exports.CUSTOMER_CONTEXT_RECEIVED = 'petdata/CUSTOMER_CONTEXT_RECEIVED';
	
	var TOKEN_LOGIN_SUCCESS = exports.TOKEN_LOGIN_SUCCESS = 'petdata/TOKEN_LOGIN_SUCCESS';
	
	var SET_ACTIVE_SUBSCRIPTION = exports.SET_ACTIVE_SUBSCRIPTION = 'petdata/SET_ACTIVE_SUBSCRIPTION';
	
	var UPDATE_LABEL_STYLES = exports.UPDATE_LABEL_STYLES = 'petdata/UPDATE_LABEL_STYLES';
	var UPDATE_LABEL_LOGOS = exports.UPDATE_LABEL_LOGOS = 'petdata/UPDATE_LABEL_LOGOS';
	var UPDATE_LABEL_OFFSET = exports.UPDATE_LABEL_OFFSET = 'petdata/UPDATE_LABEL_OFFSET';
	
	var PASSWORD_CHANGE_SUCCESS = exports.PASSWORD_CHANGE_SUCCESS = 'petdata/PASSWORD_CHANGE_SUCCESS';
	var FORGOT_PASSWORD_SENT = exports.FORGOT_PASSWORD_SENT = 'petdata/FORGOT_PASSWORD_SENT';
	
	var SHOW_ERROR_MODAL = exports.SHOW_ERROR_MODAL = 'petdata/SHOW_ERROR_MODAL';
	
	var SHOW_DEMO_MODAL = exports.SHOW_DEMO_MODAL = 'petdata/SHOW_DEMO_MODAL';
	var HIDE_DEMO_MODAL = exports.HIDE_DEMO_MODAL = 'petdata/HIDE_DEMO_MODAL';

/***/ },
/* 267 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NAME = exports.NAME = 'account';

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getIsEnglish = exports.getLabelTitleOrder = exports.getUseUSMetrics = exports.getUsePLUCode = exports.getIsPaperSizeLetter = exports.hasManualBilling = exports.getActivePageOffset = exports.getActiveLogos = exports.getActiveStyles = exports.getActiveExcelKey = exports.isCareSheetsSupported = exports.getActivePermissions = exports.getActiveSubscriptionName = exports.getActiveSubscription = exports.getManagementLink = exports.hasMultipleSubscriptions = exports.getActiveSubscriptionId = exports.getSubscriptions = exports.isDemoUser = exports.isMasterUser = exports.isContextLoaded = exports.isDemoModalOpen = exports.isAttemptingLogin = exports.getFullName = exports.getUserName = undefined;
	
	var _reselect = __webpack_require__(537);
	
	var _thenby = __webpack_require__(91);
	
	var _thenby2 = _interopRequireDefault(_thenby);
	
	var _constants = __webpack_require__(267);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getUserName = exports.getUserName = function getUserName(state) {
		return state[_constants.NAME].credentials.userName;
	};
	var getFullName = exports.getFullName = function getFullName(state) {
		return state[_constants.NAME].credentials.fullName;
	};
	var isAttemptingLogin = exports.isAttemptingLogin = function isAttemptingLogin(state) {
		return state[_constants.NAME].attemptingLogin;
	};
	var isDemoModalOpen = exports.isDemoModalOpen = function isDemoModalOpen(state) {
		return state[_constants.NAME].showDemoModal;
	};
	var isContextLoaded = exports.isContextLoaded = function isContextLoaded(state) {
		return state[_constants.NAME].contextLoaded;
	};
	var isMasterUser = exports.isMasterUser = function isMasterUser(state) {
		return state[_constants.NAME].credentials.isMasterUser;
	};
	var isDemoUser = exports.isDemoUser = function isDemoUser(state) {
		return state[_constants.NAME].credentials.isDemoUser;
	};
	
	var getSubscriptions = exports.getSubscriptions = function getSubscriptions(state) {
		return state[_constants.NAME].subscriptions.sort((0, _thenby2.default)(function (v1) {
			return v1.id === state[_constants.NAME].activeSubscriptionId ? 0 : 10;
		}).thenBy("name"));
	};
	var getActiveSubscriptionId = exports.getActiveSubscriptionId = function getActiveSubscriptionId(state) {
		return state[_constants.NAME].activeSubscriptionId;
	};
	var hasMultipleSubscriptions = exports.hasMultipleSubscriptions = function hasMultipleSubscriptions(state) {
		return state[_constants.NAME].subscriptions.length > 1 ? true : false;
	};
	
	var getManagementLink = exports.getManagementLink = function getManagementLink(state) {
		return state[_constants.NAME].managementLink;
	};
	
	var getActiveSubscription = exports.getActiveSubscription = (0, _reselect.createSelector)(getSubscriptions, getActiveSubscriptionId, function (subscriptionList, activeSubscription) {
		return subscriptionList.find(function (subscription) {
			return subscription.id === activeSubscription;
		});
	});
	
	var getActiveSubscriptionName = exports.getActiveSubscriptionName = (0, _reselect.createSelector)(getActiveSubscription, function (activeSubscription) {
		return activeSubscription !== undefined ? activeSubscription.name : '';
	});
	
	var getActivePermissions = exports.getActivePermissions = (0, _reselect.createSelector)(getActiveSubscription, function (activeSubscription) {
		return activeSubscription !== undefined ? activeSubscription.permissions : [];
	});
	
	var isCareSheetsSupported = exports.isCareSheetsSupported = (0, _reselect.createSelector)(getActiveSubscription, function (activeSubscription) {
	
		if (activeSubscription !== undefined) {
			return activeSubscription.supportsCareSheets;
		}
	
		return false;
	});
	
	var getActiveExcelKey = exports.getActiveExcelKey = (0, _reselect.createSelector)(getActiveSubscription, function (activeSubscription) {
		return activeSubscription !== undefined ? activeSubscription.excelKey : 0;
	});
	
	var getActiveStyles = exports.getActiveStyles = (0, _reselect.createSelector)(getActiveSubscription, function (activeSubscription) {
		return activeSubscription !== undefined ? activeSubscription.styles : {};
	});
	
	var getActiveLogos = exports.getActiveLogos = (0, _reselect.createSelector)(getActiveSubscription, function (activeSubscription) {
		return activeSubscription !== undefined ? activeSubscription.logos : {};
	});
	
	var getActivePageOffset = exports.getActivePageOffset = (0, _reselect.createSelector)(getActiveSubscription, function (activeSubscription) {
		return activeSubscription !== undefined ? activeSubscription.pageOffset : {};
	});
	
	var hasManualBilling = exports.hasManualBilling = (0, _reselect.createSelector)(getActiveSubscription, function (activeSubscription) {
		return activeSubscription !== undefined ? activeSubscription.manualBilling : false;
	});
	
	var getIsPaperSizeLetter = exports.getIsPaperSizeLetter = (0, _reselect.createSelector)(getActiveSubscription, function (activeSubscription) {
		return activeSubscription !== undefined ? activeSubscription.isPaperSizeLetter : false;
	});
	
	var getUsePLUCode = exports.getUsePLUCode = (0, _reselect.createSelector)(getActiveSubscription, function (activeSubscription) {
		return activeSubscription !== undefined ? activeSubscription.usePLUCode : true;
	});
	
	var getUseUSMetrics = exports.getUseUSMetrics = (0, _reselect.createSelector)(getActiveSubscription, function (activeSubscription) {
		return activeSubscription !== undefined ? activeSubscription.useUSMetrics : true;
	});
	
	var getLabelTitleOrder = exports.getLabelTitleOrder = (0, _reselect.createSelector)(getActiveSubscription, function (activeSubscription) {
		return activeSubscription !== undefined ? activeSubscription.labelTitleOrder : 0;
	});
	
	var getIsEnglish = exports.getIsEnglish = (0, _reselect.createSelector)(getActiveSubscription, function (activeSubscription) {
		return activeSubscription !== undefined && activeSubscription.language !== "German" ? true : false;
	});

/***/ },
/* 269 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_GRID_SORTING = exports.SET_GRID_SORTING = 'petdata/SET_GRID_SORTING';
	var SET_LABEL_INDEX = exports.SET_LABEL_INDEX = 'petdata/SET_LABEL_INDEX';
	
	var SELECT_LABEL = exports.SELECT_LABEL = 'petdata/SELECT_LABEL';
	
	var GET_LABEL_PET_LIST = exports.GET_LABEL_PET_LIST = 'petdata/GET_LABEL_PET_LIST';
	var PET_LABEL_LIST_RECEIVED = exports.PET_LABEL_LIST_RECEIVED = 'petdata/PET_LABEL_LIST_RECEIVED';
	var PET_LABEL_LIST_RELOAD = exports.PET_LABEL_LIST_RELOAD = 'petdata/PET_LABEL_LIST_RELOAD';
	var PET_LABEL_PRICE_UPDATE = exports.PET_LABEL_PRICE_UPDATE = 'petdata/PET_LABEL_PRICE_UPDATE';
	var PET_TYPES_ADDED = exports.PET_TYPES_ADDED = 'petdata/labels/PET_TYPES_ADDED';
	
	var TOGGLE_SELECTED_PET_TYPE = exports.TOGGLE_SELECTED_PET_TYPE = 'petdata/labels/TOGGLE_SELECTED_PET_TYPE';
	
	var LABELS_SEARCH_PHRASE = exports.LABELS_SEARCH_PHRASE = 'petdata/LABELS_SEARCH_PHRASE';
	var FILTER_PET_LABELS = exports.FILTER_PET_LABELS = 'petdata/FILTER_PET_LABELS';
	
	var CLEAR_SEARCH_RESULTS = exports.CLEAR_SEARCH_RESULTS = 'petdata/labels/CLEAR_SEARCH_RESULTS';
	
	var GET_PET_LABEL = exports.GET_PET_LABEL = 'petdata/GET_PET_LABEL';
	var PET_LABEL_RECEIVED = exports.PET_LABEL_RECEIVED = 'petdata/PET_LABEL_RECEIVED';
	var SELECT_PET_LABEL = exports.SELECT_PET_LABEL = 'petdata/SELECT_PET_LABEL';
	var DESELECT_PET_LABEL = exports.DESELECT_PET_LABEL = 'petdata/DESELECT_PET_LABEL';
	var CLEAR_ACTIVE_LABEL = exports.CLEAR_ACTIVE_LABEL = 'petdata/CLEAR_ACTIVE_LABEL';
	
	var GET_LABEL_DEFINITIONS = exports.GET_LABEL_DEFINITIONS = 'petdata/GET_LABEL_DEFINITIONS';
	var LABEL_DEFINITIONS_RECEIVED = exports.LABEL_DEFINITIONS_RECEIVED = 'petdata/LABEL_DEFINITIONS_RECEIVED';
	
	var SELECT_LABEL_SIZE = exports.SELECT_LABEL_SIZE = 'petdata/SELECT_LABEL_SIZE';
	
	var SAVE_LABEL_TO_SHEET = exports.SAVE_LABEL_TO_SHEET = 'petdata/SAVE_LABEL_TO_SHEET';
	var DELETE_LABEL_FROM_SHEET = exports.DELETE_LABEL_FROM_SHEET = 'petdata/DELETE_LABEL_FROM_SHEET';
	
	var CLEAR_LABEL_SHEET = exports.CLEAR_LABEL_SHEET = 'petdata/CLEAR_LABEL_SHEET';
	
	var TOGGLE_PLU_ACTIVE = exports.TOGGLE_PLU_ACTIVE = 'petdata/TOGGLE_PLU_ACTIVE';
	
	var EDIT_EXISTING_LABEL = exports.EDIT_EXISTING_LABEL = 'petdata/EDIT_EXISTING_LABEL';
	
	var GET_CUSTOM_DEFINITIONS = exports.GET_CUSTOM_DEFINITIONS = 'petdata/GET_CUSTOM_DEFINITIONS';
	var CUSTOM_DEFINITIONS_RECEIVED = exports.CUSTOM_DEFINITIONS_RECEIVED = 'petdata/CUSTOM_DEFINITIONS_RECEIVED';
	var SELECT_CUSTOM_LABEL = exports.SELECT_CUSTOM_LABEL = 'petdata/SELECT_CUSTOM_LABEL';
	
	var GET_ARTICLE_LIST = exports.GET_ARTICLE_LIST = 'petdata/GET_ARTICLE_LIST';
	var ARTICLE_LIST_RECEIVED = exports.ARTICLE_LIST_RECEIVED = 'petdata/ARTICLE_LIST_RECEIVED';
	var UPDATE_LABEL_ARTICLE = exports.UPDATE_LABEL_ARTICLE = 'petdata/UPDATE_LABEL_ARTICLE';
	var SORT_ARTICLE_COLUMN = exports.SORT_ARTICLE_COLUMN = 'petdata/SORT_ARTICLE_COLUMN';
	var CLEAR_ARTICLE_FILTERS = exports.CLEAR_ARTICLE_FILTERS = 'petdata/CLEAR_ARTICLE_FILTERS';
	var ADD_ARTICLE_MAPPING = exports.ADD_ARTICLE_MAPPING = 'petdata/ADD_ARTICLE_MAPPING';
	var DELETE_ARTICLE_MAPPING = exports.DELETE_ARTICLE_MAPPING = 'petdata/DELETE_ARTICLE_MAPPING';
	
	var UPLOAD_EXCEL_MAPPINGS = exports.UPLOAD_EXCEL_MAPPINGS = 'petdata/UPLOAD_EXCEL_MAPPINGS';
	var UPLOAD_MAPPINGS_SUCCESS = exports.UPLOAD_MAPPINGS_SUCCESS = 'petdata/UPLOAD_MAPPINGS_SUCCESS';
	
	var UPDATE_LABEL_STYLES = exports.UPDATE_LABEL_STYLES = 'petdata/UPDATE_LABEL_STYLES';
	var UPDATE_LABEL_LOGOS = exports.UPDATE_LABEL_LOGOS = 'petdata/UPDATE_LABEL_LOGOS';
	var UPDATE_LABEL_OFFSET = exports.UPDATE_LABEL_OFFSET = 'petdata/UPDATE_LABEL_OFFSET';
	
	var CALIBRATION_PDF_LINK = exports.CALIBRATION_PDF_LINK = 'petdata/CALIBRATION_PDF_LINK';
	
	var SHOW_ERROR_MODAL = exports.SHOW_ERROR_MODAL = 'petdata/SHOW_ERROR_MODAL';
	var SHOW_LABEL_MODAL = exports.SHOW_LABEL_MODAL = 'petdata/SHOW_LABEL_MODAL';
	var HIDE_LABEL_MODAL = exports.HIDE_LABEL_MODAL = 'petdata/HIDE_LABEL_MODAL';
	
	var ENABLE_LABEL_ADD = exports.ENABLE_LABEL_ADD = 'petdata/ENABLE_LABEL_ADD';
	var DISABLE_LABEL_ADD = exports.DISABLE_LABEL_ADD = 'petdata/DISABLE_LABEL_ADD';
	var SELECT_NEXT_LABEL = exports.SELECT_NEXT_LABEL = 'petdata/SELECT_NEXT_LABEL';
	
	var ADD_ARTICLE_FILTER = exports.ADD_ARTICLE_FILTER = 'petdata/ADD_ARTICLE_FILTER';

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _BarCodeField = __webpack_require__(126);
	
	var _BarCodeField2 = _interopRequireDefault(_BarCodeField);
	
	var _FormInput = __webpack_require__(49);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormMultiline = __webpack_require__(125);
	
	var _FormMultiline2 = _interopRequireDefault(_FormMultiline);
	
	var _PLUField = __webpack_require__(271);
	
	var _PLUField2 = _interopRequireDefault(_PLUField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement(_BarCodeField2.default, null);
	
	var _ref3 = _react2.default.createElement(_PLUField2.default, null);
	
	var LabelCol2LrgForm = function LabelCol2LrgForm(_ref) {
	  var activePLU = _ref.activePLU,
	      detailFields = _ref.detailFields,
	      handleSubmit = _ref.handleSubmit,
	      logoUrl = _ref.logoUrl,
	      onCancel = _ref.onCancel,
	      petLabel = _ref.petLabel,
	      submitButtonText = _ref.submitButtonText;
	
	  var fields = detailFields.map(function (detailField, index) {
	    var keyName = 'Key' + index;
	    var valueName = 'Value' + index;
	    return _react2.default.createElement(
	      'tr',
	      { key: index },
	      _react2.default.createElement(
	        'td',
	        { className: 'category' },
	        _react2.default.createElement(_reduxForm.Field, { name: keyName,
	          component: _FormInput2.default,
	          type: 'text',
	          className: 'form-control'
	        })
	      ),
	      _react2.default.createElement(
	        'td',
	        { className: 'info' },
	        _react2.default.createElement(_reduxForm.Field, { name: valueName,
	          component: _FormInput2.default,
	          type: 'text',
	          className: 'form-control'
	        })
	      )
	    );
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'row' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-lg-12' },
	      _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	          'div',
	          { className: 'two-col-lrg label-main' },
	          _react2.default.createElement(
	            'div',
	            { className: 'label-title' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'line1',
	              component: _FormInput2.default,
	              type: 'text',
	              className: 'form-control',
	              placeholder: _reactReduxI18n.I18n.t('ENTER_NAME')
	            }),
	            _react2.default.createElement(_reduxForm.Field, { name: 'line2',
	              component: _FormInput2.default,
	              type: 'text',
	              className: 'form-control latin-name',
	              placeholder: _reactReduxI18n.I18n.t('ENTER_LATIN_NAME')
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'label-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'label-footer' },
	              _react2.default.createElement('img', { src: petLabel.ImageUrl }),
	              _react2.default.createElement(
	                'div',
	                { className: 'label-info-left-col' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'price',
	                  component: _FormMultiline2.default,
	                  type: 'text',
	                  rows: '2',
	                  className: 'form-control float-left txt-price',
	                  placeholder: _reactReduxI18n.I18n.t('ENTER_PRICE')
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'label-logo' },
	                  _react2.default.createElement('img', { src: logoUrl })
	                ),
	                _ref2
	              )
	            ),
	            _react2.default.createElement(
	              'table',
	              { className: 'float-left', cellPadding: '0', cellSpacing: '0' },
	              _react2.default.createElement(
	                'tbody',
	                null,
	                fields,
	                activePLU && _ref3
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row no-gutters bottom-buttons' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 text-right' },
	            onCancel !== undefined && _react2.default.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-secondary', onClick: onCancel },
	              _reactReduxI18n.I18n.t('CANCEL')
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'submit', className: 'btn btn-primary' },
	              submitButtonText
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _reduxForm.reduxForm)()(LabelCol2LrgForm);

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _FormInput = __webpack_require__(49);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PLUField = function PLUField() {
	  return _react2.default.createElement(
	    'tr',
	    null,
	    _react2.default.createElement(
	      'td',
	      { className: 'category' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'pluKey',
	        component: _FormInput2.default,
	        type: 'text',
	        className: 'form-control',
	        placeholder: _reactReduxI18n.I18n.t('PLU')
	      })
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'info' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'plu',
	        component: _FormInput2.default,
	        type: 'text',
	        className: 'form-control',
	        placeholder: _reactReduxI18n.I18n.t('ENTER_PLU')
	      })
	    )
	  );
	};
	
	exports.default = PLUField;

/***/ },
/* 272 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NAME = exports.NAME = 'labels';

/***/ },
/* 273 */
[1197, 612, 272, 613],
/* 274 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NAV_BAR_TOGGLE = exports.NAV_BAR_TOGGLE = 'petdata/NAV_BAR_TOGGLE';
	var NAV_BAR_CLOSE = exports.NAV_BAR_CLOSE = 'petdata/NAV_BAR_CLOSE';
	var NAV_BAR_TRANSITIONED = exports.NAV_BAR_TRANSITIONED = 'petdata/NAV_BAR_TRANSITIONED';
	
	var SHOW_SELECT_STORE_MODAL = exports.SHOW_SELECT_STORE_MODAL = 'petdata/SHOW_SELECT_STORE_MODAL';
	var HIDE_SELECT_STORE_MODAL = exports.HIDE_SELECT_STORE_MODAL = 'petdata/HIDE_SELECT_STORE_MODAL';
	
	var SHOW_CHANGE_PASSWORD_MODAL = exports.SHOW_CHANGE_PASSWORD_MODAL = 'petdata/SHOW_CHANGE_PASSWORD_MODAL';
	var HIDE_CHANGE_PASSWORD_MODAL = exports.HIDE_CHANGE_PASSWORD_MODAL = 'petdata/HIDE_CHANGE_PASSWORD_MODAL';
	
	var SHOW_ERROR_MODAL = exports.SHOW_ERROR_MODAL = 'petdata/SHOW_ERROR_MODAL';
	var HIDE_ERROR_MODAL = exports.HIDE_ERROR_MODAL = 'petdata/HIDE_ERROR_MODAL';

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(28);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _userPermissions = __webpack_require__(29);
	
	var permissions = _interopRequireWildcard(_userPermissions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function activeLinkClass(navLocation, link, className) {
	  return className + ' ' + (navLocation === link ? 'active' : '');
	}
	
	var NavIconBar = function NavIconBar(_ref) {
	  var navLocation = _ref.navLocation,
	      onClick = _ref.onClick,
	      userPermissions = _ref.userPermissions;
	
	  var labelAccess = userPermissions.find(function (permission) {
	    return permission === permissions.ACCESS_LABELS;
	  });
	
	  var careSheetAccess = userPermissions.find(function (permission) {
	    return permission === permissions.ACCESS_CARE_SHEETS;
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'center' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'nav flex-xl-column' },
	      labelAccess && _react2.default.createElement(
	        'li',
	        { className: activeLinkClass(navLocation, '/labels', 'nav-labels') },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/labels', onClick: onClick },
	          _reactReduxI18n.I18n.t('LABELS')
	        )
	      ),
	      careSheetAccess && _react2.default.createElement(
	        'li',
	        { className: activeLinkClass(navLocation, '/caresheets', 'nav-care-sheets') },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/caresheets', onClick: onClick },
	          _reactReduxI18n.I18n.t('CARE_SHEETS')
	        )
	      )
	    )
	  );
	};
	
	exports.default = NavIconBar;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouter = __webpack_require__(28);
	
	var _reactstrap = __webpack_require__(56);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _actions = __webpack_require__(127);
	
	var _NavUserInfo = __webpack_require__(617);
	
	var _NavUserInfo2 = _interopRequireDefault(_NavUserInfo);
	
	var _userPermissions = __webpack_require__(29);
	
	var permissions = _interopRequireWildcard(_userPermissions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _customer$selectors = _customer2.default.selectors,
	    hasMultipleSubscriptions = _customer$selectors.hasMultipleSubscriptions,
	    getManagementLink = _customer$selectors.getManagementLink,
	    hasManualBilling = _customer$selectors.hasManualBilling;
	var logout = _customer2.default.actions.logout;
	
	
	function activeLinkClass(location, link) {
	  return location === link ? 'active' : '';
	}
	
	var NavLinkBar = function NavLinkBar(_ref) {
	  var actions = _ref.actions,
	      isMasterUser = _ref.isMasterUser,
	      managementLink = _ref.managementLink,
	      manualBilling = _ref.manualBilling,
	      multipleSubscriptions = _ref.multipleSubscriptions,
	      navLocation = _ref.navLocation,
	      navCollapsed = _ref.navCollapsed,
	      onClick = _ref.onClick,
	      onTransitionComplete = _ref.onTransitionComplete,
	      userPermissions = _ref.userPermissions,
	      isDemoUser = _ref.isDemoUser;
	
	  var navSubClass = 'nav-sub ' + (multipleSubscriptions ? 'multi-store' : '');
	
	  var adsAccess = userPermissions.find(function (permission) {
	    return permission === permissions.MANAGE_CARE_SHEET_ADS;
	  });
	
	  var logoAccess = userPermissions.find(function (permission) {
	    return permission === permissions.MANAGE_LOGO;
	  });
	
	  var articlesAccess = userPermissions.find(function (permission) {
	    return permission === permissions.MANAGE_ARTICLES;
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: navSubClass },
	    _react2.default.createElement(_NavUserInfo2.default, { onClick: onClick, useCollapsedStyle: navCollapsed }),
	    _react2.default.createElement(
	      _reactstrap.Collapse,
	      { className: 'menu-content', isOpen: !navCollapsed, onOpened: onTransitionComplete, onClosed: onTransitionComplete },
	      adsAccess && _react2.default.createElement(
	        'li',
	        { className: activeLinkClass(navLocation, '/ads') },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/ads', onClick: onClick },
	          _reactReduxI18n.I18n.t('ADVERTISING_SPACE')
	        )
	      ),
	      logoAccess && _react2.default.createElement(
	        'li',
	        { className: activeLinkClass(navLocation, '/store') },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/store', onClick: onClick },
	          _reactReduxI18n.I18n.t('STORE_INFO_LOGO')
	        )
	      ),
	      articlesAccess && _react2.default.createElement(
	        'li',
	        { className: activeLinkClass(navLocation, '/articles') },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/articles', onClick: onClick },
	          _reactReduxI18n.I18n.t('ARTICLE_MANAGEMENT')
	        )
	      ),
	      isMasterUser && !isDemoUser && _react2.default.createElement(
	        'li',
	        { className: activeLinkClass(navLocation, '/users') },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/users', onClick: onClick },
	          _reactReduxI18n.I18n.t('USERS')
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { className: 'label-link', onClick: actions.showChangePasswordModal },
	          _reactReduxI18n.I18n.t('CHANGE_PASSWORD')
	        )
	      ),
	      multipleSubscriptions && _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { className: 'label-link', onClick: actions.showSelectStoreModal },
	          _reactReduxI18n.I18n.t('CHANGE_STORE')
	        )
	      ),
	      isMasterUser && !manualBilling && _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: managementLink, target: '_blank' },
	          _reactReduxI18n.I18n.t('MANAGEMENT')
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { onClick: actions.logout },
	          _reactReduxI18n.I18n.t('LOG_OUT')
	        )
	      )
	    )
	  );
	};
	
	function mapStateToProps(state) {
	  return {
	    managementLink: getManagementLink(state),
	    manualBilling: hasManualBilling(state),
	    multipleSubscriptions: hasMultipleSubscriptions(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ logout: logout, showSelectStoreModal: _actions.showSelectStoreModal, showChangePasswordModal: _actions.showChangePasswordModal }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NavLinkBar);

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactstrap = __webpack_require__(56);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _selectors = __webpack_require__(173);
	
	var _actions = __webpack_require__(127);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _actions2 = __webpack_require__(33);
	
	var _SelectStoreButton = __webpack_require__(618);
	
	var _SelectStoreButton2 = _interopRequireDefault(_SelectStoreButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _customer$selectors = _customer2.default.selectors,
	    getSubscriptions = _customer$selectors.getSubscriptions,
	    getActiveSubscriptionId = _customer$selectors.getActiveSubscriptionId;
	//import labels from '../../labels';
	
	var setActiveSubscription = _customer2.default.actions.setActiveSubscription;
	
	var _ref2 = _react2.default.createElement('span', { className: 'lnr lnr-cross', 'aria-hidden': 'true' });
	
	var SelectStoreModal = function SelectStoreModal(_ref) {
	  var actions = _ref.actions,
	      activeSubscriptionId = _ref.activeSubscriptionId,
	      isOpen = _ref.isOpen,
	      subscriptionList = _ref.subscriptionList;
	
	  var setActiveSubscription = function setActiveSubscription(subscriptionId) {
	    actions.setActiveSubscription(subscriptionId);
	    actions.clearLabelSheet();
	    actions.hideSelectStoreModal();
	  };
	
	  var oddRowStores = subscriptionList.map(function (subscription, index) {
	    if (index % 2 === 0) {
	      return _react2.default.createElement(_SelectStoreButton2.default, { key: index, subscription: subscription, active: activeSubscriptionId === subscription.id, onClick: setActiveSubscription });
	    }
	  });
	
	  var evenRowStores = subscriptionList.map(function (subscription, index) {
	    if (index % 2 !== 0) {
	      return _react2.default.createElement(_SelectStoreButton2.default, { key: index, subscription: subscription, active: activeSubscriptionId === subscription.id, onClick: setActiveSubscription });
	    }
	  });
	
	  return _react2.default.createElement(
	    _reactstrap.Modal,
	    { isOpen: isOpen, toggle: actions.hideSelectStoreModal, id: 'modalSelectStore' },
	    _react2.default.createElement(
	      'div',
	      { className: 'modal-header' },
	      _react2.default.createElement(
	        'h4',
	        { className: 'modal-title', id: 'exampleModalLabel' },
	        _reactReduxI18n.I18n.t('SELECT_STORE')
	      ),
	      _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'close', onClick: actions.hideSelectStoreModal },
	        _ref2
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'modal-body' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6' },
	          oddRowStores
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6' },
	          evenRowStores
	        )
	      )
	    )
	  );
	};
	
	function mapStateToProps(state) {
	  return {
	    activeSubscriptionId: getActiveSubscriptionId(state),
	    isOpen: (0, _selectors.isSelectStoreOpen)(state),
	    subscriptionList: getSubscriptions(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ hideSelectStoreModal: _actions.hideSelectStoreModal, setActiveSubscription: setActiveSubscription, clearLabelSheet: _actions2.clearLabelSheet }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SelectStoreModal);

/***/ },
/* 278 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NAME = exports.NAME = 'navbar';

/***/ },
/* 279 */
[1197, 619, 278, 620],
/* 280 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var INITIALIZE_SEARCH = exports.INITIALIZE_SEARCH = 'petdata/INITIALIZE_SEARCH';
	
	var TOGGLE_FILTER_DISPLAY = exports.TOGGLE_FILTER_DISPLAY = 'petdata/TOGGLE_FILTER_DISPLAY';
	
	var SEARCH_INPUT_BLUR = exports.SEARCH_INPUT_BLUR = 'petdata/SEARCH_INPUT_BLUR';
	var SEARCH_INPUT_FOCUS = exports.SEARCH_INPUT_FOCUS = 'petdata/SEARCH_INPUT_FOCUS';
	var SEARCH_INPUT_DIRTY = exports.SEARCH_INPUT_DIRTY = 'petdata/SEARCH_INPUT_DIRTY';

/***/ },
/* 281 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NAME = exports.NAME = 'search';

/***/ },
/* 282 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ALL_USERS_RECEIVED = exports.ALL_USERS_RECEIVED = 'petdata/ALL_USERS_RECEIVED';
	var SET_USER_LIST_DIRTY = exports.SET_USER_LIST_DIRTY = 'petdata/SET_USER_LIST_DIRTY';
	
	var SELECT_USER = exports.SELECT_USER = 'petdata/SELECT_USER';
	var DESELECT_USER = exports.DESELECT_USER = 'petdata/DESELECT_USER';
	
	var REGISTER_USER_ATTEMPT = exports.REGISTER_USER_ATTEMPT = 'petdata/REGISTER_USER_ATTEMPT';
	var REGISTER_USER_SUCCESS = exports.REGISTER_USER_SUCCESS = 'petdata/REGISTER_USER_SUCCESS';
	var REGISTER_USER_FAIL = exports.REGISTER_USER_FAIL = 'petdata/REGISTER_USER_FAIL';
	
	var INITIALIZE_PERMISSION_TABLE = exports.INITIALIZE_PERMISSION_TABLE = 'petdata/INITIALIZE_PERMISSION_TABLE';
	var TOGGLE_USER_PERMISSION = exports.TOGGLE_USER_PERMISSION = 'petdata/TOGGLE_USER_PERMISSION';
	
	var SAVE_USER_ATTEMPT = exports.SAVE_USER_ATTEMPT = 'petdata/SAVE_USER_ATTEMPT';
	var SAVE_USER_SUCCESS = exports.SAVE_USER_SUCCESS = 'petdata/SAVE_USER_SUCCESS';
	var SAVE_USER_FAIL = exports.SAVE_USER_FAIL = 'petdata/SAVE_USER_FAIL';
	
	var USER_PASSWORD_CHANGED = exports.USER_PASSWORD_CHANGED = 'petdata/USER_PASSWORD_CHANGED';
	
	var SHOW_ERROR_MODAL = exports.SHOW_ERROR_MODAL = 'petdata/SHOW_ERROR_MODAL';

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserFormInput = function UserFormInput(_ref) {
	  var input = _ref.input,
	      label = _ref.label,
	      _ref$meta = _ref.meta,
	      error = _ref$meta.error,
	      submitFailed = _ref$meta.submitFailed,
	      type = _ref.type;
	
	  var inputClass = 'form-control';
	  var wrapperClass = 'row';
	  if (error && submitFailed) {
	    inputClass += ' form-control-danger';
	    wrapperClass += ' has-danger';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: wrapperClass },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: input.name, className: 'col-lg-2 col-sm-3 col-form-label' },
	      label
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-lg-10 col-sm-9' },
	      _react2.default.createElement('input', _extends({}, input, {
	        type: type,
	        className: inputClass
	      })),
	      error && submitFailed && _react2.default.createElement(
	        'div',
	        { className: 'form-control-feedback' },
	        error
	      )
	    )
	  );
	};
	
	exports.default = UserFormInput;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _UserPermissionRow = __webpack_require__(633);
	
	var _UserPermissionRow2 = _interopRequireDefault(_UserPermissionRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserPermissionTable = function UserPermissionTable(_ref) {
	  var onTogglePermission = _ref.onTogglePermission,
	      permissionTable = _ref.permissionTable,
	      supportsCareSheet = _ref.supportsCareSheet;
	
	  var subscriptionPermissions = permissionTable.map(function (subscription) {
	    return _react2.default.createElement(_UserPermissionRow2.default, { key: subscription.id, subscription: subscription, onTogglePermission: onTogglePermission, supportsCareSheet: supportsCareSheet });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'row' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-lg-12' },
	      _react2.default.createElement(
	        'h5',
	        { className: 'permissions-title' },
	        _reactReduxI18n.I18n.t('PERMISSIONS')
	      ),
	      _react2.default.createElement(
	        'table',
	        { className: 'table permissions-table table-responsive' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              null,
	              _reactReduxI18n.I18n.t('LOCATION')
	            ),
	            supportsCareSheet && _react2.default.createElement(
	              'th',
	              null,
	              _reactReduxI18n.I18n.t('PRINT_CARE_SHEETS')
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              _reactReduxI18n.I18n.t('PRINT_LABELS')
	            ),
	            supportsCareSheet && _react2.default.createElement(
	              'th',
	              null,
	              _reactReduxI18n.I18n.t('EDIT_AD_SPACE')
	            ),
	            supportsCareSheet && _react2.default.createElement(
	              'th',
	              null,
	              _reactReduxI18n.I18n.t('EDIT_STORE_INFO_LOGO')
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              _reactReduxI18n.I18n.t('ARTICLE_MANAGEMENT')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          subscriptionPermissions
	        )
	      )
	    )
	  );
	};
	
	exports.default = UserPermissionTable;

/***/ },
/* 285 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NAME = exports.NAME = 'users';

/***/ },
/* 286 */
[1196, 128, 637, 285, 638, 129],
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(44);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(27)
	  , toIndex  = __webpack_require__(84)
	  , toLength = __webpack_require__(24);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(94);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(34)
	  , toObject  = __webpack_require__(27)
	  , IObject   = __webpack_require__(109)
	  , toLength  = __webpack_require__(24);
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(34)
	  , isObject   = __webpack_require__(15)
	  , invoke     = __webpack_require__(134)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(22).f
	  , create      = __webpack_require__(79)
	  , redefineAll = __webpack_require__(82)
	  , ctx         = __webpack_require__(59)
	  , anInstance  = __webpack_require__(77)
	  , defined     = __webpack_require__(45)
	  , forOf       = __webpack_require__(94)
	  , $iterDefine = __webpack_require__(185)
	  , step        = __webpack_require__(298)
	  , setSpecies  = __webpack_require__(83)
	  , DESCRIPTORS = __webpack_require__(21)
	  , fastKey     = __webpack_require__(66).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(108)
	  , from    = __webpack_require__(289);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(82)
	  , getWeak           = __webpack_require__(66).getWeak
	  , anObject          = __webpack_require__(7)
	  , isObject          = __webpack_require__(15)
	  , anInstance        = __webpack_require__(77)
	  , forOf             = __webpack_require__(94)
	  , createArrayMethod = __webpack_require__(50)
	  , $has              = __webpack_require__(32)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(21) && !__webpack_require__(13)(function(){
	  return Object.defineProperty(__webpack_require__(177)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(15)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(7);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 298 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 299 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(81)
	  , gOPS     = __webpack_require__(138)
	  , pIE      = __webpack_require__(110)
	  , toObject = __webpack_require__(27)
	  , IObject  = __webpack_require__(109)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(13)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(22)
	  , anObject = __webpack_require__(7)
	  , getKeys  = __webpack_require__(81);
	
	module.exports = __webpack_require__(21) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(38)
	  , gOPN      = __webpack_require__(80).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(32)
	  , toIObject    = __webpack_require__(38)
	  , arrayIndexOf = __webpack_require__(130)(false)
	  , IE_PROTO     = __webpack_require__(190)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(81)
	  , toIObject = __webpack_require__(38)
	  , isEnum    = __webpack_require__(110).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(80)
	  , gOPS     = __webpack_require__(138)
	  , anObject = __webpack_require__(7)
	  , Reflect  = __webpack_require__(10).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(10).parseFloat
	  , $trim       = __webpack_require__(97).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(195) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(10).parseInt
	  , $trim     = __webpack_require__(97).trim
	  , ws        = __webpack_require__(195)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ },
/* 308 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(24)
	  , repeat   = __webpack_require__(194)
	  , defined  = __webpack_require__(45);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(17);

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(292);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(131)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(21) && /./g.flags != 'g')__webpack_require__(22).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(133)
	});

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(292);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(131)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(50)(0)
	  , redefine     = __webpack_require__(36)
	  , meta         = __webpack_require__(66)
	  , assign       = __webpack_require__(300)
	  , weak         = __webpack_require__(294)
	  , isObject     = __webpack_require__(15)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(131)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(39);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 316 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 317 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(143);
	
	var _DOMUtils = __webpack_require__(202);
	
	var _createHistory = __webpack_require__(321);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(98);
	
	var _PathUtils = __webpack_require__(86);
	
	var _ExecutionEnvironment = __webpack_require__(143);
	
	var _DOMUtils = __webpack_require__(202);
	
	var _DOMStateStorage = __webpack_require__(318);
	
	var _createDOMHistory = __webpack_require__(319);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(827);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(86);
	
	var _AsyncUtils = __webpack_require__(846);
	
	var _Actions = __webpack_require__(98);
	
	var _createLocation2 = __webpack_require__(848);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(204);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(203);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(143);
	
	var _PathUtils = __webpack_require__(86);
	
	var _runTransitionHook = __webpack_require__(204);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(203);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(47);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 324 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(888),
	    isArguments = __webpack_require__(153),
	    isArray = __webpack_require__(31),
	    isBuffer = __webpack_require__(154),
	    isIndex = __webpack_require__(215),
	    isTypedArray = __webpack_require__(222);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 326 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(150),
	    eq = __webpack_require__(115);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(150),
	    eq = __webpack_require__(115);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(209),
	    createBaseEach = __webpack_require__(902);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(903);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(337),
	    toKey = __webpack_require__(114);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(208),
	    isArray = __webpack_require__(31);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(329),
	    isArrayLike = __webpack_require__(89);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(116),
	    overRest = __webpack_require__(937),
	    setToString = __webpack_require__(940);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 335 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(116);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(31),
	    isKey = __webpack_require__(216),
	    stringToPath = __webpack_require__(353),
	    toString = __webpack_require__(360);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(47);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)(module)))

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(211);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(88);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(858),
	    arraySome = __webpack_require__(864),
	    cacheHas = __webpack_require__(890);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 342 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(332),
	    getSymbols = __webpack_require__(214),
	    keys = __webpack_require__(101);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(208),
	    getPrototype = __webpack_require__(213),
	    getSymbols = __webpack_require__(214),
	    stubArray = __webpack_require__(358);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(854),
	    Map = __webpack_require__(206),
	    Promise = __webpack_require__(856),
	    Set = __webpack_require__(857),
	    WeakMap = __webpack_require__(859),
	    baseGetTag = __webpack_require__(87),
	    toSource = __webpack_require__(354);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(868),
	    getPrototype = __webpack_require__(213),
	    isPrototype = __webpack_require__(217);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(115),
	    isArrayLike = __webpack_require__(89),
	    isIndex = __webpack_require__(215),
	    isObject = __webpack_require__(43);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 349 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 350 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 351 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 352 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(932);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 354 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43),
	    now = __webpack_require__(959),
	    toNumber = __webpack_require__(359);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(210);
	
	/**
	 * This method is like `_.isEqual` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	 * are handled by the method instead. The `customizer` is invoked with up to
	 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, othValue) {
	 *   if (isGreeting(objValue) && isGreeting(othValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqualWith(array, other, customizer);
	 * // => true
	 */
	function isEqualWith(value, other, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	}
	
	module.exports = isEqualWith;


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(150),
	    baseForOwn = __webpack_require__(209),
	    baseIteratee = __webpack_require__(112);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 358 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43),
	    isSymbol = __webpack_require__(100);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(889);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.materialColors = factory();
	  }
	})(this, function() {
	  return {"red":{"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"},"pink":{"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"},"purple":{"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"},"deepPurple":{"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"},"indigo":{"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"},"blue":{"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"},"lightBlue":{"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"},"cyan":{"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"},"teal":{"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"},"green":{"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"},"lightGreen":{"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"},"lime":{"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"},"yellow":{"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"},"amber":{"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"},"orange":{"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"},"deepOrange":{"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"},"brown":{"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"},"grey":{"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"},"blueGrey":{"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"},"darkText":{"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"},"lightText":{"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"},"darkIcons":{"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"},"lightIcons":{"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"},"white":"#ffffff","black":"#000000"};
	});


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 477 */
/***/ function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	module.exports = {
	    'default': 'RFC3986',
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return value;
	        }
	    },
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};


/***/ },
/* 478 */
/***/ function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	exports.arrayToObject = function (source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	exports.merge = function (target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (typeof target === 'object') {
	            target[source] = true;
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = exports.arrayToObject(target, options);
	    }
	
	    if (Array.isArray(target) && Array.isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                if (target[i] && typeof target[i] === 'object') {
	                    target[i] = exports.merge(target[i], item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (Object.prototype.hasOwnProperty.call(acc, key)) {
	            acc[key] = exports.merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	exports.decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	exports.encode = function (str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D || // -
	            c === 0x2E || // .
	            c === 0x5F || // _
	            c === 0x7E || // ~
	            (c >= 0x30 && c <= 0x39) || // 0-9
	            (c >= 0x41 && c <= 0x5A) || // a-z
	            (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)] + hexTable[0x80 | ((c >> 12) & 0x3F)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	exports.compact = function (obj, references) {
	    if (typeof obj !== 'object' || obj === null) {
	        return obj;
	    }
	
	    var refs = references || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0; i < obj.length; ++i) {
	            if (obj[i] && typeof obj[i] === 'object') {
	                compacted.push(exports.compact(obj[i], refs));
	            } else if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    keys.forEach(function (key) {
	        obj[key] = exports.compact(obj[key], refs);
	    });
	
	    return obj;
	};
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	exports.isBuffer = function (obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Checkboard = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _checkboard = __webpack_require__(1017);
	
	var checkboard = _interopRequireWildcard(_checkboard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Checkboard = exports.Checkboard = function Checkboard(_ref) {
	  var white = _ref.white,
	      grey = _ref.grey,
	      size = _ref.size,
	      renderers = _ref.renderers,
	      borderRadius = _ref.borderRadius,
	      boxShadow = _ref.boxShadow;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      grid: {
	        borderRadius: borderRadius,
	        boxShadow: boxShadow,
	        absolute: '0px 0px 0px 0px',
	        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.grid });
	};
	
	Checkboard.defaultProps = {
	  size: 8,
	  white: 'transparent',
	  grey: 'rgba(0,0,0,.08)',
	  renderers: {}
	};
	
	exports.default = Checkboard;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorWrap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _debounce = __webpack_require__(355);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _color = __webpack_require__(62);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
	  var ColorPicker = function (_ref) {
	    _inherits(ColorPicker, _ref);
	
	    function ColorPicker(props) {
	      _classCallCheck(this, ColorPicker);
	
	      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
	
	      _this.handleChange = function (data, event) {
	        var isValidColor = _color2.default.simpleCheckForValidColor(data);
	        if (isValidColor) {
	          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
	          _this.setState(colors);
	          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
	          _this.props.onChange && _this.props.onChange(colors, event);
	        }
	      };
	
	      _this.state = _extends({}, _color2.default.toState(props.color, 0));
	
	      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
	        fn(data, event);
	      }, 100);
	      return _this;
	    }
	
	    _createClass(ColorPicker, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        this.setState(_extends({}, _color2.default.toState(nextProps.color, this.state.oldHue)));
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, { onChange: this.handleChange }));
	      }
	    }]);
	
	    return ColorPicker;
	  }(_react.PureComponent || _react.Component);
	
	  ColorPicker.defaultProps = {
	    color: {
	      h: 250,
	      s: 0.50,
	      l: 0.20,
	      a: 1
	    }
	  };
	
	  return ColorPicker;
	};
	
	exports.default = ColorWrap;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1028);

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setLocale = exports.SET_LOCALE = exports.loadTranslations = exports.LOAD_TRANSLATIONS = undefined;
	
	var _index = __webpack_require__(4);
	
	var LOAD_TRANSLATIONS = exports.LOAD_TRANSLATIONS = 'loadTranslation';
	var loadTranslations = exports.loadTranslations = function loadTranslations(translations) {
	  return function (dispatch) {
	    _index.I18n.forceComponentsUpdate();
	    dispatch({
	      type: LOAD_TRANSLATIONS,
	      translations: translations
	    });
	  };
	};
	
	var SET_LOCALE = exports.SET_LOCALE = 'setLocal';
	var setLocale = exports.setLocale = function setLocale(locale) {
	  return function (dispatch) {
	    _index.I18n.forceComponentsUpdate();
	    dispatch({
	      type: SET_LOCALE,
	      locale: locale
	    });
	  };
	};

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	exports["default"] = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },
/* 484 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that you can use this stack
	    // to find the callsite that caused this warning to fire.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 485 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 486 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	
	  var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var type = _ref.type;
	  var payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(228);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(72);
	
	var _PatternUtils = __webpack_require__(102);
	
	var _InternalPropTypes = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(159);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(144);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(322);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(849);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(493);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(159);
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(144);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(322);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.arrayMove = exports.sortableHandle = exports.sortableElement = exports.sortableContainer = exports.SortableHandle = exports.SortableElement = exports.SortableContainer = undefined;
	
	var _utils = __webpack_require__(160);
	
	Object.defineProperty(exports, 'arrayMove', {
	  enumerable: true,
	  get: function get() {
	    return _utils.arrayMove;
	  }
	});
	
	var _SortableContainer2 = __webpack_require__(1064);
	
	var _SortableContainer3 = _interopRequireDefault(_SortableContainer2);
	
	var _SortableElement2 = __webpack_require__(1065);
	
	var _SortableElement3 = _interopRequireDefault(_SortableElement2);
	
	var _SortableHandle2 = __webpack_require__(1066);
	
	var _SortableHandle3 = _interopRequireDefault(_SortableHandle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SortableContainer = _SortableContainer3.default;
	exports.SortableElement = _SortableElement3.default;
	exports.SortableHandle = _SortableHandle3.default;
	exports.sortableContainer = _SortableContainer3.default;
	exports.sortableElement = _SortableElement3.default;
	exports.sortableHandle = _SortableHandle3.default;

/***/ },
/* 495 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(16);
	
	var PooledClass = __webpack_require__(73);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	_assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  checkpoint: function () {
	    return this._callbacks ? this._callbacks.length : 0;
	  },
	
	  rollback: function (len) {
	    if (this._callbacks) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(104);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactInstrumentation = __webpack_require__(48);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1128);
	var warning = __webpack_require__(11);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(73);
	var ReactElement = __webpack_require__(54);
	
	var emptyFunction = __webpack_require__(39);
	var traverseAllChildren = __webpack_require__(251);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(16);
	
	var ReactComponent = __webpack_require__(236);
	var ReactElement = __webpack_require__(54);
	var ReactPropTypeLocations = __webpack_require__(242);
	var ReactPropTypeLocationNames = __webpack_require__(241);
	var ReactNoopUpdateQueue = __webpack_require__(240);
	
	var emptyObject = __webpack_require__(111);
	var invariant = __webpack_require__(6);
	var keyMirror = __webpack_require__(141);
	var keyOf = __webpack_require__(69);
	var warning = __webpack_require__(11);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactDefaultInjection = __webpack_require__(1095);
	var ReactMount = __webpack_require__(507);
	var ReactReconciler = __webpack_require__(106);
	var ReactUpdates = __webpack_require__(55);
	var ReactVersion = __webpack_require__(512);
	
	var findDOMNode = __webpack_require__(1125);
	var getHostComponentFromComposite = __webpack_require__(518);
	var renderSubtreeIntoContainer = __webpack_require__(1129);
	var warning = __webpack_require__(11);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 501 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentFlags
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var DisabledInputUtils = __webpack_require__(161);
	var LinkedValueUtils = __webpack_require__(235);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(55);
	
	var warning = __webpack_require__(11);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 503 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 504 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactFeatureFlags
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactHostComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(16);
	
	var invariant = __webpack_require__(6);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1090);
	
	var containsNode = __webpack_require__(835);
	var focusNode = __webpack_require__(316);
	var getActiveElement = __webpack_require__(317);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMLazyTree = __webpack_require__(103);
	var DOMProperty = __webpack_require__(104);
	var ReactBrowserEventEmitter = __webpack_require__(163);
	var ReactCurrentOwner = __webpack_require__(74);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactDOMContainerInfo = __webpack_require__(1083);
	var ReactDOMFeatureFlags = __webpack_require__(1086);
	var ReactElement = __webpack_require__(54);
	var ReactFeatureFlags = __webpack_require__(504);
	var ReactInstanceMap = __webpack_require__(105);
	var ReactInstrumentation = __webpack_require__(48);
	var ReactMarkupChecksum = __webpack_require__(1099);
	var ReactReconciler = __webpack_require__(106);
	var ReactUpdateQueue = __webpack_require__(244);
	var ReactUpdates = __webpack_require__(55);
	
	var emptyObject = __webpack_require__(111);
	var instantiateReactComponent = __webpack_require__(522);
	var invariant = __webpack_require__(6);
	var setInnerHTML = __webpack_require__(166);
	var shouldUpdateReactComponent = __webpack_require__(250);
	var warning = __webpack_require__(11);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(hostNode._debugID, 'mount', markup.toString());
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(141);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNodeTypes
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactElement = __webpack_require__(54);
	
	var invariant = __webpack_require__(6);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (ReactElement.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(54);
	var ReactPropTypeLocationNames = __webpack_require__(241);
	var ReactPropTypesSecret = __webpack_require__(243);
	
	var emptyFunction = __webpack_require__(39);
	var getIteratorFn = __webpack_require__(519);
	var warning = __webpack_require__(11);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in the next major version. You may be ' + 'seeing this warning due to a third-party PropTypes library. ' + 'See https://fb.me/react-warning-dont-call-proptypes for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new PropTypeError('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionGroup
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var React = __webpack_require__(162);
	var ReactInstanceMap = __webpack_require__(105);
	var ReactTransitionChildMapping = __webpack_require__(1107);
	
	var emptyFunction = __webpack_require__(39);
	
	/**
	 * A basis for animations. When children are declaratively added or removed,
	 * special lifecycle hooks are called.
	 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
	 */
	var ReactTransitionGroup = React.createClass({
	  displayName: 'ReactTransitionGroup',
	
	  propTypes: {
	    component: React.PropTypes.any,
	    childFactory: React.PropTypes.func
	  },
	
	  getDefaultProps: function () {
	    return {
	      component: 'span',
	      childFactory: emptyFunction.thatReturnsArgument
	    };
	  },
	
	  getInitialState: function () {
	    return {
	      // TODO: can we get useful debug information to show at this point?
	      children: ReactTransitionChildMapping.getChildMapping(this.props.children)
	    };
	  },
	
	  componentWillMount: function () {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  },
	
	  componentDidMount: function () {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  },
	
	  componentWillReceiveProps: function (nextProps) {
	    var nextChildMapping;
	    if (false) {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    }
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  },
	
	  componentDidUpdate: function () {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },
	
	  performAppear: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillAppear) {
	      component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
	    } else {
	      this._handleDoneAppearing(key);
	    }
	  },
	
	  _handleDoneAppearing: function (key) {
	    var component = this.refs[key];
	    if (component.componentDidAppear) {
	      component.componentDidAppear();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping;
	    if (false) {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	    }
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully appeared. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performEnter: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillEnter) {
	      component.componentWillEnter(this._handleDoneEntering.bind(this, key));
	    } else {
	      this._handleDoneEntering(key);
	    }
	  },
	
	  _handleDoneEntering: function (key) {
	    var component = this.refs[key];
	    if (component.componentDidEnter) {
	      component.componentDidEnter();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping;
	    if (false) {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	    }
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully entered. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performLeave: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	    if (component.componentWillLeave) {
	      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
	    } else {
	      // Note that this is somewhat dangerous b/c it calls setState()
	      // again, effectively mutating the component before all the work
	      // is done.
	      this._handleDoneLeaving(key);
	    }
	  },
	
	  _handleDoneLeaving: function (key) {
	    var component = this.refs[key];
	
	    if (component.componentDidLeave) {
	      component.componentDidLeave();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping;
	    if (false) {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	    }
	
	    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	      // This entered again before it fully left. Add it again.
	      this.performEnter(key);
	    } else {
	      this.setState(function (state) {
	        var newChildren = _assign({}, state.children);
	        delete newChildren[key];
	        return { children: newChildren };
	      });
	    }
	  },
	
	  render: function () {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	
	    // Do not forward ReactTransitionGroup props to primitive DOM nodes
	    var props = _assign({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return React.createElement(this.props.component, props, childrenToRender);
	  }
	});
	
	module.exports = ReactTransitionGroup;

/***/ },
/* 512 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '15.3.2';

/***/ },
/* 513 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(234);
	var traverseAllChildren = __webpack_require__(251);
	var warning = __webpack_require__(11);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(238);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(157)))

/***/ },
/* 517 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getHostComponentFromComposite
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(509);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 519 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVendorPrefixedEventName
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(16);
	
	var ReactCompositeComponent = __webpack_require__(1080);
	var ReactEmptyComponent = __webpack_require__(503);
	var ReactHostComponent = __webpack_require__(505);
	
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(11);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	var nextDebugID = 1;
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? nextDebugID++ : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 523 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactElement = __webpack_require__(54);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	var escapeTextContentForBrowser = __webpack_require__(165);
	var setInnerHTML = __webpack_require__(166);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _es6Error = __webpack_require__(830);
	
	var _es6Error2 = _interopRequireDefault(_es6Error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubmissionError = function (_ExtendableError) {
	  _inherits(SubmissionError, _ExtendableError);
	
	  function SubmissionError(errors) {
	    _classCallCheck(this, SubmissionError);
	
	    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));
	
	    _this.errors = errors;
	    return _this;
	  }
	
	  return SubmissionError;
	}(_es6Error2.default);
	
	exports.default = SubmissionError;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateSyncWarnings = exports.updateSyncErrors = exports.untouch = exports.unregisterField = exports.touch = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.registerField = exports.initialize = exports.focus = exports.destroy = exports.clearAsyncError = exports.clearSubmit = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actionTypes = __webpack_require__(253);
	
	var arrayInsert = exports.arrayInsert = function arrayInsert(form, field, index, value) {
	  return { type: _actionTypes.ARRAY_INSERT, meta: { form: form, field: field, index: index }, payload: value };
	};
	
	var arrayMove = exports.arrayMove = function arrayMove(form, field, from, to) {
	  return { type: _actionTypes.ARRAY_MOVE, meta: { form: form, field: field, from: from, to: to } };
	};
	
	var arrayPop = exports.arrayPop = function arrayPop(form, field) {
	  return { type: _actionTypes.ARRAY_POP, meta: { form: form, field: field } };
	};
	
	var arrayPush = exports.arrayPush = function arrayPush(form, field, value) {
	  return { type: _actionTypes.ARRAY_PUSH, meta: { form: form, field: field }, payload: value };
	};
	
	var arrayRemove = exports.arrayRemove = function arrayRemove(form, field, index) {
	  return { type: _actionTypes.ARRAY_REMOVE, meta: { form: form, field: field, index: index } };
	};
	
	var arrayRemoveAll = exports.arrayRemoveAll = function arrayRemoveAll(form, field) {
	  return { type: _actionTypes.ARRAY_REMOVE_ALL, meta: { form: form, field: field } };
	};
	
	var arrayShift = exports.arrayShift = function arrayShift(form, field) {
	  return { type: _actionTypes.ARRAY_SHIFT, meta: { form: form, field: field } };
	};
	
	var arraySplice = exports.arraySplice = function arraySplice(form, field, index, removeNum, value) {
	  var action = {
	    type: _actionTypes.ARRAY_SPLICE,
	    meta: { form: form, field: field, index: index, removeNum: removeNum }
	  };
	  if (value !== undefined) {
	    action.payload = value;
	  }
	  return action;
	};
	
	var arraySwap = exports.arraySwap = function arraySwap(form, field, indexA, indexB) {
	  if (indexA === indexB) {
	    throw new Error('Swap indices cannot be equal');
	  }
	  if (indexA < 0 || indexB < 0) {
	    throw new Error('Swap indices cannot be negative');
	  }
	  return { type: _actionTypes.ARRAY_SWAP, meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
	};
	
	var arrayUnshift = exports.arrayUnshift = function arrayUnshift(form, field, value) {
	  return { type: _actionTypes.ARRAY_UNSHIFT, meta: { form: form, field: field }, payload: value };
	};
	
	var autofill = exports.autofill = function autofill(form, field, value) {
	  return { type: _actionTypes.AUTOFILL, meta: { form: form, field: field }, payload: value };
	};
	
	var blur = exports.blur = function blur(form, field, value, touch) {
	  return { type: _actionTypes.BLUR, meta: { form: form, field: field, touch: touch }, payload: value };
	};
	
	var change = exports.change = function change(form, field, value, touch, persistentSubmitErrors) {
	  return { type: _actionTypes.CHANGE, meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors }, payload: value };
	};
	
	var clearSubmit = exports.clearSubmit = function clearSubmit(form) {
	  return { type: _actionTypes.CLEAR_SUBMIT, meta: { form: form } };
	};
	
	var clearAsyncError = exports.clearAsyncError = function clearAsyncError(form, field) {
	  return { type: _actionTypes.CLEAR_ASYNC_ERROR, meta: { form: form, field: field } };
	};
	
	var destroy = exports.destroy = function destroy() {
	  for (var _len = arguments.length, form = Array(_len), _key = 0; _key < _len; _key++) {
	    form[_key] = arguments[_key];
	  }
	
	  return { type: _actionTypes.DESTROY, meta: { form: form } };
	};
	
	var focus = exports.focus = function focus(form, field) {
	  return { type: _actionTypes.FOCUS, meta: { form: form, field: field } };
	};
	
	var initialize = exports.initialize = function initialize(form, values, keepDirty) {
	  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  if (keepDirty instanceof Object) {
	    otherMeta = keepDirty;
	    keepDirty = false;
	  }
	  return { type: _actionTypes.INITIALIZE, meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta), payload: values };
	};
	
	var registerField = exports.registerField = function registerField(form, name, type) {
	  return { type: _actionTypes.REGISTER_FIELD, meta: { form: form }, payload: { name: name, type: type } };
	};
	
	var reset = exports.reset = function reset(form) {
	  return { type: _actionTypes.RESET, meta: { form: form } };
	};
	
	var startAsyncValidation = exports.startAsyncValidation = function startAsyncValidation(form, field) {
	  return { type: _actionTypes.START_ASYNC_VALIDATION, meta: { form: form, field: field } };
	};
	
	var startSubmit = exports.startSubmit = function startSubmit(form) {
	  return { type: _actionTypes.START_SUBMIT, meta: { form: form } };
	};
	
	var stopAsyncValidation = exports.stopAsyncValidation = function stopAsyncValidation(form, errors) {
	  var action = {
	    type: _actionTypes.STOP_ASYNC_VALIDATION,
	    meta: { form: form },
	    payload: errors
	  };
	  if (errors && Object.keys(errors).length) {
	    action.error = true;
	  }
	  return action;
	};
	
	var stopSubmit = exports.stopSubmit = function stopSubmit(form, errors) {
	  var action = {
	    type: _actionTypes.STOP_SUBMIT,
	    meta: { form: form },
	    payload: errors
	  };
	  if (errors && Object.keys(errors).length) {
	    action.error = true;
	  }
	  return action;
	};
	
	var submit = exports.submit = function submit(form) {
	  return { type: _actionTypes.SUBMIT, meta: { form: form } };
	};
	
	var setSubmitFailed = exports.setSubmitFailed = function setSubmitFailed(form) {
	  for (var _len2 = arguments.length, fields = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    fields[_key2 - 1] = arguments[_key2];
	  }
	
	  return { type: _actionTypes.SET_SUBMIT_FAILED, meta: { form: form, fields: fields }, error: true };
	};
	
	var setSubmitSucceeded = exports.setSubmitSucceeded = function setSubmitSucceeded(form) {
	  for (var _len3 = arguments.length, fields = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    fields[_key3 - 1] = arguments[_key3];
	  }
	
	  return { type: _actionTypes.SET_SUBMIT_SUCCEEDED, meta: { form: form, fields: fields }, error: false };
	};
	
	var touch = exports.touch = function touch(form) {
	  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    fields[_key4 - 1] = arguments[_key4];
	  }
	
	  return { type: _actionTypes.TOUCH, meta: { form: form, fields: fields } };
	};
	
	var unregisterField = exports.unregisterField = function unregisterField(form, name) {
	  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  return { type: _actionTypes.UNREGISTER_FIELD, meta: { form: form }, payload: { name: name, destroyOnUnmount: destroyOnUnmount } };
	};
	
	var untouch = exports.untouch = function untouch(form) {
	  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    fields[_key5 - 1] = arguments[_key5];
	  }
	
	  return { type: _actionTypes.UNTOUCH, meta: { form: form, fields: fields } };
	};
	
	var updateSyncErrors = exports.updateSyncErrors = function updateSyncErrors(form) {
	  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var error = arguments[2];
	  return { type: _actionTypes.UPDATE_SYNC_ERRORS, meta: { form: form }, payload: { syncErrors: syncErrors, error: error } };
	};
	
	var updateSyncWarnings = exports.updateSyncWarnings = function updateSyncWarnings(form) {
	  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var warning = arguments[2];
	  return { type: _actionTypes.UPDATE_SYNC_WARNINGS, meta: { form: form }, payload: { syncWarnings: syncWarnings, warning: warning } };
	};

/***/ },
/* 528 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var processProps = function processProps(type, props, _value) {
	  var value = props.value;
	
	  if (type === 'checkbox') {
	    return _extends({}, props, {
	      checked: !!value
	    });
	  }
	  if (type === 'radio') {
	    return _extends({}, props, {
	      checked: value === _value,
	      value: _value
	    });
	  }
	  if (type === 'select-multiple') {
	    return _extends({}, props, {
	      value: value || []
	    });
	  }
	  if (type === 'file') {
	    return _extends({}, props, {
	      value: value || undefined
	    });
	  }
	  return props;
	};
	
	var createFieldProps = function createFieldProps(_ref2, name, _ref) {
	  var getIn = _ref2.getIn,
	      toJS = _ref2.toJS;
	
	  var asyncError = _ref.asyncError,
	      asyncValidating = _ref.asyncValidating,
	      onBlur = _ref.onBlur,
	      onChange = _ref.onChange,
	      onDrop = _ref.onDrop,
	      onDragStart = _ref.onDragStart,
	      dirty = _ref.dirty,
	      dispatch = _ref.dispatch,
	      onFocus = _ref.onFocus,
	      form = _ref.form,
	      format = _ref.format,
	      parse = _ref.parse,
	      pristine = _ref.pristine,
	      props = _ref.props,
	      state = _ref.state,
	      submitError = _ref.submitError,
	      submitFailed = _ref.submitFailed,
	      submitting = _ref.submitting,
	      syncError = _ref.syncError,
	      syncWarning = _ref.syncWarning,
	      validate = _ref.validate,
	      value = _ref.value,
	      _value = _ref._value,
	      warn = _ref.warn,
	      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);
	
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	
	  var formatFieldValue = function formatFieldValue(value, format) {
	    if (format === null) {
	      return value;
	    }
	    var defaultFormattedValue = value == null ? '' : value;
	    return format ? format(value, name) : defaultFormattedValue;
	  };
	
	  var formattedFieldValue = formatFieldValue(value, format);
	
	  return {
	    input: processProps(custom.type, {
	      name: name,
	      onBlur: onBlur,
	      onChange: onChange,
	      onDragStart: onDragStart,
	      onDrop: onDrop,
	      onFocus: onFocus,
	      value: formattedFieldValue
	    }, _value),
	    meta: _extends({}, toJS(state), {
	      active: !!(state && getIn(state, 'active')),
	      asyncValidating: asyncValidating,
	      autofilled: !!(state && getIn(state, 'autofilled')),
	      dirty: dirty,
	      dispatch: dispatch,
	      error: error,
	      form: form,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: !!submitting,
	      submitFailed: !!submitFailed,
	      touched: !!(state && getIn(state, 'touched')),
	      valid: !error,
	      visited: !!(state && getIn(state, 'visited'))
	    }),
	    custom: _extends({}, custom, props)
	  };
	};
	
	exports.default = createFieldProps;

/***/ },
/* 529 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	exports.default = isEvent;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getValue = __webpack_require__(1151);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _isReactNative = __webpack_require__(1157);
	
	var _isReactNative2 = _interopRequireDefault(_isReactNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onChangeValue = function onChangeValue(event, _ref) {
	  var name = _ref.name,
	      parse = _ref.parse,
	      normalize = _ref.normalize;
	
	  // read value from input
	  var value = (0, _getValue2.default)(event, _isReactNative2.default);
	
	  // parse value if we have a parser
	  if (parse) {
	    value = parse(value, name);
	  }
	
	  // normalize value
	  if (normalize) {
	    value = normalize(name, value);
	  }
	
	  return value;
	};
	
	exports.default = onChangeValue;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(529);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent2.default)(event);
	  if (is) {
	    event.preventDefault();
	  }
	  return is;
	};
	
	exports.default = silenceEvent;

/***/ },
/* 532 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createIsPristine = function createIsPristine(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      var formState = getFormState(state);
	      var initial = getIn(formState, form + '.initial') || empty;
	      var values = getIn(formState, form + '.values') || initial;
	      return deepEqual(initial, values);
	    };
	  };
	};
	
	exports.default = createIsPristine;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(156);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getIn = function getIn(state, field) {
	  if (!state) {
	    return state;
	  }
	
	  var path = (0, _toPath3.default)(field);
	  var length = path.length;
	  if (!length) {
	    return undefined;
	  }
	
	  var result = state;
	  for (var i = 0; i < length && !!result; ++i) {
	    result = result[path[i]];
	  }
	
	  return result;
	};
	
	exports.default = getIn;

/***/ },
/* 534 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  var rest = funcs.slice(0, -1);
	  return function () {
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(117);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1188);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 536 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 537 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];
	
	  var lastArgs = null;
	  var lastResult = null;
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
	      return equalityCheck(value, lastArgs[index]);
	    })) {
	      lastResult = func.apply(undefined, args);
	    }
	    lastArgs = args;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    memoizeOptions[_key2 - 1] = arguments[_key2];
	  }
	
	  return function () {
	    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      funcs[_key3] = arguments[_key3];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      return resultFunc.apply(undefined, arguments);
	    }].concat(memoizeOptions));
	
	    var selector = function selector(state, props) {
	      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
	        args[_key4 - 2] = arguments[_key4];
	      }
	
	      var params = dependencies.map(function (dependency) {
	        return dependency.apply(undefined, [state, props].concat(args));
	      });
	      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
	    };
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      values[_key5] = arguments[_key5];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	var bind = __webpack_require__(260);
	var Axios = __webpack_require__(540);
	var defaults = __webpack_require__(168);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(257);
	axios.CancelToken = __webpack_require__(539);
	axios.isCancel = __webpack_require__(258);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(554);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(257);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(168);
	var utils = __webpack_require__(40);
	var InterceptorManager = __webpack_require__(541);
	var dispatchRequest = __webpack_require__(542);
	var isAbsoluteURL = __webpack_require__(550);
	var combineURLs = __webpack_require__(548);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	var transformData = __webpack_require__(545);
	var isCancel = __webpack_require__(258);
	var defaults = __webpack_require__(168);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 543 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(259);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 546 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 548 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 550 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 554 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _translations = __webpack_require__(643);
	
	var _translations2 = _interopRequireDefault(_translations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureLanguages(store, defaultLanguage) {
		// Loop over the translations available and build a single object with locale as key
		var languageTokens = {};
		Object.keys(_translations2.default).forEach(function (language) {
			languageTokens[_translations2.default[language].locale] = _translations2.default[language].tokens;
		});
	
		(0, _reactReduxI18n.syncTranslationWithStore)(store);
		store.dispatch((0, _reactReduxI18n.loadTranslations)(languageTokens));
		store.dispatch((0, _reactReduxI18n.setLocale)(defaultLanguage));
	}
	
	exports.default = configureLanguages;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(12);
	
	var _reduxImmutableStateInvariant = __webpack_require__(1179);
	
	var _reduxImmutableStateInvariant2 = _interopRequireDefault(_reduxImmutableStateInvariant);
	
	var _reduxThunk = __webpack_require__(1182);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reactRouter = __webpack_require__(28);
	
	var _rootReducer = __webpack_require__(639);
	
	var _rootReducer2 = _interopRequireDefault(_rootReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStoreProd() {
	  var middlewares = [
	  // Add other middleware on this line...
	
	  // thunk middleware can also accept an extra argument to be passed to each thunk action
	  // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
	
	
	  // thunk middleware can also accept an extra argument to be passed to each thunk action
	  // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
	  _reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory)];
	
	  return (0, _redux.createStore)(_rootReducer2.default, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middlewares)));
	}
	
	function configureStoreDev() {
	  var middlewares = [
	  // Add other middleware on this line...
	
	  // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
	  (0, _reduxImmutableStateInvariant2.default)(), _reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory)];
	
	  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose; // add support for Redux dev tools
	  var store = (0, _redux.createStore)(_rootReducer2.default, composeEnhancers(_redux.applyMiddleware.apply(undefined, middlewares)));
	
	  if (false) {
	    // Enable Webpack hot module replacement for reducers
	    module.hot.accept('../rootReducer', function () {
	      var nextReducer = require('../rootReducer').default; // eslint-disable-line global-require
	      store.replaceReducer(nextReducer);
	    });
	  }
	
	  return store;
	}
	
	var configureStore =  true ? configureStoreProd : configureStoreDev;
	
	exports.default = configureStore;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var attemptTokenLogin = _customer2.default.actions.attemptTokenLogin;
	
	var App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.attemptTokenLogin();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { id: 'wrapper' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return App;
	}(_react2.default.Component);
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ attemptTokenLogin: attemptTokenLogin }, dispatch);
	}
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(App);

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(8);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _navbar = __webpack_require__(279);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isContextLoaded = _customer2.default.selectors.isContextLoaded;
	var NavBar = _navbar2.default.components.NavBar;
	
	var _ref2 = _react2.default.createElement(
	  'div',
	  { className: 'full-width-loading' },
	  _react2.default.createElement('div', null)
	);
	
	var NavLayout = function NavLayout(_ref) {
	  var children = _ref.children,
	      contextLoaded = _ref.contextLoaded,
	      location = _ref.location;
	
	  if (!contextLoaded) {
	    return _ref2;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'nav-layout' },
	    _react2.default.createElement(NavBar, { location: location }),
	    children
	  );
	};
	
	function mapStateToProps(state, ownProps) {
	  return {
	    contextLoaded: isContextLoaded(state),
	    location: ownProps.location.pathname
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(NavLayout);

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(28);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h4',
	      null,
	      _reactReduxI18n.I18n.t('PAGE_NOT_FOUND')
	    ),
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: '/' },
	      ' ',
	      _reactReduxI18n.I18n.t('GO_BACK_TO_HOMEPAGE'),
	      ' '
	    )
	  );
	};
	
	exports.default = NotFoundPage;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NotFoundPage = exports.NavLayout = exports.App = undefined;
	
	var _App = __webpack_require__(557);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _NavLayout = __webpack_require__(558);
	
	var _NavLayout2 = _interopRequireDefault(_NavLayout);
	
	var _NotFoundPage = __webpack_require__(559);
	
	var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.App = _App2.default;
	exports.NavLayout = _NavLayout2.default;
	exports.NotFoundPage = _NotFoundPage2.default;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _components = __webpack_require__(560);
	
	var components = _interopRequireWildcard(_components);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = { components: components };

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _actions = __webpack_require__(123);
	
	var _selectors = __webpack_require__(124);
	
	var _PetAdPreview = __webpack_require__(567);
	
	var _PetAdPreview2 = _interopRequireDefault(_PetAdPreview);
	
	var _PetAdTable = __webpack_require__(569);
	
	var _PetAdTable2 = _interopRequireDefault(_PetAdTable);
	
	var _userPermissions = __webpack_require__(29);
	
	var permissions = _interopRequireWildcard(_userPermissions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getActivePermissions = _customer2.default.selectors.getActivePermissions;
	
	var _ref = _react2.default.createElement('div', { className: 'loading' });
	
	var AdsPage = function (_React$Component) {
	  _inherits(AdsPage, _React$Component);
	
	  function AdsPage() {
	    _classCallCheck(this, AdsPage);
	
	    return _possibleConstructorReturn(this, (AdsPage.__proto__ || Object.getPrototypeOf(AdsPage)).apply(this, arguments));
	  }
	
	  _createClass(AdsPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var accessPermission = this.props.activePermissions.find(function (permission) {
	        return permission === permissions.MANAGE_CARE_SHEET_ADS;
	      });
	      if (!accessPermission) {
	        this.props.actions.push('/labels');
	      }
	
	      this.props.actions.getCareSheetSettings();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.authData.activeSubscriptionId !== nextProps.authData.activeSubscriptionId) {
	        this.props.actions.getCareSheetSettings();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.actions.deselectAd();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$actions = _props.actions,
	          deleteAd = _props$actions.deleteAd,
	          selectAd = _props$actions.selectAd,
	          uploadAd = _props$actions.uploadAd,
	          adsList = _props.adsList,
	          previewsList = _props.previewsList,
	          validSettings = _props.validSettings,
	          selectedAd = _props.selectedAd;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid main', id: 'main' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-12' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              _reactReduxI18n.I18n.t('ADVERTISING_SPACE')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _reactReduxI18n.I18n.t('ADVERTISING_DETAILS')
	            ),
	            !validSettings && _ref,
	            validSettings && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-9 col-md-8' },
	                  _react2.default.createElement(_PetAdTable2.default, { adsList: adsList,
	                    previewsList: previewsList,
	                    onClearAd: deleteAd,
	                    onRowSelected: selectAd,
	                    onUploadAd: uploadAd,
	                    selectedAd: selectedAd })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-3 col-md-4 text-right aspace' },
	                  Object.keys(selectedAd).length !== 0 && _react2.default.createElement(_PetAdPreview2.default, { ad: selectedAd })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdsPage;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    adsList: (0, _selectors.getAds)(state),
	    activePermissions: getActivePermissions(state),
	    previewsList: (0, _selectors.getPreviews)(state),
	    validSettings: (0, _selectors.areSettingsValid)(state),
	    selectedAd: (0, _selectors.getSelectedAd)(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ getCareSheetSettings: _actions.getCareSheetSettings, deleteAd: _actions.deleteAd, deselectAd: _actions.deselectAd, selectAd: _actions.selectAd, uploadAd: _actions.uploadAd, push: _reactRouterRedux.push }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AdsPage);

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(28);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var searchFocusHack = function searchFocusHack() {
	  document.getElementById("searchPhrase").focus();
	};
	
	var CareSheetInfo = function CareSheetInfo(_ref) {
	  var careSheet = _ref.careSheet;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'col-lg-6 col-sm-12 col-pet' },
	    _react2.default.createElement(
	      'div',
	      { className: 'media' },
	      _react2.default.createElement(
	        'div',
	        { className: 'mr-3 align-self-start' },
	        _react2.default.createElement('img', { src: careSheet.ImageURL, alt: careSheet.Name })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'media-body' },
	        _react2.default.createElement(
	          'h5',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: careSheet.PDFURL, target: '_blank' },
	            careSheet.Line1
	          )
	        ),
	        _react2.default.createElement(
	          'h6',
	          null,
	          careSheet.Line2
	        ),
	        _react2.default.createElement(
	          'h6',
	          null,
	          careSheet.Line3
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row plu-barcode no-gutters' },
	          _react2.default.createElement(
	            'span',
	            { className: 'plu' },
	            careSheet.Line4
	          )
	        ),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: careSheet.PDFURL, target: '_blank', onClick: searchFocusHack, className: 'btn btn-primary' },
	          _reactReduxI18n.I18n.t('DOWNLOAD')
	        )
	      )
	    )
	  );
	};
	
	exports.default = CareSheetInfo;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CareSheetPreview = function CareSheetPreview(_ref) {
		var link = _ref.link;
	
		return _react2.default.createElement(
			'a',
			{ href: link, target: '_blank', className: 'preview' },
			_reactReduxI18n.I18n.t('PREVIEW_CARE_SHEET')
		);
	};
	
	exports.default = CareSheetPreview;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _ReactList = __webpack_require__(265);
	
	var _ReactList2 = _interopRequireDefault(_ReactList);
	
	var _actions = __webpack_require__(123);
	
	var _selectors = __webpack_require__(124);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _search = __webpack_require__(174);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _CareSheetInfo = __webpack_require__(563);
	
	var _CareSheetInfo2 = _interopRequireDefault(_CareSheetInfo);
	
	var _userPermissions = __webpack_require__(29);
	
	var permissions = _interopRequireWildcard(_userPermissions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getActivePermissions = _customer2.default.selectors.getActivePermissions;
	var SearchPanel = _search2.default.components.SearchPanel;
	
	var _ref2 = _react2.default.createElement('div', { className: 'loading' });
	
	var CareSheetsPage = function (_React$Component) {
	  _inherits(CareSheetsPage, _React$Component);
	
	  function CareSheetsPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CareSheetsPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CareSheetsPage.__proto__ || Object.getPrototypeOf(CareSheetsPage)).call.apply(_ref, [this].concat(args))), _this), _this.handleFormSubmit = function (values) {
	      _this.props.actions.searchCareSheets(values.searchPhrase);
	    }, _this.renderItem = function (index, key) {
	      return _react2.default.createElement(_CareSheetInfo2.default, { key: key, careSheet: _this.props.searchResults[index] });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CareSheetsPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var accessPermission = this.props.activePermissions.find(function (permission) {
	        return permission === permissions.ACCESS_CARE_SHEETS;
	      });
	      if (!accessPermission) {
	        this.props.actions.push('/labels');
	      }
	
	      if (!this.props.careSheetsValid) {
	        this.props.actions.getCareSheets();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.actions.clearSearchResults();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actions = _props.actions,
	          careSheetsValid = _props.careSheetsValid,
	          searchPhrase = _props.searchPhrase,
	          searchResults = _props.searchResults,
	          selectedPetTypes = _props.selectedPetTypes,
	          petTypeList = _props.petTypeList;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid main', id: 'main' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-12' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              _reactReduxI18n.I18n.t('CARE_SHEETS')
	            )
	          )
	        ),
	        !careSheetsValid && _ref2,
	        careSheetsValid && _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-12' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'float-left search-pets-title' },
	              _reactReduxI18n.I18n.t('SEARCH_PETS')
	            ),
	            _react2.default.createElement(SearchPanel, { itemList: petTypeList,
	              onSelectedItem: actions.toggleSelectedPetType,
	              onSubmit: this.handleFormSubmit,
	              selectedItems: selectedPetTypes }),
	            searchResults.length === 0 && searchPhrase === '' && _react2.default.createElement(
	              'div',
	              { className: 'no-recent-care-sheets' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                _reactReduxI18n.I18n.t('SEARCH_FOR_A_PET')
	              )
	            ),
	            searchResults.length === 0 && searchPhrase !== '' && _react2.default.createElement(
	              'div',
	              { className: 'no-recent-care-sheets' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                _reactReduxI18n.I18n.t('NO_RESULTS_TRY_AGAIN')
	              )
	            ),
	            searchResults.length > 0 && _react2.default.createElement(
	              'h5',
	              null,
	              _reactReduxI18n.I18n.t('RESULTS'),
	              ' (',
	              searchResults.length,
	              ')'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row search-results care-sheets' },
	          _react2.default.createElement(_ReactList2.default, { itemRenderer: this.renderItem, length: searchResults.length, type: 'uniform' })
	        )
	      );
	    }
	  }]);
	
	  return CareSheetsPage;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    activePermissions: getActivePermissions(state),
	    careSheetsValid: (0, _selectors.areCareSheetsValid)(state),
	    petTypeList: (0, _selectors.getPetTypes)(state),
	    searchPhrase: (0, _selectors.getSearchPhrase)(state),
	    searchResults: (0, _selectors.getSearchResults)(state),
	    selectedPetTypes: (0, _selectors.getSelectedPetTypes)(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ clearSearchResults: _actions.clearSearchResults, getCareSheets: _actions.getCareSheets, searchCareSheets: _actions.searchCareSheets, toggleSelectedPetType: _actions.toggleSelectedPetType, push: _reactRouterRedux.push }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CareSheetsPage);

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(28);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PetAdOptions = function (_React$Component) {
	  _inherits(PetAdOptions, _React$Component);
	
	  function PetAdOptions() {
	    _classCallCheck(this, PetAdOptions);
	
	    return _possibleConstructorReturn(this, (PetAdOptions.__proto__ || Object.getPrototypeOf(PetAdOptions)).apply(this, arguments));
	  }
	
	  _createClass(PetAdOptions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          ad = _props.ad,
	          preview = _props.preview,
	          onClear = _props.onClear,
	          onUpload = _props.onUpload;
	
	      return _react2.default.createElement(
	        'td',
	        null,
	        ad.isValid && _react2.default.createElement(
	          _reactRouter.Link,
	          { to: preview, target: '_blank', className: 'aspace-preview' },
	          _reactReduxI18n.I18n.t('PREVIEW')
	        ),
	        ad.isValid && _react2.default.createElement(
	          'button',
	          { type: 'button', className: 'btn btn-link', onClick: function onClick() {
	              return onClear(ad);
	            } },
	          _reactReduxI18n.I18n.t('CLEAR')
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'custom-file' },
	          _react2.default.createElement('input', { type: 'file', id: 'file', className: 'custom-file-input', accept: 'image/jpeg, image/png', onChange: function onChange(e) {
	              onUpload(ad, e.target.files[0]);
	            } }),
	          _react2.default.createElement(
	            'span',
	            { className: 'custom-file-control' },
	            _reactReduxI18n.I18n.t('UPLOAD')
	          )
	        )
	      );
	    }
	  }]);
	
	  return PetAdOptions;
	}(_react2.default.Component);
	
	exports.default = PetAdOptions;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PetAdPreview = function PetAdPreview(_ref) {
		var ad = _ref.ad;
	
		var adClass = "aspace-placeholder ";
		if (!ad.isValid) {
			adClass += "aspace-bg";
		}
	
		return _react2.default.createElement(
			"div",
			{ className: adClass },
			ad.isValid && _react2.default.createElement("img", { src: ad.imageUrl })
		);
	};
	
	exports.default = PetAdPreview;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PetAdOptions = __webpack_require__(566);
	
	var _PetAdOptions2 = _interopRequireDefault(_PetAdOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement('i', { className: 'fa fa-check fa-lg' });
	
	var _ref3 = _react2.default.createElement('td', null);
	
	var PetAdRow = function PetAdRow(_ref) {
		var ad = _ref.ad,
		    preview = _ref.preview,
		    onClear = _ref.onClear,
		    onSelected = _ref.onSelected,
		    onUpload = _ref.onUpload,
		    selected = _ref.selected;
	
		return _react2.default.createElement(
			'tr',
			{ onClick: function onClick() {
					return onSelected(ad);
				}, className: selected && "table-active" },
			_react2.default.createElement(
				'td',
				null,
				ad.petType
			),
			_react2.default.createElement(
				'td',
				null,
				ad.isValid && _ref2
			),
			selected ? _react2.default.createElement(_PetAdOptions2.default, { ad: ad, preview: preview, onClear: onClear, onUpload: onUpload }) : _ref3
		);
	};
	
	exports.default = PetAdRow;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _PetAdRow = __webpack_require__(568);
	
	var _PetAdRow2 = _interopRequireDefault(_PetAdRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement('th', null);
	
	var PetAdTable = function PetAdTable(_ref) {
	  var adsList = _ref.adsList,
	      previewsList = _ref.previewsList,
	      onClearAd = _ref.onClearAd,
	      onRowSelected = _ref.onRowSelected,
	      onUploadAd = _ref.onUploadAd,
	      selectedAd = _ref.selectedAd;
	
	  var ads = adsList.map(function (ad) {
	    var selected = selectedAd.petType === ad.petType ? true : false;
	
	    var adPreview = previewsList.find(function (preview) {
	      return preview.petType === ad.petType;
	    });
	
	    return _react2.default.createElement(_PetAdRow2.default, { key: ad.petType,
	      ad: ad,
	      preview: adPreview.previewUrl,
	      onClear: onClearAd,
	      onSelected: onRowSelected,
	      onUpload: onUploadAd,
	      selected: selected });
	  });
	
	  return _react2.default.createElement(
	    'table',
	    { className: 'table table-hover aspace-table' },
	    _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'th',
	          null,
	          _reactReduxI18n.I18n.t('PET_TYPE')
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          _reactReduxI18n.I18n.t('AD_UPLOADED')
	        ),
	        _ref2
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      ads
	    )
	  );
	};
	
	exports.default = PetAdTable;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _FormInput = __webpack_require__(49);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _CareSheetPreview = __webpack_require__(564);
	
	var _CareSheetPreview2 = _interopRequireDefault(_CareSheetPreview);
	
	var _StoreInfoLogo = __webpack_require__(571);
	
	var _StoreInfoLogo2 = _interopRequireDefault(_StoreInfoLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement(
	  'div',
	  { className: 'col-lg-11 col-sm-10' },
	  _react2.default.createElement(_reduxForm.Field, { name: 'line1',
	    component: _FormInput2.default,
	    type: 'text',
	    className: 'form-control'
	  })
	);
	
	var _ref3 = _react2.default.createElement(
	  'div',
	  { className: 'col-lg-11 col-sm-10' },
	  _react2.default.createElement(_reduxForm.Field, { name: 'line2',
	    component: _FormInput2.default,
	    type: 'text',
	    className: 'form-control'
	  })
	);
	
	var _ref4 = _react2.default.createElement(
	  'div',
	  { className: 'col-lg-11 col-sm-10' },
	  _react2.default.createElement(_reduxForm.Field, { name: 'line3',
	    component: _FormInput2.default,
	    type: 'text',
	    className: 'form-control'
	  })
	);
	
	var _ref5 = _react2.default.createElement(
	  'div',
	  { className: 'col-lg-11 col-sm-10' },
	  _react2.default.createElement(_reduxForm.Field, { name: 'line4',
	    component: _FormInput2.default,
	    type: 'text',
	    className: 'form-control'
	  })
	);
	
	var _ref6 = _react2.default.createElement(_reduxForm.Field, { name: 'useLogo',
	  component: _FormInput2.default,
	  type: 'checkbox',
	  className: 'form-checkbox' });
	
	var StoreInfoForm = function StoreInfoForm(_ref) {
	  var handleSubmit = _ref.handleSubmit,
	      onUpload = _ref.onUpload,
	      storeSettings = _ref.storeSettings,
	      submitting = _ref.submitting,
	      useLogo = _ref.useLogo;
	
	  var invalidLogo = useLogo && storeSettings.logoUrl === null;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'form',
	      { onSubmit: handleSubmit },
	      _react2.default.createElement(
	        'fieldset',
	        { disabled: useLogo },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'example-text-input', className: 'col-lg-1 col-sm-2 col-form-label' },
	            _reactReduxI18n.I18n.t('LINE1')
	          ),
	          _ref2
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'example-text-input', className: 'col-lg-1 col-sm-2 col-form-label' },
	            _reactReduxI18n.I18n.t('LINE2')
	          ),
	          _ref3
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'example-text-input', className: 'col-lg-1 col-sm-2 col-form-label' },
	            _reactReduxI18n.I18n.t('LINE3')
	          ),
	          _ref4
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'example-text-input', className: 'col-lg-1 col-sm-2 col-form-label' },
	            _reactReduxI18n.I18n.t('LINE4')
	          ),
	          _ref5
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'logo-instead' },
	        _ref6,
	        _reactReduxI18n.I18n.t('USE_LOGO_INSTEAD')
	      ),
	      useLogo && _react2.default.createElement(_StoreInfoLogo2.default, { useLogo: useLogo, logoUrl: storeSettings.logoUrl, onUpload: onUpload }),
	      _react2.default.createElement(
	        'div',
	        { className: 'row no-gutters bottom-buttons' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-2 col-sm-4' },
	          _react2.default.createElement(_CareSheetPreview2.default, { link: storeSettings.previewUrl })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-10 col-sm-8 text-right' },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-primary', disabled: submitting || invalidLogo },
	            _reactReduxI18n.I18n.t('SAVE')
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _reduxForm.reduxForm)()(StoreInfoForm);

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement(
	  'h5',
	  null,
	  'Logo'
	);
	
	var StoreInfoLogo = function StoreInfoLogo(_ref) {
	  var logoUrl = _ref.logoUrl,
	      onUpload = _ref.onUpload,
	      useLogo = _ref.useLogo;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _ref2,
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-4' },
	        _react2.default.createElement(
	          'div',
	          { className: 'company-logo' },
	          useLogo && logoUrl !== null && _react2.default.createElement('img', { src: logoUrl, alt: 'Store Logo', title: 'Store Logo' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-8' },
	        _react2.default.createElement(
	          'label',
	          { className: 'custom-file' },
	          _react2.default.createElement('input', { type: 'file', id: 'file', className: 'custom-file-input', accept: 'image/jpeg, image/png', onChange: function onChange(e) {
	              onUpload(e.target.files[0]);
	            } }),
	          _react2.default.createElement(
	            'span',
	            { className: 'custom-file-control' },
	            _reactReduxI18n.I18n.t('UPLOAD_LOGO')
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'logo-description' },
	          _reactReduxI18n.I18n.t('STORE_LOGO_DETAILS'),
	          _react2.default.createElement(
	            'span',
	            null,
	            _reactReduxI18n.I18n.t('STORE_LOGO_FORMATS')
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = StoreInfoLogo;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _actions = __webpack_require__(123);
	
	var _selectors = __webpack_require__(124);
	
	var _StoreInfoForm = __webpack_require__(570);
	
	var _StoreInfoForm2 = _interopRequireDefault(_StoreInfoForm);
	
	var _userPermissions = __webpack_require__(29);
	
	var permissions = _interopRequireWildcard(_userPermissions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getActivePermissions = _customer2.default.selectors.getActivePermissions;
	
	
	var formName = 'storeInfoForm';
	var formSelector = (0, _reduxForm.formValueSelector)(formName);
	
	var _ref2 = _react2.default.createElement('div', { className: 'loading' });
	
	var StoreInfoPage = function (_React$Component) {
	  _inherits(StoreInfoPage, _React$Component);
	
	  function StoreInfoPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StoreInfoPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreInfoPage.__proto__ || Object.getPrototypeOf(StoreInfoPage)).call.apply(_ref, [this].concat(args))), _this), _this.handleFormSubmit = function (values) {
	      return new Promise(function (resolve, reject) {
	        _this.props.actions.saveStoreSettings(values).then(function () {
	          resolve();
	        }).catch(function () {
	          reject();
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(StoreInfoPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var accessPermission = this.props.activePermissions.find(function (permission) {
	        return permission === permissions.MANAGE_LOGO;
	      });
	      if (!accessPermission) {
	        this.props.actions.push('/labels');
	      }
	
	      this.props.actions.getCareSheetSettings();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.authData.activeSubscriptionId !== nextProps.authData.activeSubscriptionId) {
	        this.props.actions.getCareSheetSettings();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          uploadLogo = _props.actions.uploadLogo,
	          useLogo = _props.useLogo,
	          storeSettings = _props.storeSettings,
	          validSettings = _props.validSettings;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid main', id: 'main' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-12' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              _reactReduxI18n.I18n.t('STORE_INFO_LOGO')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _reactReduxI18n.I18n.t('STORE_INFO_DETAILS')
	            ),
	            !validSettings && _ref2,
	            validSettings && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'row no-gutters' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    _reactReduxI18n.I18n.t('STORE_INFO')
	                  )
	                )
	              ),
	              _react2.default.createElement(_StoreInfoForm2.default, { form: formName,
	                initialValues: { line1: storeSettings.infoLine1,
	                  line2: storeSettings.infoLine2,
	                  line3: storeSettings.infoLine3,
	                  line4: storeSettings.infoLine4,
	                  useLogo: storeSettings.useLogo },
	                onSubmit: this.handleFormSubmit,
	                onUpload: uploadLogo,
	                storeSettings: storeSettings,
	                useLogo: useLogo })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StoreInfoPage;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    activePermissions: getActivePermissions(state),
	    useLogo: formSelector(state, 'useLogo'),
	    storeSettings: (0, _selectors.getStoreSettings)(state),
	    validSettings: (0, _selectors.areSettingsValid)(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ getCareSheetSettings: _actions.getCareSheetSettings, uploadLogo: _actions.uploadLogo, saveStoreSettings: _actions.saveStoreSettings, push: _reactRouterRedux.push }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StoreInfoPage);

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StoreInfoPage = exports.CareSheetsPage = exports.AdsPage = undefined;
	
	var _AdsPage = __webpack_require__(562);
	
	var _AdsPage2 = _interopRequireDefault(_AdsPage);
	
	var _CareSheetsPage = __webpack_require__(565);
	
	var _CareSheetsPage2 = _interopRequireDefault(_CareSheetsPage);
	
	var _StoreInfoPage = __webpack_require__(572);
	
	var _StoreInfoPage2 = _interopRequireDefault(_StoreInfoPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AdsPage = _AdsPage2.default;
	exports.CareSheetsPage = _CareSheetsPage2.default;
	exports.StoreInfoPage = _StoreInfoPage2.default;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	
	var _actionTypes = __webpack_require__(261);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _thenby = __webpack_require__(91);
	
	var _thenby2 = _interopRequireDefault(_thenby);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialSettings = {
	  ads: [],
	  previews: [],
	  selectedAd: {},
	  store: {
	    info1: '',
	    info2: '',
	    info3: '',
	    info4: '',
	    useLogo: false,
	    logoUrl: '',
	    previewUrl: ''
	  },
	  valid: false
	};
	
	var initialSearch = {
	  petTypes: [],
	  results: [],
	  phrase: '',
	  selectedPetTypes: []
	};
	
	var initialState = {
	  list: [],
	  petTypes: [],
	  valid: false,
	  search: initialSearch,
	  settings: initialSettings
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case types.CARESHEET_SETTINGS_RECEIVED:
	      {
	        // If we already have an ad selected, we need to update it with received data
	        var selectedAd = {};
	        if (Object.keys(state.settings.selectedAd).length !== 0) {
	          selectedAd = action.payload.ads.find(function (ad) {
	            return ad.petType === state.settings.selectedAd.petType;
	          });
	        }
	
	        return _extends({}, state, {
	          settings: {
	            ads: action.payload.ads,
	            previews: action.payload.previews,
	            selectedAd: selectedAd,
	            store: {
	              infoLine1: action.payload.store.infoLine1,
	              infoLine2: action.payload.store.infoLine2,
	              infoLine3: action.payload.store.infoLine3,
	              infoLine4: action.payload.store.infoLine4,
	              useLogo: action.payload.store.useLogo,
	              logoUrl: action.payload.store.logoUrl,
	              previewUrl: action.payload.store.previewUrl
	            },
	            valid: true
	          }
	        });
	      }
	    case types.GET_CARESHEET_SETTINGS:
	      {
	        return _extends({}, state, {
	          settings: initialSettings
	        });
	      }
	    case types.AD_SELECTED:
	      {
	        return _extends({}, state, {
	          settings: _extends({}, state.settings, {
	            selectedAd: action.payload.ad
	          })
	        });
	      }
	    case types.AD_DESELECTED:
	      {
	        return _extends({}, state, {
	          settings: _extends({}, state.settings, {
	            selectedAd: {}
	          })
	
	        });
	      }
	    case types.CARESHEET_LIST_RECEIVED:
	      {
	        return _extends({}, state, {
	          list: action.payload.caresheets,
	          valid: true
	        });
	      }
	    case types.PET_TYPES_ADDED:
	      {
	        return _extends({}, state, {
	          search: _extends({}, state.search, {
	            petTypes: action.payload.petTypes,
	            selectedPetTypes: action.payload.selectedPetTypes
	          })
	        });
	      }
	    case types.TOGGLE_SELECTED_PET_TYPE:
	      {
	        var selectedPetTypes = [].concat(_toConsumableArray(state.search.selectedPetTypes));
	        var togglePetType = action.payload.petType;
	
	        var found = selectedPetTypes.find(function (petType) {
	          return petType === togglePetType;
	        });
	
	        if (found) {
	          var index = selectedPetTypes.indexOf(togglePetType);
	          selectedPetTypes.splice(index, 1);
	        } else {
	          selectedPetTypes.push(togglePetType);
	        }
	
	        return _extends({}, state, {
	          search: _extends({}, state.search, {
	            selectedPetTypes: selectedPetTypes
	          })
	        });
	      }
	    case types.FILTER_CARESHEETS:
	      {
	        var searchPhrase = state.search.phrase;
	
	        var searchAllTypes = state.search.petTypes.length === state.search.selectedPetTypes.length || state.search.selectedPetTypes.length === 0 ? true : false;
	
	        var searchResults = state.list.filter(function (caresheet) {
	          if (searchAllTypes) {
	            return caresheet.Line1 !== null && caresheet.Line1.toLowerCase().indexOf(searchPhrase) >= 0 || caresheet.Line2 !== null && caresheet.Line2.toLowerCase().indexOf(searchPhrase) >= 0 || caresheet.Line3 !== null && caresheet.Line3.toLowerCase().indexOf(searchPhrase) >= 0 || caresheet.Line4 !== null && caresheet.Line4.toLowerCase().indexOf(searchPhrase) >= 0;
	          } else {
	            return state.search.selectedPetTypes.includes(caresheet.Type) && (caresheet.Line1 !== null && caresheet.Line1.toLowerCase().indexOf(searchPhrase) >= 0 || caresheet.Line2 !== null && caresheet.Line2.toLowerCase().indexOf(searchPhrase) >= 0 || caresheet.Line3 !== null && caresheet.Line3.toLowerCase().indexOf(searchPhrase) >= 0 || caresheet.Line4 !== null && caresheet.Line4.toLowerCase().indexOf(searchPhrase) >= 0);
	          }
	        });
	
	        searchResults.sort((0, _thenby2.default)("Line1").thenBy("Line2"));
	
	        return _extends({}, state, {
	          search: _extends({}, state.search, {
	            results: searchResults
	          })
	        });
	      }
	    case types.CARESHEET_SEARCH_PHRASE:
	      {
	        var _searchPhrase = '';
	        if (action.payload.searchPhrase !== undefined) {
	          _searchPhrase = action.payload.searchPhrase.toLowerCase();
	        } else {
	          _searchPhrase = '';
	        }
	
	        return _extends({}, state, {
	          search: _extends({}, state.search, {
	            phrase: _searchPhrase
	          })
	        });
	      }
	    case types.CLEAR_SEARCH_RESULTS:
	      {
	        return _extends({}, state, {
	          search: _extends({}, state.search, {
	            results: [],
	            phrase: '',
	            selectedPetType: state.search.petTypes
	          })
	        });
	      }
	    default:
	      return state;
	  }
	}

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(56);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement('span', { className: 'lnr lnr-cross', 'aria-hidden': 'true' });
	
	var DemoModal = function DemoModal(_ref) {
	  var isOpen = _ref.isOpen,
	      onClose = _ref.onClose,
	      onStartDemo = _ref.onStartDemo;
	
	  return _react2.default.createElement(
	    _reactstrap.Modal,
	    { isOpen: isOpen, toggle: onClose, id: 'modalSelectStore' },
	    _react2.default.createElement(
	      'div',
	      { className: 'modal-header' },
	      _react2.default.createElement(
	        'h4',
	        { className: 'modal-title', id: 'exampleModalLabel' },
	        _reactReduxI18n.I18n.t('DEMO_TITLE')
	      ),
	      _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close', onClick: onClose },
	        _ref2
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'modal-body' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _reactReduxI18n.I18n.t('DEMO_TEXT')
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'modal-footer' },
	      _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'btn btn-primary', onClick: function onClick() {
	            return onStartDemo('de');
	          } },
	        _reactReduxI18n.I18n.t('DEMO_DE_LOGIN')
	      ),
	      _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'btn btn-primary', onClick: function onClick() {
	            return onStartDemo('en');
	          } },
	        _reactReduxI18n.I18n.t('DEMO_EN_LOGIN')
	      )
	    )
	  );
	};
	
	exports.default = DemoModal;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(28);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _actions = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForgotPasswordPage = function (_React$Component) {
	  _inherits(ForgotPasswordPage, _React$Component);
	
	  function ForgotPasswordPage(props) {
	    _classCallCheck(this, ForgotPasswordPage);
	
	    var _this = _possibleConstructorReturn(this, (ForgotPasswordPage.__proto__ || Object.getPrototypeOf(ForgotPasswordPage)).call(this, props));
	
	    _this.handleUsernameChanged = function (username) {
	      _this.setState({ username: username });
	    };
	
	    _this.handleSendPassword = function () {
	      _this.props.actions.forgotPassword(_this.state.username);
	      _this.setState({ username: '' });
	      _this.setState({ sent: true });
	    };
	
	    _this.state = {
	      username: '',
	      sent: false
	    };
	    return _this;
	  }
	
	  _createClass(ForgotPasswordPage, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'login-form-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container login' },
	          _react2.default.createElement(
	            'form',
	            { className: 'form-login' },
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-login' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/' },
	                _reactReduxI18n.I18n.t('pet_data')
	              )
	            ),
	            this.state.sent === false && _react2.default.createElement(
	              'div',
	              null,
	              _reactReduxI18n.I18n.t('RESET_PASSWORD_HEADER'),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'email', className: 'sr-only' },
	                _reactReduxI18n.I18n.t('EMAIL_ADDRESS')
	              ),
	              _react2.default.createElement('input', { name: 'email',
	                className: 'form-control',
	                placeholder: _reactReduxI18n.I18n.t('EMAIL_ADDRESS'),
	                value: this.state.username,
	                onChange: function onChange(e) {
	                  _this2.handleUsernameChanged(e.target.value);
	                }
	              }),
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-login', onClick: this.handleSendPassword },
	                _reactReduxI18n.I18n.t('SEND_PASSWORD')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'no-account' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/labels' },
	                  _reactReduxI18n.I18n.t('RESET_PASSWORD_BACK')
	                )
	              )
	            ),
	            this.state.sent === true && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                _reactReduxI18n.I18n.t('RESET_PASSWORD_CONFIRMATION')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'no-account' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/labels' },
	                  _reactReduxI18n.I18n.t('RESET_PASSWORD_BACK')
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ForgotPasswordPage;
	}(_react2.default.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ forgotPassword: _actions.forgotPassword }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ForgotPasswordPage);

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(28);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _FormInput = __webpack_require__(49);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _apiEndpoints = __webpack_require__(76);
	
	var endpoints = _interopRequireWildcard(_apiEndpoints);
	
	var _DemoModal = __webpack_require__(575);
	
	var _DemoModal2 = _interopRequireDefault(_DemoModal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement('span', { className: 'lnr lnr-cross-circle', 'aria-hidden': 'true' });
	
	var _ref3 = _react2.default.createElement(_reduxForm.Field, { name: 'remember',
	  component: _FormInput2.default,
	  type: 'checkbox',
	  className: 'form-checkbox'
	});
	
	var LoginForm = function LoginForm(_ref) {
	  var attemptingLogin = _ref.attemptingLogin,
	      handleSubmit = _ref.handleSubmit,
	      submitFailed = _ref.submitFailed,
	      isOpen = _ref.isOpen,
	      onDemoClose = _ref.onDemoClose,
	      onStartDemo = _ref.onStartDemo,
	      onOpenDemoModal = _ref.onOpenDemoModal;
	
	  var signupLink = endpoints.SIGNUP_EN;
	  var browserLanguage = window.navigator.language;
	  browserLanguage = browserLanguage.substring(0, 2);
	  if (browserLanguage === 'de') {
	    signupLink = endpoints.SIGNUP_DE;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'login-form-container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container login' },
	      _react2.default.createElement(
	        'form',
	        { className: 'form-login', onSubmit: handleSubmit },
	        _react2.default.createElement(
	          'div',
	          { className: 'logo-login' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/' },
	            _reactReduxI18n.I18n.t('pet_data')
	          )
	        ),
	        submitFailed && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger', role: 'alert' },
	          _ref2,
	          _react2.default.createElement(
	            'span',
	            { className: 'form-error-text' },
	            _reactReduxI18n.I18n.t('INVALID_CREDENTIALS')
	          ),
	          _reactReduxI18n.I18n.t('PLEASE_REENTER')
	        ),
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'email', className: 'sr-only' },
	          _reactReduxI18n.I18n.t('EMAIL_ADDRESS')
	        ),
	        _react2.default.createElement(_reduxForm.Field, { name: 'email',
	          component: _FormInput2.default,
	          type: 'text',
	          className: 'form-control',
	          placeholder: _reactReduxI18n.I18n.t('EMAIL_ADDRESS')
	        }),
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'password', className: 'sr-only' },
	          _reactReduxI18n.I18n.t('PASSWORD')
	        ),
	        _react2.default.createElement(_reduxForm.Field, { name: 'password',
	          component: _FormInput2.default,
	          type: 'password',
	          className: 'form-control',
	          placeholder: _reactReduxI18n.I18n.t('PASSWORD')
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'forgot-password' },
	          _ref3,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'checkRemember', className: 'checkbox-label' },
	            _reactReduxI18n.I18n.t('REMEMBER_ME')
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/forgot', className: 'forgot-password-link' },
	            _reactReduxI18n.I18n.t('FORGOT_PASSWORD')
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { type: 'submit', className: 'btn btn-login', disabled: attemptingLogin },
	          _reactReduxI18n.I18n.t('LOG_IN')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'no-account' },
	          _reactReduxI18n.I18n.t('NO_ACCOUNT')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'account-text' },
	          _react2.default.createElement(
	            'a',
	            { href: signupLink, target: '_blank' },
	            _reactReduxI18n.I18n.t('SIGN_UP')
	          ),
	          _reactReduxI18n.I18n.t('OR'),
	          _react2.default.createElement(
	            'a',
	            { onClick: function onClick(e) {
	                e.preventDefault();onOpenDemoModal();
	              }, href: '' },
	            _reactReduxI18n.I18n.t('VIEW_DEMO')
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_DemoModal2.default, { isOpen: isOpen, onClose: onDemoClose, onStartDemo: onStartDemo })
	  );
	};
	
	exports.default = (0, _reduxForm.reduxForm)()(LoginForm);

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _redux = __webpack_require__(12);
	
	var _LoginForm = __webpack_require__(577);
	
	var _LoginForm2 = _interopRequireDefault(_LoginForm);
	
	var _actions = __webpack_require__(169);
	
	var _selectors = __webpack_require__(268);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formName = 'loginForm';
	
	function handleFormSubmit(values, dispatch) {
	  return new Promise(function (resolve, reject) {
	    dispatch((0, _actions.login)(values)).then(function () {
	      resolve();
	    }).catch(function () {
	      reject();
	    });
	  });
	}
	
	function handleDemoLogin(language) {
	  var user = 'demo' + language + '@petdata.at';
	  return function (dispatch) {
	    dispatch((0, _actions.login)({ email: user, password: 'Test1234' }));
	  };
	}
	
	function handleSubmitFail(errors, dispatch) {
	  dispatch((0, _reduxForm.change)(formName, 'password', ''));
	}
	
	function handleFormValidation(values) {
	  var invalid_credentials = _reactReduxI18n.I18n.t('INVALID_CREDENTIALS');
	
	  var errors = {};
	
	  if (!values.email) {
	    errors.email = invalid_credentials;
	  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
	    errors.email = invalid_credentials;
	  }
	
	  if (!values.password) {
	    errors.password = invalid_credentials;
	  }
	
	  return errors;
	}
	
	var LoginPage = function LoginPage(_ref) {
	  var actions = _ref.actions,
	      remember = _ref.remember,
	      rememberEmail = _ref.rememberEmail,
	      demoModalOpen = _ref.demoModalOpen;
	
	  return _react2.default.createElement(_LoginForm2.default, { form: formName,
	    onSubmit: handleFormSubmit,
	    onSubmitFail: handleSubmitFail,
	    validate: handleFormValidation,
	    isOpen: demoModalOpen,
	    onDemoClose: actions.hideDemoModal,
	    onStartDemo: actions.handleDemoLogin,
	    onOpenDemoModal: actions.showDemoModal,
	    initialValues: { remember: remember, email: rememberEmail, password: '' }
	  });
	};
	
	function mapStateToProps(state) {
	  return {
	    attemptingLogin: (0, _selectors.isAttemptingLogin)(state),
	    demoModalOpen: (0, _selectors.isDemoModalOpen)(state),
	    remember: localStorage.rememberUserName ? true : false,
	    rememberEmail: localStorage.rememberUserName
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ showDemoModal: _actions.showDemoModal, hideDemoModal: _actions.hideDemoModal, handleDemoLogin: handleDemoLogin }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LoginPage);

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ForgotPasswordPage = exports.LoginPage = undefined;
	
	var _LoginPage = __webpack_require__(578);
	
	var _LoginPage2 = _interopRequireDefault(_LoginPage);
	
	var _ForgotPasswordPage = __webpack_require__(576);
	
	var _ForgotPasswordPage2 = _interopRequireDefault(_ForgotPasswordPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.LoginPage = _LoginPage2.default;
	exports.ForgotPasswordPage = _ForgotPasswordPage2.default;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	
	var _actionTypes = __webpack_require__(266);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialCredentials = {
	  userName: '',
	  fullName: '',
	  isActive: false,
	  isDemoUser: false,
	  isMasterUser: false
	};
	
	var initialState = {
	  attemptingLogin: false,
	  showDemoModal: false,
	  attemptingLogout: false,
	  authenticated: false,
	  contextLoaded: false,
	  credentials: initialCredentials,
	  subscriptions: [],
	  activeSubscriptionId: 0,
	  managementLink: ''
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case types.CUSTOMER_LOGIN_ATTEMPT:
	      return _extends({}, state, {
	        attemptingLogin: true
	      });
	    case types.CUSTOMER_LOGIN_SUCCESS:
	      return _extends({}, state, {
	        attemptingLogin: false,
	        authenticated: true,
	        credentials: {
	          userName: action.payload.userName,
	          fullName: action.payload.fullName,
	          isActive: action.payload.isActive,
	          isDemoUser: action.payload.isDemoUser,
	          isMasterUser: action.payload.isMasterUser
	        }
	      });
	    case types.CUSTOMER_LOGIN_FAIL:
	      return _extends({}, state, {
	        attemptingLogin: false
	      });
	    case types.SHOW_DEMO_MODAL:
	      return _extends({}, state, {
	        showDemoModal: true
	      });
	    case types.HIDE_DEMO_MODAL:
	      return _extends({}, state, {
	        showDemoModal: false
	      });
	    case types.CUSTOMER_LOGOUT:
	      return _extends({}, state, {
	        authenticated: false,
	        contextLoaded: false,
	        credentials: initialCredentials,
	        subscriptions: [],
	        activeSubscriptionId: 0
	      });
	    case types.CUSTOMER_CONTEXT_RECEIVED:
	      return _extends({}, state, {
	        contextLoaded: true,
	        credentials: {
	          userName: action.payload.userName,
	          fullName: action.payload.fullName,
	          isActive: action.payload.isActive,
	          isDemoUser: action.payload.isDemoUser,
	          isMasterUser: action.payload.isMasterUser
	        },
	        subscriptions: action.payload.subscriptionList,
	        activeSubscriptionId: action.payload.activeSubscriptionId,
	        managementLink: action.payload.managementLink
	      });
	    case types.TOKEN_LOGIN_SUCCESS:
	      return _extends({}, state, {
	        authenticated: true
	      });
	    case types.SET_ACTIVE_SUBSCRIPTION:
	      // We don't need to set the state if it's already equal, that way we avoid an unneeded render
	      if (state.activeSubscriptionId === action.payload.activeSubscriptionId) {
	        return state;
	      }
	      return _extends({}, state, {
	        activeSubscriptionId: action.payload.activeSubscriptionId,
	        managementLink: action.payload.managementLink
	      });
	    case types.UPDATE_LABEL_STYLES:
	      {
	        var subscriptions = JSON.parse(JSON.stringify(state.subscriptions));
	        for (var x = 0; x < subscriptions.length; x++) {
	          if (subscriptions[x].id === state.activeSubscriptionId) subscriptions[x].styles = action.payload.LabelStyles;
	        }
	        return _extends({}, state, {
	          subscriptions: subscriptions
	        });
	      }
	    case types.UPDATE_LABEL_LOGOS:
	      {
	        var _subscriptions = JSON.parse(JSON.stringify(state.subscriptions));
	        for (var _x3 = 0; _x3 < _subscriptions.length; _x3++) {
	          if (_subscriptions[_x3].id === state.activeSubscriptionId) _subscriptions[_x3].logos = action.payload.LabelLogos;
	        }
	        return _extends({}, state, {
	          subscriptions: _subscriptions
	        });
	      }
	    case types.UPDATE_LABEL_OFFSET:
	      {
	        var _subscriptions2 = JSON.parse(JSON.stringify(state.subscriptions));
	        for (var _x4 = 0; _x4 < _subscriptions2.length; _x4++) {
	          if (_subscriptions2[_x4].id === state.activeSubscriptionId) {
	            _subscriptions2[_x4].pageOffset = action.payload.pageOffset;
	
	            _subscriptions2[_x4].isPaperSizeLetter = action.payload.isPaperSizeLetter;
	
	            _subscriptions2[_x4].usePLUCode = action.payload.usePLUCode;
	
	            _subscriptions2[_x4].useUSMetrics = action.payload.useUSMetrics;
	
	            _subscriptions2[_x4].labelTitleOrder = action.payload.labelTitleOrder;
	          }
	        }
	        return _extends({}, state, {
	          subscriptions: _subscriptions2
	        });
	      }
	    default:
	      return state;
	  }
	}

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import FormInput from '../../common/components/FormInput';
	
	
	var _ref2 = _react2.default.createElement(
	  'div',
	  { className: 'col-lg-10 col-sm-10' },
	  _react2.default.createElement(
	    _reduxForm.Field,
	    { name: 'IsPaperSizeLetter', component: 'select' },
	    _react2.default.createElement(
	      'option',
	      { value: 'false' },
	      'A4'
	    ),
	    _react2.default.createElement(
	      'option',
	      { value: 'true' },
	      'Letter'
	    )
	  )
	);
	
	var _ref3 = _react2.default.createElement('br', null);
	
	var _ref4 = _react2.default.createElement(
	  'div',
	  { className: 'col-lg-10 col-sm-10' },
	  _react2.default.createElement(_reduxForm.Field, { name: 'pageOffset.PosX',
	    component: 'input',
	    type: 'number',
	    className: 'form-control'
	  })
	);
	
	var _ref5 = _react2.default.createElement(
	  'div',
	  { className: 'col-lg-10 col-sm-10' },
	  _react2.default.createElement(_reduxForm.Field, { name: 'pageOffset.PosY',
	    component: 'input',
	    type: 'number',
	    className: 'form-control'
	  })
	);
	
	var AdvancedSettingsForm = function AdvancedSettingsForm(_ref) {
	  var handleSubmit = _ref.handleSubmit,
	      submitting = _ref.submitting,
	      handleCancel = _ref.handleCancel,
	      isEnglishIn = _ref.isEnglishIn;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'form',
	      { onSubmit: handleSubmit },
	      _react2.default.createElement(
	        'h5',
	        null,
	        _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_HEADER_TITLE')
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_HEADER_DESCRIPTION')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'example-text-input', className: 'col-lg-2 col-sm-2 col-form-label' },
	          _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_HEADER_FIELD')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-10 col-sm-10' },
	          _react2.default.createElement(
	            _reduxForm.Field,
	            { name: 'LabelTitleOrder', component: 'select' },
	            _react2.default.createElement(
	              'option',
	              { value: '0' },
	              _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_HEADER_LAT_N')
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: '1' },
	              _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_HEADER_N_LAT')
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: '2' },
	              _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_HEADER_IN_N_LAT')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'h5',
	        null,
	        _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_PLU_TITLE')
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_PLU_DESCRIPTION')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'example-text-input', className: 'col-lg-2 col-sm-2 col-form-label' },
	          _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_PLU_FIELD')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-10 col-sm-10' },
	          _react2.default.createElement(
	            _reduxForm.Field,
	            { name: 'UsePLUCode', component: 'select' },
	            _react2.default.createElement(
	              'option',
	              { value: 'true' },
	              _reactReduxI18n.I18n.t('YES')
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'false' },
	              _reactReduxI18n.I18n.t('NO')
	            )
	          )
	        )
	      ),
	      isEnglishIn && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h5',
	          null,
	          _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_METRIC_TITLE')
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_METRIC_DESCRIPTION')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'example-text-input', className: 'col-lg-2 col-sm-2 col-form-label' },
	            _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_METRIC_FIELD')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-10 col-sm-10' },
	            _react2.default.createElement(
	              _reduxForm.Field,
	              { name: 'UseUSMetrics', component: 'select' },
	              _react2.default.createElement(
	                'option',
	                { value: 'false' },
	                _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_METRIC_EU')
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'true' },
	                _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_METRIC_US')
	              )
	            )
	          )
	        )
	      ),
	      isEnglishIn && false && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h5',
	          null,
	          _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_TITLE')
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_DESCRIPTION')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'example-text-input', className: 'col-lg-2 col-sm-2 col-form-label' },
	            _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_FIELD')
	          ),
	          _ref2
	        )
	      ),
	      _react2.default.createElement(
	        'h5',
	        null,
	        _reactReduxI18n.I18n.t('PRINTER_ADJUSTMENT')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _reactReduxI18n.I18n.t('ADJUSTMENT_INSTRUCTIONS') } }),
	          _ref3
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'example-text-input', className: 'col-lg-2 col-sm-2 col-form-label' },
	          _reactReduxI18n.I18n.t('B_HORIZONTAL')
	        ),
	        _ref4
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'example-text-input', className: 'col-lg-2 col-sm-2 col-form-label' },
	          _reactReduxI18n.I18n.t('A_VERTICAL')
	        ),
	        _ref5
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'label-customize ' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row no-gutters bottom-buttons' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 text-right' },
	            _react2.default.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-secondary', onClick: handleCancel },
	              _reactReduxI18n.I18n.t('CANCEL')
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'submit', className: 'btn btn-primary', disabled: submitting },
	              _reactReduxI18n.I18n.t('SAVE')
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _reduxForm.reduxForm)()(AdvancedSettingsForm);

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _actions = __webpack_require__(33);
	
	var _CloseButton = __webpack_require__(107);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _AdvancedSettingsForm = __webpack_require__(581);
	
	var _AdvancedSettingsForm2 = _interopRequireDefault(_AdvancedSettingsForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {formValueSelector} from 'redux-form';
	
	
	var _customer$selectors = _customer2.default.selectors,
	    getActivePermissions = _customer$selectors.getActivePermissions,
	    getIsPaperSizeLetter = _customer$selectors.getIsPaperSizeLetter,
	    getUsePLUCode = _customer$selectors.getUsePLUCode,
	    getUseUSMetrics = _customer$selectors.getUseUSMetrics,
	    getLabelTitleOrder = _customer$selectors.getLabelTitleOrder,
	    getActivePageOffset = _customer$selectors.getActivePageOffset,
	    getIsEnglish = _customer$selectors.getIsEnglish;
	//import {areSettingsValid, getStoreSettings} from '../selectors';
	
	//import * as permissions from '../../common/userPermissions';
	
	var formName = 'advancedSettingsForm';
	//const formSelector = formValueSelector(formName);
	
	var _ref2 = _react2.default.createElement(_CloseButton2.default, { url: '/labels' });
	
	var _ref3 = _react2.default.createElement(
	  'p',
	  null,
	  ' '
	);
	
	var _ref4 = _react2.default.createElement('div', { className: 'loading' });
	
	var _ref5 = _react2.default.createElement('div', { className: 'row no-gutters' });
	
	var AdvancedSettingsPage = function (_React$Component) {
	  _inherits(AdvancedSettingsPage, _React$Component);
	
	  function AdvancedSettingsPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AdvancedSettingsPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdvancedSettingsPage.__proto__ || Object.getPrototypeOf(AdvancedSettingsPage)).call.apply(_ref, [this].concat(args))), _this), _this.handleCancel = function () {
	      _this.props.actions.push('/labels');
	    }, _this.handleFormSubmit = function (values) {
	      _this.props.actions.saveLabelSettings(values.IsPaperSizeLetter, values.UsePLUCode, values.UseUSMetrics, values.LabelTitleOrder, values.pageOffset.PosY, values.pageOffset.PosX);
	      _this.props.actions.clearLabelSheet();
	      _this.props.actions.push('/labels');
	
	      /* return new Promise((resolve, reject) => {
	        this.props.actions.saveLabelSettings(values.IsPaperSizeLetter,values.UsePLUCode ,values.UseUSMetrics, values.LabelTitleOrder  , values.VerticalOffset, values.HorizontalOffset)
	          .then(() => {
	            resolve();
	          })
	          .catch(() => {
	            reject();
	          });
	      }); */
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AdvancedSettingsPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	    /*  const accessPermission = this.props.activePermissions.find((permission) => {
	        return permission === permissions.MANAGE_LOGO;
	      });
	      if(!accessPermission)
	      {
	        this.props.actions.push('/labels');
	      } 
	        this.props.actions.getCareSheetSettings();
	      */
	
	
	    // componentWillReceiveProps(nextProps) {
	    /*   if(this.props.authData.activeSubscriptionId !== nextProps.authData.activeSubscriptionId) {
	         this.props.actions.getCareSheetSettings();
	       }
	       */
	    //}
	
	  }, {
	    key: 'render',
	    value: function render() {
	      // const {actions: {uploadLogo}, useLogo, storeSettings, validSettings} = this.props;
	      var validSettings = true;
	      var test = this.props.isEnglish;
	      if (test) test = false;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid main full-width', id: 'main' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-12' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'float-left' },
	              _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LABEL_PAGE_TITLE')
	            ),
	            _ref2
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-12' },
	            _ref3,
	            !validSettings && _ref4,
	            validSettings && _react2.default.createElement(
	              'div',
	              null,
	              _ref5,
	              _react2.default.createElement(_AdvancedSettingsForm2.default, { form: formName,
	                initialValues: { IsPaperSizeLetter: this.props.isPaperSizeLetter,
	                  UsePLUCode: this.props.usePLUCode,
	                  UseUSMetrics: this.props.useUSMetrics,
	                  LabelTitleOrder: this.props.labelTitleOrder,
	
	                  pageOffset: this.props.pageOffset },
	                onSubmit: this.handleFormSubmit,
	                handleCancel: this.handleCancel
	                /*                            storeSettings={{IsPaperSizeLetter: this.props.isPaperSizeLetter, 
	                                            UsePLUCode: this.props.usePLUCode,
	                                            UseUSMetrics: this.props.useUSMetrics, 
	                                            LabelTitleOrder: this.props.labelTitleOrder}}
	                                           useLogo={true}  */
	                , isEnglishIn: this.props.isEnglish
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdvancedSettingsPage;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    activePermissions: getActivePermissions(state),
	    // useLogo: formSelector(state, 'useLogo'),
	    isPaperSizeLetter: getIsPaperSizeLetter(state),
	    useUSMetrics: getUseUSMetrics(state),
	    usePLUCode: getUsePLUCode(state),
	    labelTitleOrder: getLabelTitleOrder(state),
	    pageOffset: getActivePageOffset(state),
	    isEnglish: getIsEnglish(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    // actions: bindActionCreators({getCareSheetSettings, uploadLogo, saveStoreSettings, push}, dispatch)
	    actions: (0, _redux.bindActionCreators)({ saveLabelSettings: _actions.saveLabelSettings, clearLabelSheet: _actions.clearLabelSheet, push: _reactRouterRedux.push }, dispatch)
	  };
	}
	
	AdvancedSettingsPage.defaultProps = {
	  usePLUCode: true,
	  useUSMetrics: false,
	  isPaperSizeLetter: false,
	  labelTitleOrder: 0,
	  isEnglish: false
	
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AdvancedSettingsPage);

/***/ },
/* 583 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ArticleColumnsEN = exports.ArticleColumnsEN = [{
	  key: 'Id',
	  name: 'ID',
	  editable: false,
	  filterable: true,
	  sortable: true,
	  width: 80
	}, {
	  key: 'Line1',
	  name: 'Lat. Name',
	  editable: false,
	  filterable: true,
	  sortable: true
	}, {
	  key: 'Line2',
	  name: 'Name',
	  editable: false,
	  filterable: true,
	  sortable: true
	}, {
	  key: 'PetType',
	  name: 'Pet Type',
	  editable: false,
	  filterable: true,
	  sortable: true
	}, {
	  key: 'CustomerName',
	  name: 'Integration Name',
	  editable: true,
	  filterable: true,
	  sortable: true,
	  width: 150
	}, {
	  key: 'Price',
	  name: 'Price',
	  editable: true,
	  filterable: true,
	  sortable: true,
	  width: 80
	}, {
	  key: 'Barcode',
	  name: 'EAN',
	  editable: true,
	  filterable: true,
	  sortable: true,
	  width: 100
	}, {
	  key: 'PLUCode',
	  name: 'PLU',
	  editable: true,
	  filterable: true,
	  sortable: true,
	  width: 80
	}];
	
	var ArticleColumnsDE = exports.ArticleColumnsDE = [{
	  key: 'Id',
	  name: 'ID',
	  editable: false,
	  filterable: true,
	  sortable: true,
	  width: 80
	}, {
	  key: 'Line1',
	  name: 'Lat. Name',
	  editable: false,
	  filterable: true,
	  sortable: true
	}, {
	  key: 'Line2',
	  name: 'Name',
	  editable: false,
	  filterable: true,
	  sortable: true
	}, {
	  key: 'PetType',
	  name: 'Tiertyp',
	  editable: false,
	  filterable: true,
	  sortable: true
	}, {
	  key: 'CustomerName',
	  name: 'Integrationsname',
	  editable: true,
	  filterable: true,
	  sortable: true,
	  width: 150
	}, {
	  key: 'Price',
	  name: 'Preis',
	  editable: true,
	  filterable: true,
	  sortable: true,
	  width: 80
	}, {
	  key: 'Barcode',
	  name: 'EAN',
	  editable: true,
	  filterable: true,
	  sortable: true,
	  width: 100
	}, {
	  key: 'PLUCode',
	  name: 'PLU',
	  editable: true,
	  filterable: true,
	  sortable: true,
	  width: 80
	}];

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGridAddons = __webpack_require__(481);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContextMenu = _reactDataGridAddons.Menu.ContextMenu,
	    MenuItem = _reactDataGridAddons.Menu.MenuItem;
	
	var ArticlesContext = function (_React$Component) {
		_inherits(ArticlesContext, _React$Component);
	
		function ArticlesContext() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ArticlesContext);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ArticlesContext.__proto__ || Object.getPrototypeOf(ArticlesContext)).call.apply(_ref, [this].concat(args))), _this), _this.onRowCopy = function (e, data) {
				_this.props.onRowCopy(e, data);
			}, _this.onRowDelete = function (e, data) {
				_this.props.onRowDelete(e, data);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ArticlesContext, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					ContextMenu,
					null,
					_react2.default.createElement(
						MenuItem,
						{ data: { rowIdx: this.props.rowIdx, idx: this.props.idx }, onClick: this.onRowCopy },
						_reactReduxI18n.I18n.t('DUPLICATE_ROW')
					),
					_react2.default.createElement(
						MenuItem,
						{ data: { rowIdx: this.props.rowIdx, idx: this.props.idx }, onClick: this.onRowDelete },
						_reactReduxI18n.I18n.t('CLEAR_ROW')
					)
				);
			}
		}]);
	
		return ArticlesContext;
	}(_react2.default.Component);
	
	exports.default = ArticlesContext;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reactDataGrid = __webpack_require__(1030);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(481);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _ArticlesContext = __webpack_require__(584);
	
	var _ArticlesContext2 = _interopRequireDefault(_ArticlesContext);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _apiEndpoints = __webpack_require__(76);
	
	var _actions = __webpack_require__(33);
	
	var _selectors = __webpack_require__(57);
	
	var _ArticleColumns = __webpack_require__(583);
	
	var _userPermissions = __webpack_require__(29);
	
	var permissions = _interopRequireWildcard(_userPermissions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _customer$selectors = _customer2.default.selectors,
	    getActiveExcelKey = _customer$selectors.getActiveExcelKey,
	    getActiveSubscriptionId = _customer$selectors.getActiveSubscriptionId,
	    getActivePermissions = _customer$selectors.getActivePermissions;
	
	var _ref5 = _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableAddRow: false, enableFilter: true, filterRowsButtonText: 'Filter' });
	
	var ArticlesPage = function (_React$Component) {
	  _inherits(ArticlesPage, _React$Component);
	
	  function ArticlesPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ArticlesPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ArticlesPage.__proto__ || Object.getPrototypeOf(ArticlesPage)).call.apply(_ref, [this].concat(args))), _this), _this.rowGetter = function (i) {
	      return _this.props.articleList[i];
	    }, _this.handleFilterChange = function (filter) {
	      _this.props.actions.addArticleFilter(filter.column.key, filter.filterTerm);
	    }, _this.onClearFilters = function () {
	      _this.props.actions.clearArticleFilters();
	    }, _this.handleGridRowsUpdated = function (_ref2) {
	      var fromRow = _ref2.fromRow,
	          updated = _ref2.updated;
	
	      var key = Object.keys(updated)[0];
	      _this.props.actions.updateLabelArticle(_this.props.articleList[fromRow], key, updated[key]);
	      _this.props.actions.petLabelListReload(false);
	    }, _this.handleGridSort = function (sortColumn, sortDirection) {
	      _this.props.actions.sortArticles(sortColumn, sortDirection);
	    }, _this.deleteArticle = function (e, _ref3) {
	      var rowIdx = _ref3.rowIdx;
	
	      _this.props.actions.deleteArticleMapping(_this.props.articleList[rowIdx]);
	      _this.props.actions.petLabelListReload(false);
	    }, _this.copyArticle = function (e, _ref4) {
	      var rowIdx = _ref4.rowIdx;
	
	      _this.props.actions.addArticleMapping(_this.props.articleList[rowIdx]);
	      _this.props.actions.petLabelListReload(false);
	    }, _this.onUpload = function (excelFile) {
	      _this.props.actions.uploadExcelFile(excelFile);
	      _this.props.actions.petLabelListReload(false);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ArticlesPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var accessPermission = this.props.activePermissions.find(function (permission) {
	        return permission === permissions.MANAGE_ARTICLES;
	      });
	      if (!accessPermission) {
	        this.props.actions.push('/labels');
	      }
	
	      this.props.actions.getArticleList();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var excelDownloadUrl = _apiEndpoints.ARTICLE_EXCEL_DOWNLOAD + '?subscriptionID=' + this.props.subscriptionId + '&key=' + this.props.excelKey;
	
	      var articleColumns = _ArticleColumns.ArticleColumnsDE;
	      var browserLanguage = window.navigator.language;
	      browserLanguage = browserLanguage.substring(0, 2);
	      if (browserLanguage === 'en') {
	        articleColumns = _ArticleColumns.ArticleColumnsEN;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid main', id: 'main' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-12' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              _reactReduxI18n.I18n.t('ARTICLE_MANAGEMENT')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _reactReduxI18n.I18n.t('ARTICLE_INSTRUCTIONS')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pt-4' },
	              _react2.default.createElement(
	                'label',
	                { className: 'custom-file btn-upload float-right' },
	                _react2.default.createElement('input', { type: 'file', id: 'file',
	                  className: 'custom-file-input',
	                  accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet application/vnd.ms-excel .csv',
	                  onChange: function onChange(e) {
	                    _this2.onUpload(e.target.files[0]);
	                  } }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'custom-file-control' },
	                  _reactReduxI18n.I18n.t('UPLOAD_FILE')
	                )
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: excelDownloadUrl, className: 'btn btn-primary float-right', download: true },
	                _reactReduxI18n.I18n.t('EXPORT_TO_EXCEL')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'data-grid-wrapper' },
	          this.props.articlesValid && _react2.default.createElement(_reactDataGrid2.default, {
	            contextMenu: _react2.default.createElement(_ArticlesContext2.default, { onRowDelete: this.deleteArticle, onRowCopy: this.copyArticle }),
	            enableCellSelect: true,
	            columns: articleColumns,
	            rowGetter: this.rowGetter,
	            rowsCount: this.props.articleList.length,
	            onGridRowsUpdated: this.handleGridRowsUpdated,
	            onGridSort: this.handleGridSort,
	            toolbar: _ref5,
	            onAddFilter: this.handleFilterChange,
	            onClearFilters: this.onClearFilters
	          })
	        )
	      );
	    }
	  }]);
	
	  return ArticlesPage;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    articleList: (0, _selectors.getShownArticles)(state),
	    articlesValid: (0, _selectors.areArticlesValid)(state),
	    activePermissions: getActivePermissions(state),
	    excelKey: getActiveExcelKey(state),
	    subscriptionId: getActiveSubscriptionId(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ addArticleMapping: _actions.addArticleMapping,
	      deleteArticleMapping: _actions.deleteArticleMapping,
	      getArticleList: _actions.getArticleList,
	      sortArticles: _actions.sortArticles,
	      updateLabelArticle: _actions.updateLabelArticle,
	      uploadExcelFile: _actions.uploadExcelFile,
	      clearArticleFilters: _actions.clearArticleFilters,
	      addArticleFilter: _actions.addArticleFilter,
	      petLabelListReload: _actions.petLabelListReload,
	      push: _reactRouterRedux.push }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ArticlesPage);

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _actions = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BackButton = function (_React$Component) {
	  _inherits(BackButton, _React$Component);
	
	  function BackButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BackButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BackButton.__proto__ || Object.getPrototypeOf(BackButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
	      _this.props.actions.clearSearchResults();
	      _this.props.actions.deselectPetLabel();
	      _this.props.actions.clearActiveLabel();
	      _this.props.actions.push(_this.props.url);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BackButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'btn btn-primary-back', onClick: this.handleClick },
	        _reactReduxI18n.I18n.t('BACK_TO_LABELS_SEARCH_RESULTS')
	      );
	    }
	  }]);
	
	  return BackButton;
	}(_react2.default.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ clearActiveLabel: _actions.clearActiveLabel, clearSearchResults: _actions.clearSearchResults, deselectPetLabel: _actions.deselectPetLabel, push: _reactRouterRedux.push }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(BackButton);

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouter = __webpack_require__(28);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _thenby = __webpack_require__(91);
	
	var _thenby2 = _interopRequireDefault(_thenby);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _actions = __webpack_require__(33);
	
	var _selectors = __webpack_require__(57);
	
	var _CloseButton = __webpack_require__(107);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _LabelCol2Form = __webpack_require__(170);
	
	var _LabelCol2Form2 = _interopRequireDefault(_LabelCol2Form);
	
	var _LabelCol4Form = __webpack_require__(171);
	
	var _LabelCol4Form2 = _interopRequireDefault(_LabelCol4Form);
	
	var _LabelCol4LrgForm = __webpack_require__(172);
	
	var _LabelCol4LrgForm2 = _interopRequireDefault(_LabelCol4LrgForm);
	
	var _userPermissions = __webpack_require__(29);
	
	var permissions = _interopRequireWildcard(_userPermissions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _customer$selectors = _customer2.default.selectors,
	    getActivePermissions = _customer$selectors.getActivePermissions,
	    getUsePLUCode = _customer$selectors.getUsePLUCode;
	
	
	var formName = "createLabelForm";
	
	var _ref = _react2.default.createElement(_CloseButton2.default, { url: '/labels' });
	
	var _ref2 = _react2.default.createElement('div', { className: 'loading' });
	
	var CreateLabelPage = function (_React$Component) {
	  _inherits(CreateLabelPage, _React$Component);
	
	  function CreateLabelPage(props) {
	    _classCallCheck(this, CreateLabelPage);
	
	    var _this = _possibleConstructorReturn(this, (CreateLabelPage.__proto__ || Object.getPrototypeOf(CreateLabelPage)).call(this, props));
	
	    _this.handleBack = function () {
	      _this.props.actions.deselectPetLabel();
	      _this.props.actions.clearActiveLabel();
	    };
	
	    _this.handleFormSubmit = function (values) {
	      _this.props.actions.saveLabelToSheet(_this.props.activePageSize, _this.props.activePetLabel, _this.state.fieldMapping, _this.props.activePLU, values);
	    };
	
	    _this.state = {
	      fieldMapping: []
	    };
	    return _this;
	  }
	
	  _createClass(CreateLabelPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var labelAccess = this.props.activePermissions.find(function (permission) {
	        return permission === permissions.ACCESS_LABELS;
	      });
	      if (!labelAccess) {
	        this.props.actions.push('/labels');
	      } else if (this.props.selectedGridIndex < 0 || this.props.selectedPetLabelId < 0) {
	        this.props.actions.push('/labels');
	      } else {
	        this.props.actions.getPetLabel(this.props.selectedPetLabelId, this.props.activePageSize, this.props.selectedArticleMappingId);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (this.props.activePetLabel !== newProps.activePetLabel && Object.keys(newProps.activePetLabel).length !== 0) {
	        var columns = newProps.fieldPositions.reduce(function (prev, current) {
	          return prev.Column > current.Column ? prev.Column : current.Column;
	        });
	
	        // Make sure the field positions are sorted properly
	        if (columns === 0) {
	          newProps.fieldPositions.sort((0, _thenby2.default)("Column").thenBy("Row"));
	        } else if (columns === 1) {
	          newProps.fieldPositions.sort((0, _thenby2.default)("Row").thenBy("Column"));
	        }
	
	        // Sort the fields into the correct order
	        var labelFields = [];
	        newProps.fieldPositions.forEach(function (position) {
	          var labelField = newProps.activePetLabel.DetailFields.find(function (detailField) {
	            return detailField.Key === position.Field;
	          });
	          labelFields.push(labelField);
	        });
	
	        // Build the mapping from the ordered fields
	        var fieldMapping = [];
	        labelFields.forEach(function (detailField, index) {
	          if (detailField !== undefined) {
	            var keyName = 'Key' + index;
	            var valueName = 'Value' + index;
	            var mapping = {
	              name: detailField.Key,
	              key: keyName,
	              value: valueName
	            };
	            fieldMapping.push(mapping);
	          }
	        });
	        this.setState({ fieldMapping: fieldMapping });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeLogoUrl = _props.activeLogoUrl,
	          activePageSize = _props.activePageSize,
	          activePetLabel = _props.activePetLabel,
	          activePLU = _props.activePLU,
	          fieldPositions = _props.fieldPositions;
	
	      var validLabel = Object.keys(activePetLabel).length !== 0;
	      var large = false;
	      if (activePageSize === '195 x 66 mm') {
	        large = true;
	      }
	
	      var columns = -1;
	      var labelFields = [];
	      var initialValues = {};
	      if (validLabel) {
	        // We need the max column to select the proper label template
	        columns = fieldPositions.reduce(function (prev, current) {
	          return prev.Column > current.Column ? prev.Column : current.Column;
	        });
	
	        // Sort the fields into the correct order
	        fieldPositions.forEach(function (position) {
	          var labelField = activePetLabel.DetailFields.find(function (detailField) {
	            return detailField.Key === position.Field;
	          });
	          labelFields.push(labelField);
	        });
	
	        initialValues["line1"] = activePetLabel.Line1;
	        initialValues["line2"] = activePetLabel.Line2;
	        initialValues["plu"] = activePetLabel.PLUCode;
	        initialValues["barcode"] = activePetLabel.Barcode;
	        initialValues["pluKey"] = activePetLabel.PLUCodeTitle !== null ? activePetLabel.PLUCodeTitle : 'PLU';
	
	        if (activePetLabel.Price !== null && activePetLabel.Price !== undefined) {
	          initialValues["price"] = activePetLabel.Price;
	        }
	
	        labelFields.forEach(function (detailField, index) {
	          if (detailField !== undefined) {
	            var keyName = 'Key' + index;
	            var valueName = 'Value' + index;
	            initialValues[keyName] = detailField.Key;
	            initialValues[valueName] = detailField.Value;
	          }
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid main full-width', id: 'main' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'float-left' },
	                _reactReduxI18n.I18n.t('CREATE_LABEL')
	              ),
	              _ref,
	              _react2.default.createElement(
	                'div',
	                { className: 'back' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/pet_search', onClick: this.handleBack },
	                  _reactReduxI18n.I18n.t('BACK_SEARCH_RESULTS')
	                )
	              )
	            )
	          ),
	          !validLabel && _ref2,
	          validLabel && columns === 0 && _react2.default.createElement(_LabelCol2Form2.default, { activePLU: activePLU,
	            detailFields: labelFields,
	            form: formName,
	            initialValues: initialValues,
	            logoUrl: activeLogoUrl,
	            onSubmit: this.handleFormSubmit,
	            petLabel: activePetLabel,
	            submitButtonText: _reactReduxI18n.I18n.t('CREATE_LABEL')
	          }),
	          validLabel && columns === 1 && large === false && _react2.default.createElement(_LabelCol4Form2.default, { activePLU: activePLU,
	            detailFields: labelFields,
	            form: formName,
	            initialValues: initialValues,
	            logoUrl: activeLogoUrl,
	            onSubmit: this.handleFormSubmit,
	            petLabel: activePetLabel,
	            submitButtonText: _reactReduxI18n.I18n.t('CREATE_LABEL')
	          }),
	          validLabel && columns === 1 && large === true && _react2.default.createElement(_LabelCol4LrgForm2.default, { activePLU: activePLU,
	            detailFields: labelFields,
	            form: formName,
	            initialValues: initialValues,
	            logoUrl: activeLogoUrl,
	            onSubmit: this.handleFormSubmit,
	            petLabel: activePetLabel,
	            submitButtonText: _reactReduxI18n.I18n.t('CREATE_LABEL')
	          })
	        )
	      );
	    }
	  }]);
	
	  return CreateLabelPage;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    activeLogoUrl: (0, _selectors.getActiveLogo)(state),
	    activeDefinition: (0, _selectors.getActiveDefinition)(state),
	    activePageSize: (0, _selectors.getActivePageSize)(state),
	    activePermissions: getActivePermissions(state),
	    activePetLabel: (0, _selectors.getActivePetLabel)(state),
	    activePLU: getUsePLUCode(state),
	    fieldPositions: (0, _selectors.getFieldPositions)(state),
	    selectedGridIndex: (0, _selectors.getSelectedGridIndex)(state),
	    selectedPetLabelId: (0, _selectors.getSelectedPetLabelId)(state),
	    selectedArticleMappingId: (0, _selectors.getSelectedArticleMappingId)(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ change: _reduxForm.change, clearActiveLabel: _actions.clearActiveLabel, deselectPetLabel: _actions.deselectPetLabel, getPetLabel: _actions.getPetLabel, saveLabelToSheet: _actions.saveLabelToSheet, push: _reactRouterRedux.push }, dispatch)
	  };
	}
	
	CreateLabelPage.defaultProps = {
	  activeLogoUrl: ''
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CreateLabelPage);

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(56);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomDropdown = function (_React$Component) {
	  _inherits(CustomDropdown, _React$Component);
	
	  function CustomDropdown(props) {
	    _classCallCheck(this, CustomDropdown);
	
	    var _this = _possibleConstructorReturn(this, (CustomDropdown.__proto__ || Object.getPrototypeOf(CustomDropdown)).call(this, props));
	
	    _this.handleToggle = function () {
	      _this.setState({ isOpen: !_this.state.isOpen });
	    };
	
	    _this.state = {
	      isOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(CustomDropdown, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      //  const {petTypeList} = this.props;
	      var petTypeList = this.props.petTypeList.sort();
	
	      var petTypes = petTypeList.map(function (petType) {
	        return _react2.default.createElement(
	          _reactstrap.DropdownItem,
	          { key: petType, onClick: function onClick() {
	              _this2.props.onSelected(petType);
	            } },
	          petType
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dropdown float-right' },
	        _react2.default.createElement(
	          _reactstrap.Dropdown,
	          { isOpen: this.state.isOpen, toggle: this.handleToggle },
	          _react2.default.createElement(
	            _reactstrap.DropdownToggle,
	            { caret: true, color: 'secondary' },
	            _reactReduxI18n.I18n.t('CREATE_CUSTOM_LABEL')
	          ),
	          _react2.default.createElement(
	            _reactstrap.DropdownMenu,
	            null,
	            petTypes
	          )
	        )
	      );
	    }
	  }]);
	
	  return CustomDropdown;
	}(_react2.default.Component);
	
	exports.default = CustomDropdown;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _thenby = __webpack_require__(91);
	
	var _thenby2 = _interopRequireDefault(_thenby);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _actions = __webpack_require__(33);
	
	var _selectors = __webpack_require__(57);
	
	var _CloseButton = __webpack_require__(107);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _LabelCol2Form = __webpack_require__(170);
	
	var _LabelCol2Form2 = _interopRequireDefault(_LabelCol2Form);
	
	var _LabelCol4Form = __webpack_require__(171);
	
	var _LabelCol4Form2 = _interopRequireDefault(_LabelCol4Form);
	
	var _LabelCol2LrgForm = __webpack_require__(270);
	
	var _LabelCol2LrgForm2 = _interopRequireDefault(_LabelCol2LrgForm);
	
	var _LabelCol4LrgForm = __webpack_require__(172);
	
	var _LabelCol4LrgForm2 = _interopRequireDefault(_LabelCol4LrgForm);
	
	var _userPermissions = __webpack_require__(29);
	
	var permissions = _interopRequireWildcard(_userPermissions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _customer$selectors = _customer2.default.selectors,
	    getActivePermissions = _customer$selectors.getActivePermissions,
	    getUsePLUCode = _customer$selectors.getUsePLUCode;
	
	
	var formName = 'customLabelForm';
	
	var _ref = _react2.default.createElement(_CloseButton2.default, { url: '/labels' });
	
	var _ref2 = _react2.default.createElement('div', { className: 'loading' });
	
	var CustomLabelPage = function (_React$Component) {
	  _inherits(CustomLabelPage, _React$Component);
	
	  function CustomLabelPage(props) {
	    _classCallCheck(this, CustomLabelPage);
	
	    var _this = _possibleConstructorReturn(this, (CustomLabelPage.__proto__ || Object.getPrototypeOf(CustomLabelPage)).call(this, props));
	
	    _this.handleFormSubmit = function (values) {
	      _this.props.actions.saveLabelToSheet(_this.props.activePageSize, _this.props.activePetLabel, _this.state.fieldMapping, _this.props.activePLU, values);
	    };
	
	    _this.state = {
	      fieldMapping: []
	    };
	    return _this;
	  }
	
	  _createClass(CustomLabelPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var labelAccess = this.props.activePermissions.find(function (permission) {
	        return permission === permissions.ACCESS_LABELS;
	      });
	      if (!labelAccess) {
	        this.props.actions.push('/labels');
	      } else if (this.props.selectedGridIndex < 0 || Object.keys(this.props.activePetLabel).length === 0) {
	        this.props.actions.push('/labels');
	      } else {
	        var columns = this.props.fieldPositions.reduce(function (prev, current) {
	          return prev.Column > current.Column ? prev.Column : current.Column;
	        });
	
	        // Make sure the field positions are sorted properly
	        var fieldPositions = this.props.fieldPositions;
	        if (columns === 0) {
	          fieldPositions.sort((0, _thenby2.default)("Column").thenBy("Row"));
	        } else if (columns === 1) {
	          fieldPositions.sort((0, _thenby2.default)("Row").thenBy("Column"));
	        }
	
	        // Sort the fields into the correct order
	        var labelFields = [];
	        fieldPositions.forEach(function (position) {
	          var labelField = _this2.props.activePetLabel.DetailFields.find(function (detailField) {
	            return detailField.Key === position.Field;
	          });
	          labelFields.push(labelField);
	        });
	
	        // Build the mapping from the ordered fields
	        var fieldMapping = [];
	        labelFields.forEach(function (detailField, index) {
	          if (detailField !== undefined) {
	            var keyName = 'Key' + index;
	            var valueName = 'Value' + index;
	            var mapping = {
	              name: detailField.Key,
	              key: keyName,
	              value: valueName
	            };
	            fieldMapping.push(mapping);
	          }
	        });
	        this.setState({ fieldMapping: fieldMapping });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeLogoUrl = _props.activeLogoUrl,
	          activePageSize = _props.activePageSize,
	          activePetLabel = _props.activePetLabel,
	          activePLU = _props.activePLU,
	          fieldPositions = _props.fieldPositions;
	
	      var validLabel = Object.keys(activePetLabel).length !== 0;
	      var large = false;
	      if (activePageSize === '195 x 66 mm' || activePageSize == '91 x 130 mm' || activePageSize == '133 x 191 mm') {
	        large = true;
	      }
	
	      var columns = -1;
	      var labelFields = [];
	      var initialValues = {};
	      if (validLabel) {
	        // We need the max column to select the proper label template
	        columns = fieldPositions.reduce(function (prev, current) {
	          return prev.Column > current.Column ? prev.Column : current.Column;
	        });
	
	        // Sort the fields into the correct order
	        fieldPositions.forEach(function (position) {
	          var labelField = activePetLabel.DetailFields.find(function (detailField) {
	            return detailField.Key === position.Field;
	          });
	          labelFields.push(labelField);
	        });
	
	        initialValues["line1"] = activePetLabel.Line1;
	        initialValues["line2"] = activePetLabel.Line2;
	        initialValues["plu"] = activePetLabel.PLUCode;
	        initialValues["barcode"] = activePetLabel.Barcode;
	        initialValues["pluKey"] = activePetLabel.PLUCodeTitle;
	        initialValues["price"] = activePetLabel.Price;
	
	        labelFields.forEach(function (detailField, index) {
	          if (detailField !== undefined) {
	            var keyName = 'Key' + index;
	            var valueName = 'Value' + index;
	            initialValues[keyName] = detailField.OverwrittenKey;
	            initialValues[valueName] = detailField.OverwrittenValue;
	          }
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid main full-width', id: 'main' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'float-left' },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL')
	              ),
	              _ref
	            )
	          ),
	          !validLabel && _ref2,
	          validLabel && columns === 0 && large === false && _react2.default.createElement(_LabelCol2Form2.default, { activePLU: activePLU,
	            detailFields: labelFields,
	            form: formName,
	            initialValues: initialValues,
	            logoUrl: activeLogoUrl,
	            onSubmit: this.handleFormSubmit,
	            petLabel: activePetLabel,
	            submitButtonText: _reactReduxI18n.I18n.t('SAVE_LABEL')
	          }),
	          validLabel && columns === 0 && large === true && _react2.default.createElement(_LabelCol2LrgForm2.default, { activePLU: activePLU,
	            detailFields: labelFields,
	            form: formName,
	            initialValues: initialValues,
	            logoUrl: activeLogoUrl,
	            onSubmit: this.handleFormSubmit,
	            petLabel: activePetLabel,
	            submitButtonText: _reactReduxI18n.I18n.t('SAVE_LABEL')
	          }),
	          validLabel && columns === 1 && large === false && _react2.default.createElement(_LabelCol4Form2.default, { activePLU: activePLU,
	            detailFields: labelFields,
	            form: formName,
	            initialValues: initialValues,
	            logoUrl: activeLogoUrl,
	            onSubmit: this.handleFormSubmit,
	            petLabel: activePetLabel,
	            submitButtonText: _reactReduxI18n.I18n.t('SAVE_LABEL')
	          }),
	          validLabel && columns === 1 && large === true && _react2.default.createElement(_LabelCol4LrgForm2.default, { activePLU: activePLU,
	            detailFields: labelFields,
	            form: formName,
	            initialValues: initialValues,
	            logoUrl: activeLogoUrl,
	            onSubmit: this.handleFormSubmit,
	            petLabel: activePetLabel,
	            submitButtonText: _reactReduxI18n.I18n.t('SAVE_LABEL')
	          })
	        )
	      );
	    }
	  }]);
	
	  return CustomLabelPage;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    activeLogoUrl: (0, _selectors.getActiveLogo)(state),
	    activePageSize: (0, _selectors.getActivePageSize)(state),
	    activePetLabel: (0, _selectors.getActivePetLabel)(state),
	    activePermissions: getActivePermissions(state),
	    activePLU: getUsePLUCode(state),
	    fieldPositions: (0, _selectors.getFieldPositions)(state),
	    selectedGridIndex: (0, _selectors.getSelectedGridIndex)(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ push: _reactRouterRedux.push, saveLabelToSheet: _actions.saveLabelToSheet }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CustomLabelPage);

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _selectors = __webpack_require__(57);
	
	var _actions = __webpack_require__(33);
	
	var _CloseButton = __webpack_require__(107);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _StyledLabel2Col = __webpack_require__(608);
	
	var _StyledLabel2Col2 = _interopRequireDefault(_StyledLabel2Col);
	
	var _StyledLabel4Col = __webpack_require__(610);
	
	var _StyledLabel4Col2 = _interopRequireDefault(_StyledLabel4Col);
	
	var _StyledLabel2ColLrg = __webpack_require__(609);
	
	var _StyledLabel2ColLrg2 = _interopRequireDefault(_StyledLabel2ColLrg);
	
	var _StyledLabel4ColLrg = __webpack_require__(611);
	
	var _StyledLabel4ColLrg2 = _interopRequireDefault(_StyledLabel4ColLrg);
	
	var _LabelStylePicker = __webpack_require__(601);
	
	var _LabelStylePicker2 = _interopRequireDefault(_LabelStylePicker);
	
	var _userPermissions = __webpack_require__(29);
	
	var permissions = _interopRequireWildcard(_userPermissions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _customer$selectors = _customer2.default.selectors,
	    getActiveStyles = _customer$selectors.getActiveStyles,
	    getActiveLogos = _customer$selectors.getActiveLogos,
	    isContextLoaded = _customer$selectors.isContextLoaded,
	    getActivePermissions = _customer$selectors.getActivePermissions;
	
	var _ref = _react2.default.createElement(_CloseButton2.default, { url: '/labels' });
	
	var CustomizeLabelPage = function (_React$Component) {
	  _inherits(CustomizeLabelPage, _React$Component);
	
	  function CustomizeLabelPage(props) {
	    _classCallCheck(this, CustomizeLabelPage);
	
	    var _this = _possibleConstructorReturn(this, (CustomizeLabelPage.__proto__ || Object.getPrototypeOf(CustomizeLabelPage)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var styleElements = void 0;
	    if (props.contextLoaded) {
	      styleElements = _this.resetStyleElements(props.activeStyles, props.activePageSize);
	    }
	
	    _this.state = {
	      styleElements: styleElements
	    };
	    return _this;
	  }
	
	  _createClass(CustomizeLabelPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var labelAccess = this.props.activePermissions.find(function (permission) {
	        return permission === permissions.ACCESS_LABELS;
	      });
	      if (!labelAccess) {
	        this.props.actions.push('/labels');
	      } else if (this.props.contextLoaded === false) {
	        this.props.actions.push('/labels');
	      }
	    }
	  }, {
	    key: 'resetStyleElements',
	    value: function resetStyleElements(activeStyles, activePageSize) {
	      var styleElements = activeStyles[activePageSize];
	
	      var labelBorderStyle = styleElements.find(function (element) {
	        return element.Name === 'labelborder';
	      });
	      var labelBorderColorCode = '#FFFFFF';
	      if (labelBorderStyle !== undefined) {
	        labelBorderColorCode = labelBorderStyle.ColorCode.toLowerCase();
	      }
	
	      var labelBgStyle = styleElements.find(function (element) {
	        return element.Name === 'background';
	      });
	      var labelBgColorCode = labelBgStyle.ColorCode.toLowerCase();
	
	      var headerBgStyle = styleElements.find(function (element) {
	        return element.Name === 'headerbackground';
	      });
	      var headerBgColorCode = headerBgStyle.ColorCode.toLowerCase();
	
	      var headerFontStyle = styleElements.find(function (element) {
	        return element.Name === 'headercolor';
	      });
	      var headerFontColorCode = headerFontStyle.ColorCode.toLowerCase();
	
	      var detailBgStyle = styleElements.find(function (element) {
	        return element.Name === 'detailtitlebackground';
	      });
	      var detailBgColorCode = detailBgStyle.ColorCode.toLowerCase();
	
	      var detailFontStyle = styleElements.find(function (element) {
	        return element.Name === 'detailtitlecolor';
	      });
	      var detailFontColorCode = detailFontStyle.ColorCode.toLowerCase();
	
	      var valueBgStyle = styleElements.find(function (element) {
	        return element.Name === 'detailvaluebackground';
	      });
	      var valueBgColorCode = valueBgStyle.ColorCode.toLowerCase();
	
	      var valueFontStyle = styleElements.find(function (element) {
	        return element.Name === 'detailvaluecolor';
	      });
	      var valueFontColorCode = valueFontStyle.ColorCode.toLowerCase();
	
	      var priceBgStyle = styleElements.find(function (element) {
	        return element.Name === 'pricebackground';
	      });
	      var priceBgColorCode = priceBgStyle.ColorCode.toLowerCase();
	
	      var priceFontStyle = styleElements.find(function (element) {
	        return element.Name === 'pricecolor';
	      });
	      var priceFontColorCode = priceFontStyle.ColorCode.toLowerCase();
	
	      var pluFontStyle = styleElements.find(function (element) {
	        return element.Name === 'pluprice';
	      });
	      var pluFontColorCode = '#FFFFFF';
	      if (pluFontStyle !== undefined) {
	        pluFontColorCode = pluFontStyle.ColorCode.toLowerCase();
	      }
	
	      var barCodeStyle = styleElements.find(function (element) {
	        return element.Name === 'barcodebackground';
	      });
	      var barCodeBgColorCode = void 0;
	      if (barCodeStyle !== undefined) {
	        barCodeBgColorCode = barCodeStyle.ColorCode.toLowerCase();
	      }
	
	      var imageBorderStyle = styleElements.find(function (element) {
	        return element.Name === 'imageborder';
	      });
	      var imageBorderColorCode = void 0;
	      if (imageBorderStyle !== undefined) {
	        imageBorderColorCode = imageBorderStyle.ColorCode.toLowerCase();
	      }
	
	      var rightPanelBgStyle = styleElements.find(function (element) {
	        return element.Name === 'rightbackground';
	      });
	      var rightPanelColorCode = void 0;
	      if (rightPanelBgStyle !== undefined) {
	        rightPanelColorCode = rightPanelBgStyle.ColorCode.toLowerCase();
	      }
	
	      var labelStyleElements = {
	        labelBorderColor: labelBorderColorCode,
	        labelBgColor: labelBgColorCode,
	        headerBgColor: headerBgColorCode,
	        headerFontColor: headerFontColorCode,
	        detailBgColor: detailBgColorCode,
	        detailFontColor: detailFontColorCode,
	        valueBgColor: valueBgColorCode,
	        valueFontColor: valueFontColorCode,
	        priceFontColor: priceFontColorCode,
	        priceBgColor: priceBgColorCode,
	        pluFontColor: pluFontColorCode,
	        barCodeBgColor: barCodeBgColorCode,
	        imageBorderColor: imageBorderColorCode,
	        rightPanelBgColor: rightPanelColorCode
	      };
	
	      return labelStyleElements;
	    }
	  }, {
	    key: 'resetDefaultElements',
	    value: function resetDefaultElements(activeStyles, activePageSize) {
	      var styleElements = activeStyles[activePageSize];
	
	      var labelBorderStyle = styleElements.find(function (element) {
	        return element.Name === 'labelborder';
	      });
	      var labelBorderColorCode = '#FFFFFF';
	      if (labelBorderStyle !== undefined) {
	        labelBorderColorCode = labelBorderStyle.DefaultColorCode.toLowerCase();
	      }
	
	      var labelBgStyle = styleElements.find(function (element) {
	        return element.Name === 'background';
	      });
	      var labelBgColorCode = labelBgStyle.DefaultColorCode.toLowerCase();
	
	      var headerBgStyle = styleElements.find(function (element) {
	        return element.Name === 'headerbackground';
	      });
	      var headerBgColorCode = headerBgStyle.DefaultColorCode.toLowerCase();
	
	      var headerFontStyle = styleElements.find(function (element) {
	        return element.Name === 'headercolor';
	      });
	      var headerFontColorCode = headerFontStyle.DefaultColorCode.toLowerCase();
	
	      var detailBgStyle = styleElements.find(function (element) {
	        return element.Name === 'detailtitlebackground';
	      });
	      var detailBgColorCode = detailBgStyle.DefaultColorCode.toLowerCase();
	
	      var detailFontStyle = styleElements.find(function (element) {
	        return element.Name === 'detailtitlecolor';
	      });
	      var detailFontColorCode = detailFontStyle.DefaultColorCode.toLowerCase();
	
	      var valueBgStyle = styleElements.find(function (element) {
	        return element.Name === 'detailvaluebackground';
	      });
	      var valueBgColorCode = valueBgStyle.DefaultColorCode.toLowerCase();
	
	      var valueFontStyle = styleElements.find(function (element) {
	        return element.Name === 'detailvaluecolor';
	      });
	      var valueFontColorCode = valueFontStyle.DefaultColorCode.toLowerCase();
	
	      var priceBgStyle = styleElements.find(function (element) {
	        return element.Name === 'pricebackground';
	      });
	      var priceBgColorCode = priceBgStyle.DefaultColorCode.toLowerCase();
	
	      var priceFontStyle = styleElements.find(function (element) {
	        return element.Name === 'pricecolor';
	      });
	      var priceFontColorCode = priceFontStyle.DefaultColorCode.toLowerCase();
	
	      var pluFontStyle = styleElements.find(function (element) {
	        return element.Name === 'pluprice';
	      });
	      var pluFontColorCode = '#FFFFFF';
	      if (pluFontStyle !== undefined) {
	        pluFontColorCode = pluFontStyle.DefaultColorCode.toLowerCase();
	      }
	
	      var barCodeStyle = styleElements.find(function (element) {
	        return element.Name === 'barcodebackground';
	      });
	      var barCodeBgColorCode = void 0;
	      if (barCodeStyle !== undefined) {
	        barCodeBgColorCode = barCodeStyle.DefaultColorCode.toLowerCase();
	      }
	
	      var imageBorderStyle = styleElements.find(function (element) {
	        return element.Name === 'imageborder';
	      });
	      var imageBorderColorCode = void 0;
	      if (imageBorderStyle !== undefined) {
	        imageBorderColorCode = imageBorderStyle.DefaultColorCode.toLowerCase();
	      }
	
	      var rightPanelBgStyle = styleElements.find(function (element) {
	        return element.Name === 'rightbackground';
	      });
	      var rightPanelColorCode = '#FFFFFF';
	      if (rightPanelBgStyle !== undefined) {
	        rightPanelColorCode = rightPanelBgStyle.DefaultColorCode.toLowerCase();
	      }
	
	      var labelStyleElements = {
	        labelBorderColor: labelBorderColorCode,
	        labelBgColor: labelBgColorCode,
	        headerBgColor: headerBgColorCode,
	        headerFontColor: headerFontColorCode,
	        detailBgColor: detailBgColorCode,
	        detailFontColor: detailFontColorCode,
	        valueBgColor: valueBgColorCode,
	        valueFontColor: valueFontColorCode,
	        priceFontColor: priceFontColorCode,
	        priceBgColor: priceBgColorCode,
	        pluFontColor: pluFontColorCode,
	        barCodeBgColor: barCodeBgColorCode,
	        imageBorderColor: imageBorderColorCode,
	        rightPanelBgColor: rightPanelColorCode
	      };
	
	      return labelStyleElements;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeDefinition = _props.activeDefinition,
	          activeLogos = _props.activeLogos,
	          activePageSize = _props.activePageSize,
	          contextLoaded = _props.contextLoaded,
	          definitionsValid = _props.definitionsValid;
	
	      var large = false;
	      if (activePageSize === '195 x 66 mm' || activePageSize == '91 x 130 mm' || activePageSize == '133 x 191 mm') {
	        large = true;
	      }
	
	      var logo = '';
	      var columns = -1;
	      if (definitionsValid) {
	        var fieldColumns = activeDefinition.FieldMappings.map(function (mapping) {
	          return mapping.Column;
	        });
	
	        // We need the max column to select the proper label template
	        columns = fieldColumns.reduce(function (prev, current) {
	          return prev > current ? prev : current;
	        });
	      }
	
	      if (contextLoaded) {
	        logo = activeLogos[activePageSize];
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'wrapper', onClick: this.closeColorPickers },
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid main label-customize full-width', id: 'main' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row', onClick: this.closeColorPickers },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'float-left' },
	                _reactReduxI18n.I18n.t('CUSTOMIZE_LABEL')
	              ),
	              _ref
	            )
	          ),
	          columns === 0 && large === false && _react2.default.createElement(_StyledLabel2Col2.default, { styleElements: this.state.styleElements, logoUrl: logo }),
	          columns === 0 && large === true && _react2.default.createElement(_StyledLabel2ColLrg2.default, { styleElements: this.state.styleElements, logoUrl: logo }),
	          columns === 1 && large === false && _react2.default.createElement(_StyledLabel4Col2.default, { styleElements: this.state.styleElements, logoUrl: logo }),
	          columns === 1 && large === true && _react2.default.createElement(_StyledLabel4ColLrg2.default, { styleElements: this.state.styleElements, logoUrl: logo }),
	          definitionsValid && activeDefinition !== null && _react2.default.createElement(_LabelStylePicker2.default, { ref: function ref(instance) {
	              return _this2.picker = instance;
	            },
	            columnCount: columns,
	            styleElements: this.state.styleElements,
	            onColorChange: this.handleColorChange,
	            onLogoUpload: this.handleLogoUpload,
	            onRestoreDefault: this.handleRestoreDefault,
	            logoUrl: logo }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row no-gutters bottom-buttons' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 text-right' },
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-secondary', onClick: this.handleCancel },
	                _reactReduxI18n.I18n.t('CANCEL')
	              ),
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-primary', onClick: this.handleSave },
	                _reactReduxI18n.I18n.t('SAVE')
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CustomizeLabelPage;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.closeColorPickers = function () {
	    _this3.picker.closeColorPickers();
	  };
	
	  this.handleColorChange = function (name, color) {
	    var styleElements = _extends({}, _this3.state.styleElements);
	
	    switch (name) {
	      case 'mainBorder':
	        {
	          styleElements.labelBorderColor = color.hex;
	          break;
	        }
	      case 'mainBackground':
	        {
	          styleElements.labelBgColor = color.hex;
	          break;
	        }
	      case 'headerFont':
	        {
	          styleElements.headerFontColor = color.hex;
	          break;
	        }
	      case 'headerBackground':
	        {
	          styleElements.headerBgColor = color.hex;
	          break;
	        }
	      case 'detailFont':
	        {
	          styleElements.detailFontColor = color.hex;
	          break;
	        }
	      case 'detailBackground':
	        {
	          styleElements.detailBgColor = color.hex;
	          break;
	        }
	      case 'valueFont':
	        {
	          styleElements.valueFontColor = color.hex;
	          break;
	        }
	      case 'valueBackground':
	        {
	          styleElements.valueBgColor = color.hex;
	          break;
	        }
	      case 'priceFont':
	        {
	          styleElements.priceFontColor = color.hex;
	          break;
	        }
	      case 'priceBackground':
	        {
	          styleElements.priceBgColor = color.hex;
	          break;
	        }
	      case 'pluFont':
	        {
	          styleElements.pluFontColor = color.hex;
	          break;
	        }
	      case 'barCodeBackground':
	        {
	          styleElements.barCodeBgColor = color.hex;
	          break;
	        }
	      case 'imageBorder':
	        {
	          styleElements.imageBorderColor = color.hex;
	          break;
	        }
	      case 'rightPanelBackground':
	        {
	          styleElements.rightPanelBgColor = color.hex;
	        }
	    }
	    _this3.setState({ styleElements: styleElements });
	  };
	
	  this.handleRestoreDefault = function () {
	    var styleElements = _this3.resetDefaultElements(_this3.props.activeStyles, _this3.props.activePageSize);
	    _this3.setState({ styleElements: styleElements });
	  };
	
	  this.handleSave = function () {
	    _this3.props.actions.saveLabelStyles(_this3.props.activeDefinition, _this3.state.styleElements);
	    _this3.props.actions.push('/labels');
	  };
	
	  this.handleLogoUpload = function (file) {
	    _this3.props.actions.uploadLogo(_this3.props.activePageSize, file);
	  };
	};
	
	function mapStateToProps(state) {
	  return {
	    activeDefinition: (0, _selectors.getActiveDefinition)(state),
	    activeLogos: getActiveLogos(state),
	    activeStyles: getActiveStyles(state),
	    activePageSize: (0, _selectors.getActivePageSize)(state),
	    activePermissions: getActivePermissions(state),
	    contextLoaded: isContextLoaded(state),
	    definitionsValid: (0, _selectors.areDefinitionsValid)(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ push: _reactRouterRedux.push, getDefinitions: _actions.getDefinitions, saveLabelStyles: _actions.saveLabelStyles, uploadLogo: _actions.uploadLogo }, dispatch)
	  };
	}
	
	CustomizeLabelPage.defaultProps = {
	  activeLogos: {},
	  activeStyles: {}
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CustomizeLabelPage);

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _thenby = __webpack_require__(91);
	
	var _thenby2 = _interopRequireDefault(_thenby);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _actions = __webpack_require__(33);
	
	var _selectors = __webpack_require__(57);
	
	var _CloseButton = __webpack_require__(107);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _LabelCol2Form = __webpack_require__(170);
	
	var _LabelCol2Form2 = _interopRequireDefault(_LabelCol2Form);
	
	var _LabelCol4Form = __webpack_require__(171);
	
	var _LabelCol4Form2 = _interopRequireDefault(_LabelCol4Form);
	
	var _LabelCol2LrgForm = __webpack_require__(270);
	
	var _LabelCol2LrgForm2 = _interopRequireDefault(_LabelCol2LrgForm);
	
	var _LabelCol4LrgForm = __webpack_require__(172);
	
	var _LabelCol4LrgForm2 = _interopRequireDefault(_LabelCol4LrgForm);
	
	var _userPermissions = __webpack_require__(29);
	
	var permissions = _interopRequireWildcard(_userPermissions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _customer$selectors = _customer2.default.selectors,
	    getActivePermissions = _customer$selectors.getActivePermissions,
	    getUsePLUCode = _customer$selectors.getUsePLUCode;
	
	
	var formName = 'editLabelForm';
	
	var _ref = _react2.default.createElement(_CloseButton2.default, { url: '/labels' });
	
	var _ref2 = _react2.default.createElement('div', { className: 'loading' });
	
	var EditLabelPage = function (_React$Component) {
	  _inherits(EditLabelPage, _React$Component);
	
	  function EditLabelPage(props) {
	    _classCallCheck(this, EditLabelPage);
	
	    var _this = _possibleConstructorReturn(this, (EditLabelPage.__proto__ || Object.getPrototypeOf(EditLabelPage)).call(this, props));
	
	    _this.handleFormCancel = function () {
	      _this.props.actions.push('/labels');
	    };
	
	    _this.handleFormSubmit = function (values) {
	      _this.props.actions.saveLabelToSheet(_this.props.activePageSize, _this.props.activePetLabel, _this.state.fieldMapping, _this.props.activePLU, values);
	    };
	
	    _this.state = {
	      fieldMapping: []
	    };
	    return _this;
	  }
	
	  _createClass(EditLabelPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var labelAccess = this.props.activePermissions.find(function (permission) {
	        return permission === permissions.ACCESS_LABELS;
	      });
	      if (!labelAccess) {
	        this.props.actions.push('/labels');
	      } else if (this.props.selectedGridIndex < 0 || Object.keys(this.props.activePetLabel).length === 0) {
	        this.props.actions.push('/labels');
	      } else {
	        var columns = this.props.fieldPositions.reduce(function (prev, current) {
	          return prev.Column > current.Column ? prev.Column : current.Column;
	        });
	
	        // Make sure the field positions are sorted properly
	        var fieldPositions = this.props.fieldPositions;
	        if (columns === 0) {
	          fieldPositions.sort((0, _thenby2.default)("Column").thenBy("Row"));
	        } else if (columns === 1) {
	          fieldPositions.sort((0, _thenby2.default)("Row").thenBy("Column"));
	        }
	
	        // Sort the fields into the correct order
	        var labelFields = [];
	        fieldPositions.forEach(function (position) {
	          var labelField = _this2.props.activePetLabel.DetailFields.find(function (detailField) {
	            return detailField.Key === position.Field;
	          });
	          labelFields.push(labelField);
	        });
	
	        // Build the mapping from the ordered fields
	        var fieldMapping = [];
	        labelFields.forEach(function (detailField, index) {
	          if (detailField !== undefined) {
	            var keyName = 'Key' + index;
	            var valueName = 'Value' + index;
	            var mapping = {
	              name: detailField.Key,
	              key: keyName,
	              value: valueName
	            };
	            fieldMapping.push(mapping);
	          }
	        });
	        this.setState({ fieldMapping: fieldMapping });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeLogoUrl = _props.activeLogoUrl,
	          activePageSize = _props.activePageSize,
	          activePetLabel = _props.activePetLabel,
	          activePLU = _props.activePLU,
	          fieldPositions = _props.fieldPositions;
	
	      var validLabel = Object.keys(activePetLabel).length !== 0;
	      var large = false;
	      if (activePageSize === '195 x 66 mm' || activePageSize == '91 x 130 mm' || activePageSize == '133 x 191 mm') {
	        large = true;
	      }
	
	      var columns = -1;
	      var labelFields = [];
	      var initialValues = {};
	      if (validLabel) {
	        // We need the max column to select the proper label template
	        columns = fieldPositions.reduce(function (prev, current) {
	          return prev.Column > current.Column ? prev.Column : current.Column;
	        });
	
	        // Sort the fields into the correct order
	        fieldPositions.forEach(function (position) {
	          var labelField = activePetLabel.DetailFields.find(function (detailField) {
	            return detailField.Key === position.Field;
	          });
	          labelFields.push(labelField);
	        });
	
	        initialValues["line1"] = activePetLabel.Line1;
	        initialValues["line2"] = activePetLabel.Line2;
	        initialValues["plu"] = activePetLabel.PLUCode;
	        initialValues["barcode"] = activePetLabel.Barcode;
	        initialValues["pluKey"] = activePetLabel.PLUCodeTitle;
	        initialValues["price"] = activePetLabel.Price;
	
	        labelFields.forEach(function (detailField, index) {
	          if (detailField !== undefined) {
	            var keyName = 'Key' + index;
	            var valueName = 'Value' + index;
	            initialValues[keyName] = detailField.OverwrittenKey;
	            initialValues[valueName] = detailField.OverwrittenValue;
	          }
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid main full-width', id: 'main' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'float-left' },
	                _reactReduxI18n.I18n.t('EDIT_LABEL')
	              ),
	              _ref
	            )
	          ),
	          !validLabel && _ref2,
	          validLabel && columns === 0 && large == false && _react2.default.createElement(_LabelCol2Form2.default, { activePLU: activePLU,
	            detailFields: labelFields,
	            form: formName,
	            initialValues: initialValues,
	            logoUrl: activeLogoUrl,
	            onSubmit: this.handleFormSubmit,
	            petLabel: activePetLabel,
	            submitButtonText: _reactReduxI18n.I18n.t('SAVE_LABEL'),
	            onCancel: this.handleFormCancel
	          }),
	          validLabel && columns === 0 && large == true && _react2.default.createElement(_LabelCol2LrgForm2.default, { activePLU: activePLU,
	            detailFields: labelFields,
	            form: formName,
	            initialValues: initialValues,
	            logoUrl: activeLogoUrl,
	            onSubmit: this.handleFormSubmit,
	            petLabel: activePetLabel,
	            submitButtonText: _reactReduxI18n.I18n.t('SAVE_LABEL'),
	            onCancel: this.handleFormCancel
	          }),
	          validLabel && columns === 1 && large === false && _react2.default.createElement(_LabelCol4Form2.default, { activePLU: activePLU,
	            detailFields: labelFields,
	            form: formName,
	            initialValues: initialValues,
	            logoUrl: activeLogoUrl,
	            onSubmit: this.handleFormSubmit,
	            petLabel: activePetLabel,
	            submitButtonText: _reactReduxI18n.I18n.t('SAVE_LABEL'),
	            onCancel: this.handleFormCancel
	          }),
	          validLabel && columns === 1 && large === true && _react2.default.createElement(_LabelCol4LrgForm2.default, { activePLU: activePLU,
	            detailFields: labelFields,
	            form: formName,
	            initialValues: initialValues,
	            logoUrl: activeLogoUrl,
	            onSubmit: this.handleFormSubmit,
	            petLabel: activePetLabel,
	            submitButtonText: _reactReduxI18n.I18n.t('SAVE_LABEL'),
	            onCancel: this.handleFormCancel
	          })
	        )
	      );
	    }
	  }]);
	
	  return EditLabelPage;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    activeLogoUrl: (0, _selectors.getActiveLogo)(state),
	    activePageSize: (0, _selectors.getActivePageSize)(state),
	    activePetLabel: (0, _selectors.getActivePetLabel)(state),
	    activePermissions: getActivePermissions(state),
	    activePLU: getUsePLUCode(state),
	    fieldPositions: (0, _selectors.getFieldPositions)(state),
	    selectedGridIndex: (0, _selectors.getSelectedGridIndex)(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ push: _reactRouterRedux.push, saveLabelToSheet: _actions.saveLabelToSheet }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EditLabelPage);

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmptyLabel = function EmptyLabel(_ref) {
		var index = _ref.index,
		    onSelected = _ref.onSelected;
	
		return _react2.default.createElement("div", { className: "empty-label", onClick: function onClick() {
				onSelected(index);
			} });
	};
	
	exports.default = EmptyLabel;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LabelHover = __webpack_require__(597);
	
	var _LabelHover2 = _interopRequireDefault(_LabelHover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilledLabel = function (_React$Component) {
	  _inherits(FilledLabel, _React$Component);
	
	  function FilledLabel(props) {
	    _classCallCheck(this, FilledLabel);
	
	    var _this = _possibleConstructorReturn(this, (FilledLabel.__proto__ || Object.getPrototypeOf(FilledLabel)).call(this, props));
	
	    _this.handleMouseDown = function () {
	      _this.setState({ dragging: true });
	    };
	
	    _this.handleMouseUp = function () {
	      _this.setState({ dragging: false });
	    };
	
	    _this.handleMouseEnter = function () {
	      _this.setState({ hover: true });
	    };
	
	    _this.handleMouseLeave = function () {
	      _this.setState({ hover: false });
	    };
	
	    _this.state = {
	      dragging: false,
	      hover: false
	    };
	    return _this;
	  }
	
	  _createClass(FilledLabel, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.canHover === false) {
	        this.setState({ hover: false });
	      }
	
	      if (this.props.index === newProps.index) {
	        this.setState({ dragging: false });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          canHover = _props.canHover,
	          imageUrl = _props.imageUrl,
	          index = _props.index;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'label-image',
	          style: { backgroundImage: 'url(' + imageUrl + ')' },
	          onMouseEnter: this.handleMouseEnter,
	          onMouseOver: this.handleMouseEnter,
	          onMouseUp: this.handleMouseUp },
	        this.state.hover && canHover && !this.state.dragging && _react2.default.createElement(_LabelHover2.default, { index: index, onMouseDown: this.handleMouseDown, onMouseLeave: this.handleMouseLeave })
	      );
	    }
	  }]);
	
	  return FilledLabel;
	}(_react2.default.Component);
	
	exports.default = FilledLabel;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EmptyLabel = __webpack_require__(592);
	
	var _EmptyLabel2 = _interopRequireDefault(_EmptyLabel);
	
	var _FilledLabel = __webpack_require__(593);
	
	var _FilledLabel2 = _interopRequireDefault(_FilledLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Label = function Label(_ref) {
		var canHover = _ref.canHover,
		    data = _ref.data,
		    index = _ref.index,
		    onSelected = _ref.onSelected;
	
		if (Object.keys(data).length === 0) {
			return _react2.default.createElement(_EmptyLabel2.default, { index: index, onSelected: onSelected });
		} else {
			return _react2.default.createElement(_FilledLabel2.default, { canHover: canHover, imageUrl: data.imageUrl, index: index });
		}
	};
	
	exports.default = Label;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(56);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LabelAddedModal = function LabelAddedModal(_ref) {
	  var isOpen = _ref.isOpen,
	      onClose = _ref.onClose;
	
	  return _react2.default.createElement(
	    _reactstrap.Modal,
	    { isOpen: isOpen, toggle: onClose, id: 'modalSelectStore' },
	    _react2.default.createElement(
	      'div',
	      { className: 'modal-body' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _reactReduxI18n.I18n.t('LABEL_ADDED_MESSAGE')
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'modal-footer' },
	      _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'btn btn-primary', onClick: onClose },
	        _reactReduxI18n.I18n.t('CONTINUE')
	      )
	    )
	  );
	};
	
	exports.default = LabelAddedModal;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _actions = __webpack_require__(33);
	
	var _selectors = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LabelGrid = function (_React$Component) {
	  _inherits(LabelGrid, _React$Component);
	
	  function LabelGrid() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LabelGrid);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LabelGrid.__proto__ || Object.getPrototypeOf(LabelGrid)).call.apply(_ref, [this].concat(args))), _this), _this.onSortStart = function () {
	      var onSortStart = _this.props.onSortStart;
	
	      _this.props.actions.setGridSorting(true);
	
	      if (onSortStart) {
	        onSortStart(_this.refs.component);
	      }
	    }, _this.onSortEnd = function (_ref2) {
	      var oldIndex = _ref2.oldIndex,
	          newIndex = _ref2.newIndex;
	      var onSortEnd = _this.props.onSortEnd;
	
	
	      _this.props.actions.setGridSorting(false);
	      _this.props.actions.setLabelIndex(oldIndex, newIndex);
	
	      if (onSortEnd) {
	        onSortEnd(_this.refs.component);
	      }
	    }, _this.onSelectLabel = function (index) {
	      _this.props.actions.selectLabel(index);
	      _this.props.actions.push('/pet_search');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LabelGrid, [{
	    key: 'render',
	    value: function render() {
	      var Component = this.props.component;
	      var _props = this.props,
	          isSorting = _props.isSorting,
	          items = _props.items;
	
	      var props = {
	        axis: 'xy',
	        isSorting: isSorting,
	        items: items,
	        onSelected: this.onSelectLabel,
	        onSortEnd: this.onSortEnd,
	        onSortStart: this.onSortStart,
	        ref: 'component'
	      };
	
	      return _react2.default.createElement(Component, _extends({}, this.props, props));
	    }
	  }]);
	
	  return LabelGrid;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    isSorting: (0, _selectors.isGridSorting)(state),
	    labelSize: (0, _selectors.getActiveLabelSize)(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ push: _reactRouterRedux.push, selectLabel: _actions.selectLabel, setGridSorting: _actions.setGridSorting, setLabelIndex: _actions.setLabelIndex }, dispatch)
	  };
	}
	
	LabelGrid.defaultProps = {
	  className: "stylizedList",
	  itemClass: "stylizedItem"
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LabelGrid);

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _actions = __webpack_require__(33);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isDemoUser = _customer2.default.selectors.isDemoUser;
	
	var LabelHover = function (_React$Component) {
	  _inherits(LabelHover, _React$Component);
	
	  function LabelHover(props) {
	    _classCallCheck(this, LabelHover);
	
	    var _this = _possibleConstructorReturn(this, (LabelHover.__proto__ || Object.getPrototypeOf(LabelHover)).call(this, props));
	
	    _this.handleMouseDown = function () {
	      _this.setState({ mouseDown: true });
	    };
	
	    _this.handleMouseUp = function () {
	      _this.setState({ mouseDown: false });
	    };
	
	    _this.handleMouseMove = function () {
	      if (_this.state.mouseDown) {
	        _this.props.onMouseDown();
	      }
	    };
	
	    _this.handleMouseLeave = function () {
	      _this.setState({ mouseDown: false });
	      _this.props.onMouseLeave();
	    };
	
	    _this.state = {
	      mouseDown: false
	    };
	    return _this;
	  }
	
	  _createClass(LabelHover, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actions = _props.actions,
	          index = _props.index,
	          isDemoUser = _props.isDemoUser;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'label-overlay',
	          onMouseDown: this.handleMouseDown,
	          onMouseUp: this.handleMouseUp,
	          onMouseMove: this.handleMouseMove,
	          onMouseLeave: this.handleMouseLeave
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'btn-row' },
	          !isDemoUser && _react2.default.createElement('div', { className: 'btn-edit', onClick: function onClick() {
	              actions.editLabel(index);
	            } }),
	          _react2.default.createElement('div', { className: 'btn-delete', onClick: function onClick() {
	              actions.deleteLabel(index);
	            } })
	        )
	      );
	    }
	  }]);
	
	  return LabelHover;
	}(_react2.default.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ deleteLabel: _actions.deleteLabel, editLabel: _actions.editLabel }, dispatch)
	  };
	}
	
	function mapStateToProps(state) {
	  return {
	    isDemoUser: isDemoUser(state)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LabelHover);

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(28);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _apiEndpoints = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LabelPageButtons = function LabelPageButtons(_ref) {
		var onClear = _ref.onClear,
		    pdfId = _ref.pdfId;
	
		var pdfLink = _apiEndpoints.LABEL_GET_PDF + '/' + pdfId;
		return _react2.default.createElement(
			'div',
			{ className: 'col-xl-12 col-sm-4 text-right' },
			_react2.default.createElement(
				'button',
				{ type: 'button', className: 'btn btn-secondary', onClick: onClear },
				_reactReduxI18n.I18n.t('CLEAR')
			),
			_react2.default.createElement(
				_reactRouter.Link,
				{ to: pdfLink, target: '_blank', className: 'btn btn-primary' },
				_reactReduxI18n.I18n.t('GENERATE')
			)
		);
	};
	
	exports.default = LabelPageButtons;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SortableList = __webpack_require__(607);
	
	var _SortableList2 = _interopRequireDefault(_SortableList);
	
	var _LabelGrid = __webpack_require__(596);
	
	var _LabelGrid2 = _interopRequireDefault(_LabelGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LabelSheet = function LabelSheet(_ref) {
	  var labels = _ref.labels;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'label-sheet' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(_LabelGrid2.default, {
	        component: _SortableList2.default,
	        distance: 5,
	        lockToContainerEdges: true,
	        lockOffset: 0,
	        items: labels,
	        helperClass: 'stylizedHelper',
	        className: 'stylizedList grid',
	        itemClass: 'stylizedItem gridSpace'
	      })
	    )
	  );
	};
	
	exports.default = LabelSheet;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _thenby = __webpack_require__(91);
	
	var _thenby2 = _interopRequireDefault(_thenby);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LabelSizeList = function (_React$Component) {
	  _inherits(LabelSizeList, _React$Component);
	
	  function LabelSizeList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LabelSizeList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LabelSizeList.__proto__ || Object.getPrototypeOf(LabelSizeList)).call.apply(_ref, [this].concat(args))), _this), _this.handleSizeChange = function (e) {
	      _this.props.onSelected(e.target.value);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LabelSizeList, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeSize = _props.activeSize,
	          definitions = _props.definitions;
	
	
	      definitions.sort((0, _thenby2.default)("Height").thenBy("Width"));
	
	      var definitionNames = definitions.map(function (definition) {
	        return _react2.default.createElement(
	          'option',
	          { key: definition.LabelName, value: definition.LabelName },
	          definition.LabelName
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'col-xl-12 col-sm-2' },
	        _react2.default.createElement(
	          'label',
	          { className: 'lbl-label-size', htmlFor: 'label-size' },
	          _reactReduxI18n.I18n.t('LABEL_SIZE')
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'select' },
	          _react2.default.createElement(
	            'select',
	            { id: 'label-size', defaultValue: activeSize, onChange: function onChange(e) {
	                _this2.handleSizeChange(e);
	              } },
	            definitionNames
	          )
	        )
	      );
	    }
	  }]);
	
	  return LabelSizeList;
	}(_react2.default.Component);
	
	exports.default = LabelSizeList;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactColor = __webpack_require__(1021);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LabelStylePicker = function (_React$Component) {
	  _inherits(LabelStylePicker, _React$Component);
	
	  function LabelStylePicker(props) {
	    _classCallCheck(this, LabelStylePicker);
	
	    var _this = _possibleConstructorReturn(this, (LabelStylePicker.__proto__ || Object.getPrototypeOf(LabelStylePicker)).call(this, props));
	
	    _this.openColorPicker = function (event) {
	      _this.closeColorPickers();
	      switch (event.target.id) {
	        case 'mainBorder':
	          {
	            _this.setState({ mainBorderOpen: !_this.state.mainBorderOpen });
	            break;
	          }
	        case 'mainBackground':
	          {
	            _this.setState({ mainBackgroundOpen: !_this.state.mainBackgroundOpen });
	            break;
	          }
	        case 'headerFont':
	          {
	            _this.setState({ headerFontOpen: !_this.state.headerFontOpen });
	            break;
	          }
	        case 'headerBackground':
	          {
	            _this.setState({ headerBackgroundOpen: !_this.state.headerBackgroundOpen });
	            break;
	          }
	        case 'detailFont':
	          {
	            _this.setState({ detailFontOpen: !_this.state.detailFontOpen });
	            break;
	          }
	        case 'detailBackground':
	          {
	            _this.setState({ detailBackgroundOpen: !_this.state.detailBackgroundOpen });
	            break;
	          }
	        case 'valueFont':
	          {
	            _this.setState({ valueFontOpen: !_this.state.valueFontOpen });
	            break;
	          }
	        case 'valueBackground':
	          {
	            _this.setState({ valueBackgroundOpen: !_this.state.valueBackgroundOpen });
	            break;
	          }
	        case 'priceFont':
	          {
	            _this.setState({ priceFontOpen: !_this.state.priceFontOpen });
	            break;
	          }
	        case 'priceBackground':
	          {
	            _this.setState({ priceBackgroundOpen: !_this.state.priceBackgroundOpen });
	            break;
	          }
	        case 'pluFont':
	          {
	            _this.setState({ pluFontOpen: !_this.state.pluFontOpen });
	            break;
	          }
	        case 'barCodeBackground':
	          {
	            _this.setState({ barCodeBackgroundOpen: !_this.state.barCodeBackgroundOpen });
	            break;
	          }
	        case 'imageBorder':
	          {
	            _this.setState({ imageBorderOpen: !_this.state.imageBorderOpen });
	            break;
	          }
	        case 'rightPanelBackground':
	          {
	            _this.setState({ rightPanelOpen: !_this.state.rightPanelOpen });
	            break;
	          }
	      }
	      event.stopPropagation();
	    };
	
	    _this.closeColorPickers = function () {
	      var closePopups = {
	        mainBorderOpen: false,
	        mainBackgroundOpen: false,
	        headerFontOpen: false,
	        headerBackgroundOpen: false,
	        detailFontOpen: false,
	        detailBackgroundOpen: false,
	        valueFontOpen: false,
	        valueBackgroundOpen: false,
	        priceFontOpen: false,
	        priceBackgroundOpen: false,
	        pluFontOpen: false,
	        barCodeBackgroundOpen: false,
	        imageBorderOpen: false,
	        rightPanelOpen: false
	      };
	      _this.setState(closePopups);
	    };
	
	    _this.handleColorChange = function (name) {
	      return function (color) {
	        _this.props.onColorChange(name, color);
	      };
	    };
	
	    _this.blockClosing = function (event) {
	      event.stopPropagation();
	    };
	
	    _this.state = {
	      mainBorderOpen: false,
	      mainBackgroundOpen: false,
	      headerFontOpen: false,
	      headerBackgroundOpen: false,
	      detailFontOpen: false,
	      detailBackgroundOpen: false,
	      valueFontOpen: false,
	      valueBackgroundOpen: false,
	      priceFontOpen: false,
	      priceBackgroundOpen: false,
	      pluFontOpen: false,
	      barCodeBackgroundOpen: false,
	      imageBorderOpen: false,
	      rightPanelOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(LabelStylePicker, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          columnCount = _props.columnCount,
	          logoUrl = _props.logoUrl,
	          onLogoUpload = _props.onLogoUpload,
	          onRestoreDefault = _props.onRestoreDefault,
	          styleElements = _props.styleElements;
	
	
	      var labelBorderColor = { backgroundColor: styleElements.labelBorderColor };
	      var labelBorderColorCode = styleElements.labelBorderColor;
	      var labelBgColor = { backgroundColor: styleElements.labelBgColor };
	      var labelBgColorCode = styleElements.labelBgColor;
	      var headerBgColor = { backgroundColor: styleElements.headerBgColor };
	      var headerBgColorCode = styleElements.headerBgColor;
	      var headerFontColor = { backgroundColor: styleElements.headerFontColor };
	      var headerFontColorCode = styleElements.headerFontColor;
	      var detailBgColor = { backgroundColor: styleElements.detailBgColor };
	      var detailBgColorCode = styleElements.detailBgColor;
	      var detailFontColor = { backgroundColor: styleElements.detailFontColor };
	      var detailFontColorCode = styleElements.detailFontColor;
	      var valueBgColor = { backgroundColor: styleElements.valueBgColor };
	      var valueBgColorCode = styleElements.valueBgColor;
	      var valueFontColor = { backgroundColor: styleElements.valueFontColor };
	      var valueFontColorCode = styleElements.valueFontColor;
	      var priceBgColor = { backgroundColor: styleElements.priceBgColor };
	      var priceBgColorCode = styleElements.priceBgColor;
	      var priceFontColor = { backgroundColor: styleElements.priceFontColor };
	      var priceFontColorCode = styleElements.priceFontColor;
	      var pluFontColor = { backgroundColor: styleElements.pluFontColor };
	      var pluFontColorCode = styleElements.pluFontColor;
	      var barCodeBgColor = { backgroundColor: styleElements.barCodeBgColor };
	      var barCodeBgColorCode = styleElements.barCodeBgColor;
	      var imageBorderColor = { backgroundColor: styleElements.imageBorderColor };
	      var imageBorderColorCode = styleElements.imageBorderColor;
	      var rightPanelBgColor = { backgroundColor: styleElements.rightPanelBgColor };
	      var rightPanelColorCode = styleElements.rightPanelBgColor;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'customize-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row no-gutters' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              _reactReduxI18n.I18n.t('MAIN')
	            ),
	            columnCount === 0 && _react2.default.createElement(
	              'div',
	              { className: 'float-left' },
	              _react2.default.createElement(
	                'span',
	                { className: 'attribute-title' },
	                _reactReduxI18n.I18n.t('BORDER')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'attribute-color-box', id: 'mainBorder', onClick: this.openColorPicker },
	                _react2.default.createElement('div', { className: 'color-box', id: 'mainBorder', style: labelBorderColor }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'color-box-label', id: 'mainBorder' },
	                  labelBorderColorCode
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.blockClosing },
	                this.state.mainBorderOpen && _react2.default.createElement(_reactColor.SketchPicker, { color: labelBorderColorCode,
	                  disableAlpha: true,
	                  onChange: this.handleColorChange('mainBorder') })
	              )
	            ),
	            columnCount === 1 && _react2.default.createElement(
	              'div',
	              { className: 'float-left' },
	              _react2.default.createElement(
	                'span',
	                { className: 'attribute-title' },
	                _reactReduxI18n.I18n.t('IMAGE_BORDER')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'attribute-color-box', id: 'imageBorder', onClick: this.openColorPicker },
	                _react2.default.createElement('div', { className: 'color-box', id: 'imageBorder', style: imageBorderColor }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'color-box-label', id: 'imageBorder' },
	                  imageBorderColorCode
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.blockClosing },
	                this.state.imageBorderOpen && _react2.default.createElement(_reactColor.SketchPicker, { color: imageBorderColorCode,
	                  disableAlpha: true,
	                  onChange: this.handleColorChange('imageBorder') })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'float-left' },
	              _react2.default.createElement(
	                'span',
	                { className: 'attribute-title' },
	                _reactReduxI18n.I18n.t('BACKGROUND')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'attribute-color-box', id: 'mainBackground', onClick: this.openColorPicker },
	                _react2.default.createElement('div', { className: 'color-box', id: 'mainBackground', style: labelBgColor }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'color-box-label', id: 'mainBackground' },
	                  labelBgColorCode
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.blockClosing },
	                this.state.mainBackgroundOpen && _react2.default.createElement(_reactColor.SketchPicker, { color: labelBgColorCode,
	                  disableAlpha: true,
	                  onChange: this.handleColorChange('mainBackground') })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              _reactReduxI18n.I18n.t('TITLE')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'float-left' },
	              _react2.default.createElement(
	                'span',
	                { className: 'attribute-title' },
	                _reactReduxI18n.I18n.t('TEXT')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'attribute-color-box', id: 'headerFont', onClick: this.openColorPicker },
	                _react2.default.createElement('div', { className: 'color-box', id: 'headerFont', style: headerFontColor }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'color-box-label', id: 'headerFont' },
	                  headerFontColorCode
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.blockClosing },
	                this.state.headerFontOpen && _react2.default.createElement(_reactColor.SketchPicker, { color: headerFontColorCode,
	                  disableAlpha: true,
	                  onChange: this.handleColorChange('headerFont') })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'float-left' },
	              _react2.default.createElement(
	                'span',
	                { className: 'attribute-title' },
	                _reactReduxI18n.I18n.t('BACKGROUND')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'attribute-color-box', id: 'headerBackground', onClick: this.openColorPicker },
	                _react2.default.createElement('div', { className: 'color-box', id: 'headerBackground', style: headerBgColor }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'color-box-label', id: 'headerBackground' },
	                  headerBgColorCode
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.blockClosing },
	                this.state.headerBackgroundOpen && _react2.default.createElement(_reactColor.SketchPicker, { color: headerBgColorCode,
	                  disableAlpha: true,
	                  onChange: this.handleColorChange('headerBackground') })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              _reactReduxI18n.I18n.t('DETAIL')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'float-left' },
	              _react2.default.createElement(
	                'span',
	                { className: 'attribute-title' },
	                _reactReduxI18n.I18n.t('TEXT')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'attribute-color-box', id: 'detailFont', onClick: this.openColorPicker },
	                _react2.default.createElement('div', { className: 'color-box', id: 'detailFont', style: detailFontColor }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'color-box-label', id: 'detailFont' },
	                  detailFontColorCode
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.blockClosing },
	                this.state.detailFontOpen && _react2.default.createElement(_reactColor.SketchPicker, { color: detailFontColorCode,
	                  disableAlpha: true,
	                  onChange: this.handleColorChange('detailFont') })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'float-left' },
	              _react2.default.createElement(
	                'span',
	                { className: 'attribute-title' },
	                _reactReduxI18n.I18n.t('BACKGROUND')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'attribute-color-box', id: 'detailBackground', onClick: this.openColorPicker },
	                _react2.default.createElement('div', { className: 'color-box', id: 'detailBackground', style: detailBgColor }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'color-box-label', id: 'detailBackground' },
	                  detailBgColorCode
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.blockClosing },
	                this.state.detailBackgroundOpen && _react2.default.createElement(_reactColor.SketchPicker, { color: detailBgColorCode,
	                  disableAlpha: true,
	                  onChange: this.handleColorChange('detailBackground') })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              _reactReduxI18n.I18n.t('LABEL')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'float-left' },
	              _react2.default.createElement(
	                'span',
	                { className: 'attribute-title' },
	                _reactReduxI18n.I18n.t('TEXT')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'attribute-color-box', id: 'valueFont', onClick: this.openColorPicker },
	                _react2.default.createElement('div', { className: 'color-box', id: 'valueFont', style: valueFontColor }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'color-box-label', id: 'valueFont' },
	                  valueFontColorCode
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.blockClosing },
	                this.state.valueFontOpen && _react2.default.createElement(_reactColor.SketchPicker, { color: valueFontColorCode,
	                  disableAlpha: true,
	                  onChange: this.handleColorChange('valueFont') })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'float-left' },
	              _react2.default.createElement(
	                'span',
	                { className: 'attribute-title' },
	                _reactReduxI18n.I18n.t('BACKGROUND')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'attribute-color-box', id: 'valueBackground', onClick: this.openColorPicker },
	                _react2.default.createElement('div', { className: 'color-box', id: 'valueBackground', style: valueBgColor }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'color-box-label', id: 'valueBackground' },
	                  valueBgColorCode
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.blockClosing },
	                this.state.valueBackgroundOpen && _react2.default.createElement(_reactColor.SketchPicker, { color: valueBgColorCode,
	                  disableAlpha: true,
	                  onChange: this.handleColorChange('valueBackground') })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              _reactReduxI18n.I18n.t('PRICE')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'float-left' },
	              _react2.default.createElement(
	                'span',
	                { className: 'attribute-title' },
	                _reactReduxI18n.I18n.t('TEXT')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'attribute-color-box', id: 'priceFont', onClick: this.openColorPicker },
	                _react2.default.createElement('div', { className: 'color-box', id: 'priceFont', style: priceFontColor }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'color-box-label', id: 'priceFont' },
	                  priceFontColorCode
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.blockClosing },
	                this.state.priceFontOpen && _react2.default.createElement(_reactColor.SketchPicker, { color: priceFontColorCode,
	                  disableAlpha: true,
	                  onChange: this.handleColorChange('priceFont') })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'float-left' },
	              _react2.default.createElement(
	                'span',
	                { className: 'attribute-title' },
	                _reactReduxI18n.I18n.t('BACKGROUND')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'attribute-color-box', id: 'priceBackground', onClick: this.openColorPicker },
	                _react2.default.createElement('div', { className: 'color-box', id: 'priceBackground', style: priceBgColor }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'color-box-label', id: 'priceBackground' },
	                  priceBgColorCode
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.blockClosing },
	                this.state.priceBackgroundOpen && _react2.default.createElement(_reactColor.SketchPicker, { color: priceBgColorCode,
	                  disableAlpha: true,
	                  onChange: this.handleColorChange('priceBackground') })
	              )
	            )
	          ),
	          columnCount === 1 && _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              _reactReduxI18n.I18n.t('PLU')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'float-left' },
	              _react2.default.createElement(
	                'span',
	                { className: 'attribute-title' },
	                _reactReduxI18n.I18n.t('TEXT')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'attribute-color-box', id: 'pluFont', onClick: this.openColorPicker },
	                _react2.default.createElement('div', { className: 'color-box', id: 'pluFont', style: pluFontColor }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'color-box-label', id: 'pluFont' },
	                  pluFontColorCode
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.blockClosing },
	                this.state.pluFontOpen && _react2.default.createElement(_reactColor.SketchPicker, { color: pluFontColorCode,
	                  disableAlpha: true,
	                  onChange: this.handleColorChange('pluFont') })
	              )
	            )
	          ),
	          columnCount === 1 && _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              _reactReduxI18n.I18n.t('BARCODE')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'float-left' },
	              _react2.default.createElement(
	                'span',
	                { className: 'attribute-title' },
	                _reactReduxI18n.I18n.t('BACKGROUND')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'attribute-color-box', id: 'barCodeBackground', onClick: this.openColorPicker },
	                _react2.default.createElement('div', { className: 'color-box', id: 'barCodeBackground', style: barCodeBgColor }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'color-box-label', id: 'barCodeBackground' },
	                  barCodeBgColorCode
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.blockClosing },
	                this.state.barCodeBackgroundOpen && _react2.default.createElement(_reactColor.SketchPicker, { color: barCodeBgColorCode,
	                  disableAlpha: true,
	                  onChange: this.handleColorChange('barCodeBackground') })
	              )
	            )
	          ),
	          columnCount === 1 && rightPanelColorCode !== undefined && _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              _reactReduxI18n.I18n.t('RIGHTCOLUMN')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'float-left' },
	              _react2.default.createElement(
	                'span',
	                { className: 'attribute-title' },
	                _reactReduxI18n.I18n.t('BACKGROUND')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'attribute-color-box', id: 'rightPanelBackground', onClick: this.openColorPicker },
	                _react2.default.createElement('div', { className: 'color-box', id: 'rightPanelBackground', style: rightPanelBgColor }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'color-box-label', id: 'rightPanelBackground' },
	                  rightPanelColorCode
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.blockClosing },
	                this.state.rightPanelOpen && _react2.default.createElement(_reactColor.SketchPicker, { color: rightPanelColorCode,
	                  disableAlpha: true,
	                  onChange: this.handleColorChange('rightPanelBackground') })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            rightPanelColorCode === undefined && _react2.default.createElement(
	              'button',
	              { className: 'btn btn-link', onClick: onRestoreDefault },
	              _reactReduxI18n.I18n.t('RESTORE_DEFAULT_COLORS')
	            ),
	            rightPanelColorCode !== undefined && _react2.default.createElement(
	              'button',
	              { className: 'margin-four-col-lrg btn btn-link', onClick: onRestoreDefault },
	              _reactReduxI18n.I18n.t('RESTORE_DEFAULT_COLORS')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row customize-logo no-gutters' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6 pr-4' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              _reactReduxI18n.I18n.t('LOGO')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'company-logo' },
	              _react2.default.createElement('img', { src: logoUrl, alt: 'Company Logo', title: 'Company Logo' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6 mt-4' },
	            _react2.default.createElement(
	              'label',
	              { className: 'custom-file' },
	              _react2.default.createElement('input', { type: 'file', id: 'file', className: 'custom-file-input', accept: 'image/jpeg, image/png', onChange: function onChange(e) {
	                  onLogoUpload(e.target.files[0]);
	                } }),
	              _react2.default.createElement(
	                'span',
	                { className: 'custom-file-control' },
	                _reactReduxI18n.I18n.t('UPLOAD_LOGO')
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'attribute-title' },
	              _reactReduxI18n.I18n.t('LOGO_FORMAT')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LabelStylePicker;
	}(_react2.default.Component);
	
	exports.default = LabelStylePicker;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouter = __webpack_require__(28);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _actions = __webpack_require__(33);
	
	var _selectors = __webpack_require__(57);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _LabelPageButtons = __webpack_require__(598);
	
	var _LabelPageButtons2 = _interopRequireDefault(_LabelPageButtons);
	
	var _LabelSheet = __webpack_require__(599);
	
	var _LabelSheet2 = _interopRequireDefault(_LabelSheet);
	
	var _LabelSizeList = __webpack_require__(600);
	
	var _LabelSizeList2 = _interopRequireDefault(_LabelSizeList);
	
	var _PageSetupModal = __webpack_require__(604);
	
	var _PageSetupModal2 = _interopRequireDefault(_PageSetupModal);
	
	var _userPermissions = __webpack_require__(29);
	
	var permissions = _interopRequireWildcard(_userPermissions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* import {clearLabelSheet, createCalibrationLink, getCustomDefinitions, getDefinitions, savePageSetup, selectLabelSize, togglePLU} from '../actions';
	import {getActivePageSize, getCalibrationLink, areDefinitionsValid, getLabelDefinitions, getLabels, getPdfId, isPLUActive} from '../selectors'; */
	
	var _customer$selectors = _customer2.default.selectors,
	    getActivePageOffset = _customer$selectors.getActivePageOffset,
	    getActivePermissions = _customer$selectors.getActivePermissions;
	//import PLUChangeModal from './PLUChangeModal';
	//import PLUSelector from './PLUSelector';
	
	var _ref = _react2.default.createElement('div', { className: 'loading' });
	
	var _ref2 = _react2.default.createElement('div', { className: 'col-xl-1 col-sm-1' });
	
	var _ref3 = _react2.default.createElement('div', { className: 'col-xl-1 col-sm-1' });
	
	var LabelsPage = function (_React$Component) {
	  _inherits(LabelsPage, _React$Component);
	
	  function LabelsPage(props) {
	    _classCallCheck(this, LabelsPage);
	
	    var _this = _possibleConstructorReturn(this, (LabelsPage.__proto__ || Object.getPrototypeOf(LabelsPage)).call(this, props));
	
	    _this.handleLabelSize = function (labelSize) {
	      _this.props.actions.selectLabelSize(labelSize);
	      _this.props.actions.getCustomDefinitions(labelSize);
	    };
	
	    _this.handleShowSetupModal = function () {
	      _this.setState({ setupModalOpen: true });
	    };
	
	    _this.handleHideSetupModal = function () {
	      _this.setState({ setupModalOpen: false });
	    };
	
	    _this.handleSetupChange = function (verticalOffset, horizontalOffset) {
	      _this.props.actions.savePageSetup(_this.props.activePageSize, verticalOffset, horizontalOffset);
	    };
	
	    _this.state = {
	      pluModalOpen: false,
	      setupModalOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(LabelsPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var labelAccess = this.props.activePermissions.find(function (permission) {
	        return permission === permissions.ACCESS_LABELS;
	      });
	      if (!labelAccess) {
	        this.props.actions.push('/no_access');
	      }
	
	      if (!this.props.definitionsValid) {
	        this.props.actions.getDefinitions();
	      }
	
	      /*   this.props.actions.createCalibrationLink(); */
	    }
	
	    /*   handleTogglePLU = () => {
	        this.setState({pluModalOpen: true});
	      }
	    
	      handleHidePluModal = () => {
	        this.setState({pluModalOpen: false});
	      }
	    
	      handlePLUChange = () => {
	        this.props.actions.togglePLU();
	        this.handleHidePluModal();
	      } */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      /* const {actions, activePageSize, activePLU, calibrationLink, definitions, definitionsValid, labelList, pageOffset, pdfId} = this.props; */
	      var _props = this.props,
	          actions = _props.actions,
	          activePageSize = _props.activePageSize,
	          definitions = _props.definitions,
	          definitionsValid = _props.definitionsValid,
	          labelList = _props.labelList,
	          pageOffset = _props.pageOffset,
	          pdfId = _props.pdfId;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid main labels', id: 'main' },
	        !definitionsValid && _ref,
	        definitionsValid && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'row label-info' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                _reactReduxI18n.I18n.t('LABELS')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'label-form' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row no-gutters' },
	                  _react2.default.createElement(_LabelSizeList2.default, { activeSize: activePageSize, definitions: definitions, onSelected: this.handleLabelSize }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xl-12 col-sm-6 p-0 mid' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row no-gutters p-0 m-0' },
	                      _ref2,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xl-12 col-sm-4' },
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { to: '/customize_label', className: 'label-link customize' },
	                          _reactReduxI18n.I18n.t('CUSTOMIZE_COLORS_LOGO')
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xl-12 col-sm-4' },
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { to: '/advanced_settings_label', className: 'label-link customize' },
	                          _reactReduxI18n.I18n.t('ADVANCED_SETTINGS_LINK')
	                        )
	                      ),
	                      _ref3
	                    )
	                  ),
	                  _react2.default.createElement(_LabelPageButtons2.default, { onClear: actions.clearLabelSheet, pdfId: pdfId })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_LabelSheet2.default, { labels: labelList })
	        ),
	        _react2.default.createElement(_PageSetupModal2.default, { isOpen: this.state.setupModalOpen,
	          onClose: this.handleHideSetupModal,
	          onAccept: this.handleSetupChange,
	          offsetValue: pageOffset
	        })
	      );
	    }
	  }]);
	
	  return LabelsPage;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    activePageSize: (0, _selectors.getActivePageSize)(state),
	    activePermissions: getActivePermissions(state),
	    //    activePLU: getUsePLUCode(state),
	    // calibrationLink: getCalibrationLink(state),
	    definitions: (0, _selectors.getLabelDefinitions)(state),
	    definitionsValid: (0, _selectors.areDefinitionsValid)(state),
	    labelList: (0, _selectors.getLabels)(state),
	    pageOffset: getActivePageOffset(state),
	    pdfId: (0, _selectors.getPdfId)(state)
	
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ clearLabelSheet: _actions.clearLabelSheet,
	      //                      createCalibrationLink, 
	      getCustomDefinitions: _actions.getCustomDefinitions,
	      getDefinitions: _actions.getDefinitions,
	      savePageSetup: _actions.savePageSetup,
	      selectLabelSize: _actions.selectLabelSize,
	      togglePLU: _actions.togglePLU,
	      push: _reactRouterRedux.push }, dispatch)
	  };
	}
	
	LabelsPage.defaultProps = {
	  activePermissions: [],
	  pageOffset: {}
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LabelsPage);

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NoAccessPage = function (_React$Component) {
	  _inherits(NoAccessPage, _React$Component);
	
	  function NoAccessPage() {
	    _classCallCheck(this, NoAccessPage);
	
	    return _possibleConstructorReturn(this, (NoAccessPage.__proto__ || Object.getPrototypeOf(NoAccessPage)).apply(this, arguments));
	  }
	
	  _createClass(NoAccessPage, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid main', id: 'main' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-12' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'float-left' },
	              _reactReduxI18n.I18n.t('ACCESS_WELCOME')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NoAccessPage;
	}(_react2.default.Component);
	
	exports.default = NoAccessPage;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(56);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* import {Link} from 'react-router'; */
	
	
	var _ref = _react2.default.createElement('span', { className: 'lnr lnr-cross', 'aria-hidden': 'true' });
	
	var _ref2 = _react2.default.createElement('br', null);
	
	var PageSetupModal = function (_React$Component) {
	  _inherits(PageSetupModal, _React$Component);
	
	  function PageSetupModal(props) {
	    _classCallCheck(this, PageSetupModal);
	
	    var _this = _possibleConstructorReturn(this, (PageSetupModal.__proto__ || Object.getPrototypeOf(PageSetupModal)).call(this, props));
	
	    _this.handleVerticalChange = function (e) {
	      _this.setState({ verticalOffset: e.target.value });
	    };
	
	    _this.handleHorizontalChange = function (e) {
	      _this.setState({ horizontalOffset: e.target.value });
	    };
	
	    _this.handleSave = function () {
	      _this.props.onAccept(_this.state.verticalOffset, _this.state.horizontalOffset);
	    };
	
	    _this.handleVerticalSave = function (e) {
	      _this.props.onAccept(e.target.value, _this.state.horizontalOffset);
	    };
	
	    _this.handleHorizontalSave = function (e) {
	      _this.props.onAccept(_this.state.verticalOffset, e.target.value);
	    };
	
	    var posY = 0;
	    var posX = 0;
	    if (props.offsetValue !== null) {
	      posY = props.offsetValue.PosY;
	      posX = props.offsetValue.PosX;
	    }
	
	    _this.state = {
	      verticalOffset: posY,
	      horizontalOffset: posX
	    };
	    return _this;
	  }
	
	  _createClass(PageSetupModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      /* const {isOpen, onClose, calibrationLink} = this.props; */
	
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          onClose = _props.onClose;
	
	
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        { isOpen: isOpen, toggle: onClose, id: 'modalPageSetup', className: 'wide-modal' },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-header' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'modal-title', id: 'exampleModalLabel' },
	            _reactReduxI18n.I18n.t('PRINTER_ADJUSTMENT')
	          ),
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close', onClick: onClose },
	            _ref
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _reactReduxI18n.I18n.t('ADJUSTMENT_INSTRUCTIONS') } }),
	              _ref2
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _reactReduxI18n.I18n.t('B_HORIZONTAL'),
	              _react2.default.createElement('input', { className: 'form-control', type: 'number', value: this.state.horizontalOffset, id: 'example-text-input',
	                onChange: function onChange(e) {
	                  _this2.handleHorizontalChange(e);_this2.handleHorizontalSave(e);
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _reactReduxI18n.I18n.t('A_VERTICAL'),
	              _react2.default.createElement('input', { className: 'form-control', type: 'number', value: this.state.verticalOffset, id: 'example-text-input',
	                onChange: function onChange(e) {
	                  _this2.handleVerticalChange(e);_this2.handleVerticalSave(e);
	                } })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PageSetupModal;
	}(_react2.default.Component);
	
	exports.default = PageSetupModal;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PetLabelInfo = function (_React$Component) {
	  _inherits(PetLabelInfo, _React$Component);
	
	  function PetLabelInfo() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PetLabelInfo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PetLabelInfo.__proto__ || Object.getPrototypeOf(PetLabelInfo)).call.apply(_ref, [this].concat(args))), _this), _this.handleLabelSelected = function (petLabel) {
	      var price = _this.refs[petLabel.Id].value;
	      _this.props.onSelected(petLabel, price);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PetLabelInfo, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          petLabel = _props.petLabel,
	          enabled = _props.enabled;
	
	
	      var priceDefault = "";
	      if (petLabel.Price !== '') {
	        priceDefault = petLabel.Price;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'col-lg-6 col-sm-12 col-pet' },
	        _react2.default.createElement(
	          'div',
	          { className: 'media' },
	          _react2.default.createElement(
	            'div',
	            { className: 'mr-3 align-self-start' },
	            _react2.default.createElement('img', { src: petLabel.ImageUrl, alt: petLabel.Line1 })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'media-body' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              petLabel.Line1
	            ),
	            _react2.default.createElement(
	              'h6',
	              null,
	              petLabel.Line2
	            ),
	            _react2.default.createElement(
	              'h6',
	              null,
	              petLabel.Line3,
	              ' '
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row plu-barcode no-gutters' },
	              _react2.default.createElement(
	                'span',
	                { className: 'plu' },
	                petLabel.Line4
	              )
	            ),
	            _react2.default.createElement('input', { id: petLabel.Id, name: petLabel.Id, type: 'text', className: 'form-control', key: petLabel.Id + 'a' + petLabel.ArticleMappingEntryID,
	              placeholder: _reactReduxI18n.I18n.t('ENTER_PRICE_SEARCH_RESULTS'), defaultValue: priceDefault, ref: petLabel.Id }),
	            _react2.default.createElement(
	              'button',
	              { type: 'button', onClick: function onClick() {
	                  _this2.handleLabelSelected(petLabel);
	                }, className: 'btn btn-primary', disabled: !enabled },
	              _reactReduxI18n.I18n.t('ADD')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PetLabelInfo;
	}(_react2.default.Component);
	
	exports.default = PetLabelInfo;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _ReactList = __webpack_require__(265);
	
	var _ReactList2 = _interopRequireDefault(_ReactList);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _search = __webpack_require__(174);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _actions = __webpack_require__(33);
	
	var _selectors = __webpack_require__(57);
	
	var _BackButton = __webpack_require__(586);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _CustomDropdown = __webpack_require__(588);
	
	var _CustomDropdown2 = _interopRequireDefault(_CustomDropdown);
	
	var _PetLabelInfo = __webpack_require__(605);
	
	var _PetLabelInfo2 = _interopRequireDefault(_PetLabelInfo);
	
	var _LabelAddedModal = __webpack_require__(595);
	
	var _LabelAddedModal2 = _interopRequireDefault(_LabelAddedModal);
	
	var _userPermissions = __webpack_require__(29);
	
	var permissions = _interopRequireWildcard(_userPermissions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _customer$selectors = _customer2.default.selectors,
	    getActivePermissions = _customer$selectors.getActivePermissions,
	    getUsePLUCode = _customer$selectors.getUsePLUCode;
	var SearchPanel = _search2.default.components.SearchPanel;
	
	var _ref2 = _react2.default.createElement(_BackButton2.default, { url: '/labels' });
	
	var _ref3 = _react2.default.createElement('div', { className: 'loading' });
	
	var PetSearchPage = function (_React$Component) {
	  _inherits(PetSearchPage, _React$Component);
	
	  function PetSearchPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PetSearchPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PetSearchPage.__proto__ || Object.getPrototypeOf(PetSearchPage)).call.apply(_ref, [this].concat(args))), _this), _this.handleFormSubmit = function (values) {
	      _this.props.actions.searchPetLabels(values.searchPhrase);
	    }, _this.handleLabelSelected = function (petLabel, price) {
	      _this.props.actions.disableLabelAdd();
	      _this.props.actions.quickSaveLabelToSheet(_this.props.activePageSize, petLabel, price, _this.props.activePLU);
	    }, _this.handleCustomLabel = function (petType) {
	      _this.props.actions.selectCustomLabel(petType);
	      _this.props.actions.push('/custom_label');
	    }, _this.handleLabelModalClose = function () {
	      _this.props.actions.hideLabelModal();
	      _this.props.actions.enableLabelAdd();
	    }, _this.renderItem = function (index, key) {
	      return _react2.default.createElement(_PetLabelInfo2.default, { key: key, petLabel: _this.props.searchResults[index], onSelected: _this.handleLabelSelected, enabled: _this.props.labelAddEnabled });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PetSearchPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var labelAccess = this.props.activePermissions.find(function (permission) {
	        return permission === permissions.ACCESS_LABELS;
	      });
	      if (!labelAccess) {
	        this.props.actions.push('/labels');
	      } else if (this.props.selectedGridIndex < 0) {
	        this.props.actions.push('/labels');
	      } else if (!this.props.petLabelsValid) {
	        this.props.actions.getPetLabelList();
	      }
	      if (this.props.emptyLabels <= 0) {
	        this.props.actions.clearSearchResults();
	        this.props.actions.push("/labels");
	      }
	      this.props.actions.hideLabelModal();
	      this.props.actions.enableLabelAdd();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.emptyLabels <= 0) {
	        this.props.actions.hideLabelModal();
	        this.props.actions.clearSearchResults();
	        this.props.actions.push("/labels");
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actions = _props.actions,
	          petLabelsValid = _props.petLabelsValid,
	          petTypeList = _props.petTypeList,
	          searchPhrase = _props.searchPhrase,
	          searchResults = _props.searchResults,
	          selectedPetTypes = _props.selectedPetTypes,
	          isModalOpen = _props.isModalOpen;
	
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid main full-width', id: 'main' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'float-left' },
	                _reactReduxI18n.I18n.t('CREATE_LABEL')
	              ),
	              _ref2
	            )
	          ),
	          !petLabelsValid && _ref3,
	          petLabelsValid && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-lg-12' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'float-left search-pets-title' },
	                  _reactReduxI18n.I18n.t('SEARCH_PETS')
	                ),
	                _react2.default.createElement(_CustomDropdown2.default, { petTypeList: petTypeList, onSelected: this.handleCustomLabel }),
	                _react2.default.createElement(SearchPanel, { itemList: petTypeList,
	                  onSelectedItem: actions.toggleSelectedPetType,
	                  onSubmit: this.handleFormSubmit,
	                  selectedItems: selectedPetTypes }),
	                searchResults.length === 0 && searchPhrase === '' && _react2.default.createElement(
	                  'div',
	                  { className: 'no-recent-labels' },
	                  _react2.default.createElement(
	                    'h1',
	                    null,
	                    _reactReduxI18n.I18n.t('SEARCH_FOR_A_PET')
	                  ),
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    _reactReduxI18n.I18n.t('OR_CREATE_CUSTOM_LABEL')
	                  )
	                ),
	                searchResults.length === 0 && searchPhrase !== '' && _react2.default.createElement(
	                  'div',
	                  { className: 'no-recent-labels' },
	                  _react2.default.createElement(
	                    'h1',
	                    null,
	                    _reactReduxI18n.I18n.t('NO_RESULTS_TRY_AGAIN')
	                  ),
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    _reactReduxI18n.I18n.t('OR_CREATE_CUSTOM_LABEL')
	                  )
	                ),
	                searchResults.length > 0 && _react2.default.createElement(
	                  'h5',
	                  null,
	                  _reactReduxI18n.I18n.t('RESULTS'),
	                  ' (',
	                  searchResults.length,
	                  ')'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row search-results care-sheets' },
	              _react2.default.createElement(_ReactList2.default, { itemRenderer: this.renderItem, length: searchResults.length, type: 'uniform' })
	            )
	          )
	        ),
	        _react2.default.createElement(_LabelAddedModal2.default, { isOpen: isModalOpen, onClose: this.handleLabelModalClose })
	      );
	    }
	  }]);
	
	  return PetSearchPage;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    activePageSize: (0, _selectors.getActivePageSize)(state),
	    activePermissions: getActivePermissions(state),
	    isModalOpen: (0, _selectors.isLabelModalOpen)(state),
	    petLabelsValid: (0, _selectors.arePetLabelsValid)(state),
	    petTypeList: (0, _selectors.getPetTypes)(state),
	    searchPhrase: (0, _selectors.getSearchPhrase)(state),
	    searchResults: (0, _selectors.getSearchResults)(state),
	    selectedGridIndex: (0, _selectors.getSelectedGridIndex)(state),
	    selectedPetTypes: (0, _selectors.getSelectedPetTypes)(state),
	    emptyLabels: (0, _selectors.getEmptyLabels)(state),
	    labelAddEnabled: (0, _selectors.isLabelAddEnabled)(state),
	    activePLU: getUsePLUCode(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ clearSearchResults: _actions.clearSearchResults,
	      getPetLabelList: _actions.getPetLabelList,
	      push: _reactRouterRedux.push,
	      searchPetLabels: _actions.searchPetLabels,
	      selectCustomLabel: _actions.selectCustomLabel,
	      selectPetLabel: _actions.selectPetLabel,
	      toggleSelectedPetType: _actions.toggleSelectedPetType,
	      quickSaveLabelToSheet: _actions.quickSaveLabelToSheet,
	      hideLabelModal: _actions.hideLabelModal,
	      disableLabelAdd: _actions.disableLabelAdd,
	      enableLabelAdd: _actions.enableLabelAdd }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PetSearchPage);

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSortableHoc = __webpack_require__(494);
	
	var _Label = __webpack_require__(594);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ITEM_BORDER = 10;
	
	var Item = (0, _reactSortableHoc.SortableElement)(function (props) {
	  var itemWidth = props.labelSize.width + ITEM_BORDER + 'px';
	  var itemHeight = props.labelSize.height + ITEM_BORDER + 'px';
	
	  var gridItemClass = 'gridItem';
	  if (Object.keys(props.data).length !== 0) {
	    gridItemClass += ' filled';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: props.className, style: { height: itemHeight, maxHeight: itemHeight, width: itemWidth, maxWidth: itemWidth } },
	    _react2.default.createElement(
	      'div',
	      { className: gridItemClass },
	      _react2.default.createElement(_Label2.default, { canHover: props.canHover, data: props.data, index: props.labelIndex, onSelected: props.onSelected })
	    )
	  );
	});
	
	var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref) {
	  var className = _ref.className,
	      isSorting = _ref.isSorting,
	      items = _ref.items,
	      itemClass = _ref.itemClass,
	      labelSize = _ref.labelSize,
	      onSelected = _ref.onSelected;
	
	  var gridWidth = (labelSize.width + ITEM_BORDER) * 2;
	  return _react2.default.createElement(
	    'div',
	    { className: className, style: { width: gridWidth + 'px' } },
	    items.map(function (label, index) {
	      return _react2.default.createElement(Item, {
	        key: 'item-' + index,
	        className: itemClass,
	        index: index,
	        labelIndex: index,
	        data: label,
	        onSelected: onSelected,
	        labelSize: labelSize,
	        canHover: !isSorting
	      });
	    })
	  );
	});
	
	exports.default = SortableList;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _paracheirodon_innesi = __webpack_require__(142);
	
	var _paracheirodon_innesi2 = _interopRequireDefault(_paracheirodon_innesi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement('img', { src: _paracheirodon_innesi2.default, className: 'float-left' });
	
	var _ref3 = _react2.default.createElement('div', { className: 'barcode-customize barcode float-right' });
	
	var StyledLabel2Col = function StyledLabel2Col(_ref) {
	  var logoUrl = _ref.logoUrl,
	      styleElements = _ref.styleElements;
	
	  // Create the element styles
	  var headerBackground = { background: styleElements.headerBgColor };
	  var headerFont = { color: styleElements.headerFontColor };
	  var detailBackground = { backgroundColor: styleElements.detailBgColor };
	  var detailFont = { color: styleElements.detailFontColor };
	  var valueBackground = { backgroundColor: styleElements.valueBgColor };
	  var valueFont = { color: styleElements.valueFontColor };
	  var priceBackground = { backgroundColor: styleElements.priceBgColor };
	  var priceFont = { color: styleElements.priceFontColor };
	  var labelBackground = { background: styleElements.labelBgColor };
	  var tableBackground = { borderColor: styleElements.labelBgColor };
	  var labelBorder = { borderColor: styleElements.labelBorderColor };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'label-main 2col', style: labelBorder },
	    _react2.default.createElement(
	      'div',
	      { className: 'label-title', style: headerBackground },
	      _react2.default.createElement(
	        'span',
	        { className: 'label-control form-control', style: headerFont },
	        _reactReduxI18n.I18n.t('CUSTOM_LABEL_PET_LAT_NAME')
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'label-control form-control latin-name', style: headerFont },
	        _reactReduxI18n.I18n.t('CUSTOM_LABEL_PET_NAME')
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'label-content', style: labelBackground },
	      _ref2,
	      _react2.default.createElement(
	        'table',
	        { className: 'float-left', cellPadding: '0', cellSpacing: '0' },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_2')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_2')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_1')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_1')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_4')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_3')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_3')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_4')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_5')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_5')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_6')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_6')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('PLU')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                '12345'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'label-footer', style: priceBackground },
	      _react2.default.createElement(
	        'span',
	        { className: 'label-control form-control float-left txt-price', style: priceFont },
	        _reactReduxI18n.I18n.t('CUSTOM_LABEL_PET_PRICE')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'label-logo' },
	        _react2.default.createElement('img', { src: logoUrl })
	      ),
	      _ref3
	    )
	  );
	};
	
	exports.default = StyledLabel2Col;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _paracheirodon_innesi = __webpack_require__(142);
	
	var _paracheirodon_innesi2 = _interopRequireDefault(_paracheirodon_innesi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement('img', { src: _paracheirodon_innesi2.default, className: 'float-left' });
	
	var _ref3 = _react2.default.createElement('div', { className: 'barcode-customize barcode float-right' });
	
	var StyledLabel2ColLrg = function StyledLabel2ColLrg(_ref) {
	  var logoUrl = _ref.logoUrl,
	      styleElements = _ref.styleElements;
	
	  // Create the element styles
	  var headerBackground = { background: styleElements.headerBgColor };
	  var headerFont = { color: styleElements.headerFontColor };
	  var detailBackground = { backgroundColor: styleElements.detailBgColor };
	  var detailFont = { color: styleElements.detailFontColor };
	  var valueBackground = { backgroundColor: styleElements.valueBgColor };
	  var valueFont = { color: styleElements.valueFontColor };
	  var priceBackground = { backgroundColor: styleElements.priceBgColor };
	  var priceFont = { color: styleElements.priceFontColor };
	  var labelBackground = { background: styleElements.labelBgColor };
	  var tableBackground = { borderColor: styleElements.labelBgColor };
	  var labelBorder = { borderColor: styleElements.labelBorderColor };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'two-col-lrg label-main', style: labelBorder },
	    _react2.default.createElement(
	      'div',
	      { className: 'label-title', style: headerBackground },
	      _react2.default.createElement(
	        'span',
	        { className: 'label-control form-control', style: headerFont },
	        _reactReduxI18n.I18n.t('CUSTOM_LABEL_PET_LAT_NAME')
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'label-control form-control latin-name', style: headerFont },
	        _reactReduxI18n.I18n.t('CUSTOM_LABEL_PET_NAME')
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'label-content', style: labelBackground },
	      _react2.default.createElement(
	        'div',
	        { className: 'label-footer' },
	        _ref2,
	        _react2.default.createElement(
	          'div',
	          { className: 'label-info-left-col', style: priceBackground },
	          _react2.default.createElement(
	            'span',
	            { className: 'label-control form-control float-left txt-price', style: priceFont },
	            _reactReduxI18n.I18n.t('CUSTOM_LABEL_PET_PRICE')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'label-logo' },
	            _react2.default.createElement('img', { src: logoUrl })
	          ),
	          _ref3
	        )
	      ),
	      _react2.default.createElement(
	        'table',
	        { className: 'float-left', cellPadding: '0', cellSpacing: '0' },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_7')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_7')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_8')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_8')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_9')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_9')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_1')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_1')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_4')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_4')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_3')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_3')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_11')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_11')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_12')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_12')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_14')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_14')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_5')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_5')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_17')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_17')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_16')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_16')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_18')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_18')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_6')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_6')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_13')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_13')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_19')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_19')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('PLU')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                '12345'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = StyledLabel2ColLrg;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _paracheirodon_innesi = __webpack_require__(142);
	
	var _paracheirodon_innesi2 = _interopRequireDefault(_paracheirodon_innesi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement('div', { className: 'barcode' });
	
	var StyledLabel4Col = function StyledLabel4Col(_ref) {
	  var logoUrl = _ref.logoUrl,
	      styleElements = _ref.styleElements;
	
	  // Create the element styles
	  var headerBackground = { background: styleElements.headerBgColor };
	  var headerFont = { color: styleElements.headerFontColor };
	  var detailFont = { color: styleElements.detailFontColor };
	  var valueBackground = { backgroundColor: styleElements.valueBgColor };
	  var valueFont = { color: styleElements.valueFontColor };
	  var priceFont = { color: styleElements.priceFontColor };
	
	  var labelBorder = { borderColor: styleElements.labelBgColor };
	  var imageBackground = { backgroundColor: styleElements.labelBgColor };
	  var pluFont = { color: styleElements.pluFontColor };
	  var barCodeBackground = { backgroundColor: styleElements.barCodeBgColor };
	  var labelRightCol = { backgroundColor: styleElements.labelBgColor, borderColor: styleElements.labelBgColor };
	  var priceBackground = { backgroundColor: styleElements.priceBgColor, borderColor: styleElements.labelBgColor };
	  var tableRowBackground = { borderBottomColor: styleElements.labelBgColor, borderTopColor: styleElements.labelBgColor };
	  var detailBackground = { backgroundColor: styleElements.detailBgColor, borderLeftColor: styleElements.labelBgColor };
	  var imageBorder = { borderColor: styleElements.imageBorderColor };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'four-col label-main', style: labelBorder },
	    _react2.default.createElement(
	      'div',
	      { className: 'label-logo', style: imageBackground },
	      _react2.default.createElement('img', { src: logoUrl })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'label-title', style: headerBackground },
	      _react2.default.createElement(
	        'span',
	        { className: 'label-control form-control', style: headerFont },
	        _reactReduxI18n.I18n.t('CUSTOM_LABEL_PET_LAT_NAME')
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'label-control form-control latin-name', style: headerFont },
	        _reactReduxI18n.I18n.t('CUSTOM_LABEL_PET_NAME')
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'label-right-col', style: labelRightCol },
	      _react2.default.createElement('img', { src: _paracheirodon_innesi2.default, style: imageBorder }),
	      _react2.default.createElement(
	        'div',
	        { className: 'price', style: priceBackground },
	        _react2.default.createElement(
	          'span',
	          { className: 'label-control form-control txt-price', style: priceFont },
	          _reactReduxI18n.I18n.t('CUSTOM_LABEL_PET_PRICE')
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'plu' },
	        _react2.default.createElement(
	          'span',
	          { className: 'label-control form-control', style: pluFont },
	          '12345'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'label-content' },
	      _react2.default.createElement(
	        'table',
	        { cellPadding: '0', cellSpacing: '0' },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            { style: tableRowBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_1')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_1')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_2')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_2')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableRowBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_3')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_3')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_4')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_4')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableRowBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_5')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_5')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_6')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_6')
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'label-footer', style: barCodeBackground },
	      _ref2
	    )
	  );
	};
	
	exports.default = StyledLabel4Col;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _paracheirodon_innesi = __webpack_require__(142);
	
	var _paracheirodon_innesi2 = _interopRequireDefault(_paracheirodon_innesi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement('div', { className: 'barcode' });
	
	var StyledLabel4ColLrg = function StyledLabel4ColLrg(_ref) {
	  var logoUrl = _ref.logoUrl,
	      styleElements = _ref.styleElements;
	
	  // Create the element styles
	  var headerBackground = { background: styleElements.headerBgColor };
	  var headerFont = { color: styleElements.headerFontColor };
	  var detailFont = { color: styleElements.detailFontColor };
	  var valueBackground = { backgroundColor: styleElements.valueBgColor };
	  var valueFont = { color: styleElements.valueFontColor };
	  var priceFont = { color: styleElements.priceFontColor };
	
	  var pluFont = { color: styleElements.pluFontColor };
	  var barCodeBackground = { backgroundColor: styleElements.barCodeBgColor };
	  var priceBackground = { backgroundColor: styleElements.priceBgColor, borderColor: styleElements.labelBgColor };
	  var tableRowBackground = { borderBottomColor: styleElements.labelBgColor, borderTopColor: styleElements.labelBgColor };
	  var detailBackground = { backgroundColor: styleElements.detailBgColor, borderLeftColor: styleElements.labelBgColor };
	  var imageBorder = { borderColor: styleElements.imageBorderColor };
	  var fullLabel = { backgroundColor: styleElements.labelBgColor };
	  var rightPanelBackground = { backgroundColor: styleElements.rightPanelBgColor };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'four-col-lrg label-main', style: fullLabel },
	    _react2.default.createElement(
	      'div',
	      { className: 'label-title', style: headerBackground },
	      _react2.default.createElement(
	        'div',
	        { className: 'label-left-img' },
	        _react2.default.createElement('img', { src: _paracheirodon_innesi2.default, style: imageBorder })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'title-fields' },
	        _react2.default.createElement(
	          'span',
	          { className: 'label-control form-control', style: headerFont },
	          _reactReduxI18n.I18n.t('CUSTOM_LABEL_PET_LAT_NAME')
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'label-control form-control latin-name', style: headerFont },
	          _reactReduxI18n.I18n.t('CUSTOM_LABEL_PET_NAME')
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'label-right-col', style: rightPanelBackground },
	      _react2.default.createElement(
	        'div',
	        { className: 'label-logo', style: rightPanelBackground },
	        _react2.default.createElement('img', { src: logoUrl })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'price', style: priceBackground },
	        _react2.default.createElement(
	          'span',
	          { className: 'label-control form-control txt-price', style: priceFont },
	          _reactReduxI18n.I18n.t('CUSTOM_LABEL_PET_PRICE')
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'plu' },
	        _react2.default.createElement(
	          'span',
	          { className: 'label-control form-control', style: pluFont },
	          '12345'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'label-footer', style: barCodeBackground },
	        _ref2
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'label-content' },
	      _react2.default.createElement(
	        'table',
	        { cellPadding: '0', cellSpacing: '0' },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            { style: tableRowBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_7')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_7')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_8')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_8')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableRowBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_1')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_1')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_9')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_9')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableRowBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_4')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_4')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_3')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_3')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableRowBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_14')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_14')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_11')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_11')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableRowBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_5')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_5')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_12')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_12')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableRowBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_17')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_17')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_16')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_16')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: tableRowBackground },
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_13')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_13')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'category', style: detailBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: detailFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_KEY_6')
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'info', style: valueBackground },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-control form-control', style: valueFont },
	                _reactReduxI18n.I18n.t('CUSTOM_LABEL_VALUE_6')
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = StyledLabel4ColLrg;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AdvancedSettingsPage = exports.NoAccessPage = exports.PetSearchPage = exports.LabelsPage = exports.EditLabelPage = exports.CustomizeLabelPage = exports.CustomLabelPage = exports.CreateLabelPage = exports.ArticlesPage = undefined;
	
	var _ArticlesPage = __webpack_require__(585);
	
	var _ArticlesPage2 = _interopRequireDefault(_ArticlesPage);
	
	var _CreateLabelPage = __webpack_require__(587);
	
	var _CreateLabelPage2 = _interopRequireDefault(_CreateLabelPage);
	
	var _CustomLabelPage = __webpack_require__(589);
	
	var _CustomLabelPage2 = _interopRequireDefault(_CustomLabelPage);
	
	var _CustomizeLabelPage = __webpack_require__(590);
	
	var _CustomizeLabelPage2 = _interopRequireDefault(_CustomizeLabelPage);
	
	var _EditLabelPage = __webpack_require__(591);
	
	var _EditLabelPage2 = _interopRequireDefault(_EditLabelPage);
	
	var _LabelsPage = __webpack_require__(602);
	
	var _LabelsPage2 = _interopRequireDefault(_LabelsPage);
	
	var _PetSearchPage = __webpack_require__(606);
	
	var _PetSearchPage2 = _interopRequireDefault(_PetSearchPage);
	
	var _NoAccessPage = __webpack_require__(603);
	
	var _NoAccessPage2 = _interopRequireDefault(_NoAccessPage);
	
	var _AdvancedSettingsPage = __webpack_require__(582);
	
	var _AdvancedSettingsPage2 = _interopRequireDefault(_AdvancedSettingsPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ArticlesPage = _ArticlesPage2.default;
	exports.CreateLabelPage = _CreateLabelPage2.default;
	exports.CustomLabelPage = _CustomLabelPage2.default;
	exports.CustomizeLabelPage = _CustomizeLabelPage2.default;
	exports.EditLabelPage = _EditLabelPage2.default;
	exports.LabelsPage = _LabelsPage2.default;
	exports.PetSearchPage = _PetSearchPage2.default;
	exports.NoAccessPage = _NoAccessPage2.default;
	exports.AdvancedSettingsPage = _AdvancedSettingsPage2.default;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	
	var _reactSortableHoc = __webpack_require__(494);
	
	var _thenby = __webpack_require__(91);
	
	var _thenby2 = _interopRequireDefault(_thenby);
	
	var _actionTypes = __webpack_require__(269);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialSearch = {
	  petTypes: [],
	  results: [],
	  phrase: '',
	  selectedPetTypes: []
	};
	
	var initialState = {
	  list: [],
	
	  grid: {
	    isSorting: false
	  },
	
	  petLabels: [],
	  petLabelsValid: false,
	
	  search: initialSearch,
	
	  selected: {
	    gridIndex: -1,
	    petLabelId: -1,
	    articleMappingId: -1
	  },
	
	  active: {
	    petLabel: {}
	  },
	
	  definitions: [],
	  definitionsValid: false,
	
	  customDefinitions: [],
	  selectedCustomType: '',
	
	  activeSize: '',
	  activePLU: false,
	
	  pdfId: '0',
	
	  articles: [],
	  articlesValid: false,
	  shownArticles: [],
	  articleSortColumn: null,
	  articleSortDirection: '',
	  articleFilters: {},
	
	  calibrationLink: '',
	
	  labelModalOpen: false,
	  labelAddEnabled: true
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case types.SET_GRID_SORTING:
	      {
	        return _extends({}, state, {
	          grid: _extends({}, state.grid, {
	            isSorting: action.payload.isSorting
	          })
	        });
	      }
	    case types.SET_LABEL_INDEX:
	      {
	        var _action$payload = action.payload,
	            oldIndex = _action$payload.oldIndex,
	            newIndex = _action$payload.newIndex;
	
	        var list = (0, _reactSortableHoc.arrayMove)(state.list, oldIndex, newIndex);
	        return _extends({}, state, {
	          list: list
	        });
	      }
	    case types.SELECT_LABEL:
	      {
	        return _extends({}, state, {
	          selected: _extends({}, state.selected, {
	            gridIndex: action.payload.index
	          })
	        });
	      }
	    case types.PET_LABEL_LIST_RECEIVED:
	      {
	        return _extends({}, state, {
	          petLabels: action.payload.petLabels,
	          petLabelsValid: true
	        });
	      }
	    case types.PET_LABEL_LIST_RELOAD:
	      {
	        var li = action.payload.isValid;
	
	        return _extends({}, state, {
	          petLabelsValid: li
	        });
	      }
	
	    case types.PET_LABEL_PRICE_UPDATE:
	      {
	        var labelIndex = -1;
	        var newArticles = [].concat(_toConsumableArray(state.petLabels));
	        newArticles.find(function (petLabel, index) {
	          if (petLabel.Id === action.payload.label.Id && petLabel.ArticleMappingEntryID === action.payload.label.ArticleMappingEntryID) {
	            return labelIndex = index;
	          }
	        });
	
	        //state.petLabels.slice(0);
	        var newpet = JSON.parse(JSON.stringify(action.payload.label));
	        newpet.Price = action.payload.price;
	        newArticles[labelIndex] = newpet;
	
	        return _extends({}, state, {
	          petLabels: newArticles
	        });
	      }
	
	    case types.PET_TYPES_ADDED:
	      {
	        return _extends({}, state, {
	          search: _extends({}, state.search, {
	            petTypes: action.payload.petTypes,
	            selectedPetTypes: action.payload.selectedPetTypes
	          })
	        });
	      }
	    case types.TOGGLE_SELECTED_PET_TYPE:
	      {
	        var selectedPetTypes = [].concat(_toConsumableArray(state.search.selectedPetTypes));
	        var togglePetType = action.payload.petType;
	
	        var found = selectedPetTypes.find(function (petType) {
	          return petType === togglePetType;
	        });
	
	        if (found) {
	          var index = selectedPetTypes.indexOf(togglePetType);
	          selectedPetTypes.splice(index, 1);
	        } else {
	          selectedPetTypes.push(togglePetType);
	        }
	
	        return _extends({}, state, {
	          search: _extends({}, state.search, {
	            selectedPetTypes: selectedPetTypes
	          })
	        });
	      }
	    case types.LABELS_SEARCH_PHRASE:
	      {
	        var searchPhrase = '';
	        if (action.payload.searchPhrase !== undefined) {
	          searchPhrase = action.payload.searchPhrase.toLowerCase();
	        } else {
	          searchPhrase = '';
	        }
	
	        return _extends({}, state, {
	          search: _extends({}, state.search, {
	            phrase: searchPhrase
	          })
	        });
	      }
	    case types.CLEAR_SEARCH_RESULTS:
	      {
	        return _extends({}, state, {
	          search: _extends({}, state.search, {
	            results: [],
	            phrase: '',
	            selectedPetType: state.search.petTypes
	          })
	        });
	      }
	    case types.FILTER_PET_LABELS:
	      {
	        var _searchPhrase = state.search.phrase;
	
	        var searchAllTypes = state.search.petTypes.length === state.search.selectedPetTypes.length || state.search.selectedPetTypes.length === 0 ? true : false;
	
	        var searchResults = state.petLabels.filter(function (petLabel) {
	          if (searchAllTypes) {
	            return petLabel.Line1 !== null && petLabel.Line1.toLowerCase().indexOf(_searchPhrase) >= 0 || petLabel.Line2 !== null && petLabel.Line2.toLowerCase().indexOf(_searchPhrase) >= 0 || petLabel.Line3 !== null && petLabel.Line3.toLowerCase().indexOf(_searchPhrase) >= 0 || petLabel.Line4 !== null && petLabel.Line4.toLowerCase().indexOf(_searchPhrase) >= 0;
	          } else {
	            return state.search.selectedPetTypes.includes(petLabel.PetType) && (petLabel.Line1 !== null && petLabel.Line1.toLowerCase().indexOf(_searchPhrase) >= 0 || petLabel.Line2 !== null && petLabel.Line2.toLowerCase().indexOf(_searchPhrase) >= 0 || petLabel.Line3 !== null && petLabel.Line3.toLowerCase().indexOf(_searchPhrase) >= 0 || petLabel.Line4 !== null && petLabel.Line4.toLowerCase().indexOf(_searchPhrase) >= 0);
	          }
	        });
	
	        searchResults.sort((0, _thenby2.default)("Line1").thenBy("Line2"));
	
	        return _extends({}, state, {
	          search: _extends({}, state.search, {
	            results: searchResults
	          })
	        });
	      }
	    case types.SELECT_PET_LABEL:
	      {
	        return _extends({}, state, {
	          selected: _extends({}, state.selected, {
	            petLabelId: action.payload.petLabelId,
	            articleMappingId: action.payload.articleMappingId
	          })
	        });
	      }
	    case types.DESELECT_PET_LABEL:
	      {
	        return _extends({}, state, {
	          selected: _extends({}, state.selected, {
	            petLabelId: -1,
	            articleMappingId: -1
	          })
	        });
	      }
	    case types.PET_LABEL_RECEIVED:
	      {
	        return _extends({}, state, {
	          active: _extends({}, state.active, {
	            petLabel: action.payload.petLabel
	          })
	        });
	      }
	    case types.CLEAR_ACTIVE_LABEL:
	      {
	        return _extends({}, state, {
	          active: _extends({}, state.active, {
	            petLabel: {}
	          })
	        });
	      }
	    case types.LABEL_DEFINITIONS_RECEIVED:
	      {
	        return _extends({}, state, {
	          definitions: action.payload.definitions,
	          definitionsValid: true,
	          styleElements: action.payload.definitions[0].StyleElements
	        });
	      }
	    case types.SELECT_LABEL_SIZE:
	      {
	        var labelList = createLabelList(state, action.payload.labelSize);
	        return _extends({}, state, {
	          activeSize: action.payload.labelSize,
	          list: labelList,
	          pdfId: action.payload.pdfId
	        });
	      }
	    case types.SAVE_LABEL_TO_SHEET:
	      {
	        var labels = JSON.parse(JSON.stringify(state.list));
	        labels[state.selected.gridIndex] = { imageUrl: action.payload.imageUrl, data: action.payload.label };
	        return _extends({}, state, {
	          list: labels
	        });
	      }
	    case types.CLEAR_LABEL_SHEET:
	      {
	        var _labelList = createLabelList(state, state.activeSize);
	        return _extends({}, state, {
	          list: _labelList
	        });
	      }
	    case types.TOGGLE_PLU_ACTIVE:
	      {
	        return _extends({}, state, {
	          activePLU: !state.activePLU
	        });
	      }
	    case types.DELETE_LABEL_FROM_SHEET:
	      {
	        var _labels = JSON.parse(JSON.stringify(state.list));
	        _labels[action.payload.gridIndex] = {};
	        return _extends({}, state, {
	          list: _labels
	        });
	      }
	    case types.EDIT_EXISTING_LABEL:
	      {
	        var label = state.list[action.payload.gridIndex].data;
	        return _extends({}, state, {
	          selected: _extends({}, state.selected, {
	            gridIndex: action.payload.gridIndex
	          }),
	          active: _extends({}, state.active, {
	            petLabel: label
	          })
	        });
	      }
	    case types.CUSTOM_DEFINITIONS_RECEIVED:
	      {
	        return _extends({}, state, {
	          customDefinitions: action.payload.definitions
	        });
	      }
	    case types.SELECT_CUSTOM_LABEL:
	      {
	        return _extends({}, state, {
	          selectedCustomType: action.payload.petType,
	          active: _extends({}, state.active, {
	            petLabel: state.customDefinitions[action.payload.petType]
	          })
	        });
	      }
	    case types.ARTICLE_LIST_RECEIVED:
	      {
	
	        // TODO: need to apply the filters here
	
	        var newShownArticles = action.payload.petLabels.slice(0);
	        var shownArticles = [];
	        if (state.articleSortColumn !== null) {
	          shownArticles = sortArticleList(state, newShownArticles, state.articleSortColumn, state.articleSortDirection);
	        } else {
	          shownArticles = sortArticleList(state, newShownArticles, 'Line1', 'ASC');
	        }
	
	        return _extends({}, state, {
	          articles: action.payload.petLabels,
	          articlesValid: true,
	          articleSortColumn: 'Line1',
	          articleSortDirection: 'ASC',
	          shownArticles: shownArticles
	        });
	      }
	    case types.UPDATE_LABEL_ARTICLE:
	      {
	        var _labelIndex = -1;
	        state.articles.find(function (petLabel, index) {
	          if (petLabel.Id === action.payload.label.Id && petLabel.ArticleMappingEntryID === action.payload.label.ArticleMappingEntryID) {
	            return _labelIndex = index;
	          }
	        });
	
	        var _newArticles = state.articles.slice(0);
	        _newArticles[_labelIndex] = action.payload.label;
	
	        var _newShownArticles = _newArticles.slice(0);
	
	        var filterArticles = filterArticleList(state, _newShownArticles, state.articleFilters);
	
	        var _shownArticles = [];
	        if (state.articleSortColumn !== null) {
	          _shownArticles = sortArticleList(state, filterArticles, state.articleSortColumn, state.articleSortDirection);
	        } else {
	          _shownArticles = _newShownArticles;
	        }
	
	        return _extends({}, state, {
	          articles: _newArticles,
	          shownArticles: _shownArticles
	        });
	      }
	    case types.SORT_ARTICLE_COLUMN:
	      {
	        var sortColumn = action.payload.sortColumn;
	        var sortDirection = action.payload.sortDirection;
	
	        var _filterArticles = filterArticleList(state, state.shownArticles, state.articleFilters);
	        var articleList = sortArticleList(state, _filterArticles, action.payload.sortColumn, action.payload.sortDirection);
	
	        return _extends({}, state, {
	          shownArticles: articleList,
	          articleSortColumn: sortColumn,
	          articleSortDirection: sortDirection
	        });
	      }
	    case types.CLEAR_ARTICLE_FILTERS:
	      {
	        var _articleList = state.articles.slice(0);
	        var _shownArticles2 = [];
	        if (state.articleSortColumn !== null) {
	          var _newShownArticles2 = _articleList.slice(0);
	          _shownArticles2 = sortArticleList(state, _newShownArticles2, state.articleSortColumn, state.articleSortDirection);
	        } else {
	          _shownArticles2 = _articleList.slice(0);
	        }
	
	        return _extends({}, state, {
	          shownArticles: _shownArticles2,
	          filters: []
	        });
	      }
	    case types.CALIBRATION_PDF_LINK:
	      {
	        return _extends({}, state, {
	          calibrationLink: action.payload.link
	        });
	      }
	    case types.ADD_ARTICLE_MAPPING:
	      {
	        var _articleList2 = state.articles.slice(0);
	        _articleList2.push(action.payload.article);
	
	        var _filterArticles2 = filterArticleList(state, _articleList2, state.articleFilters);
	
	        var _shownArticles3 = [];
	        if (state.articleSortColumn !== null) {
	          var _newShownArticles3 = _filterArticles2.slice(0);
	          _shownArticles3 = sortArticleList(state, _newShownArticles3, state.articleSortColumn, state.articleSortDirection);
	        } else {
	          _shownArticles3 = _articleList2.slice(0);
	        }
	
	        return _extends({}, state, {
	          articles: _articleList2,
	          shownArticles: _shownArticles3
	        });
	      }
	    case types.DELETE_ARTICLE_MAPPING:
	      {
	        var _articleList3 = state.articles.slice(0);
	        var _index = _articleList3.indexOf(action.payload.article);
	        if (_index > -1) {
	          _articleList3.splice(_index, 1);
	        }
	
	        if (action.payload.article.ArticleMappingEntryID === 0) {
	          var article = JSON.parse(JSON.stringify(action.payload.article));
	          article.CustomerName = '';
	          article.Price = '';
	          article.PLUCode = '';
	          _articleList3.push(article);
	        }
	
	        var _filterArticles3 = filterArticleList(state, _articleList3, state.articleFilters);
	
	        var _shownArticles4 = [];
	        if (state.articleSortColumn !== null) {
	          var _newShownArticles4 = _filterArticles3.slice(0);
	          _shownArticles4 = sortArticleList(state, _newShownArticles4, state.articleSortColumn, state.articleSortDirection);
	        } else {
	          _shownArticles4 = _articleList3.slice(0);
	        }
	
	        return _extends({}, state, {
	          articles: _articleList3,
	          shownArticles: _shownArticles4
	        });
	      }
	    case types.SHOW_LABEL_MODAL:
	      {
	        return _extends({}, state, {
	          labelModalOpen: true
	        });
	      }
	    case types.HIDE_LABEL_MODAL:
	      {
	        return _extends({}, state, {
	          labelModalOpen: false
	        });
	      }
	    case types.DISABLE_LABEL_ADD:
	      {
	        return _extends({}, state, {
	          labelAddEnabled: false
	        });
	      }
	    case types.ENABLE_LABEL_ADD:
	      {
	        return _extends({}, state, {
	          labelAddEnabled: true
	        });
	      }
	    case types.SELECT_NEXT_LABEL:
	      {
	        var nextIndex = 0;
	        state.list.find(function (label) {
	          if (Object.keys(label).length === 0) {
	            return label;
	          }
	          nextIndex++;
	        });
	
	        return _extends({}, state, {
	          selected: _extends({}, state.selected, {
	            gridIndex: nextIndex
	          })
	        });
	      }
	    case types.ADD_ARTICLE_FILTER:
	      {
	        var filters = JSON.parse(JSON.stringify(state.articleFilters));
	        filters[action.payload.column] = action.payload.value;
	
	        var filteredArticles = filterArticleList(state, state.articles.slice(0), filters);
	        var _shownArticles5 = sortArticleList(state, filteredArticles, state.articleSortColumn, state.articleSortDirection);
	
	        return _extends({}, state, {
	          articleFilters: filters,
	          shownArticles: _shownArticles5
	        });
	      }
	    default:
	      return state;
	  }
	}
	
	function createLabelList(state, labelSize) {
	  var selectedLabel = state.definitions.find(function (label) {
	    return label.LabelName === labelSize;
	  });
	  var labelList = new Array(selectedLabel.LabelPositions.length);
	  labelList.fill({}, 0, selectedLabel.LabelPositions.length);
	  return labelList;
	}
	
	function sortArticleList(state, articles, sortColumn, sortDirection) {
	  var articleList = articles.slice(0);
	  var list = [];
	  if (sortDirection !== 'NONE') {
	    list = articleList.sort(function (a, b) {
	      if (sortDirection === 'ASC') {
	        return a[sortColumn] > b[sortColumn] ? 1 : -1;
	      } else if (sortDirection === 'DESC') {
	        return a[sortColumn] < b[sortColumn] ? 1 : -1;
	      }
	    });
	  } else {
	    list = articles.slice(0);
	  }
	  return list;
	}
	
	function filterArticleList(state, articles, filters) {
	  var articleList = articles.slice(0);
	
	  if (filters['Id'] !== undefined) {
	    articleList = articleList.filter(function (article) {
	      return article.Id.toString().includes(filters['Id']);
	    });
	  }
	
	  if (filters['Line1'] !== undefined) {
	    articleList = articleList.filter(function (article) {
	      return article.Line1.toLowerCase().includes(filters['Line1'].toLowerCase());
	    });
	  }
	
	  if (filters['Line2'] !== undefined) {
	    articleList = articleList.filter(function (article) {
	      return article.Line2.toLowerCase().includes(filters['Line2'].toLowerCase());
	    });
	  }
	
	  if (filters['PetType'] !== undefined) {
	    articleList = articleList.filter(function (article) {
	      return article.PetType.toLowerCase().includes(filters['PetType'].toLowerCase());
	    });
	  }
	
	  if (filters['CustomerName'] !== undefined) {
	    articleList = articleList.filter(function (article) {
	      return article.CustomerName.toLowerCase().includes(filters['CustomerName'].toLowerCase());
	    });
	  }
	
	  if (filters['Price'] !== undefined) {
	    articleList = articleList.filter(function (article) {
	      return article.Price.toLowerCase().includes(filters['Price'].toLowerCase());
	    });
	  }
	
	  if (filters['Barcode'] !== undefined) {
	    articleList = articleList.filter(function (article) {
	      return article.Barcode.toLowerCase().includes(filters['Barcode'].toLowerCase());
	    });
	  }
	
	  if (filters['PLUCode'] !== undefined) {
	    articleList = articleList.filter(function (article) {
	      return article.PLUCode.toLowerCase().includes(filters['PLUCode'].toLowerCase());
	    });
	  }
	
	  return articleList;
	}

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactstrap = __webpack_require__(56);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _selectors = __webpack_require__(173);
	
	var _actions = __webpack_require__(127);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var savePasswordChange = _customer2.default.actions.savePasswordChange;
	
	var _ref = _react2.default.createElement('span', { className: 'lnr lnr-cross', 'aria-hidden': 'true' });
	
	var ChangePasswordModal = function (_React$Component) {
	  _inherits(ChangePasswordModal, _React$Component);
	
	  function ChangePasswordModal(props) {
	    _classCallCheck(this, ChangePasswordModal);
	
	    var _this = _possibleConstructorReturn(this, (ChangePasswordModal.__proto__ || Object.getPrototypeOf(ChangePasswordModal)).call(this, props));
	
	    _this.handlePasswordClose = function () {
	      _this.setState({ oldPassword: '' });
	      _this.setState({ newPassword: '' });
	      _this.setState({ confirmPassword: '' });
	      _this.setState({ passwordError: '' });
	      _this.props.actions.hideChangePasswordModal();
	    };
	
	    _this.handleOldPasswordChange = function (password) {
	      _this.setState({ oldPassword: password });
	    };
	
	    _this.handlePasswordChange = function (password) {
	      _this.setState({ newPassword: password });
	      if (password.length < 8) {
	        var errorMsg = _reactReduxI18n.I18n.t('PASSWORD_CHARACTERS');
	        _this.setState({ passwordError: errorMsg });
	      } else if (password !== _this.state.confirmPassword) {
	        var _errorMsg = _reactReduxI18n.I18n.t('PASSWORDS_DO_NOT_MATCH');
	        _this.setState({ passwordError: _errorMsg });
	      } else {
	        _this.setState({ passwordError: '' });
	      }
	    };
	
	    _this.handleConfirmPasswordChange = function (password) {
	      _this.setState({ confirmPassword: password });
	      if (_this.state.newPassword.length < 8) {
	        var errorMsg = _reactReduxI18n.I18n.t('PASSWORD_CHARACTERS');
	        _this.setState({ passwordError: errorMsg });
	      } else if (password !== _this.state.newPassword) {
	        var _errorMsg2 = _reactReduxI18n.I18n.t('PASSWORDS_DO_NOT_MATCH');
	        _this.setState({ passwordError: _errorMsg2 });
	      } else {
	        _this.setState({ passwordError: '' });
	      }
	    };
	
	    _this.handlePasswordAccept = function () {
	      if (_this.state.newPassword.length < 8) {
	        var errorMsg = _reactReduxI18n.I18n.t('PASSWORD_CHARACTERS');
	        _this.setState({ passwordError: errorMsg });
	      } else if (_this.state.newPassword !== _this.state.confirmPassword) {
	        var _errorMsg3 = _reactReduxI18n.I18n.t('PASSWORDS_DO_NOT_MATCH');
	        _this.setState({ passwordError: _errorMsg3 });
	      } else {
	        return new Promise(function (resolve) {
	          _this.props.actions.savePasswordChange(_this.state.oldPassword, _this.state.newPassword).then(function () {
	            resolve();
	            _this.props.actions.hideChangePasswordModal();
	          }).catch(function () {
	            _this.setState({ oldPassword: '' });
	            _this.setState({ newPassword: '' });
	            _this.setState({ confirmPassword: '' });
	            _this.setState({ passwordError: 'Invalid password. Please try again.' });
	          });
	        });
	      }
	    };
	
	    _this.state = {
	      oldPassword: '',
	      newPassword: '',
	      confirmPassword: '',
	      passwordError: ''
	    };
	    return _this;
	  }
	
	  _createClass(ChangePasswordModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var isOpen = this.props.isOpen;
	
	
	      var confirmRowStyle = 'row';
	      var confirmInputStyle = 'form-control';
	      if (this.state.passwordError !== '') {
	        confirmRowStyle += ' has-danger';
	        confirmInputStyle += ' form-control-danger';
	      }
	
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        { isOpen: isOpen, toggle: this.handlePasswordClose, id: 'modalSelectStore' },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-header' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'modal-title', id: 'exampleModalLabel' },
	            _reactReduxI18n.I18n.t('CHANGE_PASSWORD')
	          ),
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'close', onClick: this.handlePasswordClose },
	            _ref
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _react2.default.createElement('input', { className: 'form-control',
	                type: 'password',
	                value: this.state.oldPassword,
	                placeholder: _reactReduxI18n.I18n.t('CURRENT_PASSWORD'),
	                onChange: function onChange(e) {
	                  _this2.handleOldPasswordChange(e.target.value);
	                },
	                autoComplete: 'off' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _react2.default.createElement('input', { className: 'form-control',
	                type: 'password',
	                value: this.state.newPassword,
	                placeholder: _reactReduxI18n.I18n.t('NEW_PASSWORD'),
	                onChange: function onChange(e) {
	                  _this2.handlePasswordChange(e.target.value);
	                },
	                autoComplete: 'off' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: confirmRowStyle },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _react2.default.createElement('input', { className: confirmInputStyle,
	                type: 'password',
	                value: this.state.confirmPassword,
	                placeholder: _reactReduxI18n.I18n.t('CONFIRM_PASSWORD'),
	                onChange: function onChange(e) {
	                  _this2.handleConfirmPasswordChange(e.target.value);
	                },
	                autoComplete: 'off' }),
	              this.state.passwordError !== '' && _react2.default.createElement(
	                'div',
	                { className: 'form-control-feedback' },
	                this.state.passwordError
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-footer' },
	            _react2.default.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-secondary', 'data-dismiss': 'modal', onClick: this.handlePasswordClose },
	              _reactReduxI18n.I18n.t('CANCEL')
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-primary', onClick: this.handlePasswordAccept },
	              _reactReduxI18n.I18n.t('CHANGE_PASSWORD')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChangePasswordModal;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    isOpen: (0, _selectors.isChangePasswordOpen)(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ hideChangePasswordModal: _actions.hideChangePasswordModal, savePasswordChange: savePasswordChange }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChangePasswordModal);

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(56);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement('span', { className: 'lnr lnr-cross', 'aria-hidden': 'true' });
	
	var ErrorModal = function ErrorModal(_ref) {
	  var isOpen = _ref.isOpen,
	      onClose = _ref.onClose;
	
	  return _react2.default.createElement(
	    _reactstrap.Modal,
	    { isOpen: isOpen, toggle: onClose, id: 'modalSelectStore' },
	    _react2.default.createElement(
	      'div',
	      { className: 'modal-header' },
	      _react2.default.createElement(
	        'h4',
	        { className: 'modal-title', id: 'exampleModalLabel' },
	        _reactReduxI18n.I18n.t('APPLICATION_ERROR')
	      ),
	      _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close', onClick: onClose },
	        _ref2
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'modal-body' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _reactReduxI18n.I18n.t('ERROR_MESSAGE')
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'modal-footer' },
	      _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'btn btn-primary', onClick: onClose },
	        _reactReduxI18n.I18n.t('CLOSE')
	      )
	    )
	  );
	};
	
	exports.default = ErrorModal;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(8);
	
	var _redux = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(28);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _actions = __webpack_require__(127);
	
	var navBarActions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__(173);
	
	var _NavIconBar = __webpack_require__(275);
	
	var _NavIconBar2 = _interopRequireDefault(_NavIconBar);
	
	var _NavLinkBar = __webpack_require__(276);
	
	var _NavLinkBar2 = _interopRequireDefault(_NavLinkBar);
	
	var _SelectStoreModal = __webpack_require__(277);
	
	var _SelectStoreModal2 = _interopRequireDefault(_SelectStoreModal);
	
	var _ChangePasswordModal = __webpack_require__(614);
	
	var _ChangePasswordModal2 = _interopRequireDefault(_ChangePasswordModal);
	
	var _ErrorModal = __webpack_require__(615);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _customer$selectors = _customer2.default.selectors,
	    getActivePermissions = _customer$selectors.getActivePermissions,
	    hasMultipleSubscriptions = _customer$selectors.hasMultipleSubscriptions,
	    isMasterUser = _customer$selectors.isMasterUser,
	    isDemoUser = _customer$selectors.isDemoUser;
	
	
	function isDesktopClient() {
	  var bootStrapXlSize = 1330;
	  return Math.max(document.documentElement["clientWidth"], document.body["scrollWidth"], document.documentElement["scrollWidth"], document.body["offsetWidth"], document.documentElement["offsetWidth"]) >= bootStrapXlSize;
	}
	
	var _ref2 = _react2.default.createElement(
	  'h1',
	  { className: 'logo text-hide' },
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/' },
	    'Petdata'
	  )
	);
	
	var _ref3 = _react2.default.createElement(_SelectStoreModal2.default, null);
	
	var _ref4 = _react2.default.createElement(_ChangePasswordModal2.default, null);
	
	var NavBar = function (_React$Component) {
	  _inherits(NavBar, _React$Component);
	
	  function NavBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NavBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavBar.__proto__ || Object.getPrototypeOf(NavBar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNavBarToggle = function () {
	      if (!isDesktopClient() && !_this.props.navTransitioning) {
	        _this.props.actions.toggleNavBar();
	      }
	    }, _this.handleNavBarClose = function () {
	      if (!isDesktopClient() && !_this.props.navCollapsed && !_this.props.navTransitioning) {
	        _this.props.actions.closeNavBar();
	      }
	    }, _this.handleTransitionComplete = function () {
	      if (!isDesktopClient()) {
	        _this.props.actions.transitionComplete();
	      }
	    }, _this.handleErrorModalClose = function () {
	      _this.props.actions.hideErrorModal();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(NavBar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isMasterUser = _props.isMasterUser,
	          isErrorOpen = _props.isErrorOpen,
	          navCollapsed = _props.navCollapsed,
	          navLocation = _props.navLocation,
	          multipleSubscriptions = _props.multipleSubscriptions,
	          userPermissions = _props.userPermissions,
	          isDemoUser = _props.isDemoUser;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'nav-side-menu' },
	          _ref2,
	          _react2.default.createElement(_NavIconBar2.default, { navLocation: navLocation,
	            onClick: this.handleNavBarClose,
	            userPermissions: userPermissions
	          }),
	          _react2.default.createElement(_NavLinkBar2.default, { navLocation: navLocation,
	            navCollapsed: navCollapsed,
	            onClick: this.handleNavBarToggle,
	            onTransitionComplete: this.handleTransitionComplete,
	            userPermissions: userPermissions,
	            isMasterUser: isMasterUser,
	            isDemoUser: isDemoUser
	          })
	        ),
	        multipleSubscriptions && _ref3,
	        _ref4,
	        _react2.default.createElement(_ErrorModal2.default, { isOpen: isErrorOpen, onClose: this.handleErrorModalClose })
	      );
	    }
	  }]);
	
	  return NavBar;
	}(_react2.default.Component);
	
	function mapStateToProps(state, ownProps) {
	  return {
	    isMasterUser: isMasterUser(state),
	    isDemoUser: isDemoUser(state),
	    isErrorOpen: (0, _selectors.isErrorOpen)(state),
	    multipleSubscriptions: hasMultipleSubscriptions(state),
	    navLocation: '/' + ownProps.location.split('/')[1],
	    navCollapsed: (0, _selectors.isNavbarCollapsed)(state),
	    navTransitioning: (0, _selectors.isNavbarTransitioning)(state),
	    userPermissions: getActivePermissions(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(_extends({}, navBarActions), dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NavBar);

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(8);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _customer$selectors = _customer2.default.selectors,
	    hasMultipleSubscriptions = _customer$selectors.hasMultipleSubscriptions,
	    getFullName = _customer$selectors.getFullName,
	    getActiveSubscriptionName = _customer$selectors.getActiveSubscriptionName;
	
	
	var NavUserInfo = function NavUserInfo(_ref) {
	  var useCollapsedStyle = _ref.useCollapsedStyle,
	      fullName = _ref.fullName,
	      multiSubscriptions = _ref.multiSubscriptions,
	      onClick = _ref.onClick,
	      subscriptionName = _ref.subscriptionName;
	
	  var navMenuClass = 'toggle-btn align-middle ' + (useCollapsedStyle ? 'collapsed' : '');
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { id: 'navMenu', className: navMenuClass, onClick: onClick },
	      _react2.default.createElement(
	        'div',
	        { className: 'name text-right' },
	        _react2.default.createElement(
	          'div',
	          { className: 'name-wrap' },
	          fullName
	        )
	      ),
	      multiSubscriptions && _react2.default.createElement(
	        'div',
	        { className: 'store' },
	        subscriptionName
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'user' },
	      fullName
	    ),
	    multiSubscriptions && _react2.default.createElement(
	      'div',
	      { className: 'store-sidenav' },
	      subscriptionName
	    )
	  );
	};
	
	function mapStateToProps(state) {
	  return {
	    fullName: getFullName(state),
	    multiSubscriptions: hasMultipleSubscriptions(state),
	    subscriptionName: getActiveSubscriptionName(state)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(NavUserInfo);

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectStoreButton = function SelectStoreButton(_ref) {
		var active = _ref.active,
		    _onClick = _ref.onClick,
		    subscription = _ref.subscription;
		return _react2.default.createElement(
			'button',
			{ key: subscription.id,
				type: 'button',
				className: 'btn btn-link btn-radio ' + (active ? 'active' : ''),
				onClick: function onClick() {
					_onClick(subscription.id);
				} },
			subscription.name
		);
	};
	
	exports.default = SelectStoreButton;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectStoreModal = exports.NavLinkBar = exports.NavIconBar = exports.NavBar = undefined;
	
	var _NavBar = __webpack_require__(616);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _NavIconBar = __webpack_require__(275);
	
	var _NavIconBar2 = _interopRequireDefault(_NavIconBar);
	
	var _NavLinkBar = __webpack_require__(276);
	
	var _NavLinkBar2 = _interopRequireDefault(_NavLinkBar);
	
	var _SelectStoreModal = __webpack_require__(277);
	
	var _SelectStoreModal2 = _interopRequireDefault(_SelectStoreModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.NavBar = _NavBar2.default;
	exports.NavIconBar = _NavIconBar2.default;
	exports.NavLinkBar = _NavLinkBar2.default;
	exports.SelectStoreModal = _SelectStoreModal2.default;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	
	var _actionTypes = __webpack_require__(274);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = {
		collapsed: true,
		transitioning: false,
		selectStoreOpen: false,
		changePasswordOpen: false,
		errorOpen: false
	};
	
	function reducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		switch (action.type) {
			case types.NAV_BAR_TOGGLE:
				{
					return _extends({}, state, {
						collapsed: !state.collapsed,
						transitioning: true
					});
				}
			case types.NAV_BAR_CLOSE:
				{
					return _extends({}, state, {
						collapsed: true,
						transitioning: true
					});
				}
			case types.NAV_BAR_TRANSITIONED:
				{
					return _extends({}, state, {
						transitioning: false
					});
				}
			case types.SHOW_SELECT_STORE_MODAL:
				{
					return _extends({}, state, {
						selectStoreOpen: true
					});
				}
			case types.HIDE_SELECT_STORE_MODAL:
				{
					return _extends({}, state, {
						selectStoreOpen: false
					});
				}
			case types.SHOW_CHANGE_PASSWORD_MODAL:
				{
					return _extends({}, state, {
						changePasswordOpen: true
					});
				}
			case types.HIDE_CHANGE_PASSWORD_MODAL:
				{
					return _extends({}, state, {
						changePasswordOpen: false
					});
				}
			case types.SHOW_ERROR_MODAL:
				{
					return _extends({}, state, {
						errorOpen: true
					});
				}
			case types.HIDE_ERROR_MODAL:
				{
					return _extends({}, state, {
						errorOpen: false
					});
				}
			default:
				return state;
		}
	}

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.initializeSearch = initializeSearch;
	exports.toggleFilterDisplay = toggleFilterDisplay;
	exports.searchInputBlur = searchInputBlur;
	exports.searchInputFocus = searchInputFocus;
	exports.searchInputDirty = searchInputDirty;
	
	var _actionTypes = __webpack_require__(280);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function initializeSearch() {
		return {
			type: types.INITIALIZE_SEARCH
		};
	}
	
	function toggleFilterDisplay() {
		return {
			type: types.TOGGLE_FILTER_DISPLAY
		};
	}
	
	function searchInputBlur() {
		return {
			type: types.SEARCH_INPUT_BLUR
		};
	}
	
	function searchInputFocus() {
		return {
			type: types.SEARCH_INPUT_FOCUS
		};
	}
	
	function searchInputDirty() {
		return {
			type: types.SEARCH_INPUT_DIRTY
		};
	}

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _FormInput = __webpack_require__(49);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement(
	  'span',
	  { className: 'input-group-btn' },
	  _react2.default.createElement(
	    'button',
	    { className: 'btn btn-secondary btn-search', type: 'submit' },
	    _react2.default.createElement('i', { className: 'fa fa-search lg' })
	  )
	);
	
	var SearchForm = function SearchForm(_ref) {
	  var handleSubmit = _ref.handleSubmit,
	      hasFocus = _ref.hasFocus,
	      onBlur = _ref.onBlur,
	      onFocus = _ref.onFocus;
	
	  var searchClass = 'search-box';
	  if (hasFocus) {
	    searchClass += ' focus';
	  }
	
	  return _react2.default.createElement(
	    'form',
	    { className: searchClass, onSubmit: handleSubmit },
	    _react2.default.createElement(_reduxForm.Field, { name: 'searchPhrase',
	      id: 'searchPhrase',
	      component: _FormInput2.default,
	      type: 'text',
	      className: 'form-control',
	      onBlur: onBlur,
	      onFocus: onFocus,
	      placeholder: _reactReduxI18n.I18n.t('PET_SEARCH_PLACEHOLDER')
	    }),
	    _ref2
	  );
	};
	
	exports.default = (0, _reduxForm.reduxForm)()(SearchForm);

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isFilterOn(itemList, selectedItems) {
	  if (selectedItems.length === 0 || selectedItems.length === itemList.length) {
	    return false;
	  } else {
	    return true;
	  }
	}
	
	var SearchMultiSelect = function SearchMultiSelect(_ref) {
	  var isOpen = _ref.isOpen,
	      onSelected = _ref.onSelected,
	      onToggle = _ref.onToggle,
	      itemList = _ref.itemList,
	      selectedItems = _ref.selectedItems;
	
	  var petTypes = itemList.map(function (petType) {
	    var checkedClass = '';
	    if (selectedItems.includes(petType)) {
	      checkedClass = 'multi-checked';
	    }
	
	    return _react2.default.createElement(
	      _reactstrap.DropdownItem,
	      { key: petType,
	        className: checkedClass,
	        toggle: false,
	        onClick: function onClick(e) {
	          e.target.blur();onSelected(petType);
	        } },
	      petType
	    );
	  });
	
	  var filterClass = isFilterOn(itemList, selectedItems) ? 'filter-on' : '';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'input-group-btn search-panel' },
	    _react2.default.createElement(
	      _reactstrap.ButtonDropdown,
	      { isOpen: isOpen, toggle: onToggle, className: 'btn-group input-group-btn search-panel' },
	      _react2.default.createElement(_reactstrap.DropdownToggle, { className: filterClass }),
	      _react2.default.createElement(
	        _reactstrap.DropdownMenu,
	        null,
	        petTypes
	      )
	    )
	  );
	};
	
	exports.default = SearchMultiSelect;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _lodash = __webpack_require__(956);
	
	var _actions = __webpack_require__(621);
	
	var _selectors = __webpack_require__(627);
	
	var _SearchMultiSelect = __webpack_require__(623);
	
	var _SearchMultiSelect2 = _interopRequireDefault(_SearchMultiSelect);
	
	var _SearchForm = __webpack_require__(622);
	
	var _SearchForm2 = _interopRequireDefault(_SearchForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formName = "searchForm";
	
	var SearchPanel = function (_React$Component) {
	  _inherits(SearchPanel, _React$Component);
	
	  function SearchPanel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SearchPanel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchPanel.__proto__ || Object.getPrototypeOf(SearchPanel)).call.apply(_ref, [this].concat(args))), _this), _this.handleInputChange = function (values) {
	      if (_this.props.isPristine && values.searchPhrase !== undefined) {
	        _this.props.actions.searchInputDirty();
	      }
	
	      if (!_this.props.isPristine) {
	        _this.props.onSubmit(values);
	      }
	
	      return {};
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SearchPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.actions.initializeSearch();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          actions = _props.actions,
	          filterOpen = _props.filterOpen,
	          inputFocus = _props.inputFocus,
	          itemList = _props.itemList,
	          onSelectedItem = _props.onSelectedItem,
	          onSubmit = _props.onSubmit,
	          selectedItems = _props.selectedItems;
	
	      var asyncInput = (0, _lodash.debounce)(function (values) {
	        _this2.handleInputChange(values);
	      }, 250);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'input-group search' },
	        _react2.default.createElement(_SearchMultiSelect2.default, { isOpen: filterOpen,
	          itemList: itemList.sort(),
	          onSelected: onSelectedItem,
	          onToggle: actions.toggleFilterDisplay,
	          selectedItems: selectedItems }),
	        _react2.default.createElement(_SearchForm2.default, { form: formName,
	          hasFocus: inputFocus,
	          onBlur: actions.searchInputBlur,
	          onFocus: actions.searchInputFocus,
	          onSubmit: onSubmit,
	          validate: asyncInput })
	      );
	    }
	  }]);
	
	  return SearchPanel;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    filterOpen: (0, _selectors.isFilterOpen)(state),
	    inputFocus: (0, _selectors.isInputFocused)(state),
	    isPristine: (0, _selectors.isPristine)(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ initializeSearch: _actions.initializeSearch, searchInputBlur: _actions.searchInputBlur, searchInputDirty: _actions.searchInputDirty, searchInputFocus: _actions.searchInputFocus, toggleFilterDisplay: _actions.toggleFilterDisplay }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchPanel);

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchPanel = undefined;
	
	var _SearchPanel = __webpack_require__(624);
	
	var _SearchPanel2 = _interopRequireDefault(_SearchPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SearchPanel = _SearchPanel2.default;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	
	var _actionTypes = __webpack_require__(280);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = {
		filterOpen: false,
		inputFocus: false,
		pristine: true
	};
	
	function reducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		switch (action.type) {
			case types.INITIALIZE_SEARCH:
				{
					return _extends({}, state, {
						filterOpen: false,
						inputFocus: false,
						pristine: true
					});
				}
			case types.TOGGLE_FILTER_DISPLAY:
				{
					return _extends({}, state, {
						filterOpen: !state.filterOpen
					});
				}
			case types.SEARCH_INPUT_BLUR:
				{
					return _extends({}, state, {
						inputFocus: false
					});
				}
			case types.SEARCH_INPUT_FOCUS:
				{
					return _extends({}, state, {
						inputFocus: true
					});
				}
			case types.SEARCH_INPUT_DIRTY:
				{
					return _extends({}, state, {
						pristine: false
					});
				}
			default:
				return state;
		}
	}

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isPristine = exports.isInputFocused = exports.isFilterOpen = undefined;
	
	var _constants = __webpack_require__(281);
	
	var isFilterOpen = exports.isFilterOpen = function isFilterOpen(state) {
	  return state[_constants.NAME].filterOpen;
	};
	var isInputFocused = exports.isInputFocused = function isInputFocused(state) {
	  return state[_constants.NAME].inputFocus;
	};
	var isPristine = exports.isPristine = function isPristine(state) {
	  return state[_constants.NAME].pristine;
	};

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(56);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement('span', { className: 'lnr lnr-cross', 'aria-hidden': 'true' });
	
	var ChangePasswordModal = function ChangePasswordModal(_ref) {
	  var isOpen = _ref.isOpen,
	      onAccept = _ref.onAccept,
	      onClose = _ref.onClose,
	      newPassword = _ref.newPassword,
	      confirmPassword = _ref.confirmPassword,
	      passwordError = _ref.passwordError,
	      onPasswordChange = _ref.onPasswordChange,
	      onConfirmPasswordChange = _ref.onConfirmPasswordChange;
	
	  var confirmRowStyle = 'row';
	  var confirmInputStyle = 'form-control';
	  if (passwordError !== '') {
	    confirmRowStyle += ' has-danger';
	    confirmInputStyle += ' form-control-danger';
	  }
	
	  return _react2.default.createElement(
	    _reactstrap.Modal,
	    { isOpen: isOpen, toggle: onClose, id: 'modalSelectStore' },
	    _react2.default.createElement(
	      'div',
	      { className: 'modal-header' },
	      _react2.default.createElement(
	        'h4',
	        { className: 'modal-title', id: 'exampleModalLabel' },
	        _reactReduxI18n.I18n.t('CHANGE_PASSWORD')
	      ),
	      _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close', onClick: onClose },
	        _ref2
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'modal-body' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement('input', { className: 'form-control',
	            type: 'password',
	            value: newPassword,
	            placeholder: _reactReduxI18n.I18n.t('NEW_PASSWORD'),
	            onChange: function onChange(e) {
	              onPasswordChange(e.target.value);
	            },
	            autoComplete: 'off' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: confirmRowStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement('input', { className: confirmInputStyle,
	            type: 'password',
	            value: confirmPassword,
	            placeholder: _reactReduxI18n.I18n.t('CONFIRM_PASSWORD'),
	            onChange: function onChange(e) {
	              onConfirmPasswordChange(e.target.value);
	            },
	            autoComplete: 'off' }),
	          passwordError !== '' && _react2.default.createElement(
	            'div',
	            { className: 'form-control-feedback' },
	            passwordError
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'modal-footer' },
	      _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'btn btn-secondary', 'data-dismiss': 'modal', onClick: onClose },
	        _reactReduxI18n.I18n.t('CANCEL')
	      ),
	      _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'btn btn-primary', onClick: onAccept },
	        _reactReduxI18n.I18n.t('CHANGE_PASSWORD')
	      )
	    )
	  );
	};
	
	exports.default = ChangePasswordModal;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _UserFormInput = __webpack_require__(283);
	
	var _UserFormInput2 = _interopRequireDefault(_UserFormInput);
	
	var _UserPermissionTable = __webpack_require__(284);
	
	var _UserPermissionTable2 = _interopRequireDefault(_UserPermissionTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreateUserForm = function CreateUserForm(_ref) {
	  var handleSubmit = _ref.handleSubmit,
	      onCancel = _ref.onCancel,
	      onTogglePermission = _ref.onTogglePermission,
	      permissionTable = _ref.permissionTable,
	      submitting = _ref.submitting,
	      supportsCareSheet = _ref.supportsCareSheet;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'container-fluid main', id: 'main' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-12' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _reactReduxI18n.I18n.t('CREATE_USER')
	        ),
	        _react2.default.createElement(
	          'form',
	          { className: 'user-form', onSubmit: handleSubmit },
	          _react2.default.createElement(
	            'div',
	            { className: 'row no-gutters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _react2.default.createElement(
	                'h5',
	                null,
	                _reactReduxI18n.I18n.t('USER_INFO')
	              )
	            )
	          ),
	          _react2.default.createElement(_reduxForm.Field, { name: 'firstName',
	            component: _UserFormInput2.default,
	            type: 'text',
	            label: _reactReduxI18n.I18n.t('FIRST_NAME')
	          }),
	          _react2.default.createElement(_reduxForm.Field, { name: 'lastName',
	            component: _UserFormInput2.default,
	            type: 'text',
	            label: _reactReduxI18n.I18n.t('LAST_NAME')
	          }),
	          _react2.default.createElement(_reduxForm.Field, { name: 'email',
	            component: _UserFormInput2.default,
	            type: 'text',
	            label: _reactReduxI18n.I18n.t('EMAIL_ADDRESS')
	          }),
	          _react2.default.createElement(_reduxForm.Field, { name: 'password',
	            component: _UserFormInput2.default,
	            type: 'password',
	            label: _reactReduxI18n.I18n.t('PASSWORD')
	          }),
	          _react2.default.createElement(_reduxForm.Field, { name: 'confirmPassword',
	            component: _UserFormInput2.default,
	            type: 'password',
	            label: _reactReduxI18n.I18n.t('CONFIRM_PASSWORD')
	          }),
	          _react2.default.createElement(_UserPermissionTable2.default, { permissionTable: permissionTable, onTogglePermission: onTogglePermission, supportsCareSheet: supportsCareSheet }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row no-gutters bottom-buttons' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 text-right' },
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-secondary', disabled: submitting, onClick: onCancel },
	                _reactReduxI18n.I18n.t('CANCEL')
	              ),
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', className: 'btn btn-primary', disabled: submitting },
	                _reactReduxI18n.I18n.t('CREATE_USER')
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _reduxForm.reduxForm)()(CreateUserForm);

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _actions = __webpack_require__(128);
	
	var _selectors = __webpack_require__(129);
	
	var _CreateUserForm = __webpack_require__(629);
	
	var _CreateUserForm2 = _interopRequireDefault(_CreateUserForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _customer$selectors = _customer2.default.selectors,
	    isMasterUser = _customer$selectors.isMasterUser,
	    isCareSheetsSupported = _customer$selectors.isCareSheetsSupported;
	
	
	var formName = 'createUserForm';
	
	var CreateUserPage = function (_React$Component) {
	  _inherits(CreateUserPage, _React$Component);
	
	  function CreateUserPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CreateUserPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreateUserPage.__proto__ || Object.getPrototypeOf(CreateUserPage)).call.apply(_ref, [this].concat(args))), _this), _this.handleFormSubmit = function (values, dispatch) {
	      return new Promise(function (resolve, reject) {
	        dispatch((0, _actions.registerUser)(values, _this.props.permissionTable)).then(function () {
	          resolve();
	        }).catch(function () {
	          reject();
	        });
	      });
	    }, _this.handleFormCancel = function () {
	      _this.props.actions.push('/users');
	    }, _this.handleFormValidation = function (values) {
	      var errors = {};
	
	      if (!values.firstName) {
	        errors.firstName = _reactReduxI18n.I18n.t('PLEASE_ENTER_FIRST_NAME');
	      }
	
	      if (!values.lastName) {
	        errors.lastName = _reactReduxI18n.I18n.t('PLEASE_ENTER_LAST_NAME');
	      }
	
	      if (!values.email) {
	        errors.email = _reactReduxI18n.I18n.t('PLEASE_ENTER_VALID_EMAIL');
	      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
	        errors.email = _reactReduxI18n.I18n.t('PLEASE_ENTER_VALID_EMAIL');
	      }
	
	      if (values.password === undefined || values.password.length < 8 || values.password.length > 100) {
	        errors.password = _reactReduxI18n.I18n.t('PASSWORD_CHARACTERS');
	      }
	      if (values.confirmPassword === undefined || values.password !== values.confirmPassword) {
	        errors.confirmPassword = _reactReduxI18n.I18n.t('PASSWORDS_DO_NOT_MATCH');
	      }
	
	      return errors;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CreateUserPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.isMasterUser) {
	        this.props.actions.push('/labels');
	      }
	
	      this.props.actions.initializePermissionTable();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actions = _props.actions,
	          permissionTable = _props.permissionTable,
	          supportsCareSheets = _props.supportsCareSheets;
	
	      return _react2.default.createElement(_CreateUserForm2.default, { form: formName,
	        onCancel: this.handleFormCancel,
	        onSubmit: this.handleFormSubmit,
	        onTogglePermission: actions.toggleUserPermission,
	        permissionTable: permissionTable,
	        validate: this.handleFormValidation,
	        supportsCareSheet: supportsCareSheets
	      });
	    }
	  }]);
	
	  return CreateUserPage;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    isMasterUser: isMasterUser(state),
	    permissionTable: (0, _selectors.getSelectedPermissions)(state),
	    supportsCareSheets: isCareSheetsSupported(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ initializePermissionTable: _actions.initializePermissionTable, registerUser: _actions.registerUser, toggleUserPermission: _actions.toggleUserPermission, push: _reactRouterRedux.push }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CreateUserPage);

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _FormInput = __webpack_require__(49);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _UserFormInput = __webpack_require__(283);
	
	var _UserFormInput2 = _interopRequireDefault(_UserFormInput);
	
	var _UserPermissionTable = __webpack_require__(284);
	
	var _UserPermissionTable2 = _interopRequireDefault(_UserPermissionTable);
	
	var _ChangePasswordModal = __webpack_require__(628);
	
	var _ChangePasswordModal2 = _interopRequireDefault(_ChangePasswordModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement(
	  'label',
	  { className: 'switch' },
	  _react2.default.createElement(_reduxForm.Field, { name: 'status',
	    component: _FormInput2.default,
	    type: 'checkbox'
	  }),
	  _react2.default.createElement('div', { className: 'slider' })
	);
	
	var EditUserForm = function EditUserForm(_ref) {
	  var handleSubmit = _ref.handleSubmit,
	      onCancel = _ref.onCancel,
	      onTogglePermission = _ref.onTogglePermission,
	      permissionTable = _ref.permissionTable,
	      status = _ref.status,
	      submitting = _ref.submitting,
	      username = _ref.username,
	      modalOpen = _ref.modalOpen,
	      onPasswordAccept = _ref.onPasswordAccept,
	      onCloseModal = _ref.onCloseModal,
	      onOpenModal = _ref.onOpenModal,
	      newPassword = _ref.newPassword,
	      confirmPassword = _ref.confirmPassword,
	      passwordError = _ref.passwordError,
	      onPasswordChange = _ref.onPasswordChange,
	      onConfirmPasswordChange = _ref.onConfirmPasswordChange,
	      supportsCareSheet = _ref.supportsCareSheet;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'container-fluid main', id: 'main' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-12' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _reactReduxI18n.I18n.t('EDIT_USER')
	        ),
	        _react2.default.createElement(
	          'form',
	          { className: 'user-form', onSubmit: handleSubmit },
	          _react2.default.createElement(
	            'div',
	            { className: 'row no-gutters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _react2.default.createElement(
	                'h5',
	                null,
	                _reactReduxI18n.I18n.t('USER_INFO')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-lg-2 col-sm-3 col-form-label' },
	              _reactReduxI18n.I18n.t('EMAIL_ADDRESS')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-10 col-sm-9' },
	              _react2.default.createElement(
	                'span',
	                { className: 'email' },
	                username
	              )
	            )
	          ),
	          _react2.default.createElement(_reduxForm.Field, { name: 'firstName',
	            component: _UserFormInput2.default,
	            type: 'text',
	            label: _reactReduxI18n.I18n.t('FIRST_NAME')
	          }),
	          _react2.default.createElement(_reduxForm.Field, { name: 'lastName',
	            component: _UserFormInput2.default,
	            type: 'text',
	            label: _reactReduxI18n.I18n.t('LAST_NAME')
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'change-password', className: 'col-lg-2 col-sm-3 col-form-label' },
	              _reactReduxI18n.I18n.t('PASSWORD')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-10 col-sm-9' },
	              _react2.default.createElement(
	                'button',
	                { type: 'button',
	                  name: 'change-password',
	                  className: 'change-password btn btn-link',
	                  onClick: onOpenModal },
	                _reactReduxI18n.I18n.t('CHANGE_PASSWORD')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'status', className: 'col-lg-2 col-sm-3 col-form-label' },
	              _reactReduxI18n.I18n.t('STATUS')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-10 col-sm-9' },
	              _ref2,
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-active' },
	                status ? _reactReduxI18n.I18n.t('ACTIVE') : _reactReduxI18n.I18n.t('INACTIVE')
	              )
	            )
	          ),
	          _react2.default.createElement(_UserPermissionTable2.default, { permissionTable: permissionTable, onTogglePermission: onTogglePermission, supportsCareSheet: supportsCareSheet }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row no-gutters bottom-buttons' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 text-right' },
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-secondary', disabled: submitting, onClick: onCancel },
	                _reactReduxI18n.I18n.t('CANCEL')
	              ),
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', className: 'btn btn-primary', disabled: submitting },
	                _reactReduxI18n.I18n.t('SAVE')
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_ChangePasswordModal2.default, { isOpen: modalOpen,
	      onAccept: onPasswordAccept,
	      onClose: onCloseModal,
	      newPassword: newPassword,
	      confirmPassword: confirmPassword,
	      passwordError: passwordError,
	      onPasswordChange: onPasswordChange,
	      onConfirmPasswordChange: onConfirmPasswordChange })
	  );
	};
	
	EditUserForm.defaultProps = {
	  username: ''
	};
	
	exports.default = (0, _reduxForm.reduxForm)()(EditUserForm);

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reduxForm = __webpack_require__(26);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _actions = __webpack_require__(128);
	
	var _selectors = __webpack_require__(129);
	
	var _EditUserForm = __webpack_require__(631);
	
	var _EditUserForm2 = _interopRequireDefault(_EditUserForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _customer$selectors = _customer2.default.selectors,
	    isMasterUser = _customer$selectors.isMasterUser,
	    isCareSheetsSupported = _customer$selectors.isCareSheetsSupported;
	
	
	var formName = 'editUserForm';
	var formSelector = (0, _reduxForm.formValueSelector)(formName);
	
	var EditUserPage = function (_React$Component) {
	  _inherits(EditUserPage, _React$Component);
	
	  function EditUserPage(props) {
	    _classCallCheck(this, EditUserPage);
	
	    var _this = _possibleConstructorReturn(this, (EditUserPage.__proto__ || Object.getPrototypeOf(EditUserPage)).call(this, props));
	
	    _this.handleFormSubmit = function (values) {
	      return new Promise(function (resolve, reject) {
	        _this.props.actions.saveUser(_this.props.selectedUser.userName, values, _this.props.permissionTable).then(function () {
	          resolve();
	        }).catch(function () {
	          reject();
	        });
	      });
	    };
	
	    _this.handleFormCancel = function () {
	      _this.props.actions.push('/users');
	    };
	
	    _this.handleFormValidation = function (values) {
	      var errors = {};
	
	      if (!values.firstName) {
	        errors.firstName = _reactReduxI18n.I18n.t('PLEASE_ENTER_FIRST_NAME');
	      }
	
	      if (!values.lastName) {
	        errors.lastName = _reactReduxI18n.I18n.t('PLEASE_ENTER_LAST_NAME');
	      }
	
	      return errors;
	    };
	
	    _this.handlePasswordOpen = function () {
	      _this.setState({ modalOpen: true });
	    };
	
	    _this.handlePasswordClose = function () {
	      _this.setState({ modalOpen: false });
	      _this.setState({ newPassword: '' });
	      _this.setState({ confirmPassword: '' });
	      _this.setState({ passwordError: '' });
	    };
	
	    _this.handlePasswordAccept = function () {
	      if (_this.state.newPassword.length < 8) {
	        var errorMsg = _reactReduxI18n.I18n.t('PASSWORD_CHARACTERS');
	        _this.setState({ passwordError: errorMsg });
	      } else if (_this.state.newPassword !== _this.state.confirmPassword) {
	        var _errorMsg = _reactReduxI18n.I18n.t('PASSWORDS_DO_NOT_MATCH');
	        _this.setState({ passwordError: _errorMsg });
	      } else {
	        _this.props.actions.savePasswordChange(_this.props.selectedUser.userName, _this.state.newPassword);
	        _this.handlePasswordClose();
	      }
	    };
	
	    _this.handlePasswordChange = function (password) {
	      _this.setState({ newPassword: password });
	      if (password.length < 8) {
	        var errorMsg = _reactReduxI18n.I18n.t('PASSWORD_CHARACTERS');
	        _this.setState({ passwordError: errorMsg });
	      } else if (password !== _this.state.confirmPassword) {
	        var _errorMsg2 = _reactReduxI18n.I18n.t('PASSWORDS_DO_NOT_MATCH');
	        _this.setState({ passwordError: _errorMsg2 });
	      } else {
	        _this.setState({ passwordError: '' });
	      }
	    };
	
	    _this.handleConfirmPasswordChange = function (password) {
	      _this.setState({ confirmPassword: password });
	      if (_this.state.newPassword.length < 8) {
	        var errorMsg = _reactReduxI18n.I18n.t('PASSWORD_CHARACTERS');
	        _this.setState({ passwordError: errorMsg });
	      } else if (password !== _this.state.newPassword) {
	        var _errorMsg3 = _reactReduxI18n.I18n.t('PASSWORDS_DO_NOT_MATCH');
	        _this.setState({ passwordError: _errorMsg3 });
	      } else {
	        _this.setState({ passwordError: '' });
	      }
	    };
	
	    _this.state = {
	      modalOpen: false,
	      newPassword: '',
	      confirmPassword: '',
	      passwordError: ''
	    };
	    return _this;
	  }
	
	  _createClass(EditUserPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.isMasterUser) {
	        this.props.actions.push('/labels');
	      }
	
	      if (Object.keys(this.props.selectedUser).length === 0) {
	        this.props.actions.push('/users');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.actions.deselectUser();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actions = _props.actions,
	          permissionTable = _props.permissionTable,
	          selectedUser = _props.selectedUser,
	          status = _props.status,
	          supportsCareSheets = _props.supportsCareSheets;
	
	      return _react2.default.createElement(_EditUserForm2.default, { form: formName,
	        initialValues: { firstName: selectedUser.firstName,
	          lastName: selectedUser.lastName,
	          status: selectedUser.isActive },
	        onCancel: this.handleFormCancel,
	        onTogglePermission: actions.toggleUserPermission,
	        onSubmit: this.handleFormSubmit,
	        permissionTable: permissionTable,
	        status: status,
	        subscriptions: selectedUser.subscriptions,
	        username: selectedUser.userName,
	        validate: this.handleFormValidation,
	        modalOpen: this.state.modalOpen,
	        onOpenModal: this.handlePasswordOpen,
	        onCloseModal: this.handlePasswordClose,
	        onPasswordAccept: this.handlePasswordAccept,
	        newPassword: this.state.newPassword,
	        confirmPassword: this.state.confirmPassword,
	        passwordError: this.state.passwordError,
	        onPasswordChange: this.handlePasswordChange,
	        onConfirmPasswordChange: this.handleConfirmPasswordChange,
	        supportsCareSheet: supportsCareSheets
	
	      });
	    }
	  }]);
	
	  return EditUserPage;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    isMasterUser: isMasterUser(state),
	    permissionTable: (0, _selectors.getSelectedPermissions)(state),
	    selectedUser: (0, _selectors.getSelectedUser)(state),
	    status: formSelector(state, 'status'),
	    supportsCareSheets: isCareSheetsSupported(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ deselectUser: _actions.deselectUser, push: _reactRouterRedux.push, saveUser: _actions.saveUser, toggleUserPermission: _actions.toggleUserPermission, savePasswordChange: _actions.savePasswordChange }, dispatch)
	  };
	}
	
	EditUserPage.defaultProps = {
	  status: false
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EditUserPage);

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _userPermissions = __webpack_require__(29);
	
	var permissions = _interopRequireWildcard(_userPermissions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement('i', { className: 'fa fa-check fa-lg' });
	
	var _ref3 = _react2.default.createElement('i', { className: 'fa fa-check fa-lg' });
	
	var _ref4 = _react2.default.createElement('i', { className: 'fa fa-check fa-lg' });
	
	var _ref5 = _react2.default.createElement('i', { className: 'fa fa-check fa-lg' });
	
	var _ref6 = _react2.default.createElement('i', { className: 'fa fa-check fa-lg' });
	
	var UserPermissionRow = function UserPermissionRow(_ref) {
	  var onTogglePermission = _ref.onTogglePermission,
	      subscription = _ref.subscription,
	      supportsCareSheet = _ref.supportsCareSheet;
	  var _subscription$permiss = subscription.permissions,
	      accessCareSheets = _subscription$permiss.accessCareSheets,
	      accessLabels = _subscription$permiss.accessLabels,
	      manageArticles = _subscription$permiss.manageArticles,
	      manageLogo = _subscription$permiss.manageLogo,
	      manageCareSheetAds = _subscription$permiss.manageCareSheetAds;
	
	  return _react2.default.createElement(
	    'tr',
	    { key: subscription.id },
	    _react2.default.createElement(
	      'td',
	      null,
	      subscription.name
	    ),
	    supportsCareSheet && _react2.default.createElement(
	      'td',
	      { className: accessCareSheets ? '' : 'empty',
	        onClick: function onClick() {
	          onTogglePermission(subscription.id, permissions.ACCESS_CARE_SHEETS);
	        } },
	      accessCareSheets && _ref2
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: accessLabels ? '' : 'empty',
	        onClick: function onClick() {
	          onTogglePermission(subscription.id, permissions.ACCESS_LABELS);
	        } },
	      accessLabels && _ref3
	    ),
	    supportsCareSheet && _react2.default.createElement(
	      'td',
	      { className: manageCareSheetAds ? '' : 'empty',
	        onClick: function onClick() {
	          onTogglePermission(subscription.id, permissions.MANAGE_CARE_SHEET_ADS);
	        } },
	      manageCareSheetAds && _ref4
	    ),
	    supportsCareSheet && _react2.default.createElement(
	      'td',
	      { className: manageLogo ? '' : 'empty',
	        onClick: function onClick() {
	          onTogglePermission(subscription.id, permissions.MANAGE_LOGO);
	        } },
	      manageLogo && _ref5
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: manageArticles ? '' : 'empty',
	        onClick: function onClick() {
	          onTogglePermission(subscription.id, permissions.MANAGE_ARTICLES);
	        } },
	      manageArticles && _ref6
	    )
	  );
	};
	
	exports.default = UserPermissionRow;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _UserTableRow = __webpack_require__(635);
	
	var _UserTableRow2 = _interopRequireDefault(_UserTableRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement('th', null);
	
	var UserTable = function UserTable(_ref) {
	  var userList = _ref.userList,
	      onSelected = _ref.onSelected;
	
	  var users = userList.map(function (user) {
	    return _react2.default.createElement(_UserTableRow2.default, { key: user.userName, user: user, onSelected: onSelected });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'col-lg-12' },
	    _react2.default.createElement(
	      'table',
	      { className: 'table table-hover users-table' },
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            _reactReduxI18n.I18n.t('NAME')
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            _reactReduxI18n.I18n.t('STATUS')
	          ),
	          _ref2
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        users
	      )
	    )
	  );
	};
	
	exports.default = UserTable;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(28);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserTableRow = function UserTableRow(_ref) {
		var onSelected = _ref.onSelected,
		    user = _ref.user;
	
		return _react2.default.createElement(
			'tr',
			{ onClick: function onClick() {
					onSelected(user);
				} },
			_react2.default.createElement(
				'td',
				null,
				user.firstName + ' ' + user.lastName
			),
			_react2.default.createElement(
				'td',
				null,
				user.isActive ? _reactReduxI18n.I18n.t('ACTIVE') : _reactReduxI18n.I18n.t('INACTIVE')
			),
			_react2.default.createElement(
				'td',
				null,
				_react2.default.createElement(
					_reactRouter.Link,
					{ to: '/users/edit' },
					_reactReduxI18n.I18n.t('EDIT')
				)
			)
		);
	};
	
	exports.default = UserTableRow;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactRouter = __webpack_require__(28);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _actions = __webpack_require__(128);
	
	var _selectors = __webpack_require__(129);
	
	var _UserTable = __webpack_require__(634);
	
	var _UserTable2 = _interopRequireDefault(_UserTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isMasterUser = _customer2.default.selectors.isMasterUser;
	
	var _ref2 = _react2.default.createElement('div', { className: 'loading' });
	
	var UsersPage = function (_React$Component) {
	  _inherits(UsersPage, _React$Component);
	
	  function UsersPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UsersPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UsersPage.__proto__ || Object.getPrototypeOf(UsersPage)).call.apply(_ref, [this].concat(args))), _this), _this.handleUserSelected = function (user) {
	      _this.props.actions.selectUser(user);
	      _this.props.actions.push('/users/edit');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UsersPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.isMasterUser) {
	        this.props.actions.push('/labels');
	      }
	
	      if (!this.props.userListValid) {
	        this.props.actions.getAllUsers();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          userListValid = _props.userListValid,
	          userList = _props.userList;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid main', id: 'main' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-12' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'float-left' },
	              _reactReduxI18n.I18n.t('USERS')
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/users/create', className: 'btn btn-primary float-right create' },
	              _reactReduxI18n.I18n.t('CREATE_USER')
	            )
	          ),
	          !userListValid && _ref2
	        ),
	        userListValid && _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(_UserTable2.default, { userList: userList, onSelected: this.handleUserSelected })
	        )
	      );
	    }
	  }]);
	
	  return UsersPage;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    isMasterUser: isMasterUser(state),
	    userList: (0, _selectors.getUsers)(state),
	    userListValid: (0, _selectors.areUsersValid)(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({ getAllUsers: _actions.getAllUsers, push: _reactRouterRedux.push, selectUser: _actions.selectUser }, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UsersPage);

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UsersPage = exports.EditUserPage = exports.CreateUserPage = undefined;
	
	var _CreateUserPage = __webpack_require__(630);
	
	var _CreateUserPage2 = _interopRequireDefault(_CreateUserPage);
	
	var _EditUserPage = __webpack_require__(632);
	
	var _EditUserPage2 = _interopRequireDefault(_EditUserPage);
	
	var _UsersPage = __webpack_require__(636);
	
	var _UsersPage2 = _interopRequireDefault(_UsersPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CreateUserPage = _CreateUserPage2.default;
	exports.EditUserPage = _EditUserPage2.default;
	exports.UsersPage = _UsersPage2.default;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	
	var _actionTypes = __webpack_require__(282);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _userPermissions = __webpack_require__(29);
	
	var permissions = _interopRequireWildcard(_userPermissions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialSelected = {
		user: {},
		permissions: []
	};
	
	var initialState = {
		list: [],
		valid: false,
		selected: initialSelected
	};
	
	function reducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		switch (action.type) {
			case types.ALL_USERS_RECEIVED:
				{
					return _extends({}, state, {
						list: action.payload.users,
						valid: true
					});
				}
			case types.SELECT_USER:
				{
					return _extends({}, state, {
						selected: {
							user: action.payload.selectedUser,
							permissions: action.payload.selectedUser.subscriptions
						}
					});
				}
			case types.DESELECT_USER:
				{
					return _extends({}, state, {
						selected: initialSelected
					});
				}
			case types.TOGGLE_USER_PERMISSION:
				{
					// We use JSON.parse to get a deep copy, as with redux we can't mutate the state directly.
					var subscriptions = JSON.parse(JSON.stringify(state.selected.permissions));
					var subscription = subscriptions.find(function (subscription) {
						return subscription.id === action.payload.subscriptionId;
					});
	
					switch (action.payload.permissionType) {
						case permissions.ACCESS_CARE_SHEETS:
							subscription.permissions.accessCareSheets = !subscription.permissions.accessCareSheets;
							break;
						case permissions.ACCESS_LABELS:
							subscription.permissions.accessLabels = !subscription.permissions.accessLabels;
							break;
						case permissions.MANAGE_ARTICLES:
							subscription.permissions.manageArticles = !subscription.permissions.manageArticles;
							break;
						case permissions.MANAGE_LOGO:
							subscription.permissions.manageLogo = !subscription.permissions.manageLogo;
							break;
						case permissions.MANAGE_CARE_SHEET_ADS:
							subscription.permissions.manageCareSheetAds = !subscription.permissions.manageCareSheetAds;
							break;
					}
					return _extends({}, state, {
						selected: _extends({}, state.selected, {
							permissions: subscriptions
						})
					});
				}
			case types.INITIALIZE_PERMISSION_TABLE:
				{
					return _extends({}, state, {
						selected: _extends({}, state.selected, {
							permissions: action.payload.subscriptions
						})
					});
				}
			default:
				return state;
		}
	}

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _combineReducers;
	
	var _redux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reactReduxI18n = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(26);
	
	var _actionTypes = __webpack_require__(264);
	
	var _caresheets = __webpack_require__(263);
	
	var _caresheets2 = _interopRequireDefault(_caresheets);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _labels = __webpack_require__(273);
	
	var _labels2 = _interopRequireDefault(_labels);
	
	var _navbar = __webpack_require__(279);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _search = __webpack_require__(174);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _users = __webpack_require__(286);
	
	var _users2 = _interopRequireDefault(_users);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var appReducer = (0, _redux.combineReducers)((_combineReducers = {}, _defineProperty(_combineReducers, _caresheets2.default.constants.NAME, _caresheets2.default.reducer), _defineProperty(_combineReducers, _customer2.default.constants.NAME, _customer2.default.reducer), _defineProperty(_combineReducers, _labels2.default.constants.NAME, _labels2.default.reducer), _defineProperty(_combineReducers, _navbar2.default.constants.NAME, _navbar2.default.reducer), _defineProperty(_combineReducers, _search2.default.constants.NAME, _search2.default.reducer), _defineProperty(_combineReducers, _users2.default.constants.NAME, _users2.default.reducer), _defineProperty(_combineReducers, 'routing', _reactRouterRedux.routerReducer), _defineProperty(_combineReducers, 'i18n', _reactReduxI18n.i18nReducer), _defineProperty(_combineReducers, 'form', _reduxForm.reducer), _combineReducers));
	
	var rootReducer = function rootReducer(state, action) {
	  if (action.type === _actionTypes.CLEAR_APPLICATION_STATE) {
	    var _state = state,
	        routing = _state.routing,
	        i18n = _state.i18n,
	        form = _state.form;
	
	    state = { routing: routing, i18n: i18n, form: form };
	  }
	  return appReducer(state, action);
	};
	
	exports.default = rootReducer;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(28);
	
	var _authHelpers = __webpack_require__(644);
	
	var _app = __webpack_require__(561);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _caresheets = __webpack_require__(263);
	
	var _caresheets2 = _interopRequireDefault(_caresheets);
	
	var _customer = __webpack_require__(14);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _labels = __webpack_require__(273);
	
	var _labels2 = _interopRequireDefault(_labels);
	
	var _users = __webpack_require__(286);
	
	var _users2 = _interopRequireDefault(_users);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createElement(
	  _reactRouter.Route,
	  { component: _app2.default.components.App },
	  _react2.default.createElement(_reactRouter.Redirect, { from: '/', to: '/labels' }),
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { component: (0, _authHelpers.UserIsAuthenticated)(_app2.default.components.NavLayout) },
	    _react2.default.createElement(_reactRouter.Route, { path: '/articles', component: (0, _authHelpers.UserIsAuthenticated)(_labels2.default.components.ArticlesPage) }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/ads', component: (0, _authHelpers.UserIsAuthenticated)(_caresheets2.default.components.AdsPage) }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/caresheets', component: (0, _authHelpers.UserIsAuthenticated)(_caresheets2.default.components.CareSheetsPage) }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/store', component: (0, _authHelpers.UserIsAuthenticated)(_caresheets2.default.components.StoreInfoPage) }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/labels', component: (0, _authHelpers.UserIsAuthenticated)(_labels2.default.components.LabelsPage) }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/no_access', component: (0, _authHelpers.UserIsAuthenticated)(_labels2.default.components.NoAccessPage) }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/users', component: (0, _authHelpers.UserIsAuthenticated)(_users2.default.components.UsersPage) }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/users/create', component: (0, _authHelpers.UserIsAuthenticated)(_users2.default.components.CreateUserPage) }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/users/edit', component: (0, _authHelpers.UserIsAuthenticated)(_users2.default.components.EditUserPage) })
	  ),
	  _react2.default.createElement(_reactRouter.Route, { path: '/pet_search', component: (0, _authHelpers.UserIsAuthenticated)(_labels2.default.components.PetSearchPage) }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/create_label', component: (0, _authHelpers.UserIsAuthenticated)(_labels2.default.components.CreateLabelPage) }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/edit_label', component: (0, _authHelpers.UserIsAuthenticated)(_labels2.default.components.EditLabelPage) }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/custom_label', component: (0, _authHelpers.UserIsAuthenticated)(_labels2.default.components.CustomLabelPage) }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/customize_label', component: (0, _authHelpers.UserIsAuthenticated)(_labels2.default.components.CustomizeLabelPage) }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/advanced_settings_label', component: (0, _authHelpers.UserIsAuthenticated)(_labels2.default.components.AdvancedSettingsPage) }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/login', component: (0, _authHelpers.UserIsNotAuthenticated)(_customer2.default.components.LoginPage) }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/forgot', component: (0, _authHelpers.UserIsNotAuthenticated)(_customer2.default.components.ForgotPasswordPage) }),
	  _react2.default.createElement(_reactRouter.Route, { path: '*', component: (0, _authHelpers.UserIsAuthenticated)(_app2.default.components.NotFoundPage) })
	);

/***/ },
/* 641 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var locale = exports.locale = "de-DE";
	
	var tokens = exports.tokens = {
		EMAIL_ADDRESS: "Email Adresse",
		PASSWORD: "Passwort",
		REMEMBER_ME: "Angemeldet bleiben",
		FORGOT_PASSWORD: "Passwort vergessen?",
		LOG_IN: "Anmelden",
		NO_ACCOUNT: "Neu bei Petdata? ",
		SIGN_UP: "Bestellen",
		OR: " oder ",
		VIEW_DEMO: "Demo starten",
		INVALID_CREDENTIALS: "Die eingegebenen Daten sind nicht korrekt.",
		PLEASE_REENTER: "Bitte versuchen Sie es erneut.",
	
		LABELS: "Etiketten",
		CARE_SHEETS: "Tierinformationsblätter",
		ADVERTISING_SPACE: "Werbefläche",
		STORE_INFO_LOGO: "Adresse und Logo",
		ARTICLE_MANAGEMENT: "Artikelverwaltung",
		USERS: "Benutzer",
		LOG_OUT: "Abmelden",
		CHANGE_STORE: "Standort/Filiale",
	
		PET_SEARCH_PLACEHOLDER: "Tiername oder PLU-Code, Beispiel: Nymphensittich bzw. Nymphicus hollandicus",
	
		CREATE_USER: "Benutzer erstellen",
		NAME: "Name",
		STATUS: "Status",
		ACTIVE: "Aktiv",
		INACTIVE: "Nicht aktiv",
	
		USER_INFO: "Benutzerinfo",
		FIRST_NAME: "Vorname",
		LAST_NAME: "Nachname",
		CONFIRM_PASSWORD: "Bitte das Passwort wiederholen",
		CANCEL: "Abbrechen",
	
		PERMISSIONS: "Berechtigungen",
		LOCATION: "Standort",
		PRINT_CARE_SHEETS: "Tierinformationsblätter",
		PRINT_LABELS: "Etiketten",
		EDIT_AD_SPACE: "Werbefläche",
		EDIT_STORE_INFO_LOGO: "Adresse und Logo",
	
		EDIT_USER: "Benutzer bearbeiten",
		CHANGE_PASSWORD: "Passwort ändern",
		SAVE: "Speichern",
	
		ADVERTISING_DETAILS: "Das Bild muss eine Größe von 57 x 128 mm bzw. 673 x 1512 Pixel @ 300 dpi haben. Folgende Formate werden unterstützt: jpg und png. Das Bild kann pro Tiertyp einzeln konfiguriert werden.",
		PET_TYPE: "Tiertyp",
		AD_UPLOADED: "Bild",
		UPLOAD: "Upload",
		CLEAR: "Löschen",
	
		STORE_INFO_DETAILS: "Auf dem Tierinformationsblatt kann das Logo oder die Adresse angezeigt werden.",
		STORE_INFO: "Adresse",
		LINE1: "1. Zeile",
		LINE2: "2. Zeile",
		LINE3: "3. Zeile",
		LINE4: "4. Zeile",
		USE_LOGO_INSTEAD: "Ich möchte mein Logo verwenden",
		UPLOAD_LOGO: "Upload Logo",
		STORE_LOGO_DETAILS: "Das Firmenlogo muss eine Größe von 57 x 45 mm bzw. 673 x 531 Pixel @ 300 dpi haben.",
		STORE_LOGO_FORMATS: "Es werden nur JPG und PNG Formate unterstützt.",
	
		PREVIEW_CARE_SHEET: "Voransicht",
	
		SEARCH_PETS: "Suche",
		SEARCH_FOR_A_PET: "Suche nach einem Tier",
		NO_RESULTS_TRY_AGAIN: "Es wurden keine Treffer gefunden. Versuchen Sie es nochmal.",
		DOWNLOAD: "Download",
	
		SAVED_SUCCESSFULLY: "Die Änderung wurde übernommen",
	
		SELECT: "Auswählen",
	
		CUSTOMIZE_COLORS_LOGO: "Design ändern",
		PAGE_SETUP: "Seite einrichten",
		GENERATE: "Erstellen",
		PLU: "PLU-Code",
		ENABLE_PLU: "PLU-Code anzeigen",
		PLU_CONFIRMATION: "Diese Änderung löscht die bereits ausgewählten Etiketten. Möchten Sie fortfahren?",
		YES: "Ja",
		NO: "Nein",
		CREATE_LABEL: "Etikett erstellen",
		CREATE_CUSTOM_LABEL: "Leeretikett erstellen",
		OR_CREATE_CUSTOM_LABEL: "oder Leeretikett erstellen",
		RESULTS: "Ergebnisse",
		BACK_SEARCH_RESULTS: "Zurück zu den Suchergebnissen",
		BACK_TO_LABELS_SEARCH_RESULTS: "Zurück zu Etiketten",
		ENTER_PRICE_SEARCH_RESULTS: "Preis",
		ENTER_PRICE: "Preis eingeben",
		ENTER_PLU: "PLU eingeben",
		EDIT_LABEL: "Etikett editieren",
		SAVE_LABEL: "Etikett speichern",
		ENTER_BARCODE: "EAN Barcode eingeben",
		ENTER_NAME: "Name eingeben",
		ENTER_LATIN_NAME: "Lat. Name eingeben",
		CUSTOM_LABEL: "Leeretikett",
		LABEL_SIZE: "Etikettenformate",
	
		DUPLICATE_ROW: "Tier duplizieren",
		CLEAR_ROW: "Tier löschen",
		ARTICLE_INSTRUCTIONS: "Hier können Sie Preis, PLU- und EAN Code sowie einen Integrationsnamen hinterlegen, die dann am Etikett angezeigt werden (Erweiterte Einstellungen). Der Integrationsname ist hilfreich, wenn ein anderer Name als der Standardname gewünscht wird oder von demselben Tier mehrere Einträge vorhanden sind. Sie können die Werte in der Tabelle direkt eingeben oder als Excel Datei herunterladen (Datei Download), bearbeiten und mit den Änderungen wieder hochladen (Datei Upload).",
		UPLOAD_FILE: "Datei Upload",
		EXPORT_TO_EXCEL: "Datei Download",
	
		CUSTOMIZE_LABEL: "Etiketten-Design ändern",
		MAIN: "Hauptfarben",
		BORDER: "Rahmen",
		IMAGE_BORDER: "Bildrand",
		BACKGROUND: "Hintergrund",
		LABEL: "Detailinfo",
		TEXT: "Text",
		PRICE: "Preis",
		TITLE: "Überschrift",
		DETAIL: "Detailinfo Title",
		BARCODE: "Barcode",
		RESTORE_DEFAULT_COLORS: "Standard wiederherstellen",
		LOGO: "Logo",
		LOGO_FORMAT: "202 x 118 Pixel @ 300 dpi",
		RIGHTCOLUMN: "Rechte Splate",
	
		PRINTER_ADJUSTMENT: "Seite anpassen",
		ADJUSTMENT_INSTRUCTIONS: "Um Etiketten millimetergenau zu platzieren, kann der Ausdruck vertikal und horizontal justiert werden.<p> <br /> Horizontal:<br /> Soll das Etikett z.B. um 5 mm nach rechts verschoben werden, geben Sie 5 im Feld „Horizontal (mm)“ ein. Bei der Eingabe von -5 wird das Etikett um 5 mm nach links verschoben.</p><p><br /> Vertikal:<br />Wenn das Etikett z.B. um 3 mm nach oben verschoben werden soll, geben Sie 3 im Feld „Vertikal (mm)“ ein. Mit der Eingabe von -3 wird das Etikett um 3 mm nach unten verschoben.</p><p><br /> Tipp:<br /> Falls das Etikett nicht der angegebenen Größe entspricht, deaktivieren Sie in den Druckereinstellung den Zoom, der bei einigen Druckern als Standard eingestellt ist.</p>",
		A_VERTICAL: "Vertikal(mm)",
		B_HORIZONTAL: "Horizontal(mm)",
	
		CUSTOM_LABEL_PET_LAT_NAME: "Paracheirodon innesi",
		CUSTOM_LABEL_PET_NAME: "Neonsalmler",
		CUSTOM_LABEL_PET_PRICE: "1,99 €",
	
		CUSTOM_LABEL_KEY_1: "Größe",
		CUSTOM_LABEL_VALUE_1: "4 cm",
		CUSTOM_LABEL_KEY_2: "Herkunft",
		CUSTOM_LABEL_VALUE_2: "Süßwasser",
		CUSTOM_LABEL_KEY_3: "Temp.",
		CUSTOM_LABEL_VALUE_3: "21-26 °C",
		CUSTOM_LABEL_KEY_4: "Ernährung",
		CUSTOM_LABEL_VALUE_4: "Carnivor",
		CUSTOM_LABEL_KEY_5: "Haltung",
		CUSTOM_LABEL_VALUE_5: "Gruppe",
		CUSTOM_LABEL_KEY_6: "Aquarium",
		CUSTOM_LABEL_VALUE_6: "Ab 60 cm / 54 l",
	
		CUSTOM_LABEL_KEY_7: "Familie",
		CUSTOM_LABEL_VALUE_7: "Characidae",
		CUSTOM_LABEL_KEY_8: "Verbreitung",
		CUSTOM_LABEL_VALUE_8: "Südamerika",
		CUSTOM_LABEL_KEY_9: "Lebensraum",
		CUSTOM_LABEL_VALUE_9: "Süßwasser",
		CUSTOM_LABEL_KEY_10: "Temperatur",
		CUSTOM_LABEL_VALUE_10: "21-26 °C",
		CUSTOM_LABEL_KEY_11: "pH-Wert",
		CUSTOM_LABEL_VALUE_11: "5,5-7,5",
		CUSTOM_LABEL_KEY_12: "Härte",
		CUSTOM_LABEL_VALUE_12: "< 15 °dH",
		CUSTOM_LABEL_KEY_13: "Lebenserwartung",
		CUSTOM_LABEL_VALUE_13: "5 Jahre",
		CUSTOM_LABEL_KEY_14: "Verhalten",
		CUSTOM_LABEL_VALUE_14: "Friedlich",
		CUSTOM_LABEL_KEY_15: "Verhalten",
		CUSTOM_LABEL_VALUE_15: "Friedlich",
		CUSTOM_LABEL_KEY_16: "Fortpflanzung",
		CUSTOM_LABEL_VALUE_16: "Freilaicher",
		CUSTOM_LABEL_KEY_17: "Schwierigkeitsgrad",
		CUSTOM_LABEL_VALUE_17: "Anfänger",
		CUSTOM_LABEL_KEY_18: "Zucht",
		CUSTOM_LABEL_VALUE_18: "Mittelschwer",
		CUSTOM_LABEL_KEY_19: "Artenschutz",
		CUSTOM_LABEL_VALUE_19: "Nein",
	
		PAGE_NOT_FOUND: "404 Seite nicht gefunden",
		GO_BACK_TO_HOMEPAGE: "Zurück zur Startseite",
	
		PLEASE_ENTER_FIRST_NAME: "Vorname darf nicht leer sein.",
		PLEASE_ENTER_LAST_NAME: "Nachname darf nicht leer sein.",
		PLEASE_ENTER_VALID_EMAIL: "Bitte geben Sie eine gültige E-Mail Adresse an.",
		PASSWORD_CHARACTERS: "Vergeben Sie mind. 8 Zeichen.",
		PASSWORDS_DO_NOT_MATCH: "Passwort stimmt nicht überein.",
	
		EDIT: "Editieren",
		NEW_PASSWORD: "Neues Passwort",
	
		ACCESS_WELCOME: "Willkomen bei Petdata",
	
		PRINT_CALIBRATION_PAGE: "Justierungsseite erstellen",
	
		PREVIEW: "Voransicht",
		CURRENT_PASSWORD: "Aktuelles Passwort",
		SEND_PASSWORD: "Passwort zurücksetzten",
	
		RESET_PASSWORD_HEADER: "Bitte geben Sie Ihre E-Mail Adresse an.",
		RESET_PASSWORD_BACK: "Zurück zum Login",
		RESET_PASSWORD_CONFIRMATION: "Ein neues Passwort wurde an die Ihre E-Mail Adresse versendet.",
	
		APPLICATION_ERROR: "Fehler",
		ERROR_MESSAGE: "Ein Anwendungsfehler ist aufgetreten.",
	
		LABEL_ADDED: "Etikett erstellt",
		LABEL_ADDED_MESSAGE: "Das Etikett wurde erfolgreich erstellt!",
		CONTINUE: "Weiter",
	
		ADD: "Erstellen",
		MANAGEMENT: "Abo verwalten",
	
		DEMO_DE_LOGIN: "Deutsche Demo",
		DEMO_EN_LOGIN: "English Demo",
		DEMO_TEXT: "Sie können Petdata mit unserer Demoversion ausführlich testen. Alle Funktionen sind verfügbar, ausgenommen Editieren der Etiketten und Benutzerverwaltung.",
		DEMO_TITLE: "Demoversion starten",
	
		ADVANCED_SETTINGS_LINK: "Erweiterte Einstellungen",
		ADVANCED_SETTINGS_LABEL_PAGE_TITLE: "Erweiterte Einstellungen",
		ADVANCED_SETTINGS_LABEL_PAGE_DESCRIPTION: "Hier können Sie bla bla bla",
		ADVANCED_SETTINGS_LABEL_PLU_TITLE: "PLU Code",
		ADVANCED_SETTINGS_LABEL_PLU_DESCRIPTION: "Petdata Etiketten können auf den Etiketten einen PLU Code anzeigen. Diese Funktion ist standardmäßig aktiviert.",
		ADVANCED_SETTINGS_LABEL_PLU_FIELD: "PLU Code verwenden",
		ADVANCED_SETTINGS_LABEL_HEADER_TITLE: "Etiketten Titel",
		ADVANCED_SETTINGS_LABEL_HEADER_FIELD: "Reihenfolge",
		ADVANCED_SETTINGS_LABEL_HEADER_DESCRIPTION: "Auf jedem Etikett stehen zwei Zeilen für den Namen des Tieres zur Verfügung. Die Belegung dieser zwei Zeilen lässt sich konfigurieren.",
		ADVANCED_SETTINGS_LABEL_METRIC_TITLE: "Maßeinheiten",
		ADVANCED_SETTINGS_LABEL_METRIC_DESCRIPTION: "Tierinformationen stehen in zwei verschiedenen Maßsystemen zur Verfügung. ",
		ADVANCED_SETTINGS_LABEL_METRIC_FIELD: "Maßeinheit",
		ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_TITLE: "Seitenformat",
		ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_DESCRIPTION: "Petdata unterstützt das A4 und Letter Format für die PDF Erstellung.",
		ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_FIELD: "Format",
		ADVANCED_SETTINGS_LABEL_PRINTER_CALIBRATION_TITLE: "Drucker justieren",
	
		ADVANCED_SETTINGS_LABEL_HEADER_N_LAT: "Zeile 1: Name; Zeile 2: Wissenschaftlicher Name",
		ADVANCED_SETTINGS_LABEL_HEADER_LAT_N: "Zeile 1: Wissenschaftlicher Name; Zeile 2: Name",
		ADVANCED_SETTINGS_LABEL_HEADER_IN_N_LAT: "Zeile 1 Integrationsname aus der Artikelverwaltung falls vorhanden, sonst Name; Zeile 2: Wissenschaftlicher Name",
	
		ADVANCED_SETTINGS_LABEL_METRIC_US: "Angloamerikanisches Maßsystem (pound, inch, )",
		ADVANCED_SETTINGS_LABEL_METRIC_EU: "Metrisches Maßsystem (Gramm, Zentimeter, ...)"
	
	};

/***/ },
/* 642 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var locale = exports.locale = "en-US";
	
	var tokens = exports.tokens = {
		EMAIL_ADDRESS: "Email Address",
		PASSWORD: "Password",
		REMEMBER_ME: "Remember me",
		FORGOT_PASSWORD: "Forgot Password?",
		LOG_IN: "Log In",
		NO_ACCOUNT: "Don't have a Petdata account? ",
		SIGN_UP: "Sign Up",
		OR: " or ",
		VIEW_DEMO: "View Demo",
		INVALID_CREDENTIALS: "Invalid email address or password.",
		PLEASE_REENTER: "Please re-enter",
	
		LABELS: "Labels",
		CARE_SHEETS: "Care Sheets",
		ADVERTISING_SPACE: "Advertising Space",
		STORE_INFO_LOGO: "Store Info / Logo",
		ARTICLE_MANAGEMENT: "Article Management",
		USERS: "Users",
		LOG_OUT: "Log Out",
		CHANGE_STORE: "Change Store",
	
		PET_SEARCH_PLACEHOLDER: "Search for a pet, PLU, or specification. For example: Parrot Africa",
	
		CREATE_USER: "Create User",
		NAME: "Name",
		STATUS: "Status",
		ACTIVE: "Active",
		INACTIVE: "Inactive",
	
		USER_INFO: "User Info",
		FIRST_NAME: "First Name",
		LAST_NAME: "Last Name",
		CONFIRM_PASSWORD: "Confirm Password",
		CANCEL: "Cancel",
	
		PERMISSIONS: "Permissions",
		LOCATION: "Location",
		PRINT_CARE_SHEETS: "Print Care Sheets",
		PRINT_LABELS: "Print Labels",
		EDIT_AD_SPACE: "Edit Ad Space",
		EDIT_STORE_INFO_LOGO: "Edit Store Info / Logo",
	
		EDIT_USER: "Edit User",
		CHANGE_PASSWORD: "Change Password",
		SAVE: "Save",
	
		ADVERTISING_DETAILS: "Your ad must be 57 x 128 mm or 673 x 1512 px @ 300 dpi. JPG or PNG formats accepted. Your ad will display on the care sheet for each specific pet type.",
		PET_TYPE: "Pet Type",
		AD_UPLOADED: "Ad Uploaded",
		UPLOAD: "Upload",
		CLEAR: "Clear",
	
		STORE_INFO_DETAILS: "Choose whether to use your store information or logo on pet care sheets.",
		STORE_INFO: "Store Info",
		LINE1: "Line 1",
		LINE2: "Line 2",
		LINE3: "Line 3",
		LINE4: "Line 4",
		USE_LOGO_INSTEAD: "I want to use my logo instead",
		UPLOAD_LOGO: "Upload Logo",
		STORE_LOGO_DETAILS: "Your logo must be 57 x 45 mm or 673 x 531 px @ 300 dpi.",
		STORE_LOGO_FORMATS: "JPG or PNG formats accepted.",
	
		PREVIEW_CARE_SHEET: "Preview Care Sheet",
	
		SEARCH_PETS: "Search Pets",
		SEARCH_FOR_A_PET: "Search for a pet",
		NO_RESULTS_TRY_AGAIN: "No Results. Please try again.",
		DOWNLOAD: "Download",
	
		SAVED_SUCCESSFULLY: "Saved successfully",
	
		SELECT: "Select",
	
		CUSTOMIZE_COLORS_LOGO: "Customize Colors",
		PAGE_SETUP: "Page Setup",
		GENERATE: "Generate",
		PLU: "PLU",
		ENABLE_PLU: "Enable PLU",
		PLU_CONFIRMATION: "Enabling the PLU field will clear the current label sheet. Do you want to continue?",
		YES: "Yes",
		NO: "No",
		CREATE_LABEL: "Create Label",
		CREATE_CUSTOM_LABEL: "Create Custom Label",
		OR_CREATE_CUSTOM_LABEL: "or create a custom label",
		RESULTS: "Results",
		BACK_SEARCH_RESULTS: "Back to search results",
		BACK_TO_LABELS_SEARCH_RESULTS: "Back To Labels",
		ENTER_PRICE_SEARCH_RESULTS: "Price",
		ENTER_PRICE: "Enter Price",
		ENTER_PLU: "Enter PLU",
		EDIT_LABEL: "Edit Label",
		SAVE_LABEL: "Save Label",
		ENTER_BARCODE: "Enter EAN Barcode",
		ENTER_NAME: "Enter Name",
		ENTER_LATIN_NAME: "Enter Latin Name",
		CUSTOM_LABEL: "Custom Label",
		LABEL_SIZE: "Label Size",
	
		DUPLICATE_ROW: "Duplicate Row",
		CLEAR_ROW: "Clear Row",
		ARTICLE_INSTRUCTIONS: "You can enter the price, PLU and EAN code and an Integrationsname, which are then displayed on the label (Advanced Settings). The Integrationsname is useful if you want a different name than the default name or if there are several entries for the same animal. You can enter the values in the table directly or download as Excel file (File Download), edit and upload with the changes (File Upload).",
		UPLOAD_FILE: "Upload File",
		EXPORT_TO_EXCEL: "Export To Excel",
	
		CUSTOMIZE_LABEL: "Customize Label",
		MAIN: "Main",
		BORDER: "Border",
		IMAGE_BORDER: "Image Border",
		BACKGROUND: "Background",
		LABEL: "Labeldetails",
		TEXT: "Text",
		PRICE: "Price",
		TITLE: "Header",
		DETAIL: "Labeldetails Title",
		BARCODE: "Barcode",
		RESTORE_DEFAULT_COLORS: "Restore Default Colors",
		LOGO: "Logo",
		LOGO_FORMAT: "202 x 118 Pixel @ 300 dpi",
		RIGHTCOLUMN: "Right Column",
	
		PRINTER_ADJUSTMENT: "Printer Adjustment",
		ADJUSTMENT_INSTRUCTIONS: "In order to place labels with millimeter precision, the printout can be adjusted vertically and horizontally. <P> <br /> Horizontal: <br /> If the label is to be used e.g. 5 mm to the right, enter 5 in the Horizontal (mm) box. Entering -5 moves the label 5 mm to the left. </ P> <p> <br /> Vertical: <br /> If the label is e.g. by 3 mm, enter 3 in the Vertical (mm) field. Enter -3 to move the label down by 3mm. </ P> <p> <br /> Tip: <br /> If the label does not match the specified size, deactivate the zoom setting in the printer setting, which is the default setting for some printers. </ p> ",
		A_VERTICAL: "A (vertical)",
		B_HORIZONTAL: "B (horizontal)",
	
		CUSTOM_LABEL_PET_LAT_NAME: "Paracheirodon innesi",
		CUSTOM_LABEL_PET_NAME: "Neon Tetra",
		CUSTOM_LABEL_PET_PRICE: "1.99 $",
	
		CUSTOM_LABEL_KEY_1: "Size",
		CUSTOM_LABEL_VALUE_1: "4 cm",
		CUSTOM_LABEL_KEY_2: "Origin",
		CUSTOM_LABEL_VALUE_2: "South America",
		CUSTOM_LABEL_KEY_3: "Temp.",
		CUSTOM_LABEL_VALUE_3: "21-26 °C",
		CUSTOM_LABEL_KEY_4: "Diet",
		CUSTOM_LABEL_VALUE_4: "Carnivore",
		CUSTOM_LABEL_KEY_5: "Keeping",
		CUSTOM_LABEL_VALUE_5: "Group",
		CUSTOM_LABEL_KEY_6: "Aquarium",
		CUSTOM_LABEL_VALUE_6: "60 cm / 54 l",
	
		CUSTOM_LABEL_KEY_7: "Family",
		CUSTOM_LABEL_VALUE_7: "Characidae",
		CUSTOM_LABEL_KEY_8: "Origin",
		CUSTOM_LABEL_VALUE_8: "South America",
		CUSTOM_LABEL_KEY_9: "Habitat",
		CUSTOM_LABEL_VALUE_9: "Tributaries",
		CUSTOM_LABEL_KEY_10: "Temperature",
		CUSTOM_LABEL_VALUE_10: "21-26 °C",
		CUSTOM_LABEL_KEY_11: "pH",
		CUSTOM_LABEL_VALUE_11: "5,5-7,5",
		CUSTOM_LABEL_KEY_12: "Hardness",
		CUSTOM_LABEL_VALUE_12: "5-15 °dH",
		CUSTOM_LABEL_KEY_13: "Life Span",
		CUSTOM_LABEL_VALUE_13: "5 years",
		CUSTOM_LABEL_KEY_14: "Behavior",
		CUSTOM_LABEL_VALUE_14: "Peaceful",
		CUSTOM_LABEL_KEY_15: "Temperament",
		CUSTOM_LABEL_VALUE_15: "",
		CUSTOM_LABEL_KEY_16: "Reporduction",
		CUSTOM_LABEL_VALUE_16: "Egg scatterers",
		CUSTOM_LABEL_KEY_17: "Care Level",
		CUSTOM_LABEL_VALUE_17: "Easy",
		CUSTOM_LABEL_KEY_18: "Breeding",
		CUSTOM_LABEL_VALUE_18: "Moderately difficult",
		CUSTOM_LABEL_KEY_19: "Protection Agrmt.",
		CUSTOM_LABEL_VALUE_19: "No",
	
		PAGE_NOT_FOUND: "404 Page Not Found",
		GO_BACK_TO_HOMEPAGE: "Go back to homepage",
	
		PLEASE_ENTER_FIRST_NAME: "Please enter a first name.",
		PLEASE_ENTER_LAST_NAME: "Please enter a last name.",
		PLEASE_ENTER_VALID_EMAIL: "Please enter a valid email address",
		PASSWORD_CHARACTERS: "Your password must be between 8-100 characters.",
		PASSWORDS_DO_NOT_MATCH: "Passwords do not match",
	
		EDIT: "Edit",
		NEW_PASSWORD: "New Password",
	
		ACCESS_WELCOME: "Welcome to Petdata",
	
		PRINT_CALIBRATION_PAGE: "Print Calibration Page",
	
		PREVIEW: "Preview",
		CURRENT_PASSWORD: "Current Password",
		SEND_PASSWORD: "Reset Password",
	
		RESET_PASSWORD_HEADER: "Please enter your email address.",
		RESET_PASSWORD_BACK: "Back to Login",
		RESET_PASSWORD_CONFIRMATION: "Your password has been sent to the provided email address.",
	
		APPLICATION_ERROR: "Application Error",
		ERROR_MESSAGE: "An application error has occurred. Please contact an administrator if you continue to experience issues.",
	
		LABEL_ADDED: "Label Added",
		LABEL_ADDED_MESSAGE: "Successfully added the chosen pet to the label sheet.",
		CONTINUE: "Continue",
		ADD: "Add",
	
		MANAGEMENT: "Management",
	
		DEMO_DE_LOGIN: "Deutsche Demo",
		DEMO_EN_LOGIN: "English Demo",
		DEMO_TEXT: "Our demo lets you explore most of our application. Only user management and detailed label editing features are disabled.",
		DEMO_TITLE: "Start Demo",
	
		ADVANCED_SETTINGS_LINK: "Advanced Settings",
		ADVANCED_SETTINGS_LABEL_PAGE_TITLE: "Advanced Settings",
	
		ADVANCED_SETTINGS_LABEL_PLU_TITLE: "PLU Code",
		ADVANCED_SETTINGS_LABEL_PLU_DESCRIPTION: "Petdata Labels support a PLU Code field. This feature can be disabled.",
		ADVANCED_SETTINGS_LABEL_PLU_FIELD: "Use PLU Code",
		ADVANCED_SETTINGS_LABEL_HEADER_TITLE: "Label Title",
		ADVANCED_SETTINGS_LABEL_HEADER_FIELD: "Order",
		ADVANCED_SETTINGS_LABEL_HEADER_DESCRIPTION: "Each label has two lines for the name of the animal. The assignment of these two lines can be configured.",
		ADVANCED_SETTINGS_LABEL_METRIC_TITLE: "System of measurement",
		ADVANCED_SETTINGS_LABEL_METRIC_DESCRIPTION: "Animal information is available in two different measurement systems.",
		ADVANCED_SETTINGS_LABEL_METRIC_FIELD: "System of measurement",
		ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_TITLE: "Page format",
		ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_DESCRIPTION: "Petdata support A4 and Letter formats for the generated PDFs.",
		ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_FIELD: "Format",
		ADVANCED_SETTINGS_LABEL_PRINTER_CALIBRATION_TITLE: "Printer Adjustment",
	
		ADVANCED_SETTINGS_LABEL_HEADER_N_LAT: "Line 1: Common Name; Line2: Scientific Name",
		ADVANCED_SETTINGS_LABEL_HEADER_LAT_N: "Line 1: Scientific Name; Line 2: Common Name",
		ADVANCED_SETTINGS_LABEL_HEADER_IN_N_LAT: "Line 1: Integrationsname from Article Management, if available, otherwise Common Name; Line 2: Scientific Name",
	
		ADVANCED_SETTINGS_LABEL_METRIC_US: "United States customary units (inch, gallon, degrees Farenheit, pound, …)",
		ADVANCED_SETTINGS_LABEL_METRIC_EU: "Metric system (meter, liter, degrees Celsius, kilogramm, …)"
	
	};

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enUS = __webpack_require__(642);
	
	var enUS = _interopRequireWildcard(_enUS);
	
	var _deDE = __webpack_require__(641);
	
	var deDE = _interopRequireWildcard(_deDE);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = { enUS: enUS, deDE: deDE };

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserIsNotAuthenticated = exports.UserIsAuthenticated = undefined;
	
	var _reactRouterRedux = __webpack_require__(20);
	
	var _reduxAuthWrapper = __webpack_require__(1136);
	
	var UserIsAuthenticated = exports.UserIsAuthenticated = (0, _reduxAuthWrapper.UserAuthWrapper)({
	  authSelector: function authSelector(state) {
	    return state.account;
	  },
	  authenticatingSelector: function authenticatingSelector(state) {
	    return state.account.attemptingLogin;
	  },
	  redirectAction: _reactRouterRedux.routerActions.replace,
	  wrapperDisplayName: 'UserIsAuthenticated',
	  predicate: function predicate(account) {
	    return account.authenticated === true;
	  },
	  failureRedirectPath: function failureRedirectPath(state, ownProps) {
	    return ownProps.location.query.redirect || '/login';
	  }
	});
	
	var UserIsNotAuthenticated = exports.UserIsNotAuthenticated = (0, _reduxAuthWrapper.UserAuthWrapper)({
	  authSelector: function authSelector(state) {
	    return state.account;
	  },
	  redirectAction: _reactRouterRedux.routerActions.replace,
	  wrapperDisplayName: 'UserIsNotAuthenticated',
	  predicate: function predicate(account) {
	    return account.authenticated === false;
	  },
	  failureRedirectPath: function failureRedirectPath(state, ownProps) {
	    return ownProps.location.query.redirect || '/';
	  },
	  allowRedirectBack: false
	});

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(826);
	
	__webpack_require__(1186);
	
	__webpack_require__(646);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(655);
	module.exports = __webpack_require__(58).RegExp.escape;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(15)
	  , isArray  = __webpack_require__(183)
	  , SPECIES  = __webpack_require__(17)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(647);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(7)
	  , toPrimitive = __webpack_require__(52)
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(81)
	  , gOPS    = __webpack_require__(138)
	  , pIE     = __webpack_require__(110);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(81)
	  , toIObject = __webpack_require__(38);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(653)
	  , invoke    = __webpack_require__(134)
	  , aFunction = __webpack_require__(34);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(10);

/***/ },
/* 654 */
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(3)
	  , $re     = __webpack_require__(654)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(288)});
	
	__webpack_require__(93)('copyWithin');

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $every  = __webpack_require__(50)(4);
	
	$export($export.P + $export.F * !__webpack_require__(46)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', {fill: __webpack_require__(175)});
	
	__webpack_require__(93)('fill');

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $filter = __webpack_require__(50)(2);
	
	$export($export.P + $export.F * !__webpack_require__(46)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(3)
	  , $find   = __webpack_require__(50)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(93)(KEY);

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(3)
	  , $find   = __webpack_require__(50)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(93)(KEY);

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(3)
	  , $forEach = __webpack_require__(50)(0)
	  , STRICT   = __webpack_require__(46)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(59)
	  , $export        = __webpack_require__(3)
	  , toObject       = __webpack_require__(27)
	  , call           = __webpack_require__(297)
	  , isArrayIter    = __webpack_require__(182)
	  , toLength       = __webpack_require__(24)
	  , createProperty = __webpack_require__(176)
	  , getIterFn      = __webpack_require__(199);
	
	$export($export.S + $export.F * !__webpack_require__(136)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(3)
	  , $indexOf      = __webpack_require__(130)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(46)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(183)});

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(3)
	  , toIObject = __webpack_require__(38)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(109) != Object || !__webpack_require__(46)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(3)
	  , toIObject     = __webpack_require__(38)
	  , toInteger     = __webpack_require__(68)
	  , toLength      = __webpack_require__(24)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(46)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $map    = __webpack_require__(50)(1);
	
	$export($export.P + $export.F * !__webpack_require__(46)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(3)
	  , createProperty = __webpack_require__(176);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(13)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $reduce = __webpack_require__(290);
	
	$export($export.P + $export.F * !__webpack_require__(46)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $reduce = __webpack_require__(290);
	
	$export($export.P + $export.F * !__webpack_require__(46)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(3)
	  , html       = __webpack_require__(180)
	  , cof        = __webpack_require__(44)
	  , toIndex    = __webpack_require__(84)
	  , toLength   = __webpack_require__(24)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(13)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $some   = __webpack_require__(50)(3);
	
	$export($export.P + $export.F * !__webpack_require__(46)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(3)
	  , aFunction = __webpack_require__(34)
	  , toObject  = __webpack_require__(27)
	  , fails     = __webpack_require__(13)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(46)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Array');

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(3)
	  , fails   = __webpack_require__(13)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(3)
	  , toObject    = __webpack_require__(27)
	  , toPrimitive = __webpack_require__(52);
	
	$export($export.P + $export.F * __webpack_require__(13)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(17)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(35)(proto, TO_PRIMITIVE, __webpack_require__(649));

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(36)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Function', {bind: __webpack_require__(291)});

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(15)
	  , getPrototypeOf = __webpack_require__(42)
	  , HAS_INSTANCE   = __webpack_require__(17)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(22).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(22).f
	  , createDesc = __webpack_require__(67)
	  , has        = __webpack_require__(32)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(21) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(3)
	  , log1p   = __webpack_require__(299)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(3)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(3)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(3)
	  , sign    = __webpack_require__(187);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(3)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(3)
	  , $expm1  = __webpack_require__(186);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(3)
	  , sign      = __webpack_require__(187)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(3)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(3)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(13)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(299)});

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {sign: __webpack_require__(187)});

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(3)
	  , expm1   = __webpack_require__(186)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(13)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(3)
	  , expm1   = __webpack_require__(186)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(10)
	  , has               = __webpack_require__(32)
	  , cof               = __webpack_require__(44)
	  , inheritIfRequired = __webpack_require__(181)
	  , toPrimitive       = __webpack_require__(52)
	  , fails             = __webpack_require__(13)
	  , gOPN              = __webpack_require__(80).f
	  , gOPD              = __webpack_require__(41).f
	  , dP                = __webpack_require__(22).f
	  , $trim             = __webpack_require__(97).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(79)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(21) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(36)(global, NUMBER, $Number);
	}

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(3)
	  , _isFinite = __webpack_require__(10).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(296)});

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(3)
	  , isInteger = __webpack_require__(296)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(3)
	  , $parseFloat = __webpack_require__(306);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(3)
	  , $parseInt = __webpack_require__(307);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(3)
	  , toInteger    = __webpack_require__(68)
	  , aNumberValue = __webpack_require__(287)
	  , repeat       = __webpack_require__(194)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(13)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(3)
	  , $fails       = __webpack_require__(13)
	  , aNumberValue = __webpack_require__(287)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(3);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(300)});

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(79)});

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(21), 'Object', {defineProperties: __webpack_require__(301)});

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(21), 'Object', {defineProperty: __webpack_require__(22).f});

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(15)
	  , meta     = __webpack_require__(66).onFreeze;
	
	__webpack_require__(51)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(38)
	  , $getOwnPropertyDescriptor = __webpack_require__(41).f;
	
	__webpack_require__(51)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(51)('getOwnPropertyNames', function(){
	  return __webpack_require__(302).f;
	});

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(27)
	  , $getPrototypeOf = __webpack_require__(42);
	
	__webpack_require__(51)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(15);
	
	__webpack_require__(51)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(15);
	
	__webpack_require__(51)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(15);
	
	__webpack_require__(51)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', {is: __webpack_require__(308)});

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(27)
	  , $keys    = __webpack_require__(81);
	
	__webpack_require__(51)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(15)
	  , meta     = __webpack_require__(66).onFreeze;
	
	__webpack_require__(51)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(15)
	  , meta     = __webpack_require__(66).onFreeze;
	
	__webpack_require__(51)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(189).set});

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(108)
	  , test    = {};
	test[__webpack_require__(17)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(36)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(3)
	  , $parseFloat = __webpack_require__(306);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(3)
	  , $parseInt = __webpack_require__(307);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(78)
	  , global             = __webpack_require__(10)
	  , ctx                = __webpack_require__(59)
	  , classof            = __webpack_require__(108)
	  , $export            = __webpack_require__(3)
	  , isObject           = __webpack_require__(15)
	  , aFunction          = __webpack_require__(34)
	  , anInstance         = __webpack_require__(77)
	  , forOf              = __webpack_require__(94)
	  , speciesConstructor = __webpack_require__(191)
	  , task               = __webpack_require__(196).set
	  , microtask          = __webpack_require__(188)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(17)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(82)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(96)($Promise, PROMISE);
	__webpack_require__(83)(PROMISE);
	Wrapper = __webpack_require__(58)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(136)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(3)
	  , aFunction = __webpack_require__(34)
	  , anObject  = __webpack_require__(7)
	  , rApply    = (__webpack_require__(10).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(13)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(3)
	  , create     = __webpack_require__(79)
	  , aFunction  = __webpack_require__(34)
	  , anObject   = __webpack_require__(7)
	  , isObject   = __webpack_require__(15)
	  , fails      = __webpack_require__(13)
	  , bind       = __webpack_require__(291)
	  , rConstruct = (__webpack_require__(10).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(22)
	  , $export     = __webpack_require__(3)
	  , anObject    = __webpack_require__(7)
	  , toPrimitive = __webpack_require__(52);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(13)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(3)
	  , gOPD     = __webpack_require__(41).f
	  , anObject = __webpack_require__(7);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(3)
	  , anObject = __webpack_require__(7);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(184)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(41)
	  , $export  = __webpack_require__(3)
	  , anObject = __webpack_require__(7);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(3)
	  , getProto = __webpack_require__(42)
	  , anObject = __webpack_require__(7);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(41)
	  , getPrototypeOf = __webpack_require__(42)
	  , has            = __webpack_require__(32)
	  , $export        = __webpack_require__(3)
	  , isObject       = __webpack_require__(15)
	  , anObject       = __webpack_require__(7);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(3)
	  , anObject      = __webpack_require__(7)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(305)});

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(3)
	  , anObject           = __webpack_require__(7)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(3)
	  , setProto = __webpack_require__(189);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(22)
	  , gOPD           = __webpack_require__(41)
	  , getPrototypeOf = __webpack_require__(42)
	  , has            = __webpack_require__(32)
	  , $export        = __webpack_require__(3)
	  , createDesc     = __webpack_require__(67)
	  , anObject       = __webpack_require__(7)
	  , isObject       = __webpack_require__(15);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(10)
	  , inheritIfRequired = __webpack_require__(181)
	  , dP                = __webpack_require__(22).f
	  , gOPN              = __webpack_require__(80).f
	  , isRegExp          = __webpack_require__(135)
	  , $flags            = __webpack_require__(133)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(21) && (!CORRECT_NEW || __webpack_require__(13)(function(){
	  re2[__webpack_require__(17)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(36)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(83)('RegExp');

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(132)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(132)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(132)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(132)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(135)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(312);
	var anObject    = __webpack_require__(7)
	  , $flags      = __webpack_require__(133)
	  , DESCRIPTORS = __webpack_require__(21)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(36)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(13)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(37)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(37)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(37)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(37)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $at     = __webpack_require__(192)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(3)
	  , toLength  = __webpack_require__(24)
	  , context   = __webpack_require__(193)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(179)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(37)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(37)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(37)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(3)
	  , toIndex        = __webpack_require__(84)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(3)
	  , context  = __webpack_require__(193)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(179)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(37)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(192)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(185)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(37)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(3)
	  , toIObject = __webpack_require__(38)
	  , toLength  = __webpack_require__(24);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(194)
	});

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(37)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(3)
	  , toLength    = __webpack_require__(24)
	  , context     = __webpack_require__(193)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(179)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(37)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(37)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(37)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(97)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(10)
	  , has            = __webpack_require__(32)
	  , DESCRIPTORS    = __webpack_require__(21)
	  , $export        = __webpack_require__(3)
	  , redefine       = __webpack_require__(36)
	  , META           = __webpack_require__(66).KEY
	  , $fails         = __webpack_require__(13)
	  , shared         = __webpack_require__(139)
	  , setToStringTag = __webpack_require__(96)
	  , uid            = __webpack_require__(85)
	  , wks            = __webpack_require__(17)
	  , wksExt         = __webpack_require__(310)
	  , wksDefine      = __webpack_require__(198)
	  , keyOf          = __webpack_require__(651)
	  , enumKeys       = __webpack_require__(650)
	  , isArray        = __webpack_require__(183)
	  , anObject       = __webpack_require__(7)
	  , toIObject      = __webpack_require__(38)
	  , toPrimitive    = __webpack_require__(52)
	  , createDesc     = __webpack_require__(67)
	  , _create        = __webpack_require__(79)
	  , gOPNExt        = __webpack_require__(302)
	  , $GOPD          = __webpack_require__(41)
	  , $DP            = __webpack_require__(22)
	  , $keys          = __webpack_require__(81)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(80).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(110).f  = $propertyIsEnumerable;
	  __webpack_require__(138).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(78)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(35)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(3)
	  , $typed       = __webpack_require__(140)
	  , buffer       = __webpack_require__(197)
	  , anObject     = __webpack_require__(7)
	  , toIndex      = __webpack_require__(84)
	  , toLength     = __webpack_require__(24)
	  , isObject     = __webpack_require__(15)
	  , ArrayBuffer  = __webpack_require__(10).ArrayBuffer
	  , speciesConstructor = __webpack_require__(191)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(13)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(83)(ARRAY_BUFFER);

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	$export($export.G + $export.W + $export.F * !__webpack_require__(140).ABV, {
	  DataView: __webpack_require__(197).DataView
	});

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(294);
	
	// 23.4 WeakSet Objects
	__webpack_require__(131)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(3)
	  , $includes = __webpack_require__(130)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(93)('includes');

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(3)
	  , microtask = __webpack_require__(188)()
	  , process   = __webpack_require__(10).process
	  , isNode    = __webpack_require__(44)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(3)
	  , cof     = __webpack_require__(44);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(293)('Map')});

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(3)
	  , toObject        = __webpack_require__(27)
	  , aFunction       = __webpack_require__(34)
	  , $defineProperty = __webpack_require__(22);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(21) && $export($export.P + __webpack_require__(137), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(3)
	  , toObject        = __webpack_require__(27)
	  , aFunction       = __webpack_require__(34)
	  , $defineProperty = __webpack_require__(22);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(21) && $export($export.P + __webpack_require__(137), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(3)
	  , $entries = __webpack_require__(304)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(3)
	  , ownKeys        = __webpack_require__(305)
	  , toIObject      = __webpack_require__(38)
	  , gOPD           = __webpack_require__(41)
	  , createProperty = __webpack_require__(176);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(3)
	  , toObject                 = __webpack_require__(27)
	  , toPrimitive              = __webpack_require__(52)
	  , getPrototypeOf           = __webpack_require__(42)
	  , getOwnPropertyDescriptor = __webpack_require__(41).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(21) && $export($export.P + __webpack_require__(137), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(3)
	  , toObject                 = __webpack_require__(27)
	  , toPrimitive              = __webpack_require__(52)
	  , getPrototypeOf           = __webpack_require__(42)
	  , getOwnPropertyDescriptor = __webpack_require__(41).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(21) && $export($export.P + __webpack_require__(137), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(3)
	  , $values = __webpack_require__(304)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(3)
	  , global      = __webpack_require__(10)
	  , core        = __webpack_require__(58)
	  , microtask   = __webpack_require__(188)()
	  , OBSERVABLE  = __webpack_require__(17)('observable')
	  , aFunction   = __webpack_require__(34)
	  , anObject    = __webpack_require__(7)
	  , anInstance  = __webpack_require__(77)
	  , redefineAll = __webpack_require__(82)
	  , hide        = __webpack_require__(35)
	  , forOf       = __webpack_require__(94)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(83)('Observable');

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(60)
	  , anObject                  = __webpack_require__(7)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(60)
	  , anObject               = __webpack_require__(7)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(313)
	  , from                    = __webpack_require__(289)
	  , metadata                = __webpack_require__(60)
	  , anObject                = __webpack_require__(7)
	  , getPrototypeOf          = __webpack_require__(42)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(60)
	  , anObject               = __webpack_require__(7)
	  , getPrototypeOf         = __webpack_require__(42)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(60)
	  , anObject                = __webpack_require__(7)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(60)
	  , anObject               = __webpack_require__(7)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(60)
	  , anObject               = __webpack_require__(7)
	  , getPrototypeOf         = __webpack_require__(42)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(60)
	  , anObject               = __webpack_require__(7)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(60)
	  , anObject                  = __webpack_require__(7)
	  , aFunction                 = __webpack_require__(34)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(293)('Set')});

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(3)
	  , $at     = __webpack_require__(192)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(3)
	  , defined     = __webpack_require__(45)
	  , toLength    = __webpack_require__(24)
	  , isRegExp    = __webpack_require__(135)
	  , getFlags    = __webpack_require__(133)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(184)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3)
	  , $pad    = __webpack_require__(309);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3)
	  , $pad    = __webpack_require__(309);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(97)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(97)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(198)('asyncIterator');

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(198)('observable');

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(3);
	
	$export($export.S, 'System', {global: __webpack_require__(10)});

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(200)
	  , redefine      = __webpack_require__(36)
	  , global        = __webpack_require__(10)
	  , hide          = __webpack_require__(35)
	  , Iterators     = __webpack_require__(95)
	  , wks           = __webpack_require__(17)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	  , $task   = __webpack_require__(196);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(10)
	  , $export    = __webpack_require__(3)
	  , invoke     = __webpack_require__(134)
	  , partial    = __webpack_require__(652)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(775);
	__webpack_require__(714);
	__webpack_require__(716);
	__webpack_require__(715);
	__webpack_require__(718);
	__webpack_require__(720);
	__webpack_require__(725);
	__webpack_require__(719);
	__webpack_require__(717);
	__webpack_require__(727);
	__webpack_require__(726);
	__webpack_require__(722);
	__webpack_require__(723);
	__webpack_require__(721);
	__webpack_require__(713);
	__webpack_require__(724);
	__webpack_require__(728);
	__webpack_require__(729);
	__webpack_require__(681);
	__webpack_require__(683);
	__webpack_require__(682);
	__webpack_require__(731);
	__webpack_require__(730);
	__webpack_require__(701);
	__webpack_require__(711);
	__webpack_require__(712);
	__webpack_require__(702);
	__webpack_require__(703);
	__webpack_require__(704);
	__webpack_require__(705);
	__webpack_require__(706);
	__webpack_require__(707);
	__webpack_require__(708);
	__webpack_require__(709);
	__webpack_require__(710);
	__webpack_require__(684);
	__webpack_require__(685);
	__webpack_require__(686);
	__webpack_require__(687);
	__webpack_require__(688);
	__webpack_require__(689);
	__webpack_require__(690);
	__webpack_require__(691);
	__webpack_require__(692);
	__webpack_require__(693);
	__webpack_require__(694);
	__webpack_require__(695);
	__webpack_require__(696);
	__webpack_require__(697);
	__webpack_require__(698);
	__webpack_require__(699);
	__webpack_require__(700);
	__webpack_require__(762);
	__webpack_require__(767);
	__webpack_require__(774);
	__webpack_require__(765);
	__webpack_require__(757);
	__webpack_require__(758);
	__webpack_require__(763);
	__webpack_require__(768);
	__webpack_require__(770);
	__webpack_require__(753);
	__webpack_require__(754);
	__webpack_require__(755);
	__webpack_require__(756);
	__webpack_require__(759);
	__webpack_require__(760);
	__webpack_require__(761);
	__webpack_require__(764);
	__webpack_require__(766);
	__webpack_require__(769);
	__webpack_require__(771);
	__webpack_require__(772);
	__webpack_require__(773);
	__webpack_require__(676);
	__webpack_require__(678);
	__webpack_require__(677);
	__webpack_require__(680);
	__webpack_require__(679);
	__webpack_require__(665);
	__webpack_require__(663);
	__webpack_require__(669);
	__webpack_require__(666);
	__webpack_require__(672);
	__webpack_require__(674);
	__webpack_require__(662);
	__webpack_require__(668);
	__webpack_require__(659);
	__webpack_require__(673);
	__webpack_require__(657);
	__webpack_require__(671);
	__webpack_require__(670);
	__webpack_require__(664);
	__webpack_require__(667);
	__webpack_require__(656);
	__webpack_require__(658);
	__webpack_require__(661);
	__webpack_require__(660);
	__webpack_require__(675);
	__webpack_require__(200);
	__webpack_require__(747);
	__webpack_require__(752);
	__webpack_require__(312);
	__webpack_require__(748);
	__webpack_require__(749);
	__webpack_require__(750);
	__webpack_require__(751);
	__webpack_require__(732);
	__webpack_require__(311);
	__webpack_require__(313);
	__webpack_require__(314);
	__webpack_require__(787);
	__webpack_require__(776);
	__webpack_require__(777);
	__webpack_require__(782);
	__webpack_require__(785);
	__webpack_require__(786);
	__webpack_require__(780);
	__webpack_require__(783);
	__webpack_require__(781);
	__webpack_require__(784);
	__webpack_require__(778);
	__webpack_require__(779);
	__webpack_require__(733);
	__webpack_require__(734);
	__webpack_require__(735);
	__webpack_require__(736);
	__webpack_require__(737);
	__webpack_require__(740);
	__webpack_require__(738);
	__webpack_require__(739);
	__webpack_require__(741);
	__webpack_require__(742);
	__webpack_require__(743);
	__webpack_require__(744);
	__webpack_require__(746);
	__webpack_require__(745);
	__webpack_require__(788);
	__webpack_require__(814);
	__webpack_require__(817);
	__webpack_require__(816);
	__webpack_require__(818);
	__webpack_require__(819);
	__webpack_require__(815);
	__webpack_require__(820);
	__webpack_require__(821);
	__webpack_require__(799);
	__webpack_require__(802);
	__webpack_require__(798);
	__webpack_require__(796);
	__webpack_require__(797);
	__webpack_require__(800);
	__webpack_require__(801);
	__webpack_require__(791);
	__webpack_require__(813);
	__webpack_require__(822);
	__webpack_require__(790);
	__webpack_require__(792);
	__webpack_require__(794);
	__webpack_require__(793);
	__webpack_require__(795);
	__webpack_require__(804);
	__webpack_require__(805);
	__webpack_require__(807);
	__webpack_require__(806);
	__webpack_require__(809);
	__webpack_require__(808);
	__webpack_require__(810);
	__webpack_require__(811);
	__webpack_require__(812);
	__webpack_require__(789);
	__webpack_require__(803);
	__webpack_require__(825);
	__webpack_require__(824);
	__webpack_require__(823);
	module.exports = __webpack_require__(58);

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(829);
	var isArguments = __webpack_require__(828);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 828 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 829 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 830 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _extendableBuiltin(cls) {
	  function ExtendableBuiltin() {
	    cls.apply(this, arguments);
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	var ExtendableError = function (_extendableBuiltin2) {
	  _inherits(ExtendableError, _extendableBuiltin2);
	
	  function ExtendableError() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    _classCallCheck(this, ExtendableError);
	
	    // extending Error is weird and does not propagate `message`
	    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));
	
	    Object.defineProperty(_this, 'message', {
	      configurable: true,
	      enumerable: false,
	      value: message,
	      writable: true
	    });
	
	    Object.defineProperty(_this, 'name', {
	      configurable: true,
	      enumerable: false,
	      value: _this.constructor.name,
	      writable: true
	    });
	
	    if (Error.hasOwnProperty('captureStackTrace')) {
	      Error.captureStackTrace(_this, _this.constructor);
	      return _possibleConstructorReturn(_this);
	    }
	
	    Object.defineProperty(_this, 'stack', {
	      configurable: true,
	      enumerable: false,
	      value: new Error(message).stack,
	      writable: true
	    });
	    return _this;
	  }
	
	  return ExtendableError;
	}(_extendableBuiltin(Error));
	
	exports.default = ExtendableError;
	module.exports = exports['default'];


/***/ },
/* 831 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(6);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	/* Slow implementation for browsers that don't natively support .matches() */
	function matchesSelector_SLOW(element, selector) {
	  var root = element;
	  while (root.parentNode) {
	    root = root.parentNode;
	  }
	
	  var all = root.querySelectorAll(selector);
	  return Array.prototype.indexOf.call(all, element) !== -1;
	}
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function addClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function removeClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
	        .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function conditionClass(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to check the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function hasClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : void 0;
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  },
	
	  /**
	   * Tests whether the element matches the selector specified
	   *
	   * @param {DOMNode|DOMWindow} element the element that we are querying
	   * @param {string} selector the CSS selector
	   * @return {boolean} true if the element matches the selector, false if not
	   */
	  matchesSelector: function matchesSelector(element, selector) {
	    var matchesImpl = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.msMatchesSelector || function (s) {
	      return matchesSelector_SLOW(element, s);
	    };
	    return matchesImpl.call(element, selector);
	  }
	
	};
	
	module.exports = CSSCore;

/***/ },
/* 833 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(833);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(843);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var createArrayFromMixed = __webpack_require__(836);
	var getMarkupWrap = __webpack_require__(838);
	var invariant = __webpack_require__(6);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 839 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 840 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(840);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 842 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(842);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 844 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "favicon.ico";

/***/ },
/* 846 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(98);
	
	var _PathUtils = __webpack_require__(86);
	
	var _ExecutionEnvironment = __webpack_require__(143);
	
	var _DOMUtils = __webpack_require__(202);
	
	var _DOMStateStorage = __webpack_require__(318);
	
	var _createDOMHistory = __webpack_require__(319);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(98);
	
	var _PathUtils = __webpack_require__(86);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(86);
	
	var _Actions = __webpack_require__(98);
	
	var _createHistory = __webpack_require__(321);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
	global.IntlPolyfill = __webpack_require__(851);
	
	// Require all locale data for `Intl`. This module will be
	// ignored when bundling for the browser with Browserify/Webpack.
	__webpack_require__(1195);
	
	// hack to export the polyfill as global Intl if needed
	if (!global.Intl) {
	    global.Intl = global.IntlPolyfill;
	    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
	}
	
	// providing an idiomatic api for the nodejs version of this module
	module.exports = global.IntlPolyfill;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 851 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	var jsx = function () {
	  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
	  return function createRawReactElement(type, props, key, children) {
	    var defaultProps = type && type.defaultProps;
	    var childrenLength = arguments.length - 3;
	
	    if (!props && childrenLength !== 0) {
	      props = {};
	    }
	
	    if (props && defaultProps) {
	      for (var propName in defaultProps) {
	        if (props[propName] === void 0) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    } else if (!props) {
	      props = defaultProps || {};
	    }
	
	    if (childrenLength === 1) {
	      props.children = children;
	    } else if (childrenLength > 1) {
	      var childArray = Array(childrenLength);
	
	      for (var i = 0; i < childrenLength; i++) {
	        childArray[i] = arguments[i + 3];
	      }
	
	      props.children = childArray;
	    }
	
	    return {
	      $$typeof: REACT_ELEMENT_TYPE,
	      type: type,
	      key: key === undefined ? null : '' + key,
	      ref: null,
	      props: props,
	      _owner: null
	    };
	  };
	}();
	
	var asyncToGenerator = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            return step("next", value);
	          }, function (err) {
	            return step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var defineEnumerableProperties = function (obj, descs) {
	  for (var key in descs) {
	    var desc = descs[key];
	    desc.configurable = desc.enumerable = true;
	    if ("value" in desc) desc.writable = true;
	    Object.defineProperty(obj, key, desc);
	  }
	
	  return obj;
	};
	
	var defaults = function (obj, defaults) {
	  var keys = Object.getOwnPropertyNames(defaults);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var value = Object.getOwnPropertyDescriptor(defaults, key);
	
	    if (value && value.configurable && obj[key] === undefined) {
	      Object.defineProperty(obj, key, value);
	    }
	  }
	
	  return obj;
	};
	
	var defineProperty$1 = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var get = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var _instanceof = function (left, right) {
	  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
	    return right[Symbol.hasInstance](left);
	  } else {
	    return left instanceof right;
	  }
	};
	
	var interopRequireDefault = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};
	
	var interopRequireWildcard = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }
	
	    newObj.default = obj;
	    return newObj;
	  }
	};
	
	var newArrowCheck = function (innerThis, boundThis) {
	  if (innerThis !== boundThis) {
	    throw new TypeError("Cannot instantiate an arrow function");
	  }
	};
	
	var objectDestructuringEmpty = function (obj) {
	  if (obj == null) throw new TypeError("Cannot destructure undefined");
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var selfGlobal = typeof global === "undefined" ? self : global;
	
	var set = function set(object, property, value, receiver) {
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent !== null) {
	      set(parent, property, value, receiver);
	    }
	  } else if ("value" in desc && desc.writable) {
	    desc.value = value;
	  } else {
	    var setter = desc.set;
	
	    if (setter !== undefined) {
	      setter.call(receiver, value);
	    }
	  }
	
	  return value;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var slicedToArrayLoose = function (arr, i) {
	  if (Array.isArray(arr)) {
	    return arr;
	  } else if (Symbol.iterator in Object(arr)) {
	    var _arr = [];
	
	    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
	      _arr.push(_step.value);
	
	      if (i && _arr.length === i) break;
	    }
	
	    return _arr;
	  } else {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	  }
	};
	
	var taggedTemplateLiteral = function (strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, {
	    raw: {
	      value: Object.freeze(raw)
	    }
	  }));
	};
	
	var taggedTemplateLiteralLoose = function (strings, raw) {
	  strings.raw = raw;
	  return strings;
	};
	
	var temporalRef = function (val, name, undef) {
	  if (val === undef) {
	    throw new ReferenceError(name + " is not defined - temporal dead zone");
	  } else {
	    return val;
	  }
	};
	
	var temporalUndefined = {};
	
	var toArray = function (arr) {
	  return Array.isArray(arr) ? arr : Array.from(arr);
	};
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	
	
	var babelHelpers$1 = Object.freeze({
	  jsx: jsx,
	  asyncToGenerator: asyncToGenerator,
	  classCallCheck: classCallCheck,
	  createClass: createClass,
	  defineEnumerableProperties: defineEnumerableProperties,
	  defaults: defaults,
	  defineProperty: defineProperty$1,
	  get: get,
	  inherits: inherits,
	  interopRequireDefault: interopRequireDefault,
	  interopRequireWildcard: interopRequireWildcard,
	  newArrowCheck: newArrowCheck,
	  objectDestructuringEmpty: objectDestructuringEmpty,
	  objectWithoutProperties: objectWithoutProperties,
	  possibleConstructorReturn: possibleConstructorReturn,
	  selfGlobal: selfGlobal,
	  set: set,
	  slicedToArray: slicedToArray,
	  slicedToArrayLoose: slicedToArrayLoose,
	  taggedTemplateLiteral: taggedTemplateLiteral,
	  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
	  temporalRef: temporalRef,
	  temporalUndefined: temporalUndefined,
	  toArray: toArray,
	  toConsumableArray: toConsumableArray,
	  typeof: _typeof,
	  extends: _extends,
	  instanceof: _instanceof
	});
	
	var realDefineProp = function () {
	    var sentinel = function sentinel() {};
	    try {
	        Object.defineProperty(sentinel, 'a', {
	            get: function get() {
	                return 1;
	            }
	        });
	        Object.defineProperty(sentinel, 'prototype', { writable: false });
	        return sentinel.a === 1 && sentinel.prototype instanceof Object;
	    } catch (e) {
	        return false;
	    }
	}();
	
	// Need a workaround for getters in ES3
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	// We use this a lot (and need it for proto-less objects)
	var hop = Object.prototype.hasOwnProperty;
	
	// Naive defineProperty for compatibility
	var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
	    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
	};
	
	// Array.prototype.indexOf, as good as we need it to be
	var arrIndexOf = Array.prototype.indexOf || function (search) {
	    /*jshint validthis:true */
	    var t = this;
	    if (!t.length) return -1;
	
	    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
	        if (t[i] === search) return i;
	    }
	
	    return -1;
	};
	
	// Create an object with the specified prototype (2nd arg required for Record)
	var objCreate = Object.create || function (proto, props) {
	    var obj = void 0;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (var k in props) {
	        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
	    }
	
	    return obj;
	};
	
	// Snapshot some (hopefully still) native built-ins
	var arrSlice = Array.prototype.slice;
	var arrConcat = Array.prototype.concat;
	var arrPush = Array.prototype.push;
	var arrJoin = Array.prototype.join;
	var arrShift = Array.prototype.shift;
	
	// Naive Function.prototype.bind for compatibility
	var fnBind = Function.prototype.bind || function (thisObj) {
	    var fn = this,
	        args = arrSlice.call(arguments, 1);
	
	    // All our (presently) bound functions have either 1 or 0 arguments. By returning
	    // different function signatures, we can pass some tests in ES3 environments
	    if (fn.length === 1) {
	        return function () {
	            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	        };
	    }
	    return function () {
	        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	    };
	};
	
	// Object housing internal properties for constructors
	var internals = objCreate(null);
	
	// Keep internal properties internal
	var secret = Math.random();
	
	// Helper functions
	// ================
	
	/**
	 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
	 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
	 * causing issue #62.
	 */
	function log10Floor(n) {
	    // ES6 provides the more accurate Math.log10
	    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));
	
	    var x = Math.round(Math.log(n) * Math.LOG10E);
	    return x - (Number('1e' + x) > n);
	}
	
	/**
	 * A map that doesn't contain Object in its prototype chain
	 */
	function Record(obj) {
	    // Copy only own properties over unless this object is already a Record instance
	    for (var k in obj) {
	        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
	    }
	}
	Record.prototype = objCreate(null);
	
	/**
	 * An ordered list
	 */
	function List() {
	    defineProperty(this, 'length', { writable: true, value: 0 });
	
	    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
	}
	List.prototype = objCreate(null);
	
	/**
	 * Constructs a regular expression to restore tainted RegExp properties
	 */
	function createRegExpRestore() {
	    if (internals.disableRegExpRestore) {
	        return function () {/* no-op */};
	    }
	
	    var regExpCache = {
	        lastMatch: RegExp.lastMatch || '',
	        leftContext: RegExp.leftContext,
	        multiline: RegExp.multiline,
	        input: RegExp.input
	    },
	        has = false;
	
	    // Create a snapshot of all the 'captured' properties
	    for (var i = 1; i <= 9; i++) {
	        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
	    }return function () {
	        // Now we've snapshotted some properties, escape the lastMatch string
	        var esc = /[.?*+^$[\]\\(){}|-]/g,
	            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
	            reg = new List();
	
	        // If any of the captured strings were non-empty, iterate over them all
	        if (has) {
	            for (var _i = 1; _i <= 9; _i++) {
	                var m = regExpCache['$' + _i];
	
	                // If it's empty, add an empty capturing group
	                if (!m) lm = '()' + lm;
	
	                // Else find the string in lm and escape & wrap it to capture it
	                else {
	                        m = m.replace(esc, '\\$&');
	                        lm = lm.replace(m, '(' + m + ')');
	                    }
	
	                // Push it to the reg and chop lm to make sure further groups come after
	                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
	                lm = lm.slice(lm.indexOf('(') + 1);
	            }
	        }
	
	        var exprStr = arrJoin.call(reg, '') + lm;
	
	        // Shorten the regex by replacing each part of the expression with a match
	        // for a string of that exact length.  This is safe for the type of
	        // expressions generated above, because the expression matches the whole
	        // match string, so we know each group and each segment between capturing
	        // groups can be matched by its length alone.
	        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
	            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
	        });
	
	        // Create the regular expression that will reconstruct the RegExp properties
	        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');
	
	        // Set the lastIndex of the generated expression to ensure that the match
	        // is found in the correct index.
	        expr.lastIndex = regExpCache.leftContext.length;
	
	        expr.exec(regExpCache.input);
	    };
	}
	
	/**
	 * Mimics ES5's abstract ToObject() function
	 */
	function toObject(arg) {
	    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');
	
	    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
	    return Object(arg);
	}
	
	function toNumber(arg) {
	    if (typeof arg === 'number') return arg;
	    return Number(arg);
	}
	
	function toInteger(arg) {
	    var number = toNumber(arg);
	    if (isNaN(number)) return 0;
	    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
	    if (number < 0) return Math.floor(Math.abs(number)) * -1;
	    return Math.floor(Math.abs(number));
	}
	
	function toLength(arg) {
	    var len = toInteger(arg);
	    if (len <= 0) return 0;
	    if (len === Infinity) return Math.pow(2, 53) - 1;
	    return Math.min(len, Math.pow(2, 53) - 1);
	}
	
	/**
	 * Returns "internal" properties for an object
	 */
	function getInternalProperties(obj) {
	    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);
	
	    return objCreate(null);
	}
	
	/**
	* Defines regular expressions for various operations related to the BCP 47 syntax,
	* as defined at http://tools.ietf.org/html/bcp47#section-2.1
	*/
	
	// extlang       = 3ALPHA              ; selected ISO 639 codes
	//                 *2("-" 3ALPHA)      ; permanently reserved
	var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';
	
	// language      = 2*3ALPHA            ; shortest ISO 639 code
	//                 ["-" extlang]       ; sometimes followed by
	//                                     ; extended language subtags
	//               / 4ALPHA              ; or reserved for future use
	//               / 5*8ALPHA            ; or registered language subtag
	var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';
	
	// script        = 4ALPHA              ; ISO 15924 code
	var script = '[a-z]{4}';
	
	// region        = 2ALPHA              ; ISO 3166-1 code
	//               / 3DIGIT              ; UN M.49 code
	var region = '(?:[a-z]{2}|\\d{3})';
	
	// variant       = 5*8alphanum         ; registered variants
	//               / (DIGIT 3alphanum)
	var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';
	
	//                                     ; Single alphanumerics
	//                                     ; "x" reserved for private use
	// singleton     = DIGIT               ; 0 - 9
	//               / %x41-57             ; A - W
	//               / %x59-5A             ; Y - Z
	//               / %x61-77             ; a - w
	//               / %x79-7A             ; y - z
	var singleton = '[0-9a-wy-z]';
	
	// extension     = singleton 1*("-" (2*8alphanum))
	var extension = singleton + '(?:-[a-z0-9]{2,8})+';
	
	// privateuse    = "x" 1*("-" (1*8alphanum))
	var privateuse = 'x(?:-[a-z0-9]{1,8})+';
	
	// irregular     = "en-GB-oed"         ; irregular tags do not match
	//               / "i-ami"             ; the 'langtag' production and
	//               / "i-bnn"             ; would not otherwise be
	//               / "i-default"         ; considered 'well-formed'
	//               / "i-enochian"        ; These tags are all valid,
	//               / "i-hak"             ; but most are deprecated
	//               / "i-klingon"         ; in favor of more modern
	//               / "i-lux"             ; subtags or subtag
	//               / "i-mingo"           ; combination
	//               / "i-navajo"
	//               / "i-pwn"
	//               / "i-tao"
	//               / "i-tay"
	//               / "i-tsu"
	//               / "sgn-BE-FR"
	//               / "sgn-BE-NL"
	//               / "sgn-CH-DE"
	var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';
	
	// regular       = "art-lojban"        ; these tags match the 'langtag'
	//               / "cel-gaulish"       ; production, but their subtags
	//               / "no-bok"            ; are not extended language
	//               / "no-nyn"            ; or variant subtags: their meaning
	//               / "zh-guoyu"          ; is defined by their registration
	//               / "zh-hakka"          ; and all of these are deprecated
	//               / "zh-min"            ; in favor of a more modern
	//               / "zh-min-nan"        ; subtag or sequence of subtags
	//               / "zh-xiang"
	var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';
	
	// grandfathered = irregular           ; non-redundant tags registered
	//               / regular             ; during the RFC 3066 era
	var grandfathered = '(?:' + irregular + '|' + regular + ')';
	
	// langtag       = language
	//                 ["-" script]
	//                 ["-" region]
	//                 *("-" variant)
	//                 *("-" extension)
	//                 ["-" privateuse]
	var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';
	
	// Language-Tag  = langtag             ; normal language tags
	//               / privateuse          ; private use tag
	//               / grandfathered       ; grandfathered tags
	var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');
	
	// Match duplicate variants in a language tag
	var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');
	
	// Match duplicate singletons in a language tag (except in private use)
	var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');
	
	// Match all extension sequences
	var expExtSequences = RegExp('-' + extension, 'ig');
	
	// Default locale is the first-added locale data for us
	var defaultLocale = void 0;
	function setDefaultLocale(locale) {
	    defaultLocale = locale;
	}
	
	// IANA Subtag Registry redundant tag and subtag maps
	var redundantTags = {
	    tags: {
	        "art-lojban": "jbo",
	        "i-ami": "ami",
	        "i-bnn": "bnn",
	        "i-hak": "hak",
	        "i-klingon": "tlh",
	        "i-lux": "lb",
	        "i-navajo": "nv",
	        "i-pwn": "pwn",
	        "i-tao": "tao",
	        "i-tay": "tay",
	        "i-tsu": "tsu",
	        "no-bok": "nb",
	        "no-nyn": "nn",
	        "sgn-BE-FR": "sfb",
	        "sgn-BE-NL": "vgt",
	        "sgn-CH-DE": "sgg",
	        "zh-guoyu": "cmn",
	        "zh-hakka": "hak",
	        "zh-min-nan": "nan",
	        "zh-xiang": "hsn",
	        "sgn-BR": "bzs",
	        "sgn-CO": "csn",
	        "sgn-DE": "gsg",
	        "sgn-DK": "dsl",
	        "sgn-ES": "ssp",
	        "sgn-FR": "fsl",
	        "sgn-GB": "bfi",
	        "sgn-GR": "gss",
	        "sgn-IE": "isg",
	        "sgn-IT": "ise",
	        "sgn-JP": "jsl",
	        "sgn-MX": "mfs",
	        "sgn-NI": "ncs",
	        "sgn-NL": "dse",
	        "sgn-NO": "nsl",
	        "sgn-PT": "psr",
	        "sgn-SE": "swl",
	        "sgn-US": "ase",
	        "sgn-ZA": "sfs",
	        "zh-cmn": "cmn",
	        "zh-cmn-Hans": "cmn-Hans",
	        "zh-cmn-Hant": "cmn-Hant",
	        "zh-gan": "gan",
	        "zh-wuu": "wuu",
	        "zh-yue": "yue"
	    },
	    subtags: {
	        BU: "MM",
	        DD: "DE",
	        FX: "FR",
	        TP: "TL",
	        YD: "YE",
	        ZR: "CD",
	        heploc: "alalc97",
	        'in': "id",
	        iw: "he",
	        ji: "yi",
	        jw: "jv",
	        mo: "ro",
	        ayx: "nun",
	        bjd: "drl",
	        ccq: "rki",
	        cjr: "mom",
	        cka: "cmr",
	        cmk: "xch",
	        drh: "khk",
	        drw: "prs",
	        gav: "dev",
	        hrr: "jal",
	        ibi: "opa",
	        kgh: "kml",
	        lcq: "ppr",
	        mst: "mry",
	        myt: "mry",
	        sca: "hle",
	        tie: "ras",
	        tkk: "twm",
	        tlw: "weo",
	        tnf: "prs",
	        ybd: "rki",
	        yma: "lrr"
	    },
	    extLang: {
	        aao: ["aao", "ar"],
	        abh: ["abh", "ar"],
	        abv: ["abv", "ar"],
	        acm: ["acm", "ar"],
	        acq: ["acq", "ar"],
	        acw: ["acw", "ar"],
	        acx: ["acx", "ar"],
	        acy: ["acy", "ar"],
	        adf: ["adf", "ar"],
	        ads: ["ads", "sgn"],
	        aeb: ["aeb", "ar"],
	        aec: ["aec", "ar"],
	        aed: ["aed", "sgn"],
	        aen: ["aen", "sgn"],
	        afb: ["afb", "ar"],
	        afg: ["afg", "sgn"],
	        ajp: ["ajp", "ar"],
	        apc: ["apc", "ar"],
	        apd: ["apd", "ar"],
	        arb: ["arb", "ar"],
	        arq: ["arq", "ar"],
	        ars: ["ars", "ar"],
	        ary: ["ary", "ar"],
	        arz: ["arz", "ar"],
	        ase: ["ase", "sgn"],
	        asf: ["asf", "sgn"],
	        asp: ["asp", "sgn"],
	        asq: ["asq", "sgn"],
	        asw: ["asw", "sgn"],
	        auz: ["auz", "ar"],
	        avl: ["avl", "ar"],
	        ayh: ["ayh", "ar"],
	        ayl: ["ayl", "ar"],
	        ayn: ["ayn", "ar"],
	        ayp: ["ayp", "ar"],
	        bbz: ["bbz", "ar"],
	        bfi: ["bfi", "sgn"],
	        bfk: ["bfk", "sgn"],
	        bjn: ["bjn", "ms"],
	        bog: ["bog", "sgn"],
	        bqn: ["bqn", "sgn"],
	        bqy: ["bqy", "sgn"],
	        btj: ["btj", "ms"],
	        bve: ["bve", "ms"],
	        bvl: ["bvl", "sgn"],
	        bvu: ["bvu", "ms"],
	        bzs: ["bzs", "sgn"],
	        cdo: ["cdo", "zh"],
	        cds: ["cds", "sgn"],
	        cjy: ["cjy", "zh"],
	        cmn: ["cmn", "zh"],
	        coa: ["coa", "ms"],
	        cpx: ["cpx", "zh"],
	        csc: ["csc", "sgn"],
	        csd: ["csd", "sgn"],
	        cse: ["cse", "sgn"],
	        csf: ["csf", "sgn"],
	        csg: ["csg", "sgn"],
	        csl: ["csl", "sgn"],
	        csn: ["csn", "sgn"],
	        csq: ["csq", "sgn"],
	        csr: ["csr", "sgn"],
	        czh: ["czh", "zh"],
	        czo: ["czo", "zh"],
	        doq: ["doq", "sgn"],
	        dse: ["dse", "sgn"],
	        dsl: ["dsl", "sgn"],
	        dup: ["dup", "ms"],
	        ecs: ["ecs", "sgn"],
	        esl: ["esl", "sgn"],
	        esn: ["esn", "sgn"],
	        eso: ["eso", "sgn"],
	        eth: ["eth", "sgn"],
	        fcs: ["fcs", "sgn"],
	        fse: ["fse", "sgn"],
	        fsl: ["fsl", "sgn"],
	        fss: ["fss", "sgn"],
	        gan: ["gan", "zh"],
	        gds: ["gds", "sgn"],
	        gom: ["gom", "kok"],
	        gse: ["gse", "sgn"],
	        gsg: ["gsg", "sgn"],
	        gsm: ["gsm", "sgn"],
	        gss: ["gss", "sgn"],
	        gus: ["gus", "sgn"],
	        hab: ["hab", "sgn"],
	        haf: ["haf", "sgn"],
	        hak: ["hak", "zh"],
	        hds: ["hds", "sgn"],
	        hji: ["hji", "ms"],
	        hks: ["hks", "sgn"],
	        hos: ["hos", "sgn"],
	        hps: ["hps", "sgn"],
	        hsh: ["hsh", "sgn"],
	        hsl: ["hsl", "sgn"],
	        hsn: ["hsn", "zh"],
	        icl: ["icl", "sgn"],
	        ils: ["ils", "sgn"],
	        inl: ["inl", "sgn"],
	        ins: ["ins", "sgn"],
	        ise: ["ise", "sgn"],
	        isg: ["isg", "sgn"],
	        isr: ["isr", "sgn"],
	        jak: ["jak", "ms"],
	        jax: ["jax", "ms"],
	        jcs: ["jcs", "sgn"],
	        jhs: ["jhs", "sgn"],
	        jls: ["jls", "sgn"],
	        jos: ["jos", "sgn"],
	        jsl: ["jsl", "sgn"],
	        jus: ["jus", "sgn"],
	        kgi: ["kgi", "sgn"],
	        knn: ["knn", "kok"],
	        kvb: ["kvb", "ms"],
	        kvk: ["kvk", "sgn"],
	        kvr: ["kvr", "ms"],
	        kxd: ["kxd", "ms"],
	        lbs: ["lbs", "sgn"],
	        lce: ["lce", "ms"],
	        lcf: ["lcf", "ms"],
	        liw: ["liw", "ms"],
	        lls: ["lls", "sgn"],
	        lsg: ["lsg", "sgn"],
	        lsl: ["lsl", "sgn"],
	        lso: ["lso", "sgn"],
	        lsp: ["lsp", "sgn"],
	        lst: ["lst", "sgn"],
	        lsy: ["lsy", "sgn"],
	        ltg: ["ltg", "lv"],
	        lvs: ["lvs", "lv"],
	        lzh: ["lzh", "zh"],
	        max: ["max", "ms"],
	        mdl: ["mdl", "sgn"],
	        meo: ["meo", "ms"],
	        mfa: ["mfa", "ms"],
	        mfb: ["mfb", "ms"],
	        mfs: ["mfs", "sgn"],
	        min: ["min", "ms"],
	        mnp: ["mnp", "zh"],
	        mqg: ["mqg", "ms"],
	        mre: ["mre", "sgn"],
	        msd: ["msd", "sgn"],
	        msi: ["msi", "ms"],
	        msr: ["msr", "sgn"],
	        mui: ["mui", "ms"],
	        mzc: ["mzc", "sgn"],
	        mzg: ["mzg", "sgn"],
	        mzy: ["mzy", "sgn"],
	        nan: ["nan", "zh"],
	        nbs: ["nbs", "sgn"],
	        ncs: ["ncs", "sgn"],
	        nsi: ["nsi", "sgn"],
	        nsl: ["nsl", "sgn"],
	        nsp: ["nsp", "sgn"],
	        nsr: ["nsr", "sgn"],
	        nzs: ["nzs", "sgn"],
	        okl: ["okl", "sgn"],
	        orn: ["orn", "ms"],
	        ors: ["ors", "ms"],
	        pel: ["pel", "ms"],
	        pga: ["pga", "ar"],
	        pks: ["pks", "sgn"],
	        prl: ["prl", "sgn"],
	        prz: ["prz", "sgn"],
	        psc: ["psc", "sgn"],
	        psd: ["psd", "sgn"],
	        pse: ["pse", "ms"],
	        psg: ["psg", "sgn"],
	        psl: ["psl", "sgn"],
	        pso: ["pso", "sgn"],
	        psp: ["psp", "sgn"],
	        psr: ["psr", "sgn"],
	        pys: ["pys", "sgn"],
	        rms: ["rms", "sgn"],
	        rsi: ["rsi", "sgn"],
	        rsl: ["rsl", "sgn"],
	        sdl: ["sdl", "sgn"],
	        sfb: ["sfb", "sgn"],
	        sfs: ["sfs", "sgn"],
	        sgg: ["sgg", "sgn"],
	        sgx: ["sgx", "sgn"],
	        shu: ["shu", "ar"],
	        slf: ["slf", "sgn"],
	        sls: ["sls", "sgn"],
	        sqk: ["sqk", "sgn"],
	        sqs: ["sqs", "sgn"],
	        ssh: ["ssh", "ar"],
	        ssp: ["ssp", "sgn"],
	        ssr: ["ssr", "sgn"],
	        svk: ["svk", "sgn"],
	        swc: ["swc", "sw"],
	        swh: ["swh", "sw"],
	        swl: ["swl", "sgn"],
	        syy: ["syy", "sgn"],
	        tmw: ["tmw", "ms"],
	        tse: ["tse", "sgn"],
	        tsm: ["tsm", "sgn"],
	        tsq: ["tsq", "sgn"],
	        tss: ["tss", "sgn"],
	        tsy: ["tsy", "sgn"],
	        tza: ["tza", "sgn"],
	        ugn: ["ugn", "sgn"],
	        ugy: ["ugy", "sgn"],
	        ukl: ["ukl", "sgn"],
	        uks: ["uks", "sgn"],
	        urk: ["urk", "ms"],
	        uzn: ["uzn", "uz"],
	        uzs: ["uzs", "uz"],
	        vgt: ["vgt", "sgn"],
	        vkk: ["vkk", "ms"],
	        vkt: ["vkt", "ms"],
	        vsi: ["vsi", "sgn"],
	        vsl: ["vsl", "sgn"],
	        vsv: ["vsv", "sgn"],
	        wuu: ["wuu", "zh"],
	        xki: ["xki", "sgn"],
	        xml: ["xml", "sgn"],
	        xmm: ["xmm", "ms"],
	        xms: ["xms", "sgn"],
	        yds: ["yds", "sgn"],
	        ysl: ["ysl", "sgn"],
	        yue: ["yue", "zh"],
	        zib: ["zib", "sgn"],
	        zlm: ["zlm", "ms"],
	        zmi: ["zmi", "ms"],
	        zsl: ["zsl", "sgn"],
	        zsm: ["zsm", "ms"]
	    }
	};
	
	/**
	 * Convert only a-z to uppercase as per section 6.1 of the spec
	 */
	function toLatinUpperCase(str) {
	    var i = str.length;
	
	    while (i--) {
	        var ch = str.charAt(i);
	
	        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
	    }
	
	    return str;
	}
	
	/**
	 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
	 * argument (which must be a String value)
	 *
	 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
	 *   2.1, or successor,
	 * - does not include duplicate variant subtags, and
	 * - does not include duplicate singleton subtags.
	 *
	 * The abstract operation returns true if locale can be generated from the ABNF
	 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
	 * contain duplicate variant or singleton subtags (other than as a private use
	 * subtag). It returns false otherwise. Terminal value characters in the grammar are
	 * interpreted as the Unicode equivalents of the ASCII octet values given.
	 */
	function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
	    // represents a well-formed BCP 47 language tag as specified in RFC 5646
	    if (!expBCP47Syntax.test(locale)) return false;
	
	    // does not include duplicate variant subtags, and
	    if (expVariantDupes.test(locale)) return false;
	
	    // does not include duplicate singleton subtags.
	    if (expSingletonDupes.test(locale)) return false;
	
	    return true;
	}
	
	/**
	 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
	 * regularized form of the locale argument (which must be a String value that is
	 * a structurally valid BCP 47 language tag as verified by the
	 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
	 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
	 * into canonical form, and to regularize the case of the subtags, but does not
	 * take the steps to bring a language tag into “extlang form” and to reorder
	 * variant subtags.
	
	 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
	 * may include canonicalization rules for the extension subtag sequences they
	 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
	 * Implementations are allowed, but not required, to apply these additional rules.
	 */
	function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
	    var match = void 0,
	        parts = void 0;
	
	    // A language tag is in 'canonical form' when the tag is well-formed
	    // according to the rules in Sections 2.1 and 2.2
	
	    // Section 2.1 says all subtags use lowercase...
	    locale = locale.toLowerCase();
	
	    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
	    // appear at the start of the tag nor occur after singletons.  Such two-letter
	    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
	    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
	    parts = locale.split('-');
	    for (var i = 1, max = parts.length; i < max; i++) {
	        // Two-letter subtags are all uppercase
	        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();
	
	        // Four-letter subtags are titlecase
	        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
	
	            // Is it a singleton?
	            else if (parts[i].length === 1 && parts[i] !== 'x') break;
	    }
	    locale = arrJoin.call(parts, '-');
	
	    // The steps laid out in RFC 5646 section 4.5 are as follows:
	
	    // 1.  Extension sequences are ordered into case-insensitive ASCII order
	    //     by singleton subtag.
	    if ((match = locale.match(expExtSequences)) && match.length > 1) {
	        // The built-in sort() sorts by ASCII order, so use that
	        match.sort();
	
	        // Replace all extensions with the joined, sorted array
	        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
	    }
	
	    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
	    //     Value', if there is one.
	    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];
	
	    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
	    //     For extlangs, the original primary language subtag is also
	    //     replaced if there is a primary language subtag in the 'Preferred-
	    //     Value'.
	    parts = locale.split('-');
	
	    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
	        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
	            parts[_i] = redundantTags.extLang[parts[_i]][0];
	
	            // For extlang tags, the prefix needs to be removed if it is redundant
	            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
	                parts = arrSlice.call(parts, _i++);
	                _max -= 1;
	            }
	        }
	    }
	
	    return arrJoin.call(parts, '-');
	}
	
	/**
	 * The DefaultLocale abstract operation returns a String value representing the
	 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
	 * host environment’s current locale.
	 */
	function /* 6.2.4 */DefaultLocale() {
	    return defaultLocale;
	}
	
	// Sect 6.3 Currency Codes
	// =======================
	
	var expCurrencyCode = /^[A-Z]{3}$/;
	
	/**
	 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
	 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
	 * code. The following steps are taken:
	 */
	function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
	    // 1. Let `c` be ToString(currency)
	    var c = String(currency);
	
	    // 2. Let `normalized` be the result of mapping c to upper case as described
	    //    in 6.1.
	    var normalized = toLatinUpperCase(c);
	
	    // 3. If the string length of normalized is not 3, return false.
	    // 4. If normalized contains any character that is not in the range "A" to "Z"
	    //    (U+0041 to U+005A), return false.
	    if (expCurrencyCode.test(normalized) === false) return false;
	
	    // 5. Return true
	    return true;
	}
	
	var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below
	
	function /* 9.2.1 */CanonicalizeLocaleList(locales) {
	    // The abstract operation CanonicalizeLocaleList takes the following steps:
	
	    // 1. If locales is undefined, then a. Return a new empty List
	    if (locales === undefined) return new List();
	
	    // 2. Let seen be a new empty List.
	    var seen = new List();
	
	    // 3. If locales is a String value, then
	    //    a. Let locales be a new array created as if by the expression new
	    //    Array(locales) where Array is the standard built-in constructor with
	    //    that name and locales is the value of locales.
	    locales = typeof locales === 'string' ? [locales] : locales;
	
	    // 4. Let O be ToObject(locales).
	    var O = toObject(locales);
	
	    // 5. Let lenValue be the result of calling the [[Get]] internal method of
	    //    O with the argument "length".
	    // 6. Let len be ToUint32(lenValue).
	    var len = toLength(O.length);
	
	    // 7. Let k be 0.
	    var k = 0;
	
	    // 8. Repeat, while k < len
	    while (k < len) {
	        // a. Let Pk be ToString(k).
	        var Pk = String(k);
	
	        // b. Let kPresent be the result of calling the [[HasProperty]] internal
	        //    method of O with argument Pk.
	        var kPresent = Pk in O;
	
	        // c. If kPresent is true, then
	        if (kPresent) {
	            // i. Let kValue be the result of calling the [[Get]] internal
	            //     method of O with argument Pk.
	            var kValue = O[Pk];
	
	            // ii. If the type of kValue is not String or Object, then throw a
	            //     TypeError exception.
	            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');
	
	            // iii. Let tag be ToString(kValue).
	            var tag = String(kValue);
	
	            // iv. If the result of calling the abstract operation
	            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
	            //     the argument, is false, then throw a RangeError exception.
	            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");
	
	            // v. Let tag be the result of calling the abstract operation
	            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
	            //    argument.
	            tag = CanonicalizeLanguageTag(tag);
	
	            // vi. If tag is not an element of seen, then append tag as the last
	            //     element of seen.
	            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
	        }
	
	        // d. Increase k by 1.
	        k++;
	    }
	
	    // 9. Return seen.
	    return seen;
	}
	
	/**
	 * The BestAvailableLocale abstract operation compares the provided argument
	 * locale, which must be a String value with a structurally valid and
	 * canonicalized BCP 47 language tag, against the locales in availableLocales and
	 * returns either the longest non-empty prefix of locale that is an element of
	 * availableLocales, or undefined if there is no such element. It uses the
	 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
	 */
	function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
	    // 1. Let candidate be locale
	    var candidate = locale;
	
	    // 2. Repeat
	    while (candidate) {
	        // a. If availableLocales contains an element equal to candidate, then return
	        // candidate.
	        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;
	
	        // b. Let pos be the character index of the last occurrence of "-"
	        // (U+002D) within candidate. If that character does not occur, return
	        // undefined.
	        var pos = candidate.lastIndexOf('-');
	
	        if (pos < 0) return;
	
	        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
	        //    then decrease pos by 2.
	        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;
	
	        // d. Let candidate be the substring of candidate from position 0, inclusive,
	        //    to position pos, exclusive.
	        candidate = candidate.substring(0, pos);
	    }
	}
	
	/**
	 * The LookupMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The following steps are taken:
	 */
	function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
	    // 1. Let i be 0.
	    var i = 0;
	
	    // 2. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	
	    // 3. Let availableLocale be undefined.
	    var availableLocale = void 0;
	
	    var locale = void 0,
	        noExtensionsLocale = void 0;
	
	    // 4. Repeat while i < len and availableLocale is undefined:
	    while (i < len && !availableLocale) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position i.
	        locale = requestedLocales[i];
	
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. Increase i by 1.
	        i++;
	    }
	
	    // 5. Let result be a new Record.
	    var result = new Record();
	
	    // 6. If availableLocale is not undefined, then
	    if (availableLocale !== undefined) {
	        // a. Set result.[[locale]] to availableLocale.
	        result['[[locale]]'] = availableLocale;
	
	        // b. If locale and noExtensionsLocale are not the same String value, then
	        if (String(locale) !== String(noExtensionsLocale)) {
	            // i. Let extension be the String value consisting of the first
	            //    substring of locale that is a Unicode locale extension sequence.
	            var extension = locale.match(expUnicodeExSeq)[0];
	
	            // ii. Let extensionIndex be the character position of the initial
	            //     "-" of the first Unicode locale extension sequence within locale.
	            var extensionIndex = locale.indexOf('-u-');
	
	            // iii. Set result.[[extension]] to extension.
	            result['[[extension]]'] = extension;
	
	            // iv. Set result.[[extensionIndex]] to extensionIndex.
	            result['[[extensionIndex]]'] = extensionIndex;
	        }
	    }
	    // 7. Else
	    else
	        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
	        //    operation (defined in 6.2.4).
	        result['[[locale]]'] = DefaultLocale();
	
	    // 8. Return result
	    return result;
	}
	
	/**
	 * The BestFitMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The algorithm is implementation dependent, but should produce results
	 * that a typical user of the requested locales would perceive as at least as
	 * good as those produced by the LookupMatcher abstract operation. Options
	 * specified through Unicode locale extension sequences must be ignored by the
	 * algorithm. Information about such subsequences is returned separately.
	 * The abstract operation returns a record with a [[locale]] field, whose value
	 * is the language tag of the selected locale, which must be an element of
	 * availableLocales. If the language tag of the request locale that led to the
	 * selected locale contained a Unicode locale extension sequence, then the
	 * returned record also contains an [[extension]] field whose value is the first
	 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
	 * is the index of the first Unicode locale extension sequence within the request
	 * locale language tag.
	 */
	function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
	    return LookupMatcher(availableLocales, requestedLocales);
	}
	
	/**
	 * The ResolveLocale abstract operation compares a BCP 47 language priority list
	 * requestedLocales against the locales in availableLocales and determines the
	 * best available language to meet the request. availableLocales and
	 * requestedLocales must be provided as List values, options as a Record.
	 */
	function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
	    if (availableLocales.length === 0) {
	        throw new ReferenceError('No locale data has been provided for this object yet.');
	    }
	
	    // The following steps are taken:
	    // 1. Let matcher be the value of options.[[localeMatcher]].
	    var matcher = options['[[localeMatcher]]'];
	
	    var r = void 0;
	
	    // 2. If matcher is "lookup", then
	    if (matcher === 'lookup')
	        // a. Let r be the result of calling the LookupMatcher abstract operation
	        //    (defined in 9.2.3) with arguments availableLocales and
	        //    requestedLocales.
	        r = LookupMatcher(availableLocales, requestedLocales);
	
	        // 3. Else
	    else
	        // a. Let r be the result of calling the BestFitMatcher abstract
	        //    operation (defined in 9.2.4) with arguments availableLocales and
	        //    requestedLocales.
	        r = BestFitMatcher(availableLocales, requestedLocales);
	
	    // 4. Let foundLocale be the value of r.[[locale]].
	    var foundLocale = r['[[locale]]'];
	
	    var extensionSubtags = void 0,
	        extensionSubtagsLength = void 0;
	
	    // 5. If r has an [[extension]] field, then
	    if (hop.call(r, '[[extension]]')) {
	        // a. Let extension be the value of r.[[extension]].
	        var extension = r['[[extension]]'];
	        // b. Let split be the standard built-in function object defined in ES5,
	        //    15.5.4.14.
	        var split = String.prototype.split;
	        // c. Let extensionSubtags be the result of calling the [[Call]] internal
	        //    method of split with extension as the this value and an argument
	        //    list containing the single item "-".
	        extensionSubtags = split.call(extension, '-');
	        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
	        //    internal method of extensionSubtags with argument "length".
	        extensionSubtagsLength = extensionSubtags.length;
	    }
	
	    // 6. Let result be a new Record.
	    var result = new Record();
	
	    // 7. Set result.[[dataLocale]] to foundLocale.
	    result['[[dataLocale]]'] = foundLocale;
	
	    // 8. Let supportedExtension be "-u".
	    var supportedExtension = '-u';
	    // 9. Let i be 0.
	    var i = 0;
	    // 10. Let len be the result of calling the [[Get]] internal method of
	    //     relevantExtensionKeys with argument "length".
	    var len = relevantExtensionKeys.length;
	
	    // 11 Repeat while i < len:
	    while (i < len) {
	        // a. Let key be the result of calling the [[Get]] internal method of
	        //    relevantExtensionKeys with argument ToString(i).
	        var key = relevantExtensionKeys[i];
	        // b. Let foundLocaleData be the result of calling the [[Get]] internal
	        //    method of localeData with the argument foundLocale.
	        var foundLocaleData = localeData[foundLocale];
	        // c. Let keyLocaleData be the result of calling the [[Get]] internal
	        //    method of foundLocaleData with the argument key.
	        var keyLocaleData = foundLocaleData[key];
	        // d. Let value be the result of calling the [[Get]] internal method of
	        //    keyLocaleData with argument "0".
	        var value = keyLocaleData['0'];
	        // e. Let supportedExtensionAddition be "".
	        var supportedExtensionAddition = '';
	        // f. Let indexOf be the standard built-in function object defined in
	        //    ES5, 15.4.4.14.
	        var indexOf = arrIndexOf;
	
	        // g. If extensionSubtags is not undefined, then
	        if (extensionSubtags !== undefined) {
	            // i. Let keyPos be the result of calling the [[Call]] internal
	            //    method of indexOf with extensionSubtags as the this value and
	            // an argument list containing the single item key.
	            var keyPos = indexOf.call(extensionSubtags, key);
	
	            // ii. If keyPos ≠ -1, then
	            if (keyPos !== -1) {
	                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
	                //    result of calling the [[Get]] internal method of
	                //    extensionSubtags with argument ToString(keyPos +1) is greater
	                //    than 2, then
	                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
	                    // a. Let requestedValue be the result of calling the [[Get]]
	                    //    internal method of extensionSubtags with argument
	                    //    ToString(keyPos + 1).
	                    var requestedValue = extensionSubtags[keyPos + 1];
	                    // b. Let valuePos be the result of calling the [[Call]]
	                    //    internal method of indexOf with keyLocaleData as the
	                    //    this value and an argument list containing the single
	                    //    item requestedValue.
	                    var valuePos = indexOf.call(keyLocaleData, requestedValue);
	
	                    // c. If valuePos ≠ -1, then
	                    if (valuePos !== -1) {
	                        // i. Let value be requestedValue.
	                        value = requestedValue,
	                        // ii. Let supportedExtensionAddition be the
	                        //     concatenation of "-", key, "-", and value.
	                        supportedExtensionAddition = '-' + key + '-' + value;
	                    }
	                }
	                // 2. Else
	                else {
	                        // a. Let valuePos be the result of calling the [[Call]]
	                        // internal method of indexOf with keyLocaleData as the this
	                        // value and an argument list containing the single item
	                        // "true".
	                        var _valuePos = indexOf(keyLocaleData, 'true');
	
	                        // b. If valuePos ≠ -1, then
	                        if (_valuePos !== -1)
	                            // i. Let value be "true".
	                            value = 'true';
	                    }
	            }
	        }
	        // h. If options has a field [[<key>]], then
	        if (hop.call(options, '[[' + key + ']]')) {
	            // i. Let optionsValue be the value of options.[[<key>]].
	            var optionsValue = options['[[' + key + ']]'];
	
	            // ii. If the result of calling the [[Call]] internal method of indexOf
	            //     with keyLocaleData as the this value and an argument list
	            //     containing the single item optionsValue is not -1, then
	            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
	                // 1. If optionsValue is not equal to value, then
	                if (optionsValue !== value) {
	                    // a. Let value be optionsValue.
	                    value = optionsValue;
	                    // b. Let supportedExtensionAddition be "".
	                    supportedExtensionAddition = '';
	                }
	            }
	        }
	        // i. Set result.[[<key>]] to value.
	        result['[[' + key + ']]'] = value;
	
	        // j. Append supportedExtensionAddition to supportedExtension.
	        supportedExtension += supportedExtensionAddition;
	
	        // k. Increase i by 1.
	        i++;
	    }
	    // 12. If the length of supportedExtension is greater than 2, then
	    if (supportedExtension.length > 2) {
	        // a.
	        var privateIndex = foundLocale.indexOf("-x-");
	        // b.
	        if (privateIndex === -1) {
	            // i.
	            foundLocale = foundLocale + supportedExtension;
	        }
	        // c.
	        else {
	                // i.
	                var preExtension = foundLocale.substring(0, privateIndex);
	                // ii.
	                var postExtension = foundLocale.substring(privateIndex);
	                // iii.
	                foundLocale = preExtension + supportedExtension + postExtension;
	            }
	        // d. asserting - skipping
	        // e.
	        foundLocale = CanonicalizeLanguageTag(foundLocale);
	    }
	    // 13. Set result.[[locale]] to foundLocale.
	    result['[[locale]]'] = foundLocale;
	
	    // 14. Return result.
	    return result;
	}
	
	/**
	 * The LookupSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
	 * Locales appear in the same order in the returned list as in requestedLocales.
	 * The following steps are taken:
	 */
	function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
	    // 1. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	    // 2. Let subset be a new empty List.
	    var subset = new List();
	    // 3. Let k be 0.
	    var k = 0;
	
	    // 4. Repeat while k < len
	    while (k < len) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position k.
	        var locale = requestedLocales[k];
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. If availableLocale is not undefined, then append locale to the end of
	        //    subset.
	        if (availableLocale !== undefined) arrPush.call(subset, locale);
	
	        // e. Increment k by 1.
	        k++;
	    }
	
	    // 5. Let subsetArray be a new Array object whose elements are the same
	    //    values in the same order as the elements of subset.
	    var subsetArray = arrSlice.call(subset);
	
	    // 6. Return subsetArray.
	    return subsetArray;
	}
	
	/**
	 * The BestFitSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the Best Fit Matcher
	 * algorithm. Locales appear in the same order in the returned list as in
	 * requestedLocales. The steps taken are implementation dependent.
	 */
	function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
	    // ###TODO: implement this function as described by the specification###
	    return LookupSupportedLocales(availableLocales, requestedLocales);
	}
	
	/**
	 * The SupportedLocales abstract operation returns the subset of the provided BCP
	 * 47 language priority list requestedLocales for which availableLocales has a
	 * matching locale. Two algorithms are available to match the locales: the Lookup
	 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
	 * best-fit algorithm. Locales appear in the same order in the returned list as
	 * in requestedLocales. The following steps are taken:
	 */
	function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
	    var matcher = void 0,
	        subset = void 0;
	
	    // 1. If options is not undefined, then
	    if (options !== undefined) {
	        // a. Let options be ToObject(options).
	        options = new Record(toObject(options));
	        // b. Let matcher be the result of calling the [[Get]] internal method of
	        //    options with argument "localeMatcher".
	        matcher = options.localeMatcher;
	
	        // c. If matcher is not undefined, then
	        if (matcher !== undefined) {
	            // i. Let matcher be ToString(matcher).
	            matcher = String(matcher);
	
	            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
	            //     exception.
	            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
	        }
	    }
	    // 2. If matcher is undefined or "best fit", then
	    if (matcher === undefined || matcher === 'best fit')
	        // a. Let subset be the result of calling the BestFitSupportedLocales
	        //    abstract operation (defined in 9.2.7) with arguments
	        //    availableLocales and requestedLocales.
	        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
	        // 3. Else
	    else
	        // a. Let subset be the result of calling the LookupSupportedLocales
	        //    abstract operation (defined in 9.2.6) with arguments
	        //    availableLocales and requestedLocales.
	        subset = LookupSupportedLocales(availableLocales, requestedLocales);
	
	    // 4. For each named own property name P of subset,
	    for (var P in subset) {
	        if (!hop.call(subset, P)) continue;
	
	        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
	        //    method of subset with P.
	        // b. Set desc.[[Writable]] to false.
	        // c. Set desc.[[Configurable]] to false.
	        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
	        //    and true as arguments.
	        defineProperty(subset, P, {
	            writable: false, configurable: false, value: subset[P]
	        });
	    }
	    // "Freeze" the array so no new elements can be added
	    defineProperty(subset, 'length', { writable: false });
	
	    // 5. Return subset
	    return subset;
	}
	
	/**
	 * The GetOption abstract operation extracts the value of the property named
	 * property from the provided options object, converts it to the required type,
	 * checks whether it is one of a List of allowed values, and fills in a fallback
	 * value if necessary.
	 */
	function /*9.2.9 */GetOption(options, property, type, values, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Assert: type is "boolean" or "string".
	        // b. If type is "boolean", then let value be ToBoolean(value).
	        // c. If type is "string", then let value be ToString(value).
	        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;
	
	        // d. If values is not undefined, then
	        if (values !== undefined) {
	            // i. If values does not contain an element equal to value, then throw a
	            //    RangeError exception.
	            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
	        }
	
	        // e. Return value.
	        return value;
	    }
	    // Else return fallback.
	    return fallback;
	}
	
	/**
	 * The GetNumberOption abstract operation extracts a property value from the
	 * provided options object, converts it to a Number value, checks whether it is
	 * in the allowed range, and fills in a fallback value if necessary.
	 */
	function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Let value be ToNumber(value).
	        value = Number(value);
	
	        // b. If value is NaN or less than minimum or greater than maximum, throw a
	        //    RangeError exception.
	        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');
	
	        // c. Return floor(value).
	        return Math.floor(value);
	    }
	    // 3. Else return fallback.
	    return fallback;
	}
	
	// 8 The Intl Object
	var Intl = {};
	
	// 8.2 Function Properties of the Intl Object
	
	// 8.2.1
	// @spec[tc39/ecma402/master/spec/intl.html]
	// @clause[sec-intl.getcanonicallocales]
	function getCanonicalLocales(locales) {
	    // 1. Let ll be ? CanonicalizeLocaleList(locales).
	    var ll = CanonicalizeLocaleList(locales);
	    // 2. Return CreateArrayFromList(ll).
	    {
	        var result = [];
	
	        var len = ll.length;
	        var k = 0;
	
	        while (k < len) {
	            result[k] = ll[k];
	            k++;
	        }
	        return result;
	    }
	}
	
	Object.defineProperty(Intl, 'getCanonicalLocales', {
	    enumerable: false,
	    configurable: true,
	    writable: true,
	    value: getCanonicalLocales
	});
	
	// Currency minor units output from get-4217 grunt task, formatted
	var currencyMinorUnits = {
	    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
	    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
	    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
	};
	
	// Define the NumberFormat constructor internally so it cannot be tainted
	function NumberFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.NumberFormat(locales, options);
	    }
	
	    return InitializeNumberFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'NumberFormat', {
	    configurable: true,
	    writable: true,
	    value: NumberFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(Intl.NumberFormat, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeNumberFormat accepts the arguments
	 * numberFormat (which must be an object), locales, and options. It initializes
	 * numberFormat as a NumberFormat object.
	 */
	function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(numberFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
	    // value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(numberFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. If options is undefined, then
	    if (options === undefined)
	        // a. Let options be the result of creating a new object as if by the
	        // expression new Object() where Object is the standard built-in constructor
	        // with that name.
	        options = {};
	
	        // 5. Else
	    else
	        // a. Let options be ToObject(options).
	        options = toObject(options);
	
	    // 6. Let opt be a new Record.
	    var opt = new Record(),
	
	
	    // 7. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
	    //    a List containing the two String values "lookup" and "best fit", and
	    //    "best fit".
	    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 8. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 9. Let NumberFormat be the standard built-in object that is the initial value
	    //    of Intl.NumberFormat.
	    // 10. Let localeData be the value of the [[localeData]] internal property of
	    //     NumberFormat.
	    var localeData = internals.NumberFormat['[[localeData]]'];
	
	    // 11. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //     internal property of NumberFormat, and localeData.
	    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 12. Set the [[locale]] internal property of numberFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
	    //     of r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let s be the result of calling the GetOption abstract operation with the
	    //     arguments options, "style", "string", a List containing the three String
	    //     values "decimal", "percent", and "currency", and "decimal".
	    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');
	
	    // 16. Set the [[style]] internal property of numberFormat to s.
	    internal['[[style]]'] = s;
	
	    // 17. Let c be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currency", "string", undefined, and undefined.
	    var c = GetOption(options, 'currency', 'string');
	
	    // 18. If c is not undefined and the result of calling the
	    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
	    //     argument c is false, then throw a RangeError exception.
	    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");
	
	    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
	    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');
	
	    var cDigits = void 0;
	
	    // 20. If s is "currency", then
	    if (s === 'currency') {
	        // a. Let c be the result of converting c to upper case as specified in 6.1.
	        c = c.toUpperCase();
	
	        // b. Set the [[currency]] internal property of numberFormat to c.
	        internal['[[currency]]'] = c;
	
	        // c. Let cDigits be the result of calling the CurrencyDigits abstract
	        //    operation (defined below) with argument c.
	        cDigits = CurrencyDigits(c);
	    }
	
	    // 21. Let cd be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currencyDisplay", "string", a List containing the
	    //     three String values "code", "symbol", and "name", and "symbol".
	    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');
	
	    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
	    //     numberFormat to cd.
	    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;
	
	    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
	    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
	    //     and 1.
	    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);
	
	    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
	    internal['[[minimumIntegerDigits]]'] = mnid;
	
	    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
	    //     be 0.
	    var mnfdDefault = s === 'currency' ? cDigits : 0;
	
	    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
	    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);
	
	    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
	    internal['[[minimumFractionDigits]]'] = mnfd;
	
	    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
	    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
	    //     be max(mnfd, 3).
	    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);
	
	    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
	    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);
	
	    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
	    internal['[[maximumFractionDigits]]'] = mxfd;
	
	    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
	    //     with argument "minimumSignificantDigits".
	    var mnsd = options.minimumSignificantDigits;
	
	    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
	    //     with argument "maximumSignificantDigits".
	    var mxsd = options.maximumSignificantDigits;
	
	    // 33. If mnsd is not undefined or mxsd is not undefined, then:
	    if (mnsd !== undefined || mxsd !== undefined) {
	        // a. Let mnsd be the result of calling the GetNumberOption abstract
	        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
	        //    and 1.
	        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);
	
	        // b. Let mxsd be the result of calling the GetNumberOption abstract
	        //     operation with arguments options, "maximumSignificantDigits", mnsd,
	        //     21, and 21.
	        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);
	
	        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
	        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
	        //    numberFormat to mxsd.
	        internal['[[minimumSignificantDigits]]'] = mnsd;
	        internal['[[maximumSignificantDigits]]'] = mxsd;
	    }
	    // 34. Let g be the result of calling the GetOption abstract operation with the
	    //     arguments options, "useGrouping", "boolean", undefined, and true.
	    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);
	
	    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
	    internal['[[useGrouping]]'] = g;
	
	    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 37. Let patterns be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "patterns".
	    var patterns = dataLocaleData.patterns;
	
	    // 38. Assert: patterns is an object (see 11.2.3)
	
	    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
	    //     patterns with argument s.
	    var stylePatterns = patterns[s];
	
	    // 40. Set the [[positivePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "positivePattern".
	    internal['[[positivePattern]]'] = stylePatterns.positivePattern;
	
	    // 41. Set the [[negativePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "negativePattern".
	    internal['[[negativePattern]]'] = stylePatterns.negativePattern;
	
	    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
	    //     true.
	    internal['[[initializedNumberFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return numberFormat;
	}
	
	function CurrencyDigits(currency) {
	    // When the CurrencyDigits abstract operation is called with an argument currency
	    // (which must be an upper case String value), the following steps are taken:
	
	    // 1. If the ISO 4217 currency and funds code list contains currency as an
	    // alphabetic code, then return the minor unit value corresponding to the
	    // currency from the list; else return 2.
	    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
	}
	
	/* 11.2.3 */internals.NumberFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
	 * following steps are taken:
	 */
	/* 11.2.2 */
	defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * NumberFormat object.
	 */
	/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatNumber
	});
	
	function GetFormatNumber() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 11.3_b
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this NumberFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 1, that takes the argument value and
	        //    performs the following steps:
	        var F = function F(value) {
	            // i. If value is not provided, then let value be undefined.
	            // ii. Let x be ToNumber(value).
	            // iii. Return the result of calling the FormatNumber abstract
	            //      operation (defined below) with arguments this and x.
	            return FormatNumber(this, /* x = */Number(value));
	        };
	
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts() {
	    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');
	
	    var x = Number(value);
	    return FormatNumberToParts(this, x);
	}
	
	Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
	    configurable: true,
	    enumerable: false,
	    writable: true,
	    value: formatToParts
	});
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumbertoparts]
	 */
	function FormatNumberToParts(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be ArrayCreate(0).
	    var result = [];
	    // 3. Let n be 0.
	    var n = 0;
	    // 4. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Let O be ObjectCreate(%ObjectPrototype%).
	        var O = {};
	        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
	        O.type = part['[[type]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
	        O.value = part['[[value]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
	        result[n] = O;
	        // a. Increment n by 1.
	        n += 1;
	    }
	    // 5. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-partitionnumberpattern]
	 */
	function PartitionNumberPattern(numberFormat, x) {
	
	    var internal = getInternalProperties(numberFormat),
	        locale = internal['[[dataLocale]]'],
	        nums = internal['[[numberingSystem]]'],
	        data = internals.NumberFormat['[[localeData]]'][locale],
	        ild = data.symbols[nums] || data.symbols.latn,
	        pattern = void 0;
	
	    // 1. If x is not NaN and x < 0, then:
	    if (!isNaN(x) && x < 0) {
	        // a. Let x be -x.
	        x = -x;
	        // a. Let pattern be the value of numberFormat.[[negativePattern]].
	        pattern = internal['[[negativePattern]]'];
	    }
	    // 2. Else,
	    else {
	            // a. Let pattern be the value of numberFormat.[[positivePattern]].
	            pattern = internal['[[positivePattern]]'];
	        }
	    // 3. Let result be a new empty List.
	    var result = new List();
	    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
	    var beginIndex = pattern.indexOf('{', 0);
	    // 5. Let endIndex be 0.
	    var endIndex = 0;
	    // 6. Let nextIndex be 0.
	    var nextIndex = 0;
	    // 7. Let length be the number of code units in pattern.
	    var length = pattern.length;
	    // 8. Repeat while beginIndex is an integer index into pattern:
	    while (beginIndex > -1 && beginIndex < length) {
	        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
	        endIndex = pattern.indexOf('}', beginIndex);
	        // a. If endIndex = -1, throw new Error exception.
	        if (endIndex === -1) throw new Error();
	        // a. If beginIndex is greater than nextIndex, then:
	        if (beginIndex > nextIndex) {
	            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
	            var literal = pattern.substring(nextIndex, beginIndex);
	            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
	        }
	        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // a. If p is equal "number", then:
	        if (p === "number") {
	            // i. If x is NaN,
	            if (isNaN(x)) {
	                // 1. Let n be an ILD String value indicating the NaN value.
	                var n = ild.nan;
	                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
	            }
	            // ii. Else if isFinite(x) is false,
	            else if (!isFinite(x)) {
	                    // 1. Let n be an ILD String value indicating infinity.
	                    var _n = ild.infinity;
	                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
	                }
	                // iii. Else,
	                else {
	                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
	                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;
	
	                        var _n2 = void 0;
	                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
	                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
	                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
	                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
	                        }
	                        // 3. Else,
	                        else {
	                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
	                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
	                            }
	                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
	                        if (numSys[nums]) {
	                            (function () {
	                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
	                                var digits = numSys[nums];
	                                // a. Replace each digit in n with the value of digits[digit].
	                                _n2 = String(_n2).replace(/\d/g, function (digit) {
	                                    return digits[digit];
	                                });
	                            })();
	                        }
	                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
	                        else _n2 = String(_n2); // ###TODO###
	
	                        var integer = void 0;
	                        var fraction = void 0;
	                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
	                        var decimalSepIndex = _n2.indexOf('.', 0);
	                        // 7. If decimalSepIndex > 0, then:
	                        if (decimalSepIndex > 0) {
	                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
	                            integer = _n2.substring(0, decimalSepIndex);
	                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
	                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
	                        }
	                        // 8. Else:
	                        else {
	                                // a. Let integer be n.
	                                integer = _n2;
	                                // a. Let fraction be undefined.
	                                fraction = undefined;
	                            }
	                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
	                        if (internal['[[useGrouping]]'] === true) {
	                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
	                            var groupSepSymbol = ild.group;
	                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
	                            var groups = [];
	                            // ----> implementation:
	                            // Primary group represents the group closest to the decimal
	                            var pgSize = data.patterns.primaryGroupSize || 3;
	                            // Secondary group is every other group
	                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
	                            // Group only if necessary
	                            if (integer.length > pgSize) {
	                                // Index of the primary grouping separator
	                                var end = integer.length - pgSize;
	                                // Starting index for our loop
	                                var idx = end % sgSize;
	                                var start = integer.slice(0, idx);
	                                if (start.length) arrPush.call(groups, start);
	                                // Loop to separate into secondary grouping digits
	                                while (idx < end) {
	                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
	                                    idx += sgSize;
	                                }
	                                // Add the primary grouping digits
	                                arrPush.call(groups, integer.slice(end));
	                            } else {
	                                arrPush.call(groups, integer);
	                            }
	                            // a. Assert: The number of elements in groups List is greater than 0.
	                            if (groups.length === 0) throw new Error();
	                            // a. Repeat, while groups List is not empty:
	                            while (groups.length) {
	                                // i. Remove the first element from groups and let integerGroup be the value of that element.
	                                var integerGroup = arrShift.call(groups);
	                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
	                                // iii. If groups List is not empty, then:
	                                if (groups.length) {
	                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
	                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
	                                }
	                            }
	                        }
	                        // 10. Else,
	                        else {
	                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
	                            }
	                        // 11. If fraction is not undefined, then:
	                        if (fraction !== undefined) {
	                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
	                            var decimalSepSymbol = ild.decimal;
	                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
	                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
	                        }
	                    }
	        }
	        // a. Else if p is equal "plusSign", then:
	        else if (p === "plusSign") {
	                // i. Let plusSignSymbol be the ILND String representing the plus sign.
	                var plusSignSymbol = ild.plusSign;
	                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
	            }
	            // a. Else if p is equal "minusSign", then:
	            else if (p === "minusSign") {
	                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
	                    var minusSignSymbol = ild.minusSign;
	                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
	                }
	                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
	                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
	                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
	                        var percentSignSymbol = ild.percentSign;
	                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
	                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
	                    }
	                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
	                    else if (p === "currency" && internal['[[style]]'] === "currency") {
	                            // i. Let currency be the value of numberFormat.[[currency]].
	                            var currency = internal['[[currency]]'];
	
	                            var cd = void 0;
	
	                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
	                            if (internal['[[currencyDisplay]]'] === "code") {
	                                // 1. Let cd be currency.
	                                cd = currency;
	                            }
	                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
	                            else if (internal['[[currencyDisplay]]'] === "symbol") {
	                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
	                                    cd = data.currencies[currency] || currency;
	                                }
	                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
	                                else if (internal['[[currencyDisplay]]'] === "name") {
	                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
	                                        cd = currency;
	                                    }
	                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
	                        }
	                        // a. Else,
	                        else {
	                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
	                                var _literal = pattern.substring(beginIndex, endIndex);
	                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
	                            }
	        // a. Set nextIndex to endIndex + 1.
	        nextIndex = endIndex + 1;
	        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
	        beginIndex = pattern.indexOf('{', nextIndex);
	    }
	    // 9. If nextIndex is less than length, then:
	    if (nextIndex < length) {
	        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
	        var _literal2 = pattern.substring(nextIndex, length);
	        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
	    }
	    // 10. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumber]
	 */
	function FormatNumber(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be an empty String.
	    var result = '';
	    // 3. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Set result to a String value produced by concatenating result and part.[[value]].
	        result += part['[[value]]'];
	    }
	    // 4. Return result.
	    return result;
	}
	
	/**
	 * When the ToRawPrecision abstract operation is called with arguments x (which
	 * must be a finite non-negative number), minPrecision, and maxPrecision (both
	 * must be integers between 1 and 21) the following steps are taken:
	 */
	function ToRawPrecision(x, minPrecision, maxPrecision) {
	    // 1. Let p be maxPrecision.
	    var p = maxPrecision;
	
	    var m = void 0,
	        e = void 0;
	
	    // 2. If x = 0, then
	    if (x === 0) {
	        // a. Let m be the String consisting of p occurrences of the character "0".
	        m = arrJoin.call(Array(p + 1), '0');
	        // b. Let e be 0.
	        e = 0;
	    }
	    // 3. Else
	    else {
	            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
	            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
	            //    possible. If there are two such sets of e and n, pick the e and n for
	            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
	            e = log10Floor(Math.abs(x));
	
	            // Easier to get to m from here
	            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));
	
	            // b. Let m be the String consisting of the digits of the decimal
	            //    representation of n (in order, with no leading zeroes)
	            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
	        }
	
	    // 4. If e ≥ p, then
	    if (e >= p)
	        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
	        return m + arrJoin.call(Array(e - p + 1 + 1), '0');
	
	        // 5. If e = p-1, then
	    else if (e === p - 1)
	            // a. Return m.
	            return m;
	
	            // 6. If e ≥ 0, then
	        else if (e >= 0)
	                // a. Let m be the concatenation of the first e+1 characters of m, the character
	                //    ".", and the remaining p–(e+1) characters of m.
	                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);
	
	                // 7. If e < 0, then
	            else if (e < 0)
	                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
	                    //    character "0", and the string m.
	                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;
	
	    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
	    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
	        // a. Let cut be maxPrecision – minPrecision.
	        var cut = maxPrecision - minPrecision;
	
	        // b. Repeat while cut > 0 and the last character of m is "0":
	        while (cut > 0 && m.charAt(m.length - 1) === '0') {
	            //  i. Remove the last character from m.
	            m = m.slice(0, -1);
	
	            //  ii. Decrease cut by 1.
	            cut--;
	        }
	
	        // c. If the last character of m is ".", then
	        if (m.charAt(m.length - 1) === '.')
	            //    i. Remove the last character from m.
	            m = m.slice(0, -1);
	    }
	    // 9. Return m.
	    return m;
	}
	
	/**
	 * @spec[tc39/ecma402/master/spec/numberformat.html]
	 * @clause[sec-torawfixed]
	 * When the ToRawFixed abstract operation is called with arguments x (which must
	 * be a finite non-negative number), minInteger (which must be an integer between
	 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
	 * 20) the following steps are taken:
	 */
	function ToRawFixed(x, minInteger, minFraction, maxFraction) {
	    // 1. Let f be maxFraction.
	    var f = maxFraction;
	    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
	    var n = Math.pow(10, f) * x; // diverging...
	    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
	    var m = n === 0 ? "0" : n.toFixed(0); // divering...
	
	    {
	        // this diversion is needed to take into consideration big numbers, e.g.:
	        // 1.2344501e+37 -> 12344501000000000000000000000000000000
	        var idx = void 0;
	        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
	        if (exp) {
	            m = m.slice(0, idx).replace('.', '');
	            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
	        }
	    }
	
	    var int = void 0;
	    // 4. If f ≠ 0, then
	    if (f !== 0) {
	        // a. Let k be the number of characters in m.
	        var k = m.length;
	        // a. If k ≤ f, then
	        if (k <= f) {
	            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
	            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
	            // ii. Let m be the concatenation of Strings z and m.
	            m = z + m;
	            // iii. Let k be f+1.
	            k = f + 1;
	        }
	        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
	        var a = m.substring(0, k - f),
	            b = m.substring(k - f, m.length);
	        // a. Let m be the concatenation of the three Strings a, ".", and b.
	        m = a + "." + b;
	        // a. Let int be the number of characters in a.
	        int = a.length;
	    }
	    // 5. Else, let int be the number of characters in m.
	    else int = m.length;
	    // 6. Let cut be maxFraction – minFraction.
	    var cut = maxFraction - minFraction;
	    // 7. Repeat while cut > 0 and the last character of m is "0":
	    while (cut > 0 && m.slice(-1) === "0") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	        // a. Decrease cut by 1.
	        cut--;
	    }
	    // 8. If the last character of m is ".", then
	    if (m.slice(-1) === ".") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	    }
	    // 9. If int < minInteger, then
	    if (int < minInteger) {
	        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
	        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
	        // a. Let m be the concatenation of Strings z and m.
	        m = _z + m;
	    }
	    // 10. Return m.
	    return m;
	}
	
	// Sect 11.3.2 Table 2, Numbering systems
	// ======================================
	var numSys = {
	    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
	    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
	    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
	    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
	    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
	    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
	    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
	    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
	    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
	    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
	    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
	    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
	    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
	    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
	    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
	    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
	    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
	    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
	    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
	    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
	    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
	    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
	};
	
	/**
	 * This function provides access to the locale and formatting options computed
	 * during initialization of the object.
	 *
	 * The function returns a new object whose properties and attributes are set as
	 * if constructed by an object literal assigning to each of the following
	 * properties the value of the corresponding internal property of this
	 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
	 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
	 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
	 * useGrouping. Properties whose corresponding internal properties are not present
	 * are not assigned.
	 */
	/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
	    configurable: true,
	    writable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 11.3_b
	        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	/* jslint esnext: true */
	
	// Match these datetime components in a CLDR pattern, except those in single quotes
	var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	// trim patterns after transformations
	var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	// Skip over patterns with these datetime components because we don't have data
	// to back them up:
	// timezone, weekday, amoung others
	var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string
	
	var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
	var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];
	
	function isDateFormatOnly(obj) {
	    for (var i = 0; i < tmKeys.length; i += 1) {
	        if (obj.hasOwnProperty(tmKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function isTimeFormatOnly(obj) {
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (obj.hasOwnProperty(dtKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
	    var o = { _: {} };
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (dateFormatObj[dtKeys[i]]) {
	            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
	        }
	        if (dateFormatObj._[dtKeys[i]]) {
	            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
	        }
	    }
	    for (var j = 0; j < tmKeys.length; j += 1) {
	        if (timeFormatObj[tmKeys[j]]) {
	            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
	        }
	        if (timeFormatObj._[tmKeys[j]]) {
	            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
	        }
	    }
	    return o;
	}
	
	function computeFinalPatterns(formatObj) {
	    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
	    //  'In patterns, two single quotes represents a literal single quote, either
	    //   inside or outside single quotes. Text within single quotes is not
	    //   interpreted in any way (except for two adjacent single quotes).'
	    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
	        return literal ? literal : "'";
	    });
	
	    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
	    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
	    return formatObj;
	}
	
	function expDTComponentsMeta($0, formatObj) {
	    switch ($0.charAt(0)) {
	        // --- Era
	        case 'G':
	            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{era}';
	
	        // --- Year
	        case 'y':
	        case 'Y':
	        case 'u':
	        case 'U':
	        case 'r':
	            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{year}';
	
	        // --- Quarter (not supported in this polyfill)
	        case 'Q':
	        case 'q':
	            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{quarter}';
	
	        // --- Month
	        case 'M':
	        case 'L':
	            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{month}';
	
	        // --- Week (not supported in this polyfill)
	        case 'w':
	            // week of the year
	            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{weekday}';
	        case 'W':
	            // week of the month
	            formatObj.week = 'numeric';
	            return '{weekday}';
	
	        // --- Day
	        case 'd':
	            // day of the month
	            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{day}';
	        case 'D': // day of the year
	        case 'F': // day of the week
	        case 'g':
	            // 1..n: Modified Julian day
	            formatObj.day = 'numeric';
	            return '{day}';
	
	        // --- Week Day
	        case 'E':
	            // day of the week
	            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'e':
	            // local day of the week
	            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'c':
	            // stand alone local day of the week
	            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	
	        // --- Period
	        case 'a': // AM, PM
	        case 'b': // am, pm, noon, midnight
	        case 'B':
	            // flexible day periods
	            formatObj.hour12 = true;
	            return '{ampm}';
	
	        // --- Hour
	        case 'h':
	        case 'H':
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	        case 'k':
	        case 'K':
	            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	
	        // --- Minute
	        case 'm':
	            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{minute}';
	
	        // --- Second
	        case 's':
	            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{second}';
	        case 'S':
	        case 'A':
	            formatObj.second = 'numeric';
	            return '{second}';
	
	        // --- Timezone
	        case 'z': // 1..3, 4: specific non-location format
	        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
	        case 'O': // 1, 4: miliseconds in day short, long
	        case 'v': // 1, 4: generic non-location format
	        case 'V': // 1, 2, 3, 4: time zone ID or city
	        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
	        case 'x':
	            // 1, 2, 3, 4: The ISO8601 varios formats
	            // this polyfill only supports much, for now, we are just doing something dummy
	            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
	            return '{timeZoneName}';
	    }
	}
	
	/**
	 * Converts the CLDR availableFormats into the objects and patterns required by
	 * the ECMAScript Internationalization API specification.
	 */
	function createDateTimeFormat(skeleton, pattern) {
	    // we ignore certain patterns that are unsupported to avoid this expensive op.
	    if (unwantedDTCs.test(pattern)) return undefined;
	
	    var formatObj = {
	        originalPattern: pattern,
	        _: {}
	    };
	
	    // Replace the pattern string with the one required by the specification, whilst
	    // at the same time evaluating it for the subsets and formats
	    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj._);
	    });
	
	    // Match the skeleton string with the one required by the specification
	    // this implementation is based on the Date Field Symbol Table:
	    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	    // Note: we are adding extra data to the formatObject even though this polyfill
	    //       might not support it.
	    skeleton.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj);
	    });
	
	    return computeFinalPatterns(formatObj);
	}
	
	/**
	 * Processes DateTime formats from CLDR to an easier-to-parse format.
	 * the result of this operation should be cached the first time a particular
	 * calendar is analyzed.
	 *
	 * The specification requires we support at least the following subsets of
	 * date/time components:
	 *
	 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
	 *   - 'weekday', 'year', 'month', 'day'
	 *   - 'year', 'month', 'day'
	 *   - 'year', 'month'
	 *   - 'month', 'day'
	 *   - 'hour', 'minute', 'second'
	 *   - 'hour', 'minute'
	 *
	 * We need to cherry pick at least these subsets from the CLDR data and convert
	 * them into the pattern objects used in the ECMA-402 API.
	 */
	function createDateTimeFormats(formats) {
	    var availableFormats = formats.availableFormats;
	    var timeFormats = formats.timeFormats;
	    var dateFormats = formats.dateFormats;
	    var result = [];
	    var skeleton = void 0,
	        pattern = void 0,
	        computed = void 0,
	        i = void 0,
	        j = void 0;
	    var timeRelatedFormats = [];
	    var dateRelatedFormats = [];
	
	    // Map available (custom) formats into a pattern for createDateTimeFormats
	    for (skeleton in availableFormats) {
	        if (availableFormats.hasOwnProperty(skeleton)) {
	            pattern = availableFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                // in some cases, the format is only displaying date specific props
	                // or time specific props, in which case we need to also produce the
	                // combined formats.
	                if (isDateFormatOnly(computed)) {
	                    dateRelatedFormats.push(computed);
	                } else if (isTimeFormatOnly(computed)) {
	                    timeRelatedFormats.push(computed);
	                }
	            }
	        }
	    }
	
	    // Map time formats into a pattern for createDateTimeFormats
	    for (skeleton in timeFormats) {
	        if (timeFormats.hasOwnProperty(skeleton)) {
	            pattern = timeFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                timeRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // Map date formats into a pattern for createDateTimeFormats
	    for (skeleton in dateFormats) {
	        if (dateFormats.hasOwnProperty(skeleton)) {
	            pattern = dateFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                dateRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // combine custom time and custom date formats when they are orthogonals to complete the
	    // formats supported by CLDR.
	    // This Algo is based on section "Missing Skeleton Fields" from:
	    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
	    for (i = 0; i < timeRelatedFormats.length; i += 1) {
	        for (j = 0; j < dateRelatedFormats.length; j += 1) {
	            if (dateRelatedFormats[j].month === 'long') {
	                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
	            } else if (dateRelatedFormats[j].month === 'short') {
	                pattern = formats.medium;
	            } else {
	                pattern = formats.short;
	            }
	            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
	            computed.originalPattern = pattern;
	            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
	            result.push(computeFinalPatterns(computed));
	        }
	    }
	
	    return result;
	}
	
	// this represents the exceptions of the rule that are not covered by CLDR availableFormats
	// for single property configurations, they play no role when using multiple properties, and
	// those that are not in this table, are not exceptions or are not covered by the data we
	// provide.
	var validSyntheticProps = {
	    second: {
	        numeric: 's',
	        '2-digit': 'ss'
	    },
	    minute: {
	        numeric: 'm',
	        '2-digit': 'mm'
	    },
	    year: {
	        numeric: 'y',
	        '2-digit': 'yy'
	    },
	    day: {
	        numeric: 'd',
	        '2-digit': 'dd'
	    },
	    month: {
	        numeric: 'L',
	        '2-digit': 'LL',
	        narrow: 'LLLLL',
	        short: 'LLL',
	        long: 'LLLL'
	    },
	    weekday: {
	        narrow: 'ccccc',
	        short: 'ccc',
	        long: 'cccc'
	    }
	};
	
	function generateSyntheticFormat(propName, propValue) {
	    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
	        var _ref2;
	
	        return _ref2 = {
	            originalPattern: validSyntheticProps[propName][propValue],
	            _: defineProperty$1({}, propName, propValue),
	            extendedPattern: "{" + propName + "}"
	        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
	    }
	}
	
	// An object map of date component keys, saves using a regex later
	var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });
	
	/**
	 * Returns a string for a date component, resolved using multiple inheritance as specified
	 * as specified in the Unicode Technical Standard 35.
	 */
	function resolveDateString(data, ca, component, width, key) {
	    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
	    // 'In clearly specified instances, resources may inherit from within the same locale.
	    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
	    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],
	
	
	    // "sideways" inheritance resolves strings when a key doesn't exist
	    alts = {
	        narrow: ['short', 'long'],
	        short: ['long', 'narrow'],
	        long: ['short', 'narrow']
	    },
	
	
	    //
	    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];
	
	    // `key` wouldn't be specified for components 'dayPeriods'
	    return key !== null ? resolved[key] : resolved;
	}
	
	// Define the DateTimeFormat constructor internally so it cannot be tainted
	function DateTimeFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.DateTimeFormat(locales, options);
	    }
	    return InitializeDateTimeFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'DateTimeFormat', {
	    configurable: true,
	    writable: true,
	    value: DateTimeFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(DateTimeFormatConstructor, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
	 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
	 * DateTimeFormat object.
	 */
	function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(dateTimeFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
	    //    value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(dateTimeFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined below) with arguments options, "any", and "date".
	    options = ToDateTimeOptions(options, 'any', 'date');
	
	    // 5. Let opt be a new Record.
	    var opt = new Record();
	
	    // 6. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
	    //    containing the two String values "lookup" and "best fit", and "best fit".
	    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 7. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 8. Let DateTimeFormat be the standard built-in object that is the initial
	    //    value of Intl.DateTimeFormat.
	    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need
	
	    // 9. Let localeData be the value of the [[localeData]] internal property of
	    //    DateTimeFormat.
	    var localeData = DateTimeFormat['[[localeData]]'];
	
	    // 10. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //      internal property of DateTimeFormat, and localeData.
	    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
	    //     r.[[ca]].
	    internal['[[calendar]]'] = r['[[ca]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
	    //     r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let tz be the result of calling the [[Get]] internal method of options with
	    //     argument "timeZone".
	    var tz = options.timeZone;
	
	    // 16. If tz is not undefined, then
	    if (tz !== undefined) {
	        // a. Let tz be ToString(tz).
	        // b. Convert tz to upper case as described in 6.1.
	        //    NOTE: If an implementation accepts additional time zone values, as permitted
	        //          under certain conditions by the Conformance clause, different casing
	        //          rules apply.
	        tz = toLatinUpperCase(tz);
	
	        // c. If tz is not "UTC", then throw a RangeError exception.
	        // ###TODO: accept more time zones###
	        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
	    }
	
	    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
	    internal['[[timeZone]]'] = tz;
	
	    // 18. Let opt be a new Record.
	    opt = new Record();
	
	    // 19. For each row of Table 3, except the header row, do:
	    for (var prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, prop)) continue;
	
	        // 20. Let prop be the name given in the Property column of the row.
	        // 21. Let value be the result of calling the GetOption abstract operation,
	        //     passing as argument options, the name given in the Property column of the
	        //     row, "string", a List containing the strings given in the Values column of
	        //     the row, and undefined.
	        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);
	
	        // 22. Set opt.[[<prop>]] to value.
	        opt['[[' + prop + ']]'] = value;
	    }
	
	    // Assigned a value below
	    var bestFormat = void 0;
	
	    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 24. Let formats be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "formats".
	    //     Note: we process the CLDR formats into the spec'd structure
	    var formats = ToDateTimeFormats(dataLocaleData.formats);
	
	    // 25. Let matcher be the result of calling the GetOption abstract operation with
	    //     arguments options, "formatMatcher", "string", a List containing the two String
	    //     values "basic" and "best fit", and "best fit".
	    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');
	
	    // Optimization: caching the processed formats as a one time operation by
	    // replacing the initial structure from localeData
	    dataLocaleData.formats = formats;
	
	    // 26. If matcher is "basic", then
	    if (matcher === 'basic') {
	        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
	        //     operation (defined below) with opt and formats.
	        bestFormat = BasicFormatMatcher(opt, formats);
	
	        // 28. Else
	    } else {
	        {
	            // diverging
	            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
	        }
	        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
	        //     abstract operation (defined below) with opt and formats.
	        bestFormat = BestFitFormatMatcher(opt, formats);
	    }
	
	    // 30. For each row in Table 3, except the header row, do
	    for (var _prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, _prop)) continue;
	
	        // a. Let prop be the name given in the Property column of the row.
	        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
	        //    bestFormat with argument prop.
	        // c. If pDesc is not undefined, then
	        if (hop.call(bestFormat, _prop)) {
	            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
	            //    with argument prop.
	            var p = bestFormat[_prop];
	            {
	                // diverging
	                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
	            }
	
	            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
	            internal['[[' + _prop + ']]'] = p;
	        }
	    }
	
	    var pattern = void 0; // Assigned a value below
	
	    // 31. Let hr12 be the result of calling the GetOption abstract operation with
	    //     arguments options, "hour12", "boolean", undefined, and undefined.
	    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	
	    // 32. If dateTimeFormat has an internal property [[hour]], then
	    if (internal['[[hour]]']) {
	        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
	        //    internal method of dataLocaleData with argument "hour12".
	        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;
	
	        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
	        internal['[[hour12]]'] = hr12;
	
	        // c. If hr12 is true, then
	        if (hr12 === true) {
	            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
	            //    dataLocaleData with argument "hourNo0".
	            var hourNo0 = dataLocaleData.hourNo0;
	
	            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
	            internal['[[hourNo0]]'] = hourNo0;
	
	            // iii. Let pattern be the result of calling the [[Get]] internal method of
	            //      bestFormat with argument "pattern12".
	            pattern = bestFormat.pattern12;
	        }
	
	        // d. Else
	        else
	            // i. Let pattern be the result of calling the [[Get]] internal method of
	            //    bestFormat with argument "pattern".
	            pattern = bestFormat.pattern;
	    }
	
	    // 33. Else
	    else
	        // a. Let pattern be the result of calling the [[Get]] internal method of
	        //    bestFormat with argument "pattern".
	        pattern = bestFormat.pattern;
	
	    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
	    internal['[[pattern]]'] = pattern;
	
	    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
	    //     true.
	    internal['[[initializedDateTimeFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return dateTimeFormat;
	}
	
	/**
	 * Several DateTimeFormat algorithms use values from the following table, which provides
	 * property names and allowable values for the components of date and time formats:
	 */
	var dateTimeComponents = {
	    weekday: ["narrow", "short", "long"],
	    era: ["narrow", "short", "long"],
	    year: ["2-digit", "numeric"],
	    month: ["2-digit", "numeric", "narrow", "short", "long"],
	    day: ["2-digit", "numeric"],
	    hour: ["2-digit", "numeric"],
	    minute: ["2-digit", "numeric"],
	    second: ["2-digit", "numeric"],
	    timeZoneName: ["short", "long"]
	};
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeFormats(formats) {
	    if (Object.prototype.toString.call(formats) === '[object Array]') {
	        return formats;
	    }
	    return createDateTimeFormats(formats);
	}
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeOptions(options, required, defaults) {
	    // 1. If options is undefined, then let options be null, else let options be
	    //    ToObject(options).
	    if (options === undefined) options = null;else {
	        // (#12) options needs to be a Record, but it also needs to inherit properties
	        var opt2 = toObject(options);
	        options = new Record();
	
	        for (var k in opt2) {
	            options[k] = opt2[k];
	        }
	    }
	
	    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
	    var create = objCreate;
	
	    // 3. Let options be the result of calling the [[Call]] internal method of create with
	    //    undefined as the this value and an argument list containing the single item
	    //    options.
	    options = create(options);
	
	    // 4. Let needDefaults be true.
	    var needDefaults = true;
	
	    // 5. If required is "date" or "any", then
	    if (required === 'date' || required === 'any') {
	        // a. For each of the property names "weekday", "year", "month", "day":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
	    }
	
	    // 6. If required is "time" or "any", then
	    if (required === 'time' || required === 'any') {
	        // a. For each of the property names "hour", "minute", "second":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
	    }
	
	    // 7. If needDefaults is true and defaults is either "date" or "all", then
	    if (needDefaults && (defaults === 'date' || defaults === 'all'))
	        // a. For each of the property names "year", "month", "day":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.year = options.month = options.day = 'numeric';
	
	    // 8. If needDefaults is true and defaults is either "time" or "all", then
	    if (needDefaults && (defaults === 'time' || defaults === 'all'))
	        // a. For each of the property names "hour", "minute", "second":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.hour = options.minute = options.second = 'numeric';
	
	    // 9. Return options.
	    return options;
	}
	
	/**
	 * When the BasicFormatMatcher abstract operation is called with two arguments options and
	 * formats, the following steps are taken:
	 */
	function BasicFormatMatcher(options, formats) {
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, property) ? format[property] : undefined;
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        // 5. If delta = 2, decrease score by longMorePenalty.
	                        if (delta === 2) score -= longMorePenalty;
	
	                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
	                        else if (delta === 1) score -= shortMorePenalty;
	
	                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
	                            else if (delta === -1) score -= shortLessPenalty;
	
	                                // 8. Else if delta = -2, decrease score by longLessPenalty.
	                                else if (delta === -2) score -= longLessPenalty;
	                    }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/**
	 * When the BestFitFormatMatcher abstract operation is called with two arguments options
	 * and formats, it performs implementation dependent steps, which should return a set of
	 * component representations that a typical user of the selected locale would perceive as
	 * at least as good as the one returned by BasicFormatMatcher.
	 *
	 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
	 * with the addition of bonus points awarded where the requested format is of
	 * the same data type as the potentially matching format.
	 *
	 * This algo relies on the concept of closest distance matching described here:
	 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
	 * Typically a “best match” is found using a closest distance match, such as:
	 *
	 * Symbols requesting a best choice for the locale are replaced.
	 *      j → one of {H, k, h, K}; C → one of {a, b, B}
	 * -> Covered by cldr.js matching process
	 *
	 * For fields with symbols representing the same type (year, month, day, etc):
	 *     Most symbols have a small distance from each other.
	 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
	 *     -> Covered by cldr.js matching process
	 *
	 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
	 *         MMM ≅ MMMM
	 *         MM ≅ M
	 *     Numeric and text fields are given a larger distance from each other.
	 *         MMM ≈ MM
	 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
	 *         d ≋ D; ...
	 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
	 *
	 *
	 * For example,
	 *
	 *     { month: 'numeric', day: 'numeric' }
	 *
	 * should match
	 *
	 *     { month: '2-digit', day: '2-digit' }
	 *
	 * rather than
	 *
	 *     { month: 'short', day: 'numeric' }
	 *
	 * This makes sense because a user requesting a formatted date with numeric parts would
	 * not expect to see the returned format containing narrow, short or long part names
	 */
	function BestFitFormatMatcher(options, formats) {
	    /** Diverging: this block implements the hack for single property configuration, eg.:
	     *
	     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
	     *
	     * should produce a single digit with the day of the month. This is needed because
	     * CLDR `availableFormats` data structure doesn't cover these cases.
	     */
	    {
	        var optionsPropNames = [];
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            if (options['[[' + property + ']]'] !== undefined) {
	                optionsPropNames.push(property);
	            }
	        }
	        if (optionsPropNames.length === 1) {
	            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
	            if (_bestFormat) {
	                return _bestFormat;
	            }
	        }
	    }
	
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    var patternPenalty = 2;
	
	    var hour12Penalty = 1;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var _property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, _property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + _property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, _property) ? format[_property] : undefined;
	
	            // Diverging: using the default properties produced by the pattern/skeleton
	            // to match it with user options, and apply a penalty
	            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
	            if (optionsProp !== patternProp) {
	                score -= patternPenalty;
	            }
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        {
	                            // diverging from spec
	                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
	                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
	                            } else {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
	                            }
	                        }
	                    }
	        }
	
	        {
	            // diverging to also take into consideration differences between 12 or 24 hours
	            // which is special for the best fit only.
	            if (format._.hour12 !== options.hour12) {
	                score -= hour12Penalty;
	            }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/* 12.2.3 */internals.DateTimeFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['ca', 'nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
	 * following steps are taken:
	 */
	/* 12.2.2 */
	defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * DateTimeFormat object.
	 */
	/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatDateTime
	});
	
	function GetFormatDateTime() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 12.3_b
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 0, that takes the argument date and
	        //    performs the following steps:
	        var F = function F() {
	            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	            //   i. If date is not provided or is undefined, then let x be the
	            //      result as if by the expression Date.now() where Date.now is
	            //      the standard built-in function defined in ES5, 15.9.4.4.
	            //  ii. Else let x be ToNumber(date).
	            // iii. Return the result of calling the FormatDateTime abstract
	            //      operation (defined below) with arguments this and x.
	            var x = date === undefined ? Date.now() : toNumber(date);
	            return FormatDateTime(this, x);
	        };
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts$1() {
	    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');
	
	    var x = date === undefined ? Date.now() : toNumber(date);
	    return FormatToPartsDateTime(this, x);
	}
	
	Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
	    enumerable: false,
	    writable: true,
	    configurable: true,
	    value: formatToParts$1
	});
	
	function CreateDateTimeParts(dateTimeFormat, x) {
	    // 1. If x is not a finite Number, then throw a RangeError exception.
	    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');
	
	    var internal = dateTimeFormat.__getInternalProperties(secret);
	
	    // Creating restore point for properties on the RegExp object... please wait
	    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this
	
	    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
	    var locale = internal['[[locale]]'];
	
	    // 3. Let nf be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
	    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    var nf = new Intl.NumberFormat([locale], { useGrouping: false });
	
	    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
	    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
	    // 11.1.3.
	    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });
	
	    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
	    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
	    // and the value of the [[timeZone]] internal property of dateTimeFormat.
	    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);
	
	    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
	    var pattern = internal['[[pattern]]'];
	
	    // 7.
	    var result = new List();
	
	    // 8.
	    var index = 0;
	
	    // 9.
	    var beginIndex = pattern.indexOf('{');
	
	    // 10.
	    var endIndex = 0;
	
	    // Need the locale minus any extensions
	    var dataLocale = internal['[[dataLocale]]'];
	
	    // Need the calendar data from CLDR
	    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
	    var ca = internal['[[calendar]]'];
	
	    // 11.
	    while (beginIndex !== -1) {
	        var fv = void 0;
	        // a.
	        endIndex = pattern.indexOf('}', beginIndex);
	        // b.
	        if (endIndex === -1) {
	            throw new Error('Unclosed pattern');
	        }
	        // c.
	        if (beginIndex > index) {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(index, beginIndex)
	            });
	        }
	        // d.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // e.
	        if (dateTimeComponents.hasOwnProperty(p)) {
	            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
	            var f = internal['[[' + p + ']]'];
	            //  ii. Let v be the value of tm.[[<p>]].
	            var v = tm['[[' + p + ']]'];
	            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
	            if (p === 'year' && v <= 0) {
	                v = 1 - v;
	            }
	            //  iv. If p is "month", then increase v by 1.
	            else if (p === 'month') {
	                    v++;
	                }
	                //   v. If p is "hour" and the value of the [[hour12]] internal property of
	                //      dateTimeFormat is true, then
	                else if (p === 'hour' && internal['[[hour12]]'] === true) {
	                        // 1. Let v be v modulo 12.
	                        v = v % 12;
	                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
	                        //    dateTimeFormat is true, then let v be 12.
	                        if (v === 0 && internal['[[hourNo0]]'] === true) {
	                            v = 12;
	                        }
	                    }
	
	            //  vi. If f is "numeric", then
	            if (f === 'numeric') {
	                // 1. Let fv be the result of calling the FormatNumber abstract operation
	                //    (defined in 11.3.2) with arguments nf and v.
	                fv = FormatNumber(nf, v);
	            }
	            // vii. Else if f is "2-digit", then
	            else if (f === '2-digit') {
	                    // 1. Let fv be the result of calling the FormatNumber abstract operation
	                    //    with arguments nf2 and v.
	                    fv = FormatNumber(nf2, v);
	                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
	                    //    containing the last two characters.
	                    if (fv.length > 2) {
	                        fv = fv.slice(-2);
	                    }
	                }
	                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
	                //     value representing f in the desired form; the String value depends upon
	                //     the implementation and the effective locale and calendar of
	                //     dateTimeFormat. If p is "month", then the String value may also depend
	                //     on whether dateTimeFormat has a [[day]] internal property. If p is
	                //     "timeZoneName", then the String value may also depend on the value of
	                //     the [[inDST]] field of tm.
	                else if (f in dateWidths) {
	                        switch (p) {
	                            case 'month':
	                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
	                                break;
	
	                            case 'weekday':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
	                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
	                                } catch (e) {
	                                    throw new Error('Could not find weekday data for locale ' + locale);
	                                }
	                                break;
	
	                            case 'timeZoneName':
	                                fv = ''; // ###TODO
	                                break;
	
	                            case 'era':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
	                                } catch (e) {
	                                    throw new Error('Could not find era data for locale ' + locale);
	                                }
	                                break;
	
	                            default:
	                                fv = tm['[[' + p + ']]'];
	                        }
	                    }
	            // ix
	            arrPush.call(result, {
	                type: p,
	                value: fv
	            });
	            // f.
	        } else if (p === 'ampm') {
	            // i.
	            var _v = tm['[[hour]]'];
	            // ii./iii.
	            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
	            // iv.
	            arrPush.call(result, {
	                type: 'dayPeriod',
	                value: fv
	            });
	            // g.
	        } else {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(beginIndex, endIndex + 1)
	            });
	        }
	        // h.
	        index = endIndex + 1;
	        // i.
	        beginIndex = pattern.indexOf('{', index);
	    }
	    // 12.
	    if (endIndex < pattern.length - 1) {
	        arrPush.call(result, {
	            type: 'literal',
	            value: pattern.substr(endIndex + 1)
	        });
	    }
	    // 13.
	    return result;
	}
	
	/**
	 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
	 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
	 * value), it returns a String value representing x (interpreted as a time value as
	 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
	 * options of dateTimeFormat.
	 */
	function FormatDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = '';
	
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result += part.value;
	    }
	    return result;
	}
	
	function FormatToPartsDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = [];
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result.push({
	            type: part.type,
	            value: part.value
	        });
	    }
	    return result;
	}
	
	/**
	 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
	 * timeZone, the following steps are taken:
	 */
	function ToLocalTime(date, calendar, timeZone) {
	    // 1. Apply calendrical calculations on date for the given calendar and time zone to
	    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
	    //    The calculations should use best available information about the specified
	    //    calendar and time zone. If the calendar is "gregory", then the calculations must
	    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
	    //    bound by the restrictions on the use of best available information on time zones
	    //    for local time zone adjustment and daylight saving time adjustment imposed by
	    //    ES5, 15.9.1.7 and 15.9.1.8.
	    // ###TODO###
	    var d = new Date(date),
	        m = 'get' + (timeZone || '');
	
	    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
	    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
	    //    calculated value.
	    return new Record({
	        '[[weekday]]': d[m + 'Day'](),
	        '[[era]]': +(d[m + 'FullYear']() >= 0),
	        '[[year]]': d[m + 'FullYear'](),
	        '[[month]]': d[m + 'Month'](),
	        '[[day]]': d[m + 'Date'](),
	        '[[hour]]': d[m + 'Hours'](),
	        '[[minute]]': d[m + 'Minutes'](),
	        '[[second]]': d[m + 'Seconds'](),
	        '[[inDST]]': false // ###TODO###
	    });
	}
	
	/**
	 * The function returns a new object whose properties and attributes are set as if
	 * constructed by an object literal assigning to each of the following properties the
	 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
	 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
	 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
	 * properties are not present are not assigned.
	 */
	/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 12.3_b
	        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	var ls = Intl.__localeSensitiveProtos = {
	    Number: {},
	    Date: {}
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.2.1 */ls.Number.toLocaleString = function () {
	    // Satisfy test 13.2.1_1
	    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');
	
	    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
	    // 2. If locales is not provided, then let locales be undefined.
	    // 3. If options is not provided, then let options be undefined.
	    // 4. Let numberFormat be the result of creating a new object as if by the
	    //    expression new Intl.NumberFormat(locales, options) where
	    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    // 5. Return the result of calling the FormatNumber abstract operation
	    //    (defined in 11.3.2) with arguments numberFormat and x.
	    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.3.1 */ls.Date.toLocaleString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
	    options = ToDateTimeOptions(options, 'any', 'all');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleDateString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.2 */ls.Date.toLocaleDateString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0],
	
	
	    // 4. If options is not provided, then let options be undefined.
	    options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
	    options = ToDateTimeOptions(options, 'date', 'date');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleTimeString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
	    options = ToDateTimeOptions(options, 'time', 'time');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
	        // Need this here for IE 8, to avoid the _DontEnum_ bug
	        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });
	
	        for (var k in ls.Date) {
	            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
	        }
	    }
	});
	
	/**
	 * Can't really ship a single script with data for hundreds of locales, so we provide
	 * this __addLocaleData method as a means for the developer to add the data on an
	 * as-needed basis
	 */
	defineProperty(Intl, '__addLocaleData', {
	    value: function value(data) {
	        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");
	
	        addLocaleData(data, data.locale);
	    }
	});
	
	function addLocaleData(data, tag) {
	    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
	    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");
	
	    var locale = void 0,
	        locales = [tag],
	        parts = tag.split('-');
	
	    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
	    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);
	
	    while (locale = arrShift.call(locales)) {
	        // Add to NumberFormat internal properties as per 11.2.3
	        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
	        internals.NumberFormat['[[localeData]]'][locale] = data.number;
	
	        // ...and DateTimeFormat internal properties as per 12.2.3
	        if (data.date) {
	            data.date.nu = data.number.nu;
	            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
	            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
	        }
	    }
	
	    // If this is the first set of locale data added, make it the default
	    if (defaultLocale === undefined) setDefaultLocale(tag);
	}
	
	defineProperty(Intl, '__disableRegExpRestore', {
	    value: function value() {
	        internals.disableRegExpRestore = true;
	    }
	});
	
	module.exports = Intl;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 852 */
/***/ function(module, exports) {

	exports = module.exports = stringify
	exports.getSerialize = serializer
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [], keys = []
	
	  if (cycleReplacer == null) cycleReplacer = function(key, value) {
	    if (stack[0] === value) return "[Circular ~]"
	    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = stack.indexOf(this)
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
	      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
	    }
	    else stack.push(value)
	
	    return replacer == null ? value : replacer.call(this, key, value)
	  }
	}


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap');
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' ||
	        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (nonEnumShadows || isPrototype(value)) {
	    return !nativeKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEmpty;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(92)(module)))

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(88),
	    root = __webpack_require__(47);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(912),
	    hashDelete = __webpack_require__(913),
	    hashGet = __webpack_require__(914),
	    hashHas = __webpack_require__(915),
	    hashSet = __webpack_require__(916);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(88),
	    root = __webpack_require__(47);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(88),
	    root = __webpack_require__(47);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(207),
	    setCacheAdd = __webpack_require__(938),
	    setCacheHas = __webpack_require__(939);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(88),
	    root = __webpack_require__(47);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 860 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 861 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 862 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 863 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 864 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(113),
	    keys = __webpack_require__(101);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(113),
	    keysIn = __webpack_require__(155);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(147),
	    arrayEach = __webpack_require__(324),
	    assignValue = __webpack_require__(328),
	    baseAssign = __webpack_require__(865),
	    baseAssignIn = __webpack_require__(866),
	    cloneBuffer = __webpack_require__(338),
	    copyArray = __webpack_require__(212),
	    copySymbols = __webpack_require__(898),
	    copySymbolsIn = __webpack_require__(899),
	    getAllKeys = __webpack_require__(343),
	    getAllKeysIn = __webpack_require__(907),
	    getTag = __webpack_require__(345),
	    initCloneArray = __webpack_require__(917),
	    initCloneByTag = __webpack_require__(918),
	    initCloneObject = __webpack_require__(346),
	    isArray = __webpack_require__(31),
	    isBuffer = __webpack_require__(154),
	    isObject = __webpack_require__(43),
	    keys = __webpack_require__(101);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 869 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(208),
	    isFlattenable = __webpack_require__(919);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 871 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(87),
	    isObjectLike = __webpack_require__(70);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(147),
	    equalArrays = __webpack_require__(341),
	    equalByTag = __webpack_require__(905),
	    equalObjects = __webpack_require__(906),
	    getTag = __webpack_require__(345),
	    isArray = __webpack_require__(31),
	    isBuffer = __webpack_require__(154),
	    isTypedArray = __webpack_require__(222);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(147),
	    baseIsEqual = __webpack_require__(210);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(219),
	    isMasked = __webpack_require__(921),
	    isObject = __webpack_require__(43),
	    toSource = __webpack_require__(354);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(87),
	    isLength = __webpack_require__(220),
	    isObjectLike = __webpack_require__(70);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(217),
	    nativeKeys = __webpack_require__(933);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43),
	    isPrototype = __webpack_require__(217),
	    nativeKeysIn = __webpack_require__(934);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(874),
	    getMatchData = __webpack_require__(908),
	    matchesStrictComparable = __webpack_require__(350);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(210),
	    get = __webpack_require__(953),
	    hasIn = __webpack_require__(954),
	    isKey = __webpack_require__(216),
	    isStrictComparable = __webpack_require__(348),
	    matchesStrictComparable = __webpack_require__(350),
	    toKey = __webpack_require__(114);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(147),
	    assignMergeValue = __webpack_require__(327),
	    baseFor = __webpack_require__(330),
	    baseMergeDeep = __webpack_require__(882),
	    isObject = __webpack_require__(43),
	    keysIn = __webpack_require__(155);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(327),
	    cloneBuffer = __webpack_require__(338),
	    cloneTypedArray = __webpack_require__(339),
	    copyArray = __webpack_require__(212),
	    initCloneObject = __webpack_require__(346),
	    isArguments = __webpack_require__(153),
	    isArray = __webpack_require__(31),
	    isArrayLikeObject = __webpack_require__(955),
	    isBuffer = __webpack_require__(154),
	    isFunction = __webpack_require__(219),
	    isObject = __webpack_require__(43),
	    isPlainObject = __webpack_require__(117),
	    isTypedArray = __webpack_require__(222),
	    toPlainObject = __webpack_require__(966);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(148),
	    baseIteratee = __webpack_require__(112),
	    baseMap = __webpack_require__(333),
	    baseSortBy = __webpack_require__(887),
	    baseUnary = __webpack_require__(335),
	    compareMultiple = __webpack_require__(897),
	    identity = __webpack_require__(116);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 884 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(331);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(948),
	    defineProperty = __webpack_require__(340),
	    identity = __webpack_require__(116);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 887 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 888 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(99),
	    arrayMap = __webpack_require__(148),
	    isArray = __webpack_require__(31),
	    isSymbol = __webpack_require__(100);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 890 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(211);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(860),
	    arrayReduce = __webpack_require__(326),
	    mapToArray = __webpack_require__(349);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 893 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(861),
	    arrayReduce = __webpack_require__(326),
	    setToArray = __webpack_require__(352);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(99);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(100);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(896);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(113),
	    getSymbols = __webpack_require__(214);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(113),
	    getSymbolsIn = __webpack_require__(344);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(47);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(334),
	    isIterateeCall = __webpack_require__(347);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(89);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 903 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(112),
	    isArrayLike = __webpack_require__(89),
	    keys = __webpack_require__(101);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(99),
	    Uint8Array = __webpack_require__(323),
	    eq = __webpack_require__(115),
	    equalArrays = __webpack_require__(341),
	    mapToArray = __webpack_require__(349),
	    setToArray = __webpack_require__(352);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(343);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(332),
	    getSymbolsIn = __webpack_require__(344),
	    keysIn = __webpack_require__(155);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(348),
	    keys = __webpack_require__(101);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(99);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 910 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(337),
	    isArguments = __webpack_require__(153),
	    isArray = __webpack_require__(31),
	    isIndex = __webpack_require__(215),
	    isLength = __webpack_require__(220),
	    toKey = __webpack_require__(114);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(152);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 913 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(152);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(152);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(152);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 917 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(211),
	    cloneDataView = __webpack_require__(891),
	    cloneMap = __webpack_require__(892),
	    cloneRegExp = __webpack_require__(893),
	    cloneSet = __webpack_require__(894),
	    cloneSymbol = __webpack_require__(895),
	    cloneTypedArray = __webpack_require__(339);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(99),
	    isArguments = __webpack_require__(153),
	    isArray = __webpack_require__(31);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 920 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(900);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 922 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(149);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(149);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(149);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(149);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(855),
	    ListCache = __webpack_require__(146),
	    Map = __webpack_require__(206);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(151);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(151);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(151);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(151);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(957);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(351);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 934 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(342);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)(module)))

/***/ },
/* 936 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(862);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 938 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 939 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(886),
	    shortOut = __webpack_require__(941);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 941 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(146);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 943 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 944 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 945 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(146),
	    Map = __webpack_require__(206),
	    MapCache = __webpack_require__(207);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(867);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ },
/* 948 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(952);


/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(904),
	    findIndex = __webpack_require__(951);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(869),
	    baseIteratee = __webpack_require__(112),
	    toInteger = __webpack_require__(965);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(324),
	    baseEach = __webpack_require__(329),
	    castFunction = __webpack_require__(336),
	    isArray = __webpack_require__(31);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(331);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(871),
	    hasPath = __webpack_require__(911);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(89),
	    isObjectLike = __webpack_require__(70);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(92)(module)))

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(207);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(881),
	    createAssigner = __webpack_require__(901);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(47);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(884),
	    basePropertyDeep = __webpack_require__(885),
	    isKey = __webpack_require__(216),
	    toKey = __webpack_require__(114);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(870),
	    baseOrderBy = __webpack_require__(883),
	    baseRest = __webpack_require__(334),
	    isIterateeCall = __webpack_require__(347);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 962 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(355),
	    isObject = __webpack_require__(43);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(359);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(964);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(113),
	    keysIn = __webpack_require__(155);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 362,
		"./af.js": 362,
		"./ar": 369,
		"./ar-dz": 363,
		"./ar-dz.js": 363,
		"./ar-kw": 364,
		"./ar-kw.js": 364,
		"./ar-ly": 365,
		"./ar-ly.js": 365,
		"./ar-ma": 366,
		"./ar-ma.js": 366,
		"./ar-sa": 367,
		"./ar-sa.js": 367,
		"./ar-tn": 368,
		"./ar-tn.js": 368,
		"./ar.js": 369,
		"./az": 370,
		"./az.js": 370,
		"./be": 371,
		"./be.js": 371,
		"./bg": 372,
		"./bg.js": 372,
		"./bn": 373,
		"./bn.js": 373,
		"./bo": 374,
		"./bo.js": 374,
		"./br": 375,
		"./br.js": 375,
		"./bs": 376,
		"./bs.js": 376,
		"./ca": 377,
		"./ca.js": 377,
		"./cs": 378,
		"./cs.js": 378,
		"./cv": 379,
		"./cv.js": 379,
		"./cy": 380,
		"./cy.js": 380,
		"./da": 381,
		"./da.js": 381,
		"./de": 384,
		"./de-at": 382,
		"./de-at.js": 382,
		"./de-ch": 383,
		"./de-ch.js": 383,
		"./de.js": 384,
		"./dv": 385,
		"./dv.js": 385,
		"./el": 386,
		"./el.js": 386,
		"./en-au": 387,
		"./en-au.js": 387,
		"./en-ca": 388,
		"./en-ca.js": 388,
		"./en-gb": 389,
		"./en-gb.js": 389,
		"./en-ie": 390,
		"./en-ie.js": 390,
		"./en-nz": 391,
		"./en-nz.js": 391,
		"./eo": 392,
		"./eo.js": 392,
		"./es": 394,
		"./es-do": 393,
		"./es-do.js": 393,
		"./es.js": 394,
		"./et": 395,
		"./et.js": 395,
		"./eu": 396,
		"./eu.js": 396,
		"./fa": 397,
		"./fa.js": 397,
		"./fi": 398,
		"./fi.js": 398,
		"./fo": 399,
		"./fo.js": 399,
		"./fr": 402,
		"./fr-ca": 400,
		"./fr-ca.js": 400,
		"./fr-ch": 401,
		"./fr-ch.js": 401,
		"./fr.js": 402,
		"./fy": 403,
		"./fy.js": 403,
		"./gd": 404,
		"./gd.js": 404,
		"./gl": 405,
		"./gl.js": 405,
		"./gom-latn": 406,
		"./gom-latn.js": 406,
		"./he": 407,
		"./he.js": 407,
		"./hi": 408,
		"./hi.js": 408,
		"./hr": 409,
		"./hr.js": 409,
		"./hu": 410,
		"./hu.js": 410,
		"./hy-am": 411,
		"./hy-am.js": 411,
		"./id": 412,
		"./id.js": 412,
		"./is": 413,
		"./is.js": 413,
		"./it": 414,
		"./it.js": 414,
		"./ja": 415,
		"./ja.js": 415,
		"./jv": 416,
		"./jv.js": 416,
		"./ka": 417,
		"./ka.js": 417,
		"./kk": 418,
		"./kk.js": 418,
		"./km": 419,
		"./km.js": 419,
		"./kn": 420,
		"./kn.js": 420,
		"./ko": 421,
		"./ko.js": 421,
		"./ky": 422,
		"./ky.js": 422,
		"./lb": 423,
		"./lb.js": 423,
		"./lo": 424,
		"./lo.js": 424,
		"./lt": 425,
		"./lt.js": 425,
		"./lv": 426,
		"./lv.js": 426,
		"./me": 427,
		"./me.js": 427,
		"./mi": 428,
		"./mi.js": 428,
		"./mk": 429,
		"./mk.js": 429,
		"./ml": 430,
		"./ml.js": 430,
		"./mr": 431,
		"./mr.js": 431,
		"./ms": 433,
		"./ms-my": 432,
		"./ms-my.js": 432,
		"./ms.js": 433,
		"./my": 434,
		"./my.js": 434,
		"./nb": 435,
		"./nb.js": 435,
		"./ne": 436,
		"./ne.js": 436,
		"./nl": 438,
		"./nl-be": 437,
		"./nl-be.js": 437,
		"./nl.js": 438,
		"./nn": 439,
		"./nn.js": 439,
		"./pa-in": 440,
		"./pa-in.js": 440,
		"./pl": 441,
		"./pl.js": 441,
		"./pt": 443,
		"./pt-br": 442,
		"./pt-br.js": 442,
		"./pt.js": 443,
		"./ro": 444,
		"./ro.js": 444,
		"./ru": 445,
		"./ru.js": 445,
		"./sd": 446,
		"./sd.js": 446,
		"./se": 447,
		"./se.js": 447,
		"./si": 448,
		"./si.js": 448,
		"./sk": 449,
		"./sk.js": 449,
		"./sl": 450,
		"./sl.js": 450,
		"./sq": 451,
		"./sq.js": 451,
		"./sr": 453,
		"./sr-cyrl": 452,
		"./sr-cyrl.js": 452,
		"./sr.js": 453,
		"./ss": 454,
		"./ss.js": 454,
		"./sv": 455,
		"./sv.js": 455,
		"./sw": 456,
		"./sw.js": 456,
		"./ta": 457,
		"./ta.js": 457,
		"./te": 458,
		"./te.js": 458,
		"./tet": 459,
		"./tet.js": 459,
		"./th": 460,
		"./th.js": 460,
		"./tl-ph": 461,
		"./tl-ph.js": 461,
		"./tlh": 462,
		"./tlh.js": 462,
		"./tr": 463,
		"./tr.js": 463,
		"./tzl": 464,
		"./tzl.js": 464,
		"./tzm": 466,
		"./tzm-latn": 465,
		"./tzm-latn.js": 465,
		"./tzm.js": 466,
		"./uk": 467,
		"./uk.js": 467,
		"./ur": 468,
		"./ur.js": 468,
		"./uz": 470,
		"./uz-latn": 469,
		"./uz-latn.js": 469,
		"./uz.js": 470,
		"./vi": 471,
		"./vi.js": 471,
		"./x-pseudo": 472,
		"./x-pseudo.js": 472,
		"./yo": 473,
		"./yo.js": 473,
		"./zh-cn": 474,
		"./zh-cn.js": 474,
		"./zh-hk": 475,
		"./zh-hk.js": 475,
		"./zh-tw": 476,
		"./zh-tw.js": 476
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 967;


/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	var symbolMap$1 = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$1[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	var symbolMap$2 = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap$1 = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm$1 = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals$1 = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize$1 = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm$1(number),
	            str = plurals$1[u][pluralForm$1(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months$1 = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	moment.defineLocale('ar', {
	    months : months$1,
	    monthsShort : months$1,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize$1('s'),
	        m : pluralize$1('m'),
	        mm : pluralize$1('m'),
	        h : pluralize$1('h'),
	        hh : pluralize$1('h'),
	        d : pluralize$1('d'),
	        dd : pluralize$1('d'),
	        M : pluralize$1('M'),
	        MM : pluralize$1('M'),
	        y : pluralize$1('y'),
	        yy : pluralize$1('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap$1[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$2[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	var symbolMap$3 = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap$2 = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap$2[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$3[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	var symbolMap$4 = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap$3 = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap$3[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$4[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	var months$2 = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural$1(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate$1(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$1(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$1(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$1(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$1(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$1(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	moment.defineLocale('cs', {
	    months : months$2,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months$2, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months$2)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate$1,
	        m : translate$1,
	        mm : translate$1,
	        h : translate$1,
	        hh : translate$1,
	        d : translate$1,
	        dd : translate$1,
	        M : translate$1,
	        MM : translate$1,
	        y : translate$1,
	        yy : translate$1
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime$1(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime$1,
	        mm : '%d Minuten',
	        h : processRelativeTime$1,
	        hh : '%d Stunden',
	        d : processRelativeTime$1,
	        dd : processRelativeTime$1,
	        M : processRelativeTime$1,
	        MM : processRelativeTime$1,
	        y : processRelativeTime$1,
	        yy : processRelativeTime$1
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	function processRelativeTime$2(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime$2,
	        mm : '%d Minuten',
	        h : processRelativeTime$2,
	        hh : '%d Stunden',
	        d : processRelativeTime$2,
	        dd : processRelativeTime$2,
	        M : processRelativeTime$2,
	        MM : processRelativeTime$2,
	        y : processRelativeTime$2,
	        yy : processRelativeTime$2
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	var months$3 = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	moment.defineLocale('dv', {
	    months : months$3,
	    monthsShort : months$3,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort$1 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort$1[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	var monthsShortDot$1 = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort$2 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot$1;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort$2[m.month()];
	        } else {
	            return monthsShortDot$1[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	function processRelativeTime$3(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime$3,
	        m      : processRelativeTime$3,
	        mm     : processRelativeTime$3,
	        h      : processRelativeTime$3,
	        hh     : processRelativeTime$3,
	        d      : processRelativeTime$3,
	        dd     : '%d päeva',
	        M      : processRelativeTime$3,
	        MM     : processRelativeTime$3,
	        y      : processRelativeTime$3,
	        yy     : processRelativeTime$3
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	var symbolMap$5 = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap$4 = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap$4[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$5[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate$2(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate$2,
	        m : translate$2,
	        mm : translate$2,
	        h : translate$2,
	        hh : translate$2,
	        d : translate$2,
	        dd : translate$2,
	        M : translate$2,
	        MM : translate$2,
	        y : translate$2,
	        yy : translate$2
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	var months$4 = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort$3 = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays$1 = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	moment.defineLocale('gd', {
	    months : months$4,
	    monthsShort : monthsShort$3,
	    monthsParseExact : true,
	    weekdays : weekdays$1,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	function processRelativeTime$4(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime$4,
	        m : processRelativeTime$4,
	        mm : processRelativeTime$4,
	        h : processRelativeTime$4,
	        hh : processRelativeTime$4,
	        d : processRelativeTime$4,
	        dd : processRelativeTime$4,
	        M : processRelativeTime$4,
	        MM : processRelativeTime$4,
	        y : processRelativeTime$4,
	        yy : processRelativeTime$4
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	var symbolMap$6 = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap$5 = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap$5[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$6[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	function translate$3(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate$3,
	        mm     : translate$3,
	        h      : translate$3,
	        hh     : translate$3,
	        d      : 'dan',
	        dd     : translate$3,
	        M      : 'mjesec',
	        MM     : translate$3,
	        y      : 'godinu',
	        yy     : translate$3
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate$4(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate$4,
	        m : translate$4,
	        mm : translate$4,
	        h : translate$4,
	        hh : translate$4,
	        d : translate$4,
	        dd : translate$4,
	        M : translate$4,
	        MM : translate$4,
	        y : translate$4,
	        yy : translate$4
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	function plural$2(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate$5(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural$2(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural$2(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural$2(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural$2(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural$2(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate$5,
	        m : translate$5,
	        mm : translate$5,
	        h : 'klukkustund',
	        hh : translate$5,
	        d : translate$5,
	        dd : translate$5,
	        M : translate$5,
	        MM : translate$5,
	        y : translate$5,
	        yy : translate$5
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	var suffixes$1 = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes$1[number] || suffixes$1[a] || suffixes$1[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	var symbolMap$7 = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap$6 = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap$6[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$7[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	
	var suffixes$2 = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes$2[number] || suffixes$2[a] || suffixes$2[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	function processRelativeTime$5(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime$5,
	        mm : '%d Minutten',
	        h : processRelativeTime$5,
	        hh : '%d Stonnen',
	        d : processRelativeTime$5,
	        dd : '%d Deeg',
	        M : processRelativeTime$5,
	        MM : '%d Méint',
	        y : processRelativeTime$5,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate$6(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate$6,
	        h : translateSingular,
	        hh : translate$6,
	        d : translateSingular,
	        dd : translate$6,
	        M : translateSingular,
	        MM : translate$6,
	        y : translateSingular,
	        yy : translate$6
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	var units$1 = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural$1(number, withoutSuffix, key) {
	    return number + ' ' + format(units$1[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units$1[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural$1,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural$1,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural$1,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural$1,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural$1
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	var symbolMap$8 = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap$7 = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap$7[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$8[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	var symbolMap$9 = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap$8 = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap$8[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$9[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	var symbolMap$10 = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap$9 = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap$9[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$10[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	var monthsShortWithDots$1 = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots$1 = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots$1;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots$1[m.month()];
	        } else {
	            return monthsShortWithDots$1[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	var monthsShortWithDots$2 = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots$2 = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse$1 = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex$1 = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots$2;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots$2[m.month()];
	        } else {
	            return monthsShortWithDots$2[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex$1,
	    monthsShortRegex: monthsRegex$1,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse$1,
	    longMonthsParse : monthsParse$1,
	    shortMonthsParse : monthsParse$1,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	var symbolMap$11 = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap$10 = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap$10[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$11[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural$3(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate$7(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural$3(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural$3(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural$3(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural$3(number) ? 'lata' : 'lat');
	    }
	}
	
	moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate$7,
	        mm : translate$7,
	        h : translate$7,
	        hh : translate$7,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate$7,
	        y : 'rok',
	        yy : translate$7
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	function relativeTimeWithPlural$2(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural$2,
	        h : 'o oră',
	        hh : relativeTimeWithPlural$2,
	        d : 'o zi',
	        dd : relativeTimeWithPlural$2,
	        M : 'o lună',
	        MM : relativeTimeWithPlural$2,
	        y : 'un an',
	        yy : relativeTimeWithPlural$2
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	function plural$4(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural$3(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural$4(format[key], +number);
	    }
	}
	var monthsParse$2 = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse$2,
	    longMonthsParse : monthsParse$2,
	    shortMonthsParse : monthsParse$2,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural$3,
	        mm : relativeTimeWithPlural$3,
	        h : 'час',
	        hh : relativeTimeWithPlural$3,
	        d : 'день',
	        dd : relativeTimeWithPlural$3,
	        M : 'месяц',
	        MM : relativeTimeWithPlural$3,
	        y : 'год',
	        yy : relativeTimeWithPlural$3
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	var months$5 = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	moment.defineLocale('sd', {
	    months : months$5,
	    monthsShort : months$5,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	
	moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	/*jshint -W100*/
	moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	var months$6 = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort$4 = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural$5(n) {
	    return (n > 1) && (n < 5);
	}
	function translate$8(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$5(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$5(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$5(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$5(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$5(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	moment.defineLocale('sk', {
	    months : months$6,
	    monthsShort : monthsShort$4,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate$8,
	        m : translate$8,
	        mm : translate$8,
	        h : translate$8,
	        hh : translate$8,
	        d : translate$8,
	        dd : translate$8,
	        M : translate$8,
	        MM : translate$8,
	        y : translate$8,
	        yy : translate$8
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	function processRelativeTime$6(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime$6,
	        m      : processRelativeTime$6,
	        mm     : processRelativeTime$6,
	        h      : processRelativeTime$6,
	        hh     : processRelativeTime$6,
	        d      : processRelativeTime$6,
	        dd     : processRelativeTime$6,
	        M      : processRelativeTime$6,
	        MM     : processRelativeTime$6,
	        y      : processRelativeTime$6,
	        yy     : processRelativeTime$6
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	var translator$1 = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator$1.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator$1.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator$1.translate,
	        mm     : translator$1.translate,
	        h      : translator$1.translate,
	        hh     : translator$1.translate,
	        d      : 'дан',
	        dd     : translator$1.translate,
	        M      : 'месец',
	        MM     : translator$1.translate,
	        y      : 'годину',
	        yy     : translator$1.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	var translator$2 = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator$2.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator$2.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator$2.translate,
	        mm     : translator$2.translate,
	        h      : translator$2.translate,
	        hh     : translator$2.translate,
	        d      : 'dan',
	        dd     : translator$2.translate,
	        M      : 'mesec',
	        MM     : translator$2.translate,
	        y      : 'godinu',
	        yy     : translator$2.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	
	moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	var symbolMap$12 = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap$11 = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap$11[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$12[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate$9(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate$9,
	        h : 'wa’ rep',
	        hh : translate$9,
	        d : 'wa’ jaj',
	        dd : translate$9,
	        M : 'wa’ jar',
	        MM : translate$9,
	        y : 'wa’ DIS',
	        yy : translate$9
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	var suffixes$3 = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes$3[a] || suffixes$3[b] || suffixes$3[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime$7,
	        m : processRelativeTime$7,
	        mm : processRelativeTime$7,
	        h : processRelativeTime$7,
	        hh : processRelativeTime$7,
	        d : processRelativeTime$7,
	        dd : processRelativeTime$7,
	        M : processRelativeTime$7,
	        MM : processRelativeTime$7,
	        y : processRelativeTime$7,
	        yy : processRelativeTime$7
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime$7(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	function plural$6(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural$4(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural$6(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural$4,
	        mm : relativeTimeWithPlural$4,
	        h : 'годину',
	        hh : relativeTimeWithPlural$4,
	        d : 'день',
	        dd : relativeTimeWithPlural$4,
	        M : 'місяць',
	        MM : relativeTimeWithPlural$4,
	        y : 'рік',
	        yy : relativeTimeWithPlural$4
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	var months$7 = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days$1 = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	moment.defineLocale('ur', {
	    months : months$7,
	    monthsShort : months$7,
	    weekdays : days$1,
	    weekdaysShort : days$1,
	    weekdaysMin : days$1,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	moment.locale('en');
	
	return moment;
	
	})));


/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(39);
	var invariant = __webpack_require__(6);
	
	module.exports = function() {
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  function shim() {
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(972);
	var parse = __webpack_require__(971);
	var formats = __webpack_require__(477);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(478);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    parameterLimit: 1000,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var parseValues = function parseValues(str, options) {
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos));
	            val = options.decoder(part.slice(pos + 1));
	        }
	        if (has.call(obj, key)) {
	            obj[key] = [].concat(obj[key]).concat(val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function parseObject(chain, val, options) {
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj;
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(parseObject(chain, val, options));
	    } else {
	        obj = options.plainObjects ? Object.create(null) : {};
	        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
	        var index = parseInt(cleanRoot, 10);
	        if (
	            !isNaN(index) &&
	            root !== cleanRoot &&
	            String(index) === cleanRoot &&
	            index >= 0 &&
	            (options.parseArrays && index <= options.arrayLimit)
	        ) {
	            obj = [];
	            obj[index] = parseObject(chain, val, options);
	        } else {
	            obj[cleanRoot] = parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	var parseKeys = function parseKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^\.\[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var parent = /^([^\[\]]*)/;
	    var child = /(\[[^\[\]]*\])/g;
	
	    // Get the parent
	
	    var segment = parent.exec(key);
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (segment[1]) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, segment[1])) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(segment[1]);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].replace(/\[|\]/g, ''))) {
	            if (!options.allowPrototypes) {
	                continue;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts || {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(478);
	var formats = __webpack_require__(477);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) {
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) {
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) {
	        return prefix;
	    }
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaults = {
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    serializeDate: function serializeDate(date) {
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (obj === null) {
	        if (strictNullHandling) {
	            return encoder ? encoder(prefix) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
	        if (encoder) {
	            return [formatter(encoder(prefix)) + '=' + formatter(encoder(obj))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (Array.isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            values = values.concat(stringify(
	                obj[key],
	                generateArrayPrefix(prefix, key),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter
	            ));
	        } else {
	            values = values.concat(stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter
	            ));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts || {};
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = encode ? (typeof options.encoder === 'function' ? options.encoder : defaults.encoder) : null;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
	    if (typeof options.format === 'undefined') {
	        options.format = formats.default;
	    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
	        throw new TypeError('Unknown format option provided.');
	    }
	    var formatter = formats.formatters[options.format];
	    var objKeys;
	    var filter;
	
	    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (Array.isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        keys = keys.concat(stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encoder,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter
	        ));
	    }
	
	    return keys.join(delimiter);
	};


/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1187);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1076);

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(511);

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlphaPicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(19);
	
	var _AlphaPointer = __webpack_require__(977);
	
	var _AlphaPointer2 = _interopRequireDefault(_AlphaPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlphaPicker = exports.AlphaPicker = function AlphaPicker(_ref) {
	  var rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      direction = _ref.direction,
	      style = _ref.style,
	      renderers = _ref.renderers,
	      pointer = _ref.pointer;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        position: 'relative',
	        width: width,
	        height: height
	      },
	      alpha: {
	        radius: '2px',
	        style: style
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'alpha-picker' },
	    _react2.default.createElement(_common.Alpha, _extends({}, styles.alpha, {
	      rgb: rgb,
	      hsl: hsl,
	      pointer: pointer,
	      renderers: renderers,
	      onChange: onChange,
	      direction: direction
	    }))
	  );
	};
	
	AlphaPicker.defaultProps = {
	  width: '316px',
	  height: '16px',
	  direction: 'horizontal',
	  pointer: _AlphaPointer2.default
	};
	
	exports.default = (0, _common.ColorWrap)(AlphaPicker);

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlphaPointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlphaPointer = exports.AlphaPointer = function AlphaPointer(_ref) {
	  var direction = _ref.direction;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '18px',
	        height: '18px',
	        borderRadius: '50%',
	        transform: 'translate(-9px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    },
	    'vertical': {
	      picker: {
	        transform: 'translate(-3px, -9px)'
	      }
	    }
	  }, { vertical: direction === 'vertical' });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = AlphaPointer;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Block = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(62);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(19);
	
	var _BlockSwatches = __webpack_require__(979);
	
	var _BlockSwatches2 = _interopRequireDefault(_BlockSwatches);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Block = exports.Block = function Block(_ref) {
	  var onChange = _ref.onChange,
	      hex = _ref.hex,
	      colors = _ref.colors,
	      width = _ref.width,
	      triangle = _ref.triangle;
	
	  var transparent = hex === 'transparent';
	  var handleChange = function handleChange(hexCode, e) {
	    _color2.default.isValidHex(hexCode) && onChange({
	      hex: hexCode,
	      source: 'hex'
	    }, e);
	  };
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        boxShadow: '0 1px rgba(0,0,0,.1)',
	        borderRadius: '6px',
	        position: 'relative'
	      },
	      head: {
	        height: '110px',
	        background: hex,
	        borderRadius: '6px 6px 0 0',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center',
	        position: 'relative'
	      },
	      body: {
	        padding: '10px'
	      },
	      label: {
	        fontSize: '18px',
	        color: transparent ? 'rgba(0,0,0,0.4)' : '#fff',
	        position: 'relative'
	      },
	      triangle: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 10px 10px 10px',
	        borderColor: 'transparent transparent ' + hex + ' transparent',
	        position: 'absolute',
	        top: '-10px',
	        left: '50%',
	        marginLeft: '-10px'
	      },
	      input: {
	        width: '100%',
	        fontSize: '12px',
	        color: '#666',
	        border: '0px',
	        outline: 'none',
	        height: '22px',
	        boxShadow: 'inset 0 0 0 1px #ddd',
	        borderRadius: '4px',
	        padding: '0 7px',
	        boxSizing: 'border-box'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      }
	    }
	  }, { 'hide-triangle': triangle === 'hide' });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'block-picker' },
	    _react2.default.createElement('div', { style: styles.triangle }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.head },
	      transparent && _react2.default.createElement(_common.Checkboard, { borderRadius: '6px 6px 0 0' }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.label },
	        hex
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(_BlockSwatches2.default, { colors: colors, onClick: handleChange }),
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input },
	        value: hex,
	        onChange: handleChange
	      })
	    )
	  );
	};
	
	Block.defaultProps = {
	  width: '170px',
	  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
	  triangle: 'top'
	};
	
	exports.default = (0, _common.ColorWrap)(Block);

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BlockSwatches = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(71);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _common = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlockSwatches = exports.BlockSwatches = function BlockSwatches(_ref) {
	  var colors = _ref.colors,
	      onClick = _ref.onClick;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        marginRight: '-10px'
	      },
	      swatch: {
	        width: '22px',
	        height: '22px',
	        float: 'left',
	        marginRight: '10px',
	        marginBottom: '10px',
	        borderRadius: '4px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatches },
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_common.Swatch, {
	        key: c,
	        color: c,
	        style: styles.swatch,
	        onClick: onClick,
	        focusStyle: {
	          boxShadow: '0 0 4px ' + c
	        }
	      });
	    }),
	    _react2.default.createElement('div', { style: styles.clear })
	  );
	};
	
	exports.default = BlockSwatches;

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chrome = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(19);
	
	var _ChromeFields = __webpack_require__(981);
	
	var _ChromeFields2 = _interopRequireDefault(_ChromeFields);
	
	var _ChromePointer = __webpack_require__(982);
	
	var _ChromePointer2 = _interopRequireDefault(_ChromePointer);
	
	var _ChromePointerCircle = __webpack_require__(983);
	
	var _ChromePointerCircle2 = _interopRequireDefault(_ChromePointerCircle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chrome = exports.Chrome = function Chrome(_ref) {
	  var onChange = _ref.onChange,
	      disableAlpha = _ref.disableAlpha,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hsv = _ref.hsv,
	      hex = _ref.hex,
	      renderers = _ref.renderers;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        background: '#fff',
	        borderRadius: '2px',
	        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
	        boxSizing: 'initial',
	        width: '225px',
	        fontFamily: 'Menlo'
	      },
	      saturation: {
	        width: '100%',
	        paddingBottom: '55%',
	        position: 'relative',
	        borderRadius: '2px 2px 0 0',
	        overflow: 'hidden'
	      },
	      Saturation: {
	        radius: '2px 2px 0 0'
	      },
	      body: {
	        padding: '16px 16px 12px'
	      },
	      controls: {
	        display: 'flex'
	      },
	      color: {
	        width: '32px'
	      },
	      swatch: {
	        marginTop: '6px',
	        width: '16px',
	        height: '16px',
	        borderRadius: '8px',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      active: {
	        absolute: '0px 0px 0px 0px',
	        borderRadius: '8px',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
	        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
	        zIndex: '2'
	      },
	      toggles: {
	        flex: '1'
	      },
	      hue: {
	        height: '10px',
	        position: 'relative',
	        marginBottom: '8px'
	      },
	      Hue: {
	        radius: '2px'
	      },
	      alpha: {
	        height: '10px',
	        position: 'relative'
	      },
	      Alpha: {
	        radius: '2px'
	      }
	    },
	    'disableAlpha': {
	      color: {
	        width: '22px'
	      },
	      alpha: {
	        display: 'none'
	      },
	      hue: {
	        marginBottom: '0px'
	      },
	      swatch: {
	        width: '10px',
	        height: '10px',
	        marginTop: '0px'
	      }
	    }
	  }, { disableAlpha: disableAlpha });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'chrome-picker' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        style: styles.Saturation,
	        hsl: hsl,
	        hsv: hsv,
	        pointer: _ChromePointerCircle2.default,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(
	        'div',
	        { style: styles.controls, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.color },
	          _react2.default.createElement(
	            'div',
	            { style: styles.swatch },
	            _react2.default.createElement('div', { style: styles.active }),
	            _react2.default.createElement(_common.Checkboard, { renderers: renderers })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggles },
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, {
	              style: styles.Hue,
	              hsl: hsl,
	              pointer: _ChromePointer2.default,
	              onChange: onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.Alpha, {
	              style: styles.Alpha,
	              rgb: rgb,
	              hsl: hsl,
	              pointer: _ChromePointer2.default,
	              renderers: renderers,
	              onChange: onChange
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_ChromeFields2.default, {
	        rgb: rgb,
	        hsl: hsl,
	        hex: hex,
	        onChange: onChange,
	        disableAlpha: disableAlpha
	      })
	    )
	  );
	};
	
	exports.default = (0, _common.ColorWrap)(Chrome);

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromeFields = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(62);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */
	
	var ChromeFields = exports.ChromeFields = function (_React$Component) {
	  _inherits(ChromeFields, _React$Component);
	
	  function ChromeFields() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChromeFields);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      view: ''
	    }, _this.toggleViews = function () {
	      if (_this.state.view === 'hex') {
	        _this.setState({ view: 'rgb' });
	      } else if (_this.state.view === 'rgb') {
	        _this.setState({ view: 'hsl' });
	      } else if (_this.state.view === 'hsl') {
	        if (_this.props.hsl.a === 1) {
	          _this.setState({ view: 'hex' });
	        } else {
	          _this.setState({ view: 'rgb' });
	        }
	      }
	    }, _this.handleChange = function (data, e) {
	      if (data.hex) {
	        _color2.default.isValidHex(data.hex) && _this.props.onChange({
	          hex: data.hex,
	          source: 'hex'
	        }, e);
	      } else if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          source: 'rgb'
	        }, e);
	      } else if (data.a) {
	        if (data.a < 0) {
	          data.a = 0;
	        } else if (data.a > 1) {
	          data.a = 1;
	        }
	
	        _this.props.onChange({
	          h: _this.props.hsl.h,
	          s: _this.props.hsl.s,
	          l: _this.props.hsl.l,
	          a: Math.round(data.a * 100) / 100,
	          source: 'rgb'
	        }, e);
	      } else if (data.h || data.s || data.l) {
	        _this.props.onChange({
	          h: data.h || _this.props.hsl.h,
	          s: data.s && data.s.replace('%', '') || _this.props.hsl.s,
	          l: data.l && data.l.replace('%', '') || _this.props.hsl.l,
	          source: 'hsl'
	        }, e);
	      }
	    }, _this.showHighlight = function (e) {
	      e.target.style.background = '#eee';
	    }, _this.hideHighlight = function (e) {
	      e.target.style.background = 'transparent';
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChromeFields, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.hsl.a === 1 && this.state.view !== 'hex') {
	        this.setState({ view: 'hex' });
	      } else if (this.state.view !== 'rgb' && this.state.view !== 'hsl') {
	        this.setState({ view: 'rgb' });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hsl.a !== 1 && this.state.view === 'hex') {
	        this.setState({ view: 'rgb' });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            paddingTop: '16px',
	            display: 'flex'
	          },
	          fields: {
	            flex: '1',
	            display: 'flex',
	            marginLeft: '-6px'
	          },
	          field: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          alpha: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          toggle: {
	            width: '32px',
	            textAlign: 'right',
	            position: 'relative'
	          },
	          icon: {
	            marginRight: '-4px',
	            marginTop: '12px',
	            cursor: 'pointer',
	            position: 'relative'
	          },
	          iconHighlight: {
	            position: 'absolute',
	            width: '24px',
	            height: '28px',
	            background: '#eee',
	            borderRadius: '4px',
	            top: '10px',
	            left: '12px',
	            display: 'none'
	          },
	          input: {
	            fontSize: '11px',
	            color: '#333',
	            width: '100%',
	            borderRadius: '2px',
	            border: 'none',
	            boxShadow: 'inset 0 0 0 1px #dadada',
	            height: '21px',
	            textAlign: 'center'
	          },
	          label: {
	            textTransform: 'uppercase',
	            fontSize: '11px',
	            lineHeight: '11px',
	            color: '#969696',
	            textAlign: 'center',
	            display: 'block',
	            marginTop: '12px'
	          },
	          svg: {
	            width: '24px',
	            height: '24px',
	            border: '1px transparent solid',
	            borderRadius: '5px'
	          }
	        },
	        'disableAlpha': {
	          alpha: {
	            display: 'none'
	          }
	        }
	      }, this.props, this.state);
	
	      var fields = void 0;
	      if (this.state.view === 'hex') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'hex', value: this.props.hex,
	              onChange: this.handleChange
	            })
	          )
	        );
	      } else if (this.state.view === 'rgb') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'r',
	              value: this.props.rgb.r,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'g',
	              value: this.props.rgb.g,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'b',
	              value: this.props.rgb.b,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'a',
	              value: this.props.rgb.a,
	              arrowOffset: 0.01,
	              onChange: this.handleChange
	            })
	          )
	        );
	      } else if (this.state.view === 'hsl') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'h',
	              value: Math.round(this.props.hsl.h),
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 's',
	              value: Math.round(this.props.hsl.s * 100) + '%',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'l',
	              value: Math.round(this.props.hsl.l * 100) + '%',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'a',
	              value: this.props.hsl.a,
	              arrowOffset: 0.01,
	              onChange: this.handleChange
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap, className: 'flexbox-fix' },
	        fields,
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggle },
	          _react2.default.createElement(
	            'div',
	            { style: styles.icon, onClick: this.toggleViews, ref: 'icon' },
	            _react2.default.createElement(
	              'svg',
	              {
	                style: styles.svg,
	                viewBox: '0 0 24 24',
	                onMouseOver: this.showHighlight,
	                onMouseEnter: this.showHighlight,
	                onMouseOut: this.hideHighlight
	              },
	              _react2.default.createElement('path', {
	                ref: 'iconUp',
	                fill: '#333',
	                d: 'M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
	              }),
	              _react2.default.createElement('path', {
	                ref: 'iconDown',
	                fill: '#333',
	                d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15Z'
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChromeFields;
	}(_react2.default.Component);
	
	exports.default = ChromeFields;

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChromePointer = exports.ChromePointer = function ChromePointer() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        transform: 'translate(-6px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = ChromePointer;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointerCircle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        boxShadow: 'inset 0 0 0 1px #fff',
	        transform: 'translate(-6px, -6px)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = ChromePointerCircle;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Circle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(71);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _materialColors = __webpack_require__(361);
	
	var material = _interopRequireWildcard(_materialColors);
	
	var _common = __webpack_require__(19);
	
	var _CircleSwatch = __webpack_require__(985);
	
	var _CircleSwatch2 = _interopRequireDefault(_CircleSwatch);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Circle = exports.Circle = function Circle(_ref) {
	  var width = _ref.width,
	      onChange = _ref.onChange,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      circleSize = _ref.circleSize,
	      circleSpacing = _ref.circleSpacing;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        display: 'flex',
	        flexWrap: 'wrap',
	        marginRight: -circleSpacing,
	        marginBottom: -circleSpacing
	      }
	    }
	  });
	
	  var handleChange = function handleChange(hexCode, e) {
	    return onChange({ hex: hexCode, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'circle-picker' },
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_CircleSwatch2.default, {
	        key: c,
	        color: c,
	        onClick: handleChange,
	        active: hex === c.toLowerCase(),
	        circleSize: circleSize,
	        circleSpacing: circleSpacing
	      });
	    })
	  );
	};
	
	Circle.defaultProps = {
	  width: '252px',
	  circleSize: 28,
	  circleSpacing: 14,
	  colors: [material.red['500'], material.pink['500'], material.purple['500'], material.deepPurple['500'], material.indigo['500'], material.blue['500'], material.lightBlue['500'], material.cyan['500'], material.teal['500'], material.green['500'], material.lightGreen['500'], material.lime['500'], material.yellow['500'], material.amber['500'], material.orange['500'], material.deepOrange['500'], material.brown['500'], material.blueGrey['500']]
	};
	
	exports.default = (0, _common.ColorWrap)(Circle);

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CircleSwatch = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleSwatch = exports.CircleSwatch = function CircleSwatch(_ref) {
	  var color = _ref.color,
	      onClick = _ref.onClick,
	      hover = _ref.hover,
	      active = _ref.active,
	      circleSize = _ref.circleSize,
	      circleSpacing = _ref.circleSpacing;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        width: circleSize,
	        height: circleSize,
	        marginRight: circleSpacing,
	        marginBottom: circleSpacing,
	        transform: 'scale(1)',
	        transition: '100ms transform ease'
	      },
	      Swatch: {
	        borderRadius: '50%',
	        background: 'transparent',
	        boxShadow: 'inset 0 0 0 ' + circleSize / 2 + 'px ' + color,
	        transition: '100ms box-shadow ease'
	      }
	    },
	    'hover': {
	      swatch: {
	        transform: 'scale(1.2)'
	      }
	    },
	    'active': {
	      Swatch: {
	        boxShadow: 'inset 0 0 0 3px ' + color
	      }
	    }
	  }, { hover: hover, active: active });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatch },
	    _react2.default.createElement(_common.Swatch, {
	      style: styles.Swatch,
	      color: color,
	      onClick: onClick,
	      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
	    })
	  );
	};
	
	CircleSwatch.defaultProps = {
	  circleSize: 28,
	  circleSpacing: 14
	};
	
	exports.default = (0, _reactcss.handleHover)(CircleSwatch);

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Alpha = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _alpha = __webpack_require__(1016);
	
	var alpha = _interopRequireWildcard(_alpha);
	
	var _Checkboard = __webpack_require__(479);
	
	var _Checkboard2 = _interopRequireDefault(_Checkboard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Alpha = exports.Alpha = function (_ref) {
	  _inherits(Alpha, _ref);
	
	  function Alpha() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Alpha);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
	      var change = alpha.calculateChange(e, skip, _this.props, _this.refs.container);
	      change && _this.props.onChange && _this.props.onChange(change, e);
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleChange);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Alpha, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var rgb = this.props.rgb;
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          alpha: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius
	          },
	          checkboard: {
	            absolute: '0px 0px 0px 0px',
	            overflow: 'hidden'
	          },
	          gradient: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
	            boxShadow: this.props.shadow,
	            borderRadius: this.props.radius
	          },
	          container: {
	            position: 'relative',
	            height: '100%',
	            margin: '0 3px'
	          },
	          pointer: {
	            position: 'absolute',
	            left: rgb.a * 100 + '%'
	          },
	          slider: {
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            marginTop: '1px',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'vertical': {
	          gradient: {
	            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
	          },
	          pointer: {
	            left: 0,
	            top: rgb.a * 100 + '%'
	          }
	        },
	        'overwrite': _extends({}, this.props.style)
	      }, {
	        vertical: this.props.direction === 'vertical',
	        overwrite: true
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.alpha },
	        _react2.default.createElement(
	          'div',
	          { style: styles.checkboard },
	          _react2.default.createElement(_Checkboard2.default, { renderers: this.props.renderers })
	        ),
	        _react2.default.createElement('div', { style: styles.gradient }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: styles.container,
	            ref: 'container',
	            onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange
	          },
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Alpha;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Alpha;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditableInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditableInput = exports.EditableInput = function (_ref) {
	  _inherits(EditableInput, _ref);
	
	  function EditableInput(props) {
	    _classCallCheck(this, EditableInput);
	
	    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
	
	    _this.handleBlur = function () {
	      if (_this.state.blurValue) {
	        _this.setState({ value: _this.state.blurValue, blurValue: null });
	      }
	    };
	
	    _this.handleChange = function (e) {
	      if (!!_this.props.label) {
	        _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, e.target.value), e);
	      } else {
	        _this.props.onChange && _this.props.onChange(e.target.value, e);
	      }
	
	      _this.setState({ value: e.target.value });
	    };
	
	    _this.handleKeyDown = function (e) {
	      var number = Number(e.target.value);
	      if (!isNaN(number)) {
	        var amount = _this.props.arrowOffset || 1;
	
	        // Up
	        if (e.keyCode === 38) {
	          if (_this.props.label !== null) {
	            _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, number + amount), e);
	          } else {
	            _this.props.onChange && _this.props.onChange(number + amount, e);
	          }
	
	          _this.setState({ value: number + amount });
	        }
	
	        // Down
	        if (e.keyCode === 40) {
	          if (_this.props.label !== null) {
	            _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, number - amount), e);
	          } else {
	            _this.props.onChange && _this.props.onChange(number - amount, e);
	          }
	
	          _this.setState({ value: number - amount });
	        }
	      }
	    };
	
	    _this.handleDrag = function (e) {
	      if (_this.props.dragLabel) {
	        var newValue = Math.round(_this.props.value + e.movementX);
	        if (newValue >= 0 && newValue <= _this.props.dragMax) {
	          _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, newValue), e);
	        }
	      }
	    };
	
	    _this.handleMouseDown = function (e) {
	      if (_this.props.dragLabel) {
	        e.preventDefault();
	        _this.handleDrag(e);
	        window.addEventListener('mousemove', _this.handleDrag);
	        window.addEventListener('mouseup', _this.handleMouseUp);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleDrag);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.state = {
	      value: String(props.value).toUpperCase(),
	      blurValue: String(props.value).toUpperCase()
	    };
	    return _this;
	  }
	
	  _createClass(EditableInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var input = this.refs.input;
	      if (nextProps.value !== this.state.value) {
	        if (input === document.activeElement) {
	          this.setState({ blurValue: String(nextProps.value).toUpperCase() });
	        } else {
	          this.setState({ value: String(nextProps.value).toUpperCase() });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            position: 'relative'
	          }
	        },
	        'user-override': {
	          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
	          input: this.props.style && this.props.style.input ? this.props.style.input : {},
	          label: this.props.style && this.props.style.label ? this.props.style.label : {}
	        },
	        'dragLabel-true': {
	          label: {
	            cursor: 'ew-resize'
	          }
	        }
	      }, {
	        'user-override': true
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap },
	        _react2.default.createElement('input', {
	          style: styles.input,
	          ref: 'input',
	          value: this.state.value,
	          onKeyDown: this.handleKeyDown,
	          onChange: this.handleChange,
	          onBlur: this.handleBlur,
	          placeholder: this.props.placeholder
	        }),
	        this.props.label ? _react2.default.createElement(
	          'span',
	          { style: styles.label, onMouseDown: this.handleMouseDown },
	          this.props.label
	        ) : null
	      );
	    }
	  }]);
	
	  return EditableInput;
	}(_react.PureComponent || _react.Component);
	
	exports.default = EditableInput;

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hue = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _hue = __webpack_require__(1018);
	
	var hue = _interopRequireWildcard(_hue);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hue = exports.Hue = function (_ref) {
	  _inherits(Hue, _ref);
	
	  function Hue() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Hue);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
	      var change = hue.calculateChange(e, skip, _this.props, _this.refs.container);
	      change && _this.props.onChange && _this.props.onChange(change, e);
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Hue, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          hue: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%,\n            #0ff 50%, #00f 67%, #f0f 83%, #f00 100%)',
	            borderRadius: this.props.radius,
	            boxShadow: this.props.shadow
	          },
	          container: {
	            margin: '0 2px',
	            position: 'relative',
	            height: '100%'
	          },
	          pointer: {
	            position: 'absolute',
	            left: this.props.hsl.h * 100 / 360 + '%'
	          },
	          slider: {
	            marginTop: '1px',
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'vertical': {
	          hue: {
	            background: 'linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n            #0ff 50%, #00f 67%, #f0f 83%, #f00 100%)'
	          },
	          pointer: {
	            left: '0px',
	            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
	          }
	        }
	      }, { vertical: this.props.direction === 'vertical' });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.hue },
	        _react2.default.createElement(
	          'div',
	          {
	            style: styles.container,
	            ref: 'container',
	            onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange
	          },
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Hue;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Hue;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Saturation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _throttle = __webpack_require__(963);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _saturation = __webpack_require__(1020);
	
	var saturation = _interopRequireWildcard(_saturation);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Saturation = exports.Saturation = function (_ref) {
	  _inherits(Saturation, _ref);
	
	  function Saturation(props) {
	    _classCallCheck(this, Saturation);
	
	    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
	
	    _this.handleChange = function (e, skip) {
	      _this.props.onChange && _this.throttle(_this.props.onChange, saturation.calculateChange(e, skip, _this.props, _this.refs.container), e);
	    };
	
	    _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
	      fn(data, e);
	    }, 50);
	    return _this;
	  }
	
	  _createClass(Saturation, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _ref2 = this.props.style || {},
	          color = _ref2.color,
	          white = _ref2.white,
	          black = _ref2.black,
	          pointer = _ref2.pointer,
	          circle = _ref2.circle;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          color: {
	            absolute: '0px 0px 0px 0px',
	            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
	            borderRadius: this.props.radius
	          },
	          white: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, #fff, rgba(255,255,255,0))'
	          },
	          black: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to top, #000, rgba(0,0,0,0))',
	            boxShadow: this.props.shadow
	          },
	          pointer: {
	            position: 'absolute',
	            top: -(this.props.hsv.v * 100) + 100 + '%',
	            left: this.props.hsv.s * 100 + '%',
	            cursor: 'default'
	          },
	          circle: {
	            width: '4px',
	            height: '4px',
	            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
	            borderRadius: '50%',
	            cursor: 'hand',
	            transform: 'translate(-2px, -2px)'
	          }
	        },
	        'custom': {
	          color: color,
	          white: white,
	          black: black,
	          pointer: pointer,
	          circle: circle
	        }
	      }, { 'custom': !!this.props.style });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: styles.color,
	          ref: 'container',
	          onMouseDown: this.handleMouseDown,
	          onTouchMove: this.handleChange,
	          onTouchStart: this.handleChange
	        },
	        _react2.default.createElement(
	          'div',
	          { style: styles.white },
	          _react2.default.createElement('div', { style: styles.black }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.circle })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Saturation;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Saturation;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _interaction = __webpack_require__(1019);
	
	var _ = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ENTER = 13;
	
	var Swatch = exports.Swatch = function Swatch(_ref) {
	  var color = _ref.color,
	      style = _ref.style,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? color : _ref$title,
	      children = _ref.children,
	      focus = _ref.focus,
	      _ref$focusStyle = _ref.focusStyle,
	      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
	
	  var transparent = color === 'transparent';
	  var styles = (0, _reactcss2.default)({
	    default: {
	      swatch: _extends({
	        background: color,
	        height: '100%',
	        width: '100%',
	        cursor: 'pointer',
	        position: 'relative',
	        outline: 'none'
	      }, style, focus ? focusStyle : {})
	    }
	  });
	
	  var handleClick = function handleClick(e) {
	    return onClick(color, e);
	  };
	  var handleKeyDown = function handleKeyDown(e) {
	    return e.keyCode === ENTER && onClick(color, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    {
	      style: styles.swatch,
	      onClick: handleClick,
	      title: title,
	      tabIndex: 0,
	      onKeyDown: handleKeyDown
	    },
	    children,
	    transparent && _react2.default.createElement(_.Checkboard, {
	      borderRadius: styles.swatch.borderRadius,
	      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
	    })
	  );
	};
	
	exports.default = (0, _interaction.handleFocus)(Swatch);

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Compact = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(71);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _color = __webpack_require__(62);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactMaterialDesign = __webpack_require__(224);
	
	var _common = __webpack_require__(19);
	
	var _CompactColor = __webpack_require__(992);
	
	var _CompactColor2 = _interopRequireDefault(_CompactColor);
	
	var _CompactFields = __webpack_require__(993);
	
	var _CompactFields2 = _interopRequireDefault(_CompactFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Compact = exports.Compact = function Compact(_ref) {
	  var onChange = _ref.onChange,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      rgb = _ref.rgb;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      Compact: {
	        background: '#f6f6f6',
	        radius: '4px'
	      },
	      compact: {
	        paddingTop: '5px',
	        paddingLeft: '5px',
	        boxSizing: 'initial',
	        width: '240px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      _color2.default.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else {
	      onChange(data, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    _reactMaterialDesign.Raised,
	    { style: styles.Compact },
	    _react2.default.createElement(
	      'div',
	      { style: styles.compact, className: 'compact-picker' },
	      _react2.default.createElement(
	        'div',
	        null,
	        (0, _map2.default)(colors, function (c) {
	          return _react2.default.createElement(_CompactColor2.default, {
	            key: c,
	            color: c,
	            active: c.toLowerCase() === hex,
	            onClick: handleChange
	          });
	        }),
	        _react2.default.createElement('div', { style: styles.clear })
	      ),
	      _react2.default.createElement(_CompactFields2.default, { hex: hex, rgb: rgb, onChange: handleChange })
	    )
	  );
	};
	
	Compact.defaultProps = {
	  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E']
	};
	
	exports.default = (0, _common.ColorWrap)(Compact);

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactColor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompactColor = exports.CompactColor = function CompactColor(_ref) {
	  var color = _ref.color,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      color: {
	        background: color,
	        width: '15px',
	        height: '15px',
	        float: 'left',
	        marginRight: '5px',
	        marginBottom: '5px',
	        position: 'relative',
	        cursor: 'pointer'
	      },
	      dot: {
	        absolute: '5px 5px 5px 5px',
	        background: '#fff',
	        borderRadius: '50%',
	        opacity: '0'
	      }
	    },
	    'active': {
	      dot: {
	        opacity: '1'
	      }
	    },
	    'color-#FFFFFF': {
	      color: {
	        boxShadow: 'inset 0 0 0 1px #ddd'
	      },
	      dot: {
	        background: '#000'
	      }
	    },
	    'transparent': {
	      dot: {
	        background: '#000'
	      }
	    }
	  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });
	
	  return _react2.default.createElement(
	    _common.Swatch,
	    {
	      style: styles.color,
	      color: color,
	      onClick: onClick,
	      focusStyle: { boxShadow: '0 0 4px ' + color }
	    },
	    _react2.default.createElement('div', { style: styles.dot })
	  );
	};
	
	exports.default = CompactColor;

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactFields = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompactFields = exports.CompactFields = function CompactFields(_ref) {
	  var hex = _ref.hex,
	      rgb = _ref.rgb,
	      onChange = _ref.onChange;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        display: 'flex',
	        paddingBottom: '6px',
	        paddingRight: '5px',
	        position: 'relative'
	      },
	      active: {
	        position: 'absolute',
	        top: '6px',
	        left: '5px',
	        height: '9px',
	        width: '9px',
	        background: hex
	      },
	      HEXwrap: {
	        flex: '6',
	        position: 'relative'
	      },
	      HEXinput: {
	        width: '80%',
	        padding: '0px',
	        paddingLeft: '20%',
	        border: 'none',
	        outline: 'none',
	        background: 'none',
	        fontSize: '12px',
	        color: '#333',
	        height: '16px'
	      },
	      HEXlabel: {
	        display: 'none'
	      },
	      RGBwrap: {
	        flex: '3',
	        position: 'relative'
	      },
	      RGBinput: {
	        width: '70%',
	        padding: '0px',
	        paddingLeft: '30%',
	        border: 'none',
	        outline: 'none',
	        background: 'none',
	        fontSize: '12px',
	        color: '#333',
	        height: '16px'
	      },
	      RGBlabel: {
	        position: 'absolute',
	        top: '3px',
	        left: '0px',
	        lineHeight: '16px',
	        textTransform: 'uppercase',
	        fontSize: '12px',
	        color: '#999'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    } else {
	      onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields, className: 'flexbox-fix' },
	    _react2.default.createElement('div', { style: styles.active }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	      label: 'hex',
	      value: hex,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'r',
	      value: rgb.r,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'g',
	      value: rgb.g,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'b',
	      value: rgb.b,
	      onChange: handleChange
	    })
	  );
	};
	
	exports.default = CompactFields;

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Github = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(71);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _common = __webpack_require__(19);
	
	var _GithubSwatch = __webpack_require__(995);
	
	var _GithubSwatch2 = _interopRequireDefault(_GithubSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Github = exports.Github = function Github(_ref) {
	  var width = _ref.width,
	      colors = _ref.colors,
	      onChange = _ref.onChange,
	      triangle = _ref.triangle;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        border: '1px solid rgba(0,0,0,0.2)',
	        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
	        borderRadius: '4px',
	        position: 'relative',
	        padding: '5px',
	        display: 'flex',
	        flexWrap: 'wrap'
	      },
	      triangle: {
	        position: 'absolute',
	        border: '7px solid transparent',
	        borderBottomColor: '#fff'
	      },
	      triangleShadow: {
	        position: 'absolute',
	        border: '8px solid transparent',
	        borderBottomColor: 'rgba(0,0,0,0.15)'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      },
	      triangleShadow: {
	        display: 'none'
	      }
	    },
	    'top-left-triangle': {
	      triangle: {
	        top: '-14px',
	        left: '10px'
	      },
	      triangleShadow: {
	        top: '-16px',
	        left: '9px'
	      }
	    },
	    'top-right-triangle': {
	      triangle: {
	        top: '-14px',
	        right: '10px'
	      },
	      triangleShadow: {
	        top: '-16px',
	        right: '9px'
	      }
	    },
	    'bottom-right-triangle': {
	      triangle: {
	        top: '35px',
	        right: '10px',
	        transform: 'rotate(180deg)'
	      },
	      triangleShadow: {
	        top: '37px',
	        right: '9px',
	        transform: 'rotate(180deg)'
	      }
	    }
	  }, {
	    'hide-triangle': triangle === 'hide',
	    'top-left-triangle': triangle === 'top-left',
	    'top-right-triangle': triangle === 'top-right',
	    'bottom-right-triangle': triangle === 'bottom-right'
	  });
	
	  var handleChange = function handleChange(hex, e) {
	    return onChange({ hex: hex, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'github-picker' },
	    _react2.default.createElement('div', { style: styles.triangleShadow }),
	    _react2.default.createElement('div', { style: styles.triangle }),
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_GithubSwatch2.default, { color: c, key: c, onClick: handleChange });
	    })
	  );
	};
	
	Github.defaultProps = {
	  width: '200px',
	  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
	  triangle: 'top-left'
	};
	
	exports.default = (0, _common.ColorWrap)(Github);

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GithubSwatch = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GithubSwatch = exports.GithubSwatch = function GithubSwatch(_ref) {
	  var hover = _ref.hover,
	      color = _ref.color,
	      onClick = _ref.onClick;
	
	  var hoverSwatch = {
	    position: 'relative',
	    zIndex: '2',
	    outline: '2px solid #fff',
	    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
	  };
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        width: '25px',
	        height: '25px'
	      }
	    },
	    'hover': {
	      swatch: hoverSwatch
	    }
	  }, { hover: hover });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatch },
	    _react2.default.createElement(_common.Swatch, { color: color, onClick: onClick, focusStyle: hoverSwatch })
	  );
	};
	
	exports.default = (0, _reactcss.handleHover)(GithubSwatch);

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HuePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(19);
	
	var _HuePointer = __webpack_require__(997);
	
	var _HuePointer2 = _interopRequireDefault(_HuePointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HuePicker = exports.HuePicker = function HuePicker(_ref) {
	  var width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      hsl = _ref.hsl,
	      direction = _ref.direction,
	      pointer = _ref.pointer;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        position: 'relative',
	        width: width,
	        height: height
	      },
	      hue: {
	        radius: '2px'
	      }
	    }
	  });
	
	  // Overwrite to provide pure hue color
	  var handleChange = function handleChange(data) {
	    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'hue-picker' },
	    _react2.default.createElement(_common.Hue, _extends({}, styles.hue, {
	      hsl: hsl,
	      pointer: pointer,
	      onChange: handleChange,
	      direction: direction
	    }))
	  );
	};
	
	HuePicker.defaultProps = {
	  width: '316px',
	  height: '16px',
	  direction: 'horizontal',
	  pointer: _HuePointer2.default
	};
	
	exports.default = (0, _common.ColorWrap)(HuePicker);

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderPointer = exports.SliderPointer = function SliderPointer(_ref) {
	  var direction = _ref.direction;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '18px',
	        height: '18px',
	        borderRadius: '50%',
	        transform: 'translate(-9px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    },
	    'vertical': {
	      picker: {
	        transform: 'translate(-3px, -9px)'
	      }
	    }
	  }, { vertical: direction === 'vertical' });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = SliderPointer;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Material = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(62);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactMaterialDesign = __webpack_require__(224);
	
	var _common = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Material = exports.Material = function Material(_ref) {
	  var onChange = _ref.onChange,
	      hex = _ref.hex,
	      rgb = _ref.rgb;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      material: {
	        width: '98px',
	        height: '98px',
	        padding: '16px',
	        fontFamily: 'Roboto'
	      },
	      HEXwrap: {
	        position: 'relative'
	      },
	      HEXinput: {
	        width: '100%',
	        marginTop: '12px',
	        fontSize: '15px',
	        color: '#333',
	        padding: '0px',
	        border: '0px',
	        borderBottom: '2px solid ' + hex,
	        outline: 'none',
	        height: '30px'
	      },
	      HEXlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        fontSize: '11px',
	        color: '#999999',
	        textTransform: 'capitalize'
	      },
	      Hex: {
	        style: {}
	      },
	      RGBwrap: {
	        position: 'relative'
	      },
	      RGBinput: {
	        width: '100%',
	        marginTop: '12px',
	        fontSize: '15px',
	        color: '#333',
	        padding: '0px',
	        border: '0px',
	        borderBottom: '1px solid #eee',
	        outline: 'none',
	        height: '30px'
	      },
	      RGBlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        fontSize: '11px',
	        color: '#999999',
	        textTransform: 'capitalize'
	      },
	      split: {
	        display: 'flex',
	        marginRight: '-10px',
	        paddingTop: '11px'
	      },
	      third: {
	        flex: '1',
	        paddingRight: '10px'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      _color2.default.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    _reactMaterialDesign.Raised,
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: styles.material, className: 'material-picker' },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	        label: 'hex',
	        value: hex,
	        onChange: handleChange
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.split, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'r', value: rgb.r,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'g',
	            value: rgb.g,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'b',
	            value: rgb.b,
	            onChange: handleChange
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _common.ColorWrap)(Material);

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Photoshop = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(19);
	
	var _PhotoshopFields = __webpack_require__(1001);
	
	var _PhotoshopFields2 = _interopRequireDefault(_PhotoshopFields);
	
	var _PhotoshopPointerCircle = __webpack_require__(1003);
	
	var _PhotoshopPointerCircle2 = _interopRequireDefault(_PhotoshopPointerCircle);
	
	var _PhotoshopPointer = __webpack_require__(1002);
	
	var _PhotoshopPointer2 = _interopRequireDefault(_PhotoshopPointer);
	
	var _PhotoshopButton = __webpack_require__(1000);
	
	var _PhotoshopButton2 = _interopRequireDefault(_PhotoshopButton);
	
	var _PhotoshopPreviews = __webpack_require__(1004);
	
	var _PhotoshopPreviews2 = _interopRequireDefault(_PhotoshopPreviews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Photoshop = exports.Photoshop = function (_React$Component) {
	  _inherits(Photoshop, _React$Component);
	
	  function Photoshop(props) {
	    _classCallCheck(this, Photoshop);
	
	    var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
	
	    _this.state = {
	      currentColor: props.hex
	    };
	    return _this;
	  }
	
	  _createClass(Photoshop, [{
	    key: 'render',
	    value: function render() {
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            background: '#DCDCDC',
	            borderRadius: '4px',
	            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
	            boxSizing: 'initial',
	            width: '513px'
	          },
	          head: {
	            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
	            borderBottom: '1px solid #B1B1B1',
	            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
	            height: '23px',
	            lineHeight: '24px',
	            borderRadius: '4px 4px 0 0',
	            fontSize: '13px',
	            color: '#4D4D4D',
	            textAlign: 'center'
	          },
	          body: {
	            padding: '15px 15px 0',
	            display: 'flex'
	          },
	          saturation: {
	            width: '256px',
	            height: '256px',
	            position: 'relative',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0',
	            overflow: 'hidden'
	          },
	          hue: {
	            position: 'relative',
	            height: '256px',
	            width: '19px',
	            marginLeft: '10px',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0'
	          },
	          controls: {
	            width: '180px',
	            marginLeft: '10px'
	          },
	          top: {
	            display: 'flex'
	          },
	          previews: {
	            width: '60px'
	          },
	          actions: {
	            flex: '1',
	            marginLeft: '20px'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.picker, className: 'photoshop-picker' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.head },
	          this.props.header
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.body, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.saturation },
	            _react2.default.createElement(_common.Saturation, {
	              hsl: this.props.hsl,
	              hsv: this.props.hsv,
	              pointer: _PhotoshopPointerCircle2.default,
	              onChange: this.props.onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, {
	              direction: 'vertical',
	              hsl: this.props.hsl,
	              pointer: _PhotoshopPointer2.default,
	              onChange: this.props.onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.controls },
	            _react2.default.createElement(
	              'div',
	              { style: styles.top, className: 'flexbox-fix' },
	              _react2.default.createElement(
	                'div',
	                { style: styles.previews },
	                _react2.default.createElement(_PhotoshopPreviews2.default, {
	                  rgb: this.props.rgb,
	                  currentColor: this.state.currentColor
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: styles.actions },
	                _react2.default.createElement(_PhotoshopButton2.default, { label: 'OK', onClick: this.props.onAccept, active: true }),
	                _react2.default.createElement(_PhotoshopButton2.default, { label: 'Cancel', onClick: this.props.onCancel }),
	                _react2.default.createElement(_PhotoshopFields2.default, {
	                  onChange: this.props.onChange,
	                  rgb: this.props.rgb,
	                  hsv: this.props.hsv,
	                  hex: this.props.hex
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Photoshop;
	}(_react2.default.Component);
	
	Photoshop.defaultProps = {
	  header: 'Color Picker'
	};
	
	exports.default = (0, _common.ColorWrap)(Photoshop);

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopBotton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopBotton = exports.PhotoshopBotton = function PhotoshopBotton(_ref) {
	  var onClick = _ref.onClick,
	      label = _ref.label,
	      children = _ref.children,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      button: {
	        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
	        border: '1px solid #878787',
	        borderRadius: '2px',
	        height: '20px',
	        boxShadow: '0 1px 0 0 #EAEAEA',
	        fontSize: '14px',
	        color: '#000',
	        lineHeight: '20px',
	        textAlign: 'center',
	        marginBottom: '10px',
	        cursor: 'pointer'
	      }
	    },
	    'active': {
	      button: {
	        boxShadow: '0 0 0 1px #878787'
	      }
	    }
	  }, { active: active });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.button, onClick: onClick },
	    label || children
	  );
	};
	
	exports.default = PhotoshopBotton;

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPicker = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(62);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPicker = exports.PhotoshopPicker = function PhotoshopPicker(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsv = _ref.hsv,
	      hex = _ref.hex;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        paddingTop: '5px',
	        paddingBottom: '9px',
	        width: '80px',
	        position: 'relative'
	      },
	      divider: {
	        height: '5px'
	      },
	      RGBwrap: {
	        position: 'relative'
	      },
	      RGBinput: {
	        marginLeft: '40%',
	        width: '40%',
	        height: '18px',
	        border: '1px solid #888888',
	        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	        marginBottom: '5px',
	        fontSize: '13px',
	        paddingLeft: '3px',
	        marginRight: '10px'
	      },
	      RGBlabel: {
	        left: '0px',
	        width: '34px',
	        textTransform: 'uppercase',
	        fontSize: '13px',
	        height: '18px',
	        lineHeight: '22px',
	        position: 'absolute'
	      },
	      HEXwrap: {
	        position: 'relative'
	      },
	      HEXinput: {
	        marginLeft: '20%',
	        width: '80%',
	        height: '18px',
	        border: '1px solid #888888',
	        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	        marginBottom: '6px',
	        fontSize: '13px',
	        paddingLeft: '3px'
	      },
	      HEXlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        width: '14px',
	        textTransform: 'uppercase',
	        fontSize: '13px',
	        height: '18px',
	        lineHeight: '22px'
	      },
	      fieldSymbols: {
	        position: 'absolute',
	        top: '5px',
	        right: '-7px',
	        fontSize: '13px'
	      },
	      symbol: {
	        height: '20px',
	        lineHeight: '22px',
	        paddingBottom: '7px'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data['#']) {
	      _color2.default.isValidHex(data['#']) && onChange({
	        hex: data['#'],
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    } else if (data.h || data.s || data.v) {
	      onChange({
	        h: data.h || hsv.h,
	        s: data.s || hsv.s,
	        v: data.v || hsv.v,
	        source: 'hsv'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields },
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'h',
	      value: Math.round(hsv.h),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 's',
	      value: Math.round(hsv.s * 100),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'v',
	      value: Math.round(hsv.v * 100),
	      onChange: handleChange
	    }),
	    _react2.default.createElement('div', { style: styles.divider }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'r',
	      value: rgb.r,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'g',
	      value: rgb.g,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'b',
	      value: rgb.b,
	      onChange: handleChange
	    }),
	    _react2.default.createElement('div', { style: styles.divider }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	      label: '#',
	      value: hex.replace('#', ''),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.fieldSymbols },
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '\xB0'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '%'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '%'
	      )
	    )
	  );
	};
	
	exports.default = PhotoshopPicker;

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      triangle: {
	        width: 0,
	        height: 0,
	        borderStyle: 'solid',
	        borderWidth: '4px 0 4px 6px',
	        borderColor: 'transparent transparent transparent #fff',
	        position: 'absolute',
	        top: '1px',
	        left: '1px'
	      },
	      triangleBorder: {
	        width: 0,
	        height: 0,
	        borderStyle: 'solid',
	        borderWidth: '5px 0 5px 8px',
	        borderColor: 'transparent transparent transparent #555'
	      },
	
	      left: {
	        Extend: 'triangleBorder',
	        transform: 'translate(-13px, -4px)'
	      },
	      leftInside: {
	        Extend: 'triangle',
	        transform: 'translate(-8px, -5px)'
	      },
	
	      right: {
	        Extend: 'triangleBorder',
	        transform: 'translate(20px, -14px) rotate(180deg)'
	      },
	      rightInside: {
	        Extend: 'triangle',
	        transform: 'translate(-8px, -5px)'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.pointer },
	    _react2.default.createElement(
	      'div',
	      { style: styles.left },
	      _react2.default.createElement('div', { style: styles.leftInside })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.right },
	      _react2.default.createElement('div', { style: styles.rightInside })
	    )
	  );
	};
	
	exports.default = PhotoshopPointerCircle;

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
	  var hsl = _ref.hsl;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        boxShadow: 'inset 0 0 0 1px #fff',
	        transform: 'translate(-6px, -6px)'
	      }
	    },
	    'black-outline': {
	      picker: {
	        boxShadow: 'inset 0 0 0 1px #000'
	      }
	    }
	  }, { 'black-outline': hsl.l > 0.5 });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = PhotoshopPointerCircle;

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPreviews = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPreviews = exports.PhotoshopPreviews = function PhotoshopPreviews(_ref) {
	  var rgb = _ref.rgb,
	      currentColor = _ref.currentColor;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        border: '1px solid #B3B3B3',
	        borderBottom: '1px solid #F0F0F0',
	        marginBottom: '2px',
	        marginTop: '1px'
	      },
	      new: {
	        height: '34px',
	        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
	        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
	      },
	      current: {
	        height: '34px',
	        background: currentColor,
	        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
	      },
	      label: {
	        fontSize: '14px',
	        color: '#000',
	        textAlign: 'center'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: styles.label },
	      'new'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatches },
	      _react2.default.createElement('div', { style: styles.new }),
	      _react2.default.createElement('div', { style: styles.current })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.label },
	      'current'
	    )
	  );
	};
	
	exports.default = PhotoshopPreviews;

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sketch = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(19);
	
	var _SketchFields = __webpack_require__(1006);
	
	var _SketchFields2 = _interopRequireDefault(_SketchFields);
	
	var _SketchPresetColors = __webpack_require__(1007);
	
	var _SketchPresetColors2 = _interopRequireDefault(_SketchPresetColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sketch = exports.Sketch = function Sketch(_ref) {
	  var width = _ref.width,
	      rgb = _ref.rgb,
	      hex = _ref.hex,
	      hsv = _ref.hsv,
	      hsl = _ref.hsl,
	      onChange = _ref.onChange,
	      disableAlpha = _ref.disableAlpha,
	      presetColors = _ref.presetColors,
	      renderers = _ref.renderers;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: width,
	        padding: '10px 10px 0',
	        boxSizing: 'initial',
	        background: '#fff',
	        borderRadius: '4px',
	        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
	      },
	      saturation: {
	        width: '100%',
	        paddingBottom: '75%',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      Saturation: {
	        radius: '3px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	      controls: {
	        display: 'flex'
	      },
	      sliders: {
	        padding: '4px 0',
	        flex: '1'
	      },
	      color: {
	        width: '24px',
	        height: '24px',
	        position: 'relative',
	        marginTop: '4px',
	        marginLeft: '4px',
	        borderRadius: '3px'
	      },
	      activeColor: {
	        absolute: '0px 0px 0px 0px',
	        borderRadius: '2px',
	        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	      hue: {
	        position: 'relative',
	        height: '10px',
	        overflow: 'hidden'
	      },
	      Hue: {
	        radius: '2px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	
	      alpha: {
	        position: 'relative',
	        height: '10px',
	        marginTop: '4px',
	        overflow: 'hidden'
	      },
	      Alpha: {
	        radius: '2px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      }
	    },
	    'disableAlpha': {
	      color: {
	        height: '10px'
	      },
	      hue: {
	        height: '10px'
	      },
	      alpha: {
	        display: 'none'
	      }
	    }
	  }, { disableAlpha: disableAlpha });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'sketch-picker' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        style: styles.Saturation,
	        hsl: hsl,
	        hsv: hsv,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.controls, className: 'flexbox-fix' },
	      _react2.default.createElement(
	        'div',
	        { style: styles.sliders },
	        _react2.default.createElement(
	          'div',
	          { style: styles.hue },
	          _react2.default.createElement(_common.Hue, {
	            style: styles.Hue,
	            hsl: hsl,
	            onChange: onChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.alpha },
	          _react2.default.createElement(_common.Alpha, {
	            style: styles.Alpha,
	            rgb: rgb,
	            hsl: hsl,
	            renderers: renderers,
	            onChange: onChange
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.color },
	        _react2.default.createElement(_common.Checkboard, null),
	        _react2.default.createElement('div', { style: styles.activeColor })
	      )
	    ),
	    _react2.default.createElement(_SketchFields2.default, {
	      rgb: rgb,
	      hsl: hsl,
	      hex: hex,
	      onChange: onChange,
	      disableAlpha: disableAlpha
	    }),
	    _react2.default.createElement(_SketchPresetColors2.default, { colors: presetColors, onClick: onChange })
	  );
	};
	
	Sketch.defaultProps = {
	  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF'],
	  width: 200
	};
	
	exports.default = (0, _common.ColorWrap)(Sketch);

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShetchFields = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(62);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-param-reassign */
	
	var ShetchFields = exports.ShetchFields = function ShetchFields(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hex = _ref.hex,
	      disableAlpha = _ref.disableAlpha;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        display: 'flex',
	        paddingTop: '4px'
	      },
	      single: {
	        flex: '1',
	        paddingLeft: '6px'
	      },
	      alpha: {
	        flex: '1',
	        paddingLeft: '6px'
	      },
	      double: {
	        flex: '2'
	      },
	      input: {
	        width: '80%',
	        padding: '4px 10% 3px',
	        border: 'none',
	        boxShadow: 'inset 0 0 0 1px #ccc',
	        fontSize: '11px'
	      },
	      label: {
	        display: 'block',
	        textAlign: 'center',
	        fontSize: '11px',
	        color: '#222',
	        paddingTop: '3px',
	        paddingBottom: '4px',
	        textTransform: 'capitalize'
	      }
	    },
	    'disableAlpha': {
	      alpha: {
	        display: 'none'
	      }
	    }
	  }, { disableAlpha: disableAlpha });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      _color2.default.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        a: rgb.a,
	        source: 'rgb'
	      }, e);
	    } else if (data.a) {
	      if (data.a < 0) {
	        data.a = 0;
	      } else if (data.a > 100) {
	        data.a = 100;
	      }
	
	      data.a = data.a / 100;
	      onChange({
	        h: hsl.h,
	        s: hsl.s,
	        l: hsl.l,
	        a: data.a,
	        source: 'rgb'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields, className: 'flexbox-fix' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.double },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'hex',
	        value: hex.replace('#', ''),
	        onChange: handleChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'r',
	        value: rgb.r,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'g',
	        value: rgb.g,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'b',
	        value: rgb.b,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.alpha },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'a',
	        value: Math.round(rgb.a * 100),
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '100'
	      })
	    )
	  );
	};
	
	exports.default = ShetchFields;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SketchPresetColors = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(223);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SketchPresetColors = exports.SketchPresetColors = function SketchPresetColors(_ref) {
	  var colors = _ref.colors,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      colors: {
	        margin: '0 -10px',
	        padding: '10px 0 0 10px',
	        borderTop: '1px solid #eee',
	        display: 'flex',
	        flexWrap: 'wrap',
	        position: 'relative'
	      },
	      swatchWrap: {
	        width: '16px',
	        height: '16px',
	        margin: '0 10px 10px 0'
	      },
	      swatch: {
	        borderRadius: '3px',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
	      }
	    },
	    'no-presets': {
	      colors: {
	        display: 'none'
	      }
	    }
	  }, {
	    'no-presets': !colors || !colors.length
	  });
	
	  var handleClick = function handleClick(hex, e) {
	    onClick({
	      hex: hex,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.colors, className: 'flexbox-fix' },
	    colors.map(function (colorObjOrString) {
	      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
	      return _react2.default.createElement(
	        'div',
	        { key: c.color, style: styles.swatchWrap },
	        _react2.default.createElement(_common.Swatch, _extends({}, c, {
	          style: styles.swatch,
	          onClick: handleClick,
	          focusStyle: {
	            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
	          }
	        }))
	      );
	    })
	  );
	};
	SketchPresetColors.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    color: _propTypes2.default.string,
	    title: _propTypes2.default.string
	  })]))
	};
	
	exports.default = SketchPresetColors;

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slider = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(19);
	
	var _SliderSwatches = __webpack_require__(1011);
	
	var _SliderSwatches2 = _interopRequireDefault(_SliderSwatches);
	
	var _SliderPointer = __webpack_require__(1009);
	
	var _SliderPointer2 = _interopRequireDefault(_SliderPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Slider = exports.Slider = function Slider(_ref) {
	  var hsl = _ref.hsl,
	      onChange = _ref.onChange,
	      pointer = _ref.pointer;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      hue: {
	        height: '12px',
	        position: 'relative'
	      },
	      Hue: {
	        radius: '2px'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'slider-picker' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.hue },
	      _react2.default.createElement(_common.Hue, {
	        style: styles.Hue,
	        hsl: hsl,
	        pointer: pointer,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatches },
	      _react2.default.createElement(_SliderSwatches2.default, { hsl: hsl, onClick: onChange })
	    )
	  );
	};
	
	Slider.defaultProps = {
	  pointer: _SliderPointer2.default
	};
	
	exports.default = (0, _common.ColorWrap)(Slider);

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderPointer = exports.SliderPointer = function SliderPointer() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '14px',
	        height: '14px',
	        borderRadius: '6px',
	        transform: 'translate(-7px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = SliderPointer;

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatch = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderSwatch = exports.SliderSwatch = function SliderSwatch(_ref) {
	  var hsl = _ref.hsl,
	      offset = _ref.offset,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      active = _ref.active,
	      first = _ref.first,
	      last = _ref.last;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        height: '12px',
	        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
	        cursor: 'pointer'
	      }
	    },
	    'first': {
	      swatch: {
	        borderRadius: '2px 0 0 2px'
	      }
	    },
	    'last': {
	      swatch: {
	        borderRadius: '0 2px 2px 0'
	      }
	    },
	    'active': {
	      swatch: {
	        transform: 'scaleY(1.8)',
	        borderRadius: '3.6px/2px'
	      }
	    }
	  }, { active: active, first: first, last: last });
	
	  var handleClick = function handleClick(e) {
	    return onClick({
	      h: hsl.h,
	      s: 0.5,
	      l: offset,
	      source: 'hsl'
	    }, e);
	  };
	
	  return _react2.default.createElement('div', { style: styles.swatch, onClick: handleClick });
	};
	
	exports.default = SliderSwatch;

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatches = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _SliderSwatch = __webpack_require__(1010);
	
	var _SliderSwatch2 = _interopRequireDefault(_SliderSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderSwatches = exports.SliderSwatches = function SliderSwatches(_ref) {
	  var onClick = _ref.onClick,
	      hsl = _ref.hsl;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        marginTop: '20px'
	      },
	      swatch: {
	        boxSizing: 'border-box',
	        width: '20%',
	        paddingRight: '1px',
	        float: 'left'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatches },
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.80',
	        active: Math.round(hsl.l * 100) / 100 === 0.80 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick,
	        first: true
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.65',
	        active: Math.round(hsl.l * 100) / 100 === 0.65 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.50',
	        active: Math.round(hsl.l * 100) / 100 === 0.50 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.35',
	        active: Math.round(hsl.l * 100) / 100 === 0.35 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.20',
	        active: Math.round(hsl.l * 100) / 100 === 0.20 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick,
	        last: true
	      })
	    ),
	    _react2.default.createElement('div', { style: styles.clear })
	  );
	};
	
	exports.default = SliderSwatches;

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatches = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(71);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _color = __webpack_require__(62);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _materialColors = __webpack_require__(361);
	
	var material = _interopRequireWildcard(_materialColors);
	
	var _common = __webpack_require__(19);
	
	var _reactMaterialDesign = __webpack_require__(224);
	
	var _SwatchesGroup = __webpack_require__(1014);
	
	var _SwatchesGroup2 = _interopRequireDefault(_SwatchesGroup);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Swatches = exports.Swatches = function Swatches(_ref) {
	  var width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      colors = _ref.colors,
	      hex = _ref.hex;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: width,
	        height: height
	      },
	      overflow: {
	        height: height,
	        overflowY: 'scroll'
	      },
	      body: {
	        padding: '16px 0 6px 16px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    _color2.default.isValidHex(data) && onChange({
	      hex: data,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'swatches-picker' },
	    _react2.default.createElement(
	      _reactMaterialDesign.Raised,
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: styles.overflow },
	        _react2.default.createElement(
	          'div',
	          { style: styles.body },
	          (0, _map2.default)(colors, function (group) {
	            return _react2.default.createElement(_SwatchesGroup2.default, {
	              key: group.toString(),
	              group: group,
	              active: hex,
	              onClick: handleChange
	            });
	          }),
	          _react2.default.createElement('div', { style: styles.clear })
	        )
	      )
	    )
	  );
	};
	
	/* eslint-disable max-len */
	Swatches.defaultProps = {
	  width: 320,
	  height: 240,
	  colors: [[material.red['900'], material.red['700'], material.red['500'], material.red['300'], material.red['100']], [material.pink['900'], material.pink['700'], material.pink['500'], material.pink['300'], material.pink['100']], [material.purple['900'], material.purple['700'], material.purple['500'], material.purple['300'], material.purple['100']], [material.deepPurple['900'], material.deepPurple['700'], material.deepPurple['500'], material.deepPurple['300'], material.deepPurple['100']], [material.indigo['900'], material.indigo['700'], material.indigo['500'], material.indigo['300'], material.indigo['100']], [material.blue['900'], material.blue['700'], material.blue['500'], material.blue['300'], material.blue['100']], [material.lightBlue['900'], material.lightBlue['700'], material.lightBlue['500'], material.lightBlue['300'], material.lightBlue['100']], [material.cyan['900'], material.cyan['700'], material.cyan['500'], material.cyan['300'], material.cyan['100']], [material.teal['900'], material.teal['700'], material.teal['500'], material.teal['300'], material.teal['100']], ['#194D33', material.green['700'], material.green['500'], material.green['300'], material.green['100']], [material.lightGreen['900'], material.lightGreen['700'], material.lightGreen['500'], material.lightGreen['300'], material.lightGreen['100']], [material.lime['900'], material.lime['700'], material.lime['500'], material.lime['300'], material.lime['100']], [material.yellow['900'], material.yellow['700'], material.yellow['500'], material.yellow['300'], material.yellow['100']], [material.amber['900'], material.amber['700'], material.amber['500'], material.amber['300'], material.amber['100']], [material.orange['900'], material.orange['700'], material.orange['500'], material.orange['300'], material.orange['100']], [material.deepOrange['900'], material.deepOrange['700'], material.deepOrange['500'], material.deepOrange['300'], material.deepOrange['100']], [material.brown['900'], material.brown['700'], material.brown['500'], material.brown['300'], material.brown['100']], [material.blueGrey['900'], material.blueGrey['700'], material.blueGrey['500'], material.blueGrey['300'], material.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']]
	};
	
	exports.default = (0, _common.ColorWrap)(Swatches);

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesColor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwatchesColor = exports.SwatchesColor = function SwatchesColor(_ref) {
	  var color = _ref.color,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      first = _ref.first,
	      last = _ref.last,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      color: {
	        width: '40px',
	        height: '24px',
	        cursor: 'pointer',
	        background: color,
	        marginBottom: '1px'
	      },
	      check: {
	        fill: '#fff',
	        marginLeft: '8px',
	        display: 'none'
	      }
	    },
	    'first': {
	      color: {
	        overflow: 'hidden',
	        borderRadius: '2px 2px 0 0'
	      }
	    },
	    'last': {
	      color: {
	        overflow: 'hidden',
	        borderRadius: '0 0 2px 2px'
	      }
	    },
	    'active': {
	      check: {
	        display: 'block'
	      }
	    },
	    'color-#FFFFFF': {
	      color: {
	        boxShadow: 'inset 0 0 0 1px #ddd'
	      },
	      check: {
	        fill: '#333'
	      }
	    },
	    'transparent': {
	      check: {
	        fill: '#333'
	      }
	    }
	  }, {
	    first: first,
	    last: last,
	    active: active,
	    'color-#FFFFFF': color === '#FFFFFF',
	    'transparent': color === 'transparent'
	  });
	
	  return _react2.default.createElement(
	    _common.Swatch,
	    {
	      color: color,
	      style: styles.color,
	      onClick: onClick,
	      focusStyle: { boxShadow: '0 0 4px ' + color }
	    },
	    _react2.default.createElement(
	      'div',
	      { style: styles.check },
	      _react2.default.createElement(
	        'svg',
	        { style: { width: '24px', height: '24px' }, viewBox: '0 0 24 24' },
	        _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
	      )
	    )
	  );
	};
	
	exports.default = SwatchesColor;

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesGroup = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(71);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _SwatchesColor = __webpack_require__(1013);
	
	var _SwatchesColor2 = _interopRequireDefault(_SwatchesColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwatchesGroup = exports.SwatchesGroup = function SwatchesGroup(_ref) {
	  var onClick = _ref.onClick,
	      group = _ref.group,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      group: {
	        paddingBottom: '10px',
	        width: '40px',
	        float: 'left',
	        marginRight: '10px'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.group },
	    (0, _map2.default)(group, function (color, i) {
	      return _react2.default.createElement(_SwatchesColor2.default, {
	        key: color,
	        color: color,
	        active: color.toLowerCase() === active,
	        first: i === 0,
	        last: i === group.length - 1,
	        onClick: onClick
	      });
	    })
	  );
	};
	
	exports.default = SwatchesGroup;

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Twitter = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(71);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _color = __webpack_require__(62);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Twitter = exports.Twitter = function Twitter(_ref) {
	  var onChange = _ref.onChange,
	      hex = _ref.hex,
	      colors = _ref.colors,
	      width = _ref.width,
	      triangle = _ref.triangle;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        border: '0 solid rgba(0,0,0,0.25)',
	        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
	        borderRadius: '4px',
	        position: 'relative'
	      },
	      body: {
	        padding: '15px 9px 9px 15px'
	      },
	      label: {
	        fontSize: '18px',
	        color: '#fff'
	      },
	      triangle: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 9px 10px 9px',
	        borderColor: 'transparent transparent #fff transparent',
	        position: 'absolute'
	      },
	      triangleShadow: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 9px 10px 9px',
	        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
	        position: 'absolute'
	      },
	      hash: {
	        background: '#F0F0F0',
	        height: '30px',
	        width: '30px',
	        borderRadius: '4px 0 0 4px',
	        float: 'left',
	        color: '#98A1A4',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center'
	      },
	      input: {
	        width: '100px',
	        fontSize: '14px',
	        color: '#666',
	        border: '0px',
	        outline: 'none',
	        height: '28px',
	        boxShadow: 'inset 0 0 0 1px #F0F0F0',
	        borderRadius: '0 4px 4px 0',
	        float: 'left',
	        paddingLeft: '8px'
	      },
	      swatch: {
	        width: '30px',
	        height: '30px',
	        float: 'left',
	        borderRadius: '4px',
	        margin: '0 6px 6px 0'
	      },
	      clear: {
	        clear: 'both'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      },
	      triangleShadow: {
	        display: 'none'
	      }
	    },
	    'top-left-triangle': {
	      triangle: {
	        top: '-10px',
	        left: '12px'
	      },
	      triangleShadow: {
	        top: '-11px',
	        left: '12px'
	      }
	    },
	    'top-right-triangle': {
	      triangle: {
	        top: '-10px',
	        right: '12px'
	      },
	      triangleShadow: {
	        top: '-11px',
	        right: '12px'
	      }
	    }
	  }, {
	    'hide-triangle': triangle === 'hide',
	    'top-left-triangle': triangle === 'top-left',
	    'top-right-triangle': triangle === 'top-right'
	  });
	
	  var handleChange = function handleChange(hexcode, e) {
	    _color2.default.isValidHex(hexcode) && onChange({
	      hex: hexcode,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'twitter-picker' },
	    _react2.default.createElement('div', { style: styles.triangleShadow }),
	    _react2.default.createElement('div', { style: styles.triangle }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      (0, _map2.default)(colors, function (c, i) {
	        return _react2.default.createElement(_common.Swatch, {
	          key: i,
	          color: c,
	          hex: c,
	          style: styles.swatch,
	          onClick: handleChange,
	          focusStyle: {
	            boxShadow: '0 0 4px ' + c
	          }
	        });
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.hash },
	        '#'
	      ),
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input },
	        value: hex.replace('#', ''),
	        onChange: handleChange
	      }),
	      _react2.default.createElement('div', { style: styles.clear })
	    )
	  );
	};
	
	Twitter.defaultProps = {
	  width: '276px',
	  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
	  triangle: 'top-left'
	};
	
	exports.default = (0, _common.ColorWrap)(Twitter);

/***/ },
/* 1016 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChange = calculateChange;
	function calculateChange(e, skip, props, container) {
	  !skip && e.preventDefault();
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (props.direction === 'vertical') {
	    var a = void 0;
	    if (top < 0) {
	      a = 0;
	    } else if (top > containerHeight) {
	      a = 1;
	    } else {
	      a = Math.round(top * 100 / containerHeight) / 100;
	    }
	
	    if (props.hsl.a !== a) {
	      return {
	        h: props.hsl.h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: a,
	        source: 'rgb'
	      };
	    }
	  } else {
	    var _a = void 0;
	    if (left < 0) {
	      _a = 0;
	    } else if (left > containerWidth) {
	      _a = 1;
	    } else {
	      _a = Math.round(left * 100 / containerWidth) / 100;
	    }
	
	    if (props.a !== _a) {
	      return {
	        h: props.hsl.h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: _a,
	        source: 'rgb'
	      };
	    }
	  }
	  return null;
	}

/***/ },
/* 1017 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.render = render;
	exports.get = get;
	var checkboardCache = {};
	
	function render(c1, c2, size, serverCanvas) {
	  if (typeof document === 'undefined' && !serverCanvas) return null;
	  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
	  canvas.width = size * 2;
	  canvas.height = size * 2;
	  var ctx = canvas.getContext('2d');
	  if (!ctx) return null; // If no context can be found, return early.
	  ctx.fillStyle = c1;
	  ctx.fillRect(0, 0, canvas.width, canvas.height);
	  ctx.fillStyle = c2;
	  ctx.fillRect(0, 0, size, size);
	  ctx.translate(size, size);
	  ctx.fillRect(0, 0, size, size);
	  return canvas.toDataURL();
	}
	
	function get(c1, c2, size, serverCanvas) {
	  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
	  var checkboard = render(c1, c2, size, serverCanvas);
	
	  if (checkboardCache[key]) {
	    return checkboardCache[key];
	  }
	  checkboardCache[key] = checkboard;
	  return checkboard;
	}

/***/ },
/* 1018 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChange = calculateChange;
	function calculateChange(e, skip, props, container) {
	  !skip && e.preventDefault();
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (props.direction === 'vertical') {
	    var h = void 0;
	    if (top < 0) {
	      h = 359;
	    } else if (top > containerHeight) {
	      h = 0;
	    } else {
	      var percent = -(top * 100 / containerHeight) + 100;
	      h = 360 * percent / 100;
	    }
	
	    if (props.hsl.h !== h) {
	      return {
	        h: h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: props.hsl.a,
	        source: 'rgb'
	      };
	    }
	  } else {
	    var _h = void 0;
	    if (left < 0) {
	      _h = 0;
	    } else if (left > containerWidth) {
	      _h = 359;
	    } else {
	      var _percent = left * 100 / containerWidth;
	      _h = 360 * _percent / 100;
	    }
	
	    if (props.hsl.h !== _h) {
	      return {
	        h: _h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: props.hsl.a,
	        source: 'rgb'
	      };
	    }
	  }
	  return null;
	}

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleFocus = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var handleFocus = exports.handleFocus = function handleFocus(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Focus, _React$Component);
	
	    function Focus() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Focus);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
	        return _this.setState({ focus: true });
	      }, _this.handleBlur = function () {
	        return _this.setState({ focus: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onFocus: _this.handleFocus, onBlur: _this.handleBlur },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Focus;
	  }(_react2.default.Component);
	};

/***/ },
/* 1020 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChange = calculateChange;
	function calculateChange(e, skip, props, container) {
	  !skip && e.preventDefault();
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (left < 0) {
	    left = 0;
	  } else if (left > containerWidth) {
	    left = containerWidth;
	  } else if (top < 0) {
	    top = 0;
	  } else if (top > containerHeight) {
	    top = containerHeight;
	  }
	
	  var saturation = left * 100 / containerWidth;
	  var bright = -(top * 100 / containerHeight) + 100;
	
	  return {
	    h: props.hsl.h,
	    s: saturation,
	    v: bright,
	    a: props.hsl.a,
	    source: 'rgb'
	  };
	}

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomPicker = exports.TwitterPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.HuePicker = exports.GithubPicker = exports.CompactPicker = exports.ChromePicker = exports.default = exports.CirclePicker = exports.BlockPicker = exports.AlphaPicker = undefined;
	
	var _Alpha = __webpack_require__(976);
	
	Object.defineProperty(exports, 'AlphaPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Block = __webpack_require__(978);
	
	Object.defineProperty(exports, 'BlockPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Block).default;
	  }
	});
	
	var _Circle = __webpack_require__(984);
	
	Object.defineProperty(exports, 'CirclePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Circle).default;
	  }
	});
	
	var _Chrome = __webpack_require__(980);
	
	Object.defineProperty(exports, 'ChromePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chrome).default;
	  }
	});
	
	var _Compact = __webpack_require__(991);
	
	Object.defineProperty(exports, 'CompactPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Compact).default;
	  }
	});
	
	var _Github = __webpack_require__(994);
	
	Object.defineProperty(exports, 'GithubPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Github).default;
	  }
	});
	
	var _Hue = __webpack_require__(996);
	
	Object.defineProperty(exports, 'HuePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Material = __webpack_require__(998);
	
	Object.defineProperty(exports, 'MaterialPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Material).default;
	  }
	});
	
	var _Photoshop = __webpack_require__(999);
	
	Object.defineProperty(exports, 'PhotoshopPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Photoshop).default;
	  }
	});
	
	var _Sketch = __webpack_require__(1005);
	
	Object.defineProperty(exports, 'SketchPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sketch).default;
	  }
	});
	
	var _Slider = __webpack_require__(1008);
	
	Object.defineProperty(exports, 'SliderPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Slider).default;
	  }
	});
	
	var _Swatches = __webpack_require__(1012);
	
	Object.defineProperty(exports, 'SwatchesPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatches).default;
	  }
	});
	
	var _Twitter = __webpack_require__(1015);
	
	Object.defineProperty(exports, 'TwitterPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Twitter).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(480);
	
	Object.defineProperty(exports, 'CustomPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Chrome2 = _interopRequireDefault(_Chrome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chrome2.default;

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isString = __webpack_require__(221);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Link, [{
	    key: 'handleClick',
	    value: function handleClick(e) {
	      if (this.props.onClick) {
	        this.props.onClick(e, this.props.callbackValue);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var a;
	      if ((0, _isString2.default)(this.props.onClick)) {
	        a = _react2.default.createElement(
	          'a',
	          { style: { textDecoration: 'none' }, href: this.props.onClick, target: this.props.newTab && '_blank' },
	          this.props.children
	        );
	      } else {
	        a = _react2.default.createElement(
	          'a',
	          { style: { textDecoration: 'none' }, onClick: this.handleClick },
	          this.props.children
	        );
	      }
	
	      return a;
	    }
	  }]);
	
	  return Link;
	}(_react2.default.Component);
	
	// Link.propTypes =
	//   onClick: PropTypes.oneOfType(
	//     PropTypes.string,
	//     PropTypes.func
	//   );
	
	Link.defaultProps = {
	  newTab: false
	};
	
	exports.default = Link;

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node: true, esnext: true */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(223);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Raised = function (_React$Component) {
	  _inherits(Raised, _React$Component);
	
	  function Raised() {
	    _classCallCheck(this, Raised);
	
	    return _possibleConstructorReturn(this, (Raised.__proto__ || Object.getPrototypeOf(Raised)).apply(this, arguments));
	  }
	
	  _createClass(Raised, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            position: 'relative'
	          },
	          content: {
	            position: 'relative'
	          },
	          bg: {
	            absolute: '0px 0px 0px 0px',
	            boxShadow: '0 ${ this.props.zDepth }px ${ this.props.zDepth * 4 }px rgba(0,0,0,.24)',
	            borderRadius: this.props.radius,
	            background: this.props.background
	          }
	        },
	        'zDepth-0': {
	          bg: {
	            boxShadow: 'none'
	          }
	        },
	
	        'zDepth-1': {
	          bg: {
	            boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
	          }
	        },
	        'zDepth-2': {
	          bg: {
	            boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
	          }
	        },
	        'zDepth-3': {
	          bg: {
	            boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
	          }
	        },
	        'zDepth-4': {
	          bg: {
	            boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
	          }
	        },
	        'zDepth-5': {
	          bg: {
	            boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
	          }
	        },
	        'square': {
	          bg: {
	            borderRadius: '0'
	          }
	        },
	        'circle': {
	          bg: {
	            borderRadius: '50%'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap },
	        _react2.default.createElement('div', { style: styles.bg }),
	        _react2.default.createElement(
	          'div',
	          { style: styles.content },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Raised;
	}(_react2.default.Component);
	
	Raised.propTypes = {
	  background: _propTypes2.default.string,
	  zDepth: _propTypes2.default.oneOf(['0', '1', '2', '3', '4', '5', 0, 1, 2, 3, 4, 5]),
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Raised.defaultProps = {
	  background: '#fff',
	  zDepth: '1',
	  radius: '2px'
	};
	
	exports.default = Raised;

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(223);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tab = function (_React$Component) {
	  _inherits(Tab, _React$Component);
	
	  function Tab() {
	    _classCallCheck(this, Tab);
	
	    var _this = _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).call(this));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tab, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      if (this.props.selectable !== false) {
	        this.props.onClick(this.props.tab);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          tab: {
	            color: this.props.inactive || this.props.color,
	            cursor: 'pointer',
	            paddingLeft: '12px',
	            paddingRight: '12px',
	            height: '48px',
	            lineHeight: '48px',
	            textAlign: 'center',
	            fontSize: '14px',
	            textTransform: this.props.capitalize === false ? '' : 'uppercase',
	            fontWeight: '500',
	            whiteSpace: 'nowrap',
	            opacity: '.47',
	            transition: 'opacity 100ms linear'
	          }
	        },
	        'selected': {
	          tab: {
	            color: this.props.color,
	            opacity: '.87'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.tab, onClick: this.handleClick },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Tab;
	}(_react2.default.Component);
	
	Tab.propTypes = {
	  selected: _propTypes2.default.bool
	};
	
	Tab.defaultProps = {
	  selected: false,
	  color: '#fff'
	};
	
	exports.default = Tab;

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _isString = __webpack_require__(221);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _Tab = __webpack_require__(1024);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _Link = __webpack_require__(1022);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// var Ink = require('./Ink');
	
	// var context = {
	//   primaryColor: '#2196F3',
	//   accentColor: '#E91E63',
	//   theme: 'light'
	// }
	
	var Tabs = function (_React$Component) {
	  _inherits(Tabs, _React$Component);
	
	  function Tabs(props) {
	    _classCallCheck(this, Tabs);
	
	    var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this));
	
	    var selectedTab;
	    if (props.selectedTab < (props.tabs && props.tabs.length)) {
	      selectedTab = props.selectedTab;
	    } else {
	      selectedTab = 0;
	    }
	
	    _this.state = {
	      selectedTab: selectedTab
	    };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.slide = _this.slide.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tabs, [{
	    key: 'handleClick',
	    value: function handleClick(tab) {
	      if (this.props.onChange) {
	        this.props.onChange(tab);
	      }
	
	      this.setState({
	        selectedTab: tab
	      });
	    }
	  }, {
	    key: 'slide',
	    value: function slide() {
	      if (this.props.tabs.length) {
	        var containerNode = this.refs.tabs.getDOMNode();
	        var containerLeft = containerNode.scrollLeft;
	        var containerRight = containerNode.offsetWidth + containerNode.scrollLeft;
	
	        var selectedNode = this.refs['tab-' + this.state.selectedTab] && this.refs['tab-' + this.state.selectedTab].getDOMNode();
	        var selectedLeft = selectedNode && selectedNode.getBoundingClientRect().left - containerNode.getBoundingClientRect().left + containerNode.scrollLeft;
	        var selectedRight = selectedNode && selectedLeft + selectedNode.offsetWidth;
	
	        // scroll right if tab is off screen
	        if (selectedRight > containerRight) {
	          containerNode.scrollLeft += selectedRight - containerRight;
	        }
	
	        // scroll left if tab is off screen
	        if (selectedLeft < containerLeft) {
	          containerNode.scrollLeft -= containerLeft - selectedLeft;
	        }
	
	        // slide the indicator
	        var indicator = this.refs.indicator;
	        indicator.style.left = selectedLeft + 'px';
	        indicator.style.width = selectedNode.offsetWidth + 'px';
	        indicator.style.height = '2px';
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.slide();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedTab !== this.state.selectedTab) {
	        this.setState({ selectedTab: nextProps.selectedTab });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (nextState.selectedTab >= (nextProps.tabs && nextProps.tabs.length)) {
	        nextState.selectedTab = nextProps.tabs.length - 1;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.slide();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          tabs: {
	            position: 'relative',
	            background: this.props.background
	          },
	          tabWrap: {
	            display: 'flex'
	          },
	          tab: {
	            justifyContent: 'flex-start',
	            minWidth: '68px',
	            maxWidth: '240px'
	          },
	          Tab: {
	            color: this.props.color,
	            inactive: this.props.inactive,
	            capitalize: this.props.capitalize
	          },
	          indicator: {
	            height: '0',
	            position: 'absolute',
	            bottom: '0',
	            left: '0',
	            background: this.props.color,
	            transition: 'all 200ms linear'
	          }
	        },
	        'scrollable': {
	          tabs: {
	            overflowX: 'scroll'
	          },
	          tabWrap: {
	            paddingLeft: '60px',
	            justifyContent: 'flex-start',
	            width: '400%'
	          },
	          tab: {
	            width: 'auto'
	          }
	        },
	        'align-justify': {
	          tabWrap: {
	            justifyContent: 'space-between'
	          },
	          tab: {
	            width: 100 / this.props.tabs.length + '%'
	          }
	        },
	        'align-left': {
	          tabWrap: {
	            paddingLeft: '60px',
	            justifyContent: 'flex-start'
	          },
	          tab: {
	            width: 'auto'
	          }
	        },
	        'align-center': {
	          tabWrap: {
	            justifyContent: 'center'
	          },
	          tab: {
	            width: 'auto'
	          }
	        }
	      }, {
	        'scrollable': this.props.width / this.props.tabs.length < 72
	      }, this.props, this.state);
	
	      var tabs = [];
	      for (var i = 0; i < this.props.tabs.length; i++) {
	        var tab = this.props.tabs[i];
	
	        var label;
	        var callback;
	        var callbackValue;
	        var newTab;
	        if ((0, _isString2.default)(tab)) {
	          label = tab;
	          callback = null;
	        } else {
	          label = tab.label;
	          callback = tab.onClick;
	          callbackValue = tab.callbackValue;
	          newTab = tab.newTab;
	        }
	
	        tabs.push(_react2.default.createElement(
	          'div',
	          { style: styles.tab, ref: 'tab-' + i, key: i },
	          _react2.default.createElement(
	            _Link2.default,
	            { onClick: callback, callbackValue: callbackValue, newTab: newTab },
	            _react2.default.createElement(
	              _Tab2.default,
	              { style: styles.Tab, tab: i, selected: this.state.selectedTab === i, selectable: tab.selectable, onClick: this.handleClick },
	              label
	            )
	          )
	        ));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.tabs, ref: 'tabs' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.tabWrap, className: 'flexbox-fix' },
	          tabs
	        ),
	        _react2.default.createElement('div', { style: styles.indicator, ref: 'indicator' })
	      );
	    }
	  }]);
	
	  return Tabs;
	}(_react2.default.Component);
	
	Tabs.defaultProps = {
	  selectedTab: 0,
	  background: 'transparent',
	  color: '#fff'
	};
	
	exports.default = Tabs;

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node: true, esnext: true */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(5);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tile = function (_React$Component) {
	  _inherits(Tile, _React$Component);
	
	  function Tile() {
	    _classCallCheck(this, Tile);
	
	    return _possibleConstructorReturn(this, (Tile.__proto__ || Object.getPrototypeOf(Tile)).apply(this, arguments));
	  }
	
	  _createClass(Tile, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          tile: {
	            fontSize: '16px',
	            padding: '16px',
	            display: 'flex',
	            justifyContent: 'space-between',
	            color: this.props.color
	          },
	          primary: {
	            display: 'flex',
	            width: '100%'
	          },
	          sidebar: {
	            minWidth: '56px',
	            maxWidth: '56px',
	            flexBasis: '56px' },
	          content: {
	            background: 'none',
	            flex: '1',
	            overflow: 'auto'
	          },
	          secondary: {
	            flexBasis: '42',
	            textAlign: 'center'
	          },
	          sidebarIcon: {
	            marginTop: '-12px',
	            marginLeft: '-12px',
	            marginBottom: '-12px'
	          }
	        },
	        'divider': {
	          tile: {
	            boxShadow: 'inset 0 -1px 0 rgba(0,0,0,.12)'
	          }
	        },
	        'condensed': {
	          tile: {
	            paddingBottom: '0px',
	            paddingTop: '0px',
	            paddingRight: '0px'
	          },
	          sidebar: {
	            minWidth: '28px',
	            maxWidth: '28px',
	            flexBasis: '28px'
	          }
	        }
	      }, {
	        'clickable': this.props.onClick
	      }, this.props);
	
	      var _props$children = _slicedToArray(this.props.children, 2),
	          sidebar = _props$children[0],
	          content = _props$children[1];
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.tile, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.primary, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.sidebar, key: "sidebar-#{ sidebar }" },
	            sidebar
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.content, key: "content-#{ content }" },
	            content
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tile;
	}(_react2.default.Component);
	
	;
	
	exports.default = Tile;

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// jscs: disable
	
	// TinyColor v1.1.2
	// https://github.com/bgrins/TinyColor
	// Brian Grinstead, MIT License
	
	(function() {
	
	var trimLeft = /^[\s,#]+/;
	var trimRight = /\s+$/;
	var tinyCounter = 0;
	var math = Math;
	var mathRound = math.round;
	var mathMin = math.min;
	var mathMax = math.max;
	var mathRandom = math.random;
	
	function tinycolor(color, opts) {
	
			color = (color) ? color : '';
			opts = opts || { };
	
			// If input is already a tinycolor, return itself
			if (color instanceof tinycolor) {
				 return color;
			}
			// If we are called as a function, call using new instead
			if (!(this instanceof tinycolor)) {
					return new tinycolor(color, opts);
			}
	
			var rgb = inputToRGB(color);
			this._originalInput = color,
			this._r = rgb.r,
			this._g = rgb.g,
			this._b = rgb.b,
			this._a = rgb.a,
			this._roundA = mathRound(100*this._a) / 100,
			this._format = opts.format || rgb.format;
			this._gradientType = opts.gradientType;
	
			// Don't let the range of [0,255] come back in [0,1].
			// Potentially lose a little bit of precision here, but will fix issues where
			// .5 gets interpreted as half of the total, instead of half of 1
			// If it was supposed to be 128, this was already taken care of by `inputToRgb`
			if (this._r < 1) { this._r = mathRound(this._r); }
			if (this._g < 1) { this._g = mathRound(this._g); }
			if (this._b < 1) { this._b = mathRound(this._b); }
	
			this._ok = rgb.ok;
			this._tc_id = tinyCounter++;
	}
	
	tinycolor.prototype = {
			isDark: function() {
					return this.getBrightness() < 128;
			},
			isLight: function() {
					return !this.isDark();
			},
			isValid: function() {
					return this._ok;
			},
			getOriginalInput: function() {
				return this._originalInput;
			},
			getFormat: function() {
					return this._format;
			},
			getAlpha: function() {
					return this._a;
			},
			getBrightness: function() {
					//http://www.w3.org/TR/AERT#color-contrast
					var rgb = this.toRgb();
					return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
			},
			getLuminance: function() {
					//http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
					var rgb = this.toRgb();
					var RsRGB, GsRGB, BsRGB, R, G, B;
					RsRGB = rgb.r/255;
					GsRGB = rgb.g/255;
					BsRGB = rgb.b/255;
	
					if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
					if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
					if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
					return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
			},
			setAlpha: function(value) {
					this._a = boundAlpha(value);
					this._roundA = mathRound(100*this._a) / 100;
					return this;
			},
			toHsv: function() {
					var hsv = rgbToHsv(this._r, this._g, this._b);
					return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
			},
			toHsvString: function() {
					var hsv = rgbToHsv(this._r, this._g, this._b);
					var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
					return (this._a == 1) ?
						"hsv("	+ h + ", " + s + "%, " + v + "%)" :
						"hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
			},
			toHsl: function() {
					var hsl = rgbToHsl(this._r, this._g, this._b);
					return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
			},
			toHslString: function() {
					var hsl = rgbToHsl(this._r, this._g, this._b);
					var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
					return (this._a == 1) ?
						"hsl("	+ h + ", " + s + "%, " + l + "%)" :
						"hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
			},
			toHex: function(allow3Char) {
					return rgbToHex(this._r, this._g, this._b, allow3Char);
			},
			toHexString: function(allow3Char) {
					return '#' + this.toHex(allow3Char);
			},
			toHex8: function() {
					return rgbaToHex(this._r, this._g, this._b, this._a);
			},
			toHex8String: function() {
					return '#' + this.toHex8();
			},
			toRgb: function() {
					return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
			},
			toRgbString: function() {
					return (this._a == 1) ?
						"rgb("	+ mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
						"rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
			},
			toPercentageRgb: function() {
					return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
			},
			toPercentageRgbString: function() {
					return (this._a == 1) ?
						"rgb("	+ mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
						"rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
			},
			toName: function() {
					if (this._a === 0) {
							return "transparent";
					}
	
					if (this._a < 1) {
							return false;
					}
	
					return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
			},
			toFilter: function(secondColor) {
					var hex8String = '#' + rgbaToHex(this._r, this._g, this._b, this._a);
					var secondHex8String = hex8String;
					var gradientType = this._gradientType ? "GradientType = 1, " : "";
	
					if (secondColor) {
							var s = tinycolor(secondColor);
							secondHex8String = s.toHex8String();
					}
	
					return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
			},
			toString: function(format) {
					var formatSet = !!format;
					format = format || this._format;
	
					var formattedString = false;
					var hasAlpha = this._a < 1 && this._a >= 0;
					var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "name");
	
					if (needsAlphaFormat) {
							// Special case for "transparent", all other non-alpha formats
							// will return rgba when there is transparency.
							if (format === "name" && this._a === 0) {
									return this.toName();
							}
							return this.toRgbString();
					}
					if (format === "rgb") {
							formattedString = this.toRgbString();
					}
					if (format === "prgb") {
							formattedString = this.toPercentageRgbString();
					}
					if (format === "hex" || format === "hex6") {
							formattedString = this.toHexString();
					}
					if (format === "hex3") {
							formattedString = this.toHexString(true);
					}
					if (format === "hex8") {
							formattedString = this.toHex8String();
					}
					if (format === "name") {
							formattedString = this.toName();
					}
					if (format === "hsl") {
							formattedString = this.toHslString();
					}
					if (format === "hsv") {
							formattedString = this.toHsvString();
					}
	
					return formattedString || this.toHexString();
			},
	
			_applyModification: function(fn, args) {
					var color = fn.apply(null, [this].concat([].slice.call(args)));
					this._r = color._r;
					this._g = color._g;
					this._b = color._b;
					this.setAlpha(color._a);
					return this;
			},
			lighten: function() {
					return this._applyModification(lighten, arguments);
			},
			brighten: function() {
					return this._applyModification(brighten, arguments);
			},
			darken: function() {
					return this._applyModification(darken, arguments);
			},
			desaturate: function() {
					return this._applyModification(desaturate, arguments);
			},
			saturate: function() {
					return this._applyModification(saturate, arguments);
			},
			greyscale: function() {
					return this._applyModification(greyscale, arguments);
			},
			spin: function() {
					return this._applyModification(spin, arguments);
			},
	
			_applyCombination: function(fn, args) {
					return fn.apply(null, [this].concat([].slice.call(args)));
			},
			analogous: function() {
					return this._applyCombination(analogous, arguments);
			},
			complement: function() {
					return this._applyCombination(complement, arguments);
			},
			monochromatic: function() {
					return this._applyCombination(monochromatic, arguments);
			},
			splitcomplement: function() {
					return this._applyCombination(splitcomplement, arguments);
			},
			triad: function() {
					return this._applyCombination(triad, arguments);
			},
			tetrad: function() {
					return this._applyCombination(tetrad, arguments);
			}
	};
	
	// If input is an object, force 1 into "1.0" to handle ratios properly
	// String input requires "1.0" as input, so 1 will be treated as 1
	tinycolor.fromRatio = function(color, opts) {
			if (typeof color == "object") {
					var newColor = {};
					for (var i in color) {
							if (color.hasOwnProperty(i)) {
									if (i === "a") {
											newColor[i] = color[i];
									}
									else {
											newColor[i] = convertToPercentage(color[i]);
									}
							}
					}
					color = newColor;
			}
	
			return tinycolor(color, opts);
	};
	
	// Given a string or object, convert that input to RGB
	// Possible string inputs:
	//
	//		 "red"
	//		 "#f00" or "f00"
	//		 "#ff0000" or "ff0000"
	//		 "#ff000000" or "ff000000"
	//		 "rgb 255 0 0" or "rgb (255, 0, 0)"
	//		 "rgb 1.0 0 0" or "rgb (1, 0, 0)"
	//		 "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
	//		 "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
	//		 "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
	//		 "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
	//		 "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
	//
	function inputToRGB(color) {
	
			var rgb = { r: 0, g: 0, b: 0 };
			var a = 1;
			var ok = false;
			var format = false;
	
			if (typeof color == "string") {
					color = stringInputToObject(color);
			}
	
			if (typeof color == "object") {
					if (color.hasOwnProperty("r") && color.hasOwnProperty("g") && color.hasOwnProperty("b")) {
							rgb = rgbToRgb(color.r, color.g, color.b);
							ok = true;
							format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
					}
					else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("v")) {
							color.s = convertToPercentage(color.s, 1);
							color.v = convertToPercentage(color.v, 1);
							rgb = hsvToRgb(color.h, color.s, color.v);
							ok = true;
							format = "hsv";
					}
					else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("l")) {
							color.s = convertToPercentage(color.s);
							color.l = convertToPercentage(color.l);
							rgb = hslToRgb(color.h, color.s, color.l);
							ok = true;
							format = "hsl";
					}
	
					if (color.hasOwnProperty("a")) {
							a = color.a;
					}
			}
	
			a = boundAlpha(a);
	
			return {
					ok: ok,
					format: color.format || format,
					r: mathMin(255, mathMax(rgb.r, 0)),
					g: mathMin(255, mathMax(rgb.g, 0)),
					b: mathMin(255, mathMax(rgb.b, 0)),
					a: a
			};
	}
	
	
	// Conversion Functions
	// --------------------
	
	// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
	// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
	
	// `rgbToRgb`
	// Handle bounds / percentage checking to conform to CSS color spec
	// <http://www.w3.org/TR/css3-color/>
	// *Assumes:* r, g, b in [0, 255] or [0, 1]
	// *Returns:* { r, g, b } in [0, 255]
	function rgbToRgb(r, g, b){
			return {
					r: bound01(r, 255) * 255,
					g: bound01(g, 255) * 255,
					b: bound01(b, 255) * 255
			};
	}
	
	// `rgbToHsl`
	// Converts an RGB color value to HSL.
	// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
	// *Returns:* { h, s, l } in [0,1]
	function rgbToHsl(r, g, b) {
	
			r = bound01(r, 255);
			g = bound01(g, 255);
			b = bound01(b, 255);
	
			var max = mathMax(r, g, b), min = mathMin(r, g, b);
			var h, s, l = (max + min) / 2;
	
			if(max == min) {
					h = s = 0; // achromatic
			}
			else {
					var d = max - min;
					s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
					switch(max) {
							case r: h = (g - b) / d + (g < b ? 6 : 0); break;
							case g: h = (b - r) / d + 2; break;
							case b: h = (r - g) / d + 4; break;
					}
	
					h /= 6;
			}
	
			return { h: h, s: s, l: l };
	}
	
	// `hslToRgb`
	// Converts an HSL color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	function hslToRgb(h, s, l) {
			var r, g, b;
	
			h = bound01(h, 360);
			s = bound01(s, 100);
			l = bound01(l, 100);
	
			function hue2rgb(p, q, t) {
					if(t < 0) t += 1;
					if(t > 1) t -= 1;
					if(t < 1/6) return p + (q - p) * 6 * t;
					if(t < 1/2) return q;
					if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
					return p;
			}
	
			if(s === 0) {
					r = g = b = l; // achromatic
			}
			else {
					var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
					var p = 2 * l - q;
					r = hue2rgb(p, q, h + 1/3);
					g = hue2rgb(p, q, h);
					b = hue2rgb(p, q, h - 1/3);
			}
	
			return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHsv`
	// Converts an RGB color value to HSV
	// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	// *Returns:* { h, s, v } in [0,1]
	function rgbToHsv(r, g, b) {
	
			r = bound01(r, 255);
			g = bound01(g, 255);
			b = bound01(b, 255);
	
			var max = mathMax(r, g, b), min = mathMin(r, g, b);
			var h, s, v = max;
	
			var d = max - min;
			s = max === 0 ? 0 : d / max;
	
			if(max == min) {
					h = 0; // achromatic
			}
			else {
					switch(max) {
							case r: h = (g - b) / d + (g < b ? 6 : 0); break;
							case g: h = (b - r) / d + 2; break;
							case b: h = (r - g) / d + 4; break;
					}
					h /= 6;
			}
			return { h: h, s: s, v: v };
	}
	
	// `hsvToRgb`
	// Converts an HSV color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	 function hsvToRgb(h, s, v) {
	
			h = bound01(h, 360) * 6;
			s = bound01(s, 100);
			v = bound01(v, 100);
	
			var i = math.floor(h),
					f = h - i,
					p = v * (1 - s),
					q = v * (1 - f * s),
					t = v * (1 - (1 - f) * s),
					mod = i % 6,
					r = [v, q, p, p, t, v][mod],
					g = [t, v, v, q, p, p][mod],
					b = [p, p, t, v, v, q][mod];
	
			return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHex`
	// Converts an RGB color to hex
	// Assumes r, g, and b are contained in the set [0, 255]
	// Returns a 3 or 6 character hex
	function rgbToHex(r, g, b, allow3Char) {
	
			var hex = [
					pad2(mathRound(r).toString(16)),
					pad2(mathRound(g).toString(16)),
					pad2(mathRound(b).toString(16))
			];
	
			// Return a 3 character hex if possible
			if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
					return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
			}
	
			return hex.join("");
	}
			// `rgbaToHex`
			// Converts an RGBA color plus alpha transparency to hex
			// Assumes r, g, b and a are contained in the set [0, 255]
			// Returns an 8 character hex
			function rgbaToHex(r, g, b, a) {
	
					var hex = [
							pad2(convertDecimalToHex(a)),
							pad2(mathRound(r).toString(16)),
							pad2(mathRound(g).toString(16)),
							pad2(mathRound(b).toString(16))
					];
	
					return hex.join("");
			}
	
	// `equals`
	// Can be called with any tinycolor input
	tinycolor.equals = function (color1, color2) {
			if (!color1 || !color2) { return false; }
			return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	};
	tinycolor.random = function() {
			return tinycolor.fromRatio({
					r: mathRandom(),
					g: mathRandom(),
					b: mathRandom()
			});
	};
	
	
	// Modification Functions
	// ----------------------
	// Thanks to less.js for some of the basics here
	// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
	
	function desaturate(color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.s -= amount / 100;
			hsl.s = clamp01(hsl.s);
			return tinycolor(hsl);
	}
	
	function saturate(color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.s += amount / 100;
			hsl.s = clamp01(hsl.s);
			return tinycolor(hsl);
	}
	
	function greyscale(color) {
			return tinycolor(color).desaturate(100);
	}
	
	function lighten (color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.l += amount / 100;
			hsl.l = clamp01(hsl.l);
			return tinycolor(hsl);
	}
	
	function brighten(color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var rgb = tinycolor(color).toRgb();
			rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
			rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
			rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
			return tinycolor(rgb);
	}
	
	function darken (color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.l -= amount / 100;
			hsl.l = clamp01(hsl.l);
			return tinycolor(hsl);
	}
	
	// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
	// Values outside of this range will be wrapped into this range.
	function spin(color, amount) {
			var hsl = tinycolor(color).toHsl();
			var hue = (mathRound(hsl.h) + amount) % 360;
			hsl.h = hue < 0 ? 360 + hue : hue;
			return tinycolor(hsl);
	}
	
	// Combination Functions
	// ---------------------
	// Thanks to jQuery xColor for some of the ideas behind these
	// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
	
	function complement(color) {
			var hsl = tinycolor(color).toHsl();
			hsl.h = (hsl.h + 180) % 360;
			return tinycolor(hsl);
	}
	
	function triad(color) {
			var hsl = tinycolor(color).toHsl();
			var h = hsl.h;
			return [
					tinycolor(color),
					tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
					tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
			];
	}
	
	function tetrad(color) {
			var hsl = tinycolor(color).toHsl();
			var h = hsl.h;
			return [
					tinycolor(color),
					tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
					tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
					tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
			];
	}
	
	function splitcomplement(color) {
			var hsl = tinycolor(color).toHsl();
			var h = hsl.h;
			return [
					tinycolor(color),
					tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
					tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
			];
	}
	
	function analogous(color, results, slices) {
			results = results || 6;
			slices = slices || 30;
	
			var hsl = tinycolor(color).toHsl();
			var part = 360 / slices;
			var ret = [tinycolor(color)];
	
			for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
					hsl.h = (hsl.h + part) % 360;
					ret.push(tinycolor(hsl));
			}
			return ret;
	}
	
	function monochromatic(color, results) {
			results = results || 6;
			var hsv = tinycolor(color).toHsv();
			var h = hsv.h, s = hsv.s, v = hsv.v;
			var ret = [];
			var modification = 1 / results;
	
			while (results--) {
					ret.push(tinycolor({ h: h, s: s, v: v}));
					v = (v + modification) % 1;
			}
	
			return ret;
	}
	
	// Utility Functions
	// ---------------------
	
	tinycolor.mix = function(color1, color2, amount) {
			amount = (amount === 0) ? 0 : (amount || 50);
	
			var rgb1 = tinycolor(color1).toRgb();
			var rgb2 = tinycolor(color2).toRgb();
	
			var p = amount / 100;
			var w = p * 2 - 1;
			var a = rgb2.a - rgb1.a;
	
			var w1;
	
			if (w * a == -1) {
					w1 = w;
			} else {
					w1 = (w + a) / (1 + w * a);
			}
	
			w1 = (w1 + 1) / 2;
	
			var w2 = 1 - w1;
	
			var rgba = {
					r: rgb2.r * w1 + rgb1.r * w2,
					g: rgb2.g * w1 + rgb1.g * w2,
					b: rgb2.b * w1 + rgb1.b * w2,
					a: rgb2.a * p	+ rgb1.a * (1 - p)
			};
	
			return tinycolor(rgba);
	};
	
	
	// Readability Functions
	// ---------------------
	// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
	
	// `contrast`
	// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
	tinycolor.readability = function(color1, color2) {
			var c1 = tinycolor(color1);
			var c2 = tinycolor(color2);
			return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
	};
	
	// `isReadable`
	// Ensure that foreground and background color combinations meet WCAG2 guidelines.
	// The third argument is an optional Object.
	//			the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
	//			the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
	// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
	
	// *Example*
	//		tinycolor.isReadable("#000", "#111") => false
	//		tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
	
	tinycolor.isReadable = function(color1, color2, wcag2) {
			var readability = tinycolor.readability(color1, color2);
			var wcag2Parms, out;
	
			out = false;
	
			wcag2Parms = validateWCAG2Parms(wcag2);
			switch (wcag2Parms.level + wcag2Parms.size) {
					case "AAsmall":
					case "AAAlarge":
							out = readability >= 4.5;
							break;
					case "AAlarge":
							out = readability >= 3;
							break;
					case "AAAsmall":
							out = readability >= 7;
							break;
			}
			return out;
	
	};
	
	// `mostReadable`
	// Given a base color and a list of possible foreground or background
	// colors for that base, returns the most readable color.
	// Optionally returns Black or White if the most readable color is unreadable.
	// *Example*
	//		tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
	//		tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();	// "#ffffff"
	//		tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
	//		tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
	
	
	tinycolor.mostReadable = function(baseColor, colorList, args) {
			var bestColor = null;
			var bestScore = 0;
			var readability;
			var includeFallbackColors, level, size ;
			args = args || {};
			includeFallbackColors = args.includeFallbackColors ;
			level = args.level;
			size = args.size;
	
			for (var i= 0; i < colorList.length ; i++) {
					readability = tinycolor.readability(baseColor, colorList[i]);
					if (readability > bestScore) {
							bestScore = readability;
							bestColor = tinycolor(colorList[i]);
					}
			}
	
			if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
					return bestColor;
			}
			else {
					args.includeFallbackColors=false;
					return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
			}
	};
	
	
	// Big List of Colors
	// ------------------
	// <http://www.w3.org/TR/css3-color/#svg-color>
	var names = tinycolor.names = {
			aliceblue: "f0f8ff",
			antiquewhite: "faebd7",
			aqua: "0ff",
			aquamarine: "7fffd4",
			azure: "f0ffff",
			beige: "f5f5dc",
			bisque: "ffe4c4",
			black: "000",
			blanchedalmond: "ffebcd",
			blue: "00f",
			blueviolet: "8a2be2",
			brown: "a52a2a",
			burlywood: "deb887",
			burntsienna: "ea7e5d",
			cadetblue: "5f9ea0",
			chartreuse: "7fff00",
			chocolate: "d2691e",
			coral: "ff7f50",
			cornflowerblue: "6495ed",
			cornsilk: "fff8dc",
			crimson: "dc143c",
			cyan: "0ff",
			darkblue: "00008b",
			darkcyan: "008b8b",
			darkgoldenrod: "b8860b",
			darkgray: "a9a9a9",
			darkgreen: "006400",
			darkgrey: "a9a9a9",
			darkkhaki: "bdb76b",
			darkmagenta: "8b008b",
			darkolivegreen: "556b2f",
			darkorange: "ff8c00",
			darkorchid: "9932cc",
			darkred: "8b0000",
			darksalmon: "e9967a",
			darkseagreen: "8fbc8f",
			darkslateblue: "483d8b",
			darkslategray: "2f4f4f",
			darkslategrey: "2f4f4f",
			darkturquoise: "00ced1",
			darkviolet: "9400d3",
			deeppink: "ff1493",
			deepskyblue: "00bfff",
			dimgray: "696969",
			dimgrey: "696969",
			dodgerblue: "1e90ff",
			firebrick: "b22222",
			floralwhite: "fffaf0",
			forestgreen: "228b22",
			fuchsia: "f0f",
			gainsboro: "dcdcdc",
			ghostwhite: "f8f8ff",
			gold: "ffd700",
			goldenrod: "daa520",
			gray: "808080",
			green: "008000",
			greenyellow: "adff2f",
			grey: "808080",
			honeydew: "f0fff0",
			hotpink: "ff69b4",
			indianred: "cd5c5c",
			indigo: "4b0082",
			ivory: "fffff0",
			khaki: "f0e68c",
			lavender: "e6e6fa",
			lavenderblush: "fff0f5",
			lawngreen: "7cfc00",
			lemonchiffon: "fffacd",
			lightblue: "add8e6",
			lightcoral: "f08080",
			lightcyan: "e0ffff",
			lightgoldenrodyellow: "fafad2",
			lightgray: "d3d3d3",
			lightgreen: "90ee90",
			lightgrey: "d3d3d3",
			lightpink: "ffb6c1",
			lightsalmon: "ffa07a",
			lightseagreen: "20b2aa",
			lightskyblue: "87cefa",
			lightslategray: "789",
			lightslategrey: "789",
			lightsteelblue: "b0c4de",
			lightyellow: "ffffe0",
			lime: "0f0",
			limegreen: "32cd32",
			linen: "faf0e6",
			magenta: "f0f",
			maroon: "800000",
			mediumaquamarine: "66cdaa",
			mediumblue: "0000cd",
			mediumorchid: "ba55d3",
			mediumpurple: "9370db",
			mediumseagreen: "3cb371",
			mediumslateblue: "7b68ee",
			mediumspringgreen: "00fa9a",
			mediumturquoise: "48d1cc",
			mediumvioletred: "c71585",
			midnightblue: "191970",
			mintcream: "f5fffa",
			mistyrose: "ffe4e1",
			moccasin: "ffe4b5",
			navajowhite: "ffdead",
			navy: "000080",
			oldlace: "fdf5e6",
			olive: "808000",
			olivedrab: "6b8e23",
			orange: "ffa500",
			orangered: "ff4500",
			orchid: "da70d6",
			palegoldenrod: "eee8aa",
			palegreen: "98fb98",
			paleturquoise: "afeeee",
			palevioletred: "db7093",
			papayawhip: "ffefd5",
			peachpuff: "ffdab9",
			peru: "cd853f",
			pink: "ffc0cb",
			plum: "dda0dd",
			powderblue: "b0e0e6",
			purple: "800080",
			rebeccapurple: "663399",
			red: "f00",
			rosybrown: "bc8f8f",
			royalblue: "4169e1",
			saddlebrown: "8b4513",
			salmon: "fa8072",
			sandybrown: "f4a460",
			seagreen: "2e8b57",
			seashell: "fff5ee",
			sienna: "a0522d",
			silver: "c0c0c0",
			skyblue: "87ceeb",
			slateblue: "6a5acd",
			slategray: "708090",
			slategrey: "708090",
			snow: "fffafa",
			springgreen: "00ff7f",
			steelblue: "4682b4",
			tan: "d2b48c",
			teal: "008080",
			thistle: "d8bfd8",
			tomato: "ff6347",
			turquoise: "40e0d0",
			violet: "ee82ee",
			wheat: "f5deb3",
			white: "fff",
			whitesmoke: "f5f5f5",
			yellow: "ff0",
			yellowgreen: "9acd32"
	};
	
	// Make it easy to access colors via `hexNames[hex]`
	var hexNames = tinycolor.hexNames = flip(names);
	
	
	// Utilities
	// ---------
	
	// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
	function flip(o) {
			var flipped = { };
			for (var i in o) {
					if (o.hasOwnProperty(i)) {
							flipped[o[i]] = i;
					}
			}
			return flipped;
	}
	
	// Return a valid alpha value [0,1] with all invalid values being set to 1
	function boundAlpha(a) {
			a = parseFloat(a);
	
			if (isNaN(a) || a < 0 || a > 1) {
					a = 1;
			}
	
			return a;
	}
	
	// Take input from [0, n] and return it as [0, 1]
	function bound01(n, max) {
			if (isOnePointZero(n)) { n = "100%"; }
	
			var processPercent = isPercentage(n);
			n = mathMin(max, mathMax(0, parseFloat(n)));
	
			// Automatically convert percentage into number
			if (processPercent) {
					n = parseInt(n * max, 10) / 100;
			}
	
			// Handle floating point rounding errors
			if ((math.abs(n - max) < 0.000001)) {
					return 1;
			}
	
			// Convert into [0, 1] range if it isn't already
			return (n % max) / parseFloat(max);
	}
	
	// Force a number between 0 and 1
	function clamp01(val) {
			return mathMin(1, mathMax(0, val));
	}
	
	// Parse a base-16 hex value into a base-10 integer
	function parseIntFromHex(val) {
			return parseInt(val, 16);
	}
	
	// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	function isOnePointZero(n) {
			return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
	}
	
	// Check to see if string passed in is a percentage
	function isPercentage(n) {
			return typeof n === "string" && n.indexOf('%') != -1;
	}
	
	// Force a hex value to have 2 characters
	function pad2(c) {
			return c.length == 1 ? '0' + c : '' + c;
	}
	
	// Replace a decimal with it's percentage value
	function convertToPercentage(n, multiplier) {
			multiplier = multiplier || 100;
			if (n <= 1) {
					n = (n * multiplier) + "%";
			}
	
			return n;
	}
	
	// Converts a decimal to a hex value
	function convertDecimalToHex(d) {
			return Math.round(parseFloat(d) * 255).toString(16);
	}
	// Converts a hex value to a decimal
	function convertHexToDecimal(h) {
			return (parseIntFromHex(h) / 255);
	}
	
	var matchers = (function() {
	
			// <http://www.w3.org/TR/css3-values/#integers>
			var CSS_INTEGER = "[-\\+]?\\d+%?";
	
			// <http://www.w3.org/TR/css3-values/#number-value>
			var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
	
			// Allow positive/negative integer/number.	Don't capture the either/or, just the entire outcome.
			var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
	
			// Actual matching.
			// Parentheses and commas are optional, but not required.
			// Whitespace can take the place of commas or opening paren
			var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
			var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	
			return {
					rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
					rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
					hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
					hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
					hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
					hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
					hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
					hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
					hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
			};
	})();
	
	// `stringInputToObject`
	// Permissive string parsing.	Take in a number of formats, and output an object
	// based on detected format.	Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
	function stringInputToObject(color) {
	
			color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
			var named = false;
			if (names[color]) {
					color = names[color];
					named = true;
			}
			else if (color == 'transparent') {
					return { r: 0, g: 0, b: 0, a: 0, format: "name" };
			}
	
			// Try to match string input using regular expressions.
			// Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
			// Just return an object and let the conversion functions handle that.
			// This way the result will be the same whether the tinycolor is initialized with string or object.
			var match;
			if ((match = matchers.rgb.exec(color))) {
					return { r: match[1], g: match[2], b: match[3] };
			}
			if ((match = matchers.rgba.exec(color))) {
					return { r: match[1], g: match[2], b: match[3], a: match[4] };
			}
			if ((match = matchers.hsl.exec(color))) {
					return { h: match[1], s: match[2], l: match[3] };
			}
			if ((match = matchers.hsla.exec(color))) {
					return { h: match[1], s: match[2], l: match[3], a: match[4] };
			}
			if ((match = matchers.hsv.exec(color))) {
					return { h: match[1], s: match[2], v: match[3] };
			}
			if ((match = matchers.hsva.exec(color))) {
					return { h: match[1], s: match[2], v: match[3], a: match[4] };
			}
			if ((match = matchers.hex8.exec(color))) {
					return {
							a: convertHexToDecimal(match[1]),
							r: parseIntFromHex(match[2]),
							g: parseIntFromHex(match[3]),
							b: parseIntFromHex(match[4]),
							format: named ? "name" : "hex8"
					};
			}
			if ((match = matchers.hex6.exec(color))) {
					return {
							r: parseIntFromHex(match[1]),
							g: parseIntFromHex(match[2]),
							b: parseIntFromHex(match[3]),
							format: named ? "name" : "hex"
					};
			}
			if ((match = matchers.hex3.exec(color))) {
					return {
							r: parseIntFromHex(match[1] + '' + match[1]),
							g: parseIntFromHex(match[2] + '' + match[2]),
							b: parseIntFromHex(match[3] + '' + match[3]),
							format: named ? "name" : "hex"
					};
			}
	
			return false;
	}
	
	function validateWCAG2Parms(parms) {
			// return valid WCAG2 parms for isReadable.
			// If input parms are invalid, return {"level":"AA", "size":"small"}
			var level, size;
			parms = parms || {"level":"AA", "size":"small"};
			level = (parms.level || "AA").toUpperCase();
			size = (parms.size || "small").toLowerCase();
			if (level !== "AA" && level !== "AAA") {
					level = "AA";
			}
			if (size !== "small" && size !== "large") {
					size = "small";
			}
			return {"level":level, "size":size};
	}
	// Node: Export function
	if (typeof module !== "undefined" && module.exports) {
			module.exports = tinycolor;
	}
	// AMD/requirejs: Define the module
	else if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {return tinycolor;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	// Browser: Expose to window
	else {
			window.tinycolor = tinycolor;
	}
	
	})();


/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(63));
		else if(typeof define === 'function' && define.amd)
			define(["react", "react-dom"], factory);
		else if(typeof exports === 'object')
			exports["ReactDataGrid"] = factory(require("react"), require("react-dom"));
		else
			root["ReactDataGrid"] = factory(root["React"], root["ReactDOM"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_4__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ((function(modules) {
		// Check all modules for deduplicated modules
		for(var i in modules) {
			if(Object.prototype.hasOwnProperty.call(modules, i)) {
				switch(typeof modules[i]) {
				case "function": break;
				case "object":
					// Module can be created from a template
					modules[i] = (function(_m) {
						var args = _m.slice(1), fn = modules[_m[0]];
						return function (a,b,c) {
							fn.apply(this, [a,b,c].concat(args));
						};
					}(modules[i]));
					break;
				default:
					// Module is a copy of another module
					modules[i] = modules[modules[i]];
					break;
				}
			}
		}
		return modules;
	}([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(228);
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		module.exports = function(module) {
			if(!module.webpackPolyfill) {
				module.deprecate = function() {};
				module.paths = [];
				// module.parent = undefined by default
				module.children = [];
				module.webpackPolyfill = 1;
			}
			return module;
		}
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = __webpack_require__(187);
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_4__;
	
	/***/ }),
	/* 5 */,
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		var invariant = function(condition, format, a, b, c, d, e, f) {
		  if (false) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  }
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error(
		        'Minified exception occurred; use the non-minified dev environment ' +
		        'for the full error message and additional helpful warnings.'
		      );
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(
		        format.replace(/%s/g, function() { return args[argIndex++]; })
		      );
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		};
	
		module.exports = invariant;
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
		/*
			MIT License http://www.opensource.org/licenses/mit-license.php
			Author Tobias Koppers @sokra
		*/
		// css base code, injected by the css-loader
		module.exports = function() {
			var list = [];
	
			// return the list of modules as css string
			list.toString = function toString() {
				var result = [];
				for(var i = 0; i < this.length; i++) {
					var item = this[i];
					if(item[2]) {
						result.push("@media " + item[2] + "{" + item[1] + "}");
					} else {
						result.push(item[1]);
					}
				}
				return result.join("");
			};
	
			// import a list of modules into the list
			list.i = function(modules, mediaQuery) {
				if(typeof modules === "string")
					modules = [[null, modules, ""]];
				var alreadyImportedModules = {};
				for(var i = 0; i < this.length; i++) {
					var id = this[i][0];
					if(typeof id === "number")
						alreadyImportedModules[id] = true;
				}
				for(i = 0; i < modules.length; i++) {
					var item = modules[i];
					// skip already imported module
					// this implementation is not 100% perfect for weird media query combinations
					//  when a module is imported multiple times with different media queries.
					//  I hope this will never occur (Hey this way we have smaller bundles)
					if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
						if(mediaQuery && !item[2]) {
							item[2] = mediaQuery;
						} else if(mediaQuery) {
							item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
						}
						list.push(item);
					}
				}
			};
			return list;
		};
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/*
			MIT License http://www.opensource.org/licenses/mit-license.php
			Author Tobias Koppers @sokra
		*/
		var stylesInDom = {},
			memoize = function(fn) {
				var memo;
				return function () {
					if (typeof memo === "undefined") memo = fn.apply(this, arguments);
					return memo;
				};
			},
			isOldIE = memoize(function() {
				return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
			}),
			getHeadElement = memoize(function () {
				return document.head || document.getElementsByTagName("head")[0];
			}),
			singletonElement = null,
			singletonCounter = 0,
			styleElementsInsertedAtTop = [];
	
		module.exports = function(list, options) {
			if(false) {
				if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
			}
	
			options = options || {};
			// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
			// tags it will allow on a page
			if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
			// By default, add <style> tags to the bottom of <head>.
			if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
			var styles = listToStyles(list);
			addStylesToDom(styles, options);
	
			return function update(newList) {
				var mayRemove = [];
				for(var i = 0; i < styles.length; i++) {
					var item = styles[i];
					var domStyle = stylesInDom[item.id];
					domStyle.refs--;
					mayRemove.push(domStyle);
				}
				if(newList) {
					var newStyles = listToStyles(newList);
					addStylesToDom(newStyles, options);
				}
				for(var i = 0; i < mayRemove.length; i++) {
					var domStyle = mayRemove[i];
					if(domStyle.refs === 0) {
						for(var j = 0; j < domStyle.parts.length; j++)
							domStyle.parts[j]();
						delete stylesInDom[domStyle.id];
					}
				}
			};
		}
	
		function addStylesToDom(styles, options) {
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				if(domStyle) {
					domStyle.refs++;
					for(var j = 0; j < domStyle.parts.length; j++) {
						domStyle.parts[j](item.parts[j]);
					}
					for(; j < item.parts.length; j++) {
						domStyle.parts.push(addStyle(item.parts[j], options));
					}
				} else {
					var parts = [];
					for(var j = 0; j < item.parts.length; j++) {
						parts.push(addStyle(item.parts[j], options));
					}
					stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
				}
			}
		}
	
		function listToStyles(list) {
			var styles = [];
			var newStyles = {};
			for(var i = 0; i < list.length; i++) {
				var item = list[i];
				var id = item[0];
				var css = item[1];
				var media = item[2];
				var sourceMap = item[3];
				var part = {css: css, media: media, sourceMap: sourceMap};
				if(!newStyles[id])
					styles.push(newStyles[id] = {id: id, parts: [part]});
				else
					newStyles[id].parts.push(part);
			}
			return styles;
		}
	
		function insertStyleElement(options, styleElement) {
			var head = getHeadElement();
			var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
			if (options.insertAt === "top") {
				if(!lastStyleElementInsertedAtTop) {
					head.insertBefore(styleElement, head.firstChild);
				} else if(lastStyleElementInsertedAtTop.nextSibling) {
					head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
				} else {
					head.appendChild(styleElement);
				}
				styleElementsInsertedAtTop.push(styleElement);
			} else if (options.insertAt === "bottom") {
				head.appendChild(styleElement);
			} else {
				throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
			}
		}
	
		function removeStyleElement(styleElement) {
			styleElement.parentNode.removeChild(styleElement);
			var idx = styleElementsInsertedAtTop.indexOf(styleElement);
			if(idx >= 0) {
				styleElementsInsertedAtTop.splice(idx, 1);
			}
		}
	
		function createStyleElement(options) {
			var styleElement = document.createElement("style");
			styleElement.type = "text/css";
			insertStyleElement(options, styleElement);
			return styleElement;
		}
	
		function createLinkElement(options) {
			var linkElement = document.createElement("link");
			linkElement.rel = "stylesheet";
			insertStyleElement(options, linkElement);
			return linkElement;
		}
	
		function addStyle(obj, options) {
			var styleElement, update, remove;
	
			if (options.singleton) {
				var styleIndex = singletonCounter++;
				styleElement = singletonElement || (singletonElement = createStyleElement(options));
				update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
				remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
			} else if(obj.sourceMap &&
				typeof URL === "function" &&
				typeof URL.createObjectURL === "function" &&
				typeof URL.revokeObjectURL === "function" &&
				typeof Blob === "function" &&
				typeof btoa === "function") {
				styleElement = createLinkElement(options);
				update = updateLink.bind(null, styleElement);
				remove = function() {
					removeStyleElement(styleElement);
					if(styleElement.href)
						URL.revokeObjectURL(styleElement.href);
				};
			} else {
				styleElement = createStyleElement(options);
				update = applyToTag.bind(null, styleElement);
				remove = function() {
					removeStyleElement(styleElement);
				};
			}
	
			update(obj);
	
			return function updateStyle(newObj) {
				if(newObj) {
					if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
						return;
					update(obj = newObj);
				} else {
					remove();
				}
			};
		}
	
		var replaceText = (function () {
			var textStore = [];
	
			return function (index, replacement) {
				textStore[index] = replacement;
				return textStore.filter(Boolean).join('\n');
			};
		})();
	
		function applyToSingletonTag(styleElement, index, remove, obj) {
			var css = remove ? "" : obj.css;
	
			if (styleElement.styleSheet) {
				styleElement.styleSheet.cssText = replaceText(index, css);
			} else {
				var cssNode = document.createTextNode(css);
				var childNodes = styleElement.childNodes;
				if (childNodes[index]) styleElement.removeChild(childNodes[index]);
				if (childNodes.length) {
					styleElement.insertBefore(cssNode, childNodes[index]);
				} else {
					styleElement.appendChild(cssNode);
				}
			}
		}
	
		function applyToTag(styleElement, obj) {
			var css = obj.css;
			var media = obj.media;
	
			if(media) {
				styleElement.setAttribute("media", media)
			}
	
			if(styleElement.styleSheet) {
				styleElement.styleSheet.cssText = css;
			} else {
				while(styleElement.firstChild) {
					styleElement.removeChild(styleElement.firstChild);
				}
				styleElement.appendChild(document.createTextNode(css));
			}
		}
	
		function updateLink(linkElement, obj) {
			var css = obj.css;
			var sourceMap = obj.sourceMap;
	
			if(sourceMap) {
				// http://stackoverflow.com/a/26603875
				css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
			}
	
			var blob = new Blob([css], { type: "text/css" });
	
			var oldSrc = linkElement.href;
	
			linkElement.href = URL.createObjectURL(blob);
	
			if(oldSrc)
				URL.revokeObjectURL(oldSrc);
		}
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		  Copyright (c) 2015 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
	
		function classNames() {
			var classes = '';
			var arg;
	
			for (var i = 0; i < arguments.length; i++) {
				arg = arguments[i];
				if (!arg) {
					continue;
				}
	
				if ('string' === typeof arg || 'number' === typeof arg) {
					classes += ' ' + arg;
				} else if (Object.prototype.toString.call(arg) === '[object Array]') {
					classes += ' ' + classNames.apply(null, arg);
				} else if ('object' === typeof arg) {
					for (var key in arg) {
						if (!arg.hasOwnProperty(key) || !arg[key]) {
							continue;
						}
						classes += ' ' + key;
					}
				}
			}
			return classes.substr(1);
		}
	
		// safely export classNames for node / browserify
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		}
	
		// safely export classNames for RequireJS
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		module.exports = {
		  getColumn: function getColumn(columns, idx) {
		    if (Array.isArray(columns)) {
		      return columns[idx];
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.get(idx);
		    }
		  },
		  spliceColumn: function spliceColumn(metrics, idx, column) {
		    if (Array.isArray(metrics.columns)) {
		      metrics.columns.splice(idx, 1, column);
		    } else if (typeof Immutable !== 'undefined') {
		      metrics.columns = metrics.columns.splice(idx, 1, column);
		    }
		    return metrics;
		  },
		  getSize: function getSize(columns) {
		    if (Array.isArray(columns)) {
		      return columns.length;
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.size;
		    }
		  },
	
	
		  // Logic extented to allow for functions to be passed down in column.editable
		  // this allows us to deicde whether we can be edting from a cell level
		  canEdit: function canEdit(col, rowData, enableCellSelect) {
		    if (col.editable != null && typeof col.editable === 'function') {
		      return enableCellSelect === true && col.editable(rowData);
		    }
		    return enableCellSelect === true && (!!col.editor || !!col.editable);
		  }
		};
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
	
		var ExcelColumnShape = {
		  name: React.PropTypes.node.isRequired,
		  key: React.PropTypes.string.isRequired,
		  width: React.PropTypes.number.isRequired,
		  filterable: React.PropTypes.bool
		};
	
		module.exports = ExcelColumnShape;
	
	/***/ }),
	/* 12 */
	[1786, 150],
	/* 13 */
	/***/ (function(module, exports) {
	
		/**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */
		var isArray = Array.isArray;
	
		module.exports = isArray;
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var PropTypes = __webpack_require__(2).PropTypes;
	
		module.exports = {
		  selected: PropTypes.object.isRequired,
		  copied: PropTypes.object,
		  dragged: PropTypes.object,
		  onCellClick: PropTypes.func.isRequired,
		  onCellDoubleClick: PropTypes.func.isRequired,
		  onCommit: PropTypes.func.isRequired,
		  onCommitCancel: PropTypes.func.isRequired,
		  handleDragEnterRow: PropTypes.func.isRequired,
		  handleTerminateDrag: PropTypes.func.isRequired
		};
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseGetTag = __webpack_require__(42),
		    getPrototype = __webpack_require__(304),
		    isObjectLike = __webpack_require__(30);
	
		/** `Object#toString` result references. */
		var objectTag = '[object Object]';
	
		/** Used for built-in method references. */
		var funcProto = Function.prototype,
		    objectProto = Object.prototype;
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Used to infer the `Object` constructor. */
		var objectCtorString = funcToString.call(Object);
	
		/**
		 * Checks if `value` is a plain object, that is, an object created by the
		 * `Object` constructor or one with a `[[Prototype]]` of `null`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.8.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 * }
		 *
		 * _.isPlainObject(new Foo);
		 * // => false
		 *
		 * _.isPlainObject([1, 2, 3]);
		 * // => false
		 *
		 * _.isPlainObject({ 'x': 0, 'y': 0 });
		 * // => true
		 *
		 * _.isPlainObject(Object.create(null));
		 * // => true
		 */
		function isPlainObject(value) {
		  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
		    return false;
		  }
		  var proto = getPrototype(value);
		  if (proto === null) {
		    return true;
		  }
		  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
		  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
		    funcToString.call(Ctor) == objectCtorString;
		}
	
		module.exports = isPlainObject;
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _DragDropContext = __webpack_require__(129);
	
		Object.defineProperty(exports, 'DragDropContext', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DragDropContext).default;
		  }
		});
	
		var _DragDropContextProvider = __webpack_require__(364);
	
		Object.defineProperty(exports, 'DragDropContextProvider', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DragDropContextProvider).default;
		  }
		});
	
		var _DragLayer = __webpack_require__(365);
	
		Object.defineProperty(exports, 'DragLayer', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DragLayer).default;
		  }
		});
	
		var _DragSource = __webpack_require__(366);
	
		Object.defineProperty(exports, 'DragSource', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DragSource).default;
		  }
		});
	
		var _DropTarget = __webpack_require__(367);
	
		Object.defineProperty(exports, 'DropTarget', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DropTarget).default;
		  }
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		function createObjectWithProperties(originalObj, properties) {
		  var result = {};
		  for (var _iterator = properties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var property = _ref;
	
		    if (originalObj[property]) {
		      result[property] = originalObj[property];
		    }
		  }
		  return result;
		}
	
		module.exports = createObjectWithProperties;
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 *  Copyright (c) 2014-2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		(function (global, factory) {
		   true ? module.exports = factory() :
		  typeof define === 'function' && define.amd ? define(factory) :
		  (global.Immutable = factory());
		}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
		  function createClass(ctor, superClass) {
		    if (superClass) {
		      ctor.prototype = Object.create(superClass.prototype);
		    }
		    ctor.prototype.constructor = ctor;
		  }
	
		  function Iterable(value) {
		      return isIterable(value) ? value : Seq(value);
		    }
	
	
		  createClass(KeyedIterable, Iterable);
		    function KeyedIterable(value) {
		      return isKeyed(value) ? value : KeyedSeq(value);
		    }
	
	
		  createClass(IndexedIterable, Iterable);
		    function IndexedIterable(value) {
		      return isIndexed(value) ? value : IndexedSeq(value);
		    }
	
	
		  createClass(SetIterable, Iterable);
		    function SetIterable(value) {
		      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
		    }
	
	
	
		  function isIterable(maybeIterable) {
		    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
		  }
	
		  function isKeyed(maybeKeyed) {
		    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
		  }
	
		  function isIndexed(maybeIndexed) {
		    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
		  }
	
		  function isAssociative(maybeAssociative) {
		    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
		  }
	
		  function isOrdered(maybeOrdered) {
		    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
		  }
	
		  Iterable.isIterable = isIterable;
		  Iterable.isKeyed = isKeyed;
		  Iterable.isIndexed = isIndexed;
		  Iterable.isAssociative = isAssociative;
		  Iterable.isOrdered = isOrdered;
	
		  Iterable.Keyed = KeyedIterable;
		  Iterable.Indexed = IndexedIterable;
		  Iterable.Set = SetIterable;
	
	
		  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
		  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
		  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
		  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
		  // Used for setting prototype methods that IE8 chokes on.
		  var DELETE = 'delete';
	
		  // Constants describing the size of trie nodes.
		  var SHIFT = 5; // Resulted in best performance after ______?
		  var SIZE = 1 << SHIFT;
		  var MASK = SIZE - 1;
	
		  // A consistent shared value representing "not set" which equals nothing other
		  // than itself, and nothing that could be provided externally.
		  var NOT_SET = {};
	
		  // Boolean references, Rough equivalent of `bool &`.
		  var CHANGE_LENGTH = { value: false };
		  var DID_ALTER = { value: false };
	
		  function MakeRef(ref) {
		    ref.value = false;
		    return ref;
		  }
	
		  function SetRef(ref) {
		    ref && (ref.value = true);
		  }
	
		  // A function which returns a value representing an "owner" for transient writes
		  // to tries. The return value will only ever equal itself, and will not equal
		  // the return of any subsequent call of this function.
		  function OwnerID() {}
	
		  // http://jsperf.com/copy-array-inline
		  function arrCopy(arr, offset) {
		    offset = offset || 0;
		    var len = Math.max(0, arr.length - offset);
		    var newArr = new Array(len);
		    for (var ii = 0; ii < len; ii++) {
		      newArr[ii] = arr[ii + offset];
		    }
		    return newArr;
		  }
	
		  function ensureSize(iter) {
		    if (iter.size === undefined) {
		      iter.size = iter.__iterate(returnTrue);
		    }
		    return iter.size;
		  }
	
		  function wrapIndex(iter, index) {
		    // This implements "is array index" which the ECMAString spec defines as:
		    //
		    //     A String property name P is an array index if and only if
		    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
		    //     to 2^32−1.
		    //
		    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
		    if (typeof index !== 'number') {
		      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
		      if ('' + uint32Index !== index || uint32Index === 4294967295) {
		        return NaN;
		      }
		      index = uint32Index;
		    }
		    return index < 0 ? ensureSize(iter) + index : index;
		  }
	
		  function returnTrue() {
		    return true;
		  }
	
		  function wholeSlice(begin, end, size) {
		    return (begin === 0 || (size !== undefined && begin <= -size)) &&
		      (end === undefined || (size !== undefined && end >= size));
		  }
	
		  function resolveBegin(begin, size) {
		    return resolveIndex(begin, size, 0);
		  }
	
		  function resolveEnd(end, size) {
		    return resolveIndex(end, size, size);
		  }
	
		  function resolveIndex(index, size, defaultIndex) {
		    return index === undefined ?
		      defaultIndex :
		      index < 0 ?
		        Math.max(0, size + index) :
		        size === undefined ?
		          index :
		          Math.min(size, index);
		  }
	
		  /* global Symbol */
	
		  var ITERATE_KEYS = 0;
		  var ITERATE_VALUES = 1;
		  var ITERATE_ENTRIES = 2;
	
		  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
		  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
		  function Iterator(next) {
		      this.next = next;
		    }
	
		    Iterator.prototype.toString = function() {
		      return '[Iterator]';
		    };
	
	
		  Iterator.KEYS = ITERATE_KEYS;
		  Iterator.VALUES = ITERATE_VALUES;
		  Iterator.ENTRIES = ITERATE_ENTRIES;
	
		  Iterator.prototype.inspect =
		  Iterator.prototype.toSource = function () { return this.toString(); }
		  Iterator.prototype[ITERATOR_SYMBOL] = function () {
		    return this;
		  };
	
	
		  function iteratorValue(type, k, v, iteratorResult) {
		    var value = type === 0 ? k : type === 1 ? v : [k, v];
		    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
		      value: value, done: false
		    });
		    return iteratorResult;
		  }
	
		  function iteratorDone() {
		    return { value: undefined, done: true };
		  }
	
		  function hasIterator(maybeIterable) {
		    return !!getIteratorFn(maybeIterable);
		  }
	
		  function isIterator(maybeIterator) {
		    return maybeIterator && typeof maybeIterator.next === 'function';
		  }
	
		  function getIterator(iterable) {
		    var iteratorFn = getIteratorFn(iterable);
		    return iteratorFn && iteratorFn.call(iterable);
		  }
	
		  function getIteratorFn(iterable) {
		    var iteratorFn = iterable && (
		      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
		      iterable[FAUX_ITERATOR_SYMBOL]
		    );
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
	
		  function isArrayLike(value) {
		    return value && typeof value.length === 'number';
		  }
	
		  createClass(Seq, Iterable);
		    function Seq(value) {
		      return value === null || value === undefined ? emptySequence() :
		        isIterable(value) ? value.toSeq() : seqFromValue(value);
		    }
	
		    Seq.of = function(/*...values*/) {
		      return Seq(arguments);
		    };
	
		    Seq.prototype.toSeq = function() {
		      return this;
		    };
	
		    Seq.prototype.toString = function() {
		      return this.__toString('Seq {', '}');
		    };
	
		    Seq.prototype.cacheResult = function() {
		      if (!this._cache && this.__iterateUncached) {
		        this._cache = this.entrySeq().toArray();
		        this.size = this._cache.length;
		      }
		      return this;
		    };
	
		    // abstract __iterateUncached(fn, reverse)
	
		    Seq.prototype.__iterate = function(fn, reverse) {
		      return seqIterate(this, fn, reverse, true);
		    };
	
		    // abstract __iteratorUncached(type, reverse)
	
		    Seq.prototype.__iterator = function(type, reverse) {
		      return seqIterator(this, type, reverse, true);
		    };
	
	
	
		  createClass(KeyedSeq, Seq);
		    function KeyedSeq(value) {
		      return value === null || value === undefined ?
		        emptySequence().toKeyedSeq() :
		        isIterable(value) ?
		          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
		          keyedSeqFromValue(value);
		    }
	
		    KeyedSeq.prototype.toKeyedSeq = function() {
		      return this;
		    };
	
	
	
		  createClass(IndexedSeq, Seq);
		    function IndexedSeq(value) {
		      return value === null || value === undefined ? emptySequence() :
		        !isIterable(value) ? indexedSeqFromValue(value) :
		        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
		    }
	
		    IndexedSeq.of = function(/*...values*/) {
		      return IndexedSeq(arguments);
		    };
	
		    IndexedSeq.prototype.toIndexedSeq = function() {
		      return this;
		    };
	
		    IndexedSeq.prototype.toString = function() {
		      return this.__toString('Seq [', ']');
		    };
	
		    IndexedSeq.prototype.__iterate = function(fn, reverse) {
		      return seqIterate(this, fn, reverse, false);
		    };
	
		    IndexedSeq.prototype.__iterator = function(type, reverse) {
		      return seqIterator(this, type, reverse, false);
		    };
	
	
	
		  createClass(SetSeq, Seq);
		    function SetSeq(value) {
		      return (
		        value === null || value === undefined ? emptySequence() :
		        !isIterable(value) ? indexedSeqFromValue(value) :
		        isKeyed(value) ? value.entrySeq() : value
		      ).toSetSeq();
		    }
	
		    SetSeq.of = function(/*...values*/) {
		      return SetSeq(arguments);
		    };
	
		    SetSeq.prototype.toSetSeq = function() {
		      return this;
		    };
	
	
	
		  Seq.isSeq = isSeq;
		  Seq.Keyed = KeyedSeq;
		  Seq.Set = SetSeq;
		  Seq.Indexed = IndexedSeq;
	
		  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
		  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
		  createClass(ArraySeq, IndexedSeq);
		    function ArraySeq(array) {
		      this._array = array;
		      this.size = array.length;
		    }
	
		    ArraySeq.prototype.get = function(index, notSetValue) {
		      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
		    };
	
		    ArraySeq.prototype.__iterate = function(fn, reverse) {
		      var array = this._array;
		      var maxIndex = array.length - 1;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    };
	
		    ArraySeq.prototype.__iterator = function(type, reverse) {
		      var array = this._array;
		      var maxIndex = array.length - 1;
		      var ii = 0;
		      return new Iterator(function() 
		        {return ii > maxIndex ?
		          iteratorDone() :
		          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
		      );
		    };
	
	
	
		  createClass(ObjectSeq, KeyedSeq);
		    function ObjectSeq(object) {
		      var keys = Object.keys(object);
		      this._object = object;
		      this._keys = keys;
		      this.size = keys.length;
		    }
	
		    ObjectSeq.prototype.get = function(key, notSetValue) {
		      if (notSetValue !== undefined && !this.has(key)) {
		        return notSetValue;
		      }
		      return this._object[key];
		    };
	
		    ObjectSeq.prototype.has = function(key) {
		      return this._object.hasOwnProperty(key);
		    };
	
		    ObjectSeq.prototype.__iterate = function(fn, reverse) {
		      var object = this._object;
		      var keys = this._keys;
		      var maxIndex = keys.length - 1;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        var key = keys[reverse ? maxIndex - ii : ii];
		        if (fn(object[key], key, this) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    };
	
		    ObjectSeq.prototype.__iterator = function(type, reverse) {
		      var object = this._object;
		      var keys = this._keys;
		      var maxIndex = keys.length - 1;
		      var ii = 0;
		      return new Iterator(function()  {
		        var key = keys[reverse ? maxIndex - ii : ii];
		        return ii++ > maxIndex ?
		          iteratorDone() :
		          iteratorValue(type, key, object[key]);
		      });
		    };
	
		  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
		  createClass(IterableSeq, IndexedSeq);
		    function IterableSeq(iterable) {
		      this._iterable = iterable;
		      this.size = iterable.length || iterable.size;
		    }
	
		    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var iterable = this._iterable;
		      var iterator = getIterator(iterable);
		      var iterations = 0;
		      if (isIterator(iterator)) {
		        var step;
		        while (!(step = iterator.next()).done) {
		          if (fn(step.value, iterations++, this) === false) {
		            break;
		          }
		        }
		      }
		      return iterations;
		    };
	
		    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterable = this._iterable;
		      var iterator = getIterator(iterable);
		      if (!isIterator(iterator)) {
		        return new Iterator(iteratorDone);
		      }
		      var iterations = 0;
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step : iteratorValue(type, iterations++, step.value);
		      });
		    };
	
	
	
		  createClass(IteratorSeq, IndexedSeq);
		    function IteratorSeq(iterator) {
		      this._iterator = iterator;
		      this._iteratorCache = [];
		    }
	
		    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var iterator = this._iterator;
		      var cache = this._iteratorCache;
		      var iterations = 0;
		      while (iterations < cache.length) {
		        if (fn(cache[iterations], iterations++, this) === false) {
		          return iterations;
		        }
		      }
		      var step;
		      while (!(step = iterator.next()).done) {
		        var val = step.value;
		        cache[iterations] = val;
		        if (fn(val, iterations++, this) === false) {
		          break;
		        }
		      }
		      return iterations;
		    };
	
		    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterator = this._iterator;
		      var cache = this._iteratorCache;
		      var iterations = 0;
		      return new Iterator(function()  {
		        if (iterations >= cache.length) {
		          var step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		          cache[iterations] = step.value;
		        }
		        return iteratorValue(type, iterations, cache[iterations++]);
		      });
		    };
	
	
	
	
		  // # pragma Helper functions
	
		  function isSeq(maybeSeq) {
		    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
		  }
	
		  var EMPTY_SEQ;
	
		  function emptySequence() {
		    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
		  }
	
		  function keyedSeqFromValue(value) {
		    var seq =
		      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
		      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
		      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
		      typeof value === 'object' ? new ObjectSeq(value) :
		      undefined;
		    if (!seq) {
		      throw new TypeError(
		        'Expected Array or iterable object of [k, v] entries, '+
		        'or keyed object: ' + value
		      );
		    }
		    return seq;
		  }
	
		  function indexedSeqFromValue(value) {
		    var seq = maybeIndexedSeqFromValue(value);
		    if (!seq) {
		      throw new TypeError(
		        'Expected Array or iterable object of values: ' + value
		      );
		    }
		    return seq;
		  }
	
		  function seqFromValue(value) {
		    var seq = maybeIndexedSeqFromValue(value) ||
		      (typeof value === 'object' && new ObjectSeq(value));
		    if (!seq) {
		      throw new TypeError(
		        'Expected Array or iterable object of values, or keyed object: ' + value
		      );
		    }
		    return seq;
		  }
	
		  function maybeIndexedSeqFromValue(value) {
		    return (
		      isArrayLike(value) ? new ArraySeq(value) :
		      isIterator(value) ? new IteratorSeq(value) :
		      hasIterator(value) ? new IterableSeq(value) :
		      undefined
		    );
		  }
	
		  function seqIterate(seq, fn, reverse, useKeys) {
		    var cache = seq._cache;
		    if (cache) {
		      var maxIndex = cache.length - 1;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        var entry = cache[reverse ? maxIndex - ii : ii];
		        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    }
		    return seq.__iterateUncached(fn, reverse);
		  }
	
		  function seqIterator(seq, type, reverse, useKeys) {
		    var cache = seq._cache;
		    if (cache) {
		      var maxIndex = cache.length - 1;
		      var ii = 0;
		      return new Iterator(function()  {
		        var entry = cache[reverse ? maxIndex - ii : ii];
		        return ii++ > maxIndex ?
		          iteratorDone() :
		          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
		      });
		    }
		    return seq.__iteratorUncached(type, reverse);
		  }
	
		  function fromJS(json, converter) {
		    return converter ?
		      fromJSWith(converter, json, '', {'': json}) :
		      fromJSDefault(json);
		  }
	
		  function fromJSWith(converter, json, key, parentJSON) {
		    if (Array.isArray(json)) {
		      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
		    }
		    if (isPlainObj(json)) {
		      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
		    }
		    return json;
		  }
	
		  function fromJSDefault(json) {
		    if (Array.isArray(json)) {
		      return IndexedSeq(json).map(fromJSDefault).toList();
		    }
		    if (isPlainObj(json)) {
		      return KeyedSeq(json).map(fromJSDefault).toMap();
		    }
		    return json;
		  }
	
		  function isPlainObj(value) {
		    return value && (value.constructor === Object || value.constructor === undefined);
		  }
	
		  /**
		   * An extension of the "same-value" algorithm as [described for use by ES6 Map
		   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
		   *
		   * NaN is considered the same as NaN, however -0 and 0 are considered the same
		   * value, which is different from the algorithm described by
		   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
		   *
		   * This is extended further to allow Objects to describe the values they
		   * represent, by way of `valueOf` or `equals` (and `hashCode`).
		   *
		   * Note: because of this extension, the key equality of Immutable.Map and the
		   * value equality of Immutable.Set will differ from ES6 Map and Set.
		   *
		   * ### Defining custom values
		   *
		   * The easiest way to describe the value an object represents is by implementing
		   * `valueOf`. For example, `Date` represents a value by returning a unix
		   * timestamp for `valueOf`:
		   *
		   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
		   *     var date2 = new Date(1234567890000);
		   *     date1.valueOf(); // 1234567890000
		   *     assert( date1 !== date2 );
		   *     assert( Immutable.is( date1, date2 ) );
		   *
		   * Note: overriding `valueOf` may have other implications if you use this object
		   * where JavaScript expects a primitive, such as implicit string coercion.
		   *
		   * For more complex types, especially collections, implementing `valueOf` may
		   * not be performant. An alternative is to implement `equals` and `hashCode`.
		   *
		   * `equals` takes another object, presumably of similar type, and returns true
		   * if the it is equal. Equality is symmetrical, so the same result should be
		   * returned if this and the argument are flipped.
		   *
		   *     assert( a.equals(b) === b.equals(a) );
		   *
		   * `hashCode` returns a 32bit integer number representing the object which will
		   * be used to determine how to store the value object in a Map or Set. You must
		   * provide both or neither methods, one must not exist without the other.
		   *
		   * Also, an important relationship between these methods must be upheld: if two
		   * values are equal, they *must* return the same hashCode. If the values are not
		   * equal, they might have the same hashCode; this is called a hash collision,
		   * and while undesirable for performance reasons, it is acceptable.
		   *
		   *     if (a.equals(b)) {
		   *       assert( a.hashCode() === b.hashCode() );
		   *     }
		   *
		   * All Immutable collections implement `equals` and `hashCode`.
		   *
		   */
		  function is(valueA, valueB) {
		    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
		      return true;
		    }
		    if (!valueA || !valueB) {
		      return false;
		    }
		    if (typeof valueA.valueOf === 'function' &&
		        typeof valueB.valueOf === 'function') {
		      valueA = valueA.valueOf();
		      valueB = valueB.valueOf();
		      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
		        return true;
		      }
		      if (!valueA || !valueB) {
		        return false;
		      }
		    }
		    if (typeof valueA.equals === 'function' &&
		        typeof valueB.equals === 'function' &&
		        valueA.equals(valueB)) {
		      return true;
		    }
		    return false;
		  }
	
		  function deepEqual(a, b) {
		    if (a === b) {
		      return true;
		    }
	
		    if (
		      !isIterable(b) ||
		      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
		      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
		      isKeyed(a) !== isKeyed(b) ||
		      isIndexed(a) !== isIndexed(b) ||
		      isOrdered(a) !== isOrdered(b)
		    ) {
		      return false;
		    }
	
		    if (a.size === 0 && b.size === 0) {
		      return true;
		    }
	
		    var notAssociative = !isAssociative(a);
	
		    if (isOrdered(a)) {
		      var entries = a.entries();
		      return b.every(function(v, k)  {
		        var entry = entries.next().value;
		        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
		      }) && entries.next().done;
		    }
	
		    var flipped = false;
	
		    if (a.size === undefined) {
		      if (b.size === undefined) {
		        if (typeof a.cacheResult === 'function') {
		          a.cacheResult();
		        }
		      } else {
		        flipped = true;
		        var _ = a;
		        a = b;
		        b = _;
		      }
		    }
	
		    var allEqual = true;
		    var bSize = b.__iterate(function(v, k)  {
		      if (notAssociative ? !a.has(v) :
		          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
		        allEqual = false;
		        return false;
		      }
		    });
	
		    return allEqual && a.size === bSize;
		  }
	
		  createClass(Repeat, IndexedSeq);
	
		    function Repeat(value, times) {
		      if (!(this instanceof Repeat)) {
		        return new Repeat(value, times);
		      }
		      this._value = value;
		      this.size = times === undefined ? Infinity : Math.max(0, times);
		      if (this.size === 0) {
		        if (EMPTY_REPEAT) {
		          return EMPTY_REPEAT;
		        }
		        EMPTY_REPEAT = this;
		      }
		    }
	
		    Repeat.prototype.toString = function() {
		      if (this.size === 0) {
		        return 'Repeat []';
		      }
		      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
		    };
	
		    Repeat.prototype.get = function(index, notSetValue) {
		      return this.has(index) ? this._value : notSetValue;
		    };
	
		    Repeat.prototype.includes = function(searchValue) {
		      return is(this._value, searchValue);
		    };
	
		    Repeat.prototype.slice = function(begin, end) {
		      var size = this.size;
		      return wholeSlice(begin, end, size) ? this :
		        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
		    };
	
		    Repeat.prototype.reverse = function() {
		      return this;
		    };
	
		    Repeat.prototype.indexOf = function(searchValue) {
		      if (is(this._value, searchValue)) {
		        return 0;
		      }
		      return -1;
		    };
	
		    Repeat.prototype.lastIndexOf = function(searchValue) {
		      if (is(this._value, searchValue)) {
		        return this.size;
		      }
		      return -1;
		    };
	
		    Repeat.prototype.__iterate = function(fn, reverse) {
		      for (var ii = 0; ii < this.size; ii++) {
		        if (fn(this._value, ii, this) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    };
	
		    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
		      var ii = 0;
		      return new Iterator(function() 
		        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
		      );
		    };
	
		    Repeat.prototype.equals = function(other) {
		      return other instanceof Repeat ?
		        is(this._value, other._value) :
		        deepEqual(other);
		    };
	
	
		  var EMPTY_REPEAT;
	
		  function invariant(condition, error) {
		    if (!condition) throw new Error(error);
		  }
	
		  createClass(Range, IndexedSeq);
	
		    function Range(start, end, step) {
		      if (!(this instanceof Range)) {
		        return new Range(start, end, step);
		      }
		      invariant(step !== 0, 'Cannot step a Range by 0');
		      start = start || 0;
		      if (end === undefined) {
		        end = Infinity;
		      }
		      step = step === undefined ? 1 : Math.abs(step);
		      if (end < start) {
		        step = -step;
		      }
		      this._start = start;
		      this._end = end;
		      this._step = step;
		      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
		      if (this.size === 0) {
		        if (EMPTY_RANGE) {
		          return EMPTY_RANGE;
		        }
		        EMPTY_RANGE = this;
		      }
		    }
	
		    Range.prototype.toString = function() {
		      if (this.size === 0) {
		        return 'Range []';
		      }
		      return 'Range [ ' +
		        this._start + '...' + this._end +
		        (this._step !== 1 ? ' by ' + this._step : '') +
		      ' ]';
		    };
	
		    Range.prototype.get = function(index, notSetValue) {
		      return this.has(index) ?
		        this._start + wrapIndex(this, index) * this._step :
		        notSetValue;
		    };
	
		    Range.prototype.includes = function(searchValue) {
		      var possibleIndex = (searchValue - this._start) / this._step;
		      return possibleIndex >= 0 &&
		        possibleIndex < this.size &&
		        possibleIndex === Math.floor(possibleIndex);
		    };
	
		    Range.prototype.slice = function(begin, end) {
		      if (wholeSlice(begin, end, this.size)) {
		        return this;
		      }
		      begin = resolveBegin(begin, this.size);
		      end = resolveEnd(end, this.size);
		      if (end <= begin) {
		        return new Range(0, 0);
		      }
		      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
		    };
	
		    Range.prototype.indexOf = function(searchValue) {
		      var offsetValue = searchValue - this._start;
		      if (offsetValue % this._step === 0) {
		        var index = offsetValue / this._step;
		        if (index >= 0 && index < this.size) {
		          return index
		        }
		      }
		      return -1;
		    };
	
		    Range.prototype.lastIndexOf = function(searchValue) {
		      return this.indexOf(searchValue);
		    };
	
		    Range.prototype.__iterate = function(fn, reverse) {
		      var maxIndex = this.size - 1;
		      var step = this._step;
		      var value = reverse ? this._start + maxIndex * step : this._start;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        if (fn(value, ii, this) === false) {
		          return ii + 1;
		        }
		        value += reverse ? -step : step;
		      }
		      return ii;
		    };
	
		    Range.prototype.__iterator = function(type, reverse) {
		      var maxIndex = this.size - 1;
		      var step = this._step;
		      var value = reverse ? this._start + maxIndex * step : this._start;
		      var ii = 0;
		      return new Iterator(function()  {
		        var v = value;
		        value += reverse ? -step : step;
		        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
		      });
		    };
	
		    Range.prototype.equals = function(other) {
		      return other instanceof Range ?
		        this._start === other._start &&
		        this._end === other._end &&
		        this._step === other._step :
		        deepEqual(this, other);
		    };
	
	
		  var EMPTY_RANGE;
	
		  createClass(Collection, Iterable);
		    function Collection() {
		      throw TypeError('Abstract');
		    }
	
	
		  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
		  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
		  createClass(SetCollection, Collection);function SetCollection() {}
	
	
		  Collection.Keyed = KeyedCollection;
		  Collection.Indexed = IndexedCollection;
		  Collection.Set = SetCollection;
	
		  var imul =
		    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
		    Math.imul :
		    function imul(a, b) {
		      a = a | 0; // int
		      b = b | 0; // int
		      var c = a & 0xffff;
		      var d = b & 0xffff;
		      // Shift by 0 fixes the sign on the high part.
		      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
		    };
	
		  // v8 has an optimization for storing 31-bit signed numbers.
		  // Values which have either 00 or 11 as the high order bits qualify.
		  // This function drops the highest order bit in a signed number, maintaining
		  // the sign bit.
		  function smi(i32) {
		    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
		  }
	
		  function hash(o) {
		    if (o === false || o === null || o === undefined) {
		      return 0;
		    }
		    if (typeof o.valueOf === 'function') {
		      o = o.valueOf();
		      if (o === false || o === null || o === undefined) {
		        return 0;
		      }
		    }
		    if (o === true) {
		      return 1;
		    }
		    var type = typeof o;
		    if (type === 'number') {
		      if (o !== o || o === Infinity) {
		        return 0;
		      }
		      var h = o | 0;
		      if (h !== o) {
		        h ^= o * 0xFFFFFFFF;
		      }
		      while (o > 0xFFFFFFFF) {
		        o /= 0xFFFFFFFF;
		        h ^= o;
		      }
		      return smi(h);
		    }
		    if (type === 'string') {
		      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
		    }
		    if (typeof o.hashCode === 'function') {
		      return o.hashCode();
		    }
		    if (type === 'object') {
		      return hashJSObj(o);
		    }
		    if (typeof o.toString === 'function') {
		      return hashString(o.toString());
		    }
		    throw new Error('Value type ' + type + ' cannot be hashed.');
		  }
	
		  function cachedHashString(string) {
		    var hash = stringHashCache[string];
		    if (hash === undefined) {
		      hash = hashString(string);
		      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
		        STRING_HASH_CACHE_SIZE = 0;
		        stringHashCache = {};
		      }
		      STRING_HASH_CACHE_SIZE++;
		      stringHashCache[string] = hash;
		    }
		    return hash;
		  }
	
		  // http://jsperf.com/hashing-strings
		  function hashString(string) {
		    // This is the hash from JVM
		    // The hash code for a string is computed as
		    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
		    // where s[i] is the ith character of the string and n is the length of
		    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
		    // (exclusive) by dropping high bits.
		    var hash = 0;
		    for (var ii = 0; ii < string.length; ii++) {
		      hash = 31 * hash + string.charCodeAt(ii) | 0;
		    }
		    return smi(hash);
		  }
	
		  function hashJSObj(obj) {
		    var hash;
		    if (usingWeakMap) {
		      hash = weakMap.get(obj);
		      if (hash !== undefined) {
		        return hash;
		      }
		    }
	
		    hash = obj[UID_HASH_KEY];
		    if (hash !== undefined) {
		      return hash;
		    }
	
		    if (!canDefineProperty) {
		      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
		      if (hash !== undefined) {
		        return hash;
		      }
	
		      hash = getIENodeHash(obj);
		      if (hash !== undefined) {
		        return hash;
		      }
		    }
	
		    hash = ++objHashUID;
		    if (objHashUID & 0x40000000) {
		      objHashUID = 0;
		    }
	
		    if (usingWeakMap) {
		      weakMap.set(obj, hash);
		    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
		      throw new Error('Non-extensible objects are not allowed as keys.');
		    } else if (canDefineProperty) {
		      Object.defineProperty(obj, UID_HASH_KEY, {
		        'enumerable': false,
		        'configurable': false,
		        'writable': false,
		        'value': hash
		      });
		    } else if (obj.propertyIsEnumerable !== undefined &&
		               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
		      // Since we can't define a non-enumerable property on the object
		      // we'll hijack one of the less-used non-enumerable properties to
		      // save our hash on it. Since this is a function it will not show up in
		      // `JSON.stringify` which is what we want.
		      obj.propertyIsEnumerable = function() {
		        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
		      };
		      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
		    } else if (obj.nodeType !== undefined) {
		      // At this point we couldn't get the IE `uniqueID` to use as a hash
		      // and we couldn't use a non-enumerable property to exploit the
		      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
		      // itself.
		      obj[UID_HASH_KEY] = hash;
		    } else {
		      throw new Error('Unable to set a non-enumerable property on object.');
		    }
	
		    return hash;
		  }
	
		  // Get references to ES5 object methods.
		  var isExtensible = Object.isExtensible;
	
		  // True if Object.defineProperty works as expected. IE8 fails this test.
		  var canDefineProperty = (function() {
		    try {
		      Object.defineProperty({}, '@', {});
		      return true;
		    } catch (e) {
		      return false;
		    }
		  }());
	
		  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
		  // and avoid memory leaks from the IE cloneNode bug.
		  function getIENodeHash(node) {
		    if (node && node.nodeType > 0) {
		      switch (node.nodeType) {
		        case 1: // Element
		          return node.uniqueID;
		        case 9: // Document
		          return node.documentElement && node.documentElement.uniqueID;
		      }
		    }
		  }
	
		  // If possible, use a WeakMap.
		  var usingWeakMap = typeof WeakMap === 'function';
		  var weakMap;
		  if (usingWeakMap) {
		    weakMap = new WeakMap();
		  }
	
		  var objHashUID = 0;
	
		  var UID_HASH_KEY = '__immutablehash__';
		  if (typeof Symbol === 'function') {
		    UID_HASH_KEY = Symbol(UID_HASH_KEY);
		  }
	
		  var STRING_HASH_CACHE_MIN_STRLEN = 16;
		  var STRING_HASH_CACHE_MAX_SIZE = 255;
		  var STRING_HASH_CACHE_SIZE = 0;
		  var stringHashCache = {};
	
		  function assertNotInfinite(size) {
		    invariant(
		      size !== Infinity,
		      'Cannot perform this action with an infinite size.'
		    );
		  }
	
		  createClass(Map, KeyedCollection);
	
		    // @pragma Construction
	
		    function Map(value) {
		      return value === null || value === undefined ? emptyMap() :
		        isMap(value) && !isOrdered(value) ? value :
		        emptyMap().withMutations(function(map ) {
		          var iter = KeyedIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v, k)  {return map.set(k, v)});
		        });
		    }
	
		    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
		      return emptyMap().withMutations(function(map ) {
		        for (var i = 0; i < keyValues.length; i += 2) {
		          if (i + 1 >= keyValues.length) {
		            throw new Error('Missing value for key: ' + keyValues[i]);
		          }
		          map.set(keyValues[i], keyValues[i + 1]);
		        }
		      });
		    };
	
		    Map.prototype.toString = function() {
		      return this.__toString('Map {', '}');
		    };
	
		    // @pragma Access
	
		    Map.prototype.get = function(k, notSetValue) {
		      return this._root ?
		        this._root.get(0, undefined, k, notSetValue) :
		        notSetValue;
		    };
	
		    // @pragma Modification
	
		    Map.prototype.set = function(k, v) {
		      return updateMap(this, k, v);
		    };
	
		    Map.prototype.setIn = function(keyPath, v) {
		      return this.updateIn(keyPath, NOT_SET, function()  {return v});
		    };
	
		    Map.prototype.remove = function(k) {
		      return updateMap(this, k, NOT_SET);
		    };
	
		    Map.prototype.deleteIn = function(keyPath) {
		      return this.updateIn(keyPath, function()  {return NOT_SET});
		    };
	
		    Map.prototype.update = function(k, notSetValue, updater) {
		      return arguments.length === 1 ?
		        k(this) :
		        this.updateIn([k], notSetValue, updater);
		    };
	
		    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
		      if (!updater) {
		        updater = notSetValue;
		        notSetValue = undefined;
		      }
		      var updatedValue = updateInDeepMap(
		        this,
		        forceIterator(keyPath),
		        notSetValue,
		        updater
		      );
		      return updatedValue === NOT_SET ? undefined : updatedValue;
		    };
	
		    Map.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = 0;
		        this._root = null;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return emptyMap();
		    };
	
		    // @pragma Composition
	
		    Map.prototype.merge = function(/*...iters*/) {
		      return mergeIntoMapWith(this, undefined, arguments);
		    };
	
		    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoMapWith(this, merger, iters);
		    };
	
		    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
		      return this.updateIn(
		        keyPath,
		        emptyMap(),
		        function(m ) {return typeof m.merge === 'function' ?
		          m.merge.apply(m, iters) :
		          iters[iters.length - 1]}
		      );
		    };
	
		    Map.prototype.mergeDeep = function(/*...iters*/) {
		      return mergeIntoMapWith(this, deepMerger, arguments);
		    };
	
		    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
		    };
	
		    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
		      return this.updateIn(
		        keyPath,
		        emptyMap(),
		        function(m ) {return typeof m.mergeDeep === 'function' ?
		          m.mergeDeep.apply(m, iters) :
		          iters[iters.length - 1]}
		      );
		    };
	
		    Map.prototype.sort = function(comparator) {
		      // Late binding
		      return OrderedMap(sortFactory(this, comparator));
		    };
	
		    Map.prototype.sortBy = function(mapper, comparator) {
		      // Late binding
		      return OrderedMap(sortFactory(this, comparator, mapper));
		    };
	
		    // @pragma Mutability
	
		    Map.prototype.withMutations = function(fn) {
		      var mutable = this.asMutable();
		      fn(mutable);
		      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
		    };
	
		    Map.prototype.asMutable = function() {
		      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
		    };
	
		    Map.prototype.asImmutable = function() {
		      return this.__ensureOwner();
		    };
	
		    Map.prototype.wasAltered = function() {
		      return this.__altered;
		    };
	
		    Map.prototype.__iterator = function(type, reverse) {
		      return new MapIterator(this, type, reverse);
		    };
	
		    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      this._root && this._root.iterate(function(entry ) {
		        iterations++;
		        return fn(entry[1], entry[0], this$0);
		      }, reverse);
		      return iterations;
		    };
	
		    Map.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this.__altered = false;
		        return this;
		      }
		      return makeMap(this.size, this._root, ownerID, this.__hash);
		    };
	
	
		  function isMap(maybeMap) {
		    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
		  }
	
		  Map.isMap = isMap;
	
		  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
		  var MapPrototype = Map.prototype;
		  MapPrototype[IS_MAP_SENTINEL] = true;
		  MapPrototype[DELETE] = MapPrototype.remove;
		  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
		  // #pragma Trie Nodes
	
	
	
		    function ArrayMapNode(ownerID, entries) {
		      this.ownerID = ownerID;
		      this.entries = entries;
		    }
	
		    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      var entries = this.entries;
		      for (var ii = 0, len = entries.length; ii < len; ii++) {
		        if (is(key, entries[ii][0])) {
		          return entries[ii][1];
		        }
		      }
		      return notSetValue;
		    };
	
		    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      var removed = value === NOT_SET;
	
		      var entries = this.entries;
		      var idx = 0;
		      for (var len = entries.length; idx < len; idx++) {
		        if (is(key, entries[idx][0])) {
		          break;
		        }
		      }
		      var exists = idx < len;
	
		      if (exists ? entries[idx][1] === value : removed) {
		        return this;
		      }
	
		      SetRef(didAlter);
		      (removed || !exists) && SetRef(didChangeSize);
	
		      if (removed && entries.length === 1) {
		        return; // undefined
		      }
	
		      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
		        return createNodes(ownerID, entries, key, value);
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newEntries = isEditable ? entries : arrCopy(entries);
	
		      if (exists) {
		        if (removed) {
		          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
		        } else {
		          newEntries[idx] = [key, value];
		        }
		      } else {
		        newEntries.push([key, value]);
		      }
	
		      if (isEditable) {
		        this.entries = newEntries;
		        return this;
		      }
	
		      return new ArrayMapNode(ownerID, newEntries);
		    };
	
	
	
	
		    function BitmapIndexedNode(ownerID, bitmap, nodes) {
		      this.ownerID = ownerID;
		      this.bitmap = bitmap;
		      this.nodes = nodes;
		    }
	
		    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
		      var bitmap = this.bitmap;
		      return (bitmap & bit) === 0 ? notSetValue :
		        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
		    };
	
		    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
		      var bit = 1 << keyHashFrag;
		      var bitmap = this.bitmap;
		      var exists = (bitmap & bit) !== 0;
	
		      if (!exists && value === NOT_SET) {
		        return this;
		      }
	
		      var idx = popCount(bitmap & (bit - 1));
		      var nodes = this.nodes;
		      var node = exists ? nodes[idx] : undefined;
		      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
		      if (newNode === node) {
		        return this;
		      }
	
		      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
		        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
		      }
	
		      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
		        return nodes[idx ^ 1];
		      }
	
		      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
		        return newNode;
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
		      var newNodes = exists ? newNode ?
		        setIn(nodes, idx, newNode, isEditable) :
		        spliceOut(nodes, idx, isEditable) :
		        spliceIn(nodes, idx, newNode, isEditable);
	
		      if (isEditable) {
		        this.bitmap = newBitmap;
		        this.nodes = newNodes;
		        return this;
		      }
	
		      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
		    };
	
	
	
	
		    function HashArrayMapNode(ownerID, count, nodes) {
		      this.ownerID = ownerID;
		      this.count = count;
		      this.nodes = nodes;
		    }
	
		    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
		      var node = this.nodes[idx];
		      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
		    };
	
		    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
		      var removed = value === NOT_SET;
		      var nodes = this.nodes;
		      var node = nodes[idx];
	
		      if (removed && !node) {
		        return this;
		      }
	
		      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
		      if (newNode === node) {
		        return this;
		      }
	
		      var newCount = this.count;
		      if (!node) {
		        newCount++;
		      } else if (!newNode) {
		        newCount--;
		        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
		          return packNodes(ownerID, nodes, newCount, idx);
		        }
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
		      if (isEditable) {
		        this.count = newCount;
		        this.nodes = newNodes;
		        return this;
		      }
	
		      return new HashArrayMapNode(ownerID, newCount, newNodes);
		    };
	
	
	
	
		    function HashCollisionNode(ownerID, keyHash, entries) {
		      this.ownerID = ownerID;
		      this.keyHash = keyHash;
		      this.entries = entries;
		    }
	
		    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      var entries = this.entries;
		      for (var ii = 0, len = entries.length; ii < len; ii++) {
		        if (is(key, entries[ii][0])) {
		          return entries[ii][1];
		        }
		      }
		      return notSetValue;
		    };
	
		    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
	
		      var removed = value === NOT_SET;
	
		      if (keyHash !== this.keyHash) {
		        if (removed) {
		          return this;
		        }
		        SetRef(didAlter);
		        SetRef(didChangeSize);
		        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
		      }
	
		      var entries = this.entries;
		      var idx = 0;
		      for (var len = entries.length; idx < len; idx++) {
		        if (is(key, entries[idx][0])) {
		          break;
		        }
		      }
		      var exists = idx < len;
	
		      if (exists ? entries[idx][1] === value : removed) {
		        return this;
		      }
	
		      SetRef(didAlter);
		      (removed || !exists) && SetRef(didChangeSize);
	
		      if (removed && len === 2) {
		        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newEntries = isEditable ? entries : arrCopy(entries);
	
		      if (exists) {
		        if (removed) {
		          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
		        } else {
		          newEntries[idx] = [key, value];
		        }
		      } else {
		        newEntries.push([key, value]);
		      }
	
		      if (isEditable) {
		        this.entries = newEntries;
		        return this;
		      }
	
		      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
		    };
	
	
	
	
		    function ValueNode(ownerID, keyHash, entry) {
		      this.ownerID = ownerID;
		      this.keyHash = keyHash;
		      this.entry = entry;
		    }
	
		    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
		    };
	
		    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      var removed = value === NOT_SET;
		      var keyMatch = is(key, this.entry[0]);
		      if (keyMatch ? value === this.entry[1] : removed) {
		        return this;
		      }
	
		      SetRef(didAlter);
	
		      if (removed) {
		        SetRef(didChangeSize);
		        return; // undefined
		      }
	
		      if (keyMatch) {
		        if (ownerID && ownerID === this.ownerID) {
		          this.entry[1] = value;
		          return this;
		        }
		        return new ValueNode(ownerID, this.keyHash, [key, value]);
		      }
	
		      SetRef(didChangeSize);
		      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
		    };
	
	
	
		  // #pragma Iterators
	
		  ArrayMapNode.prototype.iterate =
		  HashCollisionNode.prototype.iterate = function (fn, reverse) {
		    var entries = this.entries;
		    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
		      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
		        return false;
		      }
		    }
		  }
	
		  BitmapIndexedNode.prototype.iterate =
		  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
		    var nodes = this.nodes;
		    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
		      var node = nodes[reverse ? maxIndex - ii : ii];
		      if (node && node.iterate(fn, reverse) === false) {
		        return false;
		      }
		    }
		  }
	
		  ValueNode.prototype.iterate = function (fn, reverse) {
		    return fn(this.entry);
		  }
	
		  createClass(MapIterator, Iterator);
	
		    function MapIterator(map, type, reverse) {
		      this._type = type;
		      this._reverse = reverse;
		      this._stack = map._root && mapIteratorFrame(map._root);
		    }
	
		    MapIterator.prototype.next = function() {
		      var type = this._type;
		      var stack = this._stack;
		      while (stack) {
		        var node = stack.node;
		        var index = stack.index++;
		        var maxIndex;
		        if (node.entry) {
		          if (index === 0) {
		            return mapIteratorValue(type, node.entry);
		          }
		        } else if (node.entries) {
		          maxIndex = node.entries.length - 1;
		          if (index <= maxIndex) {
		            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
		          }
		        } else {
		          maxIndex = node.nodes.length - 1;
		          if (index <= maxIndex) {
		            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
		            if (subNode) {
		              if (subNode.entry) {
		                return mapIteratorValue(type, subNode.entry);
		              }
		              stack = this._stack = mapIteratorFrame(subNode, stack);
		            }
		            continue;
		          }
		        }
		        stack = this._stack = this._stack.__prev;
		      }
		      return iteratorDone();
		    };
	
	
		  function mapIteratorValue(type, entry) {
		    return iteratorValue(type, entry[0], entry[1]);
		  }
	
		  function mapIteratorFrame(node, prev) {
		    return {
		      node: node,
		      index: 0,
		      __prev: prev
		    };
		  }
	
		  function makeMap(size, root, ownerID, hash) {
		    var map = Object.create(MapPrototype);
		    map.size = size;
		    map._root = root;
		    map.__ownerID = ownerID;
		    map.__hash = hash;
		    map.__altered = false;
		    return map;
		  }
	
		  var EMPTY_MAP;
		  function emptyMap() {
		    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
		  }
	
		  function updateMap(map, k, v) {
		    var newRoot;
		    var newSize;
		    if (!map._root) {
		      if (v === NOT_SET) {
		        return map;
		      }
		      newSize = 1;
		      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
		    } else {
		      var didChangeSize = MakeRef(CHANGE_LENGTH);
		      var didAlter = MakeRef(DID_ALTER);
		      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
		      if (!didAlter.value) {
		        return map;
		      }
		      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
		    }
		    if (map.__ownerID) {
		      map.size = newSize;
		      map._root = newRoot;
		      map.__hash = undefined;
		      map.__altered = true;
		      return map;
		    }
		    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
		  }
	
		  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		    if (!node) {
		      if (value === NOT_SET) {
		        return node;
		      }
		      SetRef(didAlter);
		      SetRef(didChangeSize);
		      return new ValueNode(ownerID, keyHash, [key, value]);
		    }
		    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
		  }
	
		  function isLeafNode(node) {
		    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
		  }
	
		  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
		    if (node.keyHash === keyHash) {
		      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
		    }
	
		    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
		    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
		    var newNode;
		    var nodes = idx1 === idx2 ?
		      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
		      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
		    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
		  }
	
		  function createNodes(ownerID, entries, key, value) {
		    if (!ownerID) {
		      ownerID = new OwnerID();
		    }
		    var node = new ValueNode(ownerID, hash(key), [key, value]);
		    for (var ii = 0; ii < entries.length; ii++) {
		      var entry = entries[ii];
		      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
		    }
		    return node;
		  }
	
		  function packNodes(ownerID, nodes, count, excluding) {
		    var bitmap = 0;
		    var packedII = 0;
		    var packedNodes = new Array(count);
		    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
		      var node = nodes[ii];
		      if (node !== undefined && ii !== excluding) {
		        bitmap |= bit;
		        packedNodes[packedII++] = node;
		      }
		    }
		    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
		  }
	
		  function expandNodes(ownerID, nodes, bitmap, including, node) {
		    var count = 0;
		    var expandedNodes = new Array(SIZE);
		    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
		      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
		    }
		    expandedNodes[including] = node;
		    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
		  }
	
		  function mergeIntoMapWith(map, merger, iterables) {
		    var iters = [];
		    for (var ii = 0; ii < iterables.length; ii++) {
		      var value = iterables[ii];
		      var iter = KeyedIterable(value);
		      if (!isIterable(value)) {
		        iter = iter.map(function(v ) {return fromJS(v)});
		      }
		      iters.push(iter);
		    }
		    return mergeIntoCollectionWith(map, merger, iters);
		  }
	
		  function deepMerger(existing, value, key) {
		    return existing && existing.mergeDeep && isIterable(value) ?
		      existing.mergeDeep(value) :
		      is(existing, value) ? existing : value;
		  }
	
		  function deepMergerWith(merger) {
		    return function(existing, value, key)  {
		      if (existing && existing.mergeDeepWith && isIterable(value)) {
		        return existing.mergeDeepWith(merger, value);
		      }
		      var nextValue = merger(existing, value, key);
		      return is(existing, nextValue) ? existing : nextValue;
		    };
		  }
	
		  function mergeIntoCollectionWith(collection, merger, iters) {
		    iters = iters.filter(function(x ) {return x.size !== 0});
		    if (iters.length === 0) {
		      return collection;
		    }
		    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
		      return collection.constructor(iters[0]);
		    }
		    return collection.withMutations(function(collection ) {
		      var mergeIntoMap = merger ?
		        function(value, key)  {
		          collection.update(key, NOT_SET, function(existing )
		            {return existing === NOT_SET ? value : merger(existing, value, key)}
		          );
		        } :
		        function(value, key)  {
		          collection.set(key, value);
		        }
		      for (var ii = 0; ii < iters.length; ii++) {
		        iters[ii].forEach(mergeIntoMap);
		      }
		    });
		  }
	
		  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
		    var isNotSet = existing === NOT_SET;
		    var step = keyPathIter.next();
		    if (step.done) {
		      var existingValue = isNotSet ? notSetValue : existing;
		      var newValue = updater(existingValue);
		      return newValue === existingValue ? existing : newValue;
		    }
		    invariant(
		      isNotSet || (existing && existing.set),
		      'invalid keyPath'
		    );
		    var key = step.value;
		    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
		    var nextUpdated = updateInDeepMap(
		      nextExisting,
		      keyPathIter,
		      notSetValue,
		      updater
		    );
		    return nextUpdated === nextExisting ? existing :
		      nextUpdated === NOT_SET ? existing.remove(key) :
		      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
		  }
	
		  function popCount(x) {
		    x = x - ((x >> 1) & 0x55555555);
		    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
		    x = (x + (x >> 4)) & 0x0f0f0f0f;
		    x = x + (x >> 8);
		    x = x + (x >> 16);
		    return x & 0x7f;
		  }
	
		  function setIn(array, idx, val, canEdit) {
		    var newArray = canEdit ? array : arrCopy(array);
		    newArray[idx] = val;
		    return newArray;
		  }
	
		  function spliceIn(array, idx, val, canEdit) {
		    var newLen = array.length + 1;
		    if (canEdit && idx + 1 === newLen) {
		      array[idx] = val;
		      return array;
		    }
		    var newArray = new Array(newLen);
		    var after = 0;
		    for (var ii = 0; ii < newLen; ii++) {
		      if (ii === idx) {
		        newArray[ii] = val;
		        after = -1;
		      } else {
		        newArray[ii] = array[ii + after];
		      }
		    }
		    return newArray;
		  }
	
		  function spliceOut(array, idx, canEdit) {
		    var newLen = array.length - 1;
		    if (canEdit && idx === newLen) {
		      array.pop();
		      return array;
		    }
		    var newArray = new Array(newLen);
		    var after = 0;
		    for (var ii = 0; ii < newLen; ii++) {
		      if (ii === idx) {
		        after = 1;
		      }
		      newArray[ii] = array[ii + after];
		    }
		    return newArray;
		  }
	
		  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
		  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
		  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
		  createClass(List, IndexedCollection);
	
		    // @pragma Construction
	
		    function List(value) {
		      var empty = emptyList();
		      if (value === null || value === undefined) {
		        return empty;
		      }
		      if (isList(value)) {
		        return value;
		      }
		      var iter = IndexedIterable(value);
		      var size = iter.size;
		      if (size === 0) {
		        return empty;
		      }
		      assertNotInfinite(size);
		      if (size > 0 && size < SIZE) {
		        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
		      }
		      return empty.withMutations(function(list ) {
		        list.setSize(size);
		        iter.forEach(function(v, i)  {return list.set(i, v)});
		      });
		    }
	
		    List.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    List.prototype.toString = function() {
		      return this.__toString('List [', ']');
		    };
	
		    // @pragma Access
	
		    List.prototype.get = function(index, notSetValue) {
		      index = wrapIndex(this, index);
		      if (index >= 0 && index < this.size) {
		        index += this._origin;
		        var node = listNodeFor(this, index);
		        return node && node.array[index & MASK];
		      }
		      return notSetValue;
		    };
	
		    // @pragma Modification
	
		    List.prototype.set = function(index, value) {
		      return updateList(this, index, value);
		    };
	
		    List.prototype.remove = function(index) {
		      return !this.has(index) ? this :
		        index === 0 ? this.shift() :
		        index === this.size - 1 ? this.pop() :
		        this.splice(index, 1);
		    };
	
		    List.prototype.insert = function(index, value) {
		      return this.splice(index, 0, value);
		    };
	
		    List.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = this._origin = this._capacity = 0;
		        this._level = SHIFT;
		        this._root = this._tail = null;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return emptyList();
		    };
	
		    List.prototype.push = function(/*...values*/) {
		      var values = arguments;
		      var oldSize = this.size;
		      return this.withMutations(function(list ) {
		        setListBounds(list, 0, oldSize + values.length);
		        for (var ii = 0; ii < values.length; ii++) {
		          list.set(oldSize + ii, values[ii]);
		        }
		      });
		    };
	
		    List.prototype.pop = function() {
		      return setListBounds(this, 0, -1);
		    };
	
		    List.prototype.unshift = function(/*...values*/) {
		      var values = arguments;
		      return this.withMutations(function(list ) {
		        setListBounds(list, -values.length);
		        for (var ii = 0; ii < values.length; ii++) {
		          list.set(ii, values[ii]);
		        }
		      });
		    };
	
		    List.prototype.shift = function() {
		      return setListBounds(this, 1);
		    };
	
		    // @pragma Composition
	
		    List.prototype.merge = function(/*...iters*/) {
		      return mergeIntoListWith(this, undefined, arguments);
		    };
	
		    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoListWith(this, merger, iters);
		    };
	
		    List.prototype.mergeDeep = function(/*...iters*/) {
		      return mergeIntoListWith(this, deepMerger, arguments);
		    };
	
		    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoListWith(this, deepMergerWith(merger), iters);
		    };
	
		    List.prototype.setSize = function(size) {
		      return setListBounds(this, 0, size);
		    };
	
		    // @pragma Iteration
	
		    List.prototype.slice = function(begin, end) {
		      var size = this.size;
		      if (wholeSlice(begin, end, size)) {
		        return this;
		      }
		      return setListBounds(
		        this,
		        resolveBegin(begin, size),
		        resolveEnd(end, size)
		      );
		    };
	
		    List.prototype.__iterator = function(type, reverse) {
		      var index = 0;
		      var values = iterateList(this, reverse);
		      return new Iterator(function()  {
		        var value = values();
		        return value === DONE ?
		          iteratorDone() :
		          iteratorValue(type, index++, value);
		      });
		    };
	
		    List.prototype.__iterate = function(fn, reverse) {
		      var index = 0;
		      var values = iterateList(this, reverse);
		      var value;
		      while ((value = values()) !== DONE) {
		        if (fn(value, index++, this) === false) {
		          break;
		        }
		      }
		      return index;
		    };
	
		    List.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        return this;
		      }
		      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
		    };
	
	
		  function isList(maybeList) {
		    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
		  }
	
		  List.isList = isList;
	
		  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
		  var ListPrototype = List.prototype;
		  ListPrototype[IS_LIST_SENTINEL] = true;
		  ListPrototype[DELETE] = ListPrototype.remove;
		  ListPrototype.setIn = MapPrototype.setIn;
		  ListPrototype.deleteIn =
		  ListPrototype.removeIn = MapPrototype.removeIn;
		  ListPrototype.update = MapPrototype.update;
		  ListPrototype.updateIn = MapPrototype.updateIn;
		  ListPrototype.mergeIn = MapPrototype.mergeIn;
		  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
		  ListPrototype.withMutations = MapPrototype.withMutations;
		  ListPrototype.asMutable = MapPrototype.asMutable;
		  ListPrototype.asImmutable = MapPrototype.asImmutable;
		  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
		    function VNode(array, ownerID) {
		      this.array = array;
		      this.ownerID = ownerID;
		    }
	
		    // TODO: seems like these methods are very similar
	
		    VNode.prototype.removeBefore = function(ownerID, level, index) {
		      if (index === level ? 1 << level : 0 || this.array.length === 0) {
		        return this;
		      }
		      var originIndex = (index >>> level) & MASK;
		      if (originIndex >= this.array.length) {
		        return new VNode([], ownerID);
		      }
		      var removingFirst = originIndex === 0;
		      var newChild;
		      if (level > 0) {
		        var oldChild = this.array[originIndex];
		        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
		        if (newChild === oldChild && removingFirst) {
		          return this;
		        }
		      }
		      if (removingFirst && !newChild) {
		        return this;
		      }
		      var editable = editableVNode(this, ownerID);
		      if (!removingFirst) {
		        for (var ii = 0; ii < originIndex; ii++) {
		          editable.array[ii] = undefined;
		        }
		      }
		      if (newChild) {
		        editable.array[originIndex] = newChild;
		      }
		      return editable;
		    };
	
		    VNode.prototype.removeAfter = function(ownerID, level, index) {
		      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
		        return this;
		      }
		      var sizeIndex = ((index - 1) >>> level) & MASK;
		      if (sizeIndex >= this.array.length) {
		        return this;
		      }
	
		      var newChild;
		      if (level > 0) {
		        var oldChild = this.array[sizeIndex];
		        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
		        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
		          return this;
		        }
		      }
	
		      var editable = editableVNode(this, ownerID);
		      editable.array.splice(sizeIndex + 1);
		      if (newChild) {
		        editable.array[sizeIndex] = newChild;
		      }
		      return editable;
		    };
	
	
	
		  var DONE = {};
	
		  function iterateList(list, reverse) {
		    var left = list._origin;
		    var right = list._capacity;
		    var tailPos = getTailOffset(right);
		    var tail = list._tail;
	
		    return iterateNodeOrLeaf(list._root, list._level, 0);
	
		    function iterateNodeOrLeaf(node, level, offset) {
		      return level === 0 ?
		        iterateLeaf(node, offset) :
		        iterateNode(node, level, offset);
		    }
	
		    function iterateLeaf(node, offset) {
		      var array = offset === tailPos ? tail && tail.array : node && node.array;
		      var from = offset > left ? 0 : left - offset;
		      var to = right - offset;
		      if (to > SIZE) {
		        to = SIZE;
		      }
		      return function()  {
		        if (from === to) {
		          return DONE;
		        }
		        var idx = reverse ? --to : from++;
		        return array && array[idx];
		      };
		    }
	
		    function iterateNode(node, level, offset) {
		      var values;
		      var array = node && node.array;
		      var from = offset > left ? 0 : (left - offset) >> level;
		      var to = ((right - offset) >> level) + 1;
		      if (to > SIZE) {
		        to = SIZE;
		      }
		      return function()  {
		        do {
		          if (values) {
		            var value = values();
		            if (value !== DONE) {
		              return value;
		            }
		            values = null;
		          }
		          if (from === to) {
		            return DONE;
		          }
		          var idx = reverse ? --to : from++;
		          values = iterateNodeOrLeaf(
		            array && array[idx], level - SHIFT, offset + (idx << level)
		          );
		        } while (true);
		      };
		    }
		  }
	
		  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
		    var list = Object.create(ListPrototype);
		    list.size = capacity - origin;
		    list._origin = origin;
		    list._capacity = capacity;
		    list._level = level;
		    list._root = root;
		    list._tail = tail;
		    list.__ownerID = ownerID;
		    list.__hash = hash;
		    list.__altered = false;
		    return list;
		  }
	
		  var EMPTY_LIST;
		  function emptyList() {
		    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
		  }
	
		  function updateList(list, index, value) {
		    index = wrapIndex(list, index);
	
		    if (index !== index) {
		      return list;
		    }
	
		    if (index >= list.size || index < 0) {
		      return list.withMutations(function(list ) {
		        index < 0 ?
		          setListBounds(list, index).set(0, value) :
		          setListBounds(list, 0, index + 1).set(index, value)
		      });
		    }
	
		    index += list._origin;
	
		    var newTail = list._tail;
		    var newRoot = list._root;
		    var didAlter = MakeRef(DID_ALTER);
		    if (index >= getTailOffset(list._capacity)) {
		      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
		    } else {
		      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
		    }
	
		    if (!didAlter.value) {
		      return list;
		    }
	
		    if (list.__ownerID) {
		      list._root = newRoot;
		      list._tail = newTail;
		      list.__hash = undefined;
		      list.__altered = true;
		      return list;
		    }
		    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
		  }
	
		  function updateVNode(node, ownerID, level, index, value, didAlter) {
		    var idx = (index >>> level) & MASK;
		    var nodeHas = node && idx < node.array.length;
		    if (!nodeHas && value === undefined) {
		      return node;
		    }
	
		    var newNode;
	
		    if (level > 0) {
		      var lowerNode = node && node.array[idx];
		      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
		      if (newLowerNode === lowerNode) {
		        return node;
		      }
		      newNode = editableVNode(node, ownerID);
		      newNode.array[idx] = newLowerNode;
		      return newNode;
		    }
	
		    if (nodeHas && node.array[idx] === value) {
		      return node;
		    }
	
		    SetRef(didAlter);
	
		    newNode = editableVNode(node, ownerID);
		    if (value === undefined && idx === newNode.array.length - 1) {
		      newNode.array.pop();
		    } else {
		      newNode.array[idx] = value;
		    }
		    return newNode;
		  }
	
		  function editableVNode(node, ownerID) {
		    if (ownerID && node && ownerID === node.ownerID) {
		      return node;
		    }
		    return new VNode(node ? node.array.slice() : [], ownerID);
		  }
	
		  function listNodeFor(list, rawIndex) {
		    if (rawIndex >= getTailOffset(list._capacity)) {
		      return list._tail;
		    }
		    if (rawIndex < 1 << (list._level + SHIFT)) {
		      var node = list._root;
		      var level = list._level;
		      while (node && level > 0) {
		        node = node.array[(rawIndex >>> level) & MASK];
		        level -= SHIFT;
		      }
		      return node;
		    }
		  }
	
		  function setListBounds(list, begin, end) {
		    // Sanitize begin & end using this shorthand for ToInt32(argument)
		    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
		    if (begin !== undefined) {
		      begin = begin | 0;
		    }
		    if (end !== undefined) {
		      end = end | 0;
		    }
		    var owner = list.__ownerID || new OwnerID();
		    var oldOrigin = list._origin;
		    var oldCapacity = list._capacity;
		    var newOrigin = oldOrigin + begin;
		    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
		    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
		      return list;
		    }
	
		    // If it's going to end after it starts, it's empty.
		    if (newOrigin >= newCapacity) {
		      return list.clear();
		    }
	
		    var newLevel = list._level;
		    var newRoot = list._root;
	
		    // New origin might need creating a higher root.
		    var offsetShift = 0;
		    while (newOrigin + offsetShift < 0) {
		      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
		      newLevel += SHIFT;
		      offsetShift += 1 << newLevel;
		    }
		    if (offsetShift) {
		      newOrigin += offsetShift;
		      oldOrigin += offsetShift;
		      newCapacity += offsetShift;
		      oldCapacity += offsetShift;
		    }
	
		    var oldTailOffset = getTailOffset(oldCapacity);
		    var newTailOffset = getTailOffset(newCapacity);
	
		    // New size might need creating a higher root.
		    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
		      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
		      newLevel += SHIFT;
		    }
	
		    // Locate or create the new tail.
		    var oldTail = list._tail;
		    var newTail = newTailOffset < oldTailOffset ?
		      listNodeFor(list, newCapacity - 1) :
		      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
		    // Merge Tail into tree.
		    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
		      newRoot = editableVNode(newRoot, owner);
		      var node = newRoot;
		      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
		        var idx = (oldTailOffset >>> level) & MASK;
		        node = node.array[idx] = editableVNode(node.array[idx], owner);
		      }
		      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
		    }
	
		    // If the size has been reduced, there's a chance the tail needs to be trimmed.
		    if (newCapacity < oldCapacity) {
		      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
		    }
	
		    // If the new origin is within the tail, then we do not need a root.
		    if (newOrigin >= newTailOffset) {
		      newOrigin -= newTailOffset;
		      newCapacity -= newTailOffset;
		      newLevel = SHIFT;
		      newRoot = null;
		      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
		    // Otherwise, if the root has been trimmed, garbage collect.
		    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
		      offsetShift = 0;
	
		      // Identify the new top root node of the subtree of the old root.
		      while (newRoot) {
		        var beginIndex = (newOrigin >>> newLevel) & MASK;
		        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
		          break;
		        }
		        if (beginIndex) {
		          offsetShift += (1 << newLevel) * beginIndex;
		        }
		        newLevel -= SHIFT;
		        newRoot = newRoot.array[beginIndex];
		      }
	
		      // Trim the new sides of the new root.
		      if (newRoot && newOrigin > oldOrigin) {
		        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
		      }
		      if (newRoot && newTailOffset < oldTailOffset) {
		        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
		      }
		      if (offsetShift) {
		        newOrigin -= offsetShift;
		        newCapacity -= offsetShift;
		      }
		    }
	
		    if (list.__ownerID) {
		      list.size = newCapacity - newOrigin;
		      list._origin = newOrigin;
		      list._capacity = newCapacity;
		      list._level = newLevel;
		      list._root = newRoot;
		      list._tail = newTail;
		      list.__hash = undefined;
		      list.__altered = true;
		      return list;
		    }
		    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
		  }
	
		  function mergeIntoListWith(list, merger, iterables) {
		    var iters = [];
		    var maxSize = 0;
		    for (var ii = 0; ii < iterables.length; ii++) {
		      var value = iterables[ii];
		      var iter = IndexedIterable(value);
		      if (iter.size > maxSize) {
		        maxSize = iter.size;
		      }
		      if (!isIterable(value)) {
		        iter = iter.map(function(v ) {return fromJS(v)});
		      }
		      iters.push(iter);
		    }
		    if (maxSize > list.size) {
		      list = list.setSize(maxSize);
		    }
		    return mergeIntoCollectionWith(list, merger, iters);
		  }
	
		  function getTailOffset(size) {
		    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
		  }
	
		  createClass(OrderedMap, Map);
	
		    // @pragma Construction
	
		    function OrderedMap(value) {
		      return value === null || value === undefined ? emptyOrderedMap() :
		        isOrderedMap(value) ? value :
		        emptyOrderedMap().withMutations(function(map ) {
		          var iter = KeyedIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v, k)  {return map.set(k, v)});
		        });
		    }
	
		    OrderedMap.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    OrderedMap.prototype.toString = function() {
		      return this.__toString('OrderedMap {', '}');
		    };
	
		    // @pragma Access
	
		    OrderedMap.prototype.get = function(k, notSetValue) {
		      var index = this._map.get(k);
		      return index !== undefined ? this._list.get(index)[1] : notSetValue;
		    };
	
		    // @pragma Modification
	
		    OrderedMap.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = 0;
		        this._map.clear();
		        this._list.clear();
		        return this;
		      }
		      return emptyOrderedMap();
		    };
	
		    OrderedMap.prototype.set = function(k, v) {
		      return updateOrderedMap(this, k, v);
		    };
	
		    OrderedMap.prototype.remove = function(k) {
		      return updateOrderedMap(this, k, NOT_SET);
		    };
	
		    OrderedMap.prototype.wasAltered = function() {
		      return this._map.wasAltered() || this._list.wasAltered();
		    };
	
		    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._list.__iterate(
		        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
		        reverse
		      );
		    };
	
		    OrderedMap.prototype.__iterator = function(type, reverse) {
		      return this._list.fromEntrySeq().__iterator(type, reverse);
		    };
	
		    OrderedMap.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      var newMap = this._map.__ensureOwner(ownerID);
		      var newList = this._list.__ensureOwner(ownerID);
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this._map = newMap;
		        this._list = newList;
		        return this;
		      }
		      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
		    };
	
	
		  function isOrderedMap(maybeOrderedMap) {
		    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
		  }
	
		  OrderedMap.isOrderedMap = isOrderedMap;
	
		  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
		  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
		  function makeOrderedMap(map, list, ownerID, hash) {
		    var omap = Object.create(OrderedMap.prototype);
		    omap.size = map ? map.size : 0;
		    omap._map = map;
		    omap._list = list;
		    omap.__ownerID = ownerID;
		    omap.__hash = hash;
		    return omap;
		  }
	
		  var EMPTY_ORDERED_MAP;
		  function emptyOrderedMap() {
		    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
		  }
	
		  function updateOrderedMap(omap, k, v) {
		    var map = omap._map;
		    var list = omap._list;
		    var i = map.get(k);
		    var has = i !== undefined;
		    var newMap;
		    var newList;
		    if (v === NOT_SET) { // removed
		      if (!has) {
		        return omap;
		      }
		      if (list.size >= SIZE && list.size >= map.size * 2) {
		        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
		        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
		        if (omap.__ownerID) {
		          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
		        }
		      } else {
		        newMap = map.remove(k);
		        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
		      }
		    } else {
		      if (has) {
		        if (v === list.get(i)[1]) {
		          return omap;
		        }
		        newMap = map;
		        newList = list.set(i, [k, v]);
		      } else {
		        newMap = map.set(k, list.size);
		        newList = list.set(list.size, [k, v]);
		      }
		    }
		    if (omap.__ownerID) {
		      omap.size = newMap.size;
		      omap._map = newMap;
		      omap._list = newList;
		      omap.__hash = undefined;
		      return omap;
		    }
		    return makeOrderedMap(newMap, newList);
		  }
	
		  createClass(ToKeyedSequence, KeyedSeq);
		    function ToKeyedSequence(indexed, useKeys) {
		      this._iter = indexed;
		      this._useKeys = useKeys;
		      this.size = indexed.size;
		    }
	
		    ToKeyedSequence.prototype.get = function(key, notSetValue) {
		      return this._iter.get(key, notSetValue);
		    };
	
		    ToKeyedSequence.prototype.has = function(key) {
		      return this._iter.has(key);
		    };
	
		    ToKeyedSequence.prototype.valueSeq = function() {
		      return this._iter.valueSeq();
		    };
	
		    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
		      var reversedSequence = reverseFactory(this, true);
		      if (!this._useKeys) {
		        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
		      }
		      return reversedSequence;
		    };
	
		    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
		      var mappedSequence = mapFactory(this, mapper, context);
		      if (!this._useKeys) {
		        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
		      }
		      return mappedSequence;
		    };
	
		    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      var ii;
		      return this._iter.__iterate(
		        this._useKeys ?
		          function(v, k)  {return fn(v, k, this$0)} :
		          ((ii = reverse ? resolveSize(this) : 0),
		            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
		        reverse
		      );
		    };
	
		    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
		      if (this._useKeys) {
		        return this._iter.__iterator(type, reverse);
		      }
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      var ii = reverse ? resolveSize(this) : 0;
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step :
		          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
		      });
		    };
	
		  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
		  createClass(ToIndexedSequence, IndexedSeq);
		    function ToIndexedSequence(iter) {
		      this._iter = iter;
		      this.size = iter.size;
		    }
	
		    ToIndexedSequence.prototype.includes = function(value) {
		      return this._iter.includes(value);
		    };
	
		    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
		    };
	
		    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      var iterations = 0;
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step :
		          iteratorValue(type, iterations++, step.value, step)
		      });
		    };
	
	
	
		  createClass(ToSetSequence, SetSeq);
		    function ToSetSequence(iter) {
		      this._iter = iter;
		      this.size = iter.size;
		    }
	
		    ToSetSequence.prototype.has = function(key) {
		      return this._iter.includes(key);
		    };
	
		    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
		    };
	
		    ToSetSequence.prototype.__iterator = function(type, reverse) {
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step :
		          iteratorValue(type, step.value, step.value, step);
		      });
		    };
	
	
	
		  createClass(FromEntriesSequence, KeyedSeq);
		    function FromEntriesSequence(entries) {
		      this._iter = entries;
		      this.size = entries.size;
		    }
	
		    FromEntriesSequence.prototype.entrySeq = function() {
		      return this._iter.toSeq();
		    };
	
		    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._iter.__iterate(function(entry ) {
		        // Check if entry exists first so array access doesn't throw for holes
		        // in the parent iteration.
		        if (entry) {
		          validateEntry(entry);
		          var indexedIterable = isIterable(entry);
		          return fn(
		            indexedIterable ? entry.get(1) : entry[1],
		            indexedIterable ? entry.get(0) : entry[0],
		            this$0
		          );
		        }
		      }, reverse);
		    };
	
		    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      return new Iterator(function()  {
		        while (true) {
		          var step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		          var entry = step.value;
		          // Check if entry exists first so array access doesn't throw for holes
		          // in the parent iteration.
		          if (entry) {
		            validateEntry(entry);
		            var indexedIterable = isIterable(entry);
		            return iteratorValue(
		              type,
		              indexedIterable ? entry.get(0) : entry[0],
		              indexedIterable ? entry.get(1) : entry[1],
		              step
		            );
		          }
		        }
		      });
		    };
	
	
		  ToIndexedSequence.prototype.cacheResult =
		  ToKeyedSequence.prototype.cacheResult =
		  ToSetSequence.prototype.cacheResult =
		  FromEntriesSequence.prototype.cacheResult =
		    cacheResultThrough;
	
	
		  function flipFactory(iterable) {
		    var flipSequence = makeSequence(iterable);
		    flipSequence._iter = iterable;
		    flipSequence.size = iterable.size;
		    flipSequence.flip = function()  {return iterable};
		    flipSequence.reverse = function () {
		      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
		      reversedSequence.flip = function()  {return iterable.reverse()};
		      return reversedSequence;
		    };
		    flipSequence.has = function(key ) {return iterable.includes(key)};
		    flipSequence.includes = function(key ) {return iterable.has(key)};
		    flipSequence.cacheResult = cacheResultThrough;
		    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
		    }
		    flipSequence.__iteratorUncached = function(type, reverse) {
		      if (type === ITERATE_ENTRIES) {
		        var iterator = iterable.__iterator(type, reverse);
		        return new Iterator(function()  {
		          var step = iterator.next();
		          if (!step.done) {
		            var k = step.value[0];
		            step.value[0] = step.value[1];
		            step.value[1] = k;
		          }
		          return step;
		        });
		      }
		      return iterable.__iterator(
		        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
		        reverse
		      );
		    }
		    return flipSequence;
		  }
	
	
		  function mapFactory(iterable, mapper, context) {
		    var mappedSequence = makeSequence(iterable);
		    mappedSequence.size = iterable.size;
		    mappedSequence.has = function(key ) {return iterable.has(key)};
		    mappedSequence.get = function(key, notSetValue)  {
		      var v = iterable.get(key, NOT_SET);
		      return v === NOT_SET ?
		        notSetValue :
		        mapper.call(context, v, key, iterable);
		    };
		    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      return iterable.__iterate(
		        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
		        reverse
		      );
		    }
		    mappedSequence.__iteratorUncached = function (type, reverse) {
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      return new Iterator(function()  {
		        var step = iterator.next();
		        if (step.done) {
		          return step;
		        }
		        var entry = step.value;
		        var key = entry[0];
		        return iteratorValue(
		          type,
		          key,
		          mapper.call(context, entry[1], key, iterable),
		          step
		        );
		      });
		    }
		    return mappedSequence;
		  }
	
	
		  function reverseFactory(iterable, useKeys) {
		    var reversedSequence = makeSequence(iterable);
		    reversedSequence._iter = iterable;
		    reversedSequence.size = iterable.size;
		    reversedSequence.reverse = function()  {return iterable};
		    if (iterable.flip) {
		      reversedSequence.flip = function () {
		        var flipSequence = flipFactory(iterable);
		        flipSequence.reverse = function()  {return iterable.flip()};
		        return flipSequence;
		      };
		    }
		    reversedSequence.get = function(key, notSetValue) 
		      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
		    reversedSequence.has = function(key )
		      {return iterable.has(useKeys ? key : -1 - key)};
		    reversedSequence.includes = function(value ) {return iterable.includes(value)};
		    reversedSequence.cacheResult = cacheResultThrough;
		    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
		      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
		    };
		    reversedSequence.__iterator =
		      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
		    return reversedSequence;
		  }
	
	
		  function filterFactory(iterable, predicate, context, useKeys) {
		    var filterSequence = makeSequence(iterable);
		    if (useKeys) {
		      filterSequence.has = function(key ) {
		        var v = iterable.get(key, NOT_SET);
		        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
		      };
		      filterSequence.get = function(key, notSetValue)  {
		        var v = iterable.get(key, NOT_SET);
		        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
		          v : notSetValue;
		      };
		    }
		    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      iterable.__iterate(function(v, k, c)  {
		        if (predicate.call(context, v, k, c)) {
		          iterations++;
		          return fn(v, useKeys ? k : iterations - 1, this$0);
		        }
		      }, reverse);
		      return iterations;
		    };
		    filterSequence.__iteratorUncached = function (type, reverse) {
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      var iterations = 0;
		      return new Iterator(function()  {
		        while (true) {
		          var step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		          var entry = step.value;
		          var key = entry[0];
		          var value = entry[1];
		          if (predicate.call(context, value, key, iterable)) {
		            return iteratorValue(type, useKeys ? key : iterations++, value, step);
		          }
		        }
		      });
		    }
		    return filterSequence;
		  }
	
	
		  function countByFactory(iterable, grouper, context) {
		    var groups = Map().asMutable();
		    iterable.__iterate(function(v, k)  {
		      groups.update(
		        grouper.call(context, v, k, iterable),
		        0,
		        function(a ) {return a + 1}
		      );
		    });
		    return groups.asImmutable();
		  }
	
	
		  function groupByFactory(iterable, grouper, context) {
		    var isKeyedIter = isKeyed(iterable);
		    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
		    iterable.__iterate(function(v, k)  {
		      groups.update(
		        grouper.call(context, v, k, iterable),
		        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
		      );
		    });
		    var coerce = iterableClass(iterable);
		    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
		  }
	
	
		  function sliceFactory(iterable, begin, end, useKeys) {
		    var originalSize = iterable.size;
	
		    // Sanitize begin & end using this shorthand for ToInt32(argument)
		    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
		    if (begin !== undefined) {
		      begin = begin | 0;
		    }
		    if (end !== undefined) {
		      if (end === Infinity) {
		        end = originalSize;
		      } else {
		        end = end | 0;
		      }
		    }
	
		    if (wholeSlice(begin, end, originalSize)) {
		      return iterable;
		    }
	
		    var resolvedBegin = resolveBegin(begin, originalSize);
		    var resolvedEnd = resolveEnd(end, originalSize);
	
		    // begin or end will be NaN if they were provided as negative numbers and
		    // this iterable's size is unknown. In that case, cache first so there is
		    // a known size and these do not resolve to NaN.
		    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
		      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
		    }
	
		    // Note: resolvedEnd is undefined when the original sequence's length is
		    // unknown and this slice did not supply an end and should contain all
		    // elements after resolvedBegin.
		    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
		    var resolvedSize = resolvedEnd - resolvedBegin;
		    var sliceSize;
		    if (resolvedSize === resolvedSize) {
		      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
		    }
	
		    var sliceSeq = makeSequence(iterable);
	
		    // If iterable.size is undefined, the size of the realized sliceSeq is
		    // unknown at this point unless the number of items to slice is 0
		    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
		    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
		      sliceSeq.get = function (index, notSetValue) {
		        index = wrapIndex(this, index);
		        return index >= 0 && index < sliceSize ?
		          iterable.get(index + resolvedBegin, notSetValue) :
		          notSetValue;
		      }
		    }
	
		    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
		      if (sliceSize === 0) {
		        return 0;
		      }
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var skipped = 0;
		      var isSkipping = true;
		      var iterations = 0;
		      iterable.__iterate(function(v, k)  {
		        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
		          iterations++;
		          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
		                 iterations !== sliceSize;
		        }
		      });
		      return iterations;
		    };
	
		    sliceSeq.__iteratorUncached = function(type, reverse) {
		      if (sliceSize !== 0 && reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      // Don't bother instantiating parent iterator if taking 0.
		      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
		      var skipped = 0;
		      var iterations = 0;
		      return new Iterator(function()  {
		        while (skipped++ < resolvedBegin) {
		          iterator.next();
		        }
		        if (++iterations > sliceSize) {
		          return iteratorDone();
		        }
		        var step = iterator.next();
		        if (useKeys || type === ITERATE_VALUES) {
		          return step;
		        } else if (type === ITERATE_KEYS) {
		          return iteratorValue(type, iterations - 1, undefined, step);
		        } else {
		          return iteratorValue(type, iterations - 1, step.value[1], step);
		        }
		      });
		    }
	
		    return sliceSeq;
		  }
	
	
		  function takeWhileFactory(iterable, predicate, context) {
		    var takeSequence = makeSequence(iterable);
		    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var iterations = 0;
		      iterable.__iterate(function(v, k, c) 
		        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
		      );
		      return iterations;
		    };
		    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      var iterating = true;
		      return new Iterator(function()  {
		        if (!iterating) {
		          return iteratorDone();
		        }
		        var step = iterator.next();
		        if (step.done) {
		          return step;
		        }
		        var entry = step.value;
		        var k = entry[0];
		        var v = entry[1];
		        if (!predicate.call(context, v, k, this$0)) {
		          iterating = false;
		          return iteratorDone();
		        }
		        return type === ITERATE_ENTRIES ? step :
		          iteratorValue(type, k, v, step);
		      });
		    };
		    return takeSequence;
		  }
	
	
		  function skipWhileFactory(iterable, predicate, context, useKeys) {
		    var skipSequence = makeSequence(iterable);
		    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var isSkipping = true;
		      var iterations = 0;
		      iterable.__iterate(function(v, k, c)  {
		        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
		          iterations++;
		          return fn(v, useKeys ? k : iterations - 1, this$0);
		        }
		      });
		      return iterations;
		    };
		    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      var skipping = true;
		      var iterations = 0;
		      return new Iterator(function()  {
		        var step, k, v;
		        do {
		          step = iterator.next();
		          if (step.done) {
		            if (useKeys || type === ITERATE_VALUES) {
		              return step;
		            } else if (type === ITERATE_KEYS) {
		              return iteratorValue(type, iterations++, undefined, step);
		            } else {
		              return iteratorValue(type, iterations++, step.value[1], step);
		            }
		          }
		          var entry = step.value;
		          k = entry[0];
		          v = entry[1];
		          skipping && (skipping = predicate.call(context, v, k, this$0));
		        } while (skipping);
		        return type === ITERATE_ENTRIES ? step :
		          iteratorValue(type, k, v, step);
		      });
		    };
		    return skipSequence;
		  }
	
	
		  function concatFactory(iterable, values) {
		    var isKeyedIterable = isKeyed(iterable);
		    var iters = [iterable].concat(values).map(function(v ) {
		      if (!isIterable(v)) {
		        v = isKeyedIterable ?
		          keyedSeqFromValue(v) :
		          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
		      } else if (isKeyedIterable) {
		        v = KeyedIterable(v);
		      }
		      return v;
		    }).filter(function(v ) {return v.size !== 0});
	
		    if (iters.length === 0) {
		      return iterable;
		    }
	
		    if (iters.length === 1) {
		      var singleton = iters[0];
		      if (singleton === iterable ||
		          isKeyedIterable && isKeyed(singleton) ||
		          isIndexed(iterable) && isIndexed(singleton)) {
		        return singleton;
		      }
		    }
	
		    var concatSeq = new ArraySeq(iters);
		    if (isKeyedIterable) {
		      concatSeq = concatSeq.toKeyedSeq();
		    } else if (!isIndexed(iterable)) {
		      concatSeq = concatSeq.toSetSeq();
		    }
		    concatSeq = concatSeq.flatten(true);
		    concatSeq.size = iters.reduce(
		      function(sum, seq)  {
		        if (sum !== undefined) {
		          var size = seq.size;
		          if (size !== undefined) {
		            return sum + size;
		          }
		        }
		      },
		      0
		    );
		    return concatSeq;
		  }
	
	
		  function flattenFactory(iterable, depth, useKeys) {
		    var flatSequence = makeSequence(iterable);
		    flatSequence.__iterateUncached = function(fn, reverse) {
		      var iterations = 0;
		      var stopped = false;
		      function flatDeep(iter, currentDepth) {var this$0 = this;
		        iter.__iterate(function(v, k)  {
		          if ((!depth || currentDepth < depth) && isIterable(v)) {
		            flatDeep(v, currentDepth + 1);
		          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
		            stopped = true;
		          }
		          return !stopped;
		        }, reverse);
		      }
		      flatDeep(iterable, 0);
		      return iterations;
		    }
		    flatSequence.__iteratorUncached = function(type, reverse) {
		      var iterator = iterable.__iterator(type, reverse);
		      var stack = [];
		      var iterations = 0;
		      return new Iterator(function()  {
		        while (iterator) {
		          var step = iterator.next();
		          if (step.done !== false) {
		            iterator = stack.pop();
		            continue;
		          }
		          var v = step.value;
		          if (type === ITERATE_ENTRIES) {
		            v = v[1];
		          }
		          if ((!depth || stack.length < depth) && isIterable(v)) {
		            stack.push(iterator);
		            iterator = v.__iterator(type, reverse);
		          } else {
		            return useKeys ? step : iteratorValue(type, iterations++, v, step);
		          }
		        }
		        return iteratorDone();
		      });
		    }
		    return flatSequence;
		  }
	
	
		  function flatMapFactory(iterable, mapper, context) {
		    var coerce = iterableClass(iterable);
		    return iterable.toSeq().map(
		      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
		    ).flatten(true);
		  }
	
	
		  function interposeFactory(iterable, separator) {
		    var interposedSequence = makeSequence(iterable);
		    interposedSequence.size = iterable.size && iterable.size * 2 -1;
		    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      iterable.__iterate(function(v, k) 
		        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
		        fn(v, iterations++, this$0) !== false},
		        reverse
		      );
		      return iterations;
		    };
		    interposedSequence.__iteratorUncached = function(type, reverse) {
		      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
		      var iterations = 0;
		      var step;
		      return new Iterator(function()  {
		        if (!step || iterations % 2) {
		          step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		        }
		        return iterations % 2 ?
		          iteratorValue(type, iterations++, separator) :
		          iteratorValue(type, iterations++, step.value, step);
		      });
		    };
		    return interposedSequence;
		  }
	
	
		  function sortFactory(iterable, comparator, mapper) {
		    if (!comparator) {
		      comparator = defaultComparator;
		    }
		    var isKeyedIterable = isKeyed(iterable);
		    var index = 0;
		    var entries = iterable.toSeq().map(
		      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
		    ).toArray();
		    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
		      isKeyedIterable ?
		      function(v, i)  { entries[i].length = 2; } :
		      function(v, i)  { entries[i] = v[1]; }
		    );
		    return isKeyedIterable ? KeyedSeq(entries) :
		      isIndexed(iterable) ? IndexedSeq(entries) :
		      SetSeq(entries);
		  }
	
	
		  function maxFactory(iterable, comparator, mapper) {
		    if (!comparator) {
		      comparator = defaultComparator;
		    }
		    if (mapper) {
		      var entry = iterable.toSeq()
		        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
		        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
		      return entry && entry[0];
		    } else {
		      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
		    }
		  }
	
		  function maxCompare(comparator, a, b) {
		    var comp = comparator(b, a);
		    // b is considered the new max if the comparator declares them equal, but
		    // they are not equal and b is in fact a nullish value.
		    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
		  }
	
	
		  function zipWithFactory(keyIter, zipper, iters) {
		    var zipSequence = makeSequence(keyIter);
		    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
		    // Note: this a generic base implementation of __iterate in terms of
		    // __iterator which may be more generically useful in the future.
		    zipSequence.__iterate = function(fn, reverse) {
		      /* generic:
		      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
		      var step;
		      var iterations = 0;
		      while (!(step = iterator.next()).done) {
		        iterations++;
		        if (fn(step.value[1], step.value[0], this) === false) {
		          break;
		        }
		      }
		      return iterations;
		      */
		      // indexed:
		      var iterator = this.__iterator(ITERATE_VALUES, reverse);
		      var step;
		      var iterations = 0;
		      while (!(step = iterator.next()).done) {
		        if (fn(step.value, iterations++, this) === false) {
		          break;
		        }
		      }
		      return iterations;
		    };
		    zipSequence.__iteratorUncached = function(type, reverse) {
		      var iterators = iters.map(function(i )
		        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
		      );
		      var iterations = 0;
		      var isDone = false;
		      return new Iterator(function()  {
		        var steps;
		        if (!isDone) {
		          steps = iterators.map(function(i ) {return i.next()});
		          isDone = steps.some(function(s ) {return s.done});
		        }
		        if (isDone) {
		          return iteratorDone();
		        }
		        return iteratorValue(
		          type,
		          iterations++,
		          zipper.apply(null, steps.map(function(s ) {return s.value}))
		        );
		      });
		    };
		    return zipSequence
		  }
	
	
		  // #pragma Helper Functions
	
		  function reify(iter, seq) {
		    return isSeq(iter) ? seq : iter.constructor(seq);
		  }
	
		  function validateEntry(entry) {
		    if (entry !== Object(entry)) {
		      throw new TypeError('Expected [K, V] tuple: ' + entry);
		    }
		  }
	
		  function resolveSize(iter) {
		    assertNotInfinite(iter.size);
		    return ensureSize(iter);
		  }
	
		  function iterableClass(iterable) {
		    return isKeyed(iterable) ? KeyedIterable :
		      isIndexed(iterable) ? IndexedIterable :
		      SetIterable;
		  }
	
		  function makeSequence(iterable) {
		    return Object.create(
		      (
		        isKeyed(iterable) ? KeyedSeq :
		        isIndexed(iterable) ? IndexedSeq :
		        SetSeq
		      ).prototype
		    );
		  }
	
		  function cacheResultThrough() {
		    if (this._iter.cacheResult) {
		      this._iter.cacheResult();
		      this.size = this._iter.size;
		      return this;
		    } else {
		      return Seq.prototype.cacheResult.call(this);
		    }
		  }
	
		  function defaultComparator(a, b) {
		    return a > b ? 1 : a < b ? -1 : 0;
		  }
	
		  function forceIterator(keyPath) {
		    var iter = getIterator(keyPath);
		    if (!iter) {
		      // Array might not be iterable in this environment, so we need a fallback
		      // to our wrapped type.
		      if (!isArrayLike(keyPath)) {
		        throw new TypeError('Expected iterable or array-like: ' + keyPath);
		      }
		      iter = getIterator(Iterable(keyPath));
		    }
		    return iter;
		  }
	
		  createClass(Record, KeyedCollection);
	
		    function Record(defaultValues, name) {
		      var hasInitialized;
	
		      var RecordType = function Record(values) {
		        if (values instanceof RecordType) {
		          return values;
		        }
		        if (!(this instanceof RecordType)) {
		          return new RecordType(values);
		        }
		        if (!hasInitialized) {
		          hasInitialized = true;
		          var keys = Object.keys(defaultValues);
		          setProps(RecordTypePrototype, keys);
		          RecordTypePrototype.size = keys.length;
		          RecordTypePrototype._name = name;
		          RecordTypePrototype._keys = keys;
		          RecordTypePrototype._defaultValues = defaultValues;
		        }
		        this._map = Map(values);
		      };
	
		      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
		      RecordTypePrototype.constructor = RecordType;
	
		      return RecordType;
		    }
	
		    Record.prototype.toString = function() {
		      return this.__toString(recordName(this) + ' {', '}');
		    };
	
		    // @pragma Access
	
		    Record.prototype.has = function(k) {
		      return this._defaultValues.hasOwnProperty(k);
		    };
	
		    Record.prototype.get = function(k, notSetValue) {
		      if (!this.has(k)) {
		        return notSetValue;
		      }
		      var defaultVal = this._defaultValues[k];
		      return this._map ? this._map.get(k, defaultVal) : defaultVal;
		    };
	
		    // @pragma Modification
	
		    Record.prototype.clear = function() {
		      if (this.__ownerID) {
		        this._map && this._map.clear();
		        return this;
		      }
		      var RecordType = this.constructor;
		      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
		    };
	
		    Record.prototype.set = function(k, v) {
		      if (!this.has(k)) {
		        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
		      }
		      if (this._map && !this._map.has(k)) {
		        var defaultVal = this._defaultValues[k];
		        if (v === defaultVal) {
		          return this;
		        }
		      }
		      var newMap = this._map && this._map.set(k, v);
		      if (this.__ownerID || newMap === this._map) {
		        return this;
		      }
		      return makeRecord(this, newMap);
		    };
	
		    Record.prototype.remove = function(k) {
		      if (!this.has(k)) {
		        return this;
		      }
		      var newMap = this._map && this._map.remove(k);
		      if (this.__ownerID || newMap === this._map) {
		        return this;
		      }
		      return makeRecord(this, newMap);
		    };
	
		    Record.prototype.wasAltered = function() {
		      return this._map.wasAltered();
		    };
	
		    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
		      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
		    };
	
		    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
		    };
	
		    Record.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      var newMap = this._map && this._map.__ensureOwner(ownerID);
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this._map = newMap;
		        return this;
		      }
		      return makeRecord(this, newMap, ownerID);
		    };
	
	
		  var RecordPrototype = Record.prototype;
		  RecordPrototype[DELETE] = RecordPrototype.remove;
		  RecordPrototype.deleteIn =
		  RecordPrototype.removeIn = MapPrototype.removeIn;
		  RecordPrototype.merge = MapPrototype.merge;
		  RecordPrototype.mergeWith = MapPrototype.mergeWith;
		  RecordPrototype.mergeIn = MapPrototype.mergeIn;
		  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
		  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
		  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
		  RecordPrototype.setIn = MapPrototype.setIn;
		  RecordPrototype.update = MapPrototype.update;
		  RecordPrototype.updateIn = MapPrototype.updateIn;
		  RecordPrototype.withMutations = MapPrototype.withMutations;
		  RecordPrototype.asMutable = MapPrototype.asMutable;
		  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
		  function makeRecord(likeRecord, map, ownerID) {
		    var record = Object.create(Object.getPrototypeOf(likeRecord));
		    record._map = map;
		    record.__ownerID = ownerID;
		    return record;
		  }
	
		  function recordName(record) {
		    return record._name || record.constructor.name || 'Record';
		  }
	
		  function setProps(prototype, names) {
		    try {
		      names.forEach(setProp.bind(undefined, prototype));
		    } catch (error) {
		      // Object.defineProperty failed. Probably IE8.
		    }
		  }
	
		  function setProp(prototype, name) {
		    Object.defineProperty(prototype, name, {
		      get: function() {
		        return this.get(name);
		      },
		      set: function(value) {
		        invariant(this.__ownerID, 'Cannot set on an immutable record.');
		        this.set(name, value);
		      }
		    });
		  }
	
		  createClass(Set, SetCollection);
	
		    // @pragma Construction
	
		    function Set(value) {
		      return value === null || value === undefined ? emptySet() :
		        isSet(value) && !isOrdered(value) ? value :
		        emptySet().withMutations(function(set ) {
		          var iter = SetIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v ) {return set.add(v)});
		        });
		    }
	
		    Set.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    Set.fromKeys = function(value) {
		      return this(KeyedIterable(value).keySeq());
		    };
	
		    Set.prototype.toString = function() {
		      return this.__toString('Set {', '}');
		    };
	
		    // @pragma Access
	
		    Set.prototype.has = function(value) {
		      return this._map.has(value);
		    };
	
		    // @pragma Modification
	
		    Set.prototype.add = function(value) {
		      return updateSet(this, this._map.set(value, true));
		    };
	
		    Set.prototype.remove = function(value) {
		      return updateSet(this, this._map.remove(value));
		    };
	
		    Set.prototype.clear = function() {
		      return updateSet(this, this._map.clear());
		    };
	
		    // @pragma Composition
	
		    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
		      iters = iters.filter(function(x ) {return x.size !== 0});
		      if (iters.length === 0) {
		        return this;
		      }
		      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
		        return this.constructor(iters[0]);
		      }
		      return this.withMutations(function(set ) {
		        for (var ii = 0; ii < iters.length; ii++) {
		          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
		        }
		      });
		    };
	
		    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
		      if (iters.length === 0) {
		        return this;
		      }
		      iters = iters.map(function(iter ) {return SetIterable(iter)});
		      var originalSet = this;
		      return this.withMutations(function(set ) {
		        originalSet.forEach(function(value ) {
		          if (!iters.every(function(iter ) {return iter.includes(value)})) {
		            set.remove(value);
		          }
		        });
		      });
		    };
	
		    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
		      if (iters.length === 0) {
		        return this;
		      }
		      iters = iters.map(function(iter ) {return SetIterable(iter)});
		      var originalSet = this;
		      return this.withMutations(function(set ) {
		        originalSet.forEach(function(value ) {
		          if (iters.some(function(iter ) {return iter.includes(value)})) {
		            set.remove(value);
		          }
		        });
		      });
		    };
	
		    Set.prototype.merge = function() {
		      return this.union.apply(this, arguments);
		    };
	
		    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return this.union.apply(this, iters);
		    };
	
		    Set.prototype.sort = function(comparator) {
		      // Late binding
		      return OrderedSet(sortFactory(this, comparator));
		    };
	
		    Set.prototype.sortBy = function(mapper, comparator) {
		      // Late binding
		      return OrderedSet(sortFactory(this, comparator, mapper));
		    };
	
		    Set.prototype.wasAltered = function() {
		      return this._map.wasAltered();
		    };
	
		    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
		    };
	
		    Set.prototype.__iterator = function(type, reverse) {
		      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
		    };
	
		    Set.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      var newMap = this._map.__ensureOwner(ownerID);
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this._map = newMap;
		        return this;
		      }
		      return this.__make(newMap, ownerID);
		    };
	
	
		  function isSet(maybeSet) {
		    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
		  }
	
		  Set.isSet = isSet;
	
		  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
		  var SetPrototype = Set.prototype;
		  SetPrototype[IS_SET_SENTINEL] = true;
		  SetPrototype[DELETE] = SetPrototype.remove;
		  SetPrototype.mergeDeep = SetPrototype.merge;
		  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
		  SetPrototype.withMutations = MapPrototype.withMutations;
		  SetPrototype.asMutable = MapPrototype.asMutable;
		  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
		  SetPrototype.__empty = emptySet;
		  SetPrototype.__make = makeSet;
	
		  function updateSet(set, newMap) {
		    if (set.__ownerID) {
		      set.size = newMap.size;
		      set._map = newMap;
		      return set;
		    }
		    return newMap === set._map ? set :
		      newMap.size === 0 ? set.__empty() :
		      set.__make(newMap);
		  }
	
		  function makeSet(map, ownerID) {
		    var set = Object.create(SetPrototype);
		    set.size = map ? map.size : 0;
		    set._map = map;
		    set.__ownerID = ownerID;
		    return set;
		  }
	
		  var EMPTY_SET;
		  function emptySet() {
		    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
		  }
	
		  createClass(OrderedSet, Set);
	
		    // @pragma Construction
	
		    function OrderedSet(value) {
		      return value === null || value === undefined ? emptyOrderedSet() :
		        isOrderedSet(value) ? value :
		        emptyOrderedSet().withMutations(function(set ) {
		          var iter = SetIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v ) {return set.add(v)});
		        });
		    }
	
		    OrderedSet.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    OrderedSet.fromKeys = function(value) {
		      return this(KeyedIterable(value).keySeq());
		    };
	
		    OrderedSet.prototype.toString = function() {
		      return this.__toString('OrderedSet {', '}');
		    };
	
	
		  function isOrderedSet(maybeOrderedSet) {
		    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
		  }
	
		  OrderedSet.isOrderedSet = isOrderedSet;
	
		  var OrderedSetPrototype = OrderedSet.prototype;
		  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
		  OrderedSetPrototype.__empty = emptyOrderedSet;
		  OrderedSetPrototype.__make = makeOrderedSet;
	
		  function makeOrderedSet(map, ownerID) {
		    var set = Object.create(OrderedSetPrototype);
		    set.size = map ? map.size : 0;
		    set._map = map;
		    set.__ownerID = ownerID;
		    return set;
		  }
	
		  var EMPTY_ORDERED_SET;
		  function emptyOrderedSet() {
		    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
		  }
	
		  createClass(Stack, IndexedCollection);
	
		    // @pragma Construction
	
		    function Stack(value) {
		      return value === null || value === undefined ? emptyStack() :
		        isStack(value) ? value :
		        emptyStack().unshiftAll(value);
		    }
	
		    Stack.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    Stack.prototype.toString = function() {
		      return this.__toString('Stack [', ']');
		    };
	
		    // @pragma Access
	
		    Stack.prototype.get = function(index, notSetValue) {
		      var head = this._head;
		      index = wrapIndex(this, index);
		      while (head && index--) {
		        head = head.next;
		      }
		      return head ? head.value : notSetValue;
		    };
	
		    Stack.prototype.peek = function() {
		      return this._head && this._head.value;
		    };
	
		    // @pragma Modification
	
		    Stack.prototype.push = function(/*...values*/) {
		      if (arguments.length === 0) {
		        return this;
		      }
		      var newSize = this.size + arguments.length;
		      var head = this._head;
		      for (var ii = arguments.length - 1; ii >= 0; ii--) {
		        head = {
		          value: arguments[ii],
		          next: head
		        };
		      }
		      if (this.__ownerID) {
		        this.size = newSize;
		        this._head = head;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return makeStack(newSize, head);
		    };
	
		    Stack.prototype.pushAll = function(iter) {
		      iter = IndexedIterable(iter);
		      if (iter.size === 0) {
		        return this;
		      }
		      assertNotInfinite(iter.size);
		      var newSize = this.size;
		      var head = this._head;
		      iter.reverse().forEach(function(value ) {
		        newSize++;
		        head = {
		          value: value,
		          next: head
		        };
		      });
		      if (this.__ownerID) {
		        this.size = newSize;
		        this._head = head;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return makeStack(newSize, head);
		    };
	
		    Stack.prototype.pop = function() {
		      return this.slice(1);
		    };
	
		    Stack.prototype.unshift = function(/*...values*/) {
		      return this.push.apply(this, arguments);
		    };
	
		    Stack.prototype.unshiftAll = function(iter) {
		      return this.pushAll(iter);
		    };
	
		    Stack.prototype.shift = function() {
		      return this.pop.apply(this, arguments);
		    };
	
		    Stack.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = 0;
		        this._head = undefined;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return emptyStack();
		    };
	
		    Stack.prototype.slice = function(begin, end) {
		      if (wholeSlice(begin, end, this.size)) {
		        return this;
		      }
		      var resolvedBegin = resolveBegin(begin, this.size);
		      var resolvedEnd = resolveEnd(end, this.size);
		      if (resolvedEnd !== this.size) {
		        // super.slice(begin, end);
		        return IndexedCollection.prototype.slice.call(this, begin, end);
		      }
		      var newSize = this.size - resolvedBegin;
		      var head = this._head;
		      while (resolvedBegin--) {
		        head = head.next;
		      }
		      if (this.__ownerID) {
		        this.size = newSize;
		        this._head = head;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return makeStack(newSize, head);
		    };
	
		    // @pragma Mutability
	
		    Stack.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this.__altered = false;
		        return this;
		      }
		      return makeStack(this.size, this._head, ownerID, this.__hash);
		    };
	
		    // @pragma Iteration
	
		    Stack.prototype.__iterate = function(fn, reverse) {
		      if (reverse) {
		        return this.reverse().__iterate(fn);
		      }
		      var iterations = 0;
		      var node = this._head;
		      while (node) {
		        if (fn(node.value, iterations++, this) === false) {
		          break;
		        }
		        node = node.next;
		      }
		      return iterations;
		    };
	
		    Stack.prototype.__iterator = function(type, reverse) {
		      if (reverse) {
		        return this.reverse().__iterator(type);
		      }
		      var iterations = 0;
		      var node = this._head;
		      return new Iterator(function()  {
		        if (node) {
		          var value = node.value;
		          node = node.next;
		          return iteratorValue(type, iterations++, value);
		        }
		        return iteratorDone();
		      });
		    };
	
	
		  function isStack(maybeStack) {
		    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
		  }
	
		  Stack.isStack = isStack;
	
		  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
		  var StackPrototype = Stack.prototype;
		  StackPrototype[IS_STACK_SENTINEL] = true;
		  StackPrototype.withMutations = MapPrototype.withMutations;
		  StackPrototype.asMutable = MapPrototype.asMutable;
		  StackPrototype.asImmutable = MapPrototype.asImmutable;
		  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
		  function makeStack(size, head, ownerID, hash) {
		    var map = Object.create(StackPrototype);
		    map.size = size;
		    map._head = head;
		    map.__ownerID = ownerID;
		    map.__hash = hash;
		    map.__altered = false;
		    return map;
		  }
	
		  var EMPTY_STACK;
		  function emptyStack() {
		    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
		  }
	
		  /**
		   * Contributes additional methods to a constructor
		   */
		  function mixin(ctor, methods) {
		    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
		    Object.keys(methods).forEach(keyCopier);
		    Object.getOwnPropertySymbols &&
		      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
		    return ctor;
		  }
	
		  Iterable.Iterator = Iterator;
	
		  mixin(Iterable, {
	
		    // ### Conversion to other types
	
		    toArray: function() {
		      assertNotInfinite(this.size);
		      var array = new Array(this.size || 0);
		      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
		      return array;
		    },
	
		    toIndexedSeq: function() {
		      return new ToIndexedSequence(this);
		    },
	
		    toJS: function() {
		      return this.toSeq().map(
		        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
		      ).__toJS();
		    },
	
		    toJSON: function() {
		      return this.toSeq().map(
		        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
		      ).__toJS();
		    },
	
		    toKeyedSeq: function() {
		      return new ToKeyedSequence(this, true);
		    },
	
		    toMap: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return Map(this.toKeyedSeq());
		    },
	
		    toObject: function() {
		      assertNotInfinite(this.size);
		      var object = {};
		      this.__iterate(function(v, k)  { object[k] = v; });
		      return object;
		    },
	
		    toOrderedMap: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return OrderedMap(this.toKeyedSeq());
		    },
	
		    toOrderedSet: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
		    },
	
		    toSet: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return Set(isKeyed(this) ? this.valueSeq() : this);
		    },
	
		    toSetSeq: function() {
		      return new ToSetSequence(this);
		    },
	
		    toSeq: function() {
		      return isIndexed(this) ? this.toIndexedSeq() :
		        isKeyed(this) ? this.toKeyedSeq() :
		        this.toSetSeq();
		    },
	
		    toStack: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return Stack(isKeyed(this) ? this.valueSeq() : this);
		    },
	
		    toList: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return List(isKeyed(this) ? this.valueSeq() : this);
		    },
	
	
		    // ### Common JavaScript methods and properties
	
		    toString: function() {
		      return '[Iterable]';
		    },
	
		    __toString: function(head, tail) {
		      if (this.size === 0) {
		        return head + tail;
		      }
		      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
		    },
	
	
		    // ### ES6 Collection methods (ES6 Array and Map)
	
		    concat: function() {var values = SLICE$0.call(arguments, 0);
		      return reify(this, concatFactory(this, values));
		    },
	
		    includes: function(searchValue) {
		      return this.some(function(value ) {return is(value, searchValue)});
		    },
	
		    entries: function() {
		      return this.__iterator(ITERATE_ENTRIES);
		    },
	
		    every: function(predicate, context) {
		      assertNotInfinite(this.size);
		      var returnValue = true;
		      this.__iterate(function(v, k, c)  {
		        if (!predicate.call(context, v, k, c)) {
		          returnValue = false;
		          return false;
		        }
		      });
		      return returnValue;
		    },
	
		    filter: function(predicate, context) {
		      return reify(this, filterFactory(this, predicate, context, true));
		    },
	
		    find: function(predicate, context, notSetValue) {
		      var entry = this.findEntry(predicate, context);
		      return entry ? entry[1] : notSetValue;
		    },
	
		    forEach: function(sideEffect, context) {
		      assertNotInfinite(this.size);
		      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
		    },
	
		    join: function(separator) {
		      assertNotInfinite(this.size);
		      separator = separator !== undefined ? '' + separator : ',';
		      var joined = '';
		      var isFirst = true;
		      this.__iterate(function(v ) {
		        isFirst ? (isFirst = false) : (joined += separator);
		        joined += v !== null && v !== undefined ? v.toString() : '';
		      });
		      return joined;
		    },
	
		    keys: function() {
		      return this.__iterator(ITERATE_KEYS);
		    },
	
		    map: function(mapper, context) {
		      return reify(this, mapFactory(this, mapper, context));
		    },
	
		    reduce: function(reducer, initialReduction, context) {
		      assertNotInfinite(this.size);
		      var reduction;
		      var useFirst;
		      if (arguments.length < 2) {
		        useFirst = true;
		      } else {
		        reduction = initialReduction;
		      }
		      this.__iterate(function(v, k, c)  {
		        if (useFirst) {
		          useFirst = false;
		          reduction = v;
		        } else {
		          reduction = reducer.call(context, reduction, v, k, c);
		        }
		      });
		      return reduction;
		    },
	
		    reduceRight: function(reducer, initialReduction, context) {
		      var reversed = this.toKeyedSeq().reverse();
		      return reversed.reduce.apply(reversed, arguments);
		    },
	
		    reverse: function() {
		      return reify(this, reverseFactory(this, true));
		    },
	
		    slice: function(begin, end) {
		      return reify(this, sliceFactory(this, begin, end, true));
		    },
	
		    some: function(predicate, context) {
		      return !this.every(not(predicate), context);
		    },
	
		    sort: function(comparator) {
		      return reify(this, sortFactory(this, comparator));
		    },
	
		    values: function() {
		      return this.__iterator(ITERATE_VALUES);
		    },
	
	
		    // ### More sequential methods
	
		    butLast: function() {
		      return this.slice(0, -1);
		    },
	
		    isEmpty: function() {
		      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
		    },
	
		    count: function(predicate, context) {
		      return ensureSize(
		        predicate ? this.toSeq().filter(predicate, context) : this
		      );
		    },
	
		    countBy: function(grouper, context) {
		      return countByFactory(this, grouper, context);
		    },
	
		    equals: function(other) {
		      return deepEqual(this, other);
		    },
	
		    entrySeq: function() {
		      var iterable = this;
		      if (iterable._cache) {
		        // We cache as an entries array, so we can just return the cache!
		        return new ArraySeq(iterable._cache);
		      }
		      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
		      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
		      return entriesSequence;
		    },
	
		    filterNot: function(predicate, context) {
		      return this.filter(not(predicate), context);
		    },
	
		    findEntry: function(predicate, context, notSetValue) {
		      var found = notSetValue;
		      this.__iterate(function(v, k, c)  {
		        if (predicate.call(context, v, k, c)) {
		          found = [k, v];
		          return false;
		        }
		      });
		      return found;
		    },
	
		    findKey: function(predicate, context) {
		      var entry = this.findEntry(predicate, context);
		      return entry && entry[0];
		    },
	
		    findLast: function(predicate, context, notSetValue) {
		      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
		    },
	
		    findLastEntry: function(predicate, context, notSetValue) {
		      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
		    },
	
		    findLastKey: function(predicate, context) {
		      return this.toKeyedSeq().reverse().findKey(predicate, context);
		    },
	
		    first: function() {
		      return this.find(returnTrue);
		    },
	
		    flatMap: function(mapper, context) {
		      return reify(this, flatMapFactory(this, mapper, context));
		    },
	
		    flatten: function(depth) {
		      return reify(this, flattenFactory(this, depth, true));
		    },
	
		    fromEntrySeq: function() {
		      return new FromEntriesSequence(this);
		    },
	
		    get: function(searchKey, notSetValue) {
		      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
		    },
	
		    getIn: function(searchKeyPath, notSetValue) {
		      var nested = this;
		      // Note: in an ES6 environment, we would prefer:
		      // for (var key of searchKeyPath) {
		      var iter = forceIterator(searchKeyPath);
		      var step;
		      while (!(step = iter.next()).done) {
		        var key = step.value;
		        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
		        if (nested === NOT_SET) {
		          return notSetValue;
		        }
		      }
		      return nested;
		    },
	
		    groupBy: function(grouper, context) {
		      return groupByFactory(this, grouper, context);
		    },
	
		    has: function(searchKey) {
		      return this.get(searchKey, NOT_SET) !== NOT_SET;
		    },
	
		    hasIn: function(searchKeyPath) {
		      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
		    },
	
		    isSubset: function(iter) {
		      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
		      return this.every(function(value ) {return iter.includes(value)});
		    },
	
		    isSuperset: function(iter) {
		      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
		      return iter.isSubset(this);
		    },
	
		    keyOf: function(searchValue) {
		      return this.findKey(function(value ) {return is(value, searchValue)});
		    },
	
		    keySeq: function() {
		      return this.toSeq().map(keyMapper).toIndexedSeq();
		    },
	
		    last: function() {
		      return this.toSeq().reverse().first();
		    },
	
		    lastKeyOf: function(searchValue) {
		      return this.toKeyedSeq().reverse().keyOf(searchValue);
		    },
	
		    max: function(comparator) {
		      return maxFactory(this, comparator);
		    },
	
		    maxBy: function(mapper, comparator) {
		      return maxFactory(this, comparator, mapper);
		    },
	
		    min: function(comparator) {
		      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
		    },
	
		    minBy: function(mapper, comparator) {
		      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
		    },
	
		    rest: function() {
		      return this.slice(1);
		    },
	
		    skip: function(amount) {
		      return this.slice(Math.max(0, amount));
		    },
	
		    skipLast: function(amount) {
		      return reify(this, this.toSeq().reverse().skip(amount).reverse());
		    },
	
		    skipWhile: function(predicate, context) {
		      return reify(this, skipWhileFactory(this, predicate, context, true));
		    },
	
		    skipUntil: function(predicate, context) {
		      return this.skipWhile(not(predicate), context);
		    },
	
		    sortBy: function(mapper, comparator) {
		      return reify(this, sortFactory(this, comparator, mapper));
		    },
	
		    take: function(amount) {
		      return this.slice(0, Math.max(0, amount));
		    },
	
		    takeLast: function(amount) {
		      return reify(this, this.toSeq().reverse().take(amount).reverse());
		    },
	
		    takeWhile: function(predicate, context) {
		      return reify(this, takeWhileFactory(this, predicate, context));
		    },
	
		    takeUntil: function(predicate, context) {
		      return this.takeWhile(not(predicate), context);
		    },
	
		    valueSeq: function() {
		      return this.toIndexedSeq();
		    },
	
	
		    // ### Hashable Object
	
		    hashCode: function() {
		      return this.__hash || (this.__hash = hashIterable(this));
		    }
	
	
		    // ### Internal
	
		    // abstract __iterate(fn, reverse)
	
		    // abstract __iterator(type, reverse)
		  });
	
		  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
		  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
		  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
		  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
		  var IterablePrototype = Iterable.prototype;
		  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
		  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
		  IterablePrototype.__toJS = IterablePrototype.toArray;
		  IterablePrototype.__toStringMapper = quoteString;
		  IterablePrototype.inspect =
		  IterablePrototype.toSource = function() { return this.toString(); };
		  IterablePrototype.chain = IterablePrototype.flatMap;
		  IterablePrototype.contains = IterablePrototype.includes;
	
		  mixin(KeyedIterable, {
	
		    // ### More sequential methods
	
		    flip: function() {
		      return reify(this, flipFactory(this));
		    },
	
		    mapEntries: function(mapper, context) {var this$0 = this;
		      var iterations = 0;
		      return reify(this,
		        this.toSeq().map(
		          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
		        ).fromEntrySeq()
		      );
		    },
	
		    mapKeys: function(mapper, context) {var this$0 = this;
		      return reify(this,
		        this.toSeq().flip().map(
		          function(k, v)  {return mapper.call(context, k, v, this$0)}
		        ).flip()
		      );
		    }
	
		  });
	
		  var KeyedIterablePrototype = KeyedIterable.prototype;
		  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
		  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
		  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
		  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
		  mixin(IndexedIterable, {
	
		    // ### Conversion to other types
	
		    toKeyedSeq: function() {
		      return new ToKeyedSequence(this, false);
		    },
	
	
		    // ### ES6 Collection methods (ES6 Array and Map)
	
		    filter: function(predicate, context) {
		      return reify(this, filterFactory(this, predicate, context, false));
		    },
	
		    findIndex: function(predicate, context) {
		      var entry = this.findEntry(predicate, context);
		      return entry ? entry[0] : -1;
		    },
	
		    indexOf: function(searchValue) {
		      var key = this.keyOf(searchValue);
		      return key === undefined ? -1 : key;
		    },
	
		    lastIndexOf: function(searchValue) {
		      var key = this.lastKeyOf(searchValue);
		      return key === undefined ? -1 : key;
		    },
	
		    reverse: function() {
		      return reify(this, reverseFactory(this, false));
		    },
	
		    slice: function(begin, end) {
		      return reify(this, sliceFactory(this, begin, end, false));
		    },
	
		    splice: function(index, removeNum /*, ...values*/) {
		      var numArgs = arguments.length;
		      removeNum = Math.max(removeNum | 0, 0);
		      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
		        return this;
		      }
		      // If index is negative, it should resolve relative to the size of the
		      // collection. However size may be expensive to compute if not cached, so
		      // only call count() if the number is in fact negative.
		      index = resolveBegin(index, index < 0 ? this.count() : this.size);
		      var spliced = this.slice(0, index);
		      return reify(
		        this,
		        numArgs === 1 ?
		          spliced :
		          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
		      );
		    },
	
	
		    // ### More collection methods
	
		    findLastIndex: function(predicate, context) {
		      var entry = this.findLastEntry(predicate, context);
		      return entry ? entry[0] : -1;
		    },
	
		    first: function() {
		      return this.get(0);
		    },
	
		    flatten: function(depth) {
		      return reify(this, flattenFactory(this, depth, false));
		    },
	
		    get: function(index, notSetValue) {
		      index = wrapIndex(this, index);
		      return (index < 0 || (this.size === Infinity ||
		          (this.size !== undefined && index > this.size))) ?
		        notSetValue :
		        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
		    },
	
		    has: function(index) {
		      index = wrapIndex(this, index);
		      return index >= 0 && (this.size !== undefined ?
		        this.size === Infinity || index < this.size :
		        this.indexOf(index) !== -1
		      );
		    },
	
		    interpose: function(separator) {
		      return reify(this, interposeFactory(this, separator));
		    },
	
		    interleave: function(/*...iterables*/) {
		      var iterables = [this].concat(arrCopy(arguments));
		      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
		      var interleaved = zipped.flatten(true);
		      if (zipped.size) {
		        interleaved.size = zipped.size * iterables.length;
		      }
		      return reify(this, interleaved);
		    },
	
		    keySeq: function() {
		      return Range(0, this.size);
		    },
	
		    last: function() {
		      return this.get(-1);
		    },
	
		    skipWhile: function(predicate, context) {
		      return reify(this, skipWhileFactory(this, predicate, context, false));
		    },
	
		    zip: function(/*, ...iterables */) {
		      var iterables = [this].concat(arrCopy(arguments));
		      return reify(this, zipWithFactory(this, defaultZipper, iterables));
		    },
	
		    zipWith: function(zipper/*, ...iterables */) {
		      var iterables = arrCopy(arguments);
		      iterables[0] = this;
		      return reify(this, zipWithFactory(this, zipper, iterables));
		    }
	
		  });
	
		  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
		  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
		  mixin(SetIterable, {
	
		    // ### ES6 Collection methods (ES6 Array and Map)
	
		    get: function(value, notSetValue) {
		      return this.has(value) ? value : notSetValue;
		    },
	
		    includes: function(value) {
		      return this.has(value);
		    },
	
	
		    // ### More sequential methods
	
		    keySeq: function() {
		      return this.valueSeq();
		    }
	
		  });
	
		  SetIterable.prototype.has = IterablePrototype.includes;
		  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
		  // Mixin subclasses
	
		  mixin(KeyedSeq, KeyedIterable.prototype);
		  mixin(IndexedSeq, IndexedIterable.prototype);
		  mixin(SetSeq, SetIterable.prototype);
	
		  mixin(KeyedCollection, KeyedIterable.prototype);
		  mixin(IndexedCollection, IndexedIterable.prototype);
		  mixin(SetCollection, SetIterable.prototype);
	
	
		  // #pragma Helper functions
	
		  function keyMapper(v, k) {
		    return k;
		  }
	
		  function entryMapper(v, k) {
		    return [k, v];
		  }
	
		  function not(predicate) {
		    return function() {
		      return !predicate.apply(this, arguments);
		    }
		  }
	
		  function neg(predicate) {
		    return function() {
		      return -predicate.apply(this, arguments);
		    }
		  }
	
		  function quoteString(value) {
		    return typeof value === 'string' ? JSON.stringify(value) : String(value);
		  }
	
		  function defaultZipper() {
		    return arrCopy(arguments);
		  }
	
		  function defaultNegComparator(a, b) {
		    return a < b ? 1 : a > b ? -1 : 0;
		  }
	
		  function hashIterable(iterable) {
		    if (iterable.size === Infinity) {
		      return 0;
		    }
		    var ordered = isOrdered(iterable);
		    var keyed = isKeyed(iterable);
		    var h = ordered ? 1 : 0;
		    var size = iterable.__iterate(
		      keyed ?
		        ordered ?
		          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
		          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
		        ordered ?
		          function(v ) { h = 31 * h + hash(v) | 0; } :
		          function(v ) { h = h + hash(v) | 0; }
		    );
		    return murmurHashOfSize(size, h);
		  }
	
		  function murmurHashOfSize(size, h) {
		    h = imul(h, 0xCC9E2D51);
		    h = imul(h << 15 | h >>> -15, 0x1B873593);
		    h = imul(h << 13 | h >>> -13, 5);
		    h = (h + 0xE6546B64 | 0) ^ size;
		    h = imul(h ^ h >>> 16, 0x85EBCA6B);
		    h = imul(h ^ h >>> 13, 0xC2B2AE35);
		    h = smi(h ^ h >>> 16);
		    return h;
		  }
	
		  function hashMerge(a, b) {
		    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
		  }
	
		  var Immutable = {
	
		    Iterable: Iterable,
	
		    Seq: Seq,
		    Collection: Collection,
		    Map: Map,
		    OrderedMap: OrderedMap,
		    List: List,
		    Stack: Stack,
		    Set: Set,
		    OrderedSet: OrderedSet,
	
		    Record: Record,
		    Range: Range,
		    Repeat: Repeat,
	
		    is: is,
		    fromJS: fromJS
	
		  };
	
		  return Immutable;
	
		}));
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(196);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-header.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-header.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ }),
	/* 20 */
	13,
	/* 21 */
	[1697, 430, 454],
	/* 22 */,
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var shallowCloneObject = __webpack_require__(36);
	
		var contextTypes = {
		  metricsComputator: React.PropTypes.object
		};
	
		var MetricsComputatorMixin = {
	
		  childContextTypes: contextTypes,
	
		  getChildContext: function getChildContext() {
		    return { metricsComputator: this };
		  },
		  getMetricImpl: function getMetricImpl(name) {
		    return this._DOMMetrics.metrics[name].value;
		  },
		  registerMetricsImpl: function registerMetricsImpl(component, metrics) {
		    var getters = {};
		    var s = this._DOMMetrics;
	
		    for (var name in metrics) {
		      if (s.metrics[name] !== undefined) {
		        throw new Error('DOM metric ' + name + ' is already defined');
		      }
		      s.metrics[name] = { component: component, computator: metrics[name].bind(component) };
		      getters[name] = this.getMetricImpl.bind(null, name);
		    }
	
		    if (s.components.indexOf(component) === -1) {
		      s.components.push(component);
		    }
	
		    return getters;
		  },
		  unregisterMetricsFor: function unregisterMetricsFor(component) {
		    var s = this._DOMMetrics;
		    var idx = s.components.indexOf(component);
	
		    if (idx > -1) {
		      s.components.splice(idx, 1);
	
		      var name = void 0;
		      var metricsToDelete = {};
	
		      for (name in s.metrics) {
		        if (s.metrics[name].component === component) {
		          metricsToDelete[name] = true;
		        }
		      }
	
		      for (name in metricsToDelete) {
		        if (metricsToDelete.hasOwnProperty(name)) {
		          delete s.metrics[name];
		        }
		      }
		    }
		  },
		  updateMetrics: function updateMetrics() {
		    var s = this._DOMMetrics;
	
		    var needUpdate = false;
	
		    for (var name in s.metrics) {
		      if (!s.metrics.hasOwnProperty(name)) continue;
	
		      var newMetric = s.metrics[name].computator();
		      if (newMetric !== s.metrics[name].value) {
		        needUpdate = true;
		      }
		      s.metrics[name].value = newMetric;
		    }
	
		    if (needUpdate) {
		      for (var i = 0, len = s.components.length; i < len; i++) {
		        if (s.components[i].metricsUpdated) {
		          s.components[i].metricsUpdated();
		        }
		      }
		    }
		  },
		  componentWillMount: function componentWillMount() {
		    this._DOMMetrics = {
		      metrics: {},
		      components: []
		    };
		  },
		  componentDidMount: function componentDidMount() {
		    if (window.addEventListener) {
		      window.addEventListener('resize', this.updateMetrics);
		    } else {
		      window.attachEvent('resize', this.updateMetrics);
		    }
		    this.updateMetrics();
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    window.removeEventListener('resize', this.updateMetrics);
		  }
		};
	
		var MetricsMixin = {
	
		  contextTypes: contextTypes,
	
		  componentWillMount: function componentWillMount() {
		    if (this.DOMMetrics) {
		      this._DOMMetricsDefs = shallowCloneObject(this.DOMMetrics);
	
		      this.DOMMetrics = {};
		      for (var name in this._DOMMetricsDefs) {
		        if (!this._DOMMetricsDefs.hasOwnProperty(name)) continue;
	
		        this.DOMMetrics[name] = function () {};
		      }
		    }
		  },
		  componentDidMount: function componentDidMount() {
		    if (this.DOMMetrics) {
		      this.DOMMetrics = this.registerMetrics(this._DOMMetricsDefs);
		    }
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    if (!this.registerMetricsImpl) {
		      return this.context.metricsComputator.unregisterMetricsFor(this);
		    }
		    if (this.hasOwnProperty('DOMMetrics')) {
		      delete this.DOMMetrics;
		    }
		  },
		  registerMetrics: function registerMetrics(metrics) {
		    if (this.registerMetricsImpl) {
		      return this.registerMetricsImpl(this, metrics);
		    }
	
		    return this.context.metricsComputator.registerMetricsImpl(this, metrics);
		  },
		  getMetric: function getMetric(name) {
		    if (this.getMetricImpl) {
		      return this.getMetricImpl(name);
		    }
	
		    return this.context.metricsComputator.getMetricImpl(name);
		  }
		};
	
		module.exports = {
		  MetricsComputatorMixin: MetricsComputatorMixin,
		  MetricsMixin: MetricsMixin
		};
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
		module.exports = exports['default'];
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var identity = __webpack_require__(118),
		    overRest = __webpack_require__(331),
		    setToString = __webpack_require__(334);
	
		/**
		 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
		 *
		 * @private
		 * @param {Function} func The function to apply a rest parameter to.
		 * @param {number} [start=func.length-1] The start position of the rest parameter.
		 * @returns {Function} Returns the new function.
		 */
		function baseRest(func, start) {
		  return setToString(overRest(func, start, identity), func + '');
		}
	
		module.exports = baseRest;
	
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(195);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-core.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-core.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(197);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-row.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-row.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ }),
	/* 28 */
	[1786, 115],
	/* 29 */
	/***/ (function(module, exports) {
	
		/**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */
		function isObject(value) {
		  var type = typeof value;
		  return value != null && (type == 'object' || type == 'function');
		}
	
		module.exports = isObject;
	
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports) {
	
		/**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */
		function isObjectLike(value) {
		  return value != null && typeof value == 'object';
		}
	
		module.exports = isObjectLike;
	
	
	/***/ }),
	/* 31 */
	[1660, 53, 451, 478],
	/* 32 */
	30,
	/* 33 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var shallowCloneObject = __webpack_require__(36);
		var sameColumn = __webpack_require__(162);
		var ColumnUtils = __webpack_require__(10);
		var getScrollbarSize = __webpack_require__(35);
		var isColumnsImmutable = __webpack_require__(69);
	
		function setColumnWidths(columns, totalWidth) {
		  return columns.map(function (column) {
		    var colInfo = Object.assign({}, column);
		    if (column.width) {
		      if (/^([0-9]+)%$/.exec(column.width.toString())) {
		        colInfo.width = Math.floor(column.width / 100 * totalWidth);
		      }
		    }
		    return colInfo;
		  });
		}
	
		function setDefferedColumnWidths(columns, unallocatedWidth, minColumnWidth) {
		  var defferedColumns = columns.filter(function (c) {
		    return !c.width;
		  });
		  return columns.map(function (column) {
		    if (!column.width) {
		      if (unallocatedWidth <= 0) {
		        column.width = minColumnWidth;
		      } else {
		        column.width = Math.floor(unallocatedWidth / ColumnUtils.getSize(defferedColumns));
		      }
		    }
		    return column;
		  });
		}
	
		function setColumnOffsets(columns) {
		  var left = 0;
		  return columns.map(function (column) {
		    column.left = left;
		    left += column.width;
		    return column;
		  });
		}
	
		/**
		 * Update column metrics calculation.
		 *
		 * @param {ColumnMetricsType} metrics
		 */
		function recalculate(metrics) {
		  // compute width for columns which specify width
		  var columns = setColumnWidths(metrics.columns, metrics.totalWidth);
	
		  var unallocatedWidth = columns.filter(function (c) {
		    return c.width;
		  }).reduce(function (w, column) {
		    return w - column.width;
		  }, metrics.totalWidth);
		  unallocatedWidth -= getScrollbarSize();
	
		  var width = columns.filter(function (c) {
		    return c.width;
		  }).reduce(function (w, column) {
		    return w + column.width;
		  }, 0);
	
		  // compute width for columns which doesn't specify width
		  columns = setDefferedColumnWidths(columns, unallocatedWidth, metrics.minColumnWidth);
	
		  // compute left offset
		  columns = setColumnOffsets(columns);
	
		  return {
		    columns: columns,
		    width: width,
		    totalWidth: metrics.totalWidth,
		    minColumnWidth: metrics.minColumnWidth
		  };
		}
	
		/**
		 * Update column metrics calculation by resizing a column.
		 *
		 * @param {ColumnMetricsType} metrics
		 * @param {Column} column
		 * @param {number} width
		 */
		function resizeColumn(metrics, index, width) {
		  var column = ColumnUtils.getColumn(metrics.columns, index);
		  var metricsClone = shallowCloneObject(metrics);
		  metricsClone.columns = metrics.columns.slice(0);
	
		  var updatedColumn = shallowCloneObject(column);
		  updatedColumn.width = Math.max(width, metricsClone.minColumnWidth);
	
		  metricsClone = ColumnUtils.spliceColumn(metricsClone, index, updatedColumn);
	
		  return recalculate(metricsClone);
		}
	
		function areColumnsImmutable(prevColumns, nextColumns) {
		  return isColumnsImmutable(prevColumns) && isColumnsImmutable(nextColumns);
		}
	
		function compareEachColumn(prevColumns, nextColumns, isSameColumn) {
		  var i = void 0;
		  var len = void 0;
		  var column = void 0;
		  var prevColumnsByKey = {};
		  var nextColumnsByKey = {};
	
		  if (ColumnUtils.getSize(prevColumns) !== ColumnUtils.getSize(nextColumns)) {
		    return false;
		  }
	
		  for (i = 0, len = ColumnUtils.getSize(prevColumns); i < len; i++) {
		    column = prevColumns[i];
		    prevColumnsByKey[column.key] = column;
		  }
	
		  for (i = 0, len = ColumnUtils.getSize(nextColumns); i < len; i++) {
		    column = nextColumns[i];
		    nextColumnsByKey[column.key] = column;
		    var prevColumn = prevColumnsByKey[column.key];
		    if (prevColumn === undefined || !isSameColumn(prevColumn, column)) {
		      return false;
		    }
		  }
	
		  for (i = 0, len = ColumnUtils.getSize(prevColumns); i < len; i++) {
		    column = prevColumns[i];
		    var nextColumn = nextColumnsByKey[column.key];
		    if (nextColumn === undefined) {
		      return false;
		    }
		  }
		  return true;
		}
	
		function sameColumns(prevColumns, nextColumns, isSameColumn) {
		  if (areColumnsImmutable(prevColumns, nextColumns)) {
		    return prevColumns === nextColumns;
		  }
	
		  return compareEachColumn(prevColumns, nextColumns, isSameColumn);
		}
	
		module.exports = { recalculate: recalculate, resizeColumn: resizeColumn, sameColumn: sameColumn, sameColumns: sameColumns };
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _OverflowCell = __webpack_require__(171);
	
		var _OverflowCell2 = _interopRequireDefault(_OverflowCell);
	
		var _RowComparer = __webpack_require__(62);
	
		var _RowComparer2 = _interopRequireDefault(_RowComparer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var joinClasses = __webpack_require__(9);
		var Cell = __webpack_require__(59);
		var ColumnUtilsMixin = __webpack_require__(10);
		var cellMetaDataShape = __webpack_require__(14);
		var PropTypes = React.PropTypes;
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(27);
	
		var CellExpander = React.createClass({
		  displayName: 'CellExpander',
		  render: function render() {
		    return React.createElement(Cell, this.props);
		  }
		});
	
		// The list of the propTypes that we want to include in the Row div
		var knownDivPropertyKeys = ['height'];
	
		var Row = React.createClass({
		  displayName: 'Row',
	
	
		  propTypes: {
		    height: PropTypes.number.isRequired,
		    columns: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
		    row: PropTypes.any.isRequired,
		    cellRenderer: PropTypes.func,
		    cellMetaData: PropTypes.shape(cellMetaDataShape),
		    isSelected: PropTypes.bool,
		    idx: PropTypes.number.isRequired,
		    expandedRows: PropTypes.arrayOf(PropTypes.object),
		    extraClasses: PropTypes.string,
		    forceUpdate: PropTypes.bool,
		    subRowDetails: PropTypes.object,
		    isRowHovered: PropTypes.bool,
		    colVisibleStart: PropTypes.number.isRequired,
		    colVisibleEnd: PropTypes.number.isRequired,
		    colDisplayStart: PropTypes.number.isRequired,
		    colDisplayEnd: PropTypes.number.isRequired,
		    isScrolling: React.PropTypes.bool.isRequired
		  },
	
		  mixins: [ColumnUtilsMixin],
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      cellRenderer: Cell,
		      isSelected: false,
		      height: 35
		    };
		  },
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    return (0, _RowComparer2['default'])(nextProps, this.props);
		  },
		  handleDragEnter: function handleDragEnter() {
		    var handleDragEnterRow = this.props.cellMetaData.handleDragEnterRow;
		    if (handleDragEnterRow) {
		      handleDragEnterRow(this.props.idx);
		    }
		  },
		  getSelectedColumn: function getSelectedColumn() {
		    if (this.props.cellMetaData) {
		      var selected = this.props.cellMetaData.selected;
		      if (selected && selected.idx) {
		        return this.getColumn(this.props.columns, selected.idx);
		      }
		    }
		  },
		  getCellRenderer: function getCellRenderer(columnKey) {
		    var CellRenderer = this.props.cellRenderer;
		    if (this.props.subRowDetails && this.props.subRowDetails.field === columnKey) {
		      return CellExpander;
		    }
		    return CellRenderer;
		  },
		  getCell: function getCell(column, i, selectedColumn) {
		    var _this = this;
	
		    var CellRenderer = this.props.cellRenderer;
		    var _props = this.props,
		        colVisibleStart = _props.colVisibleStart,
		        colVisibleEnd = _props.colVisibleEnd,
		        idx = _props.idx,
		        cellMetaData = _props.cellMetaData;
		    var key = column.key,
		        formatter = column.formatter,
		        locked = column.locked;
	
		    var baseCellProps = { key: key + '-' + idx, idx: i, rowIdx: idx, height: this.getRowHeight(), column: column, cellMetaData: cellMetaData };
	
		    if ((i < colVisibleStart || i > colVisibleEnd) && !locked) {
		      return React.createElement(_OverflowCell2['default'], _extends({ ref: function ref(node) {
		          return _this[key] = node;
		        } }, baseCellProps));
		    }
	
		    var _props2 = this.props,
		        row = _props2.row,
		        isSelected = _props2.isSelected;
	
		    var cellProps = {
		      ref: function ref(node) {
		        return _this[key] = node;
		      },
		      value: this.getCellValue(key || i),
		      rowData: row,
		      isRowSelected: isSelected,
		      expandableOptions: this.getExpandableOptions(key),
		      selectedColumn: selectedColumn,
		      formatter: formatter,
		      isScrolling: this.props.isScrolling
		    };
	
		    return React.createElement(CellRenderer, _extends({}, baseCellProps, cellProps));
		  },
		  getCells: function getCells() {
		    var _this2 = this;
	
		    var cells = [];
		    var lockedCells = [];
		    var selectedColumn = this.getSelectedColumn();
		    if (this.props.columns) {
		      this.props.columns.forEach(function (column, i) {
		        var cell = _this2.getCell(column, i, selectedColumn);
		        if (column.locked) {
		          lockedCells.push(cell);
		        } else {
		          cells.push(cell);
		        }
		      });
		    }
	
		    return cells.concat(lockedCells);
		  },
		  getRowHeight: function getRowHeight() {
		    var rows = this.props.expandedRows || null;
		    if (rows && this.props.idx) {
		      var row = rows[this.props.idx] || null;
		      if (row) {
		        return row.height;
		      }
		    }
		    return this.props.height;
		  },
		  getCellValue: function getCellValue(key) {
		    var val = void 0;
		    if (key === 'select-row') {
		      return this.props.isSelected;
		    } else if (typeof this.props.row.get === 'function') {
		      val = this.props.row.get(key);
		    } else {
		      val = this.props.row[key];
		    }
		    return val;
		  },
		  isContextMenuDisplayed: function isContextMenuDisplayed() {
		    if (this.props.cellMetaData) {
		      var selected = this.props.cellMetaData.selected;
		      if (selected && selected.contextMenuDisplayed && selected.rowIdx === this.props.idx) {
		        return true;
		      }
		    }
		    return false;
		  },
		  getExpandableOptions: function getExpandableOptions(columnKey) {
		    return { canExpand: this.props.subRowDetails && this.props.subRowDetails.field === columnKey, expanded: this.props.subRowDetails && this.props.subRowDetails.expanded, children: this.props.subRowDetails && this.props.subRowDetails.children, treeDepth: this.props.subRowDetails ? this.props.subRowDetails.treeDepth : 0 };
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var _this3 = this;
	
		    this.props.columns.forEach(function (column) {
		      if (column.locked) {
		        if (!_this3[column.key]) return;
		        _this3[column.key].setScrollLeft(scrollLeft);
		      }
		    });
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  renderCell: function renderCell(props) {
		    if (typeof this.props.cellRenderer === 'function') {
		      this.props.cellRenderer.call(this, props);
		    }
		    if (React.isValidElement(this.props.cellRenderer)) {
		      return React.cloneElement(this.props.cellRenderer, props);
		    }
	
		    return this.props.cellRenderer(props);
		  },
		  render: function render() {
		    var className = joinClasses('react-grid-Row', 'react-grid-Row--' + (this.props.idx % 2 === 0 ? 'even' : 'odd'), {
		      'row-selected': this.props.isSelected,
		      'row-context-menu': this.isContextMenuDisplayed()
		    }, this.props.extraClasses);
	
		    var style = {
		      height: this.getRowHeight(this.props),
		      overflow: 'hidden',
		      contain: 'layout'
		    };
	
		    var cells = this.getCells();
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { className: className, style: style, onDragEnter: this.handleDragEnter }),
		      React.isValidElement(this.props.row) ? this.props.row : cells
		    );
		  }
		});
	
		module.exports = Row;
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var size = void 0;
	
		function getScrollbarSize() {
		  if (size === undefined) {
		    var outer = document.createElement('div');
		    outer.style.width = '50px';
		    outer.style.height = '50px';
		    outer.style.position = 'absolute';
		    outer.style.top = '-200px';
		    outer.style.left = '-200px';
	
		    var inner = document.createElement('div');
		    inner.style.height = '100px';
		    inner.style.width = '100%';
	
		    outer.appendChild(inner);
		    document.body.appendChild(outer);
	
		    var outerWidth = outer.clientWidth;
		    outer.style.overflowY = 'scroll';
		    var innerWidth = inner.clientWidth;
	
		    document.body.removeChild(outer);
	
		    size = outerWidth - innerWidth;
		  }
	
		  return size;
		}
	
		module.exports = getScrollbarSize;
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		function shallowCloneObject(obj) {
		  var result = {};
		  for (var k in obj) {
		    if (obj.hasOwnProperty(k)) {
		      result[k] = obj[k];
		    }
		  }
		  return result;
		}
	
		module.exports = shallowCloneObject;
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var isFunction = function isFunction(functionToCheck) {
		  var getType = {};
		  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
		};
	
		module.exports = isFunction;
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(193);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-cell.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-cell.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = undefined;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		exports.beginDrag = beginDrag;
		exports.publishDragSource = publishDragSource;
		exports.hover = hover;
		exports.drop = drop;
		exports.endDrag = endDrag;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _isArray = __webpack_require__(20);
	
		var _isArray2 = _interopRequireDefault(_isArray);
	
		var _isObject = __webpack_require__(29);
	
		var _isObject2 = _interopRequireDefault(_isObject);
	
		var _matchesType = __webpack_require__(105);
	
		var _matchesType2 = _interopRequireDefault(_matchesType);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var BEGIN_DRAG = exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
		var PUBLISH_DRAG_SOURCE = exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
		var HOVER = exports.HOVER = 'dnd-core/HOVER';
		var DROP = exports.DROP = 'dnd-core/DROP';
		var END_DRAG = exports.END_DRAG = 'dnd-core/END_DRAG';
	
		function beginDrag(sourceIds) {
		  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { publishSource: true, clientOffset: null };
		  var publishSource = options.publishSource,
		      clientOffset = options.clientOffset,
		      getSourceClientOffset = options.getSourceClientOffset;
	
		  (0, _invariant2.default)((0, _isArray2.default)(sourceIds), 'Expected sourceIds to be an array.');
	
		  var monitor = this.getMonitor();
		  var registry = this.getRegistry();
		  (0, _invariant2.default)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
	
		  for (var i = 0; i < sourceIds.length; i++) {
		    (0, _invariant2.default)(registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
		  }
	
		  var sourceId = null;
		  for (var _i = sourceIds.length - 1; _i >= 0; _i--) {
		    if (monitor.canDragSource(sourceIds[_i])) {
		      sourceId = sourceIds[_i];
		      break;
		    }
		  }
		  if (sourceId === null) {
		    return;
		  }
	
		  var sourceClientOffset = null;
		  if (clientOffset) {
		    (0, _invariant2.default)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
		    sourceClientOffset = getSourceClientOffset(sourceId);
		  }
	
		  var source = registry.getSource(sourceId);
		  var item = source.beginDrag(monitor, sourceId);
		  (0, _invariant2.default)((0, _isObject2.default)(item), 'Item must be an object.');
	
		  registry.pinSource(sourceId);
	
		  var itemType = registry.getSourceType(sourceId);
		  return {
		    type: BEGIN_DRAG,
		    itemType: itemType,
		    item: item,
		    sourceId: sourceId,
		    clientOffset: clientOffset,
		    sourceClientOffset: sourceClientOffset,
		    isSourcePublic: publishSource
		  };
		}
	
		function publishDragSource() {
		  var monitor = this.getMonitor();
		  if (!monitor.isDragging()) {
		    return;
		  }
	
		  return { type: PUBLISH_DRAG_SOURCE };
		}
	
		function hover(targetIdsArg) {
		  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		      _ref$clientOffset = _ref.clientOffset,
		      clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;
	
		  (0, _invariant2.default)((0, _isArray2.default)(targetIdsArg), 'Expected targetIds to be an array.');
		  var targetIds = targetIdsArg.slice(0);
	
		  var monitor = this.getMonitor();
		  var registry = this.getRegistry();
		  (0, _invariant2.default)(monitor.isDragging(), 'Cannot call hover while not dragging.');
		  (0, _invariant2.default)(!monitor.didDrop(), 'Cannot call hover after drop.');
	
		  // First check invariants.
		  for (var i = 0; i < targetIds.length; i++) {
		    var targetId = targetIds[i];
		    (0, _invariant2.default)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
	
		    var target = registry.getTarget(targetId);
		    (0, _invariant2.default)(target, 'Expected targetIds to be registered.');
		  }
	
		  var draggedItemType = monitor.getItemType();
	
		  // Remove those targetIds that don't match the targetType.  This
		  // fixes shallow isOver which would only be non-shallow because of
		  // non-matching targets.
		  for (var _i2 = targetIds.length - 1; _i2 >= 0; _i2--) {
		    var _targetId = targetIds[_i2];
		    var targetType = registry.getTargetType(_targetId);
		    if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
		      targetIds.splice(_i2, 1);
		    }
		  }
	
		  // Finally call hover on all matching targets.
		  for (var _i3 = 0; _i3 < targetIds.length; _i3++) {
		    var _targetId2 = targetIds[_i3];
		    var _target = registry.getTarget(_targetId2);
		    _target.hover(monitor, _targetId2);
		  }
	
		  return {
		    type: HOVER,
		    targetIds: targetIds,
		    clientOffset: clientOffset
		  };
		}
	
		function drop() {
		  var _this = this;
	
		  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
		  var monitor = this.getMonitor();
		  var registry = this.getRegistry();
		  (0, _invariant2.default)(monitor.isDragging(), 'Cannot call drop while not dragging.');
		  (0, _invariant2.default)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
	
		  var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
	
		  targetIds.reverse();
		  targetIds.forEach(function (targetId, index) {
		    var target = registry.getTarget(targetId);
	
		    var dropResult = target.drop(monitor, targetId);
		    (0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isObject2.default)(dropResult), 'Drop result must either be an object or undefined.');
		    if (typeof dropResult === 'undefined') {
		      dropResult = index === 0 ? {} : monitor.getDropResult();
		    }
	
		    _this.store.dispatch({
		      type: DROP,
		      dropResult: _extends({}, options, dropResult)
		    });
		  });
		}
	
		function endDrag() {
		  var monitor = this.getMonitor();
		  var registry = this.getRegistry();
		  (0, _invariant2.default)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
	
		  var sourceId = monitor.getSourceId();
		  var source = registry.getSource(sourceId, true);
		  source.endDrag(monitor, sourceId);
	
		  registry.unpinSource();
	
		  return { type: END_DRAG };
		}
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.addSource = addSource;
		exports.addTarget = addTarget;
		exports.removeSource = removeSource;
		exports.removeTarget = removeTarget;
		var ADD_SOURCE = exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
		var ADD_TARGET = exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
		var REMOVE_SOURCE = exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
		var REMOVE_TARGET = exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
	
		function addSource(sourceId) {
		  return {
		    type: ADD_SOURCE,
		    sourceId: sourceId
		  };
		}
	
		function addTarget(targetId) {
		  return {
		    type: ADD_TARGET,
		    targetId: targetId
		  };
		}
	
		function removeSource(sourceId) {
		  return {
		    type: REMOVE_SOURCE,
		    sourceId: sourceId
		  };
		}
	
		function removeTarget(targetId) {
		  return {
		    type: REMOVE_TARGET,
		    targetId: targetId
		  };
		}
	
	/***/ }),
	/* 41 */
	[1651, 46],
	/* 42 */
	[1660, 77, 305, 329],
	/* 43 */
	[1690, 314],
	/* 44 */
	[1697, 292, 306],
	/* 45 */
	[1774, 44],
	/* 46 */
	/***/ (function(module, exports) {
	
		/**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */
		function eq(value, other) {
		  return value === other || (value !== value && other !== other);
		}
	
		module.exports = eq;
	
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var isArrayLike = __webpack_require__(83),
		    isObjectLike = __webpack_require__(30);
	
		/**
		 * This method is like `_.isArrayLike` except that it also checks if `value`
		 * is an object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array-like object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArrayLikeObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLikeObject(document.body.children);
		 * // => true
		 *
		 * _.isArrayLikeObject('abc');
		 * // => false
		 *
		 * _.isArrayLikeObject(_.noop);
		 * // => false
		 */
		function isArrayLikeObject(value) {
		  return isObjectLike(value) && isArrayLike(value);
		}
	
		module.exports = isArrayLikeObject;
	
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _redux = __webpack_require__(396);
	
		var _reducers = __webpack_require__(354);
	
		var _reducers2 = _interopRequireDefault(_reducers);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = (0, _redux.createStore)(_reducers2.default);
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = checkDecoratorArguments;
		function checkDecoratorArguments(functionName, signature) {
		  if (false) {
		    for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i += 1) {
		      var arg = arguments.length <= i + 2 ? undefined : arguments[i + 2];
		      if (arg && arg.prototype && arg.prototype.render) {
		        console.error( // eslint-disable-line no-console
		        'You seem to be applying the arguments in the wrong order. ' + ('It should be ' + functionName + '(' + signature + ')(Component), not the other way around. ') + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
		        return;
		      }
		    }
		  }
		}
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/*!
		  Copyright (c) 2016 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/react-select
		*/
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
			value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _reactInputAutosize = __webpack_require__(377);
	
		var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
		var _classnames = __webpack_require__(51);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _utilsDefaultArrowRenderer = __webpack_require__(391);
	
		var _utilsDefaultArrowRenderer2 = _interopRequireDefault(_utilsDefaultArrowRenderer);
	
		var _utilsDefaultFilterOptions = __webpack_require__(139);
	
		var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);
	
		var _utilsDefaultMenuRenderer = __webpack_require__(140);
	
		var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);
	
		var _utilsDefaultClearRenderer = __webpack_require__(392);
	
		var _utilsDefaultClearRenderer2 = _interopRequireDefault(_utilsDefaultClearRenderer);
	
		var _Async = __webpack_require__(386);
	
		var _Async2 = _interopRequireDefault(_Async);
	
		var _AsyncCreatable = __webpack_require__(387);
	
		var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
		var _Creatable = __webpack_require__(388);
	
		var _Creatable2 = _interopRequireDefault(_Creatable);
	
		var _Option = __webpack_require__(389);
	
		var _Option2 = _interopRequireDefault(_Option);
	
		var _Value = __webpack_require__(390);
	
		var _Value2 = _interopRequireDefault(_Value);
	
		function stringifyValue(value) {
			var valueType = typeof value;
			if (valueType === 'string') {
				return value;
			} else if (valueType === 'object') {
				return JSON.stringify(value);
			} else if (valueType === 'number' || valueType === 'boolean') {
				return String(value);
			} else {
				return '';
			}
		}
	
		var stringOrNode = _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]);
	
		var instanceId = 1;
	
		var Select = _react2['default'].createClass({
	
			displayName: 'Select',
	
			propTypes: {
				addLabelText: _react2['default'].PropTypes.string, // placeholder displayed when you want to add a label on a multi-value input
				'aria-label': _react2['default'].PropTypes.string, // Aria label (for assistive tech)
				'aria-labelledby': _react2['default'].PropTypes.string, // HTML ID of an element that should be used as the label (for assistive tech)
				arrowRenderer: _react2['default'].PropTypes.func, // Create drop-down caret element
				autoBlur: _react2['default'].PropTypes.bool, // automatically blur the component when an option is selected
				autofocus: _react2['default'].PropTypes.bool, // autofocus the component on mount
				autosize: _react2['default'].PropTypes.bool, // whether to enable autosizing or not
				backspaceRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
				backspaceToRemoveMessage: _react2['default'].PropTypes.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
				className: _react2['default'].PropTypes.string, // className for the outer element
				clearAllText: stringOrNode, // title for the "clear" control when multi: true
				clearRenderer: _react2['default'].PropTypes.func, // create clearable x element
				clearValueText: stringOrNode, // title for the "clear" control
				clearable: _react2['default'].PropTypes.bool, // should it be possible to reset value
				deleteRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
				delimiter: _react2['default'].PropTypes.string, // delimiter to use to join multiple values for the hidden field value
				disabled: _react2['default'].PropTypes.bool, // whether the Select is disabled or not
				escapeClearsValue: _react2['default'].PropTypes.bool, // whether escape clears the value when the menu is closed
				filterOption: _react2['default'].PropTypes.func, // method to filter a single option (option, filterString)
				filterOptions: _react2['default'].PropTypes.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
				ignoreAccents: _react2['default'].PropTypes.bool, // whether to strip diacritics when filtering
				ignoreCase: _react2['default'].PropTypes.bool, // whether to perform case-insensitive filtering
				inputProps: _react2['default'].PropTypes.object, // custom attributes for the Input
				inputRenderer: _react2['default'].PropTypes.func, // returns a custom input component
				instanceId: _react2['default'].PropTypes.string, // set the components instanceId
				isLoading: _react2['default'].PropTypes.bool, // whether the Select is loading externally or not (such as options being loaded)
				joinValues: _react2['default'].PropTypes.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
				labelKey: _react2['default'].PropTypes.string, // path of the label value in option objects
				matchPos: _react2['default'].PropTypes.string, // (any|start) match the start or entire string when filtering
				matchProp: _react2['default'].PropTypes.string, // (any|label|value) which option property to filter on
				menuBuffer: _react2['default'].PropTypes.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
				menuContainerStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu container
				menuRenderer: _react2['default'].PropTypes.func, // renders a custom menu with options
				menuStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu
				multi: _react2['default'].PropTypes.bool, // multi-value input
				name: _react2['default'].PropTypes.string, // generates a hidden <input /> tag with this field name for html forms
				noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
				onBlur: _react2['default'].PropTypes.func, // onBlur handler: function (event) {}
				onBlurResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared on blur
				onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
				onClose: _react2['default'].PropTypes.func, // fires when the menu is closed
				onCloseResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared when menu is closed through the arrow
				onFocus: _react2['default'].PropTypes.func, // onFocus handler: function (event) {}
				onInputChange: _react2['default'].PropTypes.func, // onInputChange handler: function (inputValue) {}
				onInputKeyDown: _react2['default'].PropTypes.func, // input keyDown handler: function (event) {}
				onMenuScrollToBottom: _react2['default'].PropTypes.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
				onOpen: _react2['default'].PropTypes.func, // fires when the menu is opened
				onValueClick: _react2['default'].PropTypes.func, // onClick handler for value labels: function (value, event) {}
				openAfterFocus: _react2['default'].PropTypes.bool, // boolean to enable opening dropdown when focused
				openOnFocus: _react2['default'].PropTypes.bool, // always open options menu on focus
				optionClassName: _react2['default'].PropTypes.string, // additional class(es) to apply to the <Option /> elements
				optionComponent: _react2['default'].PropTypes.func, // option component to render in dropdown
				optionRenderer: _react2['default'].PropTypes.func, // optionRenderer: function (option) {}
				options: _react2['default'].PropTypes.array, // array of options
				pageSize: _react2['default'].PropTypes.number, // number of entries to page when using page up/down keys
				placeholder: stringOrNode, // field placeholder, displayed when there's no value
				required: _react2['default'].PropTypes.bool, // applies HTML5 required attribute when needed
				resetValue: _react2['default'].PropTypes.any, // value to use when you clear the control
				scrollMenuIntoView: _react2['default'].PropTypes.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
				searchable: _react2['default'].PropTypes.bool, // whether to enable searching feature or not
				simpleValue: _react2['default'].PropTypes.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
				style: _react2['default'].PropTypes.object, // optional style to apply to the control
				tabIndex: _react2['default'].PropTypes.string, // optional tab index of the control
				tabSelectsValue: _react2['default'].PropTypes.bool, // whether to treat tabbing out while focused to be value selection
				value: _react2['default'].PropTypes.any, // initial field value
				valueComponent: _react2['default'].PropTypes.func, // value component to render
				valueKey: _react2['default'].PropTypes.string, // path of the label value in option objects
				valueRenderer: _react2['default'].PropTypes.func, // valueRenderer: function (option) {}
				wrapperStyle: _react2['default'].PropTypes.object },
	
			// optional style to apply to the component wrapper
			statics: { Async: _Async2['default'], AsyncCreatable: _AsyncCreatable2['default'], Creatable: _Creatable2['default'] },
	
			getDefaultProps: function getDefaultProps() {
				return {
					addLabelText: 'Add "{label}"?',
					arrowRenderer: _utilsDefaultArrowRenderer2['default'],
					autosize: true,
					backspaceRemoves: true,
					backspaceToRemoveMessage: 'Press backspace to remove {label}',
					clearable: true,
					clearAllText: 'Clear all',
					clearRenderer: _utilsDefaultClearRenderer2['default'],
					clearValueText: 'Clear value',
					deleteRemoves: true,
					delimiter: ',',
					disabled: false,
					escapeClearsValue: true,
					filterOptions: _utilsDefaultFilterOptions2['default'],
					ignoreAccents: true,
					ignoreCase: true,
					inputProps: {},
					isLoading: false,
					joinValues: false,
					labelKey: 'label',
					matchPos: 'any',
					matchProp: 'any',
					menuBuffer: 0,
					menuRenderer: _utilsDefaultMenuRenderer2['default'],
					multi: false,
					noResultsText: 'No results found',
					onBlurResetsInput: true,
					onCloseResetsInput: true,
					openAfterFocus: false,
					optionComponent: _Option2['default'],
					pageSize: 5,
					placeholder: 'Select...',
					required: false,
					scrollMenuIntoView: true,
					searchable: true,
					simpleValue: false,
					tabSelectsValue: true,
					valueComponent: _Value2['default'],
					valueKey: 'value'
				};
			},
	
			getInitialState: function getInitialState() {
				return {
					inputValue: '',
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false,
					required: false
				};
			},
	
			componentWillMount: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: this.handleRequired(valueArray[0], this.props.multi)
					});
				}
			},
	
			componentDidMount: function componentDidMount() {
				if (this.props.autofocus) {
					this.focus();
				}
			},
	
			componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: this.handleRequired(valueArray[0], nextProps.multi)
					});
				}
			},
	
			componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
				if (nextState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(nextState.isOpen);
					var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
					handler && handler();
				}
			},
	
			componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = _reactDom2['default'].findDOMNode(this.focused);
					var menuNode = _reactDom2['default'].findDOMNode(this.menu);
					menuNode.scrollTop = focusedOptionNode.offsetTop;
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = _reactDom2['default'].findDOMNode(this.focused);
					var menuDOM = _reactDom2['default'].findDOMNode(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
			},
	
			componentWillUnmount: function componentWillUnmount() {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			},
	
			toggleTouchOutsideEvent: function toggleTouchOutsideEvent(enabled) {
				if (enabled) {
					if (!document.addEventListener && document.attachEvent) {
						document.attachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.addEventListener('touchstart', this.handleTouchOutside);
					}
				} else {
					if (!document.removeEventListener && document.detachEvent) {
						document.detachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.removeEventListener('touchstart', this.handleTouchOutside);
					}
				}
			},
	
			handleTouchOutside: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			},
	
			focus: function focus() {
				if (!this.input) return;
				this.input.focus();
	
				if (this.props.openAfterFocus) {
					this.setState({
						isOpen: true
					});
				}
			},
	
			blurInput: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			},
	
			handleTouchMove: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			},
	
			handleTouchStart: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			},
	
			handleTouchEnd: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			},
	
			handleTouchEndClearValue: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			},
	
			handleMouseDown: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					return;
				}
	
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: true,
						isPseudoFocused: false
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = true;
					this.focus();
				}
			},
	
			handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				if (!this.state.isOpen) {
					return;
				}
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			},
	
			handleMouseDownOnMenu: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			},
	
			closeMenu: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi,
						inputValue: ''
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi,
						inputValue: this.state.inputValue
					});
				}
				this.hasScrolledToOption = false;
			},
	
			handleInputFocus: function handleInputFocus(event) {
				if (this.props.disabled) return;
				var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
				this.setState({
					isFocused: true,
					isOpen: isOpen
				});
				this._openAfterFocus = false;
			},
	
			handleInputBlur: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = '';
				}
				this.setState(onBlurredState);
			},
	
			handleInputChange: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value && this.props.onInputChange) {
					var nextState = this.props.onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && typeof nextState !== 'object') {
						newInputValue = '' + nextState;
					}
				}
	
				this.setState({
					isOpen: true,
					isPseudoFocused: false,
					inputValue: newInputValue
				});
			},
	
			handleKeyDown: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						return;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							return;
						}
						this.selectFocusedOption();
						return;
					case 13:
						// enter
						if (!this.state.isOpen) return;
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 27:
						// escape
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 38:
						// up
						this.focusPreviousOption();
						break;
					case 40:
						// down
						this.focusNextOption();
						break;
					case 33:
						// page up
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							return;
						}
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							return;
						}
						this.focusStartOption();
						break;
					case 46:
						// backspace
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						return;
					default:
						return;
				}
				event.preventDefault();
			},
	
			handleValueClick: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			},
	
			handleMenuScroll: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
					this.props.onMenuScrollToBottom();
				}
			},
	
			handleRequired: function handleRequired(value, multi) {
				if (!value) return true;
				return multi ? value.length === 0 : Object.keys(value).length === 0;
			},
	
			getOptionLabel: function getOptionLabel(op) {
				return op[this.props.labelKey];
			},
	
			/**
		  * Turns a value into an array from the given options
		  * @param	{String|Number|Array}	value		- the value of the select input
		  * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
		  * @returns	{Array}	the value of the select represented in an array
		  */
			getValueArray: function getValueArray(value, nextProps) {
				var _this = this;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = typeof nextProps === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') value = value.split(props.delimiter);
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return _this.expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = this.expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			},
	
			/**
		  * Retrieve a value from the given options and valueKey
		  * @param	{String|Number|Array}	value	- the selected value(s)
		  * @param	{Object}		props	- the Select component's props (or nextProps)
		  */
			expandValue: function expandValue(value, props) {
				var valueType = typeof value;
				if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
				var options = props.options;
				var valueKey = props.valueKey;
	
				if (!options) return;
				for (var i = 0; i < options.length; i++) {
					if (options[i][valueKey] === value) return options[i];
				}
			},
	
			setValue: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (!this.props.onChange) return;
				if (this.props.required) {
					var required = this.handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				this.props.onChange(value);
			},
	
			selectValue: function selectValue(value) {
				var _this3 = this;
	
				//NOTE: update value in the callback to make sure the input value is empty so that there are no styling issues (Chrome had issue otherwise)
				this.hasScrolledToOption = false;
				if (this.props.multi) {
					this.setState({
						inputValue: '',
						focusedIndex: null
					}, function () {
						_this3.addValue(value);
					});
				} else {
					this.setState({
						isOpen: false,
						inputValue: '',
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			},
	
			addValue: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			},
	
			popValue: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(valueArray.slice(0, valueArray.length - 1));
			},
	
			removeValue: function removeValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i !== value;
				}));
				this.focus();
			},
	
			clearValue: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				event.stopPropagation();
				event.preventDefault();
				this.setValue(this.getResetValue());
				this.setState({
					isOpen: false,
					inputValue: ''
				}, this.focus);
			},
	
			getResetValue: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			},
	
			focusOption: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			},
	
			focusNextOption: function focusNextOption() {
				this.focusAdjacentOption('next');
			},
	
			focusPreviousOption: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			},
	
			focusPageUpOption: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			},
	
			focusPageDownOption: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			},
	
			focusStartOption: function focusStartOption() {
				this.focusAdjacentOption('start');
			},
	
			focusEndOption: function focusEndOption() {
				this.focusAdjacentOption('end');
			},
	
			focusAdjacentOption: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						inputValue: '',
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
					});
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var potentialIndex = focusedIndex + this.props.pageSize;
					if (potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			},
	
			getFocusedOption: function getFocusedOption() {
				return this._focusedOption;
			},
	
			getInputValue: function getInputValue() {
				return this.state.inputValue;
			},
	
			selectFocusedOption: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			},
	
			renderLoading: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2['default'].createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2['default'].createElement('span', { className: 'Select-loading' })
				);
			},
	
			renderValue: function renderValue(valueArray, isOpen) {
				var _this4 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					return !this.state.inputValue ? _react2['default'].createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2['default'].createElement(
							ValueComponent,
							{
								id: _this4._instancePrefix + '-value-' + i,
								instancePrefix: _this4._instancePrefix,
								disabled: _this4.props.disabled || value.clearableValue === false,
								key: 'value-' + i + '-' + value[_this4.props.valueKey],
								onClick: onClick,
								onRemove: _this4.removeValue,
								value: value
							},
							renderLabel(value, i),
							_react2['default'].createElement(
								'span',
								{ className: 'Select-aria-only' },
								' '
							)
						);
					});
				} else if (!this.state.inputValue) {
					if (isOpen) onClick = null;
					return _react2['default'].createElement(
						ValueComponent,
						{
							id: this._instancePrefix + '-value-item',
							disabled: this.props.disabled,
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			},
	
			renderInput: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this5 = this;
	
				var className = (0, _classnames2['default'])('Select-input', this.props.inputProps.className);
				var isOpen = !!this.state.isOpen;
	
				var ariaOwns = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				// TODO: Check how this project includes Object.assign()
				var inputProps = _extends({}, this.props.inputProps, {
					role: 'combobox',
					'aria-expanded': '' + isOpen,
					'aria-owns': ariaOwns,
					'aria-haspopup': '' + isOpen,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-label': this.props['aria-label'],
					className: className,
					tabIndex: this.props.tabIndex,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this5.input = _ref;
					},
					required: this.state.required,
					value: this.state.inputValue
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var _props$inputProps = this.props.inputProps;
					var inputClassName = _props$inputProps.inputClassName;
	
					var divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);
	
					return _react2['default'].createElement('div', _extends({}, divProps, {
						role: 'combobox',
						'aria-expanded': isOpen,
						'aria-owns': isOpen ? this._instancePrefix + '-list' : this._instancePrefix + '-value',
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						className: className,
						tabIndex: this.props.tabIndex || 0,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function (ref) {
							return _this5.input = ref;
						},
						'aria-readonly': '' + !!this.props.disabled,
						style: { border: 0, width: 1, display: 'inline-block' } }));
				}
	
				if (this.props.autosize) {
					return _react2['default'].createElement(_reactInputAutosize2['default'], _extends({}, inputProps, { minWidth: '5' }));
				}
				return _react2['default'].createElement(
					'div',
					{ className: className },
					_react2['default'].createElement('input', inputProps)
				);
			},
	
			renderClear: function renderClear() {
				if (!this.props.clearable || !this.props.value || this.props.value === 0 || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
				var clear = this.props.clearRenderer();
	
				return _react2['default'].createElement(
					'span',
					{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
						'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
						onMouseDown: this.clearValue,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEndClearValue
					},
					clear
				);
			},
	
			renderArrow: function renderArrow() {
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				return _react2['default'].createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			},
	
			filterOptions: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _utilsDefaultFilterOptions2['default'];
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			},
	
			onOptionRef: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			},
	
			renderMenu: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey,
						onOptionRef: this.onOptionRef
					});
				} else if (this.props.noResultsText) {
					return _react2['default'].createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			},
	
			renderHiddenField: function renderHiddenField(valueArray) {
				var _this6 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this6.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2['default'].createElement('input', {
						type: 'hidden',
						ref: function (ref) {
							return _this6.value = ref;
						},
						name: this.props.name,
						value: value,
						disabled: this.props.disabled });
				}
				return valueArray.map(function (item, index) {
					return _react2['default'].createElement('input', { key: 'hidden.' + index,
						type: 'hidden',
						ref: 'value' + index,
						name: _this6.props.name,
						value: stringifyValue(item[_this6.props.valueKey]),
						disabled: _this6.props.disabled });
				});
			},
	
			getFocusableOptionIndex: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = options.indexOf(focusedOption);
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			},
	
			renderOuter: function renderOuter(options, valueArray, focusedOption) {
				var _this7 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2['default'].createElement(
					'div',
					{ ref: function (ref) {
							return _this7.menuContainer = ref;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2['default'].createElement(
						'div',
						{ ref: function (ref) {
								return _this7.menu = ref;
							}, role: 'listbox', className: 'Select-menu', id: this._instancePrefix + '-list',
							style: this.props.menuStyle,
							onScroll: this.handleMenuScroll,
							onMouseDown: this.handleMouseDownOnMenu },
						menu
					)
				);
			},
	
			render: function render() {
				var _this8 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2['default'])('Select', this.props.className, {
					'Select--multi': this.props.multi,
					'Select--single': !this.props.multi,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'has-value': valueArray.length
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2['default'].createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2['default'].createElement(
					'div',
					{ ref: function (ref) {
							return _this8.wrapper = ref;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2['default'].createElement(
						'div',
						{ ref: function (ref) {
								return _this8.control = ref;
							},
							className: 'Select-control',
							style: this.props.style,
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchStart: this.handleTouchStart,
							onTouchMove: this.handleTouchMove
						},
						_react2['default'].createElement(
							'span',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
				);
			}
	
		});
	
		exports['default'] = Select;
		module.exports = exports['default'];
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		  Copyright (c) 2016 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
		/* global define */
	
		(function () {
			'use strict';
	
			var hasOwn = {}.hasOwnProperty;
	
			function classNames () {
				var classes = [];
	
				for (var i = 0; i < arguments.length; i++) {
					var arg = arguments[i];
					if (!arg) continue;
	
					var argType = typeof arg;
	
					if (argType === 'string' || argType === 'number') {
						classes.push(arg);
					} else if (Array.isArray(arg)) {
						classes.push(classNames.apply(null, arg));
					} else if (argType === 'object') {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					}
				}
	
				return classes.join(' ');
			}
	
			if (typeof module !== 'undefined' && module.exports) {
				module.exports = classNames;
			} else if (true) {
				// register as 'classnames', consistent with npm package name
				!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
					return classNames;
				}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			} else {
				window.classNames = classNames;
			}
		}());
	
	
	/***/ }),
	/* 52 */
	[1616, 464, 465, 466, 467, 468],
	/* 53 */
	[1640, 12],
	/* 54 */
	[1651, 155],
	/* 55 */
	[1690, 461],
	/* 56 */
	[1774, 21],
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var isSymbol = __webpack_require__(93);
	
		/** Used as references for various `Number` constants. */
		var INFINITY = 1 / 0;
	
		/**
		 * Converts `value` to a string key if it's not a string or symbol.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @returns {string|symbol} Returns the key.
		 */
		function toKey(value) {
		  if (typeof value == 'string' || isSymbol(value)) {
		    return value;
		  }
		  var result = (value + '');
		  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
		}
	
		module.exports = toKey;
	
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _keyMirror = __webpack_require__(199);
	
		var _keyMirror2 = _interopRequireDefault(_keyMirror);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var constants = {
		  UpdateActions: (0, _keyMirror2['default'])({
		    CELL_UPDATE: null,
		    COLUMN_FILL: null,
		    COPY_PASTE: null,
		    CELL_DRAG: null
		  }),
		  DragItemTypes: {
		    Column: 'column'
		  }
		};
	
		module.exports = constants;
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _underscore = __webpack_require__(97);
	
		var _underscore2 = _interopRequireDefault(_underscore);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var EditorContainer = __webpack_require__(181);
		var ExcelColumn = __webpack_require__(11);
		var isFunction = __webpack_require__(37);
		var CellMetaDataShape = __webpack_require__(14);
		var SimpleCellFormatter = __webpack_require__(184);
		var ColumnUtils = __webpack_require__(10);
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(38);
	
		// The list of the propTypes that we want to include in the Cell div
		var knownDivPropertyKeys = ['height', 'tabIndex', 'value'];
	
		var Cell = React.createClass({
		  displayName: 'Cell',
	
	
		  propTypes: {
		    rowIdx: React.PropTypes.number.isRequired,
		    idx: React.PropTypes.number.isRequired,
		    selected: React.PropTypes.shape({
		      idx: React.PropTypes.number.isRequired
		    }),
		    selectedColumn: React.PropTypes.object,
		    height: React.PropTypes.number,
		    tabIndex: React.PropTypes.number,
		    column: React.PropTypes.shape(ExcelColumn).isRequired,
		    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number, React.PropTypes.object, React.PropTypes.bool]).isRequired,
		    isExpanded: React.PropTypes.bool,
		    isRowSelected: React.PropTypes.bool,
		    cellMetaData: React.PropTypes.shape(CellMetaDataShape).isRequired,
		    handleDragStart: React.PropTypes.func,
		    className: React.PropTypes.string,
		    cellControls: React.PropTypes.any,
		    rowData: React.PropTypes.object.isRequired,
		    forceUpdate: React.PropTypes.bool,
		    expandableOptions: React.PropTypes.object.isRequired,
		    isScrolling: React.PropTypes.bool.isRequired,
		    tooltip: React.PropTypes.string,
		    isCellValueChanging: React.PropTypes.func
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      tabIndex: -1,
		      isExpanded: false,
		      value: '',
		      isCellValueChanging: function isCellValueChanging(value, nextValue) {
		        return value !== nextValue;
		      }
		    };
		  },
		  getInitialState: function getInitialState() {
		    return {
		      isCellValueChanging: false
		    };
		  },
		  componentDidMount: function componentDidMount() {
		    this.checkFocus();
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    this.setState({
		      isCellValueChanging: this.props.isCellValueChanging(this.props.value, nextProps.value)
		    });
		  },
		  componentDidUpdate: function componentDidUpdate() {
		    this.checkFocus();
		    var dragged = this.props.cellMetaData.dragged;
		    if (dragged && dragged.complete === true) {
		      this.props.cellMetaData.handleTerminateDrag();
		    }
		    if (this.state.isCellValueChanging && this.props.selectedColumn != null) {
		      this.applyUpdateClass();
		    }
		  },
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    var shouldUpdate = this.props.column.width !== nextProps.column.width || this.props.column.left !== nextProps.column.left || this.props.column.cellClass !== nextProps.column.cellClass || this.props.height !== nextProps.height || this.props.rowIdx !== nextProps.rowIdx || this.isCellSelectionChanging(nextProps) || this.isDraggedCellChanging(nextProps) || this.isCopyCellChanging(nextProps) || this.props.isRowSelected !== nextProps.isRowSelected || this.isSelected() || this.props.isCellValueChanging(this.props.value, nextProps.value) || this.props.forceUpdate === true || this.props.className !== nextProps.className || this.hasChangedDependentValues(nextProps);
		    return shouldUpdate;
		  },
		  onCellClick: function onCellClick(e) {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellClick && typeof meta.onCellClick === 'function') {
		      meta.onCellClick({ rowIdx: this.props.rowIdx, idx: this.props.idx }, e);
		    }
		  },
		  onCellContextMenu: function onCellContextMenu() {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellContextMenu && typeof meta.onCellContextMenu === 'function') {
		      meta.onCellContextMenu({ rowIdx: this.props.rowIdx, idx: this.props.idx });
		    }
		  },
		  onCellDoubleClick: function onCellDoubleClick(e) {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellDoubleClick && typeof meta.onCellDoubleClick === 'function') {
		      meta.onCellDoubleClick({ rowIdx: this.props.rowIdx, idx: this.props.idx }, e);
		    }
		  },
		  onCellExpand: function onCellExpand(e) {
		    e.stopPropagation();
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellExpand != null) {
		      meta.onCellExpand({ rowIdx: this.props.rowIdx, idx: this.props.idx, rowData: this.props.rowData, expandArgs: this.props.expandableOptions });
		    }
		  },
		  onCellKeyDown: function onCellKeyDown(e) {
		    if (this.canExpand() && e.key === 'Enter') {
		      this.onCellExpand(e);
		    }
		  },
		  onDragHandleDoubleClick: function onDragHandleDoubleClick(e) {
		    e.stopPropagation();
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onDragHandleDoubleClick && typeof meta.onDragHandleDoubleClick === 'function') {
		      meta.onDragHandleDoubleClick({ rowIdx: this.props.rowIdx, idx: this.props.idx, rowData: this.getRowData(), e: e });
		    }
		  },
		  onDragOver: function onDragOver(e) {
		    e.preventDefault();
		  },
		  getStyle: function getStyle() {
		    var style = {
		      position: 'absolute',
		      width: this.props.column.width,
		      height: this.props.height,
		      left: this.props.column.left,
		      contain: 'layout'
		    };
		    return style;
		  },
		  getFormatter: function getFormatter() {
		    var col = this.props.column;
		    if (this.isActive()) {
		      return React.createElement(EditorContainer, { rowData: this.getRowData(), rowIdx: this.props.rowIdx, value: this.props.value, idx: this.props.idx, cellMetaData: this.props.cellMetaData, column: col, height: this.props.height });
		    }
	
		    return this.props.column.formatter;
		  },
		  getRowData: function getRowData() {
		    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
		    return props.rowData.toJSON ? props.rowData.toJSON() : props.rowData;
		  },
		  getFormatterDependencies: function getFormatterDependencies() {
		    // convention based method to get corresponding Id or Name of any Name or Id property
		    if (typeof this.props.column.getRowMetaData === 'function') {
		      return this.props.column.getRowMetaData(this.getRowData(), this.props.column);
		    }
		  },
		  getCellClass: function getCellClass() {
		    var className = joinClasses(this.props.column.cellClass, 'react-grid-Cell', this.props.className, this.props.column.locked ? 'react-grid-Cell--locked' : null);
		    var extraClasses = joinClasses({
		      'row-selected': this.props.isRowSelected,
		      editing: this.isActive(),
		      copied: this.isCopied() || this.wasDraggedOver() || this.isDraggedOverUpwards() || this.isDraggedOverDownwards(),
		      'is-dragged-over-up': this.isDraggedOverUpwards(),
		      'is-dragged-over-down': this.isDraggedOverDownwards(),
		      'was-dragged-over': this.wasDraggedOver(),
		      'cell-tooltip': this.props.tooltip ? true : false
		    });
		    return joinClasses(className, extraClasses);
		  },
		  getUpdateCellClass: function getUpdateCellClass() {
		    return this.props.column.getUpdateCellClass ? this.props.column.getUpdateCellClass(this.props.selectedColumn, this.props.column, this.state.isCellValueChanging) : '';
		  },
		  isColumnSelected: function isColumnSelected() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
	
		    return meta.selected && meta.selected.idx === this.props.idx;
		  },
		  isSelected: function isSelected() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
	
		    return meta.selected && meta.selected.rowIdx === this.props.rowIdx && meta.selected.idx === this.props.idx;
		  },
		  isActive: function isActive() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
		    return this.isSelected() && meta.selected.active === true;
		  },
		  isCellSelectionChanging: function isCellSelectionChanging(nextProps) {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
		    var nextSelected = nextProps.cellMetaData.selected;
		    if (meta.selected && nextSelected) {
		      return this.props.idx === nextSelected.idx || this.props.idx === meta.selected.idx;
		    }
	
		    return true;
		  },
		  isCellSelectEnabled: function isCellSelectEnabled() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
		    return meta.enableCellSelect;
		  },
		  hasChangedDependentValues: function hasChangedDependentValues(nextProps) {
		    var currentColumn = this.props.column;
		    var hasChangedDependentValues = false;
	
		    if (currentColumn.getRowMetaData) {
		      var currentRowMetaData = currentColumn.getRowMetaData(this.getRowData(), currentColumn);
		      var nextColumn = nextProps.column;
		      var nextRowMetaData = nextColumn.getRowMetaData(this.getRowData(nextProps), nextColumn);
	
		      hasChangedDependentValues = !_underscore2['default'].isEqual(currentRowMetaData, nextRowMetaData);
		    }
	
		    return hasChangedDependentValues;
		  },
		  applyUpdateClass: function applyUpdateClass() {
		    var updateCellClass = this.getUpdateCellClass();
		    // -> removing the class
		    if (updateCellClass != null && updateCellClass !== '') {
		      var cellDOMNode = ReactDOM.findDOMNode(this);
		      if (cellDOMNode.classList) {
		        cellDOMNode.classList.remove(updateCellClass);
		        // -> and re-adding the class
		        cellDOMNode.classList.add(updateCellClass);
		      } else if (cellDOMNode.className.indexOf(updateCellClass) === -1) {
		        // IE9 doesn't support classList, nor (I think) altering element.className
		        // without replacing it wholesale.
		        cellDOMNode.className = cellDOMNode.className + ' ' + updateCellClass;
		      }
		    }
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var ctrl = this; // flow on windows has an outdated react declaration, once that gets updated, we can remove this
		    if (ctrl.isMounted()) {
		      var node = ReactDOM.findDOMNode(this);
		      if (node) {
		        var transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		        node.style.webkitTransform = transform;
		        node.style.transform = transform;
		      }
		    }
		  },
		  isCopied: function isCopied() {
		    var copied = this.props.cellMetaData.copied;
		    return copied && copied.rowIdx === this.props.rowIdx && copied.idx === this.props.idx;
		  },
		  isDraggedOver: function isDraggedOver() {
		    var dragged = this.props.cellMetaData.dragged;
		    return dragged && dragged.overRowIdx === this.props.rowIdx && dragged.idx === this.props.idx;
		  },
		  wasDraggedOver: function wasDraggedOver() {
		    var dragged = this.props.cellMetaData.dragged;
		    return dragged && (dragged.overRowIdx < this.props.rowIdx && this.props.rowIdx < dragged.rowIdx || dragged.overRowIdx > this.props.rowIdx && this.props.rowIdx > dragged.rowIdx) && dragged.idx === this.props.idx;
		  },
		  isDraggedCellChanging: function isDraggedCellChanging(nextProps) {
		    var isChanging = void 0;
		    var dragged = this.props.cellMetaData.dragged;
		    var nextDragged = nextProps.cellMetaData.dragged;
		    if (dragged) {
		      isChanging = nextDragged && this.props.idx === nextDragged.idx || dragged && this.props.idx === dragged.idx;
		      return isChanging;
		    }
	
		    return false;
		  },
		  isCopyCellChanging: function isCopyCellChanging(nextProps) {
		    var isChanging = void 0;
		    var copied = this.props.cellMetaData.copied;
		    var nextCopied = nextProps.cellMetaData.copied;
		    if (copied) {
		      isChanging = nextCopied && this.props.idx === nextCopied.idx || copied && this.props.idx === copied.idx;
		      return isChanging;
		    }
		    return false;
		  },
		  isDraggedOverUpwards: function isDraggedOverUpwards() {
		    var dragged = this.props.cellMetaData.dragged;
		    return !this.isSelected() && this.isDraggedOver() && this.props.rowIdx < dragged.rowIdx;
		  },
		  isDraggedOverDownwards: function isDraggedOverDownwards() {
		    var dragged = this.props.cellMetaData.dragged;
		    return !this.isSelected() && this.isDraggedOver() && this.props.rowIdx > dragged.rowIdx;
		  },
		  isFocusedOnBody: function isFocusedOnBody() {
		    return document.activeElement == null || document.activeElement.nodeName && typeof document.activeElement.nodeName === 'string' && document.activeElement.nodeName.toLowerCase() === 'body';
		  },
		  isFocusedOnCell: function isFocusedOnCell() {
		    return document.activeElement && document.activeElement.className === 'react-grid-Cell';
		  },
		  checkFocus: function checkFocus() {
		    if (this.isSelected() && !this.isActive()) {
		      if (this.props.isScrolling && !this.props.cellMetaData.isScrollingVerticallyWithKeyboard && !this.props.cellMetaData.isScrollingHorizontallyWithKeyboard) {
		        return;
		      }
		      // Only focus to the current cell if the currently active node in the document is within the data grid.
		      // Meaning focus should not be stolen from elements that the grid doesnt control.
		      var dataGridDOMNode = this.props.cellMetaData && this.props.cellMetaData.getDataGridDOMNode ? this.props.cellMetaData.getDataGridDOMNode() : null;
		      if (this.isFocusedOnCell() || this.isFocusedOnBody() || dataGridDOMNode && dataGridDOMNode.contains(document.activeElement)) {
		        var cellDOMNode = ReactDOM.findDOMNode(this);
		        if (cellDOMNode) {
		          cellDOMNode.focus();
		        }
		      }
		    }
		  },
		  canEdit: function canEdit() {
		    return this.props.column.editor != null || this.props.column.editable;
		  },
		  canExpand: function canExpand() {
		    return this.props.expandableOptions && this.props.expandableOptions.canExpand;
		  },
		  createColumEventCallBack: function createColumEventCallBack(onColumnEvent, info) {
		    return function (e) {
		      onColumnEvent(e, info);
		    };
		  },
		  createCellEventCallBack: function createCellEventCallBack(gridEvent, columnEvent) {
		    return function (e) {
		      gridEvent(e);
		      columnEvent(e);
		    };
		  },
		  createEventDTO: function createEventDTO(gridEvents, columnEvents, onColumnEvent) {
		    var allEvents = Object.assign({}, gridEvents);
	
		    for (var eventKey in columnEvents) {
		      if (columnEvents.hasOwnProperty(eventKey)) {
		        var event = columnEvents[event];
		        var eventInfo = { rowIdx: this.props.rowIdx, idx: this.props.idx, name: eventKey };
		        var eventCallback = this.createColumEventCallBack(onColumnEvent, eventInfo);
	
		        if (allEvents.hasOwnProperty(eventKey)) {
		          var currentEvent = allEvents[eventKey];
		          allEvents[eventKey] = this.createCellEventCallBack(currentEvent, eventCallback);
		        } else {
		          allEvents[eventKey] = eventCallback;
		        }
		      }
		    }
	
		    return allEvents;
		  },
		  getEvents: function getEvents() {
		    var columnEvents = this.props.column ? Object.assign({}, this.props.column.events) : undefined;
		    var onColumnEvent = this.props.cellMetaData ? this.props.cellMetaData.onColumnEvent : undefined;
		    var gridEvents = {
		      onClick: this.onCellClick,
		      onDoubleClick: this.onCellDoubleClick,
		      onContextMenu: this.onCellContextMenu,
		      onDragOver: this.onDragOver
		    };
	
		    if (!columnEvents || !onColumnEvent) {
		      return gridEvents;
		    }
	
		    return this.createEventDTO(gridEvents, columnEvents, onColumnEvent);
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  renderCellContent: function renderCellContent(props) {
		    var CellContent = void 0;
		    var Formatter = this.getFormatter();
		    if (React.isValidElement(Formatter)) {
		      props.dependentValues = this.getFormatterDependencies();
		      CellContent = React.cloneElement(Formatter, props);
		    } else if (isFunction(Formatter)) {
		      CellContent = React.createElement(Formatter, { value: this.props.value, dependentValues: this.getFormatterDependencies() });
		    } else {
		      CellContent = React.createElement(SimpleCellFormatter, { value: this.props.value });
		    }
		    var cellExpander = void 0;
		    var marginLeft = this.props.expandableOptions ? this.props.expandableOptions.treeDepth * 30 : 0;
		    if (this.canExpand()) {
		      cellExpander = React.createElement(
		        'span',
		        { style: { float: 'left', marginLeft: marginLeft }, onClick: this.onCellExpand },
		        this.props.expandableOptions.expanded ? String.fromCharCode('9660') : String.fromCharCode('9658')
		      );
		    }
		    return React.createElement(
		      'div',
		      { className: 'react-grid-Cell__value' },
		      cellExpander,
		      React.createElement(
		        'span',
		        null,
		        CellContent
		      ),
		      ' ',
		      this.props.cellControls,
		      ' '
		    );
		  },
		  render: function render() {
		    if (this.props.column.hidden) {
		      return null;
		    }
	
		    var style = this.getStyle();
	
		    var className = this.getCellClass();
	
		    var cellContent = this.renderCellContent({
		      value: this.props.value,
		      column: this.props.column,
		      rowIdx: this.props.rowIdx,
		      isExpanded: this.props.isExpanded
		    });
	
		    var dragHandle = !this.isActive() && ColumnUtils.canEdit(this.props.column, this.props.rowData, this.props.cellMetaData.enableCellSelect) ? React.createElement(
		      'div',
		      { className: 'drag-handle', draggable: 'true', onDoubleClick: this.onDragHandleDoubleClick },
		      React.createElement('span', { style: { display: 'none' } })
		    ) : null;
		    var events = this.getEvents();
		    var tooltip = this.props.tooltip ? React.createElement(
		      'span',
		      { className: 'cell-tooltip-text' },
		      this.props.tooltip
		    ) : null;
	
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { className: className, style: style }, events),
		      cellContent,
		      dragHandle,
		      tooltip
		    );
		  }
		});
	
		module.exports = Cell;
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var ExcelColumn = __webpack_require__(11);
		var ResizeHandle = __webpack_require__(174);
		__webpack_require__(19);
	
		var PropTypes = React.PropTypes;
	
		function simpleCellRenderer(objArgs) {
		  var headerText = objArgs.column.rowType === 'header' ? objArgs.column.name : '';
		  return React.createElement(
		    'div',
		    { className: 'widget-HeaderCell__value' },
		    headerText
		  );
		}
	
		var HeaderCell = React.createClass({
		  displayName: 'HeaderCell',
	
	
		  propTypes: {
		    renderer: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
		    column: PropTypes.shape(ExcelColumn).isRequired,
		    onResize: PropTypes.func.isRequired,
		    height: PropTypes.number.isRequired,
		    onResizeEnd: PropTypes.func.isRequired,
		    className: PropTypes.string
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      renderer: simpleCellRenderer
		    };
		  },
		  getInitialState: function getInitialState() {
		    return { resizing: false };
		  },
		  onDragStart: function onDragStart(e) {
		    this.setState({ resizing: true });
		    // need to set dummy data for FF
		    if (e && e.dataTransfer && e.dataTransfer.setData) e.dataTransfer.setData('text/plain', 'dummy');
		  },
		  onDrag: function onDrag(e) {
		    var resize = this.props.onResize || null; // for flows sake, doesnt recognise a null check direct
		    if (resize) {
		      var _width = this.getWidthFromMouseEvent(e);
		      if (_width > 0) {
		        resize(this.props.column, _width);
		      }
		    }
		  },
		  onDragEnd: function onDragEnd(e) {
		    var width = this.getWidthFromMouseEvent(e);
		    this.props.onResizeEnd(this.props.column, width);
		    this.setState({ resizing: false });
		  },
		  getWidthFromMouseEvent: function getWidthFromMouseEvent(e) {
		    var right = e.pageX || e.touches && e.touches[0] && e.touches[0].pageX || e.changedTouches && e.changedTouches[e.changedTouches.length - 1].pageX;
		    var left = ReactDOM.findDOMNode(this).getBoundingClientRect().left;
		    return right - left;
		  },
		  getCell: function getCell() {
		    if (React.isValidElement(this.props.renderer)) {
		      // if it is a string, it's an HTML element, and column is not a valid property, so only pass height
		      if (typeof this.props.renderer.type === 'string') {
		        return React.cloneElement(this.props.renderer, { height: this.props.height });
		      }
		      return React.cloneElement(this.props.renderer, { column: this.props.column, height: this.props.height });
		    }
		    return this.props.renderer({ column: this.props.column });
		  },
		  getStyle: function getStyle() {
		    return {
		      width: this.props.column.width,
		      left: this.props.column.left,
		      display: 'inline-block',
		      position: 'absolute',
		      height: this.props.height,
		      margin: 0,
		      textOverflow: 'ellipsis',
		      whiteSpace: 'nowrap'
		    };
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var node = ReactDOM.findDOMNode(this);
		    node.style.webkitTransform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		    node.style.transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		  },
		  removeScroll: function removeScroll() {
		    var node = ReactDOM.findDOMNode(this);
		    if (node) {
		      var transform = 'none';
		      node.style.webkitTransform = transform;
		      node.style.transform = transform;
		    }
		  },
		  render: function render() {
		    var resizeHandle = void 0;
		    if (this.props.column.resizable) {
		      resizeHandle = React.createElement(ResizeHandle, {
		        onDrag: this.onDrag,
		        onDragStart: this.onDragStart,
		        onDragEnd: this.onDragEnd
		      });
		    }
		    var className = joinClasses({
		      'react-grid-HeaderCell': true,
		      'react-grid-HeaderCell--resizing': this.state.resizing,
		      'react-grid-HeaderCell--locked': this.props.column.locked
		    });
		    className = joinClasses(className, this.props.className, this.props.column.cellClass);
		    var cell = this.getCell();
		    return React.createElement(
		      'div',
		      { className: className, style: this.getStyle() },
		      cell,
		      resizeHandle
		    );
		  }
		});
	
		module.exports = HeaderCell;
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var KeyboardHandlerMixin = {
		  onKeyDown: function onKeyDown(e) {
		    if (this.isCtrlKeyHeldDown(e)) {
		      this.checkAndCall('onPressKeyWithCtrl', e);
		    } else if (this.isKeyExplicitlyHandled(e.key)) {
		      // break up individual keyPress events to have their own specific callbacks
		      // this allows multiple mixins to listen to onKeyDown events and somewhat reduces methodName clashing
		      var callBack = 'onPress' + e.key;
		      this.checkAndCall(callBack, e);
		    } else if (this.isKeyPrintable(e.keyCode)) {
		      this.checkAndCall('onPressChar', e);
		    }
	
		    // Track which keys are currently down for shift clicking etc
		    this._keysDown = this._keysDown || {};
		    this._keysDown[e.keyCode] = true;
		    if (this.props.onGridKeyDown && typeof this.props.onGridKeyDown === 'function') {
		      this.props.onGridKeyDown(e);
		    }
		  },
		  onKeyUp: function onKeyUp(e) {
		    // Track which keys are currently down for shift clicking etc
		    this._keysDown = this._keysDown || {};
		    delete this._keysDown[e.keyCode];
	
		    if (this.props.onGridKeyUp && typeof this.props.onGridKeyUp === 'function') {
		      this.props.onGridKeyUp(e);
		    }
		  },
		  isKeyDown: function isKeyDown(keyCode) {
		    if (!this._keysDown) return false;
		    return keyCode in this._keysDown;
		  },
		  isSingleKeyDown: function isSingleKeyDown(keyCode) {
		    if (!this._keysDown) return false;
		    return keyCode in this._keysDown && Object.keys(this._keysDown).length === 1;
		  },
	
	
		  // taken from http://stackoverflow.com/questions/12467240/determine-if-javascript-e-keycode-is-a-printable-non-control-character
		  isKeyPrintable: function isKeyPrintable(keycode) {
		    var valid = keycode > 47 && keycode < 58 || // number keys
		    keycode === 32 || keycode === 13 || // spacebar & return key(s) (if you want to allow carriage returns)
		    keycode > 64 && keycode < 91 || // letter keys
		    keycode > 95 && keycode < 112 || // numpad keys
		    keycode > 185 && keycode < 193 || // ;=,-./` (in order)
		    keycode > 218 && keycode < 223; // [\]' (in order)
	
		    return valid;
		  },
		  isKeyExplicitlyHandled: function isKeyExplicitlyHandled(key) {
		    return typeof this['onPress' + key] === 'function';
		  },
		  isCtrlKeyHeldDown: function isCtrlKeyHeldDown(e) {
		    return e.ctrlKey === true && e.key !== 'Control';
		  },
		  checkAndCall: function checkAndCall(methodName, args) {
		    if (typeof this[methodName] === 'function') {
		      this[methodName](args);
		    }
		  }
		};
	
		module.exports = KeyboardHandlerMixin;
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.shouldRowUpdate = undefined;
	
		var _ColumnMetrics = __webpack_require__(33);
	
		var _ColumnMetrics2 = _interopRequireDefault(_ColumnMetrics);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function doesRowContainSelectedCell(props) {
		  var selected = props.cellMetaData.selected;
		  if (selected && selected.rowIdx === props.idx) {
		    return true;
		  }
		  return false;
		}
	
		function willRowBeDraggedOver(props) {
		  var dragged = props.cellMetaData.dragged;
		  return dragged != null && (dragged.rowIdx >= 0 || dragged.complete === true);
		}
	
		function hasRowBeenCopied(props) {
		  var copied = props.cellMetaData.copied;
		  return copied != null && copied.rowIdx === props.idx;
		}
	
		var shouldRowUpdate = exports.shouldRowUpdate = function shouldRowUpdate(nextProps, currentProps) {
		  return !_ColumnMetrics2['default'].sameColumns(currentProps.columns, nextProps.columns, _ColumnMetrics2['default'].sameColumn) || doesRowContainSelectedCell(currentProps) || doesRowContainSelectedCell(nextProps) || willRowBeDraggedOver(nextProps) || nextProps.row !== currentProps.row || currentProps.colDisplayStart !== nextProps.colDisplayStart || currentProps.colDisplayEnd !== nextProps.colDisplayEnd || currentProps.colVisibleStart !== nextProps.colVisibleStart || currentProps.colVisibleEnd !== nextProps.colVisibleEnd || hasRowBeenCopied(currentProps) || currentProps.isSelected !== nextProps.isSelected || nextProps.height !== currentProps.height || currentProps.isOver !== nextProps.isOver || currentProps.canDrop !== nextProps.canDrop || currentProps.forceUpdate === true;
		};
	
		exports['default'] = shouldRowUpdate;
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var RowUtils = {
		  get: function get(row, property) {
		    if (typeof row.get === 'function') {
		      return row.get(property);
		    }
	
		    return row[property];
		  },
		  isRowSelected: function isRowSelected(keys, indexes, isSelectedKey, rowData, rowIdx) {
		    if (indexes && Object.prototype.toString.call(indexes) === '[object Array]') {
		      return indexes.indexOf(rowIdx) > -1;
		    } else if (keys && keys.rowKey && keys.values && Object.prototype.toString.call(keys.values) === '[object Array]') {
		      return keys.values.indexOf(rowData[keys.rowKey]) > -1;
		    } else if (isSelectedKey && rowData && typeof isSelectedKey === 'string') {
		      return rowData[isSelectedKey];
		    }
		    return false;
		  }
		};
	
		module.exports = RowUtils;
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.SimpleRowsContainer = undefined;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SimpleRowsContainer = function SimpleRowsContainer(props) {
		  return _react2['default'].createElement(
		    'div',
		    { key: 'rows-container' },
		    props.rows
		  );
		};
	
		SimpleRowsContainer.propTypes = {
		  width: _react.PropTypes.number,
		  rows: _react.PropTypes.array
		};
	
		var RowsContainer = function (_React$Component) {
		  _inherits(RowsContainer, _React$Component);
	
		  function RowsContainer(props) {
		    _classCallCheck(this, RowsContainer);
	
		    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
		    _this.plugins = props.window ? props.window.ReactDataGridPlugins : window.ReactDataGridPlugins;
		    _this.hasContextMenu = _this.hasContextMenu.bind(_this);
		    _this.renderRowsWithContextMenu = _this.renderRowsWithContextMenu.bind(_this);
		    _this.getContextMenuContainer = _this.getContextMenuContainer.bind(_this);
		    _this.state = { ContextMenuContainer: _this.getContextMenuContainer(props) };
		    return _this;
		  }
	
		  RowsContainer.prototype.getContextMenuContainer = function getContextMenuContainer() {
		    if (this.hasContextMenu()) {
		      if (!this.plugins) {
		        throw new Error('You need to include ReactDataGrid UiPlugins in order to initialise context menu');
		      }
		      return this.plugins.Menu.ContextMenuLayer('reactDataGridContextMenu')(SimpleRowsContainer);
		    }
		  };
	
		  RowsContainer.prototype.hasContextMenu = function hasContextMenu() {
		    return this.props.contextMenu && _react2['default'].isValidElement(this.props.contextMenu);
		  };
	
		  RowsContainer.prototype.renderRowsWithContextMenu = function renderRowsWithContextMenu() {
		    var ContextMenuRowsContainer = this.state.ContextMenuContainer;
		    var newProps = { rowIdx: this.props.rowIdx, idx: this.props.idx };
		    var contextMenu = _react2['default'].cloneElement(this.props.contextMenu, newProps);
		    // Initialise the context menu if it is available
		    return _react2['default'].createElement(
		      'div',
		      null,
		      _react2['default'].createElement(ContextMenuRowsContainer, this.props),
		      contextMenu
		    );
		  };
	
		  RowsContainer.prototype.render = function render() {
		    return this.hasContextMenu() ? this.renderRowsWithContextMenu() : _react2['default'].createElement(SimpleRowsContainer, this.props);
		  };
	
		  return RowsContainer;
		}(_react2['default'].Component);
	
		RowsContainer.propTypes = {
		  contextMenu: _react.PropTypes.element,
		  rowIdx: _react.PropTypes.number,
		  idx: _react.PropTypes.number,
		  window: _react.PropTypes.object
		};
	
		exports['default'] = RowsContainer;
		exports.SimpleRowsContainer = SimpleRowsContainer;
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		__webpack_require__(72);
	
		var CheckboxEditor = React.createClass({
		  displayName: 'CheckboxEditor',
	
	
		  propTypes: {
		    value: React.PropTypes.bool,
		    rowIdx: React.PropTypes.number,
		    column: React.PropTypes.shape({
		      key: React.PropTypes.string,
		      onCellChange: React.PropTypes.func
		    }),
		    dependentValues: React.PropTypes.object
		  },
	
		  handleChange: function handleChange(e) {
		    this.props.column.onCellChange(this.props.rowIdx, this.props.column.key, this.props.dependentValues, e);
		  },
		  render: function render() {
		    var checked = this.props.value != null ? this.props.value : false;
		    var checkboxName = 'checkbox' + this.props.rowIdx;
		    return React.createElement(
		      'div',
		      { className: 'react-grid-checkbox-container checkbox-align', onClick: this.handleChange },
		      React.createElement('input', { className: 'react-grid-checkbox', type: 'checkbox', name: checkboxName, checked: checked }),
		      React.createElement('label', { htmlFor: checkboxName, className: 'react-grid-checkbox-label' })
		    );
		  }
		});
	
		module.exports = CheckboxEditor;
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var ExcelColumn = __webpack_require__(11);
	
		var EditorBase = function (_React$Component) {
		  _inherits(EditorBase, _React$Component);
	
		  function EditorBase() {
		    _classCallCheck(this, EditorBase);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  EditorBase.prototype.getStyle = function getStyle() {
		    return {
		      width: '100%'
		    };
		  };
	
		  EditorBase.prototype.getValue = function getValue() {
		    var updated = {};
		    updated[this.props.column.key] = this.getInputNode().value;
		    return updated;
		  };
	
		  EditorBase.prototype.getInputNode = function getInputNode() {
		    var domNode = ReactDOM.findDOMNode(this);
		    if (domNode.tagName === 'INPUT') {
		      return domNode;
		    }
	
		    return domNode.querySelector('input:not([type=hidden])');
		  };
	
		  EditorBase.prototype.inheritContainerStyles = function inheritContainerStyles() {
		    return true;
		  };
	
		  return EditorBase;
		}(React.Component);
	
		EditorBase.propTypes = {
		  onKeyDown: React.PropTypes.func.isRequired,
		  value: React.PropTypes.any.isRequired,
		  onBlur: React.PropTypes.func.isRequired,
		  column: React.PropTypes.shape(ExcelColumn).isRequired,
		  commit: React.PropTypes.func.isRequired
		};
	
		module.exports = EditorBase;
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var React = __webpack_require__(2);
		var EditorBase = __webpack_require__(66);
	
		var SimpleTextEditor = function (_EditorBase) {
		  _inherits(SimpleTextEditor, _EditorBase);
	
		  function SimpleTextEditor() {
		    _classCallCheck(this, SimpleTextEditor);
	
		    return _possibleConstructorReturn(this, _EditorBase.apply(this, arguments));
		  }
	
		  SimpleTextEditor.prototype.render = function render() {
		    var _this2 = this;
	
		    return React.createElement('input', { ref: function ref(node) {
		        return _this2.input = node;
		      }, type: 'text', onBlur: this.props.onBlur, className: 'form-control', defaultValue: this.props.value });
		  };
	
		  return SimpleTextEditor;
		}(EditorBase);
	
		module.exports = SimpleTextEditor;
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var _immutable = __webpack_require__(18);
	
		module.exports = {
		  isEmptyArray: __webpack_require__(188),
		  isEmptyObject: __webpack_require__(189),
		  isFunction: __webpack_require__(37),
		  isImmutableCollection: __webpack_require__(190),
		  getMixedTypeValueRetriever: __webpack_require__(192),
		  isColumnsImmutable: __webpack_require__(69),
		  isImmutableMap: __webpack_require__(191),
		  last: function last(arrayOrList) {
		    if (arrayOrList == null) {
		      throw new Error('arrayOrCollection is null');
		    }
	
		    if (_immutable.List.isList(arrayOrList)) {
		      return arrayOrList.last();
		    }
	
		    if (Array.isArray(arrayOrList)) {
		      return arrayOrList[arrayOrList.length - 1];
		    }
	
		    throw new Error('Cant get last of: ' + (typeof arrayOrList === 'undefined' ? 'undefined' : _typeof(arrayOrList)));
		  }
		};
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		module.exports = function isColumnsImmutable(columns) {
		  return typeof Immutable !== 'undefined' && columns instanceof Immutable.List;
		};
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @providesModule shallowEqual
		 * @typechecks
		 * 
		 */
	
		'use strict';
	
		var hasOwnProperty = Object.prototype.hasOwnProperty;
	
		/**
		 * Performs equality by iterating through keys on an object and returning false
		 * when any key has values which are not strictly equal between the arguments.
		 * Returns true when the values of all keys are strictly equal.
		 */
		function shallowEqual(objA, objB) {
		  if (objA === objB) {
		    return true;
		  }
	
		  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
		    return false;
		  }
	
		  var keysA = Object.keys(objA);
		  var keysB = Object.keys(objB);
	
		  if (keysA.length !== keysB.length) {
		    return false;
		  }
	
		  // Test for A's keys different from B.
		  var bHasOwnProperty = hasOwnProperty.bind(objB);
		  for (var i = 0; i < keysA.length; i++) {
		    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
		      return false;
		    }
		  }
	
		  return true;
		}
	
		module.exports = shallowEqual;
	
	/***/ }),
	/* 71 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		function ToObject(val) {
			if (val == null) {
				throw new TypeError('Object.assign cannot be called with null or undefined');
			}
	
			return Object(val);
		}
	
		module.exports = Object.assign || function (target, source) {
			var from;
			var keys;
			var to = ToObject(target);
	
			for (var s = 1; s < arguments.length; s++) {
				from = arguments[s];
				keys = Object.keys(Object(from));
	
				for (var i = 0; i < keys.length; i++) {
					to[keys[i]] = from[keys[i]];
				}
			}
	
			return to;
		};
	
	
	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(194);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-checkbox.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-checkbox.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ }),
	/* 73 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		exports['default'] = isDisposable;
	
		function isDisposable(obj) {
		  return Boolean(obj && typeof obj.dispose === 'function');
		}
	
		module.exports = exports['default'];
	
	/***/ }),
	/* 74 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = ownerDocument;
		function ownerDocument(node) {
		  return node && node.ownerDocument || document;
		}
		module.exports = exports["default"];
	
	/***/ }),
	/* 75 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright 2015, Yahoo! Inc.
		 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
		 */
		'use strict';
	
		var REACT_STATICS = {
		    childContextTypes: true,
		    contextTypes: true,
		    defaultProps: true,
		    displayName: true,
		    getDefaultProps: true,
		    mixins: true,
		    propTypes: true,
		    type: true
		};
	
		var KNOWN_STATICS = {
		    name: true,
		    length: true,
		    prototype: true,
		    caller: true,
		    arguments: true,
		    arity: true
		};
	
		var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
		module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
		    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
		        var keys = Object.getOwnPropertyNames(sourceComponent);
	
		        /* istanbul ignore else */
		        if (isGetOwnPropertySymbolsAvailable) {
		            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
		        }
	
		        for (var i = 0; i < keys.length; ++i) {
		            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
		                try {
		                    targetComponent[keys[i]] = sourceComponent[keys[i]];
		                } catch (error) {
	
		                }
		            }
		        }
		    }
	
		    return targetComponent;
		};
	
	
	/***/ }),
	/* 76 */
	[1636, 108, 332, 333],
	/* 77 */
	[1640, 28],
	/* 78 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseIndexOf = __webpack_require__(288);
	
		/**
		 * A specialized version of `_.includes` for arrays without support for
		 * specifying an index to search from.
		 *
		 * @private
		 * @param {Array} [array] The array to inspect.
		 * @param {*} target The value to search for.
		 * @returns {boolean} Returns `true` if `target` is found, else `false`.
		 */
		function arrayIncludes(array, value) {
		  var length = array == null ? 0 : array.length;
		  return !!length && baseIndexOf(array, value, 0) > -1;
		}
	
		module.exports = arrayIncludes;
	
	
	/***/ }),
	/* 79 */
	/***/ (function(module, exports) {
	
		/**
		 * This function is like `arrayIncludes` except that it accepts a comparator.
		 *
		 * @private
		 * @param {Array} [array] The array to inspect.
		 * @param {*} target The value to search for.
		 * @param {Function} comparator The comparator invoked per element.
		 * @returns {boolean} Returns `true` if `target` is found, else `false`.
		 */
		function arrayIncludesWith(array, value, comparator) {
		  var index = -1,
		      length = array == null ? 0 : array.length;
	
		  while (++index < length) {
		    if (comparator(value, array[index])) {
		      return true;
		    }
		  }
		  return false;
		}
	
		module.exports = arrayIncludesWith;
	
	
	/***/ }),
	/* 80 */
	/***/ (function(module, exports) {
	
		/**
		 * A specialized version of `_.map` for arrays without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the new mapped array.
		 */
		function arrayMap(array, iteratee) {
		  var index = -1,
		      length = array == null ? 0 : array.length,
		      result = Array(length);
	
		  while (++index < length) {
		    result[index] = iteratee(array[index], index, array);
		  }
		  return result;
		}
	
		module.exports = arrayMap;
	
	
	/***/ }),
	/* 81 */
	/***/ (function(module, exports) {
	
		/**
		 * The base implementation of `_.unary` without support for storing metadata.
		 *
		 * @private
		 * @param {Function} func The function to cap arguments for.
		 * @returns {Function} Returns the new capped function.
		 */
		function baseUnary(func) {
		  return function(value) {
		    return func(value);
		  };
		}
	
		module.exports = baseUnary;
	
	
	/***/ }),
	/* 82 */
	/***/ (function(module, exports) {
	
		/**
		 * Checks if a `cache` value for `key` exists.
		 *
		 * @private
		 * @param {Object} cache The cache to query.
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function cacheHas(cache, key) {
		  return cache.has(key);
		}
	
		module.exports = cacheHas;
	
	
	/***/ }),
	/* 83 */
	[1795, 120, 121],
	/* 84 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _store = __webpack_require__(48);
	
		var _store2 = _interopRequireDefault(_store);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		    getItem: function getItem() {
		        return _store2.default.getState().currentItem;
		    },
		    getPosition: function getPosition() {
		        var _store$getState = _store2.default.getState();
	
		        var x = _store$getState.x;
		        var y = _store$getState.y;
	
	
		        return { x: x, y: y };
		    },
		    hideMenu: function hideMenu() {
		        _store2.default.dispatch({
		            type: "SET_PARAMS",
		            data: {
		                isVisible: false,
		                currentItem: {}
		            }
		        });
		    }
		}; /* eslint-disable object-property-newline */
	
	/***/ }),
	/* 85 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		var FILE = exports.FILE = '__NATIVE_FILE__';
		var URL = exports.URL = '__NATIVE_URL__';
		var TEXT = exports.TEXT = '__NATIVE_TEXT__';
	
	/***/ }),
	/* 86 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = shallowEqual;
		function shallowEqual(objA, objB) {
		  if (objA === objB) {
		    return true;
		  }
	
		  var keysA = Object.keys(objA);
		  var keysB = Object.keys(objB);
	
		  if (keysA.length !== keysB.length) {
		    return false;
		  }
	
		  // Test for A's keys different from B.
		  var hasOwn = Object.prototype.hasOwnProperty;
		  for (var i = 0; i < keysA.length; i += 1) {
		    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
		      return false;
		    }
	
		    var valA = objA[keysA[i]];
		    var valB = objB[keysA[i]];
	
		    if (valA !== valB) {
		      return false;
		    }
		  }
	
		  return true;
		}
	
	/***/ }),
	/* 87 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.ActionTypes = undefined;
		exports['default'] = createStore;
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		var _symbolObservable = __webpack_require__(403);
	
		var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		/**
		 * These are private action types reserved by Redux.
		 * For any unknown actions, you must return the current state.
		 * If the current state is undefined, you must return the initial state.
		 * Do not reference these action types directly in your code.
		 */
		var ActionTypes = exports.ActionTypes = {
		  INIT: '@@redux/INIT'
		};
	
		/**
		 * Creates a Redux store that holds the state tree.
		 * The only way to change the data in the store is to call `dispatch()` on it.
		 *
		 * There should only be a single store in your app. To specify how different
		 * parts of the state tree respond to actions, you may combine several reducers
		 * into a single reducer function by using `combineReducers`.
		 *
		 * @param {Function} reducer A function that returns the next state tree, given
		 * the current state tree and the action to handle.
		 *
		 * @param {any} [preloadedState] The initial state. You may optionally specify it
		 * to hydrate the state from the server in universal apps, or to restore a
		 * previously serialized user session.
		 * If you use `combineReducers` to produce the root reducer function, this must be
		 * an object with the same shape as `combineReducers` keys.
		 *
		 * @param {Function} enhancer The store enhancer. You may optionally specify it
		 * to enhance the store with third-party capabilities such as middleware,
		 * time travel, persistence, etc. The only store enhancer that ships with Redux
		 * is `applyMiddleware()`.
		 *
		 * @returns {Store} A Redux store that lets you read the state, dispatch actions
		 * and subscribe to changes.
		 */
		function createStore(reducer, preloadedState, enhancer) {
		  var _ref2;
	
		  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
		    enhancer = preloadedState;
		    preloadedState = undefined;
		  }
	
		  if (typeof enhancer !== 'undefined') {
		    if (typeof enhancer !== 'function') {
		      throw new Error('Expected the enhancer to be a function.');
		    }
	
		    return enhancer(createStore)(reducer, preloadedState);
		  }
	
		  if (typeof reducer !== 'function') {
		    throw new Error('Expected the reducer to be a function.');
		  }
	
		  var currentReducer = reducer;
		  var currentState = preloadedState;
		  var currentListeners = [];
		  var nextListeners = currentListeners;
		  var isDispatching = false;
	
		  function ensureCanMutateNextListeners() {
		    if (nextListeners === currentListeners) {
		      nextListeners = currentListeners.slice();
		    }
		  }
	
		  /**
		   * Reads the state tree managed by the store.
		   *
		   * @returns {any} The current state tree of your application.
		   */
		  function getState() {
		    return currentState;
		  }
	
		  /**
		   * Adds a change listener. It will be called any time an action is dispatched,
		   * and some part of the state tree may potentially have changed. You may then
		   * call `getState()` to read the current state tree inside the callback.
		   *
		   * You may call `dispatch()` from a change listener, with the following
		   * caveats:
		   *
		   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
		   * If you subscribe or unsubscribe while the listeners are being invoked, this
		   * will not have any effect on the `dispatch()` that is currently in progress.
		   * However, the next `dispatch()` call, whether nested or not, will use a more
		   * recent snapshot of the subscription list.
		   *
		   * 2. The listener should not expect to see all state changes, as the state
		   * might have been updated multiple times during a nested `dispatch()` before
		   * the listener is called. It is, however, guaranteed that all subscribers
		   * registered before the `dispatch()` started will be called with the latest
		   * state by the time it exits.
		   *
		   * @param {Function} listener A callback to be invoked on every dispatch.
		   * @returns {Function} A function to remove this change listener.
		   */
		  function subscribe(listener) {
		    if (typeof listener !== 'function') {
		      throw new Error('Expected listener to be a function.');
		    }
	
		    var isSubscribed = true;
	
		    ensureCanMutateNextListeners();
		    nextListeners.push(listener);
	
		    return function unsubscribe() {
		      if (!isSubscribed) {
		        return;
		      }
	
		      isSubscribed = false;
	
		      ensureCanMutateNextListeners();
		      var index = nextListeners.indexOf(listener);
		      nextListeners.splice(index, 1);
		    };
		  }
	
		  /**
		   * Dispatches an action. It is the only way to trigger a state change.
		   *
		   * The `reducer` function, used to create the store, will be called with the
		   * current state tree and the given `action`. Its return value will
		   * be considered the **next** state of the tree, and the change listeners
		   * will be notified.
		   *
		   * The base implementation only supports plain object actions. If you want to
		   * dispatch a Promise, an Observable, a thunk, or something else, you need to
		   * wrap your store creating function into the corresponding middleware. For
		   * example, see the documentation for the `redux-thunk` package. Even the
		   * middleware will eventually dispatch plain object actions using this method.
		   *
		   * @param {Object} action A plain object representing “what changed”. It is
		   * a good idea to keep actions serializable so you can record and replay user
		   * sessions, or use the time travelling `redux-devtools`. An action must have
		   * a `type` property which may not be `undefined`. It is a good idea to use
		   * string constants for action types.
		   *
		   * @returns {Object} For convenience, the same action object you dispatched.
		   *
		   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
		   * return something else (for example, a Promise you can await).
		   */
		  function dispatch(action) {
		    if (!(0, _isPlainObject2['default'])(action)) {
		      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
		    }
	
		    if (typeof action.type === 'undefined') {
		      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
		    }
	
		    if (isDispatching) {
		      throw new Error('Reducers may not dispatch actions.');
		    }
	
		    try {
		      isDispatching = true;
		      currentState = currentReducer(currentState, action);
		    } finally {
		      isDispatching = false;
		    }
	
		    var listeners = currentListeners = nextListeners;
		    for (var i = 0; i < listeners.length; i++) {
		      listeners[i]();
		    }
	
		    return action;
		  }
	
		  /**
		   * Replaces the reducer currently used by the store to calculate the state.
		   *
		   * You might need this if your app implements code splitting and you want to
		   * load some of the reducers dynamically. You might also need this if you
		   * implement a hot reloading mechanism for Redux.
		   *
		   * @param {Function} nextReducer The reducer for the store to use instead.
		   * @returns {void}
		   */
		  function replaceReducer(nextReducer) {
		    if (typeof nextReducer !== 'function') {
		      throw new Error('Expected the nextReducer to be a function.');
		    }
	
		    currentReducer = nextReducer;
		    dispatch({ type: ActionTypes.INIT });
		  }
	
		  /**
		   * Interoperability point for observable/reactive libraries.
		   * @returns {observable} A minimal observable of state changes.
		   * For more information, see the observable proposal:
		   * https://github.com/zenparsing/es-observable
		   */
		  function observable() {
		    var _ref;
	
		    var outerSubscribe = subscribe;
		    return _ref = {
		      /**
		       * The minimal observable subscription method.
		       * @param {Object} observer Any object that can be used as an observer.
		       * The observer object should have a `next` method.
		       * @returns {subscription} An object with an `unsubscribe` method that can
		       * be used to unsubscribe the observable from the store, and prevent further
		       * emission of values from the observable.
		       */
		      subscribe: function subscribe(observer) {
		        if (typeof observer !== 'object') {
		          throw new TypeError('Expected the observer to be an object.');
		        }
	
		        function observeState() {
		          if (observer.next) {
		            observer.next(getState());
		          }
		        }
	
		        observeState();
		        var unsubscribe = outerSubscribe(observeState);
		        return { unsubscribe: unsubscribe };
		      }
		    }, _ref[_symbolObservable2['default']] = function () {
		      return this;
		    }, _ref;
		  }
	
		  // When a store is created, an "INIT" action is dispatched so that every
		  // reducer returns their initial state. This effectively populates
		  // the initial state tree.
		  dispatch({ type: ActionTypes.INIT });
	
		  return _ref2 = {
		    dispatch: dispatch,
		    subscribe: subscribe,
		    getState: getState,
		    replaceReducer: replaceReducer
		  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
		}
	
	/***/ }),
	/* 88 */
	[1619, 21, 12],
	/* 89 */
	[1624, 469, 470, 471, 472, 473],
	/* 90 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var isArray = __webpack_require__(13),
		    isSymbol = __webpack_require__(93);
	
		/** Used to match property names within property paths. */
		var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
		    reIsPlainProp = /^\w*$/;
	
		/**
		 * Checks if `value` is a property name and not a property path.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {Object} [object] The object to query keys on.
		 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
		 */
		function isKey(value, object) {
		  if (isArray(value)) {
		    return false;
		  }
		  var type = typeof value;
		  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
		      value == null || isSymbol(value)) {
		    return true;
		  }
		  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
		    (object != null && value in Object(object));
		}
	
		module.exports = isKey;
	
	
	/***/ }),
	/* 91 */
	/***/ (function(module, exports) {
	
		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;
	
		/**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */
		function isLength(value) {
		  return typeof value == 'number' &&
		    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}
	
		module.exports = isLength;
	
	
	/***/ }),
	/* 92 */
	29,
	/* 93 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseGetTag = __webpack_require__(31),
		    isObjectLike = __webpack_require__(32);
	
		/** `Object#toString` result references. */
		var symbolTag = '[object Symbol]';
	
		/**
		 * Checks if `value` is classified as a `Symbol` primitive or object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
		 * @example
		 *
		 * _.isSymbol(Symbol.iterator);
		 * // => true
		 *
		 * _.isSymbol('abc');
		 * // => false
		 */
		function isSymbol(value) {
		  return typeof value == 'symbol' ||
		    (isObjectLike(value) && baseGetTag(value) == symbolTag);
		}
	
		module.exports = isSymbol;
	
	
	/***/ }),
	/* 94 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var arrayLikeKeys = __webpack_require__(416),
		    baseKeys = __webpack_require__(433),
		    isArrayLike = __webpack_require__(157);
	
		/**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */
		function keys(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
		}
	
		module.exports = keys;
	
	
	/***/ }),
	/* 95 */,
	/* 96 */,
	/* 97 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
		//     http://underscorejs.org
		//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
		//     Underscore may be freely distributed under the MIT license.
	
		(function() {
	
		  // Baseline setup
		  // --------------
	
		  // Establish the root object, `window` in the browser, or `exports` on the server.
		  var root = this;
	
		  // Save the previous value of the `_` variable.
		  var previousUnderscore = root._;
	
		  // Save bytes in the minified (but not gzipped) version:
		  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
		  // Create quick reference variables for speed access to core prototypes.
		  var
		    push             = ArrayProto.push,
		    slice            = ArrayProto.slice,
		    toString         = ObjProto.toString,
		    hasOwnProperty   = ObjProto.hasOwnProperty;
	
		  // All **ECMAScript 5** native function implementations that we hope to use
		  // are declared here.
		  var
		    nativeIsArray      = Array.isArray,
		    nativeKeys         = Object.keys,
		    nativeBind         = FuncProto.bind,
		    nativeCreate       = Object.create;
	
		  // Naked function reference for surrogate-prototype-swapping.
		  var Ctor = function(){};
	
		  // Create a safe reference to the Underscore object for use below.
		  var _ = function(obj) {
		    if (obj instanceof _) return obj;
		    if (!(this instanceof _)) return new _(obj);
		    this._wrapped = obj;
		  };
	
		  // Export the Underscore object for **Node.js**, with
		  // backwards-compatibility for the old `require()` API. If we're in
		  // the browser, add `_` as a global object.
		  if (true) {
		    if (typeof module !== 'undefined' && module.exports) {
		      exports = module.exports = _;
		    }
		    exports._ = _;
		  } else {
		    root._ = _;
		  }
	
		  // Current version.
		  _.VERSION = '1.8.3';
	
		  // Internal function that returns an efficient (for current engines) version
		  // of the passed-in callback, to be repeatedly applied in other Underscore
		  // functions.
		  var optimizeCb = function(func, context, argCount) {
		    if (context === void 0) return func;
		    switch (argCount == null ? 3 : argCount) {
		      case 1: return function(value) {
		        return func.call(context, value);
		      };
		      case 2: return function(value, other) {
		        return func.call(context, value, other);
		      };
		      case 3: return function(value, index, collection) {
		        return func.call(context, value, index, collection);
		      };
		      case 4: return function(accumulator, value, index, collection) {
		        return func.call(context, accumulator, value, index, collection);
		      };
		    }
		    return function() {
		      return func.apply(context, arguments);
		    };
		  };
	
		  // A mostly-internal function to generate callbacks that can be applied
		  // to each element in a collection, returning the desired result — either
		  // identity, an arbitrary callback, a property matcher, or a property accessor.
		  var cb = function(value, context, argCount) {
		    if (value == null) return _.identity;
		    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
		    if (_.isObject(value)) return _.matcher(value);
		    return _.property(value);
		  };
		  _.iteratee = function(value, context) {
		    return cb(value, context, Infinity);
		  };
	
		  // An internal function for creating assigner functions.
		  var createAssigner = function(keysFunc, undefinedOnly) {
		    return function(obj) {
		      var length = arguments.length;
		      if (length < 2 || obj == null) return obj;
		      for (var index = 1; index < length; index++) {
		        var source = arguments[index],
		            keys = keysFunc(source),
		            l = keys.length;
		        for (var i = 0; i < l; i++) {
		          var key = keys[i];
		          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
		        }
		      }
		      return obj;
		    };
		  };
	
		  // An internal function for creating a new object that inherits from another.
		  var baseCreate = function(prototype) {
		    if (!_.isObject(prototype)) return {};
		    if (nativeCreate) return nativeCreate(prototype);
		    Ctor.prototype = prototype;
		    var result = new Ctor;
		    Ctor.prototype = null;
		    return result;
		  };
	
		  var property = function(key) {
		    return function(obj) {
		      return obj == null ? void 0 : obj[key];
		    };
		  };
	
		  // Helper for collection methods to determine whether a collection
		  // should be iterated as an array or as an object
		  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
		  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
		  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
		  var getLength = property('length');
		  var isArrayLike = function(collection) {
		    var length = getLength(collection);
		    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
		  };
	
		  // Collection Functions
		  // --------------------
	
		  // The cornerstone, an `each` implementation, aka `forEach`.
		  // Handles raw objects in addition to array-likes. Treats all
		  // sparse array-likes as if they were dense.
		  _.each = _.forEach = function(obj, iteratee, context) {
		    iteratee = optimizeCb(iteratee, context);
		    var i, length;
		    if (isArrayLike(obj)) {
		      for (i = 0, length = obj.length; i < length; i++) {
		        iteratee(obj[i], i, obj);
		      }
		    } else {
		      var keys = _.keys(obj);
		      for (i = 0, length = keys.length; i < length; i++) {
		        iteratee(obj[keys[i]], keys[i], obj);
		      }
		    }
		    return obj;
		  };
	
		  // Return the results of applying the iteratee to each element.
		  _.map = _.collect = function(obj, iteratee, context) {
		    iteratee = cb(iteratee, context);
		    var keys = !isArrayLike(obj) && _.keys(obj),
		        length = (keys || obj).length,
		        results = Array(length);
		    for (var index = 0; index < length; index++) {
		      var currentKey = keys ? keys[index] : index;
		      results[index] = iteratee(obj[currentKey], currentKey, obj);
		    }
		    return results;
		  };
	
		  // Create a reducing function iterating left or right.
		  function createReduce(dir) {
		    // Optimized iterator function as using arguments.length
		    // in the main function will deoptimize the, see #1991.
		    function iterator(obj, iteratee, memo, keys, index, length) {
		      for (; index >= 0 && index < length; index += dir) {
		        var currentKey = keys ? keys[index] : index;
		        memo = iteratee(memo, obj[currentKey], currentKey, obj);
		      }
		      return memo;
		    }
	
		    return function(obj, iteratee, memo, context) {
		      iteratee = optimizeCb(iteratee, context, 4);
		      var keys = !isArrayLike(obj) && _.keys(obj),
		          length = (keys || obj).length,
		          index = dir > 0 ? 0 : length - 1;
		      // Determine the initial value if none is provided.
		      if (arguments.length < 3) {
		        memo = obj[keys ? keys[index] : index];
		        index += dir;
		      }
		      return iterator(obj, iteratee, memo, keys, index, length);
		    };
		  }
	
		  // **Reduce** builds up a single result from a list of values, aka `inject`,
		  // or `foldl`.
		  _.reduce = _.foldl = _.inject = createReduce(1);
	
		  // The right-associative version of reduce, also known as `foldr`.
		  _.reduceRight = _.foldr = createReduce(-1);
	
		  // Return the first value which passes a truth test. Aliased as `detect`.
		  _.find = _.detect = function(obj, predicate, context) {
		    var key;
		    if (isArrayLike(obj)) {
		      key = _.findIndex(obj, predicate, context);
		    } else {
		      key = _.findKey(obj, predicate, context);
		    }
		    if (key !== void 0 && key !== -1) return obj[key];
		  };
	
		  // Return all the elements that pass a truth test.
		  // Aliased as `select`.
		  _.filter = _.select = function(obj, predicate, context) {
		    var results = [];
		    predicate = cb(predicate, context);
		    _.each(obj, function(value, index, list) {
		      if (predicate(value, index, list)) results.push(value);
		    });
		    return results;
		  };
	
		  // Return all the elements for which a truth test fails.
		  _.reject = function(obj, predicate, context) {
		    return _.filter(obj, _.negate(cb(predicate)), context);
		  };
	
		  // Determine whether all of the elements match a truth test.
		  // Aliased as `all`.
		  _.every = _.all = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var keys = !isArrayLike(obj) && _.keys(obj),
		        length = (keys || obj).length;
		    for (var index = 0; index < length; index++) {
		      var currentKey = keys ? keys[index] : index;
		      if (!predicate(obj[currentKey], currentKey, obj)) return false;
		    }
		    return true;
		  };
	
		  // Determine if at least one element in the object matches a truth test.
		  // Aliased as `any`.
		  _.some = _.any = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var keys = !isArrayLike(obj) && _.keys(obj),
		        length = (keys || obj).length;
		    for (var index = 0; index < length; index++) {
		      var currentKey = keys ? keys[index] : index;
		      if (predicate(obj[currentKey], currentKey, obj)) return true;
		    }
		    return false;
		  };
	
		  // Determine if the array or object contains a given item (using `===`).
		  // Aliased as `includes` and `include`.
		  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
		    if (!isArrayLike(obj)) obj = _.values(obj);
		    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
		    return _.indexOf(obj, item, fromIndex) >= 0;
		  };
	
		  // Invoke a method (with arguments) on every item in a collection.
		  _.invoke = function(obj, method) {
		    var args = slice.call(arguments, 2);
		    var isFunc = _.isFunction(method);
		    return _.map(obj, function(value) {
		      var func = isFunc ? method : value[method];
		      return func == null ? func : func.apply(value, args);
		    });
		  };
	
		  // Convenience version of a common use case of `map`: fetching a property.
		  _.pluck = function(obj, key) {
		    return _.map(obj, _.property(key));
		  };
	
		  // Convenience version of a common use case of `filter`: selecting only objects
		  // containing specific `key:value` pairs.
		  _.where = function(obj, attrs) {
		    return _.filter(obj, _.matcher(attrs));
		  };
	
		  // Convenience version of a common use case of `find`: getting the first object
		  // containing specific `key:value` pairs.
		  _.findWhere = function(obj, attrs) {
		    return _.find(obj, _.matcher(attrs));
		  };
	
		  // Return the maximum element (or element-based computation).
		  _.max = function(obj, iteratee, context) {
		    var result = -Infinity, lastComputed = -Infinity,
		        value, computed;
		    if (iteratee == null && obj != null) {
		      obj = isArrayLike(obj) ? obj : _.values(obj);
		      for (var i = 0, length = obj.length; i < length; i++) {
		        value = obj[i];
		        if (value > result) {
		          result = value;
		        }
		      }
		    } else {
		      iteratee = cb(iteratee, context);
		      _.each(obj, function(value, index, list) {
		        computed = iteratee(value, index, list);
		        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
		          result = value;
		          lastComputed = computed;
		        }
		      });
		    }
		    return result;
		  };
	
		  // Return the minimum element (or element-based computation).
		  _.min = function(obj, iteratee, context) {
		    var result = Infinity, lastComputed = Infinity,
		        value, computed;
		    if (iteratee == null && obj != null) {
		      obj = isArrayLike(obj) ? obj : _.values(obj);
		      for (var i = 0, length = obj.length; i < length; i++) {
		        value = obj[i];
		        if (value < result) {
		          result = value;
		        }
		      }
		    } else {
		      iteratee = cb(iteratee, context);
		      _.each(obj, function(value, index, list) {
		        computed = iteratee(value, index, list);
		        if (computed < lastComputed || computed === Infinity && result === Infinity) {
		          result = value;
		          lastComputed = computed;
		        }
		      });
		    }
		    return result;
		  };
	
		  // Shuffle a collection, using the modern version of the
		  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
		  _.shuffle = function(obj) {
		    var set = isArrayLike(obj) ? obj : _.values(obj);
		    var length = set.length;
		    var shuffled = Array(length);
		    for (var index = 0, rand; index < length; index++) {
		      rand = _.random(0, index);
		      if (rand !== index) shuffled[index] = shuffled[rand];
		      shuffled[rand] = set[index];
		    }
		    return shuffled;
		  };
	
		  // Sample **n** random values from a collection.
		  // If **n** is not specified, returns a single random element.
		  // The internal `guard` argument allows it to work with `map`.
		  _.sample = function(obj, n, guard) {
		    if (n == null || guard) {
		      if (!isArrayLike(obj)) obj = _.values(obj);
		      return obj[_.random(obj.length - 1)];
		    }
		    return _.shuffle(obj).slice(0, Math.max(0, n));
		  };
	
		  // Sort the object's values by a criterion produced by an iteratee.
		  _.sortBy = function(obj, iteratee, context) {
		    iteratee = cb(iteratee, context);
		    return _.pluck(_.map(obj, function(value, index, list) {
		      return {
		        value: value,
		        index: index,
		        criteria: iteratee(value, index, list)
		      };
		    }).sort(function(left, right) {
		      var a = left.criteria;
		      var b = right.criteria;
		      if (a !== b) {
		        if (a > b || a === void 0) return 1;
		        if (a < b || b === void 0) return -1;
		      }
		      return left.index - right.index;
		    }), 'value');
		  };
	
		  // An internal function used for aggregate "group by" operations.
		  var group = function(behavior) {
		    return function(obj, iteratee, context) {
		      var result = {};
		      iteratee = cb(iteratee, context);
		      _.each(obj, function(value, index) {
		        var key = iteratee(value, index, obj);
		        behavior(result, value, key);
		      });
		      return result;
		    };
		  };
	
		  // Groups the object's values by a criterion. Pass either a string attribute
		  // to group by, or a function that returns the criterion.
		  _.groupBy = group(function(result, value, key) {
		    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
		  });
	
		  // Indexes the object's values by a criterion, similar to `groupBy`, but for
		  // when you know that your index values will be unique.
		  _.indexBy = group(function(result, value, key) {
		    result[key] = value;
		  });
	
		  // Counts instances of an object that group by a certain criterion. Pass
		  // either a string attribute to count by, or a function that returns the
		  // criterion.
		  _.countBy = group(function(result, value, key) {
		    if (_.has(result, key)) result[key]++; else result[key] = 1;
		  });
	
		  // Safely create a real, live array from anything iterable.
		  _.toArray = function(obj) {
		    if (!obj) return [];
		    if (_.isArray(obj)) return slice.call(obj);
		    if (isArrayLike(obj)) return _.map(obj, _.identity);
		    return _.values(obj);
		  };
	
		  // Return the number of elements in an object.
		  _.size = function(obj) {
		    if (obj == null) return 0;
		    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
		  };
	
		  // Split a collection into two arrays: one whose elements all satisfy the given
		  // predicate, and one whose elements all do not satisfy the predicate.
		  _.partition = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var pass = [], fail = [];
		    _.each(obj, function(value, key, obj) {
		      (predicate(value, key, obj) ? pass : fail).push(value);
		    });
		    return [pass, fail];
		  };
	
		  // Array Functions
		  // ---------------
	
		  // Get the first element of an array. Passing **n** will return the first N
		  // values in the array. Aliased as `head` and `take`. The **guard** check
		  // allows it to work with `_.map`.
		  _.first = _.head = _.take = function(array, n, guard) {
		    if (array == null) return void 0;
		    if (n == null || guard) return array[0];
		    return _.initial(array, array.length - n);
		  };
	
		  // Returns everything but the last entry of the array. Especially useful on
		  // the arguments object. Passing **n** will return all the values in
		  // the array, excluding the last N.
		  _.initial = function(array, n, guard) {
		    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
		  };
	
		  // Get the last element of an array. Passing **n** will return the last N
		  // values in the array.
		  _.last = function(array, n, guard) {
		    if (array == null) return void 0;
		    if (n == null || guard) return array[array.length - 1];
		    return _.rest(array, Math.max(0, array.length - n));
		  };
	
		  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
		  // Especially useful on the arguments object. Passing an **n** will return
		  // the rest N values in the array.
		  _.rest = _.tail = _.drop = function(array, n, guard) {
		    return slice.call(array, n == null || guard ? 1 : n);
		  };
	
		  // Trim out all falsy values from an array.
		  _.compact = function(array) {
		    return _.filter(array, _.identity);
		  };
	
		  // Internal implementation of a recursive `flatten` function.
		  var flatten = function(input, shallow, strict, startIndex) {
		    var output = [], idx = 0;
		    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
		      var value = input[i];
		      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
		        //flatten current level of array or arguments object
		        if (!shallow) value = flatten(value, shallow, strict);
		        var j = 0, len = value.length;
		        output.length += len;
		        while (j < len) {
		          output[idx++] = value[j++];
		        }
		      } else if (!strict) {
		        output[idx++] = value;
		      }
		    }
		    return output;
		  };
	
		  // Flatten out an array, either recursively (by default), or just one level.
		  _.flatten = function(array, shallow) {
		    return flatten(array, shallow, false);
		  };
	
		  // Return a version of the array that does not contain the specified value(s).
		  _.without = function(array) {
		    return _.difference(array, slice.call(arguments, 1));
		  };
	
		  // Produce a duplicate-free version of the array. If the array has already
		  // been sorted, you have the option of using a faster algorithm.
		  // Aliased as `unique`.
		  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
		    if (!_.isBoolean(isSorted)) {
		      context = iteratee;
		      iteratee = isSorted;
		      isSorted = false;
		    }
		    if (iteratee != null) iteratee = cb(iteratee, context);
		    var result = [];
		    var seen = [];
		    for (var i = 0, length = getLength(array); i < length; i++) {
		      var value = array[i],
		          computed = iteratee ? iteratee(value, i, array) : value;
		      if (isSorted) {
		        if (!i || seen !== computed) result.push(value);
		        seen = computed;
		      } else if (iteratee) {
		        if (!_.contains(seen, computed)) {
		          seen.push(computed);
		          result.push(value);
		        }
		      } else if (!_.contains(result, value)) {
		        result.push(value);
		      }
		    }
		    return result;
		  };
	
		  // Produce an array that contains the union: each distinct element from all of
		  // the passed-in arrays.
		  _.union = function() {
		    return _.uniq(flatten(arguments, true, true));
		  };
	
		  // Produce an array that contains every item shared between all the
		  // passed-in arrays.
		  _.intersection = function(array) {
		    var result = [];
		    var argsLength = arguments.length;
		    for (var i = 0, length = getLength(array); i < length; i++) {
		      var item = array[i];
		      if (_.contains(result, item)) continue;
		      for (var j = 1; j < argsLength; j++) {
		        if (!_.contains(arguments[j], item)) break;
		      }
		      if (j === argsLength) result.push(item);
		    }
		    return result;
		  };
	
		  // Take the difference between one array and a number of other arrays.
		  // Only the elements present in just the first array will remain.
		  _.difference = function(array) {
		    var rest = flatten(arguments, true, true, 1);
		    return _.filter(array, function(value){
		      return !_.contains(rest, value);
		    });
		  };
	
		  // Zip together multiple lists into a single array -- elements that share
		  // an index go together.
		  _.zip = function() {
		    return _.unzip(arguments);
		  };
	
		  // Complement of _.zip. Unzip accepts an array of arrays and groups
		  // each array's elements on shared indices
		  _.unzip = function(array) {
		    var length = array && _.max(array, getLength).length || 0;
		    var result = Array(length);
	
		    for (var index = 0; index < length; index++) {
		      result[index] = _.pluck(array, index);
		    }
		    return result;
		  };
	
		  // Converts lists into objects. Pass either a single array of `[key, value]`
		  // pairs, or two parallel arrays of the same length -- one of keys, and one of
		  // the corresponding values.
		  _.object = function(list, values) {
		    var result = {};
		    for (var i = 0, length = getLength(list); i < length; i++) {
		      if (values) {
		        result[list[i]] = values[i];
		      } else {
		        result[list[i][0]] = list[i][1];
		      }
		    }
		    return result;
		  };
	
		  // Generator function to create the findIndex and findLastIndex functions
		  function createPredicateIndexFinder(dir) {
		    return function(array, predicate, context) {
		      predicate = cb(predicate, context);
		      var length = getLength(array);
		      var index = dir > 0 ? 0 : length - 1;
		      for (; index >= 0 && index < length; index += dir) {
		        if (predicate(array[index], index, array)) return index;
		      }
		      return -1;
		    };
		  }
	
		  // Returns the first index on an array-like that passes a predicate test
		  _.findIndex = createPredicateIndexFinder(1);
		  _.findLastIndex = createPredicateIndexFinder(-1);
	
		  // Use a comparator function to figure out the smallest index at which
		  // an object should be inserted so as to maintain order. Uses binary search.
		  _.sortedIndex = function(array, obj, iteratee, context) {
		    iteratee = cb(iteratee, context, 1);
		    var value = iteratee(obj);
		    var low = 0, high = getLength(array);
		    while (low < high) {
		      var mid = Math.floor((low + high) / 2);
		      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
		    }
		    return low;
		  };
	
		  // Generator function to create the indexOf and lastIndexOf functions
		  function createIndexFinder(dir, predicateFind, sortedIndex) {
		    return function(array, item, idx) {
		      var i = 0, length = getLength(array);
		      if (typeof idx == 'number') {
		        if (dir > 0) {
		            i = idx >= 0 ? idx : Math.max(idx + length, i);
		        } else {
		            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
		        }
		      } else if (sortedIndex && idx && length) {
		        idx = sortedIndex(array, item);
		        return array[idx] === item ? idx : -1;
		      }
		      if (item !== item) {
		        idx = predicateFind(slice.call(array, i, length), _.isNaN);
		        return idx >= 0 ? idx + i : -1;
		      }
		      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
		        if (array[idx] === item) return idx;
		      }
		      return -1;
		    };
		  }
	
		  // Return the position of the first occurrence of an item in an array,
		  // or -1 if the item is not included in the array.
		  // If the array is large and already in sort order, pass `true`
		  // for **isSorted** to use binary search.
		  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
		  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
		  // Generate an integer Array containing an arithmetic progression. A port of
		  // the native Python `range()` function. See
		  // [the Python documentation](http://docs.python.org/library/functions.html#range).
		  _.range = function(start, stop, step) {
		    if (stop == null) {
		      stop = start || 0;
		      start = 0;
		    }
		    step = step || 1;
	
		    var length = Math.max(Math.ceil((stop - start) / step), 0);
		    var range = Array(length);
	
		    for (var idx = 0; idx < length; idx++, start += step) {
		      range[idx] = start;
		    }
	
		    return range;
		  };
	
		  // Function (ahem) Functions
		  // ------------------
	
		  // Determines whether to execute a function as a constructor
		  // or a normal function with the provided arguments
		  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
		    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
		    var self = baseCreate(sourceFunc.prototype);
		    var result = sourceFunc.apply(self, args);
		    if (_.isObject(result)) return result;
		    return self;
		  };
	
		  // Create a function bound to a given object (assigning `this`, and arguments,
		  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
		  // available.
		  _.bind = function(func, context) {
		    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
		    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
		    var args = slice.call(arguments, 2);
		    var bound = function() {
		      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
		    };
		    return bound;
		  };
	
		  // Partially apply a function by creating a version that has had some of its
		  // arguments pre-filled, without changing its dynamic `this` context. _ acts
		  // as a placeholder, allowing any combination of arguments to be pre-filled.
		  _.partial = function(func) {
		    var boundArgs = slice.call(arguments, 1);
		    var bound = function() {
		      var position = 0, length = boundArgs.length;
		      var args = Array(length);
		      for (var i = 0; i < length; i++) {
		        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
		      }
		      while (position < arguments.length) args.push(arguments[position++]);
		      return executeBound(func, bound, this, this, args);
		    };
		    return bound;
		  };
	
		  // Bind a number of an object's methods to that object. Remaining arguments
		  // are the method names to be bound. Useful for ensuring that all callbacks
		  // defined on an object belong to it.
		  _.bindAll = function(obj) {
		    var i, length = arguments.length, key;
		    if (length <= 1) throw new Error('bindAll must be passed function names');
		    for (i = 1; i < length; i++) {
		      key = arguments[i];
		      obj[key] = _.bind(obj[key], obj);
		    }
		    return obj;
		  };
	
		  // Memoize an expensive function by storing its results.
		  _.memoize = function(func, hasher) {
		    var memoize = function(key) {
		      var cache = memoize.cache;
		      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
		      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
		      return cache[address];
		    };
		    memoize.cache = {};
		    return memoize;
		  };
	
		  // Delays a function for the given number of milliseconds, and then calls
		  // it with the arguments supplied.
		  _.delay = function(func, wait) {
		    var args = slice.call(arguments, 2);
		    return setTimeout(function(){
		      return func.apply(null, args);
		    }, wait);
		  };
	
		  // Defers a function, scheduling it to run after the current call stack has
		  // cleared.
		  _.defer = _.partial(_.delay, _, 1);
	
		  // Returns a function, that, when invoked, will only be triggered at most once
		  // during a given window of time. Normally, the throttled function will run
		  // as much as it can, without ever going more than once per `wait` duration;
		  // but if you'd like to disable the execution on the leading edge, pass
		  // `{leading: false}`. To disable execution on the trailing edge, ditto.
		  _.throttle = function(func, wait, options) {
		    var context, args, result;
		    var timeout = null;
		    var previous = 0;
		    if (!options) options = {};
		    var later = function() {
		      previous = options.leading === false ? 0 : _.now();
		      timeout = null;
		      result = func.apply(context, args);
		      if (!timeout) context = args = null;
		    };
		    return function() {
		      var now = _.now();
		      if (!previous && options.leading === false) previous = now;
		      var remaining = wait - (now - previous);
		      context = this;
		      args = arguments;
		      if (remaining <= 0 || remaining > wait) {
		        if (timeout) {
		          clearTimeout(timeout);
		          timeout = null;
		        }
		        previous = now;
		        result = func.apply(context, args);
		        if (!timeout) context = args = null;
		      } else if (!timeout && options.trailing !== false) {
		        timeout = setTimeout(later, remaining);
		      }
		      return result;
		    };
		  };
	
		  // Returns a function, that, as long as it continues to be invoked, will not
		  // be triggered. The function will be called after it stops being called for
		  // N milliseconds. If `immediate` is passed, trigger the function on the
		  // leading edge, instead of the trailing.
		  _.debounce = function(func, wait, immediate) {
		    var timeout, args, context, timestamp, result;
	
		    var later = function() {
		      var last = _.now() - timestamp;
	
		      if (last < wait && last >= 0) {
		        timeout = setTimeout(later, wait - last);
		      } else {
		        timeout = null;
		        if (!immediate) {
		          result = func.apply(context, args);
		          if (!timeout) context = args = null;
		        }
		      }
		    };
	
		    return function() {
		      context = this;
		      args = arguments;
		      timestamp = _.now();
		      var callNow = immediate && !timeout;
		      if (!timeout) timeout = setTimeout(later, wait);
		      if (callNow) {
		        result = func.apply(context, args);
		        context = args = null;
		      }
	
		      return result;
		    };
		  };
	
		  // Returns the first function passed as an argument to the second,
		  // allowing you to adjust arguments, run code before and after, and
		  // conditionally execute the original function.
		  _.wrap = function(func, wrapper) {
		    return _.partial(wrapper, func);
		  };
	
		  // Returns a negated version of the passed-in predicate.
		  _.negate = function(predicate) {
		    return function() {
		      return !predicate.apply(this, arguments);
		    };
		  };
	
		  // Returns a function that is the composition of a list of functions, each
		  // consuming the return value of the function that follows.
		  _.compose = function() {
		    var args = arguments;
		    var start = args.length - 1;
		    return function() {
		      var i = start;
		      var result = args[start].apply(this, arguments);
		      while (i--) result = args[i].call(this, result);
		      return result;
		    };
		  };
	
		  // Returns a function that will only be executed on and after the Nth call.
		  _.after = function(times, func) {
		    return function() {
		      if (--times < 1) {
		        return func.apply(this, arguments);
		      }
		    };
		  };
	
		  // Returns a function that will only be executed up to (but not including) the Nth call.
		  _.before = function(times, func) {
		    var memo;
		    return function() {
		      if (--times > 0) {
		        memo = func.apply(this, arguments);
		      }
		      if (times <= 1) func = null;
		      return memo;
		    };
		  };
	
		  // Returns a function that will be executed at most one time, no matter how
		  // often you call it. Useful for lazy initialization.
		  _.once = _.partial(_.before, 2);
	
		  // Object Functions
		  // ----------------
	
		  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
		  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
		  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
		                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
		  function collectNonEnumProps(obj, keys) {
		    var nonEnumIdx = nonEnumerableProps.length;
		    var constructor = obj.constructor;
		    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
		    // Constructor is a special case.
		    var prop = 'constructor';
		    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
		    while (nonEnumIdx--) {
		      prop = nonEnumerableProps[nonEnumIdx];
		      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
		        keys.push(prop);
		      }
		    }
		  }
	
		  // Retrieve the names of an object's own properties.
		  // Delegates to **ECMAScript 5**'s native `Object.keys`
		  _.keys = function(obj) {
		    if (!_.isObject(obj)) return [];
		    if (nativeKeys) return nativeKeys(obj);
		    var keys = [];
		    for (var key in obj) if (_.has(obj, key)) keys.push(key);
		    // Ahem, IE < 9.
		    if (hasEnumBug) collectNonEnumProps(obj, keys);
		    return keys;
		  };
	
		  // Retrieve all the property names of an object.
		  _.allKeys = function(obj) {
		    if (!_.isObject(obj)) return [];
		    var keys = [];
		    for (var key in obj) keys.push(key);
		    // Ahem, IE < 9.
		    if (hasEnumBug) collectNonEnumProps(obj, keys);
		    return keys;
		  };
	
		  // Retrieve the values of an object's properties.
		  _.values = function(obj) {
		    var keys = _.keys(obj);
		    var length = keys.length;
		    var values = Array(length);
		    for (var i = 0; i < length; i++) {
		      values[i] = obj[keys[i]];
		    }
		    return values;
		  };
	
		  // Returns the results of applying the iteratee to each element of the object
		  // In contrast to _.map it returns an object
		  _.mapObject = function(obj, iteratee, context) {
		    iteratee = cb(iteratee, context);
		    var keys =  _.keys(obj),
		          length = keys.length,
		          results = {},
		          currentKey;
		      for (var index = 0; index < length; index++) {
		        currentKey = keys[index];
		        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
		      }
		      return results;
		  };
	
		  // Convert an object into a list of `[key, value]` pairs.
		  _.pairs = function(obj) {
		    var keys = _.keys(obj);
		    var length = keys.length;
		    var pairs = Array(length);
		    for (var i = 0; i < length; i++) {
		      pairs[i] = [keys[i], obj[keys[i]]];
		    }
		    return pairs;
		  };
	
		  // Invert the keys and values of an object. The values must be serializable.
		  _.invert = function(obj) {
		    var result = {};
		    var keys = _.keys(obj);
		    for (var i = 0, length = keys.length; i < length; i++) {
		      result[obj[keys[i]]] = keys[i];
		    }
		    return result;
		  };
	
		  // Return a sorted list of the function names available on the object.
		  // Aliased as `methods`
		  _.functions = _.methods = function(obj) {
		    var names = [];
		    for (var key in obj) {
		      if (_.isFunction(obj[key])) names.push(key);
		    }
		    return names.sort();
		  };
	
		  // Extend a given object with all the properties in passed-in object(s).
		  _.extend = createAssigner(_.allKeys);
	
		  // Assigns a given object with all the own properties in the passed-in object(s)
		  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
		  _.extendOwn = _.assign = createAssigner(_.keys);
	
		  // Returns the first key on an object that passes a predicate test
		  _.findKey = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var keys = _.keys(obj), key;
		    for (var i = 0, length = keys.length; i < length; i++) {
		      key = keys[i];
		      if (predicate(obj[key], key, obj)) return key;
		    }
		  };
	
		  // Return a copy of the object only containing the whitelisted properties.
		  _.pick = function(object, oiteratee, context) {
		    var result = {}, obj = object, iteratee, keys;
		    if (obj == null) return result;
		    if (_.isFunction(oiteratee)) {
		      keys = _.allKeys(obj);
		      iteratee = optimizeCb(oiteratee, context);
		    } else {
		      keys = flatten(arguments, false, false, 1);
		      iteratee = function(value, key, obj) { return key in obj; };
		      obj = Object(obj);
		    }
		    for (var i = 0, length = keys.length; i < length; i++) {
		      var key = keys[i];
		      var value = obj[key];
		      if (iteratee(value, key, obj)) result[key] = value;
		    }
		    return result;
		  };
	
		   // Return a copy of the object without the blacklisted properties.
		  _.omit = function(obj, iteratee, context) {
		    if (_.isFunction(iteratee)) {
		      iteratee = _.negate(iteratee);
		    } else {
		      var keys = _.map(flatten(arguments, false, false, 1), String);
		      iteratee = function(value, key) {
		        return !_.contains(keys, key);
		      };
		    }
		    return _.pick(obj, iteratee, context);
		  };
	
		  // Fill in a given object with default properties.
		  _.defaults = createAssigner(_.allKeys, true);
	
		  // Creates an object that inherits from the given prototype object.
		  // If additional properties are provided then they will be added to the
		  // created object.
		  _.create = function(prototype, props) {
		    var result = baseCreate(prototype);
		    if (props) _.extendOwn(result, props);
		    return result;
		  };
	
		  // Create a (shallow-cloned) duplicate of an object.
		  _.clone = function(obj) {
		    if (!_.isObject(obj)) return obj;
		    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
		  };
	
		  // Invokes interceptor with the obj, and then returns obj.
		  // The primary purpose of this method is to "tap into" a method chain, in
		  // order to perform operations on intermediate results within the chain.
		  _.tap = function(obj, interceptor) {
		    interceptor(obj);
		    return obj;
		  };
	
		  // Returns whether an object has a given set of `key:value` pairs.
		  _.isMatch = function(object, attrs) {
		    var keys = _.keys(attrs), length = keys.length;
		    if (object == null) return !length;
		    var obj = Object(object);
		    for (var i = 0; i < length; i++) {
		      var key = keys[i];
		      if (attrs[key] !== obj[key] || !(key in obj)) return false;
		    }
		    return true;
		  };
	
	
		  // Internal recursive comparison function for `isEqual`.
		  var eq = function(a, b, aStack, bStack) {
		    // Identical objects are equal. `0 === -0`, but they aren't identical.
		    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
		    if (a === b) return a !== 0 || 1 / a === 1 / b;
		    // A strict comparison is necessary because `null == undefined`.
		    if (a == null || b == null) return a === b;
		    // Unwrap any wrapped objects.
		    if (a instanceof _) a = a._wrapped;
		    if (b instanceof _) b = b._wrapped;
		    // Compare `[[Class]]` names.
		    var className = toString.call(a);
		    if (className !== toString.call(b)) return false;
		    switch (className) {
		      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
		      case '[object RegExp]':
		      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
		      case '[object String]':
		        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
		        // equivalent to `new String("5")`.
		        return '' + a === '' + b;
		      case '[object Number]':
		        // `NaN`s are equivalent, but non-reflexive.
		        // Object(NaN) is equivalent to NaN
		        if (+a !== +a) return +b !== +b;
		        // An `egal` comparison is performed for other numeric values.
		        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
		      case '[object Date]':
		      case '[object Boolean]':
		        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
		        // millisecond representations. Note that invalid dates with millisecond representations
		        // of `NaN` are not equivalent.
		        return +a === +b;
		    }
	
		    var areArrays = className === '[object Array]';
		    if (!areArrays) {
		      if (typeof a != 'object' || typeof b != 'object') return false;
	
		      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
		      // from different frames are.
		      var aCtor = a.constructor, bCtor = b.constructor;
		      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
		                               _.isFunction(bCtor) && bCtor instanceof bCtor)
		                          && ('constructor' in a && 'constructor' in b)) {
		        return false;
		      }
		    }
		    // Assume equality for cyclic structures. The algorithm for detecting cyclic
		    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
		    // Initializing stack of traversed objects.
		    // It's done here since we only need them for objects and arrays comparison.
		    aStack = aStack || [];
		    bStack = bStack || [];
		    var length = aStack.length;
		    while (length--) {
		      // Linear search. Performance is inversely proportional to the number of
		      // unique nested structures.
		      if (aStack[length] === a) return bStack[length] === b;
		    }
	
		    // Add the first object to the stack of traversed objects.
		    aStack.push(a);
		    bStack.push(b);
	
		    // Recursively compare objects and arrays.
		    if (areArrays) {
		      // Compare array lengths to determine if a deep comparison is necessary.
		      length = a.length;
		      if (length !== b.length) return false;
		      // Deep compare the contents, ignoring non-numeric properties.
		      while (length--) {
		        if (!eq(a[length], b[length], aStack, bStack)) return false;
		      }
		    } else {
		      // Deep compare objects.
		      var keys = _.keys(a), key;
		      length = keys.length;
		      // Ensure that both objects contain the same number of properties before comparing deep equality.
		      if (_.keys(b).length !== length) return false;
		      while (length--) {
		        // Deep compare each member
		        key = keys[length];
		        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
		      }
		    }
		    // Remove the first object from the stack of traversed objects.
		    aStack.pop();
		    bStack.pop();
		    return true;
		  };
	
		  // Perform a deep comparison to check if two objects are equal.
		  _.isEqual = function(a, b) {
		    return eq(a, b);
		  };
	
		  // Is a given array, string, or object empty?
		  // An "empty" object has no enumerable own-properties.
		  _.isEmpty = function(obj) {
		    if (obj == null) return true;
		    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
		    return _.keys(obj).length === 0;
		  };
	
		  // Is a given value a DOM element?
		  _.isElement = function(obj) {
		    return !!(obj && obj.nodeType === 1);
		  };
	
		  // Is a given value an array?
		  // Delegates to ECMA5's native Array.isArray
		  _.isArray = nativeIsArray || function(obj) {
		    return toString.call(obj) === '[object Array]';
		  };
	
		  // Is a given variable an object?
		  _.isObject = function(obj) {
		    var type = typeof obj;
		    return type === 'function' || type === 'object' && !!obj;
		  };
	
		  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
		  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
		    _['is' + name] = function(obj) {
		      return toString.call(obj) === '[object ' + name + ']';
		    };
		  });
	
		  // Define a fallback version of the method in browsers (ahem, IE < 9), where
		  // there isn't any inspectable "Arguments" type.
		  if (!_.isArguments(arguments)) {
		    _.isArguments = function(obj) {
		      return _.has(obj, 'callee');
		    };
		  }
	
		  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
		  // IE 11 (#1621), and in Safari 8 (#1929).
		  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
		    _.isFunction = function(obj) {
		      return typeof obj == 'function' || false;
		    };
		  }
	
		  // Is a given object a finite number?
		  _.isFinite = function(obj) {
		    return isFinite(obj) && !isNaN(parseFloat(obj));
		  };
	
		  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
		  _.isNaN = function(obj) {
		    return _.isNumber(obj) && obj !== +obj;
		  };
	
		  // Is a given value a boolean?
		  _.isBoolean = function(obj) {
		    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
		  };
	
		  // Is a given value equal to null?
		  _.isNull = function(obj) {
		    return obj === null;
		  };
	
		  // Is a given variable undefined?
		  _.isUndefined = function(obj) {
		    return obj === void 0;
		  };
	
		  // Shortcut function for checking if an object has a given property directly
		  // on itself (in other words, not on a prototype).
		  _.has = function(obj, key) {
		    return obj != null && hasOwnProperty.call(obj, key);
		  };
	
		  // Utility Functions
		  // -----------------
	
		  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
		  // previous owner. Returns a reference to the Underscore object.
		  _.noConflict = function() {
		    root._ = previousUnderscore;
		    return this;
		  };
	
		  // Keep the identity function around for default iteratees.
		  _.identity = function(value) {
		    return value;
		  };
	
		  // Predicate-generating functions. Often useful outside of Underscore.
		  _.constant = function(value) {
		    return function() {
		      return value;
		    };
		  };
	
		  _.noop = function(){};
	
		  _.property = property;
	
		  // Generates a function for a given object that returns a given property.
		  _.propertyOf = function(obj) {
		    return obj == null ? function(){} : function(key) {
		      return obj[key];
		    };
		  };
	
		  // Returns a predicate for checking whether an object has a given set of
		  // `key:value` pairs.
		  _.matcher = _.matches = function(attrs) {
		    attrs = _.extendOwn({}, attrs);
		    return function(obj) {
		      return _.isMatch(obj, attrs);
		    };
		  };
	
		  // Run a function **n** times.
		  _.times = function(n, iteratee, context) {
		    var accum = Array(Math.max(0, n));
		    iteratee = optimizeCb(iteratee, context, 1);
		    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
		    return accum;
		  };
	
		  // Return a random integer between min and max (inclusive).
		  _.random = function(min, max) {
		    if (max == null) {
		      max = min;
		      min = 0;
		    }
		    return min + Math.floor(Math.random() * (max - min + 1));
		  };
	
		  // A (possibly faster) way to get the current timestamp as an integer.
		  _.now = Date.now || function() {
		    return new Date().getTime();
		  };
	
		   // List of HTML entities for escaping.
		  var escapeMap = {
		    '&': '&amp;',
		    '<': '&lt;',
		    '>': '&gt;',
		    '"': '&quot;',
		    "'": '&#x27;',
		    '`': '&#x60;'
		  };
		  var unescapeMap = _.invert(escapeMap);
	
		  // Functions for escaping and unescaping strings to/from HTML interpolation.
		  var createEscaper = function(map) {
		    var escaper = function(match) {
		      return map[match];
		    };
		    // Regexes for identifying a key that needs to be escaped
		    var source = '(?:' + _.keys(map).join('|') + ')';
		    var testRegexp = RegExp(source);
		    var replaceRegexp = RegExp(source, 'g');
		    return function(string) {
		      string = string == null ? '' : '' + string;
		      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
		    };
		  };
		  _.escape = createEscaper(escapeMap);
		  _.unescape = createEscaper(unescapeMap);
	
		  // If the value of the named `property` is a function then invoke it with the
		  // `object` as context; otherwise, return it.
		  _.result = function(object, property, fallback) {
		    var value = object == null ? void 0 : object[property];
		    if (value === void 0) {
		      value = fallback;
		    }
		    return _.isFunction(value) ? value.call(object) : value;
		  };
	
		  // Generate a unique integer id (unique within the entire client session).
		  // Useful for temporary DOM ids.
		  var idCounter = 0;
		  _.uniqueId = function(prefix) {
		    var id = ++idCounter + '';
		    return prefix ? prefix + id : id;
		  };
	
		  // By default, Underscore uses ERB-style template delimiters, change the
		  // following template settings to use alternative delimiters.
		  _.templateSettings = {
		    evaluate    : /<%([\s\S]+?)%>/g,
		    interpolate : /<%=([\s\S]+?)%>/g,
		    escape      : /<%-([\s\S]+?)%>/g
		  };
	
		  // When customizing `templateSettings`, if you don't want to define an
		  // interpolation, evaluation or escaping regex, we need one that is
		  // guaranteed not to match.
		  var noMatch = /(.)^/;
	
		  // Certain characters need to be escaped so that they can be put into a
		  // string literal.
		  var escapes = {
		    "'":      "'",
		    '\\':     '\\',
		    '\r':     'r',
		    '\n':     'n',
		    '\u2028': 'u2028',
		    '\u2029': 'u2029'
		  };
	
		  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
		  var escapeChar = function(match) {
		    return '\\' + escapes[match];
		  };
	
		  // JavaScript micro-templating, similar to John Resig's implementation.
		  // Underscore templating handles arbitrary delimiters, preserves whitespace,
		  // and correctly escapes quotes within interpolated code.
		  // NB: `oldSettings` only exists for backwards compatibility.
		  _.template = function(text, settings, oldSettings) {
		    if (!settings && oldSettings) settings = oldSettings;
		    settings = _.defaults({}, settings, _.templateSettings);
	
		    // Combine delimiters into one regular expression via alternation.
		    var matcher = RegExp([
		      (settings.escape || noMatch).source,
		      (settings.interpolate || noMatch).source,
		      (settings.evaluate || noMatch).source
		    ].join('|') + '|$', 'g');
	
		    // Compile the template source, escaping string literals appropriately.
		    var index = 0;
		    var source = "__p+='";
		    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
		      source += text.slice(index, offset).replace(escaper, escapeChar);
		      index = offset + match.length;
	
		      if (escape) {
		        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
		      } else if (interpolate) {
		        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
		      } else if (evaluate) {
		        source += "';\n" + evaluate + "\n__p+='";
		      }
	
		      // Adobe VMs need the match returned to produce the correct offest.
		      return match;
		    });
		    source += "';\n";
	
		    // If a variable is not specified, place data values in local scope.
		    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
		    source = "var __t,__p='',__j=Array.prototype.join," +
		      "print=function(){__p+=__j.call(arguments,'');};\n" +
		      source + 'return __p;\n';
	
		    try {
		      var render = new Function(settings.variable || 'obj', '_', source);
		    } catch (e) {
		      e.source = source;
		      throw e;
		    }
	
		    var template = function(data) {
		      return render.call(this, data, _);
		    };
	
		    // Provide the compiled source as a convenience for precompilation.
		    var argument = settings.variable || 'obj';
		    template.source = 'function(' + argument + '){\n' + source + '}';
	
		    return template;
		  };
	
		  // Add a "chain" function. Start chaining a wrapped Underscore object.
		  _.chain = function(obj) {
		    var instance = _(obj);
		    instance._chain = true;
		    return instance;
		  };
	
		  // OOP
		  // ---------------
		  // If Underscore is called as a function, it returns a wrapped object that
		  // can be used OO-style. This wrapper holds altered versions of all the
		  // underscore functions. Wrapped objects may be chained.
	
		  // Helper function to continue chaining intermediate results.
		  var result = function(instance, obj) {
		    return instance._chain ? _(obj).chain() : obj;
		  };
	
		  // Add your own custom functions to the Underscore object.
		  _.mixin = function(obj) {
		    _.each(_.functions(obj), function(name) {
		      var func = _[name] = obj[name];
		      _.prototype[name] = function() {
		        var args = [this._wrapped];
		        push.apply(args, arguments);
		        return result(this, func.apply(_, args));
		      };
		    });
		  };
	
		  // Add all of the Underscore functions to the wrapper object.
		  _.mixin(_);
	
		  // Add all mutator Array functions to the wrapper.
		  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
		    var method = ArrayProto[name];
		    _.prototype[name] = function() {
		      var obj = this._wrapped;
		      method.apply(obj, arguments);
		      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
		      return result(this, obj);
		    };
		  });
	
		  // Add all accessor Array functions to the wrapper.
		  _.each(['concat', 'join', 'slice'], function(name) {
		    var method = ArrayProto[name];
		    _.prototype[name] = function() {
		      return result(this, method.apply(this._wrapped, arguments));
		    };
		  });
	
		  // Extracts the result from a wrapped and chained object.
		  _.prototype.value = function() {
		    return this._wrapped;
		  };
	
		  // Provide unwrapping proxy for some methods used in engine operations
		  // such as arithmetic and JSON stringification.
		  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
		  _.prototype.toString = function() {
		    return '' + this._wrapped;
		  };
	
		  // AMD registration happens at the end for compatibility with AMD loaders
		  // that may not enforce next-turn semantics on modules. Even though general
		  // practice for AMD registration is to be anonymous, underscore registers
		  // as a named module because, like jQuery, it is a base library that is
		  // popular enough to be bundled in a third party lib, but not be part of
		  // an AMD load request. Those cases could generate an error when an
		  // anonymous define() is called outside of a loader request.
		  if (true) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		      return _;
		    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		  }
		}.call(this));
	
	
	/***/ }),
	/* 98 */,
	/* 99 */,
	/* 100 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reselect = __webpack_require__(397);
	
		var _reactDataGrid = __webpack_require__(3);
	
		var isEmptyArray = _reactDataGrid.utils.isEmptyArray,
		    isEmptyObject = _reactDataGrid.utils.isEmptyObject;
	
		var groupRows = __webpack_require__(209);
		var filterRows = __webpack_require__(208);
		var sortRows = __webpack_require__(211);
	
		var getInputRows = function getInputRows(state) {
		  return state.rows;
		};
		var getFilters = function getFilters(state) {
		  return state.filters;
		};
		var getFilteredRows = (0, _reselect.createSelector)([getFilters, getInputRows], function (filters) {
		  var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
		  if (!filters || isEmptyObject(filters)) {
		    return rows;
		  }
		  return filterRows(filters, rows);
		});
	
		var getSortColumn = function getSortColumn(state) {
		  return state.sortColumn;
		};
		var getSortDirection = function getSortDirection(state) {
		  return state.sortDirection;
		};
		var getSortedRows = (0, _reselect.createSelector)([getFilteredRows, getSortColumn, getSortDirection], function (rows, sortColumn, sortDirection) {
		  if (!sortDirection && !sortColumn) {
		    return rows;
		  }
		  return sortRows(rows, sortColumn, sortDirection);
		});
	
		var getGroupedColumns = function getGroupedColumns(state) {
		  return state.groupBy;
		};
		var getExpandedRows = function getExpandedRows(state) {
		  return state.expandedRows;
		};
		var getFlattenedGroupedRows = (0, _reselect.createSelector)([getSortedRows, getGroupedColumns, getExpandedRows], function (rows, groupedColumns) {
		  var expandedRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
		  if (!groupedColumns || isEmptyObject(groupedColumns) || isEmptyArray(groupedColumns)) {
		    return rows;
		  }
		  return groupRows(rows, groupedColumns, expandedRows);
		});
	
		var getSelectedKeys = function getSelectedKeys(state) {
		  return state.selectedKeys;
		};
		var getRowKey = function getRowKey(state) {
		  return state.rowKey;
		};
		var getSelectedRowsByKey = (0, _reselect.createSelector)([getRowKey, getSelectedKeys, getInputRows], function (rowKey, selectedKeys) {
		  var rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
		  return selectedKeys.map(function (k) {
		    return rows.filter(function (r) {
		      return r[rowKey] === k;
		    })[0];
		  });
		});
	
		var Selectors = {
		  getRows: getFlattenedGroupedRows,
		  getSelectedRowsByKey: getSelectedRowsByKey
		};
		module.exports = Selectors;
	
	/***/ }),
	/* 101 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _reactDnd = __webpack_require__(16);
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var DragItemTypes = _reactDataGrid._constants.DragItemTypes;
	
		var DraggableHeaderCell = function (_Component) {
		  _inherits(DraggableHeaderCell, _Component);
	
		  function DraggableHeaderCell() {
		    _classCallCheck(this, DraggableHeaderCell);
	
		    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		  }
	
		  DraggableHeaderCell.prototype.componentDidMount = function componentDidMount() {
		    var connectDragPreview = this.props.connectDragPreview;
		    var img = new Image();
		    img.src = './assets/images/drag_column_full.png';
		    img.onload = function () {
		      connectDragPreview(img);
		    };
		  };
	
		  DraggableHeaderCell.prototype.setScrollLeft = function setScrollLeft(scrollLeft) {
		    var node = ReactDOM.findDOMNode(this);
		    node.style.webkitTransform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		    node.style.transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		  };
	
		  DraggableHeaderCell.prototype.render = function render() {
		    var _props = this.props,
		        connectDragSource = _props.connectDragSource,
		        isDragging = _props.isDragging;
	
		    if (isDragging) {
		      return null;
		    }
		    return connectDragSource(_react2['default'].createElement(
		      'div',
		      { style: { cursor: 'move' } },
		      _react2['default'].createElement(_reactDataGrid.HeaderCell, this.props)
		    ));
		  };
	
		  return DraggableHeaderCell;
		}(_react.Component);
	
		DraggableHeaderCell.propTypes = {
		  connectDragSource: _react.PropTypes.func.isRequired,
		  connectDragPreview: _react.PropTypes.func.isRequired,
		  isDragging: _react.PropTypes.bool.isRequired
		};
	
		function collect(connect, monitor) {
		  return {
		    connectDragSource: connect.dragSource(),
		    isDragging: monitor.isDragging(),
		    connectDragPreview: connect.dragPreview()
		  };
		}
	
		var headerCellSource = {
		  beginDrag: function beginDrag(props) {
		    return props.column;
		  },
		  endDrag: function endDrag(props) {
		    return props.column;
		  }
		};
	
		exports['default'] = (0, _reactDnd.DragSource)(DragItemTypes.Column, headerCellSource, collect)(DraggableHeaderCell);
	
	/***/ }),
	/* 102 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var OWNER_COMPONENT_KEY = 'Owner > component';
		var WASTED_TIME_KEY = 'Wasted time (ms)';
		var WASTED_INSTANCES_KEY = 'Instances';
	
		var SummaryItemModel = function () {
		  function SummaryItemModel(summary) {
		    _classCallCheck(this, SummaryItemModel);
	
		    if ((typeof summary === 'undefined' ? 'undefined' : _typeof(summary)) === 'object') {
		      this._createModel(summary);
		    } else {
		      this._createEmptyModel(summary);
		    }
		  }
	
		  SummaryItemModel.prototype._createModel = function _createModel(summary) {
		    var _getComponentAndOwner2 = this._getComponentAndOwner(summary),
		        owner = _getComponentAndOwner2.owner,
		        component = _getComponentAndOwner2.component;
	
		    this.owner = owner;
		    this.component = component;
		    this.wastedInstances = summary[WASTED_INSTANCES_KEY];
		    this.wastedTime = summary[WASTED_TIME_KEY];
		  };
	
		  SummaryItemModel.prototype._createEmptyModel = function _createEmptyModel(componentName) {
		    this.owner = componentName;
		    this.component = componentName;
		    this.wastedInstances = 0;
		    this.wastedTime = 0;
		  };
	
		  SummaryItemModel.prototype._getComponentAndOwner = function _getComponentAndOwner(summary) {
		    var ownerAndComponent = summary[OWNER_COMPONENT_KEY];
		    var splitOwnerComponent = ownerAndComponent.split('>');
	
		    return {
		      owner: splitOwnerComponent[0].trim(),
		      component: splitOwnerComponent[1].trim()
		    };
		  };
	
		  return SummaryItemModel;
		}();
	
		exports['default'] = SummaryItemModel;
	
	/***/ }),
	/* 103 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = dirtyHandlerIds;
		exports.areDirty = areDirty;
	
		var _xor = __webpack_require__(348);
	
		var _xor2 = _interopRequireDefault(_xor);
	
		var _intersection = __webpack_require__(341);
	
		var _intersection2 = _interopRequireDefault(_intersection);
	
		var _dragDrop = __webpack_require__(39);
	
		var _registry = __webpack_require__(40);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var NONE = [];
		var ALL = [];
	
		function dirtyHandlerIds() {
		  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
		  var action = arguments[1];
		  var dragOperation = arguments[2];
	
		  switch (action.type) {
		    case _dragDrop.HOVER:
		      break;
		    case _registry.ADD_SOURCE:
		    case _registry.ADD_TARGET:
		    case _registry.REMOVE_TARGET:
		    case _registry.REMOVE_SOURCE:
		      return NONE;
		    case _dragDrop.BEGIN_DRAG:
		    case _dragDrop.PUBLISH_DRAG_SOURCE:
		    case _dragDrop.END_DRAG:
		    case _dragDrop.DROP:
		    default:
		      return ALL;
		  }
	
		  var targetIds = action.targetIds;
		  var prevTargetIds = dragOperation.targetIds;
	
		  var result = (0, _xor2.default)(targetIds, prevTargetIds);
	
		  var didChange = false;
		  if (result.length === 0) {
		    for (var i = 0; i < targetIds.length; i++) {
		      if (targetIds[i] !== prevTargetIds[i]) {
		        didChange = true;
		        break;
		      }
		    }
		  } else {
		    didChange = true;
		  }
	
		  if (!didChange) {
		    return NONE;
		  }
	
		  var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
		  var innermostTargetId = targetIds[targetIds.length - 1];
	
		  if (prevInnermostTargetId !== innermostTargetId) {
		    if (prevInnermostTargetId) {
		      result.push(prevInnermostTargetId);
		    }
		    if (innermostTargetId) {
		      result.push(innermostTargetId);
		    }
		  }
	
		  return result;
		}
	
		function areDirty(state, handlerIds) {
		  if (state === NONE) {
		    return false;
		  }
	
		  if (state === ALL || typeof handlerIds === 'undefined') {
		    return true;
		  }
	
		  return (0, _intersection2.default)(handlerIds, state).length > 0;
		}
	
	/***/ }),
	/* 104 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		exports.default = dragOffset;
		exports.getSourceClientOffset = getSourceClientOffset;
		exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;
	
		var _dragDrop = __webpack_require__(39);
	
		var initialState = {
		  initialSourceClientOffset: null,
		  initialClientOffset: null,
		  clientOffset: null
		};
	
		function areOffsetsEqual(offsetA, offsetB) {
		  if (offsetA === offsetB) {
		    return true;
		  }
		  return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
		}
	
		function dragOffset() {
		  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		  var action = arguments[1];
	
		  switch (action.type) {
		    case _dragDrop.BEGIN_DRAG:
		      return {
		        initialSourceClientOffset: action.sourceClientOffset,
		        initialClientOffset: action.clientOffset,
		        clientOffset: action.clientOffset
		      };
		    case _dragDrop.HOVER:
		      if (areOffsetsEqual(state.clientOffset, action.clientOffset)) {
		        return state;
		      }
		      return _extends({}, state, {
		        clientOffset: action.clientOffset
		      });
		    case _dragDrop.END_DRAG:
		    case _dragDrop.DROP:
		      return initialState;
		    default:
		      return state;
		  }
		}
	
		function getSourceClientOffset(state) {
		  var clientOffset = state.clientOffset,
		      initialClientOffset = state.initialClientOffset,
		      initialSourceClientOffset = state.initialSourceClientOffset;
	
		  if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
		    return null;
		  }
		  return {
		    x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
		    y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
		  };
		}
	
		function getDifferenceFromInitialOffset(state) {
		  var clientOffset = state.clientOffset,
		      initialClientOffset = state.initialClientOffset;
	
		  if (!clientOffset || !initialClientOffset) {
		    return null;
		  }
		  return {
		    x: clientOffset.x - initialClientOffset.x,
		    y: clientOffset.y - initialClientOffset.y
		  };
		}
	
	/***/ }),
	/* 105 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = matchesType;
	
		var _isArray = __webpack_require__(20);
	
		var _isArray2 = _interopRequireDefault(_isArray);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function matchesType(targetType, draggedItemType) {
		  if ((0, _isArray2.default)(targetType)) {
		    return targetType.some(function (t) {
		      return t === draggedItemType;
		    });
		  } else {
		    return targetType === draggedItemType;
		  }
		}
	
	/***/ }),
	/* 106 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = hasClass;
		function hasClass(element, className) {
		  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
		}
		module.exports = exports["default"];
	
	/***/ }),
	/* 107 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = camelizeStyleName;
	
		var _camelize = __webpack_require__(274);
	
		var _camelize2 = _interopRequireDefault(_camelize);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var msPattern = /^-ms-/; /**
		                          * Copyright 2014-2015, Facebook, Inc.
		                          * All rights reserved.
		                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
		                          */
		function camelizeStyleName(string) {
		  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
		}
		module.exports = exports['default'];
	
	/***/ }),
	/* 108 */
	[1624, 322, 323, 324, 325, 326],
	/* 109 */
	/***/ (function(module, exports) {
	
		/**
		 * A faster alternative to `Function#apply`, this function invokes `func`
		 * with the `this` binding of `thisArg` and the arguments of `args`.
		 *
		 * @private
		 * @param {Function} func The function to invoke.
		 * @param {*} thisArg The `this` binding of `func`.
		 * @param {Array} args The arguments to invoke `func` with.
		 * @returns {*} Returns the result of `func`.
		 */
		function apply(func, thisArg, args) {
		  switch (args.length) {
		    case 0: return func.call(thisArg);
		    case 1: return func.call(thisArg, args[0]);
		    case 2: return func.call(thisArg, args[0], args[1]);
		    case 3: return func.call(thisArg, args[0], args[1], args[2]);
		  }
		  return func.apply(thisArg, args);
		}
	
		module.exports = apply;
	
	
	/***/ }),
	/* 110 */
	[1656, 114],
	/* 111 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var SetCache = __webpack_require__(76),
		    arrayIncludes = __webpack_require__(78),
		    arrayIncludesWith = __webpack_require__(79),
		    arrayMap = __webpack_require__(80),
		    baseUnary = __webpack_require__(81),
		    cacheHas = __webpack_require__(82);
	
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;
	
		/**
		 * The base implementation of methods like `_.difference` without support
		 * for excluding multiple arrays or iteratee shorthands.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {Array} values The values to exclude.
		 * @param {Function} [iteratee] The iteratee invoked per element.
		 * @param {Function} [comparator] The comparator invoked per element.
		 * @returns {Array} Returns the new array of filtered values.
		 */
		function baseDifference(array, values, iteratee, comparator) {
		  var index = -1,
		      includes = arrayIncludes,
		      isCommon = true,
		      length = array.length,
		      result = [],
		      valuesLength = values.length;
	
		  if (!length) {
		    return result;
		  }
		  if (iteratee) {
		    values = arrayMap(values, baseUnary(iteratee));
		  }
		  if (comparator) {
		    includes = arrayIncludesWith;
		    isCommon = false;
		  }
		  else if (values.length >= LARGE_ARRAY_SIZE) {
		    includes = cacheHas;
		    isCommon = false;
		    values = new SetCache(values);
		  }
		  outer:
		  while (++index < length) {
		    var value = array[index],
		        computed = iteratee == null ? value : iteratee(value);
	
		    value = (comparator || value !== 0) ? value : 0;
		    if (isCommon && computed === computed) {
		      var valuesIndex = valuesLength;
		      while (valuesIndex--) {
		        if (values[valuesIndex] === computed) {
		          continue outer;
		        }
		      }
		      result.push(value);
		    }
		    else if (!includes(values, computed, comparator)) {
		      result.push(value);
		    }
		  }
		  return result;
		}
	
		module.exports = baseDifference;
	
	
	/***/ }),
	/* 112 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var arrayPush = __webpack_require__(285),
		    isFlattenable = __webpack_require__(312);
	
		/**
		 * The base implementation of `_.flatten` with support for restricting flattening.
		 *
		 * @private
		 * @param {Array} array The array to flatten.
		 * @param {number} depth The maximum recursion depth.
		 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
		 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
		 * @param {Array} [result=[]] The initial result value.
		 * @returns {Array} Returns the new flattened array.
		 */
		function baseFlatten(array, depth, predicate, isStrict, result) {
		  var index = -1,
		      length = array.length;
	
		  predicate || (predicate = isFlattenable);
		  result || (result = []);
	
		  while (++index < length) {
		    var value = array[index];
		    if (depth > 0 && predicate(value)) {
		      if (depth > 1) {
		        // Recursively flatten arrays (susceptible to call stack limits).
		        baseFlatten(value, depth - 1, predicate, isStrict, result);
		      } else {
		        arrayPush(result, value);
		      }
		    } else if (!isStrict) {
		      result[result.length] = value;
		    }
		  }
		  return result;
		}
	
		module.exports = baseFlatten;
	
	
	/***/ }),
	/* 113 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var SetCache = __webpack_require__(76),
		    arrayIncludes = __webpack_require__(78),
		    arrayIncludesWith = __webpack_require__(79),
		    cacheHas = __webpack_require__(82),
		    createSet = __webpack_require__(302),
		    setToArray = __webpack_require__(117);
	
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;
	
		/**
		 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {Function} [iteratee] The iteratee invoked per element.
		 * @param {Function} [comparator] The comparator invoked per element.
		 * @returns {Array} Returns the new duplicate free array.
		 */
		function baseUniq(array, iteratee, comparator) {
		  var index = -1,
		      includes = arrayIncludes,
		      length = array.length,
		      isCommon = true,
		      result = [],
		      seen = result;
	
		  if (comparator) {
		    isCommon = false;
		    includes = arrayIncludesWith;
		  }
		  else if (length >= LARGE_ARRAY_SIZE) {
		    var set = iteratee ? null : createSet(array);
		    if (set) {
		      return setToArray(set);
		    }
		    isCommon = false;
		    includes = cacheHas;
		    seen = new SetCache;
		  }
		  else {
		    seen = iteratee ? [] : result;
		  }
		  outer:
		  while (++index < length) {
		    var value = array[index],
		        computed = iteratee ? iteratee(value) : value;
	
		    value = (comparator || value !== 0) ? value : 0;
		    if (isCommon && computed === computed) {
		      var seenIndex = seen.length;
		      while (seenIndex--) {
		        if (seen[seenIndex] === computed) {
		          continue outer;
		        }
		      }
		      if (iteratee) {
		        seen.push(computed);
		      }
		      result.push(value);
		    }
		    else if (!includes(seen, computed, comparator)) {
		      if (seen !== result) {
		        seen.push(computed);
		      }
		      result.push(value);
		    }
		  }
		  return result;
		}
	
		module.exports = baseUniq;
	
	
	/***/ }),
	/* 114 */
	[1688, 44],
	/* 115 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/** Detect free variable `global` from Node.js. */
		var freeGlobal = typeof (window) == 'object' && (window) && (window).Object === Object && (window);
	
		module.exports = freeGlobal;
	
	
	/***/ }),
	/* 116 */
	/***/ (function(module, exports) {
	
		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;
	
		/** Used to detect unsigned integer values. */
		var reIsUint = /^(?:0|[1-9]\d*)$/;
	
		/**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */
		function isIndex(value, length) {
		  length = length == null ? MAX_SAFE_INTEGER : length;
		  return !!length &&
		    (typeof value == 'number' || reIsUint.test(value)) &&
		    (value > -1 && value % 1 == 0 && value < length);
		}
	
		module.exports = isIndex;
	
	
	/***/ }),
	/* 117 */
	/***/ (function(module, exports) {
	
		/**
		 * Converts `set` to an array of its values.
		 *
		 * @private
		 * @param {Object} set The set to convert.
		 * @returns {Array} Returns the values.
		 */
		function setToArray(set) {
		  var index = -1,
		      result = Array(set.size);
	
		  set.forEach(function(value) {
		    result[++index] = value;
		  });
		  return result;
		}
	
		module.exports = setToArray;
	
	
	/***/ }),
	/* 118 */
	/***/ (function(module, exports) {
	
		/**
		 * This method returns the first argument it receives.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Util
		 * @param {*} value Any value.
		 * @returns {*} Returns `value`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 *
		 * console.log(_.identity(object) === object);
		 * // => true
		 */
		function identity(value) {
		  return value;
		}
	
		module.exports = identity;
	
	
	/***/ }),
	/* 119 */
	[1789, 290, 30],
	/* 120 */
	[1807, 42, 29],
	/* 121 */
	91,
	/* 122 */
	/***/ (function(module, exports) {
	
		/**
		 * This method returns `undefined`.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.3.0
		 * @category Util
		 * @example
		 *
		 * _.times(2, _.noop);
		 * // => [undefined, undefined]
		 */
		function noop() {
		  // No operation performed.
		}
	
		module.exports = noop;
	
	
	/***/ }),
	/* 123 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseDifference = __webpack_require__(111),
		    baseRest = __webpack_require__(25),
		    isArrayLikeObject = __webpack_require__(47);
	
		/**
		 * Creates an array excluding all given values using
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * for equality comparisons.
		 *
		 * **Note:** Unlike `_.pull`, this method returns a new array.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Array
		 * @param {Array} array The array to inspect.
		 * @param {...*} [values] The values to exclude.
		 * @returns {Array} Returns the new array of filtered values.
		 * @see _.difference, _.xor
		 * @example
		 *
		 * _.without([2, 1, 2, 3], 1, 2);
		 * // => [3]
		 */
		var without = baseRest(function(array, values) {
		  return isArrayLikeObject(array)
		    ? baseDifference(array, values)
		    : [];
		});
	
		module.exports = without;
	
	
	/***/ }),
	/* 124 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _contextMenu = __webpack_require__(350);
	
		Object.defineProperty(exports, "ContextMenu", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_contextMenu).default;
		  }
		});
	
		var _contextmenuLayer = __webpack_require__(352);
	
		Object.defineProperty(exports, "ContextMenuLayer", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_contextmenuLayer).default;
		  }
		});
	
		var _menuItem = __webpack_require__(353);
	
		Object.defineProperty(exports, "MenuItem", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_menuItem).default;
		  }
		});
	
		var _monitor = __webpack_require__(84);
	
		Object.defineProperty(exports, "monitor", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_monitor).default;
		  }
		});
	
		var _submenu = __webpack_require__(355);
	
		Object.defineProperty(exports, "SubMenu", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_submenu).default;
		  }
		});
	
		var _connect = __webpack_require__(349);
	
		Object.defineProperty(exports, "connect", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_connect).default;
		  }
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/***/ }),
	/* 125 */
	51,
	/* 126 */
	/***/ (function(module, exports) {
	
		/*
		object-assign
		(c) Sindre Sorhus
		@license MIT
		*/
	
		'use strict';
		/* eslint-disable no-unused-vars */
		var getOwnPropertySymbols = Object.getOwnPropertySymbols;
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
		function toObject(val) {
			if (val === null || val === undefined) {
				throw new TypeError('Object.assign cannot be called with null or undefined');
			}
	
			return Object(val);
		}
	
		function shouldUseNative() {
			try {
				if (!Object.assign) {
					return false;
				}
	
				// Detect buggy property enumeration order in older V8 versions.
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=4118
				var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
				test1[5] = 'de';
				if (Object.getOwnPropertyNames(test1)[0] === '5') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test2 = {};
				for (var i = 0; i < 10; i++) {
					test2['_' + String.fromCharCode(i)] = i;
				}
				var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
					return test2[n];
				});
				if (order2.join('') !== '0123456789') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test3 = {};
				'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
					test3[letter] = letter;
				});
				if (Object.keys(Object.assign({}, test3)).join('') !==
						'abcdefghijklmnopqrst') {
					return false;
				}
	
				return true;
			} catch (err) {
				// We don't expect any of the above to throw, but better to be safe.
				return false;
			}
		}
	
		module.exports = shouldUseNative() ? Object.assign : function (target, source) {
			var from;
			var to = toObject(target);
			var symbols;
	
			for (var s = 1; s < arguments.length; s++) {
				from = Object(arguments[s]);
	
				for (var key in from) {
					if (hasOwnProperty.call(from, key)) {
						to[key] = from[key];
					}
				}
	
				if (getOwnPropertySymbols) {
					symbols = getOwnPropertySymbols(from);
					for (var i = 0; i < symbols.length; i++) {
						if (propIsEnumerable.call(from, symbols[i])) {
							to[symbols[i]] = from[symbols[i]];
						}
					}
				}
			}
	
			return to;
		};
	
	
	/***/ }),
	/* 127 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.isSafari = exports.isFirefox = undefined;
	
		var _memoize = __webpack_require__(345);
	
		var _memoize2 = _interopRequireDefault(_memoize);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var isFirefox = exports.isFirefox = (0, _memoize2.default)(function () {
		  return (/firefox/i.test(navigator.userAgent)
		  );
		});
		var isSafari = exports.isSafari = (0, _memoize2.default)(function () {
		  return Boolean(window.safari);
		});
	
	/***/ }),
	/* 128 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.getEmptyImage = exports.NativeTypes = undefined;
		exports.default = createHTML5Backend;
	
		var _HTML5Backend = __webpack_require__(358);
	
		var _HTML5Backend2 = _interopRequireDefault(_HTML5Backend);
	
		var _getEmptyImage = __webpack_require__(362);
	
		var _getEmptyImage2 = _interopRequireDefault(_getEmptyImage);
	
		var _NativeTypes = __webpack_require__(85);
	
		var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.NativeTypes = NativeTypes;
		exports.getEmptyImage = _getEmptyImage2.default;
		function createHTML5Backend(manager) {
		  return new _HTML5Backend2.default(manager);
		}
	
	/***/ }),
	/* 129 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.unpackBackendForEs5Users = exports.createChildContext = exports.CHILD_CONTEXT_TYPES = undefined;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		exports.default = DragDropContext;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _dndCore = __webpack_require__(255);
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _hoistNonReactStatics = __webpack_require__(75);
	
		var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
		var _checkDecoratorArguments = __webpack_require__(49);
	
		var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var CHILD_CONTEXT_TYPES = exports.CHILD_CONTEXT_TYPES = {
		  dragDropManager: _react.PropTypes.object.isRequired
		};
	
		var createChildContext = exports.createChildContext = function createChildContext(backend, context) {
		  return {
		    dragDropManager: new _dndCore.DragDropManager(backend, context)
		  };
		};
	
		var unpackBackendForEs5Users = exports.unpackBackendForEs5Users = function unpackBackendForEs5Users(backendOrModule) {
		  // Auto-detect ES6 default export for people still using ES5
		  var backend = backendOrModule;
		  if ((typeof backend === 'undefined' ? 'undefined' : _typeof(backend)) === 'object' && typeof backend.default === 'function') {
		    backend = backend.default;
		  }
		  (0, _invariant2.default)(typeof backend === 'function', 'Expected the backend to be a function or an ES6 module exporting a default function. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-drop-context.html');
		  return backend;
		};
	
		function DragDropContext(backendOrModule) {
		  _checkDecoratorArguments2.default.apply(undefined, ['DragDropContext', 'backend'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	
		  var backend = unpackBackendForEs5Users(backendOrModule);
		  var childContext = createChildContext(backend);
	
		  return function decorateContext(DecoratedComponent) {
		    var _class, _temp;
	
		    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
		    var DragDropContextContainer = (_temp = _class = function (_Component) {
		      _inherits(DragDropContextContainer, _Component);
	
		      function DragDropContextContainer() {
		        _classCallCheck(this, DragDropContextContainer);
	
		        return _possibleConstructorReturn(this, (DragDropContextContainer.__proto__ || Object.getPrototypeOf(DragDropContextContainer)).apply(this, arguments));
		      }
	
		      _createClass(DragDropContextContainer, [{
		        key: 'getDecoratedComponentInstance',
		        value: function getDecoratedComponentInstance() {
		          (0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can ' + 'not be a stateless component.');
		          return this.child;
		        }
		      }, {
		        key: 'getManager',
		        value: function getManager() {
		          return childContext.dragDropManager;
		        }
		      }, {
		        key: 'getChildContext',
		        value: function getChildContext() {
		          return childContext;
		        }
		      }, {
		        key: 'render',
		        value: function render() {
		          var _this2 = this;
	
		          return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
		            ref: function ref(child) {
		              return _this2.child = child;
		            }
		          }));
		        }
		      }]);
	
		      return DragDropContextContainer;
		    }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragDropContext(' + displayName + ')', _class.childContextTypes = CHILD_CONTEXT_TYPES, _temp);
	
	
		    return (0, _hoistNonReactStatics2.default)(DragDropContextContainer, DecoratedComponent);
		  };
		}
	
	/***/ }),
	/* 130 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = areOptionsEqual;
	
		var _shallowEqual = __webpack_require__(86);
	
		var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function areOptionsEqual(nextOptions, currentOptions) {
		  if (currentOptions === nextOptions) {
		    return true;
		  }
	
		  return currentOptions !== null && nextOptions !== null && (0, _shallowEqual2.default)(currentOptions, nextOptions);
		}
	
	/***/ }),
	/* 131 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = decorateHandler;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _disposables = __webpack_require__(248);
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _hoistNonReactStatics = __webpack_require__(75);
	
		var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
		var _shallowEqual = __webpack_require__(86);
	
		var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
		var _shallowEqualScalar = __webpack_require__(133);
	
		var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		function decorateHandler(_ref) {
		  var _class, _temp;
	
		  var DecoratedComponent = _ref.DecoratedComponent,
		      createHandler = _ref.createHandler,
		      createMonitor = _ref.createMonitor,
		      createConnector = _ref.createConnector,
		      registerHandler = _ref.registerHandler,
		      containerDisplayName = _ref.containerDisplayName,
		      getType = _ref.getType,
		      collect = _ref.collect,
		      options = _ref.options;
		  var _options$arePropsEqua = options.arePropsEqual,
		      arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
	
		  var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
		  var DragDropContainer = (_temp = _class = function (_Component) {
		    _inherits(DragDropContainer, _Component);
	
		    _createClass(DragDropContainer, [{
		      key: 'getHandlerId',
		      value: function getHandlerId() {
		        return this.handlerId;
		      }
		    }, {
		      key: 'getDecoratedComponentInstance',
		      value: function getDecoratedComponentInstance() {
		        return this.decoratedComponentInstance;
		      }
		    }, {
		      key: 'shouldComponentUpdate',
		      value: function shouldComponentUpdate(nextProps, nextState) {
		        return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
		      }
		    }]);
	
		    function DragDropContainer(props, context) {
		      _classCallCheck(this, DragDropContainer);
	
		      var _this = _possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).call(this, props, context));
	
		      _this.handleChange = _this.handleChange.bind(_this);
		      _this.handleChildRef = _this.handleChildRef.bind(_this);
	
		      (0, _invariant2.default)(_typeof(_this.context.dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
		      _this.manager = _this.context.dragDropManager;
		      _this.handlerMonitor = createMonitor(_this.manager);
		      _this.handlerConnector = createConnector(_this.manager.getBackend());
		      _this.handler = createHandler(_this.handlerMonitor);
	
		      _this.disposable = new _disposables.SerialDisposable();
		      _this.receiveProps(props);
		      _this.state = _this.getCurrentState();
		      _this.dispose();
		      return _this;
		    }
	
		    _createClass(DragDropContainer, [{
		      key: 'componentDidMount',
		      value: function componentDidMount() {
		        this.isCurrentlyMounted = true;
		        this.disposable = new _disposables.SerialDisposable();
		        this.currentType = null;
		        this.receiveProps(this.props);
		        this.handleChange();
		      }
		    }, {
		      key: 'componentWillReceiveProps',
		      value: function componentWillReceiveProps(nextProps) {
		        if (!arePropsEqual(nextProps, this.props)) {
		          this.receiveProps(nextProps);
		          this.handleChange();
		        }
		      }
		    }, {
		      key: 'componentWillUnmount',
		      value: function componentWillUnmount() {
		        this.dispose();
		        this.isCurrentlyMounted = false;
		      }
		    }, {
		      key: 'receiveProps',
		      value: function receiveProps(props) {
		        this.handler.receiveProps(props);
		        this.receiveType(getType(props));
		      }
		    }, {
		      key: 'receiveType',
		      value: function receiveType(type) {
		        if (type === this.currentType) {
		          return;
		        }
	
		        this.currentType = type;
	
		        var _registerHandler = registerHandler(type, this.handler, this.manager),
		            handlerId = _registerHandler.handlerId,
		            unregister = _registerHandler.unregister;
	
		        this.handlerId = handlerId;
		        this.handlerMonitor.receiveHandlerId(handlerId);
		        this.handlerConnector.receiveHandlerId(handlerId);
	
		        var globalMonitor = this.manager.getMonitor();
		        var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, { handlerIds: [handlerId] });
	
		        this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister)));
		      }
		    }, {
		      key: 'handleChange',
		      value: function handleChange() {
		        if (!this.isCurrentlyMounted) {
		          return;
		        }
	
		        var nextState = this.getCurrentState();
		        if (!(0, _shallowEqual2.default)(nextState, this.state)) {
		          this.setState(nextState);
		        }
		      }
		    }, {
		      key: 'dispose',
		      value: function dispose() {
		        this.disposable.dispose();
		        this.handlerConnector.receiveHandlerId(null);
		      }
		    }, {
		      key: 'handleChildRef',
		      value: function handleChildRef(component) {
		        this.decoratedComponentInstance = component;
		        this.handler.receiveComponent(component);
		      }
		    }, {
		      key: 'getCurrentState',
		      value: function getCurrentState() {
		        var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);
	
		        if (false) {
		          (0, _invariant2.default)((0, _isPlainObject2.default)(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
		        }
	
		        return nextState;
		      }
		    }, {
		      key: 'render',
		      value: function render() {
		        return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
		          ref: this.handleChildRef
		        }));
		      }
		    }]);
	
		    return DragDropContainer;
		  }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = containerDisplayName + '(' + displayName + ')', _class.contextTypes = {
		    dragDropManager: _react.PropTypes.object.isRequired
		  }, _temp);
	
	
		  return (0, _hoistNonReactStatics2.default)(DragDropContainer, DecoratedComponent);
		}
	
	/***/ }),
	/* 132 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		       value: true
		});
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		exports.default = isValidType;
	
		var _isArray = __webpack_require__(20);
	
		var _isArray2 = _interopRequireDefault(_isArray);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function isValidType(type, allowArray) {
		       return typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol' || allowArray && (0, _isArray2.default)(type) && type.every(function (t) {
		              return isValidType(t, false);
		       });
		}
	
	/***/ }),
	/* 133 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		exports.default = shallowEqualScalar;
		function shallowEqualScalar(objA, objB) {
		  if (objA === objB) {
		    return true;
		  }
	
		  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
		    return false;
		  }
	
		  var keysA = Object.keys(objA);
		  var keysB = Object.keys(objB);
	
		  if (keysA.length !== keysB.length) {
		    return false;
		  }
	
		  // Test for A's keys different from B.
		  var hasOwn = Object.prototype.hasOwnProperty;
		  for (var i = 0; i < keysA.length; i += 1) {
		    if (!hasOwn.call(objB, keysA[i])) {
		      return false;
		    }
	
		    var valA = objA[keysA[i]];
		    var valB = objB[keysA[i]];
	
		    if (valA !== valB || (typeof valA === 'undefined' ? 'undefined' : _typeof(valA)) === 'object' || (typeof valB === 'undefined' ? 'undefined' : _typeof(valB)) === 'object') {
		      return false;
		    }
		  }
	
		  return true;
		}
	
	/***/ }),
	/* 134 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = wrapConnectorHooks;
	
		var _react = __webpack_require__(2);
	
		var _cloneWithRef = __webpack_require__(376);
	
		var _cloneWithRef2 = _interopRequireDefault(_cloneWithRef);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function throwIfCompositeComponentElement(element) {
		  // Custom components can no longer be wrapped directly in React DnD 2.0
		  // so that we don't need to depend on findDOMNode() from react-dom.
		  if (typeof element.type === 'string') {
		    return;
		  }
	
		  var displayName = element.type.displayName || element.type.name || 'the component';
	
		  throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
		}
	
		function wrapHookToRecognizeElement(hook) {
		  return function () {
		    var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
		    // When passed a node, call the hook straight away.
		    if (!(0, _react.isValidElement)(elementOrNode)) {
		      var node = elementOrNode;
		      hook(node, options);
		      return undefined;
		    }
	
		    // If passed a ReactElement, clone it and attach this function as a ref.
		    // This helps us achieve a neat API where user doesn't even know that refs
		    // are being used under the hood.
		    var element = elementOrNode;
		    throwIfCompositeComponentElement(element);
	
		    // When no options are passed, use the hook directly
		    var ref = options ? function (node) {
		      return hook(node, options);
		    } : hook;
	
		    return (0, _cloneWithRef2.default)(element, ref);
		  };
		}
	
		function wrapConnectorHooks(hooks) {
		  var wrappedHooks = {};
	
		  Object.keys(hooks).forEach(function (key) {
		    var hook = hooks[key];
		    var wrappedHook = wrapHookToRecognizeElement(hook);
		    wrappedHooks[key] = function () {
		      return wrappedHook;
		    };
		  });
	
		  return wrappedHooks;
		}
	
	/***/ }),
	/* 135 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = getContainer;
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function getContainer(container, defaultContainer) {
		  container = typeof container === 'function' ? container() : container;
		  return _reactDom2.default.findDOMNode(container) || defaultContainer;
		}
		module.exports = exports['default'];
	
	/***/ }),
	/* 136 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		exports.default = function (componentOrElement) {
		  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
		};
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _ownerDocument = __webpack_require__(74);
	
		var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		module.exports = exports['default'];
	
	/***/ }),
	/* 137 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _createChainableTypeChecker = __webpack_require__(138);
	
		var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function validate(props, propName, componentName, location, propFullName) {
		  var propValue = props[propName];
		  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
		  if (_react2.default.isValidElement(propValue)) {
		    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
		  }
	
		  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
		    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
		  }
	
		  return null;
		}
	
		exports.default = (0, _createChainableTypeChecker2.default)(validate);
	
	/***/ }),
	/* 138 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.default = createChainableTypeChecker;
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		// Mostly taken from ReactPropTypes.
	
		function createChainableTypeChecker(validate) {
		  function checkType(isRequired, props, propName, componentName, location, propFullName) {
		    var componentNameSafe = componentName || '<<anonymous>>';
		    var propFullNameSafe = propFullName || propName;
	
		    if (props[propName] == null) {
		      if (isRequired) {
		        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
		      }
	
		      return null;
		    }
	
		    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
		      args[_key - 6] = arguments[_key];
		    }
	
		    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
		  }
	
		  var chainedCheckType = checkType.bind(null, false);
		  chainedCheckType.isRequired = checkType.bind(null, true);
	
		  return chainedCheckType;
		}
	
	/***/ }),
	/* 139 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _stripDiacritics = __webpack_require__(141);
	
		var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
		function filterOptions(options, filterValue, excludeOptions, props) {
			var _this = this;
	
			if (props.ignoreAccents) {
				filterValue = (0, _stripDiacritics2['default'])(filterValue);
			}
	
			if (props.ignoreCase) {
				filterValue = filterValue.toLowerCase();
			}
	
			if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
				return i[props.valueKey];
			});
	
			return options.filter(function (option) {
				if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
				if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
				if (!filterValue) return true;
				var valueTest = String(option[props.valueKey]);
				var labelTest = String(option[props.labelKey]);
				if (props.ignoreAccents) {
					if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2['default'])(valueTest);
					if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2['default'])(labelTest);
				}
				if (props.ignoreCase) {
					if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
					if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
				}
				return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
			});
		}
	
		module.exports = filterOptions;
	
	/***/ }),
	/* 140 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _classnames = __webpack_require__(51);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function menuRenderer(_ref) {
			var focusedOption = _ref.focusedOption;
			var instancePrefix = _ref.instancePrefix;
			var labelKey = _ref.labelKey;
			var onFocus = _ref.onFocus;
			var onSelect = _ref.onSelect;
			var optionClassName = _ref.optionClassName;
			var optionComponent = _ref.optionComponent;
			var optionRenderer = _ref.optionRenderer;
			var options = _ref.options;
			var valueArray = _ref.valueArray;
			var valueKey = _ref.valueKey;
			var onOptionRef = _ref.onOptionRef;
	
			var Option = optionComponent;
	
			return options.map(function (option, i) {
				var isSelected = valueArray && valueArray.indexOf(option) > -1;
				var isFocused = option === focusedOption;
				var optionClass = (0, _classnames2['default'])(optionClassName, {
					'Select-option': true,
					'is-selected': isSelected,
					'is-focused': isFocused,
					'is-disabled': option.disabled
				});
	
				return _react2['default'].createElement(
					Option,
					{
						className: optionClass,
						instancePrefix: instancePrefix,
						isDisabled: option.disabled,
						isFocused: isFocused,
						isSelected: isSelected,
						key: 'option-' + i + '-' + option[valueKey],
						onFocus: onFocus,
						onSelect: onSelect,
						option: option,
						optionIndex: i,
						ref: function (ref) {
							onOptionRef(ref, isFocused);
						}
					},
					optionRenderer(option, i)
				);
			});
		}
	
		module.exports = menuRenderer;
	
	/***/ }),
	/* 141 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
		module.exports = function stripDiacritics(str) {
			for (var i = 0; i < map.length; i++) {
				str = str.replace(map[i].letters, map[i].base);
			}
			return str;
		};
	
	/***/ }),
	/* 142 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
		exports["default"] = compose;
		/**
		 * Composes single-argument functions from right to left. The rightmost
		 * function can take multiple arguments as it provides the signature for
		 * the resulting composite function.
		 *
		 * @param {...Function} funcs The functions to compose.
		 * @returns {Function} A function obtained by composing the argument functions
		 * from right to left. For example, compose(f, g, h) is identical to doing
		 * (...args) => f(g(h(...args))).
		 */
	
		function compose() {
		  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
		    funcs[_key] = arguments[_key];
		  }
	
		  if (funcs.length === 0) {
		    return function (arg) {
		      return arg;
		    };
		  }
	
		  if (funcs.length === 1) {
		    return funcs[0];
		  }
	
		  var last = funcs[funcs.length - 1];
		  var rest = funcs.slice(0, -1);
		  return function () {
		    return rest.reduceRight(function (composed, f) {
		      return f(composed);
		    }, last.apply(undefined, arguments));
		  };
		}
	
	/***/ }),
	/* 143 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		exports['default'] = warning;
		/**
		 * Prints a warning in the console if it exists.
		 *
		 * @param {String} message The warning message.
		 * @returns {void}
		 */
		function warning(message) {
		  /* eslint-disable no-console */
		  if (typeof console !== 'undefined' && typeof console.error === 'function') {
		    console.error(message);
		  }
		  /* eslint-enable no-console */
		  try {
		    // This error was thrown as a convenience so that if you enable
		    // "break on all exceptions" in your console,
		    // it would pause the execution at this line.
		    throw new Error(message);
		    /* eslint-disable no-empty */
		  } catch (e) {}
		  /* eslint-enable no-empty */
		}
	
	/***/ }),
	/* 144 */
	/***/ (function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(243);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-toolbar.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-toolbar.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ }),
	/* 145 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var ListCache = __webpack_require__(52),
		    stackClear = __webpack_require__(483),
		    stackDelete = __webpack_require__(484),
		    stackGet = __webpack_require__(485),
		    stackHas = __webpack_require__(486),
		    stackSet = __webpack_require__(487);
	
		/**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Stack(entries) {
		  var data = this.__data__ = new ListCache(entries);
		  this.size = data.size;
		}
	
		// Add methods to `Stack`.
		Stack.prototype.clear = stackClear;
		Stack.prototype['delete'] = stackDelete;
		Stack.prototype.get = stackGet;
		Stack.prototype.has = stackHas;
		Stack.prototype.set = stackSet;
	
		module.exports = Stack;
	
	
	/***/ }),
	/* 146 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var castPath = __webpack_require__(148),
		    toKey = __webpack_require__(57);
	
		/**
		 * The base implementation of `_.get` without support for default values.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path of the property to get.
		 * @returns {*} Returns the resolved value.
		 */
		function baseGet(object, path) {
		  path = castPath(path, object);
	
		  var index = 0,
		      length = path.length;
	
		  while (object != null && index < length) {
		    object = object[toKey(path[index++])];
		  }
		  return (index && index == length) ? object : undefined;
		}
	
		module.exports = baseGet;
	
	
	/***/ }),
	/* 147 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseIsEqualDeep = __webpack_require__(428),
		    isObjectLike = __webpack_require__(32);
	
		/**
		 * The base implementation of `_.isEqual` which supports partial comparisons
		 * and tracks traversed objects.
		 *
		 * @private
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @param {boolean} bitmask The bitmask flags.
		 *  1 - Unordered comparison
		 *  2 - Partial comparison
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 */
		function baseIsEqual(value, other, bitmask, customizer, stack) {
		  if (value === other) {
		    return true;
		  }
		  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
		    return value !== value && other !== other;
		  }
		  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
		}
	
		module.exports = baseIsEqual;
	
	
	/***/ }),
	/* 148 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var isArray = __webpack_require__(13),
		    isKey = __webpack_require__(90),
		    stringToPath = __webpack_require__(488),
		    toString = __webpack_require__(497);
	
		/**
		 * Casts `value` to a path array if it's not one.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @param {Object} [object] The object to query keys on.
		 * @returns {Array} Returns the cast property path array.
		 */
		function castPath(value, object) {
		  if (isArray(value)) {
		    return value;
		  }
		  return isKey(value, object) ? [value] : stringToPath(toString(value));
		}
	
		module.exports = castPath;
	
	
	/***/ }),
	/* 149 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var SetCache = __webpack_require__(411),
		    arraySome = __webpack_require__(419),
		    cacheHas = __webpack_require__(441);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;
	
		/**
		 * A specialized version of `baseIsEqualDeep` for arrays with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Array} array The array to compare.
		 * @param {Array} other The other array to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `array` and `other` objects.
		 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
		 */
		function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
		  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
		      arrLength = array.length,
		      othLength = other.length;
	
		  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
		    return false;
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(array);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var index = -1,
		      result = true,
		      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
		  stack.set(array, other);
		  stack.set(other, array);
	
		  // Ignore non-index properties.
		  while (++index < arrLength) {
		    var arrValue = array[index],
		        othValue = other[index];
	
		    if (customizer) {
		      var compared = isPartial
		        ? customizer(othValue, arrValue, index, other, array, stack)
		        : customizer(arrValue, othValue, index, array, other, stack);
		    }
		    if (compared !== undefined) {
		      if (compared) {
		        continue;
		      }
		      result = false;
		      break;
		    }
		    // Recursively compare arrays (susceptible to call stack limits).
		    if (seen) {
		      if (!arraySome(other, function(othValue, othIndex) {
		            if (!cacheHas(seen, othIndex) &&
		                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
		              return seen.push(othIndex);
		            }
		          })) {
		        result = false;
		        break;
		      }
		    } else if (!(
		          arrValue === othValue ||
		            equalFunc(arrValue, othValue, bitmask, customizer, stack)
		        )) {
		      result = false;
		      break;
		    }
		  }
		  stack['delete'](array);
		  stack['delete'](other);
		  return result;
		}
	
		module.exports = equalArrays;
	
	
	/***/ }),
	/* 150 */
	115,
	/* 151 */
	116,
	/* 152 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(92);
	
		/**
		 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` if suitable for strict
		 *  equality comparisons, else `false`.
		 */
		function isStrictComparable(value) {
		  return value === value && !isObject(value);
		}
	
		module.exports = isStrictComparable;
	
	
	/***/ }),
	/* 153 */
	/***/ (function(module, exports) {
	
		/**
		 * A specialized version of `matchesProperty` for source values suitable
		 * for strict equality comparisons, i.e. `===`.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @param {*} srcValue The value to match.
		 * @returns {Function} Returns the new spec function.
		 */
		function matchesStrictComparable(key, srcValue) {
		  return function(object) {
		    if (object == null) {
		      return false;
		    }
		    return object[key] === srcValue &&
		      (srcValue !== undefined || (key in Object(object)));
		  };
		}
	
		module.exports = matchesStrictComparable;
	
	
	/***/ }),
	/* 154 */
	/***/ (function(module, exports) {
	
		/** Used for built-in method references. */
		var funcProto = Function.prototype;
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;
	
		/**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to convert.
		 * @returns {string} Returns the source code.
		 */
		function toSource(func) {
		  if (func != null) {
		    try {
		      return funcToString.call(func);
		    } catch (e) {}
		    try {
		      return (func + '');
		    } catch (e) {}
		  }
		  return '';
		}
	
		module.exports = toSource;
	
	
	/***/ }),
	/* 155 */
	46,
	/* 156 */
	[1789, 427, 32],
	/* 157 */
	[1795, 159, 91],
	/* 158 */
	[1801, 12, 496],
	/* 159 */
	[1807, 31, 92],
	/* 160 */
	[1810, 431, 440, 477],
	/* 161 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _shallowEqual = __webpack_require__(70);
	
		var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
		var _RowsContainer = __webpack_require__(64);
	
		var _RowsContainer2 = _interopRequireDefault(_RowsContainer);
	
		var _RowGroup = __webpack_require__(175);
	
		var _RowGroup2 = _interopRequireDefault(_RowGroup);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var PropTypes = React.PropTypes;
		var ScrollShim = __webpack_require__(176);
		var Row = __webpack_require__(34);
		var cellMetaDataShape = __webpack_require__(14);
		var RowUtils = __webpack_require__(63);
		__webpack_require__(26);
	
		var Canvas = React.createClass({
		  displayName: 'Canvas',
	
		  mixins: [ScrollShim],
	
		  propTypes: {
		    rowRenderer: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
		    rowHeight: PropTypes.number.isRequired,
		    height: PropTypes.number.isRequired,
		    width: PropTypes.number,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    style: PropTypes.string,
		    className: PropTypes.string,
		    displayStart: PropTypes.number.isRequired,
		    displayEnd: PropTypes.number.isRequired,
		    visibleStart: PropTypes.number.isRequired,
		    visibleEnd: PropTypes.number.isRequired,
		    colVisibleStart: PropTypes.number.isRequired,
		    colVisibleEnd: PropTypes.number.isRequired,
		    colDisplayStart: PropTypes.number.isRequired,
		    colDisplayEnd: PropTypes.number.isRequired,
		    rowsCount: PropTypes.number.isRequired,
		    rowGetter: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.array.isRequired]),
		    expandedRows: PropTypes.array,
		    onRows: PropTypes.func,
		    onScroll: PropTypes.func,
		    columns: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
		    cellMetaData: PropTypes.shape(cellMetaDataShape).isRequired,
		    selectedRows: PropTypes.array,
		    rowKey: React.PropTypes.string,
		    rowScrollTimeout: React.PropTypes.number,
		    contextMenu: PropTypes.element,
		    getSubRowDetails: PropTypes.func,
		    rowSelection: React.PropTypes.oneOfType([React.PropTypes.shape({
		      indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		    }), React.PropTypes.shape({
		      isSelectedKey: React.PropTypes.string.isRequired
		    }), React.PropTypes.shape({
		      keys: React.PropTypes.shape({
		        values: React.PropTypes.array.isRequired,
		        rowKey: React.PropTypes.string.isRequired
		      }).isRequired
		    })]),
		    rowGroupRenderer: React.PropTypes.func,
		    isScrolling: React.PropTypes.bool
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      rowRenderer: Row,
		      onRows: function onRows() {},
		      selectedRows: [],
		      rowScrollTimeout: 0
		    };
		  },
		  getInitialState: function getInitialState() {
		    return {
		      displayStart: this.props.displayStart,
		      displayEnd: this.props.displayEnd,
		      scrollingTimeout: null
		    };
		  },
		  componentWillMount: function componentWillMount() {
		    this._currentRowsLength = 0;
		    this._currentRowsRange = { start: 0, end: 0 };
		    this._scroll = { scrollTop: 0, scrollLeft: 0 };
		  },
		  componentDidMount: function componentDidMount() {
		    this.onRows();
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (nextProps.displayStart !== this.state.displayStart || nextProps.displayEnd !== this.state.displayEnd) {
		      this.setState({
		        displayStart: nextProps.displayStart,
		        displayEnd: nextProps.displayEnd
		      });
		    }
		  },
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
		    var shouldUpdate = nextState.displayStart !== this.state.displayStart || nextState.displayEnd !== this.state.displayEnd || nextState.scrollingTimeout !== this.state.scrollingTimeout || nextProps.rowsCount !== this.props.rowsCount || nextProps.rowHeight !== this.props.rowHeight || nextProps.columns !== this.props.columns || nextProps.width !== this.props.width || nextProps.height !== this.props.height || nextProps.cellMetaData !== this.props.cellMetaData || this.props.colDisplayStart !== nextProps.colDisplayStart || this.props.colDisplayEnd !== nextProps.colDisplayEnd || this.props.colVisibleStart !== nextProps.colVisibleStart || this.props.colVisibleEnd !== nextProps.colVisibleEnd || !(0, _shallowEqual2['default'])(nextProps.style, this.props.style);
		    return shouldUpdate;
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    this._currentRowsLength = 0;
		    this._currentRowsRange = { start: 0, end: 0 };
		    this._scroll = { scrollTop: 0, scrollLeft: 0 };
		  },
		  componentDidUpdate: function componentDidUpdate() {
		    if (this._scroll.scrollTop !== 0 && this._scroll.scrollLeft !== 0) {
		      this.setScrollLeft(this._scroll.scrollLeft);
		    }
		    this.onRows();
		  },
		  onRows: function onRows() {
		    if (this._currentRowsRange !== { start: 0, end: 0 }) {
		      this.props.onRows(this._currentRowsRange);
		      this._currentRowsRange = { start: 0, end: 0 };
		    }
		  },
		  onScroll: function onScroll(e) {
		    if (ReactDOM.findDOMNode(this) !== e.target) {
		      return;
		    }
		    this.appendScrollShim();
		    var scrollLeft = e.target.scrollLeft;
		    var scrollTop = e.target.scrollTop;
		    var scroll = { scrollTop: scrollTop, scrollLeft: scrollLeft };
		    this._scroll = scroll;
		    this.props.onScroll(scroll);
		  },
		  getSubRows: function getSubRows(row) {
		    var subRowDetails = this.props.getSubRowDetails(row);
		    if (subRowDetails.expanded === true) {
		      return subRowDetails.children.map(function (r) {
		        return { row: r };
		      });
		    }
		  },
		  addSubRows: function addSubRows(rowsInput, row, i, displayEnd, treeDepth) {
		    var _this = this;
	
		    var subRowDetails = this.props.getSubRowDetails(row) || {};
		    var rows = rowsInput;
		    var increment = i;
		    if (increment < displayEnd) {
		      subRowDetails.treeDepth = treeDepth;
		      rows.push({ row: row, subRowDetails: subRowDetails });
		      increment++;
		    }
		    if (subRowDetails && subRowDetails.expanded) {
		      var subRows = this.getSubRows(row);
		      subRows.forEach(function (sr) {
		        var result = _this.addSubRows(rows, sr.row, increment, displayEnd, treeDepth + 1);
		        rows = result.rows;
		        increment = result.increment;
		      });
		    }
		    return { rows: rows, increment: increment };
		  },
		  getRows: function getRows(displayStart, displayEnd) {
		    this._currentRowsRange = { start: displayStart, end: displayEnd };
		    if (Array.isArray(this.props.rowGetter)) {
		      return this.props.rowGetter.slice(displayStart, displayEnd);
		    }
		    var rows = [];
		    var rowFetchIndex = displayStart;
		    var i = displayStart;
		    while (i < displayEnd) {
		      var row = this.props.rowGetter(rowFetchIndex);
		      if (this.props.getSubRowDetails) {
		        var treeDepth = 0;
		        var result = this.addSubRows(rows, row, i, displayEnd, treeDepth);
		        rows = result.rows;
		        i = result.increment;
		      } else {
		        rows.push({ row: row });
		        i++;
		      }
		      rowFetchIndex++;
		    }
		    return rows;
		  },
		  getScrollbarWidth: function getScrollbarWidth() {
		    var scrollbarWidth = 0;
		    // Get the scrollbar width
		    var canvas = ReactDOM.findDOMNode(this);
		    scrollbarWidth = canvas.offsetWidth - canvas.clientWidth;
		    return scrollbarWidth;
		  },
		  getScroll: function getScroll() {
		    var _ReactDOM$findDOMNode = ReactDOM.findDOMNode(this),
		        scrollTop = _ReactDOM$findDOMNode.scrollTop,
		        scrollLeft = _ReactDOM$findDOMNode.scrollLeft;
	
		    return { scrollTop: scrollTop, scrollLeft: scrollLeft };
		  },
		  isRowSelected: function isRowSelected(idx, row) {
		    var _this2 = this;
	
		    // Use selectedRows if set
		    if (this.props.selectedRows !== null) {
		      var selectedRows = this.props.selectedRows.filter(function (r) {
		        var rowKeyValue = row.get ? row.get(_this2.props.rowKey) : row[_this2.props.rowKey];
		        return r[_this2.props.rowKey] === rowKeyValue;
		      });
		      return selectedRows.length > 0 && selectedRows[0].isSelected;
		    }
	
		    // Else use new rowSelection props
		    if (this.props.rowSelection) {
		      var _props$rowSelection = this.props.rowSelection,
		          keys = _props$rowSelection.keys,
		          indexes = _props$rowSelection.indexes,
		          isSelectedKey = _props$rowSelection.isSelectedKey;
	
		      return RowUtils.isRowSelected(keys, indexes, isSelectedKey, row, idx);
		    }
	
		    return false;
		  },
	
	
		  _currentRowsLength: 0,
		  _currentRowsRange: { start: 0, end: 0 },
		  _scroll: { scrollTop: 0, scrollLeft: 0 },
	
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    if (this._currentRowsLength !== 0) {
		      if (!this.rows) return;
		      for (var i = 0, len = this._currentRowsLength; i < len; i++) {
		        if (this.rows[i]) {
		          var row = this.getRowByRef(i);
		          if (row && row.setScrollLeft) {
		            row.setScrollLeft(scrollLeft);
		          }
		        }
		      }
		    }
		  },
		  getRowByRef: function getRowByRef(i) {
		    // check if wrapped with React DND drop target
		    var wrappedRow = this.rows[i].getDecoratedComponentInstance ? this.rows[i].getDecoratedComponentInstance(i) : null;
		    if (wrappedRow) {
		      return wrappedRow.row;
		    }
		    return this.rows[i];
		  },
	
	
		  rows: [],
	
		  renderRow: function renderRow(props) {
		    var row = props.row;
		    if (row.__metaData && row.__metaData.isGroup) {
		      return React.createElement(_RowGroup2['default'], _extends({
		        key: props.key,
		        name: row.name
		      }, row.__metaData, {
		        row: props.row,
		        idx: props.idx,
		        height: props.height,
		        cellMetaData: this.props.cellMetaData,
		        renderer: this.props.rowGroupRenderer,
		        columns: props.columns
		      }));
		    }
		    var RowsRenderer = this.props.rowRenderer;
		    if (typeof RowsRenderer === 'function') {
		      return React.createElement(RowsRenderer, props);
		    }
	
		    if (React.isValidElement(this.props.rowRenderer)) {
		      return React.cloneElement(this.props.rowRenderer, props);
		    }
		  },
		  renderPlaceholder: function renderPlaceholder(key, height) {
		    // just renders empty cells
		    // if we wanted to show gridlines, we'd need classes and position as with renderScrollingPlaceholder
		    return React.createElement(
		      'div',
		      { key: key, style: { height: height } },
		      this.props.columns.map(function (column, idx) {
		        return React.createElement('div', { style: { width: column.width }, key: idx });
		      })
		    );
		  },
		  render: function render() {
		    var _this3 = this;
	
		    var _state = this.state,
		        displayStart = _state.displayStart,
		        displayEnd = _state.displayEnd;
		    var _props = this.props,
		        rowHeight = _props.rowHeight,
		        rowsCount = _props.rowsCount;
	
	
		    var rows = this.getRows(displayStart, displayEnd).map(function (r, idx) {
		      return _this3.renderRow({
		        key: 'row-' + (displayStart + idx),
		        ref: function ref(node) {
		          return _this3.rows[idx] = node;
		        },
		        idx: displayStart + idx,
		        visibleStart: _this3.props.visibleStart,
		        visibleEnd: _this3.props.visibleEnd,
		        row: r.row,
		        height: rowHeight,
		        onMouseOver: _this3.onMouseOver,
		        columns: _this3.props.columns,
		        isSelected: _this3.isRowSelected(displayStart + idx, r.row, displayStart, displayEnd),
		        expandedRows: _this3.props.expandedRows,
		        cellMetaData: _this3.props.cellMetaData,
		        subRowDetails: r.subRowDetails,
		        colVisibleStart: _this3.props.colVisibleStart,
		        colVisibleEnd: _this3.props.colVisibleEnd,
		        colDisplayStart: _this3.props.colDisplayStart,
		        colDisplayEnd: _this3.props.colDisplayEnd,
		        isScrolling: _this3.props.isScrolling
		      });
		    });
	
		    this._currentRowsLength = rows.length;
	
		    if (displayStart > 0) {
		      rows.unshift(this.renderPlaceholder('top', displayStart * rowHeight));
		    }
	
		    if (rowsCount - displayEnd > 0) {
		      rows.push(this.renderPlaceholder('bottom', (rowsCount - displayEnd) * rowHeight));
		    }
	
		    var style = {
		      position: 'absolute',
		      top: 0,
		      left: 0,
		      overflowX: 'auto',
		      overflowY: 'scroll',
		      width: this.props.totalWidth,
		      height: this.props.height
		    };
	
		    return React.createElement(
		      'div',
		      {
		        style: style,
		        onScroll: this.onScroll,
		        className: joinClasses('react-grid-Canvas', this.props.className, { opaque: this.props.cellMetaData.selected && this.props.cellMetaData.selected.active }) },
		      React.createElement(_RowsContainer2['default'], {
		        width: this.props.width,
		        rows: rows,
		        contextMenu: this.props.contextMenu,
		        rowIdx: this.props.cellMetaData.selected.rowIdx,
		        idx: this.props.cellMetaData.selected.idx })
		    );
		  }
		});
	
		module.exports = Canvas;
	
	/***/ }),
	/* 162 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isValidElement = __webpack_require__(2).isValidElement;
	
		module.exports = function sameColumn(a, b) {
		  var k = void 0;
	
		  for (k in a) {
		    if (a.hasOwnProperty(k)) {
		      if (typeof a[k] === 'function' && typeof b[k] === 'function' || isValidElement(a[k]) && isValidElement(b[k])) {
		        continue;
		      }
		      if (!b.hasOwnProperty(k) || a[k] !== b[k]) {
		        return false;
		      }
		    }
		  }
	
		  for (k in b) {
		    if (b.hasOwnProperty(k) && !a.hasOwnProperty(k)) {
		      return false;
		    }
		  }
	
		  return true;
		};
	
	/***/ }),
	/* 163 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var ColumnMetrics = __webpack_require__(33);
		var DOMMetrics = __webpack_require__(23);
		Object.assign = __webpack_require__(71);
		var PropTypes = __webpack_require__(2).PropTypes;
		var ColumnUtils = __webpack_require__(10);
	
		var Column = function Column() {
		  _classCallCheck(this, Column);
		};
	
		module.exports = {
		  mixins: [DOMMetrics.MetricsMixin],
	
		  propTypes: {
		    columns: PropTypes.arrayOf(Column),
		    minColumnWidth: PropTypes.number,
		    columnEquality: PropTypes.func,
		    onColumnResize: PropTypes.func
		  },
	
		  DOMMetrics: {
		    gridWidth: function gridWidth() {
		      return _reactDom2['default'].findDOMNode(this).parentElement.offsetWidth;
		    }
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      minColumnWidth: 80,
		      columnEquality: ColumnMetrics.sameColumn
		    };
		  },
		  componentWillMount: function componentWillMount() {
		    this._mounted = true;
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (nextProps.columns) {
		      if (!ColumnMetrics.sameColumns(this.props.columns, nextProps.columns, this.props.columnEquality) || nextProps.minWidth !== this.props.minWidth) {
		        var columnMetrics = this.createColumnMetrics(nextProps);
		        this.setState({ columnMetrics: columnMetrics });
		      }
		    }
		  },
		  getTotalWidth: function getTotalWidth() {
		    var totalWidth = 0;
		    if (this._mounted) {
		      totalWidth = this.DOMMetrics.gridWidth();
		    } else {
		      totalWidth = ColumnUtils.getSize(this.props.columns) * this.props.minColumnWidth;
		    }
		    return totalWidth;
		  },
		  getColumnMetricsType: function getColumnMetricsType(metrics) {
		    var totalWidth = metrics.totalWidth || this.getTotalWidth();
		    var currentMetrics = {
		      columns: metrics.columns,
		      totalWidth: totalWidth,
		      minColumnWidth: metrics.minColumnWidth
		    };
		    var updatedMetrics = ColumnMetrics.recalculate(currentMetrics);
		    return updatedMetrics;
		  },
		  getColumn: function getColumn(idx) {
		    var columns = this.state.columnMetrics.columns;
		    if (Array.isArray(columns)) {
		      return columns[idx];
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.get(idx);
		    }
		  },
		  getSize: function getSize() {
		    var columns = this.state.columnMetrics.columns;
		    if (Array.isArray(columns)) {
		      return columns.length;
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.size;
		    }
		  },
		  metricsUpdated: function metricsUpdated() {
		    var columnMetrics = this.createColumnMetrics();
		    this.setState({ columnMetrics: columnMetrics });
		  },
		  createColumnMetrics: function createColumnMetrics() {
		    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
		    var gridColumns = this.setupGridColumns(props);
		    return this.getColumnMetricsType({
		      columns: gridColumns,
		      minColumnWidth: this.props.minColumnWidth,
		      totalWidth: props.minWidth
		    });
		  },
		  onColumnResize: function onColumnResize(index, width) {
		    var columnMetrics = ColumnMetrics.resizeColumn(this.state.columnMetrics, index, width);
		    this.setState({ columnMetrics: columnMetrics });
		    if (this.props.onColumnResize) {
		      this.props.onColumnResize(index, width);
		    }
		  }
		};
	
	/***/ }),
	/* 164 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var PropTypes = React.PropTypes;
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(19);
	
		// The list of the propTypes that we want to include in the Draggable div
		var knownDivPropertyKeys = ['onDragStart', 'onDragEnd', 'onDrag', 'style'];
	
		var Draggable = React.createClass({
		  displayName: 'Draggable',
	
		  propTypes: {
		    onDragStart: PropTypes.func,
		    onDragEnd: PropTypes.func,
		    onDrag: PropTypes.func,
		    component: PropTypes.oneOfType([PropTypes.func, PropTypes.constructor]),
		    style: PropTypes.object
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      onDragStart: function onDragStart() {
		        return true;
		      },
		      onDragEnd: function onDragEnd() {},
		      onDrag: function onDrag() {}
		    };
		  },
		  getInitialState: function getInitialState() {
		    return {
		      drag: null
		    };
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    this.cleanUp();
		  },
		  onMouseDown: function onMouseDown(e) {
		    var drag = this.props.onDragStart(e);
	
		    if (drag === null && e.button !== 0) {
		      return;
		    }
	
		    window.addEventListener('mouseup', this.onMouseUp);
		    window.addEventListener('mousemove', this.onMouseMove);
		    window.addEventListener('touchend', this.onMouseUp);
		    window.addEventListener('touchmove', this.onMouseMove);
	
		    this.setState({ drag: drag });
		  },
		  onMouseMove: function onMouseMove(e) {
		    if (this.state.drag === null) {
		      return;
		    }
	
		    if (e.preventDefault) {
		      e.preventDefault();
		    }
	
		    this.props.onDrag(e);
		  },
		  onMouseUp: function onMouseUp(e) {
		    this.cleanUp();
		    this.props.onDragEnd(e, this.state.drag);
		    this.setState({ drag: null });
		  },
		  cleanUp: function cleanUp() {
		    window.removeEventListener('mouseup', this.onMouseUp);
		    window.removeEventListener('mousemove', this.onMouseMove);
		    window.removeEventListener('touchend', this.onMouseUp);
		    window.removeEventListener('touchmove', this.onMouseMove);
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  render: function render() {
		    return React.createElement('div', _extends({}, this.getKnownDivProps(), {
		      onMouseDown: this.onMouseDown,
		      onTouchStart: this.onMouseDown,
		      className: 'react-grid-HeaderCell__draggable' }));
		  }
		});
	
		module.exports = Draggable;
	
	/***/ }),
	/* 165 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var PropTypes = React.PropTypes;
		var Header = __webpack_require__(167);
		var Viewport = __webpack_require__(177);
		var GridScrollMixin = __webpack_require__(166);
		var DOMMetrics = __webpack_require__(23);
		var cellMetaDataShape = __webpack_require__(14);
		__webpack_require__(26);
	
		var Grid = React.createClass({
		  displayName: 'Grid',
	
		  propTypes: {
		    rowGetter: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
		    columns: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
		    columnMetrics: PropTypes.object,
		    minHeight: PropTypes.number,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    headerRows: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
		    rowHeight: PropTypes.number,
		    rowRenderer: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
		    emptyRowsView: PropTypes.func,
		    expandedRows: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
		    selectedRows: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
		    rowSelection: React.PropTypes.oneOfType([React.PropTypes.shape({
		      indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		    }), React.PropTypes.shape({
		      isSelectedKey: React.PropTypes.string.isRequired
		    }), React.PropTypes.shape({
		      keys: React.PropTypes.shape({
		        values: React.PropTypes.array.isRequired,
		        rowKey: React.PropTypes.string.isRequired
		      }).isRequired
		    })]),
		    rowsCount: PropTypes.number,
		    onRows: PropTypes.func,
		    sortColumn: React.PropTypes.string,
		    sortDirection: React.PropTypes.oneOf(['ASC', 'DESC', 'NONE']),
		    rowOffsetHeight: PropTypes.number.isRequired,
		    onViewportKeydown: PropTypes.func.isRequired,
		    onViewportKeyup: PropTypes.func,
		    onViewportDragStart: PropTypes.func.isRequired,
		    onViewportDragEnd: PropTypes.func.isRequired,
		    onViewportDoubleClick: PropTypes.func.isRequired,
		    onColumnResize: PropTypes.func,
		    onSort: PropTypes.func,
		    onHeaderDrop: PropTypes.func,
		    cellMetaData: PropTypes.shape(cellMetaDataShape),
		    rowKey: PropTypes.string.isRequired,
		    rowScrollTimeout: PropTypes.number,
		    contextMenu: PropTypes.element,
		    getSubRowDetails: PropTypes.func,
		    draggableHeaderCell: PropTypes.func,
		    getValidFilterValues: PropTypes.func,
		    rowGroupRenderer: PropTypes.func,
		    overScan: PropTypes.object
		  },
	
		  mixins: [GridScrollMixin, DOMMetrics.MetricsComputatorMixin],
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      rowHeight: 35,
		      minHeight: 350
		    };
		  },
	
	
		  getStyle: function getStyle() {
		    return {
		      overflow: 'hidden',
		      outline: 0,
		      position: 'relative',
		      minHeight: this.props.minHeight
		    };
		  },
	
		  render: function render() {
		    var _this = this;
	
		    var headerRows = this.props.headerRows || [{ ref: function ref(node) {
		        return _this.row = node;
		      } }];
		    var EmptyRowsView = this.props.emptyRowsView;
	
		    return React.createElement(
		      'div',
		      { style: this.getStyle(), className: 'react-grid-Grid' },
		      React.createElement(Header, {
		        ref: function ref(input) {
		          _this.header = input;
		        },
		        columnMetrics: this.props.columnMetrics,
		        onColumnResize: this.props.onColumnResize,
		        height: this.props.rowHeight,
		        totalWidth: this.props.totalWidth,
		        headerRows: headerRows,
		        sortColumn: this.props.sortColumn,
		        sortDirection: this.props.sortDirection,
		        draggableHeaderCell: this.props.draggableHeaderCell,
		        onSort: this.props.onSort,
		        onHeaderDrop: this.props.onHeaderDrop,
		        onScroll: this.onHeaderScroll,
		        getValidFilterValues: this.props.getValidFilterValues,
		        cellMetaData: this.props.cellMetaData
		      }),
		      this.props.rowsCount >= 1 || this.props.rowsCount === 0 && !this.props.emptyRowsView ? React.createElement(
		        'div',
		        { ref: function ref(node) {
		            _this.viewPortContainer = node;
		          }, tabIndex: '0', onKeyDown: this.props.onViewportKeydown, onKeyUp: this.props.onViewportKeyup, onDoubleClick: this.props.onViewportDoubleClick, onDragStart: this.props.onViewportDragStart, onDragEnd: this.props.onViewportDragEnd },
		        React.createElement(Viewport, {
		          ref: function ref(node) {
		            _this.viewport = node;
		          },
		          rowKey: this.props.rowKey,
		          width: this.props.columnMetrics.width,
		          rowHeight: this.props.rowHeight,
		          rowRenderer: this.props.rowRenderer,
		          rowGetter: this.props.rowGetter,
		          rowsCount: this.props.rowsCount,
		          selectedRows: this.props.selectedRows,
		          expandedRows: this.props.expandedRows,
		          columnMetrics: this.props.columnMetrics,
		          totalWidth: this.props.totalWidth,
		          onScroll: this.onScroll,
		          onRows: this.props.onRows,
		          cellMetaData: this.props.cellMetaData,
		          rowOffsetHeight: this.props.rowOffsetHeight || this.props.rowHeight * headerRows.length,
		          minHeight: this.props.minHeight,
		          rowScrollTimeout: this.props.rowScrollTimeout,
		          contextMenu: this.props.contextMenu,
		          rowSelection: this.props.rowSelection,
		          getSubRowDetails: this.props.getSubRowDetails,
		          rowGroupRenderer: this.props.rowGroupRenderer,
		          overScan: this.props.overScan
		        })
		      ) : React.createElement(
		        'div',
		        { ref: function ref(node) {
		            _this.emptyView = node;
		          }, className: 'react-grid-Empty' },
		        React.createElement(EmptyRowsView, null)
		      )
		    );
		  }
		});
	
		module.exports = Grid;
	
	/***/ }),
	/* 166 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var ReactDOM = __webpack_require__(4);
	
		module.exports = {
		  componentDidMount: function componentDidMount() {
		    this._scrollLeft = this.viewport ? this.viewport.getScroll().scrollLeft : 0;
		    this._onScroll();
		  },
		  componentDidUpdate: function componentDidUpdate() {
		    this._onScroll();
		  },
		  componentWillMount: function componentWillMount() {
		    this._scrollLeft = undefined;
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    this._scrollLeft = undefined;
		  },
		  onScroll: function onScroll(props) {
		    if (this._scrollLeft !== props.scrollLeft) {
		      this._scrollLeft = props.scrollLeft;
		      this._onScroll();
		    }
		  },
		  onHeaderScroll: function onHeaderScroll(e) {
		    var scrollLeft = e.target.scrollLeft;
		    if (this._scrollLeft !== scrollLeft) {
		      this._scrollLeft = scrollLeft;
		      this.header.setScrollLeft(scrollLeft);
		      var canvas = ReactDOM.findDOMNode(this.viewport.canvas);
		      canvas.scrollLeft = scrollLeft;
		      this.viewport.canvas.setScrollLeft(scrollLeft);
		    }
		  },
		  _onScroll: function _onScroll() {
		    if (this._scrollLeft !== undefined) {
		      this.header.setScrollLeft(this._scrollLeft);
		      if (this.viewport) {
		        this.viewport.setScrollLeft(this._scrollLeft);
		      }
		    }
		  }
		};
	
	/***/ }),
	/* 167 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var shallowCloneObject = __webpack_require__(36);
		var ColumnMetrics = __webpack_require__(33);
		var ColumnUtils = __webpack_require__(10);
		var HeaderRow = __webpack_require__(169);
		var getScrollbarSize = __webpack_require__(35);
		var PropTypes = React.PropTypes;
		var createObjectWithProperties = __webpack_require__(17);
		var cellMetaDataShape = __webpack_require__(14);
		__webpack_require__(19);
	
		// The list of the propTypes that we want to include in the Header div
		var knownDivPropertyKeys = ['height', 'onScroll'];
	
		var Header = React.createClass({
		  displayName: 'Header',
	
		  propTypes: {
		    columnMetrics: PropTypes.shape({ width: PropTypes.number.isRequired, columns: PropTypes.any }).isRequired,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    height: PropTypes.number.isRequired,
		    headerRows: PropTypes.array.isRequired,
		    sortColumn: PropTypes.string,
		    sortDirection: PropTypes.oneOf(['ASC', 'DESC', 'NONE']),
		    onSort: PropTypes.func,
		    onColumnResize: PropTypes.func,
		    onScroll: PropTypes.func,
		    onHeaderDrop: PropTypes.func,
		    draggableHeaderCell: PropTypes.func,
		    getValidFilterValues: PropTypes.func,
		    cellMetaData: PropTypes.shape(cellMetaDataShape)
		  },
	
		  getInitialState: function getInitialState() {
		    return { resizing: null };
		  },
		  componentWillReceiveProps: function componentWillReceiveProps() {
		    this.setState({ resizing: null });
		  },
	
	
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
		    var update = !ColumnMetrics.sameColumns(this.props.columnMetrics.columns, nextProps.columnMetrics.columns, ColumnMetrics.sameColumn) || this.props.totalWidth !== nextProps.totalWidth || this.props.headerRows.length !== nextProps.headerRows.length || this.state.resizing !== nextState.resizing || this.props.sortColumn !== nextProps.sortColumn || this.props.sortDirection !== nextProps.sortDirection;
		    return update;
		  },
	
		  onColumnResize: function onColumnResize(column, width) {
		    var state = this.state.resizing || this.props;
	
		    var pos = this.getColumnPosition(column);
	
		    if (pos != null) {
		      var _resizing = {
		        columnMetrics: shallowCloneObject(state.columnMetrics)
		      };
		      _resizing.columnMetrics = ColumnMetrics.resizeColumn(_resizing.columnMetrics, pos, width);
	
		      // we don't want to influence scrollLeft while resizing
		      if (_resizing.columnMetrics.totalWidth < state.columnMetrics.totalWidth) {
		        _resizing.columnMetrics.totalWidth = state.columnMetrics.totalWidth;
		      }
	
		      _resizing.column = ColumnUtils.getColumn(_resizing.columnMetrics.columns, pos);
		      this.setState({ resizing: _resizing });
		    }
		  },
		  onColumnResizeEnd: function onColumnResizeEnd(column, width) {
		    var pos = this.getColumnPosition(column);
		    if (pos !== null && this.props.onColumnResize) {
		      this.props.onColumnResize(pos, width || column.width);
		    }
		  },
		  getHeaderRows: function getHeaderRows() {
		    var _this = this;
	
		    var columnMetrics = this.getColumnMetrics();
		    var resizeColumn = void 0;
		    if (this.state.resizing) {
		      resizeColumn = this.state.resizing.column;
		    }
		    var headerRows = [];
		    this.props.headerRows.forEach(function (row, index) {
		      // To allow header filters to be visible
		      var rowHeight = 'auto';
		      if (row.rowType === 'filter') {
		        rowHeight = '500px';
		      }
		      var scrollbarSize = getScrollbarSize() > 0 ? getScrollbarSize() : 0;
		      var updatedWidth = isNaN(_this.props.totalWidth - scrollbarSize) ? _this.props.totalWidth : _this.props.totalWidth - scrollbarSize;
		      var headerRowStyle = {
		        position: 'absolute',
		        top: _this.getCombinedHeaderHeights(index),
		        left: 0,
		        width: updatedWidth,
		        overflowX: 'hidden',
		        minHeight: rowHeight
		      };
	
		      headerRows.push(React.createElement(HeaderRow, {
		        key: row.ref,
		        ref: function ref(node) {
		          return _this.row = node;
		        },
		        rowType: row.rowType,
		        style: headerRowStyle,
		        onColumnResize: _this.onColumnResize,
		        onColumnResizeEnd: _this.onColumnResizeEnd,
		        width: columnMetrics.width,
		        height: row.height || _this.props.height,
		        columns: columnMetrics.columns,
		        resizing: resizeColumn,
		        draggableHeaderCell: _this.props.draggableHeaderCell,
		        filterable: row.filterable,
		        onFilterChange: row.onFilterChange,
		        onHeaderDrop: _this.props.onHeaderDrop,
		        sortColumn: _this.props.sortColumn,
		        sortDirection: _this.props.sortDirection,
		        onSort: _this.props.onSort,
		        onScroll: _this.props.onScroll,
		        getValidFilterValues: _this.props.getValidFilterValues
		      }));
		    });
		    return headerRows;
		  },
		  getColumnMetrics: function getColumnMetrics() {
		    var columnMetrics = void 0;
		    if (this.state.resizing) {
		      columnMetrics = this.state.resizing.columnMetrics;
		    } else {
		      columnMetrics = this.props.columnMetrics;
		    }
		    return columnMetrics;
		  },
		  getColumnPosition: function getColumnPosition(column) {
		    var columnMetrics = this.getColumnMetrics();
		    var pos = -1;
		    columnMetrics.columns.forEach(function (c, idx) {
		      if (c.key === column.key) {
		        pos = idx;
		      }
		    });
		    return pos === -1 ? null : pos;
		  },
		  getCombinedHeaderHeights: function getCombinedHeaderHeights(until) {
		    var stopAt = this.props.headerRows.length;
		    if (typeof until !== 'undefined') {
		      stopAt = until;
		    }
	
		    var height = 0;
		    for (var index = 0; index < stopAt; index++) {
		      height += this.props.headerRows[index].height || this.props.height;
		    }
		    return height;
		  },
		  getStyle: function getStyle() {
		    return {
		      position: 'relative',
		      height: this.getCombinedHeaderHeights()
		    };
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var node = ReactDOM.findDOMNode(this.row);
		    node.scrollLeft = scrollLeft;
		    this.row.setScrollLeft(scrollLeft);
		    if (this.filterRow) {
		      var nodeFilters = this.filterRow;
		      nodeFilters.scrollLeft = scrollLeft;
		      this.filterRow.setScrollLeft(scrollLeft);
		    }
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
	
	
		  // Set the cell selection to -1 x -1 when clicking on the header
		  onHeaderClick: function onHeaderClick() {
		    this.props.cellMetaData.onCellClick({ rowIdx: -1, idx: -1 });
		  },
		  render: function render() {
		    var className = joinClasses({
		      'react-grid-Header': true,
		      'react-grid-Header--resizing': !!this.state.resizing
		    });
		    var headerRows = this.getHeaderRows();
	
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { style: this.getStyle(), className: className, onClick: this.onHeaderClick }),
		      headerRows
		    );
		  }
		});
	
		module.exports = Header;
	
	/***/ }),
	/* 168 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		var HeaderCellType = {
		  SORTABLE: 0,
		  FILTERABLE: 1,
		  NONE: 2,
		  CHECKBOX: 3
		};
	
		module.exports = HeaderCellType;
	
	/***/ }),
	/* 169 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var shallowEqual = __webpack_require__(70);
		var BaseHeaderCell = __webpack_require__(60);
		var getScrollbarSize = __webpack_require__(35);
		var ExcelColumn = __webpack_require__(11);
		var ColumnUtilsMixin = __webpack_require__(10);
		var SortableHeaderCell = __webpack_require__(180);
		var FilterableHeaderCell = __webpack_require__(179);
		var HeaderCellType = __webpack_require__(168);
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(19);
	
		var PropTypes = React.PropTypes;
	
		var HeaderRowStyle = {
		  overflow: React.PropTypes.string,
		  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		  height: React.PropTypes.number,
		  position: React.PropTypes.string
		};
	
		// The list of the propTypes that we want to include in the HeaderRow div
		var knownDivPropertyKeys = ['width', 'height', 'style', 'onScroll'];
	
		var HeaderRow = React.createClass({
		  displayName: 'HeaderRow',
	
		  propTypes: {
		    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    height: PropTypes.number.isRequired,
		    columns: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
		    onColumnResize: PropTypes.func,
		    onSort: PropTypes.func.isRequired,
		    onColumnResizeEnd: PropTypes.func,
		    style: PropTypes.shape(HeaderRowStyle),
		    sortColumn: PropTypes.string,
		    sortDirection: React.PropTypes.oneOf(Object.keys(SortableHeaderCell.DEFINE_SORT)),
		    cellRenderer: PropTypes.func,
		    headerCellRenderer: PropTypes.func,
		    filterable: PropTypes.bool,
		    onFilterChange: PropTypes.func,
		    resizing: PropTypes.object,
		    onScroll: PropTypes.func,
		    rowType: PropTypes.string,
		    draggableHeaderCell: PropTypes.func,
		    onHeaderDrop: PropTypes.func
		  },
	
		  mixins: [ColumnUtilsMixin],
	
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    return nextProps.width !== this.props.width || nextProps.height !== this.props.height || nextProps.columns !== this.props.columns || !shallowEqual(nextProps.style, this.props.style) || this.props.sortColumn !== nextProps.sortColumn || this.props.sortDirection !== nextProps.sortDirection;
		  },
	
	
		  cells: [],
	
		  getHeaderCellType: function getHeaderCellType(column) {
		    if (column.filterable) {
		      if (this.props.filterable) return HeaderCellType.FILTERABLE;
		    }
	
		    if (column.sortable) return HeaderCellType.SORTABLE;
	
		    return HeaderCellType.NONE;
		  },
		  getFilterableHeaderCell: function getFilterableHeaderCell(column) {
		    var FilterRenderer = FilterableHeaderCell;
		    if (column.filterRenderer !== undefined) {
		      FilterRenderer = column.filterRenderer;
		    }
		    return React.createElement(FilterRenderer, _extends({}, this.props, { onChange: this.props.onFilterChange }));
		  },
		  getSortableHeaderCell: function getSortableHeaderCell(column) {
		    var sortDirection = this.props.sortColumn === column.key ? this.props.sortDirection : SortableHeaderCell.DEFINE_SORT.NONE;
		    return React.createElement(SortableHeaderCell, { columnKey: column.key, onSort: this.props.onSort, sortDirection: sortDirection });
		  },
		  getHeaderRenderer: function getHeaderRenderer(column) {
		    var renderer = void 0;
		    if (column.headerRenderer && !this.props.filterable) {
		      renderer = column.headerRenderer;
		    } else {
		      var headerCellType = this.getHeaderCellType(column);
		      switch (headerCellType) {
		        case HeaderCellType.SORTABLE:
		          renderer = this.getSortableHeaderCell(column);
		          break;
		        case HeaderCellType.FILTERABLE:
		          renderer = this.getFilterableHeaderCell(column);
		          break;
		        default:
		          break;
		      }
		    }
		    return renderer;
		  },
		  getStyle: function getStyle() {
		    return {
		      overflow: 'hidden',
		      width: '100%',
		      height: this.props.height,
		      position: 'absolute'
		    };
		  },
		  getCells: function getCells() {
		    var _this = this;
	
		    var cells = [];
		    var lockedCells = [];
	
		    var _loop = function _loop(i, len) {
		      var column = Object.assign({ rowType: _this.props.rowType }, _this.getColumn(_this.props.columns, i));
		      var _renderer = _this.getHeaderRenderer(column);
		      if (column.key === 'select-row' && _this.props.rowType === 'filter') {
		        _renderer = React.createElement('div', null);
		      }
		      var HeaderCell = column.draggable ? _this.props.draggableHeaderCell : BaseHeaderCell;
		      var cell = React.createElement(HeaderCell, {
		        ref: function ref(node) {
		          return _this.cells[i] = node;
		        },
		        key: i,
		        height: _this.props.height,
		        column: column,
		        renderer: _renderer,
		        resizing: _this.props.resizing === column,
		        onResize: _this.props.onColumnResize,
		        onResizeEnd: _this.props.onColumnResizeEnd,
		        onHeaderDrop: _this.props.onHeaderDrop
		      });
		      if (column.locked) {
		        lockedCells.push(cell);
		      } else {
		        cells.push(cell);
		      }
		    };
	
		    for (var i = 0, len = this.getSize(this.props.columns); i < len; i++) {
		      _loop(i, len);
		    }
	
		    return cells.concat(lockedCells);
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var _this2 = this;
	
		    this.props.columns.forEach(function (column, i) {
		      if (column.locked) {
		        _this2.cells[i].setScrollLeft(scrollLeft);
		      } else {
		        if (_this2.cells[i] && _this2.cells[i].removeScroll) {
		          _this2.cells[i].removeScroll();
		        }
		      }
		    });
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  render: function render() {
		    var cellsStyle = {
		      width: this.props.width ? this.props.width + getScrollbarSize() : '100%',
		      height: this.props.height,
		      whiteSpace: 'nowrap',
		      overflowX: 'hidden',
		      overflowY: 'hidden'
		    };
	
		    var cells = this.getCells();
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { className: 'react-grid-HeaderRow' }),
		      React.createElement(
		        'div',
		        { style: cellsStyle },
		        cells
		      )
		    );
		  }
		});
	
		module.exports = HeaderRow;
	
	/***/ }),
	/* 170 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		module.exports = {
		  Backspace: 8,
		  Tab: 9,
		  Enter: 13,
		  Shift: 16,
		  Ctrl: 17,
		  Alt: 18,
		  PauseBreak: 19,
		  CapsLock: 20,
		  Escape: 27,
		  PageUp: 33,
		  PageDown: 34,
		  End: 35,
		  Home: 36,
		  LeftArrow: 37,
		  UpArrow: 38,
		  RightArrow: 39,
		  DownArrow: 40,
		  Insert: 45,
		  Delete: 46,
		  0: 48,
		  1: 49,
		  2: 50,
		  3: 51,
		  4: 52,
		  5: 53,
		  6: 54,
		  7: 55,
		  8: 56,
		  9: 57,
		  a: 65,
		  b: 66,
		  c: 67,
		  d: 68,
		  e: 69,
		  f: 70,
		  g: 71,
		  h: 72,
		  i: 73,
		  j: 74,
		  k: 75,
		  l: 76,
		  m: 77,
		  n: 78,
		  o: 79,
		  p: 80,
		  q: 81,
		  r: 82,
		  s: 83,
		  t: 84,
		  u: 85,
		  v: 86,
		  w: 87,
		  x: 88,
		  y: 89,
		  z: 90,
		  LeftWindowKey: 91,
		  RightWindowKey: 92,
		  SelectKey: 93,
		  NumPad0: 96,
		  NumPad1: 97,
		  NumPad2: 98,
		  NumPad3: 99,
		  NumPad4: 100,
		  NumPad5: 101,
		  NumPad6: 102,
		  NumPad7: 103,
		  NumPad8: 104,
		  NumPad9: 105,
		  Multiply: 106,
		  Add: 107,
		  Subtract: 109,
		  DecimalPoint: 110,
		  Divide: 111,
		  F1: 112,
		  F2: 113,
		  F3: 114,
		  F4: 115,
		  F5: 116,
		  F6: 117,
		  F7: 118,
		  F8: 119,
		  F9: 120,
		  F10: 121,
		  F12: 123,
		  NumLock: 144,
		  ScrollLock: 145,
		  SemiColon: 186,
		  EqualSign: 187,
		  Comma: 188,
		  Dash: 189,
		  Period: 190,
		  ForwardSlash: 191,
		  GraveAccent: 192,
		  OpenBracket: 219,
		  BackSlash: 220,
		  CloseBracket: 221,
		  SingleQuote: 222
		};
	
	/***/ }),
	/* 171 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.OverflowCellComponent = undefined;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _focusableComponentWrapper = __webpack_require__(183);
	
		var _focusableComponentWrapper2 = _interopRequireDefault(_focusableComponentWrapper);
	
		__webpack_require__(38);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var OverflowCell = function (_React$Component) {
		  _inherits(OverflowCell, _React$Component);
	
		  function OverflowCell() {
		    _classCallCheck(this, OverflowCell);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  OverflowCell.prototype.getStyle = function getStyle() {
		    var style = {
		      position: 'absolute',
		      width: this.props.column.width,
		      height: this.props.height,
		      left: this.props.column.left,
		      border: '1px solid #eee'
		    };
		    return style;
		  };
	
		  OverflowCell.prototype.render = function render() {
		    return _react2['default'].createElement('div', { tabIndex: '-1', style: this.getStyle(), width: '100%', className: 'react-grid-Cell' });
		  };
	
		  return OverflowCell;
		}(_react2['default'].Component);
	
		OverflowCell.isSelected = function (props) {
		  var cellMetaData = props.cellMetaData,
		      rowIdx = props.rowIdx,
		      idx = props.idx;
	
		  if (cellMetaData == null) {
		    return false;
		  }
	
		  var selected = cellMetaData.selected;
	
	
		  return selected && selected.rowIdx === rowIdx && selected.idx === idx;
		};
	
		OverflowCell.isScrolling = function (props) {
		  return props.cellMetaData.isScrollingHorizontallyWithKeyboard;
		};
	
		OverflowCell.propTypes = {
		  rowIdx: _react2['default'].PropTypes.number,
		  idx: _react2['default'].PropTypes.number,
		  height: _react2['default'].PropTypes.number,
		  column: _react2['default'].PropTypes.object,
		  cellMetaData: _react2['default'].PropTypes.object
		};
	
		OverflowCell.displayName = 'Cell';
	
		var OverflowCellComponent = OverflowCell;
		exports['default'] = (0, _focusableComponentWrapper2['default'])(OverflowCell);
		exports.OverflowCellComponent = OverflowCellComponent;
	
	/***/ }),
	/* 172 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _ExcelColumn = __webpack_require__(11);
	
		var _ExcelColumn2 = _interopRequireDefault(_ExcelColumn);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		exports['default'] = { ExcelColumn: _ExcelColumn2['default'] };
	
	/***/ }),
	/* 173 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _AppConstants = __webpack_require__(58);
	
		var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var BaseGrid = __webpack_require__(165);
		var Row = __webpack_require__(34);
		var ExcelColumn = __webpack_require__(11);
		var KeyboardHandlerMixin = __webpack_require__(61);
		var CheckboxEditor = __webpack_require__(65);
		var DOMMetrics = __webpack_require__(23);
		var ColumnMetricsMixin = __webpack_require__(163);
		var RowUtils = __webpack_require__(63);
		var ColumnUtils = __webpack_require__(10);
		var KeyCodes = __webpack_require__(170);
	
		__webpack_require__(26);
		__webpack_require__(72);
	
		if (!Object.assign) {
		  Object.assign = __webpack_require__(71);
		}
	
		var ReactDataGrid = React.createClass({
		  displayName: 'ReactDataGrid',
	
	
		  mixins: [ColumnMetricsMixin, DOMMetrics.MetricsComputatorMixin, KeyboardHandlerMixin],
	
		  propTypes: {
		    rowHeight: React.PropTypes.number.isRequired,
		    headerRowHeight: React.PropTypes.number,
		    headerFiltersHeight: React.PropTypes.number,
		    minHeight: React.PropTypes.number.isRequired,
		    minWidth: React.PropTypes.number,
		    enableRowSelect: React.PropTypes.oneOfType([React.PropTypes.bool, React.PropTypes.string]),
		    onRowUpdated: React.PropTypes.func,
		    rowGetter: React.PropTypes.func.isRequired,
		    rowsCount: React.PropTypes.number.isRequired,
		    toolbar: React.PropTypes.element,
		    enableCellSelect: React.PropTypes.bool,
		    columns: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.array]).isRequired,
		    onFilter: React.PropTypes.func,
		    onCellCopyPaste: React.PropTypes.func,
		    onCellsDragged: React.PropTypes.func,
		    onAddFilter: React.PropTypes.func,
		    onGridSort: React.PropTypes.func,
		    onDragHandleDoubleClick: React.PropTypes.func,
		    onGridRowsUpdated: React.PropTypes.func,
		    onRowSelect: React.PropTypes.func,
		    rowKey: React.PropTypes.string,
		    rowScrollTimeout: React.PropTypes.number,
		    onClearFilters: React.PropTypes.func,
		    contextMenu: React.PropTypes.element,
		    cellNavigationMode: React.PropTypes.oneOf(['none', 'loopOverRow', 'changeRow']),
		    onCellSelected: React.PropTypes.func,
		    onCellDeSelected: React.PropTypes.func,
		    onCellExpand: React.PropTypes.func,
		    enableDragAndDrop: React.PropTypes.bool,
		    onRowExpandToggle: React.PropTypes.func,
		    draggableHeaderCell: React.PropTypes.func,
		    getValidFilterValues: React.PropTypes.func,
		    rowSelection: React.PropTypes.shape({
		      enableShiftSelect: React.PropTypes.bool,
		      onRowsSelected: React.PropTypes.func,
		      onRowsDeselected: React.PropTypes.func,
		      showCheckbox: React.PropTypes.bool,
		      selectBy: React.PropTypes.oneOfType([React.PropTypes.shape({
		        indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		      }), React.PropTypes.shape({
		        isSelectedKey: React.PropTypes.string.isRequired
		      }), React.PropTypes.shape({
		        keys: React.PropTypes.shape({
		          values: React.PropTypes.array.isRequired,
		          rowKey: React.PropTypes.string.isRequired
		        }).isRequired
		      })]).isRequired
		    }),
		    onRowClick: React.PropTypes.func,
		    onGridKeyUp: React.PropTypes.func,
		    onGridKeyDown: React.PropTypes.func,
		    rowGroupRenderer: React.PropTypes.func,
		    rowActionsCell: React.PropTypes.func,
		    onCheckCellIsEditable: React.PropTypes.func,
		    /* called before cell is set active, returns a boolean to determine whether cell is editable */
		    overScan: React.PropTypes.object
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      enableCellSelect: false,
		      tabIndex: -1,
		      rowHeight: 35,
		      headerFiltersHeight: 45,
		      enableRowSelect: false,
		      minHeight: 350,
		      rowKey: 'id',
		      rowScrollTimeout: 0,
		      cellNavigationMode: 'none',
		      overScan: {
		        colsStart: 5,
		        colsEnd: 5,
		        rowsStart: 5,
		        rowsEnd: 5
		      }
		    };
		  },
	
	
		  getInitialState: function getInitialState() {
		    var columnMetrics = this.createColumnMetrics();
		    var initialState = { columnMetrics: columnMetrics, selectedRows: [], copied: null, expandedRows: [], canFilter: false, columnFilters: {}, sortDirection: null, sortColumn: null, dragged: null, scrollOffset: 0, lastRowIdxUiSelected: -1 };
		    if (this.props.enableCellSelect) {
		      initialState.selected = { rowIdx: 0, idx: 0 };
		    } else {
		      initialState.selected = { rowIdx: -1, idx: -1 };
		    }
		    return initialState;
		  },
	
		  hasSelectedCellChanged: function hasSelectedCellChanged(selected) {
		    var previouslySelected = Object.assign({}, this.state.selected);
		    return previouslySelected.rowIdx !== selected.rowIdx || previouslySelected.idx !== selected.idx || previouslySelected.active === false;
		  },
	
		  onContextMenuHide: function onContextMenuHide() {
		    document.removeEventListener('click', this.onContextMenuHide);
		    var newSelected = Object.assign({}, this.state.selected, { contextMenuDisplayed: false });
		    this.setState({ selected: newSelected });
		  },
	
		  onColumnEvent: function onColumnEvent(ev, columnEvent) {
		    var idx = columnEvent.idx,
		        name = columnEvent.name;
	
	
		    if (name && typeof idx !== 'undefined') {
		      var column = this.getColumn(idx);
	
		      if (column && column.events && column.events[name] && typeof column.events[name] === 'function') {
		        var eventArgs = {
		          rowIdx: columnEvent.rowIdx,
		          idx: idx,
		          column: column
		        };
	
		        column.events[name](ev, eventArgs);
		      }
		    }
		  },
	
		  onSelect: function onSelect(selected) {
		    var _this = this;
	
		    if (this.state.selected.rowIdx !== selected.rowIdx || this.state.selected.idx !== selected.idx || this.state.selected.active === false) {
		      var _idx = selected.idx;
		      var _rowIdx = selected.rowIdx;
		      if (this.isCellWithinBounds(selected)) {
		        var oldSelection = this.state.selected;
		        this.setState({ selected: selected }, function () {
		          if (typeof _this.props.onCellDeSelected === 'function') {
		            _this.props.onCellDeSelected(oldSelection);
		          }
		          if (typeof _this.props.onCellSelected === 'function') {
		            _this.props.onCellSelected(selected);
		          }
		        });
		      } else if (_rowIdx === -1 && _idx === -1) {
		        // When it's outside of the grid, set rowIdx anyway
		        this.setState({ selected: { idx: _idx, rowIdx: _rowIdx } });
		      }
		    }
		  },
	
		  onCellClick: function onCellClick(cell) {
		    this.onSelect({ rowIdx: cell.rowIdx, idx: cell.idx });
	
		    if (this.props.onRowClick && typeof this.props.onRowClick === 'function') {
		      this.props.onRowClick(cell.rowIdx, this.props.rowGetter(cell.rowIdx));
		    }
		  },
	
		  onCellContextMenu: function onCellContextMenu(cell) {
		    this.onSelect({ rowIdx: cell.rowIdx, idx: cell.idx, contextMenuDisplayed: this.props.contextMenu });
		    if (this.props.contextMenu) {
		      document.addEventListener('click', this.onContextMenuHide);
		    }
		  },
	
		  onCellDoubleClick: function onCellDoubleClick(cell) {
		    this.onSelect({ rowIdx: cell.rowIdx, idx: cell.idx });
		    this.setActive('Enter');
		  },
	
		  onViewportDoubleClick: function onViewportDoubleClick() {
		    this.setActive();
		  },
	
		  onPressArrowUp: function onPressArrowUp(e) {
		    this.moveSelectedCell(e, -1, 0);
		  },
		  onPressArrowDown: function onPressArrowDown(e) {
		    this.moveSelectedCell(e, 1, 0);
		  },
		  onPressArrowLeft: function onPressArrowLeft(e) {
		    this.moveSelectedCell(e, 0, -1);
		  },
		  onPressArrowRight: function onPressArrowRight(e) {
		    this.moveSelectedCell(e, 0, 1);
		  },
		  onPressTab: function onPressTab(e) {
		    this.moveSelectedCell(e, 0, e.shiftKey ? -1 : 1);
		  },
		  onPressEnter: function onPressEnter(e) {
		    this.setActive(e.key);
		  },
		  onPressDelete: function onPressDelete(e) {
		    this.setActive(e.key);
		  },
		  onPressEscape: function onPressEscape(e) {
		    this.setInactive(e.key);
		    this.handleCancelCopy();
		  },
		  onPressBackspace: function onPressBackspace(e) {
		    this.setActive(e.key);
		  },
		  onPressChar: function onPressChar(e) {
		    if (this.isKeyPrintable(e.keyCode)) {
		      this.setActive(e.keyCode);
		    }
		  },
		  onPressKeyWithCtrl: function onPressKeyWithCtrl(e) {
		    var keys = {
		      KeyCode_c: 99,
		      KeyCode_C: 67,
		      KeyCode_V: 86,
		      KeyCode_v: 118
		    };
	
		    var rowIdx = this.state.selected.rowIdx;
		    var row = this.props.rowGetter(rowIdx);
	
		    var idx = this.state.selected.idx;
		    var col = this.getColumn(idx);
	
		    if (ColumnUtils.canEdit(col, row, this.props.enableCellSelect)) {
		      if (e.keyCode === keys.KeyCode_c || e.keyCode === keys.KeyCode_C) {
		        var _value = this.getSelectedValue();
		        this.handleCopy({ value: _value });
		      } else if (e.keyCode === keys.KeyCode_v || e.keyCode === keys.KeyCode_V) {
		        this.handlePaste();
		      }
		    }
		  },
		  onGridRowsUpdated: function onGridRowsUpdated(cellKey, fromRow, toRow, updated, action, originRow) {
		    var rowIds = [];
	
		    for (var i = fromRow; i <= toRow; i++) {
		      rowIds.push(this.props.rowGetter(i)[this.props.rowKey]);
		    }
	
		    var fromRowId = this.props.rowGetter(action === 'COPY_PASTE' ? originRow : fromRow)[this.props.rowKey];
		    var toRowId = this.props.rowGetter(toRow)[this.props.rowKey];
	
		    this.props.onGridRowsUpdated({ cellKey: cellKey, fromRow: fromRow, toRow: toRow, fromRowId: fromRowId, toRowId: toRowId, rowIds: rowIds, updated: updated, action: action });
		  },
		  onCellCommit: function onCellCommit(commit) {
		    var selected = Object.assign({}, this.state.selected);
		    selected.active = false;
		    if (commit.key === 'Tab') {
		      selected.idx += 1;
		    }
		    var expandedRows = this.state.expandedRows;
		    // if(commit.changed && commit.changed.expandedHeight){
		    //   expandedRows = this.expandRow(commit.rowIdx, commit.changed.expandedHeight);
		    // }
		    this.setState({ selected: selected, expandedRows: expandedRows });
	
		    if (this.props.onRowUpdated) {
		      this.props.onRowUpdated(commit);
		    }
	
		    var targetRow = commit.rowIdx;
	
		    if (this.props.onGridRowsUpdated) {
		      this.onGridRowsUpdated(commit.cellKey, targetRow, targetRow, commit.updated, _AppConstants2['default'].UpdateActions.CELL_UPDATE);
		    }
		  },
		  onDragStart: function onDragStart(e) {
		    var idx = this.state.selected.idx;
		    // To prevent dragging down/up when reordering rows.
		    var isViewportDragging = e && e.target && e.target.className;
		    if (idx > -1 && isViewportDragging) {
		      var _value2 = this.getSelectedValue();
		      this.handleDragStart({ idx: this.state.selected.idx, rowIdx: this.state.selected.rowIdx, value: _value2 });
		      // need to set dummy data for FF
		      if (e && e.dataTransfer) {
		        if (e.dataTransfer.setData) {
		          e.dataTransfer.dropEffect = 'move';
		          e.dataTransfer.effectAllowed = 'move';
		          e.dataTransfer.setData('text/plain', '');
		        }
		      }
		    }
		  },
		  onToggleFilter: function onToggleFilter() {
		    var _this2 = this;
	
		    // setState() does not immediately mutate this.state but creates a pending state transition.
		    // Therefore if you want to do something after the state change occurs, pass it in as a callback function.
		    this.setState({ canFilter: !this.state.canFilter }, function () {
		      if (_this2.state.canFilter === false && _this2.props.onClearFilters) {
		        _this2.props.onClearFilters();
		      }
		    });
		  },
		  onDragHandleDoubleClick: function onDragHandleDoubleClick(e) {
		    if (this.props.onDragHandleDoubleClick) {
		      this.props.onDragHandleDoubleClick(e);
		    }
	
		    if (this.props.onGridRowsUpdated) {
		      var _onGridRowsUpdated;
	
		      var cellKey = this.getColumn(e.idx).key;
		      this.onGridRowsUpdated(cellKey, e.rowIdx, this.props.rowsCount - 1, (_onGridRowsUpdated = {}, _onGridRowsUpdated[cellKey] = e.rowData[cellKey], _onGridRowsUpdated), _AppConstants2['default'].UpdateActions.COLUMN_FILL);
		    }
		  },
		  onCellExpand: function onCellExpand(args) {
		    if (this.props.onCellExpand) {
		      this.props.onCellExpand(args);
		    }
		  },
		  onRowExpandToggle: function onRowExpandToggle(args) {
		    if (typeof this.props.onRowExpandToggle === 'function') {
		      this.props.onRowExpandToggle(args);
		    }
		  },
		  isCellWithinBounds: function isCellWithinBounds(_ref) {
		    var idx = _ref.idx,
		        rowIdx = _ref.rowIdx;
	
		    return idx >= 0 && rowIdx >= 0 && idx < ColumnUtils.getSize(this.state.columnMetrics.columns) && rowIdx < this.props.rowsCount;
		  },
		  handleDragStart: function handleDragStart(dragged) {
		    if (!this.dragEnabled()) {
		      return;
		    }
		    if (this.isCellWithinBounds(dragged)) {
		      this.setState({ dragged: dragged });
		    }
		  },
		  handleDragEnd: function handleDragEnd() {
		    if (!this.dragEnabled()) {
		      return;
		    }
		    var _state = this.state,
		        selected = _state.selected,
		        dragged = _state.dragged;
	
		    var column = this.getColumn(this.state.selected.idx);
		    if (selected && dragged && column) {
		      var cellKey = column.key;
		      var fromRow = selected.rowIdx < dragged.overRowIdx ? selected.rowIdx : dragged.overRowIdx;
		      var toRow = selected.rowIdx > dragged.overRowIdx ? selected.rowIdx : dragged.overRowIdx;
		      if (this.props.onCellsDragged) {
		        this.props.onCellsDragged({ cellKey: cellKey, fromRow: fromRow, toRow: toRow, value: dragged.value });
		      }
		      if (this.props.onGridRowsUpdated) {
		        var _onGridRowsUpdated2;
	
		        this.onGridRowsUpdated(cellKey, fromRow, toRow, (_onGridRowsUpdated2 = {}, _onGridRowsUpdated2[cellKey] = dragged.value, _onGridRowsUpdated2), _AppConstants2['default'].UpdateActions.CELL_DRAG);
		      }
		    }
		    this.setState({ dragged: { complete: true } });
		  },
		  handleDragEnter: function handleDragEnter(row) {
		    if (!this.dragEnabled() || this.state.dragged == null) {
		      return;
		    }
		    var dragged = this.state.dragged;
		    dragged.overRowIdx = row;
		    this.setState({ dragged: dragged });
		  },
		  handleTerminateDrag: function handleTerminateDrag() {
		    if (!this.dragEnabled()) {
		      return;
		    }
		    this.setState({ dragged: null });
		  },
		  handlePaste: function handlePaste() {
		    if (!this.copyPasteEnabled() || !this.state.copied) {
		      return;
		    }
		    var selected = this.state.selected;
		    var cellKey = this.getColumn(this.state.selected.idx).key;
		    var textToCopy = this.state.textToCopy;
		    var fromRow = this.state.copied.rowIdx;
		    var toRow = selected.rowIdx;
	
		    if (this.props.onCellCopyPaste) {
		      this.props.onCellCopyPaste({ cellKey: cellKey, rowIdx: toRow, value: textToCopy, fromRow: fromRow, toRow: toRow });
		    }
	
		    if (this.props.onGridRowsUpdated) {
		      var _onGridRowsUpdated3;
	
		      this.onGridRowsUpdated(cellKey, toRow, toRow, (_onGridRowsUpdated3 = {}, _onGridRowsUpdated3[cellKey] = textToCopy, _onGridRowsUpdated3), _AppConstants2['default'].UpdateActions.COPY_PASTE, fromRow);
		    }
		  },
		  handleCancelCopy: function handleCancelCopy() {
		    this.setState({ copied: null });
		  },
		  handleCopy: function handleCopy(args) {
		    if (!this.copyPasteEnabled()) {
		      return;
		    }
		    var textToCopy = args.value;
		    var selected = this.state.selected;
		    var copied = { idx: selected.idx, rowIdx: selected.rowIdx };
		    this.setState({ textToCopy: textToCopy, copied: copied });
		  },
	
	
		  handleSort: function handleSort(columnKey, direction) {
		    this.setState({ sortDirection: direction, sortColumn: columnKey }, function () {
		      this.props.onGridSort(columnKey, direction);
		    });
		  },
	
		  getSelectedRow: function getSelectedRow(rows, key) {
		    var _this3 = this;
	
		    var selectedRow = rows.filter(function (r) {
		      if (r[_this3.props.rowKey] === key) {
		        return true;
		      }
		      return false;
		    });
		    if (selectedRow.length > 0) {
		      return selectedRow[0];
		    }
		  },
		  useNewRowSelection: function useNewRowSelection() {
		    return this.props.rowSelection && this.props.rowSelection.selectBy;
		  },
	
		  // return false if not a shift select so can be handled as normal row selection
		  handleShiftSelect: function handleShiftSelect(rowIdx) {
		    if (this.state.lastRowIdxUiSelected > -1 && this.isSingleKeyDown(KeyCodes.Shift)) {
		      var _props$rowSelection$s = this.props.rowSelection.selectBy,
		          keys = _props$rowSelection$s.keys,
		          indexes = _props$rowSelection$s.indexes,
		          isSelectedKey = _props$rowSelection$s.isSelectedKey;
	
		      var isPreviouslySelected = RowUtils.isRowSelected(keys, indexes, isSelectedKey, this.props.rowGetter(rowIdx), rowIdx);
	
		      if (isPreviouslySelected) return false;
	
		      var handled = false;
	
		      if (rowIdx > this.state.lastRowIdxUiSelected) {
		        var rowsSelected = [];
	
		        for (var i = this.state.lastRowIdxUiSelected + 1; i <= rowIdx; i++) {
		          rowsSelected.push({ rowIdx: i, row: this.props.rowGetter(i) });
		        }
	
		        if (typeof this.props.rowSelection.onRowsSelected === 'function') {
		          this.props.rowSelection.onRowsSelected(rowsSelected);
		        }
	
		        handled = true;
		      } else if (rowIdx < this.state.lastRowIdxUiSelected) {
		        var _rowsSelected = [];
	
		        for (var _i = rowIdx; _i <= this.state.lastRowIdxUiSelected - 1; _i++) {
		          _rowsSelected.push({ rowIdx: _i, row: this.props.rowGetter(_i) });
		        }
	
		        if (typeof this.props.rowSelection.onRowsSelected === 'function') {
		          this.props.rowSelection.onRowsSelected(_rowsSelected);
		        }
	
		        handled = true;
		      }
	
		      if (handled) {
		        this.setState({ lastRowIdxUiSelected: rowIdx });
		      }
	
		      return handled;
		    }
	
		    return false;
		  },
		  handleNewRowSelect: function handleNewRowSelect(rowIdx, rowData) {
		    if (this.selectAllCheckbox.checked === true) {
		      this.selectAllCheckbox.checked = false;
		    }
	
		    var _props$rowSelection$s2 = this.props.rowSelection.selectBy,
		        keys = _props$rowSelection$s2.keys,
		        indexes = _props$rowSelection$s2.indexes,
		        isSelectedKey = _props$rowSelection$s2.isSelectedKey;
	
		    var isPreviouslySelected = RowUtils.isRowSelected(keys, indexes, isSelectedKey, rowData, rowIdx);
	
		    this.setState({ lastRowIdxUiSelected: isPreviouslySelected ? -1 : rowIdx, selected: { rowIdx: rowIdx, idx: 0 } });
	
		    if (isPreviouslySelected && typeof this.props.rowSelection.onRowsDeselected === 'function') {
		      this.props.rowSelection.onRowsDeselected([{ rowIdx: rowIdx, row: rowData }]);
		    } else if (!isPreviouslySelected && typeof this.props.rowSelection.onRowsSelected === 'function') {
		      this.props.rowSelection.onRowsSelected([{ rowIdx: rowIdx, row: rowData }]);
		    }
		  },
	
		  // columnKey not used here as this function will select the whole row,
		  // but needed to match the function signature in the CheckboxEditor
		  handleRowSelect: function handleRowSelect(rowIdx, columnKey, rowData, e) {
		    e.stopPropagation();
	
		    if (this.useNewRowSelection()) {
		      if (this.props.rowSelection.enableShiftSelect === true) {
		        if (!this.handleShiftSelect(rowIdx)) {
		          this.handleNewRowSelect(rowIdx, rowData);
		        }
		      } else {
		        this.handleNewRowSelect(rowIdx, rowData);
		      }
		    } else {
		      // Fallback to old onRowSelect handler
		      var _selectedRows = this.props.enableRowSelect === 'single' ? [] : this.state.selectedRows.slice(0);
		      var selectedRow = this.getSelectedRow(_selectedRows, rowData[this.props.rowKey]);
		      if (selectedRow) {
		        selectedRow.isSelected = !selectedRow.isSelected;
		      } else {
		        rowData.isSelected = true;
		        _selectedRows.push(rowData);
		      }
		      this.setState({ selectedRows: _selectedRows, selected: { rowIdx: rowIdx, idx: 0 } });
		      if (this.props.onRowSelect) {
		        this.props.onRowSelect(_selectedRows.filter(function (r) {
		          return r.isSelected === true;
		        }));
		      }
		    }
		  },
	
	
		  handleCheckboxChange: function handleCheckboxChange(e) {
		    var allRowsSelected = void 0;
		    if (e.currentTarget instanceof HTMLInputElement && e.currentTarget.checked === true) {
		      allRowsSelected = true;
		    } else {
		      allRowsSelected = false;
		    }
		    if (this.useNewRowSelection()) {
		      var _props$rowSelection$s3 = this.props.rowSelection.selectBy,
		          keys = _props$rowSelection$s3.keys,
		          indexes = _props$rowSelection$s3.indexes,
		          isSelectedKey = _props$rowSelection$s3.isSelectedKey;
	
	
		      if (allRowsSelected && typeof this.props.rowSelection.onRowsSelected === 'function') {
		        var _selectedRows2 = [];
		        for (var i = 0; i < this.props.rowsCount; i++) {
		          var rowData = this.props.rowGetter(i);
		          if (!RowUtils.isRowSelected(keys, indexes, isSelectedKey, rowData, i)) {
		            _selectedRows2.push({ rowIdx: i, row: rowData });
		          }
		        }
	
		        if (_selectedRows2.length > 0) {
		          this.props.rowSelection.onRowsSelected(_selectedRows2);
		        }
		      } else if (!allRowsSelected && typeof this.props.rowSelection.onRowsDeselected === 'function') {
		        var deselectedRows = [];
		        for (var _i2 = 0; _i2 < this.props.rowsCount; _i2++) {
		          var _rowData = this.props.rowGetter(_i2);
		          if (RowUtils.isRowSelected(keys, indexes, isSelectedKey, _rowData, _i2)) {
		            deselectedRows.push({ rowIdx: _i2, row: _rowData });
		          }
		        }
	
		        if (deselectedRows.length > 0) {
		          this.props.rowSelection.onRowsDeselected(deselectedRows);
		        }
		      }
		    } else {
		      var _selectedRows3 = [];
		      for (var _i3 = 0; _i3 < this.props.rowsCount; _i3++) {
		        var row = Object.assign({}, this.props.rowGetter(_i3), { isSelected: allRowsSelected });
		        _selectedRows3.push(row);
		      }
		      this.setState({ selectedRows: _selectedRows3 });
		      if (typeof this.props.onRowSelect === 'function') {
		        this.props.onRowSelect(_selectedRows3.filter(function (r) {
		          return r.isSelected === true;
		        }));
		      }
		    }
		  },
	
		  getScrollOffSet: function getScrollOffSet() {
		    var scrollOffset = 0;
		    var canvas = ReactDOM.findDOMNode(this).querySelector('.react-grid-Canvas');
		    if (canvas) {
		      scrollOffset = canvas.offsetWidth - canvas.clientWidth;
		    }
		    this.setState({ scrollOffset: scrollOffset });
		  },
		  getRowOffsetHeight: function getRowOffsetHeight() {
		    var offsetHeight = 0;
		    this.getHeaderRows().forEach(function (row) {
		      return offsetHeight += parseFloat(row.height, 10);
		    });
		    return offsetHeight;
		  },
		  getHeaderRows: function getHeaderRows() {
		    var _this4 = this;
	
		    var rows = [{ ref: function ref(node) {
		        return _this4.row = node;
		      }, height: this.props.headerRowHeight || this.props.rowHeight, rowType: 'header' }];
		    if (this.state.canFilter === true) {
		      rows.push({
		        ref: function ref(node) {
		          return _this4.filterRow = node;
		        },
		        filterable: true,
		        onFilterChange: this.props.onAddFilter,
		        height: this.props.headerFiltersHeight,
		        rowType: 'filter'
		      });
		    }
		    return rows;
		  },
	
		  getInitialSelectedRows: function getInitialSelectedRows() {
		    var selectedRows = [];
		    for (var i = 0; i < this.props.rowsCount; i++) {
		      selectedRows.push(false);
		    }
		    return selectedRows;
		  },
		  getRowSelectionProps: function getRowSelectionProps() {
		    if (this.props.rowSelection) {
		      return this.props.rowSelection.selectBy;
		    }
	
		    return null;
		  },
		  getSelectedRows: function getSelectedRows() {
		    if (this.props.rowSelection) {
		      return null;
		    }
	
		    return this.state.selectedRows.filter(function (r) {
		      return r.isSelected === true;
		    });
		  },
		  getSelectedValue: function getSelectedValue() {
		    var rowIdx = this.state.selected.rowIdx;
		    var idx = this.state.selected.idx;
		    var cellKey = this.getColumn(idx).key;
		    var row = this.props.rowGetter(rowIdx);
		    return RowUtils.get(row, cellKey);
		  },
		  moveSelectedCell: function moveSelectedCell(e, rowDelta, cellDelta) {
		    // we need to prevent default as we control grid scroll
		    // otherwise it moves every time you left/right which is janky
		    e.preventDefault();
		    var rowIdx = void 0;
		    var idx = void 0;
		    var cellNavigationMode = this.props.cellNavigationMode;
	
		    if (cellNavigationMode !== 'none') {
		      var _calculateNextSelecti = this.calculateNextSelectionPosition(cellNavigationMode, cellDelta, rowDelta);
	
		      idx = _calculateNextSelecti.idx;
		      rowIdx = _calculateNextSelecti.rowIdx;
		    } else {
		      rowIdx = this.state.selected.rowIdx + rowDelta;
		      idx = this.state.selected.idx + cellDelta;
		    }
		    this.onSelect({ idx: idx, rowIdx: rowIdx });
		  },
		  getNbrColumns: function getNbrColumns() {
		    var _props = this.props,
		        columns = _props.columns,
		        enableRowSelect = _props.enableRowSelect;
	
		    return enableRowSelect ? columns.length + 1 : columns.length;
		  },
		  getDataGridDOMNode: function getDataGridDOMNode() {
		    if (!this._gridNode) {
		      this._gridNode = ReactDOM.findDOMNode(this);
		    }
		    return this._gridNode;
		  },
		  calculateNextSelectionPosition: function calculateNextSelectionPosition(cellNavigationMode, cellDelta, rowDelta) {
		    var _rowDelta = rowDelta;
		    var idx = this.state.selected.idx + cellDelta;
		    var nbrColumns = this.getNbrColumns();
		    if (cellDelta > 0) {
		      if (this.isAtLastCellInRow(nbrColumns)) {
		        if (cellNavigationMode === 'changeRow') {
		          _rowDelta = this.isAtLastRow() ? rowDelta : rowDelta + 1;
		          idx = this.isAtLastRow() ? idx : 0;
		        } else {
		          idx = 0;
		        }
		      }
		    } else if (cellDelta < 0) {
		      if (this.isAtFirstCellInRow()) {
		        if (cellNavigationMode === 'changeRow') {
		          _rowDelta = this.isAtFirstRow() ? rowDelta : rowDelta - 1;
		          idx = this.isAtFirstRow() ? 0 : nbrColumns - 1;
		        } else {
		          idx = nbrColumns - 1;
		        }
		      }
		    }
		    var rowIdx = this.state.selected.rowIdx + _rowDelta;
		    return { idx: idx, rowIdx: rowIdx };
		  },
		  isAtLastCellInRow: function isAtLastCellInRow(nbrColumns) {
		    return this.state.selected.idx === nbrColumns - 1;
		  },
		  isAtLastRow: function isAtLastRow() {
		    return this.state.selected.rowIdx === this.props.rowsCount - 1;
		  },
		  isAtFirstCellInRow: function isAtFirstCellInRow() {
		    return this.state.selected.idx === 0;
		  },
		  isAtFirstRow: function isAtFirstRow() {
		    return this.state.selected.rowIdx === 0;
		  },
		  openCellEditor: function openCellEditor(rowIdx, idx) {
		    var _this5 = this;
	
		    var row = this.props.rowGetter(rowIdx);
		    var col = this.getColumn(idx);
	
		    if (!ColumnUtils.canEdit(col, row, this.props.enableCellSelect)) {
		      return;
		    }
	
		    var selected = { rowIdx: rowIdx, idx: idx };
		    if (this.hasSelectedCellChanged(selected)) {
		      this.setState({ selected: selected }, function () {
		        _this5.setActive('Enter');
		      });
		    } else {
		      this.setActive('Enter');
		    }
		  },
		  scrollToColumn: function scrollToColumn(colIdx) {
		    var canvas = ReactDOM.findDOMNode(this).querySelector('.react-grid-Canvas');
		    if (canvas) {
		      var left = 0;
		      var locked = 0;
	
		      for (var i = 0; i < colIdx; i++) {
		        var column = this.getColumn(i);
		        if (column) {
		          if (column.width) {
		            left += column.width;
		          }
		          if (column.locked) {
		            locked += column.width;
		          }
		        }
		      }
	
		      var selectedColumn = this.getColumn(colIdx);
		      if (selectedColumn) {
		        var scrollLeft = left - locked - canvas.scrollLeft;
		        var scrollRight = left + selectedColumn.width - canvas.scrollLeft;
	
		        if (scrollLeft < 0) {
		          canvas.scrollLeft += scrollLeft;
		        } else if (scrollRight > canvas.clientWidth) {
		          var scrollAmount = scrollRight - canvas.clientWidth;
		          canvas.scrollLeft += scrollAmount;
		        }
		      }
		    }
		  },
		  setActive: function setActive(keyPressed) {
		    var rowIdx = this.state.selected.rowIdx;
		    var row = this.props.rowGetter(rowIdx);
	
		    var idx = this.state.selected.idx;
		    var column = this.getColumn(idx);
	
		    if (ColumnUtils.canEdit(column, row, this.props.enableCellSelect) && !this.isActive()) {
		      var _selected = Object.assign({}, this.state.selected, { idx: idx, rowIdx: rowIdx, active: true, initialKeyCode: keyPressed });
		      var showEditor = true;
		      if (typeof this.props.onCheckCellIsEditable === 'function') {
		        var args = Object.assign({}, { row: row, column: column }, _selected);
		        showEditor = this.props.onCheckCellIsEditable(args);
		      }
		      if (showEditor !== false) {
		        this.setState({ selected: _selected }, this.scrollToColumn(idx));
		        this.handleCancelCopy();
		      }
		    }
		  },
		  setInactive: function setInactive() {
		    var rowIdx = this.state.selected.rowIdx;
		    var row = this.props.rowGetter(rowIdx);
	
		    var idx = this.state.selected.idx;
		    var col = this.getColumn(idx);
	
		    if (ColumnUtils.canEdit(col, row, this.props.enableCellSelect) && this.isActive()) {
		      var _selected2 = Object.assign({}, this.state.selected, { idx: idx, rowIdx: rowIdx, active: false });
		      this.setState({ selected: _selected2 });
		    }
		  },
		  isActive: function isActive() {
		    return this.state.selected.active === true;
		  },
	
	
		  setupGridColumns: function setupGridColumns() {
		    var _this6 = this;
	
		    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
		    var columns = props.columns;
	
		    if (this._cachedColumns === columns) {
		      return this._cachedComputedColumns;
		    }
	
		    this._cachedColumns = columns;
	
		    var cols = columns.slice(0);
		    var unshiftedCols = {};
		    if (this.props.rowActionsCell || props.enableRowSelect && !this.props.rowSelection || props.rowSelection && props.rowSelection.showCheckbox !== false) {
		      var headerRenderer = props.enableRowSelect === 'single' ? null : React.createElement(
		        'div',
		        { className: 'react-grid-checkbox-container checkbox-align' },
		        React.createElement('input', { className: 'react-grid-checkbox', type: 'checkbox', name: 'select-all-checkbox', id: 'select-all-checkbox', ref: function ref(grid) {
		            return _this6.selectAllCheckbox = grid;
		          }, onChange: this.handleCheckboxChange }),
		        React.createElement('label', { htmlFor: 'select-all-checkbox', className: 'react-grid-checkbox-label' })
		      );
		      var Formatter = this.props.rowActionsCell ? this.props.rowActionsCell : CheckboxEditor;
		      var selectColumn = {
		        key: 'select-row',
		        name: '',
		        formatter: React.createElement(Formatter, { rowSelection: this.props.rowSelection }),
		        onCellChange: this.handleRowSelect,
		        filterable: false,
		        headerRenderer: headerRenderer,
		        width: 60,
		        locked: true,
		        getRowMetaData: function getRowMetaData(rowData) {
		          return rowData;
		        },
		        cellClass: this.props.rowActionsCell ? 'rdg-row-actions-cell' : ''
		      };
		      unshiftedCols = cols.unshift(selectColumn);
		      cols = unshiftedCols > 0 ? cols : unshiftedCols;
		    }
		    this._cachedComputedColumns = cols;
	
		    return this._cachedComputedColumns;
		  },
	
		  copyPasteEnabled: function copyPasteEnabled() {
		    return this.props.onCellCopyPaste !== null;
		  },
	
		  dragEnabled: function dragEnabled() {
		    return this.props.onGridRowsUpdated !== undefined || this.props.onCellsDragged !== undefined;
		  },
	
		  renderToolbar: function renderToolbar() {
		    var Toolbar = this.props.toolbar;
		    if (React.isValidElement(Toolbar)) {
		      return React.cloneElement(Toolbar, { columns: this.props.columns, onToggleFilter: this.onToggleFilter, numberOfRows: this.props.rowsCount });
		    }
		  },
		  render: function render() {
		    var _this7 = this;
	
		    var cellMetaData = {
		      selected: this.state.selected,
		      dragged: this.state.dragged,
		      hoveredRowIdx: this.state.hoveredRowIdx,
		      onCellClick: this.onCellClick,
		      onCellContextMenu: this.onCellContextMenu,
		      onCellDoubleClick: this.onCellDoubleClick,
		      onCommit: this.onCellCommit,
		      onCommitCancel: this.setInactive,
		      copied: this.state.copied,
		      handleDragEnterRow: this.handleDragEnter,
		      handleTerminateDrag: this.handleTerminateDrag,
		      enableCellSelect: this.props.enableCellSelect,
		      onColumnEvent: this.onColumnEvent,
		      openCellEditor: this.openCellEditor,
		      onDragHandleDoubleClick: this.onDragHandleDoubleClick,
		      onCellExpand: this.onCellExpand,
		      onRowExpandToggle: this.onRowExpandToggle,
		      onRowHover: this.onRowHover,
		      getDataGridDOMNode: this.getDataGridDOMNode,
		      isScrollingVerticallyWithKeyboard: this.isKeyDown(KeyCodes.DownArrow) || this.isKeyDown(KeyCodes.UpArrow),
		      isScrollingHorizontallyWithKeyboard: this.isKeyDown(KeyCodes.LeftArrow) || this.isKeyDown(KeyCodes.RightArrow) || this.isKeyDown(KeyCodes.Tab)
		    };
	
		    var toolbar = this.renderToolbar();
		    var containerWidth = this.props.minWidth || this.DOMMetrics.gridWidth();
		    var gridWidth = containerWidth - this.state.scrollOffset;
	
		    // depending on the current lifecycle stage, gridWidth() may not initialize correctly
		    // this also handles cases where it always returns undefined -- such as when inside a div with display:none
		    // eg Bootstrap tabs and collapses
		    if (typeof containerWidth === 'undefined' || isNaN(containerWidth) || containerWidth === 0) {
		      containerWidth = '100%';
		    }
		    if (typeof gridWidth === 'undefined' || isNaN(gridWidth) || gridWidth === 0) {
		      gridWidth = '100%';
		    }
		    return React.createElement(
		      'div',
		      { className: 'react-grid-Container', style: { width: containerWidth } },
		      toolbar,
		      React.createElement(
		        'div',
		        { className: 'react-grid-Main' },
		        React.createElement(BaseGrid, _extends({
		          ref: function ref(node) {
		            return _this7.base = node;
		          }
		        }, this.props, {
		          rowKey: this.props.rowKey,
		          headerRows: this.getHeaderRows(),
		          columnMetrics: this.state.columnMetrics,
		          rowGetter: this.props.rowGetter,
		          rowsCount: this.props.rowsCount,
		          rowHeight: this.props.rowHeight,
		          cellMetaData: cellMetaData,
		          selectedRows: this.getSelectedRows(),
		          rowSelection: this.getRowSelectionProps(),
		          expandedRows: this.state.expandedRows,
		          rowOffsetHeight: this.getRowOffsetHeight(),
		          sortColumn: this.state.sortColumn,
		          sortDirection: this.state.sortDirection,
		          onSort: this.handleSort,
		          minHeight: this.props.minHeight,
		          totalWidth: gridWidth,
		          onViewportKeydown: this.onKeyDown,
		          onViewportKeyup: this.onKeyUp,
		          onViewportDragStart: this.onDragStart,
		          onViewportDragEnd: this.handleDragEnd,
		          onViewportDoubleClick: this.onViewportDoubleClick,
		          onColumnResize: this.onColumnResize,
		          rowScrollTimeout: this.props.rowScrollTimeout,
		          contextMenu: this.props.contextMenu,
		          overScan: this.props.overScan }))
		      )
		    );
		  }
		});
	
		module.exports = ReactDataGrid;
	
	/***/ }),
	/* 174 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var Draggable = __webpack_require__(164);
		__webpack_require__(19);
	
		var ResizeHandle = React.createClass({
		  displayName: 'ResizeHandle',
	
		  style: {
		    position: 'absolute',
		    top: 0,
		    right: 0,
		    width: 6,
		    height: '100%'
		  },
	
		  render: function render() {
		    return React.createElement(Draggable, _extends({}, this.props, {
		      className: 'react-grid-HeaderCell__resizeHandle',
		      style: this.style
		    }));
		  }
		});
	
		module.exports = ResizeHandle;
	
	/***/ }),
	/* 175 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _classnames = __webpack_require__(9);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		__webpack_require__(27);
	
		var _utils = __webpack_require__(68);
	
		var _utils2 = _interopRequireDefault(_utils);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var RowGroup = function (_Component) {
		  _inherits(RowGroup, _Component);
	
		  function RowGroup() {
		    _classCallCheck(this, RowGroup);
	
		    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
		    _this.checkFocus = _this.checkFocus.bind(_this);
		    _this.isSelected = _this.isSelected.bind(_this);
		    _this.onClick = _this.onClick.bind(_this);
		    _this.onRowExpandToggle = _this.onRowExpandToggle.bind(_this);
		    _this.onKeyDown = _this.onKeyDown.bind(_this);
		    _this.onRowExpandClick = _this.onRowExpandClick.bind(_this);
		    return _this;
		  }
	
		  RowGroup.prototype.componentDidMount = function componentDidMount() {
		    this.checkFocus();
		  };
	
		  RowGroup.prototype.componentDidUpdate = function componentDidUpdate() {
		    this.checkFocus();
		  };
	
		  RowGroup.prototype.isSelected = function isSelected() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
	
		    return meta.selected && meta.selected.rowIdx === this.props.idx;
		  };
	
		  RowGroup.prototype.onClick = function onClick(e) {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellClick && typeof meta.onCellClick === 'function') {
		      meta.onCellClick({ rowIdx: this.props.idx, idx: 0 }, e);
		    }
		  };
	
		  RowGroup.prototype.onKeyDown = function onKeyDown(e) {
		    if (e.key === 'ArrowLeft') {
		      this.onRowExpandToggle(false);
		    }
		    if (e.key === 'ArrowRight') {
		      this.onRowExpandToggle(true);
		    }
		    if (e.key === 'Enter') {
		      this.onRowExpandToggle(!this.props.isExpanded);
		    }
		  };
	
		  RowGroup.prototype.onRowExpandClick = function onRowExpandClick() {
		    this.onRowExpandToggle(!this.props.isExpanded);
		  };
	
		  RowGroup.prototype.onRowExpandToggle = function onRowExpandToggle(expand) {
		    var shouldExpand = expand == null ? !this.props.isExpanded : expand;
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onRowExpandToggle && typeof meta.onRowExpandToggle === 'function') {
		      meta.onRowExpandToggle({ rowIdx: this.props.idx, shouldExpand: shouldExpand, columnGroupName: this.props.columnGroupName, name: this.props.name });
		    }
		  };
	
		  RowGroup.prototype.getClassName = function getClassName() {
		    return (0, _classnames2['default'])('react-grid-row-group', 'react-grid-Row', { 'row-selected': this.isSelected() });
		  };
	
		  RowGroup.prototype.checkFocus = function checkFocus() {
		    if (this.isSelected()) {
		      _reactDom2['default'].findDOMNode(this).focus();
		    }
		  };
	
		  RowGroup.prototype.render = function render() {
		    var lastColumn = _utils2['default'].last(this.props.columns);
	
		    var style = {
		      height: '50px',
		      overflow: 'hidden',
		      border: '1px solid #dddddd',
		      paddingTop: '15px',
		      paddingLeft: '5px',
		      width: lastColumn.left + lastColumn.width
		    };
		    var rowGroupRendererProps = Object.assign({ onRowExpandClick: this.onRowExpandClick }, this.props);
	
		    return _react2['default'].createElement(
		      'div',
		      { style: style, className: this.getClassName(), onClick: this.onClick, onKeyDown: this.onKeyDown, tabIndex: -1 },
		      _react2['default'].createElement(this.props.renderer, rowGroupRendererProps)
		    );
		  };
	
		  return RowGroup;
		}(_react.Component);
	
		RowGroup.propTypes = {
		  name: _react.PropTypes.string.isRequired,
		  columnGroupName: _react.PropTypes.string.isRequired,
		  isExpanded: _react.PropTypes.bool.isRequired,
		  treeDepth: _react.PropTypes.number.isRequired,
		  height: _react.PropTypes.number.isRequired,
		  cellMetaData: _react.PropTypes.object,
		  idx: _react.PropTypes.number.isRequired,
		  renderer: _react.PropTypes.func,
		  columns: _react.PropTypes.array.isRequired
		};
	
		var DefaultRowGroupRenderer = function DefaultRowGroupRenderer(props) {
		  var treeDepth = props.treeDepth || 0;
		  var marginLeft = treeDepth * 20;
	
		  return _react2['default'].createElement(
		    'div',
		    null,
		    _react2['default'].createElement(
		      'span',
		      { className: 'row-expand-icon', style: { float: 'left', marginLeft: marginLeft, cursor: 'pointer' }, onClick: props.onRowExpandClick },
		      props.isExpanded ? String.fromCharCode('9660') : String.fromCharCode('9658')
		    ),
		    _react2['default'].createElement(
		      'strong',
		      null,
		      props.columnGroupName,
		      ' : ',
		      props.name
		    )
		  );
		};
	
		DefaultRowGroupRenderer.propTypes = {
		  onRowExpandClick: _react.PropTypes.func.isRequired,
		  isExpanded: _react.PropTypes.bool.isRequired,
		  treeDepth: _react.PropTypes.number.isRequired,
		  name: _react.PropTypes.string.isRequired,
		  columnGroupName: _react.PropTypes.string.isRequired
		};
	
		RowGroup.defaultProps = {
		  renderer: DefaultRowGroupRenderer
		};
	
		exports['default'] = RowGroup;
	
	/***/ }),
	/* 176 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var ScrollShim = {
		  appendScrollShim: function appendScrollShim() {
		    if (!this._scrollShim) {
		      var size = this._scrollShimSize();
		      var shim = document.createElement('div');
		      if (shim.classList) {
		        shim.classList.add('react-grid-ScrollShim'); // flow - not compatible with HTMLElement
		      } else {
		        shim.className += ' react-grid-ScrollShim';
		      }
		      shim.style.position = 'absolute';
		      shim.style.top = 0;
		      shim.style.left = 0;
		      shim.style.width = size.width + 'px';
		      shim.style.height = size.height + 'px';
		      _reactDom2['default'].findDOMNode(this).appendChild(shim);
		      this._scrollShim = shim;
		    }
		    this._scheduleRemoveScrollShim();
		  },
		  _scrollShimSize: function _scrollShimSize() {
		    return {
		      width: this.props.width,
		      height: this.props.length * this.props.rowHeight
		    };
		  },
		  _scheduleRemoveScrollShim: function _scheduleRemoveScrollShim() {
		    if (this._scheduleRemoveScrollShimTimer) {
		      clearTimeout(this._scheduleRemoveScrollShimTimer);
		    }
		    this._scheduleRemoveScrollShimTimer = setTimeout(this._removeScrollShim, 200);
		  },
		  _removeScrollShim: function _removeScrollShim() {
		    if (this._scrollShim) {
		      this._scrollShim.parentNode.removeChild(this._scrollShim);
		      this._scrollShim = undefined;
		    }
		  }
		};
	
		module.exports = ScrollShim;
	
	/***/ }),
	/* 177 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var Canvas = __webpack_require__(161);
		var ViewportScroll = __webpack_require__(178);
		var cellMetaDataShape = __webpack_require__(14);
		var PropTypes = React.PropTypes;
	
		var Viewport = React.createClass({
		  displayName: 'Viewport',
	
		  mixins: [ViewportScroll],
	
		  propTypes: {
		    rowOffsetHeight: PropTypes.number.isRequired,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
		    columnMetrics: PropTypes.object.isRequired,
		    rowGetter: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
		    selectedRows: PropTypes.array,
		    rowSelection: React.PropTypes.oneOfType([React.PropTypes.shape({
		      indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		    }), React.PropTypes.shape({
		      isSelectedKey: React.PropTypes.string.isRequired
		    }), React.PropTypes.shape({
		      keys: React.PropTypes.shape({
		        values: React.PropTypes.array.isRequired,
		        rowKey: React.PropTypes.string.isRequired
		      }).isRequired
		    })]),
		    expandedRows: PropTypes.array,
		    rowRenderer: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
		    rowsCount: PropTypes.number.isRequired,
		    rowHeight: PropTypes.number.isRequired,
		    onRows: PropTypes.func,
		    onScroll: PropTypes.func,
		    minHeight: PropTypes.number,
		    cellMetaData: PropTypes.shape(cellMetaDataShape),
		    rowKey: PropTypes.string.isRequired,
		    rowScrollTimeout: PropTypes.number,
		    contextMenu: PropTypes.element,
		    getSubRowDetails: PropTypes.func,
		    rowGroupRenderer: PropTypes.func
		  },
	
		  onScroll: function onScroll(scroll) {
		    this.updateScroll(scroll.scrollTop, scroll.scrollLeft, this.state.height, this.props.rowHeight, this.props.rowsCount);
	
		    if (this.props.onScroll) {
		      this.props.onScroll({ scrollTop: scroll.scrollTop, scrollLeft: scroll.scrollLeft });
		    }
		  },
		  getScroll: function getScroll() {
		    return this.canvas.getScroll();
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    this.canvas.setScrollLeft(scrollLeft);
		  },
		  render: function render() {
		    var _this = this;
	
		    var style = {
		      padding: 0,
		      bottom: 0,
		      left: 0,
		      right: 0,
		      overflow: 'hidden',
		      position: 'absolute',
		      top: this.props.rowOffsetHeight
		    };
		    return React.createElement(
		      'div',
		      {
		        className: 'react-grid-Viewport',
		        style: style },
		      React.createElement(Canvas, {
		        ref: function ref(node) {
		          return _this.canvas = node;
		        },
		        rowKey: this.props.rowKey,
		        totalWidth: this.props.totalWidth,
		        width: this.props.columnMetrics.width,
		        rowGetter: this.props.rowGetter,
		        rowsCount: this.props.rowsCount,
		        selectedRows: this.props.selectedRows,
		        expandedRows: this.props.expandedRows,
		        columns: this.props.columnMetrics.columns,
		        rowRenderer: this.props.rowRenderer,
		        displayStart: this.state.displayStart,
		        displayEnd: this.state.displayEnd,
		        visibleStart: this.state.visibleStart,
		        visibleEnd: this.state.visibleEnd,
		        colVisibleStart: this.state.colVisibleStart,
		        colVisibleEnd: this.state.colVisibleEnd,
		        colDisplayStart: this.state.colDisplayStart,
		        colDisplayEnd: this.state.colDisplayEnd,
		        cellMetaData: this.props.cellMetaData,
		        height: this.state.height,
		        rowHeight: this.props.rowHeight,
		        onScroll: this.onScroll,
		        onRows: this.props.onRows,
		        rowScrollTimeout: this.props.rowScrollTimeout,
		        contextMenu: this.props.contextMenu,
		        rowSelection: this.props.rowSelection,
		        getSubRowDetails: this.props.getSubRowDetails,
		        rowGroupRenderer: this.props.rowGroupRenderer,
		        isScrolling: this.state.isScrolling || false
		      })
		    );
		  }
		});
	
		module.exports = Viewport;
	
	/***/ }),
	/* 178 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _ColumnUtils = __webpack_require__(10);
	
		var _ColumnUtils2 = _interopRequireDefault(_ColumnUtils);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var DOMMetrics = __webpack_require__(23);
		var min = Math.min;
		var max = Math.max;
		var floor = Math.floor;
		var ceil = Math.ceil;
	
		module.exports = {
		  mixins: [DOMMetrics.MetricsMixin],
	
		  DOMMetrics: {
		    viewportHeight: function viewportHeight() {
		      return ReactDOM.findDOMNode(this).offsetHeight;
		    },
		    viewportWidth: function viewportWidth() {
		      return ReactDOM.findDOMNode(this).offsetWidth;
		    }
		  },
	
		  propTypes: {
		    rowHeight: React.PropTypes.number,
		    rowsCount: React.PropTypes.number.isRequired
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      rowHeight: 30
		    };
		  },
		  getInitialState: function getInitialState() {
		    return this.getGridState(this.props);
		  },
		  getGridState: function getGridState(props) {
		    var totalNumberColumns = _ColumnUtils2['default'].getSize(props.columnMetrics.columns);
		    var canvasHeight = props.minHeight - props.rowOffsetHeight;
		    var renderedRowsCount = ceil((props.minHeight - props.rowHeight) / props.rowHeight);
		    var totalRowCount = min(renderedRowsCount * 4, props.rowsCount);
		    return {
		      displayStart: 0,
		      displayEnd: totalRowCount,
		      visibleStart: 0,
		      visibleEnd: totalRowCount,
		      height: canvasHeight,
		      scrollTop: 0,
		      scrollLeft: 0,
		      colVisibleStart: 0,
		      colVisibleEnd: totalNumberColumns,
		      colDisplayStart: 0,
		      colDisplayEnd: totalNumberColumns
		    };
		  },
		  getRenderedColumnCount: function getRenderedColumnCount(displayStart, width) {
		    var remainingWidth = width > 0 ? width : this.props.columnMetrics.totalWidth;
		    if (remainingWidth === 0) {
		      remainingWidth = ReactDOM.findDOMNode(this).offsetWidth;
		    }
		    var columnIndex = displayStart;
		    var columnCount = 0;
		    while (remainingWidth > 0) {
		      var column = _ColumnUtils2['default'].getColumn(this.props.columnMetrics.columns, columnIndex);
	
		      if (!column) {
		        break;
		      }
	
		      columnCount++;
		      columnIndex++;
		      remainingWidth -= column.width;
		    }
		    return columnCount;
		  },
		  getVisibleColStart: function getVisibleColStart(scrollLeft) {
		    var remainingScroll = scrollLeft;
		    var columnIndex = -1;
		    while (remainingScroll >= 0) {
		      columnIndex++;
		      remainingScroll -= _ColumnUtils2['default'].getColumn(this.props.columnMetrics.columns, columnIndex).width;
		    }
		    return columnIndex;
		  },
		  resetScrollStateAfterDelay: function resetScrollStateAfterDelay() {
		    if (this.resetScrollStateTimeoutId) {
		      clearTimeout(this.resetScrollStateTimeoutId);
		    }
	
		    this.resetScrollStateTimeoutId = setTimeout(this.resetScrollStateAfterDelayCallback, 500);
		  },
		  resetScrollStateAfterDelayCallback: function resetScrollStateAfterDelayCallback() {
		    this.resetScrollStateTimeoutId = null;
		    this.setState({
		      isScrolling: false
		    });
		  },
		  updateScroll: function updateScroll(scrollTop, scrollLeft, height, rowHeight, length, width) {
		    var isScrolling = true;
		    this.resetScrollStateAfterDelay();
	
		    var renderedRowsCount = ceil(height / rowHeight);
	
		    var visibleStart = max(0, floor(scrollTop / rowHeight));
	
		    var visibleEnd = min(visibleStart + renderedRowsCount, length);
	
		    var displayStart = max(0, visibleStart - this.props.overScan.rowsStart);
	
		    var displayEnd = min(visibleEnd + this.props.overScan.rowsEnd, length);
	
		    var totalNumberColumns = _ColumnUtils2['default'].getSize(this.props.columnMetrics.columns);
		    var colVisibleStart = totalNumberColumns > 0 ? max(0, this.getVisibleColStart(scrollLeft)) : 0;
		    var renderedColumnCount = this.getRenderedColumnCount(colVisibleStart, width);
		    var colVisibleEnd = renderedColumnCount !== 0 ? colVisibleStart + renderedColumnCount : totalNumberColumns;
		    var colDisplayStart = max(0, colVisibleStart - this.props.overScan.colsStart);
		    var colDisplayEnd = min(colVisibleEnd + this.props.overScan.colsEnd, totalNumberColumns);
	
		    var nextScrollState = {
		      visibleStart: visibleStart,
		      visibleEnd: visibleEnd,
		      displayStart: displayStart,
		      displayEnd: displayEnd,
		      height: height,
		      scrollTop: scrollTop,
		      scrollLeft: scrollLeft,
		      colVisibleStart: colVisibleStart,
		      colVisibleEnd: colVisibleEnd,
		      colDisplayStart: colDisplayStart,
		      colDisplayEnd: colDisplayEnd,
		      isScrolling: isScrolling
		    };
	
		    this.setState(nextScrollState);
		  },
		  metricsUpdated: function metricsUpdated() {
		    var height = this.DOMMetrics.viewportHeight();
		    var width = this.DOMMetrics.viewportWidth();
		    if (height) {
		      this.updateScroll(this.state.scrollTop, this.state.scrollLeft, height, this.props.rowHeight, this.props.rowsCount, width);
		    }
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (this.props.rowHeight !== nextProps.rowHeight || this.props.minHeight !== nextProps.minHeight || _ColumnUtils2['default'].getSize(this.props.columnMetrics.columns) !== _ColumnUtils2['default'].getSize(nextProps.columnMetrics.columns)) {
		      this.setState(this.getGridState(nextProps));
		    } else if (this.props.rowsCount !== nextProps.rowsCount) {
		      this.updateScroll(this.state.scrollTop, this.state.scrollLeft, this.state.height, nextProps.rowHeight, nextProps.rowsCount);
		      // Added to fix the hiding of the bottom scrollbar when showing the filters.
		    } else if (this.props.rowOffsetHeight !== nextProps.rowOffsetHeight) {
		      // The value of height can be positive or negative and will be added to the current height to cater for changes in the header height (due to the filer)
		      var _height = this.props.rowOffsetHeight - nextProps.rowOffsetHeight;
	
		      this.updateScroll(this.state.scrollTop, this.state.scrollLeft, this.state.height + _height, nextProps.rowHeight, nextProps.rowsCount);
		    }
		  }
		};
	
	/***/ }),
	/* 179 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var ExcelColumn = __webpack_require__(11);
	
		var FilterableHeaderCell = React.createClass({
		  displayName: 'FilterableHeaderCell',
	
	
		  propTypes: {
		    onChange: React.PropTypes.func.isRequired,
		    column: React.PropTypes.shape(ExcelColumn)
		  },
	
		  getInitialState: function getInitialState() {
		    return { filterTerm: '' };
		  },
		  handleChange: function handleChange(e) {
		    var val = e.target.value;
		    this.setState({ filterTerm: val });
		    this.props.onChange({ filterTerm: val, column: this.props.column });
		  },
	
	
		  renderInput: function renderInput() {
		    if (this.props.column.filterable === false) {
		      return React.createElement('span', null);
		    }
	
		    var inputKey = 'header-filter-' + this.props.column.key;
		    return React.createElement('input', { key: inputKey, type: 'text', className: 'form-control input-sm', placeholder: 'Search', value: this.state.filterTerm, onChange: this.handleChange });
		  },
	
		  render: function render() {
		    return React.createElement(
		      'div',
		      null,
		      React.createElement(
		        'div',
		        { className: 'form-group' },
		        this.renderInput()
		      )
		    );
		  }
		});
	
		module.exports = FilterableHeaderCell;
	
	/***/ }),
	/* 180 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var joinClasses = __webpack_require__(9);
		var DEFINE_SORT = {
		  ASC: 'ASC',
		  DESC: 'DESC',
		  NONE: 'NONE'
		};
	
		var SortableHeaderCell = React.createClass({
		  displayName: 'SortableHeaderCell',
	
		  propTypes: {
		    columnKey: React.PropTypes.string.isRequired,
		    column: React.PropTypes.shape({ name: React.PropTypes.node }),
		    onSort: React.PropTypes.func.isRequired,
		    sortDirection: React.PropTypes.oneOf(Object.keys(DEFINE_SORT))
		  },
	
		  onClick: function onClick() {
		    var direction = void 0;
		    switch (this.props.sortDirection) {
		      default:
		      case null:
		      case undefined:
		      case DEFINE_SORT.NONE:
		        direction = DEFINE_SORT.ASC;
		        break;
		      case DEFINE_SORT.ASC:
		        direction = DEFINE_SORT.DESC;
		        break;
		      case DEFINE_SORT.DESC:
		        direction = DEFINE_SORT.NONE;
		        break;
		    }
		    this.props.onSort(this.props.columnKey, direction);
		  },
	
		  getSortByText: function getSortByText() {
		    var unicodeKeys = {
		      ASC: '9650',
		      DESC: '9660'
		    };
		    return this.props.sortDirection === 'NONE' ? '' : String.fromCharCode(unicodeKeys[this.props.sortDirection]);
		  },
	
		  render: function render() {
		    var className = joinClasses({
		      'react-grid-HeaderCell-sortable': true,
		      'react-grid-HeaderCell-sortable--ascending': this.props.sortDirection === 'ASC',
		      'react-grid-HeaderCell-sortable--descending': this.props.sortDirection === 'DESC'
		    });
	
		    return React.createElement(
		      'div',
		      { className: className,
		        onClick: this.onClick,
		        style: { cursor: 'pointer' } },
		      React.createElement(
		        'span',
		        { className: 'pull-right' },
		        this.getSortByText()
		      ),
		      this.props.column.name
		    );
		  }
		});
	
		module.exports = SortableHeaderCell;
		module.exports.DEFINE_SORT = DEFINE_SORT;
	
	/***/ }),
	/* 181 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var joinClasses = __webpack_require__(9);
		var keyboardHandlerMixin = __webpack_require__(61);
		var SimpleTextEditor = __webpack_require__(67);
		var isFunction = __webpack_require__(37);
		__webpack_require__(26);
	
		var EditorContainer = React.createClass({
		  displayName: 'EditorContainer',
	
		  mixins: [keyboardHandlerMixin],
	
		  propTypes: {
		    rowIdx: React.PropTypes.number,
		    rowData: React.PropTypes.object.isRequired,
		    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number, React.PropTypes.object, React.PropTypes.bool]).isRequired,
		    cellMetaData: React.PropTypes.shape({
		      selected: React.PropTypes.object.isRequired,
		      copied: React.PropTypes.object,
		      dragged: React.PropTypes.object,
		      onCellClick: React.PropTypes.func,
		      onCellDoubleClick: React.PropTypes.func,
		      onCommitCancel: React.PropTypes.func,
		      onCommit: React.PropTypes.func
		    }).isRequired,
		    column: React.PropTypes.object.isRequired,
		    height: React.PropTypes.number.isRequired
		  },
	
		  changeCommitted: false,
	
		  getInitialState: function getInitialState() {
		    return { isInvalid: false };
		  },
	
	
		  componentDidMount: function componentDidMount() {
		    var inputNode = this.getInputNode();
		    if (inputNode !== undefined) {
		      this.setTextInputFocus();
		      if (!this.getEditor().disableContainerStyles) {
		        inputNode.className += ' editor-main';
		        inputNode.style.height = this.props.height - 1 + 'px';
		      }
		    }
		  },
	
		  componentWillUnmount: function componentWillUnmount() {
		    if (!this.changeCommitted && !this.hasEscapeBeenPressed()) {
		      this.commit({ key: 'Enter' });
		    }
		  },
	
		  createEditor: function createEditor() {
		    var _this = this;
	
		    var editorRef = function editorRef(c) {
		      return _this.editor = c;
		    };
		    var editorProps = {
		      ref: editorRef,
		      column: this.props.column,
		      value: this.getInitialValue(),
		      onCommit: this.commit,
		      rowMetaData: this.getRowMetaData(),
		      rowData: this.props.rowData,
		      height: this.props.height,
		      onBlur: this.commit,
		      onOverrideKeyDown: this.onKeyDown,
		      onCommitCancel: this.props.cellMetaData.onCommitCancel
		    };
	
		    var CustomEditor = this.props.column.editor;
		    // return custom column editor or SimpleEditor if none specified
		    if (React.isValidElement(CustomEditor)) {
		      return React.cloneElement(CustomEditor, editorProps);
		    }
		    if (isFunction(CustomEditor)) {
		      return React.createElement(CustomEditor, _extends({ ref: editorRef }, editorProps));
		    }
	
		    return React.createElement(SimpleTextEditor, { ref: editorRef, column: this.props.column, value: this.getInitialValue(), onBlur: this.commit, rowMetaData: this.getRowMetaData(), onKeyDown: function onKeyDown() {}, commit: function commit() {} });
		  },
		  onPressEnter: function onPressEnter() {
		    this.commit({ key: 'Enter' });
		  },
		  onPressTab: function onPressTab() {
		    this.commit({ key: 'Tab' });
		  },
		  onPressEscape: function onPressEscape(e) {
		    if (!this.editorIsSelectOpen()) {
		      this.props.cellMetaData.onCommitCancel();
		    } else {
		      // prevent event from bubbling if editor has results to select
		      e.stopPropagation();
		    }
		  },
		  onPressArrowDown: function onPressArrowDown(e) {
		    if (this.editorHasResults()) {
		      // dont want to propogate as that then moves us round the grid
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  onPressArrowUp: function onPressArrowUp(e) {
		    if (this.editorHasResults()) {
		      // dont want to propogate as that then moves us round the grid
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  onPressArrowLeft: function onPressArrowLeft(e) {
		    // prevent event propogation. this disables left cell navigation
		    if (!this.isCaretAtBeginningOfInput()) {
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  onPressArrowRight: function onPressArrowRight(e) {
		    // prevent event propogation. this disables right cell navigation
		    if (!this.isCaretAtEndOfInput()) {
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  editorHasResults: function editorHasResults() {
		    if (isFunction(this.getEditor().hasResults)) {
		      return this.getEditor().hasResults();
		    }
	
		    return false;
		  },
		  editorIsSelectOpen: function editorIsSelectOpen() {
		    if (isFunction(this.getEditor().isSelectOpen)) {
		      return this.getEditor().isSelectOpen();
		    }
	
		    return false;
		  },
		  getRowMetaData: function getRowMetaData() {
		    // clone row data so editor cannot actually change this
		    // convention based method to get corresponding Id or Name of any Name or Id property
		    if (typeof this.props.column.getRowMetaData === 'function') {
		      return this.props.column.getRowMetaData(this.props.rowData, this.props.column);
		    }
		  },
		  getEditor: function getEditor() {
		    return this.editor;
		  },
		  getInputNode: function getInputNode() {
		    return this.getEditor().getInputNode();
		  },
		  getInitialValue: function getInitialValue() {
		    var selected = this.props.cellMetaData.selected;
		    var keyCode = selected.initialKeyCode;
		    if (keyCode === 'Delete' || keyCode === 'Backspace') {
		      return '';
		    } else if (keyCode === 'Enter') {
		      return this.props.value;
		    }
	
		    var text = keyCode ? String.fromCharCode(keyCode) : this.props.value;
		    return text;
		  },
		  getContainerClass: function getContainerClass() {
		    return joinClasses({
		      'has-error': this.state.isInvalid === true
		    });
		  },
		  commit: function commit(args) {
		    var opts = args || {};
		    var updated = this.getEditor().getValue();
		    if (this.isNewValueValid(updated)) {
		      this.changeCommitted = true;
		      var cellKey = this.props.column.key;
		      this.props.cellMetaData.onCommit({ cellKey: cellKey, rowIdx: this.props.rowIdx, updated: updated, key: opts.key });
		    }
		  },
		  isNewValueValid: function isNewValueValid(value) {
		    if (isFunction(this.getEditor().validate)) {
		      var isValid = this.getEditor().validate(value);
		      this.setState({ isInvalid: !isValid });
		      return isValid;
		    }
	
		    return true;
		  },
		  setCaretAtEndOfInput: function setCaretAtEndOfInput() {
		    var input = this.getInputNode();
		    // taken from http://stackoverflow.com/questions/511088/use-javascript-to-place-cursor-at-end-of-text-in-text-input-element
		    var txtLength = input.value.length;
		    if (input.setSelectionRange) {
		      input.setSelectionRange(txtLength, txtLength);
		    } else if (input.createTextRange) {
		      var fieldRange = input.createTextRange();
		      fieldRange.moveStart('character', txtLength);
		      fieldRange.collapse();
		      fieldRange.select();
		    }
		  },
		  isCaretAtBeginningOfInput: function isCaretAtBeginningOfInput() {
		    var inputNode = this.getInputNode();
		    return inputNode.selectionStart === inputNode.selectionEnd && inputNode.selectionStart === 0;
		  },
		  isCaretAtEndOfInput: function isCaretAtEndOfInput() {
		    var inputNode = this.getInputNode();
		    return inputNode.selectionStart === inputNode.value.length;
		  },
		  isBodyClicked: function isBodyClicked(e) {
		    var relatedTarget = this.getRelatedTarget(e);
		    return relatedTarget === null;
		  },
		  isViewportClicked: function isViewportClicked(e) {
		    var relatedTarget = this.getRelatedTarget(e);
		    return relatedTarget.className.indexOf('react-grid-Viewport') > -1;
		  },
		  isClickInisdeEditor: function isClickInisdeEditor(e) {
		    var relatedTarget = this.getRelatedTarget(e);
		    return e.currentTarget.contains(relatedTarget) || relatedTarget.className.indexOf('editing') > -1 || relatedTarget.className.indexOf('react-grid-Cell') > -1;
		  },
		  getRelatedTarget: function getRelatedTarget(e) {
		    return e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
		  },
		  handleRightClick: function handleRightClick(e) {
		    e.stopPropagation();
		  },
		  handleBlur: function handleBlur(e) {
		    e.stopPropagation();
		    if (this.isBodyClicked(e)) {
		      this.commit(e);
		    }
	
		    if (!this.isBodyClicked(e)) {
		      // prevent null reference
		      if (this.isViewportClicked(e) || !this.isClickInisdeEditor(e)) {
		        this.commit(e);
		      }
		    }
		  },
		  setTextInputFocus: function setTextInputFocus() {
		    var selected = this.props.cellMetaData.selected;
		    var keyCode = selected.initialKeyCode;
		    var inputNode = this.getInputNode();
		    inputNode.focus();
		    if (inputNode.tagName === 'INPUT') {
		      if (!this.isKeyPrintable(keyCode)) {
		        inputNode.focus();
		        inputNode.select();
		      } else {
		        inputNode.select();
		      }
		    }
		  },
		  hasEscapeBeenPressed: function hasEscapeBeenPressed() {
		    var pressed = false;
		    var escapeKey = 27;
		    if (window.event) {
		      if (window.event.keyCode === escapeKey) {
		        pressed = true;
		      } else if (window.event.which === escapeKey) {
		        pressed = true;
		      }
		    }
		    return pressed;
		  },
		  renderStatusIcon: function renderStatusIcon() {
		    if (this.state.isInvalid === true) {
		      return React.createElement('span', { className: 'glyphicon glyphicon-remove form-control-feedback' });
		    }
		  },
		  render: function render() {
		    return React.createElement(
		      'div',
		      { className: this.getContainerClass(), onBlur: this.handleBlur, onKeyDown: this.onKeyDown, onContextMenu: this.handleRightClick },
		      this.createEditor(),
		      this.renderStatusIcon()
		    );
		  }
		});
	
		module.exports = EditorContainer;
	
	/***/ }),
	/* 182 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = {
		  CheckboxEditor: __webpack_require__(65),
		  EditorBase: __webpack_require__(66),
		  SimpleTextEditor: __webpack_require__(67)
		};
	
	/***/ }),
	/* 183 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */
	
	
		var focusableComponentWrapper = function focusableComponentWrapper(WrappedComponent) {
		  return function (_Component) {
		    _inherits(ComponentWrapper, _Component);
	
		    function ComponentWrapper() {
		      _classCallCheck(this, ComponentWrapper);
	
		      var _this = _possibleConstructorReturn(this, _Component.call(this));
	
		      _this.checkFocus = _this.checkFocus.bind(_this);
		      _this.state = { isScrolling: false };
		      return _this;
		    }
	
		    ComponentWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		      return WrappedComponent.isSelected(this.props) !== WrappedComponent.isSelected(nextProps);
		    };
	
		    ComponentWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		      var isScrolling = WrappedComponent.isScrolling(nextProps);
		      if (isScrolling && !this.state.isScrolling) {
		        this.setState({ isScrolling: isScrolling });
		      }
		    };
	
		    ComponentWrapper.prototype.componentDidMount = function componentDidMount() {
		      this.checkFocus();
		    };
	
		    ComponentWrapper.prototype.componentDidUpdate = function componentDidUpdate() {
		      this.checkFocus();
		    };
	
		    ComponentWrapper.prototype.checkFocus = function checkFocus() {
		      if (WrappedComponent.isSelected(this.props) && this.state.isScrolling) {
		        this.focus();
		        this.setState({ isScrolling: false });
		      }
		    };
	
		    ComponentWrapper.prototype.focus = function focus() {
		      _reactDom2['default'].findDOMNode(this).focus();
		    };
	
		    ComponentWrapper.prototype.render = function render() {
		      return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, this.state));
		    };
	
		    return ComponentWrapper;
		  }(_react.Component);
		};
	
		exports['default'] = focusableComponentWrapper;
	
	/***/ }),
	/* 184 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
	
		var SimpleCellFormatter = React.createClass({
		  displayName: 'SimpleCellFormatter',
	
		  propTypes: {
		    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number, React.PropTypes.object, React.PropTypes.bool]).isRequired
		  },
	
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    return nextProps.value !== this.props.value;
		  },
		  render: function render() {
		    return React.createElement(
		      'div',
		      { title: this.props.value },
		      this.props.value
		    );
		  }
		});
	
		module.exports = SimpleCellFormatter;
	
	/***/ }),
	/* 185 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _GridPropHelpers = __webpack_require__(186);
	
		var _GridPropHelpers2 = _interopRequireDefault(_GridPropHelpers);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		module.exports = {
		  test: { GridPropHelpers: _GridPropHelpers2['default'] }
		};
	
	/***/ }),
	/* 186 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var _rows = [];
		for (var i = 0; i < 1000; i++) {
		  _rows.push({
		    id: i,
		    title: 'Title ' + i,
		    count: i * 1000
		  });
		}
		module.exports = {
		  columns: [{
		    key: 'id',
		    name: 'ID',
		    width: 100
		  }, {
		    key: 'title',
		    name: 'Title',
		    width: 100
		  }, {
		    key: 'count',
		    name: 'Count',
		    width: 100
		  }],
		  rowGetter: function rowGetter(i) {
		    return _rows[i];
		  },
		  rowsCount: function rowsCount() {
		    return _rows.length;
		  },
		  cellMetaData: {
		    selected: { idx: 2, rowIdx: 3 },
		    dragged: null,
		    copied: null
		  }
		};
	
	/***/ }),
	/* 187 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _RowComparer = __webpack_require__(62);
	
		var _RowComparer2 = _interopRequireDefault(_RowComparer);
	
		var _RowsContainer = __webpack_require__(64);
	
		var _RowsContainer2 = _interopRequireDefault(_RowsContainer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var Grid = __webpack_require__(173);
	
	
		module.exports = Grid;
		module.exports.Row = __webpack_require__(34);
		module.exports.Cell = __webpack_require__(59);
		module.exports.HeaderCell = __webpack_require__(60);
		module.exports.RowComparer = _RowComparer2['default'];
		module.exports.RowsContainer = _RowsContainer2['default'];
		module.exports.editors = __webpack_require__(182);
		module.exports.utils = __webpack_require__(68);
		module.exports.shapes = __webpack_require__(172);
		module.exports._constants = __webpack_require__(58);
		module.exports._helpers = __webpack_require__(185);
	
	/***/ }),
	/* 188 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		var isEmptyArray = function isEmptyArray(obj) {
		  return Array.isArray(obj) && obj.length === 0;
		};
	
		module.exports = isEmptyArray;
	
	/***/ }),
	/* 189 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		function isEmpty(obj) {
		  return Object.keys(obj).length === 0 && obj.constructor === Object;
		}
	
		module.exports = isEmpty;
	
	/***/ }),
	/* 190 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _immutable = __webpack_require__(18);
	
		var isImmutableCollection = function isImmutableCollection(objToVerify) {
		  return _immutable.Iterable.isIterable(objToVerify);
		};
	
		module.exports = isImmutableCollection;
	
	/***/ }),
	/* 191 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _immutable = __webpack_require__(18);
	
		module.exports = _immutable.Map.isMap;
	
	/***/ }),
	/* 192 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		var getMixedTypeValueRetriever = function getMixedTypeValueRetriever(isImmutable) {
		  var retObj = {};
		  var retriever = function retriever(item, key) {
		    return item[key];
		  };
		  var immutableRetriever = function immutableRetriever(immutable, key) {
		    return immutable.get(key);
		  };
	
		  retObj.getValue = isImmutable ? immutableRetriever : retriever;
	
		  return retObj;
		};
	
		module.exports = getMixedTypeValueRetriever;
	
	/***/ }),
	/* 193 */
	/***/ (function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Cell{background-color:#fff;padding-left:8px;padding-right:8px;border-right:1px solid #eee;border-bottom:1px solid #ddd}.react-grid-Cell:focus{outline:2px solid #66afe9;outline-offset:-2px}.react-grid-Cell:focus .drag-handle{position:absolute;bottom:-5px;right:-4px;background:#66afe9;width:8px;height:8px;border:1px solid #fff;border-right:0;border-bottom:0;z-index:8;cursor:crosshair;cursor:-webkit-grab}.react-grid-Cell:not(.editing) .react-grid-Cell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;position:relative;top:50%;transform:translateY(-50%)}.react-grid-Cell.readonly{background-color:#000}.react-grid-Cell.copied{background:rgba(0,0,255,.2)!important}.react-grid-Cell--locked:last-of-type{border-right:1px solid #ddd;box-shadow:none;z-index:99}.react-grid-Cell:hover:focus .drag-handle .glyphicon-arrow-down{display:\"block\"}.react-grid-Cell.is-dragged-over-down{border-right:1px dashed #000;border-left:1px dashed #000;border-bottom:1px dashed #000}.react-grid-Cell.is-dragged-over-up{border-right:1px dashed #000;border-left:1px dashed #000;border-top:1px dashed #000}.react-grid-Cell.is-dragged-over-up .drag-handle{top:-5px}.react-grid-Cell:hover{background:#eee}.react-grid-cell .form-control-feedback{color:#a94442;position:absolute;top:0;right:10px;z-index:1000000;display:block;width:34px;height:34px}.react-grid-Cell.was-dragged-over{border-right:1px dashed #000;border-left:1px dashed #000}.react-grid-Cell:hover:focus .drag-handle{position:absolute;bottom:-8px;right:-7px;background:#fff;width:16px;height:16px;border:1px solid #66afe9;z-index:8;cursor:crosshair;cursor:-webkit-grab}.react-grid-Row.row-selected .react-grid-Cell{background-color:#dbecfa}.react-grid-Cell.editing{padding:0;overflow:visible!important}.react-grid-Cell.editing .has-error input{border:2px solid red!important;border-radius:2px!important}.react-grid-Cell__value ul{margin-top:0;margin-bottom:0;display:inline-block}.react-grid-Cell__value .btn-sm{padding:0}.cell-tooltip{position:relative;display:inline-block}.cell-tooltip .cell-tooltip-text{visibility:hidden;width:150px;background-color:#000;color:#fff;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;bottom:-150%;left:50%;margin-left:-60px;opacity:1s}.cell-tooltip:hover .cell-tooltip-text{visibility:visible;opacity:.8}.cell-tooltip .cell-tooltip-text:after{content:\" \";position:absolute;bottom:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent #000}.react-grid-Canvas.opaque .react-grid-Cell.cell-tooltip:hover .cell-tooltip-text{visibility:hidden}", ""]);
	
		// exports
	
	
	/***/ }),
	/* 194 */
	/***/ (function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".radio-custom,.react-grid-checkbox{opacity:0;position:absolute}.radio-custom,.radio-custom-label,.react-grid-checkbox,.react-grid-checkbox-label{display:inline-block;vertical-align:middle;margin:10px;cursor:pointer}.radio-custom-label,.react-grid-checkbox-label{position:relative}.radio-custom+.radio-custom-label:before,.react-grid-checkbox+.react-grid-checkbox-label:before{content:\"\";background:#fff;border:2px solid #ddd;display:inline-block;vertical-align:middle;width:20px;height:20px;text-align:center}.react-grid-checkbox:checked+.react-grid-checkbox-label:before{background:#005295;box-shadow:inset 0 0 0 4px #fff}.radio-custom:focus+.radio-custom-label,.react-grid-checkbox:focus+.react-grid-checkbox-label{outline:1px solid #ddd}.react-grid-HeaderCell input[type=checkbox]{z-index:99999}.react-grid-HeaderCell>.react-grid-checkbox-container{padding:0 10px;height:100%}.react-grid-HeaderCell>.react-grid-checkbox-container>.react-grid-checkbox-label{margin:0;margin-top:-.3em;position:relative;top:50%;transform:translateY(-50%)}.radio-custom+.radio-custom-label:before{border-radius:50%}.radio-custom:checked+.radio-custom-label:before{background:#ccc;box-shadow:inset 0 0 0 4px #fff}.checkbox-align{text-align:center}", ""]);
	
		// exports
	
	
	/***/ }),
	/* 195 */
	/***/ (function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Container{clear:both;margin-top:0;padding:0}.react-grid-Main{background-color:#fff;color:inherit;padding:0;outline:1px solid #e7eaec;clear:both}.react-grid-Grid{border:1px solid #ddd}.react-grid-Canvas,.react-grid-Grid{background-color:#fff}.react-grid-Cell input.editor-main,select.editor-main{display:block;width:100%;height:34px;padding:6px 12px;font-size:14px;line-height:1.42857143;color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}input.editor-main:focus,select.editor-main:focus{border-color:#66afe9;border:2px solid #66afe9;background:#eee;border-radius:4px}.react-grid-Cell input.editor-main::-moz-placeholder,select.editor-main::-moz-placeholder{color:#999;opacity:1}.react-grid-Cell input.editor-main:-ms-input-placeholder,select.editor-main:-ms-input-placeholder{color:#999}.react-grid-Cell input.editor-main::-webkit-input-placeholder,select.editor-main::-webkit-input-placeholder{color:#999}.react-grid-Cell input.editor-main[disabled],.react-grid-Cell input.editor-main[readonly],fieldset[disabled] .react-grid-Cell input.editor-main,fieldset[disabled] select.editor-main,select.editor-main[disabled],select.editor-main[readonly]{cursor:not-allowed;background-color:#eee;opacity:1}textarea.react-grid-Cell input.editor-main,textareaselect.editor-main{height:auto}.react-grid-ScrollShim{z-index:10002}", ""]);
	
		// exports
	
	
	/***/ }),
	/* 196 */
	/***/ (function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Header{box-shadow:0 0 4px 0 #ddd;background:#f9f9f9}.react-grid-Header--resizing{cursor:ew-resize}.react-grid-HeaderCell,.react-grid-HeaderRow{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.react-grid-HeaderCell{background:#f9f9f9;padding:8px;font-weight:700;border-right:1px solid #ddd;border-bottom:1px solid #ddd}.react-grid-HeaderCell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;position:relative;top:50%;transform:translateY(-50%)}.react-grid-HeaderCell__resizeHandle:hover{cursor:ew-resize;background:#ddd}.react-grid-HeaderCell--locked:last-of-type{box-shadow:none}.react-grid-HeaderCell--resizing .react-grid-HeaderCell__resizeHandle{background:#ddd}.react-grid-HeaderCell__draggable{cursor:col-resize}.rdg-can-drop>.react-grid-HeaderCell{background:#ececec}", ""]);
	
		// exports
	
	
	/***/ }),
	/* 197 */
	/***/ (function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Row.row-context-menu .react-grid-Cell,.react-grid-Row:hover .react-grid-Cell{background-color:#f2f2f2}.react-grid-Row:hover .rdg-row-index{display:none}.react-grid-Row:hover .rdg-actions-checkbox{display:block}.react-grid-Row:hover .rdg-drag-row-handle{cursor:move;cursor:grab;cursor:-moz-grab;cursor:-webkit-grab;width:12px;height:30px;margin-left:0;background-image:url(\"data:image/svg+xml;base64, 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\");background-repeat:no-repeat}.react-grid-Row.row-selected,.react-grid-Row .row-selected{background-color:#dbecfa}.react-grid-row-group .row-expand-icon:hover{color:#777}.react-grid-row-index{padding:0 18px}.rdg-row-index{display:block;text-align:center}.rdg-row-actions-cell{padding:0}.rdg-actions-checkbox{display:none;text-align:center}.rdg-actions-checkbox.selected{display:block}.rdg-dragging{cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}.rdg-dragged-row{border-bottom:1px solid #000}", ""]);
	
		// exports
	
	
	/***/ }),
	/* 198 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @providesModule invariant
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  if (false) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  }
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		module.exports = invariant;
	
	/***/ }),
	/* 199 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @providesModule keyMirror
		 * @typechecks static-only
		 */
	
		'use strict';
	
		var invariant = __webpack_require__(198);
	
		/**
		 * Constructs an enumeration with keys equal to their value.
		 *
		 * For example:
		 *
		 *   var COLORS = keyMirror({blue: null, red: null});
		 *   var myColor = COLORS.blue;
		 *   var isColorValid = !!COLORS[myColor];
		 *
		 * The last line could not be performed if the values of the generated enum were
		 * not equal to their keys.
		 *
		 *   Input:  {key1: val1, key2: val2}
		 *   Output: {key1: key1, key2: key2}
		 *
		 * @param {object} obj
		 * @return {object}
		 */
		var keyMirror = function (obj) {
		  var ret = {};
		  var key;
		  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
		  for (key in obj) {
		    if (!obj.hasOwnProperty(key)) {
		      continue;
		    }
		    ret[key] = key;
		  }
		  return ret;
		};
	
		module.exports = keyMirror;
	
	/***/ }),
	/* 200 */,
	/* 201 */,
	/* 202 */,
	/* 203 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		// rawAsap provides everything we need except exception management.
		var rawAsap = __webpack_require__(204);
		// RawTasks are recycled to reduce GC churn.
		var freeTasks = [];
		// We queue errors to ensure they are thrown in right order (FIFO).
		// Array-as-queue is good enough here, since we are just dealing with exceptions.
		var pendingErrors = [];
		var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
	
		function throwFirstError() {
		    if (pendingErrors.length) {
		        throw pendingErrors.shift();
		    }
		}
	
		/**
		 * Calls a task as soon as possible after returning, in its own event, with priority
		 * over other events like animation, reflow, and repaint. An error thrown from an
		 * event will not interrupt, nor even substantially slow down the processing of
		 * other events, but will be rather postponed to a lower priority event.
		 * @param {{call}} task A callable object, typically a function that takes no
		 * arguments.
		 */
		module.exports = asap;
		function asap(task) {
		    var rawTask;
		    if (freeTasks.length) {
		        rawTask = freeTasks.pop();
		    } else {
		        rawTask = new RawTask();
		    }
		    rawTask.task = task;
		    rawAsap(rawTask);
		}
	
		// We wrap tasks with recyclable task objects.  A task object implements
		// `call`, just like a function.
		function RawTask() {
		    this.task = null;
		}
	
		// The sole purpose of wrapping the task is to catch the exception and recycle
		// the task object after its single use.
		RawTask.prototype.call = function () {
		    try {
		        this.task.call();
		    } catch (error) {
		        if (asap.onerror) {
		            // This hook exists purely for testing purposes.
		            // Its name will be periodically randomized to break any code that
		            // depends on its existence.
		            asap.onerror(error);
		        } else {
		            // In a web browser, exceptions are not fatal. However, to avoid
		            // slowing down the queue of pending tasks, we rethrow the error in a
		            // lower priority turn.
		            pendingErrors.push(error);
		            requestErrorThrow();
		        }
		    } finally {
		        this.task = null;
		        freeTasks[freeTasks.length] = this;
		    }
		};
	
	
	/***/ }),
	/* 204 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		// Use the fastest means possible to execute a task in its own turn, with
		// priority over other events including IO, animation, reflow, and redraw
		// events in browsers.
		//
		// An exception thrown by a task will permanently interrupt the processing of
		// subsequent tasks. The higher level `asap` function ensures that if an
		// exception is thrown by a task, that the task queue will continue flushing as
		// soon as possible, but if you use `rawAsap` directly, you are responsible to
		// either ensure that no exceptions are thrown from your task, or to manually
		// call `rawAsap.requestFlush` if an exception is thrown.
		module.exports = rawAsap;
		function rawAsap(task) {
		    if (!queue.length) {
		        requestFlush();
		        flushing = true;
		    }
		    // Equivalent to push, but avoids a function call.
		    queue[queue.length] = task;
		}
	
		var queue = [];
		// Once a flush has been requested, no further calls to `requestFlush` are
		// necessary until the next `flush` completes.
		var flushing = false;
		// `requestFlush` is an implementation-specific method that attempts to kick
		// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
		// the event queue before yielding to the browser's own event loop.
		var requestFlush;
		// The position of the next task to execute in the task queue. This is
		// preserved between calls to `flush` so that it can be resumed if
		// a task throws an exception.
		var index = 0;
		// If a task schedules additional tasks recursively, the task queue can grow
		// unbounded. To prevent memory exhaustion, the task queue will periodically
		// truncate already-completed tasks.
		var capacity = 1024;
	
		// The flush function processes all tasks that have been scheduled with
		// `rawAsap` unless and until one of those tasks throws an exception.
		// If a task throws an exception, `flush` ensures that its state will remain
		// consistent and will resume where it left off when called again.
		// However, `flush` does not make any arrangements to be called again if an
		// exception is thrown.
		function flush() {
		    while (index < queue.length) {
		        var currentIndex = index;
		        // Advance the index before calling the task. This ensures that we will
		        // begin flushing on the next task the task throws an error.
		        index = index + 1;
		        queue[currentIndex].call();
		        // Prevent leaking memory for long chains of recursive calls to `asap`.
		        // If we call `asap` within tasks scheduled by `asap`, the queue will
		        // grow, but to avoid an O(n) walk for every task we execute, we don't
		        // shift tasks off the queue after they have been executed.
		        // Instead, we periodically shift 1024 tasks off the queue.
		        if (index > capacity) {
		            // Manually shift all values starting at the index back to the
		            // beginning of the queue.
		            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
		                queue[scan] = queue[scan + index];
		            }
		            queue.length -= index;
		            index = 0;
		        }
		    }
		    queue.length = 0;
		    index = 0;
		    flushing = false;
		}
	
		// `requestFlush` is implemented using a strategy based on data collected from
		// every available SauceLabs Selenium web driver worker at time of writing.
		// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
		// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
		// have WebKitMutationObserver but not un-prefixed MutationObserver.
		// Must use `global` or `self` instead of `window` to work in both frames and web
		// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
		/* globals self */
		var scope = typeof (window) !== "undefined" ? (window) : self;
		var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
		// MutationObservers are desirable because they have high priority and work
		// reliably everywhere they are implemented.
		// They are implemented in all modern browsers.
		//
		// - Android 4-4.3
		// - Chrome 26-34
		// - Firefox 14-29
		// - Internet Explorer 11
		// - iPad Safari 6-7.1
		// - iPhone Safari 7-7.1
		// - Safari 6-7
		if (typeof BrowserMutationObserver === "function") {
		    requestFlush = makeRequestCallFromMutationObserver(flush);
	
		// MessageChannels are desirable because they give direct access to the HTML
		// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
		// 11-12, and in web workers in many engines.
		// Although message channels yield to any queued rendering and IO tasks, they
		// would be better than imposing the 4ms delay of timers.
		// However, they do not work reliably in Internet Explorer or Safari.
	
		// Internet Explorer 10 is the only browser that has setImmediate but does
		// not have MutationObservers.
		// Although setImmediate yields to the browser's renderer, it would be
		// preferrable to falling back to setTimeout since it does not have
		// the minimum 4ms penalty.
		// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
		// Desktop to a lesser extent) that renders both setImmediate and
		// MessageChannel useless for the purposes of ASAP.
		// https://github.com/kriskowal/q/issues/396
	
		// Timers are implemented universally.
		// We fall back to timers in workers in most engines, and in foreground
		// contexts in the following browsers.
		// However, note that even this simple case requires nuances to operate in a
		// broad spectrum of browsers.
		//
		// - Firefox 3-13
		// - Internet Explorer 6-9
		// - iPad Safari 4.3
		// - Lynx 2.8.7
		} else {
		    requestFlush = makeRequestCallFromTimer(flush);
		}
	
		// `requestFlush` requests that the high priority event queue be flushed as
		// soon as possible.
		// This is useful to prevent an error thrown in a task from stalling the event
		// queue if the exception handled by Node.js’s
		// `process.on("uncaughtException")` or by a domain.
		rawAsap.requestFlush = requestFlush;
	
		// To request a high priority event, we induce a mutation observer by toggling
		// the text of a text node between "1" and "-1".
		function makeRequestCallFromMutationObserver(callback) {
		    var toggle = 1;
		    var observer = new BrowserMutationObserver(callback);
		    var node = document.createTextNode("");
		    observer.observe(node, {characterData: true});
		    return function requestCall() {
		        toggle = -toggle;
		        node.data = toggle;
		    };
		}
	
		// The message channel technique was discovered by Malte Ubl and was the
		// original foundation for this library.
		// http://www.nonblocking.io/2011/06/windownexttick.html
	
		// Safari 6.0.5 (at least) intermittently fails to create message ports on a
		// page's first load. Thankfully, this version of Safari supports
		// MutationObservers, so we don't need to fall back in that case.
	
		// function makeRequestCallFromMessageChannel(callback) {
		//     var channel = new MessageChannel();
		//     channel.port1.onmessage = callback;
		//     return function requestCall() {
		//         channel.port2.postMessage(0);
		//     };
		// }
	
		// For reasons explained above, we are also unable to use `setImmediate`
		// under any circumstances.
		// Even if we were, there is another bug in Internet Explorer 10.
		// It is not sufficient to assign `setImmediate` to `requestFlush` because
		// `setImmediate` must be called *by name* and therefore must be wrapped in a
		// closure.
		// Never forget.
	
		// function makeRequestCallFromSetImmediate(callback) {
		//     return function requestCall() {
		//         setImmediate(callback);
		//     };
		// }
	
		// Safari 6.0 has a problem where timers will get lost while the user is
		// scrolling. This problem does not impact ASAP because Safari 6.0 supports
		// mutation observers, so that implementation is used instead.
		// However, if we ever elect to use timers in Safari, the prevalent work-around
		// is to add a scroll event listener that calls for a flush.
	
		// `setTimeout` does not call the passed callback if the delay is less than
		// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
		// even then.
	
		function makeRequestCallFromTimer(callback) {
		    return function requestCall() {
		        // We dispatch a timeout with a specified delay of 0 for engines that
		        // can reliably accommodate that request. This will usually be snapped
		        // to a 4 milisecond delay, but once we're flushing, there's no delay
		        // between events.
		        var timeoutHandle = setTimeout(handleTimer, 0);
		        // However, since this timer gets frequently dropped in Firefox
		        // workers, we enlist an interval handle that will try to fire
		        // an event 20 times per second until it succeeds.
		        var intervalHandle = setInterval(handleTimer, 50);
	
		        function handleTimer() {
		            // Whichever timer succeeds will cancel both timers and
		            // execute the callback.
		            clearTimeout(timeoutHandle);
		            clearInterval(intervalHandle);
		            callback();
		        }
		    };
		}
	
		// This is for `asap.js` only.
		// Its name will be periodically randomized to break any code that depends on
		// its existence.
		rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
		// ASAP was originally a nextTick shim included in Q. This was factored out
		// into this ASAP package. It was later adapted to RSVP which made further
		// amendments. These decisions, particularly to marginalize MessageChannel and
		// to capture the MutationObserver implementation in a closure, were integrated
		// back into ASAP proper.
		// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	
	/***/ }),
	/* 205 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		__webpack_require__(399);
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactSelect = __webpack_require__(50);
	
		var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var isEmptyArray = _reactDataGrid.utils.isEmptyArray;
		var ExcelColumn = _reactDataGrid.shapes.ExcelColumn;
	
		var AutoCompleteFilter = function (_React$Component) {
		  _inherits(AutoCompleteFilter, _React$Component);
	
		  function AutoCompleteFilter(props) {
		    _classCallCheck(this, AutoCompleteFilter);
	
		    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
		    _this.getOptions = _this.getOptions.bind(_this);
		    _this.handleChange = _this.handleChange.bind(_this);
		    _this.filterValues = _this.filterValues.bind(_this);
		    _this.state = { options: _this.getOptions(), rawValue: '', placeholder: 'Search...' };
		    return _this;
		  }
	
		  AutoCompleteFilter.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
		    this.setState({ options: this.getOptions(newProps) });
		  };
	
		  AutoCompleteFilter.prototype.getOptions = function getOptions(newProps) {
		    var props = newProps || this.props;
		    var options = props.getValidFilterValues(props.column.key);
		    options = options.map(function (o) {
		      if (typeof o === 'string') {
		        return { value: o, label: o };
		      }
		      return o;
		    });
		    return options;
		  };
	
		  AutoCompleteFilter.prototype.columnValueContainsSearchTerms = function columnValueContainsSearchTerms(columnValue, filterTerms) {
		    var columnValueContainsSearchTerms = false;
	
		    for (var key in filterTerms) {
		      if (!filterTerms.hasOwnProperty(key)) {
		        continue;
		      }
	
		      if (columnValue !== undefined && filterTerms[key].value !== undefined) {
		        var strColumnValue = columnValue.toString();
		        var filterTermValue = filterTerms[key].value.toString();
		        var checkValueIndex = strColumnValue.trim().toLowerCase().indexOf(filterTermValue.trim().toLowerCase());
		        var columnMatchesSearch = checkValueIndex !== -1 && (checkValueIndex !== 0 || strColumnValue === filterTermValue);
		        if (columnMatchesSearch === true) {
		          columnValueContainsSearchTerms = true;
		          break;
		        }
		      }
		    }
	
		    return columnValueContainsSearchTerms;
		  };
	
		  AutoCompleteFilter.prototype.filterValues = function filterValues(row, columnFilter, columnKey) {
		    var include = true;
		    if (columnFilter === null) {
		      include = false;
		    } else if (!isEmptyArray(columnFilter.filterTerm)) {
		      include = this.columnValueContainsSearchTerms(row[columnKey], columnFilter.filterTerm);
		    }
		    return include;
		  };
	
		  AutoCompleteFilter.prototype.handleChange = function handleChange(value) {
		    var filters = value;
		    this.setState({ filters: filters });
		    this.props.onChange({ filterTerm: filters, column: this.props.column, rawValue: value, filterValues: this.filterValues });
		  };
	
		  AutoCompleteFilter.prototype.render = function render() {
		    var filterName = 'filter-' + this.props.column.key;
		    return _react2['default'].createElement(
		      'div',
		      { style: { width: this.props.column.width * 0.9 } },
		      _react2['default'].createElement(_reactSelect2['default'], {
		        name: filterName,
		        options: this.state.options,
		        placeholder: this.state.placeholder,
		        onChange: this.handleChange,
		        escapeClearsValue: true,
		        multi: true,
		        value: this.state.filters
		      })
		    );
		  };
	
		  return AutoCompleteFilter;
		}(_react2['default'].Component);
	
		AutoCompleteFilter.propTypes = {
		  onChange: _react.PropTypes.func.isRequired,
		  column: _react2['default'].PropTypes.shape(ExcelColumn),
		  getValidFilterValues: _react.PropTypes.func
		};
	
		exports['default'] = AutoCompleteFilter;
	
	/***/ }),
	/* 206 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var ExcelColumn = _reactDataGrid.shapes.ExcelColumn;
	
		var RuleType = {
		  Number: 1,
		  Range: 2,
		  GreaterThen: 3,
		  LessThen: 4
		};
	
		var NumericFilter = function (_React$Component) {
		  _inherits(NumericFilter, _React$Component);
	
		  function NumericFilter(props) {
		    _classCallCheck(this, NumericFilter);
	
		    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
		    _this.handleChange = _this.handleChange.bind(_this);
		    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
		    _this.getRules = _this.getRules.bind(_this);
		    return _this;
		  }
	
		  NumericFilter.prototype.filterValues = function filterValues(row, columnFilter, columnKey) {
		    if (columnFilter.filterTerm == null) {
		      return true;
		    }
		    var result = false;
		    // implement default filter logic
		    var value = parseInt(row[columnKey], 10);
		    for (var ruleKey in columnFilter.filterTerm) {
		      if (!columnFilter.filterTerm.hasOwnProperty(ruleKey)) {
		        continue;
		      }
	
		      var rule = columnFilter.filterTerm[ruleKey];
	
		      switch (rule.type) {
		        case RuleType.Number:
		          if (rule.value === value) {
		            result = true;
		          }
		          break;
		        case RuleType.GreaterThen:
		          if (rule.value <= value) {
		            result = true;
		          }
		          break;
		        case RuleType.LessThen:
		          if (rule.value >= value) {
		            result = true;
		          }
		          break;
		        case RuleType.Range:
		          if (rule.begin <= value && rule.end >= value) {
		            result = true;
		          }
		          break;
		        default:
		          // do nothing
		          break;
		      }
		    }
		    return result;
		  };
	
		  NumericFilter.prototype.getRules = function getRules(value) {
		    var rules = [];
		    if (value === '') {
		      return rules;
		    }
		    // check comma
		    var list = value.split(',');
		    if (list.length > 0) {
		      // handle each value with comma
		      for (var key in list) {
		        if (!list.hasOwnProperty(key)) {
		          continue;
		        }
	
		        var obj = list[key];
		        if (obj.indexOf('-') > 0) {
		          // handle dash
		          var begin = parseInt(obj.split('-')[0], 10);
		          var end = parseInt(obj.split('-')[1], 10);
		          rules.push({ type: RuleType.Range, begin: begin, end: end });
		        } else if (obj.indexOf('>') > -1) {
		          // handle greater then
		          var _begin = parseInt(obj.split('>')[1], 10);
		          rules.push({ type: RuleType.GreaterThen, value: _begin });
		        } else if (obj.indexOf('<') > -1) {
		          // handle less then
		          var _end = parseInt(obj.split('<')[1], 10);
		          rules.push({ type: RuleType.LessThen, value: _end });
		        } else {
		          // handle normal values
		          var numericValue = parseInt(obj, 10);
		          rules.push({ type: RuleType.Number, value: numericValue });
		        }
		      }
		    }
		    return rules;
		  };
	
		  NumericFilter.prototype.handleKeyPress = function handleKeyPress(e) {
		    // Validate the input
		    var regex = '>|<|-|,|([0-9])';
		    var result = RegExp(regex).test(e.key);
		    if (result === false) {
		      e.preventDefault();
		    }
		  };
	
		  NumericFilter.prototype.handleChange = function handleChange(e) {
		    var value = e.target.value;
		    var filters = this.getRules(value);
		    this.props.onChange({ filterTerm: filters.length > 0 ? filters : null, column: this.props.column, rawValue: value, filterValues: this.filterValues });
		  };
	
		  NumericFilter.prototype.render = function render() {
		    var inputKey = 'header-filter-' + this.props.column.key;
		    var columnStyle = {
		      float: 'left',
		      marginRight: 5,
		      maxWidth: '80%'
		    };
		    var badgeStyle = {
		      cursor: 'help'
		    };
	
		    var tooltipText = 'Input Methods: Range (x-y), Greater Then (>x), Less Then (<y)';
	
		    return _react2['default'].createElement(
		      'div',
		      null,
		      _react2['default'].createElement(
		        'div',
		        { style: columnStyle },
		        _react2['default'].createElement('input', { key: inputKey, type: 'text', placeholder: 'e.g. 3,10-15,>20', className: 'form-control input-sm', onChange: this.handleChange, onKeyPress: this.handleKeyPress })
		      ),
		      _react2['default'].createElement(
		        'div',
		        { className: 'input-sm' },
		        _react2['default'].createElement(
		          'span',
		          { className: 'badge', style: badgeStyle, title: tooltipText },
		          '?'
		        )
		      )
		    );
		  };
	
		  return NumericFilter;
		}(_react2['default'].Component);
	
		NumericFilter.propTypes = {
		  onChange: _react2['default'].PropTypes.func.isRequired,
		  column: _react2['default'].PropTypes.shape(ExcelColumn)
		};
		module.exports = NumericFilter;
	
	/***/ }),
	/* 207 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _NumericFilter = __webpack_require__(206);
	
		var _NumericFilter2 = _interopRequireDefault(_NumericFilter);
	
		var _AutoCompleteFilter = __webpack_require__(205);
	
		var _AutoCompleteFilter2 = _interopRequireDefault(_AutoCompleteFilter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var Filters = {
		  NumericFilter: _NumericFilter2['default'],
		  AutoCompleteFilter: _AutoCompleteFilter2['default']
		};
	
		module.exports = Filters;
	
	/***/ }),
	/* 208 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDataGrid = __webpack_require__(3);
	
		var getMixedTypeValueRetriever = _reactDataGrid.utils.getMixedTypeValueRetriever,
		    isImmutableCollection = _reactDataGrid.utils.isImmutableCollection;
	
	
		var filterRows = function filterRows(filters) {
		  var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
		  return rows.filter(function (r) {
		    var retriever = getMixedTypeValueRetriever(isImmutableCollection(r));
		    var include = true;
		    for (var columnKey in filters) {
		      if (filters.hasOwnProperty(columnKey)) {
		        var colFilter = filters[columnKey];
		        // check if custom filter function exists
		        if (colFilter.filterValues && typeof colFilter.filterValues === 'function') {
		          include = include & colFilter.filterValues(r, colFilter, columnKey);
		        } else if (typeof colFilter.filterTerm === 'string') {
		          // default filter action
		          var rowValue = retriever.getValue(r, columnKey);
		          if (rowValue) {
		            if (rowValue.toString().toLowerCase().indexOf(colFilter.filterTerm.toLowerCase()) === -1) {
		              include = include & false;
		            }
		          } else {
		            include = include & false;
		          }
		        }
		      }
		    }
		    return Boolean(include);
		  });
		};
	
		module.exports = filterRows;
	
	/***/ }),
	/* 209 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDataGrid = __webpack_require__(3);
	
		var _RowGrouperResolver = __webpack_require__(210);
	
		var _RowGrouperResolver2 = _interopRequireDefault(_RowGrouperResolver);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var isImmutableCollection = _reactDataGrid.utils.isImmutableCollection;
	
		var RowGrouper = function () {
		  function RowGrouper(columns, expandedRows) {
		    var isImmutable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
		    _classCallCheck(this, RowGrouper);
	
		    this.columns = columns.slice(0);
		    this.expandedRows = expandedRows;
		    this.resolver = new _RowGrouperResolver2['default'](isImmutable);
		  }
	
		  RowGrouper.prototype.isRowExpanded = function isRowExpanded(columnName, name) {
		    var isExpanded = true;
		    var expandedRowGroup = this.expandedRows[columnName];
		    if (expandedRowGroup && expandedRowGroup[name]) {
		      isExpanded = expandedRowGroup[name].isExpanded;
		    }
		    return isExpanded;
		  };
	
		  RowGrouper.prototype.groupRowsByColumn = function groupRowsByColumn(rows) {
		    var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
		    var nextColumnIndex = columnIndex;
		    var columnName = this.columns[columnIndex];
		    var groupedRows = this.resolver.getGroupedRows(rows, columnName);
		    var keys = this.resolver.getGroupKeys(groupedRows);
		    var dataviewRows = this.resolver.initRowsCollection();
	
		    for (var i = 0; i < keys.length; i++) {
		      var key = keys[i];
		      var isExpanded = this.isRowExpanded(columnName, key);
		      var rowGroupHeader = { name: key, __metaData: { isGroup: true, treeDepth: columnIndex, isExpanded: isExpanded, columnGroupName: columnName } };
	
		      dataviewRows = this.resolver.addHeaderRow(rowGroupHeader, dataviewRows);
	
		      if (isExpanded) {
		        nextColumnIndex = columnIndex + 1;
		        if (this.columns.length > nextColumnIndex) {
		          dataviewRows = dataviewRows.concat(this.groupRowsByColumn(this.resolver.getRowObj(groupedRows, key), nextColumnIndex));
		          nextColumnIndex = columnIndex - 1;
		        } else {
		          dataviewRows = dataviewRows.concat(this.resolver.getRowObj(groupedRows, key));
		        }
		      }
		    }
		    return dataviewRows;
		  };
	
		  return RowGrouper;
		}();
	
		var groupRows = function groupRows(rows, groupedColumns, expandedRows) {
		  var rowGrouper = new RowGrouper(groupedColumns, expandedRows, isImmutableCollection(rows));
		  return rowGrouper.groupRowsByColumn(rows, 0);
		};
	
		module.exports = groupRows;
	
	/***/ }),
	/* 210 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _immutable = __webpack_require__(18);
	
		var _groupBy = __webpack_require__(490);
	
		var _groupBy2 = _interopRequireDefault(_groupBy);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var getMixedTypeValueRetriever = _reactDataGrid.utils.getMixedTypeValueRetriever,
		    isImmutableMap = _reactDataGrid.utils.isImmutableMap;
	
		var RowGrouperResolver = function () {
		  function RowGrouperResolver(isImmutable) {
		    _classCallCheck(this, RowGrouperResolver);
	
		    this.isImmutable = isImmutable;
		    this.getRowObj = getMixedTypeValueRetriever(isImmutable).getValue;
		  }
	
		  RowGrouperResolver.prototype.initRowsCollection = function initRowsCollection() {
		    return this.isImmutable ? new _immutable.List() : [];
		  };
	
		  RowGrouperResolver.prototype.getGroupedRows = function getGroupedRows(rows, columnName) {
		    return this.isImmutable ? rows.groupBy(function (x) {
		      return isImmutableMap(x) ? x.get(columnName) : x[columnName];
		    }) : (0, _groupBy2['default'])(rows, columnName);
		  };
	
		  RowGrouperResolver.prototype.getGroupKeys = function getGroupKeys(groupedRows) {
		    var getKeys = Object.keys;
		    if (this.isImmutable) {
		      getKeys = function getKeys(col) {
		        var keys = [];
		        var iterator = col.keys();
		        var item = iterator.next();
	
		        while (!item.done) {
		          keys.push(item.value);
		          item = iterator.next();
		        }
		        return keys;
		      };
		    }
		    return getKeys(groupedRows);
		  };
	
		  RowGrouperResolver.prototype.addHeaderRow = function addHeaderRow(rowGroupHeader, dataviewRows) {
		    var rows = dataviewRows;
		    var dvRows = rows.push(rowGroupHeader);
		    if (this.isImmutable) {
		      return dvRows;
		    }
		    return rows;
		  };
	
		  return RowGrouperResolver;
		}();
	
		exports['default'] = RowGrouperResolver;
	
	/***/ }),
	/* 211 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDataGrid = __webpack_require__(3);
	
		var getMixedTypeValueRetriever = _reactDataGrid.utils.getMixedTypeValueRetriever,
		    isImmutableCollection = _reactDataGrid.utils.isImmutableCollection;
	
	
		var comparer = function comparer(a, b) {
		  if (a > b) {
		    return 1;
		  } else if (a < b) {
		    return -1;
		  }
		  return 0;
		};
	
		var sortRows = function sortRows(rows, sortColumn, sortDirection) {
		  var retriever = getMixedTypeValueRetriever(isImmutableCollection(rows));
		  var sortDirectionSign = sortDirection === 'ASC' ? 1 : -1;
		  var rowComparer = function rowComparer(a, b) {
		    return sortDirectionSign * comparer(retriever.getValue(a, sortColumn), retriever.getValue(b, sortColumn));
		  };
		  if (sortDirection === 'NONE') {
		    return rows;
		  }
		  return [].concat(rows).sort(rowComparer);
		};
	
		module.exports = sortRows;
		module.exports.comparer = comparer;
	
	/***/ }),
	/* 212 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = {
		  Selectors: __webpack_require__(100)
		};
	
	/***/ }),
	/* 213 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDnd = __webpack_require__(16);
	
		var _reactDndHtml5Backend = __webpack_require__(128);
	
		var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);
	
		var _DraggableHeaderCell = __webpack_require__(214);
	
		var _DraggableHeaderCell2 = _interopRequireDefault(_DraggableHeaderCell);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var DraggableContainer = function (_React$Component) {
		  _inherits(DraggableContainer, _React$Component);
	
		  function DraggableContainer() {
		    _classCallCheck(this, DraggableContainer);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  DraggableContainer.prototype.renderGrid = function renderGrid() {
		    return _react2['default'].Children.map(this.props.children, function (child) {
		      return _react2['default'].cloneElement(child, {
		        draggableHeaderCell: _DraggableHeaderCell2['default']
		      });
		    })[0];
		  };
	
		  DraggableContainer.prototype.render = function render() {
		    var grid = this.renderGrid();
		    return _react2['default'].createElement(
		      'div',
		      null,
		      _react2['default'].cloneElement(grid, this.props)
		    );
		  };
	
		  return DraggableContainer;
		}(_react2['default'].Component);
	
		DraggableContainer.propTypes = {
		  children: _react.PropTypes.element
		};
	
		exports['default'] = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2['default'])(DraggableContainer);
	
	/***/ }),
	/* 214 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDnd = __webpack_require__(16);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var DraggableHeaderCell = function (_React$Component) {
		  _inherits(DraggableHeaderCell, _React$Component);
	
		  function DraggableHeaderCell() {
		    _classCallCheck(this, DraggableHeaderCell);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  DraggableHeaderCell.prototype.render = function render() {
		    var _props = this.props,
		        connectDragSource = _props.connectDragSource,
		        connectDropTarget = _props.connectDropTarget,
		        isDragging = _props.isDragging,
		        isOver = _props.isOver,
		        canDrop = _props.canDrop;
	
	
		    var opacity = 1;
		    if (isDragging) {
		      opacity = 0.2;
		    }
	
		    // set drag source and drop target on header cell
		    // width: 0 - otherwise drag clone was wrongly positioned
		    return connectDragSource(connectDropTarget(_react2['default'].createElement(
		      'div',
		      {
		        style: { width: 0, cursor: 'move', opacity: opacity },
		        className: isOver && canDrop ? 'rdg-can-drop' : ''
		      },
		      _react2['default'].createElement(_reactDataGrid.HeaderCell, this.props)
		    )));
		  };
	
		  return DraggableHeaderCell;
		}(_react2['default'].Component);
	
		// drop source
	
	
		function collect(connect, monitor) {
		  return {
		    connectDragSource: connect.dragSource(),
		    isDragging: monitor.isDragging()
		  };
		}
	
		var headerCellSource = {
		  beginDrag: function beginDrag(props) {
		    return {
		      // source column
		      key: props.column.key
		    };
		  },
		  endDrag: function endDrag(props, monitor) {
		    // check if drop was made in droppable zone
		    if (monitor.didDrop()) {
		      var source = monitor.getDropResult().source;
		      var _target = monitor.getDropResult().target;
		      return props.onHeaderDrop(source, _target);
		    }
		  }
		};
	
		// drop target
		var target = {
		  drop: function drop(props, monitor) {
		    var source = monitor.getItem().key;
		    var targetKey = props.column.key;
		    return {
		      source: source,
		      target: targetKey
		    };
		  }
		};
	
		function targetCollect(connect, monitor) {
		  return {
		    connectDropTarget: connect.dropTarget(),
		    isOver: monitor.isOver(),
		    canDrop: monitor.canDrop(),
		    draggedHeader: monitor.getItem()
		  };
		}
	
		DraggableHeaderCell.propTypes = {
		  connectDragSource: _react.PropTypes.func.isRequired,
		  connectDropTarget: _react.PropTypes.func.isRequired,
		  isDragging: _react.PropTypes.bool.isRequired,
		  isOver: _react.PropTypes.bool,
		  canDrop: _react.PropTypes.bool
		};
	
		DraggableHeaderCell = (0, _reactDnd.DropTarget)('Column', target, targetCollect)(DraggableHeaderCell);
		DraggableHeaderCell = (0, _reactDnd.DragSource)('Column', headerCellSource, collect)(DraggableHeaderCell);
	
		exports['default'] = DraggableHeaderCell;
	
	/***/ }),
	/* 215 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _DraggableContainer = __webpack_require__(213);
	
		var _DraggableContainer2 = _interopRequireDefault(_DraggableContainer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		module.exports = { DraggableContainer: _DraggableContainer2['default'] };
	
	/***/ }),
	/* 216 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDndHtml5Backend = __webpack_require__(128);
	
		var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);
	
		var _reactDnd = __webpack_require__(16);
	
		var _DraggableHeaderCell = __webpack_require__(101);
	
		var _DraggableHeaderCell2 = _interopRequireDefault(_DraggableHeaderCell);
	
		var _RowDragLayer = __webpack_require__(219);
	
		var _RowDragLayer2 = _interopRequireDefault(_RowDragLayer);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var isColumnsImmutable = _reactDataGrid.utils.isColumnsImmutable;
	
		var DraggableContainer = function (_Component) {
		  _inherits(DraggableContainer, _Component);
	
		  function DraggableContainer() {
		    _classCallCheck(this, DraggableContainer);
	
		    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		  }
	
		  DraggableContainer.prototype.getRows = function getRows(rowsCount, rowGetter) {
		    var rows = [];
		    for (var j = 0; j < rowsCount; j++) {
		      rows.push(rowGetter(j));
		    }
		    return rows;
		  };
	
		  DraggableContainer.prototype.renderGrid = function renderGrid() {
		    return _react2['default'].Children.map(this.props.children, function (child) {
		      return _react2['default'].cloneElement(child, { draggableHeaderCell: _DraggableHeaderCell2['default'] });
		    })[0];
		  };
	
		  DraggableContainer.prototype.render = function render() {
		    var grid = this.renderGrid();
		    var rowGetter = this.props.getDragPreviewRow || grid.props.rowGetter;
		    var rowsCount = grid.props.rowsCount;
		    var columns = grid.props.columns;
		    var rows = this.getRows(rowsCount, rowGetter);
		    return _react2['default'].createElement(
		      'div',
		      null,
		      grid,
		      _react2['default'].createElement(_RowDragLayer2['default'], { rowSelection: grid.props.rowSelection, rows: rows, columns: isColumnsImmutable(columns) ? columns.toArray() : columns })
		    );
		  };
	
		  return DraggableContainer;
		}(_react.Component);
	
		DraggableContainer.propTypes = {
		  children: _react2['default'].PropTypes.element.isRequired,
		  getDragPreviewRow: _react2['default'].PropTypes.func
		};
	
		exports['default'] = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2['default'])(DraggableContainer);
	
	/***/ }),
	/* 217 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		__webpack_require__(400);
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _reactDnd = __webpack_require__(16);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var rowDropTarget = function rowDropTarget(Row) {
		  return function (_React$Component) {
		    _inherits(_class, _React$Component);
	
		    function _class() {
		      _classCallCheck(this, _class);
	
		      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		    }
	
		    _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		      return (0, _reactDataGrid.RowComparer)(nextProps, this.props);
		    };
	
		    _class.prototype.moveRow = function moveRow() {
		      _reactDom2['default'].findDOMNode(this).classList.add('slideUp');
		    };
	
		    _class.prototype.render = function render() {
		      var _this2 = this;
	
		      var _props = this.props,
		          connectDropTarget = _props.connectDropTarget,
		          isOver = _props.isOver,
		          canDrop = _props.canDrop;
	
		      var overlayTop = this.props.idx * this.props.height;
		      return connectDropTarget(_react2['default'].createElement(
		        'div',
		        null,
		        _react2['default'].createElement(Row, _extends({ ref: function ref(node) {
		            return _this2.row = node;
		          } }, this.props)),
		        isOver && canDrop && _react2['default'].createElement('div', { style: {
		            position: 'absolute',
		            top: overlayTop,
		            left: 0,
		            height: this.props.height,
		            width: '100%',
		            zIndex: 1,
		            borderBottom: '1px solid black'
		          } })
		      ));
		    };
	
		    return _class;
		  }(_react2['default'].Component);
		};
	
		var target = {
		  drop: function drop(props, monitor, component) {
		    // Obtain the dragged item
		    component.moveRow();
		    var rowSource = monitor.getItem();
		    var rowTarget = { idx: props.idx, data: props.row };
		    props.onRowDrop({ rowSource: rowSource, rowTarget: rowTarget });
		  }
		};
	
		function collect(connect, monitor) {
		  return {
		    connectDropTarget: connect.dropTarget(),
		    isOver: monitor.isOver(),
		    canDrop: monitor.canDrop(),
		    draggedRow: monitor.getItem()
		  };
		}
	
		exports['default'] = function (Row) {
		  return (0, _reactDnd.DropTarget)('Row', target, collect, { arePropsEqual: function arePropsEqual(nextProps, currentProps) {
		      return !(0, _reactDataGrid.RowComparer)(nextProps, currentProps);
		    } })(rowDropTarget(Row));
		};
	
	/***/ }),
	/* 218 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		__webpack_require__(27);
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDnd = __webpack_require__(16);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var CheckboxEditor = _reactDataGrid.editors.CheckboxEditor;
	
		var RowActionsCell = function (_React$Component) {
		  _inherits(RowActionsCell, _React$Component);
	
		  function RowActionsCell() {
		    _classCallCheck(this, RowActionsCell);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  RowActionsCell.prototype.renderRowIndex = function renderRowIndex() {
		    return _react2['default'].createElement(
		      'div',
		      { className: 'rdg-row-index' },
		      this.props.rowIdx + 1
		    );
		  };
	
		  RowActionsCell.prototype.render = function render() {
		    var _props = this.props,
		        connectDragSource = _props.connectDragSource,
		        rowSelection = _props.rowSelection;
	
		    var rowHandleStyle = rowSelection != null ? { position: 'absolute', marginTop: '5px' } : {};
		    var isSelected = this.props.value;
		    var editorClass = isSelected ? 'rdg-actions-checkbox selected' : 'rdg-actions-checkbox';
	
		    return connectDragSource(_react2['default'].createElement(
		      'div',
		      null,
		      _react2['default'].createElement('div', { className: 'rdg-drag-row-handle', style: rowHandleStyle }),
		      !isSelected ? this.renderRowIndex() : null,
		      rowSelection != null && _react2['default'].createElement(
		        'div',
		        { className: editorClass },
		        _react2['default'].createElement(CheckboxEditor, { column: this.props.column, rowIdx: this.props.rowIdx, dependentValues: this.props.dependentValues, value: this.props.value })
		      )
		    ));
		  };
	
		  return RowActionsCell;
		}(_react2['default'].Component);
	
		RowActionsCell.propTypes = {
		  rowIdx: _react.PropTypes.number.isRequired,
		  connectDragSource: _react.PropTypes.func.isRequired,
		  connectDragPreview: _react.PropTypes.func.isRequired,
		  isDragging: _react.PropTypes.bool.isRequired,
		  isRowHovered: _react.PropTypes.bool,
		  column: _react.PropTypes.object,
		  dependentValues: _react.PropTypes.object,
		  value: _react.PropTypes.bool,
		  rowSelection: _react.PropTypes.object.isRequired
		};
	
		RowActionsCell.defaultProps = {
		  rowIdx: 0
		};
	
		function collect(connect, monitor) {
		  return {
		    connectDragSource: connect.dragSource(),
		    isDragging: monitor.isDragging(),
		    connectDragPreview: connect.dragPreview()
		  };
		}
	
		var rowIndexSource = {
		  beginDrag: function beginDrag(props) {
		    return { idx: props.rowIdx, data: props.dependentValues };
		  },
		  endDrag: function endDrag(props) {
		    return { idx: props.rowIdx, data: props.dependentValues };
		  }
		};
	
		exports['default'] = (0, _reactDnd.DragSource)('Row', rowIndexSource, collect)(RowActionsCell);
	
	/***/ }),
	/* 219 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDnd = __webpack_require__(16);
	
		var _Selectors = __webpack_require__(100);
	
		var _Selectors2 = _interopRequireDefault(_Selectors);
	
		__webpack_require__(38);
	
		__webpack_require__(27);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var layerStyles = {
		  cursor: '-webkit-grabbing',
		  position: 'fixed',
		  pointerEvents: 'none',
		  zIndex: 100,
		  left: 0,
		  top: 0,
		  width: '100%',
		  height: '100%'
		};
	
		function getItemStyles(props) {
		  var currentOffset = props.currentOffset;
	
		  if (!currentOffset) {
		    return {
		      display: 'none'
		    };
		  }
	
		  var x = currentOffset.x,
		      y = currentOffset.y;
	
		  var transform = 'translate(' + x + 'px, ' + y + 'px)';
		  return {
		    transform: transform,
		    WebkitTransform: transform
		  };
		}
	
		var CustomDragLayer = function (_Component) {
		  _inherits(CustomDragLayer, _Component);
	
		  function CustomDragLayer() {
		    _classCallCheck(this, CustomDragLayer);
	
		    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		  }
	
		  CustomDragLayer.prototype.isDraggedRowSelected = function isDraggedRowSelected(selectedRows) {
		    var _props = this.props,
		        item = _props.item,
		        rowSelection = _props.rowSelection;
	
		    if (selectedRows && selectedRows.length > 0) {
		      var key = rowSelection.selectBy.keys.rowKey;
		      return selectedRows.filter(function (r) {
		        return r[key] === item.data[key];
		      }).length > 0;
		    }
		    return false;
		  };
	
		  CustomDragLayer.prototype.getDraggedRows = function getDraggedRows() {
		    var draggedRows = void 0;
		    var rowSelection = this.props.rowSelection;
	
		    if (rowSelection && rowSelection.selectBy.keys) {
		      var rows = this.props.rows;
		      var _rowSelection$selectB = rowSelection.selectBy.keys,
		          rowKey = _rowSelection$selectB.rowKey,
		          values = _rowSelection$selectB.values;
	
		      var selectedRows = _Selectors2['default'].getSelectedRowsByKey({ rowKey: rowKey, selectedKeys: values, rows: rows });
		      draggedRows = this.isDraggedRowSelected(selectedRows) ? selectedRows : [this.props.rows[this.props.item.idx]];
		    } else {
		      draggedRows = [this.props.rows[this.props.item.idx]];
		    }
		    return draggedRows;
		  };
	
		  CustomDragLayer.prototype.renderDraggedRows = function renderDraggedRows() {
		    var _this2 = this;
	
		    var columns = this.props.columns;
		    return this.getDraggedRows().map(function (r, i) {
		      return _react2['default'].createElement(
		        'tr',
		        { key: 'dragged-row-' + i },
		        _this2.renderDraggedCells(r, i, columns)
		      );
		    });
		  };
	
		  CustomDragLayer.prototype.renderDraggedCells = function renderDraggedCells(item, rowIdx, columns) {
		    var cells = [];
		    if (item != null) {
		      columns.forEach(function (c) {
		        if (item.hasOwnProperty(c.key)) {
		          if (c.formatter) {
		            var Formatter = c.formatter;
		            var dependentValues = typeof c.getRowMetaData === 'function' ? c.getRowMetaData(item, c) : {};
		            cells.push(_react2['default'].createElement(
		              'td',
		              { key: 'dragged-cell-' + rowIdx + '-' + c.key, className: 'react-grid-Cell', style: { padding: '5px' } },
		              _react2['default'].createElement(Formatter, { dependentValues: dependentValues, value: item[c.key] })
		            ));
		          } else {
		            cells.push(_react2['default'].createElement(
		              'td',
		              { key: 'dragged-cell-' + rowIdx + '-' + c.key, className: 'react-grid-Cell', style: { padding: '5px' } },
		              item[c.key]
		            ));
		          }
		        }
		      });
		    }
		    return cells;
		  };
	
		  CustomDragLayer.prototype.render = function render() {
		    var isDragging = this.props.isDragging;
	
		    if (!isDragging) {
		      return null;
		    }
		    var draggedRows = this.renderDraggedRows();
		    return _react2['default'].createElement(
		      'div',
		      { style: layerStyles, className: 'rdg-dragging' },
		      _react2['default'].createElement(
		        'div',
		        { style: getItemStyles(this.props), className: 'rdg-dragging' },
		        _react2['default'].createElement(
		          'table',
		          null,
		          _react2['default'].createElement(
		            'tbody',
		            null,
		            draggedRows
		          )
		        )
		      )
		    );
		  };
	
		  return CustomDragLayer;
		}(_react.Component);
	
		CustomDragLayer.propTypes = {
		  item: _react.PropTypes.object,
		  itemType: _react.PropTypes.string,
		  currentOffset: _react.PropTypes.shape({
		    x: _react.PropTypes.number.isRequired,
		    y: _react.PropTypes.number.isRequired
		  }),
		  isDragging: _react.PropTypes.bool.isRequired,
		  rowSelection: _react.PropTypes.object,
		  rows: _react.PropTypes.array.isRequired,
		  columns: _react.PropTypes.array.isRequired
		};
	
		function collect(monitor) {
		  return {
		    item: monitor.getItem(),
		    itemType: monitor.getItemType(),
		    currentOffset: monitor.getSourceClientOffset(),
		    isDragging: monitor.isDragging()
		  };
		}
	
		exports['default'] = (0, _reactDnd.DragLayer)(collect)(CustomDragLayer);
	
	/***/ }),
	/* 220 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _DragDropContainer = __webpack_require__(216);
	
		var _DragDropContainer2 = _interopRequireDefault(_DragDropContainer);
	
		var _DraggableHeaderCell = __webpack_require__(101);
	
		var _DraggableHeaderCell2 = _interopRequireDefault(_DraggableHeaderCell);
	
		var _RowActionsCell = __webpack_require__(218);
	
		var _RowActionsCell2 = _interopRequireDefault(_RowActionsCell);
	
		var _DropTargetRowContainer = __webpack_require__(217);
	
		var _DropTargetRowContainer2 = _interopRequireDefault(_DropTargetRowContainer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		module.exports = { Container: _DragDropContainer2['default'], DraggableHeaderCell: _DraggableHeaderCell2['default'], RowActionsCell: _RowActionsCell2['default'], DropTargetRowContainer: _DropTargetRowContainer2['default'] };
	
	/***/ }),
	/* 221 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var ReactAutocomplete = __webpack_require__(398);
	
		var _require = __webpack_require__(3),
		    ExcelColumn = _require.shapes.ExcelColumn;
	
		__webpack_require__(402);
	
		var optionPropType = React.PropTypes.shape({
		  id: React.PropTypes.required,
		  title: React.PropTypes.string
		});
	
		var AutoCompleteEditor = React.createClass({
		  displayName: 'AutoCompleteEditor',
	
	
		  propTypes: {
		    onCommit: React.PropTypes.func,
		    options: React.PropTypes.arrayOf(optionPropType),
		    label: React.PropTypes.any,
		    value: React.PropTypes.any,
		    height: React.PropTypes.number,
		    valueParams: React.PropTypes.arrayOf(React.PropTypes.string),
		    column: React.PropTypes.shape(ExcelColumn),
		    resultIdentifier: React.PropTypes.string,
		    search: React.PropTypes.string,
		    onKeyDown: React.PropTypes.func,
		    onFocus: React.PropTypes.func,
		    editorDisplayValue: React.PropTypes.func
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      resultIdentifier: 'id'
		    };
		  },
		  handleChange: function handleChange() {
		    this.props.onCommit();
		  },
		  getValue: function getValue() {
		    var value = void 0;
		    var updated = {};
		    if (this.hasResults() && this.isFocusedOnSuggestion()) {
		      value = this.getLabel(this.autoComplete.state.focusedValue);
		      if (this.props.valueParams) {
		        value = this.constuctValueFromParams(this.autoComplete.state.focusedValue, this.props.valueParams);
		      }
		    } else {
		      value = this.autoComplete.state.searchTerm;
		    }
	
		    updated[this.props.column.key] = value;
		    return updated;
		  },
		  getEditorDisplayValue: function getEditorDisplayValue() {
		    var displayValue = { title: '' };
		    var _props = this.props,
		        column = _props.column,
		        value = _props.value,
		        editorDisplayValue = _props.editorDisplayValue;
	
		    if (editorDisplayValue && typeof editorDisplayValue === 'function') {
		      displayValue.title = editorDisplayValue(column, value);
		    } else {
		      displayValue.title = value;
		    }
		    return displayValue;
		  },
		  getInputNode: function getInputNode() {
		    return ReactDOM.findDOMNode(this).getElementsByTagName('input')[0];
		  },
		  getLabel: function getLabel(item) {
		    var label = this.props.label != null ? this.props.label : 'title';
		    if (typeof label === 'function') {
		      return label(item);
		    } else if (typeof label === 'string') {
		      return item[label];
		    }
		  },
		  hasResults: function hasResults() {
		    return this.autoComplete.state.results.length > 0;
		  },
		  isFocusedOnSuggestion: function isFocusedOnSuggestion() {
		    var autoComplete = this.autoComplete;
		    return autoComplete.state.focusedValue != null;
		  },
		  constuctValueFromParams: function constuctValueFromParams(obj, props) {
		    if (!props) {
		      return '';
		    }
	
		    var ret = [];
		    for (var i = 0, ii = props.length; i < ii; i++) {
		      ret.push(obj[props[i]]);
		    }
		    return ret.join('|');
		  },
		  render: function render() {
		    var _this = this;
	
		    var label = this.props.label != null ? this.props.label : 'title';
		    return React.createElement(
		      'div',
		      { height: this.props.height, onKeyDown: this.props.onKeyDown },
		      React.createElement(ReactAutocomplete, { search: this.props.search, ref: function ref(node) {
		          return _this.autoComplete = node;
		        }, label: label, onChange: this.handleChange, onFocus: this.props.onFocus, resultIdentifier: this.props.resultIdentifier, options: this.props.options, value: this.getEditorDisplayValue() })
		    );
		  }
		});
	
		module.exports = AutoCompleteEditor;
	
	/***/ }),
	/* 222 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		// Wrapper HOC used when having an editor which is a redux container.
		// Required since react-data-grid requires access to getInputNode, getValue,
		// howvever when doing this.getEditor() in react-data-grid we get a react
		// componenet wrapped by the redux connect function and thus wont have access
		// to the required methods.
		module.exports = function (ContainerEditor) {
		  return function (_Component) {
		    _inherits(ContainerEditorWrapper, _Component);
	
		    function ContainerEditorWrapper() {
		      _classCallCheck(this, ContainerEditorWrapper);
	
		      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		    }
	
		    ContainerEditorWrapper.prototype.getInputNode = function getInputNode() {
		      return this.editorRef.getInputNode();
		    };
	
		    ContainerEditorWrapper.prototype.getValue = function getValue() {
		      return this.editorRef.getValue();
		    };
	
		    ContainerEditorWrapper.prototype.render = function render() {
		      var _this2 = this;
	
		      return _react2['default'].createElement(ContainerEditor, _extends({ refCallback: function refCallback(ref) {
		          _this2.editorRef = ref;
		        } }, this.props));
		    };
	
		    return ContainerEditorWrapper;
		  }(_react.Component);
		};
	
	/***/ }),
	/* 223 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var React = __webpack_require__(2);
	
		var _require = __webpack_require__(3),
		    EditorBase = _require.editors.EditorBase;
	
		var DropDownEditor = function (_EditorBase) {
		  _inherits(DropDownEditor, _EditorBase);
	
		  function DropDownEditor() {
		    _classCallCheck(this, DropDownEditor);
	
		    return _possibleConstructorReturn(this, _EditorBase.apply(this, arguments));
		  }
	
		  DropDownEditor.prototype.getInputNode = function getInputNode() {
		    return _reactDom2['default'].findDOMNode(this);
		  };
	
		  DropDownEditor.prototype.onClick = function onClick() {
		    this.getInputNode().focus();
		  };
	
		  DropDownEditor.prototype.onDoubleClick = function onDoubleClick() {
		    this.getInputNode().focus();
		  };
	
		  DropDownEditor.prototype.render = function render() {
		    return React.createElement(
		      'select',
		      { style: this.getStyle(), defaultValue: this.props.value, onBlur: this.props.onBlur, onChange: this.onChange },
		      this.renderOptions()
		    );
		  };
	
		  DropDownEditor.prototype.renderOptions = function renderOptions() {
		    var options = [];
		    this.props.options.forEach(function (name) {
		      if (typeof name === 'string') {
		        options.push(React.createElement(
		          'option',
		          { key: name, value: name },
		          name
		        ));
		      } else {
		        options.push(React.createElement(
		          'option',
		          { key: name.id, value: name.value, title: name.title },
		          name.text || name.value
		        ));
		      }
		    }, this);
		    return options;
		  };
	
		  return DropDownEditor;
		}(EditorBase);
	
		DropDownEditor.propTypes = {
		  options: React.PropTypes.arrayOf(React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
		    id: React.PropTypes.string,
		    title: React.PropTypes.string,
		    value: React.PropTypes.string,
		    text: React.PropTypes.string
		  })])).isRequired
		};
	
		module.exports = DropDownEditor;
	
	/***/ }),
	/* 224 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _require = __webpack_require__(3),
		    _require$editors = _require.editors,
		    SimpleTextEditor = _require$editors.SimpleTextEditor,
		    CheckboxEditor = _require$editors.CheckboxEditor;
	
		var Editors = {
		  AutoComplete: __webpack_require__(221),
		  DropDownEditor: __webpack_require__(223),
		  ContainerEditorWrapper: __webpack_require__(222),
		  SimpleTextEditor: SimpleTextEditor,
		  CheckboxEditor: CheckboxEditor
		};
	
		module.exports = Editors;
	
	/***/ }),
	/* 225 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// Used for displaying the value of a dropdown (using DropDownEditor) when not editing it.
		// Accepts the same parameters as the DropDownEditor.
		var React = __webpack_require__(2);
	
		var DropDownFormatter = React.createClass({
		  displayName: 'DropDownFormatter',
	
		  propTypes: {
		    options: React.PropTypes.arrayOf(React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
		      id: React.PropTypes.string,
		      title: React.PropTypes.string,
		      value: React.PropTypes.string,
		      text: React.PropTypes.string
		    })])).isRequired,
		    value: React.PropTypes.string.isRequired
		  },
	
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    return nextProps.value !== this.props.value;
		  },
		  render: function render() {
		    var value = this.props.value;
		    var option = this.props.options.filter(function (v) {
		      return v === value || v.value === value;
		    })[0];
		    if (!option) {
		      option = value;
		    }
		    var title = option.title || option.value || option;
		    var text = option.text || option.value || option;
		    return React.createElement(
		      'div',
		      { title: title },
		      text
		    );
		  }
		});
	
		module.exports = DropDownFormatter;
	
	/***/ }),
	/* 226 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		__webpack_require__(401);
	
		var PendingPool = {};
		var ReadyPool = {};
	
		var ImageFormatter = React.createClass({
		  displayName: 'ImageFormatter',
	
		  propTypes: {
		    value: React.PropTypes.string.isRequired
		  },
	
		  getInitialState: function getInitialState() {
		    return {
		      ready: false
		    };
		  },
		  componentWillMount: function componentWillMount() {
		    this._load(this.props.value);
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (nextProps.value !== this.props.value) {
		      this.setState({ value: null });
		      this._load(nextProps.value);
		    }
		  },
		  _load: function _load(src) {
		    var imageSrc = src;
		    if (ReadyPool[imageSrc]) {
		      this.setState({ value: imageSrc });
		      return;
		    }
	
		    if (PendingPool[imageSrc]) {
		      PendingPool[imageSrc].push(this._onLoad);
		      return;
		    }
	
		    PendingPool[imageSrc] = [this._onLoad];
	
		    var img = new Image();
		    img.onload = function () {
		      PendingPool[imageSrc].forEach(function (callback) {
		        callback(imageSrc);
		      });
		      delete PendingPool[imageSrc];
		      img.onload = null;
		      imageSrc = undefined;
		    };
		    img.src = imageSrc;
		  },
		  _onLoad: function _onLoad(src) {
		    if (this.isMounted() && src === this.props.value) {
		      this.setState({
		        value: src
		      });
		    }
		  },
		  render: function render() {
		    var style = this.state.value ? { backgroundImage: 'url(' + this.state.value + ')' } : undefined;
	
		    return React.createElement('div', { className: 'react-grid-image', style: style });
		  }
		});
	
		module.exports = ImageFormatter;
	
	/***/ }),
	/* 227 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// not including this
		// it currently requires the whole of moment, which we dont want to take as a dependency
		var ImageFormatter = __webpack_require__(226);
		var DropDownFormatter = __webpack_require__(225);
	
		var Formatters = {
		  ImageFormatter: ImageFormatter,
		  DropDownFormatter: DropDownFormatter
		};
	
		module.exports = Formatters;
	
	/***/ }),
	/* 228 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var Editors = __webpack_require__(224);
		var Formatters = __webpack_require__(227);
		var Toolbar = __webpack_require__(238);
		var ToolsPanel = __webpack_require__(239);
		var Data = __webpack_require__(212);
		var Menu = __webpack_require__(231);
		var Draggable = __webpack_require__(220);
		var DraggableHeader = __webpack_require__(215);
		var Filters = __webpack_require__(207);
	
		var _require = __webpack_require__(3),
		    rowComparer = _require.RowComparer;
	
		var performance = __webpack_require__(233);
		var Utils = { rowComparer: rowComparer, performance: performance };
	
		window.ReactDataGridPlugins = { Editors: Editors, Formatters: Formatters, Toolbar: Toolbar, Menu: Menu, Data: Data, ToolsPanel: ToolsPanel, Draggable: Draggable, DraggableHeader: DraggableHeader, Filters: Filters, Utils: Utils };
		module.exports = { Editors: Editors, Formatters: Formatters, Toolbar: Toolbar, Menu: Menu, Data: Data, ToolsPanel: ToolsPanel, Draggable: Draggable, DraggableHeader: DraggableHeader, Filters: Filters, Utils: Utils };
	
	/***/ }),
	/* 229 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactContextmenu = __webpack_require__(124);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var ReactDataGridContextMenu = function (_React$Component) {
		  _inherits(ReactDataGridContextMenu, _React$Component);
	
		  function ReactDataGridContextMenu() {
		    _classCallCheck(this, ReactDataGridContextMenu);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  ReactDataGridContextMenu.prototype.render = function render() {
		    return _react2['default'].createElement(
		      _reactContextmenu.ContextMenu,
		      { identifier: 'reactDataGridContextMenu' },
		      this.props.children
		    );
		  };
	
		  return ReactDataGridContextMenu;
		}(_react2['default'].Component);
	
		ReactDataGridContextMenu.propTypes = {
		  children: _react.PropTypes.node
		};
	
		exports['default'] = ReactDataGridContextMenu;
	
	/***/ }),
	/* 230 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var MenuHeader = function (_React$Component) {
		  _inherits(MenuHeader, _React$Component);
	
		  function MenuHeader() {
		    _classCallCheck(this, MenuHeader);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  MenuHeader.prototype.render = function render() {
		    return _react2["default"].createElement(
		      "div",
		      { className: "react-context-menu-header" },
		      this.props.children
		    );
		  };
	
		  return MenuHeader;
		}(_react2["default"].Component);
	
		MenuHeader.propTypes = {
		  children: _react.PropTypes.any
		};
	
		exports["default"] = MenuHeader;
	
	/***/ }),
	/* 231 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.ContextMenuLayer = exports.connect = exports.SubMenu = exports.monitor = exports.MenuItem = exports.MenuHeader = exports.ContextMenu = undefined;
	
		var _reactContextmenu = __webpack_require__(124);
	
		var _ContextMenu = __webpack_require__(229);
	
		var _ContextMenu2 = _interopRequireDefault(_ContextMenu);
	
		var _MenuHeader = __webpack_require__(230);
	
		var _MenuHeader2 = _interopRequireDefault(_MenuHeader);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		exports.ContextMenu = _ContextMenu2['default'];
		exports.MenuHeader = _MenuHeader2['default'];
		exports.MenuItem = _reactContextmenu.MenuItem;
		exports.monitor = _reactContextmenu.monitor;
		exports.SubMenu = _reactContextmenu.SubMenu;
		exports.connect = _reactContextmenu.connect;
		exports.ContextMenuLayer = _reactContextmenu.ContextMenuLayer;
	
	/***/ }),
	/* 232 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _SummaryItemModel = __webpack_require__(102);
	
		var _SummaryItemModel2 = _interopRequireDefault(_SummaryItemModel);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var SummaryParser = function () {
		  function SummaryParser(summary) {
		    _classCallCheck(this, SummaryParser);
	
		    this._summary = this._parseSummary(summary);
		    this.getByOwner = this.getByOwner.bind(this);
		    this.getSumByOwner = this.getSumByOwner.bind(this);
		    this.getByComponent = this.getByComponent.bind(this);
		  }
	
		  SummaryParser.prototype._parseSummary = function _parseSummary(summary) {
		    return summary.map(function (s) {
		      return new _SummaryItemModel2['default'](s);
		    });
		  };
	
		  SummaryParser.prototype.getByOwner = function getByOwner(ownerName) {
		    return this._summary.filter(function (s) {
		      return s.owner === ownerName;
		    });
		  };
	
		  SummaryParser.prototype.getSumByOwner = function getSumByOwner(ownerName) {
		    var summaryItemsByOwner = this.getByOwner(ownerName);
		    var summaryItem = new _SummaryItemModel2['default'](ownerName);
	
		    summaryItemsByOwner.forEach(function (s) {
		      var wastedTime = summaryItem.wastedTime,
		          wastedInstances = summaryItem.wastedInstances;
	
		      summaryItem.wastedTime = wastedTime + s.wastedTime;
		      summaryItem.wastedInstances = wastedInstances + s.wastedInstances;
		    });
	
		    return summaryItem;
		  };
	
		  SummaryParser.prototype.getByComponent = function getByComponent(component) {
		    var componentSummaryItem = this._summary.filter(function (s) {
		      return s.component === component;
		    });
	
		    if (componentSummaryItem.length > 1) {
		      throw new Error('More then 1 result retrived for ' + component);
		    }
	
		    if (componentSummaryItem.length === 0) {
		      var emptySummary = new _SummaryItemModel2['default'](component);
		      componentSummaryItem = [emptySummary];
		    }
	
		    return componentSummaryItem[0];
		  };
	
		  return SummaryParser;
		}();
	
		exports['default'] = SummaryParser;
	
	/***/ }),
	/* 233 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _SummaryParser = __webpack_require__(232);
	
		var _SummaryParser2 = _interopRequireDefault(_SummaryParser);
	
		var _SummaryItemModel = __webpack_require__(102);
	
		var _SummaryItemModel2 = _interopRequireDefault(_SummaryItemModel);
	
		var _whyDidYouUpdate = __webpack_require__(234);
	
		var _whyDidYouUpdate2 = _interopRequireDefault(_whyDidYouUpdate);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		exports['default'] = {
		  SummaryParser: _SummaryParser2['default'],
		  SummaryItemModel: _SummaryItemModel2['default'],
		  whyDidYouUpdate: _whyDidYouUpdate2['default']
		};
	
	/***/ }),
	/* 234 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.NOTIFY_LEVELS = undefined;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _underscore = __webpack_require__(97);
	
		var _underscore2 = _interopRequireDefault(_underscore);
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-console */
	
	
		var isRequiredUpdateObject = function isRequiredUpdateObject(o) {
		  return Array.isArray(o) || o && o.constructor === Object.prototype.constructor;
		};
		var NOTIFY_LEVELS = { DEBUG: 0, WARNING: 1, NONE: 2 };
		var isLogEnabled = function isLogEnabled(lvl) {
		  return lvl !== NOTIFY_LEVELS.NONE;
		};
		var isStatusTypeLoggable = function isStatusTypeLoggable(s, lvl) {
		  return s <= lvl;
		};
	
		var deepDiff = function deepDiff(o1, o2, p, notifyLevel) {
		  var notify = function notify(status, statusType) {
		    if (isStatusTypeLoggable(statusType, notifyLevel)) {
		      console.warn('Update %s', status);
		      console.log('%cbefore', 'font-weight: bold', o1);
		      console.log('%cafter ', 'font-weight: bold', o2);
		    }
		  };
	
		  if (!_underscore2['default'].isEqual(o1, o2)) {
		    console.group(p);
		    if ([o1, o2].every(_underscore2['default'].isFunction)) {
		      notify('avoidable?', NOTIFY_LEVELS.WARNING);
		    } else if (![o1, o2].every(isRequiredUpdateObject)) {
		      notify('required.', NOTIFY_LEVELS.DEBUG);
		    } else {
		      var keys = _underscore2['default'].union(_underscore2['default'].keys(o1), _underscore2['default'].keys(o2));
		      for (var _iterator = keys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		        var _ref;
	
		        if (_isArray) {
		          if (_i >= _iterator.length) break;
		          _ref = _iterator[_i++];
		        } else {
		          _i = _iterator.next();
		          if (_i.done) break;
		          _ref = _i.value;
		        }
	
		        var key = _ref;
	
		        deepDiff(o1[key], o2[key], key);
		      }
		    }
	
		    console.groupEnd();
		  } else if (o1 !== o2) {
		    console.group(p);
		    notify('avoidable!', NOTIFY_LEVELS.WARNING);
		    if (_underscore2['default'].isObject(o1) && _underscore2['default'].isObject(o2)) {
		      var _keys = _underscore2['default'].union(_underscore2['default'].keys(o1), _underscore2['default'].keys(o2));
		      for (var _iterator2 = _keys, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
		        var _ref2;
	
		        if (_isArray2) {
		          if (_i2 >= _iterator2.length) break;
		          _ref2 = _iterator2[_i2++];
		        } else {
		          _i2 = _iterator2.next();
		          if (_i2.done) break;
		          _ref2 = _i2.value;
		        }
	
		        var _key = _ref2;
	
		        deepDiff(o1[_key], o2[_key], _key);
		      }
		    }
		    console.groupEnd();
		  }
		};
	
		var whyDidYouUpdate = function whyDidYouUpdate(WrappedComponent) {
		  var notifyLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NOTIFY_LEVELS.NONE;
	
		  return function (_Component) {
		    _inherits(WhyDidYouUpdateComponentWrapper, _Component);
	
		    function WhyDidYouUpdateComponentWrapper() {
		      _classCallCheck(this, WhyDidYouUpdateComponentWrapper);
	
		      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		    }
	
		    WhyDidYouUpdateComponentWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
		      if (!isLogEnabled(notifyLevel)) {
		        return;
		      }
	
		      deepDiff({ props: prevProps, state: prevState }, { props: this.props, state: this.state }, WrappedComponent.displayName, notifyLevel);
		    };
	
		    WhyDidYouUpdateComponentWrapper.prototype.render = function render() {
		      return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, this.state));
		    };
	
		    return WhyDidYouUpdateComponentWrapper;
		  }(_react.Component);
		};
	
		exports['default'] = whyDidYouUpdate;
		exports.NOTIFY_LEVELS = NOTIFY_LEVELS;
	
	/***/ }),
	/* 235 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		__webpack_require__(144);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var propTypes = {
		  children: _react.PropTypes.array
		};
	
		var defaultProps = {
		  enableAddRow: true
		};
	
		var AdvancedToolbar = function (_Component) {
		  _inherits(AdvancedToolbar, _Component);
	
		  function AdvancedToolbar() {
		    _classCallCheck(this, AdvancedToolbar);
	
		    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		  }
	
		  AdvancedToolbar.prototype.render = function render() {
		    return _react2['default'].createElement(
		      'div',
		      { className: 'react-grid-Toolbar' },
		      this.props.children,
		      _react2['default'].createElement('div', { className: 'tools' })
		    );
		  };
	
		  return AdvancedToolbar;
		}(_react.Component);
	
		AdvancedToolbar.defaultProps = defaultProps;
		AdvancedToolbar.propTypes = propTypes;
	
		exports['default'] = AdvancedToolbar;
	
	/***/ }),
	/* 236 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var GroupedColumnButton = function (_Component) {
		  _inherits(GroupedColumnButton, _Component);
	
		  function GroupedColumnButton() {
		    _classCallCheck(this, GroupedColumnButton);
	
		    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		  }
	
		  GroupedColumnButton.prototype.render = function render() {
		    var style = {
		      width: '80px',
		      overflow: 'hidden',
		      textOverflow: 'ellipsis',
		      whiteSpace: 'nowrap'
		    };
		    return _react2['default'].createElement(
		      'button',
		      { className: 'btn grouped-col-btn btn-sm' },
		      _react2['default'].createElement(
		        'span',
		        { style: style },
		        this.props.name
		      ),
		      _react2['default'].createElement('span', {
		        className: 'glyphicon glyphicon-trash',
		        style: { float: 'right', paddingLeft: '5px' },
		        onClick: this.props.onColumnGroupDeleted.bind(null, this.props.name) })
		    );
		  };
	
		  return GroupedColumnButton;
		}(_react.Component);
	
		exports['default'] = GroupedColumnButton;
	
	
		GroupedColumnButton.propTypes = {
		  name: _react.PropTypes.string.isRequired,
		  onColumnGroupDeleted: _react.PropTypes.func
		};
	
	/***/ }),
	/* 237 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDnd = __webpack_require__(16);
	
		var _GroupedColumnButton = __webpack_require__(236);
	
		var _GroupedColumnButton2 = _interopRequireDefault(_GroupedColumnButton);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var DragItemTypes = _reactDataGrid._constants.DragItemTypes;
	
	
		var propTypes = {
		  isOver: _react.PropTypes.bool.isRequired,
		  connectDropTarget: _react.PropTypes.func,
		  canDrop: _react.PropTypes.bool.isRequired,
		  groupBy: _react.PropTypes.array,
		  noColumnsSelectedMessage: _react.PropTypes.string,
		  panelDescription: _react.PropTypes.string,
		  onColumnGroupDeleted: _react.PropTypes.func
		};
	
		var defaultProps = {
		  noColumnsSelectedMessage: 'Drag a column header here to group by that column',
		  panelDescription: 'Drag a column header here to group by that column'
		};
	
		var GroupedColumnsPanel = function (_Component) {
		  _inherits(GroupedColumnsPanel, _Component);
	
		  function GroupedColumnsPanel() {
		    _classCallCheck(this, GroupedColumnsPanel);
	
		    return _possibleConstructorReturn(this, _Component.call(this));
		  }
	
		  GroupedColumnsPanel.prototype.getPanelInstructionMessage = function getPanelInstructionMessage() {
		    var groupBy = this.props.groupBy;
	
		    return groupBy && groupBy.length > 0 ? this.props.panelDescription : this.props.noColumnsSelectedMessage;
		  };
	
		  GroupedColumnsPanel.prototype.renderGroupedColumns = function renderGroupedColumns() {
		    var _this2 = this;
	
		    return this.props.groupBy.map(function (c) {
		      return _react2['default'].createElement(_GroupedColumnButton2['default'], { key: c, name: c, onColumnGroupDeleted: _this2.props.onColumnGroupDeleted });
		    });
		  };
	
		  GroupedColumnsPanel.prototype.renderOverlay = function renderOverlay(color) {
		    return _react2['default'].createElement('div', { style: {
		        position: 'absolute',
		        top: 0,
		        left: 0,
		        height: '100%',
		        width: '100%',
		        zIndex: 1,
		        opacity: 0.5,
		        backgroundColor: color
		      } });
		  };
	
		  GroupedColumnsPanel.prototype.render = function render() {
		    var _props = this.props,
		        connectDropTarget = _props.connectDropTarget,
		        isOver = _props.isOver,
		        canDrop = _props.canDrop;
	
		    return connectDropTarget(_react2['default'].createElement(
		      'div',
		      { style: { padding: '2px', position: 'relative', margin: '-10px', display: 'inline-block', border: '1px solid #eee' } },
		      this.renderGroupedColumns(),
		      ' ',
		      _react2['default'].createElement(
		        'span',
		        null,
		        this.getPanelInstructionMessage()
		      ),
		      isOver && canDrop && this.renderOverlay('yellow'),
		      !isOver && canDrop && this.renderOverlay('#DBECFA')
		    ));
		  };
	
		  return GroupedColumnsPanel;
		}(_react.Component);
	
		GroupedColumnsPanel.defaultProps = defaultProps;
		GroupedColumnsPanel.propTypes = propTypes;
	
		var columnTarget = {
		  drop: function drop(props, monitor) {
		    // Obtain the dragged item
		    var item = monitor.getItem();
		    if (typeof props.onColumnGroupAdded === 'function') {
		      props.onColumnGroupAdded(item.key);
		    }
		  }
		};
	
		function collect(connect, monitor) {
		  return {
		    connectDropTarget: connect.dropTarget(),
		    isOver: monitor.isOver(),
		    canDrop: monitor.canDrop(),
		    draggedolumn: monitor.getItem()
		  };
		}
	
		exports['default'] = (0, _reactDnd.DropTarget)(DragItemTypes.Column, columnTarget, collect)(GroupedColumnsPanel);
	
	/***/ }),
	/* 238 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		__webpack_require__(144);
	
		var Toolbar = React.createClass({
		  displayName: 'Toolbar',
	
		  propTypes: {
		    onAddRow: React.PropTypes.func,
		    onToggleFilter: React.PropTypes.func,
		    enableFilter: React.PropTypes.bool,
		    numberOfRows: React.PropTypes.number,
		    addRowButtonText: React.PropTypes.string,
		    filterRowsButtonText: React.PropTypes.string,
		    children: React.PropTypes.any
		  },
	
		  onAddRow: function onAddRow() {
		    if (this.props.onAddRow !== null && this.props.onAddRow instanceof Function) {
		      this.props.onAddRow({ newRowIndex: this.props.numberOfRows });
		    }
		  },
		  getDefaultProps: function getDefaultProps() {
		    return {
		      enableAddRow: true,
		      addRowButtonText: 'Add Row',
		      filterRowsButtonText: 'Filter Rows'
		    };
		  },
		  renderAddRowButton: function renderAddRowButton() {
		    if (this.props.onAddRow) {
		      return React.createElement(
		        'button',
		        { type: 'button', className: 'btn', onClick: this.onAddRow },
		        this.props.addRowButtonText
		      );
		    }
		  },
		  renderToggleFilterButton: function renderToggleFilterButton() {
		    if (this.props.enableFilter) {
		      return React.createElement(
		        'button',
		        { type: 'button', className: 'btn', onClick: this.props.onToggleFilter },
		        this.props.filterRowsButtonText
		      );
		    }
		  },
		  render: function render() {
		    return React.createElement(
		      'div',
		      { className: 'react-grid-Toolbar' },
		      React.createElement(
		        'div',
		        { className: 'tools' },
		        this.renderAddRowButton(),
		        this.renderToggleFilterButton(),
		        this.props.children
		      )
		    );
		  }
		});
	
		module.exports = Toolbar;
	
	/***/ }),
	/* 239 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _AdvancedToolbar = __webpack_require__(235);
	
		var _AdvancedToolbar2 = _interopRequireDefault(_AdvancedToolbar);
	
		var _GroupedColumnsPanel = __webpack_require__(237);
	
		var _GroupedColumnsPanel2 = _interopRequireDefault(_GroupedColumnsPanel);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		module.exports = { AdvancedToolbar: _AdvancedToolbar2['default'], GroupedColumnsPanel: _GroupedColumnsPanel2['default'] };
	
	/***/ }),
	/* 240 */
	/***/ (function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".Select{position:relative}.Select,.Select div,.Select input,.Select span{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.Select.is-disabled>.Select-control{background-color:#f9f9f9}.Select.is-disabled>.Select-control:hover{box-shadow:none}.Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none;opacity:.35}.Select-control{background-color:#fff;border-color:#d9d9d9 #ccc #b3b3b3;border-radius:4px;border:1px solid #ccc;color:#333;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:36px;outline:none;overflow:hidden;position:relative;width:100%}.Select-control:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}.Select-control .Select-input:focus{outline:none}.is-searchable.is-open>.Select-control{cursor:text}.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.is-searchable.is-focused:not(.is-open)>.Select-control{cursor:text}.is-focused:not(.is-open)>.Select-control{border-color:#007eff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1)}.Select--single>.Select-control .Select-value,.Select-placeholder{bottom:0;color:#aaa;left:0;line-height:34px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#333}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#007eff;outline:none;text-decoration:underline}.Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}.Select-input>input{width:100%;background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:14px;padding:8px 0 12px;-webkit-appearance:none}.is-focused .Select-input>input{cursor:text}.has-value.is-pseudo-focused .Select-input{opacity:0}.Select-control:not(.is-searchable)>.Select-input{outline:none}.Select-loading-zone{cursor:pointer;display:table-cell;text-align:center}.Select-loading,.Select-loading-zone{position:relative;vertical-align:middle;width:16px}.Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;-o-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block}.Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;-o-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}.Select-clear-zone:hover{color:#d0021b}.Select-clear{display:inline-block;font-size:18px;line-height:1}.Select--multi .Select-clear-zone{width:17px}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}.Select-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative}.is-open .Select-arrow,.Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}.Select--multi .Select-multi-value-wrapper{display:inline-block}.Select .Select-aria-only{display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}@-webkit-keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}.Select-menu-outer{border-bottom-right-radius:4px;border-bottom-left-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0,0,0,.06);box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch}.Select-menu{max-height:198px;overflow-y:auto}.Select-option{box-sizing:border-box;background-color:#fff;color:#666;cursor:pointer;display:block;padding:8px 10px}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.Select-option.is-selected{background-color:#f5faff;background-color:rgba(0,126,255,.04);color:#333}.Select-option.is-focused{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);color:#333}.Select-option.is-disabled{color:#ccc;cursor:default}.Select-noresults{box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}.Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.Select--multi.has-value .Select-input{margin-left:5px}.Select--multi .Select-value{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);border-radius:2px;border:1px solid #c2e0ff;border:1px solid rgba(0,126,255,.24);color:#007eff;display:inline-block;font-size:.9em;line-height:1.4;margin-left:5px;margin-top:5px;vertical-align:top}.Select--multi .Select-value-icon,.Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}.Select--multi a.Select-value-label{color:#007eff;cursor:pointer;text-decoration:none}.Select--multi a.Select-value-label:hover{text-decoration:underline}.Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #c2e0ff;border-right:1px solid rgba(0,126,255,.24);padding:1px 5px 3px}.Select--multi .Select-value-icon:focus,.Select--multi .Select-value-icon:hover{background-color:#d8eafd;background-color:rgba(0,113,230,.08);color:#0071e6}.Select--multi .Select-value-icon:active{background-color:#c2e0ff;background-color:rgba(0,126,255,.24)}.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333}.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3}.Select--multi.is-disabled .Select-value-icon:active,.Select--multi.is-disabled .Select-value-icon:focus,.Select--multi.is-disabled .Select-value-icon:hover{background-color:#fcfcfc}@keyframes Select-animation-spin{to{transform:rotate(1turn)}}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn)}}", ""]);
	
		// exports
	
	
	/***/ }),
	/* 241 */
	/***/ (function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".slideUp{animation-name:slideUp;-webkit-animation-name:slideUp;animation-duration:1s;-webkit-animation-duration:1s;animation-timing-function:ease;-webkit-animation-timing-function:ease;visibility:visible!important}@keyframes slideUp{0%{transform:translateY(100%)}50%{transform:translateY(-8%)}65%{transform:translateY(4%)}80%{transform:translateY(-4%)}95%{transform:translateY(2%)}to{transform:translateY(0)}}@-webkit-keyframes slideUp{0%{-webkit-transform:translateY(100%)}50%{-webkit-transform:translateY(-8%)}65%{-webkit-transform:translateY(4%)}80%{-webkit-transform:translateY(-4%)}95%{-webkit-transform:translateY(2%)}to{-webkit-transform:translateY(0)}}", ""]);
	
		// exports
	
	
	/***/ }),
	/* 242 */
	/***/ (function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-image{background:#efefef;background-size:100%;display:inline-block;height:40px;width:40px}", ""]);
	
		// exports
	
	
	/***/ }),
	/* 243 */
	/***/ (function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Toolbar{background-color:#fff;border-color:#e7eaec;border-image:none;border-style:solid solid none;border-width:1px;color:inherit;margin-bottom:0;padding:14px 15px 7px;height:48px}.react-grid-Toolbar .btn{display:inline-block;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;color:inherit;background:#fff;border:1px solid #e7eaec}.react-grid-Toolbar .btn:hover{color:inherit;border:1px solid #d2d2d2}.react-grid-Toolbar .grouped-col-btn{background-color:#428bca;color:#fff}.react-grid-Toolbar .grouped-col-btn:hover{color:#fff}.react-grid-Toolbar .tools{display:inline-block;float:right;margin-top:0;position:relative;padding:0;margin-top:-6px}", ""]);
	
		// exports
	
	
	/***/ }),
	/* 244 */
	/***/ (function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-autocomplete-Autocomplete__search{display:block;width:100%;height:36px;padding:6px 12px;font-size:14px;line-height:1.6;color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.react-autocomplete-Autocomplete__search:focus{border-color:#a21618;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(162,22,24,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(162,22,24,.6)}.react-autocomplete-Autocomplete__search::-moz-placeholder{color:#777;opacity:1}.react-autocomplete-Autocomplete__search:-ms-input-placeholder{color:#777}.react-autocomplete-Autocomplete__search::-webkit-input-placeholder{color:#777}.react-autocomplete-Autocomplete__search[disabled],.react-autocomplete-Autocomplete__search[readonly],fieldset[disabled] .react-autocomplete-Autocomplete__search{cursor:not-allowed;background-color:#eee;opacity:1}textarea.react-autocomplete-Autocomplete__search{height:auto}.react-autocomplete-Autocomplete__results{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box;min-width:250px;width:100%;max-height:200px;overflow:auto}.react-autocomplete-Autocomplete__results.pull-right{right:0;left:auto}.react-autocomplete-Autocomplete__results .divider{height:1px;margin:10px 0;overflow:hidden;background-color:#e5e5e5}.react-autocomplete-Autocomplete__results>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.6;color:#333;white-space:nowrap}.react-autocomplete-Autocomplete__results div.action-button{display:block!important;padding:4px}.react-autocomplete-Result{cursor:pointer}.react-autocomplete-Result>a{text-decoration:none}.react-autocomplete-Result--active{color:#262626;background-color:#f5f5f5}", ""]);
	
		// exports
	
	
	/***/ }),
	/* 245 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
		var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
		exports.__esModule = true;
	
		var _isDisposable = __webpack_require__(73);
	
		var _isDisposable2 = _interopRequireWildcard(_isDisposable);
	
		/**
		 * Represents a group of disposable resources that are disposed together.
		 */
	
		var CompositeDisposable = (function () {
		  function CompositeDisposable() {
		    for (var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++) {
		      disposables[_key] = arguments[_key];
		    }
	
		    _classCallCheck(this, CompositeDisposable);
	
		    if (Array.isArray(disposables[0]) && disposables.length === 1) {
		      disposables = disposables[0];
		    }
	
		    for (var i = 0; i < disposables.length; i++) {
		      if (!_isDisposable2['default'](disposables[i])) {
		        throw new Error('Expected a disposable');
		      }
		    }
	
		    this.disposables = disposables;
		    this.isDisposed = false;
		  }
	
		  /**
		   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
		   * @param {Disposable} item Disposable to add.
		   */
	
		  CompositeDisposable.prototype.add = function add(item) {
		    if (this.isDisposed) {
		      item.dispose();
		    } else {
		      this.disposables.push(item);
		    }
		  };
	
		  /**
		   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
		   * @param {Disposable} item Disposable to remove.
		   * @returns {Boolean} true if found; false otherwise.
		   */
	
		  CompositeDisposable.prototype.remove = function remove(item) {
		    if (this.isDisposed) {
		      return false;
		    }
	
		    var index = this.disposables.indexOf(item);
		    if (index === -1) {
		      return false;
		    }
	
		    this.disposables.splice(index, 1);
		    item.dispose();
		    return true;
		  };
	
		  /**
		   * Disposes all disposables in the group and removes them from the group.
		   */
	
		  CompositeDisposable.prototype.dispose = function dispose() {
		    if (this.isDisposed) {
		      return;
		    }
	
		    var len = this.disposables.length;
		    var currentDisposables = new Array(len);
		    for (var i = 0; i < len; i++) {
		      currentDisposables[i] = this.disposables[i];
		    }
	
		    this.isDisposed = true;
		    this.disposables = [];
		    this.length = 0;
	
		    for (var i = 0; i < len; i++) {
		      currentDisposables[i].dispose();
		    }
		  };
	
		  return CompositeDisposable;
		})();
	
		exports['default'] = CompositeDisposable;
		module.exports = exports['default'];
	
	/***/ }),
	/* 246 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
		var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
		exports.__esModule = true;
		var noop = function noop() {};
	
		/**
		 * The basic disposable.
		 */
	
		var Disposable = (function () {
		  function Disposable(action) {
		    _classCallCheck(this, Disposable);
	
		    this.isDisposed = false;
		    this.action = action || noop;
		  }
	
		  Disposable.prototype.dispose = function dispose() {
		    if (!this.isDisposed) {
		      this.action.call(null);
		      this.isDisposed = true;
		    }
		  };
	
		  _createClass(Disposable, null, [{
		    key: "empty",
		    enumerable: true,
		    value: { dispose: noop }
		  }]);
	
		  return Disposable;
		})();
	
		exports["default"] = Disposable;
		module.exports = exports["default"];
	
	/***/ }),
	/* 247 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
		var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
		exports.__esModule = true;
	
		var _isDisposable = __webpack_require__(73);
	
		var _isDisposable2 = _interopRequireWildcard(_isDisposable);
	
		var SerialDisposable = (function () {
		  function SerialDisposable() {
		    _classCallCheck(this, SerialDisposable);
	
		    this.isDisposed = false;
		    this.current = null;
		  }
	
		  /**
		   * Gets the underlying disposable.
		   * @return The underlying disposable.
		   */
	
		  SerialDisposable.prototype.getDisposable = function getDisposable() {
		    return this.current;
		  };
	
		  /**
		   * Sets the underlying disposable.
		   * @param {Disposable} value The new underlying disposable.
		   */
	
		  SerialDisposable.prototype.setDisposable = function setDisposable() {
		    var value = arguments[0] === undefined ? null : arguments[0];
	
		    if (value != null && !_isDisposable2['default'](value)) {
		      throw new Error('Expected either an empty value or a valid disposable');
		    }
	
		    var isDisposed = this.isDisposed;
		    var previous = undefined;
	
		    if (!isDisposed) {
		      previous = this.current;
		      this.current = value;
		    }
	
		    if (previous) {
		      previous.dispose();
		    }
	
		    if (isDisposed && value) {
		      value.dispose();
		    }
		  };
	
		  /**
		   * Disposes the underlying disposable as well as all future replacements.
		   */
	
		  SerialDisposable.prototype.dispose = function dispose() {
		    if (this.isDisposed) {
		      return;
		    }
	
		    this.isDisposed = true;
		    var previous = this.current;
		    this.current = null;
	
		    if (previous) {
		      previous.dispose();
		    }
		  };
	
		  return SerialDisposable;
		})();
	
		exports['default'] = SerialDisposable;
		module.exports = exports['default'];
	
	/***/ }),
	/* 248 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
		exports.__esModule = true;
	
		var _isDisposable2 = __webpack_require__(73);
	
		var _isDisposable3 = _interopRequireWildcard(_isDisposable2);
	
		exports.isDisposable = _isDisposable3['default'];
	
		var _Disposable2 = __webpack_require__(246);
	
		var _Disposable3 = _interopRequireWildcard(_Disposable2);
	
		exports.Disposable = _Disposable3['default'];
	
		var _CompositeDisposable2 = __webpack_require__(245);
	
		var _CompositeDisposable3 = _interopRequireWildcard(_CompositeDisposable2);
	
		exports.CompositeDisposable = _CompositeDisposable3['default'];
	
		var _SerialDisposable2 = __webpack_require__(247);
	
		var _SerialDisposable3 = _interopRequireWildcard(_SerialDisposable2);
	
		exports.SerialDisposable = _SerialDisposable3['default'];
	
	/***/ }),
	/* 249 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _createStore = __webpack_require__(87);
	
		var _createStore2 = _interopRequireDefault(_createStore);
	
		var _reducers = __webpack_require__(257);
	
		var _reducers2 = _interopRequireDefault(_reducers);
	
		var _dragDrop = __webpack_require__(39);
	
		var dragDropActions = _interopRequireWildcard(_dragDrop);
	
		var _DragDropMonitor = __webpack_require__(250);
	
		var _DragDropMonitor2 = _interopRequireDefault(_DragDropMonitor);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var DragDropManager = function () {
		  function DragDropManager(createBackend) {
		    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		    _classCallCheck(this, DragDropManager);
	
		    var store = (0, _createStore2.default)(_reducers2.default);
		    this.context = context;
		    this.store = store;
		    this.monitor = new _DragDropMonitor2.default(store);
		    this.registry = this.monitor.registry;
		    this.backend = createBackend(this);
	
		    store.subscribe(this.handleRefCountChange.bind(this));
		  }
	
		  _createClass(DragDropManager, [{
		    key: 'handleRefCountChange',
		    value: function handleRefCountChange() {
		      var shouldSetUp = this.store.getState().refCount > 0;
		      if (shouldSetUp && !this.isSetUp) {
		        this.backend.setup();
		        this.isSetUp = true;
		      } else if (!shouldSetUp && this.isSetUp) {
		        this.backend.teardown();
		        this.isSetUp = false;
		      }
		    }
		  }, {
		    key: 'getContext',
		    value: function getContext() {
		      return this.context;
		    }
		  }, {
		    key: 'getMonitor',
		    value: function getMonitor() {
		      return this.monitor;
		    }
		  }, {
		    key: 'getBackend',
		    value: function getBackend() {
		      return this.backend;
		    }
		  }, {
		    key: 'getRegistry',
		    value: function getRegistry() {
		      return this.registry;
		    }
		  }, {
		    key: 'getActions',
		    value: function getActions() {
		      var manager = this;
		      var dispatch = this.store.dispatch;
	
	
		      function bindActionCreator(actionCreator) {
		        return function () {
		          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		            args[_key] = arguments[_key];
		          }
	
		          var action = actionCreator.apply(manager, args);
		          if (typeof action !== 'undefined') {
		            dispatch(action);
		          }
		        };
		      }
	
		      return Object.keys(dragDropActions).filter(function (key) {
		        return typeof dragDropActions[key] === 'function';
		      }).reduce(function (boundActions, key) {
		        var action = dragDropActions[key];
		        boundActions[key] = bindActionCreator(action); // eslint-disable-line no-param-reassign
		        return boundActions;
		      }, {});
		    }
		  }]);
	
		  return DragDropManager;
		}();
	
		exports.default = DragDropManager;
	
	/***/ }),
	/* 250 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _isArray = __webpack_require__(20);
	
		var _isArray2 = _interopRequireDefault(_isArray);
	
		var _matchesType = __webpack_require__(105);
	
		var _matchesType2 = _interopRequireDefault(_matchesType);
	
		var _HandlerRegistry = __webpack_require__(253);
	
		var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);
	
		var _dragOffset = __webpack_require__(104);
	
		var _dirtyHandlerIds = __webpack_require__(103);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var DragDropMonitor = function () {
		  function DragDropMonitor(store) {
		    _classCallCheck(this, DragDropMonitor);
	
		    this.store = store;
		    this.registry = new _HandlerRegistry2.default(store);
		  }
	
		  _createClass(DragDropMonitor, [{
		    key: 'subscribeToStateChange',
		    value: function subscribeToStateChange(listener) {
		      var _this = this;
	
		      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		      var handlerIds = options.handlerIds;
	
		      (0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
		      (0, _invariant2.default)(typeof handlerIds === 'undefined' || (0, _isArray2.default)(handlerIds), 'handlerIds, when specified, must be an array of strings.');
	
		      var prevStateId = this.store.getState().stateId;
		      var handleChange = function handleChange() {
		        var state = _this.store.getState();
		        var currentStateId = state.stateId;
		        try {
		          var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtyHandlerIds.areDirty)(state.dirtyHandlerIds, handlerIds);
	
		          if (!canSkipListener) {
		            listener();
		          }
		        } finally {
		          prevStateId = currentStateId;
		        }
		      };
	
		      return this.store.subscribe(handleChange);
		    }
		  }, {
		    key: 'subscribeToOffsetChange',
		    value: function subscribeToOffsetChange(listener) {
		      var _this2 = this;
	
		      (0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
	
		      var previousState = this.store.getState().dragOffset;
		      var handleChange = function handleChange() {
		        var nextState = _this2.store.getState().dragOffset;
		        if (nextState === previousState) {
		          return;
		        }
	
		        previousState = nextState;
		        listener();
		      };
	
		      return this.store.subscribe(handleChange);
		    }
		  }, {
		    key: 'canDragSource',
		    value: function canDragSource(sourceId) {
		      var source = this.registry.getSource(sourceId);
		      (0, _invariant2.default)(source, 'Expected to find a valid source.');
	
		      if (this.isDragging()) {
		        return false;
		      }
	
		      return source.canDrag(this, sourceId);
		    }
		  }, {
		    key: 'canDropOnTarget',
		    value: function canDropOnTarget(targetId) {
		      var target = this.registry.getTarget(targetId);
		      (0, _invariant2.default)(target, 'Expected to find a valid target.');
	
		      if (!this.isDragging() || this.didDrop()) {
		        return false;
		      }
	
		      var targetType = this.registry.getTargetType(targetId);
		      var draggedItemType = this.getItemType();
		      return (0, _matchesType2.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
		    }
		  }, {
		    key: 'isDragging',
		    value: function isDragging() {
		      return Boolean(this.getItemType());
		    }
		  }, {
		    key: 'isDraggingSource',
		    value: function isDraggingSource(sourceId) {
		      var source = this.registry.getSource(sourceId, true);
		      (0, _invariant2.default)(source, 'Expected to find a valid source.');
	
		      if (!this.isDragging() || !this.isSourcePublic()) {
		        return false;
		      }
	
		      var sourceType = this.registry.getSourceType(sourceId);
		      var draggedItemType = this.getItemType();
		      if (sourceType !== draggedItemType) {
		        return false;
		      }
	
		      return source.isDragging(this, sourceId);
		    }
		  }, {
		    key: 'isOverTarget',
		    value: function isOverTarget(targetId) {
		      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { shallow: false };
		      var shallow = options.shallow;
	
		      if (!this.isDragging()) {
		        return false;
		      }
	
		      var targetType = this.registry.getTargetType(targetId);
		      var draggedItemType = this.getItemType();
		      if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
		        return false;
		      }
	
		      var targetIds = this.getTargetIds();
		      if (!targetIds.length) {
		        return false;
		      }
	
		      var index = targetIds.indexOf(targetId);
		      if (shallow) {
		        return index === targetIds.length - 1;
		      } else {
		        return index > -1;
		      }
		    }
		  }, {
		    key: 'getItemType',
		    value: function getItemType() {
		      return this.store.getState().dragOperation.itemType;
		    }
		  }, {
		    key: 'getItem',
		    value: function getItem() {
		      return this.store.getState().dragOperation.item;
		    }
		  }, {
		    key: 'getSourceId',
		    value: function getSourceId() {
		      return this.store.getState().dragOperation.sourceId;
		    }
		  }, {
		    key: 'getTargetIds',
		    value: function getTargetIds() {
		      return this.store.getState().dragOperation.targetIds;
		    }
		  }, {
		    key: 'getDropResult',
		    value: function getDropResult() {
		      return this.store.getState().dragOperation.dropResult;
		    }
		  }, {
		    key: 'didDrop',
		    value: function didDrop() {
		      return this.store.getState().dragOperation.didDrop;
		    }
		  }, {
		    key: 'isSourcePublic',
		    value: function isSourcePublic() {
		      return this.store.getState().dragOperation.isSourcePublic;
		    }
		  }, {
		    key: 'getInitialClientOffset',
		    value: function getInitialClientOffset() {
		      return this.store.getState().dragOffset.initialClientOffset;
		    }
		  }, {
		    key: 'getInitialSourceClientOffset',
		    value: function getInitialSourceClientOffset() {
		      return this.store.getState().dragOffset.initialSourceClientOffset;
		    }
		  }, {
		    key: 'getClientOffset',
		    value: function getClientOffset() {
		      return this.store.getState().dragOffset.clientOffset;
		    }
		  }, {
		    key: 'getSourceClientOffset',
		    value: function getSourceClientOffset() {
		      return (0, _dragOffset.getSourceClientOffset)(this.store.getState().dragOffset);
		    }
		  }, {
		    key: 'getDifferenceFromInitialOffset',
		    value: function getDifferenceFromInitialOffset() {
		      return (0, _dragOffset.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
		    }
		  }]);
	
		  return DragDropMonitor;
		}();
	
		exports.default = DragDropMonitor;
	
	/***/ }),
	/* 251 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var DragSource = function () {
		  function DragSource() {
		    _classCallCheck(this, DragSource);
		  }
	
		  _createClass(DragSource, [{
		    key: "canDrag",
		    value: function canDrag() {
		      return true;
		    }
		  }, {
		    key: "isDragging",
		    value: function isDragging(monitor, handle) {
		      return handle === monitor.getSourceId();
		    }
		  }, {
		    key: "endDrag",
		    value: function endDrag() {}
		  }]);
	
		  return DragSource;
		}();
	
		exports.default = DragSource;
	
	/***/ }),
	/* 252 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var DropTarget = function () {
		  function DropTarget() {
		    _classCallCheck(this, DropTarget);
		  }
	
		  _createClass(DropTarget, [{
		    key: "canDrop",
		    value: function canDrop() {
		      return true;
		    }
		  }, {
		    key: "hover",
		    value: function hover() {}
		  }, {
		    key: "drop",
		    value: function drop() {}
		  }]);
	
		  return DropTarget;
		}();
	
		exports.default = DropTarget;
	
	/***/ }),
	/* 253 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _isArray = __webpack_require__(20);
	
		var _isArray2 = _interopRequireDefault(_isArray);
	
		var _asap = __webpack_require__(203);
	
		var _asap2 = _interopRequireDefault(_asap);
	
		var _registry = __webpack_require__(40);
	
		var _getNextUniqueId = __webpack_require__(260);
	
		var _getNextUniqueId2 = _interopRequireDefault(_getNextUniqueId);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var HandlerRoles = {
		  SOURCE: 'SOURCE',
		  TARGET: 'TARGET'
		};
	
		function validateSourceContract(source) {
		  (0, _invariant2.default)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
		  (0, _invariant2.default)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
		  (0, _invariant2.default)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
		}
	
		function validateTargetContract(target) {
		  (0, _invariant2.default)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
		  (0, _invariant2.default)(typeof target.hover === 'function', 'Expected hover to be a function.');
		  (0, _invariant2.default)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
		}
	
		function validateType(type, allowArray) {
		  if (allowArray && (0, _isArray2.default)(type)) {
		    type.forEach(function (t) {
		      return validateType(t, false);
		    });
		    return;
		  }
	
		  (0, _invariant2.default)(typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
		}
	
		function getNextHandlerId(role) {
		  var id = (0, _getNextUniqueId2.default)().toString();
		  switch (role) {
		    case HandlerRoles.SOURCE:
		      return 'S' + id;
		    case HandlerRoles.TARGET:
		      return 'T' + id;
		    default:
		      (0, _invariant2.default)(false, 'Unknown role: ' + role);
		  }
		}
	
		function parseRoleFromHandlerId(handlerId) {
		  switch (handlerId[0]) {
		    case 'S':
		      return HandlerRoles.SOURCE;
		    case 'T':
		      return HandlerRoles.TARGET;
		    default:
		      (0, _invariant2.default)(false, 'Cannot parse handler ID: ' + handlerId);
		  }
		}
	
		var HandlerRegistry = function () {
		  function HandlerRegistry(store) {
		    _classCallCheck(this, HandlerRegistry);
	
		    this.store = store;
	
		    this.types = {};
		    this.handlers = {};
	
		    this.pinnedSourceId = null;
		    this.pinnedSource = null;
		  }
	
		  _createClass(HandlerRegistry, [{
		    key: 'addSource',
		    value: function addSource(type, source) {
		      validateType(type);
		      validateSourceContract(source);
	
		      var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
		      this.store.dispatch((0, _registry.addSource)(sourceId));
		      return sourceId;
		    }
		  }, {
		    key: 'addTarget',
		    value: function addTarget(type, target) {
		      validateType(type, true);
		      validateTargetContract(target);
	
		      var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
		      this.store.dispatch((0, _registry.addTarget)(targetId));
		      return targetId;
		    }
		  }, {
		    key: 'addHandler',
		    value: function addHandler(role, type, handler) {
		      var id = getNextHandlerId(role);
		      this.types[id] = type;
		      this.handlers[id] = handler;
	
		      return id;
		    }
		  }, {
		    key: 'containsHandler',
		    value: function containsHandler(handler) {
		      var _this = this;
	
		      return Object.keys(this.handlers).some(function (key) {
		        return _this.handlers[key] === handler;
		      });
		    }
		  }, {
		    key: 'getSource',
		    value: function getSource(sourceId, includePinned) {
		      (0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
	
		      var isPinned = includePinned && sourceId === this.pinnedSourceId;
		      var source = isPinned ? this.pinnedSource : this.handlers[sourceId];
	
		      return source;
		    }
		  }, {
		    key: 'getTarget',
		    value: function getTarget(targetId) {
		      (0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
		      return this.handlers[targetId];
		    }
		  }, {
		    key: 'getSourceType',
		    value: function getSourceType(sourceId) {
		      (0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
		      return this.types[sourceId];
		    }
		  }, {
		    key: 'getTargetType',
		    value: function getTargetType(targetId) {
		      (0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
		      return this.types[targetId];
		    }
		  }, {
		    key: 'isSourceId',
		    value: function isSourceId(handlerId) {
		      var role = parseRoleFromHandlerId(handlerId);
		      return role === HandlerRoles.SOURCE;
		    }
		  }, {
		    key: 'isTargetId',
		    value: function isTargetId(handlerId) {
		      var role = parseRoleFromHandlerId(handlerId);
		      return role === HandlerRoles.TARGET;
		    }
		  }, {
		    key: 'removeSource',
		    value: function removeSource(sourceId) {
		      var _this2 = this;
	
		      (0, _invariant2.default)(this.getSource(sourceId), 'Expected an existing source.');
		      this.store.dispatch((0, _registry.removeSource)(sourceId));
	
		      (0, _asap2.default)(function () {
		        delete _this2.handlers[sourceId];
		        delete _this2.types[sourceId];
		      });
		    }
		  }, {
		    key: 'removeTarget',
		    value: function removeTarget(targetId) {
		      var _this3 = this;
	
		      (0, _invariant2.default)(this.getTarget(targetId), 'Expected an existing target.');
		      this.store.dispatch((0, _registry.removeTarget)(targetId));
	
		      (0, _asap2.default)(function () {
		        delete _this3.handlers[targetId];
		        delete _this3.types[targetId];
		      });
		    }
		  }, {
		    key: 'pinSource',
		    value: function pinSource(sourceId) {
		      var source = this.getSource(sourceId);
		      (0, _invariant2.default)(source, 'Expected an existing source.');
	
		      this.pinnedSourceId = sourceId;
		      this.pinnedSource = source;
		    }
		  }, {
		    key: 'unpinSource',
		    value: function unpinSource() {
		      (0, _invariant2.default)(this.pinnedSource, 'No source is pinned at the time.');
	
		      this.pinnedSourceId = null;
		      this.pinnedSource = null;
		    }
		  }]);
	
		  return HandlerRegistry;
		}();
	
		exports.default = HandlerRegistry;
	
	/***/ }),
	/* 254 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = createBackend;
	
		var _noop = __webpack_require__(122);
	
		var _noop2 = _interopRequireDefault(_noop);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var TestBackend = function () {
		  function TestBackend(manager) {
		    _classCallCheck(this, TestBackend);
	
		    this.actions = manager.getActions();
		  }
	
		  _createClass(TestBackend, [{
		    key: 'setup',
		    value: function setup() {
		      this.didCallSetup = true;
		    }
		  }, {
		    key: 'teardown',
		    value: function teardown() {
		      this.didCallTeardown = true;
		    }
		  }, {
		    key: 'connectDragSource',
		    value: function connectDragSource() {
		      return _noop2.default;
		    }
		  }, {
		    key: 'connectDragPreview',
		    value: function connectDragPreview() {
		      return _noop2.default;
		    }
		  }, {
		    key: 'connectDropTarget',
		    value: function connectDropTarget() {
		      return _noop2.default;
		    }
		  }, {
		    key: 'simulateBeginDrag',
		    value: function simulateBeginDrag(sourceIds, options) {
		      this.actions.beginDrag(sourceIds, options);
		    }
		  }, {
		    key: 'simulatePublishDragSource',
		    value: function simulatePublishDragSource() {
		      this.actions.publishDragSource();
		    }
		  }, {
		    key: 'simulateHover',
		    value: function simulateHover(targetIds, options) {
		      this.actions.hover(targetIds, options);
		    }
		  }, {
		    key: 'simulateDrop',
		    value: function simulateDrop() {
		      this.actions.drop();
		    }
		  }, {
		    key: 'simulateEndDrag',
		    value: function simulateEndDrag() {
		      this.actions.endDrag();
		    }
		  }]);
	
		  return TestBackend;
		}();
	
		function createBackend(manager) {
		  return new TestBackend(manager);
		}
	
	/***/ }),
	/* 255 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _DragDropManager = __webpack_require__(249);
	
		Object.defineProperty(exports, 'DragDropManager', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DragDropManager).default;
		  }
		});
	
		var _DragSource = __webpack_require__(251);
	
		Object.defineProperty(exports, 'DragSource', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DragSource).default;
		  }
		});
	
		var _DropTarget = __webpack_require__(252);
	
		Object.defineProperty(exports, 'DropTarget', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DropTarget).default;
		  }
		});
	
		var _createTestBackend = __webpack_require__(254);
	
		Object.defineProperty(exports, 'createTestBackend', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_createTestBackend).default;
		  }
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/***/ }),
	/* 256 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		exports.default = dragOperation;
	
		var _without = __webpack_require__(123);
	
		var _without2 = _interopRequireDefault(_without);
	
		var _dragDrop = __webpack_require__(39);
	
		var _registry = __webpack_require__(40);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var initialState = {
		  itemType: null,
		  item: null,
		  sourceId: null,
		  targetIds: [],
		  dropResult: null,
		  didDrop: false,
		  isSourcePublic: null
		};
	
		function dragOperation() {
		  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		  var action = arguments[1];
	
		  switch (action.type) {
		    case _dragDrop.BEGIN_DRAG:
		      return _extends({}, state, {
		        itemType: action.itemType,
		        item: action.item,
		        sourceId: action.sourceId,
		        isSourcePublic: action.isSourcePublic,
		        dropResult: null,
		        didDrop: false
		      });
		    case _dragDrop.PUBLISH_DRAG_SOURCE:
		      return _extends({}, state, {
		        isSourcePublic: true
		      });
		    case _dragDrop.HOVER:
		      return _extends({}, state, {
		        targetIds: action.targetIds
		      });
		    case _registry.REMOVE_TARGET:
		      if (state.targetIds.indexOf(action.targetId) === -1) {
		        return state;
		      }
		      return _extends({}, state, {
		        targetIds: (0, _without2.default)(state.targetIds, action.targetId)
		      });
		    case _dragDrop.DROP:
		      return _extends({}, state, {
		        dropResult: action.dropResult,
		        didDrop: true,
		        targetIds: []
		      });
		    case _dragDrop.END_DRAG:
		      return _extends({}, state, {
		        itemType: null,
		        item: null,
		        sourceId: null,
		        dropResult: null,
		        didDrop: false,
		        isSourcePublic: null,
		        targetIds: []
		      });
		    default:
		      return state;
		  }
		}
	
	/***/ }),
	/* 257 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = reduce;
	
		var _dragOffset = __webpack_require__(104);
	
		var _dragOffset2 = _interopRequireDefault(_dragOffset);
	
		var _dragOperation = __webpack_require__(256);
	
		var _dragOperation2 = _interopRequireDefault(_dragOperation);
	
		var _refCount = __webpack_require__(258);
	
		var _refCount2 = _interopRequireDefault(_refCount);
	
		var _dirtyHandlerIds = __webpack_require__(103);
	
		var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);
	
		var _stateId = __webpack_require__(259);
	
		var _stateId2 = _interopRequireDefault(_stateId);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function reduce() {
		  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		  var action = arguments[1];
	
		  return {
		    dirtyHandlerIds: (0, _dirtyHandlerIds2.default)(state.dirtyHandlerIds, action, state.dragOperation),
		    dragOffset: (0, _dragOffset2.default)(state.dragOffset, action),
		    refCount: (0, _refCount2.default)(state.refCount, action),
		    dragOperation: (0, _dragOperation2.default)(state.dragOperation, action),
		    stateId: (0, _stateId2.default)(state.stateId)
		  };
		}
	
	/***/ }),
	/* 258 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = refCount;
	
		var _registry = __webpack_require__(40);
	
		function refCount() {
		  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
		  var action = arguments[1];
	
		  switch (action.type) {
		    case _registry.ADD_SOURCE:
		    case _registry.ADD_TARGET:
		      return state + 1;
		    case _registry.REMOVE_SOURCE:
		    case _registry.REMOVE_TARGET:
		      return state - 1;
		    default:
		      return state;
		  }
		}
	
	/***/ }),
	/* 259 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = stateId;
		function stateId() {
		  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
		  return state + 1;
		}
	
	/***/ }),
	/* 260 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = getNextUniqueId;
		var nextUniqueId = 0;
	
		function getNextUniqueId() {
		  return nextUniqueId++;
		}
	
	/***/ }),
	/* 261 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = activeElement;
	
		var _ownerDocument = __webpack_require__(74);
	
		var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function activeElement() {
		  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();
	
		  try {
		    return doc.activeElement;
		  } catch (e) {/* ie throws if no active element */}
		}
		module.exports = exports['default'];
	
	/***/ }),
	/* 262 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = addClass;
	
		var _hasClass = __webpack_require__(106);
	
		var _hasClass2 = _interopRequireDefault(_hasClass);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function addClass(element, className) {
		  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
		}
		module.exports = exports['default'];
	
	/***/ }),
	/* 263 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.hasClass = exports.removeClass = exports.addClass = undefined;
	
		var _addClass = __webpack_require__(262);
	
		var _addClass2 = _interopRequireDefault(_addClass);
	
		var _removeClass = __webpack_require__(264);
	
		var _removeClass2 = _interopRequireDefault(_removeClass);
	
		var _hasClass = __webpack_require__(106);
	
		var _hasClass2 = _interopRequireDefault(_hasClass);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.addClass = _addClass2.default;
		exports.removeClass = _removeClass2.default;
		exports.hasClass = _hasClass2.default;
		exports.default = { addClass: _addClass2.default, removeClass: _removeClass2.default, hasClass: _hasClass2.default };
	
	/***/ }),
	/* 264 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		module.exports = function removeClass(element, className) {
		  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
		};
	
	/***/ }),
	/* 265 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _inDOM = __webpack_require__(24);
	
		var _inDOM2 = _interopRequireDefault(_inDOM);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var off = function off() {};
		if (_inDOM2.default) {
		  off = function () {
		    if (document.addEventListener) return function (node, eventName, handler, capture) {
		      return node.removeEventListener(eventName, handler, capture || false);
		    };else if (document.attachEvent) return function (node, eventName, handler) {
		      return node.detachEvent('on' + eventName, handler);
		    };
		  }();
		}
	
		exports.default = off;
		module.exports = exports['default'];
	
	/***/ }),
	/* 266 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _inDOM = __webpack_require__(24);
	
		var _inDOM2 = _interopRequireDefault(_inDOM);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var on = function on() {};
		if (_inDOM2.default) {
		  on = function () {
	
		    if (document.addEventListener) return function (node, eventName, handler, capture) {
		      return node.addEventListener(eventName, handler, capture || false);
		    };else if (document.attachEvent) return function (node, eventName, handler) {
		      return node.attachEvent('on' + eventName, function (e) {
		        e = e || window.event;
		        e.target = e.target || e.srcElement;
		        e.currentTarget = node;
		        handler.call(node, e);
		      });
		    };
		  }();
		}
	
		exports.default = on;
		module.exports = exports['default'];
	
	/***/ }),
	/* 267 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _inDOM = __webpack_require__(24);
	
		var _inDOM2 = _interopRequireDefault(_inDOM);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = function () {
		  // HTML DOM and SVG DOM may have different support levels,
		  // so we need to check on context instead of a document root element.
		  return _inDOM2.default ? function (context, node) {
		    if (context.contains) {
		      return context.contains(node);
		    } else if (context.compareDocumentPosition) {
		      return context === node || !!(context.compareDocumentPosition(node) & 16);
		    } else {
		      return fallback(context, node);
		    }
		  } : fallback;
		}();
	
		function fallback(context, node) {
		  if (node) do {
		    if (node === context) return true;
		  } while (node = node.parentNode);
	
		  return false;
		}
		module.exports = exports['default'];
	
	/***/ }),
	/* 268 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = getWindow;
		function getWindow(node) {
		  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
		}
		module.exports = exports["default"];
	
	/***/ }),
	/* 269 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = _getComputedStyle;
	
		var _camelizeStyle = __webpack_require__(107);
	
		var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var rposition = /^(top|right|bottom|left)$/;
		var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
		function _getComputedStyle(node) {
		  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
		  var doc = node.ownerDocument;
	
		  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
		    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
		    getPropertyValue: function getPropertyValue(prop) {
		      var style = node.style;
	
		      prop = (0, _camelizeStyle2.default)(prop);
	
		      if (prop == 'float') prop = 'styleFloat';
	
		      var current = node.currentStyle[prop] || null;
	
		      if (current == null && style && style[prop]) current = style[prop];
	
		      if (rnumnonpx.test(current) && !rposition.test(prop)) {
		        // Remember the original values
		        var left = style.left;
		        var runStyle = node.runtimeStyle;
		        var rsLeft = runStyle && runStyle.left;
	
		        // Put in the new values to get a computed value out
		        if (rsLeft) runStyle.left = node.currentStyle.left;
	
		        style.left = prop === 'fontSize' ? '1em' : current;
		        current = style.pixelLeft + 'px';
	
		        // Revert the changed values
		        style.left = left;
		        if (rsLeft) runStyle.left = rsLeft;
		      }
	
		      return current;
		    }
		  };
		}
		module.exports = exports['default'];
	
	/***/ }),
	/* 270 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = style;
	
		var _camelizeStyle = __webpack_require__(107);
	
		var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
		var _hyphenateStyle = __webpack_require__(276);
	
		var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);
	
		var _getComputedStyle2 = __webpack_require__(269);
	
		var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);
	
		var _removeStyle = __webpack_require__(271);
	
		var _removeStyle2 = _interopRequireDefault(_removeStyle);
	
		var _properties = __webpack_require__(273);
	
		var _isTransform = __webpack_require__(272);
	
		var _isTransform2 = _interopRequireDefault(_isTransform);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function style(node, property, value) {
		  var css = '';
		  var transforms = '';
		  var props = property;
	
		  if (typeof property === 'string') {
		    if (value === undefined) {
		      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
		    } else {
		      (props = {})[property] = value;
		    }
		  }
	
		  Object.keys(props).forEach(function (key) {
		    var value = props[key];
		    if (!value && value !== 0) {
		      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
		    } else if ((0, _isTransform2.default)(key)) {
		      transforms += key + '(' + value + ') ';
		    } else {
		      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
		    }
		  });
	
		  if (transforms) {
		    css += _properties.transform + ': ' + transforms + ';';
		  }
	
		  node.style.cssText += ';' + css;
		}
		module.exports = exports['default'];
	
	/***/ }),
	/* 271 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = removeStyle;
		function removeStyle(node, key) {
		  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
		}
		module.exports = exports['default'];
	
	/***/ }),
	/* 272 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isTransform;
		var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
		function isTransform(property) {
		  return !!(property && supportedTransforms.test(property));
		}
		module.exports = exports["default"];
	
	/***/ }),
	/* 273 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;
	
		var _inDOM = __webpack_require__(24);
	
		var _inDOM2 = _interopRequireDefault(_inDOM);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var transform = 'transform';
		var prefix = void 0,
		    transitionEnd = void 0,
		    animationEnd = void 0;
		var transitionProperty = void 0,
		    transitionDuration = void 0,
		    transitionTiming = void 0,
		    transitionDelay = void 0;
		var animationName = void 0,
		    animationDuration = void 0,
		    animationTiming = void 0,
		    animationDelay = void 0;
	
		if (_inDOM2.default) {
		  var _getTransitionPropert = getTransitionProperties();
	
		  prefix = _getTransitionPropert.prefix;
		  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
		  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	
	
		  exports.transform = transform = prefix + '-' + transform;
		  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
		  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
		  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
		  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';
	
		  exports.animationName = animationName = prefix + '-animation-name';
		  exports.animationDuration = animationDuration = prefix + '-animation-duration';
		  exports.animationTiming = animationTiming = prefix + '-animation-delay';
		  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
		}
	
		exports.transform = transform;
		exports.transitionProperty = transitionProperty;
		exports.transitionTiming = transitionTiming;
		exports.transitionDelay = transitionDelay;
		exports.transitionDuration = transitionDuration;
		exports.transitionEnd = transitionEnd;
		exports.animationName = animationName;
		exports.animationDuration = animationDuration;
		exports.animationTiming = animationTiming;
		exports.animationDelay = animationDelay;
		exports.animationEnd = animationEnd;
		exports.default = {
		  transform: transform,
		  end: transitionEnd,
		  property: transitionProperty,
		  timing: transitionTiming,
		  delay: transitionDelay,
		  duration: transitionDuration
		};
	
	
		function getTransitionProperties() {
		  var style = document.createElement('div').style;
	
		  var vendorMap = {
		    O: function O(e) {
		      return 'o' + e.toLowerCase();
		    },
		    Moz: function Moz(e) {
		      return e.toLowerCase();
		    },
		    Webkit: function Webkit(e) {
		      return 'webkit' + e;
		    },
		    ms: function ms(e) {
		      return 'MS' + e;
		    }
		  };
	
		  var vendors = Object.keys(vendorMap);
	
		  var transitionEnd = void 0,
		      animationEnd = void 0;
		  var prefix = '';
	
		  for (var i = 0; i < vendors.length; i++) {
		    var vendor = vendors[i];
	
		    if (vendor + 'TransitionProperty' in style) {
		      prefix = '-' + vendor.toLowerCase();
		      transitionEnd = vendorMap[vendor]('TransitionEnd');
		      animationEnd = vendorMap[vendor]('AnimationEnd');
		      break;
		    }
		  }
	
		  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	
		  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	
		  style = null;
	
		  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
		}
	
	/***/ }),
	/* 274 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = camelize;
		var rHyphen = /-(.)/g;
	
		function camelize(string) {
		  return string.replace(rHyphen, function (_, chr) {
		    return chr.toUpperCase();
		  });
		}
		module.exports = exports["default"];
	
	/***/ }),
	/* 275 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = hyphenate;
	
		var rUpper = /([A-Z])/g;
	
		function hyphenate(string) {
		  return string.replace(rUpper, '-$1').toLowerCase();
		}
		module.exports = exports['default'];
	
	/***/ }),
	/* 276 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = hyphenateStyleName;
	
		var _hyphenate = __webpack_require__(275);
	
		var _hyphenate2 = _interopRequireDefault(_hyphenate);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var msPattern = /^ms-/; /**
		                         * Copyright 2013-2014, Facebook, Inc.
		                         * All rights reserved.
		                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
		                         */
	
		function hyphenateStyleName(string) {
		  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
		}
		module.exports = exports['default'];
	
	/***/ }),
	/* 277 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		exports.default = function (recalc) {
		  if (!size || recalc) {
		    if (_inDOM2.default) {
		      var scrollDiv = document.createElement('div');
	
		      scrollDiv.style.position = 'absolute';
		      scrollDiv.style.top = '-9999px';
		      scrollDiv.style.width = '50px';
		      scrollDiv.style.height = '50px';
		      scrollDiv.style.overflow = 'scroll';
	
		      document.body.appendChild(scrollDiv);
		      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
		      document.body.removeChild(scrollDiv);
		    }
		  }
	
		  return size;
		};
	
		var _inDOM = __webpack_require__(24);
	
		var _inDOM2 = _interopRequireDefault(_inDOM);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var size = void 0;
	
		module.exports = exports['default'];
	
	/***/ }),
	/* 278 */
	/***/ (function(module, exports) {
	
		/**
		 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
		 * Build: `lodash modern modularize exports="npm" -o ./`
		 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
		 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
		 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
		 * Available under MIT license <https://lodash.com/license>
		 */
	
		/**
		 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
		 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(1);
		 * // => false
		 */
		function isObject(value) {
		  // Avoid a V8 JIT bug in Chrome 19-20.
		  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
		  var type = typeof value;
		  return !!value && (type == 'object' || type == 'function');
		}
	
		module.exports = isObject;
	
	
	/***/ }),
	/* 279 */
	[1610, 307, 308, 309, 310, 311],
	/* 280 */
	[1616, 317, 318, 319, 320, 321],
	/* 281 */
	[1619, 44, 28],
	/* 282 */
	[1629, 44, 28],
	/* 283 */
	/***/ (function(module, exports) {
	
		/**
		 * A specialized version of `_.filter` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {Array} Returns the new filtered array.
		 */
		function arrayFilter(array, predicate) {
		  var index = -1,
		      length = array == null ? 0 : array.length,
		      resIndex = 0,
		      result = [];
	
		  while (++index < length) {
		    var value = array[index];
		    if (predicate(value, index, array)) {
		      result[resIndex++] = value;
		    }
		  }
		  return result;
		}
	
		module.exports = arrayFilter;
	
	
	/***/ }),
	/* 284 */
	[1648, 296, 119, 20, 342, 116, 343],
	/* 285 */
	/***/ (function(module, exports) {
	
		/**
		 * Appends the elements of `values` to `array`.
		 *
		 * @private
		 * @param {Array} array The array to modify.
		 * @param {Array} values The values to append.
		 * @returns {Array} Returns `array`.
		 */
		function arrayPush(array, values) {
		  var index = -1,
		      length = values.length,
		      offset = array.length;
	
		  while (++index < length) {
		    array[offset + index] = values[index];
		  }
		  return array;
		}
	
		module.exports = arrayPush;
	
	
	/***/ }),
	/* 286 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseAssignValue = __webpack_require__(110),
		    eq = __webpack_require__(46);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Assigns `value` to `key` of `object` if the existing value is not equivalent
		 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * for equality comparisons.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function assignValue(object, key, value) {
		  var objValue = object[key];
		  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
		      (value === undefined && !(key in object))) {
		    baseAssignValue(object, key, value);
		  }
		}
	
		module.exports = assignValue;
	
	
	/***/ }),
	/* 287 */
	/***/ (function(module, exports) {
	
		/**
		 * The base implementation of `_.findIndex` and `_.findLastIndex` without
		 * support for iteratee shorthands.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {Function} predicate The function invoked per iteration.
		 * @param {number} fromIndex The index to search from.
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function baseFindIndex(array, predicate, fromIndex, fromRight) {
		  var length = array.length,
		      index = fromIndex + (fromRight ? 1 : -1);
	
		  while ((fromRight ? index-- : ++index < length)) {
		    if (predicate(array[index], index, array)) {
		      return index;
		    }
		  }
		  return -1;
		}
	
		module.exports = baseFindIndex;
	
	
	/***/ }),
	/* 288 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseFindIndex = __webpack_require__(287),
		    baseIsNaN = __webpack_require__(291),
		    strictIndexOf = __webpack_require__(336);
	
		/**
		 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} value The value to search for.
		 * @param {number} fromIndex The index to search from.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function baseIndexOf(array, value, fromIndex) {
		  return value === value
		    ? strictIndexOf(array, value, fromIndex)
		    : baseFindIndex(array, baseIsNaN, fromIndex);
		}
	
		module.exports = baseIndexOf;
	
	
	/***/ }),
	/* 289 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var SetCache = __webpack_require__(76),
		    arrayIncludes = __webpack_require__(78),
		    arrayIncludesWith = __webpack_require__(79),
		    arrayMap = __webpack_require__(80),
		    baseUnary = __webpack_require__(81),
		    cacheHas = __webpack_require__(82);
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeMin = Math.min;
	
		/**
		 * The base implementation of methods like `_.intersection`, without support
		 * for iteratee shorthands, that accepts an array of arrays to inspect.
		 *
		 * @private
		 * @param {Array} arrays The arrays to inspect.
		 * @param {Function} [iteratee] The iteratee invoked per element.
		 * @param {Function} [comparator] The comparator invoked per element.
		 * @returns {Array} Returns the new array of shared values.
		 */
		function baseIntersection(arrays, iteratee, comparator) {
		  var includes = comparator ? arrayIncludesWith : arrayIncludes,
		      length = arrays[0].length,
		      othLength = arrays.length,
		      othIndex = othLength,
		      caches = Array(othLength),
		      maxLength = Infinity,
		      result = [];
	
		  while (othIndex--) {
		    var array = arrays[othIndex];
		    if (othIndex && iteratee) {
		      array = arrayMap(array, baseUnary(iteratee));
		    }
		    maxLength = nativeMin(array.length, maxLength);
		    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
		      ? new SetCache(othIndex && array)
		      : undefined;
		  }
		  array = arrays[0];
	
		  var index = -1,
		      seen = caches[0];
	
		  outer:
		  while (++index < length && result.length < maxLength) {
		    var value = array[index],
		        computed = iteratee ? iteratee(value) : value;
	
		    value = (comparator || value !== 0) ? value : 0;
		    if (!(seen
		          ? cacheHas(seen, computed)
		          : includes(result, computed, comparator)
		        )) {
		      othIndex = othLength;
		      while (--othIndex) {
		        var cache = caches[othIndex];
		        if (!(cache
		              ? cacheHas(cache, computed)
		              : includes(arrays[othIndex], computed, comparator))
		            ) {
		          continue outer;
		        }
		      }
		      if (seen) {
		        seen.push(computed);
		      }
		      result.push(value);
		    }
		  }
		  return result;
		}
	
		module.exports = baseIntersection;
	
	
	/***/ }),
	/* 290 */
	[1667, 42, 30],
	/* 291 */
	/***/ (function(module, exports) {
	
		/**
		 * The base implementation of `_.isNaN` without support for number objects.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
		 */
		function baseIsNaN(value) {
		  return value !== value;
		}
	
		module.exports = baseIsNaN;
	
	
	/***/ }),
	/* 292 */
	[1672, 120, 315, 29, 337],
	/* 293 */
	[1675, 42, 121, 30],
	/* 294 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(29),
		    isPrototype = __webpack_require__(316),
		    nativeKeysIn = __webpack_require__(327);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeysIn(object) {
		  if (!isObject(object)) {
		    return nativeKeysIn(object);
		  }
		  var isProto = isPrototype(object),
		      result = [];
	
		  for (var key in object) {
		    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = baseKeysIn;
	
	
	/***/ }),
	/* 295 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var constant = __webpack_require__(339),
		    defineProperty = __webpack_require__(114),
		    identity = __webpack_require__(118);
	
		/**
		 * The base implementation of `setToString` without support for hot loop shorting.
		 *
		 * @private
		 * @param {Function} func The function to modify.
		 * @param {Function} string The `toString` result.
		 * @returns {Function} Returns `func`.
		 */
		var baseSetToString = !defineProperty ? identity : function(func, string) {
		  return defineProperty(func, 'toString', {
		    'configurable': true,
		    'enumerable': false,
		    'value': constant(string),
		    'writable': true
		  });
		};
	
		module.exports = baseSetToString;
	
	
	/***/ }),
	/* 296 */
	/***/ (function(module, exports) {
	
		/**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */
		function baseTimes(n, iteratee) {
		  var index = -1,
		      result = Array(n);
	
		  while (++index < n) {
		    result[index] = iteratee(index);
		  }
		  return result;
		}
	
		module.exports = baseTimes;
	
	
	/***/ }),
	/* 297 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseDifference = __webpack_require__(111),
		    baseFlatten = __webpack_require__(112),
		    baseUniq = __webpack_require__(113);
	
		/**
		 * The base implementation of methods like `_.xor`, without support for
		 * iteratee shorthands, that accepts an array of arrays to inspect.
		 *
		 * @private
		 * @param {Array} arrays The arrays to inspect.
		 * @param {Function} [iteratee] The iteratee invoked per element.
		 * @param {Function} [comparator] The comparator invoked per element.
		 * @returns {Array} Returns the new array of values.
		 */
		function baseXor(arrays, iteratee, comparator) {
		  var length = arrays.length;
		  if (length < 2) {
		    return length ? baseUniq(arrays[0]) : [];
		  }
		  var index = -1,
		      result = Array(length);
	
		  while (++index < length) {
		    var array = arrays[index],
		        othIndex = -1;
	
		    while (++othIndex < length) {
		      if (othIndex != index) {
		        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
		      }
		    }
		  }
		  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
		}
	
		module.exports = baseXor;
	
	
	/***/ }),
	/* 298 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var isArrayLikeObject = __webpack_require__(47);
	
		/**
		 * Casts `value` to an empty array if it's not an array like object.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @returns {Array|Object} Returns the cast array-like object.
		 */
		function castArrayLikeObject(value) {
		  return isArrayLikeObject(value) ? value : [];
		}
	
		module.exports = castArrayLikeObject;
	
	
	/***/ }),
	/* 299 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var assignValue = __webpack_require__(286),
		    baseAssignValue = __webpack_require__(110);
	
		/**
		 * Copies properties of `source` to `object`.
		 *
		 * @private
		 * @param {Object} source The object to copy properties from.
		 * @param {Array} props The property identifiers to copy.
		 * @param {Object} [object={}] The object to copy properties to.
		 * @param {Function} [customizer] The function to customize copied values.
		 * @returns {Object} Returns `object`.
		 */
		function copyObject(source, props, object, customizer) {
		  var isNew = !object;
		  object || (object = {});
	
		  var index = -1,
		      length = props.length;
	
		  while (++index < length) {
		    var key = props[index];
	
		    var newValue = customizer
		      ? customizer(object[key], source[key], key, object, source)
		      : undefined;
	
		    if (newValue === undefined) {
		      newValue = source[key];
		    }
		    if (isNew) {
		      baseAssignValue(object, key, newValue);
		    } else {
		      assignValue(object, key, newValue);
		    }
		  }
		  return object;
		}
	
		module.exports = copyObject;
	
	
	/***/ }),
	/* 300 */
	[1680, 28],
	/* 301 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseRest = __webpack_require__(25),
		    isIterateeCall = __webpack_require__(313);
	
		/**
		 * Creates a function like `_.assign`.
		 *
		 * @private
		 * @param {Function} assigner The function to assign values.
		 * @returns {Function} Returns the new assigner function.
		 */
		function createAssigner(assigner) {
		  return baseRest(function(object, sources) {
		    var index = -1,
		        length = sources.length,
		        customizer = length > 1 ? sources[length - 1] : undefined,
		        guard = length > 2 ? sources[2] : undefined;
	
		    customizer = (assigner.length > 3 && typeof customizer == 'function')
		      ? (length--, customizer)
		      : undefined;
	
		    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
		      customizer = length < 3 ? undefined : customizer;
		      length = 1;
		    }
		    object = Object(object);
		    while (++index < length) {
		      var source = sources[index];
		      if (source) {
		        assigner(object, source, index, customizer);
		      }
		    }
		    return object;
		  });
		}
	
		module.exports = createAssigner;
	
	
	/***/ }),
	/* 302 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var Set = __webpack_require__(282),
		    noop = __webpack_require__(122),
		    setToArray = __webpack_require__(117);
	
		/** Used as references for various `Number` constants. */
		var INFINITY = 1 / 0;
	
		/**
		 * Creates a set object of `values`.
		 *
		 * @private
		 * @param {Array} values The values to add to the set.
		 * @returns {Object} Returns the new set.
		 */
		var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
		  return new Set(values);
		};
	
		module.exports = createSet;
	
	
	/***/ }),
	/* 303 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var eq = __webpack_require__(46);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
		 * of source objects to the destination object for all destination properties
		 * that resolve to `undefined`.
		 *
		 * @private
		 * @param {*} objValue The destination value.
		 * @param {*} srcValue The source value.
		 * @param {string} key The key of the property to assign.
		 * @param {Object} object The parent object of `objValue`.
		 * @returns {*} Returns the value to assign.
		 */
		function customDefaultsAssignIn(objValue, srcValue, key, object) {
		  if (objValue === undefined ||
		      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
		    return srcValue;
		  }
		  return objValue;
		}
	
		module.exports = customDefaultsAssignIn;
	
	
	/***/ }),
	/* 304 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var overArg = __webpack_require__(330);
	
		/** Built-in value references. */
		var getPrototype = overArg(Object.getPrototypeOf, Object);
	
		module.exports = getPrototype;
	
	
	/***/ }),
	/* 305 */
	[1700, 77],
	/* 306 */
	/***/ (function(module, exports) {
	
		/**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */
		function getValue(object, key) {
		  return object == null ? undefined : object[key];
		}
	
		module.exports = getValue;
	
	
	/***/ }),
	/* 307 */
	[1704, 45],
	/* 308 */
	/***/ (function(module, exports) {
	
		/**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function hashDelete(key) {
		  var result = this.has(key) && delete this.__data__[key];
		  this.size -= result ? 1 : 0;
		  return result;
		}
	
		module.exports = hashDelete;
	
	
	/***/ }),
	/* 309 */
	[1709, 45],
	/* 310 */
	[1714, 45],
	/* 311 */
	[1721, 45],
	/* 312 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var Symbol = __webpack_require__(77),
		    isArguments = __webpack_require__(119),
		    isArray = __webpack_require__(20);
	
		/** Built-in value references. */
		var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
		/**
		 * Checks if `value` is a flattenable `arguments` object or array.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
		 */
		function isFlattenable(value) {
		  return isArray(value) || isArguments(value) ||
		    !!(spreadableSymbol && value && value[spreadableSymbol]);
		}
	
		module.exports = isFlattenable;
	
	
	/***/ }),
	/* 313 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var eq = __webpack_require__(46),
		    isArrayLike = __webpack_require__(83),
		    isIndex = __webpack_require__(116),
		    isObject = __webpack_require__(29);
	
		/**
		 * Checks if the given arguments are from an iteratee call.
		 *
		 * @private
		 * @param {*} value The potential iteratee value argument.
		 * @param {*} index The potential iteratee index or key argument.
		 * @param {*} object The potential iteratee object argument.
		 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
		 *  else `false`.
		 */
		function isIterateeCall(value, index, object) {
		  if (!isObject(object)) {
		    return false;
		  }
		  var type = typeof index;
		  if (type == 'number'
		        ? (isArrayLike(object) && isIndex(index, object.length))
		        : (type == 'string' && index in object)
		      ) {
		    return eq(object[index], value);
		  }
		  return false;
		}
	
		module.exports = isIterateeCall;
	
	
	/***/ }),
	/* 314 */
	/***/ (function(module, exports) {
	
		/**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */
		function isKeyable(value) {
		  var type = typeof value;
		  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
		    ? (value !== '__proto__')
		    : (value === null);
		}
	
		module.exports = isKeyable;
	
	
	/***/ }),
	/* 315 */
	[1725, 300],
	/* 316 */
	/***/ (function(module, exports) {
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */
		function isPrototype(value) {
		  var Ctor = value && value.constructor,
		      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
		  return value === proto;
		}
	
		module.exports = isPrototype;
	
	
	/***/ }),
	/* 317 */
	/***/ (function(module, exports) {
	
		/**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */
		function listCacheClear() {
		  this.__data__ = [];
		  this.size = 0;
		}
	
		module.exports = listCacheClear;
	
	
	/***/ }),
	/* 318 */
	[1732, 41],
	/* 319 */
	[1736, 41],
	/* 320 */
	[1742, 41],
	/* 321 */
	[1744, 41],
	/* 322 */
	[1749, 279, 280, 281],
	/* 323 */
	[1757, 43],
	/* 324 */
	[1761, 43],
	/* 325 */
	[1767, 43],
	/* 326 */
	[1772, 43],
	/* 327 */
	/***/ (function(module, exports) {
	
		/**
		 * This function is like
		 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * except that it includes inherited enumerable properties.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function nativeKeysIn(object) {
		  var result = [];
		  if (object != null) {
		    for (var key in Object(object)) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = nativeKeysIn;
	
	
	/***/ }),
	/* 328 */
	[1779, 115],
	/* 329 */
	/***/ (function(module, exports) {
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var nativeObjectToString = objectProto.toString;
	
		/**
		 * Converts `value` to a string using `Object.prototype.toString`.
		 *
		 * @private
		 * @param {*} value The value to convert.
		 * @returns {string} Returns the converted string.
		 */
		function objectToString(value) {
		  return nativeObjectToString.call(value);
		}
	
		module.exports = objectToString;
	
	
	/***/ }),
	/* 330 */
	/***/ (function(module, exports) {
	
		/**
		 * Creates a unary function that invokes `func` with its argument transformed.
		 *
		 * @private
		 * @param {Function} func The function to wrap.
		 * @param {Function} transform The argument transform.
		 * @returns {Function} Returns the new function.
		 */
		function overArg(func, transform) {
		  return function(arg) {
		    return func(transform(arg));
		  };
		}
	
		module.exports = overArg;
	
	
	/***/ }),
	/* 331 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var apply = __webpack_require__(109);
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeMax = Math.max;
	
		/**
		 * A specialized version of `baseRest` which transforms the rest array.
		 *
		 * @private
		 * @param {Function} func The function to apply a rest parameter to.
		 * @param {number} [start=func.length-1] The start position of the rest parameter.
		 * @param {Function} transform The rest array transform.
		 * @returns {Function} Returns the new function.
		 */
		function overRest(func, start, transform) {
		  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
		  return function() {
		    var args = arguments,
		        index = -1,
		        length = nativeMax(args.length - start, 0),
		        array = Array(length);
	
		    while (++index < length) {
		      array[index] = args[start + index];
		    }
		    index = -1;
		    var otherArgs = Array(start + 1);
		    while (++index < start) {
		      otherArgs[index] = args[index];
		    }
		    otherArgs[start] = transform(array);
		    return apply(func, this, otherArgs);
		  };
		}
	
		module.exports = overRest;
	
	
	/***/ }),
	/* 332 */
	/***/ (function(module, exports) {
	
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
		/**
		 * Adds `value` to the array cache.
		 *
		 * @private
		 * @name add
		 * @memberOf SetCache
		 * @alias push
		 * @param {*} value The value to cache.
		 * @returns {Object} Returns the cache instance.
		 */
		function setCacheAdd(value) {
		  this.__data__.set(value, HASH_UNDEFINED);
		  return this;
		}
	
		module.exports = setCacheAdd;
	
	
	/***/ }),
	/* 333 */
	/***/ (function(module, exports) {
	
		/**
		 * Checks if `value` is in the array cache.
		 *
		 * @private
		 * @name has
		 * @memberOf SetCache
		 * @param {*} value The value to search for.
		 * @returns {number} Returns `true` if `value` is found, else `false`.
		 */
		function setCacheHas(value) {
		  return this.__data__.has(value);
		}
	
		module.exports = setCacheHas;
	
	
	/***/ }),
	/* 334 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseSetToString = __webpack_require__(295),
		    shortOut = __webpack_require__(335);
	
		/**
		 * Sets the `toString` method of `func` to return `string`.
		 *
		 * @private
		 * @param {Function} func The function to modify.
		 * @param {Function} string The `toString` result.
		 * @returns {Function} Returns `func`.
		 */
		var setToString = shortOut(baseSetToString);
	
		module.exports = setToString;
	
	
	/***/ }),
	/* 335 */
	/***/ (function(module, exports) {
	
		/** Used to detect hot functions by number of calls within a span of milliseconds. */
		var HOT_COUNT = 800,
		    HOT_SPAN = 16;
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeNow = Date.now;
	
		/**
		 * Creates a function that'll short out and invoke `identity` instead
		 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
		 * milliseconds.
		 *
		 * @private
		 * @param {Function} func The function to restrict.
		 * @returns {Function} Returns the new shortable function.
		 */
		function shortOut(func) {
		  var count = 0,
		      lastCalled = 0;
	
		  return function() {
		    var stamp = nativeNow(),
		        remaining = HOT_SPAN - (stamp - lastCalled);
	
		    lastCalled = stamp;
		    if (remaining > 0) {
		      if (++count >= HOT_COUNT) {
		        return arguments[0];
		      }
		    } else {
		      count = 0;
		    }
		    return func.apply(undefined, arguments);
		  };
		}
	
		module.exports = shortOut;
	
	
	/***/ }),
	/* 336 */
	/***/ (function(module, exports) {
	
		/**
		 * A specialized version of `_.indexOf` which performs strict equality
		 * comparisons of values, i.e. `===`.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} value The value to search for.
		 * @param {number} fromIndex The index to search from.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function strictIndexOf(array, value, fromIndex) {
		  var index = fromIndex - 1,
		      length = array.length;
	
		  while (++index < length) {
		    if (array[index] === value) {
		      return index;
		    }
		  }
		  return -1;
		}
	
		module.exports = strictIndexOf;
	
	
	/***/ }),
	/* 337 */
	154,
	/* 338 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var copyObject = __webpack_require__(299),
		    createAssigner = __webpack_require__(301),
		    keysIn = __webpack_require__(344);
	
		/**
		 * This method is like `_.assignIn` except that it accepts `customizer`
		 * which is invoked to produce the assigned values. If `customizer` returns
		 * `undefined`, assignment is handled by the method instead. The `customizer`
		 * is invoked with five arguments: (objValue, srcValue, key, object, source).
		 *
		 * **Note:** This method mutates `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @alias extendWith
		 * @category Object
		 * @param {Object} object The destination object.
		 * @param {...Object} sources The source objects.
		 * @param {Function} [customizer] The function to customize assigned values.
		 * @returns {Object} Returns `object`.
		 * @see _.assignWith
		 * @example
		 *
		 * function customizer(objValue, srcValue) {
		 *   return _.isUndefined(objValue) ? srcValue : objValue;
		 * }
		 *
		 * var defaults = _.partialRight(_.assignInWith, customizer);
		 *
		 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
		 * // => { 'a': 1, 'b': 2 }
		 */
		var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
		  copyObject(source, keysIn(source), object, customizer);
		});
	
		module.exports = assignInWith;
	
	
	/***/ }),
	/* 339 */
	/***/ (function(module, exports) {
	
		/**
		 * Creates a function that returns `value`.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.4.0
		 * @category Util
		 * @param {*} value The value to return from the new function.
		 * @returns {Function} Returns the new constant function.
		 * @example
		 *
		 * var objects = _.times(2, _.constant({ 'a': 1 }));
		 *
		 * console.log(objects);
		 * // => [{ 'a': 1 }, { 'a': 1 }]
		 *
		 * console.log(objects[0] === objects[1]);
		 * // => true
		 */
		function constant(value) {
		  return function() {
		    return value;
		  };
		}
	
		module.exports = constant;
	
	
	/***/ }),
	/* 340 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var apply = __webpack_require__(109),
		    assignInWith = __webpack_require__(338),
		    baseRest = __webpack_require__(25),
		    customDefaultsAssignIn = __webpack_require__(303);
	
		/**
		 * Assigns own and inherited enumerable string keyed properties of source
		 * objects to the destination object for all destination properties that
		 * resolve to `undefined`. Source objects are applied from left to right.
		 * Once a property is set, additional values of the same property are ignored.
		 *
		 * **Note:** This method mutates `object`.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The destination object.
		 * @param {...Object} [sources] The source objects.
		 * @returns {Object} Returns `object`.
		 * @see _.defaultsDeep
		 * @example
		 *
		 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
		 * // => { 'a': 1, 'b': 2 }
		 */
		var defaults = baseRest(function(args) {
		  args.push(undefined, customDefaultsAssignIn);
		  return apply(assignInWith, undefined, args);
		});
	
		module.exports = defaults;
	
	
	/***/ }),
	/* 341 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var arrayMap = __webpack_require__(80),
		    baseIntersection = __webpack_require__(289),
		    baseRest = __webpack_require__(25),
		    castArrayLikeObject = __webpack_require__(298);
	
		/**
		 * Creates an array of unique values that are included in all given arrays
		 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * for equality comparisons. The order and references of result values are
		 * determined by the first array.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Array
		 * @param {...Array} [arrays] The arrays to inspect.
		 * @returns {Array} Returns the new array of intersecting values.
		 * @example
		 *
		 * _.intersection([2, 1], [2, 3]);
		 * // => [2]
		 */
		var intersection = baseRest(function(arrays) {
		  var mapped = arrayMap(arrays, castArrayLikeObject);
		  return (mapped.length && mapped[0] === arrays[0])
		    ? baseIntersection(mapped)
		    : [];
		});
	
		module.exports = intersection;
	
	
	/***/ }),
	/* 342 */
	[1801, 28, 346],
	/* 343 */
	[1810, 293, 81, 328],
	/* 344 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var arrayLikeKeys = __webpack_require__(284),
		    baseKeysIn = __webpack_require__(294),
		    isArrayLike = __webpack_require__(83);
	
		/**
		 * Creates an array of the own and inherited enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keysIn(new Foo);
		 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
		 */
		function keysIn(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
		}
	
		module.exports = keysIn;
	
	
	/***/ }),
	/* 345 */
	[1818, 108],
	/* 346 */
	/***/ (function(module, exports) {
	
		/**
		 * This method returns `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {boolean} Returns `false`.
		 * @example
		 *
		 * _.times(2, _.stubFalse);
		 * // => [false, false]
		 */
		function stubFalse() {
		  return false;
		}
	
		module.exports = stubFalse;
	
	
	/***/ }),
	/* 347 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseFlatten = __webpack_require__(112),
		    baseRest = __webpack_require__(25),
		    baseUniq = __webpack_require__(113),
		    isArrayLikeObject = __webpack_require__(47);
	
		/**
		 * Creates an array of unique values, in order, from all given arrays using
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * for equality comparisons.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Array
		 * @param {...Array} [arrays] The arrays to inspect.
		 * @returns {Array} Returns the new array of combined values.
		 * @example
		 *
		 * _.union([2], [1, 2]);
		 * // => [2, 1]
		 */
		var union = baseRest(function(arrays) {
		  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
		});
	
		module.exports = union;
	
	
	/***/ }),
	/* 348 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var arrayFilter = __webpack_require__(283),
		    baseRest = __webpack_require__(25),
		    baseXor = __webpack_require__(297),
		    isArrayLikeObject = __webpack_require__(47);
	
		/**
		 * Creates an array of unique values that is the
		 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
		 * of the given arrays. The order of result values is determined by the order
		 * they occur in the arrays.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.4.0
		 * @category Array
		 * @param {...Array} [arrays] The arrays to inspect.
		 * @returns {Array} Returns the new array of filtered values.
		 * @see _.difference, _.without
		 * @example
		 *
		 * _.xor([2, 1], [2, 3]);
		 * // => [1, 3]
		 */
		var xor = baseRest(function(arrays) {
		  return baseXor(arrayFilter(arrays, isArrayLikeObject));
		});
	
		module.exports = xor;
	
	
	/***/ }),
	/* 349 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		exports.default = function (Component) {
		    var displayName = Component.displayName || Component.name || "Component";
	
		    return _react2.default.createClass({
		        displayName: "ContextMenuConnector(" + displayName + ")",
		        getInitialState: function getInitialState() {
		            return {
		                item: _store2.default.getState().currentItem
		            };
		        },
		        componentDidMount: function componentDidMount() {
		            this.unsubscribe = _store2.default.subscribe(this.handleUpdate);
		        },
		        componentWillUnmount: function componentWillUnmount() {
		            this.unsubscribe();
		        },
		        handleUpdate: function handleUpdate() {
		            this.setState(this.getInitialState());
		        },
		        render: function render() {
		            return _react2.default.createElement(Component, _extends({}, this.props, { item: this.state.item }));
		        }
		    });
		};
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _store = __webpack_require__(48);
	
		var _store2 = _interopRequireDefault(_store);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/***/ }),
	/* 350 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _store = __webpack_require__(48);
	
		var _store2 = _interopRequireDefault(_store);
	
		var _wrapper = __webpack_require__(351);
	
		var _wrapper2 = _interopRequireDefault(_wrapper);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var PropTypes = _react2.default.PropTypes;
	
	
		var ContextMenu = _react2.default.createClass({
		    displayName: "ContextMenu",
		    propTypes: {
		        identifier: PropTypes.string.isRequired
		    },
		    getInitialState: function getInitialState() {
		        return _store2.default.getState();
		    },
		    componentDidMount: function componentDidMount() {
		        this.unsubscribe = _store2.default.subscribe(this.handleUpdate);
		    },
		    componentWillUnmount: function componentWillUnmount() {
		        if (this.unsubscribe) this.unsubscribe();
		    },
		    handleUpdate: function handleUpdate() {
		        this.setState(this.getInitialState());
		    },
		    render: function render() {
		        return _react2.default.createElement(_wrapper2.default, _extends({}, this.props, this.state));
		    }
		});
	
		exports.default = ContextMenu;
	
	/***/ }),
	/* 351 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _monitor = __webpack_require__(84);
	
		var _monitor2 = _interopRequireDefault(_monitor);
	
		var _Modal = __webpack_require__(378);
	
		var _Modal2 = _interopRequireDefault(_Modal);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var modalStyle = {
		    position: "fixed",
		    zIndex: 1040,
		    top: 0,
		    bottom: 0,
		    left: 0,
		    right: 0
		},
		    backdropStyle = _extends({}, modalStyle, {
		    zIndex: "auto",
		    backgroundColor: "transparent"
		}),
		    menuStyles = {
		    position: "fixed",
		    zIndex: "auto"
		};
	
		var ContextMenuWrapper = _react2.default.createClass({
		    displayName: "ContextMenuWrapper",
		    getInitialState: function getInitialState() {
		        return {
		            left: 0,
		            top: 0
		        };
		    },
		    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		        var _this = this;
	
		        if (nextProps.isVisible === nextProps.identifier) {
		            var wrapper = window.requestAnimationFrame || setTimeout;
	
		            wrapper(function () {
		                _this.setState(_this.getMenuPosition(nextProps.x, nextProps.y));
		                _this.menu.parentNode.addEventListener("contextmenu", _this.hideMenu);
		            });
		        }
		    },
		    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		        return this.props.isVisible !== nextProps.visible;
		    },
		    hideMenu: function hideMenu(e) {
		        e.preventDefault();
		        this.menu.parentNode.removeEventListener("contextmenu", this.hideMenu);
		        _monitor2.default.hideMenu();
		    },
		    getMenuPosition: function getMenuPosition(x, y) {
		        var scrollX = document.documentElement.scrollTop;
		        var scrollY = document.documentElement.scrollLeft;
		        var _window = window;
		        var innerWidth = _window.innerWidth;
		        var innerHeight = _window.innerHeight;
		        var rect = this.menu.getBoundingClientRect();
		        var menuStyles = {
		            top: y + scrollY,
		            left: x + scrollX
		        };
	
		        if (y + rect.height > innerHeight) {
		            menuStyles.top -= rect.height;
		        }
	
		        if (x + rect.width > innerWidth) {
		            menuStyles.left -= rect.width;
		        }
	
		        return menuStyles;
		    },
		    render: function render() {
		        var _this2 = this;
	
		        var _props = this.props;
		        var isVisible = _props.isVisible;
		        var identifier = _props.identifier;
		        var children = _props.children;
	
	
		        var style = _extends({}, menuStyles, this.state);
	
		        return _react2.default.createElement(
		            _Modal2.default,
		            { style: modalStyle, backdropStyle: backdropStyle,
		                show: isVisible === identifier, onHide: function onHide() {
		                    return _monitor2.default.hideMenu();
		                } },
		            _react2.default.createElement(
		                "nav",
		                { ref: function ref(c) {
		                        return _this2.menu = c;
		                    }, style: style,
		                    className: "react-context-menu" },
		                children
		            )
		        );
		    }
		});
	
		exports.default = ContextMenuWrapper;
	
	/***/ }),
	/* 352 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		exports.default = function (identifier, configure) {
		    return function (Component) {
		        var displayName = Component.displayName || Component.name || "Component";
	
		        (0, _invariant2.default)(identifier && (typeof identifier === "string" || (typeof identifier === "undefined" ? "undefined" : _typeof(identifier)) === "symbol" || typeof identifier === "function"), "Expected identifier to be string, symbol or function. See %s", displayName);
	
		        if (configure) {
		            (0, _invariant2.default)(typeof configure === "function", "Expected configure to be a function. See %s", displayName);
		        }
	
		        return _react2.default.createClass({
		            displayName: displayName + "ContextMenuLayer",
		            getDefaultProps: function getDefaultProps() {
		                return {
		                    renderTag: "div",
		                    attributes: {}
		                };
		            },
	
		            mouseDown: false,
		            handleMouseDown: function handleMouseDown(event) {
		                var _this = this;
	
		                if (this.props.holdToDisplay >= 0 && event.button === 0) {
		                    event.persist();
	
		                    this.mouseDown = true;
		                    setTimeout(function () {
		                        if (_this.mouseDown) _this.handleContextClick(event);
		                    }, this.props.holdToDisplay);
		                }
		            },
		            handleTouchstart: function handleTouchstart(event) {
		                var _this2 = this;
	
		                event.persist();
	
		                this.mouseDown = true;
		                setTimeout(function () {
		                    if (_this2.mouseDown) _this2.handleContextClick(event);
		                }, this.props.holdToDisplay);
		            },
		            handleTouchEnd: function handleTouchEnd(event) {
		                event.preventDefault();
		                this.mouseDown = false;
		            },
		            handleMouseUp: function handleMouseUp(event) {
		                if (event.button === 0) {
		                    this.mouseDown = false;
		                }
		            },
		            handleContextClick: function handleContextClick(event) {
		                var currentItem = typeof configure === "function" ? configure(this.props) : {};
	
		                (0, _invariant2.default)((0, _lodash2.default)(currentItem), "Expected configure to return an object. See %s", displayName);
	
		                event.preventDefault();
	
		                var xPos = event.clientX || event.touches && event.touches[0].pageX,
		                    yPos = event.clientY || event.touches && event.touches[0].pageY;
	
		                _store2.default.dispatch({
		                    type: "SET_PARAMS",
		                    data: {
		                        x: xPos,
		                        y: yPos,
		                        currentItem: currentItem,
		                        isVisible: typeof identifier === "function" ? identifier(this.props) : identifier
		                    }
		                });
		            },
		            render: function render() {
		                var _props = this.props;
		                var _props$attributes = _props.attributes;
		                var _props$attributes$cla = _props$attributes.className;
		                var className = _props$attributes$cla === undefined ? "" : _props$attributes$cla;
	
		                var attributes = _objectWithoutProperties(_props$attributes, ["className"]);
	
		                var renderTag = _props.renderTag;
	
		                var props = _objectWithoutProperties(_props, ["attributes", "renderTag"]);
	
		                attributes.className = "react-context-menu-wrapper " + className;
		                attributes.onContextMenu = this.handleContextClick;
		                attributes.onMouseDown = this.handleMouseDown;
		                attributes.onMouseUp = this.handleMouseUp;
		                attributes.onTouchStart = this.handleTouchstart;
		                attributes.onTouchEnd = this.handleTouchEnd;
		                attributes.onMouseOut = this.handleMouseUp;
	
		                return _react2.default.createElement(renderTag, attributes, _react2.default.createElement(Component, props));
		            }
		        });
		    };
		};
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _lodash = __webpack_require__(278);
	
		var _lodash2 = _interopRequireDefault(_lodash);
	
		var _store = __webpack_require__(48);
	
		var _store2 = _interopRequireDefault(_store);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/***/ }),
	/* 353 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _classnames = __webpack_require__(125);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _objectAssign = __webpack_require__(126);
	
		var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
		var _monitor = __webpack_require__(84);
	
		var _monitor2 = _interopRequireDefault(_monitor);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
		var PropTypes = _react2.default.PropTypes;
	
	
		var MenuItem = _react2.default.createClass({
		    displayName: "MenuItem",
		    propTypes: {
		        onClick: PropTypes.func.isRequired,
		        data: PropTypes.object,
		        disabled: PropTypes.bool,
		        preventClose: PropTypes.bool
		    },
		    getDefaultProps: function getDefaultProps() {
		        return {
		            disabled: false,
		            data: {},
		            attributes: {}
		        };
		    },
		    handleClick: function handleClick(event) {
		        var _props = this.props;
		        var disabled = _props.disabled;
		        var onClick = _props.onClick;
		        var data = _props.data;
		        var preventClose = _props.preventClose;
	
	
		        event.preventDefault();
	
		        if (disabled) return;
	
		        (0, _objectAssign2.default)(data, _monitor2.default.getItem());
	
		        if (typeof onClick === "function") {
		            onClick(event, data);
		        }
	
		        if (preventClose) return;
	
		        _monitor2.default.hideMenu();
		    },
		    render: function render() {
		        var _props2 = this.props;
		        var disabled = _props2.disabled;
		        var children = _props2.children;
		        var _props2$attributes = _props2.attributes;
		        var _props2$attributes$cl = _props2$attributes.className;
		        var className = _props2$attributes$cl === undefined ? "" : _props2$attributes$cl;
		        var props = _objectWithoutProperties(_props2$attributes, ["className"]);
		        var menuItemClassNames = "react-context-menu-item " + className;
	
		        var classes = (0, _classnames2.default)({
		            "react-context-menu-link": true,
		            disabled: disabled
		        });
	
		        return _react2.default.createElement(
		            "div",
		            _extends({ className: menuItemClassNames }, props),
		            _react2.default.createElement(
		                "a",
		                { href: "#", className: classes, onClick: this.handleClick },
		                children
		            )
		        );
		    }
		});
	
		exports.default = MenuItem;
	
	/***/ }),
	/* 354 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		exports.default = function () {
		    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		    var action = arguments[1];
	
		    return action.type === "SET_PARAMS" ? (0, _objectAssign2.default)({}, state, action.data) : state;
		};
	
		var _objectAssign = __webpack_require__(126);
	
		var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var defaultState = {
		    x: 0,
		    y: 0,
		    isVisible: false,
		    currentItem: {}
		};
	
	/***/ }),
	/* 355 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _classnames = __webpack_require__(125);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _wrapper = __webpack_require__(356);
	
		var _wrapper2 = _interopRequireDefault(_wrapper);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var menuStyles = {
		    position: "relative",
		    zIndex: "auto"
		};
	
		var SubMenu = _react2.default.createClass({
		    displayName: "SubMenu",
		    propTypes: {
		        title: _react2.default.PropTypes.string.isRequired,
		        disabled: _react2.default.PropTypes.bool,
		        hoverDelay: _react2.default.PropTypes.number
		    },
		    getDefaultProps: function getDefaultProps() {
		        return {
		            hoverDelay: 500
		        };
		    },
		    getInitialState: function getInitialState() {
		        return {
		            visible: false
		        };
		    },
		    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
		        return this.state.isVisible !== nextState.visible;
		    },
		    componentWillUnmount: function componentWillUnmount() {
		        if (this.opentimer) clearTimeout(this.opentimer);
	
		        if (this.closetimer) clearTimeout(this.closetimer);
		    },
		    handleClick: function handleClick(e) {
		        e.preventDefault();
		    },
		    handleMouseEnter: function handleMouseEnter() {
		        var _this = this;
	
		        if (this.closetimer) clearTimeout(this.closetimer);
	
		        if (this.props.disabled || this.state.visible) return;
	
		        this.opentimer = setTimeout(function () {
		            return _this.setState({ visible: true });
		        }, this.props.hoverDelay);
		    },
		    handleMouseLeave: function handleMouseLeave() {
		        var _this2 = this;
	
		        if (this.opentimer) clearTimeout(this.opentimer);
	
		        if (!this.state.visible) return;
	
		        this.closetimer = setTimeout(function () {
		            return _this2.setState({ visible: false });
		        }, this.props.hoverDelay);
		    },
		    render: function render() {
		        var _this3 = this;
	
		        var _props = this.props;
		        var disabled = _props.disabled;
		        var children = _props.children;
		        var title = _props.title;
		        var visible = this.state.visible;
	
	
		        var classes = (0, _classnames2.default)({
		            "react-context-menu-link": true,
		            disabled: disabled,
		            active: visible
		        }),
		            menuClasses = "react-context-menu-item submenu";
	
		        return _react2.default.createElement(
		            "div",
		            { ref: function ref(c) {
		                    return _this3.item = c;
		                }, className: menuClasses, style: menuStyles,
		                onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave },
		            _react2.default.createElement(
		                "a",
		                { href: "#", className: classes, onClick: this.handleClick },
		                title
		            ),
		            _react2.default.createElement(
		                _wrapper2.default,
		                { visible: visible },
		                children
		            )
		        );
		    }
		});
	
		exports.default = SubMenu;
	
	/***/ }),
	/* 356 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var SubMenuWrapper = _react2.default.createClass({
		    displayName: "SubMenuWrapper",
		    propTypes: {
		        visible: _react2.default.PropTypes.bool
		    },
		    getInitialState: function getInitialState() {
		        return {
		            position: {
		                top: true,
		                right: true
		            }
		        };
		    },
		    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		        var _this = this;
	
		        if (nextProps.visible) {
		            var wrapper = window.requestAnimationFrame || setTimeout;
	
		            wrapper(function () {
		                _this.setState(_this.getMenuPosition());
		                _this.forceUpdate();
		            });
		        } else {
		            this.setState(this.getInitialState());
		        }
		    },
		    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		        return this.props.visible !== nextProps.visible;
		    },
		    getMenuPosition: function getMenuPosition() {
		        var _window = window;
		        var innerWidth = _window.innerWidth;
		        var innerHeight = _window.innerHeight;
		        var rect = this.menu.getBoundingClientRect();
		        var position = {};
	
		        if (rect.bottom > innerHeight) {
		            position.bottom = true;
		        } else {
		            position.top = true;
		        }
	
		        if (rect.right > innerWidth) {
		            position.left = true;
		        } else {
		            position.right = true;
		        }
	
		        return { position: position };
		    },
		    getPositionStyles: function getPositionStyles() {
		        var style = {};
		        var position = this.state.position;
	
	
		        if (position.top) style.top = 0;
		        if (position.bottom) style.bottom = 0;
		        if (position.right) style.left = "100%";
		        if (position.left) style.right = "100%";
	
		        return style;
		    },
		    render: function render() {
		        var _this2 = this;
	
		        var _props = this.props;
		        var children = _props.children;
		        var visible = _props.visible;
	
	
		        var style = _extends({
		            display: visible ? "block" : "none",
		            position: "absolute"
		        }, this.getPositionStyles());
	
		        return _react2.default.createElement(
		            "nav",
		            { ref: function ref(c) {
		                    return _this2.menu = c;
		                }, style: style, className: "react-context-menu" },
		            children
		        );
		    }
		});
	
		exports.default = SubMenuWrapper;
	
	/***/ }),
	/* 357 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _union = __webpack_require__(347);
	
		var _union2 = _interopRequireDefault(_union);
	
		var _without = __webpack_require__(123);
	
		var _without2 = _interopRequireDefault(_without);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var EnterLeaveCounter = function () {
		  function EnterLeaveCounter() {
		    _classCallCheck(this, EnterLeaveCounter);
	
		    this.entered = [];
		  }
	
		  _createClass(EnterLeaveCounter, [{
		    key: 'enter',
		    value: function enter(enteringNode) {
		      var previousLength = this.entered.length;
	
		      var isNodeEntered = function isNodeEntered(node) {
		        return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
		      };
	
		      this.entered = (0, _union2.default)(this.entered.filter(isNodeEntered), [enteringNode]);
	
		      return previousLength === 0 && this.entered.length > 0;
		    }
		  }, {
		    key: 'leave',
		    value: function leave(leavingNode) {
		      var previousLength = this.entered.length;
	
		      this.entered = (0, _without2.default)(this.entered.filter(function (node) {
		        return document.documentElement.contains(node);
		      }), leavingNode);
	
		      return previousLength > 0 && this.entered.length === 0;
		    }
		  }, {
		    key: 'reset',
		    value: function reset() {
		      this.entered = [];
		    }
		  }]);
	
		  return EnterLeaveCounter;
		}();
	
		exports.default = EnterLeaveCounter;
	
	/***/ }),
	/* 358 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _defaults = __webpack_require__(340);
	
		var _defaults2 = _interopRequireDefault(_defaults);
	
		var _shallowEqual = __webpack_require__(363);
	
		var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
		var _EnterLeaveCounter = __webpack_require__(357);
	
		var _EnterLeaveCounter2 = _interopRequireDefault(_EnterLeaveCounter);
	
		var _BrowserDetector = __webpack_require__(127);
	
		var _OffsetUtils = __webpack_require__(361);
	
		var _NativeDragSources = __webpack_require__(360);
	
		var _NativeTypes = __webpack_require__(85);
	
		var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var HTML5Backend = function () {
		  function HTML5Backend(manager) {
		    _classCallCheck(this, HTML5Backend);
	
		    this.actions = manager.getActions();
		    this.monitor = manager.getMonitor();
		    this.registry = manager.getRegistry();
		    this.context = manager.getContext();
	
		    this.sourcePreviewNodes = {};
		    this.sourcePreviewNodeOptions = {};
		    this.sourceNodes = {};
		    this.sourceNodeOptions = {};
		    this.enterLeaveCounter = new _EnterLeaveCounter2.default();
	
		    this.dragStartSourceIds = [];
		    this.dropTargetIds = [];
		    this.dragEnterTargetIds = [];
		    this.currentNativeSource = null;
		    this.currentNativeHandle = null;
		    this.currentDragSourceNode = null;
		    this.currentDragSourceNodeOffset = null;
		    this.currentDragSourceNodeOffsetChanged = false;
		    this.altKeyPressed = false;
	
		    this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
		    this.handleTopDragStart = this.handleTopDragStart.bind(this);
		    this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
		    this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
		    this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
		    this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
		    this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
		    this.handleTopDragOver = this.handleTopDragOver.bind(this);
		    this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
		    this.handleTopDrop = this.handleTopDrop.bind(this);
		    this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
		    this.handleSelectStart = this.handleSelectStart.bind(this);
		    this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
		    this.endDragNativeItem = this.endDragNativeItem.bind(this);
		  }
	
		  _createClass(HTML5Backend, [{
		    key: 'setup',
		    value: function setup() {
		      if (this.window === undefined) {
		        return;
		      }
	
		      if (this.window.__isReactDndBackendSetUp) {
		        // eslint-disable-line no-underscore-dangle
		        throw new Error('Cannot have two HTML5 backends at the same time.');
		      }
		      this.window.__isReactDndBackendSetUp = true; // eslint-disable-line no-underscore-dangle
		      this.addEventListeners(this.window);
		    }
		  }, {
		    key: 'teardown',
		    value: function teardown() {
		      if (this.window === undefined) {
		        return;
		      }
	
		      this.window.__isReactDndBackendSetUp = false; // eslint-disable-line no-underscore-dangle
		      this.removeEventListeners(this.window);
		      this.clearCurrentDragSourceNode();
		    }
		  }, {
		    key: 'addEventListeners',
		    value: function addEventListeners(target) {
		      target.addEventListener('dragstart', this.handleTopDragStart);
		      target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
		      target.addEventListener('dragend', this.handleTopDragEndCapture, true);
		      target.addEventListener('dragenter', this.handleTopDragEnter);
		      target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
		      target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
		      target.addEventListener('dragover', this.handleTopDragOver);
		      target.addEventListener('dragover', this.handleTopDragOverCapture, true);
		      target.addEventListener('drop', this.handleTopDrop);
		      target.addEventListener('drop', this.handleTopDropCapture, true);
		    }
		  }, {
		    key: 'removeEventListeners',
		    value: function removeEventListeners(target) {
		      target.removeEventListener('dragstart', this.handleTopDragStart);
		      target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
		      target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
		      target.removeEventListener('dragenter', this.handleTopDragEnter);
		      target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
		      target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
		      target.removeEventListener('dragover', this.handleTopDragOver);
		      target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
		      target.removeEventListener('drop', this.handleTopDrop);
		      target.removeEventListener('drop', this.handleTopDropCapture, true);
		    }
		  }, {
		    key: 'connectDragPreview',
		    value: function connectDragPreview(sourceId, node, options) {
		      var _this = this;
	
		      this.sourcePreviewNodeOptions[sourceId] = options;
		      this.sourcePreviewNodes[sourceId] = node;
	
		      return function () {
		        delete _this.sourcePreviewNodes[sourceId];
		        delete _this.sourcePreviewNodeOptions[sourceId];
		      };
		    }
		  }, {
		    key: 'connectDragSource',
		    value: function connectDragSource(sourceId, node, options) {
		      var _this2 = this;
	
		      this.sourceNodes[sourceId] = node;
		      this.sourceNodeOptions[sourceId] = options;
	
		      var handleDragStart = function handleDragStart(e) {
		        return _this2.handleDragStart(e, sourceId);
		      };
		      var handleSelectStart = function handleSelectStart(e) {
		        return _this2.handleSelectStart(e, sourceId);
		      };
	
		      node.setAttribute('draggable', true);
		      node.addEventListener('dragstart', handleDragStart);
		      node.addEventListener('selectstart', handleSelectStart);
	
		      return function () {
		        delete _this2.sourceNodes[sourceId];
		        delete _this2.sourceNodeOptions[sourceId];
	
		        node.removeEventListener('dragstart', handleDragStart);
		        node.removeEventListener('selectstart', handleSelectStart);
		        node.setAttribute('draggable', false);
		      };
		    }
		  }, {
		    key: 'connectDropTarget',
		    value: function connectDropTarget(targetId, node) {
		      var _this3 = this;
	
		      var handleDragEnter = function handleDragEnter(e) {
		        return _this3.handleDragEnter(e, targetId);
		      };
		      var handleDragOver = function handleDragOver(e) {
		        return _this3.handleDragOver(e, targetId);
		      };
		      var handleDrop = function handleDrop(e) {
		        return _this3.handleDrop(e, targetId);
		      };
	
		      node.addEventListener('dragenter', handleDragEnter);
		      node.addEventListener('dragover', handleDragOver);
		      node.addEventListener('drop', handleDrop);
	
		      return function () {
		        node.removeEventListener('dragenter', handleDragEnter);
		        node.removeEventListener('dragover', handleDragOver);
		        node.removeEventListener('drop', handleDrop);
		      };
		    }
		  }, {
		    key: 'getCurrentSourceNodeOptions',
		    value: function getCurrentSourceNodeOptions() {
		      var sourceId = this.monitor.getSourceId();
		      var sourceNodeOptions = this.sourceNodeOptions[sourceId];
	
		      return (0, _defaults2.default)(sourceNodeOptions || {}, {
		        dropEffect: this.altKeyPressed ? 'copy' : 'move'
		      });
		    }
		  }, {
		    key: 'getCurrentDropEffect',
		    value: function getCurrentDropEffect() {
		      if (this.isDraggingNativeItem()) {
		        // It makes more sense to default to 'copy' for native resources
		        return 'copy';
		      }
	
		      return this.getCurrentSourceNodeOptions().dropEffect;
		    }
		  }, {
		    key: 'getCurrentSourcePreviewNodeOptions',
		    value: function getCurrentSourcePreviewNodeOptions() {
		      var sourceId = this.monitor.getSourceId();
		      var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];
	
		      return (0, _defaults2.default)(sourcePreviewNodeOptions || {}, {
		        anchorX: 0.5,
		        anchorY: 0.5,
		        captureDraggingState: false
		      });
		    }
		  }, {
		    key: 'getSourceClientOffset',
		    value: function getSourceClientOffset(sourceId) {
		      return (0, _OffsetUtils.getNodeClientOffset)(this.sourceNodes[sourceId]);
		    }
		  }, {
		    key: 'isDraggingNativeItem',
		    value: function isDraggingNativeItem() {
		      var itemType = this.monitor.getItemType();
		      return Object.keys(NativeTypes).some(function (key) {
		        return NativeTypes[key] === itemType;
		      });
		    }
		  }, {
		    key: 'beginDragNativeItem',
		    value: function beginDragNativeItem(type) {
		      this.clearCurrentDragSourceNode();
	
		      var SourceType = (0, _NativeDragSources.createNativeDragSource)(type);
		      this.currentNativeSource = new SourceType();
		      this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
		      this.actions.beginDrag([this.currentNativeHandle]);
	
		      // On Firefox, if mousemove fires, the drag is over but browser failed to tell us.
		      // This is not true for other browsers.
		      if ((0, _BrowserDetector.isFirefox)()) {
		        this.window.addEventListener('mousemove', this.endDragNativeItem, true);
		      }
		    }
		  }, {
		    key: 'endDragNativeItem',
		    value: function endDragNativeItem() {
		      if (!this.isDraggingNativeItem()) {
		        return;
		      }
	
		      if ((0, _BrowserDetector.isFirefox)()) {
		        this.window.removeEventListener('mousemove', this.endDragNativeItem, true);
		      }
	
		      this.actions.endDrag();
		      this.registry.removeSource(this.currentNativeHandle);
		      this.currentNativeHandle = null;
		      this.currentNativeSource = null;
		    }
		  }, {
		    key: 'endDragIfSourceWasRemovedFromDOM',
		    value: function endDragIfSourceWasRemovedFromDOM() {
		      var node = this.currentDragSourceNode;
		      if (document.body.contains(node)) {
		        return;
		      }
	
		      if (this.clearCurrentDragSourceNode()) {
		        this.actions.endDrag();
		      }
		    }
		  }, {
		    key: 'setCurrentDragSourceNode',
		    value: function setCurrentDragSourceNode(node) {
		      this.clearCurrentDragSourceNode();
		      this.currentDragSourceNode = node;
		      this.currentDragSourceNodeOffset = (0, _OffsetUtils.getNodeClientOffset)(node);
		      this.currentDragSourceNodeOffsetChanged = false;
	
		      // Receiving a mouse event in the middle of a dragging operation
		      // means it has ended and the drag source node disappeared from DOM,
		      // so the browser didn't dispatch the dragend event.
		      this.window.addEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
		    }
		  }, {
		    key: 'clearCurrentDragSourceNode',
		    value: function clearCurrentDragSourceNode() {
		      if (this.currentDragSourceNode) {
		        this.currentDragSourceNode = null;
		        this.currentDragSourceNodeOffset = null;
		        this.currentDragSourceNodeOffsetChanged = false;
		        this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
		        return true;
		      }
	
		      return false;
		    }
		  }, {
		    key: 'checkIfCurrentDragSourceRectChanged',
		    value: function checkIfCurrentDragSourceRectChanged() {
		      var node = this.currentDragSourceNode;
		      if (!node) {
		        return false;
		      }
	
		      if (this.currentDragSourceNodeOffsetChanged) {
		        return true;
		      }
	
		      this.currentDragSourceNodeOffsetChanged = !(0, _shallowEqual2.default)((0, _OffsetUtils.getNodeClientOffset)(node), this.currentDragSourceNodeOffset);
	
		      return this.currentDragSourceNodeOffsetChanged;
		    }
		  }, {
		    key: 'handleTopDragStartCapture',
		    value: function handleTopDragStartCapture() {
		      this.clearCurrentDragSourceNode();
		      this.dragStartSourceIds = [];
		    }
		  }, {
		    key: 'handleDragStart',
		    value: function handleDragStart(e, sourceId) {
		      this.dragStartSourceIds.unshift(sourceId);
		    }
		  }, {
		    key: 'handleTopDragStart',
		    value: function handleTopDragStart(e) {
		      var _this4 = this;
	
		      var dragStartSourceIds = this.dragStartSourceIds;
	
		      this.dragStartSourceIds = null;
	
		      var clientOffset = (0, _OffsetUtils.getEventClientOffset)(e);
	
		      // Don't publish the source just yet (see why below)
		      this.actions.beginDrag(dragStartSourceIds, {
		        publishSource: false,
		        getSourceClientOffset: this.getSourceClientOffset,
		        clientOffset: clientOffset
		      });
	
		      var dataTransfer = e.dataTransfer;
	
		      var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
		      if (this.monitor.isDragging()) {
		        if (typeof dataTransfer.setDragImage === 'function') {
		          // Use custom drag image if user specifies it.
		          // If child drag source refuses drag but parent agrees,
		          // use parent's node as drag image. Neither works in IE though.
		          var sourceId = this.monitor.getSourceId();
		          var sourceNode = this.sourceNodes[sourceId];
		          var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;
	
		          var _getCurrentSourcePrev = this.getCurrentSourcePreviewNodeOptions(),
		              anchorX = _getCurrentSourcePrev.anchorX,
		              anchorY = _getCurrentSourcePrev.anchorY;
	
		          var anchorPoint = { anchorX: anchorX, anchorY: anchorY };
		          var dragPreviewOffset = (0, _OffsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint);
		          dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
		        }
	
		        try {
		          // Firefox won't drag without setting data
		          dataTransfer.setData('application/json', {});
		        } catch (err) {}
		        // IE doesn't support MIME types in setData
	
	
		        // Store drag source node so we can check whether
		        // it is removed from DOM and trigger endDrag manually.
		        this.setCurrentDragSourceNode(e.target);
	
		        // Now we are ready to publish the drag source.. or are we not?
	
		        var _getCurrentSourcePrev2 = this.getCurrentSourcePreviewNodeOptions(),
		            captureDraggingState = _getCurrentSourcePrev2.captureDraggingState;
	
		        if (!captureDraggingState) {
		          // Usually we want to publish it in the next tick so that browser
		          // is able to screenshot the current (not yet dragging) state.
		          //
		          // It also neatly avoids a situation where render() returns null
		          // in the same tick for the source element, and browser freaks out.
		          setTimeout(function () {
		            return _this4.actions.publishDragSource();
		          });
		        } else {
		          // In some cases the user may want to override this behavior, e.g.
		          // to work around IE not supporting custom drag previews.
		          //
		          // When using a custom drag layer, the only way to prevent
		          // the default drag preview from drawing in IE is to screenshot
		          // the dragging state in which the node itself has zero opacity
		          // and height. In this case, though, returning null from render()
		          // will abruptly end the dragging, which is not obvious.
		          //
		          // This is the reason such behavior is strictly opt-in.
		          this.actions.publishDragSource();
		        }
		      } else if (nativeType) {
		        // A native item (such as URL) dragged from inside the document
		        this.beginDragNativeItem(nativeType);
		      } else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
		        // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
		        // Just let it drag. It's a native type (URL or text) and will be picked up in
		        // dragenter handler.
		        return; // eslint-disable-line no-useless-return
		      } else {
		        // If by this time no drag source reacted, tell browser not to drag.
		        e.preventDefault();
		      }
		    }
		  }, {
		    key: 'handleTopDragEndCapture',
		    value: function handleTopDragEndCapture() {
		      if (this.clearCurrentDragSourceNode()) {
		        // Firefox can dispatch this event in an infinite loop
		        // if dragend handler does something like showing an alert.
		        // Only proceed if we have not handled it already.
		        this.actions.endDrag();
		      }
		    }
		  }, {
		    key: 'handleTopDragEnterCapture',
		    value: function handleTopDragEnterCapture(e) {
		      this.dragEnterTargetIds = [];
	
		      var isFirstEnter = this.enterLeaveCounter.enter(e.target);
		      if (!isFirstEnter || this.monitor.isDragging()) {
		        return;
		      }
	
		      var dataTransfer = e.dataTransfer;
	
		      var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
		      if (nativeType) {
		        // A native item (such as file or URL) dragged from outside the document
		        this.beginDragNativeItem(nativeType);
		      }
		    }
		  }, {
		    key: 'handleDragEnter',
		    value: function handleDragEnter(e, targetId) {
		      this.dragEnterTargetIds.unshift(targetId);
		    }
		  }, {
		    key: 'handleTopDragEnter',
		    value: function handleTopDragEnter(e) {
		      var _this5 = this;
	
		      var dragEnterTargetIds = this.dragEnterTargetIds;
	
		      this.dragEnterTargetIds = [];
	
		      if (!this.monitor.isDragging()) {
		        // This is probably a native item type we don't understand.
		        return;
		      }
	
		      this.altKeyPressed = e.altKey;
	
		      if (!(0, _BrowserDetector.isFirefox)()) {
		        // Don't emit hover in `dragenter` on Firefox due to an edge case.
		        // If the target changes position as the result of `dragenter`, Firefox
		        // will still happily dispatch `dragover` despite target being no longer
		        // there. The easy solution is to only fire `hover` in `dragover` on FF.
		        this.actions.hover(dragEnterTargetIds, {
		          clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
		        });
		      }
	
		      var canDrop = dragEnterTargetIds.some(function (targetId) {
		        return _this5.monitor.canDropOnTarget(targetId);
		      });
	
		      if (canDrop) {
		        // IE requires this to fire dragover events
		        e.preventDefault();
		        e.dataTransfer.dropEffect = this.getCurrentDropEffect();
		      }
		    }
		  }, {
		    key: 'handleTopDragOverCapture',
		    value: function handleTopDragOverCapture() {
		      this.dragOverTargetIds = [];
		    }
		  }, {
		    key: 'handleDragOver',
		    value: function handleDragOver(e, targetId) {
		      this.dragOverTargetIds.unshift(targetId);
		    }
		  }, {
		    key: 'handleTopDragOver',
		    value: function handleTopDragOver(e) {
		      var _this6 = this;
	
		      var dragOverTargetIds = this.dragOverTargetIds;
	
		      this.dragOverTargetIds = [];
	
		      if (!this.monitor.isDragging()) {
		        // This is probably a native item type we don't understand.
		        // Prevent default "drop and blow away the whole document" action.
		        e.preventDefault();
		        e.dataTransfer.dropEffect = 'none';
		        return;
		      }
	
		      this.altKeyPressed = e.altKey;
	
		      this.actions.hover(dragOverTargetIds, {
		        clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
		      });
	
		      var canDrop = dragOverTargetIds.some(function (targetId) {
		        return _this6.monitor.canDropOnTarget(targetId);
		      });
	
		      if (canDrop) {
		        // Show user-specified drop effect.
		        e.preventDefault();
		        e.dataTransfer.dropEffect = this.getCurrentDropEffect();
		      } else if (this.isDraggingNativeItem()) {
		        // Don't show a nice cursor but still prevent default
		        // "drop and blow away the whole document" action.
		        e.preventDefault();
		        e.dataTransfer.dropEffect = 'none';
		      } else if (this.checkIfCurrentDragSourceRectChanged()) {
		        // Prevent animating to incorrect position.
		        // Drop effect must be other than 'none' to prevent animation.
		        e.preventDefault();
		        e.dataTransfer.dropEffect = 'move';
		      }
		    }
		  }, {
		    key: 'handleTopDragLeaveCapture',
		    value: function handleTopDragLeaveCapture(e) {
		      if (this.isDraggingNativeItem()) {
		        e.preventDefault();
		      }
	
		      var isLastLeave = this.enterLeaveCounter.leave(e.target);
		      if (!isLastLeave) {
		        return;
		      }
	
		      if (this.isDraggingNativeItem()) {
		        this.endDragNativeItem();
		      }
		    }
		  }, {
		    key: 'handleTopDropCapture',
		    value: function handleTopDropCapture(e) {
		      this.dropTargetIds = [];
		      e.preventDefault();
	
		      if (this.isDraggingNativeItem()) {
		        this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
		      }
	
		      this.enterLeaveCounter.reset();
		    }
		  }, {
		    key: 'handleDrop',
		    value: function handleDrop(e, targetId) {
		      this.dropTargetIds.unshift(targetId);
		    }
		  }, {
		    key: 'handleTopDrop',
		    value: function handleTopDrop(e) {
		      var dropTargetIds = this.dropTargetIds;
	
		      this.dropTargetIds = [];
	
		      this.actions.hover(dropTargetIds, {
		        clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
		      });
		      this.actions.drop({ dropEffect: this.getCurrentDropEffect() });
	
		      if (this.isDraggingNativeItem()) {
		        this.endDragNativeItem();
		      } else {
		        this.endDragIfSourceWasRemovedFromDOM();
		      }
		    }
		  }, {
		    key: 'handleSelectStart',
		    value: function handleSelectStart(e) {
		      var target = e.target;
	
		      // Only IE requires us to explicitly say
		      // we want drag drop operation to start
	
		      if (typeof target.dragDrop !== 'function') {
		        return;
		      }
	
		      // Inputs and textareas should be selectable
		      if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
		        return;
		      }
	
		      // For other targets, ask IE
		      // to enable drag and drop
		      e.preventDefault();
		      target.dragDrop();
		    }
		  }, {
		    key: 'window',
		    get: function get() {
		      if (this.context && this.context.window) {
		        return this.context.window;
		      } else if (typeof window !== 'undefined') {
		        return window;
		      }
		      return undefined;
		    }
		  }]);
	
		  return HTML5Backend;
		}();
	
		exports.default = HTML5Backend;
	
	/***/ }),
	/* 359 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		/* eslint
		   no-plusplus: off,
		   no-mixed-operators: off
		*/
		var MonotonicInterpolant = function () {
		  function MonotonicInterpolant(xs, ys) {
		    _classCallCheck(this, MonotonicInterpolant);
	
		    var length = xs.length;
	
		    // Rearrange xs and ys so that xs is sorted
		    var indexes = [];
		    for (var i = 0; i < length; i++) {
		      indexes.push(i);
		    }
		    indexes.sort(function (a, b) {
		      return xs[a] < xs[b] ? -1 : 1;
		    });
	
		    // Get consecutive differences and slopes
		    var dys = [];
		    var dxs = [];
		    var ms = [];
		    var dx = void 0;
		    var dy = void 0;
		    for (var _i = 0; _i < length - 1; _i++) {
		      dx = xs[_i + 1] - xs[_i];
		      dy = ys[_i + 1] - ys[_i];
		      dxs.push(dx);
		      dys.push(dy);
		      ms.push(dy / dx);
		    }
	
		    // Get degree-1 coefficients
		    var c1s = [ms[0]];
		    for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
		      var _m = ms[_i2];
		      var mNext = ms[_i2 + 1];
		      if (_m * mNext <= 0) {
		        c1s.push(0);
		      } else {
		        dx = dxs[_i2];
		        var dxNext = dxs[_i2 + 1];
		        var common = dx + dxNext;
		        c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
		      }
		    }
		    c1s.push(ms[ms.length - 1]);
	
		    // Get degree-2 and degree-3 coefficients
		    var c2s = [];
		    var c3s = [];
		    var m = void 0;
		    for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
		      m = ms[_i3];
		      var c1 = c1s[_i3];
		      var invDx = 1 / dxs[_i3];
		      var _common = c1 + c1s[_i3 + 1] - m - m;
		      c2s.push((m - c1 - _common) * invDx);
		      c3s.push(_common * invDx * invDx);
		    }
	
		    this.xs = xs;
		    this.ys = ys;
		    this.c1s = c1s;
		    this.c2s = c2s;
		    this.c3s = c3s;
		  }
	
		  _createClass(MonotonicInterpolant, [{
		    key: "interpolate",
		    value: function interpolate(x) {
		      var xs = this.xs,
		          ys = this.ys,
		          c1s = this.c1s,
		          c2s = this.c2s,
		          c3s = this.c3s;
	
		      // The rightmost point in the dataset should give an exact result
	
		      var i = xs.length - 1;
		      if (x === xs[i]) {
		        return ys[i];
		      }
	
		      // Search for the interval x is in, returning the corresponding y if x is one of the original xs
		      var low = 0;
		      var high = c3s.length - 1;
		      var mid = void 0;
		      while (low <= high) {
		        mid = Math.floor(0.5 * (low + high));
		        var xHere = xs[mid];
		        if (xHere < x) {
		          low = mid + 1;
		        } else if (xHere > x) {
		          high = mid - 1;
		        } else {
		          return ys[mid];
		        }
		      }
		      i = Math.max(0, high);
	
		      // Interpolate
		      var diff = x - xs[i];
		      var diffSq = diff * diff;
		      return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
		    }
		  }]);
	
		  return MonotonicInterpolant;
		}();
	
		exports.default = MonotonicInterpolant;
	
	/***/ }),
	/* 360 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _nativeTypesConfig;
	
		exports.createNativeDragSource = createNativeDragSource;
		exports.matchNativeItemType = matchNativeItemType;
	
		var _NativeTypes = __webpack_require__(85);
	
		var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
		function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
		  var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
		    return resultSoFar || dataTransfer.getData(typeToTry);
		  }, null);
	
		  return result != null ? // eslint-disable-line eqeqeq
		  result : defaultValue;
		}
	
		var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
		  exposeProperty: 'files',
		  matchesTypes: ['Files'],
		  getData: function getData(dataTransfer) {
		    return Array.prototype.slice.call(dataTransfer.files);
		  }
		}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
		  exposeProperty: 'urls',
		  matchesTypes: ['Url', 'text/uri-list'],
		  getData: function getData(dataTransfer, matchesTypes) {
		    return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
		  }
		}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
		  exposeProperty: 'text',
		  matchesTypes: ['Text', 'text/plain'],
		  getData: function getData(dataTransfer, matchesTypes) {
		    return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
		  }
		}), _nativeTypesConfig);
	
		function createNativeDragSource(type) {
		  var _nativeTypesConfig$ty = nativeTypesConfig[type],
		      exposeProperty = _nativeTypesConfig$ty.exposeProperty,
		      matchesTypes = _nativeTypesConfig$ty.matchesTypes,
		      getData = _nativeTypesConfig$ty.getData;
	
	
		  return function () {
		    function NativeDragSource() {
		      var _item, _mutatorMap;
	
		      _classCallCheck(this, NativeDragSource);
	
		      this.item = (_item = {}, _mutatorMap = {}, _mutatorMap[exposeProperty] = _mutatorMap[exposeProperty] || {}, _mutatorMap[exposeProperty].get = function () {
		        console.warn( // eslint-disable-line no-console
		        'Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
		        return null;
		      }, _defineEnumerableProperties(_item, _mutatorMap), _item);
		    }
	
		    _createClass(NativeDragSource, [{
		      key: 'mutateItemByReadingDataTransfer',
		      value: function mutateItemByReadingDataTransfer(dataTransfer) {
		        delete this.item[exposeProperty];
		        this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
		      }
		    }, {
		      key: 'canDrag',
		      value: function canDrag() {
		        return true;
		      }
		    }, {
		      key: 'beginDrag',
		      value: function beginDrag() {
		        return this.item;
		      }
		    }, {
		      key: 'isDragging',
		      value: function isDragging(monitor, handle) {
		        return handle === monitor.getSourceId();
		      }
		    }, {
		      key: 'endDrag',
		      value: function endDrag() {}
		    }]);
	
		    return NativeDragSource;
		  }();
		}
	
		function matchNativeItemType(dataTransfer) {
		  var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
	
		  return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
		    var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
	
		    return matchesTypes.some(function (t) {
		      return dataTransferTypes.indexOf(t) > -1;
		    });
		  })[0] || null;
		}
	
	/***/ }),
	/* 361 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.getNodeClientOffset = getNodeClientOffset;
		exports.getEventClientOffset = getEventClientOffset;
		exports.getDragPreviewOffset = getDragPreviewOffset;
	
		var _BrowserDetector = __webpack_require__(127);
	
		var _MonotonicInterpolant = __webpack_require__(359);
	
		var _MonotonicInterpolant2 = _interopRequireDefault(_MonotonicInterpolant);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* eslint
		   no-mixed-operators: off
		*/
		var ELEMENT_NODE = 1;
	
		function getNodeClientOffset(node) {
		  var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
	
		  if (!el) {
		    return null;
		  }
	
		  var _el$getBoundingClient = el.getBoundingClientRect(),
		      top = _el$getBoundingClient.top,
		      left = _el$getBoundingClient.left;
	
		  return { x: left, y: top };
		}
	
		function getEventClientOffset(e) {
		  return {
		    x: e.clientX,
		    y: e.clientY
		  };
		}
	
		function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint) {
		  // The browsers will use the image intrinsic size under different conditions.
		  // Firefox only cares if it's an image, but WebKit also wants it to be detached.
		  var isImage = dragPreview.nodeName === 'IMG' && ((0, _BrowserDetector.isFirefox)() || !document.documentElement.contains(dragPreview));
		  var dragPreviewNode = isImage ? sourceNode : dragPreview;
	
		  var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
		  var offsetFromDragPreview = {
		    x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
		    y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
		  };
	
		  var sourceWidth = sourceNode.offsetWidth,
		      sourceHeight = sourceNode.offsetHeight;
		  var anchorX = anchorPoint.anchorX,
		      anchorY = anchorPoint.anchorY;
	
	
		  var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
		  var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
	
		  // Work around @2x coordinate discrepancies in browsers
		  if ((0, _BrowserDetector.isSafari)() && isImage) {
		    dragPreviewHeight /= window.devicePixelRatio;
		    dragPreviewWidth /= window.devicePixelRatio;
		  } else if ((0, _BrowserDetector.isFirefox)() && !isImage) {
		    dragPreviewHeight *= window.devicePixelRatio;
		    dragPreviewWidth *= window.devicePixelRatio;
		  }
	
		  // Interpolate coordinates depending on anchor point
		  // If you know a simpler way to do this, let me know
		  var interpolantX = new _MonotonicInterpolant2.default([0, 0.5, 1], [
		  // Dock to the left
		  offsetFromDragPreview.x,
		  // Align at the center
		  offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
		  // Dock to the right
		  offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
		  var interpolantY = new _MonotonicInterpolant2.default([0, 0.5, 1], [
		  // Dock to the top
		  offsetFromDragPreview.y,
		  // Align at the center
		  offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
		  // Dock to the bottom
		  offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
		  var x = interpolantX.interpolate(anchorX);
		  var y = interpolantY.interpolate(anchorY);
	
		  // Work around Safari 8 positioning bug
		  if ((0, _BrowserDetector.isSafari)() && isImage) {
		    // We'll have to wait for @3x to see if this is entirely correct
		    y += (window.devicePixelRatio - 1) * dragPreviewHeight;
		  }
	
		  return { x: x, y: y };
		}
	
	/***/ }),
	/* 362 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = getEmptyImage;
		var emptyImage = void 0;
		function getEmptyImage() {
		  if (!emptyImage) {
		    emptyImage = new Image();
		    emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
		  }
	
		  return emptyImage;
		}
	
	/***/ }),
	/* 363 */
	86,
	/* 364 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = undefined;
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _class, _temp;
	
		var _react = __webpack_require__(2);
	
		var _DragDropContext = __webpack_require__(129);
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		/**
		 * This class is a React-Component based version of the DragDropContext.
		 * This is an alternative to decorating an application component with an ES7 decorator.
		 */
		var DragDropContextProvider = (_temp = _class = function (_Component) {
		  _inherits(DragDropContextProvider, _Component);
	
		  function DragDropContextProvider(props, context) {
		    _classCallCheck(this, DragDropContextProvider);
	
		    var _this = _possibleConstructorReturn(this, (DragDropContextProvider.__proto__ || Object.getPrototypeOf(DragDropContextProvider)).call(this, props, context));
	
		    _this.backend = (0, _DragDropContext.unpackBackendForEs5Users)(props.backend);
		    return _this;
		  }
	
		  _createClass(DragDropContextProvider, [{
		    key: 'getChildContext',
		    value: function getChildContext() {
		      var _this2 = this;
	
		      /**
		       * This property determines which window global to use for creating the DragDropManager.
		       * If a window has been injected explicitly via props, that is used first. If it is available
		       * as a context value, then use that, otherwise use the browser global.
		       */
		      var getWindow = function getWindow() {
		        if (_this2.props && _this2.props.window) {
		          return _this2.props.window;
		        } else if (_this2.context && _this2.context.window) {
		          return _this2.context.window;
		        } else if (typeof window !== 'undefined') {
		          return window;
		        }
		        return undefined;
		      };
	
		      return (0, _DragDropContext.createChildContext)(this.backend, { window: getWindow() });
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      return _react.Children.only(this.props.children);
		    }
		  }]);
	
		  return DragDropContextProvider;
		}(_react.Component), _class.propTypes = {
		  backend: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object]).isRequired,
		  children: _react.PropTypes.element.isRequired,
		  window: _react.PropTypes.object }, _class.defaultProps = {
		  window: undefined
		}, _class.childContextTypes = _DragDropContext.CHILD_CONTEXT_TYPES, _class.displayName = 'DragDropContextProvider', _class.contextTypes = {
		  window: _react.PropTypes.object
		}, _temp);
		exports.default = DragDropContextProvider;
	
	/***/ }),
	/* 365 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = DragLayer;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _hoistNonReactStatics = __webpack_require__(75);
	
		var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _shallowEqual = __webpack_require__(86);
	
		var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
		var _shallowEqualScalar = __webpack_require__(133);
	
		var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
	
		var _checkDecoratorArguments = __webpack_require__(49);
	
		var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		function DragLayer(collect) {
		  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		  _checkDecoratorArguments2.default.apply(undefined, ['DragLayer', 'collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
		  (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer ' + 'to be a function that collects props to inject into the component. ', 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
		  (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the second argument to DragLayer to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);
	
		  return function decorateLayer(DecoratedComponent) {
		    var _class, _temp;
	
		    var _options$arePropsEqua = options.arePropsEqual,
		        arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
	
		    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
		    var DragLayerContainer = (_temp = _class = function (_Component) {
		      _inherits(DragLayerContainer, _Component);
	
		      _createClass(DragLayerContainer, [{
		        key: 'getDecoratedComponentInstance',
		        value: function getDecoratedComponentInstance() {
		          (0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can ' + 'not be a stateless component.');
		          return this.child;
		        }
		      }, {
		        key: 'shouldComponentUpdate',
		        value: function shouldComponentUpdate(nextProps, nextState) {
		          return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
		        }
		      }]);
	
		      function DragLayerContainer(props, context) {
		        _classCallCheck(this, DragLayerContainer);
	
		        var _this = _possibleConstructorReturn(this, (DragLayerContainer.__proto__ || Object.getPrototypeOf(DragLayerContainer)).call(this, props));
	
		        _this.handleChange = _this.handleChange.bind(_this);
	
		        _this.manager = context.dragDropManager;
		        (0, _invariant2.default)(_typeof(_this.manager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
		        _this.state = _this.getCurrentState();
		        return _this;
		      }
	
		      _createClass(DragLayerContainer, [{
		        key: 'componentDidMount',
		        value: function componentDidMount() {
		          this.isCurrentlyMounted = true;
	
		          var monitor = this.manager.getMonitor();
		          this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
		          this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
	
		          this.handleChange();
		        }
		      }, {
		        key: 'componentWillUnmount',
		        value: function componentWillUnmount() {
		          this.isCurrentlyMounted = false;
	
		          this.unsubscribeFromOffsetChange();
		          this.unsubscribeFromStateChange();
		        }
		      }, {
		        key: 'handleChange',
		        value: function handleChange() {
		          if (!this.isCurrentlyMounted) {
		            return;
		          }
	
		          var nextState = this.getCurrentState();
		          if (!(0, _shallowEqual2.default)(nextState, this.state)) {
		            this.setState(nextState);
		          }
		        }
		      }, {
		        key: 'getCurrentState',
		        value: function getCurrentState() {
		          var monitor = this.manager.getMonitor();
		          return collect(monitor);
		        }
		      }, {
		        key: 'render',
		        value: function render() {
		          var _this2 = this;
	
		          return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
		            ref: function ref(child) {
		              return _this2.child = child;
		            }
		          }));
		        }
		      }]);
	
		      return DragLayerContainer;
		    }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragLayer(' + displayName + ')', _class.contextTypes = {
		      dragDropManager: _react.PropTypes.object.isRequired
		    }, _temp);
	
	
		    return (0, _hoistNonReactStatics2.default)(DragLayerContainer, DecoratedComponent);
		  };
		}
	
	/***/ }),
	/* 366 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = DragSource;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		var _checkDecoratorArguments = __webpack_require__(49);
	
		var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
		var _decorateHandler = __webpack_require__(131);
	
		var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
		var _registerSource = __webpack_require__(374);
	
		var _registerSource2 = _interopRequireDefault(_registerSource);
	
		var _createSourceFactory = __webpack_require__(369);
	
		var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);
	
		var _createSourceMonitor = __webpack_require__(370);
	
		var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);
	
		var _createSourceConnector = __webpack_require__(368);
	
		var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);
	
		var _isValidType = __webpack_require__(132);
	
		var _isValidType2 = _interopRequireDefault(_isValidType);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function DragSource(type, spec, collect) {
		  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
		  _checkDecoratorArguments2.default.apply(undefined, ['DragSource', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
		  var getType = type;
		  if (typeof type !== 'function') {
		    (0, _invariant2.default)((0, _isValidType2.default)(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);
		    getType = function getType() {
		      return type;
		    };
		  }
		  (0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
		  var createSource = (0, _createSourceFactory2.default)(spec);
		  (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
		  (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
	
		  return function decorateSource(DecoratedComponent) {
		    return (0, _decorateHandler2.default)({
		      connectBackend: function connectBackend(backend, sourceId) {
		        return backend.connectDragSource(sourceId);
		      },
		      containerDisplayName: 'DragSource',
		      createHandler: createSource,
		      registerHandler: _registerSource2.default,
		      createMonitor: _createSourceMonitor2.default,
		      createConnector: _createSourceConnector2.default,
		      DecoratedComponent: DecoratedComponent,
		      getType: getType,
		      collect: collect,
		      options: options
		    });
		  };
		}
	
	/***/ }),
	/* 367 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = DropTarget;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		var _checkDecoratorArguments = __webpack_require__(49);
	
		var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
		var _decorateHandler = __webpack_require__(131);
	
		var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
		var _registerTarget = __webpack_require__(375);
	
		var _registerTarget2 = _interopRequireDefault(_registerTarget);
	
		var _createTargetFactory = __webpack_require__(372);
	
		var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);
	
		var _createTargetMonitor = __webpack_require__(373);
	
		var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);
	
		var _createTargetConnector = __webpack_require__(371);
	
		var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);
	
		var _isValidType = __webpack_require__(132);
	
		var _isValidType2 = _interopRequireDefault(_isValidType);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function DropTarget(type, spec, collect) {
		  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
		  _checkDecoratorArguments2.default.apply(undefined, ['DropTarget', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
		  var getType = type;
		  if (typeof type !== 'function') {
		    (0, _invariant2.default)((0, _isValidType2.default)(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);
		    getType = function getType() {
		      return type;
		    };
		  }
		  (0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
		  var createTarget = (0, _createTargetFactory2.default)(spec);
		  (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
		  (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
	
		  return function decorateTarget(DecoratedComponent) {
		    return (0, _decorateHandler2.default)({
		      connectBackend: function connectBackend(backend, targetId) {
		        return backend.connectDropTarget(targetId);
		      },
		      containerDisplayName: 'DropTarget',
		      createHandler: createTarget,
		      registerHandler: _registerTarget2.default,
		      createMonitor: _createTargetMonitor2.default,
		      createConnector: _createTargetConnector2.default,
		      DecoratedComponent: DecoratedComponent,
		      getType: getType,
		      collect: collect,
		      options: options
		    });
		  };
		}
	
	/***/ }),
	/* 368 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = createSourceConnector;
	
		var _wrapConnectorHooks = __webpack_require__(134);
	
		var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
	
		var _areOptionsEqual = __webpack_require__(130);
	
		var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function createSourceConnector(backend) {
		  var currentHandlerId = void 0;
	
		  var currentDragSourceNode = void 0;
		  var currentDragSourceOptions = void 0;
		  var disconnectCurrentDragSource = void 0;
	
		  var currentDragPreviewNode = void 0;
		  var currentDragPreviewOptions = void 0;
		  var disconnectCurrentDragPreview = void 0;
	
		  function reconnectDragSource() {
		    if (disconnectCurrentDragSource) {
		      disconnectCurrentDragSource();
		      disconnectCurrentDragSource = null;
		    }
	
		    if (currentHandlerId && currentDragSourceNode) {
		      disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
		    }
		  }
	
		  function reconnectDragPreview() {
		    if (disconnectCurrentDragPreview) {
		      disconnectCurrentDragPreview();
		      disconnectCurrentDragPreview = null;
		    }
	
		    if (currentHandlerId && currentDragPreviewNode) {
		      disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
		    }
		  }
	
		  function receiveHandlerId(handlerId) {
		    if (handlerId === currentHandlerId) {
		      return;
		    }
	
		    currentHandlerId = handlerId;
		    reconnectDragSource();
		    reconnectDragPreview();
		  }
	
		  var hooks = (0, _wrapConnectorHooks2.default)({
		    dragSource: function connectDragSource(node, options) {
		      if (node === currentDragSourceNode && (0, _areOptionsEqual2.default)(options, currentDragSourceOptions)) {
		        return;
		      }
	
		      currentDragSourceNode = node;
		      currentDragSourceOptions = options;
	
		      reconnectDragSource();
		    },
	
		    dragPreview: function connectDragPreview(node, options) {
		      if (node === currentDragPreviewNode && (0, _areOptionsEqual2.default)(options, currentDragPreviewOptions)) {
		        return;
		      }
	
		      currentDragPreviewNode = node;
		      currentDragPreviewOptions = options;
	
		      reconnectDragPreview();
		    }
		  });
	
		  return {
		    receiveHandlerId: receiveHandlerId,
		    hooks: hooks
		  };
		}
	
	/***/ }),
	/* 369 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = createSourceFactory;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
		var REQUIRED_SPEC_METHODS = ['beginDrag'];
	
		function createSourceFactory(spec) {
		  Object.keys(spec).forEach(function (key) {
		    (0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
		    (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
		  });
		  REQUIRED_SPEC_METHODS.forEach(function (key) {
		    (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
		  });
	
		  var Source = function () {
		    function Source(monitor) {
		      _classCallCheck(this, Source);
	
		      this.monitor = monitor;
		      this.props = null;
		      this.component = null;
		    }
	
		    _createClass(Source, [{
		      key: 'receiveProps',
		      value: function receiveProps(props) {
		        this.props = props;
		      }
		    }, {
		      key: 'receiveComponent',
		      value: function receiveComponent(component) {
		        this.component = component;
		      }
		    }, {
		      key: 'canDrag',
		      value: function canDrag() {
		        if (!spec.canDrag) {
		          return true;
		        }
	
		        return spec.canDrag(this.props, this.monitor);
		      }
		    }, {
		      key: 'isDragging',
		      value: function isDragging(globalMonitor, sourceId) {
		        if (!spec.isDragging) {
		          return sourceId === globalMonitor.getSourceId();
		        }
	
		        return spec.isDragging(this.props, this.monitor);
		      }
		    }, {
		      key: 'beginDrag',
		      value: function beginDrag() {
		        var item = spec.beginDrag(this.props, this.monitor, this.component);
		        if (false) {
		          (0, _invariant2.default)((0, _isPlainObject2.default)(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', item);
		        }
		        return item;
		      }
		    }, {
		      key: 'endDrag',
		      value: function endDrag() {
		        if (!spec.endDrag) {
		          return;
		        }
	
		        spec.endDrag(this.props, this.monitor, this.component);
		      }
		    }]);
	
		    return Source;
		  }();
	
		  return function createSource(monitor) {
		    return new Source(monitor);
		  };
		}
	
	/***/ }),
	/* 370 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = createSourceMonitor;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var isCallingCanDrag = false;
		var isCallingIsDragging = false;
	
		var SourceMonitor = function () {
		  function SourceMonitor(manager) {
		    _classCallCheck(this, SourceMonitor);
	
		    this.internalMonitor = manager.getMonitor();
		  }
	
		  _createClass(SourceMonitor, [{
		    key: 'receiveHandlerId',
		    value: function receiveHandlerId(sourceId) {
		      this.sourceId = sourceId;
		    }
		  }, {
		    key: 'canDrag',
		    value: function canDrag() {
		      (0, _invariant2.default)(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
	
		      try {
		        isCallingCanDrag = true;
		        return this.internalMonitor.canDragSource(this.sourceId);
		      } finally {
		        isCallingCanDrag = false;
		      }
		    }
		  }, {
		    key: 'isDragging',
		    value: function isDragging() {
		      (0, _invariant2.default)(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
	
		      try {
		        isCallingIsDragging = true;
		        return this.internalMonitor.isDraggingSource(this.sourceId);
		      } finally {
		        isCallingIsDragging = false;
		      }
		    }
		  }, {
		    key: 'getItemType',
		    value: function getItemType() {
		      return this.internalMonitor.getItemType();
		    }
		  }, {
		    key: 'getItem',
		    value: function getItem() {
		      return this.internalMonitor.getItem();
		    }
		  }, {
		    key: 'getDropResult',
		    value: function getDropResult() {
		      return this.internalMonitor.getDropResult();
		    }
		  }, {
		    key: 'didDrop',
		    value: function didDrop() {
		      return this.internalMonitor.didDrop();
		    }
		  }, {
		    key: 'getInitialClientOffset',
		    value: function getInitialClientOffset() {
		      return this.internalMonitor.getInitialClientOffset();
		    }
		  }, {
		    key: 'getInitialSourceClientOffset',
		    value: function getInitialSourceClientOffset() {
		      return this.internalMonitor.getInitialSourceClientOffset();
		    }
		  }, {
		    key: 'getSourceClientOffset',
		    value: function getSourceClientOffset() {
		      return this.internalMonitor.getSourceClientOffset();
		    }
		  }, {
		    key: 'getClientOffset',
		    value: function getClientOffset() {
		      return this.internalMonitor.getClientOffset();
		    }
		  }, {
		    key: 'getDifferenceFromInitialOffset',
		    value: function getDifferenceFromInitialOffset() {
		      return this.internalMonitor.getDifferenceFromInitialOffset();
		    }
		  }]);
	
		  return SourceMonitor;
		}();
	
		function createSourceMonitor(manager) {
		  return new SourceMonitor(manager);
		}
	
	/***/ }),
	/* 371 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = createTargetConnector;
	
		var _wrapConnectorHooks = __webpack_require__(134);
	
		var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
	
		var _areOptionsEqual = __webpack_require__(130);
	
		var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function createTargetConnector(backend) {
		  var currentHandlerId = void 0;
	
		  var currentDropTargetNode = void 0;
		  var currentDropTargetOptions = void 0;
		  var disconnectCurrentDropTarget = void 0;
	
		  function reconnectDropTarget() {
		    if (disconnectCurrentDropTarget) {
		      disconnectCurrentDropTarget();
		      disconnectCurrentDropTarget = null;
		    }
	
		    if (currentHandlerId && currentDropTargetNode) {
		      disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
		    }
		  }
	
		  function receiveHandlerId(handlerId) {
		    if (handlerId === currentHandlerId) {
		      return;
		    }
	
		    currentHandlerId = handlerId;
		    reconnectDropTarget();
		  }
	
		  var hooks = (0, _wrapConnectorHooks2.default)({
		    dropTarget: function connectDropTarget(node, options) {
		      if (node === currentDropTargetNode && (0, _areOptionsEqual2.default)(options, currentDropTargetOptions)) {
		        return;
		      }
	
		      currentDropTargetNode = node;
		      currentDropTargetOptions = options;
	
		      reconnectDropTarget();
		    }
		  });
	
		  return {
		    receiveHandlerId: receiveHandlerId,
		    hooks: hooks
		  };
		}
	
	/***/ }),
	/* 372 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = createTargetFactory;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];
	
		function createTargetFactory(spec) {
		  Object.keys(spec).forEach(function (key) {
		    (0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
		    (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
		  });
	
		  var Target = function () {
		    function Target(monitor) {
		      _classCallCheck(this, Target);
	
		      this.monitor = monitor;
		      this.props = null;
		      this.component = null;
		    }
	
		    _createClass(Target, [{
		      key: 'receiveProps',
		      value: function receiveProps(props) {
		        this.props = props;
		      }
		    }, {
		      key: 'receiveMonitor',
		      value: function receiveMonitor(monitor) {
		        this.monitor = monitor;
		      }
		    }, {
		      key: 'receiveComponent',
		      value: function receiveComponent(component) {
		        this.component = component;
		      }
		    }, {
		      key: 'canDrop',
		      value: function canDrop() {
		        if (!spec.canDrop) {
		          return true;
		        }
	
		        return spec.canDrop(this.props, this.monitor);
		      }
		    }, {
		      key: 'hover',
		      value: function hover() {
		        if (!spec.hover) {
		          return;
		        }
	
		        spec.hover(this.props, this.monitor, this.component);
		      }
		    }, {
		      key: 'drop',
		      value: function drop() {
		        if (!spec.drop) {
		          return undefined;
		        }
	
		        var dropResult = spec.drop(this.props, this.monitor, this.component);
		        if (false) {
		          (0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isPlainObject2.default)(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', dropResult);
		        }
		        return dropResult;
		      }
		    }]);
	
		    return Target;
		  }();
	
		  return function createTarget(monitor) {
		    return new Target(monitor);
		  };
		}
	
	/***/ }),
	/* 373 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = createTargetMonitor;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var isCallingCanDrop = false;
	
		var TargetMonitor = function () {
		  function TargetMonitor(manager) {
		    _classCallCheck(this, TargetMonitor);
	
		    this.internalMonitor = manager.getMonitor();
		  }
	
		  _createClass(TargetMonitor, [{
		    key: 'receiveHandlerId',
		    value: function receiveHandlerId(targetId) {
		      this.targetId = targetId;
		    }
		  }, {
		    key: 'canDrop',
		    value: function canDrop() {
		      (0, _invariant2.default)(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html');
	
		      try {
		        isCallingCanDrop = true;
		        return this.internalMonitor.canDropOnTarget(this.targetId);
		      } finally {
		        isCallingCanDrop = false;
		      }
		    }
		  }, {
		    key: 'isOver',
		    value: function isOver(options) {
		      return this.internalMonitor.isOverTarget(this.targetId, options);
		    }
		  }, {
		    key: 'getItemType',
		    value: function getItemType() {
		      return this.internalMonitor.getItemType();
		    }
		  }, {
		    key: 'getItem',
		    value: function getItem() {
		      return this.internalMonitor.getItem();
		    }
		  }, {
		    key: 'getDropResult',
		    value: function getDropResult() {
		      return this.internalMonitor.getDropResult();
		    }
		  }, {
		    key: 'didDrop',
		    value: function didDrop() {
		      return this.internalMonitor.didDrop();
		    }
		  }, {
		    key: 'getInitialClientOffset',
		    value: function getInitialClientOffset() {
		      return this.internalMonitor.getInitialClientOffset();
		    }
		  }, {
		    key: 'getInitialSourceClientOffset',
		    value: function getInitialSourceClientOffset() {
		      return this.internalMonitor.getInitialSourceClientOffset();
		    }
		  }, {
		    key: 'getSourceClientOffset',
		    value: function getSourceClientOffset() {
		      return this.internalMonitor.getSourceClientOffset();
		    }
		  }, {
		    key: 'getClientOffset',
		    value: function getClientOffset() {
		      return this.internalMonitor.getClientOffset();
		    }
		  }, {
		    key: 'getDifferenceFromInitialOffset',
		    value: function getDifferenceFromInitialOffset() {
		      return this.internalMonitor.getDifferenceFromInitialOffset();
		    }
		  }]);
	
		  return TargetMonitor;
		}();
	
		function createTargetMonitor(manager) {
		  return new TargetMonitor(manager);
		}
	
	/***/ }),
	/* 374 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = registerSource;
		function registerSource(type, source, manager) {
		  var registry = manager.getRegistry();
		  var sourceId = registry.addSource(type, source);
	
		  function unregisterSource() {
		    registry.removeSource(sourceId);
		  }
	
		  return {
		    handlerId: sourceId,
		    unregister: unregisterSource
		  };
		}
	
	/***/ }),
	/* 375 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = registerTarget;
		function registerTarget(type, target, manager) {
		  var registry = manager.getRegistry();
		  var targetId = registry.addTarget(type, target);
	
		  function unregisterTarget() {
		    registry.removeTarget(targetId);
		  }
	
		  return {
		    handlerId: targetId,
		    unregister: unregisterTarget
		  };
		}
	
	/***/ }),
	/* 376 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = cloneWithRef;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _react = __webpack_require__(2);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function cloneWithRef(element, newRef) {
		  var previousRef = element.ref;
		  (0, _invariant2.default)(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
	
		  if (!previousRef) {
		    // When there is no ref on the element, use the new ref directly
		    return (0, _react.cloneElement)(element, {
		      ref: newRef
		    });
		  }
	
		  return (0, _react.cloneElement)(element, {
		    ref: function ref(node) {
		      newRef(node);
	
		      if (previousRef) {
		        previousRef(node);
		      }
		    }
		  });
		}
	
	/***/ }),
	/* 377 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
	
		var sizerStyle = { position: 'absolute', top: 0, left: 0, visibility: 'hidden', height: 0, overflow: 'scroll', whiteSpace: 'pre' };
	
		var AutosizeInput = React.createClass({
			displayName: 'AutosizeInput',
	
			propTypes: {
				className: React.PropTypes.string, // className for the outer element
				defaultValue: React.PropTypes.any, // default field value
				inputClassName: React.PropTypes.string, // className for the input element
				inputStyle: React.PropTypes.object, // css styles for the input element
				minWidth: React.PropTypes.oneOfType([// minimum width for input element
				React.PropTypes.number, React.PropTypes.string]),
				onChange: React.PropTypes.func, // onChange handler: function(newValue) {}
				placeholder: React.PropTypes.string, // placeholder text
				placeholderIsMinWidth: React.PropTypes.bool, // don't collapse size to less than the placeholder
				style: React.PropTypes.object, // css styles for the outer element
				value: React.PropTypes.any },
			// field value
			getDefaultProps: function getDefaultProps() {
				return {
					minWidth: 1
				};
			},
			getInitialState: function getInitialState() {
				return {
					inputWidth: this.props.minWidth
				};
			},
			componentDidMount: function componentDidMount() {
				this.copyInputStyles();
				this.updateInputWidth();
			},
			componentDidUpdate: function componentDidUpdate() {
				this.updateInputWidth();
			},
			copyInputStyles: function copyInputStyles() {
				if (!this.isMounted() || !window.getComputedStyle) {
					return;
				}
				var inputStyle = window.getComputedStyle(this.refs.input);
				if (!inputStyle) {
					return;
				}
				var widthNode = this.refs.sizer;
				widthNode.style.fontSize = inputStyle.fontSize;
				widthNode.style.fontFamily = inputStyle.fontFamily;
				widthNode.style.fontWeight = inputStyle.fontWeight;
				widthNode.style.fontStyle = inputStyle.fontStyle;
				widthNode.style.letterSpacing = inputStyle.letterSpacing;
				if (this.props.placeholder) {
					var placeholderNode = this.refs.placeholderSizer;
					placeholderNode.style.fontSize = inputStyle.fontSize;
					placeholderNode.style.fontFamily = inputStyle.fontFamily;
					placeholderNode.style.fontWeight = inputStyle.fontWeight;
					placeholderNode.style.fontStyle = inputStyle.fontStyle;
					placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
				}
			},
			updateInputWidth: function updateInputWidth() {
				if (!this.isMounted() || typeof this.refs.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = undefined;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.refs.sizer.scrollWidth, this.refs.placeholderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.refs.sizer.scrollWidth + 2;
				}
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			},
			getInput: function getInput() {
				return this.refs.input;
			},
			focus: function focus() {
				this.refs.input.focus();
			},
			blur: function blur() {
				this.refs.input.blur();
			},
			select: function select() {
				this.refs.input.select();
			},
			render: function render() {
				var sizerValue = this.props.defaultValue || this.props.value || '';
				var wrapperStyle = this.props.style || {};
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
				var inputStyle = _extends({}, this.props.inputStyle);
				inputStyle.width = this.state.inputWidth + 'px';
				inputStyle.boxSizing = 'content-box';
				var inputProps = _extends({}, this.props);
				inputProps.className = this.props.inputClassName;
				inputProps.style = inputStyle;
				// ensure props meant for `AutosizeInput` don't end up on the `input`
				delete inputProps.inputClassName;
				delete inputProps.inputStyle;
				delete inputProps.minWidth;
				delete inputProps.placeholderIsMinWidth;
				return React.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					React.createElement('input', _extends({}, inputProps, { ref: 'input' })),
					React.createElement(
						'div',
						{ ref: 'sizer', style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? React.createElement(
						'div',
						{ ref: 'placeholderSizer', style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		});
	
		module.exports = AutosizeInput;
	
	/***/ }),
	/* 378 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*eslint-disable react/prop-types */
	
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _warning = __webpack_require__(406);
	
		var _warning2 = _interopRequireDefault(_warning);
	
		var _componentOrElement = __webpack_require__(137);
	
		var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
		var _elementType = __webpack_require__(385);
	
		var _elementType2 = _interopRequireDefault(_elementType);
	
		var _Portal = __webpack_require__(380);
	
		var _Portal2 = _interopRequireDefault(_Portal);
	
		var _ModalManager = __webpack_require__(379);
	
		var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
		var _ownerDocument = __webpack_require__(136);
	
		var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
		var _addEventListener = __webpack_require__(381);
	
		var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
		var _addFocusListener = __webpack_require__(382);
	
		var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
		var _inDOM = __webpack_require__(24);
	
		var _inDOM2 = _interopRequireDefault(_inDOM);
	
		var _activeElement = __webpack_require__(261);
	
		var _activeElement2 = _interopRequireDefault(_activeElement);
	
		var _contains = __webpack_require__(267);
	
		var _contains2 = _interopRequireDefault(_contains);
	
		var _getContainer = __webpack_require__(135);
	
		var _getContainer2 = _interopRequireDefault(_getContainer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var modalManager = new _ModalManager2.default();
	
		/**
		 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
		 * The Modal component renders its `children` node in front of a backdrop component.
		 *
		 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
		 *
		 * - Manages dialog stacking when one-at-a-time just isn't enough.
		 * - Creates a backdrop, for disabling interaction below the modal.
		 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
		 * - It disables scrolling of the page content while open.
		 * - Adds the appropriate ARIA roles are automatically.
		 * - Easily pluggable animations via a `<Transition/>` component.
		 *
		 * Note that, in the same way the backdrop element prevents users from clicking or interacting
		 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
		 * interact with page content while the Modal is open. To do this, we use a common technique of applying
		 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
		 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
		 * React hierarchy (such as the default: document.body).
		 */
		var Modal = _react2.default.createClass({
		  displayName: 'Modal',
	
	
		  propTypes: _extends({}, _Portal2.default.propTypes, {
	
		    /**
		     * Set the visibility of the Modal
		     */
		    show: _react2.default.PropTypes.bool,
	
		    /**
		     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
		     *
		     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
		     * page content can be placed behind a virtual backdrop as well as a visual one.
		     */
		    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
		    /**
		     * A callback fired when the Modal is opening.
		     */
		    onShow: _react2.default.PropTypes.func,
	
		    /**
		     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
		     *
		     * The `onHide` callback only signals intent from the Modal,
		     * you must actually set the `show` prop to `false` for the Modal to close.
		     */
		    onHide: _react2.default.PropTypes.func,
	
		    /**
		     * Include a backdrop component.
		     */
		    backdrop: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(['static'])]),
	
		    /**
		     * A function that returns a backdrop component. Useful for custom
		     * backdrop rendering.
		     *
		     * ```js
		     *  renderBackdrop={props => <MyBackdrop {...props} />}
		     * ```
		     */
		    renderBackdrop: _react2.default.PropTypes.func,
	
		    /**
		     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
		     */
		    onEscapeKeyUp: _react2.default.PropTypes.func,
	
		    /**
		     * A callback fired when the backdrop, if specified, is clicked.
		     */
		    onBackdropClick: _react2.default.PropTypes.func,
	
		    /**
		     * A style object for the backdrop component.
		     */
		    backdropStyle: _react2.default.PropTypes.object,
	
		    /**
		     * A css class or classes for the backdrop component.
		     */
		    backdropClassName: _react2.default.PropTypes.string,
	
		    /**
		     * A css class or set of classes applied to the modal container when the modal is open,
		     * and removed when it is closed.
		     */
		    containerClassName: _react2.default.PropTypes.string,
	
		    /**
		     * Close the modal when escape key is pressed
		     */
		    keyboard: _react2.default.PropTypes.bool,
	
		    /**
		     * A `<Transition/>` component to use for the dialog and backdrop components.
		     */
		    transition: _elementType2.default,
	
		    /**
		     * The `timeout` of the dialog transition if specified. This number is used to ensure that
		     * transition callbacks are always fired, even if browser transition events are canceled.
		     *
		     * See the Transition `timeout` prop for more infomation.
		     */
		    dialogTransitionTimeout: _react2.default.PropTypes.number,
	
		    /**
		     * The `timeout` of the backdrop transition if specified. This number is used to
		     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
		     *
		     * See the Transition `timeout` prop for more infomation.
		     */
		    backdropTransitionTimeout: _react2.default.PropTypes.number,
	
		    /**
		     * When `true` The modal will automatically shift focus to itself when it opens, and
		     * replace it to the last focused element when it closes. This also
		     * works correctly with any Modal children that have the `autoFocus` prop.
		     *
		     * Generally this should never be set to `false` as it makes the Modal less
		     * accessible to assistive technologies, like screen readers.
		     */
		    autoFocus: _react2.default.PropTypes.bool,
	
		    /**
		     * When `true` The modal will prevent focus from leaving the Modal while open.
		     *
		     * Generally this should never be set to `false` as it makes the Modal less
		     * accessible to assistive technologies, like screen readers.
		     */
		    enforceFocus: _react2.default.PropTypes.bool,
	
		    /**
		     * When `true` The modal will restore focus to previously focused element once
		     * modal is hidden
		     */
		    restoreFocus: _react2.default.PropTypes.bool,
	
		    /**
		     * Callback fired before the Modal transitions in
		     */
		    onEnter: _react2.default.PropTypes.func,
	
		    /**
		     * Callback fired as the Modal begins to transition in
		     */
		    onEntering: _react2.default.PropTypes.func,
	
		    /**
		     * Callback fired after the Modal finishes transitioning in
		     */
		    onEntered: _react2.default.PropTypes.func,
	
		    /**
		     * Callback fired right before the Modal transitions out
		     */
		    onExit: _react2.default.PropTypes.func,
	
		    /**
		     * Callback fired as the Modal begins to transition out
		     */
		    onExiting: _react2.default.PropTypes.func,
	
		    /**
		     * Callback fired after the Modal finishes transitioning out
		     */
		    onExited: _react2.default.PropTypes.func,
	
		    /**
		     * A ModalManager instance used to track and manage the state of open
		     * Modals. Useful when customizing how modals interact within a container
		     */
		    manager: _react2.default.PropTypes.object.isRequired
		  }),
	
		  getDefaultProps: function getDefaultProps() {
		    var noop = function noop() {};
	
		    return {
		      show: false,
		      backdrop: true,
		      keyboard: true,
		      autoFocus: true,
		      enforceFocus: true,
		      restoreFocus: true,
		      onHide: noop,
		      manager: modalManager,
		      renderBackdrop: function renderBackdrop(props) {
		        return _react2.default.createElement('div', props);
		      }
		    };
		  },
		  omitProps: function omitProps(props, propTypes) {
	
		    var keys = Object.keys(props);
		    var newProps = {};
		    keys.map(function (prop) {
		      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
		        newProps[prop] = props[prop];
		      }
		    });
	
		    return newProps;
		  },
		  getInitialState: function getInitialState() {
		    return { exited: !this.props.show };
		  },
		  render: function render() {
		    var _props = this.props,
		        show = _props.show,
		        container = _props.container,
		        children = _props.children,
		        Transition = _props.transition,
		        backdrop = _props.backdrop,
		        dialogTransitionTimeout = _props.dialogTransitionTimeout,
		        className = _props.className,
		        style = _props.style,
		        onExit = _props.onExit,
		        onExiting = _props.onExiting,
		        onEnter = _props.onEnter,
		        onEntering = _props.onEntering,
		        onEntered = _props.onEntered;
	
	
		    var dialog = _react2.default.Children.only(children);
		    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
		    var mountModal = show || Transition && !this.state.exited;
		    if (!mountModal) {
		      return null;
		    }
	
		    var _dialog$props = dialog.props,
		        role = _dialog$props.role,
		        tabIndex = _dialog$props.tabIndex;
	
	
		    if (role === undefined || tabIndex === undefined) {
		      dialog = (0, _react.cloneElement)(dialog, {
		        role: role === undefined ? 'document' : role,
		        tabIndex: tabIndex == null ? '-1' : tabIndex
		      });
		    }
	
		    if (Transition) {
		      dialog = _react2.default.createElement(
		        Transition,
		        {
		          transitionAppear: true,
		          unmountOnExit: true,
		          'in': show,
		          timeout: dialogTransitionTimeout,
		          onExit: onExit,
		          onExiting: onExiting,
		          onExited: this.handleHidden,
		          onEnter: onEnter,
		          onEntering: onEntering,
		          onEntered: onEntered
		        },
		        dialog
		      );
		    }
	
		    return _react2.default.createElement(
		      _Portal2.default,
		      {
		        ref: this.setMountNode,
		        container: container
		      },
		      _react2.default.createElement(
		        'div',
		        _extends({
		          ref: 'modal',
		          role: role || 'dialog'
		        }, filteredProps, {
		          style: style,
		          className: className
		        }),
		        backdrop && this.renderBackdrop(),
		        dialog
		      )
		    );
		  },
		  renderBackdrop: function renderBackdrop() {
		    var _this = this;
	
		    var _props2 = this.props,
		        backdropStyle = _props2.backdropStyle,
		        backdropClassName = _props2.backdropClassName,
		        renderBackdrop = _props2.renderBackdrop,
		        Transition = _props2.transition,
		        backdropTransitionTimeout = _props2.backdropTransitionTimeout;
	
	
		    var backdropRef = function backdropRef(ref) {
		      return _this.backdrop = ref;
		    };
	
		    var backdrop = _react2.default.createElement('div', {
		      ref: backdropRef,
		      style: this.props.backdropStyle,
		      className: this.props.backdropClassName,
		      onClick: this.handleBackdropClick
		    });
	
		    if (Transition) {
		      backdrop = _react2.default.createElement(
		        Transition,
		        { transitionAppear: true,
		          'in': this.props.show,
		          timeout: backdropTransitionTimeout
		        },
		        renderBackdrop({
		          ref: backdropRef,
		          style: backdropStyle,
		          className: backdropClassName,
		          onClick: this.handleBackdropClick
		        })
		      );
		    }
	
		    return backdrop;
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (nextProps.show) {
		      this.setState({ exited: false });
		    } else if (!nextProps.transition) {
		      // Otherwise let handleHidden take care of marking exited.
		      this.setState({ exited: true });
		    }
		  },
		  componentWillUpdate: function componentWillUpdate(nextProps) {
		    if (!this.props.show && nextProps.show) {
		      this.checkForFocus();
		    }
		  },
		  componentDidMount: function componentDidMount() {
		    if (this.props.show) {
		      this.onShow();
		    }
		  },
		  componentDidUpdate: function componentDidUpdate(prevProps) {
		    var transition = this.props.transition;
	
	
		    if (prevProps.show && !this.props.show && !transition) {
		      // Otherwise handleHidden will call this.
		      this.onHide();
		    } else if (!prevProps.show && this.props.show) {
		      this.onShow();
		    }
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    var _props3 = this.props,
		        show = _props3.show,
		        transition = _props3.transition;
	
	
		    if (show || transition && !this.state.exited) {
		      this.onHide();
		    }
		  },
		  onShow: function onShow() {
		    var doc = (0, _ownerDocument2.default)(this);
		    var container = (0, _getContainer2.default)(this.props.container, doc.body);
	
		    this.props.manager.add(this, container, this.props.containerClassName);
	
		    this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	
		    this._onFocusinListener = (0, _addFocusListener2.default)(this.enforceFocus);
	
		    this.focus();
	
		    if (this.props.onShow) {
		      this.props.onShow();
		    }
		  },
		  onHide: function onHide() {
		    this.props.manager.remove(this);
	
		    this._onDocumentKeyupListener.remove();
	
		    this._onFocusinListener.remove();
	
		    if (this.props.restoreFocus) {
		      this.restoreLastFocus();
		    }
		  },
		  setMountNode: function setMountNode(ref) {
		    this.mountNode = ref ? ref.getMountNode() : ref;
		  },
		  handleHidden: function handleHidden() {
		    this.setState({ exited: true });
		    this.onHide();
	
		    if (this.props.onExited) {
		      var _props4;
	
		      (_props4 = this.props).onExited.apply(_props4, arguments);
		    }
		  },
		  handleBackdropClick: function handleBackdropClick(e) {
		    if (e.target !== e.currentTarget) {
		      return;
		    }
	
		    if (this.props.onBackdropClick) {
		      this.props.onBackdropClick(e);
		    }
	
		    if (this.props.backdrop === true) {
		      this.props.onHide();
		    }
		  },
		  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
		    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
		      if (this.props.onEscapeKeyUp) {
		        this.props.onEscapeKeyUp(e);
		      }
		      this.props.onHide();
		    }
		  },
		  checkForFocus: function checkForFocus() {
		    if (_inDOM2.default) {
		      this.lastFocus = (0, _activeElement2.default)();
		    }
		  },
		  focus: function focus() {
		    var autoFocus = this.props.autoFocus;
		    var modalContent = this.getDialogElement();
		    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
		    var focusInModal = current && (0, _contains2.default)(modalContent, current);
	
		    if (modalContent && autoFocus && !focusInModal) {
		      this.lastFocus = current;
	
		      if (!modalContent.hasAttribute('tabIndex')) {
		        modalContent.setAttribute('tabIndex', -1);
		        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
		      }
	
		      modalContent.focus();
		    }
		  },
		  restoreLastFocus: function restoreLastFocus() {
		    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
		    if (this.lastFocus && this.lastFocus.focus) {
		      this.lastFocus.focus();
		      this.lastFocus = null;
		    }
		  },
		  enforceFocus: function enforceFocus() {
		    var enforceFocus = this.props.enforceFocus;
	
	
		    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
		      return;
		    }
	
		    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
		    var modal = this.getDialogElement();
	
		    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
		      modal.focus();
		    }
		  },
	
	
		  //instead of a ref, which might conflict with one the parent applied.
		  getDialogElement: function getDialogElement() {
		    var node = this.refs.modal;
		    return node && node.lastChild;
		  },
		  isTopModal: function isTopModal() {
		    return this.props.manager.isTopModal(this);
		  }
		});
	
		Modal.Manager = _ModalManager2.default;
	
		exports.default = Modal;
		module.exports = exports['default'];
	
	/***/ }),
	/* 379 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _style = __webpack_require__(270);
	
		var _style2 = _interopRequireDefault(_style);
	
		var _class = __webpack_require__(263);
	
		var _class2 = _interopRequireDefault(_class);
	
		var _scrollbarSize = __webpack_require__(277);
	
		var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
		var _isOverflowing = __webpack_require__(383);
	
		var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
		var _manageAriaHidden = __webpack_require__(384);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function findIndexOf(arr, cb) {
		  var idx = -1;
		  arr.some(function (d, i) {
		    if (cb(d, i)) {
		      idx = i;
		      return true;
		    }
		  });
		  return idx;
		}
	
		function findContainer(data, modal) {
		  return findIndexOf(data, function (d) {
		    return d.modals.indexOf(modal) !== -1;
		  });
		}
	
		function setContainerStyle(state, container) {
		  var style = { overflow: 'hidden' };
	
		  // we are only interested in the actual `style` here
		  // becasue we will override it
		  state.style = {
		    overflow: container.style.overflow,
		    paddingRight: container.style.paddingRight
		  };
	
		  if (state.overflowing) {
		    // use computed style, here to get the real padding
		    // to add our scrollbar width
		    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
		  }
	
		  (0, _style2.default)(container, style);
		}
	
		function removeContainerStyle(_ref, container) {
		  var style = _ref.style;
	
	
		  Object.keys(style).forEach(function (key) {
		    return container.style[key] = style[key];
		  });
		}
		/**
		 * Proper state managment for containers and the modals in those containers.
		 *
		 * @internal Used by the Modal to ensure proper styling of containers.
		 */
	
		var ModalManager = function () {
		  function ModalManager() {
		    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
		        _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
		        hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
		        _ref2$handleContainer = _ref2.handleContainerOverflow,
		        handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
		    _classCallCheck(this, ModalManager);
	
		    this.hideSiblingNodes = hideSiblingNodes;
		    this.handleContainerOverflow = handleContainerOverflow;
		    this.modals = [];
		    this.containers = [];
		    this.data = [];
		  }
	
		  _createClass(ModalManager, [{
		    key: 'add',
		    value: function add(modal, container, className) {
		      var modalIdx = this.modals.indexOf(modal);
		      var containerIdx = this.containers.indexOf(container);
	
		      if (modalIdx !== -1) {
		        return modalIdx;
		      }
	
		      modalIdx = this.modals.length;
		      this.modals.push(modal);
	
		      if (this.hideSiblingNodes) {
		        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
		      }
	
		      if (containerIdx !== -1) {
		        this.data[containerIdx].modals.push(modal);
		        return modalIdx;
		      }
	
		      var data = {
		        modals: [modal],
		        //right now only the first modal of a container will have its classes applied
		        classes: className ? className.split(/\s+/) : [],
	
		        overflowing: (0, _isOverflowing2.default)(container)
		      };
	
		      if (this.handleContainerOverflow) {
		        setContainerStyle(data, container);
		      }
	
		      data.classes.forEach(_class2.default.addClass.bind(null, container));
	
		      this.containers.push(container);
		      this.data.push(data);
	
		      return modalIdx;
		    }
		  }, {
		    key: 'remove',
		    value: function remove(modal) {
		      var modalIdx = this.modals.indexOf(modal);
	
		      if (modalIdx === -1) {
		        return;
		      }
	
		      var containerIdx = findContainer(this.data, modal);
		      var data = this.data[containerIdx];
		      var container = this.containers[containerIdx];
	
		      data.modals.splice(data.modals.indexOf(modal), 1);
	
		      this.modals.splice(modalIdx, 1);
	
		      // if that was the last modal in a container,
		      // clean up the container
		      if (data.modals.length === 0) {
		        data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
		        if (this.handleContainerOverflow) {
		          removeContainerStyle(data, container);
		        }
	
		        if (this.hideSiblingNodes) {
		          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
		        }
		        this.containers.splice(containerIdx, 1);
		        this.data.splice(containerIdx, 1);
		      } else if (this.hideSiblingNodes) {
		        //otherwise make sure the next top modal is visible to a SR
		        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
		      }
		    }
		  }, {
		    key: 'isTopModal',
		    value: function isTopModal(modal) {
		      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
		    }
		  }]);
	
		  return ModalManager;
		}();
	
		exports.default = ModalManager;
		module.exports = exports['default'];
	
	/***/ }),
	/* 380 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _componentOrElement = __webpack_require__(137);
	
		var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
		var _ownerDocument = __webpack_require__(136);
	
		var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
		var _getContainer = __webpack_require__(135);
	
		var _getContainer2 = _interopRequireDefault(_getContainer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/**
		 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
		 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
		 * The children of `<Portal/>` component will be appended to the `container` specified.
		 */
		var Portal = _react2.default.createClass({
	
		  displayName: 'Portal',
	
		  propTypes: {
		    /**
		     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
		     * appended to it.
		     */
		    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
		  },
	
		  componentDidMount: function componentDidMount() {
		    this._renderOverlay();
		  },
		  componentDidUpdate: function componentDidUpdate() {
		    this._renderOverlay();
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (this._overlayTarget && nextProps.container !== this.props.container) {
		      this._portalContainerNode.removeChild(this._overlayTarget);
		      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
		      this._portalContainerNode.appendChild(this._overlayTarget);
		    }
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    this._unrenderOverlay();
		    this._unmountOverlayTarget();
		  },
		  _mountOverlayTarget: function _mountOverlayTarget() {
		    if (!this._overlayTarget) {
		      this._overlayTarget = document.createElement('div');
		      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
		      this._portalContainerNode.appendChild(this._overlayTarget);
		    }
		  },
		  _unmountOverlayTarget: function _unmountOverlayTarget() {
		    if (this._overlayTarget) {
		      this._portalContainerNode.removeChild(this._overlayTarget);
		      this._overlayTarget = null;
		    }
		    this._portalContainerNode = null;
		  },
		  _renderOverlay: function _renderOverlay() {
	
		    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
		    // Save reference for future access.
		    if (overlay !== null) {
		      this._mountOverlayTarget();
		      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
		    } else {
		      // Unrender if the component is null for transitions to null
		      this._unrenderOverlay();
		      this._unmountOverlayTarget();
		    }
		  },
		  _unrenderOverlay: function _unrenderOverlay() {
		    if (this._overlayTarget) {
		      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
		      this._overlayInstance = null;
		    }
		  },
		  render: function render() {
		    return null;
		  },
		  getMountNode: function getMountNode() {
		    return this._overlayTarget;
		  },
		  getOverlayDOMNode: function getOverlayDOMNode() {
		    if (!this.isMounted()) {
		      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
		    }
	
		    if (this._overlayInstance) {
		      return _reactDom2.default.findDOMNode(this._overlayInstance);
		    }
	
		    return null;
		  }
		});
	
		exports.default = Portal;
		module.exports = exports['default'];
	
	/***/ }),
	/* 381 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		exports.default = function (node, event, handler, capture) {
		  (0, _on2.default)(node, event, handler, capture);
	
		  return {
		    remove: function remove() {
		      (0, _off2.default)(node, event, handler, capture);
		    }
		  };
		};
	
		var _on = __webpack_require__(266);
	
		var _on2 = _interopRequireDefault(_on);
	
		var _off = __webpack_require__(265);
	
		var _off2 = _interopRequireDefault(_off);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		module.exports = exports['default'];
	
	/***/ }),
	/* 382 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = addFocusListener;
		/**
		 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
		 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
		 *
		 * We only allow one Listener at a time to avoid stack overflows
		 */
		function addFocusListener(handler) {
		  var useFocusin = !document.addEventListener;
		  var remove = void 0;
	
		  if (useFocusin) {
		    document.attachEvent('onfocusin', handler);
		    remove = function remove() {
		      return document.detachEvent('onfocusin', handler);
		    };
		  } else {
		    document.addEventListener('focus', handler, true);
		    remove = function remove() {
		      return document.removeEventListener('focus', handler, true);
		    };
		  }
	
		  return { remove: remove };
		}
		module.exports = exports['default'];
	
	/***/ }),
	/* 383 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isOverflowing;
	
		var _isWindow = __webpack_require__(268);
	
		var _isWindow2 = _interopRequireDefault(_isWindow);
	
		var _ownerDocument = __webpack_require__(74);
	
		var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function isBody(node) {
		  return node && node.tagName.toLowerCase() === 'body';
		}
	
		function bodyIsOverflowing(node) {
		  var doc = (0, _ownerDocument2.default)(node);
		  var win = (0, _isWindow2.default)(doc);
		  var fullWidth = win.innerWidth;
	
		  // Support: ie8, no innerWidth
		  if (!fullWidth) {
		    var documentElementRect = doc.documentElement.getBoundingClientRect();
		    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
		  }
	
		  return doc.body.clientWidth < fullWidth;
		}
	
		function isOverflowing(container) {
		  var win = (0, _isWindow2.default)(container);
	
		  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
		}
		module.exports = exports['default'];
	
	/***/ }),
	/* 384 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.ariaHidden = ariaHidden;
		exports.hideSiblings = hideSiblings;
		exports.showSiblings = showSiblings;
	
		var BLACKLIST = ['template', 'script', 'style'];
	
		var isHidable = function isHidable(_ref) {
		  var nodeType = _ref.nodeType,
		      tagName = _ref.tagName;
		  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
		};
	
		var siblings = function siblings(container, mount, cb) {
		  mount = [].concat(mount);
	
		  [].forEach.call(container.children, function (node) {
		    if (mount.indexOf(node) === -1 && isHidable(node)) {
		      cb(node);
		    }
		  });
		};
	
		function ariaHidden(show, node) {
		  if (!node) {
		    return;
		  }
		  if (show) {
		    node.setAttribute('aria-hidden', 'true');
		  } else {
		    node.removeAttribute('aria-hidden');
		  }
		}
	
		function hideSiblings(container, mountNode) {
		  siblings(container, mountNode, function (node) {
		    return ariaHidden(true, node);
		  });
		}
	
		function showSiblings(container, mountNode) {
		  siblings(container, mountNode, function (node) {
		    return ariaHidden(false, node);
		  });
		}
	
	/***/ }),
	/* 385 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _createChainableTypeChecker = __webpack_require__(138);
	
		var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function elementType(props, propName, componentName, location, propFullName) {
		  var propValue = props[propName];
		  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
		  if (_react2.default.isValidElement(propValue)) {
		    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
		  }
	
		  if (propType !== 'function' && propType !== 'string') {
		    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
		  }
	
		  return null;
		}
	
		exports.default = (0, _createChainableTypeChecker2.default)(elementType);
	
	/***/ }),
	/* 386 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
			value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
		var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Select = __webpack_require__(50);
	
		var _Select2 = _interopRequireDefault(_Select);
	
		var _utilsStripDiacritics = __webpack_require__(141);
	
		var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);
	
		var propTypes = {
			autoload: _react2['default'].PropTypes.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
			cache: _react2['default'].PropTypes.any, // object to use to cache results; set to null/false to disable caching
			children: _react2['default'].PropTypes.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
			ignoreAccents: _react2['default'].PropTypes.bool, // strip diacritics when filtering; defaults to true
			ignoreCase: _react2['default'].PropTypes.bool, // perform case-insensitive filtering; defaults to true
			loadingPlaceholder: _react2['default'].PropTypes.oneOfType([// replaces the placeholder while options are loading
			_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
			loadOptions: _react2['default'].PropTypes.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
			options: _react.PropTypes.array.isRequired, // array of options
			placeholder: _react2['default'].PropTypes.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
			_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
			noResultsText: _react2['default'].PropTypes.oneOfType([// field noResultsText, displayed when no options come back from the server
			_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
			onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
			searchPromptText: _react2['default'].PropTypes.oneOfType([// label to prompt for search input
			_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
			onInputChange: _react2['default'].PropTypes.func, // optional for keeping track of what is being typed
			value: _react2['default'].PropTypes.any };
	
		// initial field value
		var defaultCache = {};
	
		var defaultProps = {
			autoload: true,
			cache: defaultCache,
			children: defaultChildren,
			ignoreAccents: true,
			ignoreCase: true,
			loadingPlaceholder: 'Loading...',
			options: [],
			searchPromptText: 'Type to search'
		};
	
		var Async = (function (_Component) {
			_inherits(Async, _Component);
	
			function Async(props, context) {
				_classCallCheck(this, Async);
	
				_get(Object.getPrototypeOf(Async.prototype), 'constructor', this).call(this, props, context);
	
				this._cache = props.cache === defaultCache ? {} : props.cache;
	
				this.state = {
					isLoading: false,
					options: props.options
				};
	
				this._onInputChange = this._onInputChange.bind(this);
			}
	
			_createClass(Async, [{
				key: 'componentDidMount',
				value: function componentDidMount() {
					var autoload = this.props.autoload;
	
					if (autoload) {
						this.loadOptions('');
					}
				}
			}, {
				key: 'componentWillUpdate',
				value: function componentWillUpdate(nextProps, nextState) {
					var _this = this;
	
					var propertiesToSync = ['options'];
					propertiesToSync.forEach(function (prop) {
						if (_this.props[prop] !== nextProps[prop]) {
							_this.setState(_defineProperty({}, prop, nextProps[prop]));
						}
					});
				}
			}, {
				key: 'clearOptions',
				value: function clearOptions() {
					this.setState({ options: [] });
				}
			}, {
				key: 'loadOptions',
				value: function loadOptions(inputValue) {
					var _this2 = this;
	
					var loadOptions = this.props.loadOptions;
	
					var cache = this._cache;
	
					if (cache && cache.hasOwnProperty(inputValue)) {
						this.setState({
							options: cache[inputValue]
						});
	
						return;
					}
	
					var callback = function callback(error, data) {
						if (callback === _this2._callback) {
							_this2._callback = null;
	
							var options = data && data.options || [];
	
							if (cache) {
								cache[inputValue] = options;
							}
	
							_this2.setState({
								isLoading: false,
								options: options
							});
						}
					};
	
					// Ignore all but the most recent request
					this._callback = callback;
	
					var promise = loadOptions(inputValue, callback);
					if (promise) {
						promise.then(function (data) {
							return callback(null, data);
						}, function (error) {
							return callback(error);
						});
					}
	
					if (this._callback && !this.state.isLoading) {
						this.setState({
							isLoading: true
						});
					}
	
					return inputValue;
				}
			}, {
				key: '_onInputChange',
				value: function _onInputChange(inputValue) {
					var _props = this.props;
					var ignoreAccents = _props.ignoreAccents;
					var ignoreCase = _props.ignoreCase;
					var onInputChange = _props.onInputChange;
	
					if (ignoreAccents) {
						inputValue = (0, _utilsStripDiacritics2['default'])(inputValue);
					}
	
					if (ignoreCase) {
						inputValue = inputValue.toLowerCase();
					}
	
					if (onInputChange) {
						onInputChange(inputValue);
					}
	
					return this.loadOptions(inputValue);
				}
			}, {
				key: 'inputValue',
				value: function inputValue() {
					if (this.select) {
						return this.select.state.inputValue;
					}
					return '';
				}
			}, {
				key: 'noResultsText',
				value: function noResultsText() {
					var _props2 = this.props;
					var loadingPlaceholder = _props2.loadingPlaceholder;
					var noResultsText = _props2.noResultsText;
					var searchPromptText = _props2.searchPromptText;
					var isLoading = this.state.isLoading;
	
					var inputValue = this.inputValue();
	
					if (isLoading) {
						return loadingPlaceholder;
					}
					if (inputValue && noResultsText) {
						return noResultsText;
					}
					return searchPromptText;
				}
			}, {
				key: 'focus',
				value: function focus() {
					this.select.focus();
				}
			}, {
				key: 'render',
				value: function render() {
					var _this3 = this;
	
					var _props3 = this.props;
					var children = _props3.children;
					var loadingPlaceholder = _props3.loadingPlaceholder;
					var placeholder = _props3.placeholder;
					var _state = this.state;
					var isLoading = _state.isLoading;
					var options = _state.options;
	
					var props = {
						noResultsText: this.noResultsText(),
						placeholder: isLoading ? loadingPlaceholder : placeholder,
						options: isLoading && loadingPlaceholder ? [] : options,
						ref: function ref(_ref) {
							return _this3.select = _ref;
						},
						onChange: function onChange(newValues) {
							if (_this3.props.multi && _this3.props.value && newValues.length > _this3.props.value.length) {
								_this3.clearOptions();
							}
							_this3.props.onChange(newValues);
						}
					};
	
					return children(_extends({}, this.props, props, {
						isLoading: isLoading,
						onInputChange: this._onInputChange
					}));
				}
			}]);
	
			return Async;
		})(_react.Component);
	
		exports['default'] = Async;
	
		Async.propTypes = propTypes;
		Async.defaultProps = defaultProps;
	
		function defaultChildren(props) {
			return _react2['default'].createElement(_Select2['default'], props);
		};
		module.exports = exports['default'];
	
	/***/ }),
	/* 387 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Select = __webpack_require__(50);
	
		var _Select2 = _interopRequireDefault(_Select);
	
		function reduce(obj) {
			var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
			return Object.keys(obj).reduce(function (props, key) {
				var value = obj[key];
				if (value !== undefined) props[key] = value;
				return props;
			}, props);
		}
	
		var AsyncCreatable = _react2['default'].createClass({
			displayName: 'AsyncCreatableSelect',
	
			render: function render() {
				var _this = this;
	
				return _react2['default'].createElement(
					_Select2['default'].Async,
					this.props,
					function (asyncProps) {
						return _react2['default'].createElement(
							_Select2['default'].Creatable,
							_this.props,
							function (creatableProps) {
								return _react2['default'].createElement(_Select2['default'], _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
									onInputChange: function (input) {
										creatableProps.onInputChange(input);
										return asyncProps.onInputChange(input);
									},
									ref: function (ref) {
										creatableProps.ref(ref);
										asyncProps.ref(ref);
									}
								}));
							}
						);
					}
				);
			}
		});
	
		module.exports = AsyncCreatable;
	
	/***/ }),
	/* 388 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Select = __webpack_require__(50);
	
		var _Select2 = _interopRequireDefault(_Select);
	
		var _utilsDefaultFilterOptions = __webpack_require__(139);
	
		var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);
	
		var _utilsDefaultMenuRenderer = __webpack_require__(140);
	
		var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);
	
		var Creatable = _react2['default'].createClass({
			displayName: 'CreatableSelect',
	
			propTypes: {
				// Child function responsible for creating the inner Select component
				// This component can be used to compose HOCs (eg Creatable and Async)
				// (props: Object): PropTypes.element
				children: _react2['default'].PropTypes.func,
	
				// See Select.propTypes.filterOptions
				filterOptions: _react2['default'].PropTypes.any,
	
				// Searches for any matching option within the set of options.
				// This function prevents duplicate options from being created.
				// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
				isOptionUnique: _react2['default'].PropTypes.func,
	
				// Determines if the current input text represents a valid option.
				// ({ label: string }): boolean
				isValidNewOption: _react2['default'].PropTypes.func,
	
				// See Select.propTypes.menuRenderer
				menuRenderer: _react2['default'].PropTypes.any,
	
				// Factory to create new option.
				// ({ label: string, labelKey: string, valueKey: string }): Object
				newOptionCreator: _react2['default'].PropTypes.func,
	
				// input change handler: function (inputValue) {}
				onInputChange: _react2['default'].PropTypes.func,
	
				// input keyDown handler: function (event) {}
				onInputKeyDown: _react2['default'].PropTypes.func,
	
				// new option click handler: function (option) {}
				onNewOptionClick: _react2['default'].PropTypes.func,
	
				// See Select.propTypes.options
				options: _react2['default'].PropTypes.array,
	
				// Creates prompt/placeholder option text.
				// (filterText: string): string
				promptTextCreator: _react2['default'].PropTypes.func,
	
				// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
				shouldKeyDownEventCreateNewOption: _react2['default'].PropTypes.func
			},
	
			// Default prop methods
			statics: {
				isOptionUnique: isOptionUnique,
				isValidNewOption: isValidNewOption,
				newOptionCreator: newOptionCreator,
				promptTextCreator: promptTextCreator,
				shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
			},
	
			getDefaultProps: function getDefaultProps() {
				return {
					filterOptions: _utilsDefaultFilterOptions2['default'],
					isOptionUnique: isOptionUnique,
					isValidNewOption: isValidNewOption,
					menuRenderer: _utilsDefaultMenuRenderer2['default'],
					newOptionCreator: newOptionCreator,
					promptTextCreator: promptTextCreator,
					shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
				};
			},
	
			createNewOption: function createNewOption() {
				var _props = this.props;
				var isValidNewOption = _props.isValidNewOption;
				var newOptionCreator = _props.newOptionCreator;
				var onNewOptionClick = _props.onNewOptionClick;
				var _props$options = _props.options;
				var options = _props$options === undefined ? [] : _props$options;
				var shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			},
	
			filterOptions: function filterOptions() {
				var _props2 = this.props;
				var filterOptions = _props2.filterOptions;
				var isValidNewOption = _props2.isValidNewOption;
				var options = _props2.options;
				var promptTextCreator = _props2.promptTextCreator;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
				var excludeOptions = arguments[2] || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var _prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: _prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						filteredOptions.unshift(this._createPlaceholderOption);
					}
				}
	
				return filteredOptions;
			},
	
			isOptionUnique: function isOptionUnique(_ref2) {
				var option = _ref2.option;
				var options = _ref2.options;
				var isOptionUnique = this.props.isOptionUnique;
	
				options = options || this.select.filterOptions();
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			},
	
			menuRenderer: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			},
	
			onInputChange: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				if (onInputChange) {
					onInputChange(input);
				}
	
				// This value may be needed in between Select mounts (when this.select is null)
				this.inputValue = input;
			},
	
			onInputKeyDown: function onInputKeyDown(event) {
				var _props3 = this.props;
				var shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption;
				var onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			},
	
			onOptionSelect: function onOptionSelect(option, event) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			},
	
			render: function render() {
				var _this = this;
	
				var _props4 = this.props;
				var newOptionCreator = _props4.newOptionCreator;
				var shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption;
	
				var restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref) {
						_this.select = _ref;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref) {
							_this.labelKey = _ref.props.labelKey;
							_this.valueKey = _ref.props.valueKey;
						}
					}
				});
	
				return children(props);
			}
		});
	
		function defaultChildren(props) {
			return _react2['default'].createElement(_Select2['default'], props);
		};
	
		function isOptionUnique(_ref3) {
			var option = _ref3.option;
			var options = _ref3.options;
			var labelKey = _ref3.labelKey;
			var valueKey = _ref3.valueKey;
	
			return options.filter(function (existingOption) {
				return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
			}).length === 0;
		};
	
		function isValidNewOption(_ref4) {
			var label = _ref4.label;
	
			return !!label;
		};
	
		function newOptionCreator(_ref5) {
			var label = _ref5.label;
			var labelKey = _ref5.labelKey;
			var valueKey = _ref5.valueKey;
	
			var option = {};
			option[valueKey] = label;
			option[labelKey] = label;
			option.className = 'Select-create-option-placeholder';
			return option;
		};
	
		function promptTextCreator(label) {
			return 'Create option "' + label + '"';
		}
	
		function shouldKeyDownEventCreateNewOption(_ref6) {
			var keyCode = _ref6.keyCode;
	
			switch (keyCode) {
				case 9: // TAB
				case 13: // ENTER
				case 188:
					// COMMA
					return true;
			}
	
			return false;
		};
	
		module.exports = Creatable;
	
	/***/ }),
	/* 389 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _classnames = __webpack_require__(51);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var Option = _react2['default'].createClass({
			displayName: 'Option',
	
			propTypes: {
				children: _react2['default'].PropTypes.node,
				className: _react2['default'].PropTypes.string, // className (based on mouse position)
				instancePrefix: _react2['default'].PropTypes.string.isRequired, // unique prefix for the ids (used for aria)
				isDisabled: _react2['default'].PropTypes.bool, // the option is disabled
				isFocused: _react2['default'].PropTypes.bool, // the option is focused
				isSelected: _react2['default'].PropTypes.bool, // the option is selected
				onFocus: _react2['default'].PropTypes.func, // method to handle mouseEnter on option element
				onSelect: _react2['default'].PropTypes.func, // method to handle click on option element
				onUnfocus: _react2['default'].PropTypes.func, // method to handle mouseLeave on option element
				option: _react2['default'].PropTypes.object.isRequired, // object that is base for that option
				optionIndex: _react2['default'].PropTypes.number },
			// index of the option, used to generate unique ids for aria
			blockEvent: function blockEvent(event) {
				event.preventDefault();
				event.stopPropagation();
				if (event.target.tagName !== 'A' || !('href' in event.target)) {
					return;
				}
				if (event.target.target) {
					window.open(event.target.href, event.target.target);
				} else {
					window.location.href = event.target.href;
				}
			},
	
			handleMouseDown: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			},
	
			handleMouseEnter: function handleMouseEnter(event) {
				this.onFocus(event);
			},
	
			handleMouseMove: function handleMouseMove(event) {
				this.onFocus(event);
			},
	
			handleTouchEnd: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			},
	
			handleTouchMove: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			},
	
			handleTouchStart: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			},
	
			onFocus: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			},
			render: function render() {
				var _props = this.props;
				var option = _props.option;
				var instancePrefix = _props.instancePrefix;
				var optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2['default'])(this.props.className, option.className);
	
				return option.disabled ? _react2['default'].createElement(
					'div',
					{ className: className,
						onMouseDown: this.blockEvent,
						onClick: this.blockEvent },
					this.props.children
				) : _react2['default'].createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		});
	
		module.exports = Option;
	
	/***/ }),
	/* 390 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _classnames = __webpack_require__(51);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var Value = _react2['default'].createClass({
	
			displayName: 'Value',
	
			propTypes: {
				children: _react2['default'].PropTypes.node,
				disabled: _react2['default'].PropTypes.bool, // disabled prop passed to ReactSelect
				id: _react2['default'].PropTypes.string, // Unique id for the value - used for aria
				onClick: _react2['default'].PropTypes.func, // method to handle click on value label
				onRemove: _react2['default'].PropTypes.func, // method to handle removal of the value
				value: _react2['default'].PropTypes.object.isRequired },
	
			// the option object for this value
			handleMouseDown: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			},
	
			onRemove: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			},
	
			handleTouchEndRemove: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			},
	
			handleTouchMove: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			},
	
			handleTouchStart: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			},
	
			renderRemoveIcon: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2['default'].createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'×'
				);
			},
	
			renderLabel: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2['default'].createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2['default'].createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			},
	
			render: function render() {
				return _react2['default'].createElement(
					'div',
					{ className: (0, _classnames2['default'])('Select-value', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
	
		});
	
		module.exports = Value;
	
	/***/ }),
	/* 391 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
		exports["default"] = arrowRenderer;
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function arrowRenderer(_ref) {
			var onMouseDown = _ref.onMouseDown;
	
			return _react2["default"].createElement("span", {
				className: "Select-arrow",
				onMouseDown: onMouseDown
			});
		}
	
		;
		module.exports = exports["default"];
	
	/***/ }),
	/* 392 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
			value: true
		});
		exports['default'] = clearRenderer;
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function clearRenderer() {
			return _react2['default'].createElement('span', {
				className: 'Select-clear',
				dangerouslySetInnerHTML: { __html: '&times;' }
			});
		}
	
		;
		module.exports = exports['default'];
	
	/***/ }),
	/* 393 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		exports['default'] = applyMiddleware;
	
		var _compose = __webpack_require__(142);
	
		var _compose2 = _interopRequireDefault(_compose);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		/**
		 * Creates a store enhancer that applies middleware to the dispatch method
		 * of the Redux store. This is handy for a variety of tasks, such as expressing
		 * asynchronous actions in a concise manner, or logging every action payload.
		 *
		 * See `redux-thunk` package as an example of the Redux middleware.
		 *
		 * Because middleware is potentially asynchronous, this should be the first
		 * store enhancer in the composition chain.
		 *
		 * Note that each middleware will be given the `dispatch` and `getState` functions
		 * as named arguments.
		 *
		 * @param {...Function} middlewares The middleware chain to be applied.
		 * @returns {Function} A store enhancer applying the middleware.
		 */
		function applyMiddleware() {
		  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
		    middlewares[_key] = arguments[_key];
		  }
	
		  return function (createStore) {
		    return function (reducer, preloadedState, enhancer) {
		      var store = createStore(reducer, preloadedState, enhancer);
		      var _dispatch = store.dispatch;
		      var chain = [];
	
		      var middlewareAPI = {
		        getState: store.getState,
		        dispatch: function dispatch(action) {
		          return _dispatch(action);
		        }
		      };
		      chain = middlewares.map(function (middleware) {
		        return middleware(middlewareAPI);
		      });
		      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
		      return _extends({}, store, {
		        dispatch: _dispatch
		      });
		    };
		  };
		}
	
	/***/ }),
	/* 394 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		exports['default'] = bindActionCreators;
		function bindActionCreator(actionCreator, dispatch) {
		  return function () {
		    return dispatch(actionCreator.apply(undefined, arguments));
		  };
		}
	
		/**
		 * Turns an object whose values are action creators, into an object with the
		 * same keys, but with every function wrapped into a `dispatch` call so they
		 * may be invoked directly. This is just a convenience method, as you can call
		 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
		 *
		 * For convenience, you can also pass a single function as the first argument,
		 * and get a function in return.
		 *
		 * @param {Function|Object} actionCreators An object whose values are action
		 * creator functions. One handy way to obtain it is to use ES6 `import * as`
		 * syntax. You may also pass a single function.
		 *
		 * @param {Function} dispatch The `dispatch` function available on your Redux
		 * store.
		 *
		 * @returns {Function|Object} The object mimicking the original object, but with
		 * every action creator wrapped into the `dispatch` call. If you passed a
		 * function as `actionCreators`, the return value will also be a single
		 * function.
		 */
		function bindActionCreators(actionCreators, dispatch) {
		  if (typeof actionCreators === 'function') {
		    return bindActionCreator(actionCreators, dispatch);
		  }
	
		  if (typeof actionCreators !== 'object' || actionCreators === null) {
		    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
		  }
	
		  var keys = Object.keys(actionCreators);
		  var boundActionCreators = {};
		  for (var i = 0; i < keys.length; i++) {
		    var key = keys[i];
		    var actionCreator = actionCreators[key];
		    if (typeof actionCreator === 'function') {
		      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
		    }
		  }
		  return boundActionCreators;
		}
	
	/***/ }),
	/* 395 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports['default'] = combineReducers;
	
		var _createStore = __webpack_require__(87);
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		var _warning = __webpack_require__(143);
	
		var _warning2 = _interopRequireDefault(_warning);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function getUndefinedStateErrorMessage(key, action) {
		  var actionType = action && action.type;
		  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
		  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
		}
	
		function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
		  var reducerKeys = Object.keys(reducers);
		  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
		  if (reducerKeys.length === 0) {
		    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
		  }
	
		  if (!(0, _isPlainObject2['default'])(inputState)) {
		    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
		  }
	
		  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
		    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
		  });
	
		  unexpectedKeys.forEach(function (key) {
		    unexpectedKeyCache[key] = true;
		  });
	
		  if (unexpectedKeys.length > 0) {
		    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
		  }
		}
	
		function assertReducerSanity(reducers) {
		  Object.keys(reducers).forEach(function (key) {
		    var reducer = reducers[key];
		    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
		    if (typeof initialState === 'undefined') {
		      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
		    }
	
		    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
		    if (typeof reducer(undefined, { type: type }) === 'undefined') {
		      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
		    }
		  });
		}
	
		/**
		 * Turns an object whose values are different reducer functions, into a single
		 * reducer function. It will call every child reducer, and gather their results
		 * into a single state object, whose keys correspond to the keys of the passed
		 * reducer functions.
		 *
		 * @param {Object} reducers An object whose values correspond to different
		 * reducer functions that need to be combined into one. One handy way to obtain
		 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
		 * undefined for any action. Instead, they should return their initial state
		 * if the state passed to them was undefined, and the current state for any
		 * unrecognized action.
		 *
		 * @returns {Function} A reducer function that invokes every reducer inside the
		 * passed object, and builds a state object with the same shape.
		 */
		function combineReducers(reducers) {
		  var reducerKeys = Object.keys(reducers);
		  var finalReducers = {};
		  for (var i = 0; i < reducerKeys.length; i++) {
		    var key = reducerKeys[i];
	
		    if (false) {
		      if (typeof reducers[key] === 'undefined') {
		        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
		      }
		    }
	
		    if (typeof reducers[key] === 'function') {
		      finalReducers[key] = reducers[key];
		    }
		  }
		  var finalReducerKeys = Object.keys(finalReducers);
	
		  if (false) {
		    var unexpectedKeyCache = {};
		  }
	
		  var sanityError;
		  try {
		    assertReducerSanity(finalReducers);
		  } catch (e) {
		    sanityError = e;
		  }
	
		  return function combination() {
		    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		    var action = arguments[1];
	
		    if (sanityError) {
		      throw sanityError;
		    }
	
		    if (false) {
		      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
		      if (warningMessage) {
		        (0, _warning2['default'])(warningMessage);
		      }
		    }
	
		    var hasChanged = false;
		    var nextState = {};
		    for (var i = 0; i < finalReducerKeys.length; i++) {
		      var key = finalReducerKeys[i];
		      var reducer = finalReducers[key];
		      var previousStateForKey = state[key];
		      var nextStateForKey = reducer(previousStateForKey, action);
		      if (typeof nextStateForKey === 'undefined') {
		        var errorMessage = getUndefinedStateErrorMessage(key, action);
		        throw new Error(errorMessage);
		      }
		      nextState[key] = nextStateForKey;
		      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
		    }
		    return hasChanged ? nextState : state;
		  };
		}
	
	/***/ }),
	/* 396 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
		var _createStore = __webpack_require__(87);
	
		var _createStore2 = _interopRequireDefault(_createStore);
	
		var _combineReducers = __webpack_require__(395);
	
		var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
		var _bindActionCreators = __webpack_require__(394);
	
		var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
		var _applyMiddleware = __webpack_require__(393);
	
		var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
		var _compose = __webpack_require__(142);
	
		var _compose2 = _interopRequireDefault(_compose);
	
		var _warning = __webpack_require__(143);
	
		var _warning2 = _interopRequireDefault(_warning);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		/*
		* This is a dummy function to check if the function name has been altered by minification.
		* If the function has been minified and NODE_ENV !== 'production', warn the user.
		*/
		function isCrushed() {}
	
		if (false) {
		  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
		}
	
		exports.createStore = _createStore2['default'];
		exports.combineReducers = _combineReducers2['default'];
		exports.bindActionCreators = _bindActionCreators2['default'];
		exports.applyMiddleware = _applyMiddleware2['default'];
		exports.compose = _compose2['default'];
	
	/***/ }),
	/* 397 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.defaultMemoize = defaultMemoize;
		exports.createSelectorCreator = createSelectorCreator;
		exports.createStructuredSelector = createStructuredSelector;
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
		function defaultEqualityCheck(a, b) {
		  return a === b;
		}
	
		function defaultMemoize(func) {
		  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];
	
		  var lastArgs = null;
		  var lastResult = null;
		  return function () {
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }
	
		    if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
		      return equalityCheck(value, lastArgs[index]);
		    })) {
		      lastResult = func.apply(undefined, args);
		    }
		    lastArgs = args;
		    return lastResult;
		  };
		}
	
		function getDependencies(funcs) {
		  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
		  if (!dependencies.every(function (dep) {
		    return typeof dep === 'function';
		  })) {
		    var dependencyTypes = dependencies.map(function (dep) {
		      return typeof dep;
		    }).join(', ');
		    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
		  }
	
		  return dependencies;
		}
	
		function createSelectorCreator(memoize) {
		  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
		    memoizeOptions[_key2 - 1] = arguments[_key2];
		  }
	
		  return function () {
		    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
		      funcs[_key3] = arguments[_key3];
		    }
	
		    var recomputations = 0;
		    var resultFunc = funcs.pop();
		    var dependencies = getDependencies(funcs);
	
		    var memoizedResultFunc = memoize.apply(undefined, [function () {
		      recomputations++;
		      return resultFunc.apply(undefined, arguments);
		    }].concat(memoizeOptions));
	
		    var selector = function selector(state, props) {
		      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
		        args[_key4 - 2] = arguments[_key4];
		      }
	
		      var params = dependencies.map(function (dependency) {
		        return dependency.apply(undefined, [state, props].concat(args));
		      });
		      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
		    };
	
		    selector.resultFunc = resultFunc;
		    selector.recomputations = function () {
		      return recomputations;
		    };
		    selector.resetRecomputations = function () {
		      return recomputations = 0;
		    };
		    return selector;
		  };
		}
	
		var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
		function createStructuredSelector(selectors) {
		  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];
	
		  if (typeof selectors !== 'object') {
		    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
		  }
		  var objectKeys = Object.keys(selectors);
		  return selectorCreator(objectKeys.map(function (key) {
		    return selectors[key];
		  }), function () {
		    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
		      values[_key5] = arguments[_key5];
		    }
	
		    return values.reduce(function (composition, value, index) {
		      composition[objectKeys[index]] = value;
		      return composition;
		    }, {});
		  });
		}
	
	/***/ }),
	/* 398 */
	/***/ (function(module, exports, __webpack_require__) {
	
		(function webpackUniversalModuleDefinition(root, factory) {
			if(true)
				module.exports = factory(__webpack_require__(2));
			else if(typeof define === 'function' && define.amd)
				define(["react"], factory);
			else if(typeof exports === 'object')
				exports["ReactAutocomplete"] = factory(require("react"));
			else
				root["ReactAutocomplete"] = factory(root["React"]);
		})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
		return /******/ (function(modules) { // webpackBootstrap
		/******/ 	// The module cache
		/******/ 	var installedModules = {};
	
		/******/ 	// The require function
		/******/ 	function __webpack_require__(moduleId) {
	
		/******/ 		// Check if module is in cache
		/******/ 		if(installedModules[moduleId])
		/******/ 			return installedModules[moduleId].exports;
	
		/******/ 		// Create a new module (and put it into the cache)
		/******/ 		var module = installedModules[moduleId] = {
		/******/ 			exports: {},
		/******/ 			id: moduleId,
		/******/ 			loaded: false
		/******/ 		};
	
		/******/ 		// Execute the module function
		/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
		/******/ 		// Flag the module as loaded
		/******/ 		module.loaded = true;
	
		/******/ 		// Return the exports of the module
		/******/ 		return module.exports;
		/******/ 	}
	
	
		/******/ 	// expose the modules object (__webpack_modules__)
		/******/ 	__webpack_require__.m = modules;
	
		/******/ 	// expose the module cache
		/******/ 	__webpack_require__.c = installedModules;
	
		/******/ 	// __webpack_public_path__
		/******/ 	__webpack_require__.p = "";
	
		/******/ 	// Load entry module and return exports
		/******/ 	return __webpack_require__(0);
		/******/ })
		/************************************************************************/
		/******/ ([
		/* 0 */
		/***/ function(module, exports, __webpack_require__) {
	
			"use strict";
	
			var React = __webpack_require__(1);
			var ReactDOM = __webpack_require__(2);
			var joinClasses = __webpack_require__(188);
	
			var Autocomplete = React.createClass({ displayName: "Autocomplete",
	
			  propTypes: {
			    options: React.PropTypes.any,
			    search: React.PropTypes.func,
			    resultRenderer: React.PropTypes.oneOfType([React.PropTypes.component, React.PropTypes.func]),
			    value: React.PropTypes.object,
			    onChange: React.PropTypes.func,
			    onError: React.PropTypes.func,
			    onFocus: React.PropTypes.func
			  },
	
			  getDefaultProps: function () {
			    return { search: searchArray };
			  },
	
			  getInitialState: function () {
			    var searchTerm = this.props.searchTerm ? this.props.searchTerm : this.props.value ? this.props.value.title : "";
			    return {
			      results: [],
			      showResults: false,
			      showResultsInProgress: false,
			      searchTerm: searchTerm,
			      focusedValue: null
			    };
			  },
	
			  getResultIdentifier: function (result) {
			    if (this.props.resultIdentifier === undefined) {
			      return result.id;
			    } else {
			      return result[this.props.resultIdentifier];
			    }
			  },
	
	
			  render: function () {
			    var className = joinClasses(this.props.className, "react-autocomplete-Autocomplete", this.state.showResults ? "react-autocomplete-Autocomplete--resultsShown" : undefined);
			    var style = {
			      position: "relative",
			      outline: "none"
			    };
			    return React.createElement("div", {
			      tabIndex: "1",
			      className: className,
			      onFocus: this.onFocus,
			      onBlur: this.onBlur,
			      style: style }, React.createElement("input", {
			      ref: "search",
			      className: "react-autocomplete-Autocomplete__search",
			      style: { width: "100%" },
			      onClick: this.showAllResults,
			      onChange: this.onQueryChange,
			      onFocus: this.onSearchInputFocus,
			      onBlur: this.onQueryBlur,
			      onKeyDown: this.onQueryKeyDown,
			      value: this.state.searchTerm }), React.createElement(Results, {
			      className: "react-autocomplete-Autocomplete__results",
			      onSelect: this.onValueChange,
			      onFocus: this.onValueFocus,
			      results: this.state.results,
			      focusedValue: this.state.focusedValue,
			      show: this.state.showResults,
			      renderer: this.props.resultRenderer,
			      label: this.props.label,
			      resultIdentifier: this.props.resultIdentifier }));
			  },
	
			  componentWillReceiveProps: function (nextProps) {
			    var searchTerm = nextProps.searchTerm ? nextProps.searchTerm : nextProps.value ? nextProps.value.title : "";
			    this.setState({ searchTerm: searchTerm });
			  },
	
			  componentWillMount: function () {
			    this.blurTimer = null;
			  },
	
			  /**
			    * Show results for a search term value.
			    *
			    * This method doesn't update search term value itself.
			    *
			    * @param {Search} searchTerm
			    */
			  showResults: function (searchTerm) {
			    this.setState({ showResultsInProgress: true });
			    this.props.search(this.props.options, searchTerm.trim(), this.onSearchComplete);
			  },
	
			  showAllResults: function () {
			    if (!this.state.showResultsInProgress && !this.state.showResults) {
			      this.showResults("");
			    }
			  },
	
			  onValueChange: function (value) {
			    var state = {
			      value: value,
			      showResults: false
			    };
	
			    if (value) {
			      state.searchTerm = value.title;
			    }
	
			    this.setState(state);
	
			    if (this.props.onChange) {
			      this.props.onChange(value);
			    }
			  },
	
			  onSearchComplete: function (err, results) {
			    if (err) {
			      if (this.props.onError) {
			        this.props.onError(err);
			      } else {
			        throw err;
			      }
			    }
	
			    this.setState({
			      showResultsInProgress: false,
			      showResults: true,
			      results: results
			    });
			  },
	
			  onValueFocus: function (value) {
			    this.setState({ focusedValue: value });
			  },
	
			  onQueryChange: function (e) {
			    var searchTerm = e.target.value;
			    this.setState({
			      searchTerm: searchTerm,
			      focusedValue: null
			    });
			    this.showResults(searchTerm);
			  },
	
			  onFocus: function () {
			    if (this.blurTimer) {
			      clearTimeout(this.blurTimer);
			      this.blurTimer = null;
			    }
			    this.refs.search.focus();
			  },
	
			  onSearchInputFocus: function () {
			    if (this.props.onFocus) {
			      this.props.onFocus();
			    }
	
			    this.showAllResults();
			  },
	
			  onBlur: function () {
			    // wrap in setTimeout so we can catch a click on results
			    this.blurTimer = setTimeout((function () {
			      if (this.isMounted()) {
			        this.setState({ showResults: false });
			      }
			    }).bind(this), 100);
			  },
	
			  onQueryKeyDown: function (e) {
			    if (e.key === "Enter") {
			      e.preventDefault();
			      if (this.state.focusedValue) {
			        this.onValueChange(this.state.focusedValue);
			      }
			    } else if (e.key === "ArrowUp" && this.state.showResults) {
			      e.preventDefault();
			      var prevIdx = Math.max(this.focusedValueIndex() - 1, 0);
			      this.setState({
			        focusedValue: this.state.results[prevIdx]
			      });
			    } else if (e.key === "ArrowDown") {
			      e.preventDefault();
			      if (this.state.showResults) {
			        var nextIdx = Math.min(this.focusedValueIndex() + (this.state.showResults ? 1 : 0), this.state.results.length - 1);
			        this.setState({
			          showResults: true,
			          focusedValue: this.state.results[nextIdx]
			        });
			      } else {
			        this.showAllResults();
			      }
			    }
			  },
	
			  focusedValueIndex: function () {
			    if (!this.state.focusedValue) {
			      return -1;
			    }
			    for (var i = 0, len = this.state.results.length; i < len; i++) {
			      if (this.getResultIdentifier(this.state.results[i]) === this.getResultIdentifier(this.state.focusedValue)) {
			        return i;
			      }
			    }
			    return -1;
			  }
			});
	
			var Results = React.createClass({ displayName: "Results",
	
			  getResultIdentifier: function (result) {
			    if (this.props.resultIdentifier === undefined) {
			      if (!result.id) {
			        throw Error("id property not found on result. You must specify a resultIdentifier and pass as props to autocomplete component");
			      }
			      return result.id;
			    } else {
			      return result[this.props.resultIdentifier];
			    }
			  },
	
			  render: function () {
			    var style = {
			      display: this.props.show ? "block" : "none",
			      position: "absolute",
			      listStyleType: "none"
			    };
			    var $__0 = this.props,
			        className = $__0.className,
			        props = (function (source, exclusion) {
			      var rest = {};var hasOwn = Object.prototype.hasOwnProperty;if (source == null) {
			        throw new TypeError();
			      }for (var key in source) {
			        if (hasOwn.call(source, key) && !hasOwn.call(exclusion, key)) {
			          rest[key] = source[key];
			        }
			      }return rest;
			    })($__0, { className: 1 });
	
			    return React.createElement("ul", { style: style, className: className + " react-autocomplete-Results" }, this.props.results.map(this.renderResult));
			  },
	
			  renderResult: function (result) {
			    var focused = this.props.focusedValue && this.getResultIdentifier(this.props.focusedValue) === this.getResultIdentifier(result);
			    var Renderer = this.props.renderer || Result;
			    return React.createElement(Renderer, {
			      ref: focused ? "focused" : undefined,
			      key: this.getResultIdentifier(result),
			      result: result,
			      focused: focused,
			      onMouseEnter: this.onMouseEnterResult,
			      onClick: this.props.onSelect,
			      label: this.props.label });
			  },
	
			  componentDidUpdate: function () {
			    this.scrollToFocused();
			  },
	
			  componentDidMount: function () {
			    this.scrollToFocused();
			  },
	
			  componentWillMount: function () {
			    this.ignoreFocus = false;
			  },
	
			  scrollToFocused: function () {
			    var focused = this.refs && this.refs.focused;
			    if (focused) {
			      var containerNode = ReactDOM.findDOMNode(this);
			      var scroll = containerNode.scrollTop;
			      var height = containerNode.offsetHeight;
	
			      var node = ReactDOM.findDOMNode(focused);
			      var top = node.offsetTop;
			      var bottom = top + node.offsetHeight;
	
			      // we update ignoreFocus to true if we change the scroll position so
			      // the mouseover event triggered because of that won't have an
			      // effect
			      if (top < scroll) {
			        this.ignoreFocus = true;
			        containerNode.scrollTop = top;
			      } else if (bottom - scroll > height) {
			        this.ignoreFocus = true;
			        containerNode.scrollTop = bottom - height;
			      }
			    }
			  },
	
			  onMouseEnterResult: function (e, result) {
			    // check if we need to prevent the next onFocus event because it was
			    // probably caused by a mouseover due to scroll position change
			    if (this.ignoreFocus) {
			      this.ignoreFocus = false;
			    } else {
			      // we need to make sure focused node is visible
			      // for some reason mouse events fire on visible nodes due to
			      // box-shadow
			      var containerNode = ReactDOM.findDOMNode(this);
			      var scroll = containerNode.scrollTop;
			      var height = containerNode.offsetHeight;
	
			      var node = e.target;
			      var top = node.offsetTop;
			      var bottom = top + node.offsetHeight;
	
			      if (bottom > scroll && top < scroll + height) {
			        this.props.onFocus(result);
			      }
			    }
			  }
			});
	
			var Result = React.createClass({ displayName: "Result",
	
			  getDefaultProps: function () {
			    return {
			      label: function (result) {
			        return result.title;
			      }
			    };
			  },
	
			  getLabel: function (result) {
			    if (typeof this.props.label === "function") {
			      return this.props.label(result);
			    } else if (typeof this.props.label === "string") {
			      return result[this.props.label];
			    }
			  },
	
			  render: function () {
			    var className = joinClasses({
			      "react-autocomplete-Result": true,
			      "react-autocomplete-Result--active": this.props.focused
			    });
	
			    return React.createElement("li", {
			      style: { listStyleType: "none" },
			      className: className,
			      onClick: this.onClick,
			      onMouseEnter: this.onMouseEnter }, React.createElement("a", null, this.getLabel(this.props.result)));
			  },
	
			  onClick: function () {
			    this.props.onClick(this.props.result);
			  },
	
			  onMouseEnter: function (e) {
			    if (this.props.onMouseEnter) {
			      this.props.onMouseEnter(e, this.props.result);
			    }
			  },
	
			  shouldComponentUpdate: function (nextProps) {
			    return nextProps.result.id !== this.props.result.id || nextProps.focused !== this.props.focused;
			  }
			});
	
			/**
			* Search options using specified search term treating options as an array
			* of candidates.
			*
			* @param {Array.<Object>} options
			* @param {String} searchTerm
			* @param {Callback} cb
			*/
			function searchArray(options, searchTerm, cb) {
			  if (!options) {
			    return cb(null, []);
			  }
	
			  searchTerm = new RegExp(searchTerm, "i");
	
			  var results = [];
	
			  for (var i = 0, len = options.length; i < len; i++) {
			    if (searchTerm.exec(options[i].title)) {
			      results.push(options[i]);
			    }
			  }
	
			  cb(null, results);
			}
	
			module.exports = Autocomplete;
	
		/***/ },
		/* 1 */
		/***/ function(module, exports) {
	
			module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
		/***/ },
		/* 2 */
		/***/ function(module, exports, __webpack_require__) {
	
			'use strict';
	
			module.exports = __webpack_require__(3);
	
	
		/***/ },
		/* 3 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
			'use strict';
	
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactDefaultInjection = __webpack_require__(10);
			var ReactMount = __webpack_require__(176);
			var ReactReconciler = __webpack_require__(34);
			var ReactUpdates = __webpack_require__(31);
			var ReactVersion = __webpack_require__(181);
	
			var findDOMNode = __webpack_require__(182);
			var getHostComponentFromComposite = __webpack_require__(183);
			var renderSubtreeIntoContainer = __webpack_require__(184);
			var warning = __webpack_require__(18);
	
			ReactDefaultInjection.inject();
	
			var ReactDOM = {
			  findDOMNode: findDOMNode,
			  render: ReactMount.render,
			  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
			  version: ReactVersion,
	
			  /* eslint-disable camelcase */
			  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
			  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
			};
	
			// Inject the runtime into a devtools global hook regardless of browser.
			// Allows for debugging when the hook is injected on the page.
			if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
			  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
			    ComponentTree: {
			      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
			      getNodeFromInstance: function (inst) {
			        // inst is an internal instance (but could be a composite)
			        if (inst._renderedComponent) {
			          inst = getHostComponentFromComposite(inst);
			        }
			        if (inst) {
			          return ReactDOMComponentTree.getNodeFromInstance(inst);
			        } else {
			          return null;
			        }
			      }
			    },
			    Mount: ReactMount,
			    Reconciler: ReactReconciler
			  });
			}
	
			if (process.env.NODE_ENV !== 'production') {
			  var ExecutionEnvironment = __webpack_require__(22);
			  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
			    // First check if devtools is not installed
			    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
			      // If we're in Chrome or Firefox, provide a download link if not installed.
			      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
			        // Firefox does not have the issue with devtools loaded over file://
			        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
			        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
			      }
			    }
	
			    var testFunc = function testFn() {};
			    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
			    // If we're in IE8, check to see if we are in compatibility mode and provide
			    // information on preventing compatibility mode
			    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
			    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
			    var expectedFeatures = [
			    // shims
			    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
			    for (var i = 0; i < expectedFeatures.length; i++) {
			      if (!expectedFeatures[i]) {
			        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
			        break;
			      }
			    }
			  }
			}
	
			if (process.env.NODE_ENV !== 'production') {
			  var ReactInstrumentation = __webpack_require__(37);
			  var ReactDOMUnknownPropertyHook = __webpack_require__(185);
			  var ReactDOMNullInputValuePropHook = __webpack_require__(186);
			  var ReactDOMInvalidARIAHook = __webpack_require__(187);
	
			  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
			  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
			  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
			}
	
			module.exports = ReactDOM;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 4 */
		/***/ function(module, exports) {
	
			// shim for using process in browser
			var process = module.exports = {};
	
			// cached from whatever global is present so that test runners that stub it
			// don't break things.  But we need to wrap it in a try catch in case it is
			// wrapped in strict mode code which doesn't define any globals.  It's inside a
			// function because try/catches deoptimize in certain engines.
	
			var cachedSetTimeout;
			var cachedClearTimeout;
	
			function defaultSetTimout() {
			    throw new Error('setTimeout has not been defined');
			}
			function defaultClearTimeout () {
			    throw new Error('clearTimeout has not been defined');
			}
			(function () {
			    try {
			        if (typeof setTimeout === 'function') {
			            cachedSetTimeout = setTimeout;
			        } else {
			            cachedSetTimeout = defaultSetTimout;
			        }
			    } catch (e) {
			        cachedSetTimeout = defaultSetTimout;
			    }
			    try {
			        if (typeof clearTimeout === 'function') {
			            cachedClearTimeout = clearTimeout;
			        } else {
			            cachedClearTimeout = defaultClearTimeout;
			        }
			    } catch (e) {
			        cachedClearTimeout = defaultClearTimeout;
			    }
			} ())
			function runTimeout(fun) {
			    if (cachedSetTimeout === setTimeout) {
			        //normal enviroments in sane situations
			        return setTimeout(fun, 0);
			    }
			    // if setTimeout wasn't available but was latter defined
			    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
			        cachedSetTimeout = setTimeout;
			        return setTimeout(fun, 0);
			    }
			    try {
			        // when when somebody has screwed with setTimeout but no I.E. maddness
			        return cachedSetTimeout(fun, 0);
			    } catch(e){
			        try {
			            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
			            return cachedSetTimeout.call(null, fun, 0);
			        } catch(e){
			            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
			            return cachedSetTimeout.call(this, fun, 0);
			        }
			    }
	
	
			}
			function runClearTimeout(marker) {
			    if (cachedClearTimeout === clearTimeout) {
			        //normal enviroments in sane situations
			        return clearTimeout(marker);
			    }
			    // if clearTimeout wasn't available but was latter defined
			    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
			        cachedClearTimeout = clearTimeout;
			        return clearTimeout(marker);
			    }
			    try {
			        // when when somebody has screwed with setTimeout but no I.E. maddness
			        return cachedClearTimeout(marker);
			    } catch (e){
			        try {
			            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
			            return cachedClearTimeout.call(null, marker);
			        } catch (e){
			            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
			            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
			            return cachedClearTimeout.call(this, marker);
			        }
			    }
	
	
	
			}
			var queue = [];
			var draining = false;
			var currentQueue;
			var queueIndex = -1;
	
			function cleanUpNextTick() {
			    if (!draining || !currentQueue) {
			        return;
			    }
			    draining = false;
			    if (currentQueue.length) {
			        queue = currentQueue.concat(queue);
			    } else {
			        queueIndex = -1;
			    }
			    if (queue.length) {
			        drainQueue();
			    }
			}
	
			function drainQueue() {
			    if (draining) {
			        return;
			    }
			    var timeout = runTimeout(cleanUpNextTick);
			    draining = true;
	
			    var len = queue.length;
			    while(len) {
			        currentQueue = queue;
			        queue = [];
			        while (++queueIndex < len) {
			            if (currentQueue) {
			                currentQueue[queueIndex].run();
			            }
			        }
			        queueIndex = -1;
			        len = queue.length;
			    }
			    currentQueue = null;
			    draining = false;
			    runClearTimeout(timeout);
			}
	
			process.nextTick = function (fun) {
			    var args = new Array(arguments.length - 1);
			    if (arguments.length > 1) {
			        for (var i = 1; i < arguments.length; i++) {
			            args[i - 1] = arguments[i];
			        }
			    }
			    queue.push(new Item(fun, args));
			    if (queue.length === 1 && !draining) {
			        runTimeout(drainQueue);
			    }
			};
	
			// v8 likes predictible objects
			function Item(fun, array) {
			    this.fun = fun;
			    this.array = array;
			}
			Item.prototype.run = function () {
			    this.fun.apply(null, this.array);
			};
			process.title = 'browser';
			process.browser = true;
			process.env = {};
			process.argv = [];
			process.version = ''; // empty string to avoid regexp issues
			process.versions = {};
	
			function noop() {}
	
			process.on = noop;
			process.addListener = noop;
			process.once = noop;
			process.off = noop;
			process.removeListener = noop;
			process.removeAllListeners = noop;
			process.emit = noop;
	
			process.binding = function (name) {
			    throw new Error('process.binding is not supported');
			};
	
			process.cwd = function () { return '/' };
			process.chdir = function (dir) {
			    throw new Error('process.chdir is not supported');
			};
			process.umask = function() { return 0; };
	
	
		/***/ },
		/* 5 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var DOMProperty = __webpack_require__(7);
			var ReactDOMComponentFlags = __webpack_require__(9);
	
			var invariant = __webpack_require__(8);
	
			var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
			var Flags = ReactDOMComponentFlags;
	
			var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
			/**
			 * Check if a given node should be cached.
			 */
			function shouldPrecacheNode(node, nodeID) {
			  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
			}
	
			/**
			 * Drill down (through composites and empty components) until we get a host or
			 * host text component.
			 *
			 * This is pretty polymorphic but unavoidable with the current structure we have
			 * for `_renderedChildren`.
			 */
			function getRenderedHostOrTextFromComponent(component) {
			  var rendered;
			  while (rendered = component._renderedComponent) {
			    component = rendered;
			  }
			  return component;
			}
	
			/**
			 * Populate `_hostNode` on the rendered host/text component with the given
			 * DOM node. The passed `inst` can be a composite.
			 */
			function precacheNode(inst, node) {
			  var hostInst = getRenderedHostOrTextFromComponent(inst);
			  hostInst._hostNode = node;
			  node[internalInstanceKey] = hostInst;
			}
	
			function uncacheNode(inst) {
			  var node = inst._hostNode;
			  if (node) {
			    delete node[internalInstanceKey];
			    inst._hostNode = null;
			  }
			}
	
			/**
			 * Populate `_hostNode` on each child of `inst`, assuming that the children
			 * match up with the DOM (element) children of `node`.
			 *
			 * We cache entire levels at once to avoid an n^2 problem where we access the
			 * children of a node sequentially and have to walk from the start to our target
			 * node every time.
			 *
			 * Since we update `_renderedChildren` and the actual DOM at (slightly)
			 * different times, we could race here and see a newer `_renderedChildren` than
			 * the DOM nodes we see. To avoid this, ReactMultiChild calls
			 * `prepareToManageChildren` before we change `_renderedChildren`, at which
			 * time the container's child nodes are always cached (until it unmounts).
			 */
			function precacheChildNodes(inst, node) {
			  if (inst._flags & Flags.hasCachedChildNodes) {
			    return;
			  }
			  var children = inst._renderedChildren;
			  var childNode = node.firstChild;
			  outer: for (var name in children) {
			    if (!children.hasOwnProperty(name)) {
			      continue;
			    }
			    var childInst = children[name];
			    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
			    if (childID === 0) {
			      // We're currently unmounting this child in ReactMultiChild; skip it.
			      continue;
			    }
			    // We assume the child nodes are in the same order as the child instances.
			    for (; childNode !== null; childNode = childNode.nextSibling) {
			      if (shouldPrecacheNode(childNode, childID)) {
			        precacheNode(childInst, childNode);
			        continue outer;
			      }
			    }
			    // We reached the end of the DOM children without finding an ID match.
			     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
			  }
			  inst._flags |= Flags.hasCachedChildNodes;
			}
	
			/**
			 * Given a DOM node, return the closest ReactDOMComponent or
			 * ReactDOMTextComponent instance ancestor.
			 */
			function getClosestInstanceFromNode(node) {
			  if (node[internalInstanceKey]) {
			    return node[internalInstanceKey];
			  }
	
			  // Walk up the tree until we find an ancestor whose instance we have cached.
			  var parents = [];
			  while (!node[internalInstanceKey]) {
			    parents.push(node);
			    if (node.parentNode) {
			      node = node.parentNode;
			    } else {
			      // Top of the tree. This node must not be part of a React tree (or is
			      // unmounted, potentially).
			      return null;
			    }
			  }
	
			  var closest;
			  var inst;
			  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
			    closest = inst;
			    if (parents.length) {
			      precacheChildNodes(inst, node);
			    }
			  }
	
			  return closest;
			}
	
			/**
			 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
			 * instance, or null if the node was not rendered by this React.
			 */
			function getInstanceFromNode(node) {
			  var inst = getClosestInstanceFromNode(node);
			  if (inst != null && inst._hostNode === node) {
			    return inst;
			  } else {
			    return null;
			  }
			}
	
			/**
			 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
			 * DOM node.
			 */
			function getNodeFromInstance(inst) {
			  // Without this first invariant, passing a non-DOM-component triggers the next
			  // invariant for a missing parent, which is super confusing.
			  !(inst._hostNode !== undefined) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
			  if (inst._hostNode) {
			    return inst._hostNode;
			  }
	
			  // Walk up the tree until we find an ancestor whose DOM node we have cached.
			  var parents = [];
			  while (!inst._hostNode) {
			    parents.push(inst);
			    !inst._hostParent ? process.env.NODE_ENV !== 'production' ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
			    inst = inst._hostParent;
			  }
	
			  // Now parents contains each ancestor that does *not* have a cached native
			  // node, and `inst` is the deepest ancestor that does.
			  for (; parents.length; inst = parents.pop()) {
			    precacheChildNodes(inst, inst._hostNode);
			  }
	
			  return inst._hostNode;
			}
	
			var ReactDOMComponentTree = {
			  getClosestInstanceFromNode: getClosestInstanceFromNode,
			  getInstanceFromNode: getInstanceFromNode,
			  getNodeFromInstance: getNodeFromInstance,
			  precacheChildNodes: precacheChildNodes,
			  precacheNode: precacheNode,
			  uncacheNode: uncacheNode
			};
	
			module.exports = ReactDOMComponentTree;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 6 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
			'use strict';
	
			/**
			 * WARNING: DO NOT manually require this module.
			 * This is a replacement for `invariant(...)` used by the error code system
			 * and will _only_ be required by the corresponding babel pass.
			 * It always throws.
			 */
	
			function reactProdInvariant(code) {
			  var argCount = arguments.length - 1;
	
			  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
			  for (var argIdx = 0; argIdx < argCount; argIdx++) {
			    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
			  }
	
			  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
			  var error = new Error(message);
			  error.name = 'Invariant Violation';
			  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
			  throw error;
			}
	
			module.exports = reactProdInvariant;
	
		/***/ },
		/* 7 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			function checkMask(value, bitmask) {
			  return (value & bitmask) === bitmask;
			}
	
			var DOMPropertyInjection = {
			  /**
			   * Mapping from normalized, camelcased property names to a configuration that
			   * specifies how the associated DOM property should be accessed or rendered.
			   */
			  MUST_USE_PROPERTY: 0x1,
			  HAS_BOOLEAN_VALUE: 0x4,
			  HAS_NUMERIC_VALUE: 0x8,
			  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
			  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
			  /**
			   * Inject some specialized knowledge about the DOM. This takes a config object
			   * with the following properties:
			   *
			   * isCustomAttribute: function that given an attribute name will return true
			   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
			   * attributes where it's impossible to enumerate all of the possible
			   * attribute names,
			   *
			   * Properties: object mapping DOM property name to one of the
			   * DOMPropertyInjection constants or null. If your attribute isn't in here,
			   * it won't get written to the DOM.
			   *
			   * DOMAttributeNames: object mapping React attribute name to the DOM
			   * attribute name. Attribute names not specified use the **lowercase**
			   * normalized name.
			   *
			   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
			   * attribute namespace URL. (Attribute names not specified use no namespace.)
			   *
			   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
			   * Property names not specified use the normalized name.
			   *
			   * DOMMutationMethods: Properties that require special mutation methods. If
			   * `value` is undefined, the mutation method should unset the property.
			   *
			   * @param {object} domPropertyConfig the config as described above.
			   */
			  injectDOMPropertyConfig: function (domPropertyConfig) {
			    var Injection = DOMPropertyInjection;
			    var Properties = domPropertyConfig.Properties || {};
			    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
			    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
			    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
			    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
			    if (domPropertyConfig.isCustomAttribute) {
			      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
			    }
	
			    for (var propName in Properties) {
			      !!DOMProperty.properties.hasOwnProperty(propName) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
			      var lowerCased = propName.toLowerCase();
			      var propConfig = Properties[propName];
	
			      var propertyInfo = {
			        attributeName: lowerCased,
			        attributeNamespace: null,
			        propertyName: propName,
			        mutationMethod: null,
	
			        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
			        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
			        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
			        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
			        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
			      };
			      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
			      if (process.env.NODE_ENV !== 'production') {
			        DOMProperty.getPossibleStandardName[lowerCased] = propName;
			      }
	
			      if (DOMAttributeNames.hasOwnProperty(propName)) {
			        var attributeName = DOMAttributeNames[propName];
			        propertyInfo.attributeName = attributeName;
			        if (process.env.NODE_ENV !== 'production') {
			          DOMProperty.getPossibleStandardName[attributeName] = propName;
			        }
			      }
	
			      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
			        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
			      }
	
			      if (DOMPropertyNames.hasOwnProperty(propName)) {
			        propertyInfo.propertyName = DOMPropertyNames[propName];
			      }
	
			      if (DOMMutationMethods.hasOwnProperty(propName)) {
			        propertyInfo.mutationMethod = DOMMutationMethods[propName];
			      }
	
			      DOMProperty.properties[propName] = propertyInfo;
			    }
			  }
			};
	
			/* eslint-disable max-len */
			var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
			/* eslint-enable max-len */
	
			/**
			 * DOMProperty exports lookup objects that can be used like functions:
			 *
			 *   > DOMProperty.isValid['id']
			 *   true
			 *   > DOMProperty.isValid['foobar']
			 *   undefined
			 *
			 * Although this may be confusing, it performs better in general.
			 *
			 * @see http://jsperf.com/key-exists
			 * @see http://jsperf.com/key-missing
			 */
			var DOMProperty = {
	
			  ID_ATTRIBUTE_NAME: 'data-reactid',
			  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
			  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
			  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
			  /**
			   * Map from property "standard name" to an object with info about how to set
			   * the property in the DOM. Each object contains:
			   *
			   * attributeName:
			   *   Used when rendering markup or with `*Attribute()`.
			   * attributeNamespace
			   * propertyName:
			   *   Used on DOM node instances. (This includes properties that mutate due to
			   *   external factors.)
			   * mutationMethod:
			   *   If non-null, used instead of the property or `setAttribute()` after
			   *   initial render.
			   * mustUseProperty:
			   *   Whether the property must be accessed and mutated as an object property.
			   * hasBooleanValue:
			   *   Whether the property should be removed when set to a falsey value.
			   * hasNumericValue:
			   *   Whether the property must be numeric or parse as a numeric and should be
			   *   removed when set to a falsey value.
			   * hasPositiveNumericValue:
			   *   Whether the property must be positive numeric or parse as a positive
			   *   numeric and should be removed when set to a falsey value.
			   * hasOverloadedBooleanValue:
			   *   Whether the property can be used as a flag as well as with a value.
			   *   Removed when strictly equal to false; present without a value when
			   *   strictly equal to true; present with a value otherwise.
			   */
			  properties: {},
	
			  /**
			   * Mapping from lowercase property names to the properly cased version, used
			   * to warn in the case of missing properties. Available only in __DEV__.
			   *
			   * autofocus is predefined, because adding it to the property whitelist
			   * causes unintended side effects.
			   *
			   * @type {Object}
			   */
			  getPossibleStandardName: process.env.NODE_ENV !== 'production' ? { autofocus: 'autoFocus' } : null,
	
			  /**
			   * All of the isCustomAttribute() functions that have been injected.
			   */
			  _isCustomAttributeFunctions: [],
	
			  /**
			   * Checks whether a property name is a custom attribute.
			   * @method
			   */
			  isCustomAttribute: function (attributeName) {
			    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
			      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
			      if (isCustomAttributeFn(attributeName)) {
			        return true;
			      }
			    }
			    return false;
			  },
	
			  injection: DOMPropertyInjection
			};
	
			module.exports = DOMProperty;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 8 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * Use invariant() to assert state which your program assumes to be true.
			 *
			 * Provide sprintf-style format (only %s is supported) and arguments
			 * to provide information about what broke and what you were
			 * expecting.
			 *
			 * The invariant message will be stripped in production, but the invariant
			 * will remain to ensure logic does not differ in production.
			 */
	
			var validateFormat = function validateFormat(format) {};
	
			if (process.env.NODE_ENV !== 'production') {
			  validateFormat = function validateFormat(format) {
			    if (format === undefined) {
			      throw new Error('invariant requires an error message argument');
			    }
			  };
			}
	
			function invariant(condition, format, a, b, c, d, e, f) {
			  validateFormat(format);
	
			  if (!condition) {
			    var error;
			    if (format === undefined) {
			      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
			    } else {
			      var args = [a, b, c, d, e, f];
			      var argIndex = 0;
			      error = new Error(format.replace(/%s/g, function () {
			        return args[argIndex++];
			      }));
			      error.name = 'Invariant Violation';
			    }
	
			    error.framesToPop = 1; // we don't care about invariant's own frame
			    throw error;
			  }
			}
	
			module.exports = invariant;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 9 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2015-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactDOMComponentFlags = {
			  hasCachedChildNodes: 1 << 0
			};
	
			module.exports = ReactDOMComponentFlags;
	
		/***/ },
		/* 10 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ARIADOMPropertyConfig = __webpack_require__(11);
			var BeforeInputEventPlugin = __webpack_require__(12);
			var ChangeEventPlugin = __webpack_require__(30);
			var DefaultEventPluginOrder = __webpack_require__(53);
			var EnterLeaveEventPlugin = __webpack_require__(54);
			var HTMLDOMPropertyConfig = __webpack_require__(59);
			var ReactComponentBrowserEnvironment = __webpack_require__(60);
			var ReactDOMComponent = __webpack_require__(73);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactDOMEmptyComponent = __webpack_require__(147);
			var ReactDOMTreeTraversal = __webpack_require__(148);
			var ReactDOMTextComponent = __webpack_require__(149);
			var ReactDefaultBatchingStrategy = __webpack_require__(150);
			var ReactEventListener = __webpack_require__(151);
			var ReactInjection = __webpack_require__(154);
			var ReactReconcileTransaction = __webpack_require__(155);
			var SVGDOMPropertyConfig = __webpack_require__(163);
			var SelectEventPlugin = __webpack_require__(164);
			var SimpleEventPlugin = __webpack_require__(165);
	
			var alreadyInjected = false;
	
			function inject() {
			  if (alreadyInjected) {
			    // TODO: This is currently true because these injections are shared between
			    // the client and the server package. They should be built independently
			    // and not share any injection state. Then this problem will be solved.
			    return;
			  }
			  alreadyInjected = true;
	
			  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
			  /**
			   * Inject modules for resolving DOM hierarchy and plugin ordering.
			   */
			  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
			  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
			  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
			  /**
			   * Some important event plugins included by default (without having to require
			   * them).
			   */
			  ReactInjection.EventPluginHub.injectEventPluginsByName({
			    SimpleEventPlugin: SimpleEventPlugin,
			    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
			    ChangeEventPlugin: ChangeEventPlugin,
			    SelectEventPlugin: SelectEventPlugin,
			    BeforeInputEventPlugin: BeforeInputEventPlugin
			  });
	
			  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
			  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
			  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
			  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
			  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
			  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
			    return new ReactDOMEmptyComponent(instantiate);
			  });
	
			  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
			  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
			  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
			}
	
			module.exports = {
			  inject: inject
			};
	
		/***/ },
		/* 11 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ARIADOMPropertyConfig = {
			  Properties: {
			    // Global States and Properties
			    'aria-current': 0, // state
			    'aria-details': 0,
			    'aria-disabled': 0, // state
			    'aria-hidden': 0, // state
			    'aria-invalid': 0, // state
			    'aria-keyshortcuts': 0,
			    'aria-label': 0,
			    'aria-roledescription': 0,
			    // Widget Attributes
			    'aria-autocomplete': 0,
			    'aria-checked': 0,
			    'aria-expanded': 0,
			    'aria-haspopup': 0,
			    'aria-level': 0,
			    'aria-modal': 0,
			    'aria-multiline': 0,
			    'aria-multiselectable': 0,
			    'aria-orientation': 0,
			    'aria-placeholder': 0,
			    'aria-pressed': 0,
			    'aria-readonly': 0,
			    'aria-required': 0,
			    'aria-selected': 0,
			    'aria-sort': 0,
			    'aria-valuemax': 0,
			    'aria-valuemin': 0,
			    'aria-valuenow': 0,
			    'aria-valuetext': 0,
			    // Live Region Attributes
			    'aria-atomic': 0,
			    'aria-busy': 0,
			    'aria-live': 0,
			    'aria-relevant': 0,
			    // Drag-and-Drop Attributes
			    'aria-dropeffect': 0,
			    'aria-grabbed': 0,
			    // Relationship Attributes
			    'aria-activedescendant': 0,
			    'aria-colcount': 0,
			    'aria-colindex': 0,
			    'aria-colspan': 0,
			    'aria-controls': 0,
			    'aria-describedby': 0,
			    'aria-errormessage': 0,
			    'aria-flowto': 0,
			    'aria-labelledby': 0,
			    'aria-owns': 0,
			    'aria-posinset': 0,
			    'aria-rowcount': 0,
			    'aria-rowindex': 0,
			    'aria-rowspan': 0,
			    'aria-setsize': 0
			  },
			  DOMAttributeNames: {},
			  DOMPropertyNames: {}
			};
	
			module.exports = ARIADOMPropertyConfig;
	
		/***/ },
		/* 12 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var EventPropagators = __webpack_require__(13);
			var ExecutionEnvironment = __webpack_require__(22);
			var FallbackCompositionState = __webpack_require__(23);
			var SyntheticCompositionEvent = __webpack_require__(27);
			var SyntheticInputEvent = __webpack_require__(29);
	
			var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
			var START_KEYCODE = 229;
	
			var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
			var documentMode = null;
			if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
			  documentMode = document.documentMode;
			}
	
			// Webkit offers a very useful `textInput` event that can be used to
			// directly represent `beforeInput`. The IE `textinput` event is not as
			// useful, so we don't use it.
			var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
			// In IE9+, we have access to composition events, but the data supplied
			// by the native compositionend event may be incorrect. Japanese ideographic
			// spaces, for instance (\u3000) are not recorded correctly.
			var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
			/**
			 * Opera <= 12 includes TextEvent in window, but does not fire
			 * text input events. Rely on keypress instead.
			 */
			function isPresto() {
			  var opera = window.opera;
			  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
			}
	
			var SPACEBAR_CODE = 32;
			var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
			// Events and their corresponding property names.
			var eventTypes = {
			  beforeInput: {
			    phasedRegistrationNames: {
			      bubbled: 'onBeforeInput',
			      captured: 'onBeforeInputCapture'
			    },
			    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
			  },
			  compositionEnd: {
			    phasedRegistrationNames: {
			      bubbled: 'onCompositionEnd',
			      captured: 'onCompositionEndCapture'
			    },
			    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
			  },
			  compositionStart: {
			    phasedRegistrationNames: {
			      bubbled: 'onCompositionStart',
			      captured: 'onCompositionStartCapture'
			    },
			    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
			  },
			  compositionUpdate: {
			    phasedRegistrationNames: {
			      bubbled: 'onCompositionUpdate',
			      captured: 'onCompositionUpdateCapture'
			    },
			    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
			  }
			};
	
			// Track whether we've ever handled a keypress on the space key.
			var hasSpaceKeypress = false;
	
			/**
			 * Return whether a native keypress event is assumed to be a command.
			 * This is required because Firefox fires `keypress` events for key commands
			 * (cut, copy, select-all, etc.) even though no character is inserted.
			 */
			function isKeypressCommand(nativeEvent) {
			  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
			  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
			  !(nativeEvent.ctrlKey && nativeEvent.altKey);
			}
	
			/**
			 * Translate native top level events into event types.
			 *
			 * @param {string} topLevelType
			 * @return {object}
			 */
			function getCompositionEventType(topLevelType) {
			  switch (topLevelType) {
			    case 'topCompositionStart':
			      return eventTypes.compositionStart;
			    case 'topCompositionEnd':
			      return eventTypes.compositionEnd;
			    case 'topCompositionUpdate':
			      return eventTypes.compositionUpdate;
			  }
			}
	
			/**
			 * Does our fallback best-guess model think this event signifies that
			 * composition has begun?
			 *
			 * @param {string} topLevelType
			 * @param {object} nativeEvent
			 * @return {boolean}
			 */
			function isFallbackCompositionStart(topLevelType, nativeEvent) {
			  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
			}
	
			/**
			 * Does our fallback mode think that this event is the end of composition?
			 *
			 * @param {string} topLevelType
			 * @param {object} nativeEvent
			 * @return {boolean}
			 */
			function isFallbackCompositionEnd(topLevelType, nativeEvent) {
			  switch (topLevelType) {
			    case 'topKeyUp':
			      // Command keys insert or clear IME input.
			      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
			    case 'topKeyDown':
			      // Expect IME keyCode on each keydown. If we get any other
			      // code we must have exited earlier.
			      return nativeEvent.keyCode !== START_KEYCODE;
			    case 'topKeyPress':
			    case 'topMouseDown':
			    case 'topBlur':
			      // Events are not possible without cancelling IME.
			      return true;
			    default:
			      return false;
			  }
			}
	
			/**
			 * Google Input Tools provides composition data via a CustomEvent,
			 * with the `data` property populated in the `detail` object. If this
			 * is available on the event object, use it. If not, this is a plain
			 * composition event and we have nothing special to extract.
			 *
			 * @param {object} nativeEvent
			 * @return {?string}
			 */
			function getDataFromCustomEvent(nativeEvent) {
			  var detail = nativeEvent.detail;
			  if (typeof detail === 'object' && 'data' in detail) {
			    return detail.data;
			  }
			  return null;
			}
	
			// Track the current IME composition fallback object, if any.
			var currentComposition = null;
	
			/**
			 * @return {?object} A SyntheticCompositionEvent.
			 */
			function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			  var eventType;
			  var fallbackData;
	
			  if (canUseCompositionEvent) {
			    eventType = getCompositionEventType(topLevelType);
			  } else if (!currentComposition) {
			    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
			      eventType = eventTypes.compositionStart;
			    }
			  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
			    eventType = eventTypes.compositionEnd;
			  }
	
			  if (!eventType) {
			    return null;
			  }
	
			  if (useFallbackCompositionData) {
			    // The current composition is stored statically and must not be
			    // overwritten while composition continues.
			    if (!currentComposition && eventType === eventTypes.compositionStart) {
			      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
			    } else if (eventType === eventTypes.compositionEnd) {
			      if (currentComposition) {
			        fallbackData = currentComposition.getData();
			      }
			    }
			  }
	
			  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
			  if (fallbackData) {
			    // Inject data generated from fallback path into the synthetic event.
			    // This matches the property of native CompositionEventInterface.
			    event.data = fallbackData;
			  } else {
			    var customData = getDataFromCustomEvent(nativeEvent);
			    if (customData !== null) {
			      event.data = customData;
			    }
			  }
	
			  EventPropagators.accumulateTwoPhaseDispatches(event);
			  return event;
			}
	
			/**
			 * @param {string} topLevelType Record from `EventConstants`.
			 * @param {object} nativeEvent Native browser event.
			 * @return {?string} The string corresponding to this `beforeInput` event.
			 */
			function getNativeBeforeInputChars(topLevelType, nativeEvent) {
			  switch (topLevelType) {
			    case 'topCompositionEnd':
			      return getDataFromCustomEvent(nativeEvent);
			    case 'topKeyPress':
			      /**
			       * If native `textInput` events are available, our goal is to make
			       * use of them. However, there is a special case: the spacebar key.
			       * In Webkit, preventing default on a spacebar `textInput` event
			       * cancels character insertion, but it *also* causes the browser
			       * to fall back to its default spacebar behavior of scrolling the
			       * page.
			       *
			       * Tracking at:
			       * https://code.google.com/p/chromium/issues/detail?id=355103
			       *
			       * To avoid this issue, use the keypress event as if no `textInput`
			       * event is available.
			       */
			      var which = nativeEvent.which;
			      if (which !== SPACEBAR_CODE) {
			        return null;
			      }
	
			      hasSpaceKeypress = true;
			      return SPACEBAR_CHAR;
	
			    case 'topTextInput':
			      // Record the characters to be added to the DOM.
			      var chars = nativeEvent.data;
	
			      // If it's a spacebar character, assume that we have already handled
			      // it at the keypress level and bail immediately. Android Chrome
			      // doesn't give us keycodes, so we need to blacklist it.
			      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
			        return null;
			      }
	
			      return chars;
	
			    default:
			      // For other native event types, do nothing.
			      return null;
			  }
			}
	
			/**
			 * For browsers that do not provide the `textInput` event, extract the
			 * appropriate string to use for SyntheticInputEvent.
			 *
			 * @param {string} topLevelType Record from `EventConstants`.
			 * @param {object} nativeEvent Native browser event.
			 * @return {?string} The fallback string for this `beforeInput` event.
			 */
			function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
			  // If we are currently composing (IME) and using a fallback to do so,
			  // try to extract the composed characters from the fallback object.
			  // If composition event is available, we extract a string only at
			  // compositionevent, otherwise extract it at fallback events.
			  if (currentComposition) {
			    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
			      var chars = currentComposition.getData();
			      FallbackCompositionState.release(currentComposition);
			      currentComposition = null;
			      return chars;
			    }
			    return null;
			  }
	
			  switch (topLevelType) {
			    case 'topPaste':
			      // If a paste event occurs after a keypress, throw out the input
			      // chars. Paste events should not lead to BeforeInput events.
			      return null;
			    case 'topKeyPress':
			      /**
			       * As of v27, Firefox may fire keypress events even when no character
			       * will be inserted. A few possibilities:
			       *
			       * - `which` is `0`. Arrow keys, Esc key, etc.
			       *
			       * - `which` is the pressed key code, but no char is available.
			       *   Ex: 'AltGr + d` in Polish. There is no modified character for
			       *   this key combination and no character is inserted into the
			       *   document, but FF fires the keypress for char code `100` anyway.
			       *   No `input` event will occur.
			       *
			       * - `which` is the pressed key code, but a command combination is
			       *   being used. Ex: `Cmd+C`. No character is inserted, and no
			       *   `input` event will occur.
			       */
			      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
			        return String.fromCharCode(nativeEvent.which);
			      }
			      return null;
			    case 'topCompositionEnd':
			      return useFallbackCompositionData ? null : nativeEvent.data;
			    default:
			      return null;
			  }
			}
	
			/**
			 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
			 * `textInput` or fallback behavior.
			 *
			 * @return {?object} A SyntheticInputEvent.
			 */
			function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			  var chars;
	
			  if (canUseTextInputEvent) {
			    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
			  } else {
			    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
			  }
	
			  // If no characters are being inserted, no BeforeInput event should
			  // be fired.
			  if (!chars) {
			    return null;
			  }
	
			  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
			  event.data = chars;
			  EventPropagators.accumulateTwoPhaseDispatches(event);
			  return event;
			}
	
			/**
			 * Create an `onBeforeInput` event to match
			 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
			 *
			 * This event plugin is based on the native `textInput` event
			 * available in Chrome, Safari, Opera, and IE. This event fires after
			 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
			 *
			 * `beforeInput` is spec'd but not implemented in any browsers, and
			 * the `input` event does not provide any useful information about what has
			 * actually been added, contrary to the spec. Thus, `textInput` is the best
			 * available event to identify the characters that have actually been inserted
			 * into the target node.
			 *
			 * This plugin is also responsible for emitting `composition` events, thus
			 * allowing us to share composition fallback code for both `beforeInput` and
			 * `composition` event types.
			 */
			var BeforeInputEventPlugin = {
	
			  eventTypes: eventTypes,
	
			  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
			  }
			};
	
			module.exports = BeforeInputEventPlugin;
	
		/***/ },
		/* 13 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var EventPluginHub = __webpack_require__(14);
			var EventPluginUtils = __webpack_require__(16);
	
			var accumulateInto = __webpack_require__(20);
			var forEachAccumulated = __webpack_require__(21);
			var warning = __webpack_require__(18);
	
			var getListener = EventPluginHub.getListener;
	
			/**
			 * Some event types have a notion of different registration names for different
			 * "phases" of propagation. This finds listeners by a given phase.
			 */
			function listenerAtPhase(inst, event, propagationPhase) {
			  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
			  return getListener(inst, registrationName);
			}
	
			/**
			 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
			 * here, allows us to not have to bind or create functions for each event.
			 * Mutating the event's members allows us to not have to create a wrapping
			 * "dispatch" object that pairs the event with the listener.
			 */
			function accumulateDirectionalDispatches(inst, phase, event) {
			  if (process.env.NODE_ENV !== 'production') {
			    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
			  }
			  var listener = listenerAtPhase(inst, event, phase);
			  if (listener) {
			    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
			    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
			  }
			}
	
			/**
			 * Collect dispatches (must be entirely collected before dispatching - see unit
			 * tests). Lazily allocate the array to conserve memory.  We must loop through
			 * each event and perform the traversal for each one. We cannot perform a
			 * single traversal for the entire collection of events because each event may
			 * have a different target.
			 */
			function accumulateTwoPhaseDispatchesSingle(event) {
			  if (event && event.dispatchConfig.phasedRegistrationNames) {
			    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
			  }
			}
	
			/**
			 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
			 */
			function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
			  if (event && event.dispatchConfig.phasedRegistrationNames) {
			    var targetInst = event._targetInst;
			    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
			    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
			  }
			}
	
			/**
			 * Accumulates without regard to direction, does not look for phased
			 * registration names. Same as `accumulateDirectDispatchesSingle` but without
			 * requiring that the `dispatchMarker` be the same as the dispatched ID.
			 */
			function accumulateDispatches(inst, ignoredDirection, event) {
			  if (event && event.dispatchConfig.registrationName) {
			    var registrationName = event.dispatchConfig.registrationName;
			    var listener = getListener(inst, registrationName);
			    if (listener) {
			      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
			      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
			    }
			  }
			}
	
			/**
			 * Accumulates dispatches on an `SyntheticEvent`, but only for the
			 * `dispatchMarker`.
			 * @param {SyntheticEvent} event
			 */
			function accumulateDirectDispatchesSingle(event) {
			  if (event && event.dispatchConfig.registrationName) {
			    accumulateDispatches(event._targetInst, null, event);
			  }
			}
	
			function accumulateTwoPhaseDispatches(events) {
			  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
			}
	
			function accumulateTwoPhaseDispatchesSkipTarget(events) {
			  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
			}
	
			function accumulateEnterLeaveDispatches(leave, enter, from, to) {
			  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
			}
	
			function accumulateDirectDispatches(events) {
			  forEachAccumulated(events, accumulateDirectDispatchesSingle);
			}
	
			/**
			 * A small set of propagation patterns, each of which will accept a small amount
			 * of information, and generate a set of "dispatch ready event objects" - which
			 * are sets of events that have already been annotated with a set of dispatched
			 * listener functions/ids. The API is designed this way to discourage these
			 * propagation strategies from actually executing the dispatches, since we
			 * always want to collect the entire set of dispatches before executing event a
			 * single one.
			 *
			 * @constructor EventPropagators
			 */
			var EventPropagators = {
			  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
			  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
			  accumulateDirectDispatches: accumulateDirectDispatches,
			  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
			};
	
			module.exports = EventPropagators;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 14 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var EventPluginRegistry = __webpack_require__(15);
			var EventPluginUtils = __webpack_require__(16);
			var ReactErrorUtils = __webpack_require__(17);
	
			var accumulateInto = __webpack_require__(20);
			var forEachAccumulated = __webpack_require__(21);
			var invariant = __webpack_require__(8);
	
			/**
			 * Internal store for event listeners
			 */
			var listenerBank = {};
	
			/**
			 * Internal queue of events that have accumulated their dispatches and are
			 * waiting to have their dispatches executed.
			 */
			var eventQueue = null;
	
			/**
			 * Dispatches an event and releases it back into the pool, unless persistent.
			 *
			 * @param {?object} event Synthetic event to be dispatched.
			 * @param {boolean} simulated If the event is simulated (changes exn behavior)
			 * @private
			 */
			var executeDispatchesAndRelease = function (event, simulated) {
			  if (event) {
			    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
			    if (!event.isPersistent()) {
			      event.constructor.release(event);
			    }
			  }
			};
			var executeDispatchesAndReleaseSimulated = function (e) {
			  return executeDispatchesAndRelease(e, true);
			};
			var executeDispatchesAndReleaseTopLevel = function (e) {
			  return executeDispatchesAndRelease(e, false);
			};
	
			var getDictionaryKey = function (inst) {
			  // Prevents V8 performance issue:
			  // https://github.com/facebook/react/pull/7232
			  return '.' + inst._rootNodeID;
			};
	
			function isInteractive(tag) {
			  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
			}
	
			function shouldPreventMouseEvent(name, type, props) {
			  switch (name) {
			    case 'onClick':
			    case 'onClickCapture':
			    case 'onDoubleClick':
			    case 'onDoubleClickCapture':
			    case 'onMouseDown':
			    case 'onMouseDownCapture':
			    case 'onMouseMove':
			    case 'onMouseMoveCapture':
			    case 'onMouseUp':
			    case 'onMouseUpCapture':
			      return !!(props.disabled && isInteractive(type));
			    default:
			      return false;
			  }
			}
	
			/**
			 * This is a unified interface for event plugins to be installed and configured.
			 *
			 * Event plugins can implement the following properties:
			 *
			 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
			 *     Required. When a top-level event is fired, this method is expected to
			 *     extract synthetic events that will in turn be queued and dispatched.
			 *
			 *   `eventTypes` {object}
			 *     Optional, plugins that fire events must publish a mapping of registration
			 *     names that are used to register listeners. Values of this mapping must
			 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
			 *
			 *   `executeDispatch` {function(object, function, string)}
			 *     Optional, allows plugins to override how an event gets dispatched. By
			 *     default, the listener is simply invoked.
			 *
			 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
			 *
			 * @public
			 */
			var EventPluginHub = {
	
			  /**
			   * Methods for injecting dependencies.
			   */
			  injection: {
	
			    /**
			     * @param {array} InjectedEventPluginOrder
			     * @public
			     */
			    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
			    /**
			     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
			     */
			    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
			  },
	
			  /**
			   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
			   *
			   * @param {object} inst The instance, which is the source of events.
			   * @param {string} registrationName Name of listener (e.g. `onClick`).
			   * @param {function} listener The callback to store.
			   */
			  putListener: function (inst, registrationName, listener) {
			    !(typeof listener === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
			    var key = getDictionaryKey(inst);
			    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
			    bankForRegistrationName[key] = listener;
	
			    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
			    if (PluginModule && PluginModule.didPutListener) {
			      PluginModule.didPutListener(inst, registrationName, listener);
			    }
			  },
	
			  /**
			   * @param {object} inst The instance, which is the source of events.
			   * @param {string} registrationName Name of listener (e.g. `onClick`).
			   * @return {?function} The stored callback.
			   */
			  getListener: function (inst, registrationName) {
			    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
			    // live here; needs to be moved to a better place soon
			    var bankForRegistrationName = listenerBank[registrationName];
			    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
			      return null;
			    }
			    var key = getDictionaryKey(inst);
			    return bankForRegistrationName && bankForRegistrationName[key];
			  },
	
			  /**
			   * Deletes a listener from the registration bank.
			   *
			   * @param {object} inst The instance, which is the source of events.
			   * @param {string} registrationName Name of listener (e.g. `onClick`).
			   */
			  deleteListener: function (inst, registrationName) {
			    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
			    if (PluginModule && PluginModule.willDeleteListener) {
			      PluginModule.willDeleteListener(inst, registrationName);
			    }
	
			    var bankForRegistrationName = listenerBank[registrationName];
			    // TODO: This should never be null -- when is it?
			    if (bankForRegistrationName) {
			      var key = getDictionaryKey(inst);
			      delete bankForRegistrationName[key];
			    }
			  },
	
			  /**
			   * Deletes all listeners for the DOM element with the supplied ID.
			   *
			   * @param {object} inst The instance, which is the source of events.
			   */
			  deleteAllListeners: function (inst) {
			    var key = getDictionaryKey(inst);
			    for (var registrationName in listenerBank) {
			      if (!listenerBank.hasOwnProperty(registrationName)) {
			        continue;
			      }
	
			      if (!listenerBank[registrationName][key]) {
			        continue;
			      }
	
			      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
			      if (PluginModule && PluginModule.willDeleteListener) {
			        PluginModule.willDeleteListener(inst, registrationName);
			      }
	
			      delete listenerBank[registrationName][key];
			    }
			  },
	
			  /**
			   * Allows registered plugins an opportunity to extract events from top-level
			   * native browser events.
			   *
			   * @return {*} An accumulation of synthetic events.
			   * @internal
			   */
			  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			    var events;
			    var plugins = EventPluginRegistry.plugins;
			    for (var i = 0; i < plugins.length; i++) {
			      // Not every plugin in the ordering may be loaded at runtime.
			      var possiblePlugin = plugins[i];
			      if (possiblePlugin) {
			        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
			        if (extractedEvents) {
			          events = accumulateInto(events, extractedEvents);
			        }
			      }
			    }
			    return events;
			  },
	
			  /**
			   * Enqueues a synthetic event that should be dispatched when
			   * `processEventQueue` is invoked.
			   *
			   * @param {*} events An accumulation of synthetic events.
			   * @internal
			   */
			  enqueueEvents: function (events) {
			    if (events) {
			      eventQueue = accumulateInto(eventQueue, events);
			    }
			  },
	
			  /**
			   * Dispatches all synthetic events on the event queue.
			   *
			   * @internal
			   */
			  processEventQueue: function (simulated) {
			    // Set `eventQueue` to null before processing it so that we can tell if more
			    // events get enqueued while processing.
			    var processingEventQueue = eventQueue;
			    eventQueue = null;
			    if (simulated) {
			      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
			    } else {
			      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
			    }
			    !!eventQueue ? process.env.NODE_ENV !== 'production' ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
			    // This would be a good time to rethrow if any of the event handlers threw.
			    ReactErrorUtils.rethrowCaughtError();
			  },
	
			  /**
			   * These are needed for tests only. Do not use!
			   */
			  __purge: function () {
			    listenerBank = {};
			  },
	
			  __getListenerBank: function () {
			    return listenerBank;
			  }
	
			};
	
			module.exports = EventPluginHub;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 15 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * Injectable ordering of event plugins.
			 */
			var eventPluginOrder = null;
	
			/**
			 * Injectable mapping from names to event plugin modules.
			 */
			var namesToPlugins = {};
	
			/**
			 * Recomputes the plugin list using the injected plugins and plugin ordering.
			 *
			 * @private
			 */
			function recomputePluginOrdering() {
			  if (!eventPluginOrder) {
			    // Wait until an `eventPluginOrder` is injected.
			    return;
			  }
			  for (var pluginName in namesToPlugins) {
			    var pluginModule = namesToPlugins[pluginName];
			    var pluginIndex = eventPluginOrder.indexOf(pluginName);
			    !(pluginIndex > -1) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
			    if (EventPluginRegistry.plugins[pluginIndex]) {
			      continue;
			    }
			    !pluginModule.extractEvents ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
			    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
			    var publishedEvents = pluginModule.eventTypes;
			    for (var eventName in publishedEvents) {
			      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
			    }
			  }
			}
	
			/**
			 * Publishes an event so that it can be dispatched by the supplied plugin.
			 *
			 * @param {object} dispatchConfig Dispatch configuration for the event.
			 * @param {object} PluginModule Plugin publishing the event.
			 * @return {boolean} True if the event was successfully published.
			 * @private
			 */
			function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
			  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
			  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
			  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
			  if (phasedRegistrationNames) {
			    for (var phaseName in phasedRegistrationNames) {
			      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
			        var phasedRegistrationName = phasedRegistrationNames[phaseName];
			        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
			      }
			    }
			    return true;
			  } else if (dispatchConfig.registrationName) {
			    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
			    return true;
			  }
			  return false;
			}
	
			/**
			 * Publishes a registration name that is used to identify dispatched events and
			 * can be used with `EventPluginHub.putListener` to register listeners.
			 *
			 * @param {string} registrationName Registration name to add.
			 * @param {object} PluginModule Plugin publishing the event.
			 * @private
			 */
			function publishRegistrationName(registrationName, pluginModule, eventName) {
			  !!EventPluginRegistry.registrationNameModules[registrationName] ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
			  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
			  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
			  if (process.env.NODE_ENV !== 'production') {
			    var lowerCasedName = registrationName.toLowerCase();
			    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
			    if (registrationName === 'onDoubleClick') {
			      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
			    }
			  }
			}
	
			/**
			 * Registers plugins so that they can extract and dispatch events.
			 *
			 * @see {EventPluginHub}
			 */
			var EventPluginRegistry = {
	
			  /**
			   * Ordered list of injected plugins.
			   */
			  plugins: [],
	
			  /**
			   * Mapping from event name to dispatch config
			   */
			  eventNameDispatchConfigs: {},
	
			  /**
			   * Mapping from registration name to plugin module
			   */
			  registrationNameModules: {},
	
			  /**
			   * Mapping from registration name to event name
			   */
			  registrationNameDependencies: {},
	
			  /**
			   * Mapping from lowercase registration names to the properly cased version,
			   * used to warn in the case of missing event handlers. Available
			   * only in __DEV__.
			   * @type {Object}
			   */
			  possibleRegistrationNames: process.env.NODE_ENV !== 'production' ? {} : null,
			  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
			  /**
			   * Injects an ordering of plugins (by plugin name). This allows the ordering
			   * to be decoupled from injection of the actual plugins so that ordering is
			   * always deterministic regardless of packaging, on-the-fly injection, etc.
			   *
			   * @param {array} InjectedEventPluginOrder
			   * @internal
			   * @see {EventPluginHub.injection.injectEventPluginOrder}
			   */
			  injectEventPluginOrder: function (injectedEventPluginOrder) {
			    !!eventPluginOrder ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
			    // Clone the ordering so it cannot be dynamically mutated.
			    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
			    recomputePluginOrdering();
			  },
	
			  /**
			   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
			   * in the ordering injected by `injectEventPluginOrder`.
			   *
			   * Plugins can be injected as part of page initialization or on-the-fly.
			   *
			   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
			   * @internal
			   * @see {EventPluginHub.injection.injectEventPluginsByName}
			   */
			  injectEventPluginsByName: function (injectedNamesToPlugins) {
			    var isOrderingDirty = false;
			    for (var pluginName in injectedNamesToPlugins) {
			      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
			        continue;
			      }
			      var pluginModule = injectedNamesToPlugins[pluginName];
			      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
			        !!namesToPlugins[pluginName] ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
			        namesToPlugins[pluginName] = pluginModule;
			        isOrderingDirty = true;
			      }
			    }
			    if (isOrderingDirty) {
			      recomputePluginOrdering();
			    }
			  },
	
			  /**
			   * Looks up the plugin for the supplied event.
			   *
			   * @param {object} event A synthetic event.
			   * @return {?object} The plugin that created the supplied event.
			   * @internal
			   */
			  getPluginModuleForEvent: function (event) {
			    var dispatchConfig = event.dispatchConfig;
			    if (dispatchConfig.registrationName) {
			      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
			    }
			    if (dispatchConfig.phasedRegistrationNames !== undefined) {
			      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
			      // that it is not undefined.
			      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
			      for (var phase in phasedRegistrationNames) {
			        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
			          continue;
			        }
			        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
			        if (pluginModule) {
			          return pluginModule;
			        }
			      }
			    }
			    return null;
			  },
	
			  /**
			   * Exposed for unit testing.
			   * @private
			   */
			  _resetEventPlugins: function () {
			    eventPluginOrder = null;
			    for (var pluginName in namesToPlugins) {
			      if (namesToPlugins.hasOwnProperty(pluginName)) {
			        delete namesToPlugins[pluginName];
			      }
			    }
			    EventPluginRegistry.plugins.length = 0;
	
			    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
			    for (var eventName in eventNameDispatchConfigs) {
			      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
			        delete eventNameDispatchConfigs[eventName];
			      }
			    }
	
			    var registrationNameModules = EventPluginRegistry.registrationNameModules;
			    for (var registrationName in registrationNameModules) {
			      if (registrationNameModules.hasOwnProperty(registrationName)) {
			        delete registrationNameModules[registrationName];
			      }
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
			      for (var lowerCasedName in possibleRegistrationNames) {
			        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
			          delete possibleRegistrationNames[lowerCasedName];
			        }
			      }
			    }
			  }
	
			};
	
			module.exports = EventPluginRegistry;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 16 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var ReactErrorUtils = __webpack_require__(17);
	
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			/**
			 * Injected dependencies:
			 */
	
			/**
			 * - `ComponentTree`: [required] Module that can convert between React instances
			 *   and actual node references.
			 */
			var ComponentTree;
			var TreeTraversal;
			var injection = {
			  injectComponentTree: function (Injected) {
			    ComponentTree = Injected;
			    if (process.env.NODE_ENV !== 'production') {
			      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
			    }
			  },
			  injectTreeTraversal: function (Injected) {
			    TreeTraversal = Injected;
			    if (process.env.NODE_ENV !== 'production') {
			      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
			    }
			  }
			};
	
			function isEndish(topLevelType) {
			  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
			}
	
			function isMoveish(topLevelType) {
			  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
			}
			function isStartish(topLevelType) {
			  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
			}
	
			var validateEventDispatches;
			if (process.env.NODE_ENV !== 'production') {
			  validateEventDispatches = function (event) {
			    var dispatchListeners = event._dispatchListeners;
			    var dispatchInstances = event._dispatchInstances;
	
			    var listenersIsArr = Array.isArray(dispatchListeners);
			    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
			    var instancesIsArr = Array.isArray(dispatchInstances);
			    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
			    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
			  };
			}
	
			/**
			 * Dispatch the event to the listener.
			 * @param {SyntheticEvent} event SyntheticEvent to handle
			 * @param {boolean} simulated If the event is simulated (changes exn behavior)
			 * @param {function} listener Application-level callback
			 * @param {*} inst Internal component instance
			 */
			function executeDispatch(event, simulated, listener, inst) {
			  var type = event.type || 'unknown-event';
			  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
			  if (simulated) {
			    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
			  } else {
			    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
			  }
			  event.currentTarget = null;
			}
	
			/**
			 * Standard/simple iteration through an event's collected dispatches.
			 */
			function executeDispatchesInOrder(event, simulated) {
			  var dispatchListeners = event._dispatchListeners;
			  var dispatchInstances = event._dispatchInstances;
			  if (process.env.NODE_ENV !== 'production') {
			    validateEventDispatches(event);
			  }
			  if (Array.isArray(dispatchListeners)) {
			    for (var i = 0; i < dispatchListeners.length; i++) {
			      if (event.isPropagationStopped()) {
			        break;
			      }
			      // Listeners and Instances are two parallel arrays that are always in sync.
			      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
			    }
			  } else if (dispatchListeners) {
			    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
			  }
			  event._dispatchListeners = null;
			  event._dispatchInstances = null;
			}
	
			/**
			 * Standard/simple iteration through an event's collected dispatches, but stops
			 * at the first dispatch execution returning true, and returns that id.
			 *
			 * @return {?string} id of the first dispatch execution who's listener returns
			 * true, or null if no listener returned true.
			 */
			function executeDispatchesInOrderStopAtTrueImpl(event) {
			  var dispatchListeners = event._dispatchListeners;
			  var dispatchInstances = event._dispatchInstances;
			  if (process.env.NODE_ENV !== 'production') {
			    validateEventDispatches(event);
			  }
			  if (Array.isArray(dispatchListeners)) {
			    for (var i = 0; i < dispatchListeners.length; i++) {
			      if (event.isPropagationStopped()) {
			        break;
			      }
			      // Listeners and Instances are two parallel arrays that are always in sync.
			      if (dispatchListeners[i](event, dispatchInstances[i])) {
			        return dispatchInstances[i];
			      }
			    }
			  } else if (dispatchListeners) {
			    if (dispatchListeners(event, dispatchInstances)) {
			      return dispatchInstances;
			    }
			  }
			  return null;
			}
	
			/**
			 * @see executeDispatchesInOrderStopAtTrueImpl
			 */
			function executeDispatchesInOrderStopAtTrue(event) {
			  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
			  event._dispatchInstances = null;
			  event._dispatchListeners = null;
			  return ret;
			}
	
			/**
			 * Execution of a "direct" dispatch - there must be at most one dispatch
			 * accumulated on the event or it is considered an error. It doesn't really make
			 * sense for an event with multiple dispatches (bubbled) to keep track of the
			 * return values at each dispatch execution, but it does tend to make sense when
			 * dealing with "direct" dispatches.
			 *
			 * @return {*} The return value of executing the single dispatch.
			 */
			function executeDirectDispatch(event) {
			  if (process.env.NODE_ENV !== 'production') {
			    validateEventDispatches(event);
			  }
			  var dispatchListener = event._dispatchListeners;
			  var dispatchInstance = event._dispatchInstances;
			  !!Array.isArray(dispatchListener) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
			  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
			  var res = dispatchListener ? dispatchListener(event) : null;
			  event.currentTarget = null;
			  event._dispatchListeners = null;
			  event._dispatchInstances = null;
			  return res;
			}
	
			/**
			 * @param {SyntheticEvent} event
			 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
			 */
			function hasDispatches(event) {
			  return !!event._dispatchListeners;
			}
	
			/**
			 * General utilities that are useful in creating custom Event Plugins.
			 */
			var EventPluginUtils = {
			  isEndish: isEndish,
			  isMoveish: isMoveish,
			  isStartish: isStartish,
	
			  executeDirectDispatch: executeDirectDispatch,
			  executeDispatchesInOrder: executeDispatchesInOrder,
			  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
			  hasDispatches: hasDispatches,
	
			  getInstanceFromNode: function (node) {
			    return ComponentTree.getInstanceFromNode(node);
			  },
			  getNodeFromInstance: function (node) {
			    return ComponentTree.getNodeFromInstance(node);
			  },
			  isAncestor: function (a, b) {
			    return TreeTraversal.isAncestor(a, b);
			  },
			  getLowestCommonAncestor: function (a, b) {
			    return TreeTraversal.getLowestCommonAncestor(a, b);
			  },
			  getParentInstance: function (inst) {
			    return TreeTraversal.getParentInstance(inst);
			  },
			  traverseTwoPhase: function (target, fn, arg) {
			    return TreeTraversal.traverseTwoPhase(target, fn, arg);
			  },
			  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
			    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
			  },
	
			  injection: injection
			};
	
			module.exports = EventPluginUtils;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 17 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var caughtError = null;
	
			/**
			 * Call a function while guarding against errors that happens within it.
			 *
			 * @param {String} name of the guard to use for logging or debugging
			 * @param {Function} func The function to invoke
			 * @param {*} a First argument
			 * @param {*} b Second argument
			 */
			function invokeGuardedCallback(name, func, a) {
			  try {
			    func(a);
			  } catch (x) {
			    if (caughtError === null) {
			      caughtError = x;
			    }
			  }
			}
	
			var ReactErrorUtils = {
			  invokeGuardedCallback: invokeGuardedCallback,
	
			  /**
			   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
			   * handler are sure to be rethrown by rethrowCaughtError.
			   */
			  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
			  /**
			   * During execution of guarded functions we will capture the first error which
			   * we will rethrow to be handled by the top level error handler.
			   */
			  rethrowCaughtError: function () {
			    if (caughtError) {
			      var error = caughtError;
			      caughtError = null;
			      throw error;
			    }
			  }
			};
	
			if (process.env.NODE_ENV !== 'production') {
			  /**
			   * To help development we can get better devtools integration by simulating a
			   * real browser event.
			   */
			  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
			    var fakeNode = document.createElement('react');
			    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
			      var boundFunc = func.bind(null, a);
			      var evtType = 'react-' + name;
			      fakeNode.addEventListener(evtType, boundFunc, false);
			      var evt = document.createEvent('Event');
			      evt.initEvent(evtType, false, false);
			      fakeNode.dispatchEvent(evt);
			      fakeNode.removeEventListener(evtType, boundFunc, false);
			    };
			  }
			}
	
			module.exports = ReactErrorUtils;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 18 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-2015, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var emptyFunction = __webpack_require__(19);
	
			/**
			 * Similar to invariant but only logs a warning if the condition is not met.
			 * This can be used to log issues in development environments in critical
			 * paths. Removing the logging code for production environments will keep the
			 * same logic and follow the same code paths.
			 */
	
			var warning = emptyFunction;
	
			if (process.env.NODE_ENV !== 'production') {
			  (function () {
			    var printWarning = function printWarning(format) {
			      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			        args[_key - 1] = arguments[_key];
			      }
	
			      var argIndex = 0;
			      var message = 'Warning: ' + format.replace(/%s/g, function () {
			        return args[argIndex++];
			      });
			      if (typeof console !== 'undefined') {
			        console.error(message);
			      }
			      try {
			        // --- Welcome to debugging React ---
			        // This error was thrown as a convenience so that you can use this stack
			        // to find the callsite that caused this warning to fire.
			        throw new Error(message);
			      } catch (x) {}
			    };
	
			    warning = function warning(condition, format) {
			      if (format === undefined) {
			        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
			      }
	
			      if (format.indexOf('Failed Composite propType: ') === 0) {
			        return; // Ignore CompositeComponent proptype check.
			      }
	
			      if (!condition) {
			        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
			          args[_key2 - 2] = arguments[_key2];
			        }
	
			        printWarning.apply(undefined, [format].concat(args));
			      }
			    };
			  })();
			}
	
			module.exports = warning;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 19 */
		/***/ function(module, exports) {
	
			"use strict";
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			function makeEmptyFunction(arg) {
			  return function () {
			    return arg;
			  };
			}
	
			/**
			 * This function accepts and discards inputs; it has no side effects. This is
			 * primarily useful idiomatically for overridable function endpoints which
			 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
			 */
			var emptyFunction = function emptyFunction() {};
	
			emptyFunction.thatReturns = makeEmptyFunction;
			emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
			emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
			emptyFunction.thatReturnsNull = makeEmptyFunction(null);
			emptyFunction.thatReturnsThis = function () {
			  return this;
			};
			emptyFunction.thatReturnsArgument = function (arg) {
			  return arg;
			};
	
			module.exports = emptyFunction;
	
		/***/ },
		/* 20 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * Accumulates items that must not be null or undefined into the first one. This
			 * is used to conserve memory by avoiding array allocations, and thus sacrifices
			 * API cleanness. Since `current` can be null before being passed in and not
			 * null after this function, make sure to assign it back to `current`:
			 *
			 * `a = accumulateInto(a, b);`
			 *
			 * This API should be sparingly used. Try `accumulate` for something cleaner.
			 *
			 * @return {*|array<*>} An accumulation of items.
			 */
	
			function accumulateInto(current, next) {
			  !(next != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
			  if (current == null) {
			    return next;
			  }
	
			  // Both are not empty. Warning: Never call x.concat(y) when you are not
			  // certain that x is an Array (x could be a string with concat method).
			  if (Array.isArray(current)) {
			    if (Array.isArray(next)) {
			      current.push.apply(current, next);
			      return current;
			    }
			    current.push(next);
			    return current;
			  }
	
			  if (Array.isArray(next)) {
			    // A bit too dangerous to mutate `next`.
			    return [current].concat(next);
			  }
	
			  return [current, next];
			}
	
			module.exports = accumulateInto;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 21 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			/**
			 * @param {array} arr an "accumulation" of items which is either an Array or
			 * a single item. Useful when paired with the `accumulate` module. This is a
			 * simple utility that allows us to reason about a collection of items, but
			 * handling the case when there is exactly one item (and we do not need to
			 * allocate an array).
			 */
	
			function forEachAccumulated(arr, cb, scope) {
			  if (Array.isArray(arr)) {
			    arr.forEach(cb, scope);
			  } else if (arr) {
			    cb.call(scope, arr);
			  }
			}
	
			module.exports = forEachAccumulated;
	
		/***/ },
		/* 22 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
			/**
			 * Simple, lightweight module assisting with the detection and context of
			 * Worker. Helps avoid circular dependencies and allows code to reason about
			 * whether or not they are in a Worker, even if they never include the main
			 * `ReactWorker` dependency.
			 */
			var ExecutionEnvironment = {
	
			  canUseDOM: canUseDOM,
	
			  canUseWorkers: typeof Worker !== 'undefined',
	
			  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			  canUseViewport: canUseDOM && !!window.screen,
	
			  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
			};
	
			module.exports = ExecutionEnvironment;
	
		/***/ },
		/* 23 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var PooledClass = __webpack_require__(25);
	
			var getTextContentAccessor = __webpack_require__(26);
	
			/**
			 * This helper class stores information about text content of a target node,
			 * allowing comparison of content before and after a given event.
			 *
			 * Identify the node where selection currently begins, then observe
			 * both its text content and its current position in the DOM. Since the
			 * browser may natively replace the target node during composition, we can
			 * use its position to find its replacement.
			 *
			 * @param {DOMEventTarget} root
			 */
			function FallbackCompositionState(root) {
			  this._root = root;
			  this._startText = this.getText();
			  this._fallbackText = null;
			}
	
			_assign(FallbackCompositionState.prototype, {
			  destructor: function () {
			    this._root = null;
			    this._startText = null;
			    this._fallbackText = null;
			  },
	
			  /**
			   * Get current text of input.
			   *
			   * @return {string}
			   */
			  getText: function () {
			    if ('value' in this._root) {
			      return this._root.value;
			    }
			    return this._root[getTextContentAccessor()];
			  },
	
			  /**
			   * Determine the differing substring between the initially stored
			   * text content and the current content.
			   *
			   * @return {string}
			   */
			  getData: function () {
			    if (this._fallbackText) {
			      return this._fallbackText;
			    }
	
			    var start;
			    var startValue = this._startText;
			    var startLength = startValue.length;
			    var end;
			    var endValue = this.getText();
			    var endLength = endValue.length;
	
			    for (start = 0; start < startLength; start++) {
			      if (startValue[start] !== endValue[start]) {
			        break;
			      }
			    }
	
			    var minEnd = startLength - start;
			    for (end = 1; end <= minEnd; end++) {
			      if (startValue[startLength - end] !== endValue[endLength - end]) {
			        break;
			      }
			    }
	
			    var sliceTail = end > 1 ? 1 - end : undefined;
			    this._fallbackText = endValue.slice(start, sliceTail);
			    return this._fallbackText;
			  }
			});
	
			PooledClass.addPoolingTo(FallbackCompositionState);
	
			module.exports = FallbackCompositionState;
	
		/***/ },
		/* 24 */
		/***/ function(module, exports) {
	
			/*
			object-assign
			(c) Sindre Sorhus
			@license MIT
			*/
	
			'use strict';
			/* eslint-disable no-unused-vars */
			var getOwnPropertySymbols = Object.getOwnPropertySymbols;
			var hasOwnProperty = Object.prototype.hasOwnProperty;
			var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
			function toObject(val) {
				if (val === null || val === undefined) {
					throw new TypeError('Object.assign cannot be called with null or undefined');
				}
	
				return Object(val);
			}
	
			function shouldUseNative() {
				try {
					if (!Object.assign) {
						return false;
					}
	
					// Detect buggy property enumeration order in older V8 versions.
	
					// https://bugs.chromium.org/p/v8/issues/detail?id=4118
					var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
					test1[5] = 'de';
					if (Object.getOwnPropertyNames(test1)[0] === '5') {
						return false;
					}
	
					// https://bugs.chromium.org/p/v8/issues/detail?id=3056
					var test2 = {};
					for (var i = 0; i < 10; i++) {
						test2['_' + String.fromCharCode(i)] = i;
					}
					var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
						return test2[n];
					});
					if (order2.join('') !== '0123456789') {
						return false;
					}
	
					// https://bugs.chromium.org/p/v8/issues/detail?id=3056
					var test3 = {};
					'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
						test3[letter] = letter;
					});
					if (Object.keys(Object.assign({}, test3)).join('') !==
							'abcdefghijklmnopqrst') {
						return false;
					}
	
					return true;
				} catch (err) {
					// We don't expect any of the above to throw, but better to be safe.
					return false;
				}
			}
	
			module.exports = shouldUseNative() ? Object.assign : function (target, source) {
				var from;
				var to = toObject(target);
				var symbols;
	
				for (var s = 1; s < arguments.length; s++) {
					from = Object(arguments[s]);
	
					for (var key in from) {
						if (hasOwnProperty.call(from, key)) {
							to[key] = from[key];
						}
					}
	
					if (getOwnPropertySymbols) {
						symbols = getOwnPropertySymbols(from);
						for (var i = 0; i < symbols.length; i++) {
							if (propIsEnumerable.call(from, symbols[i])) {
								to[symbols[i]] = from[symbols[i]];
							}
						}
					}
				}
	
				return to;
			};
	
	
		/***/ },
		/* 25 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * Static poolers. Several custom versions for each potential number of
			 * arguments. A completely generic pooler is easy to implement, but would
			 * require accessing the `arguments` object. In each of these, `this` refers to
			 * the Class itself, not an instance. If any others are needed, simply add them
			 * here, or in their own files.
			 */
			var oneArgumentPooler = function (copyFieldsFrom) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, copyFieldsFrom);
			    return instance;
			  } else {
			    return new Klass(copyFieldsFrom);
			  }
			};
	
			var twoArgumentPooler = function (a1, a2) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, a1, a2);
			    return instance;
			  } else {
			    return new Klass(a1, a2);
			  }
			};
	
			var threeArgumentPooler = function (a1, a2, a3) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, a1, a2, a3);
			    return instance;
			  } else {
			    return new Klass(a1, a2, a3);
			  }
			};
	
			var fourArgumentPooler = function (a1, a2, a3, a4) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, a1, a2, a3, a4);
			    return instance;
			  } else {
			    return new Klass(a1, a2, a3, a4);
			  }
			};
	
			var standardReleaser = function (instance) {
			  var Klass = this;
			  !(instance instanceof Klass) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
			  instance.destructor();
			  if (Klass.instancePool.length < Klass.poolSize) {
			    Klass.instancePool.push(instance);
			  }
			};
	
			var DEFAULT_POOL_SIZE = 10;
			var DEFAULT_POOLER = oneArgumentPooler;
	
			/**
			 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
			 * itself (statically) not adding any prototypical fields. Any CopyConstructor
			 * you give this may have a `poolSize` property, and will look for a
			 * prototypical `destructor` on instances.
			 *
			 * @param {Function} CopyConstructor Constructor that can be used to reset.
			 * @param {Function} pooler Customizable pooler.
			 */
			var addPoolingTo = function (CopyConstructor, pooler) {
			  // Casting as any so that flow ignores the actual implementation and trusts
			  // it to match the type we declared
			  var NewKlass = CopyConstructor;
			  NewKlass.instancePool = [];
			  NewKlass.getPooled = pooler || DEFAULT_POOLER;
			  if (!NewKlass.poolSize) {
			    NewKlass.poolSize = DEFAULT_POOL_SIZE;
			  }
			  NewKlass.release = standardReleaser;
			  return NewKlass;
			};
	
			var PooledClass = {
			  addPoolingTo: addPoolingTo,
			  oneArgumentPooler: oneArgumentPooler,
			  twoArgumentPooler: twoArgumentPooler,
			  threeArgumentPooler: threeArgumentPooler,
			  fourArgumentPooler: fourArgumentPooler
			};
	
			module.exports = PooledClass;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 26 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ExecutionEnvironment = __webpack_require__(22);
	
			var contentKey = null;
	
			/**
			 * Gets the key used to access text content on a DOM node.
			 *
			 * @return {?string} Key used to access text content.
			 * @internal
			 */
			function getTextContentAccessor() {
			  if (!contentKey && ExecutionEnvironment.canUseDOM) {
			    // Prefer textContent to innerText because many browsers support both but
			    // SVG <text> elements don't support innerText even when <div> does.
			    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
			  }
			  return contentKey;
			}
	
			module.exports = getTextContentAccessor;
	
		/***/ },
		/* 27 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticEvent = __webpack_require__(28);
	
			/**
			 * @interface Event
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
			 */
			var CompositionEventInterface = {
			  data: null
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
			module.exports = SyntheticCompositionEvent;
	
		/***/ },
		/* 28 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var PooledClass = __webpack_require__(25);
	
			var emptyFunction = __webpack_require__(19);
			var warning = __webpack_require__(18);
	
			var didWarnForAddedNewProperty = false;
			var isProxySupported = typeof Proxy === 'function';
	
			var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
			/**
			 * @interface Event
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/
			 */
			var EventInterface = {
			  type: null,
			  target: null,
			  // currentTarget is set when dispatching; no use in copying it here
			  currentTarget: emptyFunction.thatReturnsNull,
			  eventPhase: null,
			  bubbles: null,
			  cancelable: null,
			  timeStamp: function (event) {
			    return event.timeStamp || Date.now();
			  },
			  defaultPrevented: null,
			  isTrusted: null
			};
	
			/**
			 * Synthetic events are dispatched by event plugins, typically in response to a
			 * top-level event delegation handler.
			 *
			 * These systems should generally use pooling to reduce the frequency of garbage
			 * collection. The system should check `isPersistent` to determine whether the
			 * event should be released into the pool after being dispatched. Users that
			 * need a persisted event should invoke `persist`.
			 *
			 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
			 * normalizing browser quirks. Subclasses do not necessarily have to implement a
			 * DOM interface; custom application-specific events can also subclass this.
			 *
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {*} targetInst Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @param {DOMEventTarget} nativeEventTarget Target node.
			 */
			function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
			  if (process.env.NODE_ENV !== 'production') {
			    // these have a getter/setter for warnings
			    delete this.nativeEvent;
			    delete this.preventDefault;
			    delete this.stopPropagation;
			  }
	
			  this.dispatchConfig = dispatchConfig;
			  this._targetInst = targetInst;
			  this.nativeEvent = nativeEvent;
	
			  var Interface = this.constructor.Interface;
			  for (var propName in Interface) {
			    if (!Interface.hasOwnProperty(propName)) {
			      continue;
			    }
			    if (process.env.NODE_ENV !== 'production') {
			      delete this[propName]; // this has a getter/setter for warnings
			    }
			    var normalize = Interface[propName];
			    if (normalize) {
			      this[propName] = normalize(nativeEvent);
			    } else {
			      if (propName === 'target') {
			        this.target = nativeEventTarget;
			      } else {
			        this[propName] = nativeEvent[propName];
			      }
			    }
			  }
	
			  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
			  if (defaultPrevented) {
			    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
			  } else {
			    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
			  }
			  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
			  return this;
			}
	
			_assign(SyntheticEvent.prototype, {
	
			  preventDefault: function () {
			    this.defaultPrevented = true;
			    var event = this.nativeEvent;
			    if (!event) {
			      return;
			    }
	
			    if (event.preventDefault) {
			      event.preventDefault();
			    } else if (typeof event.returnValue !== 'unknown') {
			      // eslint-disable-line valid-typeof
			      event.returnValue = false;
			    }
			    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
			  },
	
			  stopPropagation: function () {
			    var event = this.nativeEvent;
			    if (!event) {
			      return;
			    }
	
			    if (event.stopPropagation) {
			      event.stopPropagation();
			    } else if (typeof event.cancelBubble !== 'unknown') {
			      // eslint-disable-line valid-typeof
			      // The ChangeEventPlugin registers a "propertychange" event for
			      // IE. This event does not support bubbling or cancelling, and
			      // any references to cancelBubble throw "Member not found".  A
			      // typeof check of "unknown" circumvents this issue (and is also
			      // IE specific).
			      event.cancelBubble = true;
			    }
	
			    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
			  },
	
			  /**
			   * We release all dispatched `SyntheticEvent`s after each event loop, adding
			   * them back into the pool. This allows a way to hold onto a reference that
			   * won't be added back into the pool.
			   */
			  persist: function () {
			    this.isPersistent = emptyFunction.thatReturnsTrue;
			  },
	
			  /**
			   * Checks if this event should be released back into the pool.
			   *
			   * @return {boolean} True if this should not be released, false otherwise.
			   */
			  isPersistent: emptyFunction.thatReturnsFalse,
	
			  /**
			   * `PooledClass` looks for `destructor` on each instance it releases.
			   */
			  destructor: function () {
			    var Interface = this.constructor.Interface;
			    for (var propName in Interface) {
			      if (process.env.NODE_ENV !== 'production') {
			        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
			      } else {
			        this[propName] = null;
			      }
			    }
			    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
			      this[shouldBeReleasedProperties[i]] = null;
			    }
			    if (process.env.NODE_ENV !== 'production') {
			      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
			      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
			      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
			    }
			  }
	
			});
	
			SyntheticEvent.Interface = EventInterface;
	
			if (process.env.NODE_ENV !== 'production') {
			  if (isProxySupported) {
			    /*eslint-disable no-func-assign */
			    SyntheticEvent = new Proxy(SyntheticEvent, {
			      construct: function (target, args) {
			        return this.apply(target, Object.create(target.prototype), args);
			      },
			      apply: function (constructor, that, args) {
			        return new Proxy(constructor.apply(that, args), {
			          set: function (target, prop, value) {
			            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
			              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
			              didWarnForAddedNewProperty = true;
			            }
			            target[prop] = value;
			            return true;
			          }
			        });
			      }
			    });
			    /*eslint-enable no-func-assign */
			  }
			}
			/**
			 * Helper to reduce boilerplate when creating subclasses.
			 *
			 * @param {function} Class
			 * @param {?object} Interface
			 */
			SyntheticEvent.augmentClass = function (Class, Interface) {
			  var Super = this;
	
			  var E = function () {};
			  E.prototype = Super.prototype;
			  var prototype = new E();
	
			  _assign(prototype, Class.prototype);
			  Class.prototype = prototype;
			  Class.prototype.constructor = Class;
	
			  Class.Interface = _assign({}, Super.Interface, Interface);
			  Class.augmentClass = Super.augmentClass;
	
			  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
			};
	
			PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
			module.exports = SyntheticEvent;
	
			/**
			  * Helper to nullify syntheticEvent instance properties when destructing
			  *
			  * @param {object} SyntheticEvent
			  * @param {String} propName
			  * @return {object} defineProperty object
			  */
			function getPooledWarningPropertyDefinition(propName, getVal) {
			  var isFunction = typeof getVal === 'function';
			  return {
			    configurable: true,
			    set: set,
			    get: get
			  };
	
			  function set(val) {
			    var action = isFunction ? 'setting the method' : 'setting the property';
			    warn(action, 'This is effectively a no-op');
			    return val;
			  }
	
			  function get() {
			    var action = isFunction ? 'accessing the method' : 'accessing the property';
			    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
			    warn(action, result);
			    return getVal;
			  }
	
			  function warn(action, result) {
			    var warningCondition = false;
			    process.env.NODE_ENV !== 'production' ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
			  }
			}
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 29 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticEvent = __webpack_require__(28);
	
			/**
			 * @interface Event
			 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
			 *      /#events-inputevents
			 */
			var InputEventInterface = {
			  data: null
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
			module.exports = SyntheticInputEvent;
	
		/***/ },
		/* 30 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var EventPluginHub = __webpack_require__(14);
			var EventPropagators = __webpack_require__(13);
			var ExecutionEnvironment = __webpack_require__(22);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactUpdates = __webpack_require__(31);
			var SyntheticEvent = __webpack_require__(28);
	
			var getEventTarget = __webpack_require__(50);
			var isEventSupported = __webpack_require__(51);
			var isTextInputElement = __webpack_require__(52);
	
			var eventTypes = {
			  change: {
			    phasedRegistrationNames: {
			      bubbled: 'onChange',
			      captured: 'onChangeCapture'
			    },
			    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
			  }
			};
	
			/**
			 * For IE shims
			 */
			var activeElement = null;
			var activeElementInst = null;
			var activeElementValue = null;
			var activeElementValueProp = null;
	
			/**
			 * SECTION: handle `change` event
			 */
			function shouldUseChangeEvent(elem) {
			  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
			  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
			}
	
			var doesChangeEventBubble = false;
			if (ExecutionEnvironment.canUseDOM) {
			  // See `handleChange` comment below
			  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
			}
	
			function manualDispatchChangeEvent(nativeEvent) {
			  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
			  EventPropagators.accumulateTwoPhaseDispatches(event);
	
			  // If change and propertychange bubbled, we'd just bind to it like all the
			  // other events and have it go through ReactBrowserEventEmitter. Since it
			  // doesn't, we manually listen for the events and so we have to enqueue and
			  // process the abstract event manually.
			  //
			  // Batching is necessary here in order to ensure that all event handlers run
			  // before the next rerender (including event handlers attached to ancestor
			  // elements instead of directly on the input). Without this, controlled
			  // components don't work properly in conjunction with event bubbling because
			  // the component is rerendered and the value reverted before all the event
			  // handlers can run. See https://github.com/facebook/react/issues/708.
			  ReactUpdates.batchedUpdates(runEventInBatch, event);
			}
	
			function runEventInBatch(event) {
			  EventPluginHub.enqueueEvents(event);
			  EventPluginHub.processEventQueue(false);
			}
	
			function startWatchingForChangeEventIE8(target, targetInst) {
			  activeElement = target;
			  activeElementInst = targetInst;
			  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
			}
	
			function stopWatchingForChangeEventIE8() {
			  if (!activeElement) {
			    return;
			  }
			  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
			  activeElement = null;
			  activeElementInst = null;
			}
	
			function getTargetInstForChangeEvent(topLevelType, targetInst) {
			  if (topLevelType === 'topChange') {
			    return targetInst;
			  }
			}
			function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
			  if (topLevelType === 'topFocus') {
			    // stopWatching() should be a noop here but we call it just in case we
			    // missed a blur event somehow.
			    stopWatchingForChangeEventIE8();
			    startWatchingForChangeEventIE8(target, targetInst);
			  } else if (topLevelType === 'topBlur') {
			    stopWatchingForChangeEventIE8();
			  }
			}
	
			/**
			 * SECTION: handle `input` event
			 */
			var isInputEventSupported = false;
			if (ExecutionEnvironment.canUseDOM) {
			  // IE9 claims to support the input event but fails to trigger it when
			  // deleting text, so we ignore its input events.
			  // IE10+ fire input events to often, such when a placeholder
			  // changes or when an input with a placeholder is focused.
			  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
			}
	
			/**
			 * (For IE <=11) Replacement getter/setter for the `value` property that gets
			 * set on the active element.
			 */
			var newValueProp = {
			  get: function () {
			    return activeElementValueProp.get.call(this);
			  },
			  set: function (val) {
			    // Cast to a string so we can do equality checks.
			    activeElementValue = '' + val;
			    activeElementValueProp.set.call(this, val);
			  }
			};
	
			/**
			 * (For IE <=11) Starts tracking propertychange events on the passed-in element
			 * and override the value property so that we can distinguish user events from
			 * value changes in JS.
			 */
			function startWatchingForValueChange(target, targetInst) {
			  activeElement = target;
			  activeElementInst = targetInst;
			  activeElementValue = target.value;
			  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
			  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
			  // on DOM elements
			  Object.defineProperty(activeElement, 'value', newValueProp);
			  if (activeElement.attachEvent) {
			    activeElement.attachEvent('onpropertychange', handlePropertyChange);
			  } else {
			    activeElement.addEventListener('propertychange', handlePropertyChange, false);
			  }
			}
	
			/**
			 * (For IE <=11) Removes the event listeners from the currently-tracked element,
			 * if any exists.
			 */
			function stopWatchingForValueChange() {
			  if (!activeElement) {
			    return;
			  }
	
			  // delete restores the original property definition
			  delete activeElement.value;
	
			  if (activeElement.detachEvent) {
			    activeElement.detachEvent('onpropertychange', handlePropertyChange);
			  } else {
			    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
			  }
	
			  activeElement = null;
			  activeElementInst = null;
			  activeElementValue = null;
			  activeElementValueProp = null;
			}
	
			/**
			 * (For IE <=11) Handles a propertychange event, sending a `change` event if
			 * the value of the active element has changed.
			 */
			function handlePropertyChange(nativeEvent) {
			  if (nativeEvent.propertyName !== 'value') {
			    return;
			  }
			  var value = nativeEvent.srcElement.value;
			  if (value === activeElementValue) {
			    return;
			  }
			  activeElementValue = value;
	
			  manualDispatchChangeEvent(nativeEvent);
			}
	
			/**
			 * If a `change` event should be fired, returns the target's ID.
			 */
			function getTargetInstForInputEvent(topLevelType, targetInst) {
			  if (topLevelType === 'topInput') {
			    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
			    // what we want so fall through here and trigger an abstract event
			    return targetInst;
			  }
			}
	
			function handleEventsForInputEventIE(topLevelType, target, targetInst) {
			  if (topLevelType === 'topFocus') {
			    // In IE8, we can capture almost all .value changes by adding a
			    // propertychange handler and looking for events with propertyName
			    // equal to 'value'
			    // In IE9-11, propertychange fires for most input events but is buggy and
			    // doesn't fire when text is deleted, but conveniently, selectionchange
			    // appears to fire in all of the remaining cases so we catch those and
			    // forward the event if the value has changed
			    // In either case, we don't want to call the event handler if the value
			    // is changed from JS so we redefine a setter for `.value` that updates
			    // our activeElementValue variable, allowing us to ignore those changes
			    //
			    // stopWatching() should be a noop here but we call it just in case we
			    // missed a blur event somehow.
			    stopWatchingForValueChange();
			    startWatchingForValueChange(target, targetInst);
			  } else if (topLevelType === 'topBlur') {
			    stopWatchingForValueChange();
			  }
			}
	
			// For IE8 and IE9.
			function getTargetInstForInputEventIE(topLevelType, targetInst) {
			  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
			    // On the selectionchange event, the target is just document which isn't
			    // helpful for us so just check activeElement instead.
			    //
			    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
			    // propertychange on the first input event after setting `value` from a
			    // script and fires only keydown, keypress, keyup. Catching keyup usually
			    // gets it and catching keydown lets us fire an event for the first
			    // keystroke if user does a key repeat (it'll be a little delayed: right
			    // before the second keystroke). Other input methods (e.g., paste) seem to
			    // fire selectionchange normally.
			    if (activeElement && activeElement.value !== activeElementValue) {
			      activeElementValue = activeElement.value;
			      return activeElementInst;
			    }
			  }
			}
	
			/**
			 * SECTION: handle `click` event
			 */
			function shouldUseClickEvent(elem) {
			  // Use the `click` event to detect changes to checkbox and radio inputs.
			  // This approach works across all browsers, whereas `change` does not fire
			  // until `blur` in IE8.
			  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
			}
	
			function getTargetInstForClickEvent(topLevelType, targetInst) {
			  if (topLevelType === 'topClick') {
			    return targetInst;
			  }
			}
	
			function handleControlledInputBlur(inst, node) {
			  // TODO: In IE, inst is occasionally null. Why?
			  if (inst == null) {
			    return;
			  }
	
			  // Fiber and ReactDOM keep wrapper state in separate places
			  var state = inst._wrapperState || node._wrapperState;
	
			  if (!state || !state.controlled || node.type !== 'number') {
			    return;
			  }
	
			  // If controlled, assign the value attribute to the current value on blur
			  var value = '' + node.value;
			  if (node.getAttribute('value') !== value) {
			    node.setAttribute('value', value);
			  }
			}
	
			/**
			 * This plugin creates an `onChange` event that normalizes change events
			 * across form elements. This event fires at a time when it's possible to
			 * change the element's value without seeing a flicker.
			 *
			 * Supported elements are:
			 * - input (see `isTextInputElement`)
			 * - textarea
			 * - select
			 */
			var ChangeEventPlugin = {
	
			  eventTypes: eventTypes,
	
			  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
			    var getTargetInstFunc, handleEventFunc;
			    if (shouldUseChangeEvent(targetNode)) {
			      if (doesChangeEventBubble) {
			        getTargetInstFunc = getTargetInstForChangeEvent;
			      } else {
			        handleEventFunc = handleEventsForChangeEventIE8;
			      }
			    } else if (isTextInputElement(targetNode)) {
			      if (isInputEventSupported) {
			        getTargetInstFunc = getTargetInstForInputEvent;
			      } else {
			        getTargetInstFunc = getTargetInstForInputEventIE;
			        handleEventFunc = handleEventsForInputEventIE;
			      }
			    } else if (shouldUseClickEvent(targetNode)) {
			      getTargetInstFunc = getTargetInstForClickEvent;
			    }
	
			    if (getTargetInstFunc) {
			      var inst = getTargetInstFunc(topLevelType, targetInst);
			      if (inst) {
			        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
			        event.type = 'change';
			        EventPropagators.accumulateTwoPhaseDispatches(event);
			        return event;
			      }
			    }
	
			    if (handleEventFunc) {
			      handleEventFunc(topLevelType, targetNode, targetInst);
			    }
	
			    // When blurring, set the value attribute for number inputs
			    if (topLevelType === 'topBlur') {
			      handleControlledInputBlur(targetInst, targetNode);
			    }
			  }
	
			};
	
			module.exports = ChangeEventPlugin;
	
		/***/ },
		/* 31 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6),
			    _assign = __webpack_require__(24);
	
			var CallbackQueue = __webpack_require__(32);
			var PooledClass = __webpack_require__(25);
			var ReactFeatureFlags = __webpack_require__(33);
			var ReactReconciler = __webpack_require__(34);
			var Transaction = __webpack_require__(49);
	
			var invariant = __webpack_require__(8);
	
			var dirtyComponents = [];
			var updateBatchNumber = 0;
			var asapCallbackQueue = CallbackQueue.getPooled();
			var asapEnqueued = false;
	
			var batchingStrategy = null;
	
			function ensureInjected() {
			  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
			}
	
			var NESTED_UPDATES = {
			  initialize: function () {
			    this.dirtyComponentsLength = dirtyComponents.length;
			  },
			  close: function () {
			    if (this.dirtyComponentsLength !== dirtyComponents.length) {
			      // Additional updates were enqueued by componentDidUpdate handlers or
			      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
			      // these new updates so that if A's componentDidUpdate calls setState on
			      // B, B will update before the callback A's updater provided when calling
			      // setState.
			      dirtyComponents.splice(0, this.dirtyComponentsLength);
			      flushBatchedUpdates();
			    } else {
			      dirtyComponents.length = 0;
			    }
			  }
			};
	
			var UPDATE_QUEUEING = {
			  initialize: function () {
			    this.callbackQueue.reset();
			  },
			  close: function () {
			    this.callbackQueue.notifyAll();
			  }
			};
	
			var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
			function ReactUpdatesFlushTransaction() {
			  this.reinitializeTransaction();
			  this.dirtyComponentsLength = null;
			  this.callbackQueue = CallbackQueue.getPooled();
			  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
			  /* useCreateElement */true);
			}
	
			_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
			  getTransactionWrappers: function () {
			    return TRANSACTION_WRAPPERS;
			  },
	
			  destructor: function () {
			    this.dirtyComponentsLength = null;
			    CallbackQueue.release(this.callbackQueue);
			    this.callbackQueue = null;
			    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
			    this.reconcileTransaction = null;
			  },
	
			  perform: function (method, scope, a) {
			    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
			    // with this transaction's wrappers around it.
			    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
			  }
			});
	
			PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
			function batchedUpdates(callback, a, b, c, d, e) {
			  ensureInjected();
			  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
			}
	
			/**
			 * Array comparator for ReactComponents by mount ordering.
			 *
			 * @param {ReactComponent} c1 first component you're comparing
			 * @param {ReactComponent} c2 second component you're comparing
			 * @return {number} Return value usable by Array.prototype.sort().
			 */
			function mountOrderComparator(c1, c2) {
			  return c1._mountOrder - c2._mountOrder;
			}
	
			function runBatchedUpdates(transaction) {
			  var len = transaction.dirtyComponentsLength;
			  !(len === dirtyComponents.length) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
			  // Since reconciling a component higher in the owner hierarchy usually (not
			  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
			  // them before their children by sorting the array.
			  dirtyComponents.sort(mountOrderComparator);
	
			  // Any updates enqueued while reconciling must be performed after this entire
			  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
			  // C, B could update twice in a single batch if C's render enqueues an update
			  // to B (since B would have already updated, we should skip it, and the only
			  // way we can know to do so is by checking the batch counter).
			  updateBatchNumber++;
	
			  for (var i = 0; i < len; i++) {
			    // If a component is unmounted before pending changes apply, it will still
			    // be here, but we assume that it has cleared its _pendingCallbacks and
			    // that performUpdateIfNecessary is a noop.
			    var component = dirtyComponents[i];
	
			    // If performUpdateIfNecessary happens to enqueue any new updates, we
			    // shouldn't execute the callbacks until the next render happens, so
			    // stash the callbacks first
			    var callbacks = component._pendingCallbacks;
			    component._pendingCallbacks = null;
	
			    var markerName;
			    if (ReactFeatureFlags.logTopLevelRenders) {
			      var namedComponent = component;
			      // Duck type TopLevelWrapper. This is probably always true.
			      if (component._currentElement.type.isReactTopLevelWrapper) {
			        namedComponent = component._renderedComponent;
			      }
			      markerName = 'React update: ' + namedComponent.getName();
			      console.time(markerName);
			    }
	
			    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
			    if (markerName) {
			      console.timeEnd(markerName);
			    }
	
			    if (callbacks) {
			      for (var j = 0; j < callbacks.length; j++) {
			        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
			      }
			    }
			  }
			}
	
			var flushBatchedUpdates = function () {
			  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
			  // array and perform any updates enqueued by mount-ready handlers (i.e.,
			  // componentDidUpdate) but we need to check here too in order to catch
			  // updates enqueued by setState callbacks and asap calls.
			  while (dirtyComponents.length || asapEnqueued) {
			    if (dirtyComponents.length) {
			      var transaction = ReactUpdatesFlushTransaction.getPooled();
			      transaction.perform(runBatchedUpdates, null, transaction);
			      ReactUpdatesFlushTransaction.release(transaction);
			    }
	
			    if (asapEnqueued) {
			      asapEnqueued = false;
			      var queue = asapCallbackQueue;
			      asapCallbackQueue = CallbackQueue.getPooled();
			      queue.notifyAll();
			      CallbackQueue.release(queue);
			    }
			  }
			};
	
			/**
			 * Mark a component as needing a rerender, adding an optional callback to a
			 * list of functions which will be executed once the rerender occurs.
			 */
			function enqueueUpdate(component) {
			  ensureInjected();
	
			  // Various parts of our code (such as ReactCompositeComponent's
			  // _renderValidatedComponent) assume that calls to render aren't nested;
			  // verify that that's the case. (This is called by each top-level update
			  // function, like setState, forceUpdate, etc.; creation and
			  // destruction of top-level components is guarded in ReactMount.)
	
			  if (!batchingStrategy.isBatchingUpdates) {
			    batchingStrategy.batchedUpdates(enqueueUpdate, component);
			    return;
			  }
	
			  dirtyComponents.push(component);
			  if (component._updateBatchNumber == null) {
			    component._updateBatchNumber = updateBatchNumber + 1;
			  }
			}
	
			/**
			 * Enqueue a callback to be run at the end of the current batching cycle. Throws
			 * if no updates are currently being performed.
			 */
			function asap(callback, context) {
			  !batchingStrategy.isBatchingUpdates ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
			  asapCallbackQueue.enqueue(callback, context);
			  asapEnqueued = true;
			}
	
			var ReactUpdatesInjection = {
			  injectReconcileTransaction: function (ReconcileTransaction) {
			    !ReconcileTransaction ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
			    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
			  },
	
			  injectBatchingStrategy: function (_batchingStrategy) {
			    !_batchingStrategy ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
			    !(typeof _batchingStrategy.batchedUpdates === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
			    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
			    batchingStrategy = _batchingStrategy;
			  }
			};
	
			var ReactUpdates = {
			  /**
			   * React references `ReactReconcileTransaction` using this property in order
			   * to allow dependency injection.
			   *
			   * @internal
			   */
			  ReactReconcileTransaction: null,
	
			  batchedUpdates: batchedUpdates,
			  enqueueUpdate: enqueueUpdate,
			  flushBatchedUpdates: flushBatchedUpdates,
			  injection: ReactUpdatesInjection,
			  asap: asap
			};
	
			module.exports = ReactUpdates;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 32 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
			var PooledClass = __webpack_require__(25);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * A specialized pseudo-event module to help keep track of components waiting to
			 * be notified when their DOM representations are available for use.
			 *
			 * This implements `PooledClass`, so you should never need to instantiate this.
			 * Instead, use `CallbackQueue.getPooled()`.
			 *
			 * @class ReactMountReady
			 * @implements PooledClass
			 * @internal
			 */
	
			var CallbackQueue = function () {
			  function CallbackQueue(arg) {
			    _classCallCheck(this, CallbackQueue);
	
			    this._callbacks = null;
			    this._contexts = null;
			    this._arg = arg;
			  }
	
			  /**
			   * Enqueues a callback to be invoked when `notifyAll` is invoked.
			   *
			   * @param {function} callback Invoked when `notifyAll` is invoked.
			   * @param {?object} context Context to call `callback` with.
			   * @internal
			   */
	
	
			  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
			    this._callbacks = this._callbacks || [];
			    this._callbacks.push(callback);
			    this._contexts = this._contexts || [];
			    this._contexts.push(context);
			  };
	
			  /**
			   * Invokes all enqueued callbacks and clears the queue. This is invoked after
			   * the DOM representation of a component has been created or updated.
			   *
			   * @internal
			   */
	
	
			  CallbackQueue.prototype.notifyAll = function notifyAll() {
			    var callbacks = this._callbacks;
			    var contexts = this._contexts;
			    var arg = this._arg;
			    if (callbacks && contexts) {
			      !(callbacks.length === contexts.length) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
			      this._callbacks = null;
			      this._contexts = null;
			      for (var i = 0; i < callbacks.length; i++) {
			        callbacks[i].call(contexts[i], arg);
			      }
			      callbacks.length = 0;
			      contexts.length = 0;
			    }
			  };
	
			  CallbackQueue.prototype.checkpoint = function checkpoint() {
			    return this._callbacks ? this._callbacks.length : 0;
			  };
	
			  CallbackQueue.prototype.rollback = function rollback(len) {
			    if (this._callbacks && this._contexts) {
			      this._callbacks.length = len;
			      this._contexts.length = len;
			    }
			  };
	
			  /**
			   * Resets the internal queue.
			   *
			   * @internal
			   */
	
	
			  CallbackQueue.prototype.reset = function reset() {
			    this._callbacks = null;
			    this._contexts = null;
			  };
	
			  /**
			   * `PooledClass` looks for this.
			   */
	
	
			  CallbackQueue.prototype.destructor = function destructor() {
			    this.reset();
			  };
	
			  return CallbackQueue;
			}();
	
			module.exports = PooledClass.addPoolingTo(CallbackQueue);
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 33 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var ReactFeatureFlags = {
			  // When true, call console.time() before and .timeEnd() after each top-level
			  // render (both initial renders and updates). Useful when looking at prod-mode
			  // timeline profiles in Chrome, for example.
			  logTopLevelRenders: false
			};
	
			module.exports = ReactFeatureFlags;
	
		/***/ },
		/* 34 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactRef = __webpack_require__(35);
			var ReactInstrumentation = __webpack_require__(37);
	
			var warning = __webpack_require__(18);
	
			/**
			 * Helper to call ReactRef.attachRefs with this composite component, split out
			 * to avoid allocations in the transaction mount-ready queue.
			 */
			function attachRefs() {
			  ReactRef.attachRefs(this, this._currentElement);
			}
	
			var ReactReconciler = {
	
			  /**
			   * Initializes the component, renders markup, and registers event listeners.
			   *
			   * @param {ReactComponent} internalInstance
			   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
			   * @param {?object} the containing host component instance
			   * @param {?object} info about the host container
			   * @return {?string} Rendered markup to be inserted into the DOM.
			   * @final
			   * @internal
			   */
			  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
			  ) {
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
			      }
			    }
			    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
			    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
			      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
			    }
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
			      }
			    }
			    return markup;
			  },
	
			  /**
			   * Returns a value that can be passed to
			   * ReactComponentEnvironment.replaceNodeWithMarkup.
			   */
			  getHostNode: function (internalInstance) {
			    return internalInstance.getHostNode();
			  },
	
			  /**
			   * Releases any resources allocated by `mountComponent`.
			   *
			   * @final
			   * @internal
			   */
			  unmountComponent: function (internalInstance, safely) {
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
			      }
			    }
			    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
			    internalInstance.unmountComponent(safely);
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
			      }
			    }
			  },
	
			  /**
			   * Update a component using a new element.
			   *
			   * @param {ReactComponent} internalInstance
			   * @param {ReactElement} nextElement
			   * @param {ReactReconcileTransaction} transaction
			   * @param {object} context
			   * @internal
			   */
			  receiveComponent: function (internalInstance, nextElement, transaction, context) {
			    var prevElement = internalInstance._currentElement;
	
			    if (nextElement === prevElement && context === internalInstance._context) {
			      // Since elements are immutable after the owner is rendered,
			      // we can do a cheap identity compare here to determine if this is a
			      // superfluous reconcile. It's possible for state to be mutable but such
			      // change should trigger an update of the owner which would recreate
			      // the element. We explicitly check for the existence of an owner since
			      // it's possible for an element created outside a composite to be
			      // deeply mutated and reused.
	
			      // TODO: Bailing out early is just a perf optimization right?
			      // TODO: Removing the return statement should affect correctness?
			      return;
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
			      }
			    }
	
			    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
			    if (refsChanged) {
			      ReactRef.detachRefs(internalInstance, prevElement);
			    }
	
			    internalInstance.receiveComponent(nextElement, transaction, context);
	
			    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
			      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
			      }
			    }
			  },
	
			  /**
			   * Flush any dirty changes in a component.
			   *
			   * @param {ReactComponent} internalInstance
			   * @param {ReactReconcileTransaction} transaction
			   * @internal
			   */
			  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
			    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
			      // The component's enqueued batch number should always be the current
			      // batch or the following one.
			      process.env.NODE_ENV !== 'production' ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
			      return;
			    }
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
			      }
			    }
			    internalInstance.performUpdateIfNecessary(transaction);
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
			      }
			    }
			  }
	
			};
	
			module.exports = ReactReconciler;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 35 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var ReactOwner = __webpack_require__(36);
	
			var ReactRef = {};
	
			function attachRef(ref, component, owner) {
			  if (typeof ref === 'function') {
			    ref(component.getPublicInstance());
			  } else {
			    // Legacy ref
			    ReactOwner.addComponentAsRefTo(component, ref, owner);
			  }
			}
	
			function detachRef(ref, component, owner) {
			  if (typeof ref === 'function') {
			    ref(null);
			  } else {
			    // Legacy ref
			    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
			  }
			}
	
			ReactRef.attachRefs = function (instance, element) {
			  if (element === null || typeof element !== 'object') {
			    return;
			  }
			  var ref = element.ref;
			  if (ref != null) {
			    attachRef(ref, instance, element._owner);
			  }
			};
	
			ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
			  // If either the owner or a `ref` has changed, make sure the newest owner
			  // has stored a reference to `this`, and the previous owner (if different)
			  // has forgotten the reference to `this`. We use the element instead
			  // of the public this.props because the post processing cannot determine
			  // a ref. The ref conceptually lives on the element.
	
			  // TODO: Should this even be possible? The owner cannot change because
			  // it's forbidden by shouldUpdateReactComponent. The ref can change
			  // if you swap the keys of but not the refs. Reconsider where this check
			  // is made. It probably belongs where the key checking and
			  // instantiateReactComponent is done.
	
			  var prevRef = null;
			  var prevOwner = null;
			  if (prevElement !== null && typeof prevElement === 'object') {
			    prevRef = prevElement.ref;
			    prevOwner = prevElement._owner;
			  }
	
			  var nextRef = null;
			  var nextOwner = null;
			  if (nextElement !== null && typeof nextElement === 'object') {
			    nextRef = nextElement.ref;
			    nextOwner = nextElement._owner;
			  }
	
			  return prevRef !== nextRef ||
			  // If owner changes but we have an unchanged function ref, don't update refs
			  typeof nextRef === 'string' && nextOwner !== prevOwner;
			};
	
			ReactRef.detachRefs = function (instance, element) {
			  if (element === null || typeof element !== 'object') {
			    return;
			  }
			  var ref = element.ref;
			  if (ref != null) {
			    detachRef(ref, instance, element._owner);
			  }
			};
	
			module.exports = ReactRef;
	
		/***/ },
		/* 36 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * @param {?object} object
			 * @return {boolean} True if `object` is a valid owner.
			 * @final
			 */
			function isValidOwner(object) {
			  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
			}
	
			/**
			 * ReactOwners are capable of storing references to owned components.
			 *
			 * All components are capable of //being// referenced by owner components, but
			 * only ReactOwner components are capable of //referencing// owned components.
			 * The named reference is known as a "ref".
			 *
			 * Refs are available when mounted and updated during reconciliation.
			 *
			 *   var MyComponent = React.createClass({
			 *     render: function() {
			 *       return (
			 *         <div onClick={this.handleClick}>
			 *           <CustomComponent ref="custom" />
			 *         </div>
			 *       );
			 *     },
			 *     handleClick: function() {
			 *       this.refs.custom.handleClick();
			 *     },
			 *     componentDidMount: function() {
			 *       this.refs.custom.initialize();
			 *     }
			 *   });
			 *
			 * Refs should rarely be used. When refs are used, they should only be done to
			 * control data that is not handled by React's data flow.
			 *
			 * @class ReactOwner
			 */
			var ReactOwner = {
			  /**
			   * Adds a component by ref to an owner component.
			   *
			   * @param {ReactComponent} component Component to reference.
			   * @param {string} ref Name by which to refer to the component.
			   * @param {ReactOwner} owner Component on which to record the ref.
			   * @final
			   * @internal
			   */
			  addComponentAsRefTo: function (component, ref, owner) {
			    !isValidOwner(owner) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
			    owner.attachRef(ref, component);
			  },
	
			  /**
			   * Removes a component by ref from an owner component.
			   *
			   * @param {ReactComponent} component Component to dereference.
			   * @param {string} ref Name of the ref to remove.
			   * @param {ReactOwner} owner Component on which the ref is recorded.
			   * @final
			   * @internal
			   */
			  removeComponentAsRefFrom: function (component, ref, owner) {
			    !isValidOwner(owner) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
			    var ownerPublicInstance = owner.getPublicInstance();
			    // Check that `component`'s owner is still alive and that `component` is still the current ref
			    // because we do not want to detach the ref if another component stole it.
			    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
			      owner.detachRef(ref);
			    }
			  }
	
			};
	
			module.exports = ReactOwner;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 37 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2016-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
			var debugTool = null;
	
			if (process.env.NODE_ENV !== 'production') {
			  var ReactDebugTool = __webpack_require__(38);
			  debugTool = ReactDebugTool;
			}
	
			module.exports = { debugTool: debugTool };
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 38 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2016-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var ReactInvalidSetStateWarningHook = __webpack_require__(39);
			var ReactHostOperationHistoryHook = __webpack_require__(40);
			var ReactComponentTreeHook = __webpack_require__(41);
			var ExecutionEnvironment = __webpack_require__(22);
	
			var performanceNow = __webpack_require__(47);
			var warning = __webpack_require__(18);
	
			var hooks = [];
			var didHookThrowForEvent = {};
	
			function callHook(event, fn, context, arg1, arg2, arg3, arg4, arg5) {
			  try {
			    fn.call(context, arg1, arg2, arg3, arg4, arg5);
			  } catch (e) {
			    process.env.NODE_ENV !== 'production' ? warning(didHookThrowForEvent[event], 'Exception thrown by hook while handling %s: %s', event, e + '\n' + e.stack) : void 0;
			    didHookThrowForEvent[event] = true;
			  }
			}
	
			function emitEvent(event, arg1, arg2, arg3, arg4, arg5) {
			  for (var i = 0; i < hooks.length; i++) {
			    var hook = hooks[i];
			    var fn = hook[event];
			    if (fn) {
			      callHook(event, fn, hook, arg1, arg2, arg3, arg4, arg5);
			    }
			  }
			}
	
			var isProfiling = false;
			var flushHistory = [];
			var lifeCycleTimerStack = [];
			var currentFlushNesting = 0;
			var currentFlushMeasurements = [];
			var currentFlushStartTime = 0;
			var currentTimerDebugID = null;
			var currentTimerStartTime = 0;
			var currentTimerNestedFlushDuration = 0;
			var currentTimerType = null;
	
			var lifeCycleTimerHasWarned = false;
	
			function clearHistory() {
			  ReactComponentTreeHook.purgeUnmountedComponents();
			  ReactHostOperationHistoryHook.clearHistory();
			}
	
			function getTreeSnapshot(registeredIDs) {
			  return registeredIDs.reduce(function (tree, id) {
			    var ownerID = ReactComponentTreeHook.getOwnerID(id);
			    var parentID = ReactComponentTreeHook.getParentID(id);
			    tree[id] = {
			      displayName: ReactComponentTreeHook.getDisplayName(id),
			      text: ReactComponentTreeHook.getText(id),
			      updateCount: ReactComponentTreeHook.getUpdateCount(id),
			      childIDs: ReactComponentTreeHook.getChildIDs(id),
			      // Text nodes don't have owners but this is close enough.
			      ownerID: ownerID || parentID && ReactComponentTreeHook.getOwnerID(parentID) || 0,
			      parentID: parentID
			    };
			    return tree;
			  }, {});
			}
	
			function resetMeasurements() {
			  var previousStartTime = currentFlushStartTime;
			  var previousMeasurements = currentFlushMeasurements;
			  var previousOperations = ReactHostOperationHistoryHook.getHistory();
	
			  if (currentFlushNesting === 0) {
			    currentFlushStartTime = 0;
			    currentFlushMeasurements = [];
			    clearHistory();
			    return;
			  }
	
			  if (previousMeasurements.length || previousOperations.length) {
			    var registeredIDs = ReactComponentTreeHook.getRegisteredIDs();
			    flushHistory.push({
			      duration: performanceNow() - previousStartTime,
			      measurements: previousMeasurements || [],
			      operations: previousOperations || [],
			      treeSnapshot: getTreeSnapshot(registeredIDs)
			    });
			  }
	
			  clearHistory();
			  currentFlushStartTime = performanceNow();
			  currentFlushMeasurements = [];
			}
	
			function checkDebugID(debugID) {
			  var allowRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
			  if (allowRoot && debugID === 0) {
			    return;
			  }
			  if (!debugID) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDebugTool: debugID may not be empty.') : void 0;
			  }
			}
	
			function beginLifeCycleTimer(debugID, timerType) {
			  if (currentFlushNesting === 0) {
			    return;
			  }
			  if (currentTimerType && !lifeCycleTimerHasWarned) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'Did not expect %s timer to start while %s timer is still in ' + 'progress for %s instance.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
			    lifeCycleTimerHasWarned = true;
			  }
			  currentTimerStartTime = performanceNow();
			  currentTimerNestedFlushDuration = 0;
			  currentTimerDebugID = debugID;
			  currentTimerType = timerType;
			}
	
			function endLifeCycleTimer(debugID, timerType) {
			  if (currentFlushNesting === 0) {
			    return;
			  }
			  if (currentTimerType !== timerType && !lifeCycleTimerHasWarned) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'We did not expect %s timer to stop while %s timer is still in ' + 'progress for %s instance. Please report this as a bug in React.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
			    lifeCycleTimerHasWarned = true;
			  }
			  if (isProfiling) {
			    currentFlushMeasurements.push({
			      timerType: timerType,
			      instanceID: debugID,
			      duration: performanceNow() - currentTimerStartTime - currentTimerNestedFlushDuration
			    });
			  }
			  currentTimerStartTime = 0;
			  currentTimerNestedFlushDuration = 0;
			  currentTimerDebugID = null;
			  currentTimerType = null;
			}
	
			function pauseCurrentLifeCycleTimer() {
			  var currentTimer = {
			    startTime: currentTimerStartTime,
			    nestedFlushStartTime: performanceNow(),
			    debugID: currentTimerDebugID,
			    timerType: currentTimerType
			  };
			  lifeCycleTimerStack.push(currentTimer);
			  currentTimerStartTime = 0;
			  currentTimerNestedFlushDuration = 0;
			  currentTimerDebugID = null;
			  currentTimerType = null;
			}
	
			function resumeCurrentLifeCycleTimer() {
			  var _lifeCycleTimerStack$ = lifeCycleTimerStack.pop(),
			      startTime = _lifeCycleTimerStack$.startTime,
			      nestedFlushStartTime = _lifeCycleTimerStack$.nestedFlushStartTime,
			      debugID = _lifeCycleTimerStack$.debugID,
			      timerType = _lifeCycleTimerStack$.timerType;
	
			  var nestedFlushDuration = performanceNow() - nestedFlushStartTime;
			  currentTimerStartTime = startTime;
			  currentTimerNestedFlushDuration += nestedFlushDuration;
			  currentTimerDebugID = debugID;
			  currentTimerType = timerType;
			}
	
			var lastMarkTimeStamp = 0;
			var canUsePerformanceMeasure = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function';
	
			function shouldMark(debugID) {
			  if (!isProfiling || !canUsePerformanceMeasure) {
			    return false;
			  }
			  var element = ReactComponentTreeHook.getElement(debugID);
			  if (element == null || typeof element !== 'object') {
			    return false;
			  }
			  var isHostElement = typeof element.type === 'string';
			  if (isHostElement) {
			    return false;
			  }
			  return true;
			}
	
			function markBegin(debugID, markType) {
			  if (!shouldMark(debugID)) {
			    return;
			  }
	
			  var markName = debugID + '::' + markType;
			  lastMarkTimeStamp = performanceNow();
			  performance.mark(markName);
			}
	
			function markEnd(debugID, markType) {
			  if (!shouldMark(debugID)) {
			    return;
			  }
	
			  var markName = debugID + '::' + markType;
			  var displayName = ReactComponentTreeHook.getDisplayName(debugID) || 'Unknown';
	
			  // Chrome has an issue of dropping markers recorded too fast:
			  // https://bugs.chromium.org/p/chromium/issues/detail?id=640652
			  // To work around this, we will not report very small measurements.
			  // I determined the magic number by tweaking it back and forth.
			  // 0.05ms was enough to prevent the issue, but I set it to 0.1ms to be safe.
			  // When the bug is fixed, we can `measure()` unconditionally if we want to.
			  var timeStamp = performanceNow();
			  if (timeStamp - lastMarkTimeStamp > 0.1) {
			    var measurementName = displayName + ' [' + markType + ']';
			    performance.measure(measurementName, markName);
			  }
	
			  performance.clearMarks(markName);
			  performance.clearMeasures(measurementName);
			}
	
			var ReactDebugTool = {
			  addHook: function (hook) {
			    hooks.push(hook);
			  },
			  removeHook: function (hook) {
			    for (var i = 0; i < hooks.length; i++) {
			      if (hooks[i] === hook) {
			        hooks.splice(i, 1);
			        i--;
			      }
			    }
			  },
			  isProfiling: function () {
			    return isProfiling;
			  },
			  beginProfiling: function () {
			    if (isProfiling) {
			      return;
			    }
	
			    isProfiling = true;
			    flushHistory.length = 0;
			    resetMeasurements();
			    ReactDebugTool.addHook(ReactHostOperationHistoryHook);
			  },
			  endProfiling: function () {
			    if (!isProfiling) {
			      return;
			    }
	
			    isProfiling = false;
			    resetMeasurements();
			    ReactDebugTool.removeHook(ReactHostOperationHistoryHook);
			  },
			  getFlushHistory: function () {
			    return flushHistory;
			  },
			  onBeginFlush: function () {
			    currentFlushNesting++;
			    resetMeasurements();
			    pauseCurrentLifeCycleTimer();
			    emitEvent('onBeginFlush');
			  },
			  onEndFlush: function () {
			    resetMeasurements();
			    currentFlushNesting--;
			    resumeCurrentLifeCycleTimer();
			    emitEvent('onEndFlush');
			  },
			  onBeginLifeCycleTimer: function (debugID, timerType) {
			    checkDebugID(debugID);
			    emitEvent('onBeginLifeCycleTimer', debugID, timerType);
			    markBegin(debugID, timerType);
			    beginLifeCycleTimer(debugID, timerType);
			  },
			  onEndLifeCycleTimer: function (debugID, timerType) {
			    checkDebugID(debugID);
			    endLifeCycleTimer(debugID, timerType);
			    markEnd(debugID, timerType);
			    emitEvent('onEndLifeCycleTimer', debugID, timerType);
			  },
			  onBeginProcessingChildContext: function () {
			    emitEvent('onBeginProcessingChildContext');
			  },
			  onEndProcessingChildContext: function () {
			    emitEvent('onEndProcessingChildContext');
			  },
			  onHostOperation: function (operation) {
			    checkDebugID(operation.instanceID);
			    emitEvent('onHostOperation', operation);
			  },
			  onSetState: function () {
			    emitEvent('onSetState');
			  },
			  onSetChildren: function (debugID, childDebugIDs) {
			    checkDebugID(debugID);
			    childDebugIDs.forEach(checkDebugID);
			    emitEvent('onSetChildren', debugID, childDebugIDs);
			  },
			  onBeforeMountComponent: function (debugID, element, parentDebugID) {
			    checkDebugID(debugID);
			    checkDebugID(parentDebugID, true);
			    emitEvent('onBeforeMountComponent', debugID, element, parentDebugID);
			    markBegin(debugID, 'mount');
			  },
			  onMountComponent: function (debugID) {
			    checkDebugID(debugID);
			    markEnd(debugID, 'mount');
			    emitEvent('onMountComponent', debugID);
			  },
			  onBeforeUpdateComponent: function (debugID, element) {
			    checkDebugID(debugID);
			    emitEvent('onBeforeUpdateComponent', debugID, element);
			    markBegin(debugID, 'update');
			  },
			  onUpdateComponent: function (debugID) {
			    checkDebugID(debugID);
			    markEnd(debugID, 'update');
			    emitEvent('onUpdateComponent', debugID);
			  },
			  onBeforeUnmountComponent: function (debugID) {
			    checkDebugID(debugID);
			    emitEvent('onBeforeUnmountComponent', debugID);
			    markBegin(debugID, 'unmount');
			  },
			  onUnmountComponent: function (debugID) {
			    checkDebugID(debugID);
			    markEnd(debugID, 'unmount');
			    emitEvent('onUnmountComponent', debugID);
			  },
			  onTestEvent: function () {
			    emitEvent('onTestEvent');
			  }
			};
	
			// TODO remove these when RN/www gets updated
			ReactDebugTool.addDevtool = ReactDebugTool.addHook;
			ReactDebugTool.removeDevtool = ReactDebugTool.removeHook;
	
			ReactDebugTool.addHook(ReactInvalidSetStateWarningHook);
			ReactDebugTool.addHook(ReactComponentTreeHook);
			var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
			if (/[?&]react_perf\b/.test(url)) {
			  ReactDebugTool.beginProfiling();
			}
	
			module.exports = ReactDebugTool;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 39 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2016-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var warning = __webpack_require__(18);
	
			if (process.env.NODE_ENV !== 'production') {
			  var processingChildContext = false;
	
			  var warnInvalidSetState = function () {
			    process.env.NODE_ENV !== 'production' ? warning(!processingChildContext, 'setState(...): Cannot call setState() inside getChildContext()') : void 0;
			  };
			}
	
			var ReactInvalidSetStateWarningHook = {
			  onBeginProcessingChildContext: function () {
			    processingChildContext = true;
			  },
			  onEndProcessingChildContext: function () {
			    processingChildContext = false;
			  },
			  onSetState: function () {
			    warnInvalidSetState();
			  }
			};
	
			module.exports = ReactInvalidSetStateWarningHook;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 40 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2016-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var history = [];
	
			var ReactHostOperationHistoryHook = {
			  onHostOperation: function (operation) {
			    history.push(operation);
			  },
			  clearHistory: function () {
			    if (ReactHostOperationHistoryHook._preventClearing) {
			      // Should only be used for tests.
			      return;
			    }
	
			    history = [];
			  },
			  getHistory: function () {
			    return history;
			  }
			};
	
			module.exports = ReactHostOperationHistoryHook;
	
		/***/ },
		/* 41 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2016-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(42);
	
			var ReactCurrentOwner = __webpack_require__(43);
	
			var invariant = __webpack_require__(44);
			var warning = __webpack_require__(45);
	
			function isNative(fn) {
			  // Based on isNative() from Lodash
			  var funcToString = Function.prototype.toString;
			  var hasOwnProperty = Object.prototype.hasOwnProperty;
			  var reIsNative = RegExp('^' + funcToString
			  // Take an example native function source for comparison
			  .call(hasOwnProperty)
			  // Strip regex characters so we can use it for regex
			  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
			  // Remove hasOwnProperty from the template to make it generic
			  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
			  try {
			    var source = funcToString.call(fn);
			    return reIsNative.test(source);
			  } catch (err) {
			    return false;
			  }
			}
	
			var canUseCollections =
			// Array.from
			typeof Array.from === 'function' &&
			// Map
			typeof Map === 'function' && isNative(Map) &&
			// Map.prototype.keys
			Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
			// Set
			typeof Set === 'function' && isNative(Set) &&
			// Set.prototype.keys
			Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
			var setItem;
			var getItem;
			var removeItem;
			var getItemIDs;
			var addRoot;
			var removeRoot;
			var getRootIDs;
	
			if (canUseCollections) {
			  var itemMap = new Map();
			  var rootIDSet = new Set();
	
			  setItem = function (id, item) {
			    itemMap.set(id, item);
			  };
			  getItem = function (id) {
			    return itemMap.get(id);
			  };
			  removeItem = function (id) {
			    itemMap['delete'](id);
			  };
			  getItemIDs = function () {
			    return Array.from(itemMap.keys());
			  };
	
			  addRoot = function (id) {
			    rootIDSet.add(id);
			  };
			  removeRoot = function (id) {
			    rootIDSet['delete'](id);
			  };
			  getRootIDs = function () {
			    return Array.from(rootIDSet.keys());
			  };
			} else {
			  var itemByKey = {};
			  var rootByKey = {};
	
			  // Use non-numeric keys to prevent V8 performance issues:
			  // https://github.com/facebook/react/pull/7232
			  var getKeyFromID = function (id) {
			    return '.' + id;
			  };
			  var getIDFromKey = function (key) {
			    return parseInt(key.substr(1), 10);
			  };
	
			  setItem = function (id, item) {
			    var key = getKeyFromID(id);
			    itemByKey[key] = item;
			  };
			  getItem = function (id) {
			    var key = getKeyFromID(id);
			    return itemByKey[key];
			  };
			  removeItem = function (id) {
			    var key = getKeyFromID(id);
			    delete itemByKey[key];
			  };
			  getItemIDs = function () {
			    return Object.keys(itemByKey).map(getIDFromKey);
			  };
	
			  addRoot = function (id) {
			    var key = getKeyFromID(id);
			    rootByKey[key] = true;
			  };
			  removeRoot = function (id) {
			    var key = getKeyFromID(id);
			    delete rootByKey[key];
			  };
			  getRootIDs = function () {
			    return Object.keys(rootByKey).map(getIDFromKey);
			  };
			}
	
			var unmountedIDs = [];
	
			function purgeDeep(id) {
			  var item = getItem(id);
			  if (item) {
			    var childIDs = item.childIDs;
	
			    removeItem(id);
			    childIDs.forEach(purgeDeep);
			  }
			}
	
			function describeComponentFrame(name, source, ownerName) {
			  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
			}
	
			function getDisplayName(element) {
			  if (element == null) {
			    return '#empty';
			  } else if (typeof element === 'string' || typeof element === 'number') {
			    return '#text';
			  } else if (typeof element.type === 'string') {
			    return element.type;
			  } else {
			    return element.type.displayName || element.type.name || 'Unknown';
			  }
			}
	
			function describeID(id) {
			  var name = ReactComponentTreeHook.getDisplayName(id);
			  var element = ReactComponentTreeHook.getElement(id);
			  var ownerID = ReactComponentTreeHook.getOwnerID(id);
			  var ownerName;
			  if (ownerID) {
			    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
			  }
			  process.env.NODE_ENV !== 'production' ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
			  return describeComponentFrame(name, element && element._source, ownerName);
			}
	
			var ReactComponentTreeHook = {
			  onSetChildren: function (id, nextChildIDs) {
			    var item = getItem(id);
			    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
			    item.childIDs = nextChildIDs;
	
			    for (var i = 0; i < nextChildIDs.length; i++) {
			      var nextChildID = nextChildIDs[i];
			      var nextChild = getItem(nextChildID);
			      !nextChild ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
			      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
			      !nextChild.isMounted ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
			      if (nextChild.parentID == null) {
			        nextChild.parentID = id;
			        // TODO: This shouldn't be necessary but mounting a new root during in
			        // componentWillMount currently causes not-yet-mounted components to
			        // be purged from our tree data so their parent id is missing.
			      }
			      !(nextChild.parentID === id) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
			    }
			  },
			  onBeforeMountComponent: function (id, element, parentID) {
			    var item = {
			      element: element,
			      parentID: parentID,
			      text: null,
			      childIDs: [],
			      isMounted: false,
			      updateCount: 0
			    };
			    setItem(id, item);
			  },
			  onBeforeUpdateComponent: function (id, element) {
			    var item = getItem(id);
			    if (!item || !item.isMounted) {
			      // We may end up here as a result of setState() in componentWillUnmount().
			      // In this case, ignore the element.
			      return;
			    }
			    item.element = element;
			  },
			  onMountComponent: function (id) {
			    var item = getItem(id);
			    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
			    item.isMounted = true;
			    var isRoot = item.parentID === 0;
			    if (isRoot) {
			      addRoot(id);
			    }
			  },
			  onUpdateComponent: function (id) {
			    var item = getItem(id);
			    if (!item || !item.isMounted) {
			      // We may end up here as a result of setState() in componentWillUnmount().
			      // In this case, ignore the element.
			      return;
			    }
			    item.updateCount++;
			  },
			  onUnmountComponent: function (id) {
			    var item = getItem(id);
			    if (item) {
			      // We need to check if it exists.
			      // `item` might not exist if it is inside an error boundary, and a sibling
			      // error boundary child threw while mounting. Then this instance never
			      // got a chance to mount, but it still gets an unmounting event during
			      // the error boundary cleanup.
			      item.isMounted = false;
			      var isRoot = item.parentID === 0;
			      if (isRoot) {
			        removeRoot(id);
			      }
			    }
			    unmountedIDs.push(id);
			  },
			  purgeUnmountedComponents: function () {
			    if (ReactComponentTreeHook._preventPurging) {
			      // Should only be used for testing.
			      return;
			    }
	
			    for (var i = 0; i < unmountedIDs.length; i++) {
			      var id = unmountedIDs[i];
			      purgeDeep(id);
			    }
			    unmountedIDs.length = 0;
			  },
			  isMounted: function (id) {
			    var item = getItem(id);
			    return item ? item.isMounted : false;
			  },
			  getCurrentStackAddendum: function (topElement) {
			    var info = '';
			    if (topElement) {
			      var name = getDisplayName(topElement);
			      var owner = topElement._owner;
			      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
			    }
	
			    var currentOwner = ReactCurrentOwner.current;
			    var id = currentOwner && currentOwner._debugID;
	
			    info += ReactComponentTreeHook.getStackAddendumByID(id);
			    return info;
			  },
			  getStackAddendumByID: function (id) {
			    var info = '';
			    while (id) {
			      info += describeID(id);
			      id = ReactComponentTreeHook.getParentID(id);
			    }
			    return info;
			  },
			  getChildIDs: function (id) {
			    var item = getItem(id);
			    return item ? item.childIDs : [];
			  },
			  getDisplayName: function (id) {
			    var element = ReactComponentTreeHook.getElement(id);
			    if (!element) {
			      return null;
			    }
			    return getDisplayName(element);
			  },
			  getElement: function (id) {
			    var item = getItem(id);
			    return item ? item.element : null;
			  },
			  getOwnerID: function (id) {
			    var element = ReactComponentTreeHook.getElement(id);
			    if (!element || !element._owner) {
			      return null;
			    }
			    return element._owner._debugID;
			  },
			  getParentID: function (id) {
			    var item = getItem(id);
			    return item ? item.parentID : null;
			  },
			  getSource: function (id) {
			    var item = getItem(id);
			    var element = item ? item.element : null;
			    var source = element != null ? element._source : null;
			    return source;
			  },
			  getText: function (id) {
			    var element = ReactComponentTreeHook.getElement(id);
			    if (typeof element === 'string') {
			      return element;
			    } else if (typeof element === 'number') {
			      return '' + element;
			    } else {
			      return null;
			    }
			  },
			  getUpdateCount: function (id) {
			    var item = getItem(id);
			    return item ? item.updateCount : 0;
			  },
	
	
			  getRootIDs: getRootIDs,
			  getRegisteredIDs: getItemIDs
			};
	
			module.exports = ReactComponentTreeHook;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 42 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
			'use strict';
	
			/**
			 * WARNING: DO NOT manually require this module.
			 * This is a replacement for `invariant(...)` used by the error code system
			 * and will _only_ be required by the corresponding babel pass.
			 * It always throws.
			 */
	
			function reactProdInvariant(code) {
			  var argCount = arguments.length - 1;
	
			  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
			  for (var argIdx = 0; argIdx < argCount; argIdx++) {
			    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
			  }
	
			  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
			  var error = new Error(message);
			  error.name = 'Invariant Violation';
			  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
			  throw error;
			}
	
			module.exports = reactProdInvariant;
	
		/***/ },
		/* 43 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			/**
			 * Keeps track of the current owner.
			 *
			 * The current owner is the component who should own any components that are
			 * currently being constructed.
			 */
			var ReactCurrentOwner = {
	
			  /**
			   * @internal
			   * @type {ReactComponent}
			   */
			  current: null
	
			};
	
			module.exports = ReactCurrentOwner;
	
		/***/ },
		/* 44 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * Use invariant() to assert state which your program assumes to be true.
			 *
			 * Provide sprintf-style format (only %s is supported) and arguments
			 * to provide information about what broke and what you were
			 * expecting.
			 *
			 * The invariant message will be stripped in production, but the invariant
			 * will remain to ensure logic does not differ in production.
			 */
	
			var validateFormat = function validateFormat(format) {};
	
			if (process.env.NODE_ENV !== 'production') {
			  validateFormat = function validateFormat(format) {
			    if (format === undefined) {
			      throw new Error('invariant requires an error message argument');
			    }
			  };
			}
	
			function invariant(condition, format, a, b, c, d, e, f) {
			  validateFormat(format);
	
			  if (!condition) {
			    var error;
			    if (format === undefined) {
			      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
			    } else {
			      var args = [a, b, c, d, e, f];
			      var argIndex = 0;
			      error = new Error(format.replace(/%s/g, function () {
			        return args[argIndex++];
			      }));
			      error.name = 'Invariant Violation';
			    }
	
			    error.framesToPop = 1; // we don't care about invariant's own frame
			    throw error;
			  }
			}
	
			module.exports = invariant;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 45 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-2015, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var emptyFunction = __webpack_require__(46);
	
			/**
			 * Similar to invariant but only logs a warning if the condition is not met.
			 * This can be used to log issues in development environments in critical
			 * paths. Removing the logging code for production environments will keep the
			 * same logic and follow the same code paths.
			 */
	
			var warning = emptyFunction;
	
			if (process.env.NODE_ENV !== 'production') {
			  (function () {
			    var printWarning = function printWarning(format) {
			      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			        args[_key - 1] = arguments[_key];
			      }
	
			      var argIndex = 0;
			      var message = 'Warning: ' + format.replace(/%s/g, function () {
			        return args[argIndex++];
			      });
			      if (typeof console !== 'undefined') {
			        console.error(message);
			      }
			      try {
			        // --- Welcome to debugging React ---
			        // This error was thrown as a convenience so that you can use this stack
			        // to find the callsite that caused this warning to fire.
			        throw new Error(message);
			      } catch (x) {}
			    };
	
			    warning = function warning(condition, format) {
			      if (format === undefined) {
			        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
			      }
	
			      if (format.indexOf('Failed Composite propType: ') === 0) {
			        return; // Ignore CompositeComponent proptype check.
			      }
	
			      if (!condition) {
			        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
			          args[_key2 - 2] = arguments[_key2];
			        }
	
			        printWarning.apply(undefined, [format].concat(args));
			      }
			    };
			  })();
			}
	
			module.exports = warning;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 46 */
		/***/ function(module, exports) {
	
			"use strict";
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			function makeEmptyFunction(arg) {
			  return function () {
			    return arg;
			  };
			}
	
			/**
			 * This function accepts and discards inputs; it has no side effects. This is
			 * primarily useful idiomatically for overridable function endpoints which
			 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
			 */
			var emptyFunction = function emptyFunction() {};
	
			emptyFunction.thatReturns = makeEmptyFunction;
			emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
			emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
			emptyFunction.thatReturnsNull = makeEmptyFunction(null);
			emptyFunction.thatReturnsThis = function () {
			  return this;
			};
			emptyFunction.thatReturnsArgument = function (arg) {
			  return arg;
			};
	
			module.exports = emptyFunction;
	
		/***/ },
		/* 47 */
		/***/ function(module, exports, __webpack_require__) {
	
			'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			var performance = __webpack_require__(48);
	
			var performanceNow;
	
			/**
			 * Detect if we can use `window.performance.now()` and gracefully fallback to
			 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
			 * because of Facebook's testing infrastructure.
			 */
			if (performance.now) {
			  performanceNow = function performanceNow() {
			    return performance.now();
			  };
			} else {
			  performanceNow = function performanceNow() {
			    return Date.now();
			  };
			}
	
			module.exports = performanceNow;
	
		/***/ },
		/* 48 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			'use strict';
	
			var ExecutionEnvironment = __webpack_require__(22);
	
			var performance;
	
			if (ExecutionEnvironment.canUseDOM) {
			  performance = window.performance || window.msPerformance || window.webkitPerformance;
			}
	
			module.exports = performance || {};
	
		/***/ },
		/* 49 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			var OBSERVED_ERROR = {};
	
			/**
			 * `Transaction` creates a black box that is able to wrap any method such that
			 * certain invariants are maintained before and after the method is invoked
			 * (Even if an exception is thrown while invoking the wrapped method). Whoever
			 * instantiates a transaction can provide enforcers of the invariants at
			 * creation time. The `Transaction` class itself will supply one additional
			 * automatic invariant for you - the invariant that any transaction instance
			 * should not be run while it is already being run. You would typically create a
			 * single instance of a `Transaction` for reuse multiple times, that potentially
			 * is used to wrap several different methods. Wrappers are extremely simple -
			 * they only require implementing two methods.
			 *
			 * <pre>
			 *                       wrappers (injected at creation time)
			 *                                      +        +
			 *                                      |        |
			 *                    +-----------------|--------|--------------+
			 *                    |                 v        |              |
			 *                    |      +---------------+   |              |
			 *                    |   +--|    wrapper1   |---|----+         |
			 *                    |   |  +---------------+   v    |         |
			 *                    |   |          +-------------+  |         |
			 *                    |   |     +----|   wrapper2  |--------+   |
			 *                    |   |     |    +-------------+  |     |   |
			 *                    |   |     |                     |     |   |
			 *                    |   v     v                     v     v   | wrapper
			 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
			 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
			 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
			 *                    | |   | |   |   |         |   |   | |   | |
			 *                    | |   | |   |   |         |   |   | |   | |
			 *                    | |   | |   |   |         |   |   | |   | |
			 *                    | +---+ +---+   +---------+   +---+ +---+ |
			 *                    |  initialize                    close    |
			 *                    +-----------------------------------------+
			 * </pre>
			 *
			 * Use cases:
			 * - Preserving the input selection ranges before/after reconciliation.
			 *   Restoring selection even in the event of an unexpected error.
			 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
			 *   while guaranteeing that afterwards, the event system is reactivated.
			 * - Flushing a queue of collected DOM mutations to the main UI thread after a
			 *   reconciliation takes place in a worker thread.
			 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
			 *   content.
			 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
			 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
			 * - (Future use case): Layout calculations before and after DOM updates.
			 *
			 * Transactional plugin API:
			 * - A module that has an `initialize` method that returns any precomputation.
			 * - and a `close` method that accepts the precomputation. `close` is invoked
			 *   when the wrapped process is completed, or has failed.
			 *
			 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
			 * that implement `initialize` and `close`.
			 * @return {Transaction} Single transaction for reuse in thread.
			 *
			 * @class Transaction
			 */
			var TransactionImpl = {
			  /**
			   * Sets up this instance so that it is prepared for collecting metrics. Does
			   * so such that this setup method may be used on an instance that is already
			   * initialized, in a way that does not consume additional memory upon reuse.
			   * That can be useful if you decide to make your subclass of this mixin a
			   * "PooledClass".
			   */
			  reinitializeTransaction: function () {
			    this.transactionWrappers = this.getTransactionWrappers();
			    if (this.wrapperInitData) {
			      this.wrapperInitData.length = 0;
			    } else {
			      this.wrapperInitData = [];
			    }
			    this._isInTransaction = false;
			  },
	
			  _isInTransaction: false,
	
			  /**
			   * @abstract
			   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
			   */
			  getTransactionWrappers: null,
	
			  isInTransaction: function () {
			    return !!this._isInTransaction;
			  },
	
			  /**
			   * Executes the function within a safety window. Use this for the top level
			   * methods that result in large amounts of computation/mutations that would
			   * need to be safety checked. The optional arguments helps prevent the need
			   * to bind in many cases.
			   *
			   * @param {function} method Member of scope to call.
			   * @param {Object} scope Scope to invoke from.
			   * @param {Object?=} a Argument to pass to the method.
			   * @param {Object?=} b Argument to pass to the method.
			   * @param {Object?=} c Argument to pass to the method.
			   * @param {Object?=} d Argument to pass to the method.
			   * @param {Object?=} e Argument to pass to the method.
			   * @param {Object?=} f Argument to pass to the method.
			   *
			   * @return {*} Return value from `method`.
			   */
			  perform: function (method, scope, a, b, c, d, e, f) {
			    !!this.isInTransaction() ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
			    var errorThrown;
			    var ret;
			    try {
			      this._isInTransaction = true;
			      // Catching errors makes debugging more difficult, so we start with
			      // errorThrown set to true before setting it to false after calling
			      // close -- if it's still set to true in the finally block, it means
			      // one of these calls threw.
			      errorThrown = true;
			      this.initializeAll(0);
			      ret = method.call(scope, a, b, c, d, e, f);
			      errorThrown = false;
			    } finally {
			      try {
			        if (errorThrown) {
			          // If `method` throws, prefer to show that stack trace over any thrown
			          // by invoking `closeAll`.
			          try {
			            this.closeAll(0);
			          } catch (err) {}
			        } else {
			          // Since `method` didn't throw, we don't want to silence the exception
			          // here.
			          this.closeAll(0);
			        }
			      } finally {
			        this._isInTransaction = false;
			      }
			    }
			    return ret;
			  },
	
			  initializeAll: function (startIndex) {
			    var transactionWrappers = this.transactionWrappers;
			    for (var i = startIndex; i < transactionWrappers.length; i++) {
			      var wrapper = transactionWrappers[i];
			      try {
			        // Catching errors makes debugging more difficult, so we start with the
			        // OBSERVED_ERROR state before overwriting it with the real return value
			        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
			        // block, it means wrapper.initialize threw.
			        this.wrapperInitData[i] = OBSERVED_ERROR;
			        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
			      } finally {
			        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
			          // The initializer for wrapper i threw an error; initialize the
			          // remaining wrappers but silence any exceptions from them to ensure
			          // that the first error is the one to bubble up.
			          try {
			            this.initializeAll(i + 1);
			          } catch (err) {}
			        }
			      }
			    }
			  },
	
			  /**
			   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
			   * them the respective return values of `this.transactionWrappers.init[i]`
			   * (`close`rs that correspond to initializers that failed will not be
			   * invoked).
			   */
			  closeAll: function (startIndex) {
			    !this.isInTransaction() ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
			    var transactionWrappers = this.transactionWrappers;
			    for (var i = startIndex; i < transactionWrappers.length; i++) {
			      var wrapper = transactionWrappers[i];
			      var initData = this.wrapperInitData[i];
			      var errorThrown;
			      try {
			        // Catching errors makes debugging more difficult, so we start with
			        // errorThrown set to true before setting it to false after calling
			        // close -- if it's still set to true in the finally block, it means
			        // wrapper.close threw.
			        errorThrown = true;
			        if (initData !== OBSERVED_ERROR && wrapper.close) {
			          wrapper.close.call(this, initData);
			        }
			        errorThrown = false;
			      } finally {
			        if (errorThrown) {
			          // The closer for wrapper i threw an error; close the remaining
			          // wrappers but silence any exceptions from them to ensure that the
			          // first error is the one to bubble up.
			          try {
			            this.closeAll(i + 1);
			          } catch (e) {}
			        }
			      }
			    }
			    this.wrapperInitData.length = 0;
			  }
			};
	
			module.exports = TransactionImpl;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 50 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * Gets the target node from a native browser event by accounting for
			 * inconsistencies in browser DOM APIs.
			 *
			 * @param {object} nativeEvent Native browser event.
			 * @return {DOMEventTarget} Target node.
			 */
	
			function getEventTarget(nativeEvent) {
			  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
			  // Normalize SVG <use> element events #4963
			  if (target.correspondingUseElement) {
			    target = target.correspondingUseElement;
			  }
	
			  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
			  // @see http://www.quirksmode.org/js/events_properties.html
			  return target.nodeType === 3 ? target.parentNode : target;
			}
	
			module.exports = getEventTarget;
	
		/***/ },
		/* 51 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ExecutionEnvironment = __webpack_require__(22);
	
			var useHasFeature;
			if (ExecutionEnvironment.canUseDOM) {
			  useHasFeature = document.implementation && document.implementation.hasFeature &&
			  // always returns true in newer browsers as per the standard.
			  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
			  document.implementation.hasFeature('', '') !== true;
			}
	
			/**
			 * Checks if an event is supported in the current execution environment.
			 *
			 * NOTE: This will not work correctly for non-generic events such as `change`,
			 * `reset`, `load`, `error`, and `select`.
			 *
			 * Borrows from Modernizr.
			 *
			 * @param {string} eventNameSuffix Event name, e.g. "click".
			 * @param {?boolean} capture Check if the capture phase is supported.
			 * @return {boolean} True if the event is supported.
			 * @internal
			 * @license Modernizr 3.0.0pre (Custom Build) | MIT
			 */
			function isEventSupported(eventNameSuffix, capture) {
			  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
			    return false;
			  }
	
			  var eventName = 'on' + eventNameSuffix;
			  var isSupported = eventName in document;
	
			  if (!isSupported) {
			    var element = document.createElement('div');
			    element.setAttribute(eventName, 'return;');
			    isSupported = typeof element[eventName] === 'function';
			  }
	
			  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
			    // This is the only way to test support for the `wheel` event in IE9+.
			    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
			  }
	
			  return isSupported;
			}
	
			module.exports = isEventSupported;
	
		/***/ },
		/* 52 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			/**
			 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
			 */
	
			var supportedInputTypes = {
			  'color': true,
			  'date': true,
			  'datetime': true,
			  'datetime-local': true,
			  'email': true,
			  'month': true,
			  'number': true,
			  'password': true,
			  'range': true,
			  'search': true,
			  'tel': true,
			  'text': true,
			  'time': true,
			  'url': true,
			  'week': true
			};
	
			function isTextInputElement(elem) {
			  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
			  if (nodeName === 'input') {
			    return !!supportedInputTypes[elem.type];
			  }
	
			  if (nodeName === 'textarea') {
			    return true;
			  }
	
			  return false;
			}
	
			module.exports = isTextInputElement;
	
		/***/ },
		/* 53 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * Module that is injectable into `EventPluginHub`, that specifies a
			 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
			 * plugins, without having to package every one of them. This is better than
			 * having plugins be ordered in the same order that they are injected because
			 * that ordering would be influenced by the packaging order.
			 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
			 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
			 */
	
			var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
			module.exports = DefaultEventPluginOrder;
	
		/***/ },
		/* 54 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var EventPropagators = __webpack_require__(13);
			var ReactDOMComponentTree = __webpack_require__(5);
			var SyntheticMouseEvent = __webpack_require__(55);
	
			var eventTypes = {
			  mouseEnter: {
			    registrationName: 'onMouseEnter',
			    dependencies: ['topMouseOut', 'topMouseOver']
			  },
			  mouseLeave: {
			    registrationName: 'onMouseLeave',
			    dependencies: ['topMouseOut', 'topMouseOver']
			  }
			};
	
			var EnterLeaveEventPlugin = {
	
			  eventTypes: eventTypes,
	
			  /**
			   * For almost every interaction we care about, there will be both a top-level
			   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
			   * we do not extract duplicate events. However, moving the mouse into the
			   * browser from outside will not fire a `mouseout` event. In this case, we use
			   * the `mouseover` top-level event.
			   */
			  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
			      return null;
			    }
			    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
			      // Must not be a mouse in or mouse out - ignoring.
			      return null;
			    }
	
			    var win;
			    if (nativeEventTarget.window === nativeEventTarget) {
			      // `nativeEventTarget` is probably a window object.
			      win = nativeEventTarget;
			    } else {
			      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
			      var doc = nativeEventTarget.ownerDocument;
			      if (doc) {
			        win = doc.defaultView || doc.parentWindow;
			      } else {
			        win = window;
			      }
			    }
	
			    var from;
			    var to;
			    if (topLevelType === 'topMouseOut') {
			      from = targetInst;
			      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
			      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
			    } else {
			      // Moving to a node from outside the window.
			      from = null;
			      to = targetInst;
			    }
	
			    if (from === to) {
			      // Nothing pertains to our managed components.
			      return null;
			    }
	
			    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
			    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
			    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
			    leave.type = 'mouseleave';
			    leave.target = fromNode;
			    leave.relatedTarget = toNode;
	
			    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
			    enter.type = 'mouseenter';
			    enter.target = toNode;
			    enter.relatedTarget = fromNode;
	
			    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
			    return [leave, enter];
			  }
	
			};
	
			module.exports = EnterLeaveEventPlugin;
	
		/***/ },
		/* 55 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticUIEvent = __webpack_require__(56);
			var ViewportMetrics = __webpack_require__(57);
	
			var getEventModifierState = __webpack_require__(58);
	
			/**
			 * @interface MouseEvent
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/
			 */
			var MouseEventInterface = {
			  screenX: null,
			  screenY: null,
			  clientX: null,
			  clientY: null,
			  ctrlKey: null,
			  shiftKey: null,
			  altKey: null,
			  metaKey: null,
			  getModifierState: getEventModifierState,
			  button: function (event) {
			    // Webkit, Firefox, IE9+
			    // which:  1 2 3
			    // button: 0 1 2 (standard)
			    var button = event.button;
			    if ('which' in event) {
			      return button;
			    }
			    // IE<9
			    // which:  undefined
			    // button: 0 0 0
			    // button: 1 4 2 (onmouseup)
			    return button === 2 ? 2 : button === 4 ? 1 : 0;
			  },
			  buttons: null,
			  relatedTarget: function (event) {
			    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
			  },
			  // "Proprietary" Interface.
			  pageX: function (event) {
			    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
			  },
			  pageY: function (event) {
			    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
			  }
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
			module.exports = SyntheticMouseEvent;
	
		/***/ },
		/* 56 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticEvent = __webpack_require__(28);
	
			var getEventTarget = __webpack_require__(50);
	
			/**
			 * @interface UIEvent
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/
			 */
			var UIEventInterface = {
			  view: function (event) {
			    if (event.view) {
			      return event.view;
			    }
	
			    var target = getEventTarget(event);
			    if (target.window === target) {
			      // target is a window object
			      return target;
			    }
	
			    var doc = target.ownerDocument;
			    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
			    if (doc) {
			      return doc.defaultView || doc.parentWindow;
			    } else {
			      return window;
			    }
			  },
			  detail: function (event) {
			    return event.detail || 0;
			  }
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticEvent}
			 */
			function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
			module.exports = SyntheticUIEvent;
	
		/***/ },
		/* 57 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ViewportMetrics = {
	
			  currentScrollLeft: 0,
	
			  currentScrollTop: 0,
	
			  refreshScrollValues: function (scrollPosition) {
			    ViewportMetrics.currentScrollLeft = scrollPosition.x;
			    ViewportMetrics.currentScrollTop = scrollPosition.y;
			  }
	
			};
	
			module.exports = ViewportMetrics;
	
		/***/ },
		/* 58 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * Translation from modifier key to the associated property in the event.
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
			 */
	
			var modifierKeyToProp = {
			  'Alt': 'altKey',
			  'Control': 'ctrlKey',
			  'Meta': 'metaKey',
			  'Shift': 'shiftKey'
			};
	
			// IE8 does not implement getModifierState so we simply map it to the only
			// modifier keys exposed by the event itself, does not support Lock-keys.
			// Currently, all major browsers except Chrome seems to support Lock-keys.
			function modifierStateGetter(keyArg) {
			  var syntheticEvent = this;
			  var nativeEvent = syntheticEvent.nativeEvent;
			  if (nativeEvent.getModifierState) {
			    return nativeEvent.getModifierState(keyArg);
			  }
			  var keyProp = modifierKeyToProp[keyArg];
			  return keyProp ? !!nativeEvent[keyProp] : false;
			}
	
			function getEventModifierState(nativeEvent) {
			  return modifierStateGetter;
			}
	
			module.exports = getEventModifierState;
	
		/***/ },
		/* 59 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMProperty = __webpack_require__(7);
	
			var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
			var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
			var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
			var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
			var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
			var HTMLDOMPropertyConfig = {
			  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
			  Properties: {
			    /**
			     * Standard Properties
			     */
			    accept: 0,
			    acceptCharset: 0,
			    accessKey: 0,
			    action: 0,
			    allowFullScreen: HAS_BOOLEAN_VALUE,
			    allowTransparency: 0,
			    alt: 0,
			    // specifies target context for links with `preload` type
			    as: 0,
			    async: HAS_BOOLEAN_VALUE,
			    autoComplete: 0,
			    // autoFocus is polyfilled/normalized by AutoFocusUtils
			    // autoFocus: HAS_BOOLEAN_VALUE,
			    autoPlay: HAS_BOOLEAN_VALUE,
			    capture: HAS_BOOLEAN_VALUE,
			    cellPadding: 0,
			    cellSpacing: 0,
			    charSet: 0,
			    challenge: 0,
			    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
			    cite: 0,
			    classID: 0,
			    className: 0,
			    cols: HAS_POSITIVE_NUMERIC_VALUE,
			    colSpan: 0,
			    content: 0,
			    contentEditable: 0,
			    contextMenu: 0,
			    controls: HAS_BOOLEAN_VALUE,
			    coords: 0,
			    crossOrigin: 0,
			    data: 0, // For `<object />` acts as `src`.
			    dateTime: 0,
			    'default': HAS_BOOLEAN_VALUE,
			    defer: HAS_BOOLEAN_VALUE,
			    dir: 0,
			    disabled: HAS_BOOLEAN_VALUE,
			    download: HAS_OVERLOADED_BOOLEAN_VALUE,
			    draggable: 0,
			    encType: 0,
			    form: 0,
			    formAction: 0,
			    formEncType: 0,
			    formMethod: 0,
			    formNoValidate: HAS_BOOLEAN_VALUE,
			    formTarget: 0,
			    frameBorder: 0,
			    headers: 0,
			    height: 0,
			    hidden: HAS_BOOLEAN_VALUE,
			    high: 0,
			    href: 0,
			    hrefLang: 0,
			    htmlFor: 0,
			    httpEquiv: 0,
			    icon: 0,
			    id: 0,
			    inputMode: 0,
			    integrity: 0,
			    is: 0,
			    keyParams: 0,
			    keyType: 0,
			    kind: 0,
			    label: 0,
			    lang: 0,
			    list: 0,
			    loop: HAS_BOOLEAN_VALUE,
			    low: 0,
			    manifest: 0,
			    marginHeight: 0,
			    marginWidth: 0,
			    max: 0,
			    maxLength: 0,
			    media: 0,
			    mediaGroup: 0,
			    method: 0,
			    min: 0,
			    minLength: 0,
			    // Caution; `option.selected` is not updated if `select.multiple` is
			    // disabled with `removeAttribute`.
			    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
			    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
			    name: 0,
			    nonce: 0,
			    noValidate: HAS_BOOLEAN_VALUE,
			    open: HAS_BOOLEAN_VALUE,
			    optimum: 0,
			    pattern: 0,
			    placeholder: 0,
			    playsInline: HAS_BOOLEAN_VALUE,
			    poster: 0,
			    preload: 0,
			    profile: 0,
			    radioGroup: 0,
			    readOnly: HAS_BOOLEAN_VALUE,
			    referrerPolicy: 0,
			    rel: 0,
			    required: HAS_BOOLEAN_VALUE,
			    reversed: HAS_BOOLEAN_VALUE,
			    role: 0,
			    rows: HAS_POSITIVE_NUMERIC_VALUE,
			    rowSpan: HAS_NUMERIC_VALUE,
			    sandbox: 0,
			    scope: 0,
			    scoped: HAS_BOOLEAN_VALUE,
			    scrolling: 0,
			    seamless: HAS_BOOLEAN_VALUE,
			    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
			    shape: 0,
			    size: HAS_POSITIVE_NUMERIC_VALUE,
			    sizes: 0,
			    span: HAS_POSITIVE_NUMERIC_VALUE,
			    spellCheck: 0,
			    src: 0,
			    srcDoc: 0,
			    srcLang: 0,
			    srcSet: 0,
			    start: HAS_NUMERIC_VALUE,
			    step: 0,
			    style: 0,
			    summary: 0,
			    tabIndex: 0,
			    target: 0,
			    title: 0,
			    // Setting .type throws on non-<input> tags
			    type: 0,
			    useMap: 0,
			    value: 0,
			    width: 0,
			    wmode: 0,
			    wrap: 0,
	
			    /**
			     * RDFa Properties
			     */
			    about: 0,
			    datatype: 0,
			    inlist: 0,
			    prefix: 0,
			    // property is also supported for OpenGraph in meta tags.
			    property: 0,
			    resource: 0,
			    'typeof': 0,
			    vocab: 0,
	
			    /**
			     * Non-standard Properties
			     */
			    // autoCapitalize and autoCorrect are supported in Mobile Safari for
			    // keyboard hints.
			    autoCapitalize: 0,
			    autoCorrect: 0,
			    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
			    autoSave: 0,
			    // color is for Safari mask-icon link
			    color: 0,
			    // itemProp, itemScope, itemType are for
			    // Microdata support. See http://schema.org/docs/gs.html
			    itemProp: 0,
			    itemScope: HAS_BOOLEAN_VALUE,
			    itemType: 0,
			    // itemID and itemRef are for Microdata support as well but
			    // only specified in the WHATWG spec document. See
			    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
			    itemID: 0,
			    itemRef: 0,
			    // results show looking glass icon and recent searches on input
			    // search fields in WebKit/Blink
			    results: 0,
			    // IE-only attribute that specifies security restrictions on an iframe
			    // as an alternative to the sandbox attribute on IE<10
			    security: 0,
			    // IE-only attribute that controls focus behavior
			    unselectable: 0
			  },
			  DOMAttributeNames: {
			    acceptCharset: 'accept-charset',
			    className: 'class',
			    htmlFor: 'for',
			    httpEquiv: 'http-equiv'
			  },
			  DOMPropertyNames: {},
			  DOMMutationMethods: {
			    value: function (node, value) {
			      if (value == null) {
			        return node.removeAttribute('value');
			      }
	
			      // Number inputs get special treatment due to some edge cases in
			      // Chrome. Let everything else assign the value attribute as normal.
			      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
			      if (node.type !== 'number' || node.hasAttribute('value') === false) {
			        node.setAttribute('value', '' + value);
			      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
			        // Don't assign an attribute if validation reports bad
			        // input. Chrome will clear the value. Additionally, don't
			        // operate on inputs that have focus, otherwise Chrome might
			        // strip off trailing decimal places and cause the user's
			        // cursor position to jump to the beginning of the input.
			        //
			        // In ReactDOMInput, we have an onBlur event that will trigger
			        // this function again when focus is lost.
			        node.setAttribute('value', '' + value);
			      }
			    }
			  }
			};
	
			module.exports = HTMLDOMPropertyConfig;
	
		/***/ },
		/* 60 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMChildrenOperations = __webpack_require__(61);
			var ReactDOMIDOperations = __webpack_require__(72);
	
			/**
			 * Abstracts away all functionality of the reconciler that requires knowledge of
			 * the browser context. TODO: These callers should be refactored to avoid the
			 * need for this injection.
			 */
			var ReactComponentBrowserEnvironment = {
	
			  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
			  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
			};
	
			module.exports = ReactComponentBrowserEnvironment;
	
		/***/ },
		/* 61 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMLazyTree = __webpack_require__(62);
			var Danger = __webpack_require__(68);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactInstrumentation = __webpack_require__(37);
	
			var createMicrosoftUnsafeLocalFunction = __webpack_require__(65);
			var setInnerHTML = __webpack_require__(64);
			var setTextContent = __webpack_require__(66);
	
			function getNodeAfter(parentNode, node) {
			  // Special case for text components, which return [open, close] comments
			  // from getHostNode.
			  if (Array.isArray(node)) {
			    node = node[1];
			  }
			  return node ? node.nextSibling : parentNode.firstChild;
			}
	
			/**
			 * Inserts `childNode` as a child of `parentNode` at the `index`.
			 *
			 * @param {DOMElement} parentNode Parent node in which to insert.
			 * @param {DOMElement} childNode Child node to insert.
			 * @param {number} index Index at which to insert the child.
			 * @internal
			 */
			var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
			  // We rely exclusively on `insertBefore(node, null)` instead of also using
			  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
			  // we are careful to use `null`.)
			  parentNode.insertBefore(childNode, referenceNode);
			});
	
			function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
			  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
			}
	
			function moveChild(parentNode, childNode, referenceNode) {
			  if (Array.isArray(childNode)) {
			    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
			  } else {
			    insertChildAt(parentNode, childNode, referenceNode);
			  }
			}
	
			function removeChild(parentNode, childNode) {
			  if (Array.isArray(childNode)) {
			    var closingComment = childNode[1];
			    childNode = childNode[0];
			    removeDelimitedText(parentNode, childNode, closingComment);
			    parentNode.removeChild(closingComment);
			  }
			  parentNode.removeChild(childNode);
			}
	
			function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
			  var node = openingComment;
			  while (true) {
			    var nextNode = node.nextSibling;
			    insertChildAt(parentNode, node, referenceNode);
			    if (node === closingComment) {
			      break;
			    }
			    node = nextNode;
			  }
			}
	
			function removeDelimitedText(parentNode, startNode, closingComment) {
			  while (true) {
			    var node = startNode.nextSibling;
			    if (node === closingComment) {
			      // The closing comment is removed by ReactMultiChild.
			      break;
			    } else {
			      parentNode.removeChild(node);
			    }
			  }
			}
	
			function replaceDelimitedText(openingComment, closingComment, stringText) {
			  var parentNode = openingComment.parentNode;
			  var nodeAfterComment = openingComment.nextSibling;
			  if (nodeAfterComment === closingComment) {
			    // There are no text nodes between the opening and closing comments; insert
			    // a new one if stringText isn't empty.
			    if (stringText) {
			      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
			    }
			  } else {
			    if (stringText) {
			      // Set the text content of the first node after the opening comment, and
			      // remove all following nodes up until the closing comment.
			      setTextContent(nodeAfterComment, stringText);
			      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
			    } else {
			      removeDelimitedText(parentNode, openingComment, closingComment);
			    }
			  }
	
			  if (process.env.NODE_ENV !== 'production') {
			    ReactInstrumentation.debugTool.onHostOperation({
			      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
			      type: 'replace text',
			      payload: stringText
			    });
			  }
			}
	
			var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
			if (process.env.NODE_ENV !== 'production') {
			  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
			    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
			    if (prevInstance._debugID !== 0) {
			      ReactInstrumentation.debugTool.onHostOperation({
			        instanceID: prevInstance._debugID,
			        type: 'replace with',
			        payload: markup.toString()
			      });
			    } else {
			      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
			      if (nextInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onHostOperation({
			          instanceID: nextInstance._debugID,
			          type: 'mount',
			          payload: markup.toString()
			        });
			      }
			    }
			  };
			}
	
			/**
			 * Operations for updating with DOM children.
			 */
			var DOMChildrenOperations = {
	
			  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
			  replaceDelimitedText: replaceDelimitedText,
	
			  /**
			   * Updates a component's children by processing a series of updates. The
			   * update configurations are each expected to have a `parentNode` property.
			   *
			   * @param {array<object>} updates List of update configurations.
			   * @internal
			   */
			  processUpdates: function (parentNode, updates) {
			    if (process.env.NODE_ENV !== 'production') {
			      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
			    }
	
			    for (var k = 0; k < updates.length; k++) {
			      var update = updates[k];
			      switch (update.type) {
			        case 'INSERT_MARKUP':
			          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
			          if (process.env.NODE_ENV !== 'production') {
			            ReactInstrumentation.debugTool.onHostOperation({
			              instanceID: parentNodeDebugID,
			              type: 'insert child',
			              payload: { toIndex: update.toIndex, content: update.content.toString() }
			            });
			          }
			          break;
			        case 'MOVE_EXISTING':
			          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
			          if (process.env.NODE_ENV !== 'production') {
			            ReactInstrumentation.debugTool.onHostOperation({
			              instanceID: parentNodeDebugID,
			              type: 'move child',
			              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
			            });
			          }
			          break;
			        case 'SET_MARKUP':
			          setInnerHTML(parentNode, update.content);
			          if (process.env.NODE_ENV !== 'production') {
			            ReactInstrumentation.debugTool.onHostOperation({
			              instanceID: parentNodeDebugID,
			              type: 'replace children',
			              payload: update.content.toString()
			            });
			          }
			          break;
			        case 'TEXT_CONTENT':
			          setTextContent(parentNode, update.content);
			          if (process.env.NODE_ENV !== 'production') {
			            ReactInstrumentation.debugTool.onHostOperation({
			              instanceID: parentNodeDebugID,
			              type: 'replace text',
			              payload: update.content.toString()
			            });
			          }
			          break;
			        case 'REMOVE_NODE':
			          removeChild(parentNode, update.fromNode);
			          if (process.env.NODE_ENV !== 'production') {
			            ReactInstrumentation.debugTool.onHostOperation({
			              instanceID: parentNodeDebugID,
			              type: 'remove child',
			              payload: { fromIndex: update.fromIndex }
			            });
			          }
			          break;
			      }
			    }
			  }
	
			};
	
			module.exports = DOMChildrenOperations;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 62 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2015-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMNamespaces = __webpack_require__(63);
			var setInnerHTML = __webpack_require__(64);
	
			var createMicrosoftUnsafeLocalFunction = __webpack_require__(65);
			var setTextContent = __webpack_require__(66);
	
			var ELEMENT_NODE_TYPE = 1;
			var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
			/**
			 * In IE (8-11) and Edge, appending nodes with no children is dramatically
			 * faster than appending a full subtree, so we essentially queue up the
			 * .appendChild calls here and apply them so each node is added to its parent
			 * before any children are added.
			 *
			 * In other browsers, doing so is slower or neutral compared to the other order
			 * (in Firefox, twice as slow) so we only do this inversion in IE.
			 *
			 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
			 */
			var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
			function insertTreeChildren(tree) {
			  if (!enableLazy) {
			    return;
			  }
			  var node = tree.node;
			  var children = tree.children;
			  if (children.length) {
			    for (var i = 0; i < children.length; i++) {
			      insertTreeBefore(node, children[i], null);
			    }
			  } else if (tree.html != null) {
			    setInnerHTML(node, tree.html);
			  } else if (tree.text != null) {
			    setTextContent(node, tree.text);
			  }
			}
	
			var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
			  // DocumentFragments aren't actually part of the DOM after insertion so
			  // appending children won't update the DOM. We need to ensure the fragment
			  // is properly populated first, breaking out of our lazy approach for just
			  // this level. Also, some <object> plugins (like Flash Player) will read
			  // <param> nodes immediately upon insertion into the DOM, so <object>
			  // must also be populated prior to insertion into the DOM.
			  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
			    insertTreeChildren(tree);
			    parentNode.insertBefore(tree.node, referenceNode);
			  } else {
			    parentNode.insertBefore(tree.node, referenceNode);
			    insertTreeChildren(tree);
			  }
			});
	
			function replaceChildWithTree(oldNode, newTree) {
			  oldNode.parentNode.replaceChild(newTree.node, oldNode);
			  insertTreeChildren(newTree);
			}
	
			function queueChild(parentTree, childTree) {
			  if (enableLazy) {
			    parentTree.children.push(childTree);
			  } else {
			    parentTree.node.appendChild(childTree.node);
			  }
			}
	
			function queueHTML(tree, html) {
			  if (enableLazy) {
			    tree.html = html;
			  } else {
			    setInnerHTML(tree.node, html);
			  }
			}
	
			function queueText(tree, text) {
			  if (enableLazy) {
			    tree.text = text;
			  } else {
			    setTextContent(tree.node, text);
			  }
			}
	
			function toString() {
			  return this.node.nodeName;
			}
	
			function DOMLazyTree(node) {
			  return {
			    node: node,
			    children: [],
			    html: null,
			    text: null,
			    toString: toString
			  };
			}
	
			DOMLazyTree.insertTreeBefore = insertTreeBefore;
			DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
			DOMLazyTree.queueChild = queueChild;
			DOMLazyTree.queueHTML = queueHTML;
			DOMLazyTree.queueText = queueText;
	
			module.exports = DOMLazyTree;
	
		/***/ },
		/* 63 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMNamespaces = {
			  html: 'http://www.w3.org/1999/xhtml',
			  mathml: 'http://www.w3.org/1998/Math/MathML',
			  svg: 'http://www.w3.org/2000/svg'
			};
	
			module.exports = DOMNamespaces;
	
		/***/ },
		/* 64 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ExecutionEnvironment = __webpack_require__(22);
			var DOMNamespaces = __webpack_require__(63);
	
			var WHITESPACE_TEST = /^[ \r\n\t\f]/;
			var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
			var createMicrosoftUnsafeLocalFunction = __webpack_require__(65);
	
			// SVG temp container for IE lacking innerHTML
			var reusableSVGContainer;
	
			/**
			 * Set the innerHTML property of a node, ensuring that whitespace is preserved
			 * even in IE8.
			 *
			 * @param {DOMElement} node
			 * @param {string} html
			 * @internal
			 */
			var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
			  // IE does not have innerHTML for SVG nodes, so instead we inject the
			  // new markup in a temp node and then move the child nodes across into
			  // the target node
			  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
			    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
			    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
			    var svgNode = reusableSVGContainer.firstChild;
			    while (svgNode.firstChild) {
			      node.appendChild(svgNode.firstChild);
			    }
			  } else {
			    node.innerHTML = html;
			  }
			});
	
			if (ExecutionEnvironment.canUseDOM) {
			  // IE8: When updating a just created node with innerHTML only leading
			  // whitespace is removed. When updating an existing node with innerHTML
			  // whitespace in root TextNodes is also collapsed.
			  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
			  // Feature detection; only IE8 is known to behave improperly like this.
			  var testElement = document.createElement('div');
			  testElement.innerHTML = ' ';
			  if (testElement.innerHTML === '') {
			    setInnerHTML = function (node, html) {
			      // Magic theory: IE8 supposedly differentiates between added and updated
			      // nodes when processing innerHTML, innerHTML on updated nodes suffers
			      // from worse whitespace behavior. Re-adding a node like this triggers
			      // the initial and more favorable whitespace behavior.
			      // TODO: What to do on a detached node?
			      if (node.parentNode) {
			        node.parentNode.replaceChild(node, node);
			      }
	
			      // We also implement a workaround for non-visible tags disappearing into
			      // thin air on IE8, this only happens if there is no visible text
			      // in-front of the non-visible tags. Piggyback on the whitespace fix
			      // and simply check if any non-visible tags appear in the source.
			      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
			        // Recover leading whitespace by temporarily prepending any character.
			        // \uFEFF has the potential advantage of being zero-width/invisible.
			        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
			        // in hopes that this is preserved even if "\uFEFF" is transformed to
			        // the actual Unicode character (by Babel, for example).
			        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
			        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
			        // deleteData leaves an empty `TextNode` which offsets the index of all
			        // children. Definitely want to avoid this.
			        var textNode = node.firstChild;
			        if (textNode.data.length === 1) {
			          node.removeChild(textNode);
			        } else {
			          textNode.deleteData(0, 1);
			        }
			      } else {
			        node.innerHTML = html;
			      }
			    };
			  }
			  testElement = null;
			}
	
			module.exports = setInnerHTML;
	
		/***/ },
		/* 65 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			/* globals MSApp */
	
			'use strict';
	
			/**
			 * Create a function which has 'unsafe' privileges (required by windows8 apps)
			 */
	
			var createMicrosoftUnsafeLocalFunction = function (func) {
			  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
			    return function (arg0, arg1, arg2, arg3) {
			      MSApp.execUnsafeLocalFunction(function () {
			        return func(arg0, arg1, arg2, arg3);
			      });
			    };
			  } else {
			    return func;
			  }
			};
	
			module.exports = createMicrosoftUnsafeLocalFunction;
	
		/***/ },
		/* 66 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ExecutionEnvironment = __webpack_require__(22);
			var escapeTextContentForBrowser = __webpack_require__(67);
			var setInnerHTML = __webpack_require__(64);
	
			/**
			 * Set the textContent property of a node, ensuring that whitespace is preserved
			 * even in IE8. innerText is a poor substitute for textContent and, among many
			 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
			 * as it should.
			 *
			 * @param {DOMElement} node
			 * @param {string} text
			 * @internal
			 */
			var setTextContent = function (node, text) {
			  if (text) {
			    var firstChild = node.firstChild;
	
			    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
			      firstChild.nodeValue = text;
			      return;
			    }
			  }
			  node.textContent = text;
			};
	
			if (ExecutionEnvironment.canUseDOM) {
			  if (!('textContent' in document.documentElement)) {
			    setTextContent = function (node, text) {
			      if (node.nodeType === 3) {
			        node.nodeValue = text;
			        return;
			      }
			      setInnerHTML(node, escapeTextContentForBrowser(text));
			    };
			  }
			}
	
			module.exports = setTextContent;
	
		/***/ },
		/* 67 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2016-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * Based on the escape-html library, which is used under the MIT License below:
			 *
			 * Copyright (c) 2012-2013 TJ Holowaychuk
			 * Copyright (c) 2015 Andreas Lubbe
			 * Copyright (c) 2015 Tiancheng "Timothy" Gu
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining
			 * a copy of this software and associated documentation files (the
			 * 'Software'), to deal in the Software without restriction, including
			 * without limitation the rights to use, copy, modify, merge, publish,
			 * distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to
			 * the following conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
			 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
			 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
			 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
			 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
			 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 *
			 */
	
			'use strict';
	
			// code copied and modified from escape-html
			/**
			 * Module variables.
			 * @private
			 */
	
			var matchHtmlRegExp = /["'&<>]/;
	
			/**
			 * Escape special characters in the given string of html.
			 *
			 * @param  {string} string The string to escape for inserting into HTML
			 * @return {string}
			 * @public
			 */
	
			function escapeHtml(string) {
			  var str = '' + string;
			  var match = matchHtmlRegExp.exec(str);
	
			  if (!match) {
			    return str;
			  }
	
			  var escape;
			  var html = '';
			  var index = 0;
			  var lastIndex = 0;
	
			  for (index = match.index; index < str.length; index++) {
			    switch (str.charCodeAt(index)) {
			      case 34:
			        // "
			        escape = '&quot;';
			        break;
			      case 38:
			        // &
			        escape = '&amp;';
			        break;
			      case 39:
			        // '
			        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
			        break;
			      case 60:
			        // <
			        escape = '&lt;';
			        break;
			      case 62:
			        // >
			        escape = '&gt;';
			        break;
			      default:
			        continue;
			    }
	
			    if (lastIndex !== index) {
			      html += str.substring(lastIndex, index);
			    }
	
			    lastIndex = index + 1;
			    html += escape;
			  }
	
			  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
			}
			// end code copied and modified from escape-html
	
	
			/**
			 * Escapes text to prevent scripting attacks.
			 *
			 * @param {*} text Text value to escape.
			 * @return {string} An escaped string.
			 */
			function escapeTextContentForBrowser(text) {
			  if (typeof text === 'boolean' || typeof text === 'number') {
			    // this shortcircuit helps perf for types that we know will never have
			    // special characters, especially given that this function is used often
			    // for numeric dom ids.
			    return '' + text;
			  }
			  return escapeHtml(text);
			}
	
			module.exports = escapeTextContentForBrowser;
	
		/***/ },
		/* 68 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var DOMLazyTree = __webpack_require__(62);
			var ExecutionEnvironment = __webpack_require__(22);
	
			var createNodesFromMarkup = __webpack_require__(69);
			var emptyFunction = __webpack_require__(19);
			var invariant = __webpack_require__(8);
	
			var Danger = {
	
			  /**
			   * Replaces a node with a string of markup at its current position within its
			   * parent. The markup must render into a single root node.
			   *
			   * @param {DOMElement} oldChild Child node to replace.
			   * @param {string} markup Markup to render in place of the child node.
			   * @internal
			   */
			  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
			    !ExecutionEnvironment.canUseDOM ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
			    !markup ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
			    !(oldChild.nodeName !== 'HTML') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
			    if (typeof markup === 'string') {
			      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
			      oldChild.parentNode.replaceChild(newChild, oldChild);
			    } else {
			      DOMLazyTree.replaceChildWithTree(oldChild, markup);
			    }
			  }
	
			};
	
			module.exports = Danger;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 69 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			/*eslint-disable fb-www/unsafe-html*/
	
			var ExecutionEnvironment = __webpack_require__(22);
	
			var createArrayFromMixed = __webpack_require__(70);
			var getMarkupWrap = __webpack_require__(71);
			var invariant = __webpack_require__(8);
	
			/**
			 * Dummy container used to render all markup.
			 */
			var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
			/**
			 * Pattern used by `getNodeName`.
			 */
			var nodeNamePattern = /^\s*<(\w+)/;
	
			/**
			 * Extracts the `nodeName` of the first element in a string of markup.
			 *
			 * @param {string} markup String of markup.
			 * @return {?string} Node name of the supplied markup.
			 */
			function getNodeName(markup) {
			  var nodeNameMatch = markup.match(nodeNamePattern);
			  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
			}
	
			/**
			 * Creates an array containing the nodes rendered from the supplied markup. The
			 * optionally supplied `handleScript` function will be invoked once for each
			 * <script> element that is rendered. If no `handleScript` function is supplied,
			 * an exception is thrown if any <script> elements are rendered.
			 *
			 * @param {string} markup A string of valid HTML markup.
			 * @param {?function} handleScript Invoked once for each rendered <script>.
			 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
			 */
			function createNodesFromMarkup(markup, handleScript) {
			  var node = dummyNode;
			  !!!dummyNode ? process.env.NODE_ENV !== 'production' ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
			  var nodeName = getNodeName(markup);
	
			  var wrap = nodeName && getMarkupWrap(nodeName);
			  if (wrap) {
			    node.innerHTML = wrap[1] + markup + wrap[2];
	
			    var wrapDepth = wrap[0];
			    while (wrapDepth--) {
			      node = node.lastChild;
			    }
			  } else {
			    node.innerHTML = markup;
			  }
	
			  var scripts = node.getElementsByTagName('script');
			  if (scripts.length) {
			    !handleScript ? process.env.NODE_ENV !== 'production' ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
			    createArrayFromMixed(scripts).forEach(handleScript);
			  }
	
			  var nodes = Array.from(node.childNodes);
			  while (node.lastChild) {
			    node.removeChild(node.lastChild);
			  }
			  return nodes;
			}
	
			module.exports = createNodesFromMarkup;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 70 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			var invariant = __webpack_require__(8);
	
			/**
			 * Convert array-like objects to arrays.
			 *
			 * This API assumes the caller knows the contents of the data type. For less
			 * well defined inputs use createArrayFromMixed.
			 *
			 * @param {object|function|filelist} obj
			 * @return {array}
			 */
			function toArray(obj) {
			  var length = obj.length;
	
			  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
			  // in old versions of Safari).
			  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
			  !(typeof length === 'number') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
			  !(length === 0 || length - 1 in obj) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
			  !(typeof obj.callee !== 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
			  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
			  // without method will throw during the slice call and skip straight to the
			  // fallback.
			  if (obj.hasOwnProperty) {
			    try {
			      return Array.prototype.slice.call(obj);
			    } catch (e) {
			      // IE < 9 does not support Array#slice on collections objects
			    }
			  }
	
			  // Fall back to copying key by key. This assumes all keys have a value,
			  // so will not preserve sparsely populated inputs.
			  var ret = Array(length);
			  for (var ii = 0; ii < length; ii++) {
			    ret[ii] = obj[ii];
			  }
			  return ret;
			}
	
			/**
			 * Perform a heuristic test to determine if an object is "array-like".
			 *
			 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
			 *   Joshu replied: "Mu."
			 *
			 * This function determines if its argument has "array nature": it returns
			 * true if the argument is an actual array, an `arguments' object, or an
			 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
			 *
			 * It will return false for other array-like objects like Filelist.
			 *
			 * @param {*} obj
			 * @return {boolean}
			 */
			function hasArrayNature(obj) {
			  return (
			    // not null/false
			    !!obj && (
			    // arrays are objects, NodeLists are functions in Safari
			    typeof obj == 'object' || typeof obj == 'function') &&
			    // quacks like an array
			    'length' in obj &&
			    // not window
			    !('setInterval' in obj) &&
			    // no DOM node should be considered an array-like
			    // a 'select' element has 'length' and 'item' properties on IE8
			    typeof obj.nodeType != 'number' && (
			    // a real array
			    Array.isArray(obj) ||
			    // arguments
			    'callee' in obj ||
			    // HTMLCollection/NodeList
			    'item' in obj)
			  );
			}
	
			/**
			 * Ensure that the argument is an array by wrapping it in an array if it is not.
			 * Creates a copy of the argument if it is already an array.
			 *
			 * This is mostly useful idiomatically:
			 *
			 *   var createArrayFromMixed = require('createArrayFromMixed');
			 *
			 *   function takesOneOrMoreThings(things) {
			 *     things = createArrayFromMixed(things);
			 *     ...
			 *   }
			 *
			 * This allows you to treat `things' as an array, but accept scalars in the API.
			 *
			 * If you need to convert an array-like object, like `arguments`, into an array
			 * use toArray instead.
			 *
			 * @param {*} obj
			 * @return {array}
			 */
			function createArrayFromMixed(obj) {
			  if (!hasArrayNature(obj)) {
			    return [obj];
			  } else if (Array.isArray(obj)) {
			    return obj.slice();
			  } else {
			    return toArray(obj);
			  }
			}
	
			module.exports = createArrayFromMixed;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 71 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			/*eslint-disable fb-www/unsafe-html */
	
			var ExecutionEnvironment = __webpack_require__(22);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * Dummy container used to detect which wraps are necessary.
			 */
			var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
			/**
			 * Some browsers cannot use `innerHTML` to render certain elements standalone,
			 * so we wrap them, render the wrapped nodes, then extract the desired node.
			 *
			 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
			 */
	
			var shouldWrap = {};
	
			var selectWrap = [1, '<select multiple="true">', '</select>'];
			var tableWrap = [1, '<table>', '</table>'];
			var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
			var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
			var markupWrap = {
			  '*': [1, '?<div>', '</div>'],
	
			  'area': [1, '<map>', '</map>'],
			  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
			  'legend': [1, '<fieldset>', '</fieldset>'],
			  'param': [1, '<object>', '</object>'],
			  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
			  'optgroup': selectWrap,
			  'option': selectWrap,
	
			  'caption': tableWrap,
			  'colgroup': tableWrap,
			  'tbody': tableWrap,
			  'tfoot': tableWrap,
			  'thead': tableWrap,
	
			  'td': trWrap,
			  'th': trWrap
			};
	
			// Initialize the SVG elements since we know they'll always need to be wrapped
			// consistently. If they are created inside a <div> they will be initialized in
			// the wrong namespace (and will not display).
			var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
			svgElements.forEach(function (nodeName) {
			  markupWrap[nodeName] = svgWrap;
			  shouldWrap[nodeName] = true;
			});
	
			/**
			 * Gets the markup wrap configuration for the supplied `nodeName`.
			 *
			 * NOTE: This lazily detects which wraps are necessary for the current browser.
			 *
			 * @param {string} nodeName Lowercase `nodeName`.
			 * @return {?array} Markup wrap configuration, if applicable.
			 */
			function getMarkupWrap(nodeName) {
			  !!!dummyNode ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
			  if (!markupWrap.hasOwnProperty(nodeName)) {
			    nodeName = '*';
			  }
			  if (!shouldWrap.hasOwnProperty(nodeName)) {
			    if (nodeName === '*') {
			      dummyNode.innerHTML = '<link />';
			    } else {
			      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
			    }
			    shouldWrap[nodeName] = !dummyNode.firstChild;
			  }
			  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
			}
	
			module.exports = getMarkupWrap;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 72 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMChildrenOperations = __webpack_require__(61);
			var ReactDOMComponentTree = __webpack_require__(5);
	
			/**
			 * Operations used to process updates to DOM nodes.
			 */
			var ReactDOMIDOperations = {
	
			  /**
			   * Updates a component's children by processing a series of updates.
			   *
			   * @param {array<object>} updates List of update configurations.
			   * @internal
			   */
			  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
			    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
			    DOMChildrenOperations.processUpdates(node, updates);
			  }
			};
	
			module.exports = ReactDOMIDOperations;
	
		/***/ },
		/* 73 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			/* global hasOwnProperty:true */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6),
			    _assign = __webpack_require__(24);
	
			var AutoFocusUtils = __webpack_require__(74);
			var CSSPropertyOperations = __webpack_require__(76);
			var DOMLazyTree = __webpack_require__(62);
			var DOMNamespaces = __webpack_require__(63);
			var DOMProperty = __webpack_require__(7);
			var DOMPropertyOperations = __webpack_require__(84);
			var EventPluginHub = __webpack_require__(14);
			var EventPluginRegistry = __webpack_require__(15);
			var ReactBrowserEventEmitter = __webpack_require__(86);
			var ReactDOMComponentFlags = __webpack_require__(9);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactDOMInput = __webpack_require__(89);
			var ReactDOMOption = __webpack_require__(120);
			var ReactDOMSelect = __webpack_require__(121);
			var ReactDOMTextarea = __webpack_require__(122);
			var ReactInstrumentation = __webpack_require__(37);
			var ReactMultiChild = __webpack_require__(123);
			var ReactServerRenderingTransaction = __webpack_require__(143);
	
			var emptyFunction = __webpack_require__(19);
			var escapeTextContentForBrowser = __webpack_require__(67);
			var invariant = __webpack_require__(8);
			var isEventSupported = __webpack_require__(51);
			var shallowEqual = __webpack_require__(133);
			var validateDOMNesting = __webpack_require__(146);
			var warning = __webpack_require__(18);
	
			var Flags = ReactDOMComponentFlags;
			var deleteListener = EventPluginHub.deleteListener;
			var getNode = ReactDOMComponentTree.getNodeFromInstance;
			var listenTo = ReactBrowserEventEmitter.listenTo;
			var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
			// For quickly matching children type, to test if can be treated as content.
			var CONTENT_TYPES = { 'string': true, 'number': true };
	
			var STYLE = 'style';
			var HTML = '__html';
			var RESERVED_PROPS = {
			  children: null,
			  dangerouslySetInnerHTML: null,
			  suppressContentEditableWarning: null
			};
	
			// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
			var DOC_FRAGMENT_TYPE = 11;
	
			function getDeclarationErrorAddendum(internalInstance) {
			  if (internalInstance) {
			    var owner = internalInstance._currentElement._owner || null;
			    if (owner) {
			      var name = owner.getName();
			      if (name) {
			        return ' This DOM node was rendered by `' + name + '`.';
			      }
			    }
			  }
			  return '';
			}
	
			function friendlyStringify(obj) {
			  if (typeof obj === 'object') {
			    if (Array.isArray(obj)) {
			      return '[' + obj.map(friendlyStringify).join(', ') + ']';
			    } else {
			      var pairs = [];
			      for (var key in obj) {
			        if (Object.prototype.hasOwnProperty.call(obj, key)) {
			          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
			          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
			        }
			      }
			      return '{' + pairs.join(', ') + '}';
			    }
			  } else if (typeof obj === 'string') {
			    return JSON.stringify(obj);
			  } else if (typeof obj === 'function') {
			    return '[function object]';
			  }
			  // Differs from JSON.stringify in that undefined because undefined and that
			  // inf and nan don't become null
			  return String(obj);
			}
	
			var styleMutationWarning = {};
	
			function checkAndWarnForMutatedStyle(style1, style2, component) {
			  if (style1 == null || style2 == null) {
			    return;
			  }
			  if (shallowEqual(style1, style2)) {
			    return;
			  }
	
			  var componentName = component._tag;
			  var owner = component._currentElement._owner;
			  var ownerName;
			  if (owner) {
			    ownerName = owner.getName();
			  }
	
			  var hash = ownerName + '|' + componentName;
	
			  if (styleMutationWarning.hasOwnProperty(hash)) {
			    return;
			  }
	
			  styleMutationWarning[hash] = true;
	
			  process.env.NODE_ENV !== 'production' ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
			}
	
			/**
			 * @param {object} component
			 * @param {?object} props
			 */
			function assertValidProps(component, props) {
			  if (!props) {
			    return;
			  }
			  // Note the use of `==` which checks for null or undefined.
			  if (voidElementTags[component._tag]) {
			    !(props.children == null && props.dangerouslySetInnerHTML == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
			  }
			  if (props.dangerouslySetInnerHTML != null) {
			    !(props.children == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
			    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ? process.env.NODE_ENV !== 'production' ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
			  }
			  if (process.env.NODE_ENV !== 'production') {
			    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
			    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
			    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
			  }
			  !(props.style == null || typeof props.style === 'object') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
			}
	
			function enqueuePutListener(inst, registrationName, listener, transaction) {
			  if (transaction instanceof ReactServerRenderingTransaction) {
			    return;
			  }
			  if (process.env.NODE_ENV !== 'production') {
			    // IE8 has no API for event capturing and the `onScroll` event doesn't
			    // bubble.
			    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
			  }
			  var containerInfo = inst._hostContainerInfo;
			  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
			  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
			  listenTo(registrationName, doc);
			  transaction.getReactMountReady().enqueue(putListener, {
			    inst: inst,
			    registrationName: registrationName,
			    listener: listener
			  });
			}
	
			function putListener() {
			  var listenerToPut = this;
			  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
			}
	
			function inputPostMount() {
			  var inst = this;
			  ReactDOMInput.postMountWrapper(inst);
			}
	
			function textareaPostMount() {
			  var inst = this;
			  ReactDOMTextarea.postMountWrapper(inst);
			}
	
			function optionPostMount() {
			  var inst = this;
			  ReactDOMOption.postMountWrapper(inst);
			}
	
			var setAndValidateContentChildDev = emptyFunction;
			if (process.env.NODE_ENV !== 'production') {
			  setAndValidateContentChildDev = function (content) {
			    var hasExistingContent = this._contentDebugID != null;
			    var debugID = this._debugID;
			    // This ID represents the inlined child that has no backing instance:
			    var contentDebugID = -debugID;
	
			    if (content == null) {
			      if (hasExistingContent) {
			        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
			      }
			      this._contentDebugID = null;
			      return;
			    }
	
			    validateDOMNesting(null, String(content), this, this._ancestorInfo);
			    this._contentDebugID = contentDebugID;
			    if (hasExistingContent) {
			      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
			      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
			    } else {
			      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
			      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
			      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
			    }
			  };
			}
	
			// There are so many media events, it makes sense to just
			// maintain a list rather than create a `trapBubbledEvent` for each
			var mediaEvents = {
			  topAbort: 'abort',
			  topCanPlay: 'canplay',
			  topCanPlayThrough: 'canplaythrough',
			  topDurationChange: 'durationchange',
			  topEmptied: 'emptied',
			  topEncrypted: 'encrypted',
			  topEnded: 'ended',
			  topError: 'error',
			  topLoadedData: 'loadeddata',
			  topLoadedMetadata: 'loadedmetadata',
			  topLoadStart: 'loadstart',
			  topPause: 'pause',
			  topPlay: 'play',
			  topPlaying: 'playing',
			  topProgress: 'progress',
			  topRateChange: 'ratechange',
			  topSeeked: 'seeked',
			  topSeeking: 'seeking',
			  topStalled: 'stalled',
			  topSuspend: 'suspend',
			  topTimeUpdate: 'timeupdate',
			  topVolumeChange: 'volumechange',
			  topWaiting: 'waiting'
			};
	
			function trapBubbledEventsLocal() {
			  var inst = this;
			  // If a component renders to null or if another component fatals and causes
			  // the state of the tree to be corrupted, `node` here can be null.
			  !inst._rootNodeID ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
			  var node = getNode(inst);
			  !node ? process.env.NODE_ENV !== 'production' ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
			  switch (inst._tag) {
			    case 'iframe':
			    case 'object':
			      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
			      break;
			    case 'video':
			    case 'audio':
	
			      inst._wrapperState.listeners = [];
			      // Create listener for each media event
			      for (var event in mediaEvents) {
			        if (mediaEvents.hasOwnProperty(event)) {
			          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
			        }
			      }
			      break;
			    case 'source':
			      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
			      break;
			    case 'img':
			      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
			      break;
			    case 'form':
			      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
			      break;
			    case 'input':
			    case 'select':
			    case 'textarea':
			      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
			      break;
			  }
			}
	
			function postUpdateSelectWrapper() {
			  ReactDOMSelect.postUpdateWrapper(this);
			}
	
			// For HTML, certain tags should omit their close tag. We keep a whitelist for
			// those special-case tags.
	
			var omittedCloseTags = {
			  'area': true,
			  'base': true,
			  'br': true,
			  'col': true,
			  'embed': true,
			  'hr': true,
			  'img': true,
			  'input': true,
			  'keygen': true,
			  'link': true,
			  'meta': true,
			  'param': true,
			  'source': true,
			  'track': true,
			  'wbr': true
			};
	
			var newlineEatingTags = {
			  'listing': true,
			  'pre': true,
			  'textarea': true
			};
	
			// For HTML, certain tags cannot have children. This has the same purpose as
			// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
			var voidElementTags = _assign({
			  'menuitem': true
			}, omittedCloseTags);
	
			// We accept any tag to be rendered but since this gets injected into arbitrary
			// HTML, we want to make sure that it's a safe tag.
			// http://www.w3.org/TR/REC-xml/#NT-Name
	
			var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
			var validatedTagCache = {};
			var hasOwnProperty = {}.hasOwnProperty;
	
			function validateDangerousTag(tag) {
			  if (!hasOwnProperty.call(validatedTagCache, tag)) {
			    !VALID_TAG_REGEX.test(tag) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
			    validatedTagCache[tag] = true;
			  }
			}
	
			function isCustomComponent(tagName, props) {
			  return tagName.indexOf('-') >= 0 || props.is != null;
			}
	
			var globalIdCounter = 1;
	
			/**
			 * Creates a new React class that is idempotent and capable of containing other
			 * React components. It accepts event listeners and DOM properties that are
			 * valid according to `DOMProperty`.
			 *
			 *  - Event listeners: `onClick`, `onMouseDown`, etc.
			 *  - DOM properties: `className`, `name`, `title`, etc.
			 *
			 * The `style` property functions differently from the DOM API. It accepts an
			 * object mapping of style properties to values.
			 *
			 * @constructor ReactDOMComponent
			 * @extends ReactMultiChild
			 */
			function ReactDOMComponent(element) {
			  var tag = element.type;
			  validateDangerousTag(tag);
			  this._currentElement = element;
			  this._tag = tag.toLowerCase();
			  this._namespaceURI = null;
			  this._renderedChildren = null;
			  this._previousStyle = null;
			  this._previousStyleCopy = null;
			  this._hostNode = null;
			  this._hostParent = null;
			  this._rootNodeID = 0;
			  this._domID = 0;
			  this._hostContainerInfo = null;
			  this._wrapperState = null;
			  this._topLevelWrapper = null;
			  this._flags = 0;
			  if (process.env.NODE_ENV !== 'production') {
			    this._ancestorInfo = null;
			    setAndValidateContentChildDev.call(this, null);
			  }
			}
	
			ReactDOMComponent.displayName = 'ReactDOMComponent';
	
			ReactDOMComponent.Mixin = {
	
			  /**
			   * Generates root tag markup then recurses. This method has side effects and
			   * is not idempotent.
			   *
			   * @internal
			   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
			   * @param {?ReactDOMComponent} the parent component instance
			   * @param {?object} info about the host container
			   * @param {object} context
			   * @return {string} The computed markup.
			   */
			  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
			    this._rootNodeID = globalIdCounter++;
			    this._domID = hostContainerInfo._idCounter++;
			    this._hostParent = hostParent;
			    this._hostContainerInfo = hostContainerInfo;
	
			    var props = this._currentElement.props;
	
			    switch (this._tag) {
			      case 'audio':
			      case 'form':
			      case 'iframe':
			      case 'img':
			      case 'link':
			      case 'object':
			      case 'source':
			      case 'video':
			        this._wrapperState = {
			          listeners: null
			        };
			        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
			        break;
			      case 'input':
			        ReactDOMInput.mountWrapper(this, props, hostParent);
			        props = ReactDOMInput.getHostProps(this, props);
			        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
			        break;
			      case 'option':
			        ReactDOMOption.mountWrapper(this, props, hostParent);
			        props = ReactDOMOption.getHostProps(this, props);
			        break;
			      case 'select':
			        ReactDOMSelect.mountWrapper(this, props, hostParent);
			        props = ReactDOMSelect.getHostProps(this, props);
			        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
			        break;
			      case 'textarea':
			        ReactDOMTextarea.mountWrapper(this, props, hostParent);
			        props = ReactDOMTextarea.getHostProps(this, props);
			        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
			        break;
			    }
	
			    assertValidProps(this, props);
	
			    // We create tags in the namespace of their parent container, except HTML
			    // tags get no namespace.
			    var namespaceURI;
			    var parentTag;
			    if (hostParent != null) {
			      namespaceURI = hostParent._namespaceURI;
			      parentTag = hostParent._tag;
			    } else if (hostContainerInfo._tag) {
			      namespaceURI = hostContainerInfo._namespaceURI;
			      parentTag = hostContainerInfo._tag;
			    }
			    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
			      namespaceURI = DOMNamespaces.html;
			    }
			    if (namespaceURI === DOMNamespaces.html) {
			      if (this._tag === 'svg') {
			        namespaceURI = DOMNamespaces.svg;
			      } else if (this._tag === 'math') {
			        namespaceURI = DOMNamespaces.mathml;
			      }
			    }
			    this._namespaceURI = namespaceURI;
	
			    if (process.env.NODE_ENV !== 'production') {
			      var parentInfo;
			      if (hostParent != null) {
			        parentInfo = hostParent._ancestorInfo;
			      } else if (hostContainerInfo._tag) {
			        parentInfo = hostContainerInfo._ancestorInfo;
			      }
			      if (parentInfo) {
			        // parentInfo should always be present except for the top-level
			        // component when server rendering
			        validateDOMNesting(this._tag, null, this, parentInfo);
			      }
			      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
			    }
	
			    var mountImage;
			    if (transaction.useCreateElement) {
			      var ownerDocument = hostContainerInfo._ownerDocument;
			      var el;
			      if (namespaceURI === DOMNamespaces.html) {
			        if (this._tag === 'script') {
			          // Create the script via .innerHTML so its "parser-inserted" flag is
			          // set to true and it does not execute
			          var div = ownerDocument.createElement('div');
			          var type = this._currentElement.type;
			          div.innerHTML = '<' + type + '></' + type + '>';
			          el = div.removeChild(div.firstChild);
			        } else if (props.is) {
			          el = ownerDocument.createElement(this._currentElement.type, props.is);
			        } else {
			          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
			          // See discussion in https://github.com/facebook/react/pull/6896
			          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
			          el = ownerDocument.createElement(this._currentElement.type);
			        }
			      } else {
			        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
			      }
			      ReactDOMComponentTree.precacheNode(this, el);
			      this._flags |= Flags.hasCachedChildNodes;
			      if (!this._hostParent) {
			        DOMPropertyOperations.setAttributeForRoot(el);
			      }
			      this._updateDOMProperties(null, props, transaction);
			      var lazyTree = DOMLazyTree(el);
			      this._createInitialChildren(transaction, props, context, lazyTree);
			      mountImage = lazyTree;
			    } else {
			      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
			      var tagContent = this._createContentMarkup(transaction, props, context);
			      if (!tagContent && omittedCloseTags[this._tag]) {
			        mountImage = tagOpen + '/>';
			      } else {
			        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
			      }
			    }
	
			    switch (this._tag) {
			      case 'input':
			        transaction.getReactMountReady().enqueue(inputPostMount, this);
			        if (props.autoFocus) {
			          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
			        }
			        break;
			      case 'textarea':
			        transaction.getReactMountReady().enqueue(textareaPostMount, this);
			        if (props.autoFocus) {
			          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
			        }
			        break;
			      case 'select':
			        if (props.autoFocus) {
			          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
			        }
			        break;
			      case 'button':
			        if (props.autoFocus) {
			          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
			        }
			        break;
			      case 'option':
			        transaction.getReactMountReady().enqueue(optionPostMount, this);
			        break;
			    }
	
			    return mountImage;
			  },
	
			  /**
			   * Creates markup for the open tag and all attributes.
			   *
			   * This method has side effects because events get registered.
			   *
			   * Iterating over object properties is faster than iterating over arrays.
			   * @see http://jsperf.com/obj-vs-arr-iteration
			   *
			   * @private
			   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
			   * @param {object} props
			   * @return {string} Markup of opening tag.
			   */
			  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
			    var ret = '<' + this._currentElement.type;
	
			    for (var propKey in props) {
			      if (!props.hasOwnProperty(propKey)) {
			        continue;
			      }
			      var propValue = props[propKey];
			      if (propValue == null) {
			        continue;
			      }
			      if (registrationNameModules.hasOwnProperty(propKey)) {
			        if (propValue) {
			          enqueuePutListener(this, propKey, propValue, transaction);
			        }
			      } else {
			        if (propKey === STYLE) {
			          if (propValue) {
			            if (process.env.NODE_ENV !== 'production') {
			              // See `_updateDOMProperties`. style block
			              this._previousStyle = propValue;
			            }
			            propValue = this._previousStyleCopy = _assign({}, props.style);
			          }
			          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
			        }
			        var markup = null;
			        if (this._tag != null && isCustomComponent(this._tag, props)) {
			          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
			            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
			          }
			        } else {
			          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
			        }
			        if (markup) {
			          ret += ' ' + markup;
			        }
			      }
			    }
	
			    // For static pages, no need to put React ID and checksum. Saves lots of
			    // bytes.
			    if (transaction.renderToStaticMarkup) {
			      return ret;
			    }
	
			    if (!this._hostParent) {
			      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
			    }
			    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
			    return ret;
			  },
	
			  /**
			   * Creates markup for the content between the tags.
			   *
			   * @private
			   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
			   * @param {object} props
			   * @param {object} context
			   * @return {string} Content markup.
			   */
			  _createContentMarkup: function (transaction, props, context) {
			    var ret = '';
	
			    // Intentional use of != to avoid catching zero/false.
			    var innerHTML = props.dangerouslySetInnerHTML;
			    if (innerHTML != null) {
			      if (innerHTML.__html != null) {
			        ret = innerHTML.__html;
			      }
			    } else {
			      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
			      var childrenToUse = contentToUse != null ? null : props.children;
			      if (contentToUse != null) {
			        // TODO: Validate that text is allowed as a child of this node
			        ret = escapeTextContentForBrowser(contentToUse);
			        if (process.env.NODE_ENV !== 'production') {
			          setAndValidateContentChildDev.call(this, contentToUse);
			        }
			      } else if (childrenToUse != null) {
			        var mountImages = this.mountChildren(childrenToUse, transaction, context);
			        ret = mountImages.join('');
			      }
			    }
			    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
			      // text/html ignores the first character in these tags if it's a newline
			      // Prefer to break application/xml over text/html (for now) by adding
			      // a newline specifically to get eaten by the parser. (Alternately for
			      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
			      // \r is normalized out by HTMLTextAreaElement#value.)
			      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
			      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
			      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
			      // See: Parsing of "textarea" "listing" and "pre" elements
			      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
			      return '\n' + ret;
			    } else {
			      return ret;
			    }
			  },
	
			  _createInitialChildren: function (transaction, props, context, lazyTree) {
			    // Intentional use of != to avoid catching zero/false.
			    var innerHTML = props.dangerouslySetInnerHTML;
			    if (innerHTML != null) {
			      if (innerHTML.__html != null) {
			        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
			      }
			    } else {
			      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
			      var childrenToUse = contentToUse != null ? null : props.children;
			      // TODO: Validate that text is allowed as a child of this node
			      if (contentToUse != null) {
			        // Avoid setting textContent when the text is empty. In IE11 setting
			        // textContent on a text area will cause the placeholder to not
			        // show within the textarea until it has been focused and blurred again.
			        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
			        if (contentToUse !== '') {
			          if (process.env.NODE_ENV !== 'production') {
			            setAndValidateContentChildDev.call(this, contentToUse);
			          }
			          DOMLazyTree.queueText(lazyTree, contentToUse);
			        }
			      } else if (childrenToUse != null) {
			        var mountImages = this.mountChildren(childrenToUse, transaction, context);
			        for (var i = 0; i < mountImages.length; i++) {
			          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
			        }
			      }
			    }
			  },
	
			  /**
			   * Receives a next element and updates the component.
			   *
			   * @internal
			   * @param {ReactElement} nextElement
			   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
			   * @param {object} context
			   */
			  receiveComponent: function (nextElement, transaction, context) {
			    var prevElement = this._currentElement;
			    this._currentElement = nextElement;
			    this.updateComponent(transaction, prevElement, nextElement, context);
			  },
	
			  /**
			   * Updates a DOM component after it has already been allocated and
			   * attached to the DOM. Reconciles the root DOM node, then recurses.
			   *
			   * @param {ReactReconcileTransaction} transaction
			   * @param {ReactElement} prevElement
			   * @param {ReactElement} nextElement
			   * @internal
			   * @overridable
			   */
			  updateComponent: function (transaction, prevElement, nextElement, context) {
			    var lastProps = prevElement.props;
			    var nextProps = this._currentElement.props;
	
			    switch (this._tag) {
			      case 'input':
			        lastProps = ReactDOMInput.getHostProps(this, lastProps);
			        nextProps = ReactDOMInput.getHostProps(this, nextProps);
			        break;
			      case 'option':
			        lastProps = ReactDOMOption.getHostProps(this, lastProps);
			        nextProps = ReactDOMOption.getHostProps(this, nextProps);
			        break;
			      case 'select':
			        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
			        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
			        break;
			      case 'textarea':
			        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
			        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
			        break;
			    }
	
			    assertValidProps(this, nextProps);
			    this._updateDOMProperties(lastProps, nextProps, transaction);
			    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
			    switch (this._tag) {
			      case 'input':
			        // Update the wrapper around inputs *after* updating props. This has to
			        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
			        // raise warnings and prevent the new value from being assigned.
			        ReactDOMInput.updateWrapper(this);
			        break;
			      case 'textarea':
			        ReactDOMTextarea.updateWrapper(this);
			        break;
			      case 'select':
			        // <select> value update needs to occur after <option> children
			        // reconciliation
			        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
			        break;
			    }
			  },
	
			  /**
			   * Reconciles the properties by detecting differences in property values and
			   * updating the DOM as necessary. This function is probably the single most
			   * critical path for performance optimization.
			   *
			   * TODO: Benchmark whether checking for changed values in memory actually
			   *       improves performance (especially statically positioned elements).
			   * TODO: Benchmark the effects of putting this at the top since 99% of props
			   *       do not change for a given reconciliation.
			   * TODO: Benchmark areas that can be improved with caching.
			   *
			   * @private
			   * @param {object} lastProps
			   * @param {object} nextProps
			   * @param {?DOMElement} node
			   */
			  _updateDOMProperties: function (lastProps, nextProps, transaction) {
			    var propKey;
			    var styleName;
			    var styleUpdates;
			    for (propKey in lastProps) {
			      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
			        continue;
			      }
			      if (propKey === STYLE) {
			        var lastStyle = this._previousStyleCopy;
			        for (styleName in lastStyle) {
			          if (lastStyle.hasOwnProperty(styleName)) {
			            styleUpdates = styleUpdates || {};
			            styleUpdates[styleName] = '';
			          }
			        }
			        this._previousStyleCopy = null;
			      } else if (registrationNameModules.hasOwnProperty(propKey)) {
			        if (lastProps[propKey]) {
			          // Only call deleteListener if there was a listener previously or
			          // else willDeleteListener gets called when there wasn't actually a
			          // listener (e.g., onClick={null})
			          deleteListener(this, propKey);
			        }
			      } else if (isCustomComponent(this._tag, lastProps)) {
			        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
			          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
			        }
			      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
			        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
			      }
			    }
			    for (propKey in nextProps) {
			      var nextProp = nextProps[propKey];
			      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
			      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
			        continue;
			      }
			      if (propKey === STYLE) {
			        if (nextProp) {
			          if (process.env.NODE_ENV !== 'production') {
			            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
			            this._previousStyle = nextProp;
			          }
			          nextProp = this._previousStyleCopy = _assign({}, nextProp);
			        } else {
			          this._previousStyleCopy = null;
			        }
			        if (lastProp) {
			          // Unset styles on `lastProp` but not on `nextProp`.
			          for (styleName in lastProp) {
			            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
			              styleUpdates = styleUpdates || {};
			              styleUpdates[styleName] = '';
			            }
			          }
			          // Update styles that changed since `lastProp`.
			          for (styleName in nextProp) {
			            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
			              styleUpdates = styleUpdates || {};
			              styleUpdates[styleName] = nextProp[styleName];
			            }
			          }
			        } else {
			          // Relies on `updateStylesByID` not mutating `styleUpdates`.
			          styleUpdates = nextProp;
			        }
			      } else if (registrationNameModules.hasOwnProperty(propKey)) {
			        if (nextProp) {
			          enqueuePutListener(this, propKey, nextProp, transaction);
			        } else if (lastProp) {
			          deleteListener(this, propKey);
			        }
			      } else if (isCustomComponent(this._tag, nextProps)) {
			        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
			          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
			        }
			      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
			        var node = getNode(this);
			        // If we're updating to null or undefined, we should remove the property
			        // from the DOM node instead of inadvertently setting to a string. This
			        // brings us in line with the same behavior we have on initial render.
			        if (nextProp != null) {
			          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
			        } else {
			          DOMPropertyOperations.deleteValueForProperty(node, propKey);
			        }
			      }
			    }
			    if (styleUpdates) {
			      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
			    }
			  },
	
			  /**
			   * Reconciles the children with the various properties that affect the
			   * children content.
			   *
			   * @param {object} lastProps
			   * @param {object} nextProps
			   * @param {ReactReconcileTransaction} transaction
			   * @param {object} context
			   */
			  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
			    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
			    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
			    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
			    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
			    // Note the use of `!=` which checks for null or undefined.
			    var lastChildren = lastContent != null ? null : lastProps.children;
			    var nextChildren = nextContent != null ? null : nextProps.children;
	
			    // If we're switching from children to content/html or vice versa, remove
			    // the old content
			    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
			    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
			    if (lastChildren != null && nextChildren == null) {
			      this.updateChildren(null, transaction, context);
			    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
			      this.updateTextContent('');
			      if (process.env.NODE_ENV !== 'production') {
			        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
			      }
			    }
	
			    if (nextContent != null) {
			      if (lastContent !== nextContent) {
			        this.updateTextContent('' + nextContent);
			        if (process.env.NODE_ENV !== 'production') {
			          setAndValidateContentChildDev.call(this, nextContent);
			        }
			      }
			    } else if (nextHtml != null) {
			      if (lastHtml !== nextHtml) {
			        this.updateMarkup('' + nextHtml);
			      }
			      if (process.env.NODE_ENV !== 'production') {
			        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
			      }
			    } else if (nextChildren != null) {
			      if (process.env.NODE_ENV !== 'production') {
			        setAndValidateContentChildDev.call(this, null);
			      }
	
			      this.updateChildren(nextChildren, transaction, context);
			    }
			  },
	
			  getHostNode: function () {
			    return getNode(this);
			  },
	
			  /**
			   * Destroys all event registrations for this instance. Does not remove from
			   * the DOM. That must be done by the parent.
			   *
			   * @internal
			   */
			  unmountComponent: function (safely) {
			    switch (this._tag) {
			      case 'audio':
			      case 'form':
			      case 'iframe':
			      case 'img':
			      case 'link':
			      case 'object':
			      case 'source':
			      case 'video':
			        var listeners = this._wrapperState.listeners;
			        if (listeners) {
			          for (var i = 0; i < listeners.length; i++) {
			            listeners[i].remove();
			          }
			        }
			        break;
			      case 'html':
			      case 'head':
			      case 'body':
			        /**
			         * Components like <html> <head> and <body> can't be removed or added
			         * easily in a cross-browser way, however it's valuable to be able to
			         * take advantage of React's reconciliation for styling and <title>
			         * management. So we just document it and throw in dangerous cases.
			         */
			         true ? process.env.NODE_ENV !== 'production' ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
			        break;
			    }
	
			    this.unmountChildren(safely);
			    ReactDOMComponentTree.uncacheNode(this);
			    EventPluginHub.deleteAllListeners(this);
			    this._rootNodeID = 0;
			    this._domID = 0;
			    this._wrapperState = null;
	
			    if (process.env.NODE_ENV !== 'production') {
			      setAndValidateContentChildDev.call(this, null);
			    }
			  },
	
			  getPublicInstance: function () {
			    return getNode(this);
			  }
	
			};
	
			_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
			module.exports = ReactDOMComponent;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 74 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactDOMComponentTree = __webpack_require__(5);
	
			var focusNode = __webpack_require__(75);
	
			var AutoFocusUtils = {
			  focusDOMComponent: function () {
			    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
			  }
			};
	
			module.exports = AutoFocusUtils;
	
		/***/ },
		/* 75 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * @param {DOMElement} node input/textarea to focus
			 */
	
			function focusNode(node) {
			  // IE8 can throw "Can't move focus to the control because it is invisible,
			  // not enabled, or of a type that does not accept the focus." for all kinds of
			  // reasons that are too expensive and fragile to test.
			  try {
			    node.focus();
			  } catch (e) {}
			}
	
			module.exports = focusNode;
	
		/***/ },
		/* 76 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var CSSProperty = __webpack_require__(77);
			var ExecutionEnvironment = __webpack_require__(22);
			var ReactInstrumentation = __webpack_require__(37);
	
			var camelizeStyleName = __webpack_require__(78);
			var dangerousStyleValue = __webpack_require__(80);
			var hyphenateStyleName = __webpack_require__(81);
			var memoizeStringOnly = __webpack_require__(83);
			var warning = __webpack_require__(18);
	
			var processStyleName = memoizeStringOnly(function (styleName) {
			  return hyphenateStyleName(styleName);
			});
	
			var hasShorthandPropertyBug = false;
			var styleFloatAccessor = 'cssFloat';
			if (ExecutionEnvironment.canUseDOM) {
			  var tempStyle = document.createElement('div').style;
			  try {
			    // IE8 throws "Invalid argument." if resetting shorthand style properties.
			    tempStyle.font = '';
			  } catch (e) {
			    hasShorthandPropertyBug = true;
			  }
			  // IE8 only supports accessing cssFloat (standard) as styleFloat
			  if (document.documentElement.style.cssFloat === undefined) {
			    styleFloatAccessor = 'styleFloat';
			  }
			}
	
			if (process.env.NODE_ENV !== 'production') {
			  // 'msTransform' is correct, but the other prefixes should be capitalized
			  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
			  // style values shouldn't contain a semicolon
			  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
			  var warnedStyleNames = {};
			  var warnedStyleValues = {};
			  var warnedForNaNValue = false;
	
			  var warnHyphenatedStyleName = function (name, owner) {
			    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
			      return;
			    }
	
			    warnedStyleNames[name] = true;
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
			  };
	
			  var warnBadVendoredStyleName = function (name, owner) {
			    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
			      return;
			    }
	
			    warnedStyleNames[name] = true;
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
			  };
	
			  var warnStyleValueWithSemicolon = function (name, value, owner) {
			    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
			      return;
			    }
	
			    warnedStyleValues[value] = true;
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
			  };
	
			  var warnStyleValueIsNaN = function (name, value, owner) {
			    if (warnedForNaNValue) {
			      return;
			    }
	
			    warnedForNaNValue = true;
			    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
			  };
	
			  var checkRenderMessage = function (owner) {
			    if (owner) {
			      var name = owner.getName();
			      if (name) {
			        return ' Check the render method of `' + name + '`.';
			      }
			    }
			    return '';
			  };
	
			  /**
			   * @param {string} name
			   * @param {*} value
			   * @param {ReactDOMComponent} component
			   */
			  var warnValidStyle = function (name, value, component) {
			    var owner;
			    if (component) {
			      owner = component._currentElement._owner;
			    }
			    if (name.indexOf('-') > -1) {
			      warnHyphenatedStyleName(name, owner);
			    } else if (badVendoredStyleNamePattern.test(name)) {
			      warnBadVendoredStyleName(name, owner);
			    } else if (badStyleValueWithSemicolonPattern.test(value)) {
			      warnStyleValueWithSemicolon(name, value, owner);
			    }
	
			    if (typeof value === 'number' && isNaN(value)) {
			      warnStyleValueIsNaN(name, value, owner);
			    }
			  };
			}
	
			/**
			 * Operations for dealing with CSS properties.
			 */
			var CSSPropertyOperations = {
	
			  /**
			   * Serializes a mapping of style properties for use as inline styles:
			   *
			   *   > createMarkupForStyles({width: '200px', height: 0})
			   *   "width:200px;height:0;"
			   *
			   * Undefined values are ignored so that declarative programming is easier.
			   * The result should be HTML-escaped before insertion into the DOM.
			   *
			   * @param {object} styles
			   * @param {ReactDOMComponent} component
			   * @return {?string}
			   */
			  createMarkupForStyles: function (styles, component) {
			    var serialized = '';
			    for (var styleName in styles) {
			      if (!styles.hasOwnProperty(styleName)) {
			        continue;
			      }
			      var styleValue = styles[styleName];
			      if (process.env.NODE_ENV !== 'production') {
			        warnValidStyle(styleName, styleValue, component);
			      }
			      if (styleValue != null) {
			        serialized += processStyleName(styleName) + ':';
			        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
			      }
			    }
			    return serialized || null;
			  },
	
			  /**
			   * Sets the value for multiple styles on a node.  If a value is specified as
			   * '' (empty string), the corresponding style property will be unset.
			   *
			   * @param {DOMElement} node
			   * @param {object} styles
			   * @param {ReactDOMComponent} component
			   */
			  setValueForStyles: function (node, styles, component) {
			    if (process.env.NODE_ENV !== 'production') {
			      ReactInstrumentation.debugTool.onHostOperation({
			        instanceID: component._debugID,
			        type: 'update styles',
			        payload: styles
			      });
			    }
	
			    var style = node.style;
			    for (var styleName in styles) {
			      if (!styles.hasOwnProperty(styleName)) {
			        continue;
			      }
			      if (process.env.NODE_ENV !== 'production') {
			        warnValidStyle(styleName, styles[styleName], component);
			      }
			      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
			      if (styleName === 'float' || styleName === 'cssFloat') {
			        styleName = styleFloatAccessor;
			      }
			      if (styleValue) {
			        style[styleName] = styleValue;
			      } else {
			        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
			        if (expansion) {
			          // Shorthand property that IE8 won't like unsetting, so unset each
			          // component to placate it
			          for (var individualStyleName in expansion) {
			            style[individualStyleName] = '';
			          }
			        } else {
			          style[styleName] = '';
			        }
			      }
			    }
			  }
	
			};
	
			module.exports = CSSPropertyOperations;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 77 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * CSS properties which accept numbers but are not in units of "px".
			 */
	
			var isUnitlessNumber = {
			  animationIterationCount: true,
			  borderImageOutset: true,
			  borderImageSlice: true,
			  borderImageWidth: true,
			  boxFlex: true,
			  boxFlexGroup: true,
			  boxOrdinalGroup: true,
			  columnCount: true,
			  flex: true,
			  flexGrow: true,
			  flexPositive: true,
			  flexShrink: true,
			  flexNegative: true,
			  flexOrder: true,
			  gridRow: true,
			  gridColumn: true,
			  fontWeight: true,
			  lineClamp: true,
			  lineHeight: true,
			  opacity: true,
			  order: true,
			  orphans: true,
			  tabSize: true,
			  widows: true,
			  zIndex: true,
			  zoom: true,
	
			  // SVG-related properties
			  fillOpacity: true,
			  floodOpacity: true,
			  stopOpacity: true,
			  strokeDasharray: true,
			  strokeDashoffset: true,
			  strokeMiterlimit: true,
			  strokeOpacity: true,
			  strokeWidth: true
			};
	
			/**
			 * @param {string} prefix vendor-specific prefix, eg: Webkit
			 * @param {string} key style name, eg: transitionDuration
			 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
			 * WebkitTransitionDuration
			 */
			function prefixKey(prefix, key) {
			  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
			}
	
			/**
			 * Support style names that may come passed in prefixed by adding permutations
			 * of vendor prefixes.
			 */
			var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
			// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
			// infinite loop, because it iterates over the newly added props too.
			Object.keys(isUnitlessNumber).forEach(function (prop) {
			  prefixes.forEach(function (prefix) {
			    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
			  });
			});
	
			/**
			 * Most style properties can be unset by doing .style[prop] = '' but IE8
			 * doesn't like doing that with shorthand properties so for the properties that
			 * IE8 breaks on, which are listed here, we instead unset each of the
			 * individual properties. See http://bugs.jquery.com/ticket/12385.
			 * The 4-value 'clock' properties like margin, padding, border-width seem to
			 * behave without any problems. Curiously, list-style works too without any
			 * special prodding.
			 */
			var shorthandPropertyExpansions = {
			  background: {
			    backgroundAttachment: true,
			    backgroundColor: true,
			    backgroundImage: true,
			    backgroundPositionX: true,
			    backgroundPositionY: true,
			    backgroundRepeat: true
			  },
			  backgroundPosition: {
			    backgroundPositionX: true,
			    backgroundPositionY: true
			  },
			  border: {
			    borderWidth: true,
			    borderStyle: true,
			    borderColor: true
			  },
			  borderBottom: {
			    borderBottomWidth: true,
			    borderBottomStyle: true,
			    borderBottomColor: true
			  },
			  borderLeft: {
			    borderLeftWidth: true,
			    borderLeftStyle: true,
			    borderLeftColor: true
			  },
			  borderRight: {
			    borderRightWidth: true,
			    borderRightStyle: true,
			    borderRightColor: true
			  },
			  borderTop: {
			    borderTopWidth: true,
			    borderTopStyle: true,
			    borderTopColor: true
			  },
			  font: {
			    fontStyle: true,
			    fontVariant: true,
			    fontWeight: true,
			    fontSize: true,
			    lineHeight: true,
			    fontFamily: true
			  },
			  outline: {
			    outlineWidth: true,
			    outlineStyle: true,
			    outlineColor: true
			  }
			};
	
			var CSSProperty = {
			  isUnitlessNumber: isUnitlessNumber,
			  shorthandPropertyExpansions: shorthandPropertyExpansions
			};
	
			module.exports = CSSProperty;
	
		/***/ },
		/* 78 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			'use strict';
	
			var camelize = __webpack_require__(79);
	
			var msPattern = /^-ms-/;
	
			/**
			 * Camelcases a hyphenated CSS property name, for example:
			 *
			 *   > camelizeStyleName('background-color')
			 *   < "backgroundColor"
			 *   > camelizeStyleName('-moz-transition')
			 *   < "MozTransition"
			 *   > camelizeStyleName('-ms-transition')
			 *   < "msTransition"
			 *
			 * As Andi Smith suggests
			 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
			 * is converted to lowercase `ms`.
			 *
			 * @param {string} string
			 * @return {string}
			 */
			function camelizeStyleName(string) {
			  return camelize(string.replace(msPattern, 'ms-'));
			}
	
			module.exports = camelizeStyleName;
	
		/***/ },
		/* 79 */
		/***/ function(module, exports) {
	
			"use strict";
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			var _hyphenPattern = /-(.)/g;
	
			/**
			 * Camelcases a hyphenated string, for example:
			 *
			 *   > camelize('background-color')
			 *   < "backgroundColor"
			 *
			 * @param {string} string
			 * @return {string}
			 */
			function camelize(string) {
			  return string.replace(_hyphenPattern, function (_, character) {
			    return character.toUpperCase();
			  });
			}
	
			module.exports = camelize;
	
		/***/ },
		/* 80 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var CSSProperty = __webpack_require__(77);
			var warning = __webpack_require__(18);
	
			var isUnitlessNumber = CSSProperty.isUnitlessNumber;
			var styleWarnings = {};
	
			/**
			 * Convert a value into the proper css writable value. The style name `name`
			 * should be logical (no hyphens), as specified
			 * in `CSSProperty.isUnitlessNumber`.
			 *
			 * @param {string} name CSS property name such as `topMargin`.
			 * @param {*} value CSS property value such as `10px`.
			 * @param {ReactDOMComponent} component
			 * @return {string} Normalized style value with dimensions applied.
			 */
			function dangerousStyleValue(name, value, component) {
			  // Note that we've removed escapeTextForBrowser() calls here since the
			  // whole string will be escaped when the attribute is injected into
			  // the markup. If you provide unsafe user data here they can inject
			  // arbitrary CSS which may be problematic (I couldn't repro this):
			  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
			  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
			  // This is not an XSS hole but instead a potential CSS injection issue
			  // which has lead to a greater discussion about how we're going to
			  // trust URLs moving forward. See #2115901
	
			  var isEmpty = value == null || typeof value === 'boolean' || value === '';
			  if (isEmpty) {
			    return '';
			  }
	
			  var isNonNumeric = isNaN(value);
			  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
			    return '' + value; // cast to string
			  }
	
			  if (typeof value === 'string') {
			    if (process.env.NODE_ENV !== 'production') {
			      // Allow '0' to pass through without warning. 0 is already special and
			      // doesn't require units, so we don't need to warn about it.
			      if (component && value !== '0') {
			        var owner = component._currentElement._owner;
			        var ownerName = owner ? owner.getName() : null;
			        if (ownerName && !styleWarnings[ownerName]) {
			          styleWarnings[ownerName] = {};
			        }
			        var warned = false;
			        if (ownerName) {
			          var warnings = styleWarnings[ownerName];
			          warned = warnings[name];
			          if (!warned) {
			            warnings[name] = true;
			          }
			        }
			        if (!warned) {
			          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
			        }
			      }
			    }
			    value = value.trim();
			  }
			  return value + 'px';
			}
	
			module.exports = dangerousStyleValue;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 81 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			'use strict';
	
			var hyphenate = __webpack_require__(82);
	
			var msPattern = /^ms-/;
	
			/**
			 * Hyphenates a camelcased CSS property name, for example:
			 *
			 *   > hyphenateStyleName('backgroundColor')
			 *   < "background-color"
			 *   > hyphenateStyleName('MozTransition')
			 *   < "-moz-transition"
			 *   > hyphenateStyleName('msTransition')
			 *   < "-ms-transition"
			 *
			 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
			 * is converted to `-ms-`.
			 *
			 * @param {string} string
			 * @return {string}
			 */
			function hyphenateStyleName(string) {
			  return hyphenate(string).replace(msPattern, '-ms-');
			}
	
			module.exports = hyphenateStyleName;
	
		/***/ },
		/* 82 */
		/***/ function(module, exports) {
	
			'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			var _uppercasePattern = /([A-Z])/g;
	
			/**
			 * Hyphenates a camelcased string, for example:
			 *
			 *   > hyphenate('backgroundColor')
			 *   < "background-color"
			 *
			 * For CSS style names, use `hyphenateStyleName` instead which works properly
			 * with all vendor prefixes, including `ms`.
			 *
			 * @param {string} string
			 * @return {string}
			 */
			function hyphenate(string) {
			  return string.replace(_uppercasePattern, '-$1').toLowerCase();
			}
	
			module.exports = hyphenate;
	
		/***/ },
		/* 83 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 * @typechecks static-only
			 */
	
			'use strict';
	
			/**
			 * Memoizes the return value of a function that accepts one string argument.
			 */
	
			function memoizeStringOnly(callback) {
			  var cache = {};
			  return function (string) {
			    if (!cache.hasOwnProperty(string)) {
			      cache[string] = callback.call(this, string);
			    }
			    return cache[string];
			  };
			}
	
			module.exports = memoizeStringOnly;
	
		/***/ },
		/* 84 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMProperty = __webpack_require__(7);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactInstrumentation = __webpack_require__(37);
	
			var quoteAttributeValueForBrowser = __webpack_require__(85);
			var warning = __webpack_require__(18);
	
			var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
			var illegalAttributeNameCache = {};
			var validatedAttributeNameCache = {};
	
			function isAttributeNameSafe(attributeName) {
			  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
			    return true;
			  }
			  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
			    return false;
			  }
			  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
			    validatedAttributeNameCache[attributeName] = true;
			    return true;
			  }
			  illegalAttributeNameCache[attributeName] = true;
			  process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
			  return false;
			}
	
			function shouldIgnoreValue(propertyInfo, value) {
			  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
			}
	
			/**
			 * Operations for dealing with DOM properties.
			 */
			var DOMPropertyOperations = {
	
			  /**
			   * Creates markup for the ID property.
			   *
			   * @param {string} id Unescaped ID.
			   * @return {string} Markup string.
			   */
			  createMarkupForID: function (id) {
			    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
			  },
	
			  setAttributeForID: function (node, id) {
			    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
			  },
	
			  createMarkupForRoot: function () {
			    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
			  },
	
			  setAttributeForRoot: function (node) {
			    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
			  },
	
			  /**
			   * Creates markup for a property.
			   *
			   * @param {string} name
			   * @param {*} value
			   * @return {?string} Markup string, or null if the property was invalid.
			   */
			  createMarkupForProperty: function (name, value) {
			    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
			    if (propertyInfo) {
			      if (shouldIgnoreValue(propertyInfo, value)) {
			        return '';
			      }
			      var attributeName = propertyInfo.attributeName;
			      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
			        return attributeName + '=""';
			      }
			      return attributeName + '=' + quoteAttributeValueForBrowser(value);
			    } else if (DOMProperty.isCustomAttribute(name)) {
			      if (value == null) {
			        return '';
			      }
			      return name + '=' + quoteAttributeValueForBrowser(value);
			    }
			    return null;
			  },
	
			  /**
			   * Creates markup for a custom property.
			   *
			   * @param {string} name
			   * @param {*} value
			   * @return {string} Markup string, or empty string if the property was invalid.
			   */
			  createMarkupForCustomAttribute: function (name, value) {
			    if (!isAttributeNameSafe(name) || value == null) {
			      return '';
			    }
			    return name + '=' + quoteAttributeValueForBrowser(value);
			  },
	
			  /**
			   * Sets the value for a property on a node.
			   *
			   * @param {DOMElement} node
			   * @param {string} name
			   * @param {*} value
			   */
			  setValueForProperty: function (node, name, value) {
			    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
			    if (propertyInfo) {
			      var mutationMethod = propertyInfo.mutationMethod;
			      if (mutationMethod) {
			        mutationMethod(node, value);
			      } else if (shouldIgnoreValue(propertyInfo, value)) {
			        this.deleteValueForProperty(node, name);
			        return;
			      } else if (propertyInfo.mustUseProperty) {
			        // Contrary to `setAttribute`, object properties are properly
			        // `toString`ed by IE8/9.
			        node[propertyInfo.propertyName] = value;
			      } else {
			        var attributeName = propertyInfo.attributeName;
			        var namespace = propertyInfo.attributeNamespace;
			        // `setAttribute` with objects becomes only `[object]` in IE8/9,
			        // ('' + value) makes it output the correct toString()-value.
			        if (namespace) {
			          node.setAttributeNS(namespace, attributeName, '' + value);
			        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
			          node.setAttribute(attributeName, '');
			        } else {
			          node.setAttribute(attributeName, '' + value);
			        }
			      }
			    } else if (DOMProperty.isCustomAttribute(name)) {
			      DOMPropertyOperations.setValueForAttribute(node, name, value);
			      return;
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      var payload = {};
			      payload[name] = value;
			      ReactInstrumentation.debugTool.onHostOperation({
			        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
			        type: 'update attribute',
			        payload: payload
			      });
			    }
			  },
	
			  setValueForAttribute: function (node, name, value) {
			    if (!isAttributeNameSafe(name)) {
			      return;
			    }
			    if (value == null) {
			      node.removeAttribute(name);
			    } else {
			      node.setAttribute(name, '' + value);
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      var payload = {};
			      payload[name] = value;
			      ReactInstrumentation.debugTool.onHostOperation({
			        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
			        type: 'update attribute',
			        payload: payload
			      });
			    }
			  },
	
			  /**
			   * Deletes an attributes from a node.
			   *
			   * @param {DOMElement} node
			   * @param {string} name
			   */
			  deleteValueForAttribute: function (node, name) {
			    node.removeAttribute(name);
			    if (process.env.NODE_ENV !== 'production') {
			      ReactInstrumentation.debugTool.onHostOperation({
			        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
			        type: 'remove attribute',
			        payload: name
			      });
			    }
			  },
	
			  /**
			   * Deletes the value for a property on a node.
			   *
			   * @param {DOMElement} node
			   * @param {string} name
			   */
			  deleteValueForProperty: function (node, name) {
			    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
			    if (propertyInfo) {
			      var mutationMethod = propertyInfo.mutationMethod;
			      if (mutationMethod) {
			        mutationMethod(node, undefined);
			      } else if (propertyInfo.mustUseProperty) {
			        var propName = propertyInfo.propertyName;
			        if (propertyInfo.hasBooleanValue) {
			          node[propName] = false;
			        } else {
			          node[propName] = '';
			        }
			      } else {
			        node.removeAttribute(propertyInfo.attributeName);
			      }
			    } else if (DOMProperty.isCustomAttribute(name)) {
			      node.removeAttribute(name);
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      ReactInstrumentation.debugTool.onHostOperation({
			        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
			        type: 'remove attribute',
			        payload: name
			      });
			    }
			  }
	
			};
	
			module.exports = DOMPropertyOperations;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 85 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var escapeTextContentForBrowser = __webpack_require__(67);
	
			/**
			 * Escapes attribute value to prevent scripting attacks.
			 *
			 * @param {*} value Value to escape.
			 * @return {string} An escaped string.
			 */
			function quoteAttributeValueForBrowser(value) {
			  return '"' + escapeTextContentForBrowser(value) + '"';
			}
	
			module.exports = quoteAttributeValueForBrowser;
	
		/***/ },
		/* 86 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var EventPluginRegistry = __webpack_require__(15);
			var ReactEventEmitterMixin = __webpack_require__(87);
			var ViewportMetrics = __webpack_require__(57);
	
			var getVendorPrefixedEventName = __webpack_require__(88);
			var isEventSupported = __webpack_require__(51);
	
			/**
			 * Summary of `ReactBrowserEventEmitter` event handling:
			 *
			 *  - Top-level delegation is used to trap most native browser events. This
			 *    may only occur in the main thread and is the responsibility of
			 *    ReactEventListener, which is injected and can therefore support pluggable
			 *    event sources. This is the only work that occurs in the main thread.
			 *
			 *  - We normalize and de-duplicate events to account for browser quirks. This
			 *    may be done in the worker thread.
			 *
			 *  - Forward these native events (with the associated top-level type used to
			 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
			 *    to extract any synthetic events.
			 *
			 *  - The `EventPluginHub` will then process each event by annotating them with
			 *    "dispatches", a sequence of listeners and IDs that care about that event.
			 *
			 *  - The `EventPluginHub` then dispatches the events.
			 *
			 * Overview of React and the event system:
			 *
			 * +------------+    .
			 * |    DOM     |    .
			 * +------------+    .
			 *       |           .
			 *       v           .
			 * +------------+    .
			 * | ReactEvent |    .
			 * |  Listener  |    .
			 * +------------+    .                         +-----------+
			 *       |           .               +--------+|SimpleEvent|
			 *       |           .               |         |Plugin     |
			 * +-----|------+    .               v         +-----------+
			 * |     |      |    .    +--------------+                    +------------+
			 * |     +-----------.--->|EventPluginHub|                    |    Event   |
			 * |            |    .    |              |     +-----------+  | Propagators|
			 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
			 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
			 * |            |    .    |              |     +-----------+  |  utilities |
			 * |     +-----------.--->|              |                    +------------+
			 * |     |      |    .    +--------------+
			 * +-----|------+    .                ^        +-----------+
			 *       |           .                |        |Enter/Leave|
			 *       +           .                +-------+|Plugin     |
			 * +-------------+   .                         +-----------+
			 * | application |   .
			 * |-------------|   .
			 * |             |   .
			 * |             |   .
			 * +-------------+   .
			 *                   .
			 *    React Core     .  General Purpose Event Plugin System
			 */
	
			var hasEventPageXY;
			var alreadyListeningTo = {};
			var isMonitoringScrollValue = false;
			var reactTopListenersCounter = 0;
	
			// For events like 'submit' which don't consistently bubble (which we trap at a
			// lower node than `document`), binding at `document` would cause duplicate
			// events so we don't include them here
			var topEventMapping = {
			  topAbort: 'abort',
			  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
			  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
			  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
			  topBlur: 'blur',
			  topCanPlay: 'canplay',
			  topCanPlayThrough: 'canplaythrough',
			  topChange: 'change',
			  topClick: 'click',
			  topCompositionEnd: 'compositionend',
			  topCompositionStart: 'compositionstart',
			  topCompositionUpdate: 'compositionupdate',
			  topContextMenu: 'contextmenu',
			  topCopy: 'copy',
			  topCut: 'cut',
			  topDoubleClick: 'dblclick',
			  topDrag: 'drag',
			  topDragEnd: 'dragend',
			  topDragEnter: 'dragenter',
			  topDragExit: 'dragexit',
			  topDragLeave: 'dragleave',
			  topDragOver: 'dragover',
			  topDragStart: 'dragstart',
			  topDrop: 'drop',
			  topDurationChange: 'durationchange',
			  topEmptied: 'emptied',
			  topEncrypted: 'encrypted',
			  topEnded: 'ended',
			  topError: 'error',
			  topFocus: 'focus',
			  topInput: 'input',
			  topKeyDown: 'keydown',
			  topKeyPress: 'keypress',
			  topKeyUp: 'keyup',
			  topLoadedData: 'loadeddata',
			  topLoadedMetadata: 'loadedmetadata',
			  topLoadStart: 'loadstart',
			  topMouseDown: 'mousedown',
			  topMouseMove: 'mousemove',
			  topMouseOut: 'mouseout',
			  topMouseOver: 'mouseover',
			  topMouseUp: 'mouseup',
			  topPaste: 'paste',
			  topPause: 'pause',
			  topPlay: 'play',
			  topPlaying: 'playing',
			  topProgress: 'progress',
			  topRateChange: 'ratechange',
			  topScroll: 'scroll',
			  topSeeked: 'seeked',
			  topSeeking: 'seeking',
			  topSelectionChange: 'selectionchange',
			  topStalled: 'stalled',
			  topSuspend: 'suspend',
			  topTextInput: 'textInput',
			  topTimeUpdate: 'timeupdate',
			  topTouchCancel: 'touchcancel',
			  topTouchEnd: 'touchend',
			  topTouchMove: 'touchmove',
			  topTouchStart: 'touchstart',
			  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
			  topVolumeChange: 'volumechange',
			  topWaiting: 'waiting',
			  topWheel: 'wheel'
			};
	
			/**
			 * To ensure no conflicts with other potential React instances on the page
			 */
			var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
			function getListeningForDocument(mountAt) {
			  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
			  // directly.
			  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
			    mountAt[topListenersIDKey] = reactTopListenersCounter++;
			    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
			  }
			  return alreadyListeningTo[mountAt[topListenersIDKey]];
			}
	
			/**
			 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
			 * example:
			 *
			 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
			 *
			 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
			 *
			 * @internal
			 */
			var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
			  /**
			   * Injectable event backend
			   */
			  ReactEventListener: null,
	
			  injection: {
			    /**
			     * @param {object} ReactEventListener
			     */
			    injectReactEventListener: function (ReactEventListener) {
			      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
			      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
			    }
			  },
	
			  /**
			   * Sets whether or not any created callbacks should be enabled.
			   *
			   * @param {boolean} enabled True if callbacks should be enabled.
			   */
			  setEnabled: function (enabled) {
			    if (ReactBrowserEventEmitter.ReactEventListener) {
			      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
			    }
			  },
	
			  /**
			   * @return {boolean} True if callbacks are enabled.
			   */
			  isEnabled: function () {
			    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
			  },
	
			  /**
			   * We listen for bubbled touch events on the document object.
			   *
			   * Firefox v8.01 (and possibly others) exhibited strange behavior when
			   * mounting `onmousemove` events at some node that was not the document
			   * element. The symptoms were that if your mouse is not moving over something
			   * contained within that mount point (for example on the background) the
			   * top-level listeners for `onmousemove` won't be called. However, if you
			   * register the `mousemove` on the document object, then it will of course
			   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
			   * top-level listeners to the document object only, at least for these
			   * movement types of events and possibly all events.
			   *
			   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
			   *
			   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
			   * they bubble to document.
			   *
			   * @param {string} registrationName Name of listener (e.g. `onClick`).
			   * @param {object} contentDocumentHandle Document which owns the container
			   */
			  listenTo: function (registrationName, contentDocumentHandle) {
			    var mountAt = contentDocumentHandle;
			    var isListening = getListeningForDocument(mountAt);
			    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
			    for (var i = 0; i < dependencies.length; i++) {
			      var dependency = dependencies[i];
			      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
			        if (dependency === 'topWheel') {
			          if (isEventSupported('wheel')) {
			            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
			          } else if (isEventSupported('mousewheel')) {
			            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
			          } else {
			            // Firefox needs to capture a different mouse scroll event.
			            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
			            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
			          }
			        } else if (dependency === 'topScroll') {
	
			          if (isEventSupported('scroll', true)) {
			            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
			          } else {
			            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
			          }
			        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
			          if (isEventSupported('focus', true)) {
			            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
			            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
			          } else if (isEventSupported('focusin')) {
			            // IE has `focusin` and `focusout` events which bubble.
			            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
			            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
			            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
			          }
	
			          // to make sure blur and focus event listeners are only attached once
			          isListening.topBlur = true;
			          isListening.topFocus = true;
			        } else if (topEventMapping.hasOwnProperty(dependency)) {
			          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
			        }
	
			        isListening[dependency] = true;
			      }
			    }
			  },
	
			  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
			    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
			  },
	
			  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
			    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
			  },
	
			  /**
			   * Protect against document.createEvent() returning null
			   * Some popup blocker extensions appear to do this:
			   * https://github.com/facebook/react/issues/6887
			   */
			  supportsEventPageXY: function () {
			    if (!document.createEvent) {
			      return false;
			    }
			    var ev = document.createEvent('MouseEvent');
			    return ev != null && 'pageX' in ev;
			  },
	
			  /**
			   * Listens to window scroll and resize events. We cache scroll values so that
			   * application code can access them without triggering reflows.
			   *
			   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
			   * pageX/pageY isn't supported (legacy browsers).
			   *
			   * NOTE: Scroll events do not bubble.
			   *
			   * @see http://www.quirksmode.org/dom/events/scroll.html
			   */
			  ensureScrollValueMonitoring: function () {
			    if (hasEventPageXY === undefined) {
			      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
			    }
			    if (!hasEventPageXY && !isMonitoringScrollValue) {
			      var refresh = ViewportMetrics.refreshScrollValues;
			      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
			      isMonitoringScrollValue = true;
			    }
			  }
	
			});
	
			module.exports = ReactBrowserEventEmitter;
	
		/***/ },
		/* 87 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var EventPluginHub = __webpack_require__(14);
	
			function runEventQueueInBatch(events) {
			  EventPluginHub.enqueueEvents(events);
			  EventPluginHub.processEventQueue(false);
			}
	
			var ReactEventEmitterMixin = {
	
			  /**
			   * Streams a fired top-level event to `EventPluginHub` where plugins have the
			   * opportunity to create `ReactEvent`s to be dispatched.
			   */
			  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
			    runEventQueueInBatch(events);
			  }
			};
	
			module.exports = ReactEventEmitterMixin;
	
		/***/ },
		/* 88 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ExecutionEnvironment = __webpack_require__(22);
	
			/**
			 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
			 *
			 * @param {string} styleProp
			 * @param {string} eventName
			 * @returns {object}
			 */
			function makePrefixMap(styleProp, eventName) {
			  var prefixes = {};
	
			  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
			  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
			  prefixes['Moz' + styleProp] = 'moz' + eventName;
			  prefixes['ms' + styleProp] = 'MS' + eventName;
			  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
			  return prefixes;
			}
	
			/**
			 * A list of event names to a configurable list of vendor prefixes.
			 */
			var vendorPrefixes = {
			  animationend: makePrefixMap('Animation', 'AnimationEnd'),
			  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
			  animationstart: makePrefixMap('Animation', 'AnimationStart'),
			  transitionend: makePrefixMap('Transition', 'TransitionEnd')
			};
	
			/**
			 * Event names that have already been detected and prefixed (if applicable).
			 */
			var prefixedEventNames = {};
	
			/**
			 * Element to check for prefixes on.
			 */
			var style = {};
	
			/**
			 * Bootstrap if a DOM exists.
			 */
			if (ExecutionEnvironment.canUseDOM) {
			  style = document.createElement('div').style;
	
			  // On some platforms, in particular some releases of Android 4.x,
			  // the un-prefixed "animation" and "transition" properties are defined on the
			  // style object but the events that fire will still be prefixed, so we need
			  // to check if the un-prefixed events are usable, and if not remove them from the map.
			  if (!('AnimationEvent' in window)) {
			    delete vendorPrefixes.animationend.animation;
			    delete vendorPrefixes.animationiteration.animation;
			    delete vendorPrefixes.animationstart.animation;
			  }
	
			  // Same as above
			  if (!('TransitionEvent' in window)) {
			    delete vendorPrefixes.transitionend.transition;
			  }
			}
	
			/**
			 * Attempts to determine the correct vendor prefixed event name.
			 *
			 * @param {string} eventName
			 * @returns {string}
			 */
			function getVendorPrefixedEventName(eventName) {
			  if (prefixedEventNames[eventName]) {
			    return prefixedEventNames[eventName];
			  } else if (!vendorPrefixes[eventName]) {
			    return eventName;
			  }
	
			  var prefixMap = vendorPrefixes[eventName];
	
			  for (var styleProp in prefixMap) {
			    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
			      return prefixedEventNames[eventName] = prefixMap[styleProp];
			    }
			  }
	
			  return '';
			}
	
			module.exports = getVendorPrefixedEventName;
	
		/***/ },
		/* 89 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6),
			    _assign = __webpack_require__(24);
	
			var DOMPropertyOperations = __webpack_require__(84);
			var LinkedValueUtils = __webpack_require__(90);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactUpdates = __webpack_require__(31);
	
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			var didWarnValueLink = false;
			var didWarnCheckedLink = false;
			var didWarnValueDefaultValue = false;
			var didWarnCheckedDefaultChecked = false;
			var didWarnControlledToUncontrolled = false;
			var didWarnUncontrolledToControlled = false;
	
			function forceUpdateIfMounted() {
			  if (this._rootNodeID) {
			    // DOM component is still mounted; update
			    ReactDOMInput.updateWrapper(this);
			  }
			}
	
			function isControlled(props) {
			  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
			  return usesChecked ? props.checked != null : props.value != null;
			}
	
			/**
			 * Implements an <input> host component that allows setting these optional
			 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
			 *
			 * If `checked` or `value` are not supplied (or null/undefined), user actions
			 * that affect the checked state or value will trigger updates to the element.
			 *
			 * If they are supplied (and not null/undefined), the rendered element will not
			 * trigger updates to the element. Instead, the props must change in order for
			 * the rendered element to be updated.
			 *
			 * The rendered element will be initialized as unchecked (or `defaultChecked`)
			 * with an empty value (or `defaultValue`).
			 *
			 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
			 */
			var ReactDOMInput = {
			  getHostProps: function (inst, props) {
			    var value = LinkedValueUtils.getValue(props);
			    var checked = LinkedValueUtils.getChecked(props);
	
			    var hostProps = _assign({
			      // Make sure we set .type before any other properties (setting .value
			      // before .type means .value is lost in IE11 and below)
			      type: undefined,
			      // Make sure we set .step before .value (setting .value before .step
			      // means .value is rounded on mount, based upon step precision)
			      step: undefined,
			      // Make sure we set .min & .max before .value (to ensure proper order
			      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
			      min: undefined,
			      max: undefined
			    }, props, {
			      defaultChecked: undefined,
			      defaultValue: undefined,
			      value: value != null ? value : inst._wrapperState.initialValue,
			      checked: checked != null ? checked : inst._wrapperState.initialChecked,
			      onChange: inst._wrapperState.onChange
			    });
	
			    return hostProps;
			  },
	
			  mountWrapper: function (inst, props) {
			    if (process.env.NODE_ENV !== 'production') {
			      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
			      var owner = inst._currentElement._owner;
	
			      if (props.valueLink !== undefined && !didWarnValueLink) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
			        didWarnValueLink = true;
			      }
			      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
			        didWarnCheckedLink = true;
			      }
			      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
			        didWarnCheckedDefaultChecked = true;
			      }
			      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
			        didWarnValueDefaultValue = true;
			      }
			    }
	
			    var defaultValue = props.defaultValue;
			    inst._wrapperState = {
			      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
			      initialValue: props.value != null ? props.value : defaultValue,
			      listeners: null,
			      onChange: _handleChange.bind(inst),
			      controlled: isControlled(props)
			    };
			  },
	
			  updateWrapper: function (inst) {
			    var props = inst._currentElement.props;
	
			    if (process.env.NODE_ENV !== 'production') {
			      var controlled = isControlled(props);
			      var owner = inst._currentElement._owner;
	
			      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
			        didWarnUncontrolledToControlled = true;
			      }
			      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
			        didWarnControlledToUncontrolled = true;
			      }
			    }
	
			    // TODO: Shouldn't this be getChecked(props)?
			    var checked = props.checked;
			    if (checked != null) {
			      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
			    }
	
			    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
			    var value = LinkedValueUtils.getValue(props);
			    if (value != null) {
			      if (value === 0 && node.value === '') {
			        node.value = '0';
			        // Note: IE9 reports a number inputs as 'text', so check props instead.
			      } else if (props.type === 'number') {
			        // Simulate `input.valueAsNumber`. IE9 does not support it
			        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
			        // eslint-disable-next-line
			        if (value != valueAsNumber) {
			          // Cast `value` to a string to ensure the value is set correctly. While
			          // browsers typically do this as necessary, jsdom doesn't.
			          node.value = '' + value;
			        }
			        // eslint-disable-next-line
			      } else if (value != node.value) {
			        // Cast `value` to a string to ensure the value is set correctly. While
			        // browsers typically do this as necessary, jsdom doesn't.
			        node.value = '' + value;
			      }
			    } else {
			      if (props.value == null && props.defaultValue != null) {
			        // In Chrome, assigning defaultValue to certain input types triggers input validation.
			        // For number inputs, the display value loses trailing decimal points. For email inputs,
			        // Chrome raises "The specified value <x> is not a valid email address".
			        //
			        // Here we check to see if the defaultValue has actually changed, avoiding these problems
			        // when the user is inputting text
			        //
			        // https://github.com/facebook/react/issues/7253
			        if (node.defaultValue !== '' + props.defaultValue) {
			          node.defaultValue = '' + props.defaultValue;
			        }
			      }
			      if (props.checked == null && props.defaultChecked != null) {
			        node.defaultChecked = !!props.defaultChecked;
			      }
			    }
			  },
	
			  postMountWrapper: function (inst) {
			    var props = inst._currentElement.props;
	
			    // This is in postMount because we need access to the DOM node, which is not
			    // available until after the component has mounted.
			    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
			    // Detach value from defaultValue. We won't do anything if we're working on
			    // submit or reset inputs as those values & defaultValues are linked. They
			    // are not resetable nodes so this operation doesn't matter and actually
			    // removes browser-default values (eg "Submit Query") when no value is
			    // provided.
	
			    switch (props.type) {
			      case 'submit':
			      case 'reset':
			        break;
			      case 'color':
			      case 'date':
			      case 'datetime':
			      case 'datetime-local':
			      case 'month':
			      case 'time':
			      case 'week':
			        // This fixes the no-show issue on iOS Safari and Android Chrome:
			        // https://github.com/facebook/react/issues/7233
			        node.value = '';
			        node.value = node.defaultValue;
			        break;
			      default:
			        node.value = node.value;
			        break;
			    }
	
			    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
			    // this is needed to work around a chrome bug where setting defaultChecked
			    // will sometimes influence the value of checked (even after detachment).
			    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
			    // We need to temporarily unset name to avoid disrupting radio button groups.
			    var name = node.name;
			    if (name !== '') {
			      node.name = '';
			    }
			    node.defaultChecked = !node.defaultChecked;
			    node.defaultChecked = !node.defaultChecked;
			    if (name !== '') {
			      node.name = name;
			    }
			  }
			};
	
			function _handleChange(event) {
			  var props = this._currentElement.props;
	
			  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
			  // Here we use asap to wait until all updates have propagated, which
			  // is important when using controlled components within layers:
			  // https://github.com/facebook/react/issues/1698
			  ReactUpdates.asap(forceUpdateIfMounted, this);
	
			  var name = props.name;
			  if (props.type === 'radio' && name != null) {
			    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
			    var queryRoot = rootNode;
	
			    while (queryRoot.parentNode) {
			      queryRoot = queryRoot.parentNode;
			    }
	
			    // If `rootNode.form` was non-null, then we could try `form.elements`,
			    // but that sometimes behaves strangely in IE8. We could also try using
			    // `form.getElementsByName`, but that will only return direct children
			    // and won't include inputs that use the HTML5 `form=` attribute. Since
			    // the input might not even be in a form, let's just use the global
			    // `querySelectorAll` to ensure we don't miss anything.
			    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
			    for (var i = 0; i < group.length; i++) {
			      var otherNode = group[i];
			      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
			        continue;
			      }
			      // This will throw if radio buttons rendered by different copies of React
			      // and the same name are rendered into the same form (same as #1939).
			      // That's probably okay; we don't support it just as we don't support
			      // mixing React radio buttons with non-React ones.
			      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
			      !otherInstance ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
			      // If this is a controlled radio button group, forcing the input that
			      // was previously checked to update will cause it to be come re-checked
			      // as appropriate.
			      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
			    }
			  }
	
			  return returnValue;
			}
	
			module.exports = ReactDOMInput;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 90 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var ReactPropTypesSecret = __webpack_require__(91);
			var propTypesFactory = __webpack_require__(92);
	
			var React = __webpack_require__(98);
			var PropTypes = propTypesFactory(React.isValidElement);
	
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			var hasReadOnlyValue = {
			  'button': true,
			  'checkbox': true,
			  'image': true,
			  'hidden': true,
			  'radio': true,
			  'reset': true,
			  'submit': true
			};
	
			function _assertSingleLink(inputProps) {
			  !(inputProps.checkedLink == null || inputProps.valueLink == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
			}
			function _assertValueLink(inputProps) {
			  _assertSingleLink(inputProps);
			  !(inputProps.value == null && inputProps.onChange == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
			}
	
			function _assertCheckedLink(inputProps) {
			  _assertSingleLink(inputProps);
			  !(inputProps.checked == null && inputProps.onChange == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
			}
	
			var propTypes = {
			  value: function (props, propName, componentName) {
			    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
			      return null;
			    }
			    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
			  },
			  checked: function (props, propName, componentName) {
			    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
			      return null;
			    }
			    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
			  },
			  onChange: PropTypes.func
			};
	
			var loggedTypeFailures = {};
			function getDeclarationErrorAddendum(owner) {
			  if (owner) {
			    var name = owner.getName();
			    if (name) {
			      return ' Check the render method of `' + name + '`.';
			    }
			  }
			  return '';
			}
	
			/**
			 * Provide a linked `value` attribute for controlled forms. You should not use
			 * this outside of the ReactDOM controlled form components.
			 */
			var LinkedValueUtils = {
			  checkPropTypes: function (tagName, props, owner) {
			    for (var propName in propTypes) {
			      if (propTypes.hasOwnProperty(propName)) {
			        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
			      }
			      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
			        // Only monitor this failure once because there tends to be a lot of the
			        // same error.
			        loggedTypeFailures[error.message] = true;
	
			        var addendum = getDeclarationErrorAddendum(owner);
			        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
			      }
			    }
			  },
	
			  /**
			   * @param {object} inputProps Props for form component
			   * @return {*} current value of the input either from value prop or link.
			   */
			  getValue: function (inputProps) {
			    if (inputProps.valueLink) {
			      _assertValueLink(inputProps);
			      return inputProps.valueLink.value;
			    }
			    return inputProps.value;
			  },
	
			  /**
			   * @param {object} inputProps Props for form component
			   * @return {*} current checked status of the input either from checked prop
			   *             or link.
			   */
			  getChecked: function (inputProps) {
			    if (inputProps.checkedLink) {
			      _assertCheckedLink(inputProps);
			      return inputProps.checkedLink.value;
			    }
			    return inputProps.checked;
			  },
	
			  /**
			   * @param {object} inputProps Props for form component
			   * @param {SyntheticEvent} event change event to handle
			   */
			  executeOnChange: function (inputProps, event) {
			    if (inputProps.valueLink) {
			      _assertValueLink(inputProps);
			      return inputProps.valueLink.requestChange(event.target.value);
			    } else if (inputProps.checkedLink) {
			      _assertCheckedLink(inputProps);
			      return inputProps.checkedLink.requestChange(event.target.checked);
			    } else if (inputProps.onChange) {
			      return inputProps.onChange.call(undefined, event);
			    }
			  }
			};
	
			module.exports = LinkedValueUtils;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 91 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
			module.exports = ReactPropTypesSecret;
	
		/***/ },
		/* 92 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 */
	
			'use strict';
	
			var emptyFunction = __webpack_require__(93);
			var invariant = __webpack_require__(94);
			var warning = __webpack_require__(95);
	
			var ReactPropTypesSecret = __webpack_require__(96);
			var checkPropTypes = __webpack_require__(97);
	
			module.exports = function (isValidElement) {
			  /* global Symbol */
			  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
			  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
			  /**
			   * Returns the iterator method function contained on the iterable object.
			   *
			   * Be sure to invoke the function with the iterable as context:
			   *
			   *     var iteratorFn = getIteratorFn(myIterable);
			   *     if (iteratorFn) {
			   *       var iterator = iteratorFn.call(myIterable);
			   *       ...
			   *     }
			   *
			   * @param {?object} maybeIterable
			   * @return {?function}
			   */
			  function getIteratorFn(maybeIterable) {
			    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
			    if (typeof iteratorFn === 'function') {
			      return iteratorFn;
			    }
			  }
	
			  /**
			   * Collection of methods that allow declaration and validation of props that are
			   * supplied to React components. Example usage:
			   *
			   *   var Props = require('ReactPropTypes');
			   *   var MyArticle = React.createClass({
			   *     propTypes: {
			   *       // An optional string prop named "description".
			   *       description: Props.string,
			   *
			   *       // A required enum prop named "category".
			   *       category: Props.oneOf(['News','Photos']).isRequired,
			   *
			   *       // A prop named "dialog" that requires an instance of Dialog.
			   *       dialog: Props.instanceOf(Dialog).isRequired
			   *     },
			   *     render: function() { ... }
			   *   });
			   *
			   * A more formal specification of how these methods are used:
			   *
			   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
			   *   decl := ReactPropTypes.{type}(.isRequired)?
			   *
			   * Each and every declaration produces a function with the same signature. This
			   * allows the creation of custom validation functions. For example:
			   *
			   *  var MyLink = React.createClass({
			   *    propTypes: {
			   *      // An optional string or URI prop named "href".
			   *      href: function(props, propName, componentName) {
			   *        var propValue = props[propName];
			   *        if (propValue != null && typeof propValue !== 'string' &&
			   *            !(propValue instanceof URI)) {
			   *          return new Error(
			   *            'Expected a string or an URI for ' + propName + ' in ' +
			   *            componentName
			   *          );
			   *        }
			   *      }
			   *    },
			   *    render: function() {...}
			   *  });
			   *
			   * @internal
			   */
	
			  var ANONYMOUS = '<<anonymous>>';
	
			  var ReactPropTypes;
	
			  if (process.env.NODE_ENV !== 'production') {
			    // Keep in sync with production version below
			    ReactPropTypes = {
			      array: createPrimitiveTypeChecker('array'),
			      bool: createPrimitiveTypeChecker('boolean'),
			      func: createPrimitiveTypeChecker('function'),
			      number: createPrimitiveTypeChecker('number'),
			      object: createPrimitiveTypeChecker('object'),
			      string: createPrimitiveTypeChecker('string'),
			      symbol: createPrimitiveTypeChecker('symbol'),
	
			      any: createAnyTypeChecker(),
			      arrayOf: createArrayOfTypeChecker,
			      element: createElementTypeChecker(),
			      instanceOf: createInstanceTypeChecker,
			      node: createNodeChecker(),
			      objectOf: createObjectOfTypeChecker,
			      oneOf: createEnumTypeChecker,
			      oneOfType: createUnionTypeChecker,
			      shape: createShapeTypeChecker
			    };
			  } else {
			    var productionTypeChecker = function () {
			      invariant(false, 'React.PropTypes type checking code is stripped in production.');
			    };
			    productionTypeChecker.isRequired = productionTypeChecker;
			    var getProductionTypeChecker = function () {
			      return productionTypeChecker;
			    };
			    // Keep in sync with development version above
			    ReactPropTypes = {
			      array: productionTypeChecker,
			      bool: productionTypeChecker,
			      func: productionTypeChecker,
			      number: productionTypeChecker,
			      object: productionTypeChecker,
			      string: productionTypeChecker,
			      symbol: productionTypeChecker,
	
			      any: productionTypeChecker,
			      arrayOf: getProductionTypeChecker,
			      element: productionTypeChecker,
			      instanceOf: getProductionTypeChecker,
			      node: productionTypeChecker,
			      objectOf: getProductionTypeChecker,
			      oneOf: getProductionTypeChecker,
			      oneOfType: getProductionTypeChecker,
			      shape: getProductionTypeChecker
			    };
			  }
	
			  /**
			   * inlined Object.is polyfill to avoid requiring consumers ship their own
			   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
			   */
			  /*eslint-disable no-self-compare*/
			  function is(x, y) {
			    // SameValue algorithm
			    if (x === y) {
			      // Steps 1-5, 7-10
			      // Steps 6.b-6.e: +0 != -0
			      return x !== 0 || 1 / x === 1 / y;
			    } else {
			      // Step 6.a: NaN == NaN
			      return x !== x && y !== y;
			    }
			  }
			  /*eslint-enable no-self-compare*/
	
			  /**
			   * We use an Error-like object for backward compatibility as people may call
			   * PropTypes directly and inspect their output. However, we don't use real
			   * Errors anymore. We don't inspect their stack anyway, and creating them
			   * is prohibitively expensive if they are created too often, such as what
			   * happens in oneOfType() for any type before the one that matched.
			   */
			  function PropTypeError(message) {
			    this.message = message;
			    this.stack = '';
			  }
			  // Make `instanceof Error` still work for returned errors.
			  PropTypeError.prototype = Error.prototype;
	
			  function createChainableTypeChecker(validate) {
			    if (process.env.NODE_ENV !== 'production') {
			      var manualPropTypeCallCache = {};
			    }
			    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
			      componentName = componentName || ANONYMOUS;
			      propFullName = propFullName || propName;
			      if (process.env.NODE_ENV !== 'production') {
			        if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
			          var cacheKey = componentName + ':' + propName;
			          if (!manualPropTypeCallCache[cacheKey]) {
			            process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
			            manualPropTypeCallCache[cacheKey] = true;
			          }
			        }
			      }
			      if (props[propName] == null) {
			        if (isRequired) {
			          if (props[propName] === null) {
			            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
			          }
			          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
			        }
			        return null;
			      } else {
			        return validate(props, propName, componentName, location, propFullName);
			      }
			    }
	
			    var chainedCheckType = checkType.bind(null, false);
			    chainedCheckType.isRequired = checkType.bind(null, true);
	
			    return chainedCheckType;
			  }
	
			  function createPrimitiveTypeChecker(expectedType) {
			    function validate(props, propName, componentName, location, propFullName, secret) {
			      var propValue = props[propName];
			      var propType = getPropType(propValue);
			      if (propType !== expectedType) {
			        // `propValue` being instance of, say, date/regexp, pass the 'object'
			        // check, but we can offer a more precise error message here rather than
			        // 'of type `object`'.
			        var preciseType = getPreciseType(propValue);
	
			        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
			      }
			      return null;
			    }
			    return createChainableTypeChecker(validate);
			  }
	
			  function createAnyTypeChecker() {
			    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
			  }
	
			  function createArrayOfTypeChecker(typeChecker) {
			    function validate(props, propName, componentName, location, propFullName) {
			      if (typeof typeChecker !== 'function') {
			        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
			      }
			      var propValue = props[propName];
			      if (!Array.isArray(propValue)) {
			        var propType = getPropType(propValue);
			        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
			      }
			      for (var i = 0; i < propValue.length; i++) {
			        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
			        if (error instanceof Error) {
			          return error;
			        }
			      }
			      return null;
			    }
			    return createChainableTypeChecker(validate);
			  }
	
			  function createElementTypeChecker() {
			    function validate(props, propName, componentName, location, propFullName) {
			      var propValue = props[propName];
			      if (!isValidElement(propValue)) {
			        var propType = getPropType(propValue);
			        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
			      }
			      return null;
			    }
			    return createChainableTypeChecker(validate);
			  }
	
			  function createInstanceTypeChecker(expectedClass) {
			    function validate(props, propName, componentName, location, propFullName) {
			      if (!(props[propName] instanceof expectedClass)) {
			        var expectedClassName = expectedClass.name || ANONYMOUS;
			        var actualClassName = getClassName(props[propName]);
			        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
			      }
			      return null;
			    }
			    return createChainableTypeChecker(validate);
			  }
	
			  function createEnumTypeChecker(expectedValues) {
			    if (!Array.isArray(expectedValues)) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
			      return emptyFunction.thatReturnsNull;
			    }
	
			    function validate(props, propName, componentName, location, propFullName) {
			      var propValue = props[propName];
			      for (var i = 0; i < expectedValues.length; i++) {
			        if (is(propValue, expectedValues[i])) {
			          return null;
			        }
			      }
	
			      var valuesString = JSON.stringify(expectedValues);
			      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
			    }
			    return createChainableTypeChecker(validate);
			  }
	
			  function createObjectOfTypeChecker(typeChecker) {
			    function validate(props, propName, componentName, location, propFullName) {
			      if (typeof typeChecker !== 'function') {
			        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
			      }
			      var propValue = props[propName];
			      var propType = getPropType(propValue);
			      if (propType !== 'object') {
			        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
			      }
			      for (var key in propValue) {
			        if (propValue.hasOwnProperty(key)) {
			          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
			          if (error instanceof Error) {
			            return error;
			          }
			        }
			      }
			      return null;
			    }
			    return createChainableTypeChecker(validate);
			  }
	
			  function createUnionTypeChecker(arrayOfTypeCheckers) {
			    if (!Array.isArray(arrayOfTypeCheckers)) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
			      return emptyFunction.thatReturnsNull;
			    }
	
			    function validate(props, propName, componentName, location, propFullName) {
			      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
			        var checker = arrayOfTypeCheckers[i];
			        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
			          return null;
			        }
			      }
	
			      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
			    }
			    return createChainableTypeChecker(validate);
			  }
	
			  function createNodeChecker() {
			    function validate(props, propName, componentName, location, propFullName) {
			      if (!isNode(props[propName])) {
			        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
			      }
			      return null;
			    }
			    return createChainableTypeChecker(validate);
			  }
	
			  function createShapeTypeChecker(shapeTypes) {
			    function validate(props, propName, componentName, location, propFullName) {
			      var propValue = props[propName];
			      var propType = getPropType(propValue);
			      if (propType !== 'object') {
			        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
			      }
			      for (var key in shapeTypes) {
			        var checker = shapeTypes[key];
			        if (!checker) {
			          continue;
			        }
			        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
			        if (error) {
			          return error;
			        }
			      }
			      return null;
			    }
			    return createChainableTypeChecker(validate);
			  }
	
			  function isNode(propValue) {
			    switch (typeof propValue) {
			      case 'number':
			      case 'string':
			      case 'undefined':
			        return true;
			      case 'boolean':
			        return !propValue;
			      case 'object':
			        if (Array.isArray(propValue)) {
			          return propValue.every(isNode);
			        }
			        if (propValue === null || isValidElement(propValue)) {
			          return true;
			        }
	
			        var iteratorFn = getIteratorFn(propValue);
			        if (iteratorFn) {
			          var iterator = iteratorFn.call(propValue);
			          var step;
			          if (iteratorFn !== propValue.entries) {
			            while (!(step = iterator.next()).done) {
			              if (!isNode(step.value)) {
			                return false;
			              }
			            }
			          } else {
			            // Iterator will provide entry [k,v] tuples rather than values.
			            while (!(step = iterator.next()).done) {
			              var entry = step.value;
			              if (entry) {
			                if (!isNode(entry[1])) {
			                  return false;
			                }
			              }
			            }
			          }
			        } else {
			          return false;
			        }
	
			        return true;
			      default:
			        return false;
			    }
			  }
	
			  function isSymbol(propType, propValue) {
			    // Native Symbol.
			    if (propType === 'symbol') {
			      return true;
			    }
	
			    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
			    if (propValue['@@toStringTag'] === 'Symbol') {
			      return true;
			    }
	
			    // Fallback for non-spec compliant Symbols which are polyfilled.
			    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
			      return true;
			    }
	
			    return false;
			  }
	
			  // Equivalent of `typeof` but with special handling for array and regexp.
			  function getPropType(propValue) {
			    var propType = typeof propValue;
			    if (Array.isArray(propValue)) {
			      return 'array';
			    }
			    if (propValue instanceof RegExp) {
			      // Old webkits (at least until Android 4.0) return 'function' rather than
			      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
			      // passes PropTypes.object.
			      return 'object';
			    }
			    if (isSymbol(propType, propValue)) {
			      return 'symbol';
			    }
			    return propType;
			  }
	
			  // This handles more types than `getPropType`. Only used for error messages.
			  // See `createPrimitiveTypeChecker`.
			  function getPreciseType(propValue) {
			    var propType = getPropType(propValue);
			    if (propType === 'object') {
			      if (propValue instanceof Date) {
			        return 'date';
			      } else if (propValue instanceof RegExp) {
			        return 'regexp';
			      }
			    }
			    return propType;
			  }
	
			  // Returns class name of the object, if any.
			  function getClassName(propValue) {
			    if (!propValue.constructor || !propValue.constructor.name) {
			      return ANONYMOUS;
			    }
			    return propValue.constructor.name;
			  }
	
			  ReactPropTypes.checkPropTypes = checkPropTypes;
			  ReactPropTypes.PropTypes = ReactPropTypes;
	
			  return ReactPropTypes;
			};
	
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 93 */
		/***/ function(module, exports) {
	
			"use strict";
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			function makeEmptyFunction(arg) {
			  return function () {
			    return arg;
			  };
			}
	
			/**
			 * This function accepts and discards inputs; it has no side effects. This is
			 * primarily useful idiomatically for overridable function endpoints which
			 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
			 */
			var emptyFunction = function emptyFunction() {};
	
			emptyFunction.thatReturns = makeEmptyFunction;
			emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
			emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
			emptyFunction.thatReturnsNull = makeEmptyFunction(null);
			emptyFunction.thatReturnsThis = function () {
			  return this;
			};
			emptyFunction.thatReturnsArgument = function (arg) {
			  return arg;
			};
	
			module.exports = emptyFunction;
	
		/***/ },
		/* 94 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * Use invariant() to assert state which your program assumes to be true.
			 *
			 * Provide sprintf-style format (only %s is supported) and arguments
			 * to provide information about what broke and what you were
			 * expecting.
			 *
			 * The invariant message will be stripped in production, but the invariant
			 * will remain to ensure logic does not differ in production.
			 */
	
			var validateFormat = function validateFormat(format) {};
	
			if (process.env.NODE_ENV !== 'production') {
			  validateFormat = function validateFormat(format) {
			    if (format === undefined) {
			      throw new Error('invariant requires an error message argument');
			    }
			  };
			}
	
			function invariant(condition, format, a, b, c, d, e, f) {
			  validateFormat(format);
	
			  if (!condition) {
			    var error;
			    if (format === undefined) {
			      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
			    } else {
			      var args = [a, b, c, d, e, f];
			      var argIndex = 0;
			      error = new Error(format.replace(/%s/g, function () {
			        return args[argIndex++];
			      }));
			      error.name = 'Invariant Violation';
			    }
	
			    error.framesToPop = 1; // we don't care about invariant's own frame
			    throw error;
			  }
			}
	
			module.exports = invariant;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 95 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-2015, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var emptyFunction = __webpack_require__(93);
	
			/**
			 * Similar to invariant but only logs a warning if the condition is not met.
			 * This can be used to log issues in development environments in critical
			 * paths. Removing the logging code for production environments will keep the
			 * same logic and follow the same code paths.
			 */
	
			var warning = emptyFunction;
	
			if (process.env.NODE_ENV !== 'production') {
			  (function () {
			    var printWarning = function printWarning(format) {
			      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			        args[_key - 1] = arguments[_key];
			      }
	
			      var argIndex = 0;
			      var message = 'Warning: ' + format.replace(/%s/g, function () {
			        return args[argIndex++];
			      });
			      if (typeof console !== 'undefined') {
			        console.error(message);
			      }
			      try {
			        // --- Welcome to debugging React ---
			        // This error was thrown as a convenience so that you can use this stack
			        // to find the callsite that caused this warning to fire.
			        throw new Error(message);
			      } catch (x) {}
			    };
	
			    warning = function warning(condition, format) {
			      if (format === undefined) {
			        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
			      }
	
			      if (format.indexOf('Failed Composite propType: ') === 0) {
			        return; // Ignore CompositeComponent proptype check.
			      }
	
			      if (!condition) {
			        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
			          args[_key2 - 2] = arguments[_key2];
			        }
	
			        printWarning.apply(undefined, [format].concat(args));
			      }
			    };
			  })();
			}
	
			module.exports = warning;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 96 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 */
	
			'use strict';
	
			var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
			module.exports = ReactPropTypesSecret;
	
	
		/***/ },
		/* 97 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 */
	
			'use strict';
	
			var invariant = __webpack_require__(94);
			var warning = __webpack_require__(95);
	
			var ReactPropTypesSecret = __webpack_require__(96);
	
			var loggedTypeFailures = {};
	
			/**
			 * Assert that the values match with the type specs.
			 * Error messages are memorized and will only be shown once.
			 *
			 * @param {object} typeSpecs Map of name to a ReactPropType
			 * @param {object} values Runtime values that need to be type-checked
			 * @param {string} location e.g. "prop", "context", "child context"
			 * @param {string} componentName Name of the component for error messages.
			 * @param {?Function} getStack Returns the component stack.
			 * @private
			 */
			function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
			  if (process.env.NODE_ENV !== 'production') {
			    for (var typeSpecName in typeSpecs) {
			      if (typeSpecs.hasOwnProperty(typeSpecName)) {
			        var error;
			        // Prop type validation may throw. In case they do, we don't want to
			        // fail the render phase where it didn't fail before. So we log it.
			        // After these have been cleaned up, we'll let them throw.
			        try {
			          // This is intentionally an invariant that gets caught. It's the same
			          // behavior as without this statement except with a better message.
			          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
			          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
			        } catch (ex) {
			          error = ex;
			        }
			        process.env.NODE_ENV !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error) : void 0;
			        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
			          // Only monitor this failure once because there tends to be a lot of the
			          // same error.
			          loggedTypeFailures[error.message] = true;
	
			          var stack = getStack ? getStack() : '';
	
			          process.env.NODE_ENV !== 'production' ? warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '') : void 0;
			        }
			      }
			    }
			  }
			}
	
			module.exports = checkPropTypes;
	
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 98 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var ReactChildren = __webpack_require__(99);
			var ReactComponent = __webpack_require__(107);
			var ReactPureComponent = __webpack_require__(110);
			var ReactClass = __webpack_require__(111);
			var ReactDOMFactories = __webpack_require__(113);
			var ReactElement = __webpack_require__(101);
			var ReactPropTypes = __webpack_require__(117);
			var ReactVersion = __webpack_require__(118);
	
			var onlyChild = __webpack_require__(119);
			var warning = __webpack_require__(45);
	
			var createElement = ReactElement.createElement;
			var createFactory = ReactElement.createFactory;
			var cloneElement = ReactElement.cloneElement;
	
			if (process.env.NODE_ENV !== 'production') {
			  var canDefineProperty = __webpack_require__(102);
			  var ReactElementValidator = __webpack_require__(114);
			  var didWarnPropTypesDeprecated = false;
			  createElement = ReactElementValidator.createElement;
			  createFactory = ReactElementValidator.createFactory;
			  cloneElement = ReactElementValidator.cloneElement;
			}
	
			var __spread = _assign;
	
			if (process.env.NODE_ENV !== 'production') {
			  var warned = false;
			  __spread = function () {
			    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
			    warned = true;
			    return _assign.apply(null, arguments);
			  };
			}
	
			var React = {
	
			  // Modern
	
			  Children: {
			    map: ReactChildren.map,
			    forEach: ReactChildren.forEach,
			    count: ReactChildren.count,
			    toArray: ReactChildren.toArray,
			    only: onlyChild
			  },
	
			  Component: ReactComponent,
			  PureComponent: ReactPureComponent,
	
			  createElement: createElement,
			  cloneElement: cloneElement,
			  isValidElement: ReactElement.isValidElement,
	
			  // Classic
	
			  PropTypes: ReactPropTypes,
			  createClass: ReactClass.createClass,
			  createFactory: createFactory,
			  createMixin: function (mixin) {
			    // Currently a noop. Will be used to validate and trace mixins.
			    return mixin;
			  },
	
			  // This looks DOM specific but these are actually isomorphic helpers
			  // since they are just generating DOM strings.
			  DOM: ReactDOMFactories,
	
			  version: ReactVersion,
	
			  // Deprecated hook for JSX spread, don't use this for anything.
			  __spread: __spread
			};
	
			// TODO: Fix tests so that this deprecation warning doesn't cause failures.
			if (process.env.NODE_ENV !== 'production') {
			  if (canDefineProperty) {
			    Object.defineProperty(React, 'PropTypes', {
			      get: function () {
			        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
			        didWarnPropTypesDeprecated = true;
			        return ReactPropTypes;
			      }
			    });
			  }
			}
	
			module.exports = React;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 99 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var PooledClass = __webpack_require__(100);
			var ReactElement = __webpack_require__(101);
	
			var emptyFunction = __webpack_require__(46);
			var traverseAllChildren = __webpack_require__(104);
	
			var twoArgumentPooler = PooledClass.twoArgumentPooler;
			var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
			var userProvidedKeyEscapeRegex = /\/+/g;
			function escapeUserProvidedKey(text) {
			  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
			}
	
			/**
			 * PooledClass representing the bookkeeping associated with performing a child
			 * traversal. Allows avoiding binding callbacks.
			 *
			 * @constructor ForEachBookKeeping
			 * @param {!function} forEachFunction Function to perform traversal with.
			 * @param {?*} forEachContext Context to perform context with.
			 */
			function ForEachBookKeeping(forEachFunction, forEachContext) {
			  this.func = forEachFunction;
			  this.context = forEachContext;
			  this.count = 0;
			}
			ForEachBookKeeping.prototype.destructor = function () {
			  this.func = null;
			  this.context = null;
			  this.count = 0;
			};
			PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
			function forEachSingleChild(bookKeeping, child, name) {
			  var func = bookKeeping.func,
			      context = bookKeeping.context;
	
			  func.call(context, child, bookKeeping.count++);
			}
	
			/**
			 * Iterates through children that are typically specified as `props.children`.
			 *
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
			 *
			 * The provided forEachFunc(child, index) will be called for each
			 * leaf child.
			 *
			 * @param {?*} children Children tree container.
			 * @param {function(*, int)} forEachFunc
			 * @param {*} forEachContext Context for forEachContext.
			 */
			function forEachChildren(children, forEachFunc, forEachContext) {
			  if (children == null) {
			    return children;
			  }
			  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
			  traverseAllChildren(children, forEachSingleChild, traverseContext);
			  ForEachBookKeeping.release(traverseContext);
			}
	
			/**
			 * PooledClass representing the bookkeeping associated with performing a child
			 * mapping. Allows avoiding binding callbacks.
			 *
			 * @constructor MapBookKeeping
			 * @param {!*} mapResult Object containing the ordered map of results.
			 * @param {!function} mapFunction Function to perform mapping with.
			 * @param {?*} mapContext Context to perform mapping with.
			 */
			function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
			  this.result = mapResult;
			  this.keyPrefix = keyPrefix;
			  this.func = mapFunction;
			  this.context = mapContext;
			  this.count = 0;
			}
			MapBookKeeping.prototype.destructor = function () {
			  this.result = null;
			  this.keyPrefix = null;
			  this.func = null;
			  this.context = null;
			  this.count = 0;
			};
			PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
			function mapSingleChildIntoContext(bookKeeping, child, childKey) {
			  var result = bookKeeping.result,
			      keyPrefix = bookKeeping.keyPrefix,
			      func = bookKeeping.func,
			      context = bookKeeping.context;
	
	
			  var mappedChild = func.call(context, child, bookKeeping.count++);
			  if (Array.isArray(mappedChild)) {
			    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
			  } else if (mappedChild != null) {
			    if (ReactElement.isValidElement(mappedChild)) {
			      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
			      // Keep both the (mapped) and old keys if they differ, just as
			      // traverseAllChildren used to do for objects as children
			      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
			    }
			    result.push(mappedChild);
			  }
			}
	
			function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
			  var escapedPrefix = '';
			  if (prefix != null) {
			    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
			  }
			  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
			  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
			  MapBookKeeping.release(traverseContext);
			}
	
			/**
			 * Maps children that are typically specified as `props.children`.
			 *
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
			 *
			 * The provided mapFunction(child, key, index) will be called for each
			 * leaf child.
			 *
			 * @param {?*} children Children tree container.
			 * @param {function(*, int)} func The map function.
			 * @param {*} context Context for mapFunction.
			 * @return {object} Object containing the ordered map of results.
			 */
			function mapChildren(children, func, context) {
			  if (children == null) {
			    return children;
			  }
			  var result = [];
			  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
			  return result;
			}
	
			function forEachSingleChildDummy(traverseContext, child, name) {
			  return null;
			}
	
			/**
			 * Count the number of children that are typically specified as
			 * `props.children`.
			 *
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
			 *
			 * @param {?*} children Children tree container.
			 * @return {number} The number of children.
			 */
			function countChildren(children, context) {
			  return traverseAllChildren(children, forEachSingleChildDummy, null);
			}
	
			/**
			 * Flatten a children object (typically specified as `props.children`) and
			 * return an array with appropriately re-keyed children.
			 *
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
			 */
			function toArray(children) {
			  var result = [];
			  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
			  return result;
			}
	
			var ReactChildren = {
			  forEach: forEachChildren,
			  map: mapChildren,
			  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
			  count: countChildren,
			  toArray: toArray
			};
	
			module.exports = ReactChildren;
	
		/***/ },
		/* 100 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(42);
	
			var invariant = __webpack_require__(44);
	
			/**
			 * Static poolers. Several custom versions for each potential number of
			 * arguments. A completely generic pooler is easy to implement, but would
			 * require accessing the `arguments` object. In each of these, `this` refers to
			 * the Class itself, not an instance. If any others are needed, simply add them
			 * here, or in their own files.
			 */
			var oneArgumentPooler = function (copyFieldsFrom) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, copyFieldsFrom);
			    return instance;
			  } else {
			    return new Klass(copyFieldsFrom);
			  }
			};
	
			var twoArgumentPooler = function (a1, a2) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, a1, a2);
			    return instance;
			  } else {
			    return new Klass(a1, a2);
			  }
			};
	
			var threeArgumentPooler = function (a1, a2, a3) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, a1, a2, a3);
			    return instance;
			  } else {
			    return new Klass(a1, a2, a3);
			  }
			};
	
			var fourArgumentPooler = function (a1, a2, a3, a4) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, a1, a2, a3, a4);
			    return instance;
			  } else {
			    return new Klass(a1, a2, a3, a4);
			  }
			};
	
			var standardReleaser = function (instance) {
			  var Klass = this;
			  !(instance instanceof Klass) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
			  instance.destructor();
			  if (Klass.instancePool.length < Klass.poolSize) {
			    Klass.instancePool.push(instance);
			  }
			};
	
			var DEFAULT_POOL_SIZE = 10;
			var DEFAULT_POOLER = oneArgumentPooler;
	
			/**
			 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
			 * itself (statically) not adding any prototypical fields. Any CopyConstructor
			 * you give this may have a `poolSize` property, and will look for a
			 * prototypical `destructor` on instances.
			 *
			 * @param {Function} CopyConstructor Constructor that can be used to reset.
			 * @param {Function} pooler Customizable pooler.
			 */
			var addPoolingTo = function (CopyConstructor, pooler) {
			  // Casting as any so that flow ignores the actual implementation and trusts
			  // it to match the type we declared
			  var NewKlass = CopyConstructor;
			  NewKlass.instancePool = [];
			  NewKlass.getPooled = pooler || DEFAULT_POOLER;
			  if (!NewKlass.poolSize) {
			    NewKlass.poolSize = DEFAULT_POOL_SIZE;
			  }
			  NewKlass.release = standardReleaser;
			  return NewKlass;
			};
	
			var PooledClass = {
			  addPoolingTo: addPoolingTo,
			  oneArgumentPooler: oneArgumentPooler,
			  twoArgumentPooler: twoArgumentPooler,
			  threeArgumentPooler: threeArgumentPooler,
			  fourArgumentPooler: fourArgumentPooler
			};
	
			module.exports = PooledClass;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 101 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var ReactCurrentOwner = __webpack_require__(43);
	
			var warning = __webpack_require__(45);
			var canDefineProperty = __webpack_require__(102);
			var hasOwnProperty = Object.prototype.hasOwnProperty;
	
			var REACT_ELEMENT_TYPE = __webpack_require__(103);
	
			var RESERVED_PROPS = {
			  key: true,
			  ref: true,
			  __self: true,
			  __source: true
			};
	
			var specialPropKeyWarningShown, specialPropRefWarningShown;
	
			function hasValidRef(config) {
			  if (process.env.NODE_ENV !== 'production') {
			    if (hasOwnProperty.call(config, 'ref')) {
			      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
			      if (getter && getter.isReactWarning) {
			        return false;
			      }
			    }
			  }
			  return config.ref !== undefined;
			}
	
			function hasValidKey(config) {
			  if (process.env.NODE_ENV !== 'production') {
			    if (hasOwnProperty.call(config, 'key')) {
			      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
			      if (getter && getter.isReactWarning) {
			        return false;
			      }
			    }
			  }
			  return config.key !== undefined;
			}
	
			function defineKeyPropWarningGetter(props, displayName) {
			  var warnAboutAccessingKey = function () {
			    if (!specialPropKeyWarningShown) {
			      specialPropKeyWarningShown = true;
			      process.env.NODE_ENV !== 'production' ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
			    }
			  };
			  warnAboutAccessingKey.isReactWarning = true;
			  Object.defineProperty(props, 'key', {
			    get: warnAboutAccessingKey,
			    configurable: true
			  });
			}
	
			function defineRefPropWarningGetter(props, displayName) {
			  var warnAboutAccessingRef = function () {
			    if (!specialPropRefWarningShown) {
			      specialPropRefWarningShown = true;
			      process.env.NODE_ENV !== 'production' ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
			    }
			  };
			  warnAboutAccessingRef.isReactWarning = true;
			  Object.defineProperty(props, 'ref', {
			    get: warnAboutAccessingRef,
			    configurable: true
			  });
			}
	
			/**
			 * Factory method to create a new React element. This no longer adheres to
			 * the class pattern, so do not use new to call it. Also, no instanceof check
			 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
			 * if something is a React Element.
			 *
			 * @param {*} type
			 * @param {*} key
			 * @param {string|object} ref
			 * @param {*} self A *temporary* helper to detect places where `this` is
			 * different from the `owner` when React.createElement is called, so that we
			 * can warn. We want to get rid of owner and replace string `ref`s with arrow
			 * functions, and as long as `this` and owner are the same, there will be no
			 * change in behavior.
			 * @param {*} source An annotation object (added by a transpiler or otherwise)
			 * indicating filename, line number, and/or other information.
			 * @param {*} owner
			 * @param {*} props
			 * @internal
			 */
			var ReactElement = function (type, key, ref, self, source, owner, props) {
			  var element = {
			    // This tag allow us to uniquely identify this as a React Element
			    $$typeof: REACT_ELEMENT_TYPE,
	
			    // Built-in properties that belong on the element
			    type: type,
			    key: key,
			    ref: ref,
			    props: props,
	
			    // Record the component responsible for creating this element.
			    _owner: owner
			  };
	
			  if (process.env.NODE_ENV !== 'production') {
			    // The validation flag is currently mutative. We put it on
			    // an external backing store so that we can freeze the whole object.
			    // This can be replaced with a WeakMap once they are implemented in
			    // commonly used development environments.
			    element._store = {};
	
			    // To make comparing ReactElements easier for testing purposes, we make
			    // the validation flag non-enumerable (where possible, which should
			    // include every environment we run tests in), so the test framework
			    // ignores it.
			    if (canDefineProperty) {
			      Object.defineProperty(element._store, 'validated', {
			        configurable: false,
			        enumerable: false,
			        writable: true,
			        value: false
			      });
			      // self and source are DEV only properties.
			      Object.defineProperty(element, '_self', {
			        configurable: false,
			        enumerable: false,
			        writable: false,
			        value: self
			      });
			      // Two elements created in two different places should be considered
			      // equal for testing purposes and therefore we hide it from enumeration.
			      Object.defineProperty(element, '_source', {
			        configurable: false,
			        enumerable: false,
			        writable: false,
			        value: source
			      });
			    } else {
			      element._store.validated = false;
			      element._self = self;
			      element._source = source;
			    }
			    if (Object.freeze) {
			      Object.freeze(element.props);
			      Object.freeze(element);
			    }
			  }
	
			  return element;
			};
	
			/**
			 * Create and return a new ReactElement of the given type.
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
			 */
			ReactElement.createElement = function (type, config, children) {
			  var propName;
	
			  // Reserved names are extracted
			  var props = {};
	
			  var key = null;
			  var ref = null;
			  var self = null;
			  var source = null;
	
			  if (config != null) {
			    if (hasValidRef(config)) {
			      ref = config.ref;
			    }
			    if (hasValidKey(config)) {
			      key = '' + config.key;
			    }
	
			    self = config.__self === undefined ? null : config.__self;
			    source = config.__source === undefined ? null : config.__source;
			    // Remaining properties are added to a new props object
			    for (propName in config) {
			      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
			        props[propName] = config[propName];
			      }
			    }
			  }
	
			  // Children can be more than one argument, and those are transferred onto
			  // the newly allocated props object.
			  var childrenLength = arguments.length - 2;
			  if (childrenLength === 1) {
			    props.children = children;
			  } else if (childrenLength > 1) {
			    var childArray = Array(childrenLength);
			    for (var i = 0; i < childrenLength; i++) {
			      childArray[i] = arguments[i + 2];
			    }
			    if (process.env.NODE_ENV !== 'production') {
			      if (Object.freeze) {
			        Object.freeze(childArray);
			      }
			    }
			    props.children = childArray;
			  }
	
			  // Resolve default props
			  if (type && type.defaultProps) {
			    var defaultProps = type.defaultProps;
			    for (propName in defaultProps) {
			      if (props[propName] === undefined) {
			        props[propName] = defaultProps[propName];
			      }
			    }
			  }
			  if (process.env.NODE_ENV !== 'production') {
			    if (key || ref) {
			      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
			        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
			        if (key) {
			          defineKeyPropWarningGetter(props, displayName);
			        }
			        if (ref) {
			          defineRefPropWarningGetter(props, displayName);
			        }
			      }
			    }
			  }
			  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
			};
	
			/**
			 * Return a function that produces ReactElements of a given type.
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
			 */
			ReactElement.createFactory = function (type) {
			  var factory = ReactElement.createElement.bind(null, type);
			  // Expose the type on the factory and the prototype so that it can be
			  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
			  // This should not be named `constructor` since this may not be the function
			  // that created the element, and it may not even be a constructor.
			  // Legacy hook TODO: Warn if this is accessed
			  factory.type = type;
			  return factory;
			};
	
			ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
			  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
			  return newElement;
			};
	
			/**
			 * Clone and return a new ReactElement using element as the starting point.
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
			 */
			ReactElement.cloneElement = function (element, config, children) {
			  var propName;
	
			  // Original props are copied
			  var props = _assign({}, element.props);
	
			  // Reserved names are extracted
			  var key = element.key;
			  var ref = element.ref;
			  // Self is preserved since the owner is preserved.
			  var self = element._self;
			  // Source is preserved since cloneElement is unlikely to be targeted by a
			  // transpiler, and the original source is probably a better indicator of the
			  // true owner.
			  var source = element._source;
	
			  // Owner will be preserved, unless ref is overridden
			  var owner = element._owner;
	
			  if (config != null) {
			    if (hasValidRef(config)) {
			      // Silently steal the ref from the parent.
			      ref = config.ref;
			      owner = ReactCurrentOwner.current;
			    }
			    if (hasValidKey(config)) {
			      key = '' + config.key;
			    }
	
			    // Remaining properties override existing props
			    var defaultProps;
			    if (element.type && element.type.defaultProps) {
			      defaultProps = element.type.defaultProps;
			    }
			    for (propName in config) {
			      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
			        if (config[propName] === undefined && defaultProps !== undefined) {
			          // Resolve default props
			          props[propName] = defaultProps[propName];
			        } else {
			          props[propName] = config[propName];
			        }
			      }
			    }
			  }
	
			  // Children can be more than one argument, and those are transferred onto
			  // the newly allocated props object.
			  var childrenLength = arguments.length - 2;
			  if (childrenLength === 1) {
			    props.children = children;
			  } else if (childrenLength > 1) {
			    var childArray = Array(childrenLength);
			    for (var i = 0; i < childrenLength; i++) {
			      childArray[i] = arguments[i + 2];
			    }
			    props.children = childArray;
			  }
	
			  return ReactElement(element.type, key, ref, self, source, owner, props);
			};
	
			/**
			 * Verifies the object is a ReactElement.
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
			 * @param {?object} object
			 * @return {boolean} True if `object` is a valid component.
			 * @final
			 */
			ReactElement.isValidElement = function (object) {
			  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
			};
	
			module.exports = ReactElement;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 102 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var canDefineProperty = false;
			if (process.env.NODE_ENV !== 'production') {
			  try {
			    // $FlowFixMe https://github.com/facebook/flow/issues/285
			    Object.defineProperty({}, 'x', { get: function () {} });
			    canDefineProperty = true;
			  } catch (x) {
			    // IE will fail on defineProperty
			  }
			}
	
			module.exports = canDefineProperty;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 103 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			// The Symbol used to tag the ReactElement type. If there is no native Symbol
			// nor polyfill, then a plain number is used for performance.
	
			var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
			module.exports = REACT_ELEMENT_TYPE;
	
		/***/ },
		/* 104 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(42);
	
			var ReactCurrentOwner = __webpack_require__(43);
			var REACT_ELEMENT_TYPE = __webpack_require__(103);
	
			var getIteratorFn = __webpack_require__(105);
			var invariant = __webpack_require__(44);
			var KeyEscapeUtils = __webpack_require__(106);
			var warning = __webpack_require__(45);
	
			var SEPARATOR = '.';
			var SUBSEPARATOR = ':';
	
			/**
			 * This is inlined from ReactElement since this file is shared between
			 * isomorphic and renderers. We could extract this to a
			 *
			 */
	
			/**
			 * TODO: Test that a single child and an array with one item have the same key
			 * pattern.
			 */
	
			var didWarnAboutMaps = false;
	
			/**
			 * Generate a key string that identifies a component within a set.
			 *
			 * @param {*} component A component that could contain a manual key.
			 * @param {number} index Index that is used if a manual key is not provided.
			 * @return {string}
			 */
			function getComponentKey(component, index) {
			  // Do some typechecking here since we call this blindly. We want to ensure
			  // that we don't block potential future ES APIs.
			  if (component && typeof component === 'object' && component.key != null) {
			    // Explicit key
			    return KeyEscapeUtils.escape(component.key);
			  }
			  // Implicit key determined by the index in the set
			  return index.toString(36);
			}
	
			/**
			 * @param {?*} children Children tree container.
			 * @param {!string} nameSoFar Name of the key path so far.
			 * @param {!function} callback Callback to invoke with each child found.
			 * @param {?*} traverseContext Used to pass information throughout the traversal
			 * process.
			 * @return {!number} The number of children in this subtree.
			 */
			function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
			  var type = typeof children;
	
			  if (type === 'undefined' || type === 'boolean') {
			    // All of the above are perceived as null.
			    children = null;
			  }
	
			  if (children === null || type === 'string' || type === 'number' ||
			  // The following is inlined from ReactElement. This means we can optimize
			  // some checks. React Fiber also inlines this logic for similar purposes.
			  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
			    callback(traverseContext, children,
			    // If it's the only child, treat the name as if it was wrapped in an array
			    // so that it's consistent if the number of children grows.
			    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
			    return 1;
			  }
	
			  var child;
			  var nextName;
			  var subtreeCount = 0; // Count of children found in the current subtree.
			  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
			  if (Array.isArray(children)) {
			    for (var i = 0; i < children.length; i++) {
			      child = children[i];
			      nextName = nextNamePrefix + getComponentKey(child, i);
			      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
			    }
			  } else {
			    var iteratorFn = getIteratorFn(children);
			    if (iteratorFn) {
			      var iterator = iteratorFn.call(children);
			      var step;
			      if (iteratorFn !== children.entries) {
			        var ii = 0;
			        while (!(step = iterator.next()).done) {
			          child = step.value;
			          nextName = nextNamePrefix + getComponentKey(child, ii++);
			          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
			        }
			      } else {
			        if (process.env.NODE_ENV !== 'production') {
			          var mapsAsChildrenAddendum = '';
			          if (ReactCurrentOwner.current) {
			            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
			            if (mapsAsChildrenOwnerName) {
			              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
			            }
			          }
			          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
			          didWarnAboutMaps = true;
			        }
			        // Iterator will provide entry [k,v] tuples rather than values.
			        while (!(step = iterator.next()).done) {
			          var entry = step.value;
			          if (entry) {
			            child = entry[1];
			            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
			            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
			          }
			        }
			      }
			    } else if (type === 'object') {
			      var addendum = '';
			      if (process.env.NODE_ENV !== 'production') {
			        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
			        if (children._isReactElement) {
			          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
			        }
			        if (ReactCurrentOwner.current) {
			          var name = ReactCurrentOwner.current.getName();
			          if (name) {
			            addendum += ' Check the render method of `' + name + '`.';
			          }
			        }
			      }
			      var childrenString = String(children);
			       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
			    }
			  }
	
			  return subtreeCount;
			}
	
			/**
			 * Traverses children that are typically specified as `props.children`, but
			 * might also be specified through attributes:
			 *
			 * - `traverseAllChildren(this.props.children, ...)`
			 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
			 *
			 * The `traverseContext` is an optional argument that is passed through the
			 * entire traversal. It can be used to store accumulations or anything else that
			 * the callback might find relevant.
			 *
			 * @param {?*} children Children tree object.
			 * @param {!function} callback To invoke upon traversing each child.
			 * @param {?*} traverseContext Context for traversal.
			 * @return {!number} The number of children in this subtree.
			 */
			function traverseAllChildren(children, callback, traverseContext) {
			  if (children == null) {
			    return 0;
			  }
	
			  return traverseAllChildrenImpl(children, '', callback, traverseContext);
			}
	
			module.exports = traverseAllChildren;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 105 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			/* global Symbol */
	
			var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
			var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
			/**
			 * Returns the iterator method function contained on the iterable object.
			 *
			 * Be sure to invoke the function with the iterable as context:
			 *
			 *     var iteratorFn = getIteratorFn(myIterable);
			 *     if (iteratorFn) {
			 *       var iterator = iteratorFn.call(myIterable);
			 *       ...
			 *     }
			 *
			 * @param {?object} maybeIterable
			 * @return {?function}
			 */
			function getIteratorFn(maybeIterable) {
			  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
			  if (typeof iteratorFn === 'function') {
			    return iteratorFn;
			  }
			}
	
			module.exports = getIteratorFn;
	
		/***/ },
		/* 106 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			/**
			 * Escape and wrap key so it is safe to use as a reactid
			 *
			 * @param {string} key to be escaped.
			 * @return {string} the escaped key.
			 */
	
			function escape(key) {
			  var escapeRegex = /[=:]/g;
			  var escaperLookup = {
			    '=': '=0',
			    ':': '=2'
			  };
			  var escapedString = ('' + key).replace(escapeRegex, function (match) {
			    return escaperLookup[match];
			  });
	
			  return '$' + escapedString;
			}
	
			/**
			 * Unescape and unwrap key for human-readable display
			 *
			 * @param {string} key to unescape.
			 * @return {string} the unescaped key.
			 */
			function unescape(key) {
			  var unescapeRegex = /(=0|=2)/g;
			  var unescaperLookup = {
			    '=0': '=',
			    '=2': ':'
			  };
			  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
			  return ('' + keySubstring).replace(unescapeRegex, function (match) {
			    return unescaperLookup[match];
			  });
			}
	
			var KeyEscapeUtils = {
			  escape: escape,
			  unescape: unescape
			};
	
			module.exports = KeyEscapeUtils;
	
		/***/ },
		/* 107 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(42);
	
			var ReactNoopUpdateQueue = __webpack_require__(108);
	
			var canDefineProperty = __webpack_require__(102);
			var emptyObject = __webpack_require__(109);
			var invariant = __webpack_require__(44);
			var warning = __webpack_require__(45);
	
			/**
			 * Base class helpers for the updating state of a component.
			 */
			function ReactComponent(props, context, updater) {
			  this.props = props;
			  this.context = context;
			  this.refs = emptyObject;
			  // We initialize the default updater but the real one gets injected by the
			  // renderer.
			  this.updater = updater || ReactNoopUpdateQueue;
			}
	
			ReactComponent.prototype.isReactComponent = {};
	
			/**
			 * Sets a subset of the state. Always use this to mutate
			 * state. You should treat `this.state` as immutable.
			 *
			 * There is no guarantee that `this.state` will be immediately updated, so
			 * accessing `this.state` after calling this method may return the old value.
			 *
			 * There is no guarantee that calls to `setState` will run synchronously,
			 * as they may eventually be batched together.  You can provide an optional
			 * callback that will be executed when the call to setState is actually
			 * completed.
			 *
			 * When a function is provided to setState, it will be called at some point in
			 * the future (not synchronously). It will be called with the up to date
			 * component arguments (state, props, context). These values can be different
			 * from this.* because your function may be called after receiveProps but before
			 * shouldComponentUpdate, and this new state, props, and context will not yet be
			 * assigned to this.
			 *
			 * @param {object|function} partialState Next partial state or function to
			 *        produce next partial state to be merged with current state.
			 * @param {?function} callback Called after state is updated.
			 * @final
			 * @protected
			 */
			ReactComponent.prototype.setState = function (partialState, callback) {
			  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
			  this.updater.enqueueSetState(this, partialState);
			  if (callback) {
			    this.updater.enqueueCallback(this, callback, 'setState');
			  }
			};
	
			/**
			 * Forces an update. This should only be invoked when it is known with
			 * certainty that we are **not** in a DOM transaction.
			 *
			 * You may want to call this when you know that some deeper aspect of the
			 * component's state has changed but `setState` was not called.
			 *
			 * This will not invoke `shouldComponentUpdate`, but it will invoke
			 * `componentWillUpdate` and `componentDidUpdate`.
			 *
			 * @param {?function} callback Called after update is complete.
			 * @final
			 * @protected
			 */
			ReactComponent.prototype.forceUpdate = function (callback) {
			  this.updater.enqueueForceUpdate(this);
			  if (callback) {
			    this.updater.enqueueCallback(this, callback, 'forceUpdate');
			  }
			};
	
			/**
			 * Deprecated APIs. These APIs used to exist on classic React classes but since
			 * we would like to deprecate them, we're not going to move them over to this
			 * modern base class. Instead, we define a getter that warns if it's accessed.
			 */
			if (process.env.NODE_ENV !== 'production') {
			  var deprecatedAPIs = {
			    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
			    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
			  };
			  var defineDeprecationWarning = function (methodName, info) {
			    if (canDefineProperty) {
			      Object.defineProperty(ReactComponent.prototype, methodName, {
			        get: function () {
			          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
			          return undefined;
			        }
			      });
			    }
			  };
			  for (var fnName in deprecatedAPIs) {
			    if (deprecatedAPIs.hasOwnProperty(fnName)) {
			      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
			    }
			  }
			}
	
			module.exports = ReactComponent;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 108 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2015-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var warning = __webpack_require__(45);
	
			function warnNoop(publicInstance, callerName) {
			  if (process.env.NODE_ENV !== 'production') {
			    var constructor = publicInstance.constructor;
			    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
			  }
			}
	
			/**
			 * This is the abstract API for an update queue.
			 */
			var ReactNoopUpdateQueue = {
	
			  /**
			   * Checks whether or not this composite component is mounted.
			   * @param {ReactClass} publicInstance The instance we want to test.
			   * @return {boolean} True if mounted, false otherwise.
			   * @protected
			   * @final
			   */
			  isMounted: function (publicInstance) {
			    return false;
			  },
	
			  /**
			   * Enqueue a callback that will be executed after all the pending updates
			   * have processed.
			   *
			   * @param {ReactClass} publicInstance The instance to use as `this` context.
			   * @param {?function} callback Called after state is updated.
			   * @internal
			   */
			  enqueueCallback: function (publicInstance, callback) {},
	
			  /**
			   * Forces an update. This should only be invoked when it is known with
			   * certainty that we are **not** in a DOM transaction.
			   *
			   * You may want to call this when you know that some deeper aspect of the
			   * component's state has changed but `setState` was not called.
			   *
			   * This will not invoke `shouldComponentUpdate`, but it will invoke
			   * `componentWillUpdate` and `componentDidUpdate`.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @internal
			   */
			  enqueueForceUpdate: function (publicInstance) {
			    warnNoop(publicInstance, 'forceUpdate');
			  },
	
			  /**
			   * Replaces all of the state. Always use this or `setState` to mutate state.
			   * You should treat `this.state` as immutable.
			   *
			   * There is no guarantee that `this.state` will be immediately updated, so
			   * accessing `this.state` after calling this method may return the old value.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @param {object} completeState Next state.
			   * @internal
			   */
			  enqueueReplaceState: function (publicInstance, completeState) {
			    warnNoop(publicInstance, 'replaceState');
			  },
	
			  /**
			   * Sets a subset of the state. This only exists because _pendingState is
			   * internal. This provides a merging strategy that is not available to deep
			   * properties which is confusing. TODO: Expose pendingState or don't use it
			   * during the merge.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @param {object} partialState Next partial state to be merged with state.
			   * @internal
			   */
			  enqueueSetState: function (publicInstance, partialState) {
			    warnNoop(publicInstance, 'setState');
			  }
			};
	
			module.exports = ReactNoopUpdateQueue;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 109 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var emptyObject = {};
	
			if (process.env.NODE_ENV !== 'production') {
			  Object.freeze(emptyObject);
			}
	
			module.exports = emptyObject;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 110 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var ReactComponent = __webpack_require__(107);
			var ReactNoopUpdateQueue = __webpack_require__(108);
	
			var emptyObject = __webpack_require__(109);
	
			/**
			 * Base class helpers for the updating state of a component.
			 */
			function ReactPureComponent(props, context, updater) {
			  // Duplicated from ReactComponent.
			  this.props = props;
			  this.context = context;
			  this.refs = emptyObject;
			  // We initialize the default updater but the real one gets injected by the
			  // renderer.
			  this.updater = updater || ReactNoopUpdateQueue;
			}
	
			function ComponentDummy() {}
			ComponentDummy.prototype = ReactComponent.prototype;
			ReactPureComponent.prototype = new ComponentDummy();
			ReactPureComponent.prototype.constructor = ReactPureComponent;
			// Avoid an extra prototype jump for these methods.
			_assign(ReactPureComponent.prototype, ReactComponent.prototype);
			ReactPureComponent.prototype.isPureReactComponent = true;
	
			module.exports = ReactPureComponent;
	
		/***/ },
		/* 111 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(42),
			    _assign = __webpack_require__(24);
	
			var ReactComponent = __webpack_require__(107);
			var ReactElement = __webpack_require__(101);
			var ReactPropTypeLocationNames = __webpack_require__(112);
			var ReactNoopUpdateQueue = __webpack_require__(108);
	
			var emptyObject = __webpack_require__(109);
			var invariant = __webpack_require__(44);
			var warning = __webpack_require__(45);
	
			var MIXINS_KEY = 'mixins';
	
			// Helper function to allow the creation of anonymous functions which do not
			// have .name set to the name of the variable being assigned to.
			function identity(fn) {
			  return fn;
			}
	
			/**
			 * Policies that describe methods in `ReactClassInterface`.
			 */
	
	
			var injectedMixins = [];
	
			/**
			 * Composite components are higher-level components that compose other composite
			 * or host components.
			 *
			 * To create a new type of `ReactClass`, pass a specification of
			 * your new class to `React.createClass`. The only requirement of your class
			 * specification is that you implement a `render` method.
			 *
			 *   var MyComponent = React.createClass({
			 *     render: function() {
			 *       return <div>Hello World</div>;
			 *     }
			 *   });
			 *
			 * The class specification supports a specific protocol of methods that have
			 * special meaning (e.g. `render`). See `ReactClassInterface` for
			 * more the comprehensive protocol. Any other properties and methods in the
			 * class specification will be available on the prototype.
			 *
			 * @interface ReactClassInterface
			 * @internal
			 */
			var ReactClassInterface = {
	
			  /**
			   * An array of Mixin objects to include when defining your component.
			   *
			   * @type {array}
			   * @optional
			   */
			  mixins: 'DEFINE_MANY',
	
			  /**
			   * An object containing properties and methods that should be defined on
			   * the component's constructor instead of its prototype (static methods).
			   *
			   * @type {object}
			   * @optional
			   */
			  statics: 'DEFINE_MANY',
	
			  /**
			   * Definition of prop types for this component.
			   *
			   * @type {object}
			   * @optional
			   */
			  propTypes: 'DEFINE_MANY',
	
			  /**
			   * Definition of context types for this component.
			   *
			   * @type {object}
			   * @optional
			   */
			  contextTypes: 'DEFINE_MANY',
	
			  /**
			   * Definition of context types this component sets for its children.
			   *
			   * @type {object}
			   * @optional
			   */
			  childContextTypes: 'DEFINE_MANY',
	
			  // ==== Definition methods ====
	
			  /**
			   * Invoked when the component is mounted. Values in the mapping will be set on
			   * `this.props` if that prop is not specified (i.e. using an `in` check).
			   *
			   * This method is invoked before `getInitialState` and therefore cannot rely
			   * on `this.state` or use `this.setState`.
			   *
			   * @return {object}
			   * @optional
			   */
			  getDefaultProps: 'DEFINE_MANY_MERGED',
	
			  /**
			   * Invoked once before the component is mounted. The return value will be used
			   * as the initial value of `this.state`.
			   *
			   *   getInitialState: function() {
			   *     return {
			   *       isOn: false,
			   *       fooBaz: new BazFoo()
			   *     }
			   *   }
			   *
			   * @return {object}
			   * @optional
			   */
			  getInitialState: 'DEFINE_MANY_MERGED',
	
			  /**
			   * @return {object}
			   * @optional
			   */
			  getChildContext: 'DEFINE_MANY_MERGED',
	
			  /**
			   * Uses props from `this.props` and state from `this.state` to render the
			   * structure of the component.
			   *
			   * No guarantees are made about when or how often this method is invoked, so
			   * it must not have side effects.
			   *
			   *   render: function() {
			   *     var name = this.props.name;
			   *     return <div>Hello, {name}!</div>;
			   *   }
			   *
			   * @return {ReactComponent}
			   * @required
			   */
			  render: 'DEFINE_ONCE',
	
			  // ==== Delegate methods ====
	
			  /**
			   * Invoked when the component is initially created and about to be mounted.
			   * This may have side effects, but any external subscriptions or data created
			   * by this method must be cleaned up in `componentWillUnmount`.
			   *
			   * @optional
			   */
			  componentWillMount: 'DEFINE_MANY',
	
			  /**
			   * Invoked when the component has been mounted and has a DOM representation.
			   * However, there is no guarantee that the DOM node is in the document.
			   *
			   * Use this as an opportunity to operate on the DOM when the component has
			   * been mounted (initialized and rendered) for the first time.
			   *
			   * @param {DOMElement} rootNode DOM element representing the component.
			   * @optional
			   */
			  componentDidMount: 'DEFINE_MANY',
	
			  /**
			   * Invoked before the component receives new props.
			   *
			   * Use this as an opportunity to react to a prop transition by updating the
			   * state using `this.setState`. Current props are accessed via `this.props`.
			   *
			   *   componentWillReceiveProps: function(nextProps, nextContext) {
			   *     this.setState({
			   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
			   *     });
			   *   }
			   *
			   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
			   * transition may cause a state change, but the opposite is not true. If you
			   * need it, you are probably looking for `componentWillUpdate`.
			   *
			   * @param {object} nextProps
			   * @optional
			   */
			  componentWillReceiveProps: 'DEFINE_MANY',
	
			  /**
			   * Invoked while deciding if the component should be updated as a result of
			   * receiving new props, state and/or context.
			   *
			   * Use this as an opportunity to `return false` when you're certain that the
			   * transition to the new props/state/context will not require a component
			   * update.
			   *
			   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
			   *     return !equal(nextProps, this.props) ||
			   *       !equal(nextState, this.state) ||
			   *       !equal(nextContext, this.context);
			   *   }
			   *
			   * @param {object} nextProps
			   * @param {?object} nextState
			   * @param {?object} nextContext
			   * @return {boolean} True if the component should update.
			   * @optional
			   */
			  shouldComponentUpdate: 'DEFINE_ONCE',
	
			  /**
			   * Invoked when the component is about to update due to a transition from
			   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
			   * and `nextContext`.
			   *
			   * Use this as an opportunity to perform preparation before an update occurs.
			   *
			   * NOTE: You **cannot** use `this.setState()` in this method.
			   *
			   * @param {object} nextProps
			   * @param {?object} nextState
			   * @param {?object} nextContext
			   * @param {ReactReconcileTransaction} transaction
			   * @optional
			   */
			  componentWillUpdate: 'DEFINE_MANY',
	
			  /**
			   * Invoked when the component's DOM representation has been updated.
			   *
			   * Use this as an opportunity to operate on the DOM when the component has
			   * been updated.
			   *
			   * @param {object} prevProps
			   * @param {?object} prevState
			   * @param {?object} prevContext
			   * @param {DOMElement} rootNode DOM element representing the component.
			   * @optional
			   */
			  componentDidUpdate: 'DEFINE_MANY',
	
			  /**
			   * Invoked when the component is about to be removed from its parent and have
			   * its DOM representation destroyed.
			   *
			   * Use this as an opportunity to deallocate any external resources.
			   *
			   * NOTE: There is no `componentDidUnmount` since your component will have been
			   * destroyed by that point.
			   *
			   * @optional
			   */
			  componentWillUnmount: 'DEFINE_MANY',
	
			  // ==== Advanced methods ====
	
			  /**
			   * Updates the component's currently mounted DOM representation.
			   *
			   * By default, this implements React's rendering and reconciliation algorithm.
			   * Sophisticated clients may wish to override this.
			   *
			   * @param {ReactReconcileTransaction} transaction
			   * @internal
			   * @overridable
			   */
			  updateComponent: 'OVERRIDE_BASE'
	
			};
	
			/**
			 * Mapping from class specification keys to special processing functions.
			 *
			 * Although these are declared like instance properties in the specification
			 * when defining classes using `React.createClass`, they are actually static
			 * and are accessible on the constructor instead of the prototype. Despite
			 * being static, they must be defined outside of the "statics" key under
			 * which all other static methods are defined.
			 */
			var RESERVED_SPEC_KEYS = {
			  displayName: function (Constructor, displayName) {
			    Constructor.displayName = displayName;
			  },
			  mixins: function (Constructor, mixins) {
			    if (mixins) {
			      for (var i = 0; i < mixins.length; i++) {
			        mixSpecIntoComponent(Constructor, mixins[i]);
			      }
			    }
			  },
			  childContextTypes: function (Constructor, childContextTypes) {
			    if (process.env.NODE_ENV !== 'production') {
			      validateTypeDef(Constructor, childContextTypes, 'childContext');
			    }
			    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
			  },
			  contextTypes: function (Constructor, contextTypes) {
			    if (process.env.NODE_ENV !== 'production') {
			      validateTypeDef(Constructor, contextTypes, 'context');
			    }
			    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
			  },
			  /**
			   * Special case getDefaultProps which should move into statics but requires
			   * automatic merging.
			   */
			  getDefaultProps: function (Constructor, getDefaultProps) {
			    if (Constructor.getDefaultProps) {
			      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
			    } else {
			      Constructor.getDefaultProps = getDefaultProps;
			    }
			  },
			  propTypes: function (Constructor, propTypes) {
			    if (process.env.NODE_ENV !== 'production') {
			      validateTypeDef(Constructor, propTypes, 'prop');
			    }
			    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
			  },
			  statics: function (Constructor, statics) {
			    mixStaticSpecIntoComponent(Constructor, statics);
			  },
			  autobind: function () {} };
	
			function validateTypeDef(Constructor, typeDef, location) {
			  for (var propName in typeDef) {
			    if (typeDef.hasOwnProperty(propName)) {
			      // use a warning instead of an invariant so components
			      // don't show up in prod but only in __DEV__
			      process.env.NODE_ENV !== 'production' ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
			    }
			  }
			}
	
			function validateMethodOverride(isAlreadyDefined, name) {
			  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
			  // Disallow overriding of base class methods unless explicitly allowed.
			  if (ReactClassMixin.hasOwnProperty(name)) {
			    !(specPolicy === 'OVERRIDE_BASE') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
			  }
	
			  // Disallow defining methods more than once unless explicitly allowed.
			  if (isAlreadyDefined) {
			    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
			  }
			}
	
			/**
			 * Mixin helper which handles policy validation and reserved
			 * specification keys when building React classes.
			 */
			function mixSpecIntoComponent(Constructor, spec) {
			  if (!spec) {
			    if (process.env.NODE_ENV !== 'production') {
			      var typeofSpec = typeof spec;
			      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
			      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
			    }
	
			    return;
			  }
	
			  !(typeof spec !== 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
			  !!ReactElement.isValidElement(spec) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
			  var proto = Constructor.prototype;
			  var autoBindPairs = proto.__reactAutoBindPairs;
	
			  // By handling mixins before any other properties, we ensure the same
			  // chaining order is applied to methods with DEFINE_MANY policy, whether
			  // mixins are listed before or after these methods in the spec.
			  if (spec.hasOwnProperty(MIXINS_KEY)) {
			    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
			  }
	
			  for (var name in spec) {
			    if (!spec.hasOwnProperty(name)) {
			      continue;
			    }
	
			    if (name === MIXINS_KEY) {
			      // We have already handled mixins in a special case above.
			      continue;
			    }
	
			    var property = spec[name];
			    var isAlreadyDefined = proto.hasOwnProperty(name);
			    validateMethodOverride(isAlreadyDefined, name);
	
			    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
			      RESERVED_SPEC_KEYS[name](Constructor, property);
			    } else {
			      // Setup methods on prototype:
			      // The following member methods should not be automatically bound:
			      // 1. Expected ReactClass methods (in the "interface").
			      // 2. Overridden methods (that were mixed in).
			      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
			      var isFunction = typeof property === 'function';
			      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
			      if (shouldAutoBind) {
			        autoBindPairs.push(name, property);
			        proto[name] = property;
			      } else {
			        if (isAlreadyDefined) {
			          var specPolicy = ReactClassInterface[name];
	
			          // These cases should already be caught by validateMethodOverride.
			          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
			          // For methods which are defined more than once, call the existing
			          // methods before calling the new property, merging if appropriate.
			          if (specPolicy === 'DEFINE_MANY_MERGED') {
			            proto[name] = createMergedResultFunction(proto[name], property);
			          } else if (specPolicy === 'DEFINE_MANY') {
			            proto[name] = createChainedFunction(proto[name], property);
			          }
			        } else {
			          proto[name] = property;
			          if (process.env.NODE_ENV !== 'production') {
			            // Add verbose displayName to the function, which helps when looking
			            // at profiling tools.
			            if (typeof property === 'function' && spec.displayName) {
			              proto[name].displayName = spec.displayName + '_' + name;
			            }
			          }
			        }
			      }
			    }
			  }
			}
	
			function mixStaticSpecIntoComponent(Constructor, statics) {
			  if (!statics) {
			    return;
			  }
			  for (var name in statics) {
			    var property = statics[name];
			    if (!statics.hasOwnProperty(name)) {
			      continue;
			    }
	
			    var isReserved = name in RESERVED_SPEC_KEYS;
			    !!isReserved ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
			    var isInherited = name in Constructor;
			    !!isInherited ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
			    Constructor[name] = property;
			  }
			}
	
			/**
			 * Merge two objects, but throw if both contain the same key.
			 *
			 * @param {object} one The first object, which is mutated.
			 * @param {object} two The second object
			 * @return {object} one after it has been mutated to contain everything in two.
			 */
			function mergeIntoWithNoDuplicateKeys(one, two) {
			  !(one && two && typeof one === 'object' && typeof two === 'object') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
			  for (var key in two) {
			    if (two.hasOwnProperty(key)) {
			      !(one[key] === undefined) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
			      one[key] = two[key];
			    }
			  }
			  return one;
			}
	
			/**
			 * Creates a function that invokes two functions and merges their return values.
			 *
			 * @param {function} one Function to invoke first.
			 * @param {function} two Function to invoke second.
			 * @return {function} Function that invokes the two argument functions.
			 * @private
			 */
			function createMergedResultFunction(one, two) {
			  return function mergedResult() {
			    var a = one.apply(this, arguments);
			    var b = two.apply(this, arguments);
			    if (a == null) {
			      return b;
			    } else if (b == null) {
			      return a;
			    }
			    var c = {};
			    mergeIntoWithNoDuplicateKeys(c, a);
			    mergeIntoWithNoDuplicateKeys(c, b);
			    return c;
			  };
			}
	
			/**
			 * Creates a function that invokes two functions and ignores their return vales.
			 *
			 * @param {function} one Function to invoke first.
			 * @param {function} two Function to invoke second.
			 * @return {function} Function that invokes the two argument functions.
			 * @private
			 */
			function createChainedFunction(one, two) {
			  return function chainedFunction() {
			    one.apply(this, arguments);
			    two.apply(this, arguments);
			  };
			}
	
			/**
			 * Binds a method to the component.
			 *
			 * @param {object} component Component whose method is going to be bound.
			 * @param {function} method Method to be bound.
			 * @return {function} The bound method.
			 */
			function bindAutoBindMethod(component, method) {
			  var boundMethod = method.bind(component);
			  if (process.env.NODE_ENV !== 'production') {
			    boundMethod.__reactBoundContext = component;
			    boundMethod.__reactBoundMethod = method;
			    boundMethod.__reactBoundArguments = null;
			    var componentName = component.constructor.displayName;
			    var _bind = boundMethod.bind;
			    boundMethod.bind = function (newThis) {
			      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			        args[_key - 1] = arguments[_key];
			      }
	
			      // User is trying to bind() an autobound method; we effectively will
			      // ignore the value of "this" that the user is trying to use, so
			      // let's warn.
			      if (newThis !== component && newThis !== null) {
			        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
			      } else if (!args.length) {
			        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
			        return boundMethod;
			      }
			      var reboundMethod = _bind.apply(boundMethod, arguments);
			      reboundMethod.__reactBoundContext = component;
			      reboundMethod.__reactBoundMethod = method;
			      reboundMethod.__reactBoundArguments = args;
			      return reboundMethod;
			    };
			  }
			  return boundMethod;
			}
	
			/**
			 * Binds all auto-bound methods in a component.
			 *
			 * @param {object} component Component whose method is going to be bound.
			 */
			function bindAutoBindMethods(component) {
			  var pairs = component.__reactAutoBindPairs;
			  for (var i = 0; i < pairs.length; i += 2) {
			    var autoBindKey = pairs[i];
			    var method = pairs[i + 1];
			    component[autoBindKey] = bindAutoBindMethod(component, method);
			  }
			}
	
			/**
			 * Add more to the ReactClass base class. These are all legacy features and
			 * therefore not already part of the modern ReactComponent.
			 */
			var ReactClassMixin = {
	
			  /**
			   * TODO: This will be deprecated because state should always keep a consistent
			   * type signature and the only use case for this, is to avoid that.
			   */
			  replaceState: function (newState, callback) {
			    this.updater.enqueueReplaceState(this, newState);
			    if (callback) {
			      this.updater.enqueueCallback(this, callback, 'replaceState');
			    }
			  },
	
			  /**
			   * Checks whether or not this composite component is mounted.
			   * @return {boolean} True if mounted, false otherwise.
			   * @protected
			   * @final
			   */
			  isMounted: function () {
			    return this.updater.isMounted(this);
			  }
			};
	
			var ReactClassComponent = function () {};
			_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
			var didWarnDeprecated = false;
	
			/**
			 * Module for creating composite components.
			 *
			 * @class ReactClass
			 */
			var ReactClass = {
	
			  /**
			   * Creates a composite component class given a class specification.
			   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
			   *
			   * @param {object} spec Class specification (which must define `render`).
			   * @return {function} Component constructor function.
			   * @public
			   */
			  createClass: function (spec) {
			    if (process.env.NODE_ENV !== 'production') {
			      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
			      didWarnDeprecated = true;
			    }
	
			    // To keep our warnings more understandable, we'll use a little hack here to
			    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
			    // unnecessarily identify a class without displayName as 'Constructor'.
			    var Constructor = identity(function (props, context, updater) {
			      // This constructor gets overridden by mocks. The argument is used
			      // by mocks to assert on what gets mounted.
	
			      if (process.env.NODE_ENV !== 'production') {
			        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
			      }
	
			      // Wire up auto-binding
			      if (this.__reactAutoBindPairs.length) {
			        bindAutoBindMethods(this);
			      }
	
			      this.props = props;
			      this.context = context;
			      this.refs = emptyObject;
			      this.updater = updater || ReactNoopUpdateQueue;
	
			      this.state = null;
	
			      // ReactClasses doesn't have constructors. Instead, they use the
			      // getInitialState and componentWillMount methods for initialization.
	
			      var initialState = this.getInitialState ? this.getInitialState() : null;
			      if (process.env.NODE_ENV !== 'production') {
			        // We allow auto-mocks to proceed as if they're returning null.
			        if (initialState === undefined && this.getInitialState._isMockFunction) {
			          // This is probably bad practice. Consider warning here and
			          // deprecating this convenience.
			          initialState = null;
			        }
			      }
			      !(typeof initialState === 'object' && !Array.isArray(initialState)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
			      this.state = initialState;
			    });
			    Constructor.prototype = new ReactClassComponent();
			    Constructor.prototype.constructor = Constructor;
			    Constructor.prototype.__reactAutoBindPairs = [];
	
			    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
			    mixSpecIntoComponent(Constructor, spec);
	
			    // Initialize the defaultProps property after all mixins have been merged.
			    if (Constructor.getDefaultProps) {
			      Constructor.defaultProps = Constructor.getDefaultProps();
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      // This is a tag to indicate that the use of these method names is ok,
			      // since it's used with createClass. If it's not, then it's likely a
			      // mistake so we'll warn you to use the static property, property
			      // initializer or constructor respectively.
			      if (Constructor.getDefaultProps) {
			        Constructor.getDefaultProps.isReactClassApproved = {};
			      }
			      if (Constructor.prototype.getInitialState) {
			        Constructor.prototype.getInitialState.isReactClassApproved = {};
			      }
			    }
	
			    !Constructor.prototype.render ? process.env.NODE_ENV !== 'production' ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
			    if (process.env.NODE_ENV !== 'production') {
			      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
			      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
			    }
	
			    // Reduce time spent doing lookups by setting these on the prototype.
			    for (var methodName in ReactClassInterface) {
			      if (!Constructor.prototype[methodName]) {
			        Constructor.prototype[methodName] = null;
			      }
			    }
	
			    return Constructor;
			  },
	
			  injection: {
			    injectMixin: function (mixin) {
			      injectedMixins.push(mixin);
			    }
			  }
	
			};
	
			module.exports = ReactClass;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 112 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var ReactPropTypeLocationNames = {};
	
			if (process.env.NODE_ENV !== 'production') {
			  ReactPropTypeLocationNames = {
			    prop: 'prop',
			    context: 'context',
			    childContext: 'child context'
			  };
			}
	
			module.exports = ReactPropTypeLocationNames;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 113 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactElement = __webpack_require__(101);
	
			/**
			 * Create a factory that creates HTML tag elements.
			 *
			 * @private
			 */
			var createDOMFactory = ReactElement.createFactory;
			if (process.env.NODE_ENV !== 'production') {
			  var ReactElementValidator = __webpack_require__(114);
			  createDOMFactory = ReactElementValidator.createFactory;
			}
	
			/**
			 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
			 * This is also accessible via `React.DOM`.
			 *
			 * @public
			 */
			var ReactDOMFactories = {
			  a: createDOMFactory('a'),
			  abbr: createDOMFactory('abbr'),
			  address: createDOMFactory('address'),
			  area: createDOMFactory('area'),
			  article: createDOMFactory('article'),
			  aside: createDOMFactory('aside'),
			  audio: createDOMFactory('audio'),
			  b: createDOMFactory('b'),
			  base: createDOMFactory('base'),
			  bdi: createDOMFactory('bdi'),
			  bdo: createDOMFactory('bdo'),
			  big: createDOMFactory('big'),
			  blockquote: createDOMFactory('blockquote'),
			  body: createDOMFactory('body'),
			  br: createDOMFactory('br'),
			  button: createDOMFactory('button'),
			  canvas: createDOMFactory('canvas'),
			  caption: createDOMFactory('caption'),
			  cite: createDOMFactory('cite'),
			  code: createDOMFactory('code'),
			  col: createDOMFactory('col'),
			  colgroup: createDOMFactory('colgroup'),
			  data: createDOMFactory('data'),
			  datalist: createDOMFactory('datalist'),
			  dd: createDOMFactory('dd'),
			  del: createDOMFactory('del'),
			  details: createDOMFactory('details'),
			  dfn: createDOMFactory('dfn'),
			  dialog: createDOMFactory('dialog'),
			  div: createDOMFactory('div'),
			  dl: createDOMFactory('dl'),
			  dt: createDOMFactory('dt'),
			  em: createDOMFactory('em'),
			  embed: createDOMFactory('embed'),
			  fieldset: createDOMFactory('fieldset'),
			  figcaption: createDOMFactory('figcaption'),
			  figure: createDOMFactory('figure'),
			  footer: createDOMFactory('footer'),
			  form: createDOMFactory('form'),
			  h1: createDOMFactory('h1'),
			  h2: createDOMFactory('h2'),
			  h3: createDOMFactory('h3'),
			  h4: createDOMFactory('h4'),
			  h5: createDOMFactory('h5'),
			  h6: createDOMFactory('h6'),
			  head: createDOMFactory('head'),
			  header: createDOMFactory('header'),
			  hgroup: createDOMFactory('hgroup'),
			  hr: createDOMFactory('hr'),
			  html: createDOMFactory('html'),
			  i: createDOMFactory('i'),
			  iframe: createDOMFactory('iframe'),
			  img: createDOMFactory('img'),
			  input: createDOMFactory('input'),
			  ins: createDOMFactory('ins'),
			  kbd: createDOMFactory('kbd'),
			  keygen: createDOMFactory('keygen'),
			  label: createDOMFactory('label'),
			  legend: createDOMFactory('legend'),
			  li: createDOMFactory('li'),
			  link: createDOMFactory('link'),
			  main: createDOMFactory('main'),
			  map: createDOMFactory('map'),
			  mark: createDOMFactory('mark'),
			  menu: createDOMFactory('menu'),
			  menuitem: createDOMFactory('menuitem'),
			  meta: createDOMFactory('meta'),
			  meter: createDOMFactory('meter'),
			  nav: createDOMFactory('nav'),
			  noscript: createDOMFactory('noscript'),
			  object: createDOMFactory('object'),
			  ol: createDOMFactory('ol'),
			  optgroup: createDOMFactory('optgroup'),
			  option: createDOMFactory('option'),
			  output: createDOMFactory('output'),
			  p: createDOMFactory('p'),
			  param: createDOMFactory('param'),
			  picture: createDOMFactory('picture'),
			  pre: createDOMFactory('pre'),
			  progress: createDOMFactory('progress'),
			  q: createDOMFactory('q'),
			  rp: createDOMFactory('rp'),
			  rt: createDOMFactory('rt'),
			  ruby: createDOMFactory('ruby'),
			  s: createDOMFactory('s'),
			  samp: createDOMFactory('samp'),
			  script: createDOMFactory('script'),
			  section: createDOMFactory('section'),
			  select: createDOMFactory('select'),
			  small: createDOMFactory('small'),
			  source: createDOMFactory('source'),
			  span: createDOMFactory('span'),
			  strong: createDOMFactory('strong'),
			  style: createDOMFactory('style'),
			  sub: createDOMFactory('sub'),
			  summary: createDOMFactory('summary'),
			  sup: createDOMFactory('sup'),
			  table: createDOMFactory('table'),
			  tbody: createDOMFactory('tbody'),
			  td: createDOMFactory('td'),
			  textarea: createDOMFactory('textarea'),
			  tfoot: createDOMFactory('tfoot'),
			  th: createDOMFactory('th'),
			  thead: createDOMFactory('thead'),
			  time: createDOMFactory('time'),
			  title: createDOMFactory('title'),
			  tr: createDOMFactory('tr'),
			  track: createDOMFactory('track'),
			  u: createDOMFactory('u'),
			  ul: createDOMFactory('ul'),
			  'var': createDOMFactory('var'),
			  video: createDOMFactory('video'),
			  wbr: createDOMFactory('wbr'),
	
			  // SVG
			  circle: createDOMFactory('circle'),
			  clipPath: createDOMFactory('clipPath'),
			  defs: createDOMFactory('defs'),
			  ellipse: createDOMFactory('ellipse'),
			  g: createDOMFactory('g'),
			  image: createDOMFactory('image'),
			  line: createDOMFactory('line'),
			  linearGradient: createDOMFactory('linearGradient'),
			  mask: createDOMFactory('mask'),
			  path: createDOMFactory('path'),
			  pattern: createDOMFactory('pattern'),
			  polygon: createDOMFactory('polygon'),
			  polyline: createDOMFactory('polyline'),
			  radialGradient: createDOMFactory('radialGradient'),
			  rect: createDOMFactory('rect'),
			  stop: createDOMFactory('stop'),
			  svg: createDOMFactory('svg'),
			  text: createDOMFactory('text'),
			  tspan: createDOMFactory('tspan')
			};
	
			module.exports = ReactDOMFactories;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 114 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			/**
			 * ReactElementValidator provides a wrapper around a element factory
			 * which validates the props passed to the element. This is intended to be
			 * used only in DEV and could be replaced by a static type checker for languages
			 * that support it.
			 */
	
			'use strict';
	
			var ReactCurrentOwner = __webpack_require__(43);
			var ReactComponentTreeHook = __webpack_require__(41);
			var ReactElement = __webpack_require__(101);
	
			var checkReactTypeSpec = __webpack_require__(115);
	
			var canDefineProperty = __webpack_require__(102);
			var getIteratorFn = __webpack_require__(105);
			var warning = __webpack_require__(45);
	
			function getDeclarationErrorAddendum() {
			  if (ReactCurrentOwner.current) {
			    var name = ReactCurrentOwner.current.getName();
			    if (name) {
			      return ' Check the render method of `' + name + '`.';
			    }
			  }
			  return '';
			}
	
			function getSourceInfoErrorAddendum(elementProps) {
			  if (elementProps !== null && elementProps !== undefined && elementProps.__source !== undefined) {
			    var source = elementProps.__source;
			    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
			    var lineNumber = source.lineNumber;
			    return ' Check your code at ' + fileName + ':' + lineNumber + '.';
			  }
			  return '';
			}
	
			/**
			 * Warn if there's no key explicitly set on dynamic arrays of children or
			 * object keys are not valid. This allows us to keep track of children between
			 * updates.
			 */
			var ownerHasKeyUseWarning = {};
	
			function getCurrentComponentErrorInfo(parentType) {
			  var info = getDeclarationErrorAddendum();
	
			  if (!info) {
			    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
			    if (parentName) {
			      info = ' Check the top-level render call using <' + parentName + '>.';
			    }
			  }
			  return info;
			}
	
			/**
			 * Warn if the element doesn't have an explicit key assigned to it.
			 * This element is in an array. The array could grow and shrink or be
			 * reordered. All children that haven't already been validated are required to
			 * have a "key" property assigned to it. Error statuses are cached so a warning
			 * will only be shown once.
			 *
			 * @internal
			 * @param {ReactElement} element Element that requires a key.
			 * @param {*} parentType element's parent's type.
			 */
			function validateExplicitKey(element, parentType) {
			  if (!element._store || element._store.validated || element.key != null) {
			    return;
			  }
			  element._store.validated = true;
	
			  var memoizer = ownerHasKeyUseWarning.uniqueKey || (ownerHasKeyUseWarning.uniqueKey = {});
	
			  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
			  if (memoizer[currentComponentErrorInfo]) {
			    return;
			  }
			  memoizer[currentComponentErrorInfo] = true;
	
			  // Usually the current owner is the offender, but if it accepts children as a
			  // property, it may be the creator of the child that's responsible for
			  // assigning it a key.
			  var childOwner = '';
			  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
			    // Give the component that originally created this child.
			    childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
			  }
	
			  process.env.NODE_ENV !== 'production' ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.%s', currentComponentErrorInfo, childOwner, ReactComponentTreeHook.getCurrentStackAddendum(element)) : void 0;
			}
	
			/**
			 * Ensure that every element either is passed in a static location, in an
			 * array with an explicit keys property defined, or in an object literal
			 * with valid key property.
			 *
			 * @internal
			 * @param {ReactNode} node Statically passed child of any type.
			 * @param {*} parentType node's parent's type.
			 */
			function validateChildKeys(node, parentType) {
			  if (typeof node !== 'object') {
			    return;
			  }
			  if (Array.isArray(node)) {
			    for (var i = 0; i < node.length; i++) {
			      var child = node[i];
			      if (ReactElement.isValidElement(child)) {
			        validateExplicitKey(child, parentType);
			      }
			    }
			  } else if (ReactElement.isValidElement(node)) {
			    // This element was passed in a valid location.
			    if (node._store) {
			      node._store.validated = true;
			    }
			  } else if (node) {
			    var iteratorFn = getIteratorFn(node);
			    // Entry iterators provide implicit keys.
			    if (iteratorFn) {
			      if (iteratorFn !== node.entries) {
			        var iterator = iteratorFn.call(node);
			        var step;
			        while (!(step = iterator.next()).done) {
			          if (ReactElement.isValidElement(step.value)) {
			            validateExplicitKey(step.value, parentType);
			          }
			        }
			      }
			    }
			  }
			}
	
			/**
			 * Given an element, validate that its props follow the propTypes definition,
			 * provided by the type.
			 *
			 * @param {ReactElement} element
			 */
			function validatePropTypes(element) {
			  var componentClass = element.type;
			  if (typeof componentClass !== 'function') {
			    return;
			  }
			  var name = componentClass.displayName || componentClass.name;
			  if (componentClass.propTypes) {
			    checkReactTypeSpec(componentClass.propTypes, element.props, 'prop', name, element, null);
			  }
			  if (typeof componentClass.getDefaultProps === 'function') {
			    process.env.NODE_ENV !== 'production' ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
			  }
			}
	
			var ReactElementValidator = {
	
			  createElement: function (type, props, children) {
			    var validType = typeof type === 'string' || typeof type === 'function';
			    // We warn in this case but don't throw. We expect the element creation to
			    // succeed and there will likely be errors in render.
			    if (!validType) {
			      if (typeof type !== 'function' && typeof type !== 'string') {
			        var info = '';
			        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
			          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
			        }
	
			        var sourceInfo = getSourceInfoErrorAddendum(props);
			        if (sourceInfo) {
			          info += sourceInfo;
			        } else {
			          info += getDeclarationErrorAddendum();
			        }
	
			        info += ReactComponentTreeHook.getCurrentStackAddendum();
	
			        process.env.NODE_ENV !== 'production' ? warning(false, 'React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', type == null ? type : typeof type, info) : void 0;
			      }
			    }
	
			    var element = ReactElement.createElement.apply(this, arguments);
	
			    // The result can be nullish if a mock or a custom function is used.
			    // TODO: Drop this when these are no longer allowed as the type argument.
			    if (element == null) {
			      return element;
			    }
	
			    // Skip key warning if the type isn't valid since our key validation logic
			    // doesn't expect a non-string/function type and can throw confusing errors.
			    // We don't want exception behavior to differ between dev and prod.
			    // (Rendering will throw with a helpful message and as soon as the type is
			    // fixed, the key warnings will appear.)
			    if (validType) {
			      for (var i = 2; i < arguments.length; i++) {
			        validateChildKeys(arguments[i], type);
			      }
			    }
	
			    validatePropTypes(element);
	
			    return element;
			  },
	
			  createFactory: function (type) {
			    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
			    // Legacy hook TODO: Warn if this is accessed
			    validatedFactory.type = type;
	
			    if (process.env.NODE_ENV !== 'production') {
			      if (canDefineProperty) {
			        Object.defineProperty(validatedFactory, 'type', {
			          enumerable: false,
			          get: function () {
			            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : void 0;
			            Object.defineProperty(this, 'type', {
			              value: type
			            });
			            return type;
			          }
			        });
			      }
			    }
	
			    return validatedFactory;
			  },
	
			  cloneElement: function (element, props, children) {
			    var newElement = ReactElement.cloneElement.apply(this, arguments);
			    for (var i = 2; i < arguments.length; i++) {
			      validateChildKeys(arguments[i], newElement.type);
			    }
			    validatePropTypes(newElement);
			    return newElement;
			  }
	
			};
	
			module.exports = ReactElementValidator;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 115 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(42);
	
			var ReactPropTypeLocationNames = __webpack_require__(112);
			var ReactPropTypesSecret = __webpack_require__(116);
	
			var invariant = __webpack_require__(44);
			var warning = __webpack_require__(45);
	
			var ReactComponentTreeHook;
	
			if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
			  // Temporary hack.
			  // Inline requires don't work well with Jest:
			  // https://github.com/facebook/react/issues/7240
			  // Remove the inline requires when we don't need them anymore:
			  // https://github.com/facebook/react/pull/7178
			  ReactComponentTreeHook = __webpack_require__(41);
			}
	
			var loggedTypeFailures = {};
	
			/**
			 * Assert that the values match with the type specs.
			 * Error messages are memorized and will only be shown once.
			 *
			 * @param {object} typeSpecs Map of name to a ReactPropType
			 * @param {object} values Runtime values that need to be type-checked
			 * @param {string} location e.g. "prop", "context", "child context"
			 * @param {string} componentName Name of the component for error messages.
			 * @param {?object} element The React element that is being type-checked
			 * @param {?number} debugID The React component instance that is being type-checked
			 * @private
			 */
			function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
			  for (var typeSpecName in typeSpecs) {
			    if (typeSpecs.hasOwnProperty(typeSpecName)) {
			      var error;
			      // Prop type validation may throw. In case they do, we don't want to
			      // fail the render phase where it didn't fail before. So we log it.
			      // After these have been cleaned up, we'll let them throw.
			      try {
			        // This is intentionally an invariant that gets caught. It's the same
			        // behavior as without this statement except with a better message.
			        !(typeof typeSpecs[typeSpecName] === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
			        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
			      } catch (ex) {
			        error = ex;
			      }
			      process.env.NODE_ENV !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
			      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
			        // Only monitor this failure once because there tends to be a lot of the
			        // same error.
			        loggedTypeFailures[error.message] = true;
	
			        var componentStackInfo = '';
	
			        if (process.env.NODE_ENV !== 'production') {
			          if (!ReactComponentTreeHook) {
			            ReactComponentTreeHook = __webpack_require__(41);
			          }
			          if (debugID !== null) {
			            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
			          } else if (element !== null) {
			            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
			          }
			        }
	
			        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
			      }
			    }
			  }
			}
	
			module.exports = checkReactTypeSpec;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 116 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
			module.exports = ReactPropTypesSecret;
	
		/***/ },
		/* 117 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _require = __webpack_require__(101),
			    isValidElement = _require.isValidElement;
	
			var factory = __webpack_require__(92);
	
			module.exports = factory(isValidElement);
	
		/***/ },
		/* 118 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			module.exports = '15.5.3';
	
		/***/ },
		/* 119 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
			'use strict';
	
			var _prodInvariant = __webpack_require__(42);
	
			var ReactElement = __webpack_require__(101);
	
			var invariant = __webpack_require__(44);
	
			/**
			 * Returns the first child in a collection of children and verifies that there
			 * is only one child in the collection.
			 *
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
			 *
			 * The current implementation of this function assumes that a single child gets
			 * passed without a wrapper, but the purpose of this helper function is to
			 * abstract away the particular structure of children.
			 *
			 * @param {?object} children Child collection structure.
			 * @return {ReactElement} The first and only `ReactElement` contained in the
			 * structure.
			 */
			function onlyChild(children) {
			  !ReactElement.isValidElement(children) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
			  return children;
			}
	
			module.exports = onlyChild;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 120 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var React = __webpack_require__(98);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactDOMSelect = __webpack_require__(121);
	
			var warning = __webpack_require__(18);
			var didWarnInvalidOptionChildren = false;
	
			function flattenChildren(children) {
			  var content = '';
	
			  // Flatten children and warn if they aren't strings or numbers;
			  // invalid types are ignored.
			  React.Children.forEach(children, function (child) {
			    if (child == null) {
			      return;
			    }
			    if (typeof child === 'string' || typeof child === 'number') {
			      content += child;
			    } else if (!didWarnInvalidOptionChildren) {
			      didWarnInvalidOptionChildren = true;
			      process.env.NODE_ENV !== 'production' ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
			    }
			  });
	
			  return content;
			}
	
			/**
			 * Implements an <option> host component that warns when `selected` is set.
			 */
			var ReactDOMOption = {
			  mountWrapper: function (inst, props, hostParent) {
			    // TODO (yungsters): Remove support for `selected` in <option>.
			    if (process.env.NODE_ENV !== 'production') {
			      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
			    }
	
			    // Look up whether this option is 'selected'
			    var selectValue = null;
			    if (hostParent != null) {
			      var selectParent = hostParent;
	
			      if (selectParent._tag === 'optgroup') {
			        selectParent = selectParent._hostParent;
			      }
	
			      if (selectParent != null && selectParent._tag === 'select') {
			        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
			      }
			    }
	
			    // If the value is null (e.g., no specified value or after initial mount)
			    // or missing (e.g., for <datalist>), we don't change props.selected
			    var selected = null;
			    if (selectValue != null) {
			      var value;
			      if (props.value != null) {
			        value = props.value + '';
			      } else {
			        value = flattenChildren(props.children);
			      }
			      selected = false;
			      if (Array.isArray(selectValue)) {
			        // multiple
			        for (var i = 0; i < selectValue.length; i++) {
			          if ('' + selectValue[i] === value) {
			            selected = true;
			            break;
			          }
			        }
			      } else {
			        selected = '' + selectValue === value;
			      }
			    }
	
			    inst._wrapperState = { selected: selected };
			  },
	
			  postMountWrapper: function (inst) {
			    // value="" should make a value attribute (#6219)
			    var props = inst._currentElement.props;
			    if (props.value != null) {
			      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
			      node.setAttribute('value', props.value);
			    }
			  },
	
			  getHostProps: function (inst, props) {
			    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
			    // Read state only from initial mount because <select> updates value
			    // manually; we need the initial state only for server rendering
			    if (inst._wrapperState.selected != null) {
			      hostProps.selected = inst._wrapperState.selected;
			    }
	
			    var content = flattenChildren(props.children);
	
			    if (content) {
			      hostProps.children = content;
			    }
	
			    return hostProps;
			  }
	
			};
	
			module.exports = ReactDOMOption;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 121 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var LinkedValueUtils = __webpack_require__(90);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactUpdates = __webpack_require__(31);
	
			var warning = __webpack_require__(18);
	
			var didWarnValueLink = false;
			var didWarnValueDefaultValue = false;
	
			function updateOptionsIfPendingUpdateAndMounted() {
			  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
			    this._wrapperState.pendingUpdate = false;
	
			    var props = this._currentElement.props;
			    var value = LinkedValueUtils.getValue(props);
	
			    if (value != null) {
			      updateOptions(this, Boolean(props.multiple), value);
			    }
			  }
			}
	
			function getDeclarationErrorAddendum(owner) {
			  if (owner) {
			    var name = owner.getName();
			    if (name) {
			      return ' Check the render method of `' + name + '`.';
			    }
			  }
			  return '';
			}
	
			var valuePropNames = ['value', 'defaultValue'];
	
			/**
			 * Validation function for `value` and `defaultValue`.
			 * @private
			 */
			function checkSelectPropTypes(inst, props) {
			  var owner = inst._currentElement._owner;
			  LinkedValueUtils.checkPropTypes('select', props, owner);
	
			  if (props.valueLink !== undefined && !didWarnValueLink) {
			    process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
			    didWarnValueLink = true;
			  }
	
			  for (var i = 0; i < valuePropNames.length; i++) {
			    var propName = valuePropNames[i];
			    if (props[propName] == null) {
			      continue;
			    }
			    var isArray = Array.isArray(props[propName]);
			    if (props.multiple && !isArray) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
			    } else if (!props.multiple && isArray) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
			    }
			  }
			}
	
			/**
			 * @param {ReactDOMComponent} inst
			 * @param {boolean} multiple
			 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
			 * @private
			 */
			function updateOptions(inst, multiple, propValue) {
			  var selectedValue, i;
			  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
			  if (multiple) {
			    selectedValue = {};
			    for (i = 0; i < propValue.length; i++) {
			      selectedValue['' + propValue[i]] = true;
			    }
			    for (i = 0; i < options.length; i++) {
			      var selected = selectedValue.hasOwnProperty(options[i].value);
			      if (options[i].selected !== selected) {
			        options[i].selected = selected;
			      }
			    }
			  } else {
			    // Do not set `select.value` as exact behavior isn't consistent across all
			    // browsers for all cases.
			    selectedValue = '' + propValue;
			    for (i = 0; i < options.length; i++) {
			      if (options[i].value === selectedValue) {
			        options[i].selected = true;
			        return;
			      }
			    }
			    if (options.length) {
			      options[0].selected = true;
			    }
			  }
			}
	
			/**
			 * Implements a <select> host component that allows optionally setting the
			 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
			 * stringable. If `multiple` is true, the prop must be an array of stringables.
			 *
			 * If `value` is not supplied (or null/undefined), user actions that change the
			 * selected option will trigger updates to the rendered options.
			 *
			 * If it is supplied (and not null/undefined), the rendered options will not
			 * update in response to user actions. Instead, the `value` prop must change in
			 * order for the rendered options to update.
			 *
			 * If `defaultValue` is provided, any options with the supplied values will be
			 * selected.
			 */
			var ReactDOMSelect = {
			  getHostProps: function (inst, props) {
			    return _assign({}, props, {
			      onChange: inst._wrapperState.onChange,
			      value: undefined
			    });
			  },
	
			  mountWrapper: function (inst, props) {
			    if (process.env.NODE_ENV !== 'production') {
			      checkSelectPropTypes(inst, props);
			    }
	
			    var value = LinkedValueUtils.getValue(props);
			    inst._wrapperState = {
			      pendingUpdate: false,
			      initialValue: value != null ? value : props.defaultValue,
			      listeners: null,
			      onChange: _handleChange.bind(inst),
			      wasMultiple: Boolean(props.multiple)
			    };
	
			    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
			      didWarnValueDefaultValue = true;
			    }
			  },
	
			  getSelectValueContext: function (inst) {
			    // ReactDOMOption looks at this initial value so the initial generated
			    // markup has correct `selected` attributes
			    return inst._wrapperState.initialValue;
			  },
	
			  postUpdateWrapper: function (inst) {
			    var props = inst._currentElement.props;
	
			    // After the initial mount, we control selected-ness manually so don't pass
			    // this value down
			    inst._wrapperState.initialValue = undefined;
	
			    var wasMultiple = inst._wrapperState.wasMultiple;
			    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
			    var value = LinkedValueUtils.getValue(props);
			    if (value != null) {
			      inst._wrapperState.pendingUpdate = false;
			      updateOptions(inst, Boolean(props.multiple), value);
			    } else if (wasMultiple !== Boolean(props.multiple)) {
			      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
			      if (props.defaultValue != null) {
			        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
			      } else {
			        // Revert the select back to its default unselected state.
			        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
			      }
			    }
			  }
			};
	
			function _handleChange(event) {
			  var props = this._currentElement.props;
			  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
			  if (this._rootNodeID) {
			    this._wrapperState.pendingUpdate = true;
			  }
			  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
			  return returnValue;
			}
	
			module.exports = ReactDOMSelect;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 122 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6),
			    _assign = __webpack_require__(24);
	
			var LinkedValueUtils = __webpack_require__(90);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactUpdates = __webpack_require__(31);
	
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			var didWarnValueLink = false;
			var didWarnValDefaultVal = false;
	
			function forceUpdateIfMounted() {
			  if (this._rootNodeID) {
			    // DOM component is still mounted; update
			    ReactDOMTextarea.updateWrapper(this);
			  }
			}
	
			/**
			 * Implements a <textarea> host component that allows setting `value`, and
			 * `defaultValue`. This differs from the traditional DOM API because value is
			 * usually set as PCDATA children.
			 *
			 * If `value` is not supplied (or null/undefined), user actions that affect the
			 * value will trigger updates to the element.
			 *
			 * If `value` is supplied (and not null/undefined), the rendered element will
			 * not trigger updates to the element. Instead, the `value` prop must change in
			 * order for the rendered element to be updated.
			 *
			 * The rendered element will be initialized with an empty value, the prop
			 * `defaultValue` if specified, or the children content (deprecated).
			 */
			var ReactDOMTextarea = {
			  getHostProps: function (inst, props) {
			    !(props.dangerouslySetInnerHTML == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
			    // Always set children to the same thing. In IE9, the selection range will
			    // get reset if `textContent` is mutated.  We could add a check in setTextContent
			    // to only set the value if/when the value differs from the node value (which would
			    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
			    // The value can be a boolean or object so that's why it's forced to be a string.
			    var hostProps = _assign({}, props, {
			      value: undefined,
			      defaultValue: undefined,
			      children: '' + inst._wrapperState.initialValue,
			      onChange: inst._wrapperState.onChange
			    });
	
			    return hostProps;
			  },
	
			  mountWrapper: function (inst, props) {
			    if (process.env.NODE_ENV !== 'production') {
			      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
			      if (props.valueLink !== undefined && !didWarnValueLink) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
			        didWarnValueLink = true;
			      }
			      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
			        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
			        didWarnValDefaultVal = true;
			      }
			    }
	
			    var value = LinkedValueUtils.getValue(props);
			    var initialValue = value;
	
			    // Only bother fetching default value if we're going to use it
			    if (value == null) {
			      var defaultValue = props.defaultValue;
			      // TODO (yungsters): Remove support for children content in <textarea>.
			      var children = props.children;
			      if (children != null) {
			        if (process.env.NODE_ENV !== 'production') {
			          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
			        }
			        !(defaultValue == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
			        if (Array.isArray(children)) {
			          !(children.length <= 1) ? process.env.NODE_ENV !== 'production' ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
			          children = children[0];
			        }
	
			        defaultValue = '' + children;
			      }
			      if (defaultValue == null) {
			        defaultValue = '';
			      }
			      initialValue = defaultValue;
			    }
	
			    inst._wrapperState = {
			      initialValue: '' + initialValue,
			      listeners: null,
			      onChange: _handleChange.bind(inst)
			    };
			  },
	
			  updateWrapper: function (inst) {
			    var props = inst._currentElement.props;
	
			    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
			    var value = LinkedValueUtils.getValue(props);
			    if (value != null) {
			      // Cast `value` to a string to ensure the value is set correctly. While
			      // browsers typically do this as necessary, jsdom doesn't.
			      var newValue = '' + value;
	
			      // To avoid side effects (such as losing text selection), only set value if changed
			      if (newValue !== node.value) {
			        node.value = newValue;
			      }
			      if (props.defaultValue == null) {
			        node.defaultValue = newValue;
			      }
			    }
			    if (props.defaultValue != null) {
			      node.defaultValue = props.defaultValue;
			    }
			  },
	
			  postMountWrapper: function (inst) {
			    // This is in postMount because we need access to the DOM node, which is not
			    // available until after the component has mounted.
			    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
			    var textContent = node.textContent;
	
			    // Only set node.value if textContent is equal to the expected
			    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
			    // will populate textContent as well.
			    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
			    if (textContent === inst._wrapperState.initialValue) {
			      node.value = textContent;
			    }
			  }
			};
	
			function _handleChange(event) {
			  var props = this._currentElement.props;
			  var returnValue = LinkedValueUtils.executeOnChange(props, event);
			  ReactUpdates.asap(forceUpdateIfMounted, this);
			  return returnValue;
			}
	
			module.exports = ReactDOMTextarea;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 123 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var ReactComponentEnvironment = __webpack_require__(124);
			var ReactInstanceMap = __webpack_require__(125);
			var ReactInstrumentation = __webpack_require__(37);
	
			var ReactCurrentOwner = __webpack_require__(43);
			var ReactReconciler = __webpack_require__(34);
			var ReactChildReconciler = __webpack_require__(126);
	
			var emptyFunction = __webpack_require__(19);
			var flattenChildren = __webpack_require__(142);
			var invariant = __webpack_require__(8);
	
			/**
			 * Make an update for markup to be rendered and inserted at a supplied index.
			 *
			 * @param {string} markup Markup that renders into an element.
			 * @param {number} toIndex Destination index.
			 * @private
			 */
			function makeInsertMarkup(markup, afterNode, toIndex) {
			  // NOTE: Null values reduce hidden classes.
			  return {
			    type: 'INSERT_MARKUP',
			    content: markup,
			    fromIndex: null,
			    fromNode: null,
			    toIndex: toIndex,
			    afterNode: afterNode
			  };
			}
	
			/**
			 * Make an update for moving an existing element to another index.
			 *
			 * @param {number} fromIndex Source index of the existing element.
			 * @param {number} toIndex Destination index of the element.
			 * @private
			 */
			function makeMove(child, afterNode, toIndex) {
			  // NOTE: Null values reduce hidden classes.
			  return {
			    type: 'MOVE_EXISTING',
			    content: null,
			    fromIndex: child._mountIndex,
			    fromNode: ReactReconciler.getHostNode(child),
			    toIndex: toIndex,
			    afterNode: afterNode
			  };
			}
	
			/**
			 * Make an update for removing an element at an index.
			 *
			 * @param {number} fromIndex Index of the element to remove.
			 * @private
			 */
			function makeRemove(child, node) {
			  // NOTE: Null values reduce hidden classes.
			  return {
			    type: 'REMOVE_NODE',
			    content: null,
			    fromIndex: child._mountIndex,
			    fromNode: node,
			    toIndex: null,
			    afterNode: null
			  };
			}
	
			/**
			 * Make an update for setting the markup of a node.
			 *
			 * @param {string} markup Markup that renders into an element.
			 * @private
			 */
			function makeSetMarkup(markup) {
			  // NOTE: Null values reduce hidden classes.
			  return {
			    type: 'SET_MARKUP',
			    content: markup,
			    fromIndex: null,
			    fromNode: null,
			    toIndex: null,
			    afterNode: null
			  };
			}
	
			/**
			 * Make an update for setting the text content.
			 *
			 * @param {string} textContent Text content to set.
			 * @private
			 */
			function makeTextContent(textContent) {
			  // NOTE: Null values reduce hidden classes.
			  return {
			    type: 'TEXT_CONTENT',
			    content: textContent,
			    fromIndex: null,
			    fromNode: null,
			    toIndex: null,
			    afterNode: null
			  };
			}
	
			/**
			 * Push an update, if any, onto the queue. Creates a new queue if none is
			 * passed and always returns the queue. Mutative.
			 */
			function enqueue(queue, update) {
			  if (update) {
			    queue = queue || [];
			    queue.push(update);
			  }
			  return queue;
			}
	
			/**
			 * Processes any enqueued updates.
			 *
			 * @private
			 */
			function processQueue(inst, updateQueue) {
			  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
			}
	
			var setChildrenForInstrumentation = emptyFunction;
			if (process.env.NODE_ENV !== 'production') {
			  var getDebugID = function (inst) {
			    if (!inst._debugID) {
			      // Check for ART-like instances. TODO: This is silly/gross.
			      var internal;
			      if (internal = ReactInstanceMap.get(inst)) {
			        inst = internal;
			      }
			    }
			    return inst._debugID;
			  };
			  setChildrenForInstrumentation = function (children) {
			    var debugID = getDebugID(this);
			    // TODO: React Native empty components are also multichild.
			    // This means they still get into this method but don't have _debugID.
			    if (debugID !== 0) {
			      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
			        return children[key]._debugID;
			      }) : []);
			    }
			  };
			}
	
			/**
			 * ReactMultiChild are capable of reconciling multiple children.
			 *
			 * @class ReactMultiChild
			 * @internal
			 */
			var ReactMultiChild = {
	
			  /**
			   * Provides common functionality for components that must reconcile multiple
			   * children. This is used by `ReactDOMComponent` to mount, update, and
			   * unmount child components.
			   *
			   * @lends {ReactMultiChild.prototype}
			   */
			  Mixin: {
	
			    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
			      if (process.env.NODE_ENV !== 'production') {
			        var selfDebugID = getDebugID(this);
			        if (this._currentElement) {
			          try {
			            ReactCurrentOwner.current = this._currentElement._owner;
			            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
			          } finally {
			            ReactCurrentOwner.current = null;
			          }
			        }
			      }
			      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
			    },
	
			    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
			      var nextChildren;
			      var selfDebugID = 0;
			      if (process.env.NODE_ENV !== 'production') {
			        selfDebugID = getDebugID(this);
			        if (this._currentElement) {
			          try {
			            ReactCurrentOwner.current = this._currentElement._owner;
			            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
			          } finally {
			            ReactCurrentOwner.current = null;
			          }
			          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
			          return nextChildren;
			        }
			      }
			      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
			      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
			      return nextChildren;
			    },
	
			    /**
			     * Generates a "mount image" for each of the supplied children. In the case
			     * of `ReactDOMComponent`, a mount image is a string of markup.
			     *
			     * @param {?object} nestedChildren Nested child maps.
			     * @return {array} An array of mounted representations.
			     * @internal
			     */
			    mountChildren: function (nestedChildren, transaction, context) {
			      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
			      this._renderedChildren = children;
	
			      var mountImages = [];
			      var index = 0;
			      for (var name in children) {
			        if (children.hasOwnProperty(name)) {
			          var child = children[name];
			          var selfDebugID = 0;
			          if (process.env.NODE_ENV !== 'production') {
			            selfDebugID = getDebugID(this);
			          }
			          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
			          child._mountIndex = index++;
			          mountImages.push(mountImage);
			        }
			      }
	
			      if (process.env.NODE_ENV !== 'production') {
			        setChildrenForInstrumentation.call(this, children);
			      }
	
			      return mountImages;
			    },
	
			    /**
			     * Replaces any rendered children with a text content string.
			     *
			     * @param {string} nextContent String of content.
			     * @internal
			     */
			    updateTextContent: function (nextContent) {
			      var prevChildren = this._renderedChildren;
			      // Remove any rendered children.
			      ReactChildReconciler.unmountChildren(prevChildren, false);
			      for (var name in prevChildren) {
			        if (prevChildren.hasOwnProperty(name)) {
			           true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
			        }
			      }
			      // Set new text content.
			      var updates = [makeTextContent(nextContent)];
			      processQueue(this, updates);
			    },
	
			    /**
			     * Replaces any rendered children with a markup string.
			     *
			     * @param {string} nextMarkup String of markup.
			     * @internal
			     */
			    updateMarkup: function (nextMarkup) {
			      var prevChildren = this._renderedChildren;
			      // Remove any rendered children.
			      ReactChildReconciler.unmountChildren(prevChildren, false);
			      for (var name in prevChildren) {
			        if (prevChildren.hasOwnProperty(name)) {
			           true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
			        }
			      }
			      var updates = [makeSetMarkup(nextMarkup)];
			      processQueue(this, updates);
			    },
	
			    /**
			     * Updates the rendered children with new children.
			     *
			     * @param {?object} nextNestedChildrenElements Nested child element maps.
			     * @param {ReactReconcileTransaction} transaction
			     * @internal
			     */
			    updateChildren: function (nextNestedChildrenElements, transaction, context) {
			      // Hook used by React ART
			      this._updateChildren(nextNestedChildrenElements, transaction, context);
			    },
	
			    /**
			     * @param {?object} nextNestedChildrenElements Nested child element maps.
			     * @param {ReactReconcileTransaction} transaction
			     * @final
			     * @protected
			     */
			    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
			      var prevChildren = this._renderedChildren;
			      var removedNodes = {};
			      var mountImages = [];
			      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
			      if (!nextChildren && !prevChildren) {
			        return;
			      }
			      var updates = null;
			      var name;
			      // `nextIndex` will increment for each child in `nextChildren`, but
			      // `lastIndex` will be the last index visited in `prevChildren`.
			      var nextIndex = 0;
			      var lastIndex = 0;
			      // `nextMountIndex` will increment for each newly mounted child.
			      var nextMountIndex = 0;
			      var lastPlacedNode = null;
			      for (name in nextChildren) {
			        if (!nextChildren.hasOwnProperty(name)) {
			          continue;
			        }
			        var prevChild = prevChildren && prevChildren[name];
			        var nextChild = nextChildren[name];
			        if (prevChild === nextChild) {
			          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
			          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
			          prevChild._mountIndex = nextIndex;
			        } else {
			          if (prevChild) {
			            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
			            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
			            // The `removedNodes` loop below will actually remove the child.
			          }
			          // The child must be instantiated before it's mounted.
			          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
			          nextMountIndex++;
			        }
			        nextIndex++;
			        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
			      }
			      // Remove children that are no longer present.
			      for (name in removedNodes) {
			        if (removedNodes.hasOwnProperty(name)) {
			          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
			        }
			      }
			      if (updates) {
			        processQueue(this, updates);
			      }
			      this._renderedChildren = nextChildren;
	
			      if (process.env.NODE_ENV !== 'production') {
			        setChildrenForInstrumentation.call(this, nextChildren);
			      }
			    },
	
			    /**
			     * Unmounts all rendered children. This should be used to clean up children
			     * when this component is unmounted. It does not actually perform any
			     * backend operations.
			     *
			     * @internal
			     */
			    unmountChildren: function (safely) {
			      var renderedChildren = this._renderedChildren;
			      ReactChildReconciler.unmountChildren(renderedChildren, safely);
			      this._renderedChildren = null;
			    },
	
			    /**
			     * Moves a child component to the supplied index.
			     *
			     * @param {ReactComponent} child Component to move.
			     * @param {number} toIndex Destination index of the element.
			     * @param {number} lastIndex Last index visited of the siblings of `child`.
			     * @protected
			     */
			    moveChild: function (child, afterNode, toIndex, lastIndex) {
			      // If the index of `child` is less than `lastIndex`, then it needs to
			      // be moved. Otherwise, we do not need to move it because a child will be
			      // inserted or moved before `child`.
			      if (child._mountIndex < lastIndex) {
			        return makeMove(child, afterNode, toIndex);
			      }
			    },
	
			    /**
			     * Creates a child component.
			     *
			     * @param {ReactComponent} child Component to create.
			     * @param {string} mountImage Markup to insert.
			     * @protected
			     */
			    createChild: function (child, afterNode, mountImage) {
			      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
			    },
	
			    /**
			     * Removes a child component.
			     *
			     * @param {ReactComponent} child Child to remove.
			     * @protected
			     */
			    removeChild: function (child, node) {
			      return makeRemove(child, node);
			    },
	
			    /**
			     * Mounts a child with the supplied name.
			     *
			     * NOTE: This is part of `updateChildren` and is here for readability.
			     *
			     * @param {ReactComponent} child Component to mount.
			     * @param {string} name Name of the child.
			     * @param {number} index Index at which to insert the child.
			     * @param {ReactReconcileTransaction} transaction
			     * @private
			     */
			    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
			      child._mountIndex = index;
			      return this.createChild(child, afterNode, mountImage);
			    },
	
			    /**
			     * Unmounts a rendered child.
			     *
			     * NOTE: This is part of `updateChildren` and is here for readability.
			     *
			     * @param {ReactComponent} child Component to unmount.
			     * @private
			     */
			    _unmountChild: function (child, node) {
			      var update = this.removeChild(child, node);
			      child._mountIndex = null;
			      return update;
			    }
	
			  }
	
			};
	
			module.exports = ReactMultiChild;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 124 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			var injected = false;
	
			var ReactComponentEnvironment = {
	
			  /**
			   * Optionally injectable hook for swapping out mount images in the middle of
			   * the tree.
			   */
			  replaceNodeWithMarkup: null,
	
			  /**
			   * Optionally injectable hook for processing a queue of child updates. Will
			   * later move into MultiChildComponents.
			   */
			  processChildrenUpdates: null,
	
			  injection: {
			    injectEnvironment: function (environment) {
			      !!injected ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
			      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
			      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
			      injected = true;
			    }
			  }
	
			};
	
			module.exports = ReactComponentEnvironment;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 125 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * `ReactInstanceMap` maintains a mapping from a public facing stateful
			 * instance (key) and the internal representation (value). This allows public
			 * methods to accept the user facing instance as an argument and map them back
			 * to internal methods.
			 */
	
			// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
			var ReactInstanceMap = {
	
			  /**
			   * This API should be called `delete` but we'd have to make sure to always
			   * transform these to strings for IE support. When this transform is fully
			   * supported we can rename it.
			   */
			  remove: function (key) {
			    key._reactInternalInstance = undefined;
			  },
	
			  get: function (key) {
			    return key._reactInternalInstance;
			  },
	
			  has: function (key) {
			    return key._reactInternalInstance !== undefined;
			  },
	
			  set: function (key, value) {
			    key._reactInternalInstance = value;
			  }
	
			};
	
			module.exports = ReactInstanceMap;
	
		/***/ },
		/* 126 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactReconciler = __webpack_require__(34);
	
			var instantiateReactComponent = __webpack_require__(127);
			var KeyEscapeUtils = __webpack_require__(138);
			var shouldUpdateReactComponent = __webpack_require__(134);
			var traverseAllChildren = __webpack_require__(139);
			var warning = __webpack_require__(18);
	
			var ReactComponentTreeHook;
	
			if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
			  // Temporary hack.
			  // Inline requires don't work well with Jest:
			  // https://github.com/facebook/react/issues/7240
			  // Remove the inline requires when we don't need them anymore:
			  // https://github.com/facebook/react/pull/7178
			  ReactComponentTreeHook = __webpack_require__(41);
			}
	
			function instantiateChild(childInstances, child, name, selfDebugID) {
			  // We found a component instance.
			  var keyUnique = childInstances[name] === undefined;
			  if (process.env.NODE_ENV !== 'production') {
			    if (!ReactComponentTreeHook) {
			      ReactComponentTreeHook = __webpack_require__(41);
			    }
			    if (!keyUnique) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
			    }
			  }
			  if (child != null && keyUnique) {
			    childInstances[name] = instantiateReactComponent(child, true);
			  }
			}
	
			/**
			 * ReactChildReconciler provides helpers for initializing or updating a set of
			 * children. Its output is suitable for passing it onto ReactMultiChild which
			 * does diffed reordering and insertion.
			 */
			var ReactChildReconciler = {
			  /**
			   * Generates a "mount image" for each of the supplied children. In the case
			   * of `ReactDOMComponent`, a mount image is a string of markup.
			   *
			   * @param {?object} nestedChildNodes Nested child maps.
			   * @return {?object} A set of child instances.
			   * @internal
			   */
			  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
			  ) {
			    if (nestedChildNodes == null) {
			      return null;
			    }
			    var childInstances = {};
	
			    if (process.env.NODE_ENV !== 'production') {
			      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
			        return instantiateChild(childInsts, child, name, selfDebugID);
			      }, childInstances);
			    } else {
			      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
			    }
			    return childInstances;
			  },
	
			  /**
			   * Updates the rendered children and returns a new set of children.
			   *
			   * @param {?object} prevChildren Previously initialized set of children.
			   * @param {?object} nextChildren Flat child element maps.
			   * @param {ReactReconcileTransaction} transaction
			   * @param {object} context
			   * @return {?object} A new set of child instances.
			   * @internal
			   */
			  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
			  ) {
			    // We currently don't have a way to track moves here but if we use iterators
			    // instead of for..in we can zip the iterators and check if an item has
			    // moved.
			    // TODO: If nothing has changed, return the prevChildren object so that we
			    // can quickly bailout if nothing has changed.
			    if (!nextChildren && !prevChildren) {
			      return;
			    }
			    var name;
			    var prevChild;
			    for (name in nextChildren) {
			      if (!nextChildren.hasOwnProperty(name)) {
			        continue;
			      }
			      prevChild = prevChildren && prevChildren[name];
			      var prevElement = prevChild && prevChild._currentElement;
			      var nextElement = nextChildren[name];
			      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
			        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
			        nextChildren[name] = prevChild;
			      } else {
			        if (prevChild) {
			          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
			          ReactReconciler.unmountComponent(prevChild, false);
			        }
			        // The child must be instantiated before it's mounted.
			        var nextChildInstance = instantiateReactComponent(nextElement, true);
			        nextChildren[name] = nextChildInstance;
			        // Creating mount image now ensures refs are resolved in right order
			        // (see https://github.com/facebook/react/pull/7101 for explanation).
			        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
			        mountImages.push(nextChildMountImage);
			      }
			    }
			    // Unmount children that are no longer present.
			    for (name in prevChildren) {
			      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
			        prevChild = prevChildren[name];
			        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
			        ReactReconciler.unmountComponent(prevChild, false);
			      }
			    }
			  },
	
			  /**
			   * Unmounts all rendered children. This should be used to clean up children
			   * when this component is unmounted.
			   *
			   * @param {?object} renderedChildren Previously initialized set of children.
			   * @internal
			   */
			  unmountChildren: function (renderedChildren, safely) {
			    for (var name in renderedChildren) {
			      if (renderedChildren.hasOwnProperty(name)) {
			        var renderedChild = renderedChildren[name];
			        ReactReconciler.unmountComponent(renderedChild, safely);
			      }
			    }
			  }
	
			};
	
			module.exports = ReactChildReconciler;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 127 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6),
			    _assign = __webpack_require__(24);
	
			var ReactCompositeComponent = __webpack_require__(128);
			var ReactEmptyComponent = __webpack_require__(135);
			var ReactHostComponent = __webpack_require__(136);
	
			var getNextDebugID = __webpack_require__(137);
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			// To avoid a cyclic dependency, we create the final class in this module
			var ReactCompositeComponentWrapper = function (element) {
			  this.construct(element);
			};
	
			function getDeclarationErrorAddendum(owner) {
			  if (owner) {
			    var name = owner.getName();
			    if (name) {
			      return ' Check the render method of `' + name + '`.';
			    }
			  }
			  return '';
			}
	
			/**
			 * Check if the type reference is a known internal type. I.e. not a user
			 * provided composite type.
			 *
			 * @param {function} type
			 * @return {boolean} Returns true if this is a valid internal type.
			 */
			function isInternalComponentType(type) {
			  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
			}
	
			/**
			 * Given a ReactNode, create an instance that will actually be mounted.
			 *
			 * @param {ReactNode} node
			 * @param {boolean} shouldHaveDebugID
			 * @return {object} A new instance of the element's constructor.
			 * @protected
			 */
			function instantiateReactComponent(node, shouldHaveDebugID) {
			  var instance;
	
			  if (node === null || node === false) {
			    instance = ReactEmptyComponent.create(instantiateReactComponent);
			  } else if (typeof node === 'object') {
			    var element = node;
			    var type = element.type;
			    if (typeof type !== 'function' && typeof type !== 'string') {
			      var info = '';
			      if (process.env.NODE_ENV !== 'production') {
			        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
			          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
			        }
			      }
			      info += getDeclarationErrorAddendum(element._owner);
			       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
			    }
	
			    // Special case string values
			    if (typeof element.type === 'string') {
			      instance = ReactHostComponent.createInternalComponent(element);
			    } else if (isInternalComponentType(element.type)) {
			      // This is temporarily available for custom components that are not string
			      // representations. I.e. ART. Once those are updated to use the string
			      // representation, we can drop this code path.
			      instance = new element.type(element);
	
			      // We renamed this. Allow the old name for compat. :(
			      if (!instance.getHostNode) {
			        instance.getHostNode = instance.getNativeNode;
			      }
			    } else {
			      instance = new ReactCompositeComponentWrapper(element);
			    }
			  } else if (typeof node === 'string' || typeof node === 'number') {
			    instance = ReactHostComponent.createInstanceForText(node);
			  } else {
			     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
			  }
	
			  if (process.env.NODE_ENV !== 'production') {
			    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
			  }
	
			  // These two fields are used by the DOM and ART diffing algorithms
			  // respectively. Instead of using expandos on components, we should be
			  // storing the state needed by the diffing algorithms elsewhere.
			  instance._mountIndex = 0;
			  instance._mountImage = null;
	
			  if (process.env.NODE_ENV !== 'production') {
			    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
			  }
	
			  // Internal instances should fully constructed at this point, so they should
			  // not get any new fields added to them at this point.
			  if (process.env.NODE_ENV !== 'production') {
			    if (Object.preventExtensions) {
			      Object.preventExtensions(instance);
			    }
			  }
	
			  return instance;
			}
	
			_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
			  _instantiateReactComponent: instantiateReactComponent
			});
	
			module.exports = instantiateReactComponent;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 128 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6),
			    _assign = __webpack_require__(24);
	
			var React = __webpack_require__(98);
			var ReactComponentEnvironment = __webpack_require__(124);
			var ReactCurrentOwner = __webpack_require__(43);
			var ReactErrorUtils = __webpack_require__(17);
			var ReactInstanceMap = __webpack_require__(125);
			var ReactInstrumentation = __webpack_require__(37);
			var ReactNodeTypes = __webpack_require__(129);
			var ReactReconciler = __webpack_require__(34);
	
			if (process.env.NODE_ENV !== 'production') {
			  var checkReactTypeSpec = __webpack_require__(130);
			}
	
			var emptyObject = __webpack_require__(132);
			var invariant = __webpack_require__(8);
			var shallowEqual = __webpack_require__(133);
			var shouldUpdateReactComponent = __webpack_require__(134);
			var warning = __webpack_require__(18);
	
			var CompositeTypes = {
			  ImpureClass: 0,
			  PureClass: 1,
			  StatelessFunctional: 2
			};
	
			function StatelessComponent(Component) {}
			StatelessComponent.prototype.render = function () {
			  var Component = ReactInstanceMap.get(this)._currentElement.type;
			  var element = Component(this.props, this.context, this.updater);
			  warnIfInvalidElement(Component, element);
			  return element;
			};
	
			function warnIfInvalidElement(Component, element) {
			  if (process.env.NODE_ENV !== 'production') {
			    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
			    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
			  }
			}
	
			function shouldConstruct(Component) {
			  return !!(Component.prototype && Component.prototype.isReactComponent);
			}
	
			function isPureComponent(Component) {
			  return !!(Component.prototype && Component.prototype.isPureReactComponent);
			}
	
			// Separated into a function to contain deoptimizations caused by try/finally.
			function measureLifeCyclePerf(fn, debugID, timerType) {
			  if (debugID === 0) {
			    // Top-level wrappers (see ReactMount) and empty components (see
			    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
			    // Both are implementation details that should go away in the future.
			    return fn();
			  }
	
			  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
			  try {
			    return fn();
			  } finally {
			    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
			  }
			}
	
			/**
			 * ------------------ The Life-Cycle of a Composite Component ------------------
			 *
			 * - constructor: Initialization of state. The instance is now retained.
			 *   - componentWillMount
			 *   - render
			 *   - [children's constructors]
			 *     - [children's componentWillMount and render]
			 *     - [children's componentDidMount]
			 *     - componentDidMount
			 *
			 *       Update Phases:
			 *       - componentWillReceiveProps (only called if parent updated)
			 *       - shouldComponentUpdate
			 *         - componentWillUpdate
			 *           - render
			 *           - [children's constructors or receive props phases]
			 *         - componentDidUpdate
			 *
			 *     - componentWillUnmount
			 *     - [children's componentWillUnmount]
			 *   - [children destroyed]
			 * - (destroyed): The instance is now blank, released by React and ready for GC.
			 *
			 * -----------------------------------------------------------------------------
			 */
	
			/**
			 * An incrementing ID assigned to each component when it is mounted. This is
			 * used to enforce the order in which `ReactUpdates` updates dirty components.
			 *
			 * @private
			 */
			var nextMountID = 1;
	
			/**
			 * @lends {ReactCompositeComponent.prototype}
			 */
			var ReactCompositeComponent = {
	
			  /**
			   * Base constructor for all composite component.
			   *
			   * @param {ReactElement} element
			   * @final
			   * @internal
			   */
			  construct: function (element) {
			    this._currentElement = element;
			    this._rootNodeID = 0;
			    this._compositeType = null;
			    this._instance = null;
			    this._hostParent = null;
			    this._hostContainerInfo = null;
	
			    // See ReactUpdateQueue
			    this._updateBatchNumber = null;
			    this._pendingElement = null;
			    this._pendingStateQueue = null;
			    this._pendingReplaceState = false;
			    this._pendingForceUpdate = false;
	
			    this._renderedNodeType = null;
			    this._renderedComponent = null;
			    this._context = null;
			    this._mountOrder = 0;
			    this._topLevelWrapper = null;
	
			    // See ReactUpdates and ReactUpdateQueue.
			    this._pendingCallbacks = null;
	
			    // ComponentWillUnmount shall only be called once
			    this._calledComponentWillUnmount = false;
	
			    if (process.env.NODE_ENV !== 'production') {
			      this._warnedAboutRefsInRender = false;
			    }
			  },
	
			  /**
			   * Initializes the component, renders markup, and registers event listeners.
			   *
			   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
			   * @param {?object} hostParent
			   * @param {?object} hostContainerInfo
			   * @param {?object} context
			   * @return {?string} Rendered markup to be inserted into the DOM.
			   * @final
			   * @internal
			   */
			  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
			    var _this = this;
	
			    this._context = context;
			    this._mountOrder = nextMountID++;
			    this._hostParent = hostParent;
			    this._hostContainerInfo = hostContainerInfo;
	
			    var publicProps = this._currentElement.props;
			    var publicContext = this._processContext(context);
	
			    var Component = this._currentElement.type;
	
			    var updateQueue = transaction.getUpdateQueue();
	
			    // Initialize the public class
			    var doConstruct = shouldConstruct(Component);
			    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
			    var renderedElement;
	
			    // Support functional components
			    if (!doConstruct && (inst == null || inst.render == null)) {
			      renderedElement = inst;
			      warnIfInvalidElement(Component, renderedElement);
			      !(inst === null || inst === false || React.isValidElement(inst)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
			      inst = new StatelessComponent(Component);
			      this._compositeType = CompositeTypes.StatelessFunctional;
			    } else {
			      if (isPureComponent(Component)) {
			        this._compositeType = CompositeTypes.PureClass;
			      } else {
			        this._compositeType = CompositeTypes.ImpureClass;
			      }
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      // This will throw later in _renderValidatedComponent, but add an early
			      // warning now to help debugging
			      if (inst.render == null) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
			      }
	
			      var propsMutated = inst.props !== publicProps;
			      var componentName = Component.displayName || Component.name || 'Component';
	
			      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
			    }
	
			    // These should be set up in the constructor, but as a convenience for
			    // simpler class abstractions, we set them up after the fact.
			    inst.props = publicProps;
			    inst.context = publicContext;
			    inst.refs = emptyObject;
			    inst.updater = updateQueue;
	
			    this._instance = inst;
	
			    // Store a reference from the instance back to the internal representation
			    ReactInstanceMap.set(inst, this);
	
			    if (process.env.NODE_ENV !== 'production') {
			      // Since plain JS classes are defined without any special initialization
			      // logic, we can not catch common errors early. Therefore, we have to
			      // catch them here, at initialization time, instead.
			      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
			      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
			      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
			      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
			      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
			      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
			      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
			    }
	
			    var initialState = inst.state;
			    if (initialState === undefined) {
			      inst.state = initialState = null;
			    }
			    !(typeof initialState === 'object' && !Array.isArray(initialState)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
			    this._pendingStateQueue = null;
			    this._pendingReplaceState = false;
			    this._pendingForceUpdate = false;
	
			    var markup;
			    if (inst.unstable_handleError) {
			      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
			    } else {
			      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
			    }
	
			    if (inst.componentDidMount) {
			      if (process.env.NODE_ENV !== 'production') {
			        transaction.getReactMountReady().enqueue(function () {
			          measureLifeCyclePerf(function () {
			            return inst.componentDidMount();
			          }, _this._debugID, 'componentDidMount');
			        });
			      } else {
			        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
			      }
			    }
	
			    return markup;
			  },
	
			  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
			    if (process.env.NODE_ENV !== 'production') {
			      ReactCurrentOwner.current = this;
			      try {
			        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
			      } finally {
			        ReactCurrentOwner.current = null;
			      }
			    } else {
			      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
			    }
			  },
	
			  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
			    var Component = this._currentElement.type;
	
			    if (doConstruct) {
			      if (process.env.NODE_ENV !== 'production') {
			        return measureLifeCyclePerf(function () {
			          return new Component(publicProps, publicContext, updateQueue);
			        }, this._debugID, 'ctor');
			      } else {
			        return new Component(publicProps, publicContext, updateQueue);
			      }
			    }
	
			    // This can still be an instance in case of factory components
			    // but we'll count this as time spent rendering as the more common case.
			    if (process.env.NODE_ENV !== 'production') {
			      return measureLifeCyclePerf(function () {
			        return Component(publicProps, publicContext, updateQueue);
			      }, this._debugID, 'render');
			    } else {
			      return Component(publicProps, publicContext, updateQueue);
			    }
			  },
	
			  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
			    var markup;
			    var checkpoint = transaction.checkpoint();
			    try {
			      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
			    } catch (e) {
			      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
			      transaction.rollback(checkpoint);
			      this._instance.unstable_handleError(e);
			      if (this._pendingStateQueue) {
			        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
			      }
			      checkpoint = transaction.checkpoint();
	
			      this._renderedComponent.unmountComponent(true);
			      transaction.rollback(checkpoint);
	
			      // Try again - we've informed the component about the error, so they can render an error message this time.
			      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
			      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
			    }
			    return markup;
			  },
	
			  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
			    var inst = this._instance;
	
			    var debugID = 0;
			    if (process.env.NODE_ENV !== 'production') {
			      debugID = this._debugID;
			    }
	
			    if (inst.componentWillMount) {
			      if (process.env.NODE_ENV !== 'production') {
			        measureLifeCyclePerf(function () {
			          return inst.componentWillMount();
			        }, debugID, 'componentWillMount');
			      } else {
			        inst.componentWillMount();
			      }
			      // When mounting, calls to `setState` by `componentWillMount` will set
			      // `this._pendingStateQueue` without triggering a re-render.
			      if (this._pendingStateQueue) {
			        inst.state = this._processPendingState(inst.props, inst.context);
			      }
			    }
	
			    // If not a stateless component, we now render
			    if (renderedElement === undefined) {
			      renderedElement = this._renderValidatedComponent();
			    }
	
			    var nodeType = ReactNodeTypes.getType(renderedElement);
			    this._renderedNodeType = nodeType;
			    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
			    );
			    this._renderedComponent = child;
	
			    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
			    if (process.env.NODE_ENV !== 'production') {
			      if (debugID !== 0) {
			        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
			        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
			      }
			    }
	
			    return markup;
			  },
	
			  getHostNode: function () {
			    return ReactReconciler.getHostNode(this._renderedComponent);
			  },
	
			  /**
			   * Releases any resources allocated by `mountComponent`.
			   *
			   * @final
			   * @internal
			   */
			  unmountComponent: function (safely) {
			    if (!this._renderedComponent) {
			      return;
			    }
	
			    var inst = this._instance;
	
			    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
			      inst._calledComponentWillUnmount = true;
	
			      if (safely) {
			        var name = this.getName() + '.componentWillUnmount()';
			        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
			      } else {
			        if (process.env.NODE_ENV !== 'production') {
			          measureLifeCyclePerf(function () {
			            return inst.componentWillUnmount();
			          }, this._debugID, 'componentWillUnmount');
			        } else {
			          inst.componentWillUnmount();
			        }
			      }
			    }
	
			    if (this._renderedComponent) {
			      ReactReconciler.unmountComponent(this._renderedComponent, safely);
			      this._renderedNodeType = null;
			      this._renderedComponent = null;
			      this._instance = null;
			    }
	
			    // Reset pending fields
			    // Even if this component is scheduled for another update in ReactUpdates,
			    // it would still be ignored because these fields are reset.
			    this._pendingStateQueue = null;
			    this._pendingReplaceState = false;
			    this._pendingForceUpdate = false;
			    this._pendingCallbacks = null;
			    this._pendingElement = null;
	
			    // These fields do not really need to be reset since this object is no
			    // longer accessible.
			    this._context = null;
			    this._rootNodeID = 0;
			    this._topLevelWrapper = null;
	
			    // Delete the reference from the instance to this internal representation
			    // which allow the internals to be properly cleaned up even if the user
			    // leaks a reference to the public instance.
			    ReactInstanceMap.remove(inst);
	
			    // Some existing components rely on inst.props even after they've been
			    // destroyed (in event handlers).
			    // TODO: inst.props = null;
			    // TODO: inst.state = null;
			    // TODO: inst.context = null;
			  },
	
			  /**
			   * Filters the context object to only contain keys specified in
			   * `contextTypes`
			   *
			   * @param {object} context
			   * @return {?object}
			   * @private
			   */
			  _maskContext: function (context) {
			    var Component = this._currentElement.type;
			    var contextTypes = Component.contextTypes;
			    if (!contextTypes) {
			      return emptyObject;
			    }
			    var maskedContext = {};
			    for (var contextName in contextTypes) {
			      maskedContext[contextName] = context[contextName];
			    }
			    return maskedContext;
			  },
	
			  /**
			   * Filters the context object to only contain keys specified in
			   * `contextTypes`, and asserts that they are valid.
			   *
			   * @param {object} context
			   * @return {?object}
			   * @private
			   */
			  _processContext: function (context) {
			    var maskedContext = this._maskContext(context);
			    if (process.env.NODE_ENV !== 'production') {
			      var Component = this._currentElement.type;
			      if (Component.contextTypes) {
			        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
			      }
			    }
			    return maskedContext;
			  },
	
			  /**
			   * @param {object} currentContext
			   * @return {object}
			   * @private
			   */
			  _processChildContext: function (currentContext) {
			    var Component = this._currentElement.type;
			    var inst = this._instance;
			    var childContext;
	
			    if (inst.getChildContext) {
			      if (process.env.NODE_ENV !== 'production') {
			        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
			        try {
			          childContext = inst.getChildContext();
			        } finally {
			          ReactInstrumentation.debugTool.onEndProcessingChildContext();
			        }
			      } else {
			        childContext = inst.getChildContext();
			      }
			    }
	
			    if (childContext) {
			      !(typeof Component.childContextTypes === 'object') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
			      if (process.env.NODE_ENV !== 'production') {
			        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
			      }
			      for (var name in childContext) {
			        !(name in Component.childContextTypes) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
			      }
			      return _assign({}, currentContext, childContext);
			    }
			    return currentContext;
			  },
	
			  /**
			   * Assert that the context types are valid
			   *
			   * @param {object} typeSpecs Map of context field to a ReactPropType
			   * @param {object} values Runtime values that need to be type-checked
			   * @param {string} location e.g. "prop", "context", "child context"
			   * @private
			   */
			  _checkContextTypes: function (typeSpecs, values, location) {
			    if (process.env.NODE_ENV !== 'production') {
			      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
			    }
			  },
	
			  receiveComponent: function (nextElement, transaction, nextContext) {
			    var prevElement = this._currentElement;
			    var prevContext = this._context;
	
			    this._pendingElement = null;
	
			    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
			  },
	
			  /**
			   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
			   * is set, update the component.
			   *
			   * @param {ReactReconcileTransaction} transaction
			   * @internal
			   */
			  performUpdateIfNecessary: function (transaction) {
			    if (this._pendingElement != null) {
			      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
			    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
			      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
			    } else {
			      this._updateBatchNumber = null;
			    }
			  },
	
			  /**
			   * Perform an update to a mounted component. The componentWillReceiveProps and
			   * shouldComponentUpdate methods are called, then (assuming the update isn't
			   * skipped) the remaining update lifecycle methods are called and the DOM
			   * representation is updated.
			   *
			   * By default, this implements React's rendering and reconciliation algorithm.
			   * Sophisticated clients may wish to override this.
			   *
			   * @param {ReactReconcileTransaction} transaction
			   * @param {ReactElement} prevParentElement
			   * @param {ReactElement} nextParentElement
			   * @internal
			   * @overridable
			   */
			  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
			    var inst = this._instance;
			    !(inst != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
			    var willReceive = false;
			    var nextContext;
	
			    // Determine if the context has changed or not
			    if (this._context === nextUnmaskedContext) {
			      nextContext = inst.context;
			    } else {
			      nextContext = this._processContext(nextUnmaskedContext);
			      willReceive = true;
			    }
	
			    var prevProps = prevParentElement.props;
			    var nextProps = nextParentElement.props;
	
			    // Not a simple state update but a props update
			    if (prevParentElement !== nextParentElement) {
			      willReceive = true;
			    }
	
			    // An update here will schedule an update but immediately set
			    // _pendingStateQueue which will ensure that any state updates gets
			    // immediately reconciled instead of waiting for the next batch.
			    if (willReceive && inst.componentWillReceiveProps) {
			      if (process.env.NODE_ENV !== 'production') {
			        measureLifeCyclePerf(function () {
			          return inst.componentWillReceiveProps(nextProps, nextContext);
			        }, this._debugID, 'componentWillReceiveProps');
			      } else {
			        inst.componentWillReceiveProps(nextProps, nextContext);
			      }
			    }
	
			    var nextState = this._processPendingState(nextProps, nextContext);
			    var shouldUpdate = true;
	
			    if (!this._pendingForceUpdate) {
			      if (inst.shouldComponentUpdate) {
			        if (process.env.NODE_ENV !== 'production') {
			          shouldUpdate = measureLifeCyclePerf(function () {
			            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
			          }, this._debugID, 'shouldComponentUpdate');
			        } else {
			          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
			        }
			      } else {
			        if (this._compositeType === CompositeTypes.PureClass) {
			          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
			        }
			      }
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
			    }
	
			    this._updateBatchNumber = null;
			    if (shouldUpdate) {
			      this._pendingForceUpdate = false;
			      // Will set `this.props`, `this.state` and `this.context`.
			      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
			    } else {
			      // If it's determined that a component should not update, we still want
			      // to set props and state but we shortcut the rest of the update.
			      this._currentElement = nextParentElement;
			      this._context = nextUnmaskedContext;
			      inst.props = nextProps;
			      inst.state = nextState;
			      inst.context = nextContext;
			    }
			  },
	
			  _processPendingState: function (props, context) {
			    var inst = this._instance;
			    var queue = this._pendingStateQueue;
			    var replace = this._pendingReplaceState;
			    this._pendingReplaceState = false;
			    this._pendingStateQueue = null;
	
			    if (!queue) {
			      return inst.state;
			    }
	
			    if (replace && queue.length === 1) {
			      return queue[0];
			    }
	
			    var nextState = _assign({}, replace ? queue[0] : inst.state);
			    for (var i = replace ? 1 : 0; i < queue.length; i++) {
			      var partial = queue[i];
			      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
			    }
	
			    return nextState;
			  },
	
			  /**
			   * Merges new props and state, notifies delegate methods of update and
			   * performs update.
			   *
			   * @param {ReactElement} nextElement Next element
			   * @param {object} nextProps Next public object to set as properties.
			   * @param {?object} nextState Next object to set as state.
			   * @param {?object} nextContext Next public object to set as context.
			   * @param {ReactReconcileTransaction} transaction
			   * @param {?object} unmaskedContext
			   * @private
			   */
			  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
			    var _this2 = this;
	
			    var inst = this._instance;
	
			    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
			    var prevProps;
			    var prevState;
			    var prevContext;
			    if (hasComponentDidUpdate) {
			      prevProps = inst.props;
			      prevState = inst.state;
			      prevContext = inst.context;
			    }
	
			    if (inst.componentWillUpdate) {
			      if (process.env.NODE_ENV !== 'production') {
			        measureLifeCyclePerf(function () {
			          return inst.componentWillUpdate(nextProps, nextState, nextContext);
			        }, this._debugID, 'componentWillUpdate');
			      } else {
			        inst.componentWillUpdate(nextProps, nextState, nextContext);
			      }
			    }
	
			    this._currentElement = nextElement;
			    this._context = unmaskedContext;
			    inst.props = nextProps;
			    inst.state = nextState;
			    inst.context = nextContext;
	
			    this._updateRenderedComponent(transaction, unmaskedContext);
	
			    if (hasComponentDidUpdate) {
			      if (process.env.NODE_ENV !== 'production') {
			        transaction.getReactMountReady().enqueue(function () {
			          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
			        });
			      } else {
			        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
			      }
			    }
			  },
	
			  /**
			   * Call the component's `render` method and update the DOM accordingly.
			   *
			   * @param {ReactReconcileTransaction} transaction
			   * @internal
			   */
			  _updateRenderedComponent: function (transaction, context) {
			    var prevComponentInstance = this._renderedComponent;
			    var prevRenderedElement = prevComponentInstance._currentElement;
			    var nextRenderedElement = this._renderValidatedComponent();
	
			    var debugID = 0;
			    if (process.env.NODE_ENV !== 'production') {
			      debugID = this._debugID;
			    }
	
			    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
			      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
			    } else {
			      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
			      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
			      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
			      this._renderedNodeType = nodeType;
			      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
			      );
			      this._renderedComponent = child;
	
			      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
			      if (process.env.NODE_ENV !== 'production') {
			        if (debugID !== 0) {
			          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
			          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
			        }
			      }
	
			      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
			    }
			  },
	
			  /**
			   * Overridden in shallow rendering.
			   *
			   * @protected
			   */
			  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
			    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
			  },
	
			  /**
			   * @protected
			   */
			  _renderValidatedComponentWithoutOwnerOrContext: function () {
			    var inst = this._instance;
			    var renderedElement;
	
			    if (process.env.NODE_ENV !== 'production') {
			      renderedElement = measureLifeCyclePerf(function () {
			        return inst.render();
			      }, this._debugID, 'render');
			    } else {
			      renderedElement = inst.render();
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      // We allow auto-mocks to proceed as if they're returning null.
			      if (renderedElement === undefined && inst.render._isMockFunction) {
			        // This is probably bad practice. Consider warning here and
			        // deprecating this convenience.
			        renderedElement = null;
			      }
			    }
	
			    return renderedElement;
			  },
	
			  /**
			   * @private
			   */
			  _renderValidatedComponent: function () {
			    var renderedElement;
			    if (process.env.NODE_ENV !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
			      ReactCurrentOwner.current = this;
			      try {
			        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
			      } finally {
			        ReactCurrentOwner.current = null;
			      }
			    } else {
			      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
			    }
			    !(
			    // TODO: An `isValidNode` function would probably be more appropriate
			    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
			    return renderedElement;
			  },
	
			  /**
			   * Lazily allocates the refs object and stores `component` as `ref`.
			   *
			   * @param {string} ref Reference name.
			   * @param {component} component Component to store as `ref`.
			   * @final
			   * @private
			   */
			  attachRef: function (ref, component) {
			    var inst = this.getPublicInstance();
			    !(inst != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
			    var publicComponentInstance = component.getPublicInstance();
			    if (process.env.NODE_ENV !== 'production') {
			      var componentName = component && component.getName ? component.getName() : 'a component';
			      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
			    }
			    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
			    refs[ref] = publicComponentInstance;
			  },
	
			  /**
			   * Detaches a reference name.
			   *
			   * @param {string} ref Name to dereference.
			   * @final
			   * @private
			   */
			  detachRef: function (ref) {
			    var refs = this.getPublicInstance().refs;
			    delete refs[ref];
			  },
	
			  /**
			   * Get a text description of the component that can be used to identify it
			   * in error messages.
			   * @return {string} The name or null.
			   * @internal
			   */
			  getName: function () {
			    var type = this._currentElement.type;
			    var constructor = this._instance && this._instance.constructor;
			    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
			  },
	
			  /**
			   * Get the publicly accessible representation of this component - i.e. what
			   * is exposed by refs and returned by render. Can be null for stateless
			   * components.
			   *
			   * @return {ReactComponent} the public component instance.
			   * @internal
			   */
			  getPublicInstance: function () {
			    var inst = this._instance;
			    if (this._compositeType === CompositeTypes.StatelessFunctional) {
			      return null;
			    }
			    return inst;
			  },
	
			  // Stub
			  _instantiateReactComponent: null
	
			};
	
			module.exports = ReactCompositeComponent;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 129 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var React = __webpack_require__(98);
	
			var invariant = __webpack_require__(8);
	
			var ReactNodeTypes = {
			  HOST: 0,
			  COMPOSITE: 1,
			  EMPTY: 2,
	
			  getType: function (node) {
			    if (node === null || node === false) {
			      return ReactNodeTypes.EMPTY;
			    } else if (React.isValidElement(node)) {
			      if (typeof node.type === 'function') {
			        return ReactNodeTypes.COMPOSITE;
			      } else {
			        return ReactNodeTypes.HOST;
			      }
			    }
			     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
			  }
			};
	
			module.exports = ReactNodeTypes;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 130 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var ReactPropTypeLocationNames = __webpack_require__(131);
			var ReactPropTypesSecret = __webpack_require__(91);
	
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			var ReactComponentTreeHook;
	
			if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
			  // Temporary hack.
			  // Inline requires don't work well with Jest:
			  // https://github.com/facebook/react/issues/7240
			  // Remove the inline requires when we don't need them anymore:
			  // https://github.com/facebook/react/pull/7178
			  ReactComponentTreeHook = __webpack_require__(41);
			}
	
			var loggedTypeFailures = {};
	
			/**
			 * Assert that the values match with the type specs.
			 * Error messages are memorized and will only be shown once.
			 *
			 * @param {object} typeSpecs Map of name to a ReactPropType
			 * @param {object} values Runtime values that need to be type-checked
			 * @param {string} location e.g. "prop", "context", "child context"
			 * @param {string} componentName Name of the component for error messages.
			 * @param {?object} element The React element that is being type-checked
			 * @param {?number} debugID The React component instance that is being type-checked
			 * @private
			 */
			function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
			  for (var typeSpecName in typeSpecs) {
			    if (typeSpecs.hasOwnProperty(typeSpecName)) {
			      var error;
			      // Prop type validation may throw. In case they do, we don't want to
			      // fail the render phase where it didn't fail before. So we log it.
			      // After these have been cleaned up, we'll let them throw.
			      try {
			        // This is intentionally an invariant that gets caught. It's the same
			        // behavior as without this statement except with a better message.
			        !(typeof typeSpecs[typeSpecName] === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
			        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
			      } catch (ex) {
			        error = ex;
			      }
			      process.env.NODE_ENV !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
			      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
			        // Only monitor this failure once because there tends to be a lot of the
			        // same error.
			        loggedTypeFailures[error.message] = true;
	
			        var componentStackInfo = '';
	
			        if (process.env.NODE_ENV !== 'production') {
			          if (!ReactComponentTreeHook) {
			            ReactComponentTreeHook = __webpack_require__(41);
			          }
			          if (debugID !== null) {
			            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
			          } else if (element !== null) {
			            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
			          }
			        }
	
			        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
			      }
			    }
			  }
			}
	
			module.exports = checkReactTypeSpec;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 131 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var ReactPropTypeLocationNames = {};
	
			if (process.env.NODE_ENV !== 'production') {
			  ReactPropTypeLocationNames = {
			    prop: 'prop',
			    context: 'context',
			    childContext: 'child context'
			  };
			}
	
			module.exports = ReactPropTypeLocationNames;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 132 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var emptyObject = {};
	
			if (process.env.NODE_ENV !== 'production') {
			  Object.freeze(emptyObject);
			}
	
			module.exports = emptyObject;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 133 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 * 
			 */
	
			/*eslint-disable no-self-compare */
	
			'use strict';
	
			var hasOwnProperty = Object.prototype.hasOwnProperty;
	
			/**
			 * inlined Object.is polyfill to avoid requiring consumers ship their own
			 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
			 */
			function is(x, y) {
			  // SameValue algorithm
			  if (x === y) {
			    // Steps 1-5, 7-10
			    // Steps 6.b-6.e: +0 != -0
			    // Added the nonzero y check to make Flow happy, but it is redundant
			    return x !== 0 || y !== 0 || 1 / x === 1 / y;
			  } else {
			    // Step 6.a: NaN == NaN
			    return x !== x && y !== y;
			  }
			}
	
			/**
			 * Performs equality by iterating through keys on an object and returning false
			 * when any key has values which are not strictly equal between the arguments.
			 * Returns true when the values of all keys are strictly equal.
			 */
			function shallowEqual(objA, objB) {
			  if (is(objA, objB)) {
			    return true;
			  }
	
			  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
			    return false;
			  }
	
			  var keysA = Object.keys(objA);
			  var keysB = Object.keys(objB);
	
			  if (keysA.length !== keysB.length) {
			    return false;
			  }
	
			  // Test for A's keys different from B.
			  for (var i = 0; i < keysA.length; i++) {
			    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
			      return false;
			    }
			  }
	
			  return true;
			}
	
			module.exports = shallowEqual;
	
		/***/ },
		/* 134 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * Given a `prevElement` and `nextElement`, determines if the existing
			 * instance should be updated as opposed to being destroyed or replaced by a new
			 * instance. Both arguments are elements. This ensures that this logic can
			 * operate on stateless trees without any backing instance.
			 *
			 * @param {?object} prevElement
			 * @param {?object} nextElement
			 * @return {boolean} True if the existing instance should be updated.
			 * @protected
			 */
	
			function shouldUpdateReactComponent(prevElement, nextElement) {
			  var prevEmpty = prevElement === null || prevElement === false;
			  var nextEmpty = nextElement === null || nextElement === false;
			  if (prevEmpty || nextEmpty) {
			    return prevEmpty === nextEmpty;
			  }
	
			  var prevType = typeof prevElement;
			  var nextType = typeof nextElement;
			  if (prevType === 'string' || prevType === 'number') {
			    return nextType === 'string' || nextType === 'number';
			  } else {
			    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
			  }
			}
	
			module.exports = shouldUpdateReactComponent;
	
		/***/ },
		/* 135 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var emptyComponentFactory;
	
			var ReactEmptyComponentInjection = {
			  injectEmptyComponentFactory: function (factory) {
			    emptyComponentFactory = factory;
			  }
			};
	
			var ReactEmptyComponent = {
			  create: function (instantiate) {
			    return emptyComponentFactory(instantiate);
			  }
			};
	
			ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
			module.exports = ReactEmptyComponent;
	
		/***/ },
		/* 136 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			var genericComponentClass = null;
			var textComponentClass = null;
	
			var ReactHostComponentInjection = {
			  // This accepts a class that receives the tag string. This is a catch all
			  // that can render any kind of tag.
			  injectGenericComponentClass: function (componentClass) {
			    genericComponentClass = componentClass;
			  },
			  // This accepts a text component class that takes the text string to be
			  // rendered as props.
			  injectTextComponentClass: function (componentClass) {
			    textComponentClass = componentClass;
			  }
			};
	
			/**
			 * Get a host internal component class for a specific tag.
			 *
			 * @param {ReactElement} element The element to create.
			 * @return {function} The internal class constructor function.
			 */
			function createInternalComponent(element) {
			  !genericComponentClass ? process.env.NODE_ENV !== 'production' ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
			  return new genericComponentClass(element);
			}
	
			/**
			 * @param {ReactText} text
			 * @return {ReactComponent}
			 */
			function createInstanceForText(text) {
			  return new textComponentClass(text);
			}
	
			/**
			 * @param {ReactComponent} component
			 * @return {boolean}
			 */
			function isTextComponent(component) {
			  return component instanceof textComponentClass;
			}
	
			var ReactHostComponent = {
			  createInternalComponent: createInternalComponent,
			  createInstanceForText: createInstanceForText,
			  isTextComponent: isTextComponent,
			  injection: ReactHostComponentInjection
			};
	
			module.exports = ReactHostComponent;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 137 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var nextDebugID = 1;
	
			function getNextDebugID() {
			  return nextDebugID++;
			}
	
			module.exports = getNextDebugID;
	
		/***/ },
		/* 138 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			/**
			 * Escape and wrap key so it is safe to use as a reactid
			 *
			 * @param {string} key to be escaped.
			 * @return {string} the escaped key.
			 */
	
			function escape(key) {
			  var escapeRegex = /[=:]/g;
			  var escaperLookup = {
			    '=': '=0',
			    ':': '=2'
			  };
			  var escapedString = ('' + key).replace(escapeRegex, function (match) {
			    return escaperLookup[match];
			  });
	
			  return '$' + escapedString;
			}
	
			/**
			 * Unescape and unwrap key for human-readable display
			 *
			 * @param {string} key to unescape.
			 * @return {string} the unescaped key.
			 */
			function unescape(key) {
			  var unescapeRegex = /(=0|=2)/g;
			  var unescaperLookup = {
			    '=0': '=',
			    '=2': ':'
			  };
			  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
			  return ('' + keySubstring).replace(unescapeRegex, function (match) {
			    return unescaperLookup[match];
			  });
			}
	
			var KeyEscapeUtils = {
			  escape: escape,
			  unescape: unescape
			};
	
			module.exports = KeyEscapeUtils;
	
		/***/ },
		/* 139 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var ReactCurrentOwner = __webpack_require__(43);
			var REACT_ELEMENT_TYPE = __webpack_require__(140);
	
			var getIteratorFn = __webpack_require__(141);
			var invariant = __webpack_require__(8);
			var KeyEscapeUtils = __webpack_require__(138);
			var warning = __webpack_require__(18);
	
			var SEPARATOR = '.';
			var SUBSEPARATOR = ':';
	
			/**
			 * This is inlined from ReactElement since this file is shared between
			 * isomorphic and renderers. We could extract this to a
			 *
			 */
	
			/**
			 * TODO: Test that a single child and an array with one item have the same key
			 * pattern.
			 */
	
			var didWarnAboutMaps = false;
	
			/**
			 * Generate a key string that identifies a component within a set.
			 *
			 * @param {*} component A component that could contain a manual key.
			 * @param {number} index Index that is used if a manual key is not provided.
			 * @return {string}
			 */
			function getComponentKey(component, index) {
			  // Do some typechecking here since we call this blindly. We want to ensure
			  // that we don't block potential future ES APIs.
			  if (component && typeof component === 'object' && component.key != null) {
			    // Explicit key
			    return KeyEscapeUtils.escape(component.key);
			  }
			  // Implicit key determined by the index in the set
			  return index.toString(36);
			}
	
			/**
			 * @param {?*} children Children tree container.
			 * @param {!string} nameSoFar Name of the key path so far.
			 * @param {!function} callback Callback to invoke with each child found.
			 * @param {?*} traverseContext Used to pass information throughout the traversal
			 * process.
			 * @return {!number} The number of children in this subtree.
			 */
			function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
			  var type = typeof children;
	
			  if (type === 'undefined' || type === 'boolean') {
			    // All of the above are perceived as null.
			    children = null;
			  }
	
			  if (children === null || type === 'string' || type === 'number' ||
			  // The following is inlined from ReactElement. This means we can optimize
			  // some checks. React Fiber also inlines this logic for similar purposes.
			  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
			    callback(traverseContext, children,
			    // If it's the only child, treat the name as if it was wrapped in an array
			    // so that it's consistent if the number of children grows.
			    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
			    return 1;
			  }
	
			  var child;
			  var nextName;
			  var subtreeCount = 0; // Count of children found in the current subtree.
			  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
			  if (Array.isArray(children)) {
			    for (var i = 0; i < children.length; i++) {
			      child = children[i];
			      nextName = nextNamePrefix + getComponentKey(child, i);
			      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
			    }
			  } else {
			    var iteratorFn = getIteratorFn(children);
			    if (iteratorFn) {
			      var iterator = iteratorFn.call(children);
			      var step;
			      if (iteratorFn !== children.entries) {
			        var ii = 0;
			        while (!(step = iterator.next()).done) {
			          child = step.value;
			          nextName = nextNamePrefix + getComponentKey(child, ii++);
			          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
			        }
			      } else {
			        if (process.env.NODE_ENV !== 'production') {
			          var mapsAsChildrenAddendum = '';
			          if (ReactCurrentOwner.current) {
			            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
			            if (mapsAsChildrenOwnerName) {
			              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
			            }
			          }
			          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
			          didWarnAboutMaps = true;
			        }
			        // Iterator will provide entry [k,v] tuples rather than values.
			        while (!(step = iterator.next()).done) {
			          var entry = step.value;
			          if (entry) {
			            child = entry[1];
			            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
			            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
			          }
			        }
			      }
			    } else if (type === 'object') {
			      var addendum = '';
			      if (process.env.NODE_ENV !== 'production') {
			        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
			        if (children._isReactElement) {
			          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
			        }
			        if (ReactCurrentOwner.current) {
			          var name = ReactCurrentOwner.current.getName();
			          if (name) {
			            addendum += ' Check the render method of `' + name + '`.';
			          }
			        }
			      }
			      var childrenString = String(children);
			       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
			    }
			  }
	
			  return subtreeCount;
			}
	
			/**
			 * Traverses children that are typically specified as `props.children`, but
			 * might also be specified through attributes:
			 *
			 * - `traverseAllChildren(this.props.children, ...)`
			 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
			 *
			 * The `traverseContext` is an optional argument that is passed through the
			 * entire traversal. It can be used to store accumulations or anything else that
			 * the callback might find relevant.
			 *
			 * @param {?*} children Children tree object.
			 * @param {!function} callback To invoke upon traversing each child.
			 * @param {?*} traverseContext Context for traversal.
			 * @return {!number} The number of children in this subtree.
			 */
			function traverseAllChildren(children, callback, traverseContext) {
			  if (children == null) {
			    return 0;
			  }
	
			  return traverseAllChildrenImpl(children, '', callback, traverseContext);
			}
	
			module.exports = traverseAllChildren;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 140 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			// The Symbol used to tag the ReactElement type. If there is no native Symbol
			// nor polyfill, then a plain number is used for performance.
	
			var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
			module.exports = REACT_ELEMENT_TYPE;
	
		/***/ },
		/* 141 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			/* global Symbol */
	
			var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
			var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
			/**
			 * Returns the iterator method function contained on the iterable object.
			 *
			 * Be sure to invoke the function with the iterable as context:
			 *
			 *     var iteratorFn = getIteratorFn(myIterable);
			 *     if (iteratorFn) {
			 *       var iterator = iteratorFn.call(myIterable);
			 *       ...
			 *     }
			 *
			 * @param {?object} maybeIterable
			 * @return {?function}
			 */
			function getIteratorFn(maybeIterable) {
			  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
			  if (typeof iteratorFn === 'function') {
			    return iteratorFn;
			  }
			}
	
			module.exports = getIteratorFn;
	
		/***/ },
		/* 142 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var KeyEscapeUtils = __webpack_require__(138);
			var traverseAllChildren = __webpack_require__(139);
			var warning = __webpack_require__(18);
	
			var ReactComponentTreeHook;
	
			if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
			  // Temporary hack.
			  // Inline requires don't work well with Jest:
			  // https://github.com/facebook/react/issues/7240
			  // Remove the inline requires when we don't need them anymore:
			  // https://github.com/facebook/react/pull/7178
			  ReactComponentTreeHook = __webpack_require__(41);
			}
	
			/**
			 * @param {function} traverseContext Context passed through traversal.
			 * @param {?ReactComponent} child React child component.
			 * @param {!string} name String name of key path to child.
			 * @param {number=} selfDebugID Optional debugID of the current internal instance.
			 */
			function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
			  // We found a component instance.
			  if (traverseContext && typeof traverseContext === 'object') {
			    var result = traverseContext;
			    var keyUnique = result[name] === undefined;
			    if (process.env.NODE_ENV !== 'production') {
			      if (!ReactComponentTreeHook) {
			        ReactComponentTreeHook = __webpack_require__(41);
			      }
			      if (!keyUnique) {
			        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
			      }
			    }
			    if (keyUnique && child != null) {
			      result[name] = child;
			    }
			  }
			}
	
			/**
			 * Flattens children that are typically specified as `props.children`. Any null
			 * children will not be included in the resulting object.
			 * @return {!object} flattened children keyed by name.
			 */
			function flattenChildren(children, selfDebugID) {
			  if (children == null) {
			    return children;
			  }
			  var result = {};
	
			  if (process.env.NODE_ENV !== 'production') {
			    traverseAllChildren(children, function (traverseContext, child, name) {
			      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
			    }, result);
			  } else {
			    traverseAllChildren(children, flattenSingleChildIntoContext, result);
			  }
			  return result;
			}
	
			module.exports = flattenChildren;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 143 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var PooledClass = __webpack_require__(25);
			var Transaction = __webpack_require__(49);
			var ReactInstrumentation = __webpack_require__(37);
			var ReactServerUpdateQueue = __webpack_require__(144);
	
			/**
			 * Executed within the scope of the `Transaction` instance. Consider these as
			 * being member methods, but with an implied ordering while being isolated from
			 * each other.
			 */
			var TRANSACTION_WRAPPERS = [];
	
			if (process.env.NODE_ENV !== 'production') {
			  TRANSACTION_WRAPPERS.push({
			    initialize: ReactInstrumentation.debugTool.onBeginFlush,
			    close: ReactInstrumentation.debugTool.onEndFlush
			  });
			}
	
			var noopCallbackQueue = {
			  enqueue: function () {}
			};
	
			/**
			 * @class ReactServerRenderingTransaction
			 * @param {boolean} renderToStaticMarkup
			 */
			function ReactServerRenderingTransaction(renderToStaticMarkup) {
			  this.reinitializeTransaction();
			  this.renderToStaticMarkup = renderToStaticMarkup;
			  this.useCreateElement = false;
			  this.updateQueue = new ReactServerUpdateQueue(this);
			}
	
			var Mixin = {
			  /**
			   * @see Transaction
			   * @abstract
			   * @final
			   * @return {array} Empty list of operation wrap procedures.
			   */
			  getTransactionWrappers: function () {
			    return TRANSACTION_WRAPPERS;
			  },
	
			  /**
			   * @return {object} The queue to collect `onDOMReady` callbacks with.
			   */
			  getReactMountReady: function () {
			    return noopCallbackQueue;
			  },
	
			  /**
			   * @return {object} The queue to collect React async events.
			   */
			  getUpdateQueue: function () {
			    return this.updateQueue;
			  },
	
			  /**
			   * `PooledClass` looks for this, and will invoke this before allowing this
			   * instance to be reused.
			   */
			  destructor: function () {},
	
			  checkpoint: function () {},
	
			  rollback: function () {}
			};
	
			_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
			PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
			module.exports = ReactServerRenderingTransaction;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 144 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2015-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
			var ReactUpdateQueue = __webpack_require__(145);
	
			var warning = __webpack_require__(18);
	
			function warnNoop(publicInstance, callerName) {
			  if (process.env.NODE_ENV !== 'production') {
			    var constructor = publicInstance.constructor;
			    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
			  }
			}
	
			/**
			 * This is the update queue used for server rendering.
			 * It delegates to ReactUpdateQueue while server rendering is in progress and
			 * switches to ReactNoopUpdateQueue after the transaction has completed.
			 * @class ReactServerUpdateQueue
			 * @param {Transaction} transaction
			 */
	
			var ReactServerUpdateQueue = function () {
			  function ReactServerUpdateQueue(transaction) {
			    _classCallCheck(this, ReactServerUpdateQueue);
	
			    this.transaction = transaction;
			  }
	
			  /**
			   * Checks whether or not this composite component is mounted.
			   * @param {ReactClass} publicInstance The instance we want to test.
			   * @return {boolean} True if mounted, false otherwise.
			   * @protected
			   * @final
			   */
	
	
			  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
			    return false;
			  };
	
			  /**
			   * Enqueue a callback that will be executed after all the pending updates
			   * have processed.
			   *
			   * @param {ReactClass} publicInstance The instance to use as `this` context.
			   * @param {?function} callback Called after state is updated.
			   * @internal
			   */
	
	
			  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
			    if (this.transaction.isInTransaction()) {
			      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
			    }
			  };
	
			  /**
			   * Forces an update. This should only be invoked when it is known with
			   * certainty that we are **not** in a DOM transaction.
			   *
			   * You may want to call this when you know that some deeper aspect of the
			   * component's state has changed but `setState` was not called.
			   *
			   * This will not invoke `shouldComponentUpdate`, but it will invoke
			   * `componentWillUpdate` and `componentDidUpdate`.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @internal
			   */
	
	
			  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
			    if (this.transaction.isInTransaction()) {
			      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
			    } else {
			      warnNoop(publicInstance, 'forceUpdate');
			    }
			  };
	
			  /**
			   * Replaces all of the state. Always use this or `setState` to mutate state.
			   * You should treat `this.state` as immutable.
			   *
			   * There is no guarantee that `this.state` will be immediately updated, so
			   * accessing `this.state` after calling this method may return the old value.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @param {object|function} completeState Next state.
			   * @internal
			   */
	
	
			  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
			    if (this.transaction.isInTransaction()) {
			      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
			    } else {
			      warnNoop(publicInstance, 'replaceState');
			    }
			  };
	
			  /**
			   * Sets a subset of the state. This only exists because _pendingState is
			   * internal. This provides a merging strategy that is not available to deep
			   * properties which is confusing. TODO: Expose pendingState or don't use it
			   * during the merge.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @param {object|function} partialState Next partial state to be merged with state.
			   * @internal
			   */
	
	
			  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
			    if (this.transaction.isInTransaction()) {
			      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
			    } else {
			      warnNoop(publicInstance, 'setState');
			    }
			  };
	
			  return ReactServerUpdateQueue;
			}();
	
			module.exports = ReactServerUpdateQueue;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 145 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2015-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var ReactCurrentOwner = __webpack_require__(43);
			var ReactInstanceMap = __webpack_require__(125);
			var ReactInstrumentation = __webpack_require__(37);
			var ReactUpdates = __webpack_require__(31);
	
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			function enqueueUpdate(internalInstance) {
			  ReactUpdates.enqueueUpdate(internalInstance);
			}
	
			function formatUnexpectedArgument(arg) {
			  var type = typeof arg;
			  if (type !== 'object') {
			    return type;
			  }
			  var displayName = arg.constructor && arg.constructor.name || type;
			  var keys = Object.keys(arg);
			  if (keys.length > 0 && keys.length < 20) {
			    return displayName + ' (keys: ' + keys.join(', ') + ')';
			  }
			  return displayName;
			}
	
			function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
			  var internalInstance = ReactInstanceMap.get(publicInstance);
			  if (!internalInstance) {
			    if (process.env.NODE_ENV !== 'production') {
			      var ctor = publicInstance.constructor;
			      // Only warn when we have a callerName. Otherwise we should be silent.
			      // We're probably calling from enqueueCallback. We don't want to warn
			      // there because we already warned for the corresponding lifecycle method.
			      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
			    }
			    return null;
			  }
	
			  if (process.env.NODE_ENV !== 'production') {
			    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
			  }
	
			  return internalInstance;
			}
	
			/**
			 * ReactUpdateQueue allows for state updates to be scheduled into a later
			 * reconciliation step.
			 */
			var ReactUpdateQueue = {
	
			  /**
			   * Checks whether or not this composite component is mounted.
			   * @param {ReactClass} publicInstance The instance we want to test.
			   * @return {boolean} True if mounted, false otherwise.
			   * @protected
			   * @final
			   */
			  isMounted: function (publicInstance) {
			    if (process.env.NODE_ENV !== 'production') {
			      var owner = ReactCurrentOwner.current;
			      if (owner !== null) {
			        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
			        owner._warnedAboutRefsInRender = true;
			      }
			    }
			    var internalInstance = ReactInstanceMap.get(publicInstance);
			    if (internalInstance) {
			      // During componentWillMount and render this will still be null but after
			      // that will always render to something. At least for now. So we can use
			      // this hack.
			      return !!internalInstance._renderedComponent;
			    } else {
			      return false;
			    }
			  },
	
			  /**
			   * Enqueue a callback that will be executed after all the pending updates
			   * have processed.
			   *
			   * @param {ReactClass} publicInstance The instance to use as `this` context.
			   * @param {?function} callback Called after state is updated.
			   * @param {string} callerName Name of the calling function in the public API.
			   * @internal
			   */
			  enqueueCallback: function (publicInstance, callback, callerName) {
			    ReactUpdateQueue.validateCallback(callback, callerName);
			    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
			    // Previously we would throw an error if we didn't have an internal
			    // instance. Since we want to make it a no-op instead, we mirror the same
			    // behavior we have in other enqueue* methods.
			    // We also need to ignore callbacks in componentWillMount. See
			    // enqueueUpdates.
			    if (!internalInstance) {
			      return null;
			    }
	
			    if (internalInstance._pendingCallbacks) {
			      internalInstance._pendingCallbacks.push(callback);
			    } else {
			      internalInstance._pendingCallbacks = [callback];
			    }
			    // TODO: The callback here is ignored when setState is called from
			    // componentWillMount. Either fix it or disallow doing so completely in
			    // favor of getInitialState. Alternatively, we can disallow
			    // componentWillMount during server-side rendering.
			    enqueueUpdate(internalInstance);
			  },
	
			  enqueueCallbackInternal: function (internalInstance, callback) {
			    if (internalInstance._pendingCallbacks) {
			      internalInstance._pendingCallbacks.push(callback);
			    } else {
			      internalInstance._pendingCallbacks = [callback];
			    }
			    enqueueUpdate(internalInstance);
			  },
	
			  /**
			   * Forces an update. This should only be invoked when it is known with
			   * certainty that we are **not** in a DOM transaction.
			   *
			   * You may want to call this when you know that some deeper aspect of the
			   * component's state has changed but `setState` was not called.
			   *
			   * This will not invoke `shouldComponentUpdate`, but it will invoke
			   * `componentWillUpdate` and `componentDidUpdate`.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @internal
			   */
			  enqueueForceUpdate: function (publicInstance) {
			    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
			    if (!internalInstance) {
			      return;
			    }
	
			    internalInstance._pendingForceUpdate = true;
	
			    enqueueUpdate(internalInstance);
			  },
	
			  /**
			   * Replaces all of the state. Always use this or `setState` to mutate state.
			   * You should treat `this.state` as immutable.
			   *
			   * There is no guarantee that `this.state` will be immediately updated, so
			   * accessing `this.state` after calling this method may return the old value.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @param {object} completeState Next state.
			   * @internal
			   */
			  enqueueReplaceState: function (publicInstance, completeState, callback) {
			    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
			    if (!internalInstance) {
			      return;
			    }
	
			    internalInstance._pendingStateQueue = [completeState];
			    internalInstance._pendingReplaceState = true;
	
			    // Future-proof 15.5
			    if (callback !== undefined && callback !== null) {
			      ReactUpdateQueue.validateCallback(callback, 'replaceState');
			      if (internalInstance._pendingCallbacks) {
			        internalInstance._pendingCallbacks.push(callback);
			      } else {
			        internalInstance._pendingCallbacks = [callback];
			      }
			    }
	
			    enqueueUpdate(internalInstance);
			  },
	
			  /**
			   * Sets a subset of the state. This only exists because _pendingState is
			   * internal. This provides a merging strategy that is not available to deep
			   * properties which is confusing. TODO: Expose pendingState or don't use it
			   * during the merge.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @param {object} partialState Next partial state to be merged with state.
			   * @internal
			   */
			  enqueueSetState: function (publicInstance, partialState) {
			    if (process.env.NODE_ENV !== 'production') {
			      ReactInstrumentation.debugTool.onSetState();
			      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
			    }
	
			    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
			    if (!internalInstance) {
			      return;
			    }
	
			    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
			    queue.push(partialState);
	
			    enqueueUpdate(internalInstance);
			  },
	
			  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
			    internalInstance._pendingElement = nextElement;
			    // TODO: introduce _pendingContext instead of setting it directly.
			    internalInstance._context = nextContext;
			    enqueueUpdate(internalInstance);
			  },
	
			  validateCallback: function (callback, callerName) {
			    !(!callback || typeof callback === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
			  }
	
			};
	
			module.exports = ReactUpdateQueue;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 146 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2015-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var emptyFunction = __webpack_require__(19);
			var warning = __webpack_require__(18);
	
			var validateDOMNesting = emptyFunction;
	
			if (process.env.NODE_ENV !== 'production') {
			  // This validation code was written based on the HTML5 parsing spec:
			  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
			  //
			  // Note: this does not catch all invalid nesting, nor does it try to (as it's
			  // not clear what practical benefit doing so provides); instead, we warn only
			  // for cases where the parser will give a parse tree differing from what React
			  // intended. For example, <b><div></div></b> is invalid but we don't warn
			  // because it still parses correctly; we do warn for other cases like nested
			  // <p> tags where the beginning of the second element implicitly closes the
			  // first, causing a confusing mess.
	
			  // https://html.spec.whatwg.org/multipage/syntax.html#special
			  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
			  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
			  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
			  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
			  // TODO: Distinguish by namespace here -- for <title>, including it here
			  // errs on the side of fewer warnings
			  'foreignObject', 'desc', 'title'];
	
			  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
			  var buttonScopeTags = inScopeTags.concat(['button']);
	
			  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
			  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
			  var emptyAncestorInfo = {
			    current: null,
	
			    formTag: null,
			    aTagInScope: null,
			    buttonTagInScope: null,
			    nobrTagInScope: null,
			    pTagInButtonScope: null,
	
			    listItemTagAutoclosing: null,
			    dlItemTagAutoclosing: null
			  };
	
			  var updatedAncestorInfo = function (oldInfo, tag, instance) {
			    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
			    var info = { tag: tag, instance: instance };
	
			    if (inScopeTags.indexOf(tag) !== -1) {
			      ancestorInfo.aTagInScope = null;
			      ancestorInfo.buttonTagInScope = null;
			      ancestorInfo.nobrTagInScope = null;
			    }
			    if (buttonScopeTags.indexOf(tag) !== -1) {
			      ancestorInfo.pTagInButtonScope = null;
			    }
	
			    // See rules for 'li', 'dd', 'dt' start tags in
			    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
			    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
			      ancestorInfo.listItemTagAutoclosing = null;
			      ancestorInfo.dlItemTagAutoclosing = null;
			    }
	
			    ancestorInfo.current = info;
	
			    if (tag === 'form') {
			      ancestorInfo.formTag = info;
			    }
			    if (tag === 'a') {
			      ancestorInfo.aTagInScope = info;
			    }
			    if (tag === 'button') {
			      ancestorInfo.buttonTagInScope = info;
			    }
			    if (tag === 'nobr') {
			      ancestorInfo.nobrTagInScope = info;
			    }
			    if (tag === 'p') {
			      ancestorInfo.pTagInButtonScope = info;
			    }
			    if (tag === 'li') {
			      ancestorInfo.listItemTagAutoclosing = info;
			    }
			    if (tag === 'dd' || tag === 'dt') {
			      ancestorInfo.dlItemTagAutoclosing = info;
			    }
	
			    return ancestorInfo;
			  };
	
			  /**
			   * Returns whether
			   */
			  var isTagValidWithParent = function (tag, parentTag) {
			    // First, let's check if we're in an unusual parsing mode...
			    switch (parentTag) {
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
			      case 'select':
			        return tag === 'option' || tag === 'optgroup' || tag === '#text';
			      case 'optgroup':
			        return tag === 'option' || tag === '#text';
			      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
			      // but
			      case 'option':
			        return tag === '#text';
	
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
			      // No special behavior since these rules fall back to "in body" mode for
			      // all except special table nodes which cause bad parsing behavior anyway.
	
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
			      case 'tr':
			        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
			      case 'tbody':
			      case 'thead':
			      case 'tfoot':
			        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
			      case 'colgroup':
			        return tag === 'col' || tag === 'template';
	
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
			      case 'table':
			        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
			      case 'head':
			        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
			      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
			      case 'html':
			        return tag === 'head' || tag === 'body';
			      case '#document':
			        return tag === 'html';
			    }
	
			    // Probably in the "in body" parsing mode, so we outlaw only tag combos
			    // where the parsing rules cause implicit opens or closes to be added.
			    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
			    switch (tag) {
			      case 'h1':
			      case 'h2':
			      case 'h3':
			      case 'h4':
			      case 'h5':
			      case 'h6':
			        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
			      case 'rp':
			      case 'rt':
			        return impliedEndTags.indexOf(parentTag) === -1;
	
			      case 'body':
			      case 'caption':
			      case 'col':
			      case 'colgroup':
			      case 'frame':
			      case 'head':
			      case 'html':
			      case 'tbody':
			      case 'td':
			      case 'tfoot':
			      case 'th':
			      case 'thead':
			      case 'tr':
			        // These tags are only valid with a few parents that have special child
			        // parsing rules -- if we're down here, then none of those matched and
			        // so we allow it only if we don't know what the parent is, as all other
			        // cases are invalid.
			        return parentTag == null;
			    }
	
			    return true;
			  };
	
			  /**
			   * Returns whether
			   */
			  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
			    switch (tag) {
			      case 'address':
			      case 'article':
			      case 'aside':
			      case 'blockquote':
			      case 'center':
			      case 'details':
			      case 'dialog':
			      case 'dir':
			      case 'div':
			      case 'dl':
			      case 'fieldset':
			      case 'figcaption':
			      case 'figure':
			      case 'footer':
			      case 'header':
			      case 'hgroup':
			      case 'main':
			      case 'menu':
			      case 'nav':
			      case 'ol':
			      case 'p':
			      case 'section':
			      case 'summary':
			      case 'ul':
			      case 'pre':
			      case 'listing':
			      case 'table':
			      case 'hr':
			      case 'xmp':
			      case 'h1':
			      case 'h2':
			      case 'h3':
			      case 'h4':
			      case 'h5':
			      case 'h6':
			        return ancestorInfo.pTagInButtonScope;
	
			      case 'form':
			        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
			      case 'li':
			        return ancestorInfo.listItemTagAutoclosing;
	
			      case 'dd':
			      case 'dt':
			        return ancestorInfo.dlItemTagAutoclosing;
	
			      case 'button':
			        return ancestorInfo.buttonTagInScope;
	
			      case 'a':
			        // Spec says something about storing a list of markers, but it sounds
			        // equivalent to this check.
			        return ancestorInfo.aTagInScope;
	
			      case 'nobr':
			        return ancestorInfo.nobrTagInScope;
			    }
	
			    return null;
			  };
	
			  /**
			   * Given a ReactCompositeComponent instance, return a list of its recursive
			   * owners, starting at the root and ending with the instance itself.
			   */
			  var findOwnerStack = function (instance) {
			    if (!instance) {
			      return [];
			    }
	
			    var stack = [];
			    do {
			      stack.push(instance);
			    } while (instance = instance._currentElement._owner);
			    stack.reverse();
			    return stack;
			  };
	
			  var didWarn = {};
	
			  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
			    ancestorInfo = ancestorInfo || emptyAncestorInfo;
			    var parentInfo = ancestorInfo.current;
			    var parentTag = parentInfo && parentInfo.tag;
	
			    if (childText != null) {
			      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
			      childTag = '#text';
			    }
	
			    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
			    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
			    var problematic = invalidParent || invalidAncestor;
	
			    if (problematic) {
			      var ancestorTag = problematic.tag;
			      var ancestorInstance = problematic.instance;
	
			      var childOwner = childInstance && childInstance._currentElement._owner;
			      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
			      var childOwners = findOwnerStack(childOwner);
			      var ancestorOwners = findOwnerStack(ancestorOwner);
	
			      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
			      var i;
	
			      var deepestCommon = -1;
			      for (i = 0; i < minStackLen; i++) {
			        if (childOwners[i] === ancestorOwners[i]) {
			          deepestCommon = i;
			        } else {
			          break;
			        }
			      }
	
			      var UNKNOWN = '(unknown)';
			      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
			        return inst.getName() || UNKNOWN;
			      });
			      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
			        return inst.getName() || UNKNOWN;
			      });
			      var ownerInfo = [].concat(
			      // If the parent and child instances have a common owner ancestor, start
			      // with that -- otherwise we just start with the parent's owners.
			      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
			      // If we're warning about an invalid (non-parent) ancestry, add '...'
			      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
			      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
			      if (didWarn[warnKey]) {
			        return;
			      }
			      didWarn[warnKey] = true;
	
			      var tagDisplayName = childTag;
			      var whitespaceInfo = '';
			      if (childTag === '#text') {
			        if (/\S/.test(childText)) {
			          tagDisplayName = 'Text nodes';
			        } else {
			          tagDisplayName = 'Whitespace text nodes';
			          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
			        }
			      } else {
			        tagDisplayName = '<' + childTag + '>';
			      }
	
			      if (invalidParent) {
			        var info = '';
			        if (ancestorTag === 'table' && childTag === 'tr') {
			          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
			        }
			        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
			      } else {
			        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
			      }
			    }
			  };
	
			  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
			  // For testing
			  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
			    ancestorInfo = ancestorInfo || emptyAncestorInfo;
			    var parentInfo = ancestorInfo.current;
			    var parentTag = parentInfo && parentInfo.tag;
			    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
			  };
			}
	
			module.exports = validateDOMNesting;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 147 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var DOMLazyTree = __webpack_require__(62);
			var ReactDOMComponentTree = __webpack_require__(5);
	
			var ReactDOMEmptyComponent = function (instantiate) {
			  // ReactCompositeComponent uses this:
			  this._currentElement = null;
			  // ReactDOMComponentTree uses these:
			  this._hostNode = null;
			  this._hostParent = null;
			  this._hostContainerInfo = null;
			  this._domID = 0;
			};
			_assign(ReactDOMEmptyComponent.prototype, {
			  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
			    var domID = hostContainerInfo._idCounter++;
			    this._domID = domID;
			    this._hostParent = hostParent;
			    this._hostContainerInfo = hostContainerInfo;
	
			    var nodeValue = ' react-empty: ' + this._domID + ' ';
			    if (transaction.useCreateElement) {
			      var ownerDocument = hostContainerInfo._ownerDocument;
			      var node = ownerDocument.createComment(nodeValue);
			      ReactDOMComponentTree.precacheNode(this, node);
			      return DOMLazyTree(node);
			    } else {
			      if (transaction.renderToStaticMarkup) {
			        // Normally we'd insert a comment node, but since this is a situation
			        // where React won't take over (static pages), we can simply return
			        // nothing.
			        return '';
			      }
			      return '<!--' + nodeValue + '-->';
			    }
			  },
			  receiveComponent: function () {},
			  getHostNode: function () {
			    return ReactDOMComponentTree.getNodeFromInstance(this);
			  },
			  unmountComponent: function () {
			    ReactDOMComponentTree.uncacheNode(this);
			  }
			});
	
			module.exports = ReactDOMEmptyComponent;
	
		/***/ },
		/* 148 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2015-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * Return the lowest common ancestor of A and B, or null if they are in
			 * different trees.
			 */
			function getLowestCommonAncestor(instA, instB) {
			  !('_hostNode' in instA) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
			  !('_hostNode' in instB) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
			  var depthA = 0;
			  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
			    depthA++;
			  }
			  var depthB = 0;
			  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
			    depthB++;
			  }
	
			  // If A is deeper, crawl up.
			  while (depthA - depthB > 0) {
			    instA = instA._hostParent;
			    depthA--;
			  }
	
			  // If B is deeper, crawl up.
			  while (depthB - depthA > 0) {
			    instB = instB._hostParent;
			    depthB--;
			  }
	
			  // Walk in lockstep until we find a match.
			  var depth = depthA;
			  while (depth--) {
			    if (instA === instB) {
			      return instA;
			    }
			    instA = instA._hostParent;
			    instB = instB._hostParent;
			  }
			  return null;
			}
	
			/**
			 * Return if A is an ancestor of B.
			 */
			function isAncestor(instA, instB) {
			  !('_hostNode' in instA) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
			  !('_hostNode' in instB) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
			  while (instB) {
			    if (instB === instA) {
			      return true;
			    }
			    instB = instB._hostParent;
			  }
			  return false;
			}
	
			/**
			 * Return the parent instance of the passed-in instance.
			 */
			function getParentInstance(inst) {
			  !('_hostNode' in inst) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
			  return inst._hostParent;
			}
	
			/**
			 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
			 */
			function traverseTwoPhase(inst, fn, arg) {
			  var path = [];
			  while (inst) {
			    path.push(inst);
			    inst = inst._hostParent;
			  }
			  var i;
			  for (i = path.length; i-- > 0;) {
			    fn(path[i], 'captured', arg);
			  }
			  for (i = 0; i < path.length; i++) {
			    fn(path[i], 'bubbled', arg);
			  }
			}
	
			/**
			 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
			 * should would receive a `mouseEnter` or `mouseLeave` event.
			 *
			 * Does not invoke the callback on the nearest common ancestor because nothing
			 * "entered" or "left" that element.
			 */
			function traverseEnterLeave(from, to, fn, argFrom, argTo) {
			  var common = from && to ? getLowestCommonAncestor(from, to) : null;
			  var pathFrom = [];
			  while (from && from !== common) {
			    pathFrom.push(from);
			    from = from._hostParent;
			  }
			  var pathTo = [];
			  while (to && to !== common) {
			    pathTo.push(to);
			    to = to._hostParent;
			  }
			  var i;
			  for (i = 0; i < pathFrom.length; i++) {
			    fn(pathFrom[i], 'bubbled', argFrom);
			  }
			  for (i = pathTo.length; i-- > 0;) {
			    fn(pathTo[i], 'captured', argTo);
			  }
			}
	
			module.exports = {
			  isAncestor: isAncestor,
			  getLowestCommonAncestor: getLowestCommonAncestor,
			  getParentInstance: getParentInstance,
			  traverseTwoPhase: traverseTwoPhase,
			  traverseEnterLeave: traverseEnterLeave
			};
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 149 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6),
			    _assign = __webpack_require__(24);
	
			var DOMChildrenOperations = __webpack_require__(61);
			var DOMLazyTree = __webpack_require__(62);
			var ReactDOMComponentTree = __webpack_require__(5);
	
			var escapeTextContentForBrowser = __webpack_require__(67);
			var invariant = __webpack_require__(8);
			var validateDOMNesting = __webpack_require__(146);
	
			/**
			 * Text nodes violate a couple assumptions that React makes about components:
			 *
			 *  - When mounting text into the DOM, adjacent text nodes are merged.
			 *  - Text nodes cannot be assigned a React root ID.
			 *
			 * This component is used to wrap strings between comment nodes so that they
			 * can undergo the same reconciliation that is applied to elements.
			 *
			 * TODO: Investigate representing React components in the DOM with text nodes.
			 *
			 * @class ReactDOMTextComponent
			 * @extends ReactComponent
			 * @internal
			 */
			var ReactDOMTextComponent = function (text) {
			  // TODO: This is really a ReactText (ReactNode), not a ReactElement
			  this._currentElement = text;
			  this._stringText = '' + text;
			  // ReactDOMComponentTree uses these:
			  this._hostNode = null;
			  this._hostParent = null;
	
			  // Properties
			  this._domID = 0;
			  this._mountIndex = 0;
			  this._closingComment = null;
			  this._commentNodes = null;
			};
	
			_assign(ReactDOMTextComponent.prototype, {
	
			  /**
			   * Creates the markup for this text node. This node is not intended to have
			   * any features besides containing text content.
			   *
			   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
			   * @return {string} Markup for this text node.
			   * @internal
			   */
			  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
			    if (process.env.NODE_ENV !== 'production') {
			      var parentInfo;
			      if (hostParent != null) {
			        parentInfo = hostParent._ancestorInfo;
			      } else if (hostContainerInfo != null) {
			        parentInfo = hostContainerInfo._ancestorInfo;
			      }
			      if (parentInfo) {
			        // parentInfo should always be present except for the top-level
			        // component when server rendering
			        validateDOMNesting(null, this._stringText, this, parentInfo);
			      }
			    }
	
			    var domID = hostContainerInfo._idCounter++;
			    var openingValue = ' react-text: ' + domID + ' ';
			    var closingValue = ' /react-text ';
			    this._domID = domID;
			    this._hostParent = hostParent;
			    if (transaction.useCreateElement) {
			      var ownerDocument = hostContainerInfo._ownerDocument;
			      var openingComment = ownerDocument.createComment(openingValue);
			      var closingComment = ownerDocument.createComment(closingValue);
			      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
			      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
			      if (this._stringText) {
			        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
			      }
			      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
			      ReactDOMComponentTree.precacheNode(this, openingComment);
			      this._closingComment = closingComment;
			      return lazyTree;
			    } else {
			      var escapedText = escapeTextContentForBrowser(this._stringText);
	
			      if (transaction.renderToStaticMarkup) {
			        // Normally we'd wrap this between comment nodes for the reasons stated
			        // above, but since this is a situation where React won't take over
			        // (static pages), we can simply return the text as it is.
			        return escapedText;
			      }
	
			      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
			    }
			  },
	
			  /**
			   * Updates this component by updating the text content.
			   *
			   * @param {ReactText} nextText The next text content
			   * @param {ReactReconcileTransaction} transaction
			   * @internal
			   */
			  receiveComponent: function (nextText, transaction) {
			    if (nextText !== this._currentElement) {
			      this._currentElement = nextText;
			      var nextStringText = '' + nextText;
			      if (nextStringText !== this._stringText) {
			        // TODO: Save this as pending props and use performUpdateIfNecessary
			        // and/or updateComponent to do the actual update for consistency with
			        // other component types?
			        this._stringText = nextStringText;
			        var commentNodes = this.getHostNode();
			        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
			      }
			    }
			  },
	
			  getHostNode: function () {
			    var hostNode = this._commentNodes;
			    if (hostNode) {
			      return hostNode;
			    }
			    if (!this._closingComment) {
			      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
			      var node = openingComment.nextSibling;
			      while (true) {
			        !(node != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
			        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
			          this._closingComment = node;
			          break;
			        }
			        node = node.nextSibling;
			      }
			    }
			    hostNode = [this._hostNode, this._closingComment];
			    this._commentNodes = hostNode;
			    return hostNode;
			  },
	
			  unmountComponent: function () {
			    this._closingComment = null;
			    this._commentNodes = null;
			    ReactDOMComponentTree.uncacheNode(this);
			  }
	
			});
	
			module.exports = ReactDOMTextComponent;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 150 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var ReactUpdates = __webpack_require__(31);
			var Transaction = __webpack_require__(49);
	
			var emptyFunction = __webpack_require__(19);
	
			var RESET_BATCHED_UPDATES = {
			  initialize: emptyFunction,
			  close: function () {
			    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
			  }
			};
	
			var FLUSH_BATCHED_UPDATES = {
			  initialize: emptyFunction,
			  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
			};
	
			var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
			function ReactDefaultBatchingStrategyTransaction() {
			  this.reinitializeTransaction();
			}
	
			_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
			  getTransactionWrappers: function () {
			    return TRANSACTION_WRAPPERS;
			  }
			});
	
			var transaction = new ReactDefaultBatchingStrategyTransaction();
	
			var ReactDefaultBatchingStrategy = {
			  isBatchingUpdates: false,
	
			  /**
			   * Call the provided function in a context within which calls to `setState`
			   * and friends are batched such that components aren't updated unnecessarily.
			   */
			  batchedUpdates: function (callback, a, b, c, d, e) {
			    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
			    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
			    // The code is written this way to avoid extra allocations
			    if (alreadyBatchingUpdates) {
			      return callback(a, b, c, d, e);
			    } else {
			      return transaction.perform(callback, null, a, b, c, d, e);
			    }
			  }
			};
	
			module.exports = ReactDefaultBatchingStrategy;
	
		/***/ },
		/* 151 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var EventListener = __webpack_require__(152);
			var ExecutionEnvironment = __webpack_require__(22);
			var PooledClass = __webpack_require__(25);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactUpdates = __webpack_require__(31);
	
			var getEventTarget = __webpack_require__(50);
			var getUnboundedScrollPosition = __webpack_require__(153);
	
			/**
			 * Find the deepest React component completely containing the root of the
			 * passed-in instance (for use when entire React trees are nested within each
			 * other). If React trees are not nested, returns null.
			 */
			function findParent(inst) {
			  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
			  // traversal, but caching is difficult to do correctly without using a
			  // mutation observer to listen for all DOM changes.
			  while (inst._hostParent) {
			    inst = inst._hostParent;
			  }
			  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
			  var container = rootNode.parentNode;
			  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
			}
	
			// Used to store ancestor hierarchy in top level callback
			function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
			  this.topLevelType = topLevelType;
			  this.nativeEvent = nativeEvent;
			  this.ancestors = [];
			}
			_assign(TopLevelCallbackBookKeeping.prototype, {
			  destructor: function () {
			    this.topLevelType = null;
			    this.nativeEvent = null;
			    this.ancestors.length = 0;
			  }
			});
			PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
			function handleTopLevelImpl(bookKeeping) {
			  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
			  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
			  // Loop through the hierarchy, in case there's any nested components.
			  // It's important that we build the array of ancestors before calling any
			  // event handlers, because event handlers can modify the DOM, leading to
			  // inconsistencies with ReactMount's node cache. See #1105.
			  var ancestor = targetInst;
			  do {
			    bookKeeping.ancestors.push(ancestor);
			    ancestor = ancestor && findParent(ancestor);
			  } while (ancestor);
	
			  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
			    targetInst = bookKeeping.ancestors[i];
			    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
			  }
			}
	
			function scrollValueMonitor(cb) {
			  var scrollPosition = getUnboundedScrollPosition(window);
			  cb(scrollPosition);
			}
	
			var ReactEventListener = {
			  _enabled: true,
			  _handleTopLevel: null,
	
			  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
			  setHandleTopLevel: function (handleTopLevel) {
			    ReactEventListener._handleTopLevel = handleTopLevel;
			  },
	
			  setEnabled: function (enabled) {
			    ReactEventListener._enabled = !!enabled;
			  },
	
			  isEnabled: function () {
			    return ReactEventListener._enabled;
			  },
	
			  /**
			   * Traps top-level events by using event bubbling.
			   *
			   * @param {string} topLevelType Record from `EventConstants`.
			   * @param {string} handlerBaseName Event name (e.g. "click").
			   * @param {object} element Element on which to attach listener.
			   * @return {?object} An object with a remove function which will forcefully
			   *                  remove the listener.
			   * @internal
			   */
			  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
			    if (!element) {
			      return null;
			    }
			    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
			  },
	
			  /**
			   * Traps a top-level event by using event capturing.
			   *
			   * @param {string} topLevelType Record from `EventConstants`.
			   * @param {string} handlerBaseName Event name (e.g. "click").
			   * @param {object} element Element on which to attach listener.
			   * @return {?object} An object with a remove function which will forcefully
			   *                  remove the listener.
			   * @internal
			   */
			  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
			    if (!element) {
			      return null;
			    }
			    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
			  },
	
			  monitorScrollValue: function (refresh) {
			    var callback = scrollValueMonitor.bind(null, refresh);
			    EventListener.listen(window, 'scroll', callback);
			  },
	
			  dispatchEvent: function (topLevelType, nativeEvent) {
			    if (!ReactEventListener._enabled) {
			      return;
			    }
	
			    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
			    try {
			      // Event queue being processed in the same cycle allows
			      // `preventDefault`.
			      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
			    } finally {
			      TopLevelCallbackBookKeeping.release(bookKeeping);
			    }
			  }
			};
	
			module.exports = ReactEventListener;
	
		/***/ },
		/* 152 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 *
			 * Licensed under the Apache License, Version 2.0 (the "License");
			 * you may not use this file except in compliance with the License.
			 * You may obtain a copy of the License at
			 *
			 * http://www.apache.org/licenses/LICENSE-2.0
			 *
			 * Unless required by applicable law or agreed to in writing, software
			 * distributed under the License is distributed on an "AS IS" BASIS,
			 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
			 * See the License for the specific language governing permissions and
			 * limitations under the License.
			 *
			 * @typechecks
			 */
	
			var emptyFunction = __webpack_require__(19);
	
			/**
			 * Upstream version of event listener. Does not take into account specific
			 * nature of platform.
			 */
			var EventListener = {
			  /**
			   * Listen to DOM events during the bubble phase.
			   *
			   * @param {DOMEventTarget} target DOM element to register listener on.
			   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
			   * @param {function} callback Callback function.
			   * @return {object} Object with a `remove` method.
			   */
			  listen: function listen(target, eventType, callback) {
			    if (target.addEventListener) {
			      target.addEventListener(eventType, callback, false);
			      return {
			        remove: function remove() {
			          target.removeEventListener(eventType, callback, false);
			        }
			      };
			    } else if (target.attachEvent) {
			      target.attachEvent('on' + eventType, callback);
			      return {
			        remove: function remove() {
			          target.detachEvent('on' + eventType, callback);
			        }
			      };
			    }
			  },
	
			  /**
			   * Listen to DOM events during the capture phase.
			   *
			   * @param {DOMEventTarget} target DOM element to register listener on.
			   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
			   * @param {function} callback Callback function.
			   * @return {object} Object with a `remove` method.
			   */
			  capture: function capture(target, eventType, callback) {
			    if (target.addEventListener) {
			      target.addEventListener(eventType, callback, true);
			      return {
			        remove: function remove() {
			          target.removeEventListener(eventType, callback, true);
			        }
			      };
			    } else {
			      if (process.env.NODE_ENV !== 'production') {
			        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
			      }
			      return {
			        remove: emptyFunction
			      };
			    }
			  },
	
			  registerDefault: function registerDefault() {}
			};
	
			module.exports = EventListener;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 153 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			'use strict';
	
			/**
			 * Gets the scroll position of the supplied element or window.
			 *
			 * The return values are unbounded, unlike `getScrollPosition`. This means they
			 * may be negative or exceed the element boundaries (which is possible using
			 * inertial scrolling).
			 *
			 * @param {DOMWindow|DOMElement} scrollable
			 * @return {object} Map with `x` and `y` keys.
			 */
	
			function getUnboundedScrollPosition(scrollable) {
			  if (scrollable.Window && scrollable instanceof scrollable.Window) {
			    return {
			      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
			      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
			    };
			  }
			  return {
			    x: scrollable.scrollLeft,
			    y: scrollable.scrollTop
			  };
			}
	
			module.exports = getUnboundedScrollPosition;
	
		/***/ },
		/* 154 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMProperty = __webpack_require__(7);
			var EventPluginHub = __webpack_require__(14);
			var EventPluginUtils = __webpack_require__(16);
			var ReactComponentEnvironment = __webpack_require__(124);
			var ReactEmptyComponent = __webpack_require__(135);
			var ReactBrowserEventEmitter = __webpack_require__(86);
			var ReactHostComponent = __webpack_require__(136);
			var ReactUpdates = __webpack_require__(31);
	
			var ReactInjection = {
			  Component: ReactComponentEnvironment.injection,
			  DOMProperty: DOMProperty.injection,
			  EmptyComponent: ReactEmptyComponent.injection,
			  EventPluginHub: EventPluginHub.injection,
			  EventPluginUtils: EventPluginUtils.injection,
			  EventEmitter: ReactBrowserEventEmitter.injection,
			  HostComponent: ReactHostComponent.injection,
			  Updates: ReactUpdates.injection
			};
	
			module.exports = ReactInjection;
	
		/***/ },
		/* 155 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var CallbackQueue = __webpack_require__(32);
			var PooledClass = __webpack_require__(25);
			var ReactBrowserEventEmitter = __webpack_require__(86);
			var ReactInputSelection = __webpack_require__(156);
			var ReactInstrumentation = __webpack_require__(37);
			var Transaction = __webpack_require__(49);
			var ReactUpdateQueue = __webpack_require__(145);
	
			/**
			 * Ensures that, when possible, the selection range (currently selected text
			 * input) is not disturbed by performing the transaction.
			 */
			var SELECTION_RESTORATION = {
			  /**
			   * @return {Selection} Selection information.
			   */
			  initialize: ReactInputSelection.getSelectionInformation,
			  /**
			   * @param {Selection} sel Selection information returned from `initialize`.
			   */
			  close: ReactInputSelection.restoreSelection
			};
	
			/**
			 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
			 * high level DOM manipulations (like temporarily removing a text input from the
			 * DOM).
			 */
			var EVENT_SUPPRESSION = {
			  /**
			   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
			   * the reconciliation.
			   */
			  initialize: function () {
			    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
			    ReactBrowserEventEmitter.setEnabled(false);
			    return currentlyEnabled;
			  },
	
			  /**
			   * @param {boolean} previouslyEnabled Enabled status of
			   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
			   *   restores the previous value.
			   */
			  close: function (previouslyEnabled) {
			    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
			  }
			};
	
			/**
			 * Provides a queue for collecting `componentDidMount` and
			 * `componentDidUpdate` callbacks during the transaction.
			 */
			var ON_DOM_READY_QUEUEING = {
			  /**
			   * Initializes the internal `onDOMReady` queue.
			   */
			  initialize: function () {
			    this.reactMountReady.reset();
			  },
	
			  /**
			   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
			   */
			  close: function () {
			    this.reactMountReady.notifyAll();
			  }
			};
	
			/**
			 * Executed within the scope of the `Transaction` instance. Consider these as
			 * being member methods, but with an implied ordering while being isolated from
			 * each other.
			 */
			var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
			if (process.env.NODE_ENV !== 'production') {
			  TRANSACTION_WRAPPERS.push({
			    initialize: ReactInstrumentation.debugTool.onBeginFlush,
			    close: ReactInstrumentation.debugTool.onEndFlush
			  });
			}
	
			/**
			 * Currently:
			 * - The order that these are listed in the transaction is critical:
			 * - Suppresses events.
			 * - Restores selection range.
			 *
			 * Future:
			 * - Restore document/overflow scroll positions that were unintentionally
			 *   modified via DOM insertions above the top viewport boundary.
			 * - Implement/integrate with customized constraint based layout system and keep
			 *   track of which dimensions must be remeasured.
			 *
			 * @class ReactReconcileTransaction
			 */
			function ReactReconcileTransaction(useCreateElement) {
			  this.reinitializeTransaction();
			  // Only server-side rendering really needs this option (see
			  // `ReactServerRendering`), but server-side uses
			  // `ReactServerRenderingTransaction` instead. This option is here so that it's
			  // accessible and defaults to false when `ReactDOMComponent` and
			  // `ReactDOMTextComponent` checks it in `mountComponent`.`
			  this.renderToStaticMarkup = false;
			  this.reactMountReady = CallbackQueue.getPooled(null);
			  this.useCreateElement = useCreateElement;
			}
	
			var Mixin = {
			  /**
			   * @see Transaction
			   * @abstract
			   * @final
			   * @return {array<object>} List of operation wrap procedures.
			   *   TODO: convert to array<TransactionWrapper>
			   */
			  getTransactionWrappers: function () {
			    return TRANSACTION_WRAPPERS;
			  },
	
			  /**
			   * @return {object} The queue to collect `onDOMReady` callbacks with.
			   */
			  getReactMountReady: function () {
			    return this.reactMountReady;
			  },
	
			  /**
			   * @return {object} The queue to collect React async events.
			   */
			  getUpdateQueue: function () {
			    return ReactUpdateQueue;
			  },
	
			  /**
			   * Save current transaction state -- if the return value from this method is
			   * passed to `rollback`, the transaction will be reset to that state.
			   */
			  checkpoint: function () {
			    // reactMountReady is the our only stateful wrapper
			    return this.reactMountReady.checkpoint();
			  },
	
			  rollback: function (checkpoint) {
			    this.reactMountReady.rollback(checkpoint);
			  },
	
			  /**
			   * `PooledClass` looks for this, and will invoke this before allowing this
			   * instance to be reused.
			   */
			  destructor: function () {
			    CallbackQueue.release(this.reactMountReady);
			    this.reactMountReady = null;
			  }
			};
	
			_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
			PooledClass.addPoolingTo(ReactReconcileTransaction);
	
			module.exports = ReactReconcileTransaction;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 156 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactDOMSelection = __webpack_require__(157);
	
			var containsNode = __webpack_require__(159);
			var focusNode = __webpack_require__(75);
			var getActiveElement = __webpack_require__(162);
	
			function isInDocument(node) {
			  return containsNode(document.documentElement, node);
			}
	
			/**
			 * @ReactInputSelection: React input selection module. Based on Selection.js,
			 * but modified to be suitable for react and has a couple of bug fixes (doesn't
			 * assume buttons have range selections allowed).
			 * Input selection module for React.
			 */
			var ReactInputSelection = {
	
			  hasSelectionCapabilities: function (elem) {
			    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
			    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
			  },
	
			  getSelectionInformation: function () {
			    var focusedElem = getActiveElement();
			    return {
			      focusedElem: focusedElem,
			      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
			    };
			  },
	
			  /**
			   * @restoreSelection: If any selection information was potentially lost,
			   * restore it. This is useful when performing operations that could remove dom
			   * nodes and place them back in, resulting in focus being lost.
			   */
			  restoreSelection: function (priorSelectionInformation) {
			    var curFocusedElem = getActiveElement();
			    var priorFocusedElem = priorSelectionInformation.focusedElem;
			    var priorSelectionRange = priorSelectionInformation.selectionRange;
			    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
			      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
			        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
			      }
			      focusNode(priorFocusedElem);
			    }
			  },
	
			  /**
			   * @getSelection: Gets the selection bounds of a focused textarea, input or
			   * contentEditable node.
			   * -@input: Look up selection bounds of this input
			   * -@return {start: selectionStart, end: selectionEnd}
			   */
			  getSelection: function (input) {
			    var selection;
	
			    if ('selectionStart' in input) {
			      // Modern browser with input or textarea.
			      selection = {
			        start: input.selectionStart,
			        end: input.selectionEnd
			      };
			    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
			      // IE8 input.
			      var range = document.selection.createRange();
			      // There can only be one selection per document in IE, so it must
			      // be in our element.
			      if (range.parentElement() === input) {
			        selection = {
			          start: -range.moveStart('character', -input.value.length),
			          end: -range.moveEnd('character', -input.value.length)
			        };
			      }
			    } else {
			      // Content editable or old IE textarea.
			      selection = ReactDOMSelection.getOffsets(input);
			    }
	
			    return selection || { start: 0, end: 0 };
			  },
	
			  /**
			   * @setSelection: Sets the selection bounds of a textarea or input and focuses
			   * the input.
			   * -@input     Set selection bounds of this input or textarea
			   * -@offsets   Object of same form that is returned from get*
			   */
			  setSelection: function (input, offsets) {
			    var start = offsets.start;
			    var end = offsets.end;
			    if (end === undefined) {
			      end = start;
			    }
	
			    if ('selectionStart' in input) {
			      input.selectionStart = start;
			      input.selectionEnd = Math.min(end, input.value.length);
			    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
			      var range = input.createTextRange();
			      range.collapse(true);
			      range.moveStart('character', start);
			      range.moveEnd('character', end - start);
			      range.select();
			    } else {
			      ReactDOMSelection.setOffsets(input, offsets);
			    }
			  }
			};
	
			module.exports = ReactInputSelection;
	
		/***/ },
		/* 157 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ExecutionEnvironment = __webpack_require__(22);
	
			var getNodeForCharacterOffset = __webpack_require__(158);
			var getTextContentAccessor = __webpack_require__(26);
	
			/**
			 * While `isCollapsed` is available on the Selection object and `collapsed`
			 * is available on the Range object, IE11 sometimes gets them wrong.
			 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
			 */
			function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
			  return anchorNode === focusNode && anchorOffset === focusOffset;
			}
	
			/**
			 * Get the appropriate anchor and focus node/offset pairs for IE.
			 *
			 * The catch here is that IE's selection API doesn't provide information
			 * about whether the selection is forward or backward, so we have to
			 * behave as though it's always forward.
			 *
			 * IE text differs from modern selection in that it behaves as though
			 * block elements end with a new line. This means character offsets will
			 * differ between the two APIs.
			 *
			 * @param {DOMElement} node
			 * @return {object}
			 */
			function getIEOffsets(node) {
			  var selection = document.selection;
			  var selectedRange = selection.createRange();
			  var selectedLength = selectedRange.text.length;
	
			  // Duplicate selection so we can move range without breaking user selection.
			  var fromStart = selectedRange.duplicate();
			  fromStart.moveToElementText(node);
			  fromStart.setEndPoint('EndToStart', selectedRange);
	
			  var startOffset = fromStart.text.length;
			  var endOffset = startOffset + selectedLength;
	
			  return {
			    start: startOffset,
			    end: endOffset
			  };
			}
	
			/**
			 * @param {DOMElement} node
			 * @return {?object}
			 */
			function getModernOffsets(node) {
			  var selection = window.getSelection && window.getSelection();
	
			  if (!selection || selection.rangeCount === 0) {
			    return null;
			  }
	
			  var anchorNode = selection.anchorNode;
			  var anchorOffset = selection.anchorOffset;
			  var focusNode = selection.focusNode;
			  var focusOffset = selection.focusOffset;
	
			  var currentRange = selection.getRangeAt(0);
	
			  // In Firefox, range.startContainer and range.endContainer can be "anonymous
			  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
			  // divs do not seem to expose properties, triggering a "Permission denied
			  // error" if any of its properties are accessed. The only seemingly possible
			  // way to avoid erroring is to access a property that typically works for
			  // non-anonymous divs and catch any error that may otherwise arise. See
			  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
			  try {
			    /* eslint-disable no-unused-expressions */
			    currentRange.startContainer.nodeType;
			    currentRange.endContainer.nodeType;
			    /* eslint-enable no-unused-expressions */
			  } catch (e) {
			    return null;
			  }
	
			  // If the node and offset values are the same, the selection is collapsed.
			  // `Selection.isCollapsed` is available natively, but IE sometimes gets
			  // this value wrong.
			  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
			  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
			  var tempRange = currentRange.cloneRange();
			  tempRange.selectNodeContents(node);
			  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
			  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
			  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
			  var end = start + rangeLength;
	
			  // Detect whether the selection is backward.
			  var detectionRange = document.createRange();
			  detectionRange.setStart(anchorNode, anchorOffset);
			  detectionRange.setEnd(focusNode, focusOffset);
			  var isBackward = detectionRange.collapsed;
	
			  return {
			    start: isBackward ? end : start,
			    end: isBackward ? start : end
			  };
			}
	
			/**
			 * @param {DOMElement|DOMTextNode} node
			 * @param {object} offsets
			 */
			function setIEOffsets(node, offsets) {
			  var range = document.selection.createRange().duplicate();
			  var start, end;
	
			  if (offsets.end === undefined) {
			    start = offsets.start;
			    end = start;
			  } else if (offsets.start > offsets.end) {
			    start = offsets.end;
			    end = offsets.start;
			  } else {
			    start = offsets.start;
			    end = offsets.end;
			  }
	
			  range.moveToElementText(node);
			  range.moveStart('character', start);
			  range.setEndPoint('EndToStart', range);
			  range.moveEnd('character', end - start);
			  range.select();
			}
	
			/**
			 * In modern non-IE browsers, we can support both forward and backward
			 * selections.
			 *
			 * Note: IE10+ supports the Selection object, but it does not support
			 * the `extend` method, which means that even in modern IE, it's not possible
			 * to programmatically create a backward selection. Thus, for all IE
			 * versions, we use the old IE API to create our selections.
			 *
			 * @param {DOMElement|DOMTextNode} node
			 * @param {object} offsets
			 */
			function setModernOffsets(node, offsets) {
			  if (!window.getSelection) {
			    return;
			  }
	
			  var selection = window.getSelection();
			  var length = node[getTextContentAccessor()].length;
			  var start = Math.min(offsets.start, length);
			  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
			  // IE 11 uses modern selection, but doesn't support the extend method.
			  // Flip backward selections, so we can set with a single range.
			  if (!selection.extend && start > end) {
			    var temp = end;
			    end = start;
			    start = temp;
			  }
	
			  var startMarker = getNodeForCharacterOffset(node, start);
			  var endMarker = getNodeForCharacterOffset(node, end);
	
			  if (startMarker && endMarker) {
			    var range = document.createRange();
			    range.setStart(startMarker.node, startMarker.offset);
			    selection.removeAllRanges();
	
			    if (start > end) {
			      selection.addRange(range);
			      selection.extend(endMarker.node, endMarker.offset);
			    } else {
			      range.setEnd(endMarker.node, endMarker.offset);
			      selection.addRange(range);
			    }
			  }
			}
	
			var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
			var ReactDOMSelection = {
			  /**
			   * @param {DOMElement} node
			   */
			  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
			  /**
			   * @param {DOMElement|DOMTextNode} node
			   * @param {object} offsets
			   */
			  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
			};
	
			module.exports = ReactDOMSelection;
	
		/***/ },
		/* 158 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * Given any node return the first leaf node without children.
			 *
			 * @param {DOMElement|DOMTextNode} node
			 * @return {DOMElement|DOMTextNode}
			 */
	
			function getLeafNode(node) {
			  while (node && node.firstChild) {
			    node = node.firstChild;
			  }
			  return node;
			}
	
			/**
			 * Get the next sibling within a container. This will walk up the
			 * DOM if a node's siblings have been exhausted.
			 *
			 * @param {DOMElement|DOMTextNode} node
			 * @return {?DOMElement|DOMTextNode}
			 */
			function getSiblingNode(node) {
			  while (node) {
			    if (node.nextSibling) {
			      return node.nextSibling;
			    }
			    node = node.parentNode;
			  }
			}
	
			/**
			 * Get object describing the nodes which contain characters at offset.
			 *
			 * @param {DOMElement|DOMTextNode} root
			 * @param {number} offset
			 * @return {?object}
			 */
			function getNodeForCharacterOffset(root, offset) {
			  var node = getLeafNode(root);
			  var nodeStart = 0;
			  var nodeEnd = 0;
	
			  while (node) {
			    if (node.nodeType === 3) {
			      nodeEnd = nodeStart + node.textContent.length;
	
			      if (nodeStart <= offset && nodeEnd >= offset) {
			        return {
			          node: node,
			          offset: offset - nodeStart
			        };
			      }
	
			      nodeStart = nodeEnd;
			    }
	
			    node = getLeafNode(getSiblingNode(node));
			  }
			}
	
			module.exports = getNodeForCharacterOffset;
	
		/***/ },
		/* 159 */
		/***/ function(module, exports, __webpack_require__) {
	
			'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			var isTextNode = __webpack_require__(160);
	
			/*eslint-disable no-bitwise */
	
			/**
			 * Checks if a given DOM node contains or is another DOM node.
			 */
			function containsNode(outerNode, innerNode) {
			  if (!outerNode || !innerNode) {
			    return false;
			  } else if (outerNode === innerNode) {
			    return true;
			  } else if (isTextNode(outerNode)) {
			    return false;
			  } else if (isTextNode(innerNode)) {
			    return containsNode(outerNode, innerNode.parentNode);
			  } else if ('contains' in outerNode) {
			    return outerNode.contains(innerNode);
			  } else if (outerNode.compareDocumentPosition) {
			    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
			  } else {
			    return false;
			  }
			}
	
			module.exports = containsNode;
	
		/***/ },
		/* 160 */
		/***/ function(module, exports, __webpack_require__) {
	
			'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			var isNode = __webpack_require__(161);
	
			/**
			 * @param {*} object The object to check.
			 * @return {boolean} Whether or not the object is a DOM text node.
			 */
			function isTextNode(object) {
			  return isNode(object) && object.nodeType == 3;
			}
	
			module.exports = isTextNode;
	
		/***/ },
		/* 161 */
		/***/ function(module, exports) {
	
			'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			/**
			 * @param {*} object The object to check.
			 * @return {boolean} Whether or not the object is a DOM node.
			 */
			function isNode(object) {
			  var doc = object ? object.ownerDocument || object : document;
			  var defaultView = doc.defaultView || window;
			  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
			}
	
			module.exports = isNode;
	
		/***/ },
		/* 162 */
		/***/ function(module, exports) {
	
			'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			/* eslint-disable fb-www/typeof-undefined */
	
			/**
			 * Same as document.activeElement but wraps in a try-catch block. In IE it is
			 * not safe to call document.activeElement if there is nothing focused.
			 *
			 * The activeElement will be null only if the document or document body is not
			 * yet defined.
			 *
			 * @param {?DOMDocument} doc Defaults to current document.
			 * @return {?DOMElement}
			 */
			function getActiveElement(doc) /*?DOMElement*/{
			  doc = doc || (typeof document !== 'undefined' ? document : undefined);
			  if (typeof doc === 'undefined') {
			    return null;
			  }
			  try {
			    return doc.activeElement || doc.body;
			  } catch (e) {
			    return doc.body;
			  }
			}
	
			module.exports = getActiveElement;
	
		/***/ },
		/* 163 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var NS = {
			  xlink: 'http://www.w3.org/1999/xlink',
			  xml: 'http://www.w3.org/XML/1998/namespace'
			};
	
			// We use attributes for everything SVG so let's avoid some duplication and run
			// code instead.
			// The following are all specified in the HTML config already so we exclude here.
			// - class (as className)
			// - color
			// - height
			// - id
			// - lang
			// - max
			// - media
			// - method
			// - min
			// - name
			// - style
			// - target
			// - type
			// - width
			var ATTRS = {
			  accentHeight: 'accent-height',
			  accumulate: 0,
			  additive: 0,
			  alignmentBaseline: 'alignment-baseline',
			  allowReorder: 'allowReorder',
			  alphabetic: 0,
			  amplitude: 0,
			  arabicForm: 'arabic-form',
			  ascent: 0,
			  attributeName: 'attributeName',
			  attributeType: 'attributeType',
			  autoReverse: 'autoReverse',
			  azimuth: 0,
			  baseFrequency: 'baseFrequency',
			  baseProfile: 'baseProfile',
			  baselineShift: 'baseline-shift',
			  bbox: 0,
			  begin: 0,
			  bias: 0,
			  by: 0,
			  calcMode: 'calcMode',
			  capHeight: 'cap-height',
			  clip: 0,
			  clipPath: 'clip-path',
			  clipRule: 'clip-rule',
			  clipPathUnits: 'clipPathUnits',
			  colorInterpolation: 'color-interpolation',
			  colorInterpolationFilters: 'color-interpolation-filters',
			  colorProfile: 'color-profile',
			  colorRendering: 'color-rendering',
			  contentScriptType: 'contentScriptType',
			  contentStyleType: 'contentStyleType',
			  cursor: 0,
			  cx: 0,
			  cy: 0,
			  d: 0,
			  decelerate: 0,
			  descent: 0,
			  diffuseConstant: 'diffuseConstant',
			  direction: 0,
			  display: 0,
			  divisor: 0,
			  dominantBaseline: 'dominant-baseline',
			  dur: 0,
			  dx: 0,
			  dy: 0,
			  edgeMode: 'edgeMode',
			  elevation: 0,
			  enableBackground: 'enable-background',
			  end: 0,
			  exponent: 0,
			  externalResourcesRequired: 'externalResourcesRequired',
			  fill: 0,
			  fillOpacity: 'fill-opacity',
			  fillRule: 'fill-rule',
			  filter: 0,
			  filterRes: 'filterRes',
			  filterUnits: 'filterUnits',
			  floodColor: 'flood-color',
			  floodOpacity: 'flood-opacity',
			  focusable: 0,
			  fontFamily: 'font-family',
			  fontSize: 'font-size',
			  fontSizeAdjust: 'font-size-adjust',
			  fontStretch: 'font-stretch',
			  fontStyle: 'font-style',
			  fontVariant: 'font-variant',
			  fontWeight: 'font-weight',
			  format: 0,
			  from: 0,
			  fx: 0,
			  fy: 0,
			  g1: 0,
			  g2: 0,
			  glyphName: 'glyph-name',
			  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
			  glyphOrientationVertical: 'glyph-orientation-vertical',
			  glyphRef: 'glyphRef',
			  gradientTransform: 'gradientTransform',
			  gradientUnits: 'gradientUnits',
			  hanging: 0,
			  horizAdvX: 'horiz-adv-x',
			  horizOriginX: 'horiz-origin-x',
			  ideographic: 0,
			  imageRendering: 'image-rendering',
			  'in': 0,
			  in2: 0,
			  intercept: 0,
			  k: 0,
			  k1: 0,
			  k2: 0,
			  k3: 0,
			  k4: 0,
			  kernelMatrix: 'kernelMatrix',
			  kernelUnitLength: 'kernelUnitLength',
			  kerning: 0,
			  keyPoints: 'keyPoints',
			  keySplines: 'keySplines',
			  keyTimes: 'keyTimes',
			  lengthAdjust: 'lengthAdjust',
			  letterSpacing: 'letter-spacing',
			  lightingColor: 'lighting-color',
			  limitingConeAngle: 'limitingConeAngle',
			  local: 0,
			  markerEnd: 'marker-end',
			  markerMid: 'marker-mid',
			  markerStart: 'marker-start',
			  markerHeight: 'markerHeight',
			  markerUnits: 'markerUnits',
			  markerWidth: 'markerWidth',
			  mask: 0,
			  maskContentUnits: 'maskContentUnits',
			  maskUnits: 'maskUnits',
			  mathematical: 0,
			  mode: 0,
			  numOctaves: 'numOctaves',
			  offset: 0,
			  opacity: 0,
			  operator: 0,
			  order: 0,
			  orient: 0,
			  orientation: 0,
			  origin: 0,
			  overflow: 0,
			  overlinePosition: 'overline-position',
			  overlineThickness: 'overline-thickness',
			  paintOrder: 'paint-order',
			  panose1: 'panose-1',
			  pathLength: 'pathLength',
			  patternContentUnits: 'patternContentUnits',
			  patternTransform: 'patternTransform',
			  patternUnits: 'patternUnits',
			  pointerEvents: 'pointer-events',
			  points: 0,
			  pointsAtX: 'pointsAtX',
			  pointsAtY: 'pointsAtY',
			  pointsAtZ: 'pointsAtZ',
			  preserveAlpha: 'preserveAlpha',
			  preserveAspectRatio: 'preserveAspectRatio',
			  primitiveUnits: 'primitiveUnits',
			  r: 0,
			  radius: 0,
			  refX: 'refX',
			  refY: 'refY',
			  renderingIntent: 'rendering-intent',
			  repeatCount: 'repeatCount',
			  repeatDur: 'repeatDur',
			  requiredExtensions: 'requiredExtensions',
			  requiredFeatures: 'requiredFeatures',
			  restart: 0,
			  result: 0,
			  rotate: 0,
			  rx: 0,
			  ry: 0,
			  scale: 0,
			  seed: 0,
			  shapeRendering: 'shape-rendering',
			  slope: 0,
			  spacing: 0,
			  specularConstant: 'specularConstant',
			  specularExponent: 'specularExponent',
			  speed: 0,
			  spreadMethod: 'spreadMethod',
			  startOffset: 'startOffset',
			  stdDeviation: 'stdDeviation',
			  stemh: 0,
			  stemv: 0,
			  stitchTiles: 'stitchTiles',
			  stopColor: 'stop-color',
			  stopOpacity: 'stop-opacity',
			  strikethroughPosition: 'strikethrough-position',
			  strikethroughThickness: 'strikethrough-thickness',
			  string: 0,
			  stroke: 0,
			  strokeDasharray: 'stroke-dasharray',
			  strokeDashoffset: 'stroke-dashoffset',
			  strokeLinecap: 'stroke-linecap',
			  strokeLinejoin: 'stroke-linejoin',
			  strokeMiterlimit: 'stroke-miterlimit',
			  strokeOpacity: 'stroke-opacity',
			  strokeWidth: 'stroke-width',
			  surfaceScale: 'surfaceScale',
			  systemLanguage: 'systemLanguage',
			  tableValues: 'tableValues',
			  targetX: 'targetX',
			  targetY: 'targetY',
			  textAnchor: 'text-anchor',
			  textDecoration: 'text-decoration',
			  textRendering: 'text-rendering',
			  textLength: 'textLength',
			  to: 0,
			  transform: 0,
			  u1: 0,
			  u2: 0,
			  underlinePosition: 'underline-position',
			  underlineThickness: 'underline-thickness',
			  unicode: 0,
			  unicodeBidi: 'unicode-bidi',
			  unicodeRange: 'unicode-range',
			  unitsPerEm: 'units-per-em',
			  vAlphabetic: 'v-alphabetic',
			  vHanging: 'v-hanging',
			  vIdeographic: 'v-ideographic',
			  vMathematical: 'v-mathematical',
			  values: 0,
			  vectorEffect: 'vector-effect',
			  version: 0,
			  vertAdvY: 'vert-adv-y',
			  vertOriginX: 'vert-origin-x',
			  vertOriginY: 'vert-origin-y',
			  viewBox: 'viewBox',
			  viewTarget: 'viewTarget',
			  visibility: 0,
			  widths: 0,
			  wordSpacing: 'word-spacing',
			  writingMode: 'writing-mode',
			  x: 0,
			  xHeight: 'x-height',
			  x1: 0,
			  x2: 0,
			  xChannelSelector: 'xChannelSelector',
			  xlinkActuate: 'xlink:actuate',
			  xlinkArcrole: 'xlink:arcrole',
			  xlinkHref: 'xlink:href',
			  xlinkRole: 'xlink:role',
			  xlinkShow: 'xlink:show',
			  xlinkTitle: 'xlink:title',
			  xlinkType: 'xlink:type',
			  xmlBase: 'xml:base',
			  xmlns: 0,
			  xmlnsXlink: 'xmlns:xlink',
			  xmlLang: 'xml:lang',
			  xmlSpace: 'xml:space',
			  y: 0,
			  y1: 0,
			  y2: 0,
			  yChannelSelector: 'yChannelSelector',
			  z: 0,
			  zoomAndPan: 'zoomAndPan'
			};
	
			var SVGDOMPropertyConfig = {
			  Properties: {},
			  DOMAttributeNamespaces: {
			    xlinkActuate: NS.xlink,
			    xlinkArcrole: NS.xlink,
			    xlinkHref: NS.xlink,
			    xlinkRole: NS.xlink,
			    xlinkShow: NS.xlink,
			    xlinkTitle: NS.xlink,
			    xlinkType: NS.xlink,
			    xmlBase: NS.xml,
			    xmlLang: NS.xml,
			    xmlSpace: NS.xml
			  },
			  DOMAttributeNames: {}
			};
	
			Object.keys(ATTRS).forEach(function (key) {
			  SVGDOMPropertyConfig.Properties[key] = 0;
			  if (ATTRS[key]) {
			    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
			  }
			});
	
			module.exports = SVGDOMPropertyConfig;
	
		/***/ },
		/* 164 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var EventPropagators = __webpack_require__(13);
			var ExecutionEnvironment = __webpack_require__(22);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactInputSelection = __webpack_require__(156);
			var SyntheticEvent = __webpack_require__(28);
	
			var getActiveElement = __webpack_require__(162);
			var isTextInputElement = __webpack_require__(52);
			var shallowEqual = __webpack_require__(133);
	
			var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
			var eventTypes = {
			  select: {
			    phasedRegistrationNames: {
			      bubbled: 'onSelect',
			      captured: 'onSelectCapture'
			    },
			    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
			  }
			};
	
			var activeElement = null;
			var activeElementInst = null;
			var lastSelection = null;
			var mouseDown = false;
	
			// Track whether a listener exists for this plugin. If none exist, we do
			// not extract events. See #3639.
			var hasListener = false;
	
			/**
			 * Get an object which is a unique representation of the current selection.
			 *
			 * The return value will not be consistent across nodes or browsers, but
			 * two identical selections on the same node will return identical objects.
			 *
			 * @param {DOMElement} node
			 * @return {object}
			 */
			function getSelection(node) {
			  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
			    return {
			      start: node.selectionStart,
			      end: node.selectionEnd
			    };
			  } else if (window.getSelection) {
			    var selection = window.getSelection();
			    return {
			      anchorNode: selection.anchorNode,
			      anchorOffset: selection.anchorOffset,
			      focusNode: selection.focusNode,
			      focusOffset: selection.focusOffset
			    };
			  } else if (document.selection) {
			    var range = document.selection.createRange();
			    return {
			      parentElement: range.parentElement(),
			      text: range.text,
			      top: range.boundingTop,
			      left: range.boundingLeft
			    };
			  }
			}
	
			/**
			 * Poll selection to see whether it's changed.
			 *
			 * @param {object} nativeEvent
			 * @return {?SyntheticEvent}
			 */
			function constructSelectEvent(nativeEvent, nativeEventTarget) {
			  // Ensure we have the right element, and that the user is not dragging a
			  // selection (this matches native `select` event behavior). In HTML5, select
			  // fires only on input and textarea thus if there's no focused element we
			  // won't dispatch.
			  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
			    return null;
			  }
	
			  // Only fire when selection has actually changed.
			  var currentSelection = getSelection(activeElement);
			  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
			    lastSelection = currentSelection;
	
			    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
			    syntheticEvent.type = 'select';
			    syntheticEvent.target = activeElement;
	
			    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
			    return syntheticEvent;
			  }
	
			  return null;
			}
	
			/**
			 * This plugin creates an `onSelect` event that normalizes select events
			 * across form elements.
			 *
			 * Supported elements are:
			 * - input (see `isTextInputElement`)
			 * - textarea
			 * - contentEditable
			 *
			 * This differs from native browser implementations in the following ways:
			 * - Fires on contentEditable fields as well as inputs.
			 * - Fires for collapsed selection.
			 * - Fires after user input.
			 */
			var SelectEventPlugin = {
	
			  eventTypes: eventTypes,
	
			  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			    if (!hasListener) {
			      return null;
			    }
	
			    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
			    switch (topLevelType) {
			      // Track the input node that has focus.
			      case 'topFocus':
			        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
			          activeElement = targetNode;
			          activeElementInst = targetInst;
			          lastSelection = null;
			        }
			        break;
			      case 'topBlur':
			        activeElement = null;
			        activeElementInst = null;
			        lastSelection = null;
			        break;
	
			      // Don't fire the event while the user is dragging. This matches the
			      // semantics of the native select event.
			      case 'topMouseDown':
			        mouseDown = true;
			        break;
			      case 'topContextMenu':
			      case 'topMouseUp':
			        mouseDown = false;
			        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
			      // Chrome and IE fire non-standard event when selection is changed (and
			      // sometimes when it hasn't). IE's event fires out of order with respect
			      // to key and input events on deletion, so we discard it.
			      //
			      // Firefox doesn't support selectionchange, so check selection status
			      // after each key entry. The selection changes after keydown and before
			      // keyup, but we check on keydown as well in the case of holding down a
			      // key, when multiple keydown events are fired but only one keyup is.
			      // This is also our approach for IE handling, for the reason above.
			      case 'topSelectionChange':
			        if (skipSelectionChangeEvent) {
			          break;
			        }
			      // falls through
			      case 'topKeyDown':
			      case 'topKeyUp':
			        return constructSelectEvent(nativeEvent, nativeEventTarget);
			    }
	
			    return null;
			  },
	
			  didPutListener: function (inst, registrationName, listener) {
			    if (registrationName === 'onSelect') {
			      hasListener = true;
			    }
			  }
			};
	
			module.exports = SelectEventPlugin;
	
		/***/ },
		/* 165 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var EventListener = __webpack_require__(152);
			var EventPropagators = __webpack_require__(13);
			var ReactDOMComponentTree = __webpack_require__(5);
			var SyntheticAnimationEvent = __webpack_require__(166);
			var SyntheticClipboardEvent = __webpack_require__(167);
			var SyntheticEvent = __webpack_require__(28);
			var SyntheticFocusEvent = __webpack_require__(168);
			var SyntheticKeyboardEvent = __webpack_require__(169);
			var SyntheticMouseEvent = __webpack_require__(55);
			var SyntheticDragEvent = __webpack_require__(172);
			var SyntheticTouchEvent = __webpack_require__(173);
			var SyntheticTransitionEvent = __webpack_require__(174);
			var SyntheticUIEvent = __webpack_require__(56);
			var SyntheticWheelEvent = __webpack_require__(175);
	
			var emptyFunction = __webpack_require__(19);
			var getEventCharCode = __webpack_require__(170);
			var invariant = __webpack_require__(8);
	
			/**
			 * Turns
			 * ['abort', ...]
			 * into
			 * eventTypes = {
			 *   'abort': {
			 *     phasedRegistrationNames: {
			 *       bubbled: 'onAbort',
			 *       captured: 'onAbortCapture',
			 *     },
			 *     dependencies: ['topAbort'],
			 *   },
			 *   ...
			 * };
			 * topLevelEventsToDispatchConfig = {
			 *   'topAbort': { sameConfig }
			 * };
			 */
			var eventTypes = {};
			var topLevelEventsToDispatchConfig = {};
			['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
			  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
			  var onEvent = 'on' + capitalizedEvent;
			  var topEvent = 'top' + capitalizedEvent;
	
			  var type = {
			    phasedRegistrationNames: {
			      bubbled: onEvent,
			      captured: onEvent + 'Capture'
			    },
			    dependencies: [topEvent]
			  };
			  eventTypes[event] = type;
			  topLevelEventsToDispatchConfig[topEvent] = type;
			});
	
			var onClickListeners = {};
	
			function getDictionaryKey(inst) {
			  // Prevents V8 performance issue:
			  // https://github.com/facebook/react/pull/7232
			  return '.' + inst._rootNodeID;
			}
	
			function isInteractive(tag) {
			  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
			}
	
			var SimpleEventPlugin = {
	
			  eventTypes: eventTypes,
	
			  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
			    if (!dispatchConfig) {
			      return null;
			    }
			    var EventConstructor;
			    switch (topLevelType) {
			      case 'topAbort':
			      case 'topCanPlay':
			      case 'topCanPlayThrough':
			      case 'topDurationChange':
			      case 'topEmptied':
			      case 'topEncrypted':
			      case 'topEnded':
			      case 'topError':
			      case 'topInput':
			      case 'topInvalid':
			      case 'topLoad':
			      case 'topLoadedData':
			      case 'topLoadedMetadata':
			      case 'topLoadStart':
			      case 'topPause':
			      case 'topPlay':
			      case 'topPlaying':
			      case 'topProgress':
			      case 'topRateChange':
			      case 'topReset':
			      case 'topSeeked':
			      case 'topSeeking':
			      case 'topStalled':
			      case 'topSubmit':
			      case 'topSuspend':
			      case 'topTimeUpdate':
			      case 'topVolumeChange':
			      case 'topWaiting':
			        // HTML Events
			        // @see http://www.w3.org/TR/html5/index.html#events-0
			        EventConstructor = SyntheticEvent;
			        break;
			      case 'topKeyPress':
			        // Firefox creates a keypress event for function keys too. This removes
			        // the unwanted keypress events. Enter is however both printable and
			        // non-printable. One would expect Tab to be as well (but it isn't).
			        if (getEventCharCode(nativeEvent) === 0) {
			          return null;
			        }
			      /* falls through */
			      case 'topKeyDown':
			      case 'topKeyUp':
			        EventConstructor = SyntheticKeyboardEvent;
			        break;
			      case 'topBlur':
			      case 'topFocus':
			        EventConstructor = SyntheticFocusEvent;
			        break;
			      case 'topClick':
			        // Firefox creates a click event on right mouse clicks. This removes the
			        // unwanted click events.
			        if (nativeEvent.button === 2) {
			          return null;
			        }
			      /* falls through */
			      case 'topDoubleClick':
			      case 'topMouseDown':
			      case 'topMouseMove':
			      case 'topMouseUp':
			      // TODO: Disabled elements should not respond to mouse events
			      /* falls through */
			      case 'topMouseOut':
			      case 'topMouseOver':
			      case 'topContextMenu':
			        EventConstructor = SyntheticMouseEvent;
			        break;
			      case 'topDrag':
			      case 'topDragEnd':
			      case 'topDragEnter':
			      case 'topDragExit':
			      case 'topDragLeave':
			      case 'topDragOver':
			      case 'topDragStart':
			      case 'topDrop':
			        EventConstructor = SyntheticDragEvent;
			        break;
			      case 'topTouchCancel':
			      case 'topTouchEnd':
			      case 'topTouchMove':
			      case 'topTouchStart':
			        EventConstructor = SyntheticTouchEvent;
			        break;
			      case 'topAnimationEnd':
			      case 'topAnimationIteration':
			      case 'topAnimationStart':
			        EventConstructor = SyntheticAnimationEvent;
			        break;
			      case 'topTransitionEnd':
			        EventConstructor = SyntheticTransitionEvent;
			        break;
			      case 'topScroll':
			        EventConstructor = SyntheticUIEvent;
			        break;
			      case 'topWheel':
			        EventConstructor = SyntheticWheelEvent;
			        break;
			      case 'topCopy':
			      case 'topCut':
			      case 'topPaste':
			        EventConstructor = SyntheticClipboardEvent;
			        break;
			    }
			    !EventConstructor ? process.env.NODE_ENV !== 'production' ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
			    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
			    EventPropagators.accumulateTwoPhaseDispatches(event);
			    return event;
			  },
	
			  didPutListener: function (inst, registrationName, listener) {
			    // Mobile Safari does not fire properly bubble click events on
			    // non-interactive elements, which means delegated click listeners do not
			    // fire. The workaround for this bug involves attaching an empty click
			    // listener on the target node.
			    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
			    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
			      var key = getDictionaryKey(inst);
			      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
			      if (!onClickListeners[key]) {
			        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
			      }
			    }
			  },
	
			  willDeleteListener: function (inst, registrationName) {
			    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
			      var key = getDictionaryKey(inst);
			      onClickListeners[key].remove();
			      delete onClickListeners[key];
			    }
			  }
	
			};
	
			module.exports = SimpleEventPlugin;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 166 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticEvent = __webpack_require__(28);
	
			/**
			 * @interface Event
			 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
			 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
			 */
			var AnimationEventInterface = {
			  animationName: null,
			  elapsedTime: null,
			  pseudoElement: null
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticEvent}
			 */
			function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
			module.exports = SyntheticAnimationEvent;
	
		/***/ },
		/* 167 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticEvent = __webpack_require__(28);
	
			/**
			 * @interface Event
			 * @see http://www.w3.org/TR/clipboard-apis/
			 */
			var ClipboardEventInterface = {
			  clipboardData: function (event) {
			    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
			  }
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
			module.exports = SyntheticClipboardEvent;
	
		/***/ },
		/* 168 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticUIEvent = __webpack_require__(56);
	
			/**
			 * @interface FocusEvent
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/
			 */
			var FocusEventInterface = {
			  relatedTarget: null
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
			module.exports = SyntheticFocusEvent;
	
		/***/ },
		/* 169 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticUIEvent = __webpack_require__(56);
	
			var getEventCharCode = __webpack_require__(170);
			var getEventKey = __webpack_require__(171);
			var getEventModifierState = __webpack_require__(58);
	
			/**
			 * @interface KeyboardEvent
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/
			 */
			var KeyboardEventInterface = {
			  key: getEventKey,
			  location: null,
			  ctrlKey: null,
			  shiftKey: null,
			  altKey: null,
			  metaKey: null,
			  repeat: null,
			  locale: null,
			  getModifierState: getEventModifierState,
			  // Legacy Interface
			  charCode: function (event) {
			    // `charCode` is the result of a KeyPress event and represents the value of
			    // the actual printable character.
	
			    // KeyPress is deprecated, but its replacement is not yet final and not
			    // implemented in any major browser. Only KeyPress has charCode.
			    if (event.type === 'keypress') {
			      return getEventCharCode(event);
			    }
			    return 0;
			  },
			  keyCode: function (event) {
			    // `keyCode` is the result of a KeyDown/Up event and represents the value of
			    // physical keyboard key.
	
			    // The actual meaning of the value depends on the users' keyboard layout
			    // which cannot be detected. Assuming that it is a US keyboard layout
			    // provides a surprisingly accurate mapping for US and European users.
			    // Due to this, it is left to the user to implement at this time.
			    if (event.type === 'keydown' || event.type === 'keyup') {
			      return event.keyCode;
			    }
			    return 0;
			  },
			  which: function (event) {
			    // `which` is an alias for either `keyCode` or `charCode` depending on the
			    // type of the event.
			    if (event.type === 'keypress') {
			      return getEventCharCode(event);
			    }
			    if (event.type === 'keydown' || event.type === 'keyup') {
			      return event.keyCode;
			    }
			    return 0;
			  }
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
			module.exports = SyntheticKeyboardEvent;
	
		/***/ },
		/* 170 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * `charCode` represents the actual "character code" and is safe to use with
			 * `String.fromCharCode`. As such, only keys that correspond to printable
			 * characters produce a valid `charCode`, the only exception to this is Enter.
			 * The Tab-key is considered non-printable and does not have a `charCode`,
			 * presumably because it does not produce a tab-character in browsers.
			 *
			 * @param {object} nativeEvent Native browser event.
			 * @return {number} Normalized `charCode` property.
			 */
	
			function getEventCharCode(nativeEvent) {
			  var charCode;
			  var keyCode = nativeEvent.keyCode;
	
			  if ('charCode' in nativeEvent) {
			    charCode = nativeEvent.charCode;
	
			    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
			    if (charCode === 0 && keyCode === 13) {
			      charCode = 13;
			    }
			  } else {
			    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
			    charCode = keyCode;
			  }
	
			  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
			  // Must not discard the (non-)printable Enter-key.
			  if (charCode >= 32 || charCode === 13) {
			    return charCode;
			  }
	
			  return 0;
			}
	
			module.exports = getEventCharCode;
	
		/***/ },
		/* 171 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var getEventCharCode = __webpack_require__(170);
	
			/**
			 * Normalization of deprecated HTML5 `key` values
			 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
			 */
			var normalizeKey = {
			  'Esc': 'Escape',
			  'Spacebar': ' ',
			  'Left': 'ArrowLeft',
			  'Up': 'ArrowUp',
			  'Right': 'ArrowRight',
			  'Down': 'ArrowDown',
			  'Del': 'Delete',
			  'Win': 'OS',
			  'Menu': 'ContextMenu',
			  'Apps': 'ContextMenu',
			  'Scroll': 'ScrollLock',
			  'MozPrintableKey': 'Unidentified'
			};
	
			/**
			 * Translation from legacy `keyCode` to HTML5 `key`
			 * Only special keys supported, all others depend on keyboard layout or browser
			 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
			 */
			var translateToKey = {
			  8: 'Backspace',
			  9: 'Tab',
			  12: 'Clear',
			  13: 'Enter',
			  16: 'Shift',
			  17: 'Control',
			  18: 'Alt',
			  19: 'Pause',
			  20: 'CapsLock',
			  27: 'Escape',
			  32: ' ',
			  33: 'PageUp',
			  34: 'PageDown',
			  35: 'End',
			  36: 'Home',
			  37: 'ArrowLeft',
			  38: 'ArrowUp',
			  39: 'ArrowRight',
			  40: 'ArrowDown',
			  45: 'Insert',
			  46: 'Delete',
			  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
			  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
			  144: 'NumLock',
			  145: 'ScrollLock',
			  224: 'Meta'
			};
	
			/**
			 * @param {object} nativeEvent Native browser event.
			 * @return {string} Normalized `key` property.
			 */
			function getEventKey(nativeEvent) {
			  if (nativeEvent.key) {
			    // Normalize inconsistent values reported by browsers due to
			    // implementations of a working draft specification.
	
			    // FireFox implements `key` but returns `MozPrintableKey` for all
			    // printable characters (normalized to `Unidentified`), ignore it.
			    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
			    if (key !== 'Unidentified') {
			      return key;
			    }
			  }
	
			  // Browser does not implement `key`, polyfill as much of it as we can.
			  if (nativeEvent.type === 'keypress') {
			    var charCode = getEventCharCode(nativeEvent);
	
			    // The enter-key is technically both printable and non-printable and can
			    // thus be captured by `keypress`, no other non-printable key should.
			    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
			  }
			  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
			    // While user keyboard layout determines the actual meaning of each
			    // `keyCode` value, almost all function keys have a universal value.
			    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
			  }
			  return '';
			}
	
			module.exports = getEventKey;
	
		/***/ },
		/* 172 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticMouseEvent = __webpack_require__(55);
	
			/**
			 * @interface DragEvent
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/
			 */
			var DragEventInterface = {
			  dataTransfer: null
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
			module.exports = SyntheticDragEvent;
	
		/***/ },
		/* 173 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticUIEvent = __webpack_require__(56);
	
			var getEventModifierState = __webpack_require__(58);
	
			/**
			 * @interface TouchEvent
			 * @see http://www.w3.org/TR/touch-events/
			 */
			var TouchEventInterface = {
			  touches: null,
			  targetTouches: null,
			  changedTouches: null,
			  altKey: null,
			  metaKey: null,
			  ctrlKey: null,
			  shiftKey: null,
			  getModifierState: getEventModifierState
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
			module.exports = SyntheticTouchEvent;
	
		/***/ },
		/* 174 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticEvent = __webpack_require__(28);
	
			/**
			 * @interface Event
			 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
			 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
			 */
			var TransitionEventInterface = {
			  propertyName: null,
			  elapsedTime: null,
			  pseudoElement: null
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticEvent}
			 */
			function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
			module.exports = SyntheticTransitionEvent;
	
		/***/ },
		/* 175 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticMouseEvent = __webpack_require__(55);
	
			/**
			 * @interface WheelEvent
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/
			 */
			var WheelEventInterface = {
			  deltaX: function (event) {
			    return 'deltaX' in event ? event.deltaX :
			    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
			    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
			  },
			  deltaY: function (event) {
			    return 'deltaY' in event ? event.deltaY :
			    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
			    'wheelDeltaY' in event ? -event.wheelDeltaY :
			    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
			    'wheelDelta' in event ? -event.wheelDelta : 0;
			  },
			  deltaZ: null,
	
			  // Browsers without "deltaMode" is reporting in raw wheel delta where one
			  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
			  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
			  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
			  deltaMode: null
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticMouseEvent}
			 */
			function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
			module.exports = SyntheticWheelEvent;
	
		/***/ },
		/* 176 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var DOMLazyTree = __webpack_require__(62);
			var DOMProperty = __webpack_require__(7);
			var React = __webpack_require__(98);
			var ReactBrowserEventEmitter = __webpack_require__(86);
			var ReactCurrentOwner = __webpack_require__(43);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactDOMContainerInfo = __webpack_require__(177);
			var ReactDOMFeatureFlags = __webpack_require__(178);
			var ReactFeatureFlags = __webpack_require__(33);
			var ReactInstanceMap = __webpack_require__(125);
			var ReactInstrumentation = __webpack_require__(37);
			var ReactMarkupChecksum = __webpack_require__(179);
			var ReactReconciler = __webpack_require__(34);
			var ReactUpdateQueue = __webpack_require__(145);
			var ReactUpdates = __webpack_require__(31);
	
			var emptyObject = __webpack_require__(132);
			var instantiateReactComponent = __webpack_require__(127);
			var invariant = __webpack_require__(8);
			var setInnerHTML = __webpack_require__(64);
			var shouldUpdateReactComponent = __webpack_require__(134);
			var warning = __webpack_require__(18);
	
			var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
			var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
			var ELEMENT_NODE_TYPE = 1;
			var DOC_NODE_TYPE = 9;
			var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
			var instancesByReactRootID = {};
	
			/**
			 * Finds the index of the first character
			 * that's not common between the two given strings.
			 *
			 * @return {number} the index of the character where the strings diverge
			 */
			function firstDifferenceIndex(string1, string2) {
			  var minLen = Math.min(string1.length, string2.length);
			  for (var i = 0; i < minLen; i++) {
			    if (string1.charAt(i) !== string2.charAt(i)) {
			      return i;
			    }
			  }
			  return string1.length === string2.length ? -1 : minLen;
			}
	
			/**
			 * @param {DOMElement|DOMDocument} container DOM element that may contain
			 * a React component
			 * @return {?*} DOM element that may have the reactRoot ID, or null.
			 */
			function getReactRootElementInContainer(container) {
			  if (!container) {
			    return null;
			  }
	
			  if (container.nodeType === DOC_NODE_TYPE) {
			    return container.documentElement;
			  } else {
			    return container.firstChild;
			  }
			}
	
			function internalGetID(node) {
			  // If node is something like a window, document, or text node, none of
			  // which support attributes or a .getAttribute method, gracefully return
			  // the empty string, as if the attribute were missing.
			  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
			}
	
			/**
			 * Mounts this component and inserts it into the DOM.
			 *
			 * @param {ReactComponent} componentInstance The instance to mount.
			 * @param {DOMElement} container DOM element to mount into.
			 * @param {ReactReconcileTransaction} transaction
			 * @param {boolean} shouldReuseMarkup If true, do not insert markup
			 */
			function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
			  var markerName;
			  if (ReactFeatureFlags.logTopLevelRenders) {
			    var wrappedElement = wrapperInstance._currentElement.props.child;
			    var type = wrappedElement.type;
			    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
			    console.time(markerName);
			  }
	
			  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
			  );
	
			  if (markerName) {
			    console.timeEnd(markerName);
			  }
	
			  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
			  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
			}
	
			/**
			 * Batched mount.
			 *
			 * @param {ReactComponent} componentInstance The instance to mount.
			 * @param {DOMElement} container DOM element to mount into.
			 * @param {boolean} shouldReuseMarkup If true, do not insert markup
			 */
			function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
			  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
			  /* useCreateElement */
			  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
			  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
			  ReactUpdates.ReactReconcileTransaction.release(transaction);
			}
	
			/**
			 * Unmounts a component and removes it from the DOM.
			 *
			 * @param {ReactComponent} instance React component instance.
			 * @param {DOMElement} container DOM element to unmount from.
			 * @final
			 * @internal
			 * @see {ReactMount.unmountComponentAtNode}
			 */
			function unmountComponentFromNode(instance, container, safely) {
			  if (process.env.NODE_ENV !== 'production') {
			    ReactInstrumentation.debugTool.onBeginFlush();
			  }
			  ReactReconciler.unmountComponent(instance, safely);
			  if (process.env.NODE_ENV !== 'production') {
			    ReactInstrumentation.debugTool.onEndFlush();
			  }
	
			  if (container.nodeType === DOC_NODE_TYPE) {
			    container = container.documentElement;
			  }
	
			  // http://jsperf.com/emptying-a-node
			  while (container.lastChild) {
			    container.removeChild(container.lastChild);
			  }
			}
	
			/**
			 * True if the supplied DOM node has a direct React-rendered child that is
			 * not a React root element. Useful for warning in `render`,
			 * `unmountComponentAtNode`, etc.
			 *
			 * @param {?DOMElement} node The candidate DOM node.
			 * @return {boolean} True if the DOM element contains a direct child that was
			 * rendered by React but is not a root element.
			 * @internal
			 */
			function hasNonRootReactChild(container) {
			  var rootEl = getReactRootElementInContainer(container);
			  if (rootEl) {
			    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
			    return !!(inst && inst._hostParent);
			  }
			}
	
			/**
			 * True if the supplied DOM node is a React DOM element and
			 * it has been rendered by another copy of React.
			 *
			 * @param {?DOMElement} node The candidate DOM node.
			 * @return {boolean} True if the DOM has been rendered by another copy of React
			 * @internal
			 */
			function nodeIsRenderedByOtherInstance(container) {
			  var rootEl = getReactRootElementInContainer(container);
			  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
			}
	
			/**
			 * True if the supplied DOM node is a valid node element.
			 *
			 * @param {?DOMElement} node The candidate DOM node.
			 * @return {boolean} True if the DOM is a valid DOM node.
			 * @internal
			 */
			function isValidContainer(node) {
			  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
			}
	
			/**
			 * True if the supplied DOM node is a valid React node element.
			 *
			 * @param {?DOMElement} node The candidate DOM node.
			 * @return {boolean} True if the DOM is a valid React DOM node.
			 * @internal
			 */
			function isReactNode(node) {
			  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
			}
	
			function getHostRootInstanceInContainer(container) {
			  var rootEl = getReactRootElementInContainer(container);
			  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
			  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
			}
	
			function getTopLevelWrapperInContainer(container) {
			  var root = getHostRootInstanceInContainer(container);
			  return root ? root._hostContainerInfo._topLevelWrapper : null;
			}
	
			/**
			 * Temporary (?) hack so that we can store all top-level pending updates on
			 * composites instead of having to worry about different types of components
			 * here.
			 */
			var topLevelRootCounter = 1;
			var TopLevelWrapper = function () {
			  this.rootID = topLevelRootCounter++;
			};
			TopLevelWrapper.prototype.isReactComponent = {};
			if (process.env.NODE_ENV !== 'production') {
			  TopLevelWrapper.displayName = 'TopLevelWrapper';
			}
			TopLevelWrapper.prototype.render = function () {
			  return this.props.child;
			};
			TopLevelWrapper.isReactTopLevelWrapper = true;
	
			/**
			 * Mounting is the process of initializing a React component by creating its
			 * representative DOM elements and inserting them into a supplied `container`.
			 * Any prior content inside `container` is destroyed in the process.
			 *
			 *   ReactMount.render(
			 *     component,
			 *     document.getElementById('container')
			 *   );
			 *
			 *   <div id="container">                   <-- Supplied `container`.
			 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
			 *       // ...                                 component.
			 *     </div>
			 *   </div>
			 *
			 * Inside of `container`, the first element rendered is the "reactRoot".
			 */
			var ReactMount = {
	
			  TopLevelWrapper: TopLevelWrapper,
	
			  /**
			   * Used by devtools. The keys are not important.
			   */
			  _instancesByReactRootID: instancesByReactRootID,
	
			  /**
			   * This is a hook provided to support rendering React components while
			   * ensuring that the apparent scroll position of its `container` does not
			   * change.
			   *
			   * @param {DOMElement} container The `container` being rendered into.
			   * @param {function} renderCallback This must be called once to do the render.
			   */
			  scrollMonitor: function (container, renderCallback) {
			    renderCallback();
			  },
	
			  /**
			   * Take a component that's already mounted into the DOM and replace its props
			   * @param {ReactComponent} prevComponent component instance already in the DOM
			   * @param {ReactElement} nextElement component instance to render
			   * @param {DOMElement} container container to render into
			   * @param {?function} callback function triggered on completion
			   */
			  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
			    ReactMount.scrollMonitor(container, function () {
			      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
			      if (callback) {
			        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
			      }
			    });
	
			    return prevComponent;
			  },
	
			  /**
			   * Render a new component into the DOM. Hooked by hooks!
			   *
			   * @param {ReactElement} nextElement element to render
			   * @param {DOMElement} container container to render into
			   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
			   * @return {ReactComponent} nextComponent
			   */
			  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
			    // Various parts of our code (such as ReactCompositeComponent's
			    // _renderValidatedComponent) assume that calls to render aren't nested;
			    // verify that that's the case.
			    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
			    !isValidContainer(container) ? process.env.NODE_ENV !== 'production' ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
			    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
			    var componentInstance = instantiateReactComponent(nextElement, false);
	
			    // The initial render is synchronous but any updates that happen during
			    // rendering, in componentWillMount or componentDidMount, will be batched
			    // according to the current batching strategy.
	
			    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
			    var wrapperID = componentInstance._instance.rootID;
			    instancesByReactRootID[wrapperID] = componentInstance;
	
			    return componentInstance;
			  },
	
			  /**
			   * Renders a React component into the DOM in the supplied `container`.
			   *
			   * If the React component was previously rendered into `container`, this will
			   * perform an update on it and only mutate the DOM as necessary to reflect the
			   * latest React component.
			   *
			   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
			   * @param {ReactElement} nextElement Component element to render.
			   * @param {DOMElement} container DOM element to render into.
			   * @param {?function} callback function triggered on completion
			   * @return {ReactComponent} Component instance rendered in `container`.
			   */
			  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
			    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
			    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
			  },
	
			  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
			    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
			    !React.isValidElement(nextElement) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
			    // Check if it quacks like an element
			    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
			    process.env.NODE_ENV !== 'production' ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
			    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
			    var nextContext;
			    if (parentComponent) {
			      var parentInst = ReactInstanceMap.get(parentComponent);
			      nextContext = parentInst._processChildContext(parentInst._context);
			    } else {
			      nextContext = emptyObject;
			    }
	
			    var prevComponent = getTopLevelWrapperInContainer(container);
	
			    if (prevComponent) {
			      var prevWrappedElement = prevComponent._currentElement;
			      var prevElement = prevWrappedElement.props.child;
			      if (shouldUpdateReactComponent(prevElement, nextElement)) {
			        var publicInst = prevComponent._renderedComponent.getPublicInstance();
			        var updatedCallback = callback && function () {
			          callback.call(publicInst);
			        };
			        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
			        return publicInst;
			      } else {
			        ReactMount.unmountComponentAtNode(container);
			      }
			    }
	
			    var reactRootElement = getReactRootElementInContainer(container);
			    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
			    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
			    if (process.env.NODE_ENV !== 'production') {
			      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
			      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
			        var rootElementSibling = reactRootElement;
			        while (rootElementSibling) {
			          if (internalGetID(rootElementSibling)) {
			            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
			            break;
			          }
			          rootElementSibling = rootElementSibling.nextSibling;
			        }
			      }
			    }
	
			    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
			    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
			    if (callback) {
			      callback.call(component);
			    }
			    return component;
			  },
	
			  /**
			   * Renders a React component into the DOM in the supplied `container`.
			   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
			   *
			   * If the React component was previously rendered into `container`, this will
			   * perform an update on it and only mutate the DOM as necessary to reflect the
			   * latest React component.
			   *
			   * @param {ReactElement} nextElement Component element to render.
			   * @param {DOMElement} container DOM element to render into.
			   * @param {?function} callback function triggered on completion
			   * @return {ReactComponent} Component instance rendered in `container`.
			   */
			  render: function (nextElement, container, callback) {
			    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
			  },
	
			  /**
			   * Unmounts and destroys the React component rendered in the `container`.
			   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
			   *
			   * @param {DOMElement} container DOM element containing a React component.
			   * @return {boolean} True if a component was found in and unmounted from
			   *                   `container`
			   */
			  unmountComponentAtNode: function (container) {
			    // Various parts of our code (such as ReactCompositeComponent's
			    // _renderValidatedComponent) assume that calls to render aren't nested;
			    // verify that that's the case. (Strictly speaking, unmounting won't cause a
			    // render but we still don't expect to be in a render call here.)
			    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
			    !isValidContainer(container) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
			    if (process.env.NODE_ENV !== 'production') {
			      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
			    }
	
			    var prevComponent = getTopLevelWrapperInContainer(container);
			    if (!prevComponent) {
			      // Check if the node being unmounted was rendered by React, but isn't a
			      // root node.
			      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
			      // Check if the container itself is a React root node.
			      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
			      if (process.env.NODE_ENV !== 'production') {
			        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
			      }
	
			      return false;
			    }
			    delete instancesByReactRootID[prevComponent._instance.rootID];
			    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
			    return true;
			  },
	
			  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
			    !isValidContainer(container) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
			    if (shouldReuseMarkup) {
			      var rootElement = getReactRootElementInContainer(container);
			      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
			        ReactDOMComponentTree.precacheNode(instance, rootElement);
			        return;
			      } else {
			        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
			        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
			        var rootMarkup = rootElement.outerHTML;
			        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
			        var normalizedMarkup = markup;
			        if (process.env.NODE_ENV !== 'production') {
			          // because rootMarkup is retrieved from the DOM, various normalizations
			          // will have occurred which will not be present in `markup`. Here,
			          // insert markup into a <div> or <iframe> depending on the container
			          // type to perform the same normalizations before comparing.
			          var normalizer;
			          if (container.nodeType === ELEMENT_NODE_TYPE) {
			            normalizer = document.createElement('div');
			            normalizer.innerHTML = markup;
			            normalizedMarkup = normalizer.innerHTML;
			          } else {
			            normalizer = document.createElement('iframe');
			            document.body.appendChild(normalizer);
			            normalizer.contentDocument.write(markup);
			            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
			            document.body.removeChild(normalizer);
			          }
			        }
	
			        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
			        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
			        !(container.nodeType !== DOC_NODE_TYPE) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
			        if (process.env.NODE_ENV !== 'production') {
			          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
			        }
			      }
			    }
	
			    !(container.nodeType !== DOC_NODE_TYPE) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
			    if (transaction.useCreateElement) {
			      while (container.lastChild) {
			        container.removeChild(container.lastChild);
			      }
			      DOMLazyTree.insertTreeBefore(container, markup, null);
			    } else {
			      setInnerHTML(container, markup);
			      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
			      if (hostNode._debugID !== 0) {
			        ReactInstrumentation.debugTool.onHostOperation({
			          instanceID: hostNode._debugID,
			          type: 'mount',
			          payload: markup.toString()
			        });
			      }
			    }
			  }
			};
	
			module.exports = ReactMount;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 177 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var validateDOMNesting = __webpack_require__(146);
	
			var DOC_NODE_TYPE = 9;
	
			function ReactDOMContainerInfo(topLevelWrapper, node) {
			  var info = {
			    _topLevelWrapper: topLevelWrapper,
			    _idCounter: 1,
			    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
			    _node: node,
			    _tag: node ? node.nodeName.toLowerCase() : null,
			    _namespaceURI: node ? node.namespaceURI : null
			  };
			  if (process.env.NODE_ENV !== 'production') {
			    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
			  }
			  return info;
			}
	
			module.exports = ReactDOMContainerInfo;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 178 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactDOMFeatureFlags = {
			  useCreateElement: true,
			  useFiber: false
			};
	
			module.exports = ReactDOMFeatureFlags;
	
		/***/ },
		/* 179 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var adler32 = __webpack_require__(180);
	
			var TAG_END = /\/?>/;
			var COMMENT_START = /^<\!\-\-/;
	
			var ReactMarkupChecksum = {
			  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
			  /**
			   * @param {string} markup Markup string
			   * @return {string} Markup string with checksum attribute attached
			   */
			  addChecksumToMarkup: function (markup) {
			    var checksum = adler32(markup);
	
			    // Add checksum (handle both parent tags, comments and self-closing tags)
			    if (COMMENT_START.test(markup)) {
			      return markup;
			    } else {
			      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
			    }
			  },
	
			  /**
			   * @param {string} markup to use
			   * @param {DOMElement} element root React element
			   * @returns {boolean} whether or not the markup is the same
			   */
			  canReuseMarkup: function (markup, element) {
			    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
			    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
			    var markupChecksum = adler32(markup);
			    return markupChecksum === existingChecksum;
			  }
			};
	
			module.exports = ReactMarkupChecksum;
	
		/***/ },
		/* 180 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var MOD = 65521;
	
			// adler32 is not cryptographically strong, and is only used to sanity check that
			// markup generated on the server matches the markup generated on the client.
			// This implementation (a modified version of the SheetJS version) has been optimized
			// for our use case, at the expense of conforming to the adler32 specification
			// for non-ascii inputs.
			function adler32(data) {
			  var a = 1;
			  var b = 0;
			  var i = 0;
			  var l = data.length;
			  var m = l & ~0x3;
			  while (i < m) {
			    var n = Math.min(i + 4096, m);
			    for (; i < n; i += 4) {
			      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
			    }
			    a %= MOD;
			    b %= MOD;
			  }
			  for (; i < l; i++) {
			    b += a += data.charCodeAt(i);
			  }
			  a %= MOD;
			  b %= MOD;
			  return a | b << 16;
			}
	
			module.exports = adler32;
	
		/***/ },
		/* 181 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			module.exports = '15.5.3';
	
		/***/ },
		/* 182 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var ReactCurrentOwner = __webpack_require__(43);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactInstanceMap = __webpack_require__(125);
	
			var getHostComponentFromComposite = __webpack_require__(183);
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			/**
			 * Returns the DOM node rendered by this element.
			 *
			 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
			 *
			 * @param {ReactComponent|DOMElement} componentOrElement
			 * @return {?DOMElement} The root node of this element.
			 */
			function findDOMNode(componentOrElement) {
			  if (process.env.NODE_ENV !== 'production') {
			    var owner = ReactCurrentOwner.current;
			    if (owner !== null) {
			      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
			      owner._warnedAboutRefsInRender = true;
			    }
			  }
			  if (componentOrElement == null) {
			    return null;
			  }
			  if (componentOrElement.nodeType === 1) {
			    return componentOrElement;
			  }
	
			  var inst = ReactInstanceMap.get(componentOrElement);
			  if (inst) {
			    inst = getHostComponentFromComposite(inst);
			    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
			  }
	
			  if (typeof componentOrElement.render === 'function') {
			     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
			  } else {
			     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
			  }
			}
	
			module.exports = findDOMNode;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 183 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactNodeTypes = __webpack_require__(129);
	
			function getHostComponentFromComposite(inst) {
			  var type;
	
			  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
			    inst = inst._renderedComponent;
			  }
	
			  if (type === ReactNodeTypes.HOST) {
			    return inst._renderedComponent;
			  } else if (type === ReactNodeTypes.EMPTY) {
			    return null;
			  }
			}
	
			module.exports = getHostComponentFromComposite;
	
		/***/ },
		/* 184 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactMount = __webpack_require__(176);
	
			module.exports = ReactMount.renderSubtreeIntoContainer;
	
		/***/ },
		/* 185 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMProperty = __webpack_require__(7);
			var EventPluginRegistry = __webpack_require__(15);
			var ReactComponentTreeHook = __webpack_require__(41);
	
			var warning = __webpack_require__(18);
	
			if (process.env.NODE_ENV !== 'production') {
			  var reactProps = {
			    children: true,
			    dangerouslySetInnerHTML: true,
			    key: true,
			    ref: true,
	
			    autoFocus: true,
			    defaultValue: true,
			    valueLink: true,
			    defaultChecked: true,
			    checkedLink: true,
			    innerHTML: true,
			    suppressContentEditableWarning: true,
			    onFocusIn: true,
			    onFocusOut: true
			  };
			  var warnedProperties = {};
	
			  var validateProperty = function (tagName, name, debugID) {
			    if (DOMProperty.properties.hasOwnProperty(name) || DOMProperty.isCustomAttribute(name)) {
			      return true;
			    }
			    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
			      return true;
			    }
			    if (EventPluginRegistry.registrationNameModules.hasOwnProperty(name)) {
			      return true;
			    }
			    warnedProperties[name] = true;
			    var lowerCasedName = name.toLowerCase();
	
			    // data-* attributes should be lowercase; suggest the lowercase version
			    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
			    var registrationName = EventPluginRegistry.possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? EventPluginRegistry.possibleRegistrationNames[lowerCasedName] : null;
	
			    if (standardName != null) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown DOM property %s. Did you mean %s?%s', name, standardName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
			      return true;
			    } else if (registrationName != null) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown event handler property %s. Did you mean `%s`?%s', name, registrationName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
			      return true;
			    } else {
			      // We were unable to guess which prop the user intended.
			      // It is likely that the user was just blindly spreading/forwarding props
			      // Components should be careful to only render valid props/attributes.
			      // Warning will be invoked in warnUnknownProperties to allow grouping.
			      return false;
			    }
			  };
			}
	
			var warnUnknownProperties = function (debugID, element) {
			  var unknownProps = [];
			  for (var key in element.props) {
			    var isValid = validateProperty(element.type, key, debugID);
			    if (!isValid) {
			      unknownProps.push(key);
			    }
			  }
	
			  var unknownPropString = unknownProps.map(function (prop) {
			    return '`' + prop + '`';
			  }).join(', ');
	
			  if (unknownProps.length === 1) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown prop %s on <%s> tag. Remove this prop from the element. ' + 'For details, see https://fb.me/react-unknown-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
			  } else if (unknownProps.length > 1) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown props %s on <%s> tag. Remove these props from the element. ' + 'For details, see https://fb.me/react-unknown-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
			  }
			};
	
			function handleElement(debugID, element) {
			  if (element == null || typeof element.type !== 'string') {
			    return;
			  }
			  if (element.type.indexOf('-') >= 0 || element.props.is) {
			    return;
			  }
			  warnUnknownProperties(debugID, element);
			}
	
			var ReactDOMUnknownPropertyHook = {
			  onBeforeMountComponent: function (debugID, element) {
			    handleElement(debugID, element);
			  },
			  onBeforeUpdateComponent: function (debugID, element) {
			    handleElement(debugID, element);
			  }
			};
	
			module.exports = ReactDOMUnknownPropertyHook;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 186 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactComponentTreeHook = __webpack_require__(41);
	
			var warning = __webpack_require__(18);
	
			var didWarnValueNull = false;
	
			function handleElement(debugID, element) {
			  if (element == null) {
			    return;
			  }
			  if (element.type !== 'input' && element.type !== 'textarea' && element.type !== 'select') {
			    return;
			  }
			  if (element.props != null && element.props.value === null && !didWarnValueNull) {
			    process.env.NODE_ENV !== 'production' ? warning(false, '`value` prop on `%s` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.%s', element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	
			    didWarnValueNull = true;
			  }
			}
	
			var ReactDOMNullInputValuePropHook = {
			  onBeforeMountComponent: function (debugID, element) {
			    handleElement(debugID, element);
			  },
			  onBeforeUpdateComponent: function (debugID, element) {
			    handleElement(debugID, element);
			  }
			};
	
			module.exports = ReactDOMNullInputValuePropHook;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 187 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMProperty = __webpack_require__(7);
			var ReactComponentTreeHook = __webpack_require__(41);
	
			var warning = __webpack_require__(18);
	
			var warnedProperties = {};
			var rARIA = new RegExp('^(aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	
			function validateProperty(tagName, name, debugID) {
			  if (warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
			    return true;
			  }
	
			  if (rARIA.test(name)) {
			    var lowerCasedName = name.toLowerCase();
			    var standardName = DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
			    // If this is an aria-* attribute, but is not listed in the known DOM
			    // DOM properties, then it is an invalid aria-* attribute.
			    if (standardName == null) {
			      warnedProperties[name] = true;
			      return false;
			    }
			    // aria-* attributes should be lowercase; suggest the lowercase version.
			    if (name !== standardName) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown ARIA attribute %s. Did you mean %s?%s', name, standardName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
			      warnedProperties[name] = true;
			      return true;
			    }
			  }
	
			  return true;
			}
	
			function warnInvalidARIAProps(debugID, element) {
			  var invalidProps = [];
	
			  for (var key in element.props) {
			    var isValid = validateProperty(element.type, key, debugID);
			    if (!isValid) {
			      invalidProps.push(key);
			    }
			  }
	
			  var unknownPropString = invalidProps.map(function (prop) {
			    return '`' + prop + '`';
			  }).join(', ');
	
			  if (invalidProps.length === 1) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid aria prop %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
			  } else if (invalidProps.length > 1) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid aria props %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
			  }
			}
	
			function handleElement(debugID, element) {
			  if (element == null || typeof element.type !== 'string') {
			    return;
			  }
			  if (element.type.indexOf('-') >= 0 || element.props.is) {
			    return;
			  }
	
			  warnInvalidARIAProps(debugID, element);
			}
	
			var ReactDOMInvalidARIAHook = {
			  onBeforeMountComponent: function (debugID, element) {
			    if (process.env.NODE_ENV !== 'production') {
			      handleElement(debugID, element);
			    }
			  },
			  onBeforeUpdateComponent: function (debugID, element) {
			    if (process.env.NODE_ENV !== 'production') {
			      handleElement(debugID, element);
			    }
			  }
			};
	
			module.exports = ReactDOMInvalidARIAHook;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 188 */
		/***/ function(module, exports, __webpack_require__) {
	
			var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
			  Copyright (c) 2015 Jed Watson.
			  Licensed under the MIT License (MIT), see
			  http://jedwatson.github.io/classnames
			*/
	
			function classNames() {
				var classes = '';
				var arg;
	
				for (var i = 0; i < arguments.length; i++) {
					arg = arguments[i];
					if (!arg) {
						continue;
					}
	
					if ('string' === typeof arg || 'number' === typeof arg) {
						classes += ' ' + arg;
					} else if (Object.prototype.toString.call(arg) === '[object Array]') {
						classes += ' ' + classNames.apply(null, arg);
					} else if ('object' === typeof arg) {
						for (var key in arg) {
							if (!arg.hasOwnProperty(key) || !arg[key]) {
								continue;
							}
							classes += ' ' + key;
						}
					}
				}
				return classes.substr(1);
			}
	
			// safely export classNames for node / browserify
			if (typeof module !== 'undefined' && module.exports) {
				module.exports = classNames;
			}
	
			// safely export classNames for RequireJS
			if (true) {
				!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
					return classNames;
				}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			}
	
	
		/***/ }
		/******/ ])
		});
		;
	
	/***/ }),
	/* 399 */
	/***/ (function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(240);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../../css-loader/index.js!./react-select.css", function() {
					var newContent = require("!!../../css-loader/index.js!./react-select.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ }),
	/* 400 */
	/***/ (function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(241);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-drop-target.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-drop-target.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ }),
	/* 401 */
	/***/ (function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(242);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-image.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-image.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ }),
	/* 402 */
	/***/ (function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(244);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./ron-react-autocomplete.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./ron-react-autocomplete.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ }),
	/* 403 */
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(404);
	
	
	/***/ }),
	/* 404 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _ponyfill = __webpack_require__(405);
	
		var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var root; /* global window */
	
	
		if (typeof self !== 'undefined') {
		  root = self;
		} else if (typeof window !== 'undefined') {
		  root = window;
		} else if (typeof (window) !== 'undefined') {
		  root = (window);
		} else if (true) {
		  root = module;
		} else {
		  root = Function('return this')();
		}
	
		var result = (0, _ponyfill2['default'])(root);
		exports['default'] = result;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))
	
	/***/ }),
	/* 405 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
		exports['default'] = symbolObservablePonyfill;
		function symbolObservablePonyfill(root) {
			var result;
			var _Symbol = root.Symbol;
	
			if (typeof _Symbol === 'function') {
				if (_Symbol.observable) {
					result = _Symbol.observable;
				} else {
					result = _Symbol('observable');
					_Symbol.observable = result;
				}
			} else {
				result = '@@observable';
			}
	
			return result;
		};
	
	/***/ }),
	/* 406 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2014-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
	
		var warning = function() {};
	
		if (false) {
		  warning = function(condition, format, args) {
		    var len = arguments.length;
		    args = new Array(len > 2 ? len - 2 : 0);
		    for (var key = 2; key < len; key++) {
		      args[key - 2] = arguments[key];
		    }
		    if (format === undefined) {
		      throw new Error(
		        '`warning(condition, format, ...args)` requires a warning ' +
		        'message argument'
		      );
		    }
	
		    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
		      throw new Error(
		        'The warning format should be able to uniquely identify this ' +
		        'warning. Please, use a more descriptive format than: ' + format
		      );
		    }
	
		    if (!condition) {
		      var argIndex = 0;
		      var message = 'Warning: ' +
		        format.replace(/%s/g, function() {
		          return args[argIndex++];
		        });
		      if (typeof console !== 'undefined') {
		        console.error(message);
		      }
		      try {
		        // This error was thrown as a convenience so that you can use this stack
		        // to find the callsite that caused this warning to fire.
		        throw new Error(message);
		      } catch(x) {}
		    }
		  };
		}
	
		module.exports = warning;
	
	
	/***/ }),
	/* 407 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(21),
		    root = __webpack_require__(12);
	
		/* Built-in method references that are verified to be native. */
		var DataView = getNative(root, 'DataView');
	
		module.exports = DataView;
	
	
	/***/ }),
	/* 408 */
	[1610, 456, 457, 458, 459, 460],
	/* 409 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(21),
		    root = __webpack_require__(12);
	
		/* Built-in method references that are verified to be native. */
		var Promise = getNative(root, 'Promise');
	
		module.exports = Promise;
	
	
	/***/ }),
	/* 410 */
	[1629, 21, 12],
	/* 411 */
	[1636, 89, 480, 481],
	/* 412 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var root = __webpack_require__(12);
	
		/** Built-in value references. */
		var Uint8Array = root.Uint8Array;
	
		module.exports = Uint8Array;
	
	
	/***/ }),
	/* 413 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(21),
		    root = __webpack_require__(12);
	
		/* Built-in method references that are verified to be native. */
		var WeakMap = getNative(root, 'WeakMap');
	
		module.exports = WeakMap;
	
	
	/***/ }),
	/* 414 */
	/***/ (function(module, exports) {
	
		/**
		 * A specialized version of `baseAggregator` for arrays.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} setter The function to set `accumulator` values.
		 * @param {Function} iteratee The iteratee to transform keys.
		 * @param {Object} accumulator The initial aggregated object.
		 * @returns {Function} Returns `accumulator`.
		 */
		function arrayAggregator(array, setter, iteratee, accumulator) {
		  var index = -1,
		      length = array == null ? 0 : array.length;
	
		  while (++index < length) {
		    var value = array[index];
		    setter(accumulator, value, iteratee(value), array);
		  }
		  return accumulator;
		}
	
		module.exports = arrayAggregator;
	
	
	/***/ }),
	/* 415 */
	283,
	/* 416 */
	[1648, 438, 156, 13, 158, 151, 160],
	/* 417 */
	80,
	/* 418 */
	285,
	/* 419 */
	/***/ (function(module, exports) {
	
		/**
		 * A specialized version of `_.some` for arrays without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {boolean} Returns `true` if any element passes the predicate check,
		 *  else `false`.
		 */
		function arraySome(array, predicate) {
		  var index = -1,
		      length = array == null ? 0 : array.length;
	
		  while (++index < length) {
		    if (predicate(array[index], index, array)) {
		      return true;
		    }
		  }
		  return false;
		}
	
		module.exports = arraySome;
	
	
	/***/ }),
	/* 420 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseEach = __webpack_require__(422);
	
		/**
		 * Aggregates elements of `collection` on `accumulator` with keys transformed
		 * by `iteratee` and values set by `setter`.
		 *
		 * @private
		 * @param {Array|Object} collection The collection to iterate over.
		 * @param {Function} setter The function to set `accumulator` values.
		 * @param {Function} iteratee The iteratee to transform keys.
		 * @param {Object} accumulator The initial aggregated object.
		 * @returns {Function} Returns `accumulator`.
		 */
		function baseAggregator(collection, setter, iteratee, accumulator) {
		  baseEach(collection, function(value, key, collection) {
		    setter(accumulator, value, iteratee(value), collection);
		  });
		  return accumulator;
		}
	
		module.exports = baseAggregator;
	
	
	/***/ }),
	/* 421 */
	[1656, 446],
	/* 422 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseForOwn = __webpack_require__(424),
		    createBaseEach = __webpack_require__(444);
	
		/**
		 * The base implementation of `_.forEach` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Array|Object} collection The collection to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array|Object} Returns `collection`.
		 */
		var baseEach = createBaseEach(baseForOwn);
	
		module.exports = baseEach;
	
	
	/***/ }),
	/* 423 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var createBaseFor = __webpack_require__(445);
	
		/**
		 * The base implementation of `baseForOwn` which iterates over `object`
		 * properties returned by `keysFunc` and invokes `iteratee` for each property.
		 * Iteratee functions may exit iteration early by explicitly returning `false`.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @returns {Object} Returns `object`.
		 */
		var baseFor = createBaseFor();
	
		module.exports = baseFor;
	
	
	/***/ }),
	/* 424 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseFor = __webpack_require__(423),
		    keys = __webpack_require__(94);
	
		/**
		 * The base implementation of `_.forOwn` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Object} Returns `object`.
		 */
		function baseForOwn(object, iteratee) {
		  return object && baseFor(object, iteratee, keys);
		}
	
		module.exports = baseForOwn;
	
	
	/***/ }),
	/* 425 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var arrayPush = __webpack_require__(418),
		    isArray = __webpack_require__(13);
	
		/**
		 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
		 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
		 * symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @param {Function} symbolsFunc The function to get the symbols of `object`.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function baseGetAllKeys(object, keysFunc, symbolsFunc) {
		  var result = keysFunc(object);
		  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
		}
	
		module.exports = baseGetAllKeys;
	
	
	/***/ }),
	/* 426 */
	/***/ (function(module, exports) {
	
		/**
		 * The base implementation of `_.hasIn` without support for deep paths.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {Array|string} key The key to check.
		 * @returns {boolean} Returns `true` if `key` exists, else `false`.
		 */
		function baseHasIn(object, key) {
		  return object != null && key in Object(object);
		}
	
		module.exports = baseHasIn;
	
	
	/***/ }),
	/* 427 */
	[1667, 31, 32],
	/* 428 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var Stack = __webpack_require__(145),
		    equalArrays = __webpack_require__(149),
		    equalByTag = __webpack_require__(447),
		    equalObjects = __webpack_require__(448),
		    getTag = __webpack_require__(453),
		    isArray = __webpack_require__(13),
		    isBuffer = __webpack_require__(158),
		    isTypedArray = __webpack_require__(160);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1;
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    objectTag = '[object Object]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * A specialized version of `baseIsEqual` for arrays and objects which performs
		 * deep comparisons and tracks traversed objects enabling objects with circular
		 * references to be compared.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
		  var objIsArr = isArray(object),
		      othIsArr = isArray(other),
		      objTag = objIsArr ? arrayTag : getTag(object),
		      othTag = othIsArr ? arrayTag : getTag(other);
	
		  objTag = objTag == argsTag ? objectTag : objTag;
		  othTag = othTag == argsTag ? objectTag : othTag;
	
		  var objIsObj = objTag == objectTag,
		      othIsObj = othTag == objectTag,
		      isSameTag = objTag == othTag;
	
		  if (isSameTag && isBuffer(object)) {
		    if (!isBuffer(other)) {
		      return false;
		    }
		    objIsArr = true;
		    objIsObj = false;
		  }
		  if (isSameTag && !objIsObj) {
		    stack || (stack = new Stack);
		    return (objIsArr || isTypedArray(object))
		      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
		      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
		  }
		  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
		    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
		        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
		    if (objIsWrapped || othIsWrapped) {
		      var objUnwrapped = objIsWrapped ? object.value() : object,
		          othUnwrapped = othIsWrapped ? other.value() : other;
	
		      stack || (stack = new Stack);
		      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
		    }
		  }
		  if (!isSameTag) {
		    return false;
		  }
		  stack || (stack = new Stack);
		  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
		}
	
		module.exports = baseIsEqualDeep;
	
	
	/***/ }),
	/* 429 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var Stack = __webpack_require__(145),
		    baseIsEqual = __webpack_require__(147);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;
	
		/**
		 * The base implementation of `_.isMatch` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Object} object The object to inspect.
		 * @param {Object} source The object of property values to match.
		 * @param {Array} matchData The property names, values, and compare flags to match.
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
		 */
		function baseIsMatch(object, source, matchData, customizer) {
		  var index = matchData.length,
		      length = index,
		      noCustomizer = !customizer;
	
		  if (object == null) {
		    return !length;
		  }
		  object = Object(object);
		  while (index--) {
		    var data = matchData[index];
		    if ((noCustomizer && data[2])
		          ? data[1] !== object[data[0]]
		          : !(data[0] in object)
		        ) {
		      return false;
		    }
		  }
		  while (++index < length) {
		    data = matchData[index];
		    var key = data[0],
		        objValue = object[key],
		        srcValue = data[1];
	
		    if (noCustomizer && data[2]) {
		      if (objValue === undefined && !(key in object)) {
		        return false;
		      }
		    } else {
		      var stack = new Stack;
		      if (customizer) {
		        var result = customizer(objValue, srcValue, key, object, source, stack);
		      }
		      if (!(result === undefined
		            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
		            : result
		          )) {
		        return false;
		      }
		    }
		  }
		  return true;
		}
	
		module.exports = baseIsMatch;
	
	
	/***/ }),
	/* 430 */
	[1672, 159, 462, 92, 154],
	/* 431 */
	[1675, 31, 91, 32],
	/* 432 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseMatches = __webpack_require__(434),
		    baseMatchesProperty = __webpack_require__(435),
		    identity = __webpack_require__(492),
		    isArray = __webpack_require__(13),
		    property = __webpack_require__(494);
	
		/**
		 * The base implementation of `_.iteratee`.
		 *
		 * @private
		 * @param {*} [value=_.identity] The value to convert to an iteratee.
		 * @returns {Function} Returns the iteratee.
		 */
		function baseIteratee(value) {
		  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
		  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
		  if (typeof value == 'function') {
		    return value;
		  }
		  if (value == null) {
		    return identity;
		  }
		  if (typeof value == 'object') {
		    return isArray(value)
		      ? baseMatchesProperty(value[0], value[1])
		      : baseMatches(value);
		  }
		  return property(value);
		}
	
		module.exports = baseIteratee;
	
	
	/***/ }),
	/* 433 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var isPrototype = __webpack_require__(463),
		    nativeKeys = __webpack_require__(476);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeys(object) {
		  if (!isPrototype(object)) {
		    return nativeKeys(object);
		  }
		  var result = [];
		  for (var key in Object(object)) {
		    if (hasOwnProperty.call(object, key) && key != 'constructor') {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = baseKeys;
	
	
	/***/ }),
	/* 434 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseIsMatch = __webpack_require__(429),
		    getMatchData = __webpack_require__(450),
		    matchesStrictComparable = __webpack_require__(153);
	
		/**
		 * The base implementation of `_.matches` which doesn't clone `source`.
		 *
		 * @private
		 * @param {Object} source The object of property values to match.
		 * @returns {Function} Returns the new spec function.
		 */
		function baseMatches(source) {
		  var matchData = getMatchData(source);
		  if (matchData.length == 1 && matchData[0][2]) {
		    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
		  }
		  return function(object) {
		    return object === source || baseIsMatch(object, source, matchData);
		  };
		}
	
		module.exports = baseMatches;
	
	
	/***/ }),
	/* 435 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseIsEqual = __webpack_require__(147),
		    get = __webpack_require__(489),
		    hasIn = __webpack_require__(491),
		    isKey = __webpack_require__(90),
		    isStrictComparable = __webpack_require__(152),
		    matchesStrictComparable = __webpack_require__(153),
		    toKey = __webpack_require__(57);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;
	
		/**
		 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
		 *
		 * @private
		 * @param {string} path The path of the property to get.
		 * @param {*} srcValue The value to match.
		 * @returns {Function} Returns the new spec function.
		 */
		function baseMatchesProperty(path, srcValue) {
		  if (isKey(path) && isStrictComparable(srcValue)) {
		    return matchesStrictComparable(toKey(path), srcValue);
		  }
		  return function(object) {
		    var objValue = get(object, path);
		    return (objValue === undefined && objValue === srcValue)
		      ? hasIn(object, path)
		      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
		  };
		}
	
		module.exports = baseMatchesProperty;
	
	
	/***/ }),
	/* 436 */
	/***/ (function(module, exports) {
	
		/**
		 * The base implementation of `_.property` without support for deep paths.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */
		function baseProperty(key) {
		  return function(object) {
		    return object == null ? undefined : object[key];
		  };
		}
	
		module.exports = baseProperty;
	
	
	/***/ }),
	/* 437 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseGet = __webpack_require__(146);
	
		/**
		 * A specialized version of `baseProperty` which supports deep paths.
		 *
		 * @private
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */
		function basePropertyDeep(path) {
		  return function(object) {
		    return baseGet(object, path);
		  };
		}
	
		module.exports = basePropertyDeep;
	
	
	/***/ }),
	/* 438 */
	296,
	/* 439 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var Symbol = __webpack_require__(53),
		    arrayMap = __webpack_require__(417),
		    isArray = __webpack_require__(13),
		    isSymbol = __webpack_require__(93);
	
		/** Used as references for various `Number` constants. */
		var INFINITY = 1 / 0;
	
		/** Used to convert symbols to primitives and strings. */
		var symbolProto = Symbol ? Symbol.prototype : undefined,
		    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
		/**
		 * The base implementation of `_.toString` which doesn't convert nullish
		 * values to empty strings.
		 *
		 * @private
		 * @param {*} value The value to process.
		 * @returns {string} Returns the string.
		 */
		function baseToString(value) {
		  // Exit early for strings to avoid a performance hit in some environments.
		  if (typeof value == 'string') {
		    return value;
		  }
		  if (isArray(value)) {
		    // Recursively convert values (susceptible to call stack limits).
		    return arrayMap(value, baseToString) + '';
		  }
		  if (isSymbol(value)) {
		    return symbolToString ? symbolToString.call(value) : '';
		  }
		  var result = (value + '');
		  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
		}
	
		module.exports = baseToString;
	
	
	/***/ }),
	/* 440 */
	81,
	/* 441 */
	82,
	/* 442 */
	[1680, 12],
	/* 443 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var arrayAggregator = __webpack_require__(414),
		    baseAggregator = __webpack_require__(420),
		    baseIteratee = __webpack_require__(432),
		    isArray = __webpack_require__(13);
	
		/**
		 * Creates a function like `_.groupBy`.
		 *
		 * @private
		 * @param {Function} setter The function to set accumulator values.
		 * @param {Function} [initializer] The accumulator object initializer.
		 * @returns {Function} Returns the new aggregator function.
		 */
		function createAggregator(setter, initializer) {
		  return function(collection, iteratee) {
		    var func = isArray(collection) ? arrayAggregator : baseAggregator,
		        accumulator = initializer ? initializer() : {};
	
		    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
		  };
		}
	
		module.exports = createAggregator;
	
	
	/***/ }),
	/* 444 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var isArrayLike = __webpack_require__(157);
	
		/**
		 * Creates a `baseEach` or `baseEachRight` function.
		 *
		 * @private
		 * @param {Function} eachFunc The function to iterate over a collection.
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new base function.
		 */
		function createBaseEach(eachFunc, fromRight) {
		  return function(collection, iteratee) {
		    if (collection == null) {
		      return collection;
		    }
		    if (!isArrayLike(collection)) {
		      return eachFunc(collection, iteratee);
		    }
		    var length = collection.length,
		        index = fromRight ? length : -1,
		        iterable = Object(collection);
	
		    while ((fromRight ? index-- : ++index < length)) {
		      if (iteratee(iterable[index], index, iterable) === false) {
		        break;
		      }
		    }
		    return collection;
		  };
		}
	
		module.exports = createBaseEach;
	
	
	/***/ }),
	/* 445 */
	/***/ (function(module, exports) {
	
		/**
		 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
		 *
		 * @private
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new base function.
		 */
		function createBaseFor(fromRight) {
		  return function(object, iteratee, keysFunc) {
		    var index = -1,
		        iterable = Object(object),
		        props = keysFunc(object),
		        length = props.length;
	
		    while (length--) {
		      var key = props[fromRight ? length : ++index];
		      if (iteratee(iterable[key], key, iterable) === false) {
		        break;
		      }
		    }
		    return object;
		  };
		}
	
		module.exports = createBaseFor;
	
	
	/***/ }),
	/* 446 */
	[1688, 21],
	/* 447 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var Symbol = __webpack_require__(53),
		    Uint8Array = __webpack_require__(412),
		    eq = __webpack_require__(155),
		    equalArrays = __webpack_require__(149),
		    mapToArray = __webpack_require__(474),
		    setToArray = __webpack_require__(482);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;
	
		/** `Object#toString` result references. */
		var boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    symbolTag = '[object Symbol]';
	
		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]';
	
		/** Used to convert symbols to primitives and strings. */
		var symbolProto = Symbol ? Symbol.prototype : undefined,
		    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
		/**
		 * A specialized version of `baseIsEqualDeep` for comparing objects of
		 * the same `toStringTag`.
		 *
		 * **Note:** This function only supports comparing values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {string} tag The `toStringTag` of the objects to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
		  switch (tag) {
		    case dataViewTag:
		      if ((object.byteLength != other.byteLength) ||
		          (object.byteOffset != other.byteOffset)) {
		        return false;
		      }
		      object = object.buffer;
		      other = other.buffer;
	
		    case arrayBufferTag:
		      if ((object.byteLength != other.byteLength) ||
		          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
		        return false;
		      }
		      return true;
	
		    case boolTag:
		    case dateTag:
		    case numberTag:
		      // Coerce booleans to `1` or `0` and dates to milliseconds.
		      // Invalid dates are coerced to `NaN`.
		      return eq(+object, +other);
	
		    case errorTag:
		      return object.name == other.name && object.message == other.message;
	
		    case regexpTag:
		    case stringTag:
		      // Coerce regexes to strings and treat strings, primitives and objects,
		      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
		      // for more details.
		      return object == (other + '');
	
		    case mapTag:
		      var convert = mapToArray;
	
		    case setTag:
		      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
		      convert || (convert = setToArray);
	
		      if (object.size != other.size && !isPartial) {
		        return false;
		      }
		      // Assume cyclic values are equal.
		      var stacked = stack.get(object);
		      if (stacked) {
		        return stacked == other;
		      }
		      bitmask |= COMPARE_UNORDERED_FLAG;
	
		      // Recursively compare objects (susceptible to call stack limits).
		      stack.set(object, other);
		      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
		      stack['delete'](object);
		      return result;
	
		    case symbolTag:
		      if (symbolValueOf) {
		        return symbolValueOf.call(object) == symbolValueOf.call(other);
		      }
		  }
		  return false;
		}
	
		module.exports = equalByTag;
	
	
	/***/ }),
	/* 448 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var getAllKeys = __webpack_require__(449);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1;
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * A specialized version of `baseIsEqualDeep` for objects with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
		  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
		      objProps = getAllKeys(object),
		      objLength = objProps.length,
		      othProps = getAllKeys(other),
		      othLength = othProps.length;
	
		  if (objLength != othLength && !isPartial) {
		    return false;
		  }
		  var index = objLength;
		  while (index--) {
		    var key = objProps[index];
		    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
		      return false;
		    }
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(object);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var result = true;
		  stack.set(object, other);
		  stack.set(other, object);
	
		  var skipCtor = isPartial;
		  while (++index < objLength) {
		    key = objProps[index];
		    var objValue = object[key],
		        othValue = other[key];
	
		    if (customizer) {
		      var compared = isPartial
		        ? customizer(othValue, objValue, key, other, object, stack)
		        : customizer(objValue, othValue, key, object, other, stack);
		    }
		    // Recursively compare objects (susceptible to call stack limits).
		    if (!(compared === undefined
		          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
		          : compared
		        )) {
		      result = false;
		      break;
		    }
		    skipCtor || (skipCtor = key == 'constructor');
		  }
		  if (result && !skipCtor) {
		    var objCtor = object.constructor,
		        othCtor = other.constructor;
	
		    // Non `Object` object instances with different constructors are not equal.
		    if (objCtor != othCtor &&
		        ('constructor' in object && 'constructor' in other) &&
		        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
		          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
		      result = false;
		    }
		  }
		  stack['delete'](object);
		  stack['delete'](other);
		  return result;
		}
	
		module.exports = equalObjects;
	
	
	/***/ }),
	/* 449 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseGetAllKeys = __webpack_require__(425),
		    getSymbols = __webpack_require__(452),
		    keys = __webpack_require__(94);
	
		/**
		 * Creates an array of own enumerable property names and symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function getAllKeys(object) {
		  return baseGetAllKeys(object, keys, getSymbols);
		}
	
		module.exports = getAllKeys;
	
	
	/***/ }),
	/* 450 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var isStrictComparable = __webpack_require__(152),
		    keys = __webpack_require__(94);
	
		/**
		 * Gets the property names, values, and compare flags of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the match data of `object`.
		 */
		function getMatchData(object) {
		  var result = keys(object),
		      length = result.length;
	
		  while (length--) {
		    var key = result[length],
		        value = object[key];
	
		    result[length] = [key, value, isStrictComparable(value)];
		  }
		  return result;
		}
	
		module.exports = getMatchData;
	
	
	/***/ }),
	/* 451 */
	[1700, 53],
	/* 452 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var arrayFilter = __webpack_require__(415),
		    stubArray = __webpack_require__(495);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Built-in value references. */
		var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeGetSymbols = Object.getOwnPropertySymbols;
	
		/**
		 * Creates an array of the own enumerable symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of symbols.
		 */
		var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
		  if (object == null) {
		    return [];
		  }
		  object = Object(object);
		  return arrayFilter(nativeGetSymbols(object), function(symbol) {
		    return propertyIsEnumerable.call(object, symbol);
		  });
		};
	
		module.exports = getSymbols;
	
	
	/***/ }),
	/* 453 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var DataView = __webpack_require__(407),
		    Map = __webpack_require__(88),
		    Promise = __webpack_require__(409),
		    Set = __webpack_require__(410),
		    WeakMap = __webpack_require__(413),
		    baseGetTag = __webpack_require__(31),
		    toSource = __webpack_require__(154);
	
		/** `Object#toString` result references. */
		var mapTag = '[object Map]',
		    objectTag = '[object Object]',
		    promiseTag = '[object Promise]',
		    setTag = '[object Set]',
		    weakMapTag = '[object WeakMap]';
	
		var dataViewTag = '[object DataView]';
	
		/** Used to detect maps, sets, and weakmaps. */
		var dataViewCtorString = toSource(DataView),
		    mapCtorString = toSource(Map),
		    promiseCtorString = toSource(Promise),
		    setCtorString = toSource(Set),
		    weakMapCtorString = toSource(WeakMap);
	
		/**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		var getTag = baseGetTag;
	
		// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
		if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
		    (Map && getTag(new Map) != mapTag) ||
		    (Promise && getTag(Promise.resolve()) != promiseTag) ||
		    (Set && getTag(new Set) != setTag) ||
		    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
		  getTag = function(value) {
		    var result = baseGetTag(value),
		        Ctor = result == objectTag ? value.constructor : undefined,
		        ctorString = Ctor ? toSource(Ctor) : '';
	
		    if (ctorString) {
		      switch (ctorString) {
		        case dataViewCtorString: return dataViewTag;
		        case mapCtorString: return mapTag;
		        case promiseCtorString: return promiseTag;
		        case setCtorString: return setTag;
		        case weakMapCtorString: return weakMapTag;
		      }
		    }
		    return result;
		  };
		}
	
		module.exports = getTag;
	
	
	/***/ }),
	/* 454 */
	306,
	/* 455 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var castPath = __webpack_require__(148),
		    isArguments = __webpack_require__(156),
		    isArray = __webpack_require__(13),
		    isIndex = __webpack_require__(151),
		    isLength = __webpack_require__(91),
		    toKey = __webpack_require__(57);
	
		/**
		 * Checks if `path` exists on `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path to check.
		 * @param {Function} hasFunc The function to check properties.
		 * @returns {boolean} Returns `true` if `path` exists, else `false`.
		 */
		function hasPath(object, path, hasFunc) {
		  path = castPath(path, object);
	
		  var index = -1,
		      length = path.length,
		      result = false;
	
		  while (++index < length) {
		    var key = toKey(path[index]);
		    if (!(result = object != null && hasFunc(object, key))) {
		      break;
		    }
		    object = object[key];
		  }
		  if (result || ++index != length) {
		    return result;
		  }
		  length = object == null ? 0 : object.length;
		  return !!length && isLength(length) && isIndex(key, length) &&
		    (isArray(object) || isArguments(object));
		}
	
		module.exports = hasPath;
	
	
	/***/ }),
	/* 456 */
	[1704, 56],
	/* 457 */
	308,
	/* 458 */
	[1709, 56],
	/* 459 */
	[1714, 56],
	/* 460 */
	[1721, 56],
	/* 461 */
	314,
	/* 462 */
	[1725, 442],
	/* 463 */
	316,
	/* 464 */
	317,
	/* 465 */
	[1732, 54],
	/* 466 */
	[1736, 54],
	/* 467 */
	[1742, 54],
	/* 468 */
	[1744, 54],
	/* 469 */
	[1749, 408, 52, 88],
	/* 470 */
	[1757, 55],
	/* 471 */
	[1761, 55],
	/* 472 */
	[1767, 55],
	/* 473 */
	[1772, 55],
	/* 474 */
	/***/ (function(module, exports) {
	
		/**
		 * Converts `map` to its key-value pairs.
		 *
		 * @private
		 * @param {Object} map The map to convert.
		 * @returns {Array} Returns the key-value pairs.
		 */
		function mapToArray(map) {
		  var index = -1,
		      result = Array(map.size);
	
		  map.forEach(function(value, key) {
		    result[++index] = [key, value];
		  });
		  return result;
		}
	
		module.exports = mapToArray;
	
	
	/***/ }),
	/* 475 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var memoize = __webpack_require__(493);
	
		/** Used as the maximum memoize cache size. */
		var MAX_MEMOIZE_SIZE = 500;
	
		/**
		 * A specialized version of `_.memoize` which clears the memoized function's
		 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
		 *
		 * @private
		 * @param {Function} func The function to have its output memoized.
		 * @returns {Function} Returns the new memoized function.
		 */
		function memoizeCapped(func) {
		  var result = memoize(func, function(key) {
		    if (cache.size === MAX_MEMOIZE_SIZE) {
		      cache.clear();
		    }
		    return key;
		  });
	
		  var cache = result.cache;
		  return result;
		}
	
		module.exports = memoizeCapped;
	
	
	/***/ }),
	/* 476 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var overArg = __webpack_require__(479);
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeKeys = overArg(Object.keys, Object);
	
		module.exports = nativeKeys;
	
	
	/***/ }),
	/* 477 */
	[1779, 150],
	/* 478 */
	329,
	/* 479 */
	330,
	/* 480 */
	332,
	/* 481 */
	333,
	/* 482 */
	117,
	/* 483 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var ListCache = __webpack_require__(52);
	
		/**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */
		function stackClear() {
		  this.__data__ = new ListCache;
		  this.size = 0;
		}
	
		module.exports = stackClear;
	
	
	/***/ }),
	/* 484 */
	/***/ (function(module, exports) {
	
		/**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function stackDelete(key) {
		  var data = this.__data__,
		      result = data['delete'](key);
	
		  this.size = data.size;
		  return result;
		}
	
		module.exports = stackDelete;
	
	
	/***/ }),
	/* 485 */
	/***/ (function(module, exports) {
	
		/**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function stackGet(key) {
		  return this.__data__.get(key);
		}
	
		module.exports = stackGet;
	
	
	/***/ }),
	/* 486 */
	/***/ (function(module, exports) {
	
		/**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function stackHas(key) {
		  return this.__data__.has(key);
		}
	
		module.exports = stackHas;
	
	
	/***/ }),
	/* 487 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var ListCache = __webpack_require__(52),
		    Map = __webpack_require__(88),
		    MapCache = __webpack_require__(89);
	
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;
	
		/**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */
		function stackSet(key, value) {
		  var data = this.__data__;
		  if (data instanceof ListCache) {
		    var pairs = data.__data__;
		    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
		      pairs.push([key, value]);
		      this.size = ++data.size;
		      return this;
		    }
		    data = this.__data__ = new MapCache(pairs);
		  }
		  data.set(key, value);
		  this.size = data.size;
		  return this;
		}
	
		module.exports = stackSet;
	
	
	/***/ }),
	/* 488 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var memoizeCapped = __webpack_require__(475);
	
		/** Used to match property names within property paths. */
		var reLeadingDot = /^\./,
		    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
		/** Used to match backslashes in property paths. */
		var reEscapeChar = /\\(\\)?/g;
	
		/**
		 * Converts `string` to a property path array.
		 *
		 * @private
		 * @param {string} string The string to convert.
		 * @returns {Array} Returns the property path array.
		 */
		var stringToPath = memoizeCapped(function(string) {
		  var result = [];
		  if (reLeadingDot.test(string)) {
		    result.push('');
		  }
		  string.replace(rePropName, function(match, number, quote, string) {
		    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
		  });
		  return result;
		});
	
		module.exports = stringToPath;
	
	
	/***/ }),
	/* 489 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseGet = __webpack_require__(146);
	
		/**
		 * Gets the value at `path` of `object`. If the resolved value is
		 * `undefined`, the `defaultValue` is returned in its place.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.7.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path of the property to get.
		 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
		 * @returns {*} Returns the resolved value.
		 * @example
		 *
		 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
		 *
		 * _.get(object, 'a[0].b.c');
		 * // => 3
		 *
		 * _.get(object, ['a', '0', 'b', 'c']);
		 * // => 3
		 *
		 * _.get(object, 'a.b.c', 'default');
		 * // => 'default'
		 */
		function get(object, path, defaultValue) {
		  var result = object == null ? undefined : baseGet(object, path);
		  return result === undefined ? defaultValue : result;
		}
	
		module.exports = get;
	
	
	/***/ }),
	/* 490 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseAssignValue = __webpack_require__(421),
		    createAggregator = __webpack_require__(443);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Creates an object composed of keys generated from the results of running
		 * each element of `collection` thru `iteratee`. The order of grouped values
		 * is determined by the order they occur in `collection`. The corresponding
		 * value of each key is an array of elements responsible for generating the
		 * key. The iteratee is invoked with one argument: (value).
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Collection
		 * @param {Array|Object} collection The collection to iterate over.
		 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
		 * @returns {Object} Returns the composed aggregate object.
		 * @example
		 *
		 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
		 * // => { '4': [4.2], '6': [6.1, 6.3] }
		 *
		 * // The `_.property` iteratee shorthand.
		 * _.groupBy(['one', 'two', 'three'], 'length');
		 * // => { '3': ['one', 'two'], '5': ['three'] }
		 */
		var groupBy = createAggregator(function(result, value, key) {
		  if (hasOwnProperty.call(result, key)) {
		    result[key].push(value);
		  } else {
		    baseAssignValue(result, key, [value]);
		  }
		});
	
		module.exports = groupBy;
	
	
	/***/ }),
	/* 491 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseHasIn = __webpack_require__(426),
		    hasPath = __webpack_require__(455);
	
		/**
		 * Checks if `path` is a direct or inherited property of `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path to check.
		 * @returns {boolean} Returns `true` if `path` exists, else `false`.
		 * @example
		 *
		 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
		 *
		 * _.hasIn(object, 'a');
		 * // => true
		 *
		 * _.hasIn(object, 'a.b');
		 * // => true
		 *
		 * _.hasIn(object, ['a', 'b']);
		 * // => true
		 *
		 * _.hasIn(object, 'b');
		 * // => false
		 */
		function hasIn(object, path) {
		  return object != null && hasPath(object, path, baseHasIn);
		}
	
		module.exports = hasIn;
	
	
	/***/ }),
	/* 492 */
	118,
	/* 493 */
	[1818, 89],
	/* 494 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseProperty = __webpack_require__(436),
		    basePropertyDeep = __webpack_require__(437),
		    isKey = __webpack_require__(90),
		    toKey = __webpack_require__(57);
	
		/**
		 * Creates a function that returns the value at `path` of a given object.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.4.0
		 * @category Util
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 * @example
		 *
		 * var objects = [
		 *   { 'a': { 'b': 2 } },
		 *   { 'a': { 'b': 1 } }
		 * ];
		 *
		 * _.map(objects, _.property('a.b'));
		 * // => [2, 1]
		 *
		 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
		 * // => [1, 2]
		 */
		function property(path) {
		  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
		}
	
		module.exports = property;
	
	
	/***/ }),
	/* 495 */
	/***/ (function(module, exports) {
	
		/**
		 * This method returns a new empty array.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {Array} Returns the new empty array.
		 * @example
		 *
		 * var arrays = _.times(2, _.stubArray);
		 *
		 * console.log(arrays);
		 * // => [[], []]
		 *
		 * console.log(arrays[0] === arrays[1]);
		 * // => false
		 */
		function stubArray() {
		  return [];
		}
	
		module.exports = stubArray;
	
	
	/***/ }),
	/* 496 */
	346,
	/* 497 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var baseToString = __webpack_require__(439);
	
		/**
		 * Converts `value` to a string. An empty string is returned for `null`
		 * and `undefined` values. The sign of `-0` is preserved.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to convert.
		 * @returns {string} Returns the converted string.
		 * @example
		 *
		 * _.toString(null);
		 * // => ''
		 *
		 * _.toString(-0);
		 * // => '-0'
		 *
		 * _.toString([1, 2, 3]);
		 * // => '1,2,3'
		 */
		function toString(value) {
		  return value == null ? '' : baseToString(value);
		}
	
		module.exports = toString;
	
	
	/***/ }),
	/* 498 */,
	/* 499 */,
	/* 500 */,
	/* 501 */,
	/* 502 */,
	/* 503 */,
	/* 504 */,
	/* 505 */,
	/* 506 */,
	/* 507 */,
	/* 508 */,
	/* 509 */,
	/* 510 */,
	/* 511 */,
	/* 512 */,
	/* 513 */,
	/* 514 */,
	/* 515 */,
	/* 516 */,
	/* 517 */,
	/* 518 */,
	/* 519 */,
	/* 520 */,
	/* 521 */,
	/* 522 */,
	/* 523 */,
	/* 524 */,
	/* 525 */,
	/* 526 */,
	/* 527 */,
	/* 528 */,
	/* 529 */,
	/* 530 */,
	/* 531 */,
	/* 532 */,
	/* 533 */,
	/* 534 */,
	/* 535 */,
	/* 536 */,
	/* 537 */,
	/* 538 */,
	/* 539 */,
	/* 540 */,
	/* 541 */,
	/* 542 */,
	/* 543 */,
	/* 544 */,
	/* 545 */,
	/* 546 */,
	/* 547 */,
	/* 548 */,
	/* 549 */,
	/* 550 */,
	/* 551 */,
	/* 552 */,
	/* 553 */,
	/* 554 */,
	/* 555 */,
	/* 556 */,
	/* 557 */,
	/* 558 */,
	/* 559 */,
	/* 560 */,
	/* 561 */,
	/* 562 */,
	/* 563 */,
	/* 564 */,
	/* 565 */,
	/* 566 */,
	/* 567 */,
	/* 568 */,
	/* 569 */,
	/* 570 */,
	/* 571 */,
	/* 572 */,
	/* 573 */,
	/* 574 */,
	/* 575 */,
	/* 576 */,
	/* 577 */,
	/* 578 */,
	/* 579 */,
	/* 580 */,
	/* 581 */,
	/* 582 */,
	/* 583 */,
	/* 584 */,
	/* 585 */,
	/* 586 */,
	/* 587 */,
	/* 588 */,
	/* 589 */,
	/* 590 */,
	/* 591 */,
	/* 592 */,
	/* 593 */,
	/* 594 */,
	/* 595 */,
	/* 596 */,
	/* 597 */,
	/* 598 */,
	/* 599 */,
	/* 600 */,
	/* 601 */,
	/* 602 */,
	/* 603 */,
	/* 604 */,
	/* 605 */,
	/* 606 */,
	/* 607 */,
	/* 608 */,
	/* 609 */,
	/* 610 */,
	/* 611 */,
	/* 612 */,
	/* 613 */,
	/* 614 */,
	/* 615 */,
	/* 616 */,
	/* 617 */,
	/* 618 */,
	/* 619 */,
	/* 620 */,
	/* 621 */,
	/* 622 */,
	/* 623 */,
	/* 624 */,
	/* 625 */,
	/* 626 */,
	/* 627 */,
	/* 628 */,
	/* 629 */,
	/* 630 */,
	/* 631 */,
	/* 632 */,
	/* 633 */,
	/* 634 */,
	/* 635 */,
	/* 636 */,
	/* 637 */,
	/* 638 */,
	/* 639 */,
	/* 640 */,
	/* 641 */,
	/* 642 */,
	/* 643 */,
	/* 644 */,
	/* 645 */,
	/* 646 */,
	/* 647 */,
	/* 648 */,
	/* 649 */,
	/* 650 */,
	/* 651 */,
	/* 652 */,
	/* 653 */,
	/* 654 */,
	/* 655 */,
	/* 656 */,
	/* 657 */,
	/* 658 */,
	/* 659 */,
	/* 660 */,
	/* 661 */,
	/* 662 */,
	/* 663 */,
	/* 664 */,
	/* 665 */,
	/* 666 */,
	/* 667 */,
	/* 668 */,
	/* 669 */,
	/* 670 */,
	/* 671 */,
	/* 672 */,
	/* 673 */,
	/* 674 */,
	/* 675 */,
	/* 676 */,
	/* 677 */,
	/* 678 */,
	/* 679 */,
	/* 680 */,
	/* 681 */,
	/* 682 */,
	/* 683 */,
	/* 684 */,
	/* 685 */,
	/* 686 */,
	/* 687 */,
	/* 688 */,
	/* 689 */,
	/* 690 */,
	/* 691 */,
	/* 692 */,
	/* 693 */,
	/* 694 */,
	/* 695 */,
	/* 696 */,
	/* 697 */,
	/* 698 */,
	/* 699 */,
	/* 700 */,
	/* 701 */,
	/* 702 */,
	/* 703 */,
	/* 704 */,
	/* 705 */,
	/* 706 */,
	/* 707 */,
	/* 708 */,
	/* 709 */,
	/* 710 */,
	/* 711 */,
	/* 712 */,
	/* 713 */,
	/* 714 */,
	/* 715 */,
	/* 716 */,
	/* 717 */,
	/* 718 */,
	/* 719 */,
	/* 720 */,
	/* 721 */,
	/* 722 */,
	/* 723 */,
	/* 724 */,
	/* 725 */,
	/* 726 */,
	/* 727 */,
	/* 728 */,
	/* 729 */,
	/* 730 */,
	/* 731 */,
	/* 732 */,
	/* 733 */,
	/* 734 */,
	/* 735 */,
	/* 736 */,
	/* 737 */,
	/* 738 */,
	/* 739 */,
	/* 740 */,
	/* 741 */,
	/* 742 */,
	/* 743 */,
	/* 744 */,
	/* 745 */,
	/* 746 */,
	/* 747 */,
	/* 748 */,
	/* 749 */,
	/* 750 */,
	/* 751 */,
	/* 752 */,
	/* 753 */,
	/* 754 */,
	/* 755 */,
	/* 756 */,
	/* 757 */,
	/* 758 */,
	/* 759 */,
	/* 760 */,
	/* 761 */,
	/* 762 */,
	/* 763 */,
	/* 764 */,
	/* 765 */,
	/* 766 */,
	/* 767 */,
	/* 768 */,
	/* 769 */,
	/* 770 */,
	/* 771 */,
	/* 772 */,
	/* 773 */,
	/* 774 */,
	/* 775 */,
	/* 776 */,
	/* 777 */,
	/* 778 */,
	/* 779 */,
	/* 780 */,
	/* 781 */,
	/* 782 */,
	/* 783 */,
	/* 784 */,
	/* 785 */,
	/* 786 */,
	/* 787 */,
	/* 788 */,
	/* 789 */,
	/* 790 */,
	/* 791 */,
	/* 792 */,
	/* 793 */,
	/* 794 */,
	/* 795 */,
	/* 796 */,
	/* 797 */,
	/* 798 */,
	/* 799 */,
	/* 800 */,
	/* 801 */,
	/* 802 */,
	/* 803 */,
	/* 804 */,
	/* 805 */,
	/* 806 */,
	/* 807 */,
	/* 808 */,
	/* 809 */,
	/* 810 */,
	/* 811 */,
	/* 812 */,
	/* 813 */,
	/* 814 */,
	/* 815 */,
	/* 816 */,
	/* 817 */,
	/* 818 */,
	/* 819 */,
	/* 820 */,
	/* 821 */,
	/* 822 */,
	/* 823 */,
	/* 824 */,
	/* 825 */,
	/* 826 */,
	/* 827 */,
	/* 828 */,
	/* 829 */,
	/* 830 */,
	/* 831 */,
	/* 832 */,
	/* 833 */,
	/* 834 */,
	/* 835 */,
	/* 836 */,
	/* 837 */,
	/* 838 */,
	/* 839 */,
	/* 840 */,
	/* 841 */,
	/* 842 */,
	/* 843 */,
	/* 844 */,
	/* 845 */,
	/* 846 */,
	/* 847 */,
	/* 848 */,
	/* 849 */,
	/* 850 */,
	/* 851 */,
	/* 852 */,
	/* 853 */,
	/* 854 */,
	/* 855 */,
	/* 856 */,
	/* 857 */,
	/* 858 */,
	/* 859 */,
	/* 860 */,
	/* 861 */,
	/* 862 */,
	/* 863 */,
	/* 864 */,
	/* 865 */,
	/* 866 */,
	/* 867 */,
	/* 868 */,
	/* 869 */,
	/* 870 */,
	/* 871 */,
	/* 872 */,
	/* 873 */,
	/* 874 */,
	/* 875 */,
	/* 876 */,
	/* 877 */,
	/* 878 */,
	/* 879 */,
	/* 880 */,
	/* 881 */,
	/* 882 */,
	/* 883 */,
	/* 884 */,
	/* 885 */,
	/* 886 */,
	/* 887 */,
	/* 888 */,
	/* 889 */,
	/* 890 */,
	/* 891 */,
	/* 892 */,
	/* 893 */,
	/* 894 */,
	/* 895 */,
	/* 896 */,
	/* 897 */,
	/* 898 */,
	/* 899 */,
	/* 900 */,
	/* 901 */,
	/* 902 */,
	/* 903 */,
	/* 904 */,
	/* 905 */,
	/* 906 */,
	/* 907 */,
	/* 908 */,
	/* 909 */,
	/* 910 */,
	/* 911 */,
	/* 912 */,
	/* 913 */,
	/* 914 */,
	/* 915 */,
	/* 916 */,
	/* 917 */,
	/* 918 */,
	/* 919 */,
	/* 920 */,
	/* 921 */,
	/* 922 */,
	/* 923 */,
	/* 924 */,
	/* 925 */,
	/* 926 */,
	/* 927 */,
	/* 928 */,
	/* 929 */,
	/* 930 */,
	/* 931 */,
	/* 932 */,
	/* 933 */,
	/* 934 */,
	/* 935 */,
	/* 936 */,
	/* 937 */,
	/* 938 */,
	/* 939 */,
	/* 940 */,
	/* 941 */,
	/* 942 */,
	/* 943 */,
	/* 944 */,
	/* 945 */,
	/* 946 */,
	/* 947 */,
	/* 948 */,
	/* 949 */,
	/* 950 */,
	/* 951 */,
	/* 952 */,
	/* 953 */,
	/* 954 */,
	/* 955 */,
	/* 956 */,
	/* 957 */,
	/* 958 */,
	/* 959 */,
	/* 960 */,
	/* 961 */,
	/* 962 */,
	/* 963 */,
	/* 964 */,
	/* 965 */,
	/* 966 */,
	/* 967 */,
	/* 968 */,
	/* 969 */,
	/* 970 */,
	/* 971 */,
	/* 972 */,
	/* 973 */,
	/* 974 */,
	/* 975 */,
	/* 976 */,
	/* 977 */,
	/* 978 */,
	/* 979 */,
	/* 980 */,
	/* 981 */,
	/* 982 */,
	/* 983 */,
	/* 984 */,
	/* 985 */,
	/* 986 */,
	/* 987 */,
	/* 988 */,
	/* 989 */,
	/* 990 */,
	/* 991 */,
	/* 992 */,
	/* 993 */,
	/* 994 */,
	/* 995 */,
	/* 996 */,
	/* 997 */,
	/* 998 */,
	/* 999 */,
	/* 1000 */,
	/* 1001 */,
	/* 1002 */,
	/* 1003 */,
	/* 1004 */,
	/* 1005 */,
	/* 1006 */,
	/* 1007 */,
	/* 1008 */,
	/* 1009 */,
	/* 1010 */,
	/* 1011 */,
	/* 1012 */,
	/* 1013 */,
	/* 1014 */,
	/* 1015 */,
	/* 1016 */,
	/* 1017 */,
	/* 1018 */,
	/* 1019 */,
	/* 1020 */,
	/* 1021 */,
	/* 1022 */,
	/* 1023 */,
	/* 1024 */,
	/* 1025 */,
	/* 1026 */,
	/* 1027 */,
	/* 1028 */,
	/* 1029 */,
	/* 1030 */,
	/* 1031 */,
	/* 1032 */,
	/* 1033 */,
	/* 1034 */,
	/* 1035 */,
	/* 1036 */,
	/* 1037 */,
	/* 1038 */,
	/* 1039 */,
	/* 1040 */,
	/* 1041 */,
	/* 1042 */,
	/* 1043 */,
	/* 1044 */,
	/* 1045 */,
	/* 1046 */,
	/* 1047 */,
	/* 1048 */,
	/* 1049 */,
	/* 1050 */,
	/* 1051 */,
	/* 1052 */,
	/* 1053 */,
	/* 1054 */,
	/* 1055 */,
	/* 1056 */,
	/* 1057 */,
	/* 1058 */,
	/* 1059 */,
	/* 1060 */,
	/* 1061 */,
	/* 1062 */,
	/* 1063 */,
	/* 1064 */,
	/* 1065 */,
	/* 1066 */,
	/* 1067 */,
	/* 1068 */,
	/* 1069 */,
	/* 1070 */,
	/* 1071 */,
	/* 1072 */,
	/* 1073 */,
	/* 1074 */,
	/* 1075 */,
	/* 1076 */,
	/* 1077 */,
	/* 1078 */,
	/* 1079 */,
	/* 1080 */,
	/* 1081 */,
	/* 1082 */,
	/* 1083 */,
	/* 1084 */,
	/* 1085 */,
	/* 1086 */,
	/* 1087 */,
	/* 1088 */,
	/* 1089 */,
	/* 1090 */,
	/* 1091 */,
	/* 1092 */,
	/* 1093 */,
	/* 1094 */,
	/* 1095 */,
	/* 1096 */,
	/* 1097 */,
	/* 1098 */,
	/* 1099 */,
	/* 1100 */,
	/* 1101 */,
	/* 1102 */,
	/* 1103 */,
	/* 1104 */,
	/* 1105 */,
	/* 1106 */,
	/* 1107 */,
	/* 1108 */,
	/* 1109 */,
	/* 1110 */,
	/* 1111 */,
	/* 1112 */,
	/* 1113 */,
	/* 1114 */,
	/* 1115 */,
	/* 1116 */,
	/* 1117 */,
	/* 1118 */,
	/* 1119 */,
	/* 1120 */,
	/* 1121 */,
	/* 1122 */,
	/* 1123 */,
	/* 1124 */,
	/* 1125 */,
	/* 1126 */,
	/* 1127 */,
	/* 1128 */,
	/* 1129 */,
	/* 1130 */,
	/* 1131 */,
	/* 1132 */,
	/* 1133 */,
	/* 1134 */,
	/* 1135 */,
	/* 1136 */,
	/* 1137 */,
	/* 1138 */,
	/* 1139 */,
	/* 1140 */,
	/* 1141 */,
	/* 1142 */,
	/* 1143 */,
	/* 1144 */,
	/* 1145 */,
	/* 1146 */,
	/* 1147 */,
	/* 1148 */,
	/* 1149 */,
	/* 1150 */,
	/* 1151 */,
	/* 1152 */,
	/* 1153 */,
	/* 1154 */,
	/* 1155 */,
	/* 1156 */,
	/* 1157 */,
	/* 1158 */,
	/* 1159 */,
	/* 1160 */,
	/* 1161 */,
	/* 1162 */,
	/* 1163 */,
	/* 1164 */,
	/* 1165 */,
	/* 1166 */,
	/* 1167 */,
	/* 1168 */,
	/* 1169 */,
	/* 1170 */,
	/* 1171 */,
	/* 1172 */,
	/* 1173 */,
	/* 1174 */,
	/* 1175 */,
	/* 1176 */,
	/* 1177 */,
	/* 1178 */,
	/* 1179 */,
	/* 1180 */,
	/* 1181 */,
	/* 1182 */,
	/* 1183 */,
	/* 1184 */,
	/* 1185 */,
	/* 1186 */,
	/* 1187 */,
	/* 1188 */,
	/* 1189 */,
	/* 1190 */,
	/* 1191 */,
	/* 1192 */,
	/* 1193 */,
	/* 1194 */,
	/* 1195 */,
	/* 1196 */,
	/* 1197 */,
	/* 1198 */,
	/* 1199 */,
	/* 1200 */,
	/* 1201 */,
	/* 1202 */,
	/* 1203 */,
	/* 1204 */,
	/* 1205 */,
	/* 1206 */,
	/* 1207 */,
	/* 1208 */,
	/* 1209 */,
	/* 1210 */,
	/* 1211 */,
	/* 1212 */,
	/* 1213 */,
	/* 1214 */,
	/* 1215 */,
	/* 1216 */,
	/* 1217 */,
	/* 1218 */,
	/* 1219 */,
	/* 1220 */,
	/* 1221 */,
	/* 1222 */,
	/* 1223 */,
	/* 1224 */,
	/* 1225 */,
	/* 1226 */,
	/* 1227 */,
	/* 1228 */,
	/* 1229 */,
	/* 1230 */,
	/* 1231 */,
	/* 1232 */,
	/* 1233 */,
	/* 1234 */,
	/* 1235 */,
	/* 1236 */,
	/* 1237 */,
	/* 1238 */,
	/* 1239 */,
	/* 1240 */,
	/* 1241 */,
	/* 1242 */,
	/* 1243 */,
	/* 1244 */,
	/* 1245 */,
	/* 1246 */,
	/* 1247 */,
	/* 1248 */,
	/* 1249 */,
	/* 1250 */,
	/* 1251 */,
	/* 1252 */,
	/* 1253 */,
	/* 1254 */,
	/* 1255 */,
	/* 1256 */,
	/* 1257 */,
	/* 1258 */,
	/* 1259 */,
	/* 1260 */,
	/* 1261 */,
	/* 1262 */,
	/* 1263 */,
	/* 1264 */,
	/* 1265 */,
	/* 1266 */,
	/* 1267 */,
	/* 1268 */,
	/* 1269 */,
	/* 1270 */,
	/* 1271 */,
	/* 1272 */,
	/* 1273 */,
	/* 1274 */,
	/* 1275 */,
	/* 1276 */,
	/* 1277 */,
	/* 1278 */,
	/* 1279 */,
	/* 1280 */,
	/* 1281 */,
	/* 1282 */,
	/* 1283 */,
	/* 1284 */,
	/* 1285 */,
	/* 1286 */,
	/* 1287 */,
	/* 1288 */,
	/* 1289 */,
	/* 1290 */,
	/* 1291 */,
	/* 1292 */,
	/* 1293 */,
	/* 1294 */,
	/* 1295 */,
	/* 1296 */,
	/* 1297 */,
	/* 1298 */,
	/* 1299 */,
	/* 1300 */,
	/* 1301 */,
	/* 1302 */,
	/* 1303 */,
	/* 1304 */,
	/* 1305 */,
	/* 1306 */,
	/* 1307 */,
	/* 1308 */,
	/* 1309 */,
	/* 1310 */,
	/* 1311 */,
	/* 1312 */,
	/* 1313 */,
	/* 1314 */,
	/* 1315 */,
	/* 1316 */,
	/* 1317 */,
	/* 1318 */,
	/* 1319 */,
	/* 1320 */,
	/* 1321 */,
	/* 1322 */,
	/* 1323 */,
	/* 1324 */,
	/* 1325 */,
	/* 1326 */,
	/* 1327 */,
	/* 1328 */,
	/* 1329 */,
	/* 1330 */,
	/* 1331 */,
	/* 1332 */,
	/* 1333 */,
	/* 1334 */,
	/* 1335 */,
	/* 1336 */,
	/* 1337 */,
	/* 1338 */,
	/* 1339 */,
	/* 1340 */,
	/* 1341 */,
	/* 1342 */,
	/* 1343 */,
	/* 1344 */,
	/* 1345 */,
	/* 1346 */,
	/* 1347 */,
	/* 1348 */,
	/* 1349 */,
	/* 1350 */,
	/* 1351 */,
	/* 1352 */,
	/* 1353 */,
	/* 1354 */,
	/* 1355 */,
	/* 1356 */,
	/* 1357 */,
	/* 1358 */,
	/* 1359 */,
	/* 1360 */,
	/* 1361 */,
	/* 1362 */,
	/* 1363 */,
	/* 1364 */,
	/* 1365 */,
	/* 1366 */,
	/* 1367 */,
	/* 1368 */,
	/* 1369 */,
	/* 1370 */,
	/* 1371 */,
	/* 1372 */,
	/* 1373 */,
	/* 1374 */,
	/* 1375 */,
	/* 1376 */,
	/* 1377 */,
	/* 1378 */,
	/* 1379 */,
	/* 1380 */,
	/* 1381 */,
	/* 1382 */,
	/* 1383 */,
	/* 1384 */,
	/* 1385 */,
	/* 1386 */,
	/* 1387 */,
	/* 1388 */,
	/* 1389 */,
	/* 1390 */,
	/* 1391 */,
	/* 1392 */,
	/* 1393 */,
	/* 1394 */,
	/* 1395 */,
	/* 1396 */,
	/* 1397 */,
	/* 1398 */,
	/* 1399 */,
	/* 1400 */,
	/* 1401 */,
	/* 1402 */,
	/* 1403 */,
	/* 1404 */,
	/* 1405 */,
	/* 1406 */,
	/* 1407 */,
	/* 1408 */,
	/* 1409 */,
	/* 1410 */,
	/* 1411 */,
	/* 1412 */,
	/* 1413 */,
	/* 1414 */,
	/* 1415 */,
	/* 1416 */,
	/* 1417 */,
	/* 1418 */,
	/* 1419 */,
	/* 1420 */,
	/* 1421 */,
	/* 1422 */,
	/* 1423 */,
	/* 1424 */,
	/* 1425 */,
	/* 1426 */,
	/* 1427 */,
	/* 1428 */,
	/* 1429 */,
	/* 1430 */,
	/* 1431 */,
	/* 1432 */,
	/* 1433 */,
	/* 1434 */,
	/* 1435 */,
	/* 1436 */,
	/* 1437 */,
	/* 1438 */,
	/* 1439 */,
	/* 1440 */,
	/* 1441 */,
	/* 1442 */,
	/* 1443 */,
	/* 1444 */,
	/* 1445 */,
	/* 1446 */,
	/* 1447 */,
	/* 1448 */,
	/* 1449 */,
	/* 1450 */,
	/* 1451 */,
	/* 1452 */,
	/* 1453 */,
	/* 1454 */,
	/* 1455 */,
	/* 1456 */,
	/* 1457 */,
	/* 1458 */,
	/* 1459 */,
	/* 1460 */,
	/* 1461 */,
	/* 1462 */,
	/* 1463 */,
	/* 1464 */,
	/* 1465 */,
	/* 1466 */,
	/* 1467 */,
	/* 1468 */,
	/* 1469 */,
	/* 1470 */,
	/* 1471 */,
	/* 1472 */,
	/* 1473 */,
	/* 1474 */,
	/* 1475 */,
	/* 1476 */,
	/* 1477 */,
	/* 1478 */,
	/* 1479 */,
	/* 1480 */,
	/* 1481 */,
	/* 1482 */,
	/* 1483 */,
	/* 1484 */,
	/* 1485 */,
	/* 1486 */,
	/* 1487 */,
	/* 1488 */,
	/* 1489 */,
	/* 1490 */,
	/* 1491 */,
	/* 1492 */,
	/* 1493 */,
	/* 1494 */,
	/* 1495 */,
	/* 1496 */,
	/* 1497 */,
	/* 1498 */,
	/* 1499 */,
	/* 1500 */,
	/* 1501 */,
	/* 1502 */,
	/* 1503 */,
	/* 1504 */,
	/* 1505 */,
	/* 1506 */,
	/* 1507 */,
	/* 1508 */,
	/* 1509 */,
	/* 1510 */,
	/* 1511 */,
	/* 1512 */,
	/* 1513 */,
	/* 1514 */,
	/* 1515 */,
	/* 1516 */,
	/* 1517 */,
	/* 1518 */,
	/* 1519 */,
	/* 1520 */,
	/* 1521 */,
	/* 1522 */,
	/* 1523 */,
	/* 1524 */,
	/* 1525 */,
	/* 1526 */,
	/* 1527 */,
	/* 1528 */,
	/* 1529 */,
	/* 1530 */,
	/* 1531 */,
	/* 1532 */,
	/* 1533 */,
	/* 1534 */,
	/* 1535 */,
	/* 1536 */,
	/* 1537 */,
	/* 1538 */,
	/* 1539 */,
	/* 1540 */,
	/* 1541 */,
	/* 1542 */,
	/* 1543 */,
	/* 1544 */,
	/* 1545 */,
	/* 1546 */,
	/* 1547 */,
	/* 1548 */,
	/* 1549 */,
	/* 1550 */,
	/* 1551 */,
	/* 1552 */,
	/* 1553 */,
	/* 1554 */,
	/* 1555 */,
	/* 1556 */,
	/* 1557 */,
	/* 1558 */,
	/* 1559 */,
	/* 1560 */,
	/* 1561 */,
	/* 1562 */,
	/* 1563 */,
	/* 1564 */,
	/* 1565 */,
	/* 1566 */,
	/* 1567 */,
	/* 1568 */,
	/* 1569 */,
	/* 1570 */,
	/* 1571 */,
	/* 1572 */,
	/* 1573 */,
	/* 1574 */,
	/* 1575 */,
	/* 1576 */,
	/* 1577 */,
	/* 1578 */,
	/* 1579 */,
	/* 1580 */,
	/* 1581 */,
	/* 1582 */,
	/* 1583 */,
	/* 1584 */,
	/* 1585 */,
	/* 1586 */,
	/* 1587 */,
	/* 1588 */,
	/* 1589 */,
	/* 1590 */,
	/* 1591 */,
	/* 1592 */,
	/* 1593 */,
	/* 1594 */,
	/* 1595 */,
	/* 1596 */,
	/* 1597 */,
	/* 1598 */,
	/* 1599 */,
	/* 1600 */,
	/* 1601 */,
	/* 1602 */,
	/* 1603 */,
	/* 1604 */,
	/* 1605 */,
	/* 1606 */,
	/* 1607 */,
	/* 1608 */,
	/* 1609 */,
	/* 1610 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {
	
		var hashClear = __webpack_require__(__webpack_module_template_argument_0__),
		    hashDelete = __webpack_require__(__webpack_module_template_argument_1__),
		    hashGet = __webpack_require__(__webpack_module_template_argument_2__),
		    hashHas = __webpack_require__(__webpack_module_template_argument_3__),
		    hashSet = __webpack_require__(__webpack_module_template_argument_4__);
	
		/**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Hash(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;
	
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
	
		// Add methods to `Hash`.
		Hash.prototype.clear = hashClear;
		Hash.prototype['delete'] = hashDelete;
		Hash.prototype.get = hashGet;
		Hash.prototype.has = hashHas;
		Hash.prototype.set = hashSet;
	
		module.exports = Hash;
	
	
	/***/ }),
	/* 1611 */,
	/* 1612 */,
	/* 1613 */,
	/* 1614 */,
	/* 1615 */,
	/* 1616 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {
	
		var listCacheClear = __webpack_require__(__webpack_module_template_argument_0__),
		    listCacheDelete = __webpack_require__(__webpack_module_template_argument_1__),
		    listCacheGet = __webpack_require__(__webpack_module_template_argument_2__),
		    listCacheHas = __webpack_require__(__webpack_module_template_argument_3__),
		    listCacheSet = __webpack_require__(__webpack_module_template_argument_4__);
	
		/**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function ListCache(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;
	
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
	
		// Add methods to `ListCache`.
		ListCache.prototype.clear = listCacheClear;
		ListCache.prototype['delete'] = listCacheDelete;
		ListCache.prototype.get = listCacheGet;
		ListCache.prototype.has = listCacheHas;
		ListCache.prototype.set = listCacheSet;
	
		module.exports = ListCache;
	
	
	/***/ }),
	/* 1617 */,
	/* 1618 */,
	/* 1619 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		var getNative = __webpack_require__(__webpack_module_template_argument_0__),
		    root = __webpack_require__(__webpack_module_template_argument_1__);
	
		/* Built-in method references that are verified to be native. */
		var Map = getNative(root, 'Map');
	
		module.exports = Map;
	
	
	/***/ }),
	/* 1620 */,
	/* 1621 */,
	/* 1622 */,
	/* 1623 */,
	/* 1624 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {
	
		var mapCacheClear = __webpack_require__(__webpack_module_template_argument_0__),
		    mapCacheDelete = __webpack_require__(__webpack_module_template_argument_1__),
		    mapCacheGet = __webpack_require__(__webpack_module_template_argument_2__),
		    mapCacheHas = __webpack_require__(__webpack_module_template_argument_3__),
		    mapCacheSet = __webpack_require__(__webpack_module_template_argument_4__);
	
		/**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function MapCache(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;
	
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
	
		// Add methods to `MapCache`.
		MapCache.prototype.clear = mapCacheClear;
		MapCache.prototype['delete'] = mapCacheDelete;
		MapCache.prototype.get = mapCacheGet;
		MapCache.prototype.has = mapCacheHas;
		MapCache.prototype.set = mapCacheSet;
	
		module.exports = MapCache;
	
	
	/***/ }),
	/* 1625 */,
	/* 1626 */,
	/* 1627 */,
	/* 1628 */,
	/* 1629 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		var getNative = __webpack_require__(__webpack_module_template_argument_0__),
		    root = __webpack_require__(__webpack_module_template_argument_1__);
	
		/* Built-in method references that are verified to be native. */
		var Set = getNative(root, 'Set');
	
		module.exports = Set;
	
	
	/***/ }),
	/* 1630 */,
	/* 1631 */,
	/* 1632 */,
	/* 1633 */,
	/* 1634 */,
	/* 1635 */,
	/* 1636 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {
	
		var MapCache = __webpack_require__(__webpack_module_template_argument_0__),
		    setCacheAdd = __webpack_require__(__webpack_module_template_argument_1__),
		    setCacheHas = __webpack_require__(__webpack_module_template_argument_2__);
	
		/**
		 *
		 * Creates an array cache object to store unique values.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [values] The values to cache.
		 */
		function SetCache(values) {
		  var index = -1,
		      length = values == null ? 0 : values.length;
	
		  this.__data__ = new MapCache;
		  while (++index < length) {
		    this.add(values[index]);
		  }
		}
	
		// Add methods to `SetCache`.
		SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
		SetCache.prototype.has = setCacheHas;
	
		module.exports = SetCache;
	
	
	/***/ }),
	/* 1637 */,
	/* 1638 */,
	/* 1639 */,
	/* 1640 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var root = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Built-in value references. */
		var Symbol = root.Symbol;
	
		module.exports = Symbol;
	
	
	/***/ }),
	/* 1641 */,
	/* 1642 */,
	/* 1643 */,
	/* 1644 */,
	/* 1645 */,
	/* 1646 */,
	/* 1647 */,
	/* 1648 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {
	
		var baseTimes = __webpack_require__(__webpack_module_template_argument_0__),
		    isArguments = __webpack_require__(__webpack_module_template_argument_1__),
		    isArray = __webpack_require__(__webpack_module_template_argument_2__),
		    isBuffer = __webpack_require__(__webpack_module_template_argument_3__),
		    isIndex = __webpack_require__(__webpack_module_template_argument_4__),
		    isTypedArray = __webpack_require__(__webpack_module_template_argument_5__);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Creates an array of the enumerable property names of the array-like `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @param {boolean} inherited Specify returning inherited property names.
		 * @returns {Array} Returns the array of property names.
		 */
		function arrayLikeKeys(value, inherited) {
		  var isArr = isArray(value),
		      isArg = !isArr && isArguments(value),
		      isBuff = !isArr && !isArg && isBuffer(value),
		      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
		      skipIndexes = isArr || isArg || isBuff || isType,
		      result = skipIndexes ? baseTimes(value.length, String) : [],
		      length = result.length;
	
		  for (var key in value) {
		    if ((inherited || hasOwnProperty.call(value, key)) &&
		        !(skipIndexes && (
		           // Safari 9 has enumerable `arguments.length` in strict mode.
		           key == 'length' ||
		           // Node.js 0.10 has enumerable non-index properties on buffers.
		           (isBuff && (key == 'offset' || key == 'parent')) ||
		           // PhantomJS 2 has enumerable non-index properties on typed arrays.
		           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
		           // Skip index properties.
		           isIndex(key, length)
		        ))) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = arrayLikeKeys;
	
	
	/***/ }),
	/* 1649 */,
	/* 1650 */,
	/* 1651 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var eq = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function assocIndexOf(array, key) {
		  var length = array.length;
		  while (length--) {
		    if (eq(array[length][0], key)) {
		      return length;
		    }
		  }
		  return -1;
		}
	
		module.exports = assocIndexOf;
	
	
	/***/ }),
	/* 1652 */,
	/* 1653 */,
	/* 1654 */,
	/* 1655 */,
	/* 1656 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * The base implementation of `assignValue` and `assignMergeValue` without
		 * value checks.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function baseAssignValue(object, key, value) {
		  if (key == '__proto__' && defineProperty) {
		    defineProperty(object, key, {
		      'configurable': true,
		      'enumerable': true,
		      'value': value,
		      'writable': true
		    });
		  } else {
		    object[key] = value;
		  }
		}
	
		module.exports = baseAssignValue;
	
	
	/***/ }),
	/* 1657 */,
	/* 1658 */,
	/* 1659 */,
	/* 1660 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {
	
		var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
		    getRawTag = __webpack_require__(__webpack_module_template_argument_1__),
		    objectToString = __webpack_require__(__webpack_module_template_argument_2__);
	
		/** `Object#toString` result references. */
		var nullTag = '[object Null]',
		    undefinedTag = '[object Undefined]';
	
		/** Built-in value references. */
		var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
		/**
		 * The base implementation of `getTag` without fallbacks for buggy environments.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		function baseGetTag(value) {
		  if (value == null) {
		    return value === undefined ? undefinedTag : nullTag;
		  }
		  return (symToStringTag && symToStringTag in Object(value))
		    ? getRawTag(value)
		    : objectToString(value);
		}
	
		module.exports = baseGetTag;
	
	
	/***/ }),
	/* 1661 */,
	/* 1662 */,
	/* 1663 */,
	/* 1664 */,
	/* 1665 */,
	/* 1666 */,
	/* 1667 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
		    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]';
	
		/**
		 * The base implementation of `_.isArguments`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 */
		function baseIsArguments(value) {
		  return isObjectLike(value) && baseGetTag(value) == argsTag;
		}
	
		module.exports = baseIsArguments;
	
	
	/***/ }),
	/* 1668 */,
	/* 1669 */,
	/* 1670 */,
	/* 1671 */,
	/* 1672 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {
	
		var isFunction = __webpack_require__(__webpack_module_template_argument_0__),
		    isMasked = __webpack_require__(__webpack_module_template_argument_1__),
		    isObject = __webpack_require__(__webpack_module_template_argument_2__),
		    toSource = __webpack_require__(__webpack_module_template_argument_3__);
	
		/**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
		 */
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
		/** Used to detect host constructors (Safari). */
		var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
		/** Used for built-in method references. */
		var funcProto = Function.prototype,
		    objectProto = Object.prototype;
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Used to detect if a method is native. */
		var reIsNative = RegExp('^' +
		  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
		);
	
		/**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */
		function baseIsNative(value) {
		  if (!isObject(value) || isMasked(value)) {
		    return false;
		  }
		  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
		  return pattern.test(toSource(value));
		}
	
		module.exports = baseIsNative;
	
	
	/***/ }),
	/* 1673 */,
	/* 1674 */,
	/* 1675 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {
	
		var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
		    isLength = __webpack_require__(__webpack_module_template_argument_1__),
		    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    objectTag = '[object Object]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    weakMapTag = '[object WeakMap]';
	
		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';
	
		/** Used to identify `toStringTag` values of typed arrays. */
		var typedArrayTags = {};
		typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
		typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
		typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
		typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
		typedArrayTags[uint32Tag] = true;
		typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
		typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
		typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
		typedArrayTags[errorTag] = typedArrayTags[funcTag] =
		typedArrayTags[mapTag] = typedArrayTags[numberTag] =
		typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
		typedArrayTags[setTag] = typedArrayTags[stringTag] =
		typedArrayTags[weakMapTag] = false;
	
		/**
		 * The base implementation of `_.isTypedArray` without Node.js optimizations.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 */
		function baseIsTypedArray(value) {
		  return isObjectLike(value) &&
		    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
		}
	
		module.exports = baseIsTypedArray;
	
	
	/***/ }),
	/* 1676 */,
	/* 1677 */,
	/* 1678 */,
	/* 1679 */,
	/* 1680 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var root = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Used to detect overreaching core-js shims. */
		var coreJsData = root['__core-js_shared__'];
	
		module.exports = coreJsData;
	
	
	/***/ }),
	/* 1681 */,
	/* 1682 */,
	/* 1683 */,
	/* 1684 */,
	/* 1685 */,
	/* 1686 */,
	/* 1687 */,
	/* 1688 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var getNative = __webpack_require__(__webpack_module_template_argument_0__);
	
		var defineProperty = (function() {
		  try {
		    var func = getNative(Object, 'defineProperty');
		    func({}, '', {});
		    return func;
		  } catch (e) {}
		}());
	
		module.exports = defineProperty;
	
	
	/***/ }),
	/* 1689 */,
	/* 1690 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var isKeyable = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */
		function getMapData(map, key) {
		  var data = map.__data__;
		  return isKeyable(key)
		    ? data[typeof key == 'string' ? 'string' : 'hash']
		    : data.map;
		}
	
		module.exports = getMapData;
	
	
	/***/ }),
	/* 1691 */,
	/* 1692 */,
	/* 1693 */,
	/* 1694 */,
	/* 1695 */,
	/* 1696 */,
	/* 1697 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		var baseIsNative = __webpack_require__(__webpack_module_template_argument_0__),
		    getValue = __webpack_require__(__webpack_module_template_argument_1__);
	
		/**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */
		function getNative(object, key) {
		  var value = getValue(object, key);
		  return baseIsNative(value) ? value : undefined;
		}
	
		module.exports = getNative;
	
	
	/***/ }),
	/* 1698 */,
	/* 1699 */,
	/* 1700 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var Symbol = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var nativeObjectToString = objectProto.toString;
	
		/** Built-in value references. */
		var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
		/**
		 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the raw `toStringTag`.
		 */
		function getRawTag(value) {
		  var isOwn = hasOwnProperty.call(value, symToStringTag),
		      tag = value[symToStringTag];
	
		  try {
		    value[symToStringTag] = undefined;
		    var unmasked = true;
		  } catch (e) {}
	
		  var result = nativeObjectToString.call(value);
		  if (unmasked) {
		    if (isOwn) {
		      value[symToStringTag] = tag;
		    } else {
		      delete value[symToStringTag];
		    }
		  }
		  return result;
		}
	
		module.exports = getRawTag;
	
	
	/***/ }),
	/* 1701 */,
	/* 1702 */,
	/* 1703 */,
	/* 1704 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */
		function hashClear() {
		  this.__data__ = nativeCreate ? nativeCreate(null) : {};
		  this.size = 0;
		}
	
		module.exports = hashClear;
	
	
	/***/ }),
	/* 1705 */,
	/* 1706 */,
	/* 1707 */,
	/* 1708 */,
	/* 1709 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function hashGet(key) {
		  var data = this.__data__;
		  if (nativeCreate) {
		    var result = data[key];
		    return result === HASH_UNDEFINED ? undefined : result;
		  }
		  return hasOwnProperty.call(data, key) ? data[key] : undefined;
		}
	
		module.exports = hashGet;
	
	
	/***/ }),
	/* 1710 */,
	/* 1711 */,
	/* 1712 */,
	/* 1713 */,
	/* 1714 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function hashHas(key) {
		  var data = this.__data__;
		  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
		}
	
		module.exports = hashHas;
	
	
	/***/ }),
	/* 1715 */,
	/* 1716 */,
	/* 1717 */,
	/* 1718 */,
	/* 1719 */,
	/* 1720 */,
	/* 1721 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
		/**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */
		function hashSet(key, value) {
		  var data = this.__data__;
		  this.size += this.has(key) ? 0 : 1;
		  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
		  return this;
		}
	
		module.exports = hashSet;
	
	
	/***/ }),
	/* 1722 */,
	/* 1723 */,
	/* 1724 */,
	/* 1725 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var coreJsData = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Used to detect methods masquerading as native. */
		var maskSrcKey = (function() {
		  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
		  return uid ? ('Symbol(src)_1.' + uid) : '';
		}());
	
		/**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */
		function isMasked(func) {
		  return !!maskSrcKey && (maskSrcKey in func);
		}
	
		module.exports = isMasked;
	
	
	/***/ }),
	/* 1726 */,
	/* 1727 */,
	/* 1728 */,
	/* 1729 */,
	/* 1730 */,
	/* 1731 */,
	/* 1732 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Used for built-in method references. */
		var arrayProto = Array.prototype;
	
		/** Built-in value references. */
		var splice = arrayProto.splice;
	
		/**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function listCacheDelete(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  if (index < 0) {
		    return false;
		  }
		  var lastIndex = data.length - 1;
		  if (index == lastIndex) {
		    data.pop();
		  } else {
		    splice.call(data, index, 1);
		  }
		  --this.size;
		  return true;
		}
	
		module.exports = listCacheDelete;
	
	
	/***/ }),
	/* 1733 */,
	/* 1734 */,
	/* 1735 */,
	/* 1736 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function listCacheGet(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  return index < 0 ? undefined : data[index][1];
		}
	
		module.exports = listCacheGet;
	
	
	/***/ }),
	/* 1737 */,
	/* 1738 */,
	/* 1739 */,
	/* 1740 */,
	/* 1741 */,
	/* 1742 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function listCacheHas(key) {
		  return assocIndexOf(this.__data__, key) > -1;
		}
	
		module.exports = listCacheHas;
	
	
	/***/ }),
	/* 1743 */,
	/* 1744 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */
		function listCacheSet(key, value) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  if (index < 0) {
		    ++this.size;
		    data.push([key, value]);
		  } else {
		    data[index][1] = value;
		  }
		  return this;
		}
	
		module.exports = listCacheSet;
	
	
	/***/ }),
	/* 1745 */,
	/* 1746 */,
	/* 1747 */,
	/* 1748 */,
	/* 1749 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {
	
		var Hash = __webpack_require__(__webpack_module_template_argument_0__),
		    ListCache = __webpack_require__(__webpack_module_template_argument_1__),
		    Map = __webpack_require__(__webpack_module_template_argument_2__);
	
		/**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */
		function mapCacheClear() {
		  this.size = 0;
		  this.__data__ = {
		    'hash': new Hash,
		    'map': new (Map || ListCache),
		    'string': new Hash
		  };
		}
	
		module.exports = mapCacheClear;
	
	
	/***/ }),
	/* 1750 */,
	/* 1751 */,
	/* 1752 */,
	/* 1753 */,
	/* 1754 */,
	/* 1755 */,
	/* 1756 */,
	/* 1757 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function mapCacheDelete(key) {
		  var result = getMapData(this, key)['delete'](key);
		  this.size -= result ? 1 : 0;
		  return result;
		}
	
		module.exports = mapCacheDelete;
	
	
	/***/ }),
	/* 1758 */,
	/* 1759 */,
	/* 1760 */,
	/* 1761 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function mapCacheGet(key) {
		  return getMapData(this, key).get(key);
		}
	
		module.exports = mapCacheGet;
	
	
	/***/ }),
	/* 1762 */,
	/* 1763 */,
	/* 1764 */,
	/* 1765 */,
	/* 1766 */,
	/* 1767 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function mapCacheHas(key) {
		  return getMapData(this, key).has(key);
		}
	
		module.exports = mapCacheHas;
	
	
	/***/ }),
	/* 1768 */,
	/* 1769 */,
	/* 1770 */,
	/* 1771 */,
	/* 1772 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */
		function mapCacheSet(key, value) {
		  var data = getMapData(this, key),
		      size = data.size;
	
		  data.set(key, value);
		  this.size += data.size == size ? 0 : 1;
		  return this;
		}
	
		module.exports = mapCacheSet;
	
	
	/***/ }),
	/* 1773 */,
	/* 1774 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var getNative = __webpack_require__(__webpack_module_template_argument_0__);
	
		/* Built-in method references that are verified to be native. */
		var nativeCreate = getNative(Object, 'create');
	
		module.exports = nativeCreate;
	
	
	/***/ }),
	/* 1775 */,
	/* 1776 */,
	/* 1777 */,
	/* 1778 */,
	/* 1779 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Detect free variable `exports`. */
		var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
		/** Detect free variable `module`. */
		var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;
	
		/** Detect free variable `process` from Node.js. */
		var freeProcess = moduleExports && freeGlobal.process;
	
		/** Used to access faster Node.js helpers. */
		var nodeUtil = (function() {
		  try {
		    return freeProcess && freeProcess.binding && freeProcess.binding('util');
		  } catch (e) {}
		}());
	
		module.exports = nodeUtil;
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))
	
	/***/ }),
	/* 1780 */,
	/* 1781 */,
	/* 1782 */,
	/* 1783 */,
	/* 1784 */,
	/* 1785 */,
	/* 1786 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Detect free variable `self`. */
		var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
		/** Used as a reference to the global object. */
		var root = freeGlobal || freeSelf || Function('return this')();
	
		module.exports = root;
	
	
	/***/ }),
	/* 1787 */,
	/* 1788 */,
	/* 1789 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		var baseIsArguments = __webpack_require__(__webpack_module_template_argument_0__),
		    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Built-in value references. */
		var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
		/**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */
		var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
		  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
		    !propertyIsEnumerable.call(value, 'callee');
		};
	
		module.exports = isArguments;
	
	
	/***/ }),
	/* 1790 */,
	/* 1791 */,
	/* 1792 */,
	/* 1793 */,
	/* 1794 */,
	/* 1795 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		var isFunction = __webpack_require__(__webpack_module_template_argument_0__),
		    isLength = __webpack_require__(__webpack_module_template_argument_1__);
	
		/**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */
		function isArrayLike(value) {
		  return value != null && isLength(value.length) && !isFunction(value);
		}
	
		module.exports = isArrayLike;
	
	
	/***/ }),
	/* 1796 */,
	/* 1797 */,
	/* 1798 */,
	/* 1799 */,
	/* 1800 */,
	/* 1801 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(__webpack_module_template_argument_0__),
		    stubFalse = __webpack_require__(__webpack_module_template_argument_1__);
	
		/** Detect free variable `exports`. */
		var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
		/** Detect free variable `module`. */
		var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;
	
		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined;
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
		/**
		 * Checks if `value` is a buffer.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.3.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
		 * @example
		 *
		 * _.isBuffer(new Buffer(2));
		 * // => true
		 *
		 * _.isBuffer(new Uint8Array(2));
		 * // => false
		 */
		var isBuffer = nativeIsBuffer || stubFalse;
	
		module.exports = isBuffer;
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))
	
	/***/ }),
	/* 1802 */,
	/* 1803 */,
	/* 1804 */,
	/* 1805 */,
	/* 1806 */,
	/* 1807 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
		    isObject = __webpack_require__(__webpack_module_template_argument_1__);
	
		/** `Object#toString` result references. */
		var asyncTag = '[object AsyncFunction]',
		    funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]',
		    proxyTag = '[object Proxy]';
	
		/**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */
		function isFunction(value) {
		  if (!isObject(value)) {
		    return false;
		  }
		  // The use of `Object#toString` avoids issues with the `typeof` operator
		  // in Safari 9 which returns 'object' for typed arrays and other constructors.
		  var tag = baseGetTag(value);
		  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
		}
	
		module.exports = isFunction;
	
	
	/***/ }),
	/* 1808 */,
	/* 1809 */,
	/* 1810 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {
	
		var baseIsTypedArray = __webpack_require__(__webpack_module_template_argument_0__),
		    baseUnary = __webpack_require__(__webpack_module_template_argument_1__),
		    nodeUtil = __webpack_require__(__webpack_module_template_argument_2__);
	
		/* Node.js helper references. */
		var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
		/**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */
		var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
		module.exports = isTypedArray;
	
	
	/***/ }),
	/* 1811 */,
	/* 1812 */,
	/* 1813 */,
	/* 1814 */,
	/* 1815 */,
	/* 1816 */,
	/* 1817 */,
	/* 1818 */
	/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var MapCache = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Error message constants. */
		var FUNC_ERROR_TEXT = 'Expected a function';
	
		/**
		 * Creates a function that memoizes the result of `func`. If `resolver` is
		 * provided, it determines the cache key for storing the result based on the
		 * arguments provided to the memoized function. By default, the first argument
		 * provided to the memoized function is used as the map cache key. The `func`
		 * is invoked with the `this` binding of the memoized function.
		 *
		 * **Note:** The cache is exposed as the `cache` property on the memoized
		 * function. Its creation may be customized by replacing the `_.memoize.Cache`
		 * constructor with one whose instances implement the
		 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
		 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Function
		 * @param {Function} func The function to have its output memoized.
		 * @param {Function} [resolver] The function to resolve the cache key.
		 * @returns {Function} Returns the new memoized function.
		 * @example
		 *
		 * var object = { 'a': 1, 'b': 2 };
		 * var other = { 'c': 3, 'd': 4 };
		 *
		 * var values = _.memoize(_.values);
		 * values(object);
		 * // => [1, 2]
		 *
		 * values(other);
		 * // => [3, 4]
		 *
		 * object.a = 2;
		 * values(object);
		 * // => [1, 2]
		 *
		 * // Modify the result cache.
		 * values.cache.set(object, ['a', 'b']);
		 * values(object);
		 * // => ['a', 'b']
		 *
		 * // Replace `_.memoize.Cache`.
		 * _.memoize.Cache = WeakMap;
		 */
		function memoize(func, resolver) {
		  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
		    throw new TypeError(FUNC_ERROR_TEXT);
		  }
		  var memoized = function() {
		    var args = arguments,
		        key = resolver ? resolver.apply(this, args) : args[0],
		        cache = memoized.cache;
	
		    if (cache.has(key)) {
		      return cache.get(key);
		    }
		    var result = func.apply(this, args);
		    memoized.cache = cache.set(key, result) || cache;
		    return result;
		  };
		  memoized.cache = new (memoize.Cache || MapCache);
		  return memoized;
		}
	
		// Expose `MapCache`.
		memoize.Cache = MapCache;
	
		module.exports = memoize;
	
	
	/***/ })
	/******/ ])))
	});
	;

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(63));
		else if(typeof define === 'function' && define.amd)
			define(["react", "react-dom"], factory);
		else if(typeof exports === 'object')
			exports["ReactDataGrid"] = factory(require("react"), require("react-dom"));
		else
			root["ReactDataGrid"] = factory(root["React"], root["ReactDOM"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_4__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(187);
	
	
	/***/ }),
	/* 1 */,
	/* 2 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }),
	/* 3 */,
	/* 4 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_4__;
	
	/***/ }),
	/* 5 */,
	/* 6 */,
	/* 7 */
	/***/ (function(module, exports) {
	
		/*
			MIT License http://www.opensource.org/licenses/mit-license.php
			Author Tobias Koppers @sokra
		*/
		// css base code, injected by the css-loader
		module.exports = function() {
			var list = [];
	
			// return the list of modules as css string
			list.toString = function toString() {
				var result = [];
				for(var i = 0; i < this.length; i++) {
					var item = this[i];
					if(item[2]) {
						result.push("@media " + item[2] + "{" + item[1] + "}");
					} else {
						result.push(item[1]);
					}
				}
				return result.join("");
			};
	
			// import a list of modules into the list
			list.i = function(modules, mediaQuery) {
				if(typeof modules === "string")
					modules = [[null, modules, ""]];
				var alreadyImportedModules = {};
				for(var i = 0; i < this.length; i++) {
					var id = this[i][0];
					if(typeof id === "number")
						alreadyImportedModules[id] = true;
				}
				for(i = 0; i < modules.length; i++) {
					var item = modules[i];
					// skip already imported module
					// this implementation is not 100% perfect for weird media query combinations
					//  when a module is imported multiple times with different media queries.
					//  I hope this will never occur (Hey this way we have smaller bundles)
					if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
						if(mediaQuery && !item[2]) {
							item[2] = mediaQuery;
						} else if(mediaQuery) {
							item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
						}
						list.push(item);
					}
				}
			};
			return list;
		};
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/*
			MIT License http://www.opensource.org/licenses/mit-license.php
			Author Tobias Koppers @sokra
		*/
		var stylesInDom = {},
			memoize = function(fn) {
				var memo;
				return function () {
					if (typeof memo === "undefined") memo = fn.apply(this, arguments);
					return memo;
				};
			},
			isOldIE = memoize(function() {
				return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
			}),
			getHeadElement = memoize(function () {
				return document.head || document.getElementsByTagName("head")[0];
			}),
			singletonElement = null,
			singletonCounter = 0,
			styleElementsInsertedAtTop = [];
	
		module.exports = function(list, options) {
			if(false) {
				if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
			}
	
			options = options || {};
			// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
			// tags it will allow on a page
			if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
			// By default, add <style> tags to the bottom of <head>.
			if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
			var styles = listToStyles(list);
			addStylesToDom(styles, options);
	
			return function update(newList) {
				var mayRemove = [];
				for(var i = 0; i < styles.length; i++) {
					var item = styles[i];
					var domStyle = stylesInDom[item.id];
					domStyle.refs--;
					mayRemove.push(domStyle);
				}
				if(newList) {
					var newStyles = listToStyles(newList);
					addStylesToDom(newStyles, options);
				}
				for(var i = 0; i < mayRemove.length; i++) {
					var domStyle = mayRemove[i];
					if(domStyle.refs === 0) {
						for(var j = 0; j < domStyle.parts.length; j++)
							domStyle.parts[j]();
						delete stylesInDom[domStyle.id];
					}
				}
			};
		}
	
		function addStylesToDom(styles, options) {
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				if(domStyle) {
					domStyle.refs++;
					for(var j = 0; j < domStyle.parts.length; j++) {
						domStyle.parts[j](item.parts[j]);
					}
					for(; j < item.parts.length; j++) {
						domStyle.parts.push(addStyle(item.parts[j], options));
					}
				} else {
					var parts = [];
					for(var j = 0; j < item.parts.length; j++) {
						parts.push(addStyle(item.parts[j], options));
					}
					stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
				}
			}
		}
	
		function listToStyles(list) {
			var styles = [];
			var newStyles = {};
			for(var i = 0; i < list.length; i++) {
				var item = list[i];
				var id = item[0];
				var css = item[1];
				var media = item[2];
				var sourceMap = item[3];
				var part = {css: css, media: media, sourceMap: sourceMap};
				if(!newStyles[id])
					styles.push(newStyles[id] = {id: id, parts: [part]});
				else
					newStyles[id].parts.push(part);
			}
			return styles;
		}
	
		function insertStyleElement(options, styleElement) {
			var head = getHeadElement();
			var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
			if (options.insertAt === "top") {
				if(!lastStyleElementInsertedAtTop) {
					head.insertBefore(styleElement, head.firstChild);
				} else if(lastStyleElementInsertedAtTop.nextSibling) {
					head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
				} else {
					head.appendChild(styleElement);
				}
				styleElementsInsertedAtTop.push(styleElement);
			} else if (options.insertAt === "bottom") {
				head.appendChild(styleElement);
			} else {
				throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
			}
		}
	
		function removeStyleElement(styleElement) {
			styleElement.parentNode.removeChild(styleElement);
			var idx = styleElementsInsertedAtTop.indexOf(styleElement);
			if(idx >= 0) {
				styleElementsInsertedAtTop.splice(idx, 1);
			}
		}
	
		function createStyleElement(options) {
			var styleElement = document.createElement("style");
			styleElement.type = "text/css";
			insertStyleElement(options, styleElement);
			return styleElement;
		}
	
		function createLinkElement(options) {
			var linkElement = document.createElement("link");
			linkElement.rel = "stylesheet";
			insertStyleElement(options, linkElement);
			return linkElement;
		}
	
		function addStyle(obj, options) {
			var styleElement, update, remove;
	
			if (options.singleton) {
				var styleIndex = singletonCounter++;
				styleElement = singletonElement || (singletonElement = createStyleElement(options));
				update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
				remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
			} else if(obj.sourceMap &&
				typeof URL === "function" &&
				typeof URL.createObjectURL === "function" &&
				typeof URL.revokeObjectURL === "function" &&
				typeof Blob === "function" &&
				typeof btoa === "function") {
				styleElement = createLinkElement(options);
				update = updateLink.bind(null, styleElement);
				remove = function() {
					removeStyleElement(styleElement);
					if(styleElement.href)
						URL.revokeObjectURL(styleElement.href);
				};
			} else {
				styleElement = createStyleElement(options);
				update = applyToTag.bind(null, styleElement);
				remove = function() {
					removeStyleElement(styleElement);
				};
			}
	
			update(obj);
	
			return function updateStyle(newObj) {
				if(newObj) {
					if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
						return;
					update(obj = newObj);
				} else {
					remove();
				}
			};
		}
	
		var replaceText = (function () {
			var textStore = [];
	
			return function (index, replacement) {
				textStore[index] = replacement;
				return textStore.filter(Boolean).join('\n');
			};
		})();
	
		function applyToSingletonTag(styleElement, index, remove, obj) {
			var css = remove ? "" : obj.css;
	
			if (styleElement.styleSheet) {
				styleElement.styleSheet.cssText = replaceText(index, css);
			} else {
				var cssNode = document.createTextNode(css);
				var childNodes = styleElement.childNodes;
				if (childNodes[index]) styleElement.removeChild(childNodes[index]);
				if (childNodes.length) {
					styleElement.insertBefore(cssNode, childNodes[index]);
				} else {
					styleElement.appendChild(cssNode);
				}
			}
		}
	
		function applyToTag(styleElement, obj) {
			var css = obj.css;
			var media = obj.media;
	
			if(media) {
				styleElement.setAttribute("media", media)
			}
	
			if(styleElement.styleSheet) {
				styleElement.styleSheet.cssText = css;
			} else {
				while(styleElement.firstChild) {
					styleElement.removeChild(styleElement.firstChild);
				}
				styleElement.appendChild(document.createTextNode(css));
			}
		}
	
		function updateLink(linkElement, obj) {
			var css = obj.css;
			var sourceMap = obj.sourceMap;
	
			if(sourceMap) {
				// http://stackoverflow.com/a/26603875
				css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
			}
	
			var blob = new Blob([css], { type: "text/css" });
	
			var oldSrc = linkElement.href;
	
			linkElement.href = URL.createObjectURL(blob);
	
			if(oldSrc)
				URL.revokeObjectURL(oldSrc);
		}
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		  Copyright (c) 2015 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
	
		function classNames() {
			var classes = '';
			var arg;
	
			for (var i = 0; i < arguments.length; i++) {
				arg = arguments[i];
				if (!arg) {
					continue;
				}
	
				if ('string' === typeof arg || 'number' === typeof arg) {
					classes += ' ' + arg;
				} else if (Object.prototype.toString.call(arg) === '[object Array]') {
					classes += ' ' + classNames.apply(null, arg);
				} else if ('object' === typeof arg) {
					for (var key in arg) {
						if (!arg.hasOwnProperty(key) || !arg[key]) {
							continue;
						}
						classes += ' ' + key;
					}
				}
			}
			return classes.substr(1);
		}
	
		// safely export classNames for node / browserify
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		}
	
		// safely export classNames for RequireJS
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		module.exports = {
		  getColumn: function getColumn(columns, idx) {
		    if (Array.isArray(columns)) {
		      return columns[idx];
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.get(idx);
		    }
		  },
		  spliceColumn: function spliceColumn(metrics, idx, column) {
		    if (Array.isArray(metrics.columns)) {
		      metrics.columns.splice(idx, 1, column);
		    } else if (typeof Immutable !== 'undefined') {
		      metrics.columns = metrics.columns.splice(idx, 1, column);
		    }
		    return metrics;
		  },
		  getSize: function getSize(columns) {
		    if (Array.isArray(columns)) {
		      return columns.length;
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.size;
		    }
		  },
	
	
		  // Logic extented to allow for functions to be passed down in column.editable
		  // this allows us to deicde whether we can be edting from a cell level
		  canEdit: function canEdit(col, rowData, enableCellSelect) {
		    if (col.editable != null && typeof col.editable === 'function') {
		      return enableCellSelect === true && col.editable(rowData);
		    }
		    return enableCellSelect === true && (!!col.editor || !!col.editable);
		  }
		};
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
	
		var ExcelColumnShape = {
		  name: React.PropTypes.node.isRequired,
		  key: React.PropTypes.string.isRequired,
		  width: React.PropTypes.number.isRequired,
		  filterable: React.PropTypes.bool
		};
	
		module.exports = ExcelColumnShape;
	
	/***/ }),
	/* 12 */,
	/* 13 */,
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var PropTypes = __webpack_require__(2).PropTypes;
	
		module.exports = {
		  selected: PropTypes.object.isRequired,
		  copied: PropTypes.object,
		  dragged: PropTypes.object,
		  onCellClick: PropTypes.func.isRequired,
		  onCellDoubleClick: PropTypes.func.isRequired,
		  onCommit: PropTypes.func.isRequired,
		  onCommitCancel: PropTypes.func.isRequired,
		  handleDragEnterRow: PropTypes.func.isRequired,
		  handleTerminateDrag: PropTypes.func.isRequired
		};
	
	/***/ }),
	/* 15 */,
	/* 16 */,
	/* 17 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		function createObjectWithProperties(originalObj, properties) {
		  var result = {};
		  for (var _iterator = properties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var property = _ref;
	
		    if (originalObj[property]) {
		      result[property] = originalObj[property];
		    }
		  }
		  return result;
		}
	
		module.exports = createObjectWithProperties;
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 *  Copyright (c) 2014-2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		(function (global, factory) {
		   true ? module.exports = factory() :
		  typeof define === 'function' && define.amd ? define(factory) :
		  (global.Immutable = factory());
		}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
		  function createClass(ctor, superClass) {
		    if (superClass) {
		      ctor.prototype = Object.create(superClass.prototype);
		    }
		    ctor.prototype.constructor = ctor;
		  }
	
		  function Iterable(value) {
		      return isIterable(value) ? value : Seq(value);
		    }
	
	
		  createClass(KeyedIterable, Iterable);
		    function KeyedIterable(value) {
		      return isKeyed(value) ? value : KeyedSeq(value);
		    }
	
	
		  createClass(IndexedIterable, Iterable);
		    function IndexedIterable(value) {
		      return isIndexed(value) ? value : IndexedSeq(value);
		    }
	
	
		  createClass(SetIterable, Iterable);
		    function SetIterable(value) {
		      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
		    }
	
	
	
		  function isIterable(maybeIterable) {
		    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
		  }
	
		  function isKeyed(maybeKeyed) {
		    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
		  }
	
		  function isIndexed(maybeIndexed) {
		    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
		  }
	
		  function isAssociative(maybeAssociative) {
		    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
		  }
	
		  function isOrdered(maybeOrdered) {
		    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
		  }
	
		  Iterable.isIterable = isIterable;
		  Iterable.isKeyed = isKeyed;
		  Iterable.isIndexed = isIndexed;
		  Iterable.isAssociative = isAssociative;
		  Iterable.isOrdered = isOrdered;
	
		  Iterable.Keyed = KeyedIterable;
		  Iterable.Indexed = IndexedIterable;
		  Iterable.Set = SetIterable;
	
	
		  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
		  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
		  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
		  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
		  // Used for setting prototype methods that IE8 chokes on.
		  var DELETE = 'delete';
	
		  // Constants describing the size of trie nodes.
		  var SHIFT = 5; // Resulted in best performance after ______?
		  var SIZE = 1 << SHIFT;
		  var MASK = SIZE - 1;
	
		  // A consistent shared value representing "not set" which equals nothing other
		  // than itself, and nothing that could be provided externally.
		  var NOT_SET = {};
	
		  // Boolean references, Rough equivalent of `bool &`.
		  var CHANGE_LENGTH = { value: false };
		  var DID_ALTER = { value: false };
	
		  function MakeRef(ref) {
		    ref.value = false;
		    return ref;
		  }
	
		  function SetRef(ref) {
		    ref && (ref.value = true);
		  }
	
		  // A function which returns a value representing an "owner" for transient writes
		  // to tries. The return value will only ever equal itself, and will not equal
		  // the return of any subsequent call of this function.
		  function OwnerID() {}
	
		  // http://jsperf.com/copy-array-inline
		  function arrCopy(arr, offset) {
		    offset = offset || 0;
		    var len = Math.max(0, arr.length - offset);
		    var newArr = new Array(len);
		    for (var ii = 0; ii < len; ii++) {
		      newArr[ii] = arr[ii + offset];
		    }
		    return newArr;
		  }
	
		  function ensureSize(iter) {
		    if (iter.size === undefined) {
		      iter.size = iter.__iterate(returnTrue);
		    }
		    return iter.size;
		  }
	
		  function wrapIndex(iter, index) {
		    // This implements "is array index" which the ECMAString spec defines as:
		    //
		    //     A String property name P is an array index if and only if
		    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
		    //     to 2^32−1.
		    //
		    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
		    if (typeof index !== 'number') {
		      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
		      if ('' + uint32Index !== index || uint32Index === 4294967295) {
		        return NaN;
		      }
		      index = uint32Index;
		    }
		    return index < 0 ? ensureSize(iter) + index : index;
		  }
	
		  function returnTrue() {
		    return true;
		  }
	
		  function wholeSlice(begin, end, size) {
		    return (begin === 0 || (size !== undefined && begin <= -size)) &&
		      (end === undefined || (size !== undefined && end >= size));
		  }
	
		  function resolveBegin(begin, size) {
		    return resolveIndex(begin, size, 0);
		  }
	
		  function resolveEnd(end, size) {
		    return resolveIndex(end, size, size);
		  }
	
		  function resolveIndex(index, size, defaultIndex) {
		    return index === undefined ?
		      defaultIndex :
		      index < 0 ?
		        Math.max(0, size + index) :
		        size === undefined ?
		          index :
		          Math.min(size, index);
		  }
	
		  /* global Symbol */
	
		  var ITERATE_KEYS = 0;
		  var ITERATE_VALUES = 1;
		  var ITERATE_ENTRIES = 2;
	
		  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
		  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
		  function Iterator(next) {
		      this.next = next;
		    }
	
		    Iterator.prototype.toString = function() {
		      return '[Iterator]';
		    };
	
	
		  Iterator.KEYS = ITERATE_KEYS;
		  Iterator.VALUES = ITERATE_VALUES;
		  Iterator.ENTRIES = ITERATE_ENTRIES;
	
		  Iterator.prototype.inspect =
		  Iterator.prototype.toSource = function () { return this.toString(); }
		  Iterator.prototype[ITERATOR_SYMBOL] = function () {
		    return this;
		  };
	
	
		  function iteratorValue(type, k, v, iteratorResult) {
		    var value = type === 0 ? k : type === 1 ? v : [k, v];
		    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
		      value: value, done: false
		    });
		    return iteratorResult;
		  }
	
		  function iteratorDone() {
		    return { value: undefined, done: true };
		  }
	
		  function hasIterator(maybeIterable) {
		    return !!getIteratorFn(maybeIterable);
		  }
	
		  function isIterator(maybeIterator) {
		    return maybeIterator && typeof maybeIterator.next === 'function';
		  }
	
		  function getIterator(iterable) {
		    var iteratorFn = getIteratorFn(iterable);
		    return iteratorFn && iteratorFn.call(iterable);
		  }
	
		  function getIteratorFn(iterable) {
		    var iteratorFn = iterable && (
		      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
		      iterable[FAUX_ITERATOR_SYMBOL]
		    );
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
	
		  function isArrayLike(value) {
		    return value && typeof value.length === 'number';
		  }
	
		  createClass(Seq, Iterable);
		    function Seq(value) {
		      return value === null || value === undefined ? emptySequence() :
		        isIterable(value) ? value.toSeq() : seqFromValue(value);
		    }
	
		    Seq.of = function(/*...values*/) {
		      return Seq(arguments);
		    };
	
		    Seq.prototype.toSeq = function() {
		      return this;
		    };
	
		    Seq.prototype.toString = function() {
		      return this.__toString('Seq {', '}');
		    };
	
		    Seq.prototype.cacheResult = function() {
		      if (!this._cache && this.__iterateUncached) {
		        this._cache = this.entrySeq().toArray();
		        this.size = this._cache.length;
		      }
		      return this;
		    };
	
		    // abstract __iterateUncached(fn, reverse)
	
		    Seq.prototype.__iterate = function(fn, reverse) {
		      return seqIterate(this, fn, reverse, true);
		    };
	
		    // abstract __iteratorUncached(type, reverse)
	
		    Seq.prototype.__iterator = function(type, reverse) {
		      return seqIterator(this, type, reverse, true);
		    };
	
	
	
		  createClass(KeyedSeq, Seq);
		    function KeyedSeq(value) {
		      return value === null || value === undefined ?
		        emptySequence().toKeyedSeq() :
		        isIterable(value) ?
		          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
		          keyedSeqFromValue(value);
		    }
	
		    KeyedSeq.prototype.toKeyedSeq = function() {
		      return this;
		    };
	
	
	
		  createClass(IndexedSeq, Seq);
		    function IndexedSeq(value) {
		      return value === null || value === undefined ? emptySequence() :
		        !isIterable(value) ? indexedSeqFromValue(value) :
		        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
		    }
	
		    IndexedSeq.of = function(/*...values*/) {
		      return IndexedSeq(arguments);
		    };
	
		    IndexedSeq.prototype.toIndexedSeq = function() {
		      return this;
		    };
	
		    IndexedSeq.prototype.toString = function() {
		      return this.__toString('Seq [', ']');
		    };
	
		    IndexedSeq.prototype.__iterate = function(fn, reverse) {
		      return seqIterate(this, fn, reverse, false);
		    };
	
		    IndexedSeq.prototype.__iterator = function(type, reverse) {
		      return seqIterator(this, type, reverse, false);
		    };
	
	
	
		  createClass(SetSeq, Seq);
		    function SetSeq(value) {
		      return (
		        value === null || value === undefined ? emptySequence() :
		        !isIterable(value) ? indexedSeqFromValue(value) :
		        isKeyed(value) ? value.entrySeq() : value
		      ).toSetSeq();
		    }
	
		    SetSeq.of = function(/*...values*/) {
		      return SetSeq(arguments);
		    };
	
		    SetSeq.prototype.toSetSeq = function() {
		      return this;
		    };
	
	
	
		  Seq.isSeq = isSeq;
		  Seq.Keyed = KeyedSeq;
		  Seq.Set = SetSeq;
		  Seq.Indexed = IndexedSeq;
	
		  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
		  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
		  createClass(ArraySeq, IndexedSeq);
		    function ArraySeq(array) {
		      this._array = array;
		      this.size = array.length;
		    }
	
		    ArraySeq.prototype.get = function(index, notSetValue) {
		      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
		    };
	
		    ArraySeq.prototype.__iterate = function(fn, reverse) {
		      var array = this._array;
		      var maxIndex = array.length - 1;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    };
	
		    ArraySeq.prototype.__iterator = function(type, reverse) {
		      var array = this._array;
		      var maxIndex = array.length - 1;
		      var ii = 0;
		      return new Iterator(function() 
		        {return ii > maxIndex ?
		          iteratorDone() :
		          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
		      );
		    };
	
	
	
		  createClass(ObjectSeq, KeyedSeq);
		    function ObjectSeq(object) {
		      var keys = Object.keys(object);
		      this._object = object;
		      this._keys = keys;
		      this.size = keys.length;
		    }
	
		    ObjectSeq.prototype.get = function(key, notSetValue) {
		      if (notSetValue !== undefined && !this.has(key)) {
		        return notSetValue;
		      }
		      return this._object[key];
		    };
	
		    ObjectSeq.prototype.has = function(key) {
		      return this._object.hasOwnProperty(key);
		    };
	
		    ObjectSeq.prototype.__iterate = function(fn, reverse) {
		      var object = this._object;
		      var keys = this._keys;
		      var maxIndex = keys.length - 1;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        var key = keys[reverse ? maxIndex - ii : ii];
		        if (fn(object[key], key, this) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    };
	
		    ObjectSeq.prototype.__iterator = function(type, reverse) {
		      var object = this._object;
		      var keys = this._keys;
		      var maxIndex = keys.length - 1;
		      var ii = 0;
		      return new Iterator(function()  {
		        var key = keys[reverse ? maxIndex - ii : ii];
		        return ii++ > maxIndex ?
		          iteratorDone() :
		          iteratorValue(type, key, object[key]);
		      });
		    };
	
		  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
		  createClass(IterableSeq, IndexedSeq);
		    function IterableSeq(iterable) {
		      this._iterable = iterable;
		      this.size = iterable.length || iterable.size;
		    }
	
		    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var iterable = this._iterable;
		      var iterator = getIterator(iterable);
		      var iterations = 0;
		      if (isIterator(iterator)) {
		        var step;
		        while (!(step = iterator.next()).done) {
		          if (fn(step.value, iterations++, this) === false) {
		            break;
		          }
		        }
		      }
		      return iterations;
		    };
	
		    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterable = this._iterable;
		      var iterator = getIterator(iterable);
		      if (!isIterator(iterator)) {
		        return new Iterator(iteratorDone);
		      }
		      var iterations = 0;
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step : iteratorValue(type, iterations++, step.value);
		      });
		    };
	
	
	
		  createClass(IteratorSeq, IndexedSeq);
		    function IteratorSeq(iterator) {
		      this._iterator = iterator;
		      this._iteratorCache = [];
		    }
	
		    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var iterator = this._iterator;
		      var cache = this._iteratorCache;
		      var iterations = 0;
		      while (iterations < cache.length) {
		        if (fn(cache[iterations], iterations++, this) === false) {
		          return iterations;
		        }
		      }
		      var step;
		      while (!(step = iterator.next()).done) {
		        var val = step.value;
		        cache[iterations] = val;
		        if (fn(val, iterations++, this) === false) {
		          break;
		        }
		      }
		      return iterations;
		    };
	
		    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterator = this._iterator;
		      var cache = this._iteratorCache;
		      var iterations = 0;
		      return new Iterator(function()  {
		        if (iterations >= cache.length) {
		          var step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		          cache[iterations] = step.value;
		        }
		        return iteratorValue(type, iterations, cache[iterations++]);
		      });
		    };
	
	
	
	
		  // # pragma Helper functions
	
		  function isSeq(maybeSeq) {
		    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
		  }
	
		  var EMPTY_SEQ;
	
		  function emptySequence() {
		    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
		  }
	
		  function keyedSeqFromValue(value) {
		    var seq =
		      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
		      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
		      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
		      typeof value === 'object' ? new ObjectSeq(value) :
		      undefined;
		    if (!seq) {
		      throw new TypeError(
		        'Expected Array or iterable object of [k, v] entries, '+
		        'or keyed object: ' + value
		      );
		    }
		    return seq;
		  }
	
		  function indexedSeqFromValue(value) {
		    var seq = maybeIndexedSeqFromValue(value);
		    if (!seq) {
		      throw new TypeError(
		        'Expected Array or iterable object of values: ' + value
		      );
		    }
		    return seq;
		  }
	
		  function seqFromValue(value) {
		    var seq = maybeIndexedSeqFromValue(value) ||
		      (typeof value === 'object' && new ObjectSeq(value));
		    if (!seq) {
		      throw new TypeError(
		        'Expected Array or iterable object of values, or keyed object: ' + value
		      );
		    }
		    return seq;
		  }
	
		  function maybeIndexedSeqFromValue(value) {
		    return (
		      isArrayLike(value) ? new ArraySeq(value) :
		      isIterator(value) ? new IteratorSeq(value) :
		      hasIterator(value) ? new IterableSeq(value) :
		      undefined
		    );
		  }
	
		  function seqIterate(seq, fn, reverse, useKeys) {
		    var cache = seq._cache;
		    if (cache) {
		      var maxIndex = cache.length - 1;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        var entry = cache[reverse ? maxIndex - ii : ii];
		        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    }
		    return seq.__iterateUncached(fn, reverse);
		  }
	
		  function seqIterator(seq, type, reverse, useKeys) {
		    var cache = seq._cache;
		    if (cache) {
		      var maxIndex = cache.length - 1;
		      var ii = 0;
		      return new Iterator(function()  {
		        var entry = cache[reverse ? maxIndex - ii : ii];
		        return ii++ > maxIndex ?
		          iteratorDone() :
		          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
		      });
		    }
		    return seq.__iteratorUncached(type, reverse);
		  }
	
		  function fromJS(json, converter) {
		    return converter ?
		      fromJSWith(converter, json, '', {'': json}) :
		      fromJSDefault(json);
		  }
	
		  function fromJSWith(converter, json, key, parentJSON) {
		    if (Array.isArray(json)) {
		      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
		    }
		    if (isPlainObj(json)) {
		      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
		    }
		    return json;
		  }
	
		  function fromJSDefault(json) {
		    if (Array.isArray(json)) {
		      return IndexedSeq(json).map(fromJSDefault).toList();
		    }
		    if (isPlainObj(json)) {
		      return KeyedSeq(json).map(fromJSDefault).toMap();
		    }
		    return json;
		  }
	
		  function isPlainObj(value) {
		    return value && (value.constructor === Object || value.constructor === undefined);
		  }
	
		  /**
		   * An extension of the "same-value" algorithm as [described for use by ES6 Map
		   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
		   *
		   * NaN is considered the same as NaN, however -0 and 0 are considered the same
		   * value, which is different from the algorithm described by
		   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
		   *
		   * This is extended further to allow Objects to describe the values they
		   * represent, by way of `valueOf` or `equals` (and `hashCode`).
		   *
		   * Note: because of this extension, the key equality of Immutable.Map and the
		   * value equality of Immutable.Set will differ from ES6 Map and Set.
		   *
		   * ### Defining custom values
		   *
		   * The easiest way to describe the value an object represents is by implementing
		   * `valueOf`. For example, `Date` represents a value by returning a unix
		   * timestamp for `valueOf`:
		   *
		   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
		   *     var date2 = new Date(1234567890000);
		   *     date1.valueOf(); // 1234567890000
		   *     assert( date1 !== date2 );
		   *     assert( Immutable.is( date1, date2 ) );
		   *
		   * Note: overriding `valueOf` may have other implications if you use this object
		   * where JavaScript expects a primitive, such as implicit string coercion.
		   *
		   * For more complex types, especially collections, implementing `valueOf` may
		   * not be performant. An alternative is to implement `equals` and `hashCode`.
		   *
		   * `equals` takes another object, presumably of similar type, and returns true
		   * if the it is equal. Equality is symmetrical, so the same result should be
		   * returned if this and the argument are flipped.
		   *
		   *     assert( a.equals(b) === b.equals(a) );
		   *
		   * `hashCode` returns a 32bit integer number representing the object which will
		   * be used to determine how to store the value object in a Map or Set. You must
		   * provide both or neither methods, one must not exist without the other.
		   *
		   * Also, an important relationship between these methods must be upheld: if two
		   * values are equal, they *must* return the same hashCode. If the values are not
		   * equal, they might have the same hashCode; this is called a hash collision,
		   * and while undesirable for performance reasons, it is acceptable.
		   *
		   *     if (a.equals(b)) {
		   *       assert( a.hashCode() === b.hashCode() );
		   *     }
		   *
		   * All Immutable collections implement `equals` and `hashCode`.
		   *
		   */
		  function is(valueA, valueB) {
		    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
		      return true;
		    }
		    if (!valueA || !valueB) {
		      return false;
		    }
		    if (typeof valueA.valueOf === 'function' &&
		        typeof valueB.valueOf === 'function') {
		      valueA = valueA.valueOf();
		      valueB = valueB.valueOf();
		      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
		        return true;
		      }
		      if (!valueA || !valueB) {
		        return false;
		      }
		    }
		    if (typeof valueA.equals === 'function' &&
		        typeof valueB.equals === 'function' &&
		        valueA.equals(valueB)) {
		      return true;
		    }
		    return false;
		  }
	
		  function deepEqual(a, b) {
		    if (a === b) {
		      return true;
		    }
	
		    if (
		      !isIterable(b) ||
		      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
		      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
		      isKeyed(a) !== isKeyed(b) ||
		      isIndexed(a) !== isIndexed(b) ||
		      isOrdered(a) !== isOrdered(b)
		    ) {
		      return false;
		    }
	
		    if (a.size === 0 && b.size === 0) {
		      return true;
		    }
	
		    var notAssociative = !isAssociative(a);
	
		    if (isOrdered(a)) {
		      var entries = a.entries();
		      return b.every(function(v, k)  {
		        var entry = entries.next().value;
		        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
		      }) && entries.next().done;
		    }
	
		    var flipped = false;
	
		    if (a.size === undefined) {
		      if (b.size === undefined) {
		        if (typeof a.cacheResult === 'function') {
		          a.cacheResult();
		        }
		      } else {
		        flipped = true;
		        var _ = a;
		        a = b;
		        b = _;
		      }
		    }
	
		    var allEqual = true;
		    var bSize = b.__iterate(function(v, k)  {
		      if (notAssociative ? !a.has(v) :
		          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
		        allEqual = false;
		        return false;
		      }
		    });
	
		    return allEqual && a.size === bSize;
		  }
	
		  createClass(Repeat, IndexedSeq);
	
		    function Repeat(value, times) {
		      if (!(this instanceof Repeat)) {
		        return new Repeat(value, times);
		      }
		      this._value = value;
		      this.size = times === undefined ? Infinity : Math.max(0, times);
		      if (this.size === 0) {
		        if (EMPTY_REPEAT) {
		          return EMPTY_REPEAT;
		        }
		        EMPTY_REPEAT = this;
		      }
		    }
	
		    Repeat.prototype.toString = function() {
		      if (this.size === 0) {
		        return 'Repeat []';
		      }
		      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
		    };
	
		    Repeat.prototype.get = function(index, notSetValue) {
		      return this.has(index) ? this._value : notSetValue;
		    };
	
		    Repeat.prototype.includes = function(searchValue) {
		      return is(this._value, searchValue);
		    };
	
		    Repeat.prototype.slice = function(begin, end) {
		      var size = this.size;
		      return wholeSlice(begin, end, size) ? this :
		        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
		    };
	
		    Repeat.prototype.reverse = function() {
		      return this;
		    };
	
		    Repeat.prototype.indexOf = function(searchValue) {
		      if (is(this._value, searchValue)) {
		        return 0;
		      }
		      return -1;
		    };
	
		    Repeat.prototype.lastIndexOf = function(searchValue) {
		      if (is(this._value, searchValue)) {
		        return this.size;
		      }
		      return -1;
		    };
	
		    Repeat.prototype.__iterate = function(fn, reverse) {
		      for (var ii = 0; ii < this.size; ii++) {
		        if (fn(this._value, ii, this) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    };
	
		    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
		      var ii = 0;
		      return new Iterator(function() 
		        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
		      );
		    };
	
		    Repeat.prototype.equals = function(other) {
		      return other instanceof Repeat ?
		        is(this._value, other._value) :
		        deepEqual(other);
		    };
	
	
		  var EMPTY_REPEAT;
	
		  function invariant(condition, error) {
		    if (!condition) throw new Error(error);
		  }
	
		  createClass(Range, IndexedSeq);
	
		    function Range(start, end, step) {
		      if (!(this instanceof Range)) {
		        return new Range(start, end, step);
		      }
		      invariant(step !== 0, 'Cannot step a Range by 0');
		      start = start || 0;
		      if (end === undefined) {
		        end = Infinity;
		      }
		      step = step === undefined ? 1 : Math.abs(step);
		      if (end < start) {
		        step = -step;
		      }
		      this._start = start;
		      this._end = end;
		      this._step = step;
		      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
		      if (this.size === 0) {
		        if (EMPTY_RANGE) {
		          return EMPTY_RANGE;
		        }
		        EMPTY_RANGE = this;
		      }
		    }
	
		    Range.prototype.toString = function() {
		      if (this.size === 0) {
		        return 'Range []';
		      }
		      return 'Range [ ' +
		        this._start + '...' + this._end +
		        (this._step !== 1 ? ' by ' + this._step : '') +
		      ' ]';
		    };
	
		    Range.prototype.get = function(index, notSetValue) {
		      return this.has(index) ?
		        this._start + wrapIndex(this, index) * this._step :
		        notSetValue;
		    };
	
		    Range.prototype.includes = function(searchValue) {
		      var possibleIndex = (searchValue - this._start) / this._step;
		      return possibleIndex >= 0 &&
		        possibleIndex < this.size &&
		        possibleIndex === Math.floor(possibleIndex);
		    };
	
		    Range.prototype.slice = function(begin, end) {
		      if (wholeSlice(begin, end, this.size)) {
		        return this;
		      }
		      begin = resolveBegin(begin, this.size);
		      end = resolveEnd(end, this.size);
		      if (end <= begin) {
		        return new Range(0, 0);
		      }
		      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
		    };
	
		    Range.prototype.indexOf = function(searchValue) {
		      var offsetValue = searchValue - this._start;
		      if (offsetValue % this._step === 0) {
		        var index = offsetValue / this._step;
		        if (index >= 0 && index < this.size) {
		          return index
		        }
		      }
		      return -1;
		    };
	
		    Range.prototype.lastIndexOf = function(searchValue) {
		      return this.indexOf(searchValue);
		    };
	
		    Range.prototype.__iterate = function(fn, reverse) {
		      var maxIndex = this.size - 1;
		      var step = this._step;
		      var value = reverse ? this._start + maxIndex * step : this._start;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        if (fn(value, ii, this) === false) {
		          return ii + 1;
		        }
		        value += reverse ? -step : step;
		      }
		      return ii;
		    };
	
		    Range.prototype.__iterator = function(type, reverse) {
		      var maxIndex = this.size - 1;
		      var step = this._step;
		      var value = reverse ? this._start + maxIndex * step : this._start;
		      var ii = 0;
		      return new Iterator(function()  {
		        var v = value;
		        value += reverse ? -step : step;
		        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
		      });
		    };
	
		    Range.prototype.equals = function(other) {
		      return other instanceof Range ?
		        this._start === other._start &&
		        this._end === other._end &&
		        this._step === other._step :
		        deepEqual(this, other);
		    };
	
	
		  var EMPTY_RANGE;
	
		  createClass(Collection, Iterable);
		    function Collection() {
		      throw TypeError('Abstract');
		    }
	
	
		  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
		  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
		  createClass(SetCollection, Collection);function SetCollection() {}
	
	
		  Collection.Keyed = KeyedCollection;
		  Collection.Indexed = IndexedCollection;
		  Collection.Set = SetCollection;
	
		  var imul =
		    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
		    Math.imul :
		    function imul(a, b) {
		      a = a | 0; // int
		      b = b | 0; // int
		      var c = a & 0xffff;
		      var d = b & 0xffff;
		      // Shift by 0 fixes the sign on the high part.
		      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
		    };
	
		  // v8 has an optimization for storing 31-bit signed numbers.
		  // Values which have either 00 or 11 as the high order bits qualify.
		  // This function drops the highest order bit in a signed number, maintaining
		  // the sign bit.
		  function smi(i32) {
		    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
		  }
	
		  function hash(o) {
		    if (o === false || o === null || o === undefined) {
		      return 0;
		    }
		    if (typeof o.valueOf === 'function') {
		      o = o.valueOf();
		      if (o === false || o === null || o === undefined) {
		        return 0;
		      }
		    }
		    if (o === true) {
		      return 1;
		    }
		    var type = typeof o;
		    if (type === 'number') {
		      if (o !== o || o === Infinity) {
		        return 0;
		      }
		      var h = o | 0;
		      if (h !== o) {
		        h ^= o * 0xFFFFFFFF;
		      }
		      while (o > 0xFFFFFFFF) {
		        o /= 0xFFFFFFFF;
		        h ^= o;
		      }
		      return smi(h);
		    }
		    if (type === 'string') {
		      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
		    }
		    if (typeof o.hashCode === 'function') {
		      return o.hashCode();
		    }
		    if (type === 'object') {
		      return hashJSObj(o);
		    }
		    if (typeof o.toString === 'function') {
		      return hashString(o.toString());
		    }
		    throw new Error('Value type ' + type + ' cannot be hashed.');
		  }
	
		  function cachedHashString(string) {
		    var hash = stringHashCache[string];
		    if (hash === undefined) {
		      hash = hashString(string);
		      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
		        STRING_HASH_CACHE_SIZE = 0;
		        stringHashCache = {};
		      }
		      STRING_HASH_CACHE_SIZE++;
		      stringHashCache[string] = hash;
		    }
		    return hash;
		  }
	
		  // http://jsperf.com/hashing-strings
		  function hashString(string) {
		    // This is the hash from JVM
		    // The hash code for a string is computed as
		    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
		    // where s[i] is the ith character of the string and n is the length of
		    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
		    // (exclusive) by dropping high bits.
		    var hash = 0;
		    for (var ii = 0; ii < string.length; ii++) {
		      hash = 31 * hash + string.charCodeAt(ii) | 0;
		    }
		    return smi(hash);
		  }
	
		  function hashJSObj(obj) {
		    var hash;
		    if (usingWeakMap) {
		      hash = weakMap.get(obj);
		      if (hash !== undefined) {
		        return hash;
		      }
		    }
	
		    hash = obj[UID_HASH_KEY];
		    if (hash !== undefined) {
		      return hash;
		    }
	
		    if (!canDefineProperty) {
		      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
		      if (hash !== undefined) {
		        return hash;
		      }
	
		      hash = getIENodeHash(obj);
		      if (hash !== undefined) {
		        return hash;
		      }
		    }
	
		    hash = ++objHashUID;
		    if (objHashUID & 0x40000000) {
		      objHashUID = 0;
		    }
	
		    if (usingWeakMap) {
		      weakMap.set(obj, hash);
		    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
		      throw new Error('Non-extensible objects are not allowed as keys.');
		    } else if (canDefineProperty) {
		      Object.defineProperty(obj, UID_HASH_KEY, {
		        'enumerable': false,
		        'configurable': false,
		        'writable': false,
		        'value': hash
		      });
		    } else if (obj.propertyIsEnumerable !== undefined &&
		               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
		      // Since we can't define a non-enumerable property on the object
		      // we'll hijack one of the less-used non-enumerable properties to
		      // save our hash on it. Since this is a function it will not show up in
		      // `JSON.stringify` which is what we want.
		      obj.propertyIsEnumerable = function() {
		        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
		      };
		      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
		    } else if (obj.nodeType !== undefined) {
		      // At this point we couldn't get the IE `uniqueID` to use as a hash
		      // and we couldn't use a non-enumerable property to exploit the
		      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
		      // itself.
		      obj[UID_HASH_KEY] = hash;
		    } else {
		      throw new Error('Unable to set a non-enumerable property on object.');
		    }
	
		    return hash;
		  }
	
		  // Get references to ES5 object methods.
		  var isExtensible = Object.isExtensible;
	
		  // True if Object.defineProperty works as expected. IE8 fails this test.
		  var canDefineProperty = (function() {
		    try {
		      Object.defineProperty({}, '@', {});
		      return true;
		    } catch (e) {
		      return false;
		    }
		  }());
	
		  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
		  // and avoid memory leaks from the IE cloneNode bug.
		  function getIENodeHash(node) {
		    if (node && node.nodeType > 0) {
		      switch (node.nodeType) {
		        case 1: // Element
		          return node.uniqueID;
		        case 9: // Document
		          return node.documentElement && node.documentElement.uniqueID;
		      }
		    }
		  }
	
		  // If possible, use a WeakMap.
		  var usingWeakMap = typeof WeakMap === 'function';
		  var weakMap;
		  if (usingWeakMap) {
		    weakMap = new WeakMap();
		  }
	
		  var objHashUID = 0;
	
		  var UID_HASH_KEY = '__immutablehash__';
		  if (typeof Symbol === 'function') {
		    UID_HASH_KEY = Symbol(UID_HASH_KEY);
		  }
	
		  var STRING_HASH_CACHE_MIN_STRLEN = 16;
		  var STRING_HASH_CACHE_MAX_SIZE = 255;
		  var STRING_HASH_CACHE_SIZE = 0;
		  var stringHashCache = {};
	
		  function assertNotInfinite(size) {
		    invariant(
		      size !== Infinity,
		      'Cannot perform this action with an infinite size.'
		    );
		  }
	
		  createClass(Map, KeyedCollection);
	
		    // @pragma Construction
	
		    function Map(value) {
		      return value === null || value === undefined ? emptyMap() :
		        isMap(value) && !isOrdered(value) ? value :
		        emptyMap().withMutations(function(map ) {
		          var iter = KeyedIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v, k)  {return map.set(k, v)});
		        });
		    }
	
		    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
		      return emptyMap().withMutations(function(map ) {
		        for (var i = 0; i < keyValues.length; i += 2) {
		          if (i + 1 >= keyValues.length) {
		            throw new Error('Missing value for key: ' + keyValues[i]);
		          }
		          map.set(keyValues[i], keyValues[i + 1]);
		        }
		      });
		    };
	
		    Map.prototype.toString = function() {
		      return this.__toString('Map {', '}');
		    };
	
		    // @pragma Access
	
		    Map.prototype.get = function(k, notSetValue) {
		      return this._root ?
		        this._root.get(0, undefined, k, notSetValue) :
		        notSetValue;
		    };
	
		    // @pragma Modification
	
		    Map.prototype.set = function(k, v) {
		      return updateMap(this, k, v);
		    };
	
		    Map.prototype.setIn = function(keyPath, v) {
		      return this.updateIn(keyPath, NOT_SET, function()  {return v});
		    };
	
		    Map.prototype.remove = function(k) {
		      return updateMap(this, k, NOT_SET);
		    };
	
		    Map.prototype.deleteIn = function(keyPath) {
		      return this.updateIn(keyPath, function()  {return NOT_SET});
		    };
	
		    Map.prototype.update = function(k, notSetValue, updater) {
		      return arguments.length === 1 ?
		        k(this) :
		        this.updateIn([k], notSetValue, updater);
		    };
	
		    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
		      if (!updater) {
		        updater = notSetValue;
		        notSetValue = undefined;
		      }
		      var updatedValue = updateInDeepMap(
		        this,
		        forceIterator(keyPath),
		        notSetValue,
		        updater
		      );
		      return updatedValue === NOT_SET ? undefined : updatedValue;
		    };
	
		    Map.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = 0;
		        this._root = null;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return emptyMap();
		    };
	
		    // @pragma Composition
	
		    Map.prototype.merge = function(/*...iters*/) {
		      return mergeIntoMapWith(this, undefined, arguments);
		    };
	
		    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoMapWith(this, merger, iters);
		    };
	
		    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
		      return this.updateIn(
		        keyPath,
		        emptyMap(),
		        function(m ) {return typeof m.merge === 'function' ?
		          m.merge.apply(m, iters) :
		          iters[iters.length - 1]}
		      );
		    };
	
		    Map.prototype.mergeDeep = function(/*...iters*/) {
		      return mergeIntoMapWith(this, deepMerger, arguments);
		    };
	
		    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
		    };
	
		    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
		      return this.updateIn(
		        keyPath,
		        emptyMap(),
		        function(m ) {return typeof m.mergeDeep === 'function' ?
		          m.mergeDeep.apply(m, iters) :
		          iters[iters.length - 1]}
		      );
		    };
	
		    Map.prototype.sort = function(comparator) {
		      // Late binding
		      return OrderedMap(sortFactory(this, comparator));
		    };
	
		    Map.prototype.sortBy = function(mapper, comparator) {
		      // Late binding
		      return OrderedMap(sortFactory(this, comparator, mapper));
		    };
	
		    // @pragma Mutability
	
		    Map.prototype.withMutations = function(fn) {
		      var mutable = this.asMutable();
		      fn(mutable);
		      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
		    };
	
		    Map.prototype.asMutable = function() {
		      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
		    };
	
		    Map.prototype.asImmutable = function() {
		      return this.__ensureOwner();
		    };
	
		    Map.prototype.wasAltered = function() {
		      return this.__altered;
		    };
	
		    Map.prototype.__iterator = function(type, reverse) {
		      return new MapIterator(this, type, reverse);
		    };
	
		    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      this._root && this._root.iterate(function(entry ) {
		        iterations++;
		        return fn(entry[1], entry[0], this$0);
		      }, reverse);
		      return iterations;
		    };
	
		    Map.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this.__altered = false;
		        return this;
		      }
		      return makeMap(this.size, this._root, ownerID, this.__hash);
		    };
	
	
		  function isMap(maybeMap) {
		    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
		  }
	
		  Map.isMap = isMap;
	
		  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
		  var MapPrototype = Map.prototype;
		  MapPrototype[IS_MAP_SENTINEL] = true;
		  MapPrototype[DELETE] = MapPrototype.remove;
		  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
		  // #pragma Trie Nodes
	
	
	
		    function ArrayMapNode(ownerID, entries) {
		      this.ownerID = ownerID;
		      this.entries = entries;
		    }
	
		    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      var entries = this.entries;
		      for (var ii = 0, len = entries.length; ii < len; ii++) {
		        if (is(key, entries[ii][0])) {
		          return entries[ii][1];
		        }
		      }
		      return notSetValue;
		    };
	
		    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      var removed = value === NOT_SET;
	
		      var entries = this.entries;
		      var idx = 0;
		      for (var len = entries.length; idx < len; idx++) {
		        if (is(key, entries[idx][0])) {
		          break;
		        }
		      }
		      var exists = idx < len;
	
		      if (exists ? entries[idx][1] === value : removed) {
		        return this;
		      }
	
		      SetRef(didAlter);
		      (removed || !exists) && SetRef(didChangeSize);
	
		      if (removed && entries.length === 1) {
		        return; // undefined
		      }
	
		      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
		        return createNodes(ownerID, entries, key, value);
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newEntries = isEditable ? entries : arrCopy(entries);
	
		      if (exists) {
		        if (removed) {
		          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
		        } else {
		          newEntries[idx] = [key, value];
		        }
		      } else {
		        newEntries.push([key, value]);
		      }
	
		      if (isEditable) {
		        this.entries = newEntries;
		        return this;
		      }
	
		      return new ArrayMapNode(ownerID, newEntries);
		    };
	
	
	
	
		    function BitmapIndexedNode(ownerID, bitmap, nodes) {
		      this.ownerID = ownerID;
		      this.bitmap = bitmap;
		      this.nodes = nodes;
		    }
	
		    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
		      var bitmap = this.bitmap;
		      return (bitmap & bit) === 0 ? notSetValue :
		        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
		    };
	
		    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
		      var bit = 1 << keyHashFrag;
		      var bitmap = this.bitmap;
		      var exists = (bitmap & bit) !== 0;
	
		      if (!exists && value === NOT_SET) {
		        return this;
		      }
	
		      var idx = popCount(bitmap & (bit - 1));
		      var nodes = this.nodes;
		      var node = exists ? nodes[idx] : undefined;
		      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
		      if (newNode === node) {
		        return this;
		      }
	
		      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
		        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
		      }
	
		      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
		        return nodes[idx ^ 1];
		      }
	
		      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
		        return newNode;
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
		      var newNodes = exists ? newNode ?
		        setIn(nodes, idx, newNode, isEditable) :
		        spliceOut(nodes, idx, isEditable) :
		        spliceIn(nodes, idx, newNode, isEditable);
	
		      if (isEditable) {
		        this.bitmap = newBitmap;
		        this.nodes = newNodes;
		        return this;
		      }
	
		      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
		    };
	
	
	
	
		    function HashArrayMapNode(ownerID, count, nodes) {
		      this.ownerID = ownerID;
		      this.count = count;
		      this.nodes = nodes;
		    }
	
		    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
		      var node = this.nodes[idx];
		      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
		    };
	
		    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
		      var removed = value === NOT_SET;
		      var nodes = this.nodes;
		      var node = nodes[idx];
	
		      if (removed && !node) {
		        return this;
		      }
	
		      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
		      if (newNode === node) {
		        return this;
		      }
	
		      var newCount = this.count;
		      if (!node) {
		        newCount++;
		      } else if (!newNode) {
		        newCount--;
		        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
		          return packNodes(ownerID, nodes, newCount, idx);
		        }
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
		      if (isEditable) {
		        this.count = newCount;
		        this.nodes = newNodes;
		        return this;
		      }
	
		      return new HashArrayMapNode(ownerID, newCount, newNodes);
		    };
	
	
	
	
		    function HashCollisionNode(ownerID, keyHash, entries) {
		      this.ownerID = ownerID;
		      this.keyHash = keyHash;
		      this.entries = entries;
		    }
	
		    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      var entries = this.entries;
		      for (var ii = 0, len = entries.length; ii < len; ii++) {
		        if (is(key, entries[ii][0])) {
		          return entries[ii][1];
		        }
		      }
		      return notSetValue;
		    };
	
		    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
	
		      var removed = value === NOT_SET;
	
		      if (keyHash !== this.keyHash) {
		        if (removed) {
		          return this;
		        }
		        SetRef(didAlter);
		        SetRef(didChangeSize);
		        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
		      }
	
		      var entries = this.entries;
		      var idx = 0;
		      for (var len = entries.length; idx < len; idx++) {
		        if (is(key, entries[idx][0])) {
		          break;
		        }
		      }
		      var exists = idx < len;
	
		      if (exists ? entries[idx][1] === value : removed) {
		        return this;
		      }
	
		      SetRef(didAlter);
		      (removed || !exists) && SetRef(didChangeSize);
	
		      if (removed && len === 2) {
		        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newEntries = isEditable ? entries : arrCopy(entries);
	
		      if (exists) {
		        if (removed) {
		          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
		        } else {
		          newEntries[idx] = [key, value];
		        }
		      } else {
		        newEntries.push([key, value]);
		      }
	
		      if (isEditable) {
		        this.entries = newEntries;
		        return this;
		      }
	
		      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
		    };
	
	
	
	
		    function ValueNode(ownerID, keyHash, entry) {
		      this.ownerID = ownerID;
		      this.keyHash = keyHash;
		      this.entry = entry;
		    }
	
		    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
		    };
	
		    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      var removed = value === NOT_SET;
		      var keyMatch = is(key, this.entry[0]);
		      if (keyMatch ? value === this.entry[1] : removed) {
		        return this;
		      }
	
		      SetRef(didAlter);
	
		      if (removed) {
		        SetRef(didChangeSize);
		        return; // undefined
		      }
	
		      if (keyMatch) {
		        if (ownerID && ownerID === this.ownerID) {
		          this.entry[1] = value;
		          return this;
		        }
		        return new ValueNode(ownerID, this.keyHash, [key, value]);
		      }
	
		      SetRef(didChangeSize);
		      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
		    };
	
	
	
		  // #pragma Iterators
	
		  ArrayMapNode.prototype.iterate =
		  HashCollisionNode.prototype.iterate = function (fn, reverse) {
		    var entries = this.entries;
		    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
		      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
		        return false;
		      }
		    }
		  }
	
		  BitmapIndexedNode.prototype.iterate =
		  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
		    var nodes = this.nodes;
		    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
		      var node = nodes[reverse ? maxIndex - ii : ii];
		      if (node && node.iterate(fn, reverse) === false) {
		        return false;
		      }
		    }
		  }
	
		  ValueNode.prototype.iterate = function (fn, reverse) {
		    return fn(this.entry);
		  }
	
		  createClass(MapIterator, Iterator);
	
		    function MapIterator(map, type, reverse) {
		      this._type = type;
		      this._reverse = reverse;
		      this._stack = map._root && mapIteratorFrame(map._root);
		    }
	
		    MapIterator.prototype.next = function() {
		      var type = this._type;
		      var stack = this._stack;
		      while (stack) {
		        var node = stack.node;
		        var index = stack.index++;
		        var maxIndex;
		        if (node.entry) {
		          if (index === 0) {
		            return mapIteratorValue(type, node.entry);
		          }
		        } else if (node.entries) {
		          maxIndex = node.entries.length - 1;
		          if (index <= maxIndex) {
		            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
		          }
		        } else {
		          maxIndex = node.nodes.length - 1;
		          if (index <= maxIndex) {
		            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
		            if (subNode) {
		              if (subNode.entry) {
		                return mapIteratorValue(type, subNode.entry);
		              }
		              stack = this._stack = mapIteratorFrame(subNode, stack);
		            }
		            continue;
		          }
		        }
		        stack = this._stack = this._stack.__prev;
		      }
		      return iteratorDone();
		    };
	
	
		  function mapIteratorValue(type, entry) {
		    return iteratorValue(type, entry[0], entry[1]);
		  }
	
		  function mapIteratorFrame(node, prev) {
		    return {
		      node: node,
		      index: 0,
		      __prev: prev
		    };
		  }
	
		  function makeMap(size, root, ownerID, hash) {
		    var map = Object.create(MapPrototype);
		    map.size = size;
		    map._root = root;
		    map.__ownerID = ownerID;
		    map.__hash = hash;
		    map.__altered = false;
		    return map;
		  }
	
		  var EMPTY_MAP;
		  function emptyMap() {
		    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
		  }
	
		  function updateMap(map, k, v) {
		    var newRoot;
		    var newSize;
		    if (!map._root) {
		      if (v === NOT_SET) {
		        return map;
		      }
		      newSize = 1;
		      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
		    } else {
		      var didChangeSize = MakeRef(CHANGE_LENGTH);
		      var didAlter = MakeRef(DID_ALTER);
		      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
		      if (!didAlter.value) {
		        return map;
		      }
		      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
		    }
		    if (map.__ownerID) {
		      map.size = newSize;
		      map._root = newRoot;
		      map.__hash = undefined;
		      map.__altered = true;
		      return map;
		    }
		    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
		  }
	
		  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		    if (!node) {
		      if (value === NOT_SET) {
		        return node;
		      }
		      SetRef(didAlter);
		      SetRef(didChangeSize);
		      return new ValueNode(ownerID, keyHash, [key, value]);
		    }
		    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
		  }
	
		  function isLeafNode(node) {
		    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
		  }
	
		  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
		    if (node.keyHash === keyHash) {
		      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
		    }
	
		    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
		    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
		    var newNode;
		    var nodes = idx1 === idx2 ?
		      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
		      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
		    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
		  }
	
		  function createNodes(ownerID, entries, key, value) {
		    if (!ownerID) {
		      ownerID = new OwnerID();
		    }
		    var node = new ValueNode(ownerID, hash(key), [key, value]);
		    for (var ii = 0; ii < entries.length; ii++) {
		      var entry = entries[ii];
		      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
		    }
		    return node;
		  }
	
		  function packNodes(ownerID, nodes, count, excluding) {
		    var bitmap = 0;
		    var packedII = 0;
		    var packedNodes = new Array(count);
		    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
		      var node = nodes[ii];
		      if (node !== undefined && ii !== excluding) {
		        bitmap |= bit;
		        packedNodes[packedII++] = node;
		      }
		    }
		    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
		  }
	
		  function expandNodes(ownerID, nodes, bitmap, including, node) {
		    var count = 0;
		    var expandedNodes = new Array(SIZE);
		    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
		      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
		    }
		    expandedNodes[including] = node;
		    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
		  }
	
		  function mergeIntoMapWith(map, merger, iterables) {
		    var iters = [];
		    for (var ii = 0; ii < iterables.length; ii++) {
		      var value = iterables[ii];
		      var iter = KeyedIterable(value);
		      if (!isIterable(value)) {
		        iter = iter.map(function(v ) {return fromJS(v)});
		      }
		      iters.push(iter);
		    }
		    return mergeIntoCollectionWith(map, merger, iters);
		  }
	
		  function deepMerger(existing, value, key) {
		    return existing && existing.mergeDeep && isIterable(value) ?
		      existing.mergeDeep(value) :
		      is(existing, value) ? existing : value;
		  }
	
		  function deepMergerWith(merger) {
		    return function(existing, value, key)  {
		      if (existing && existing.mergeDeepWith && isIterable(value)) {
		        return existing.mergeDeepWith(merger, value);
		      }
		      var nextValue = merger(existing, value, key);
		      return is(existing, nextValue) ? existing : nextValue;
		    };
		  }
	
		  function mergeIntoCollectionWith(collection, merger, iters) {
		    iters = iters.filter(function(x ) {return x.size !== 0});
		    if (iters.length === 0) {
		      return collection;
		    }
		    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
		      return collection.constructor(iters[0]);
		    }
		    return collection.withMutations(function(collection ) {
		      var mergeIntoMap = merger ?
		        function(value, key)  {
		          collection.update(key, NOT_SET, function(existing )
		            {return existing === NOT_SET ? value : merger(existing, value, key)}
		          );
		        } :
		        function(value, key)  {
		          collection.set(key, value);
		        }
		      for (var ii = 0; ii < iters.length; ii++) {
		        iters[ii].forEach(mergeIntoMap);
		      }
		    });
		  }
	
		  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
		    var isNotSet = existing === NOT_SET;
		    var step = keyPathIter.next();
		    if (step.done) {
		      var existingValue = isNotSet ? notSetValue : existing;
		      var newValue = updater(existingValue);
		      return newValue === existingValue ? existing : newValue;
		    }
		    invariant(
		      isNotSet || (existing && existing.set),
		      'invalid keyPath'
		    );
		    var key = step.value;
		    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
		    var nextUpdated = updateInDeepMap(
		      nextExisting,
		      keyPathIter,
		      notSetValue,
		      updater
		    );
		    return nextUpdated === nextExisting ? existing :
		      nextUpdated === NOT_SET ? existing.remove(key) :
		      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
		  }
	
		  function popCount(x) {
		    x = x - ((x >> 1) & 0x55555555);
		    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
		    x = (x + (x >> 4)) & 0x0f0f0f0f;
		    x = x + (x >> 8);
		    x = x + (x >> 16);
		    return x & 0x7f;
		  }
	
		  function setIn(array, idx, val, canEdit) {
		    var newArray = canEdit ? array : arrCopy(array);
		    newArray[idx] = val;
		    return newArray;
		  }
	
		  function spliceIn(array, idx, val, canEdit) {
		    var newLen = array.length + 1;
		    if (canEdit && idx + 1 === newLen) {
		      array[idx] = val;
		      return array;
		    }
		    var newArray = new Array(newLen);
		    var after = 0;
		    for (var ii = 0; ii < newLen; ii++) {
		      if (ii === idx) {
		        newArray[ii] = val;
		        after = -1;
		      } else {
		        newArray[ii] = array[ii + after];
		      }
		    }
		    return newArray;
		  }
	
		  function spliceOut(array, idx, canEdit) {
		    var newLen = array.length - 1;
		    if (canEdit && idx === newLen) {
		      array.pop();
		      return array;
		    }
		    var newArray = new Array(newLen);
		    var after = 0;
		    for (var ii = 0; ii < newLen; ii++) {
		      if (ii === idx) {
		        after = 1;
		      }
		      newArray[ii] = array[ii + after];
		    }
		    return newArray;
		  }
	
		  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
		  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
		  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
		  createClass(List, IndexedCollection);
	
		    // @pragma Construction
	
		    function List(value) {
		      var empty = emptyList();
		      if (value === null || value === undefined) {
		        return empty;
		      }
		      if (isList(value)) {
		        return value;
		      }
		      var iter = IndexedIterable(value);
		      var size = iter.size;
		      if (size === 0) {
		        return empty;
		      }
		      assertNotInfinite(size);
		      if (size > 0 && size < SIZE) {
		        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
		      }
		      return empty.withMutations(function(list ) {
		        list.setSize(size);
		        iter.forEach(function(v, i)  {return list.set(i, v)});
		      });
		    }
	
		    List.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    List.prototype.toString = function() {
		      return this.__toString('List [', ']');
		    };
	
		    // @pragma Access
	
		    List.prototype.get = function(index, notSetValue) {
		      index = wrapIndex(this, index);
		      if (index >= 0 && index < this.size) {
		        index += this._origin;
		        var node = listNodeFor(this, index);
		        return node && node.array[index & MASK];
		      }
		      return notSetValue;
		    };
	
		    // @pragma Modification
	
		    List.prototype.set = function(index, value) {
		      return updateList(this, index, value);
		    };
	
		    List.prototype.remove = function(index) {
		      return !this.has(index) ? this :
		        index === 0 ? this.shift() :
		        index === this.size - 1 ? this.pop() :
		        this.splice(index, 1);
		    };
	
		    List.prototype.insert = function(index, value) {
		      return this.splice(index, 0, value);
		    };
	
		    List.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = this._origin = this._capacity = 0;
		        this._level = SHIFT;
		        this._root = this._tail = null;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return emptyList();
		    };
	
		    List.prototype.push = function(/*...values*/) {
		      var values = arguments;
		      var oldSize = this.size;
		      return this.withMutations(function(list ) {
		        setListBounds(list, 0, oldSize + values.length);
		        for (var ii = 0; ii < values.length; ii++) {
		          list.set(oldSize + ii, values[ii]);
		        }
		      });
		    };
	
		    List.prototype.pop = function() {
		      return setListBounds(this, 0, -1);
		    };
	
		    List.prototype.unshift = function(/*...values*/) {
		      var values = arguments;
		      return this.withMutations(function(list ) {
		        setListBounds(list, -values.length);
		        for (var ii = 0; ii < values.length; ii++) {
		          list.set(ii, values[ii]);
		        }
		      });
		    };
	
		    List.prototype.shift = function() {
		      return setListBounds(this, 1);
		    };
	
		    // @pragma Composition
	
		    List.prototype.merge = function(/*...iters*/) {
		      return mergeIntoListWith(this, undefined, arguments);
		    };
	
		    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoListWith(this, merger, iters);
		    };
	
		    List.prototype.mergeDeep = function(/*...iters*/) {
		      return mergeIntoListWith(this, deepMerger, arguments);
		    };
	
		    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoListWith(this, deepMergerWith(merger), iters);
		    };
	
		    List.prototype.setSize = function(size) {
		      return setListBounds(this, 0, size);
		    };
	
		    // @pragma Iteration
	
		    List.prototype.slice = function(begin, end) {
		      var size = this.size;
		      if (wholeSlice(begin, end, size)) {
		        return this;
		      }
		      return setListBounds(
		        this,
		        resolveBegin(begin, size),
		        resolveEnd(end, size)
		      );
		    };
	
		    List.prototype.__iterator = function(type, reverse) {
		      var index = 0;
		      var values = iterateList(this, reverse);
		      return new Iterator(function()  {
		        var value = values();
		        return value === DONE ?
		          iteratorDone() :
		          iteratorValue(type, index++, value);
		      });
		    };
	
		    List.prototype.__iterate = function(fn, reverse) {
		      var index = 0;
		      var values = iterateList(this, reverse);
		      var value;
		      while ((value = values()) !== DONE) {
		        if (fn(value, index++, this) === false) {
		          break;
		        }
		      }
		      return index;
		    };
	
		    List.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        return this;
		      }
		      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
		    };
	
	
		  function isList(maybeList) {
		    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
		  }
	
		  List.isList = isList;
	
		  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
		  var ListPrototype = List.prototype;
		  ListPrototype[IS_LIST_SENTINEL] = true;
		  ListPrototype[DELETE] = ListPrototype.remove;
		  ListPrototype.setIn = MapPrototype.setIn;
		  ListPrototype.deleteIn =
		  ListPrototype.removeIn = MapPrototype.removeIn;
		  ListPrototype.update = MapPrototype.update;
		  ListPrototype.updateIn = MapPrototype.updateIn;
		  ListPrototype.mergeIn = MapPrototype.mergeIn;
		  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
		  ListPrototype.withMutations = MapPrototype.withMutations;
		  ListPrototype.asMutable = MapPrototype.asMutable;
		  ListPrototype.asImmutable = MapPrototype.asImmutable;
		  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
		    function VNode(array, ownerID) {
		      this.array = array;
		      this.ownerID = ownerID;
		    }
	
		    // TODO: seems like these methods are very similar
	
		    VNode.prototype.removeBefore = function(ownerID, level, index) {
		      if (index === level ? 1 << level : 0 || this.array.length === 0) {
		        return this;
		      }
		      var originIndex = (index >>> level) & MASK;
		      if (originIndex >= this.array.length) {
		        return new VNode([], ownerID);
		      }
		      var removingFirst = originIndex === 0;
		      var newChild;
		      if (level > 0) {
		        var oldChild = this.array[originIndex];
		        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
		        if (newChild === oldChild && removingFirst) {
		          return this;
		        }
		      }
		      if (removingFirst && !newChild) {
		        return this;
		      }
		      var editable = editableVNode(this, ownerID);
		      if (!removingFirst) {
		        for (var ii = 0; ii < originIndex; ii++) {
		          editable.array[ii] = undefined;
		        }
		      }
		      if (newChild) {
		        editable.array[originIndex] = newChild;
		      }
		      return editable;
		    };
	
		    VNode.prototype.removeAfter = function(ownerID, level, index) {
		      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
		        return this;
		      }
		      var sizeIndex = ((index - 1) >>> level) & MASK;
		      if (sizeIndex >= this.array.length) {
		        return this;
		      }
	
		      var newChild;
		      if (level > 0) {
		        var oldChild = this.array[sizeIndex];
		        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
		        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
		          return this;
		        }
		      }
	
		      var editable = editableVNode(this, ownerID);
		      editable.array.splice(sizeIndex + 1);
		      if (newChild) {
		        editable.array[sizeIndex] = newChild;
		      }
		      return editable;
		    };
	
	
	
		  var DONE = {};
	
		  function iterateList(list, reverse) {
		    var left = list._origin;
		    var right = list._capacity;
		    var tailPos = getTailOffset(right);
		    var tail = list._tail;
	
		    return iterateNodeOrLeaf(list._root, list._level, 0);
	
		    function iterateNodeOrLeaf(node, level, offset) {
		      return level === 0 ?
		        iterateLeaf(node, offset) :
		        iterateNode(node, level, offset);
		    }
	
		    function iterateLeaf(node, offset) {
		      var array = offset === tailPos ? tail && tail.array : node && node.array;
		      var from = offset > left ? 0 : left - offset;
		      var to = right - offset;
		      if (to > SIZE) {
		        to = SIZE;
		      }
		      return function()  {
		        if (from === to) {
		          return DONE;
		        }
		        var idx = reverse ? --to : from++;
		        return array && array[idx];
		      };
		    }
	
		    function iterateNode(node, level, offset) {
		      var values;
		      var array = node && node.array;
		      var from = offset > left ? 0 : (left - offset) >> level;
		      var to = ((right - offset) >> level) + 1;
		      if (to > SIZE) {
		        to = SIZE;
		      }
		      return function()  {
		        do {
		          if (values) {
		            var value = values();
		            if (value !== DONE) {
		              return value;
		            }
		            values = null;
		          }
		          if (from === to) {
		            return DONE;
		          }
		          var idx = reverse ? --to : from++;
		          values = iterateNodeOrLeaf(
		            array && array[idx], level - SHIFT, offset + (idx << level)
		          );
		        } while (true);
		      };
		    }
		  }
	
		  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
		    var list = Object.create(ListPrototype);
		    list.size = capacity - origin;
		    list._origin = origin;
		    list._capacity = capacity;
		    list._level = level;
		    list._root = root;
		    list._tail = tail;
		    list.__ownerID = ownerID;
		    list.__hash = hash;
		    list.__altered = false;
		    return list;
		  }
	
		  var EMPTY_LIST;
		  function emptyList() {
		    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
		  }
	
		  function updateList(list, index, value) {
		    index = wrapIndex(list, index);
	
		    if (index !== index) {
		      return list;
		    }
	
		    if (index >= list.size || index < 0) {
		      return list.withMutations(function(list ) {
		        index < 0 ?
		          setListBounds(list, index).set(0, value) :
		          setListBounds(list, 0, index + 1).set(index, value)
		      });
		    }
	
		    index += list._origin;
	
		    var newTail = list._tail;
		    var newRoot = list._root;
		    var didAlter = MakeRef(DID_ALTER);
		    if (index >= getTailOffset(list._capacity)) {
		      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
		    } else {
		      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
		    }
	
		    if (!didAlter.value) {
		      return list;
		    }
	
		    if (list.__ownerID) {
		      list._root = newRoot;
		      list._tail = newTail;
		      list.__hash = undefined;
		      list.__altered = true;
		      return list;
		    }
		    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
		  }
	
		  function updateVNode(node, ownerID, level, index, value, didAlter) {
		    var idx = (index >>> level) & MASK;
		    var nodeHas = node && idx < node.array.length;
		    if (!nodeHas && value === undefined) {
		      return node;
		    }
	
		    var newNode;
	
		    if (level > 0) {
		      var lowerNode = node && node.array[idx];
		      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
		      if (newLowerNode === lowerNode) {
		        return node;
		      }
		      newNode = editableVNode(node, ownerID);
		      newNode.array[idx] = newLowerNode;
		      return newNode;
		    }
	
		    if (nodeHas && node.array[idx] === value) {
		      return node;
		    }
	
		    SetRef(didAlter);
	
		    newNode = editableVNode(node, ownerID);
		    if (value === undefined && idx === newNode.array.length - 1) {
		      newNode.array.pop();
		    } else {
		      newNode.array[idx] = value;
		    }
		    return newNode;
		  }
	
		  function editableVNode(node, ownerID) {
		    if (ownerID && node && ownerID === node.ownerID) {
		      return node;
		    }
		    return new VNode(node ? node.array.slice() : [], ownerID);
		  }
	
		  function listNodeFor(list, rawIndex) {
		    if (rawIndex >= getTailOffset(list._capacity)) {
		      return list._tail;
		    }
		    if (rawIndex < 1 << (list._level + SHIFT)) {
		      var node = list._root;
		      var level = list._level;
		      while (node && level > 0) {
		        node = node.array[(rawIndex >>> level) & MASK];
		        level -= SHIFT;
		      }
		      return node;
		    }
		  }
	
		  function setListBounds(list, begin, end) {
		    // Sanitize begin & end using this shorthand for ToInt32(argument)
		    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
		    if (begin !== undefined) {
		      begin = begin | 0;
		    }
		    if (end !== undefined) {
		      end = end | 0;
		    }
		    var owner = list.__ownerID || new OwnerID();
		    var oldOrigin = list._origin;
		    var oldCapacity = list._capacity;
		    var newOrigin = oldOrigin + begin;
		    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
		    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
		      return list;
		    }
	
		    // If it's going to end after it starts, it's empty.
		    if (newOrigin >= newCapacity) {
		      return list.clear();
		    }
	
		    var newLevel = list._level;
		    var newRoot = list._root;
	
		    // New origin might need creating a higher root.
		    var offsetShift = 0;
		    while (newOrigin + offsetShift < 0) {
		      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
		      newLevel += SHIFT;
		      offsetShift += 1 << newLevel;
		    }
		    if (offsetShift) {
		      newOrigin += offsetShift;
		      oldOrigin += offsetShift;
		      newCapacity += offsetShift;
		      oldCapacity += offsetShift;
		    }
	
		    var oldTailOffset = getTailOffset(oldCapacity);
		    var newTailOffset = getTailOffset(newCapacity);
	
		    // New size might need creating a higher root.
		    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
		      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
		      newLevel += SHIFT;
		    }
	
		    // Locate or create the new tail.
		    var oldTail = list._tail;
		    var newTail = newTailOffset < oldTailOffset ?
		      listNodeFor(list, newCapacity - 1) :
		      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
		    // Merge Tail into tree.
		    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
		      newRoot = editableVNode(newRoot, owner);
		      var node = newRoot;
		      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
		        var idx = (oldTailOffset >>> level) & MASK;
		        node = node.array[idx] = editableVNode(node.array[idx], owner);
		      }
		      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
		    }
	
		    // If the size has been reduced, there's a chance the tail needs to be trimmed.
		    if (newCapacity < oldCapacity) {
		      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
		    }
	
		    // If the new origin is within the tail, then we do not need a root.
		    if (newOrigin >= newTailOffset) {
		      newOrigin -= newTailOffset;
		      newCapacity -= newTailOffset;
		      newLevel = SHIFT;
		      newRoot = null;
		      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
		    // Otherwise, if the root has been trimmed, garbage collect.
		    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
		      offsetShift = 0;
	
		      // Identify the new top root node of the subtree of the old root.
		      while (newRoot) {
		        var beginIndex = (newOrigin >>> newLevel) & MASK;
		        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
		          break;
		        }
		        if (beginIndex) {
		          offsetShift += (1 << newLevel) * beginIndex;
		        }
		        newLevel -= SHIFT;
		        newRoot = newRoot.array[beginIndex];
		      }
	
		      // Trim the new sides of the new root.
		      if (newRoot && newOrigin > oldOrigin) {
		        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
		      }
		      if (newRoot && newTailOffset < oldTailOffset) {
		        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
		      }
		      if (offsetShift) {
		        newOrigin -= offsetShift;
		        newCapacity -= offsetShift;
		      }
		    }
	
		    if (list.__ownerID) {
		      list.size = newCapacity - newOrigin;
		      list._origin = newOrigin;
		      list._capacity = newCapacity;
		      list._level = newLevel;
		      list._root = newRoot;
		      list._tail = newTail;
		      list.__hash = undefined;
		      list.__altered = true;
		      return list;
		    }
		    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
		  }
	
		  function mergeIntoListWith(list, merger, iterables) {
		    var iters = [];
		    var maxSize = 0;
		    for (var ii = 0; ii < iterables.length; ii++) {
		      var value = iterables[ii];
		      var iter = IndexedIterable(value);
		      if (iter.size > maxSize) {
		        maxSize = iter.size;
		      }
		      if (!isIterable(value)) {
		        iter = iter.map(function(v ) {return fromJS(v)});
		      }
		      iters.push(iter);
		    }
		    if (maxSize > list.size) {
		      list = list.setSize(maxSize);
		    }
		    return mergeIntoCollectionWith(list, merger, iters);
		  }
	
		  function getTailOffset(size) {
		    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
		  }
	
		  createClass(OrderedMap, Map);
	
		    // @pragma Construction
	
		    function OrderedMap(value) {
		      return value === null || value === undefined ? emptyOrderedMap() :
		        isOrderedMap(value) ? value :
		        emptyOrderedMap().withMutations(function(map ) {
		          var iter = KeyedIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v, k)  {return map.set(k, v)});
		        });
		    }
	
		    OrderedMap.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    OrderedMap.prototype.toString = function() {
		      return this.__toString('OrderedMap {', '}');
		    };
	
		    // @pragma Access
	
		    OrderedMap.prototype.get = function(k, notSetValue) {
		      var index = this._map.get(k);
		      return index !== undefined ? this._list.get(index)[1] : notSetValue;
		    };
	
		    // @pragma Modification
	
		    OrderedMap.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = 0;
		        this._map.clear();
		        this._list.clear();
		        return this;
		      }
		      return emptyOrderedMap();
		    };
	
		    OrderedMap.prototype.set = function(k, v) {
		      return updateOrderedMap(this, k, v);
		    };
	
		    OrderedMap.prototype.remove = function(k) {
		      return updateOrderedMap(this, k, NOT_SET);
		    };
	
		    OrderedMap.prototype.wasAltered = function() {
		      return this._map.wasAltered() || this._list.wasAltered();
		    };
	
		    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._list.__iterate(
		        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
		        reverse
		      );
		    };
	
		    OrderedMap.prototype.__iterator = function(type, reverse) {
		      return this._list.fromEntrySeq().__iterator(type, reverse);
		    };
	
		    OrderedMap.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      var newMap = this._map.__ensureOwner(ownerID);
		      var newList = this._list.__ensureOwner(ownerID);
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this._map = newMap;
		        this._list = newList;
		        return this;
		      }
		      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
		    };
	
	
		  function isOrderedMap(maybeOrderedMap) {
		    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
		  }
	
		  OrderedMap.isOrderedMap = isOrderedMap;
	
		  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
		  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
		  function makeOrderedMap(map, list, ownerID, hash) {
		    var omap = Object.create(OrderedMap.prototype);
		    omap.size = map ? map.size : 0;
		    omap._map = map;
		    omap._list = list;
		    omap.__ownerID = ownerID;
		    omap.__hash = hash;
		    return omap;
		  }
	
		  var EMPTY_ORDERED_MAP;
		  function emptyOrderedMap() {
		    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
		  }
	
		  function updateOrderedMap(omap, k, v) {
		    var map = omap._map;
		    var list = omap._list;
		    var i = map.get(k);
		    var has = i !== undefined;
		    var newMap;
		    var newList;
		    if (v === NOT_SET) { // removed
		      if (!has) {
		        return omap;
		      }
		      if (list.size >= SIZE && list.size >= map.size * 2) {
		        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
		        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
		        if (omap.__ownerID) {
		          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
		        }
		      } else {
		        newMap = map.remove(k);
		        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
		      }
		    } else {
		      if (has) {
		        if (v === list.get(i)[1]) {
		          return omap;
		        }
		        newMap = map;
		        newList = list.set(i, [k, v]);
		      } else {
		        newMap = map.set(k, list.size);
		        newList = list.set(list.size, [k, v]);
		      }
		    }
		    if (omap.__ownerID) {
		      omap.size = newMap.size;
		      omap._map = newMap;
		      omap._list = newList;
		      omap.__hash = undefined;
		      return omap;
		    }
		    return makeOrderedMap(newMap, newList);
		  }
	
		  createClass(ToKeyedSequence, KeyedSeq);
		    function ToKeyedSequence(indexed, useKeys) {
		      this._iter = indexed;
		      this._useKeys = useKeys;
		      this.size = indexed.size;
		    }
	
		    ToKeyedSequence.prototype.get = function(key, notSetValue) {
		      return this._iter.get(key, notSetValue);
		    };
	
		    ToKeyedSequence.prototype.has = function(key) {
		      return this._iter.has(key);
		    };
	
		    ToKeyedSequence.prototype.valueSeq = function() {
		      return this._iter.valueSeq();
		    };
	
		    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
		      var reversedSequence = reverseFactory(this, true);
		      if (!this._useKeys) {
		        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
		      }
		      return reversedSequence;
		    };
	
		    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
		      var mappedSequence = mapFactory(this, mapper, context);
		      if (!this._useKeys) {
		        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
		      }
		      return mappedSequence;
		    };
	
		    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      var ii;
		      return this._iter.__iterate(
		        this._useKeys ?
		          function(v, k)  {return fn(v, k, this$0)} :
		          ((ii = reverse ? resolveSize(this) : 0),
		            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
		        reverse
		      );
		    };
	
		    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
		      if (this._useKeys) {
		        return this._iter.__iterator(type, reverse);
		      }
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      var ii = reverse ? resolveSize(this) : 0;
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step :
		          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
		      });
		    };
	
		  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
		  createClass(ToIndexedSequence, IndexedSeq);
		    function ToIndexedSequence(iter) {
		      this._iter = iter;
		      this.size = iter.size;
		    }
	
		    ToIndexedSequence.prototype.includes = function(value) {
		      return this._iter.includes(value);
		    };
	
		    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
		    };
	
		    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      var iterations = 0;
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step :
		          iteratorValue(type, iterations++, step.value, step)
		      });
		    };
	
	
	
		  createClass(ToSetSequence, SetSeq);
		    function ToSetSequence(iter) {
		      this._iter = iter;
		      this.size = iter.size;
		    }
	
		    ToSetSequence.prototype.has = function(key) {
		      return this._iter.includes(key);
		    };
	
		    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
		    };
	
		    ToSetSequence.prototype.__iterator = function(type, reverse) {
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step :
		          iteratorValue(type, step.value, step.value, step);
		      });
		    };
	
	
	
		  createClass(FromEntriesSequence, KeyedSeq);
		    function FromEntriesSequence(entries) {
		      this._iter = entries;
		      this.size = entries.size;
		    }
	
		    FromEntriesSequence.prototype.entrySeq = function() {
		      return this._iter.toSeq();
		    };
	
		    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._iter.__iterate(function(entry ) {
		        // Check if entry exists first so array access doesn't throw for holes
		        // in the parent iteration.
		        if (entry) {
		          validateEntry(entry);
		          var indexedIterable = isIterable(entry);
		          return fn(
		            indexedIterable ? entry.get(1) : entry[1],
		            indexedIterable ? entry.get(0) : entry[0],
		            this$0
		          );
		        }
		      }, reverse);
		    };
	
		    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      return new Iterator(function()  {
		        while (true) {
		          var step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		          var entry = step.value;
		          // Check if entry exists first so array access doesn't throw for holes
		          // in the parent iteration.
		          if (entry) {
		            validateEntry(entry);
		            var indexedIterable = isIterable(entry);
		            return iteratorValue(
		              type,
		              indexedIterable ? entry.get(0) : entry[0],
		              indexedIterable ? entry.get(1) : entry[1],
		              step
		            );
		          }
		        }
		      });
		    };
	
	
		  ToIndexedSequence.prototype.cacheResult =
		  ToKeyedSequence.prototype.cacheResult =
		  ToSetSequence.prototype.cacheResult =
		  FromEntriesSequence.prototype.cacheResult =
		    cacheResultThrough;
	
	
		  function flipFactory(iterable) {
		    var flipSequence = makeSequence(iterable);
		    flipSequence._iter = iterable;
		    flipSequence.size = iterable.size;
		    flipSequence.flip = function()  {return iterable};
		    flipSequence.reverse = function () {
		      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
		      reversedSequence.flip = function()  {return iterable.reverse()};
		      return reversedSequence;
		    };
		    flipSequence.has = function(key ) {return iterable.includes(key)};
		    flipSequence.includes = function(key ) {return iterable.has(key)};
		    flipSequence.cacheResult = cacheResultThrough;
		    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
		    }
		    flipSequence.__iteratorUncached = function(type, reverse) {
		      if (type === ITERATE_ENTRIES) {
		        var iterator = iterable.__iterator(type, reverse);
		        return new Iterator(function()  {
		          var step = iterator.next();
		          if (!step.done) {
		            var k = step.value[0];
		            step.value[0] = step.value[1];
		            step.value[1] = k;
		          }
		          return step;
		        });
		      }
		      return iterable.__iterator(
		        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
		        reverse
		      );
		    }
		    return flipSequence;
		  }
	
	
		  function mapFactory(iterable, mapper, context) {
		    var mappedSequence = makeSequence(iterable);
		    mappedSequence.size = iterable.size;
		    mappedSequence.has = function(key ) {return iterable.has(key)};
		    mappedSequence.get = function(key, notSetValue)  {
		      var v = iterable.get(key, NOT_SET);
		      return v === NOT_SET ?
		        notSetValue :
		        mapper.call(context, v, key, iterable);
		    };
		    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      return iterable.__iterate(
		        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
		        reverse
		      );
		    }
		    mappedSequence.__iteratorUncached = function (type, reverse) {
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      return new Iterator(function()  {
		        var step = iterator.next();
		        if (step.done) {
		          return step;
		        }
		        var entry = step.value;
		        var key = entry[0];
		        return iteratorValue(
		          type,
		          key,
		          mapper.call(context, entry[1], key, iterable),
		          step
		        );
		      });
		    }
		    return mappedSequence;
		  }
	
	
		  function reverseFactory(iterable, useKeys) {
		    var reversedSequence = makeSequence(iterable);
		    reversedSequence._iter = iterable;
		    reversedSequence.size = iterable.size;
		    reversedSequence.reverse = function()  {return iterable};
		    if (iterable.flip) {
		      reversedSequence.flip = function () {
		        var flipSequence = flipFactory(iterable);
		        flipSequence.reverse = function()  {return iterable.flip()};
		        return flipSequence;
		      };
		    }
		    reversedSequence.get = function(key, notSetValue) 
		      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
		    reversedSequence.has = function(key )
		      {return iterable.has(useKeys ? key : -1 - key)};
		    reversedSequence.includes = function(value ) {return iterable.includes(value)};
		    reversedSequence.cacheResult = cacheResultThrough;
		    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
		      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
		    };
		    reversedSequence.__iterator =
		      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
		    return reversedSequence;
		  }
	
	
		  function filterFactory(iterable, predicate, context, useKeys) {
		    var filterSequence = makeSequence(iterable);
		    if (useKeys) {
		      filterSequence.has = function(key ) {
		        var v = iterable.get(key, NOT_SET);
		        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
		      };
		      filterSequence.get = function(key, notSetValue)  {
		        var v = iterable.get(key, NOT_SET);
		        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
		          v : notSetValue;
		      };
		    }
		    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      iterable.__iterate(function(v, k, c)  {
		        if (predicate.call(context, v, k, c)) {
		          iterations++;
		          return fn(v, useKeys ? k : iterations - 1, this$0);
		        }
		      }, reverse);
		      return iterations;
		    };
		    filterSequence.__iteratorUncached = function (type, reverse) {
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      var iterations = 0;
		      return new Iterator(function()  {
		        while (true) {
		          var step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		          var entry = step.value;
		          var key = entry[0];
		          var value = entry[1];
		          if (predicate.call(context, value, key, iterable)) {
		            return iteratorValue(type, useKeys ? key : iterations++, value, step);
		          }
		        }
		      });
		    }
		    return filterSequence;
		  }
	
	
		  function countByFactory(iterable, grouper, context) {
		    var groups = Map().asMutable();
		    iterable.__iterate(function(v, k)  {
		      groups.update(
		        grouper.call(context, v, k, iterable),
		        0,
		        function(a ) {return a + 1}
		      );
		    });
		    return groups.asImmutable();
		  }
	
	
		  function groupByFactory(iterable, grouper, context) {
		    var isKeyedIter = isKeyed(iterable);
		    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
		    iterable.__iterate(function(v, k)  {
		      groups.update(
		        grouper.call(context, v, k, iterable),
		        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
		      );
		    });
		    var coerce = iterableClass(iterable);
		    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
		  }
	
	
		  function sliceFactory(iterable, begin, end, useKeys) {
		    var originalSize = iterable.size;
	
		    // Sanitize begin & end using this shorthand for ToInt32(argument)
		    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
		    if (begin !== undefined) {
		      begin = begin | 0;
		    }
		    if (end !== undefined) {
		      if (end === Infinity) {
		        end = originalSize;
		      } else {
		        end = end | 0;
		      }
		    }
	
		    if (wholeSlice(begin, end, originalSize)) {
		      return iterable;
		    }
	
		    var resolvedBegin = resolveBegin(begin, originalSize);
		    var resolvedEnd = resolveEnd(end, originalSize);
	
		    // begin or end will be NaN if they were provided as negative numbers and
		    // this iterable's size is unknown. In that case, cache first so there is
		    // a known size and these do not resolve to NaN.
		    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
		      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
		    }
	
		    // Note: resolvedEnd is undefined when the original sequence's length is
		    // unknown and this slice did not supply an end and should contain all
		    // elements after resolvedBegin.
		    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
		    var resolvedSize = resolvedEnd - resolvedBegin;
		    var sliceSize;
		    if (resolvedSize === resolvedSize) {
		      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
		    }
	
		    var sliceSeq = makeSequence(iterable);
	
		    // If iterable.size is undefined, the size of the realized sliceSeq is
		    // unknown at this point unless the number of items to slice is 0
		    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
		    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
		      sliceSeq.get = function (index, notSetValue) {
		        index = wrapIndex(this, index);
		        return index >= 0 && index < sliceSize ?
		          iterable.get(index + resolvedBegin, notSetValue) :
		          notSetValue;
		      }
		    }
	
		    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
		      if (sliceSize === 0) {
		        return 0;
		      }
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var skipped = 0;
		      var isSkipping = true;
		      var iterations = 0;
		      iterable.__iterate(function(v, k)  {
		        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
		          iterations++;
		          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
		                 iterations !== sliceSize;
		        }
		      });
		      return iterations;
		    };
	
		    sliceSeq.__iteratorUncached = function(type, reverse) {
		      if (sliceSize !== 0 && reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      // Don't bother instantiating parent iterator if taking 0.
		      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
		      var skipped = 0;
		      var iterations = 0;
		      return new Iterator(function()  {
		        while (skipped++ < resolvedBegin) {
		          iterator.next();
		        }
		        if (++iterations > sliceSize) {
		          return iteratorDone();
		        }
		        var step = iterator.next();
		        if (useKeys || type === ITERATE_VALUES) {
		          return step;
		        } else if (type === ITERATE_KEYS) {
		          return iteratorValue(type, iterations - 1, undefined, step);
		        } else {
		          return iteratorValue(type, iterations - 1, step.value[1], step);
		        }
		      });
		    }
	
		    return sliceSeq;
		  }
	
	
		  function takeWhileFactory(iterable, predicate, context) {
		    var takeSequence = makeSequence(iterable);
		    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var iterations = 0;
		      iterable.__iterate(function(v, k, c) 
		        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
		      );
		      return iterations;
		    };
		    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      var iterating = true;
		      return new Iterator(function()  {
		        if (!iterating) {
		          return iteratorDone();
		        }
		        var step = iterator.next();
		        if (step.done) {
		          return step;
		        }
		        var entry = step.value;
		        var k = entry[0];
		        var v = entry[1];
		        if (!predicate.call(context, v, k, this$0)) {
		          iterating = false;
		          return iteratorDone();
		        }
		        return type === ITERATE_ENTRIES ? step :
		          iteratorValue(type, k, v, step);
		      });
		    };
		    return takeSequence;
		  }
	
	
		  function skipWhileFactory(iterable, predicate, context, useKeys) {
		    var skipSequence = makeSequence(iterable);
		    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var isSkipping = true;
		      var iterations = 0;
		      iterable.__iterate(function(v, k, c)  {
		        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
		          iterations++;
		          return fn(v, useKeys ? k : iterations - 1, this$0);
		        }
		      });
		      return iterations;
		    };
		    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      var skipping = true;
		      var iterations = 0;
		      return new Iterator(function()  {
		        var step, k, v;
		        do {
		          step = iterator.next();
		          if (step.done) {
		            if (useKeys || type === ITERATE_VALUES) {
		              return step;
		            } else if (type === ITERATE_KEYS) {
		              return iteratorValue(type, iterations++, undefined, step);
		            } else {
		              return iteratorValue(type, iterations++, step.value[1], step);
		            }
		          }
		          var entry = step.value;
		          k = entry[0];
		          v = entry[1];
		          skipping && (skipping = predicate.call(context, v, k, this$0));
		        } while (skipping);
		        return type === ITERATE_ENTRIES ? step :
		          iteratorValue(type, k, v, step);
		      });
		    };
		    return skipSequence;
		  }
	
	
		  function concatFactory(iterable, values) {
		    var isKeyedIterable = isKeyed(iterable);
		    var iters = [iterable].concat(values).map(function(v ) {
		      if (!isIterable(v)) {
		        v = isKeyedIterable ?
		          keyedSeqFromValue(v) :
		          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
		      } else if (isKeyedIterable) {
		        v = KeyedIterable(v);
		      }
		      return v;
		    }).filter(function(v ) {return v.size !== 0});
	
		    if (iters.length === 0) {
		      return iterable;
		    }
	
		    if (iters.length === 1) {
		      var singleton = iters[0];
		      if (singleton === iterable ||
		          isKeyedIterable && isKeyed(singleton) ||
		          isIndexed(iterable) && isIndexed(singleton)) {
		        return singleton;
		      }
		    }
	
		    var concatSeq = new ArraySeq(iters);
		    if (isKeyedIterable) {
		      concatSeq = concatSeq.toKeyedSeq();
		    } else if (!isIndexed(iterable)) {
		      concatSeq = concatSeq.toSetSeq();
		    }
		    concatSeq = concatSeq.flatten(true);
		    concatSeq.size = iters.reduce(
		      function(sum, seq)  {
		        if (sum !== undefined) {
		          var size = seq.size;
		          if (size !== undefined) {
		            return sum + size;
		          }
		        }
		      },
		      0
		    );
		    return concatSeq;
		  }
	
	
		  function flattenFactory(iterable, depth, useKeys) {
		    var flatSequence = makeSequence(iterable);
		    flatSequence.__iterateUncached = function(fn, reverse) {
		      var iterations = 0;
		      var stopped = false;
		      function flatDeep(iter, currentDepth) {var this$0 = this;
		        iter.__iterate(function(v, k)  {
		          if ((!depth || currentDepth < depth) && isIterable(v)) {
		            flatDeep(v, currentDepth + 1);
		          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
		            stopped = true;
		          }
		          return !stopped;
		        }, reverse);
		      }
		      flatDeep(iterable, 0);
		      return iterations;
		    }
		    flatSequence.__iteratorUncached = function(type, reverse) {
		      var iterator = iterable.__iterator(type, reverse);
		      var stack = [];
		      var iterations = 0;
		      return new Iterator(function()  {
		        while (iterator) {
		          var step = iterator.next();
		          if (step.done !== false) {
		            iterator = stack.pop();
		            continue;
		          }
		          var v = step.value;
		          if (type === ITERATE_ENTRIES) {
		            v = v[1];
		          }
		          if ((!depth || stack.length < depth) && isIterable(v)) {
		            stack.push(iterator);
		            iterator = v.__iterator(type, reverse);
		          } else {
		            return useKeys ? step : iteratorValue(type, iterations++, v, step);
		          }
		        }
		        return iteratorDone();
		      });
		    }
		    return flatSequence;
		  }
	
	
		  function flatMapFactory(iterable, mapper, context) {
		    var coerce = iterableClass(iterable);
		    return iterable.toSeq().map(
		      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
		    ).flatten(true);
		  }
	
	
		  function interposeFactory(iterable, separator) {
		    var interposedSequence = makeSequence(iterable);
		    interposedSequence.size = iterable.size && iterable.size * 2 -1;
		    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      iterable.__iterate(function(v, k) 
		        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
		        fn(v, iterations++, this$0) !== false},
		        reverse
		      );
		      return iterations;
		    };
		    interposedSequence.__iteratorUncached = function(type, reverse) {
		      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
		      var iterations = 0;
		      var step;
		      return new Iterator(function()  {
		        if (!step || iterations % 2) {
		          step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		        }
		        return iterations % 2 ?
		          iteratorValue(type, iterations++, separator) :
		          iteratorValue(type, iterations++, step.value, step);
		      });
		    };
		    return interposedSequence;
		  }
	
	
		  function sortFactory(iterable, comparator, mapper) {
		    if (!comparator) {
		      comparator = defaultComparator;
		    }
		    var isKeyedIterable = isKeyed(iterable);
		    var index = 0;
		    var entries = iterable.toSeq().map(
		      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
		    ).toArray();
		    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
		      isKeyedIterable ?
		      function(v, i)  { entries[i].length = 2; } :
		      function(v, i)  { entries[i] = v[1]; }
		    );
		    return isKeyedIterable ? KeyedSeq(entries) :
		      isIndexed(iterable) ? IndexedSeq(entries) :
		      SetSeq(entries);
		  }
	
	
		  function maxFactory(iterable, comparator, mapper) {
		    if (!comparator) {
		      comparator = defaultComparator;
		    }
		    if (mapper) {
		      var entry = iterable.toSeq()
		        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
		        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
		      return entry && entry[0];
		    } else {
		      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
		    }
		  }
	
		  function maxCompare(comparator, a, b) {
		    var comp = comparator(b, a);
		    // b is considered the new max if the comparator declares them equal, but
		    // they are not equal and b is in fact a nullish value.
		    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
		  }
	
	
		  function zipWithFactory(keyIter, zipper, iters) {
		    var zipSequence = makeSequence(keyIter);
		    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
		    // Note: this a generic base implementation of __iterate in terms of
		    // __iterator which may be more generically useful in the future.
		    zipSequence.__iterate = function(fn, reverse) {
		      /* generic:
		      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
		      var step;
		      var iterations = 0;
		      while (!(step = iterator.next()).done) {
		        iterations++;
		        if (fn(step.value[1], step.value[0], this) === false) {
		          break;
		        }
		      }
		      return iterations;
		      */
		      // indexed:
		      var iterator = this.__iterator(ITERATE_VALUES, reverse);
		      var step;
		      var iterations = 0;
		      while (!(step = iterator.next()).done) {
		        if (fn(step.value, iterations++, this) === false) {
		          break;
		        }
		      }
		      return iterations;
		    };
		    zipSequence.__iteratorUncached = function(type, reverse) {
		      var iterators = iters.map(function(i )
		        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
		      );
		      var iterations = 0;
		      var isDone = false;
		      return new Iterator(function()  {
		        var steps;
		        if (!isDone) {
		          steps = iterators.map(function(i ) {return i.next()});
		          isDone = steps.some(function(s ) {return s.done});
		        }
		        if (isDone) {
		          return iteratorDone();
		        }
		        return iteratorValue(
		          type,
		          iterations++,
		          zipper.apply(null, steps.map(function(s ) {return s.value}))
		        );
		      });
		    };
		    return zipSequence
		  }
	
	
		  // #pragma Helper Functions
	
		  function reify(iter, seq) {
		    return isSeq(iter) ? seq : iter.constructor(seq);
		  }
	
		  function validateEntry(entry) {
		    if (entry !== Object(entry)) {
		      throw new TypeError('Expected [K, V] tuple: ' + entry);
		    }
		  }
	
		  function resolveSize(iter) {
		    assertNotInfinite(iter.size);
		    return ensureSize(iter);
		  }
	
		  function iterableClass(iterable) {
		    return isKeyed(iterable) ? KeyedIterable :
		      isIndexed(iterable) ? IndexedIterable :
		      SetIterable;
		  }
	
		  function makeSequence(iterable) {
		    return Object.create(
		      (
		        isKeyed(iterable) ? KeyedSeq :
		        isIndexed(iterable) ? IndexedSeq :
		        SetSeq
		      ).prototype
		    );
		  }
	
		  function cacheResultThrough() {
		    if (this._iter.cacheResult) {
		      this._iter.cacheResult();
		      this.size = this._iter.size;
		      return this;
		    } else {
		      return Seq.prototype.cacheResult.call(this);
		    }
		  }
	
		  function defaultComparator(a, b) {
		    return a > b ? 1 : a < b ? -1 : 0;
		  }
	
		  function forceIterator(keyPath) {
		    var iter = getIterator(keyPath);
		    if (!iter) {
		      // Array might not be iterable in this environment, so we need a fallback
		      // to our wrapped type.
		      if (!isArrayLike(keyPath)) {
		        throw new TypeError('Expected iterable or array-like: ' + keyPath);
		      }
		      iter = getIterator(Iterable(keyPath));
		    }
		    return iter;
		  }
	
		  createClass(Record, KeyedCollection);
	
		    function Record(defaultValues, name) {
		      var hasInitialized;
	
		      var RecordType = function Record(values) {
		        if (values instanceof RecordType) {
		          return values;
		        }
		        if (!(this instanceof RecordType)) {
		          return new RecordType(values);
		        }
		        if (!hasInitialized) {
		          hasInitialized = true;
		          var keys = Object.keys(defaultValues);
		          setProps(RecordTypePrototype, keys);
		          RecordTypePrototype.size = keys.length;
		          RecordTypePrototype._name = name;
		          RecordTypePrototype._keys = keys;
		          RecordTypePrototype._defaultValues = defaultValues;
		        }
		        this._map = Map(values);
		      };
	
		      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
		      RecordTypePrototype.constructor = RecordType;
	
		      return RecordType;
		    }
	
		    Record.prototype.toString = function() {
		      return this.__toString(recordName(this) + ' {', '}');
		    };
	
		    // @pragma Access
	
		    Record.prototype.has = function(k) {
		      return this._defaultValues.hasOwnProperty(k);
		    };
	
		    Record.prototype.get = function(k, notSetValue) {
		      if (!this.has(k)) {
		        return notSetValue;
		      }
		      var defaultVal = this._defaultValues[k];
		      return this._map ? this._map.get(k, defaultVal) : defaultVal;
		    };
	
		    // @pragma Modification
	
		    Record.prototype.clear = function() {
		      if (this.__ownerID) {
		        this._map && this._map.clear();
		        return this;
		      }
		      var RecordType = this.constructor;
		      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
		    };
	
		    Record.prototype.set = function(k, v) {
		      if (!this.has(k)) {
		        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
		      }
		      if (this._map && !this._map.has(k)) {
		        var defaultVal = this._defaultValues[k];
		        if (v === defaultVal) {
		          return this;
		        }
		      }
		      var newMap = this._map && this._map.set(k, v);
		      if (this.__ownerID || newMap === this._map) {
		        return this;
		      }
		      return makeRecord(this, newMap);
		    };
	
		    Record.prototype.remove = function(k) {
		      if (!this.has(k)) {
		        return this;
		      }
		      var newMap = this._map && this._map.remove(k);
		      if (this.__ownerID || newMap === this._map) {
		        return this;
		      }
		      return makeRecord(this, newMap);
		    };
	
		    Record.prototype.wasAltered = function() {
		      return this._map.wasAltered();
		    };
	
		    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
		      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
		    };
	
		    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
		    };
	
		    Record.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      var newMap = this._map && this._map.__ensureOwner(ownerID);
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this._map = newMap;
		        return this;
		      }
		      return makeRecord(this, newMap, ownerID);
		    };
	
	
		  var RecordPrototype = Record.prototype;
		  RecordPrototype[DELETE] = RecordPrototype.remove;
		  RecordPrototype.deleteIn =
		  RecordPrototype.removeIn = MapPrototype.removeIn;
		  RecordPrototype.merge = MapPrototype.merge;
		  RecordPrototype.mergeWith = MapPrototype.mergeWith;
		  RecordPrototype.mergeIn = MapPrototype.mergeIn;
		  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
		  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
		  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
		  RecordPrototype.setIn = MapPrototype.setIn;
		  RecordPrototype.update = MapPrototype.update;
		  RecordPrototype.updateIn = MapPrototype.updateIn;
		  RecordPrototype.withMutations = MapPrototype.withMutations;
		  RecordPrototype.asMutable = MapPrototype.asMutable;
		  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
		  function makeRecord(likeRecord, map, ownerID) {
		    var record = Object.create(Object.getPrototypeOf(likeRecord));
		    record._map = map;
		    record.__ownerID = ownerID;
		    return record;
		  }
	
		  function recordName(record) {
		    return record._name || record.constructor.name || 'Record';
		  }
	
		  function setProps(prototype, names) {
		    try {
		      names.forEach(setProp.bind(undefined, prototype));
		    } catch (error) {
		      // Object.defineProperty failed. Probably IE8.
		    }
		  }
	
		  function setProp(prototype, name) {
		    Object.defineProperty(prototype, name, {
		      get: function() {
		        return this.get(name);
		      },
		      set: function(value) {
		        invariant(this.__ownerID, 'Cannot set on an immutable record.');
		        this.set(name, value);
		      }
		    });
		  }
	
		  createClass(Set, SetCollection);
	
		    // @pragma Construction
	
		    function Set(value) {
		      return value === null || value === undefined ? emptySet() :
		        isSet(value) && !isOrdered(value) ? value :
		        emptySet().withMutations(function(set ) {
		          var iter = SetIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v ) {return set.add(v)});
		        });
		    }
	
		    Set.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    Set.fromKeys = function(value) {
		      return this(KeyedIterable(value).keySeq());
		    };
	
		    Set.prototype.toString = function() {
		      return this.__toString('Set {', '}');
		    };
	
		    // @pragma Access
	
		    Set.prototype.has = function(value) {
		      return this._map.has(value);
		    };
	
		    // @pragma Modification
	
		    Set.prototype.add = function(value) {
		      return updateSet(this, this._map.set(value, true));
		    };
	
		    Set.prototype.remove = function(value) {
		      return updateSet(this, this._map.remove(value));
		    };
	
		    Set.prototype.clear = function() {
		      return updateSet(this, this._map.clear());
		    };
	
		    // @pragma Composition
	
		    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
		      iters = iters.filter(function(x ) {return x.size !== 0});
		      if (iters.length === 0) {
		        return this;
		      }
		      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
		        return this.constructor(iters[0]);
		      }
		      return this.withMutations(function(set ) {
		        for (var ii = 0; ii < iters.length; ii++) {
		          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
		        }
		      });
		    };
	
		    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
		      if (iters.length === 0) {
		        return this;
		      }
		      iters = iters.map(function(iter ) {return SetIterable(iter)});
		      var originalSet = this;
		      return this.withMutations(function(set ) {
		        originalSet.forEach(function(value ) {
		          if (!iters.every(function(iter ) {return iter.includes(value)})) {
		            set.remove(value);
		          }
		        });
		      });
		    };
	
		    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
		      if (iters.length === 0) {
		        return this;
		      }
		      iters = iters.map(function(iter ) {return SetIterable(iter)});
		      var originalSet = this;
		      return this.withMutations(function(set ) {
		        originalSet.forEach(function(value ) {
		          if (iters.some(function(iter ) {return iter.includes(value)})) {
		            set.remove(value);
		          }
		        });
		      });
		    };
	
		    Set.prototype.merge = function() {
		      return this.union.apply(this, arguments);
		    };
	
		    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return this.union.apply(this, iters);
		    };
	
		    Set.prototype.sort = function(comparator) {
		      // Late binding
		      return OrderedSet(sortFactory(this, comparator));
		    };
	
		    Set.prototype.sortBy = function(mapper, comparator) {
		      // Late binding
		      return OrderedSet(sortFactory(this, comparator, mapper));
		    };
	
		    Set.prototype.wasAltered = function() {
		      return this._map.wasAltered();
		    };
	
		    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
		    };
	
		    Set.prototype.__iterator = function(type, reverse) {
		      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
		    };
	
		    Set.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      var newMap = this._map.__ensureOwner(ownerID);
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this._map = newMap;
		        return this;
		      }
		      return this.__make(newMap, ownerID);
		    };
	
	
		  function isSet(maybeSet) {
		    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
		  }
	
		  Set.isSet = isSet;
	
		  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
		  var SetPrototype = Set.prototype;
		  SetPrototype[IS_SET_SENTINEL] = true;
		  SetPrototype[DELETE] = SetPrototype.remove;
		  SetPrototype.mergeDeep = SetPrototype.merge;
		  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
		  SetPrototype.withMutations = MapPrototype.withMutations;
		  SetPrototype.asMutable = MapPrototype.asMutable;
		  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
		  SetPrototype.__empty = emptySet;
		  SetPrototype.__make = makeSet;
	
		  function updateSet(set, newMap) {
		    if (set.__ownerID) {
		      set.size = newMap.size;
		      set._map = newMap;
		      return set;
		    }
		    return newMap === set._map ? set :
		      newMap.size === 0 ? set.__empty() :
		      set.__make(newMap);
		  }
	
		  function makeSet(map, ownerID) {
		    var set = Object.create(SetPrototype);
		    set.size = map ? map.size : 0;
		    set._map = map;
		    set.__ownerID = ownerID;
		    return set;
		  }
	
		  var EMPTY_SET;
		  function emptySet() {
		    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
		  }
	
		  createClass(OrderedSet, Set);
	
		    // @pragma Construction
	
		    function OrderedSet(value) {
		      return value === null || value === undefined ? emptyOrderedSet() :
		        isOrderedSet(value) ? value :
		        emptyOrderedSet().withMutations(function(set ) {
		          var iter = SetIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v ) {return set.add(v)});
		        });
		    }
	
		    OrderedSet.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    OrderedSet.fromKeys = function(value) {
		      return this(KeyedIterable(value).keySeq());
		    };
	
		    OrderedSet.prototype.toString = function() {
		      return this.__toString('OrderedSet {', '}');
		    };
	
	
		  function isOrderedSet(maybeOrderedSet) {
		    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
		  }
	
		  OrderedSet.isOrderedSet = isOrderedSet;
	
		  var OrderedSetPrototype = OrderedSet.prototype;
		  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
		  OrderedSetPrototype.__empty = emptyOrderedSet;
		  OrderedSetPrototype.__make = makeOrderedSet;
	
		  function makeOrderedSet(map, ownerID) {
		    var set = Object.create(OrderedSetPrototype);
		    set.size = map ? map.size : 0;
		    set._map = map;
		    set.__ownerID = ownerID;
		    return set;
		  }
	
		  var EMPTY_ORDERED_SET;
		  function emptyOrderedSet() {
		    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
		  }
	
		  createClass(Stack, IndexedCollection);
	
		    // @pragma Construction
	
		    function Stack(value) {
		      return value === null || value === undefined ? emptyStack() :
		        isStack(value) ? value :
		        emptyStack().unshiftAll(value);
		    }
	
		    Stack.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    Stack.prototype.toString = function() {
		      return this.__toString('Stack [', ']');
		    };
	
		    // @pragma Access
	
		    Stack.prototype.get = function(index, notSetValue) {
		      var head = this._head;
		      index = wrapIndex(this, index);
		      while (head && index--) {
		        head = head.next;
		      }
		      return head ? head.value : notSetValue;
		    };
	
		    Stack.prototype.peek = function() {
		      return this._head && this._head.value;
		    };
	
		    // @pragma Modification
	
		    Stack.prototype.push = function(/*...values*/) {
		      if (arguments.length === 0) {
		        return this;
		      }
		      var newSize = this.size + arguments.length;
		      var head = this._head;
		      for (var ii = arguments.length - 1; ii >= 0; ii--) {
		        head = {
		          value: arguments[ii],
		          next: head
		        };
		      }
		      if (this.__ownerID) {
		        this.size = newSize;
		        this._head = head;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return makeStack(newSize, head);
		    };
	
		    Stack.prototype.pushAll = function(iter) {
		      iter = IndexedIterable(iter);
		      if (iter.size === 0) {
		        return this;
		      }
		      assertNotInfinite(iter.size);
		      var newSize = this.size;
		      var head = this._head;
		      iter.reverse().forEach(function(value ) {
		        newSize++;
		        head = {
		          value: value,
		          next: head
		        };
		      });
		      if (this.__ownerID) {
		        this.size = newSize;
		        this._head = head;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return makeStack(newSize, head);
		    };
	
		    Stack.prototype.pop = function() {
		      return this.slice(1);
		    };
	
		    Stack.prototype.unshift = function(/*...values*/) {
		      return this.push.apply(this, arguments);
		    };
	
		    Stack.prototype.unshiftAll = function(iter) {
		      return this.pushAll(iter);
		    };
	
		    Stack.prototype.shift = function() {
		      return this.pop.apply(this, arguments);
		    };
	
		    Stack.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = 0;
		        this._head = undefined;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return emptyStack();
		    };
	
		    Stack.prototype.slice = function(begin, end) {
		      if (wholeSlice(begin, end, this.size)) {
		        return this;
		      }
		      var resolvedBegin = resolveBegin(begin, this.size);
		      var resolvedEnd = resolveEnd(end, this.size);
		      if (resolvedEnd !== this.size) {
		        // super.slice(begin, end);
		        return IndexedCollection.prototype.slice.call(this, begin, end);
		      }
		      var newSize = this.size - resolvedBegin;
		      var head = this._head;
		      while (resolvedBegin--) {
		        head = head.next;
		      }
		      if (this.__ownerID) {
		        this.size = newSize;
		        this._head = head;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return makeStack(newSize, head);
		    };
	
		    // @pragma Mutability
	
		    Stack.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this.__altered = false;
		        return this;
		      }
		      return makeStack(this.size, this._head, ownerID, this.__hash);
		    };
	
		    // @pragma Iteration
	
		    Stack.prototype.__iterate = function(fn, reverse) {
		      if (reverse) {
		        return this.reverse().__iterate(fn);
		      }
		      var iterations = 0;
		      var node = this._head;
		      while (node) {
		        if (fn(node.value, iterations++, this) === false) {
		          break;
		        }
		        node = node.next;
		      }
		      return iterations;
		    };
	
		    Stack.prototype.__iterator = function(type, reverse) {
		      if (reverse) {
		        return this.reverse().__iterator(type);
		      }
		      var iterations = 0;
		      var node = this._head;
		      return new Iterator(function()  {
		        if (node) {
		          var value = node.value;
		          node = node.next;
		          return iteratorValue(type, iterations++, value);
		        }
		        return iteratorDone();
		      });
		    };
	
	
		  function isStack(maybeStack) {
		    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
		  }
	
		  Stack.isStack = isStack;
	
		  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
		  var StackPrototype = Stack.prototype;
		  StackPrototype[IS_STACK_SENTINEL] = true;
		  StackPrototype.withMutations = MapPrototype.withMutations;
		  StackPrototype.asMutable = MapPrototype.asMutable;
		  StackPrototype.asImmutable = MapPrototype.asImmutable;
		  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
		  function makeStack(size, head, ownerID, hash) {
		    var map = Object.create(StackPrototype);
		    map.size = size;
		    map._head = head;
		    map.__ownerID = ownerID;
		    map.__hash = hash;
		    map.__altered = false;
		    return map;
		  }
	
		  var EMPTY_STACK;
		  function emptyStack() {
		    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
		  }
	
		  /**
		   * Contributes additional methods to a constructor
		   */
		  function mixin(ctor, methods) {
		    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
		    Object.keys(methods).forEach(keyCopier);
		    Object.getOwnPropertySymbols &&
		      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
		    return ctor;
		  }
	
		  Iterable.Iterator = Iterator;
	
		  mixin(Iterable, {
	
		    // ### Conversion to other types
	
		    toArray: function() {
		      assertNotInfinite(this.size);
		      var array = new Array(this.size || 0);
		      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
		      return array;
		    },
	
		    toIndexedSeq: function() {
		      return new ToIndexedSequence(this);
		    },
	
		    toJS: function() {
		      return this.toSeq().map(
		        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
		      ).__toJS();
		    },
	
		    toJSON: function() {
		      return this.toSeq().map(
		        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
		      ).__toJS();
		    },
	
		    toKeyedSeq: function() {
		      return new ToKeyedSequence(this, true);
		    },
	
		    toMap: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return Map(this.toKeyedSeq());
		    },
	
		    toObject: function() {
		      assertNotInfinite(this.size);
		      var object = {};
		      this.__iterate(function(v, k)  { object[k] = v; });
		      return object;
		    },
	
		    toOrderedMap: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return OrderedMap(this.toKeyedSeq());
		    },
	
		    toOrderedSet: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
		    },
	
		    toSet: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return Set(isKeyed(this) ? this.valueSeq() : this);
		    },
	
		    toSetSeq: function() {
		      return new ToSetSequence(this);
		    },
	
		    toSeq: function() {
		      return isIndexed(this) ? this.toIndexedSeq() :
		        isKeyed(this) ? this.toKeyedSeq() :
		        this.toSetSeq();
		    },
	
		    toStack: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return Stack(isKeyed(this) ? this.valueSeq() : this);
		    },
	
		    toList: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return List(isKeyed(this) ? this.valueSeq() : this);
		    },
	
	
		    // ### Common JavaScript methods and properties
	
		    toString: function() {
		      return '[Iterable]';
		    },
	
		    __toString: function(head, tail) {
		      if (this.size === 0) {
		        return head + tail;
		      }
		      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
		    },
	
	
		    // ### ES6 Collection methods (ES6 Array and Map)
	
		    concat: function() {var values = SLICE$0.call(arguments, 0);
		      return reify(this, concatFactory(this, values));
		    },
	
		    includes: function(searchValue) {
		      return this.some(function(value ) {return is(value, searchValue)});
		    },
	
		    entries: function() {
		      return this.__iterator(ITERATE_ENTRIES);
		    },
	
		    every: function(predicate, context) {
		      assertNotInfinite(this.size);
		      var returnValue = true;
		      this.__iterate(function(v, k, c)  {
		        if (!predicate.call(context, v, k, c)) {
		          returnValue = false;
		          return false;
		        }
		      });
		      return returnValue;
		    },
	
		    filter: function(predicate, context) {
		      return reify(this, filterFactory(this, predicate, context, true));
		    },
	
		    find: function(predicate, context, notSetValue) {
		      var entry = this.findEntry(predicate, context);
		      return entry ? entry[1] : notSetValue;
		    },
	
		    forEach: function(sideEffect, context) {
		      assertNotInfinite(this.size);
		      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
		    },
	
		    join: function(separator) {
		      assertNotInfinite(this.size);
		      separator = separator !== undefined ? '' + separator : ',';
		      var joined = '';
		      var isFirst = true;
		      this.__iterate(function(v ) {
		        isFirst ? (isFirst = false) : (joined += separator);
		        joined += v !== null && v !== undefined ? v.toString() : '';
		      });
		      return joined;
		    },
	
		    keys: function() {
		      return this.__iterator(ITERATE_KEYS);
		    },
	
		    map: function(mapper, context) {
		      return reify(this, mapFactory(this, mapper, context));
		    },
	
		    reduce: function(reducer, initialReduction, context) {
		      assertNotInfinite(this.size);
		      var reduction;
		      var useFirst;
		      if (arguments.length < 2) {
		        useFirst = true;
		      } else {
		        reduction = initialReduction;
		      }
		      this.__iterate(function(v, k, c)  {
		        if (useFirst) {
		          useFirst = false;
		          reduction = v;
		        } else {
		          reduction = reducer.call(context, reduction, v, k, c);
		        }
		      });
		      return reduction;
		    },
	
		    reduceRight: function(reducer, initialReduction, context) {
		      var reversed = this.toKeyedSeq().reverse();
		      return reversed.reduce.apply(reversed, arguments);
		    },
	
		    reverse: function() {
		      return reify(this, reverseFactory(this, true));
		    },
	
		    slice: function(begin, end) {
		      return reify(this, sliceFactory(this, begin, end, true));
		    },
	
		    some: function(predicate, context) {
		      return !this.every(not(predicate), context);
		    },
	
		    sort: function(comparator) {
		      return reify(this, sortFactory(this, comparator));
		    },
	
		    values: function() {
		      return this.__iterator(ITERATE_VALUES);
		    },
	
	
		    // ### More sequential methods
	
		    butLast: function() {
		      return this.slice(0, -1);
		    },
	
		    isEmpty: function() {
		      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
		    },
	
		    count: function(predicate, context) {
		      return ensureSize(
		        predicate ? this.toSeq().filter(predicate, context) : this
		      );
		    },
	
		    countBy: function(grouper, context) {
		      return countByFactory(this, grouper, context);
		    },
	
		    equals: function(other) {
		      return deepEqual(this, other);
		    },
	
		    entrySeq: function() {
		      var iterable = this;
		      if (iterable._cache) {
		        // We cache as an entries array, so we can just return the cache!
		        return new ArraySeq(iterable._cache);
		      }
		      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
		      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
		      return entriesSequence;
		    },
	
		    filterNot: function(predicate, context) {
		      return this.filter(not(predicate), context);
		    },
	
		    findEntry: function(predicate, context, notSetValue) {
		      var found = notSetValue;
		      this.__iterate(function(v, k, c)  {
		        if (predicate.call(context, v, k, c)) {
		          found = [k, v];
		          return false;
		        }
		      });
		      return found;
		    },
	
		    findKey: function(predicate, context) {
		      var entry = this.findEntry(predicate, context);
		      return entry && entry[0];
		    },
	
		    findLast: function(predicate, context, notSetValue) {
		      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
		    },
	
		    findLastEntry: function(predicate, context, notSetValue) {
		      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
		    },
	
		    findLastKey: function(predicate, context) {
		      return this.toKeyedSeq().reverse().findKey(predicate, context);
		    },
	
		    first: function() {
		      return this.find(returnTrue);
		    },
	
		    flatMap: function(mapper, context) {
		      return reify(this, flatMapFactory(this, mapper, context));
		    },
	
		    flatten: function(depth) {
		      return reify(this, flattenFactory(this, depth, true));
		    },
	
		    fromEntrySeq: function() {
		      return new FromEntriesSequence(this);
		    },
	
		    get: function(searchKey, notSetValue) {
		      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
		    },
	
		    getIn: function(searchKeyPath, notSetValue) {
		      var nested = this;
		      // Note: in an ES6 environment, we would prefer:
		      // for (var key of searchKeyPath) {
		      var iter = forceIterator(searchKeyPath);
		      var step;
		      while (!(step = iter.next()).done) {
		        var key = step.value;
		        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
		        if (nested === NOT_SET) {
		          return notSetValue;
		        }
		      }
		      return nested;
		    },
	
		    groupBy: function(grouper, context) {
		      return groupByFactory(this, grouper, context);
		    },
	
		    has: function(searchKey) {
		      return this.get(searchKey, NOT_SET) !== NOT_SET;
		    },
	
		    hasIn: function(searchKeyPath) {
		      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
		    },
	
		    isSubset: function(iter) {
		      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
		      return this.every(function(value ) {return iter.includes(value)});
		    },
	
		    isSuperset: function(iter) {
		      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
		      return iter.isSubset(this);
		    },
	
		    keyOf: function(searchValue) {
		      return this.findKey(function(value ) {return is(value, searchValue)});
		    },
	
		    keySeq: function() {
		      return this.toSeq().map(keyMapper).toIndexedSeq();
		    },
	
		    last: function() {
		      return this.toSeq().reverse().first();
		    },
	
		    lastKeyOf: function(searchValue) {
		      return this.toKeyedSeq().reverse().keyOf(searchValue);
		    },
	
		    max: function(comparator) {
		      return maxFactory(this, comparator);
		    },
	
		    maxBy: function(mapper, comparator) {
		      return maxFactory(this, comparator, mapper);
		    },
	
		    min: function(comparator) {
		      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
		    },
	
		    minBy: function(mapper, comparator) {
		      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
		    },
	
		    rest: function() {
		      return this.slice(1);
		    },
	
		    skip: function(amount) {
		      return this.slice(Math.max(0, amount));
		    },
	
		    skipLast: function(amount) {
		      return reify(this, this.toSeq().reverse().skip(amount).reverse());
		    },
	
		    skipWhile: function(predicate, context) {
		      return reify(this, skipWhileFactory(this, predicate, context, true));
		    },
	
		    skipUntil: function(predicate, context) {
		      return this.skipWhile(not(predicate), context);
		    },
	
		    sortBy: function(mapper, comparator) {
		      return reify(this, sortFactory(this, comparator, mapper));
		    },
	
		    take: function(amount) {
		      return this.slice(0, Math.max(0, amount));
		    },
	
		    takeLast: function(amount) {
		      return reify(this, this.toSeq().reverse().take(amount).reverse());
		    },
	
		    takeWhile: function(predicate, context) {
		      return reify(this, takeWhileFactory(this, predicate, context));
		    },
	
		    takeUntil: function(predicate, context) {
		      return this.takeWhile(not(predicate), context);
		    },
	
		    valueSeq: function() {
		      return this.toIndexedSeq();
		    },
	
	
		    // ### Hashable Object
	
		    hashCode: function() {
		      return this.__hash || (this.__hash = hashIterable(this));
		    }
	
	
		    // ### Internal
	
		    // abstract __iterate(fn, reverse)
	
		    // abstract __iterator(type, reverse)
		  });
	
		  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
		  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
		  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
		  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
		  var IterablePrototype = Iterable.prototype;
		  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
		  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
		  IterablePrototype.__toJS = IterablePrototype.toArray;
		  IterablePrototype.__toStringMapper = quoteString;
		  IterablePrototype.inspect =
		  IterablePrototype.toSource = function() { return this.toString(); };
		  IterablePrototype.chain = IterablePrototype.flatMap;
		  IterablePrototype.contains = IterablePrototype.includes;
	
		  mixin(KeyedIterable, {
	
		    // ### More sequential methods
	
		    flip: function() {
		      return reify(this, flipFactory(this));
		    },
	
		    mapEntries: function(mapper, context) {var this$0 = this;
		      var iterations = 0;
		      return reify(this,
		        this.toSeq().map(
		          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
		        ).fromEntrySeq()
		      );
		    },
	
		    mapKeys: function(mapper, context) {var this$0 = this;
		      return reify(this,
		        this.toSeq().flip().map(
		          function(k, v)  {return mapper.call(context, k, v, this$0)}
		        ).flip()
		      );
		    }
	
		  });
	
		  var KeyedIterablePrototype = KeyedIterable.prototype;
		  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
		  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
		  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
		  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
		  mixin(IndexedIterable, {
	
		    // ### Conversion to other types
	
		    toKeyedSeq: function() {
		      return new ToKeyedSequence(this, false);
		    },
	
	
		    // ### ES6 Collection methods (ES6 Array and Map)
	
		    filter: function(predicate, context) {
		      return reify(this, filterFactory(this, predicate, context, false));
		    },
	
		    findIndex: function(predicate, context) {
		      var entry = this.findEntry(predicate, context);
		      return entry ? entry[0] : -1;
		    },
	
		    indexOf: function(searchValue) {
		      var key = this.keyOf(searchValue);
		      return key === undefined ? -1 : key;
		    },
	
		    lastIndexOf: function(searchValue) {
		      var key = this.lastKeyOf(searchValue);
		      return key === undefined ? -1 : key;
		    },
	
		    reverse: function() {
		      return reify(this, reverseFactory(this, false));
		    },
	
		    slice: function(begin, end) {
		      return reify(this, sliceFactory(this, begin, end, false));
		    },
	
		    splice: function(index, removeNum /*, ...values*/) {
		      var numArgs = arguments.length;
		      removeNum = Math.max(removeNum | 0, 0);
		      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
		        return this;
		      }
		      // If index is negative, it should resolve relative to the size of the
		      // collection. However size may be expensive to compute if not cached, so
		      // only call count() if the number is in fact negative.
		      index = resolveBegin(index, index < 0 ? this.count() : this.size);
		      var spliced = this.slice(0, index);
		      return reify(
		        this,
		        numArgs === 1 ?
		          spliced :
		          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
		      );
		    },
	
	
		    // ### More collection methods
	
		    findLastIndex: function(predicate, context) {
		      var entry = this.findLastEntry(predicate, context);
		      return entry ? entry[0] : -1;
		    },
	
		    first: function() {
		      return this.get(0);
		    },
	
		    flatten: function(depth) {
		      return reify(this, flattenFactory(this, depth, false));
		    },
	
		    get: function(index, notSetValue) {
		      index = wrapIndex(this, index);
		      return (index < 0 || (this.size === Infinity ||
		          (this.size !== undefined && index > this.size))) ?
		        notSetValue :
		        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
		    },
	
		    has: function(index) {
		      index = wrapIndex(this, index);
		      return index >= 0 && (this.size !== undefined ?
		        this.size === Infinity || index < this.size :
		        this.indexOf(index) !== -1
		      );
		    },
	
		    interpose: function(separator) {
		      return reify(this, interposeFactory(this, separator));
		    },
	
		    interleave: function(/*...iterables*/) {
		      var iterables = [this].concat(arrCopy(arguments));
		      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
		      var interleaved = zipped.flatten(true);
		      if (zipped.size) {
		        interleaved.size = zipped.size * iterables.length;
		      }
		      return reify(this, interleaved);
		    },
	
		    keySeq: function() {
		      return Range(0, this.size);
		    },
	
		    last: function() {
		      return this.get(-1);
		    },
	
		    skipWhile: function(predicate, context) {
		      return reify(this, skipWhileFactory(this, predicate, context, false));
		    },
	
		    zip: function(/*, ...iterables */) {
		      var iterables = [this].concat(arrCopy(arguments));
		      return reify(this, zipWithFactory(this, defaultZipper, iterables));
		    },
	
		    zipWith: function(zipper/*, ...iterables */) {
		      var iterables = arrCopy(arguments);
		      iterables[0] = this;
		      return reify(this, zipWithFactory(this, zipper, iterables));
		    }
	
		  });
	
		  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
		  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
		  mixin(SetIterable, {
	
		    // ### ES6 Collection methods (ES6 Array and Map)
	
		    get: function(value, notSetValue) {
		      return this.has(value) ? value : notSetValue;
		    },
	
		    includes: function(value) {
		      return this.has(value);
		    },
	
	
		    // ### More sequential methods
	
		    keySeq: function() {
		      return this.valueSeq();
		    }
	
		  });
	
		  SetIterable.prototype.has = IterablePrototype.includes;
		  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
		  // Mixin subclasses
	
		  mixin(KeyedSeq, KeyedIterable.prototype);
		  mixin(IndexedSeq, IndexedIterable.prototype);
		  mixin(SetSeq, SetIterable.prototype);
	
		  mixin(KeyedCollection, KeyedIterable.prototype);
		  mixin(IndexedCollection, IndexedIterable.prototype);
		  mixin(SetCollection, SetIterable.prototype);
	
	
		  // #pragma Helper functions
	
		  function keyMapper(v, k) {
		    return k;
		  }
	
		  function entryMapper(v, k) {
		    return [k, v];
		  }
	
		  function not(predicate) {
		    return function() {
		      return !predicate.apply(this, arguments);
		    }
		  }
	
		  function neg(predicate) {
		    return function() {
		      return -predicate.apply(this, arguments);
		    }
		  }
	
		  function quoteString(value) {
		    return typeof value === 'string' ? JSON.stringify(value) : String(value);
		  }
	
		  function defaultZipper() {
		    return arrCopy(arguments);
		  }
	
		  function defaultNegComparator(a, b) {
		    return a < b ? 1 : a > b ? -1 : 0;
		  }
	
		  function hashIterable(iterable) {
		    if (iterable.size === Infinity) {
		      return 0;
		    }
		    var ordered = isOrdered(iterable);
		    var keyed = isKeyed(iterable);
		    var h = ordered ? 1 : 0;
		    var size = iterable.__iterate(
		      keyed ?
		        ordered ?
		          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
		          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
		        ordered ?
		          function(v ) { h = 31 * h + hash(v) | 0; } :
		          function(v ) { h = h + hash(v) | 0; }
		    );
		    return murmurHashOfSize(size, h);
		  }
	
		  function murmurHashOfSize(size, h) {
		    h = imul(h, 0xCC9E2D51);
		    h = imul(h << 15 | h >>> -15, 0x1B873593);
		    h = imul(h << 13 | h >>> -13, 5);
		    h = (h + 0xE6546B64 | 0) ^ size;
		    h = imul(h ^ h >>> 16, 0x85EBCA6B);
		    h = imul(h ^ h >>> 13, 0xC2B2AE35);
		    h = smi(h ^ h >>> 16);
		    return h;
		  }
	
		  function hashMerge(a, b) {
		    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
		  }
	
		  var Immutable = {
	
		    Iterable: Iterable,
	
		    Seq: Seq,
		    Collection: Collection,
		    Map: Map,
		    OrderedMap: OrderedMap,
		    List: List,
		    Stack: Stack,
		    Set: Set,
		    OrderedSet: OrderedSet,
	
		    Record: Record,
		    Range: Range,
		    Repeat: Repeat,
	
		    is: is,
		    fromJS: fromJS
	
		  };
	
		  return Immutable;
	
		}));
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(196);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-header.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-header.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ }),
	/* 20 */,
	/* 21 */,
	/* 22 */,
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var shallowCloneObject = __webpack_require__(36);
	
		var contextTypes = {
		  metricsComputator: React.PropTypes.object
		};
	
		var MetricsComputatorMixin = {
	
		  childContextTypes: contextTypes,
	
		  getChildContext: function getChildContext() {
		    return { metricsComputator: this };
		  },
		  getMetricImpl: function getMetricImpl(name) {
		    return this._DOMMetrics.metrics[name].value;
		  },
		  registerMetricsImpl: function registerMetricsImpl(component, metrics) {
		    var getters = {};
		    var s = this._DOMMetrics;
	
		    for (var name in metrics) {
		      if (s.metrics[name] !== undefined) {
		        throw new Error('DOM metric ' + name + ' is already defined');
		      }
		      s.metrics[name] = { component: component, computator: metrics[name].bind(component) };
		      getters[name] = this.getMetricImpl.bind(null, name);
		    }
	
		    if (s.components.indexOf(component) === -1) {
		      s.components.push(component);
		    }
	
		    return getters;
		  },
		  unregisterMetricsFor: function unregisterMetricsFor(component) {
		    var s = this._DOMMetrics;
		    var idx = s.components.indexOf(component);
	
		    if (idx > -1) {
		      s.components.splice(idx, 1);
	
		      var name = void 0;
		      var metricsToDelete = {};
	
		      for (name in s.metrics) {
		        if (s.metrics[name].component === component) {
		          metricsToDelete[name] = true;
		        }
		      }
	
		      for (name in metricsToDelete) {
		        if (metricsToDelete.hasOwnProperty(name)) {
		          delete s.metrics[name];
		        }
		      }
		    }
		  },
		  updateMetrics: function updateMetrics() {
		    var s = this._DOMMetrics;
	
		    var needUpdate = false;
	
		    for (var name in s.metrics) {
		      if (!s.metrics.hasOwnProperty(name)) continue;
	
		      var newMetric = s.metrics[name].computator();
		      if (newMetric !== s.metrics[name].value) {
		        needUpdate = true;
		      }
		      s.metrics[name].value = newMetric;
		    }
	
		    if (needUpdate) {
		      for (var i = 0, len = s.components.length; i < len; i++) {
		        if (s.components[i].metricsUpdated) {
		          s.components[i].metricsUpdated();
		        }
		      }
		    }
		  },
		  componentWillMount: function componentWillMount() {
		    this._DOMMetrics = {
		      metrics: {},
		      components: []
		    };
		  },
		  componentDidMount: function componentDidMount() {
		    if (window.addEventListener) {
		      window.addEventListener('resize', this.updateMetrics);
		    } else {
		      window.attachEvent('resize', this.updateMetrics);
		    }
		    this.updateMetrics();
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    window.removeEventListener('resize', this.updateMetrics);
		  }
		};
	
		var MetricsMixin = {
	
		  contextTypes: contextTypes,
	
		  componentWillMount: function componentWillMount() {
		    if (this.DOMMetrics) {
		      this._DOMMetricsDefs = shallowCloneObject(this.DOMMetrics);
	
		      this.DOMMetrics = {};
		      for (var name in this._DOMMetricsDefs) {
		        if (!this._DOMMetricsDefs.hasOwnProperty(name)) continue;
	
		        this.DOMMetrics[name] = function () {};
		      }
		    }
		  },
		  componentDidMount: function componentDidMount() {
		    if (this.DOMMetrics) {
		      this.DOMMetrics = this.registerMetrics(this._DOMMetricsDefs);
		    }
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    if (!this.registerMetricsImpl) {
		      return this.context.metricsComputator.unregisterMetricsFor(this);
		    }
		    if (this.hasOwnProperty('DOMMetrics')) {
		      delete this.DOMMetrics;
		    }
		  },
		  registerMetrics: function registerMetrics(metrics) {
		    if (this.registerMetricsImpl) {
		      return this.registerMetricsImpl(this, metrics);
		    }
	
		    return this.context.metricsComputator.registerMetricsImpl(this, metrics);
		  },
		  getMetric: function getMetric(name) {
		    if (this.getMetricImpl) {
		      return this.getMetricImpl(name);
		    }
	
		    return this.context.metricsComputator.getMetricImpl(name);
		  }
		};
	
		module.exports = {
		  MetricsComputatorMixin: MetricsComputatorMixin,
		  MetricsMixin: MetricsMixin
		};
	
	/***/ }),
	/* 24 */,
	/* 25 */,
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(195);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-core.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-core.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(197);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-row.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-row.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ }),
	/* 28 */,
	/* 29 */,
	/* 30 */,
	/* 31 */,
	/* 32 */,
	/* 33 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var shallowCloneObject = __webpack_require__(36);
		var sameColumn = __webpack_require__(162);
		var ColumnUtils = __webpack_require__(10);
		var getScrollbarSize = __webpack_require__(35);
		var isColumnsImmutable = __webpack_require__(69);
	
		function setColumnWidths(columns, totalWidth) {
		  return columns.map(function (column) {
		    var colInfo = Object.assign({}, column);
		    if (column.width) {
		      if (/^([0-9]+)%$/.exec(column.width.toString())) {
		        colInfo.width = Math.floor(column.width / 100 * totalWidth);
		      }
		    }
		    return colInfo;
		  });
		}
	
		function setDefferedColumnWidths(columns, unallocatedWidth, minColumnWidth) {
		  var defferedColumns = columns.filter(function (c) {
		    return !c.width;
		  });
		  return columns.map(function (column) {
		    if (!column.width) {
		      if (unallocatedWidth <= 0) {
		        column.width = minColumnWidth;
		      } else {
		        column.width = Math.floor(unallocatedWidth / ColumnUtils.getSize(defferedColumns));
		      }
		    }
		    return column;
		  });
		}
	
		function setColumnOffsets(columns) {
		  var left = 0;
		  return columns.map(function (column) {
		    column.left = left;
		    left += column.width;
		    return column;
		  });
		}
	
		/**
		 * Update column metrics calculation.
		 *
		 * @param {ColumnMetricsType} metrics
		 */
		function recalculate(metrics) {
		  // compute width for columns which specify width
		  var columns = setColumnWidths(metrics.columns, metrics.totalWidth);
	
		  var unallocatedWidth = columns.filter(function (c) {
		    return c.width;
		  }).reduce(function (w, column) {
		    return w - column.width;
		  }, metrics.totalWidth);
		  unallocatedWidth -= getScrollbarSize();
	
		  var width = columns.filter(function (c) {
		    return c.width;
		  }).reduce(function (w, column) {
		    return w + column.width;
		  }, 0);
	
		  // compute width for columns which doesn't specify width
		  columns = setDefferedColumnWidths(columns, unallocatedWidth, metrics.minColumnWidth);
	
		  // compute left offset
		  columns = setColumnOffsets(columns);
	
		  return {
		    columns: columns,
		    width: width,
		    totalWidth: metrics.totalWidth,
		    minColumnWidth: metrics.minColumnWidth
		  };
		}
	
		/**
		 * Update column metrics calculation by resizing a column.
		 *
		 * @param {ColumnMetricsType} metrics
		 * @param {Column} column
		 * @param {number} width
		 */
		function resizeColumn(metrics, index, width) {
		  var column = ColumnUtils.getColumn(metrics.columns, index);
		  var metricsClone = shallowCloneObject(metrics);
		  metricsClone.columns = metrics.columns.slice(0);
	
		  var updatedColumn = shallowCloneObject(column);
		  updatedColumn.width = Math.max(width, metricsClone.minColumnWidth);
	
		  metricsClone = ColumnUtils.spliceColumn(metricsClone, index, updatedColumn);
	
		  return recalculate(metricsClone);
		}
	
		function areColumnsImmutable(prevColumns, nextColumns) {
		  return isColumnsImmutable(prevColumns) && isColumnsImmutable(nextColumns);
		}
	
		function compareEachColumn(prevColumns, nextColumns, isSameColumn) {
		  var i = void 0;
		  var len = void 0;
		  var column = void 0;
		  var prevColumnsByKey = {};
		  var nextColumnsByKey = {};
	
		  if (ColumnUtils.getSize(prevColumns) !== ColumnUtils.getSize(nextColumns)) {
		    return false;
		  }
	
		  for (i = 0, len = ColumnUtils.getSize(prevColumns); i < len; i++) {
		    column = prevColumns[i];
		    prevColumnsByKey[column.key] = column;
		  }
	
		  for (i = 0, len = ColumnUtils.getSize(nextColumns); i < len; i++) {
		    column = nextColumns[i];
		    nextColumnsByKey[column.key] = column;
		    var prevColumn = prevColumnsByKey[column.key];
		    if (prevColumn === undefined || !isSameColumn(prevColumn, column)) {
		      return false;
		    }
		  }
	
		  for (i = 0, len = ColumnUtils.getSize(prevColumns); i < len; i++) {
		    column = prevColumns[i];
		    var nextColumn = nextColumnsByKey[column.key];
		    if (nextColumn === undefined) {
		      return false;
		    }
		  }
		  return true;
		}
	
		function sameColumns(prevColumns, nextColumns, isSameColumn) {
		  if (areColumnsImmutable(prevColumns, nextColumns)) {
		    return prevColumns === nextColumns;
		  }
	
		  return compareEachColumn(prevColumns, nextColumns, isSameColumn);
		}
	
		module.exports = { recalculate: recalculate, resizeColumn: resizeColumn, sameColumn: sameColumn, sameColumns: sameColumns };
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _OverflowCell = __webpack_require__(171);
	
		var _OverflowCell2 = _interopRequireDefault(_OverflowCell);
	
		var _RowComparer = __webpack_require__(62);
	
		var _RowComparer2 = _interopRequireDefault(_RowComparer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var joinClasses = __webpack_require__(9);
		var Cell = __webpack_require__(59);
		var ColumnUtilsMixin = __webpack_require__(10);
		var cellMetaDataShape = __webpack_require__(14);
		var PropTypes = React.PropTypes;
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(27);
	
		var CellExpander = React.createClass({
		  displayName: 'CellExpander',
		  render: function render() {
		    return React.createElement(Cell, this.props);
		  }
		});
	
		// The list of the propTypes that we want to include in the Row div
		var knownDivPropertyKeys = ['height'];
	
		var Row = React.createClass({
		  displayName: 'Row',
	
	
		  propTypes: {
		    height: PropTypes.number.isRequired,
		    columns: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
		    row: PropTypes.any.isRequired,
		    cellRenderer: PropTypes.func,
		    cellMetaData: PropTypes.shape(cellMetaDataShape),
		    isSelected: PropTypes.bool,
		    idx: PropTypes.number.isRequired,
		    expandedRows: PropTypes.arrayOf(PropTypes.object),
		    extraClasses: PropTypes.string,
		    forceUpdate: PropTypes.bool,
		    subRowDetails: PropTypes.object,
		    isRowHovered: PropTypes.bool,
		    colVisibleStart: PropTypes.number.isRequired,
		    colVisibleEnd: PropTypes.number.isRequired,
		    colDisplayStart: PropTypes.number.isRequired,
		    colDisplayEnd: PropTypes.number.isRequired,
		    isScrolling: React.PropTypes.bool.isRequired
		  },
	
		  mixins: [ColumnUtilsMixin],
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      cellRenderer: Cell,
		      isSelected: false,
		      height: 35
		    };
		  },
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    return (0, _RowComparer2['default'])(nextProps, this.props);
		  },
		  handleDragEnter: function handleDragEnter() {
		    var handleDragEnterRow = this.props.cellMetaData.handleDragEnterRow;
		    if (handleDragEnterRow) {
		      handleDragEnterRow(this.props.idx);
		    }
		  },
		  getSelectedColumn: function getSelectedColumn() {
		    if (this.props.cellMetaData) {
		      var selected = this.props.cellMetaData.selected;
		      if (selected && selected.idx) {
		        return this.getColumn(this.props.columns, selected.idx);
		      }
		    }
		  },
		  getCellRenderer: function getCellRenderer(columnKey) {
		    var CellRenderer = this.props.cellRenderer;
		    if (this.props.subRowDetails && this.props.subRowDetails.field === columnKey) {
		      return CellExpander;
		    }
		    return CellRenderer;
		  },
		  getCell: function getCell(column, i, selectedColumn) {
		    var _this = this;
	
		    var CellRenderer = this.props.cellRenderer;
		    var _props = this.props,
		        colVisibleStart = _props.colVisibleStart,
		        colVisibleEnd = _props.colVisibleEnd,
		        idx = _props.idx,
		        cellMetaData = _props.cellMetaData;
		    var key = column.key,
		        formatter = column.formatter,
		        locked = column.locked;
	
		    var baseCellProps = { key: key + '-' + idx, idx: i, rowIdx: idx, height: this.getRowHeight(), column: column, cellMetaData: cellMetaData };
	
		    if ((i < colVisibleStart || i > colVisibleEnd) && !locked) {
		      return React.createElement(_OverflowCell2['default'], _extends({ ref: function ref(node) {
		          return _this[key] = node;
		        } }, baseCellProps));
		    }
	
		    var _props2 = this.props,
		        row = _props2.row,
		        isSelected = _props2.isSelected;
	
		    var cellProps = {
		      ref: function ref(node) {
		        return _this[key] = node;
		      },
		      value: this.getCellValue(key || i),
		      rowData: row,
		      isRowSelected: isSelected,
		      expandableOptions: this.getExpandableOptions(key),
		      selectedColumn: selectedColumn,
		      formatter: formatter,
		      isScrolling: this.props.isScrolling
		    };
	
		    return React.createElement(CellRenderer, _extends({}, baseCellProps, cellProps));
		  },
		  getCells: function getCells() {
		    var _this2 = this;
	
		    var cells = [];
		    var lockedCells = [];
		    var selectedColumn = this.getSelectedColumn();
		    if (this.props.columns) {
		      this.props.columns.forEach(function (column, i) {
		        var cell = _this2.getCell(column, i, selectedColumn);
		        if (column.locked) {
		          lockedCells.push(cell);
		        } else {
		          cells.push(cell);
		        }
		      });
		    }
	
		    return cells.concat(lockedCells);
		  },
		  getRowHeight: function getRowHeight() {
		    var rows = this.props.expandedRows || null;
		    if (rows && this.props.idx) {
		      var row = rows[this.props.idx] || null;
		      if (row) {
		        return row.height;
		      }
		    }
		    return this.props.height;
		  },
		  getCellValue: function getCellValue(key) {
		    var val = void 0;
		    if (key === 'select-row') {
		      return this.props.isSelected;
		    } else if (typeof this.props.row.get === 'function') {
		      val = this.props.row.get(key);
		    } else {
		      val = this.props.row[key];
		    }
		    return val;
		  },
		  isContextMenuDisplayed: function isContextMenuDisplayed() {
		    if (this.props.cellMetaData) {
		      var selected = this.props.cellMetaData.selected;
		      if (selected && selected.contextMenuDisplayed && selected.rowIdx === this.props.idx) {
		        return true;
		      }
		    }
		    return false;
		  },
		  getExpandableOptions: function getExpandableOptions(columnKey) {
		    return { canExpand: this.props.subRowDetails && this.props.subRowDetails.field === columnKey, expanded: this.props.subRowDetails && this.props.subRowDetails.expanded, children: this.props.subRowDetails && this.props.subRowDetails.children, treeDepth: this.props.subRowDetails ? this.props.subRowDetails.treeDepth : 0 };
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var _this3 = this;
	
		    this.props.columns.forEach(function (column) {
		      if (column.locked) {
		        if (!_this3[column.key]) return;
		        _this3[column.key].setScrollLeft(scrollLeft);
		      }
		    });
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  renderCell: function renderCell(props) {
		    if (typeof this.props.cellRenderer === 'function') {
		      this.props.cellRenderer.call(this, props);
		    }
		    if (React.isValidElement(this.props.cellRenderer)) {
		      return React.cloneElement(this.props.cellRenderer, props);
		    }
	
		    return this.props.cellRenderer(props);
		  },
		  render: function render() {
		    var className = joinClasses('react-grid-Row', 'react-grid-Row--' + (this.props.idx % 2 === 0 ? 'even' : 'odd'), {
		      'row-selected': this.props.isSelected,
		      'row-context-menu': this.isContextMenuDisplayed()
		    }, this.props.extraClasses);
	
		    var style = {
		      height: this.getRowHeight(this.props),
		      overflow: 'hidden',
		      contain: 'layout'
		    };
	
		    var cells = this.getCells();
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { className: className, style: style, onDragEnter: this.handleDragEnter }),
		      React.isValidElement(this.props.row) ? this.props.row : cells
		    );
		  }
		});
	
		module.exports = Row;
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var size = void 0;
	
		function getScrollbarSize() {
		  if (size === undefined) {
		    var outer = document.createElement('div');
		    outer.style.width = '50px';
		    outer.style.height = '50px';
		    outer.style.position = 'absolute';
		    outer.style.top = '-200px';
		    outer.style.left = '-200px';
	
		    var inner = document.createElement('div');
		    inner.style.height = '100px';
		    inner.style.width = '100%';
	
		    outer.appendChild(inner);
		    document.body.appendChild(outer);
	
		    var outerWidth = outer.clientWidth;
		    outer.style.overflowY = 'scroll';
		    var innerWidth = inner.clientWidth;
	
		    document.body.removeChild(outer);
	
		    size = outerWidth - innerWidth;
		  }
	
		  return size;
		}
	
		module.exports = getScrollbarSize;
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		function shallowCloneObject(obj) {
		  var result = {};
		  for (var k in obj) {
		    if (obj.hasOwnProperty(k)) {
		      result[k] = obj[k];
		    }
		  }
		  return result;
		}
	
		module.exports = shallowCloneObject;
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var isFunction = function isFunction(functionToCheck) {
		  var getType = {};
		  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
		};
	
		module.exports = isFunction;
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(193);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-cell.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-cell.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ }),
	/* 39 */,
	/* 40 */,
	/* 41 */,
	/* 42 */,
	/* 43 */,
	/* 44 */,
	/* 45 */,
	/* 46 */,
	/* 47 */,
	/* 48 */,
	/* 49 */,
	/* 50 */,
	/* 51 */,
	/* 52 */,
	/* 53 */,
	/* 54 */,
	/* 55 */,
	/* 56 */,
	/* 57 */,
	/* 58 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _keyMirror = __webpack_require__(199);
	
		var _keyMirror2 = _interopRequireDefault(_keyMirror);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var constants = {
		  UpdateActions: (0, _keyMirror2['default'])({
		    CELL_UPDATE: null,
		    COLUMN_FILL: null,
		    COPY_PASTE: null,
		    CELL_DRAG: null
		  }),
		  DragItemTypes: {
		    Column: 'column'
		  }
		};
	
		module.exports = constants;
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _underscore = __webpack_require__(97);
	
		var _underscore2 = _interopRequireDefault(_underscore);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var EditorContainer = __webpack_require__(181);
		var ExcelColumn = __webpack_require__(11);
		var isFunction = __webpack_require__(37);
		var CellMetaDataShape = __webpack_require__(14);
		var SimpleCellFormatter = __webpack_require__(184);
		var ColumnUtils = __webpack_require__(10);
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(38);
	
		// The list of the propTypes that we want to include in the Cell div
		var knownDivPropertyKeys = ['height', 'tabIndex', 'value'];
	
		var Cell = React.createClass({
		  displayName: 'Cell',
	
	
		  propTypes: {
		    rowIdx: React.PropTypes.number.isRequired,
		    idx: React.PropTypes.number.isRequired,
		    selected: React.PropTypes.shape({
		      idx: React.PropTypes.number.isRequired
		    }),
		    selectedColumn: React.PropTypes.object,
		    height: React.PropTypes.number,
		    tabIndex: React.PropTypes.number,
		    column: React.PropTypes.shape(ExcelColumn).isRequired,
		    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number, React.PropTypes.object, React.PropTypes.bool]).isRequired,
		    isExpanded: React.PropTypes.bool,
		    isRowSelected: React.PropTypes.bool,
		    cellMetaData: React.PropTypes.shape(CellMetaDataShape).isRequired,
		    handleDragStart: React.PropTypes.func,
		    className: React.PropTypes.string,
		    cellControls: React.PropTypes.any,
		    rowData: React.PropTypes.object.isRequired,
		    forceUpdate: React.PropTypes.bool,
		    expandableOptions: React.PropTypes.object.isRequired,
		    isScrolling: React.PropTypes.bool.isRequired,
		    tooltip: React.PropTypes.string,
		    isCellValueChanging: React.PropTypes.func
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      tabIndex: -1,
		      isExpanded: false,
		      value: '',
		      isCellValueChanging: function isCellValueChanging(value, nextValue) {
		        return value !== nextValue;
		      }
		    };
		  },
		  getInitialState: function getInitialState() {
		    return {
		      isCellValueChanging: false
		    };
		  },
		  componentDidMount: function componentDidMount() {
		    this.checkFocus();
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    this.setState({
		      isCellValueChanging: this.props.isCellValueChanging(this.props.value, nextProps.value)
		    });
		  },
		  componentDidUpdate: function componentDidUpdate() {
		    this.checkFocus();
		    var dragged = this.props.cellMetaData.dragged;
		    if (dragged && dragged.complete === true) {
		      this.props.cellMetaData.handleTerminateDrag();
		    }
		    if (this.state.isCellValueChanging && this.props.selectedColumn != null) {
		      this.applyUpdateClass();
		    }
		  },
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    var shouldUpdate = this.props.column.width !== nextProps.column.width || this.props.column.left !== nextProps.column.left || this.props.column.cellClass !== nextProps.column.cellClass || this.props.height !== nextProps.height || this.props.rowIdx !== nextProps.rowIdx || this.isCellSelectionChanging(nextProps) || this.isDraggedCellChanging(nextProps) || this.isCopyCellChanging(nextProps) || this.props.isRowSelected !== nextProps.isRowSelected || this.isSelected() || this.props.isCellValueChanging(this.props.value, nextProps.value) || this.props.forceUpdate === true || this.props.className !== nextProps.className || this.hasChangedDependentValues(nextProps);
		    return shouldUpdate;
		  },
		  onCellClick: function onCellClick(e) {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellClick && typeof meta.onCellClick === 'function') {
		      meta.onCellClick({ rowIdx: this.props.rowIdx, idx: this.props.idx }, e);
		    }
		  },
		  onCellContextMenu: function onCellContextMenu() {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellContextMenu && typeof meta.onCellContextMenu === 'function') {
		      meta.onCellContextMenu({ rowIdx: this.props.rowIdx, idx: this.props.idx });
		    }
		  },
		  onCellDoubleClick: function onCellDoubleClick(e) {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellDoubleClick && typeof meta.onCellDoubleClick === 'function') {
		      meta.onCellDoubleClick({ rowIdx: this.props.rowIdx, idx: this.props.idx }, e);
		    }
		  },
		  onCellExpand: function onCellExpand(e) {
		    e.stopPropagation();
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellExpand != null) {
		      meta.onCellExpand({ rowIdx: this.props.rowIdx, idx: this.props.idx, rowData: this.props.rowData, expandArgs: this.props.expandableOptions });
		    }
		  },
		  onCellKeyDown: function onCellKeyDown(e) {
		    if (this.canExpand() && e.key === 'Enter') {
		      this.onCellExpand(e);
		    }
		  },
		  onDragHandleDoubleClick: function onDragHandleDoubleClick(e) {
		    e.stopPropagation();
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onDragHandleDoubleClick && typeof meta.onDragHandleDoubleClick === 'function') {
		      meta.onDragHandleDoubleClick({ rowIdx: this.props.rowIdx, idx: this.props.idx, rowData: this.getRowData(), e: e });
		    }
		  },
		  onDragOver: function onDragOver(e) {
		    e.preventDefault();
		  },
		  getStyle: function getStyle() {
		    var style = {
		      position: 'absolute',
		      width: this.props.column.width,
		      height: this.props.height,
		      left: this.props.column.left,
		      contain: 'layout'
		    };
		    return style;
		  },
		  getFormatter: function getFormatter() {
		    var col = this.props.column;
		    if (this.isActive()) {
		      return React.createElement(EditorContainer, { rowData: this.getRowData(), rowIdx: this.props.rowIdx, value: this.props.value, idx: this.props.idx, cellMetaData: this.props.cellMetaData, column: col, height: this.props.height });
		    }
	
		    return this.props.column.formatter;
		  },
		  getRowData: function getRowData() {
		    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
		    return props.rowData.toJSON ? props.rowData.toJSON() : props.rowData;
		  },
		  getFormatterDependencies: function getFormatterDependencies() {
		    // convention based method to get corresponding Id or Name of any Name or Id property
		    if (typeof this.props.column.getRowMetaData === 'function') {
		      return this.props.column.getRowMetaData(this.getRowData(), this.props.column);
		    }
		  },
		  getCellClass: function getCellClass() {
		    var className = joinClasses(this.props.column.cellClass, 'react-grid-Cell', this.props.className, this.props.column.locked ? 'react-grid-Cell--locked' : null);
		    var extraClasses = joinClasses({
		      'row-selected': this.props.isRowSelected,
		      editing: this.isActive(),
		      copied: this.isCopied() || this.wasDraggedOver() || this.isDraggedOverUpwards() || this.isDraggedOverDownwards(),
		      'is-dragged-over-up': this.isDraggedOverUpwards(),
		      'is-dragged-over-down': this.isDraggedOverDownwards(),
		      'was-dragged-over': this.wasDraggedOver(),
		      'cell-tooltip': this.props.tooltip ? true : false
		    });
		    return joinClasses(className, extraClasses);
		  },
		  getUpdateCellClass: function getUpdateCellClass() {
		    return this.props.column.getUpdateCellClass ? this.props.column.getUpdateCellClass(this.props.selectedColumn, this.props.column, this.state.isCellValueChanging) : '';
		  },
		  isColumnSelected: function isColumnSelected() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
	
		    return meta.selected && meta.selected.idx === this.props.idx;
		  },
		  isSelected: function isSelected() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
	
		    return meta.selected && meta.selected.rowIdx === this.props.rowIdx && meta.selected.idx === this.props.idx;
		  },
		  isActive: function isActive() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
		    return this.isSelected() && meta.selected.active === true;
		  },
		  isCellSelectionChanging: function isCellSelectionChanging(nextProps) {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
		    var nextSelected = nextProps.cellMetaData.selected;
		    if (meta.selected && nextSelected) {
		      return this.props.idx === nextSelected.idx || this.props.idx === meta.selected.idx;
		    }
	
		    return true;
		  },
		  isCellSelectEnabled: function isCellSelectEnabled() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
		    return meta.enableCellSelect;
		  },
		  hasChangedDependentValues: function hasChangedDependentValues(nextProps) {
		    var currentColumn = this.props.column;
		    var hasChangedDependentValues = false;
	
		    if (currentColumn.getRowMetaData) {
		      var currentRowMetaData = currentColumn.getRowMetaData(this.getRowData(), currentColumn);
		      var nextColumn = nextProps.column;
		      var nextRowMetaData = nextColumn.getRowMetaData(this.getRowData(nextProps), nextColumn);
	
		      hasChangedDependentValues = !_underscore2['default'].isEqual(currentRowMetaData, nextRowMetaData);
		    }
	
		    return hasChangedDependentValues;
		  },
		  applyUpdateClass: function applyUpdateClass() {
		    var updateCellClass = this.getUpdateCellClass();
		    // -> removing the class
		    if (updateCellClass != null && updateCellClass !== '') {
		      var cellDOMNode = ReactDOM.findDOMNode(this);
		      if (cellDOMNode.classList) {
		        cellDOMNode.classList.remove(updateCellClass);
		        // -> and re-adding the class
		        cellDOMNode.classList.add(updateCellClass);
		      } else if (cellDOMNode.className.indexOf(updateCellClass) === -1) {
		        // IE9 doesn't support classList, nor (I think) altering element.className
		        // without replacing it wholesale.
		        cellDOMNode.className = cellDOMNode.className + ' ' + updateCellClass;
		      }
		    }
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var ctrl = this; // flow on windows has an outdated react declaration, once that gets updated, we can remove this
		    if (ctrl.isMounted()) {
		      var node = ReactDOM.findDOMNode(this);
		      if (node) {
		        var transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		        node.style.webkitTransform = transform;
		        node.style.transform = transform;
		      }
		    }
		  },
		  isCopied: function isCopied() {
		    var copied = this.props.cellMetaData.copied;
		    return copied && copied.rowIdx === this.props.rowIdx && copied.idx === this.props.idx;
		  },
		  isDraggedOver: function isDraggedOver() {
		    var dragged = this.props.cellMetaData.dragged;
		    return dragged && dragged.overRowIdx === this.props.rowIdx && dragged.idx === this.props.idx;
		  },
		  wasDraggedOver: function wasDraggedOver() {
		    var dragged = this.props.cellMetaData.dragged;
		    return dragged && (dragged.overRowIdx < this.props.rowIdx && this.props.rowIdx < dragged.rowIdx || dragged.overRowIdx > this.props.rowIdx && this.props.rowIdx > dragged.rowIdx) && dragged.idx === this.props.idx;
		  },
		  isDraggedCellChanging: function isDraggedCellChanging(nextProps) {
		    var isChanging = void 0;
		    var dragged = this.props.cellMetaData.dragged;
		    var nextDragged = nextProps.cellMetaData.dragged;
		    if (dragged) {
		      isChanging = nextDragged && this.props.idx === nextDragged.idx || dragged && this.props.idx === dragged.idx;
		      return isChanging;
		    }
	
		    return false;
		  },
		  isCopyCellChanging: function isCopyCellChanging(nextProps) {
		    var isChanging = void 0;
		    var copied = this.props.cellMetaData.copied;
		    var nextCopied = nextProps.cellMetaData.copied;
		    if (copied) {
		      isChanging = nextCopied && this.props.idx === nextCopied.idx || copied && this.props.idx === copied.idx;
		      return isChanging;
		    }
		    return false;
		  },
		  isDraggedOverUpwards: function isDraggedOverUpwards() {
		    var dragged = this.props.cellMetaData.dragged;
		    return !this.isSelected() && this.isDraggedOver() && this.props.rowIdx < dragged.rowIdx;
		  },
		  isDraggedOverDownwards: function isDraggedOverDownwards() {
		    var dragged = this.props.cellMetaData.dragged;
		    return !this.isSelected() && this.isDraggedOver() && this.props.rowIdx > dragged.rowIdx;
		  },
		  isFocusedOnBody: function isFocusedOnBody() {
		    return document.activeElement == null || document.activeElement.nodeName && typeof document.activeElement.nodeName === 'string' && document.activeElement.nodeName.toLowerCase() === 'body';
		  },
		  isFocusedOnCell: function isFocusedOnCell() {
		    return document.activeElement && document.activeElement.className === 'react-grid-Cell';
		  },
		  checkFocus: function checkFocus() {
		    if (this.isSelected() && !this.isActive()) {
		      if (this.props.isScrolling && !this.props.cellMetaData.isScrollingVerticallyWithKeyboard && !this.props.cellMetaData.isScrollingHorizontallyWithKeyboard) {
		        return;
		      }
		      // Only focus to the current cell if the currently active node in the document is within the data grid.
		      // Meaning focus should not be stolen from elements that the grid doesnt control.
		      var dataGridDOMNode = this.props.cellMetaData && this.props.cellMetaData.getDataGridDOMNode ? this.props.cellMetaData.getDataGridDOMNode() : null;
		      if (this.isFocusedOnCell() || this.isFocusedOnBody() || dataGridDOMNode && dataGridDOMNode.contains(document.activeElement)) {
		        var cellDOMNode = ReactDOM.findDOMNode(this);
		        if (cellDOMNode) {
		          cellDOMNode.focus();
		        }
		      }
		    }
		  },
		  canEdit: function canEdit() {
		    return this.props.column.editor != null || this.props.column.editable;
		  },
		  canExpand: function canExpand() {
		    return this.props.expandableOptions && this.props.expandableOptions.canExpand;
		  },
		  createColumEventCallBack: function createColumEventCallBack(onColumnEvent, info) {
		    return function (e) {
		      onColumnEvent(e, info);
		    };
		  },
		  createCellEventCallBack: function createCellEventCallBack(gridEvent, columnEvent) {
		    return function (e) {
		      gridEvent(e);
		      columnEvent(e);
		    };
		  },
		  createEventDTO: function createEventDTO(gridEvents, columnEvents, onColumnEvent) {
		    var allEvents = Object.assign({}, gridEvents);
	
		    for (var eventKey in columnEvents) {
		      if (columnEvents.hasOwnProperty(eventKey)) {
		        var event = columnEvents[event];
		        var eventInfo = { rowIdx: this.props.rowIdx, idx: this.props.idx, name: eventKey };
		        var eventCallback = this.createColumEventCallBack(onColumnEvent, eventInfo);
	
		        if (allEvents.hasOwnProperty(eventKey)) {
		          var currentEvent = allEvents[eventKey];
		          allEvents[eventKey] = this.createCellEventCallBack(currentEvent, eventCallback);
		        } else {
		          allEvents[eventKey] = eventCallback;
		        }
		      }
		    }
	
		    return allEvents;
		  },
		  getEvents: function getEvents() {
		    var columnEvents = this.props.column ? Object.assign({}, this.props.column.events) : undefined;
		    var onColumnEvent = this.props.cellMetaData ? this.props.cellMetaData.onColumnEvent : undefined;
		    var gridEvents = {
		      onClick: this.onCellClick,
		      onDoubleClick: this.onCellDoubleClick,
		      onContextMenu: this.onCellContextMenu,
		      onDragOver: this.onDragOver
		    };
	
		    if (!columnEvents || !onColumnEvent) {
		      return gridEvents;
		    }
	
		    return this.createEventDTO(gridEvents, columnEvents, onColumnEvent);
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  renderCellContent: function renderCellContent(props) {
		    var CellContent = void 0;
		    var Formatter = this.getFormatter();
		    if (React.isValidElement(Formatter)) {
		      props.dependentValues = this.getFormatterDependencies();
		      CellContent = React.cloneElement(Formatter, props);
		    } else if (isFunction(Formatter)) {
		      CellContent = React.createElement(Formatter, { value: this.props.value, dependentValues: this.getFormatterDependencies() });
		    } else {
		      CellContent = React.createElement(SimpleCellFormatter, { value: this.props.value });
		    }
		    var cellExpander = void 0;
		    var marginLeft = this.props.expandableOptions ? this.props.expandableOptions.treeDepth * 30 : 0;
		    if (this.canExpand()) {
		      cellExpander = React.createElement(
		        'span',
		        { style: { float: 'left', marginLeft: marginLeft }, onClick: this.onCellExpand },
		        this.props.expandableOptions.expanded ? String.fromCharCode('9660') : String.fromCharCode('9658')
		      );
		    }
		    return React.createElement(
		      'div',
		      { className: 'react-grid-Cell__value' },
		      cellExpander,
		      React.createElement(
		        'span',
		        null,
		        CellContent
		      ),
		      ' ',
		      this.props.cellControls,
		      ' '
		    );
		  },
		  render: function render() {
		    if (this.props.column.hidden) {
		      return null;
		    }
	
		    var style = this.getStyle();
	
		    var className = this.getCellClass();
	
		    var cellContent = this.renderCellContent({
		      value: this.props.value,
		      column: this.props.column,
		      rowIdx: this.props.rowIdx,
		      isExpanded: this.props.isExpanded
		    });
	
		    var dragHandle = !this.isActive() && ColumnUtils.canEdit(this.props.column, this.props.rowData, this.props.cellMetaData.enableCellSelect) ? React.createElement(
		      'div',
		      { className: 'drag-handle', draggable: 'true', onDoubleClick: this.onDragHandleDoubleClick },
		      React.createElement('span', { style: { display: 'none' } })
		    ) : null;
		    var events = this.getEvents();
		    var tooltip = this.props.tooltip ? React.createElement(
		      'span',
		      { className: 'cell-tooltip-text' },
		      this.props.tooltip
		    ) : null;
	
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { className: className, style: style }, events),
		      cellContent,
		      dragHandle,
		      tooltip
		    );
		  }
		});
	
		module.exports = Cell;
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var ExcelColumn = __webpack_require__(11);
		var ResizeHandle = __webpack_require__(174);
		__webpack_require__(19);
	
		var PropTypes = React.PropTypes;
	
		function simpleCellRenderer(objArgs) {
		  var headerText = objArgs.column.rowType === 'header' ? objArgs.column.name : '';
		  return React.createElement(
		    'div',
		    { className: 'widget-HeaderCell__value' },
		    headerText
		  );
		}
	
		var HeaderCell = React.createClass({
		  displayName: 'HeaderCell',
	
	
		  propTypes: {
		    renderer: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
		    column: PropTypes.shape(ExcelColumn).isRequired,
		    onResize: PropTypes.func.isRequired,
		    height: PropTypes.number.isRequired,
		    onResizeEnd: PropTypes.func.isRequired,
		    className: PropTypes.string
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      renderer: simpleCellRenderer
		    };
		  },
		  getInitialState: function getInitialState() {
		    return { resizing: false };
		  },
		  onDragStart: function onDragStart(e) {
		    this.setState({ resizing: true });
		    // need to set dummy data for FF
		    if (e && e.dataTransfer && e.dataTransfer.setData) e.dataTransfer.setData('text/plain', 'dummy');
		  },
		  onDrag: function onDrag(e) {
		    var resize = this.props.onResize || null; // for flows sake, doesnt recognise a null check direct
		    if (resize) {
		      var _width = this.getWidthFromMouseEvent(e);
		      if (_width > 0) {
		        resize(this.props.column, _width);
		      }
		    }
		  },
		  onDragEnd: function onDragEnd(e) {
		    var width = this.getWidthFromMouseEvent(e);
		    this.props.onResizeEnd(this.props.column, width);
		    this.setState({ resizing: false });
		  },
		  getWidthFromMouseEvent: function getWidthFromMouseEvent(e) {
		    var right = e.pageX || e.touches && e.touches[0] && e.touches[0].pageX || e.changedTouches && e.changedTouches[e.changedTouches.length - 1].pageX;
		    var left = ReactDOM.findDOMNode(this).getBoundingClientRect().left;
		    return right - left;
		  },
		  getCell: function getCell() {
		    if (React.isValidElement(this.props.renderer)) {
		      // if it is a string, it's an HTML element, and column is not a valid property, so only pass height
		      if (typeof this.props.renderer.type === 'string') {
		        return React.cloneElement(this.props.renderer, { height: this.props.height });
		      }
		      return React.cloneElement(this.props.renderer, { column: this.props.column, height: this.props.height });
		    }
		    return this.props.renderer({ column: this.props.column });
		  },
		  getStyle: function getStyle() {
		    return {
		      width: this.props.column.width,
		      left: this.props.column.left,
		      display: 'inline-block',
		      position: 'absolute',
		      height: this.props.height,
		      margin: 0,
		      textOverflow: 'ellipsis',
		      whiteSpace: 'nowrap'
		    };
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var node = ReactDOM.findDOMNode(this);
		    node.style.webkitTransform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		    node.style.transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		  },
		  removeScroll: function removeScroll() {
		    var node = ReactDOM.findDOMNode(this);
		    if (node) {
		      var transform = 'none';
		      node.style.webkitTransform = transform;
		      node.style.transform = transform;
		    }
		  },
		  render: function render() {
		    var resizeHandle = void 0;
		    if (this.props.column.resizable) {
		      resizeHandle = React.createElement(ResizeHandle, {
		        onDrag: this.onDrag,
		        onDragStart: this.onDragStart,
		        onDragEnd: this.onDragEnd
		      });
		    }
		    var className = joinClasses({
		      'react-grid-HeaderCell': true,
		      'react-grid-HeaderCell--resizing': this.state.resizing,
		      'react-grid-HeaderCell--locked': this.props.column.locked
		    });
		    className = joinClasses(className, this.props.className, this.props.column.cellClass);
		    var cell = this.getCell();
		    return React.createElement(
		      'div',
		      { className: className, style: this.getStyle() },
		      cell,
		      resizeHandle
		    );
		  }
		});
	
		module.exports = HeaderCell;
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var KeyboardHandlerMixin = {
		  onKeyDown: function onKeyDown(e) {
		    if (this.isCtrlKeyHeldDown(e)) {
		      this.checkAndCall('onPressKeyWithCtrl', e);
		    } else if (this.isKeyExplicitlyHandled(e.key)) {
		      // break up individual keyPress events to have their own specific callbacks
		      // this allows multiple mixins to listen to onKeyDown events and somewhat reduces methodName clashing
		      var callBack = 'onPress' + e.key;
		      this.checkAndCall(callBack, e);
		    } else if (this.isKeyPrintable(e.keyCode)) {
		      this.checkAndCall('onPressChar', e);
		    }
	
		    // Track which keys are currently down for shift clicking etc
		    this._keysDown = this._keysDown || {};
		    this._keysDown[e.keyCode] = true;
		    if (this.props.onGridKeyDown && typeof this.props.onGridKeyDown === 'function') {
		      this.props.onGridKeyDown(e);
		    }
		  },
		  onKeyUp: function onKeyUp(e) {
		    // Track which keys are currently down for shift clicking etc
		    this._keysDown = this._keysDown || {};
		    delete this._keysDown[e.keyCode];
	
		    if (this.props.onGridKeyUp && typeof this.props.onGridKeyUp === 'function') {
		      this.props.onGridKeyUp(e);
		    }
		  },
		  isKeyDown: function isKeyDown(keyCode) {
		    if (!this._keysDown) return false;
		    return keyCode in this._keysDown;
		  },
		  isSingleKeyDown: function isSingleKeyDown(keyCode) {
		    if (!this._keysDown) return false;
		    return keyCode in this._keysDown && Object.keys(this._keysDown).length === 1;
		  },
	
	
		  // taken from http://stackoverflow.com/questions/12467240/determine-if-javascript-e-keycode-is-a-printable-non-control-character
		  isKeyPrintable: function isKeyPrintable(keycode) {
		    var valid = keycode > 47 && keycode < 58 || // number keys
		    keycode === 32 || keycode === 13 || // spacebar & return key(s) (if you want to allow carriage returns)
		    keycode > 64 && keycode < 91 || // letter keys
		    keycode > 95 && keycode < 112 || // numpad keys
		    keycode > 185 && keycode < 193 || // ;=,-./` (in order)
		    keycode > 218 && keycode < 223; // [\]' (in order)
	
		    return valid;
		  },
		  isKeyExplicitlyHandled: function isKeyExplicitlyHandled(key) {
		    return typeof this['onPress' + key] === 'function';
		  },
		  isCtrlKeyHeldDown: function isCtrlKeyHeldDown(e) {
		    return e.ctrlKey === true && e.key !== 'Control';
		  },
		  checkAndCall: function checkAndCall(methodName, args) {
		    if (typeof this[methodName] === 'function') {
		      this[methodName](args);
		    }
		  }
		};
	
		module.exports = KeyboardHandlerMixin;
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.shouldRowUpdate = undefined;
	
		var _ColumnMetrics = __webpack_require__(33);
	
		var _ColumnMetrics2 = _interopRequireDefault(_ColumnMetrics);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function doesRowContainSelectedCell(props) {
		  var selected = props.cellMetaData.selected;
		  if (selected && selected.rowIdx === props.idx) {
		    return true;
		  }
		  return false;
		}
	
		function willRowBeDraggedOver(props) {
		  var dragged = props.cellMetaData.dragged;
		  return dragged != null && (dragged.rowIdx >= 0 || dragged.complete === true);
		}
	
		function hasRowBeenCopied(props) {
		  var copied = props.cellMetaData.copied;
		  return copied != null && copied.rowIdx === props.idx;
		}
	
		var shouldRowUpdate = exports.shouldRowUpdate = function shouldRowUpdate(nextProps, currentProps) {
		  return !_ColumnMetrics2['default'].sameColumns(currentProps.columns, nextProps.columns, _ColumnMetrics2['default'].sameColumn) || doesRowContainSelectedCell(currentProps) || doesRowContainSelectedCell(nextProps) || willRowBeDraggedOver(nextProps) || nextProps.row !== currentProps.row || currentProps.colDisplayStart !== nextProps.colDisplayStart || currentProps.colDisplayEnd !== nextProps.colDisplayEnd || currentProps.colVisibleStart !== nextProps.colVisibleStart || currentProps.colVisibleEnd !== nextProps.colVisibleEnd || hasRowBeenCopied(currentProps) || currentProps.isSelected !== nextProps.isSelected || nextProps.height !== currentProps.height || currentProps.isOver !== nextProps.isOver || currentProps.canDrop !== nextProps.canDrop || currentProps.forceUpdate === true;
		};
	
		exports['default'] = shouldRowUpdate;
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var RowUtils = {
		  get: function get(row, property) {
		    if (typeof row.get === 'function') {
		      return row.get(property);
		    }
	
		    return row[property];
		  },
		  isRowSelected: function isRowSelected(keys, indexes, isSelectedKey, rowData, rowIdx) {
		    if (indexes && Object.prototype.toString.call(indexes) === '[object Array]') {
		      return indexes.indexOf(rowIdx) > -1;
		    } else if (keys && keys.rowKey && keys.values && Object.prototype.toString.call(keys.values) === '[object Array]') {
		      return keys.values.indexOf(rowData[keys.rowKey]) > -1;
		    } else if (isSelectedKey && rowData && typeof isSelectedKey === 'string') {
		      return rowData[isSelectedKey];
		    }
		    return false;
		  }
		};
	
		module.exports = RowUtils;
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.SimpleRowsContainer = undefined;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SimpleRowsContainer = function SimpleRowsContainer(props) {
		  return _react2['default'].createElement(
		    'div',
		    { key: 'rows-container' },
		    props.rows
		  );
		};
	
		SimpleRowsContainer.propTypes = {
		  width: _react.PropTypes.number,
		  rows: _react.PropTypes.array
		};
	
		var RowsContainer = function (_React$Component) {
		  _inherits(RowsContainer, _React$Component);
	
		  function RowsContainer(props) {
		    _classCallCheck(this, RowsContainer);
	
		    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
		    _this.plugins = props.window ? props.window.ReactDataGridPlugins : window.ReactDataGridPlugins;
		    _this.hasContextMenu = _this.hasContextMenu.bind(_this);
		    _this.renderRowsWithContextMenu = _this.renderRowsWithContextMenu.bind(_this);
		    _this.getContextMenuContainer = _this.getContextMenuContainer.bind(_this);
		    _this.state = { ContextMenuContainer: _this.getContextMenuContainer(props) };
		    return _this;
		  }
	
		  RowsContainer.prototype.getContextMenuContainer = function getContextMenuContainer() {
		    if (this.hasContextMenu()) {
		      if (!this.plugins) {
		        throw new Error('You need to include ReactDataGrid UiPlugins in order to initialise context menu');
		      }
		      return this.plugins.Menu.ContextMenuLayer('reactDataGridContextMenu')(SimpleRowsContainer);
		    }
		  };
	
		  RowsContainer.prototype.hasContextMenu = function hasContextMenu() {
		    return this.props.contextMenu && _react2['default'].isValidElement(this.props.contextMenu);
		  };
	
		  RowsContainer.prototype.renderRowsWithContextMenu = function renderRowsWithContextMenu() {
		    var ContextMenuRowsContainer = this.state.ContextMenuContainer;
		    var newProps = { rowIdx: this.props.rowIdx, idx: this.props.idx };
		    var contextMenu = _react2['default'].cloneElement(this.props.contextMenu, newProps);
		    // Initialise the context menu if it is available
		    return _react2['default'].createElement(
		      'div',
		      null,
		      _react2['default'].createElement(ContextMenuRowsContainer, this.props),
		      contextMenu
		    );
		  };
	
		  RowsContainer.prototype.render = function render() {
		    return this.hasContextMenu() ? this.renderRowsWithContextMenu() : _react2['default'].createElement(SimpleRowsContainer, this.props);
		  };
	
		  return RowsContainer;
		}(_react2['default'].Component);
	
		RowsContainer.propTypes = {
		  contextMenu: _react.PropTypes.element,
		  rowIdx: _react.PropTypes.number,
		  idx: _react.PropTypes.number,
		  window: _react.PropTypes.object
		};
	
		exports['default'] = RowsContainer;
		exports.SimpleRowsContainer = SimpleRowsContainer;
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		__webpack_require__(72);
	
		var CheckboxEditor = React.createClass({
		  displayName: 'CheckboxEditor',
	
	
		  propTypes: {
		    value: React.PropTypes.bool,
		    rowIdx: React.PropTypes.number,
		    column: React.PropTypes.shape({
		      key: React.PropTypes.string,
		      onCellChange: React.PropTypes.func
		    }),
		    dependentValues: React.PropTypes.object
		  },
	
		  handleChange: function handleChange(e) {
		    this.props.column.onCellChange(this.props.rowIdx, this.props.column.key, this.props.dependentValues, e);
		  },
		  render: function render() {
		    var checked = this.props.value != null ? this.props.value : false;
		    var checkboxName = 'checkbox' + this.props.rowIdx;
		    return React.createElement(
		      'div',
		      { className: 'react-grid-checkbox-container checkbox-align', onClick: this.handleChange },
		      React.createElement('input', { className: 'react-grid-checkbox', type: 'checkbox', name: checkboxName, checked: checked }),
		      React.createElement('label', { htmlFor: checkboxName, className: 'react-grid-checkbox-label' })
		    );
		  }
		});
	
		module.exports = CheckboxEditor;
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var ExcelColumn = __webpack_require__(11);
	
		var EditorBase = function (_React$Component) {
		  _inherits(EditorBase, _React$Component);
	
		  function EditorBase() {
		    _classCallCheck(this, EditorBase);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  EditorBase.prototype.getStyle = function getStyle() {
		    return {
		      width: '100%'
		    };
		  };
	
		  EditorBase.prototype.getValue = function getValue() {
		    var updated = {};
		    updated[this.props.column.key] = this.getInputNode().value;
		    return updated;
		  };
	
		  EditorBase.prototype.getInputNode = function getInputNode() {
		    var domNode = ReactDOM.findDOMNode(this);
		    if (domNode.tagName === 'INPUT') {
		      return domNode;
		    }
	
		    return domNode.querySelector('input:not([type=hidden])');
		  };
	
		  EditorBase.prototype.inheritContainerStyles = function inheritContainerStyles() {
		    return true;
		  };
	
		  return EditorBase;
		}(React.Component);
	
		EditorBase.propTypes = {
		  onKeyDown: React.PropTypes.func.isRequired,
		  value: React.PropTypes.any.isRequired,
		  onBlur: React.PropTypes.func.isRequired,
		  column: React.PropTypes.shape(ExcelColumn).isRequired,
		  commit: React.PropTypes.func.isRequired
		};
	
		module.exports = EditorBase;
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var React = __webpack_require__(2);
		var EditorBase = __webpack_require__(66);
	
		var SimpleTextEditor = function (_EditorBase) {
		  _inherits(SimpleTextEditor, _EditorBase);
	
		  function SimpleTextEditor() {
		    _classCallCheck(this, SimpleTextEditor);
	
		    return _possibleConstructorReturn(this, _EditorBase.apply(this, arguments));
		  }
	
		  SimpleTextEditor.prototype.render = function render() {
		    var _this2 = this;
	
		    return React.createElement('input', { ref: function ref(node) {
		        return _this2.input = node;
		      }, type: 'text', onBlur: this.props.onBlur, className: 'form-control', defaultValue: this.props.value });
		  };
	
		  return SimpleTextEditor;
		}(EditorBase);
	
		module.exports = SimpleTextEditor;
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var _immutable = __webpack_require__(18);
	
		module.exports = {
		  isEmptyArray: __webpack_require__(188),
		  isEmptyObject: __webpack_require__(189),
		  isFunction: __webpack_require__(37),
		  isImmutableCollection: __webpack_require__(190),
		  getMixedTypeValueRetriever: __webpack_require__(192),
		  isColumnsImmutable: __webpack_require__(69),
		  isImmutableMap: __webpack_require__(191),
		  last: function last(arrayOrList) {
		    if (arrayOrList == null) {
		      throw new Error('arrayOrCollection is null');
		    }
	
		    if (_immutable.List.isList(arrayOrList)) {
		      return arrayOrList.last();
		    }
	
		    if (Array.isArray(arrayOrList)) {
		      return arrayOrList[arrayOrList.length - 1];
		    }
	
		    throw new Error('Cant get last of: ' + (typeof arrayOrList === 'undefined' ? 'undefined' : _typeof(arrayOrList)));
		  }
		};
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		module.exports = function isColumnsImmutable(columns) {
		  return typeof Immutable !== 'undefined' && columns instanceof Immutable.List;
		};
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @providesModule shallowEqual
		 * @typechecks
		 * 
		 */
	
		'use strict';
	
		var hasOwnProperty = Object.prototype.hasOwnProperty;
	
		/**
		 * Performs equality by iterating through keys on an object and returning false
		 * when any key has values which are not strictly equal between the arguments.
		 * Returns true when the values of all keys are strictly equal.
		 */
		function shallowEqual(objA, objB) {
		  if (objA === objB) {
		    return true;
		  }
	
		  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
		    return false;
		  }
	
		  var keysA = Object.keys(objA);
		  var keysB = Object.keys(objB);
	
		  if (keysA.length !== keysB.length) {
		    return false;
		  }
	
		  // Test for A's keys different from B.
		  var bHasOwnProperty = hasOwnProperty.bind(objB);
		  for (var i = 0; i < keysA.length; i++) {
		    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
		      return false;
		    }
		  }
	
		  return true;
		}
	
		module.exports = shallowEqual;
	
	/***/ }),
	/* 71 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		function ToObject(val) {
			if (val == null) {
				throw new TypeError('Object.assign cannot be called with null or undefined');
			}
	
			return Object(val);
		}
	
		module.exports = Object.assign || function (target, source) {
			var from;
			var keys;
			var to = ToObject(target);
	
			for (var s = 1; s < arguments.length; s++) {
				from = arguments[s];
				keys = Object.keys(Object(from));
	
				for (var i = 0; i < keys.length; i++) {
					to[keys[i]] = from[keys[i]];
				}
			}
	
			return to;
		};
	
	
	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(194);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-checkbox.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-checkbox.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ }),
	/* 73 */,
	/* 74 */,
	/* 75 */,
	/* 76 */,
	/* 77 */,
	/* 78 */,
	/* 79 */,
	/* 80 */,
	/* 81 */,
	/* 82 */,
	/* 83 */,
	/* 84 */,
	/* 85 */,
	/* 86 */,
	/* 87 */,
	/* 88 */,
	/* 89 */,
	/* 90 */,
	/* 91 */,
	/* 92 */,
	/* 93 */,
	/* 94 */,
	/* 95 */,
	/* 96 */,
	/* 97 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
		//     http://underscorejs.org
		//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
		//     Underscore may be freely distributed under the MIT license.
	
		(function() {
	
		  // Baseline setup
		  // --------------
	
		  // Establish the root object, `window` in the browser, or `exports` on the server.
		  var root = this;
	
		  // Save the previous value of the `_` variable.
		  var previousUnderscore = root._;
	
		  // Save bytes in the minified (but not gzipped) version:
		  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
		  // Create quick reference variables for speed access to core prototypes.
		  var
		    push             = ArrayProto.push,
		    slice            = ArrayProto.slice,
		    toString         = ObjProto.toString,
		    hasOwnProperty   = ObjProto.hasOwnProperty;
	
		  // All **ECMAScript 5** native function implementations that we hope to use
		  // are declared here.
		  var
		    nativeIsArray      = Array.isArray,
		    nativeKeys         = Object.keys,
		    nativeBind         = FuncProto.bind,
		    nativeCreate       = Object.create;
	
		  // Naked function reference for surrogate-prototype-swapping.
		  var Ctor = function(){};
	
		  // Create a safe reference to the Underscore object for use below.
		  var _ = function(obj) {
		    if (obj instanceof _) return obj;
		    if (!(this instanceof _)) return new _(obj);
		    this._wrapped = obj;
		  };
	
		  // Export the Underscore object for **Node.js**, with
		  // backwards-compatibility for the old `require()` API. If we're in
		  // the browser, add `_` as a global object.
		  if (true) {
		    if (typeof module !== 'undefined' && module.exports) {
		      exports = module.exports = _;
		    }
		    exports._ = _;
		  } else {
		    root._ = _;
		  }
	
		  // Current version.
		  _.VERSION = '1.8.3';
	
		  // Internal function that returns an efficient (for current engines) version
		  // of the passed-in callback, to be repeatedly applied in other Underscore
		  // functions.
		  var optimizeCb = function(func, context, argCount) {
		    if (context === void 0) return func;
		    switch (argCount == null ? 3 : argCount) {
		      case 1: return function(value) {
		        return func.call(context, value);
		      };
		      case 2: return function(value, other) {
		        return func.call(context, value, other);
		      };
		      case 3: return function(value, index, collection) {
		        return func.call(context, value, index, collection);
		      };
		      case 4: return function(accumulator, value, index, collection) {
		        return func.call(context, accumulator, value, index, collection);
		      };
		    }
		    return function() {
		      return func.apply(context, arguments);
		    };
		  };
	
		  // A mostly-internal function to generate callbacks that can be applied
		  // to each element in a collection, returning the desired result — either
		  // identity, an arbitrary callback, a property matcher, or a property accessor.
		  var cb = function(value, context, argCount) {
		    if (value == null) return _.identity;
		    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
		    if (_.isObject(value)) return _.matcher(value);
		    return _.property(value);
		  };
		  _.iteratee = function(value, context) {
		    return cb(value, context, Infinity);
		  };
	
		  // An internal function for creating assigner functions.
		  var createAssigner = function(keysFunc, undefinedOnly) {
		    return function(obj) {
		      var length = arguments.length;
		      if (length < 2 || obj == null) return obj;
		      for (var index = 1; index < length; index++) {
		        var source = arguments[index],
		            keys = keysFunc(source),
		            l = keys.length;
		        for (var i = 0; i < l; i++) {
		          var key = keys[i];
		          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
		        }
		      }
		      return obj;
		    };
		  };
	
		  // An internal function for creating a new object that inherits from another.
		  var baseCreate = function(prototype) {
		    if (!_.isObject(prototype)) return {};
		    if (nativeCreate) return nativeCreate(prototype);
		    Ctor.prototype = prototype;
		    var result = new Ctor;
		    Ctor.prototype = null;
		    return result;
		  };
	
		  var property = function(key) {
		    return function(obj) {
		      return obj == null ? void 0 : obj[key];
		    };
		  };
	
		  // Helper for collection methods to determine whether a collection
		  // should be iterated as an array or as an object
		  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
		  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
		  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
		  var getLength = property('length');
		  var isArrayLike = function(collection) {
		    var length = getLength(collection);
		    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
		  };
	
		  // Collection Functions
		  // --------------------
	
		  // The cornerstone, an `each` implementation, aka `forEach`.
		  // Handles raw objects in addition to array-likes. Treats all
		  // sparse array-likes as if they were dense.
		  _.each = _.forEach = function(obj, iteratee, context) {
		    iteratee = optimizeCb(iteratee, context);
		    var i, length;
		    if (isArrayLike(obj)) {
		      for (i = 0, length = obj.length; i < length; i++) {
		        iteratee(obj[i], i, obj);
		      }
		    } else {
		      var keys = _.keys(obj);
		      for (i = 0, length = keys.length; i < length; i++) {
		        iteratee(obj[keys[i]], keys[i], obj);
		      }
		    }
		    return obj;
		  };
	
		  // Return the results of applying the iteratee to each element.
		  _.map = _.collect = function(obj, iteratee, context) {
		    iteratee = cb(iteratee, context);
		    var keys = !isArrayLike(obj) && _.keys(obj),
		        length = (keys || obj).length,
		        results = Array(length);
		    for (var index = 0; index < length; index++) {
		      var currentKey = keys ? keys[index] : index;
		      results[index] = iteratee(obj[currentKey], currentKey, obj);
		    }
		    return results;
		  };
	
		  // Create a reducing function iterating left or right.
		  function createReduce(dir) {
		    // Optimized iterator function as using arguments.length
		    // in the main function will deoptimize the, see #1991.
		    function iterator(obj, iteratee, memo, keys, index, length) {
		      for (; index >= 0 && index < length; index += dir) {
		        var currentKey = keys ? keys[index] : index;
		        memo = iteratee(memo, obj[currentKey], currentKey, obj);
		      }
		      return memo;
		    }
	
		    return function(obj, iteratee, memo, context) {
		      iteratee = optimizeCb(iteratee, context, 4);
		      var keys = !isArrayLike(obj) && _.keys(obj),
		          length = (keys || obj).length,
		          index = dir > 0 ? 0 : length - 1;
		      // Determine the initial value if none is provided.
		      if (arguments.length < 3) {
		        memo = obj[keys ? keys[index] : index];
		        index += dir;
		      }
		      return iterator(obj, iteratee, memo, keys, index, length);
		    };
		  }
	
		  // **Reduce** builds up a single result from a list of values, aka `inject`,
		  // or `foldl`.
		  _.reduce = _.foldl = _.inject = createReduce(1);
	
		  // The right-associative version of reduce, also known as `foldr`.
		  _.reduceRight = _.foldr = createReduce(-1);
	
		  // Return the first value which passes a truth test. Aliased as `detect`.
		  _.find = _.detect = function(obj, predicate, context) {
		    var key;
		    if (isArrayLike(obj)) {
		      key = _.findIndex(obj, predicate, context);
		    } else {
		      key = _.findKey(obj, predicate, context);
		    }
		    if (key !== void 0 && key !== -1) return obj[key];
		  };
	
		  // Return all the elements that pass a truth test.
		  // Aliased as `select`.
		  _.filter = _.select = function(obj, predicate, context) {
		    var results = [];
		    predicate = cb(predicate, context);
		    _.each(obj, function(value, index, list) {
		      if (predicate(value, index, list)) results.push(value);
		    });
		    return results;
		  };
	
		  // Return all the elements for which a truth test fails.
		  _.reject = function(obj, predicate, context) {
		    return _.filter(obj, _.negate(cb(predicate)), context);
		  };
	
		  // Determine whether all of the elements match a truth test.
		  // Aliased as `all`.
		  _.every = _.all = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var keys = !isArrayLike(obj) && _.keys(obj),
		        length = (keys || obj).length;
		    for (var index = 0; index < length; index++) {
		      var currentKey = keys ? keys[index] : index;
		      if (!predicate(obj[currentKey], currentKey, obj)) return false;
		    }
		    return true;
		  };
	
		  // Determine if at least one element in the object matches a truth test.
		  // Aliased as `any`.
		  _.some = _.any = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var keys = !isArrayLike(obj) && _.keys(obj),
		        length = (keys || obj).length;
		    for (var index = 0; index < length; index++) {
		      var currentKey = keys ? keys[index] : index;
		      if (predicate(obj[currentKey], currentKey, obj)) return true;
		    }
		    return false;
		  };
	
		  // Determine if the array or object contains a given item (using `===`).
		  // Aliased as `includes` and `include`.
		  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
		    if (!isArrayLike(obj)) obj = _.values(obj);
		    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
		    return _.indexOf(obj, item, fromIndex) >= 0;
		  };
	
		  // Invoke a method (with arguments) on every item in a collection.
		  _.invoke = function(obj, method) {
		    var args = slice.call(arguments, 2);
		    var isFunc = _.isFunction(method);
		    return _.map(obj, function(value) {
		      var func = isFunc ? method : value[method];
		      return func == null ? func : func.apply(value, args);
		    });
		  };
	
		  // Convenience version of a common use case of `map`: fetching a property.
		  _.pluck = function(obj, key) {
		    return _.map(obj, _.property(key));
		  };
	
		  // Convenience version of a common use case of `filter`: selecting only objects
		  // containing specific `key:value` pairs.
		  _.where = function(obj, attrs) {
		    return _.filter(obj, _.matcher(attrs));
		  };
	
		  // Convenience version of a common use case of `find`: getting the first object
		  // containing specific `key:value` pairs.
		  _.findWhere = function(obj, attrs) {
		    return _.find(obj, _.matcher(attrs));
		  };
	
		  // Return the maximum element (or element-based computation).
		  _.max = function(obj, iteratee, context) {
		    var result = -Infinity, lastComputed = -Infinity,
		        value, computed;
		    if (iteratee == null && obj != null) {
		      obj = isArrayLike(obj) ? obj : _.values(obj);
		      for (var i = 0, length = obj.length; i < length; i++) {
		        value = obj[i];
		        if (value > result) {
		          result = value;
		        }
		      }
		    } else {
		      iteratee = cb(iteratee, context);
		      _.each(obj, function(value, index, list) {
		        computed = iteratee(value, index, list);
		        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
		          result = value;
		          lastComputed = computed;
		        }
		      });
		    }
		    return result;
		  };
	
		  // Return the minimum element (or element-based computation).
		  _.min = function(obj, iteratee, context) {
		    var result = Infinity, lastComputed = Infinity,
		        value, computed;
		    if (iteratee == null && obj != null) {
		      obj = isArrayLike(obj) ? obj : _.values(obj);
		      for (var i = 0, length = obj.length; i < length; i++) {
		        value = obj[i];
		        if (value < result) {
		          result = value;
		        }
		      }
		    } else {
		      iteratee = cb(iteratee, context);
		      _.each(obj, function(value, index, list) {
		        computed = iteratee(value, index, list);
		        if (computed < lastComputed || computed === Infinity && result === Infinity) {
		          result = value;
		          lastComputed = computed;
		        }
		      });
		    }
		    return result;
		  };
	
		  // Shuffle a collection, using the modern version of the
		  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
		  _.shuffle = function(obj) {
		    var set = isArrayLike(obj) ? obj : _.values(obj);
		    var length = set.length;
		    var shuffled = Array(length);
		    for (var index = 0, rand; index < length; index++) {
		      rand = _.random(0, index);
		      if (rand !== index) shuffled[index] = shuffled[rand];
		      shuffled[rand] = set[index];
		    }
		    return shuffled;
		  };
	
		  // Sample **n** random values from a collection.
		  // If **n** is not specified, returns a single random element.
		  // The internal `guard` argument allows it to work with `map`.
		  _.sample = function(obj, n, guard) {
		    if (n == null || guard) {
		      if (!isArrayLike(obj)) obj = _.values(obj);
		      return obj[_.random(obj.length - 1)];
		    }
		    return _.shuffle(obj).slice(0, Math.max(0, n));
		  };
	
		  // Sort the object's values by a criterion produced by an iteratee.
		  _.sortBy = function(obj, iteratee, context) {
		    iteratee = cb(iteratee, context);
		    return _.pluck(_.map(obj, function(value, index, list) {
		      return {
		        value: value,
		        index: index,
		        criteria: iteratee(value, index, list)
		      };
		    }).sort(function(left, right) {
		      var a = left.criteria;
		      var b = right.criteria;
		      if (a !== b) {
		        if (a > b || a === void 0) return 1;
		        if (a < b || b === void 0) return -1;
		      }
		      return left.index - right.index;
		    }), 'value');
		  };
	
		  // An internal function used for aggregate "group by" operations.
		  var group = function(behavior) {
		    return function(obj, iteratee, context) {
		      var result = {};
		      iteratee = cb(iteratee, context);
		      _.each(obj, function(value, index) {
		        var key = iteratee(value, index, obj);
		        behavior(result, value, key);
		      });
		      return result;
		    };
		  };
	
		  // Groups the object's values by a criterion. Pass either a string attribute
		  // to group by, or a function that returns the criterion.
		  _.groupBy = group(function(result, value, key) {
		    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
		  });
	
		  // Indexes the object's values by a criterion, similar to `groupBy`, but for
		  // when you know that your index values will be unique.
		  _.indexBy = group(function(result, value, key) {
		    result[key] = value;
		  });
	
		  // Counts instances of an object that group by a certain criterion. Pass
		  // either a string attribute to count by, or a function that returns the
		  // criterion.
		  _.countBy = group(function(result, value, key) {
		    if (_.has(result, key)) result[key]++; else result[key] = 1;
		  });
	
		  // Safely create a real, live array from anything iterable.
		  _.toArray = function(obj) {
		    if (!obj) return [];
		    if (_.isArray(obj)) return slice.call(obj);
		    if (isArrayLike(obj)) return _.map(obj, _.identity);
		    return _.values(obj);
		  };
	
		  // Return the number of elements in an object.
		  _.size = function(obj) {
		    if (obj == null) return 0;
		    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
		  };
	
		  // Split a collection into two arrays: one whose elements all satisfy the given
		  // predicate, and one whose elements all do not satisfy the predicate.
		  _.partition = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var pass = [], fail = [];
		    _.each(obj, function(value, key, obj) {
		      (predicate(value, key, obj) ? pass : fail).push(value);
		    });
		    return [pass, fail];
		  };
	
		  // Array Functions
		  // ---------------
	
		  // Get the first element of an array. Passing **n** will return the first N
		  // values in the array. Aliased as `head` and `take`. The **guard** check
		  // allows it to work with `_.map`.
		  _.first = _.head = _.take = function(array, n, guard) {
		    if (array == null) return void 0;
		    if (n == null || guard) return array[0];
		    return _.initial(array, array.length - n);
		  };
	
		  // Returns everything but the last entry of the array. Especially useful on
		  // the arguments object. Passing **n** will return all the values in
		  // the array, excluding the last N.
		  _.initial = function(array, n, guard) {
		    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
		  };
	
		  // Get the last element of an array. Passing **n** will return the last N
		  // values in the array.
		  _.last = function(array, n, guard) {
		    if (array == null) return void 0;
		    if (n == null || guard) return array[array.length - 1];
		    return _.rest(array, Math.max(0, array.length - n));
		  };
	
		  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
		  // Especially useful on the arguments object. Passing an **n** will return
		  // the rest N values in the array.
		  _.rest = _.tail = _.drop = function(array, n, guard) {
		    return slice.call(array, n == null || guard ? 1 : n);
		  };
	
		  // Trim out all falsy values from an array.
		  _.compact = function(array) {
		    return _.filter(array, _.identity);
		  };
	
		  // Internal implementation of a recursive `flatten` function.
		  var flatten = function(input, shallow, strict, startIndex) {
		    var output = [], idx = 0;
		    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
		      var value = input[i];
		      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
		        //flatten current level of array or arguments object
		        if (!shallow) value = flatten(value, shallow, strict);
		        var j = 0, len = value.length;
		        output.length += len;
		        while (j < len) {
		          output[idx++] = value[j++];
		        }
		      } else if (!strict) {
		        output[idx++] = value;
		      }
		    }
		    return output;
		  };
	
		  // Flatten out an array, either recursively (by default), or just one level.
		  _.flatten = function(array, shallow) {
		    return flatten(array, shallow, false);
		  };
	
		  // Return a version of the array that does not contain the specified value(s).
		  _.without = function(array) {
		    return _.difference(array, slice.call(arguments, 1));
		  };
	
		  // Produce a duplicate-free version of the array. If the array has already
		  // been sorted, you have the option of using a faster algorithm.
		  // Aliased as `unique`.
		  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
		    if (!_.isBoolean(isSorted)) {
		      context = iteratee;
		      iteratee = isSorted;
		      isSorted = false;
		    }
		    if (iteratee != null) iteratee = cb(iteratee, context);
		    var result = [];
		    var seen = [];
		    for (var i = 0, length = getLength(array); i < length; i++) {
		      var value = array[i],
		          computed = iteratee ? iteratee(value, i, array) : value;
		      if (isSorted) {
		        if (!i || seen !== computed) result.push(value);
		        seen = computed;
		      } else if (iteratee) {
		        if (!_.contains(seen, computed)) {
		          seen.push(computed);
		          result.push(value);
		        }
		      } else if (!_.contains(result, value)) {
		        result.push(value);
		      }
		    }
		    return result;
		  };
	
		  // Produce an array that contains the union: each distinct element from all of
		  // the passed-in arrays.
		  _.union = function() {
		    return _.uniq(flatten(arguments, true, true));
		  };
	
		  // Produce an array that contains every item shared between all the
		  // passed-in arrays.
		  _.intersection = function(array) {
		    var result = [];
		    var argsLength = arguments.length;
		    for (var i = 0, length = getLength(array); i < length; i++) {
		      var item = array[i];
		      if (_.contains(result, item)) continue;
		      for (var j = 1; j < argsLength; j++) {
		        if (!_.contains(arguments[j], item)) break;
		      }
		      if (j === argsLength) result.push(item);
		    }
		    return result;
		  };
	
		  // Take the difference between one array and a number of other arrays.
		  // Only the elements present in just the first array will remain.
		  _.difference = function(array) {
		    var rest = flatten(arguments, true, true, 1);
		    return _.filter(array, function(value){
		      return !_.contains(rest, value);
		    });
		  };
	
		  // Zip together multiple lists into a single array -- elements that share
		  // an index go together.
		  _.zip = function() {
		    return _.unzip(arguments);
		  };
	
		  // Complement of _.zip. Unzip accepts an array of arrays and groups
		  // each array's elements on shared indices
		  _.unzip = function(array) {
		    var length = array && _.max(array, getLength).length || 0;
		    var result = Array(length);
	
		    for (var index = 0; index < length; index++) {
		      result[index] = _.pluck(array, index);
		    }
		    return result;
		  };
	
		  // Converts lists into objects. Pass either a single array of `[key, value]`
		  // pairs, or two parallel arrays of the same length -- one of keys, and one of
		  // the corresponding values.
		  _.object = function(list, values) {
		    var result = {};
		    for (var i = 0, length = getLength(list); i < length; i++) {
		      if (values) {
		        result[list[i]] = values[i];
		      } else {
		        result[list[i][0]] = list[i][1];
		      }
		    }
		    return result;
		  };
	
		  // Generator function to create the findIndex and findLastIndex functions
		  function createPredicateIndexFinder(dir) {
		    return function(array, predicate, context) {
		      predicate = cb(predicate, context);
		      var length = getLength(array);
		      var index = dir > 0 ? 0 : length - 1;
		      for (; index >= 0 && index < length; index += dir) {
		        if (predicate(array[index], index, array)) return index;
		      }
		      return -1;
		    };
		  }
	
		  // Returns the first index on an array-like that passes a predicate test
		  _.findIndex = createPredicateIndexFinder(1);
		  _.findLastIndex = createPredicateIndexFinder(-1);
	
		  // Use a comparator function to figure out the smallest index at which
		  // an object should be inserted so as to maintain order. Uses binary search.
		  _.sortedIndex = function(array, obj, iteratee, context) {
		    iteratee = cb(iteratee, context, 1);
		    var value = iteratee(obj);
		    var low = 0, high = getLength(array);
		    while (low < high) {
		      var mid = Math.floor((low + high) / 2);
		      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
		    }
		    return low;
		  };
	
		  // Generator function to create the indexOf and lastIndexOf functions
		  function createIndexFinder(dir, predicateFind, sortedIndex) {
		    return function(array, item, idx) {
		      var i = 0, length = getLength(array);
		      if (typeof idx == 'number') {
		        if (dir > 0) {
		            i = idx >= 0 ? idx : Math.max(idx + length, i);
		        } else {
		            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
		        }
		      } else if (sortedIndex && idx && length) {
		        idx = sortedIndex(array, item);
		        return array[idx] === item ? idx : -1;
		      }
		      if (item !== item) {
		        idx = predicateFind(slice.call(array, i, length), _.isNaN);
		        return idx >= 0 ? idx + i : -1;
		      }
		      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
		        if (array[idx] === item) return idx;
		      }
		      return -1;
		    };
		  }
	
		  // Return the position of the first occurrence of an item in an array,
		  // or -1 if the item is not included in the array.
		  // If the array is large and already in sort order, pass `true`
		  // for **isSorted** to use binary search.
		  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
		  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
		  // Generate an integer Array containing an arithmetic progression. A port of
		  // the native Python `range()` function. See
		  // [the Python documentation](http://docs.python.org/library/functions.html#range).
		  _.range = function(start, stop, step) {
		    if (stop == null) {
		      stop = start || 0;
		      start = 0;
		    }
		    step = step || 1;
	
		    var length = Math.max(Math.ceil((stop - start) / step), 0);
		    var range = Array(length);
	
		    for (var idx = 0; idx < length; idx++, start += step) {
		      range[idx] = start;
		    }
	
		    return range;
		  };
	
		  // Function (ahem) Functions
		  // ------------------
	
		  // Determines whether to execute a function as a constructor
		  // or a normal function with the provided arguments
		  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
		    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
		    var self = baseCreate(sourceFunc.prototype);
		    var result = sourceFunc.apply(self, args);
		    if (_.isObject(result)) return result;
		    return self;
		  };
	
		  // Create a function bound to a given object (assigning `this`, and arguments,
		  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
		  // available.
		  _.bind = function(func, context) {
		    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
		    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
		    var args = slice.call(arguments, 2);
		    var bound = function() {
		      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
		    };
		    return bound;
		  };
	
		  // Partially apply a function by creating a version that has had some of its
		  // arguments pre-filled, without changing its dynamic `this` context. _ acts
		  // as a placeholder, allowing any combination of arguments to be pre-filled.
		  _.partial = function(func) {
		    var boundArgs = slice.call(arguments, 1);
		    var bound = function() {
		      var position = 0, length = boundArgs.length;
		      var args = Array(length);
		      for (var i = 0; i < length; i++) {
		        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
		      }
		      while (position < arguments.length) args.push(arguments[position++]);
		      return executeBound(func, bound, this, this, args);
		    };
		    return bound;
		  };
	
		  // Bind a number of an object's methods to that object. Remaining arguments
		  // are the method names to be bound. Useful for ensuring that all callbacks
		  // defined on an object belong to it.
		  _.bindAll = function(obj) {
		    var i, length = arguments.length, key;
		    if (length <= 1) throw new Error('bindAll must be passed function names');
		    for (i = 1; i < length; i++) {
		      key = arguments[i];
		      obj[key] = _.bind(obj[key], obj);
		    }
		    return obj;
		  };
	
		  // Memoize an expensive function by storing its results.
		  _.memoize = function(func, hasher) {
		    var memoize = function(key) {
		      var cache = memoize.cache;
		      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
		      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
		      return cache[address];
		    };
		    memoize.cache = {};
		    return memoize;
		  };
	
		  // Delays a function for the given number of milliseconds, and then calls
		  // it with the arguments supplied.
		  _.delay = function(func, wait) {
		    var args = slice.call(arguments, 2);
		    return setTimeout(function(){
		      return func.apply(null, args);
		    }, wait);
		  };
	
		  // Defers a function, scheduling it to run after the current call stack has
		  // cleared.
		  _.defer = _.partial(_.delay, _, 1);
	
		  // Returns a function, that, when invoked, will only be triggered at most once
		  // during a given window of time. Normally, the throttled function will run
		  // as much as it can, without ever going more than once per `wait` duration;
		  // but if you'd like to disable the execution on the leading edge, pass
		  // `{leading: false}`. To disable execution on the trailing edge, ditto.
		  _.throttle = function(func, wait, options) {
		    var context, args, result;
		    var timeout = null;
		    var previous = 0;
		    if (!options) options = {};
		    var later = function() {
		      previous = options.leading === false ? 0 : _.now();
		      timeout = null;
		      result = func.apply(context, args);
		      if (!timeout) context = args = null;
		    };
		    return function() {
		      var now = _.now();
		      if (!previous && options.leading === false) previous = now;
		      var remaining = wait - (now - previous);
		      context = this;
		      args = arguments;
		      if (remaining <= 0 || remaining > wait) {
		        if (timeout) {
		          clearTimeout(timeout);
		          timeout = null;
		        }
		        previous = now;
		        result = func.apply(context, args);
		        if (!timeout) context = args = null;
		      } else if (!timeout && options.trailing !== false) {
		        timeout = setTimeout(later, remaining);
		      }
		      return result;
		    };
		  };
	
		  // Returns a function, that, as long as it continues to be invoked, will not
		  // be triggered. The function will be called after it stops being called for
		  // N milliseconds. If `immediate` is passed, trigger the function on the
		  // leading edge, instead of the trailing.
		  _.debounce = function(func, wait, immediate) {
		    var timeout, args, context, timestamp, result;
	
		    var later = function() {
		      var last = _.now() - timestamp;
	
		      if (last < wait && last >= 0) {
		        timeout = setTimeout(later, wait - last);
		      } else {
		        timeout = null;
		        if (!immediate) {
		          result = func.apply(context, args);
		          if (!timeout) context = args = null;
		        }
		      }
		    };
	
		    return function() {
		      context = this;
		      args = arguments;
		      timestamp = _.now();
		      var callNow = immediate && !timeout;
		      if (!timeout) timeout = setTimeout(later, wait);
		      if (callNow) {
		        result = func.apply(context, args);
		        context = args = null;
		      }
	
		      return result;
		    };
		  };
	
		  // Returns the first function passed as an argument to the second,
		  // allowing you to adjust arguments, run code before and after, and
		  // conditionally execute the original function.
		  _.wrap = function(func, wrapper) {
		    return _.partial(wrapper, func);
		  };
	
		  // Returns a negated version of the passed-in predicate.
		  _.negate = function(predicate) {
		    return function() {
		      return !predicate.apply(this, arguments);
		    };
		  };
	
		  // Returns a function that is the composition of a list of functions, each
		  // consuming the return value of the function that follows.
		  _.compose = function() {
		    var args = arguments;
		    var start = args.length - 1;
		    return function() {
		      var i = start;
		      var result = args[start].apply(this, arguments);
		      while (i--) result = args[i].call(this, result);
		      return result;
		    };
		  };
	
		  // Returns a function that will only be executed on and after the Nth call.
		  _.after = function(times, func) {
		    return function() {
		      if (--times < 1) {
		        return func.apply(this, arguments);
		      }
		    };
		  };
	
		  // Returns a function that will only be executed up to (but not including) the Nth call.
		  _.before = function(times, func) {
		    var memo;
		    return function() {
		      if (--times > 0) {
		        memo = func.apply(this, arguments);
		      }
		      if (times <= 1) func = null;
		      return memo;
		    };
		  };
	
		  // Returns a function that will be executed at most one time, no matter how
		  // often you call it. Useful for lazy initialization.
		  _.once = _.partial(_.before, 2);
	
		  // Object Functions
		  // ----------------
	
		  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
		  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
		  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
		                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
		  function collectNonEnumProps(obj, keys) {
		    var nonEnumIdx = nonEnumerableProps.length;
		    var constructor = obj.constructor;
		    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
		    // Constructor is a special case.
		    var prop = 'constructor';
		    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
		    while (nonEnumIdx--) {
		      prop = nonEnumerableProps[nonEnumIdx];
		      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
		        keys.push(prop);
		      }
		    }
		  }
	
		  // Retrieve the names of an object's own properties.
		  // Delegates to **ECMAScript 5**'s native `Object.keys`
		  _.keys = function(obj) {
		    if (!_.isObject(obj)) return [];
		    if (nativeKeys) return nativeKeys(obj);
		    var keys = [];
		    for (var key in obj) if (_.has(obj, key)) keys.push(key);
		    // Ahem, IE < 9.
		    if (hasEnumBug) collectNonEnumProps(obj, keys);
		    return keys;
		  };
	
		  // Retrieve all the property names of an object.
		  _.allKeys = function(obj) {
		    if (!_.isObject(obj)) return [];
		    var keys = [];
		    for (var key in obj) keys.push(key);
		    // Ahem, IE < 9.
		    if (hasEnumBug) collectNonEnumProps(obj, keys);
		    return keys;
		  };
	
		  // Retrieve the values of an object's properties.
		  _.values = function(obj) {
		    var keys = _.keys(obj);
		    var length = keys.length;
		    var values = Array(length);
		    for (var i = 0; i < length; i++) {
		      values[i] = obj[keys[i]];
		    }
		    return values;
		  };
	
		  // Returns the results of applying the iteratee to each element of the object
		  // In contrast to _.map it returns an object
		  _.mapObject = function(obj, iteratee, context) {
		    iteratee = cb(iteratee, context);
		    var keys =  _.keys(obj),
		          length = keys.length,
		          results = {},
		          currentKey;
		      for (var index = 0; index < length; index++) {
		        currentKey = keys[index];
		        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
		      }
		      return results;
		  };
	
		  // Convert an object into a list of `[key, value]` pairs.
		  _.pairs = function(obj) {
		    var keys = _.keys(obj);
		    var length = keys.length;
		    var pairs = Array(length);
		    for (var i = 0; i < length; i++) {
		      pairs[i] = [keys[i], obj[keys[i]]];
		    }
		    return pairs;
		  };
	
		  // Invert the keys and values of an object. The values must be serializable.
		  _.invert = function(obj) {
		    var result = {};
		    var keys = _.keys(obj);
		    for (var i = 0, length = keys.length; i < length; i++) {
		      result[obj[keys[i]]] = keys[i];
		    }
		    return result;
		  };
	
		  // Return a sorted list of the function names available on the object.
		  // Aliased as `methods`
		  _.functions = _.methods = function(obj) {
		    var names = [];
		    for (var key in obj) {
		      if (_.isFunction(obj[key])) names.push(key);
		    }
		    return names.sort();
		  };
	
		  // Extend a given object with all the properties in passed-in object(s).
		  _.extend = createAssigner(_.allKeys);
	
		  // Assigns a given object with all the own properties in the passed-in object(s)
		  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
		  _.extendOwn = _.assign = createAssigner(_.keys);
	
		  // Returns the first key on an object that passes a predicate test
		  _.findKey = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var keys = _.keys(obj), key;
		    for (var i = 0, length = keys.length; i < length; i++) {
		      key = keys[i];
		      if (predicate(obj[key], key, obj)) return key;
		    }
		  };
	
		  // Return a copy of the object only containing the whitelisted properties.
		  _.pick = function(object, oiteratee, context) {
		    var result = {}, obj = object, iteratee, keys;
		    if (obj == null) return result;
		    if (_.isFunction(oiteratee)) {
		      keys = _.allKeys(obj);
		      iteratee = optimizeCb(oiteratee, context);
		    } else {
		      keys = flatten(arguments, false, false, 1);
		      iteratee = function(value, key, obj) { return key in obj; };
		      obj = Object(obj);
		    }
		    for (var i = 0, length = keys.length; i < length; i++) {
		      var key = keys[i];
		      var value = obj[key];
		      if (iteratee(value, key, obj)) result[key] = value;
		    }
		    return result;
		  };
	
		   // Return a copy of the object without the blacklisted properties.
		  _.omit = function(obj, iteratee, context) {
		    if (_.isFunction(iteratee)) {
		      iteratee = _.negate(iteratee);
		    } else {
		      var keys = _.map(flatten(arguments, false, false, 1), String);
		      iteratee = function(value, key) {
		        return !_.contains(keys, key);
		      };
		    }
		    return _.pick(obj, iteratee, context);
		  };
	
		  // Fill in a given object with default properties.
		  _.defaults = createAssigner(_.allKeys, true);
	
		  // Creates an object that inherits from the given prototype object.
		  // If additional properties are provided then they will be added to the
		  // created object.
		  _.create = function(prototype, props) {
		    var result = baseCreate(prototype);
		    if (props) _.extendOwn(result, props);
		    return result;
		  };
	
		  // Create a (shallow-cloned) duplicate of an object.
		  _.clone = function(obj) {
		    if (!_.isObject(obj)) return obj;
		    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
		  };
	
		  // Invokes interceptor with the obj, and then returns obj.
		  // The primary purpose of this method is to "tap into" a method chain, in
		  // order to perform operations on intermediate results within the chain.
		  _.tap = function(obj, interceptor) {
		    interceptor(obj);
		    return obj;
		  };
	
		  // Returns whether an object has a given set of `key:value` pairs.
		  _.isMatch = function(object, attrs) {
		    var keys = _.keys(attrs), length = keys.length;
		    if (object == null) return !length;
		    var obj = Object(object);
		    for (var i = 0; i < length; i++) {
		      var key = keys[i];
		      if (attrs[key] !== obj[key] || !(key in obj)) return false;
		    }
		    return true;
		  };
	
	
		  // Internal recursive comparison function for `isEqual`.
		  var eq = function(a, b, aStack, bStack) {
		    // Identical objects are equal. `0 === -0`, but they aren't identical.
		    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
		    if (a === b) return a !== 0 || 1 / a === 1 / b;
		    // A strict comparison is necessary because `null == undefined`.
		    if (a == null || b == null) return a === b;
		    // Unwrap any wrapped objects.
		    if (a instanceof _) a = a._wrapped;
		    if (b instanceof _) b = b._wrapped;
		    // Compare `[[Class]]` names.
		    var className = toString.call(a);
		    if (className !== toString.call(b)) return false;
		    switch (className) {
		      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
		      case '[object RegExp]':
		      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
		      case '[object String]':
		        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
		        // equivalent to `new String("5")`.
		        return '' + a === '' + b;
		      case '[object Number]':
		        // `NaN`s are equivalent, but non-reflexive.
		        // Object(NaN) is equivalent to NaN
		        if (+a !== +a) return +b !== +b;
		        // An `egal` comparison is performed for other numeric values.
		        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
		      case '[object Date]':
		      case '[object Boolean]':
		        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
		        // millisecond representations. Note that invalid dates with millisecond representations
		        // of `NaN` are not equivalent.
		        return +a === +b;
		    }
	
		    var areArrays = className === '[object Array]';
		    if (!areArrays) {
		      if (typeof a != 'object' || typeof b != 'object') return false;
	
		      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
		      // from different frames are.
		      var aCtor = a.constructor, bCtor = b.constructor;
		      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
		                               _.isFunction(bCtor) && bCtor instanceof bCtor)
		                          && ('constructor' in a && 'constructor' in b)) {
		        return false;
		      }
		    }
		    // Assume equality for cyclic structures. The algorithm for detecting cyclic
		    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
		    // Initializing stack of traversed objects.
		    // It's done here since we only need them for objects and arrays comparison.
		    aStack = aStack || [];
		    bStack = bStack || [];
		    var length = aStack.length;
		    while (length--) {
		      // Linear search. Performance is inversely proportional to the number of
		      // unique nested structures.
		      if (aStack[length] === a) return bStack[length] === b;
		    }
	
		    // Add the first object to the stack of traversed objects.
		    aStack.push(a);
		    bStack.push(b);
	
		    // Recursively compare objects and arrays.
		    if (areArrays) {
		      // Compare array lengths to determine if a deep comparison is necessary.
		      length = a.length;
		      if (length !== b.length) return false;
		      // Deep compare the contents, ignoring non-numeric properties.
		      while (length--) {
		        if (!eq(a[length], b[length], aStack, bStack)) return false;
		      }
		    } else {
		      // Deep compare objects.
		      var keys = _.keys(a), key;
		      length = keys.length;
		      // Ensure that both objects contain the same number of properties before comparing deep equality.
		      if (_.keys(b).length !== length) return false;
		      while (length--) {
		        // Deep compare each member
		        key = keys[length];
		        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
		      }
		    }
		    // Remove the first object from the stack of traversed objects.
		    aStack.pop();
		    bStack.pop();
		    return true;
		  };
	
		  // Perform a deep comparison to check if two objects are equal.
		  _.isEqual = function(a, b) {
		    return eq(a, b);
		  };
	
		  // Is a given array, string, or object empty?
		  // An "empty" object has no enumerable own-properties.
		  _.isEmpty = function(obj) {
		    if (obj == null) return true;
		    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
		    return _.keys(obj).length === 0;
		  };
	
		  // Is a given value a DOM element?
		  _.isElement = function(obj) {
		    return !!(obj && obj.nodeType === 1);
		  };
	
		  // Is a given value an array?
		  // Delegates to ECMA5's native Array.isArray
		  _.isArray = nativeIsArray || function(obj) {
		    return toString.call(obj) === '[object Array]';
		  };
	
		  // Is a given variable an object?
		  _.isObject = function(obj) {
		    var type = typeof obj;
		    return type === 'function' || type === 'object' && !!obj;
		  };
	
		  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
		  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
		    _['is' + name] = function(obj) {
		      return toString.call(obj) === '[object ' + name + ']';
		    };
		  });
	
		  // Define a fallback version of the method in browsers (ahem, IE < 9), where
		  // there isn't any inspectable "Arguments" type.
		  if (!_.isArguments(arguments)) {
		    _.isArguments = function(obj) {
		      return _.has(obj, 'callee');
		    };
		  }
	
		  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
		  // IE 11 (#1621), and in Safari 8 (#1929).
		  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
		    _.isFunction = function(obj) {
		      return typeof obj == 'function' || false;
		    };
		  }
	
		  // Is a given object a finite number?
		  _.isFinite = function(obj) {
		    return isFinite(obj) && !isNaN(parseFloat(obj));
		  };
	
		  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
		  _.isNaN = function(obj) {
		    return _.isNumber(obj) && obj !== +obj;
		  };
	
		  // Is a given value a boolean?
		  _.isBoolean = function(obj) {
		    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
		  };
	
		  // Is a given value equal to null?
		  _.isNull = function(obj) {
		    return obj === null;
		  };
	
		  // Is a given variable undefined?
		  _.isUndefined = function(obj) {
		    return obj === void 0;
		  };
	
		  // Shortcut function for checking if an object has a given property directly
		  // on itself (in other words, not on a prototype).
		  _.has = function(obj, key) {
		    return obj != null && hasOwnProperty.call(obj, key);
		  };
	
		  // Utility Functions
		  // -----------------
	
		  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
		  // previous owner. Returns a reference to the Underscore object.
		  _.noConflict = function() {
		    root._ = previousUnderscore;
		    return this;
		  };
	
		  // Keep the identity function around for default iteratees.
		  _.identity = function(value) {
		    return value;
		  };
	
		  // Predicate-generating functions. Often useful outside of Underscore.
		  _.constant = function(value) {
		    return function() {
		      return value;
		    };
		  };
	
		  _.noop = function(){};
	
		  _.property = property;
	
		  // Generates a function for a given object that returns a given property.
		  _.propertyOf = function(obj) {
		    return obj == null ? function(){} : function(key) {
		      return obj[key];
		    };
		  };
	
		  // Returns a predicate for checking whether an object has a given set of
		  // `key:value` pairs.
		  _.matcher = _.matches = function(attrs) {
		    attrs = _.extendOwn({}, attrs);
		    return function(obj) {
		      return _.isMatch(obj, attrs);
		    };
		  };
	
		  // Run a function **n** times.
		  _.times = function(n, iteratee, context) {
		    var accum = Array(Math.max(0, n));
		    iteratee = optimizeCb(iteratee, context, 1);
		    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
		    return accum;
		  };
	
		  // Return a random integer between min and max (inclusive).
		  _.random = function(min, max) {
		    if (max == null) {
		      max = min;
		      min = 0;
		    }
		    return min + Math.floor(Math.random() * (max - min + 1));
		  };
	
		  // A (possibly faster) way to get the current timestamp as an integer.
		  _.now = Date.now || function() {
		    return new Date().getTime();
		  };
	
		   // List of HTML entities for escaping.
		  var escapeMap = {
		    '&': '&amp;',
		    '<': '&lt;',
		    '>': '&gt;',
		    '"': '&quot;',
		    "'": '&#x27;',
		    '`': '&#x60;'
		  };
		  var unescapeMap = _.invert(escapeMap);
	
		  // Functions for escaping and unescaping strings to/from HTML interpolation.
		  var createEscaper = function(map) {
		    var escaper = function(match) {
		      return map[match];
		    };
		    // Regexes for identifying a key that needs to be escaped
		    var source = '(?:' + _.keys(map).join('|') + ')';
		    var testRegexp = RegExp(source);
		    var replaceRegexp = RegExp(source, 'g');
		    return function(string) {
		      string = string == null ? '' : '' + string;
		      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
		    };
		  };
		  _.escape = createEscaper(escapeMap);
		  _.unescape = createEscaper(unescapeMap);
	
		  // If the value of the named `property` is a function then invoke it with the
		  // `object` as context; otherwise, return it.
		  _.result = function(object, property, fallback) {
		    var value = object == null ? void 0 : object[property];
		    if (value === void 0) {
		      value = fallback;
		    }
		    return _.isFunction(value) ? value.call(object) : value;
		  };
	
		  // Generate a unique integer id (unique within the entire client session).
		  // Useful for temporary DOM ids.
		  var idCounter = 0;
		  _.uniqueId = function(prefix) {
		    var id = ++idCounter + '';
		    return prefix ? prefix + id : id;
		  };
	
		  // By default, Underscore uses ERB-style template delimiters, change the
		  // following template settings to use alternative delimiters.
		  _.templateSettings = {
		    evaluate    : /<%([\s\S]+?)%>/g,
		    interpolate : /<%=([\s\S]+?)%>/g,
		    escape      : /<%-([\s\S]+?)%>/g
		  };
	
		  // When customizing `templateSettings`, if you don't want to define an
		  // interpolation, evaluation or escaping regex, we need one that is
		  // guaranteed not to match.
		  var noMatch = /(.)^/;
	
		  // Certain characters need to be escaped so that they can be put into a
		  // string literal.
		  var escapes = {
		    "'":      "'",
		    '\\':     '\\',
		    '\r':     'r',
		    '\n':     'n',
		    '\u2028': 'u2028',
		    '\u2029': 'u2029'
		  };
	
		  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
		  var escapeChar = function(match) {
		    return '\\' + escapes[match];
		  };
	
		  // JavaScript micro-templating, similar to John Resig's implementation.
		  // Underscore templating handles arbitrary delimiters, preserves whitespace,
		  // and correctly escapes quotes within interpolated code.
		  // NB: `oldSettings` only exists for backwards compatibility.
		  _.template = function(text, settings, oldSettings) {
		    if (!settings && oldSettings) settings = oldSettings;
		    settings = _.defaults({}, settings, _.templateSettings);
	
		    // Combine delimiters into one regular expression via alternation.
		    var matcher = RegExp([
		      (settings.escape || noMatch).source,
		      (settings.interpolate || noMatch).source,
		      (settings.evaluate || noMatch).source
		    ].join('|') + '|$', 'g');
	
		    // Compile the template source, escaping string literals appropriately.
		    var index = 0;
		    var source = "__p+='";
		    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
		      source += text.slice(index, offset).replace(escaper, escapeChar);
		      index = offset + match.length;
	
		      if (escape) {
		        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
		      } else if (interpolate) {
		        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
		      } else if (evaluate) {
		        source += "';\n" + evaluate + "\n__p+='";
		      }
	
		      // Adobe VMs need the match returned to produce the correct offest.
		      return match;
		    });
		    source += "';\n";
	
		    // If a variable is not specified, place data values in local scope.
		    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
		    source = "var __t,__p='',__j=Array.prototype.join," +
		      "print=function(){__p+=__j.call(arguments,'');};\n" +
		      source + 'return __p;\n';
	
		    try {
		      var render = new Function(settings.variable || 'obj', '_', source);
		    } catch (e) {
		      e.source = source;
		      throw e;
		    }
	
		    var template = function(data) {
		      return render.call(this, data, _);
		    };
	
		    // Provide the compiled source as a convenience for precompilation.
		    var argument = settings.variable || 'obj';
		    template.source = 'function(' + argument + '){\n' + source + '}';
	
		    return template;
		  };
	
		  // Add a "chain" function. Start chaining a wrapped Underscore object.
		  _.chain = function(obj) {
		    var instance = _(obj);
		    instance._chain = true;
		    return instance;
		  };
	
		  // OOP
		  // ---------------
		  // If Underscore is called as a function, it returns a wrapped object that
		  // can be used OO-style. This wrapper holds altered versions of all the
		  // underscore functions. Wrapped objects may be chained.
	
		  // Helper function to continue chaining intermediate results.
		  var result = function(instance, obj) {
		    return instance._chain ? _(obj).chain() : obj;
		  };
	
		  // Add your own custom functions to the Underscore object.
		  _.mixin = function(obj) {
		    _.each(_.functions(obj), function(name) {
		      var func = _[name] = obj[name];
		      _.prototype[name] = function() {
		        var args = [this._wrapped];
		        push.apply(args, arguments);
		        return result(this, func.apply(_, args));
		      };
		    });
		  };
	
		  // Add all of the Underscore functions to the wrapper object.
		  _.mixin(_);
	
		  // Add all mutator Array functions to the wrapper.
		  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
		    var method = ArrayProto[name];
		    _.prototype[name] = function() {
		      var obj = this._wrapped;
		      method.apply(obj, arguments);
		      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
		      return result(this, obj);
		    };
		  });
	
		  // Add all accessor Array functions to the wrapper.
		  _.each(['concat', 'join', 'slice'], function(name) {
		    var method = ArrayProto[name];
		    _.prototype[name] = function() {
		      return result(this, method.apply(this._wrapped, arguments));
		    };
		  });
	
		  // Extracts the result from a wrapped and chained object.
		  _.prototype.value = function() {
		    return this._wrapped;
		  };
	
		  // Provide unwrapping proxy for some methods used in engine operations
		  // such as arithmetic and JSON stringification.
		  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
		  _.prototype.toString = function() {
		    return '' + this._wrapped;
		  };
	
		  // AMD registration happens at the end for compatibility with AMD loaders
		  // that may not enforce next-turn semantics on modules. Even though general
		  // practice for AMD registration is to be anonymous, underscore registers
		  // as a named module because, like jQuery, it is a base library that is
		  // popular enough to be bundled in a third party lib, but not be part of
		  // an AMD load request. Those cases could generate an error when an
		  // anonymous define() is called outside of a loader request.
		  if (true) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		      return _;
		    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		  }
		}.call(this));
	
	
	/***/ }),
	/* 98 */,
	/* 99 */,
	/* 100 */,
	/* 101 */,
	/* 102 */,
	/* 103 */,
	/* 104 */,
	/* 105 */,
	/* 106 */,
	/* 107 */,
	/* 108 */,
	/* 109 */,
	/* 110 */,
	/* 111 */,
	/* 112 */,
	/* 113 */,
	/* 114 */,
	/* 115 */,
	/* 116 */,
	/* 117 */,
	/* 118 */,
	/* 119 */,
	/* 120 */,
	/* 121 */,
	/* 122 */,
	/* 123 */,
	/* 124 */,
	/* 125 */,
	/* 126 */,
	/* 127 */,
	/* 128 */,
	/* 129 */,
	/* 130 */,
	/* 131 */,
	/* 132 */,
	/* 133 */,
	/* 134 */,
	/* 135 */,
	/* 136 */,
	/* 137 */,
	/* 138 */,
	/* 139 */,
	/* 140 */,
	/* 141 */,
	/* 142 */,
	/* 143 */,
	/* 144 */,
	/* 145 */,
	/* 146 */,
	/* 147 */,
	/* 148 */,
	/* 149 */,
	/* 150 */,
	/* 151 */,
	/* 152 */,
	/* 153 */,
	/* 154 */,
	/* 155 */,
	/* 156 */,
	/* 157 */,
	/* 158 */,
	/* 159 */,
	/* 160 */,
	/* 161 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _shallowEqual = __webpack_require__(70);
	
		var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
		var _RowsContainer = __webpack_require__(64);
	
		var _RowsContainer2 = _interopRequireDefault(_RowsContainer);
	
		var _RowGroup = __webpack_require__(175);
	
		var _RowGroup2 = _interopRequireDefault(_RowGroup);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var PropTypes = React.PropTypes;
		var ScrollShim = __webpack_require__(176);
		var Row = __webpack_require__(34);
		var cellMetaDataShape = __webpack_require__(14);
		var RowUtils = __webpack_require__(63);
		__webpack_require__(26);
	
		var Canvas = React.createClass({
		  displayName: 'Canvas',
	
		  mixins: [ScrollShim],
	
		  propTypes: {
		    rowRenderer: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
		    rowHeight: PropTypes.number.isRequired,
		    height: PropTypes.number.isRequired,
		    width: PropTypes.number,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    style: PropTypes.string,
		    className: PropTypes.string,
		    displayStart: PropTypes.number.isRequired,
		    displayEnd: PropTypes.number.isRequired,
		    visibleStart: PropTypes.number.isRequired,
		    visibleEnd: PropTypes.number.isRequired,
		    colVisibleStart: PropTypes.number.isRequired,
		    colVisibleEnd: PropTypes.number.isRequired,
		    colDisplayStart: PropTypes.number.isRequired,
		    colDisplayEnd: PropTypes.number.isRequired,
		    rowsCount: PropTypes.number.isRequired,
		    rowGetter: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.array.isRequired]),
		    expandedRows: PropTypes.array,
		    onRows: PropTypes.func,
		    onScroll: PropTypes.func,
		    columns: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
		    cellMetaData: PropTypes.shape(cellMetaDataShape).isRequired,
		    selectedRows: PropTypes.array,
		    rowKey: React.PropTypes.string,
		    rowScrollTimeout: React.PropTypes.number,
		    contextMenu: PropTypes.element,
		    getSubRowDetails: PropTypes.func,
		    rowSelection: React.PropTypes.oneOfType([React.PropTypes.shape({
		      indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		    }), React.PropTypes.shape({
		      isSelectedKey: React.PropTypes.string.isRequired
		    }), React.PropTypes.shape({
		      keys: React.PropTypes.shape({
		        values: React.PropTypes.array.isRequired,
		        rowKey: React.PropTypes.string.isRequired
		      }).isRequired
		    })]),
		    rowGroupRenderer: React.PropTypes.func,
		    isScrolling: React.PropTypes.bool
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      rowRenderer: Row,
		      onRows: function onRows() {},
		      selectedRows: [],
		      rowScrollTimeout: 0
		    };
		  },
		  getInitialState: function getInitialState() {
		    return {
		      displayStart: this.props.displayStart,
		      displayEnd: this.props.displayEnd,
		      scrollingTimeout: null
		    };
		  },
		  componentWillMount: function componentWillMount() {
		    this._currentRowsLength = 0;
		    this._currentRowsRange = { start: 0, end: 0 };
		    this._scroll = { scrollTop: 0, scrollLeft: 0 };
		  },
		  componentDidMount: function componentDidMount() {
		    this.onRows();
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (nextProps.displayStart !== this.state.displayStart || nextProps.displayEnd !== this.state.displayEnd) {
		      this.setState({
		        displayStart: nextProps.displayStart,
		        displayEnd: nextProps.displayEnd
		      });
		    }
		  },
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
		    var shouldUpdate = nextState.displayStart !== this.state.displayStart || nextState.displayEnd !== this.state.displayEnd || nextState.scrollingTimeout !== this.state.scrollingTimeout || nextProps.rowsCount !== this.props.rowsCount || nextProps.rowHeight !== this.props.rowHeight || nextProps.columns !== this.props.columns || nextProps.width !== this.props.width || nextProps.height !== this.props.height || nextProps.cellMetaData !== this.props.cellMetaData || this.props.colDisplayStart !== nextProps.colDisplayStart || this.props.colDisplayEnd !== nextProps.colDisplayEnd || this.props.colVisibleStart !== nextProps.colVisibleStart || this.props.colVisibleEnd !== nextProps.colVisibleEnd || !(0, _shallowEqual2['default'])(nextProps.style, this.props.style);
		    return shouldUpdate;
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    this._currentRowsLength = 0;
		    this._currentRowsRange = { start: 0, end: 0 };
		    this._scroll = { scrollTop: 0, scrollLeft: 0 };
		  },
		  componentDidUpdate: function componentDidUpdate() {
		    if (this._scroll.scrollTop !== 0 && this._scroll.scrollLeft !== 0) {
		      this.setScrollLeft(this._scroll.scrollLeft);
		    }
		    this.onRows();
		  },
		  onRows: function onRows() {
		    if (this._currentRowsRange !== { start: 0, end: 0 }) {
		      this.props.onRows(this._currentRowsRange);
		      this._currentRowsRange = { start: 0, end: 0 };
		    }
		  },
		  onScroll: function onScroll(e) {
		    if (ReactDOM.findDOMNode(this) !== e.target) {
		      return;
		    }
		    this.appendScrollShim();
		    var scrollLeft = e.target.scrollLeft;
		    var scrollTop = e.target.scrollTop;
		    var scroll = { scrollTop: scrollTop, scrollLeft: scrollLeft };
		    this._scroll = scroll;
		    this.props.onScroll(scroll);
		  },
		  getSubRows: function getSubRows(row) {
		    var subRowDetails = this.props.getSubRowDetails(row);
		    if (subRowDetails.expanded === true) {
		      return subRowDetails.children.map(function (r) {
		        return { row: r };
		      });
		    }
		  },
		  addSubRows: function addSubRows(rowsInput, row, i, displayEnd, treeDepth) {
		    var _this = this;
	
		    var subRowDetails = this.props.getSubRowDetails(row) || {};
		    var rows = rowsInput;
		    var increment = i;
		    if (increment < displayEnd) {
		      subRowDetails.treeDepth = treeDepth;
		      rows.push({ row: row, subRowDetails: subRowDetails });
		      increment++;
		    }
		    if (subRowDetails && subRowDetails.expanded) {
		      var subRows = this.getSubRows(row);
		      subRows.forEach(function (sr) {
		        var result = _this.addSubRows(rows, sr.row, increment, displayEnd, treeDepth + 1);
		        rows = result.rows;
		        increment = result.increment;
		      });
		    }
		    return { rows: rows, increment: increment };
		  },
		  getRows: function getRows(displayStart, displayEnd) {
		    this._currentRowsRange = { start: displayStart, end: displayEnd };
		    if (Array.isArray(this.props.rowGetter)) {
		      return this.props.rowGetter.slice(displayStart, displayEnd);
		    }
		    var rows = [];
		    var rowFetchIndex = displayStart;
		    var i = displayStart;
		    while (i < displayEnd) {
		      var row = this.props.rowGetter(rowFetchIndex);
		      if (this.props.getSubRowDetails) {
		        var treeDepth = 0;
		        var result = this.addSubRows(rows, row, i, displayEnd, treeDepth);
		        rows = result.rows;
		        i = result.increment;
		      } else {
		        rows.push({ row: row });
		        i++;
		      }
		      rowFetchIndex++;
		    }
		    return rows;
		  },
		  getScrollbarWidth: function getScrollbarWidth() {
		    var scrollbarWidth = 0;
		    // Get the scrollbar width
		    var canvas = ReactDOM.findDOMNode(this);
		    scrollbarWidth = canvas.offsetWidth - canvas.clientWidth;
		    return scrollbarWidth;
		  },
		  getScroll: function getScroll() {
		    var _ReactDOM$findDOMNode = ReactDOM.findDOMNode(this),
		        scrollTop = _ReactDOM$findDOMNode.scrollTop,
		        scrollLeft = _ReactDOM$findDOMNode.scrollLeft;
	
		    return { scrollTop: scrollTop, scrollLeft: scrollLeft };
		  },
		  isRowSelected: function isRowSelected(idx, row) {
		    var _this2 = this;
	
		    // Use selectedRows if set
		    if (this.props.selectedRows !== null) {
		      var selectedRows = this.props.selectedRows.filter(function (r) {
		        var rowKeyValue = row.get ? row.get(_this2.props.rowKey) : row[_this2.props.rowKey];
		        return r[_this2.props.rowKey] === rowKeyValue;
		      });
		      return selectedRows.length > 0 && selectedRows[0].isSelected;
		    }
	
		    // Else use new rowSelection props
		    if (this.props.rowSelection) {
		      var _props$rowSelection = this.props.rowSelection,
		          keys = _props$rowSelection.keys,
		          indexes = _props$rowSelection.indexes,
		          isSelectedKey = _props$rowSelection.isSelectedKey;
	
		      return RowUtils.isRowSelected(keys, indexes, isSelectedKey, row, idx);
		    }
	
		    return false;
		  },
	
	
		  _currentRowsLength: 0,
		  _currentRowsRange: { start: 0, end: 0 },
		  _scroll: { scrollTop: 0, scrollLeft: 0 },
	
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    if (this._currentRowsLength !== 0) {
		      if (!this.rows) return;
		      for (var i = 0, len = this._currentRowsLength; i < len; i++) {
		        if (this.rows[i]) {
		          var row = this.getRowByRef(i);
		          if (row && row.setScrollLeft) {
		            row.setScrollLeft(scrollLeft);
		          }
		        }
		      }
		    }
		  },
		  getRowByRef: function getRowByRef(i) {
		    // check if wrapped with React DND drop target
		    var wrappedRow = this.rows[i].getDecoratedComponentInstance ? this.rows[i].getDecoratedComponentInstance(i) : null;
		    if (wrappedRow) {
		      return wrappedRow.row;
		    }
		    return this.rows[i];
		  },
	
	
		  rows: [],
	
		  renderRow: function renderRow(props) {
		    var row = props.row;
		    if (row.__metaData && row.__metaData.isGroup) {
		      return React.createElement(_RowGroup2['default'], _extends({
		        key: props.key,
		        name: row.name
		      }, row.__metaData, {
		        row: props.row,
		        idx: props.idx,
		        height: props.height,
		        cellMetaData: this.props.cellMetaData,
		        renderer: this.props.rowGroupRenderer,
		        columns: props.columns
		      }));
		    }
		    var RowsRenderer = this.props.rowRenderer;
		    if (typeof RowsRenderer === 'function') {
		      return React.createElement(RowsRenderer, props);
		    }
	
		    if (React.isValidElement(this.props.rowRenderer)) {
		      return React.cloneElement(this.props.rowRenderer, props);
		    }
		  },
		  renderPlaceholder: function renderPlaceholder(key, height) {
		    // just renders empty cells
		    // if we wanted to show gridlines, we'd need classes and position as with renderScrollingPlaceholder
		    return React.createElement(
		      'div',
		      { key: key, style: { height: height } },
		      this.props.columns.map(function (column, idx) {
		        return React.createElement('div', { style: { width: column.width }, key: idx });
		      })
		    );
		  },
		  render: function render() {
		    var _this3 = this;
	
		    var _state = this.state,
		        displayStart = _state.displayStart,
		        displayEnd = _state.displayEnd;
		    var _props = this.props,
		        rowHeight = _props.rowHeight,
		        rowsCount = _props.rowsCount;
	
	
		    var rows = this.getRows(displayStart, displayEnd).map(function (r, idx) {
		      return _this3.renderRow({
		        key: 'row-' + (displayStart + idx),
		        ref: function ref(node) {
		          return _this3.rows[idx] = node;
		        },
		        idx: displayStart + idx,
		        visibleStart: _this3.props.visibleStart,
		        visibleEnd: _this3.props.visibleEnd,
		        row: r.row,
		        height: rowHeight,
		        onMouseOver: _this3.onMouseOver,
		        columns: _this3.props.columns,
		        isSelected: _this3.isRowSelected(displayStart + idx, r.row, displayStart, displayEnd),
		        expandedRows: _this3.props.expandedRows,
		        cellMetaData: _this3.props.cellMetaData,
		        subRowDetails: r.subRowDetails,
		        colVisibleStart: _this3.props.colVisibleStart,
		        colVisibleEnd: _this3.props.colVisibleEnd,
		        colDisplayStart: _this3.props.colDisplayStart,
		        colDisplayEnd: _this3.props.colDisplayEnd,
		        isScrolling: _this3.props.isScrolling
		      });
		    });
	
		    this._currentRowsLength = rows.length;
	
		    if (displayStart > 0) {
		      rows.unshift(this.renderPlaceholder('top', displayStart * rowHeight));
		    }
	
		    if (rowsCount - displayEnd > 0) {
		      rows.push(this.renderPlaceholder('bottom', (rowsCount - displayEnd) * rowHeight));
		    }
	
		    var style = {
		      position: 'absolute',
		      top: 0,
		      left: 0,
		      overflowX: 'auto',
		      overflowY: 'scroll',
		      width: this.props.totalWidth,
		      height: this.props.height
		    };
	
		    return React.createElement(
		      'div',
		      {
		        style: style,
		        onScroll: this.onScroll,
		        className: joinClasses('react-grid-Canvas', this.props.className, { opaque: this.props.cellMetaData.selected && this.props.cellMetaData.selected.active }) },
		      React.createElement(_RowsContainer2['default'], {
		        width: this.props.width,
		        rows: rows,
		        contextMenu: this.props.contextMenu,
		        rowIdx: this.props.cellMetaData.selected.rowIdx,
		        idx: this.props.cellMetaData.selected.idx })
		    );
		  }
		});
	
		module.exports = Canvas;
	
	/***/ }),
	/* 162 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isValidElement = __webpack_require__(2).isValidElement;
	
		module.exports = function sameColumn(a, b) {
		  var k = void 0;
	
		  for (k in a) {
		    if (a.hasOwnProperty(k)) {
		      if (typeof a[k] === 'function' && typeof b[k] === 'function' || isValidElement(a[k]) && isValidElement(b[k])) {
		        continue;
		      }
		      if (!b.hasOwnProperty(k) || a[k] !== b[k]) {
		        return false;
		      }
		    }
		  }
	
		  for (k in b) {
		    if (b.hasOwnProperty(k) && !a.hasOwnProperty(k)) {
		      return false;
		    }
		  }
	
		  return true;
		};
	
	/***/ }),
	/* 163 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var ColumnMetrics = __webpack_require__(33);
		var DOMMetrics = __webpack_require__(23);
		Object.assign = __webpack_require__(71);
		var PropTypes = __webpack_require__(2).PropTypes;
		var ColumnUtils = __webpack_require__(10);
	
		var Column = function Column() {
		  _classCallCheck(this, Column);
		};
	
		module.exports = {
		  mixins: [DOMMetrics.MetricsMixin],
	
		  propTypes: {
		    columns: PropTypes.arrayOf(Column),
		    minColumnWidth: PropTypes.number,
		    columnEquality: PropTypes.func,
		    onColumnResize: PropTypes.func
		  },
	
		  DOMMetrics: {
		    gridWidth: function gridWidth() {
		      return _reactDom2['default'].findDOMNode(this).parentElement.offsetWidth;
		    }
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      minColumnWidth: 80,
		      columnEquality: ColumnMetrics.sameColumn
		    };
		  },
		  componentWillMount: function componentWillMount() {
		    this._mounted = true;
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (nextProps.columns) {
		      if (!ColumnMetrics.sameColumns(this.props.columns, nextProps.columns, this.props.columnEquality) || nextProps.minWidth !== this.props.minWidth) {
		        var columnMetrics = this.createColumnMetrics(nextProps);
		        this.setState({ columnMetrics: columnMetrics });
		      }
		    }
		  },
		  getTotalWidth: function getTotalWidth() {
		    var totalWidth = 0;
		    if (this._mounted) {
		      totalWidth = this.DOMMetrics.gridWidth();
		    } else {
		      totalWidth = ColumnUtils.getSize(this.props.columns) * this.props.minColumnWidth;
		    }
		    return totalWidth;
		  },
		  getColumnMetricsType: function getColumnMetricsType(metrics) {
		    var totalWidth = metrics.totalWidth || this.getTotalWidth();
		    var currentMetrics = {
		      columns: metrics.columns,
		      totalWidth: totalWidth,
		      minColumnWidth: metrics.minColumnWidth
		    };
		    var updatedMetrics = ColumnMetrics.recalculate(currentMetrics);
		    return updatedMetrics;
		  },
		  getColumn: function getColumn(idx) {
		    var columns = this.state.columnMetrics.columns;
		    if (Array.isArray(columns)) {
		      return columns[idx];
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.get(idx);
		    }
		  },
		  getSize: function getSize() {
		    var columns = this.state.columnMetrics.columns;
		    if (Array.isArray(columns)) {
		      return columns.length;
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.size;
		    }
		  },
		  metricsUpdated: function metricsUpdated() {
		    var columnMetrics = this.createColumnMetrics();
		    this.setState({ columnMetrics: columnMetrics });
		  },
		  createColumnMetrics: function createColumnMetrics() {
		    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
		    var gridColumns = this.setupGridColumns(props);
		    return this.getColumnMetricsType({
		      columns: gridColumns,
		      minColumnWidth: this.props.minColumnWidth,
		      totalWidth: props.minWidth
		    });
		  },
		  onColumnResize: function onColumnResize(index, width) {
		    var columnMetrics = ColumnMetrics.resizeColumn(this.state.columnMetrics, index, width);
		    this.setState({ columnMetrics: columnMetrics });
		    if (this.props.onColumnResize) {
		      this.props.onColumnResize(index, width);
		    }
		  }
		};
	
	/***/ }),
	/* 164 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var PropTypes = React.PropTypes;
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(19);
	
		// The list of the propTypes that we want to include in the Draggable div
		var knownDivPropertyKeys = ['onDragStart', 'onDragEnd', 'onDrag', 'style'];
	
		var Draggable = React.createClass({
		  displayName: 'Draggable',
	
		  propTypes: {
		    onDragStart: PropTypes.func,
		    onDragEnd: PropTypes.func,
		    onDrag: PropTypes.func,
		    component: PropTypes.oneOfType([PropTypes.func, PropTypes.constructor]),
		    style: PropTypes.object
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      onDragStart: function onDragStart() {
		        return true;
		      },
		      onDragEnd: function onDragEnd() {},
		      onDrag: function onDrag() {}
		    };
		  },
		  getInitialState: function getInitialState() {
		    return {
		      drag: null
		    };
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    this.cleanUp();
		  },
		  onMouseDown: function onMouseDown(e) {
		    var drag = this.props.onDragStart(e);
	
		    if (drag === null && e.button !== 0) {
		      return;
		    }
	
		    window.addEventListener('mouseup', this.onMouseUp);
		    window.addEventListener('mousemove', this.onMouseMove);
		    window.addEventListener('touchend', this.onMouseUp);
		    window.addEventListener('touchmove', this.onMouseMove);
	
		    this.setState({ drag: drag });
		  },
		  onMouseMove: function onMouseMove(e) {
		    if (this.state.drag === null) {
		      return;
		    }
	
		    if (e.preventDefault) {
		      e.preventDefault();
		    }
	
		    this.props.onDrag(e);
		  },
		  onMouseUp: function onMouseUp(e) {
		    this.cleanUp();
		    this.props.onDragEnd(e, this.state.drag);
		    this.setState({ drag: null });
		  },
		  cleanUp: function cleanUp() {
		    window.removeEventListener('mouseup', this.onMouseUp);
		    window.removeEventListener('mousemove', this.onMouseMove);
		    window.removeEventListener('touchend', this.onMouseUp);
		    window.removeEventListener('touchmove', this.onMouseMove);
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  render: function render() {
		    return React.createElement('div', _extends({}, this.getKnownDivProps(), {
		      onMouseDown: this.onMouseDown,
		      onTouchStart: this.onMouseDown,
		      className: 'react-grid-HeaderCell__draggable' }));
		  }
		});
	
		module.exports = Draggable;
	
	/***/ }),
	/* 165 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var PropTypes = React.PropTypes;
		var Header = __webpack_require__(167);
		var Viewport = __webpack_require__(177);
		var GridScrollMixin = __webpack_require__(166);
		var DOMMetrics = __webpack_require__(23);
		var cellMetaDataShape = __webpack_require__(14);
		__webpack_require__(26);
	
		var Grid = React.createClass({
		  displayName: 'Grid',
	
		  propTypes: {
		    rowGetter: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
		    columns: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
		    columnMetrics: PropTypes.object,
		    minHeight: PropTypes.number,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    headerRows: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
		    rowHeight: PropTypes.number,
		    rowRenderer: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
		    emptyRowsView: PropTypes.func,
		    expandedRows: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
		    selectedRows: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
		    rowSelection: React.PropTypes.oneOfType([React.PropTypes.shape({
		      indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		    }), React.PropTypes.shape({
		      isSelectedKey: React.PropTypes.string.isRequired
		    }), React.PropTypes.shape({
		      keys: React.PropTypes.shape({
		        values: React.PropTypes.array.isRequired,
		        rowKey: React.PropTypes.string.isRequired
		      }).isRequired
		    })]),
		    rowsCount: PropTypes.number,
		    onRows: PropTypes.func,
		    sortColumn: React.PropTypes.string,
		    sortDirection: React.PropTypes.oneOf(['ASC', 'DESC', 'NONE']),
		    rowOffsetHeight: PropTypes.number.isRequired,
		    onViewportKeydown: PropTypes.func.isRequired,
		    onViewportKeyup: PropTypes.func,
		    onViewportDragStart: PropTypes.func.isRequired,
		    onViewportDragEnd: PropTypes.func.isRequired,
		    onViewportDoubleClick: PropTypes.func.isRequired,
		    onColumnResize: PropTypes.func,
		    onSort: PropTypes.func,
		    onHeaderDrop: PropTypes.func,
		    cellMetaData: PropTypes.shape(cellMetaDataShape),
		    rowKey: PropTypes.string.isRequired,
		    rowScrollTimeout: PropTypes.number,
		    contextMenu: PropTypes.element,
		    getSubRowDetails: PropTypes.func,
		    draggableHeaderCell: PropTypes.func,
		    getValidFilterValues: PropTypes.func,
		    rowGroupRenderer: PropTypes.func,
		    overScan: PropTypes.object
		  },
	
		  mixins: [GridScrollMixin, DOMMetrics.MetricsComputatorMixin],
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      rowHeight: 35,
		      minHeight: 350
		    };
		  },
	
	
		  getStyle: function getStyle() {
		    return {
		      overflow: 'hidden',
		      outline: 0,
		      position: 'relative',
		      minHeight: this.props.minHeight
		    };
		  },
	
		  render: function render() {
		    var _this = this;
	
		    var headerRows = this.props.headerRows || [{ ref: function ref(node) {
		        return _this.row = node;
		      } }];
		    var EmptyRowsView = this.props.emptyRowsView;
	
		    return React.createElement(
		      'div',
		      { style: this.getStyle(), className: 'react-grid-Grid' },
		      React.createElement(Header, {
		        ref: function ref(input) {
		          _this.header = input;
		        },
		        columnMetrics: this.props.columnMetrics,
		        onColumnResize: this.props.onColumnResize,
		        height: this.props.rowHeight,
		        totalWidth: this.props.totalWidth,
		        headerRows: headerRows,
		        sortColumn: this.props.sortColumn,
		        sortDirection: this.props.sortDirection,
		        draggableHeaderCell: this.props.draggableHeaderCell,
		        onSort: this.props.onSort,
		        onHeaderDrop: this.props.onHeaderDrop,
		        onScroll: this.onHeaderScroll,
		        getValidFilterValues: this.props.getValidFilterValues,
		        cellMetaData: this.props.cellMetaData
		      }),
		      this.props.rowsCount >= 1 || this.props.rowsCount === 0 && !this.props.emptyRowsView ? React.createElement(
		        'div',
		        { ref: function ref(node) {
		            _this.viewPortContainer = node;
		          }, tabIndex: '0', onKeyDown: this.props.onViewportKeydown, onKeyUp: this.props.onViewportKeyup, onDoubleClick: this.props.onViewportDoubleClick, onDragStart: this.props.onViewportDragStart, onDragEnd: this.props.onViewportDragEnd },
		        React.createElement(Viewport, {
		          ref: function ref(node) {
		            _this.viewport = node;
		          },
		          rowKey: this.props.rowKey,
		          width: this.props.columnMetrics.width,
		          rowHeight: this.props.rowHeight,
		          rowRenderer: this.props.rowRenderer,
		          rowGetter: this.props.rowGetter,
		          rowsCount: this.props.rowsCount,
		          selectedRows: this.props.selectedRows,
		          expandedRows: this.props.expandedRows,
		          columnMetrics: this.props.columnMetrics,
		          totalWidth: this.props.totalWidth,
		          onScroll: this.onScroll,
		          onRows: this.props.onRows,
		          cellMetaData: this.props.cellMetaData,
		          rowOffsetHeight: this.props.rowOffsetHeight || this.props.rowHeight * headerRows.length,
		          minHeight: this.props.minHeight,
		          rowScrollTimeout: this.props.rowScrollTimeout,
		          contextMenu: this.props.contextMenu,
		          rowSelection: this.props.rowSelection,
		          getSubRowDetails: this.props.getSubRowDetails,
		          rowGroupRenderer: this.props.rowGroupRenderer,
		          overScan: this.props.overScan
		        })
		      ) : React.createElement(
		        'div',
		        { ref: function ref(node) {
		            _this.emptyView = node;
		          }, className: 'react-grid-Empty' },
		        React.createElement(EmptyRowsView, null)
		      )
		    );
		  }
		});
	
		module.exports = Grid;
	
	/***/ }),
	/* 166 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var ReactDOM = __webpack_require__(4);
	
		module.exports = {
		  componentDidMount: function componentDidMount() {
		    this._scrollLeft = this.viewport ? this.viewport.getScroll().scrollLeft : 0;
		    this._onScroll();
		  },
		  componentDidUpdate: function componentDidUpdate() {
		    this._onScroll();
		  },
		  componentWillMount: function componentWillMount() {
		    this._scrollLeft = undefined;
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    this._scrollLeft = undefined;
		  },
		  onScroll: function onScroll(props) {
		    if (this._scrollLeft !== props.scrollLeft) {
		      this._scrollLeft = props.scrollLeft;
		      this._onScroll();
		    }
		  },
		  onHeaderScroll: function onHeaderScroll(e) {
		    var scrollLeft = e.target.scrollLeft;
		    if (this._scrollLeft !== scrollLeft) {
		      this._scrollLeft = scrollLeft;
		      this.header.setScrollLeft(scrollLeft);
		      var canvas = ReactDOM.findDOMNode(this.viewport.canvas);
		      canvas.scrollLeft = scrollLeft;
		      this.viewport.canvas.setScrollLeft(scrollLeft);
		    }
		  },
		  _onScroll: function _onScroll() {
		    if (this._scrollLeft !== undefined) {
		      this.header.setScrollLeft(this._scrollLeft);
		      if (this.viewport) {
		        this.viewport.setScrollLeft(this._scrollLeft);
		      }
		    }
		  }
		};
	
	/***/ }),
	/* 167 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var shallowCloneObject = __webpack_require__(36);
		var ColumnMetrics = __webpack_require__(33);
		var ColumnUtils = __webpack_require__(10);
		var HeaderRow = __webpack_require__(169);
		var getScrollbarSize = __webpack_require__(35);
		var PropTypes = React.PropTypes;
		var createObjectWithProperties = __webpack_require__(17);
		var cellMetaDataShape = __webpack_require__(14);
		__webpack_require__(19);
	
		// The list of the propTypes that we want to include in the Header div
		var knownDivPropertyKeys = ['height', 'onScroll'];
	
		var Header = React.createClass({
		  displayName: 'Header',
	
		  propTypes: {
		    columnMetrics: PropTypes.shape({ width: PropTypes.number.isRequired, columns: PropTypes.any }).isRequired,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    height: PropTypes.number.isRequired,
		    headerRows: PropTypes.array.isRequired,
		    sortColumn: PropTypes.string,
		    sortDirection: PropTypes.oneOf(['ASC', 'DESC', 'NONE']),
		    onSort: PropTypes.func,
		    onColumnResize: PropTypes.func,
		    onScroll: PropTypes.func,
		    onHeaderDrop: PropTypes.func,
		    draggableHeaderCell: PropTypes.func,
		    getValidFilterValues: PropTypes.func,
		    cellMetaData: PropTypes.shape(cellMetaDataShape)
		  },
	
		  getInitialState: function getInitialState() {
		    return { resizing: null };
		  },
		  componentWillReceiveProps: function componentWillReceiveProps() {
		    this.setState({ resizing: null });
		  },
	
	
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
		    var update = !ColumnMetrics.sameColumns(this.props.columnMetrics.columns, nextProps.columnMetrics.columns, ColumnMetrics.sameColumn) || this.props.totalWidth !== nextProps.totalWidth || this.props.headerRows.length !== nextProps.headerRows.length || this.state.resizing !== nextState.resizing || this.props.sortColumn !== nextProps.sortColumn || this.props.sortDirection !== nextProps.sortDirection;
		    return update;
		  },
	
		  onColumnResize: function onColumnResize(column, width) {
		    var state = this.state.resizing || this.props;
	
		    var pos = this.getColumnPosition(column);
	
		    if (pos != null) {
		      var _resizing = {
		        columnMetrics: shallowCloneObject(state.columnMetrics)
		      };
		      _resizing.columnMetrics = ColumnMetrics.resizeColumn(_resizing.columnMetrics, pos, width);
	
		      // we don't want to influence scrollLeft while resizing
		      if (_resizing.columnMetrics.totalWidth < state.columnMetrics.totalWidth) {
		        _resizing.columnMetrics.totalWidth = state.columnMetrics.totalWidth;
		      }
	
		      _resizing.column = ColumnUtils.getColumn(_resizing.columnMetrics.columns, pos);
		      this.setState({ resizing: _resizing });
		    }
		  },
		  onColumnResizeEnd: function onColumnResizeEnd(column, width) {
		    var pos = this.getColumnPosition(column);
		    if (pos !== null && this.props.onColumnResize) {
		      this.props.onColumnResize(pos, width || column.width);
		    }
		  },
		  getHeaderRows: function getHeaderRows() {
		    var _this = this;
	
		    var columnMetrics = this.getColumnMetrics();
		    var resizeColumn = void 0;
		    if (this.state.resizing) {
		      resizeColumn = this.state.resizing.column;
		    }
		    var headerRows = [];
		    this.props.headerRows.forEach(function (row, index) {
		      // To allow header filters to be visible
		      var rowHeight = 'auto';
		      if (row.rowType === 'filter') {
		        rowHeight = '500px';
		      }
		      var scrollbarSize = getScrollbarSize() > 0 ? getScrollbarSize() : 0;
		      var updatedWidth = isNaN(_this.props.totalWidth - scrollbarSize) ? _this.props.totalWidth : _this.props.totalWidth - scrollbarSize;
		      var headerRowStyle = {
		        position: 'absolute',
		        top: _this.getCombinedHeaderHeights(index),
		        left: 0,
		        width: updatedWidth,
		        overflowX: 'hidden',
		        minHeight: rowHeight
		      };
	
		      headerRows.push(React.createElement(HeaderRow, {
		        key: row.ref,
		        ref: function ref(node) {
		          return _this.row = node;
		        },
		        rowType: row.rowType,
		        style: headerRowStyle,
		        onColumnResize: _this.onColumnResize,
		        onColumnResizeEnd: _this.onColumnResizeEnd,
		        width: columnMetrics.width,
		        height: row.height || _this.props.height,
		        columns: columnMetrics.columns,
		        resizing: resizeColumn,
		        draggableHeaderCell: _this.props.draggableHeaderCell,
		        filterable: row.filterable,
		        onFilterChange: row.onFilterChange,
		        onHeaderDrop: _this.props.onHeaderDrop,
		        sortColumn: _this.props.sortColumn,
		        sortDirection: _this.props.sortDirection,
		        onSort: _this.props.onSort,
		        onScroll: _this.props.onScroll,
		        getValidFilterValues: _this.props.getValidFilterValues
		      }));
		    });
		    return headerRows;
		  },
		  getColumnMetrics: function getColumnMetrics() {
		    var columnMetrics = void 0;
		    if (this.state.resizing) {
		      columnMetrics = this.state.resizing.columnMetrics;
		    } else {
		      columnMetrics = this.props.columnMetrics;
		    }
		    return columnMetrics;
		  },
		  getColumnPosition: function getColumnPosition(column) {
		    var columnMetrics = this.getColumnMetrics();
		    var pos = -1;
		    columnMetrics.columns.forEach(function (c, idx) {
		      if (c.key === column.key) {
		        pos = idx;
		      }
		    });
		    return pos === -1 ? null : pos;
		  },
		  getCombinedHeaderHeights: function getCombinedHeaderHeights(until) {
		    var stopAt = this.props.headerRows.length;
		    if (typeof until !== 'undefined') {
		      stopAt = until;
		    }
	
		    var height = 0;
		    for (var index = 0; index < stopAt; index++) {
		      height += this.props.headerRows[index].height || this.props.height;
		    }
		    return height;
		  },
		  getStyle: function getStyle() {
		    return {
		      position: 'relative',
		      height: this.getCombinedHeaderHeights()
		    };
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var node = ReactDOM.findDOMNode(this.row);
		    node.scrollLeft = scrollLeft;
		    this.row.setScrollLeft(scrollLeft);
		    if (this.filterRow) {
		      var nodeFilters = this.filterRow;
		      nodeFilters.scrollLeft = scrollLeft;
		      this.filterRow.setScrollLeft(scrollLeft);
		    }
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
	
	
		  // Set the cell selection to -1 x -1 when clicking on the header
		  onHeaderClick: function onHeaderClick() {
		    this.props.cellMetaData.onCellClick({ rowIdx: -1, idx: -1 });
		  },
		  render: function render() {
		    var className = joinClasses({
		      'react-grid-Header': true,
		      'react-grid-Header--resizing': !!this.state.resizing
		    });
		    var headerRows = this.getHeaderRows();
	
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { style: this.getStyle(), className: className, onClick: this.onHeaderClick }),
		      headerRows
		    );
		  }
		});
	
		module.exports = Header;
	
	/***/ }),
	/* 168 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		var HeaderCellType = {
		  SORTABLE: 0,
		  FILTERABLE: 1,
		  NONE: 2,
		  CHECKBOX: 3
		};
	
		module.exports = HeaderCellType;
	
	/***/ }),
	/* 169 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var shallowEqual = __webpack_require__(70);
		var BaseHeaderCell = __webpack_require__(60);
		var getScrollbarSize = __webpack_require__(35);
		var ExcelColumn = __webpack_require__(11);
		var ColumnUtilsMixin = __webpack_require__(10);
		var SortableHeaderCell = __webpack_require__(180);
		var FilterableHeaderCell = __webpack_require__(179);
		var HeaderCellType = __webpack_require__(168);
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(19);
	
		var PropTypes = React.PropTypes;
	
		var HeaderRowStyle = {
		  overflow: React.PropTypes.string,
		  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		  height: React.PropTypes.number,
		  position: React.PropTypes.string
		};
	
		// The list of the propTypes that we want to include in the HeaderRow div
		var knownDivPropertyKeys = ['width', 'height', 'style', 'onScroll'];
	
		var HeaderRow = React.createClass({
		  displayName: 'HeaderRow',
	
		  propTypes: {
		    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    height: PropTypes.number.isRequired,
		    columns: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
		    onColumnResize: PropTypes.func,
		    onSort: PropTypes.func.isRequired,
		    onColumnResizeEnd: PropTypes.func,
		    style: PropTypes.shape(HeaderRowStyle),
		    sortColumn: PropTypes.string,
		    sortDirection: React.PropTypes.oneOf(Object.keys(SortableHeaderCell.DEFINE_SORT)),
		    cellRenderer: PropTypes.func,
		    headerCellRenderer: PropTypes.func,
		    filterable: PropTypes.bool,
		    onFilterChange: PropTypes.func,
		    resizing: PropTypes.object,
		    onScroll: PropTypes.func,
		    rowType: PropTypes.string,
		    draggableHeaderCell: PropTypes.func,
		    onHeaderDrop: PropTypes.func
		  },
	
		  mixins: [ColumnUtilsMixin],
	
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    return nextProps.width !== this.props.width || nextProps.height !== this.props.height || nextProps.columns !== this.props.columns || !shallowEqual(nextProps.style, this.props.style) || this.props.sortColumn !== nextProps.sortColumn || this.props.sortDirection !== nextProps.sortDirection;
		  },
	
	
		  cells: [],
	
		  getHeaderCellType: function getHeaderCellType(column) {
		    if (column.filterable) {
		      if (this.props.filterable) return HeaderCellType.FILTERABLE;
		    }
	
		    if (column.sortable) return HeaderCellType.SORTABLE;
	
		    return HeaderCellType.NONE;
		  },
		  getFilterableHeaderCell: function getFilterableHeaderCell(column) {
		    var FilterRenderer = FilterableHeaderCell;
		    if (column.filterRenderer !== undefined) {
		      FilterRenderer = column.filterRenderer;
		    }
		    return React.createElement(FilterRenderer, _extends({}, this.props, { onChange: this.props.onFilterChange }));
		  },
		  getSortableHeaderCell: function getSortableHeaderCell(column) {
		    var sortDirection = this.props.sortColumn === column.key ? this.props.sortDirection : SortableHeaderCell.DEFINE_SORT.NONE;
		    return React.createElement(SortableHeaderCell, { columnKey: column.key, onSort: this.props.onSort, sortDirection: sortDirection });
		  },
		  getHeaderRenderer: function getHeaderRenderer(column) {
		    var renderer = void 0;
		    if (column.headerRenderer && !this.props.filterable) {
		      renderer = column.headerRenderer;
		    } else {
		      var headerCellType = this.getHeaderCellType(column);
		      switch (headerCellType) {
		        case HeaderCellType.SORTABLE:
		          renderer = this.getSortableHeaderCell(column);
		          break;
		        case HeaderCellType.FILTERABLE:
		          renderer = this.getFilterableHeaderCell(column);
		          break;
		        default:
		          break;
		      }
		    }
		    return renderer;
		  },
		  getStyle: function getStyle() {
		    return {
		      overflow: 'hidden',
		      width: '100%',
		      height: this.props.height,
		      position: 'absolute'
		    };
		  },
		  getCells: function getCells() {
		    var _this = this;
	
		    var cells = [];
		    var lockedCells = [];
	
		    var _loop = function _loop(i, len) {
		      var column = Object.assign({ rowType: _this.props.rowType }, _this.getColumn(_this.props.columns, i));
		      var _renderer = _this.getHeaderRenderer(column);
		      if (column.key === 'select-row' && _this.props.rowType === 'filter') {
		        _renderer = React.createElement('div', null);
		      }
		      var HeaderCell = column.draggable ? _this.props.draggableHeaderCell : BaseHeaderCell;
		      var cell = React.createElement(HeaderCell, {
		        ref: function ref(node) {
		          return _this.cells[i] = node;
		        },
		        key: i,
		        height: _this.props.height,
		        column: column,
		        renderer: _renderer,
		        resizing: _this.props.resizing === column,
		        onResize: _this.props.onColumnResize,
		        onResizeEnd: _this.props.onColumnResizeEnd,
		        onHeaderDrop: _this.props.onHeaderDrop
		      });
		      if (column.locked) {
		        lockedCells.push(cell);
		      } else {
		        cells.push(cell);
		      }
		    };
	
		    for (var i = 0, len = this.getSize(this.props.columns); i < len; i++) {
		      _loop(i, len);
		    }
	
		    return cells.concat(lockedCells);
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var _this2 = this;
	
		    this.props.columns.forEach(function (column, i) {
		      if (column.locked) {
		        _this2.cells[i].setScrollLeft(scrollLeft);
		      } else {
		        if (_this2.cells[i] && _this2.cells[i].removeScroll) {
		          _this2.cells[i].removeScroll();
		        }
		      }
		    });
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  render: function render() {
		    var cellsStyle = {
		      width: this.props.width ? this.props.width + getScrollbarSize() : '100%',
		      height: this.props.height,
		      whiteSpace: 'nowrap',
		      overflowX: 'hidden',
		      overflowY: 'hidden'
		    };
	
		    var cells = this.getCells();
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { className: 'react-grid-HeaderRow' }),
		      React.createElement(
		        'div',
		        { style: cellsStyle },
		        cells
		      )
		    );
		  }
		});
	
		module.exports = HeaderRow;
	
	/***/ }),
	/* 170 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		module.exports = {
		  Backspace: 8,
		  Tab: 9,
		  Enter: 13,
		  Shift: 16,
		  Ctrl: 17,
		  Alt: 18,
		  PauseBreak: 19,
		  CapsLock: 20,
		  Escape: 27,
		  PageUp: 33,
		  PageDown: 34,
		  End: 35,
		  Home: 36,
		  LeftArrow: 37,
		  UpArrow: 38,
		  RightArrow: 39,
		  DownArrow: 40,
		  Insert: 45,
		  Delete: 46,
		  0: 48,
		  1: 49,
		  2: 50,
		  3: 51,
		  4: 52,
		  5: 53,
		  6: 54,
		  7: 55,
		  8: 56,
		  9: 57,
		  a: 65,
		  b: 66,
		  c: 67,
		  d: 68,
		  e: 69,
		  f: 70,
		  g: 71,
		  h: 72,
		  i: 73,
		  j: 74,
		  k: 75,
		  l: 76,
		  m: 77,
		  n: 78,
		  o: 79,
		  p: 80,
		  q: 81,
		  r: 82,
		  s: 83,
		  t: 84,
		  u: 85,
		  v: 86,
		  w: 87,
		  x: 88,
		  y: 89,
		  z: 90,
		  LeftWindowKey: 91,
		  RightWindowKey: 92,
		  SelectKey: 93,
		  NumPad0: 96,
		  NumPad1: 97,
		  NumPad2: 98,
		  NumPad3: 99,
		  NumPad4: 100,
		  NumPad5: 101,
		  NumPad6: 102,
		  NumPad7: 103,
		  NumPad8: 104,
		  NumPad9: 105,
		  Multiply: 106,
		  Add: 107,
		  Subtract: 109,
		  DecimalPoint: 110,
		  Divide: 111,
		  F1: 112,
		  F2: 113,
		  F3: 114,
		  F4: 115,
		  F5: 116,
		  F6: 117,
		  F7: 118,
		  F8: 119,
		  F9: 120,
		  F10: 121,
		  F12: 123,
		  NumLock: 144,
		  ScrollLock: 145,
		  SemiColon: 186,
		  EqualSign: 187,
		  Comma: 188,
		  Dash: 189,
		  Period: 190,
		  ForwardSlash: 191,
		  GraveAccent: 192,
		  OpenBracket: 219,
		  BackSlash: 220,
		  CloseBracket: 221,
		  SingleQuote: 222
		};
	
	/***/ }),
	/* 171 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.OverflowCellComponent = undefined;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _focusableComponentWrapper = __webpack_require__(183);
	
		var _focusableComponentWrapper2 = _interopRequireDefault(_focusableComponentWrapper);
	
		__webpack_require__(38);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var OverflowCell = function (_React$Component) {
		  _inherits(OverflowCell, _React$Component);
	
		  function OverflowCell() {
		    _classCallCheck(this, OverflowCell);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  OverflowCell.prototype.getStyle = function getStyle() {
		    var style = {
		      position: 'absolute',
		      width: this.props.column.width,
		      height: this.props.height,
		      left: this.props.column.left,
		      border: '1px solid #eee'
		    };
		    return style;
		  };
	
		  OverflowCell.prototype.render = function render() {
		    return _react2['default'].createElement('div', { tabIndex: '-1', style: this.getStyle(), width: '100%', className: 'react-grid-Cell' });
		  };
	
		  return OverflowCell;
		}(_react2['default'].Component);
	
		OverflowCell.isSelected = function (props) {
		  var cellMetaData = props.cellMetaData,
		      rowIdx = props.rowIdx,
		      idx = props.idx;
	
		  if (cellMetaData == null) {
		    return false;
		  }
	
		  var selected = cellMetaData.selected;
	
	
		  return selected && selected.rowIdx === rowIdx && selected.idx === idx;
		};
	
		OverflowCell.isScrolling = function (props) {
		  return props.cellMetaData.isScrollingHorizontallyWithKeyboard;
		};
	
		OverflowCell.propTypes = {
		  rowIdx: _react2['default'].PropTypes.number,
		  idx: _react2['default'].PropTypes.number,
		  height: _react2['default'].PropTypes.number,
		  column: _react2['default'].PropTypes.object,
		  cellMetaData: _react2['default'].PropTypes.object
		};
	
		OverflowCell.displayName = 'Cell';
	
		var OverflowCellComponent = OverflowCell;
		exports['default'] = (0, _focusableComponentWrapper2['default'])(OverflowCell);
		exports.OverflowCellComponent = OverflowCellComponent;
	
	/***/ }),
	/* 172 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _ExcelColumn = __webpack_require__(11);
	
		var _ExcelColumn2 = _interopRequireDefault(_ExcelColumn);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		exports['default'] = { ExcelColumn: _ExcelColumn2['default'] };
	
	/***/ }),
	/* 173 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _AppConstants = __webpack_require__(58);
	
		var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var BaseGrid = __webpack_require__(165);
		var Row = __webpack_require__(34);
		var ExcelColumn = __webpack_require__(11);
		var KeyboardHandlerMixin = __webpack_require__(61);
		var CheckboxEditor = __webpack_require__(65);
		var DOMMetrics = __webpack_require__(23);
		var ColumnMetricsMixin = __webpack_require__(163);
		var RowUtils = __webpack_require__(63);
		var ColumnUtils = __webpack_require__(10);
		var KeyCodes = __webpack_require__(170);
	
		__webpack_require__(26);
		__webpack_require__(72);
	
		if (!Object.assign) {
		  Object.assign = __webpack_require__(71);
		}
	
		var ReactDataGrid = React.createClass({
		  displayName: 'ReactDataGrid',
	
	
		  mixins: [ColumnMetricsMixin, DOMMetrics.MetricsComputatorMixin, KeyboardHandlerMixin],
	
		  propTypes: {
		    rowHeight: React.PropTypes.number.isRequired,
		    headerRowHeight: React.PropTypes.number,
		    headerFiltersHeight: React.PropTypes.number,
		    minHeight: React.PropTypes.number.isRequired,
		    minWidth: React.PropTypes.number,
		    enableRowSelect: React.PropTypes.oneOfType([React.PropTypes.bool, React.PropTypes.string]),
		    onRowUpdated: React.PropTypes.func,
		    rowGetter: React.PropTypes.func.isRequired,
		    rowsCount: React.PropTypes.number.isRequired,
		    toolbar: React.PropTypes.element,
		    enableCellSelect: React.PropTypes.bool,
		    columns: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.array]).isRequired,
		    onFilter: React.PropTypes.func,
		    onCellCopyPaste: React.PropTypes.func,
		    onCellsDragged: React.PropTypes.func,
		    onAddFilter: React.PropTypes.func,
		    onGridSort: React.PropTypes.func,
		    onDragHandleDoubleClick: React.PropTypes.func,
		    onGridRowsUpdated: React.PropTypes.func,
		    onRowSelect: React.PropTypes.func,
		    rowKey: React.PropTypes.string,
		    rowScrollTimeout: React.PropTypes.number,
		    onClearFilters: React.PropTypes.func,
		    contextMenu: React.PropTypes.element,
		    cellNavigationMode: React.PropTypes.oneOf(['none', 'loopOverRow', 'changeRow']),
		    onCellSelected: React.PropTypes.func,
		    onCellDeSelected: React.PropTypes.func,
		    onCellExpand: React.PropTypes.func,
		    enableDragAndDrop: React.PropTypes.bool,
		    onRowExpandToggle: React.PropTypes.func,
		    draggableHeaderCell: React.PropTypes.func,
		    getValidFilterValues: React.PropTypes.func,
		    rowSelection: React.PropTypes.shape({
		      enableShiftSelect: React.PropTypes.bool,
		      onRowsSelected: React.PropTypes.func,
		      onRowsDeselected: React.PropTypes.func,
		      showCheckbox: React.PropTypes.bool,
		      selectBy: React.PropTypes.oneOfType([React.PropTypes.shape({
		        indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		      }), React.PropTypes.shape({
		        isSelectedKey: React.PropTypes.string.isRequired
		      }), React.PropTypes.shape({
		        keys: React.PropTypes.shape({
		          values: React.PropTypes.array.isRequired,
		          rowKey: React.PropTypes.string.isRequired
		        }).isRequired
		      })]).isRequired
		    }),
		    onRowClick: React.PropTypes.func,
		    onGridKeyUp: React.PropTypes.func,
		    onGridKeyDown: React.PropTypes.func,
		    rowGroupRenderer: React.PropTypes.func,
		    rowActionsCell: React.PropTypes.func,
		    onCheckCellIsEditable: React.PropTypes.func,
		    /* called before cell is set active, returns a boolean to determine whether cell is editable */
		    overScan: React.PropTypes.object
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      enableCellSelect: false,
		      tabIndex: -1,
		      rowHeight: 35,
		      headerFiltersHeight: 45,
		      enableRowSelect: false,
		      minHeight: 350,
		      rowKey: 'id',
		      rowScrollTimeout: 0,
		      cellNavigationMode: 'none',
		      overScan: {
		        colsStart: 5,
		        colsEnd: 5,
		        rowsStart: 5,
		        rowsEnd: 5
		      }
		    };
		  },
	
	
		  getInitialState: function getInitialState() {
		    var columnMetrics = this.createColumnMetrics();
		    var initialState = { columnMetrics: columnMetrics, selectedRows: [], copied: null, expandedRows: [], canFilter: false, columnFilters: {}, sortDirection: null, sortColumn: null, dragged: null, scrollOffset: 0, lastRowIdxUiSelected: -1 };
		    if (this.props.enableCellSelect) {
		      initialState.selected = { rowIdx: 0, idx: 0 };
		    } else {
		      initialState.selected = { rowIdx: -1, idx: -1 };
		    }
		    return initialState;
		  },
	
		  hasSelectedCellChanged: function hasSelectedCellChanged(selected) {
		    var previouslySelected = Object.assign({}, this.state.selected);
		    return previouslySelected.rowIdx !== selected.rowIdx || previouslySelected.idx !== selected.idx || previouslySelected.active === false;
		  },
	
		  onContextMenuHide: function onContextMenuHide() {
		    document.removeEventListener('click', this.onContextMenuHide);
		    var newSelected = Object.assign({}, this.state.selected, { contextMenuDisplayed: false });
		    this.setState({ selected: newSelected });
		  },
	
		  onColumnEvent: function onColumnEvent(ev, columnEvent) {
		    var idx = columnEvent.idx,
		        name = columnEvent.name;
	
	
		    if (name && typeof idx !== 'undefined') {
		      var column = this.getColumn(idx);
	
		      if (column && column.events && column.events[name] && typeof column.events[name] === 'function') {
		        var eventArgs = {
		          rowIdx: columnEvent.rowIdx,
		          idx: idx,
		          column: column
		        };
	
		        column.events[name](ev, eventArgs);
		      }
		    }
		  },
	
		  onSelect: function onSelect(selected) {
		    var _this = this;
	
		    if (this.state.selected.rowIdx !== selected.rowIdx || this.state.selected.idx !== selected.idx || this.state.selected.active === false) {
		      var _idx = selected.idx;
		      var _rowIdx = selected.rowIdx;
		      if (this.isCellWithinBounds(selected)) {
		        var oldSelection = this.state.selected;
		        this.setState({ selected: selected }, function () {
		          if (typeof _this.props.onCellDeSelected === 'function') {
		            _this.props.onCellDeSelected(oldSelection);
		          }
		          if (typeof _this.props.onCellSelected === 'function') {
		            _this.props.onCellSelected(selected);
		          }
		        });
		      } else if (_rowIdx === -1 && _idx === -1) {
		        // When it's outside of the grid, set rowIdx anyway
		        this.setState({ selected: { idx: _idx, rowIdx: _rowIdx } });
		      }
		    }
		  },
	
		  onCellClick: function onCellClick(cell) {
		    this.onSelect({ rowIdx: cell.rowIdx, idx: cell.idx });
	
		    if (this.props.onRowClick && typeof this.props.onRowClick === 'function') {
		      this.props.onRowClick(cell.rowIdx, this.props.rowGetter(cell.rowIdx));
		    }
		  },
	
		  onCellContextMenu: function onCellContextMenu(cell) {
		    this.onSelect({ rowIdx: cell.rowIdx, idx: cell.idx, contextMenuDisplayed: this.props.contextMenu });
		    if (this.props.contextMenu) {
		      document.addEventListener('click', this.onContextMenuHide);
		    }
		  },
	
		  onCellDoubleClick: function onCellDoubleClick(cell) {
		    this.onSelect({ rowIdx: cell.rowIdx, idx: cell.idx });
		    this.setActive('Enter');
		  },
	
		  onViewportDoubleClick: function onViewportDoubleClick() {
		    this.setActive();
		  },
	
		  onPressArrowUp: function onPressArrowUp(e) {
		    this.moveSelectedCell(e, -1, 0);
		  },
		  onPressArrowDown: function onPressArrowDown(e) {
		    this.moveSelectedCell(e, 1, 0);
		  },
		  onPressArrowLeft: function onPressArrowLeft(e) {
		    this.moveSelectedCell(e, 0, -1);
		  },
		  onPressArrowRight: function onPressArrowRight(e) {
		    this.moveSelectedCell(e, 0, 1);
		  },
		  onPressTab: function onPressTab(e) {
		    this.moveSelectedCell(e, 0, e.shiftKey ? -1 : 1);
		  },
		  onPressEnter: function onPressEnter(e) {
		    this.setActive(e.key);
		  },
		  onPressDelete: function onPressDelete(e) {
		    this.setActive(e.key);
		  },
		  onPressEscape: function onPressEscape(e) {
		    this.setInactive(e.key);
		    this.handleCancelCopy();
		  },
		  onPressBackspace: function onPressBackspace(e) {
		    this.setActive(e.key);
		  },
		  onPressChar: function onPressChar(e) {
		    if (this.isKeyPrintable(e.keyCode)) {
		      this.setActive(e.keyCode);
		    }
		  },
		  onPressKeyWithCtrl: function onPressKeyWithCtrl(e) {
		    var keys = {
		      KeyCode_c: 99,
		      KeyCode_C: 67,
		      KeyCode_V: 86,
		      KeyCode_v: 118
		    };
	
		    var rowIdx = this.state.selected.rowIdx;
		    var row = this.props.rowGetter(rowIdx);
	
		    var idx = this.state.selected.idx;
		    var col = this.getColumn(idx);
	
		    if (ColumnUtils.canEdit(col, row, this.props.enableCellSelect)) {
		      if (e.keyCode === keys.KeyCode_c || e.keyCode === keys.KeyCode_C) {
		        var _value = this.getSelectedValue();
		        this.handleCopy({ value: _value });
		      } else if (e.keyCode === keys.KeyCode_v || e.keyCode === keys.KeyCode_V) {
		        this.handlePaste();
		      }
		    }
		  },
		  onGridRowsUpdated: function onGridRowsUpdated(cellKey, fromRow, toRow, updated, action, originRow) {
		    var rowIds = [];
	
		    for (var i = fromRow; i <= toRow; i++) {
		      rowIds.push(this.props.rowGetter(i)[this.props.rowKey]);
		    }
	
		    var fromRowId = this.props.rowGetter(action === 'COPY_PASTE' ? originRow : fromRow)[this.props.rowKey];
		    var toRowId = this.props.rowGetter(toRow)[this.props.rowKey];
	
		    this.props.onGridRowsUpdated({ cellKey: cellKey, fromRow: fromRow, toRow: toRow, fromRowId: fromRowId, toRowId: toRowId, rowIds: rowIds, updated: updated, action: action });
		  },
		  onCellCommit: function onCellCommit(commit) {
		    var selected = Object.assign({}, this.state.selected);
		    selected.active = false;
		    if (commit.key === 'Tab') {
		      selected.idx += 1;
		    }
		    var expandedRows = this.state.expandedRows;
		    // if(commit.changed && commit.changed.expandedHeight){
		    //   expandedRows = this.expandRow(commit.rowIdx, commit.changed.expandedHeight);
		    // }
		    this.setState({ selected: selected, expandedRows: expandedRows });
	
		    if (this.props.onRowUpdated) {
		      this.props.onRowUpdated(commit);
		    }
	
		    var targetRow = commit.rowIdx;
	
		    if (this.props.onGridRowsUpdated) {
		      this.onGridRowsUpdated(commit.cellKey, targetRow, targetRow, commit.updated, _AppConstants2['default'].UpdateActions.CELL_UPDATE);
		    }
		  },
		  onDragStart: function onDragStart(e) {
		    var idx = this.state.selected.idx;
		    // To prevent dragging down/up when reordering rows.
		    var isViewportDragging = e && e.target && e.target.className;
		    if (idx > -1 && isViewportDragging) {
		      var _value2 = this.getSelectedValue();
		      this.handleDragStart({ idx: this.state.selected.idx, rowIdx: this.state.selected.rowIdx, value: _value2 });
		      // need to set dummy data for FF
		      if (e && e.dataTransfer) {
		        if (e.dataTransfer.setData) {
		          e.dataTransfer.dropEffect = 'move';
		          e.dataTransfer.effectAllowed = 'move';
		          e.dataTransfer.setData('text/plain', '');
		        }
		      }
		    }
		  },
		  onToggleFilter: function onToggleFilter() {
		    var _this2 = this;
	
		    // setState() does not immediately mutate this.state but creates a pending state transition.
		    // Therefore if you want to do something after the state change occurs, pass it in as a callback function.
		    this.setState({ canFilter: !this.state.canFilter }, function () {
		      if (_this2.state.canFilter === false && _this2.props.onClearFilters) {
		        _this2.props.onClearFilters();
		      }
		    });
		  },
		  onDragHandleDoubleClick: function onDragHandleDoubleClick(e) {
		    if (this.props.onDragHandleDoubleClick) {
		      this.props.onDragHandleDoubleClick(e);
		    }
	
		    if (this.props.onGridRowsUpdated) {
		      var _onGridRowsUpdated;
	
		      var cellKey = this.getColumn(e.idx).key;
		      this.onGridRowsUpdated(cellKey, e.rowIdx, this.props.rowsCount - 1, (_onGridRowsUpdated = {}, _onGridRowsUpdated[cellKey] = e.rowData[cellKey], _onGridRowsUpdated), _AppConstants2['default'].UpdateActions.COLUMN_FILL);
		    }
		  },
		  onCellExpand: function onCellExpand(args) {
		    if (this.props.onCellExpand) {
		      this.props.onCellExpand(args);
		    }
		  },
		  onRowExpandToggle: function onRowExpandToggle(args) {
		    if (typeof this.props.onRowExpandToggle === 'function') {
		      this.props.onRowExpandToggle(args);
		    }
		  },
		  isCellWithinBounds: function isCellWithinBounds(_ref) {
		    var idx = _ref.idx,
		        rowIdx = _ref.rowIdx;
	
		    return idx >= 0 && rowIdx >= 0 && idx < ColumnUtils.getSize(this.state.columnMetrics.columns) && rowIdx < this.props.rowsCount;
		  },
		  handleDragStart: function handleDragStart(dragged) {
		    if (!this.dragEnabled()) {
		      return;
		    }
		    if (this.isCellWithinBounds(dragged)) {
		      this.setState({ dragged: dragged });
		    }
		  },
		  handleDragEnd: function handleDragEnd() {
		    if (!this.dragEnabled()) {
		      return;
		    }
		    var _state = this.state,
		        selected = _state.selected,
		        dragged = _state.dragged;
	
		    var column = this.getColumn(this.state.selected.idx);
		    if (selected && dragged && column) {
		      var cellKey = column.key;
		      var fromRow = selected.rowIdx < dragged.overRowIdx ? selected.rowIdx : dragged.overRowIdx;
		      var toRow = selected.rowIdx > dragged.overRowIdx ? selected.rowIdx : dragged.overRowIdx;
		      if (this.props.onCellsDragged) {
		        this.props.onCellsDragged({ cellKey: cellKey, fromRow: fromRow, toRow: toRow, value: dragged.value });
		      }
		      if (this.props.onGridRowsUpdated) {
		        var _onGridRowsUpdated2;
	
		        this.onGridRowsUpdated(cellKey, fromRow, toRow, (_onGridRowsUpdated2 = {}, _onGridRowsUpdated2[cellKey] = dragged.value, _onGridRowsUpdated2), _AppConstants2['default'].UpdateActions.CELL_DRAG);
		      }
		    }
		    this.setState({ dragged: { complete: true } });
		  },
		  handleDragEnter: function handleDragEnter(row) {
		    if (!this.dragEnabled() || this.state.dragged == null) {
		      return;
		    }
		    var dragged = this.state.dragged;
		    dragged.overRowIdx = row;
		    this.setState({ dragged: dragged });
		  },
		  handleTerminateDrag: function handleTerminateDrag() {
		    if (!this.dragEnabled()) {
		      return;
		    }
		    this.setState({ dragged: null });
		  },
		  handlePaste: function handlePaste() {
		    if (!this.copyPasteEnabled() || !this.state.copied) {
		      return;
		    }
		    var selected = this.state.selected;
		    var cellKey = this.getColumn(this.state.selected.idx).key;
		    var textToCopy = this.state.textToCopy;
		    var fromRow = this.state.copied.rowIdx;
		    var toRow = selected.rowIdx;
	
		    if (this.props.onCellCopyPaste) {
		      this.props.onCellCopyPaste({ cellKey: cellKey, rowIdx: toRow, value: textToCopy, fromRow: fromRow, toRow: toRow });
		    }
	
		    if (this.props.onGridRowsUpdated) {
		      var _onGridRowsUpdated3;
	
		      this.onGridRowsUpdated(cellKey, toRow, toRow, (_onGridRowsUpdated3 = {}, _onGridRowsUpdated3[cellKey] = textToCopy, _onGridRowsUpdated3), _AppConstants2['default'].UpdateActions.COPY_PASTE, fromRow);
		    }
		  },
		  handleCancelCopy: function handleCancelCopy() {
		    this.setState({ copied: null });
		  },
		  handleCopy: function handleCopy(args) {
		    if (!this.copyPasteEnabled()) {
		      return;
		    }
		    var textToCopy = args.value;
		    var selected = this.state.selected;
		    var copied = { idx: selected.idx, rowIdx: selected.rowIdx };
		    this.setState({ textToCopy: textToCopy, copied: copied });
		  },
	
	
		  handleSort: function handleSort(columnKey, direction) {
		    this.setState({ sortDirection: direction, sortColumn: columnKey }, function () {
		      this.props.onGridSort(columnKey, direction);
		    });
		  },
	
		  getSelectedRow: function getSelectedRow(rows, key) {
		    var _this3 = this;
	
		    var selectedRow = rows.filter(function (r) {
		      if (r[_this3.props.rowKey] === key) {
		        return true;
		      }
		      return false;
		    });
		    if (selectedRow.length > 0) {
		      return selectedRow[0];
		    }
		  },
		  useNewRowSelection: function useNewRowSelection() {
		    return this.props.rowSelection && this.props.rowSelection.selectBy;
		  },
	
		  // return false if not a shift select so can be handled as normal row selection
		  handleShiftSelect: function handleShiftSelect(rowIdx) {
		    if (this.state.lastRowIdxUiSelected > -1 && this.isSingleKeyDown(KeyCodes.Shift)) {
		      var _props$rowSelection$s = this.props.rowSelection.selectBy,
		          keys = _props$rowSelection$s.keys,
		          indexes = _props$rowSelection$s.indexes,
		          isSelectedKey = _props$rowSelection$s.isSelectedKey;
	
		      var isPreviouslySelected = RowUtils.isRowSelected(keys, indexes, isSelectedKey, this.props.rowGetter(rowIdx), rowIdx);
	
		      if (isPreviouslySelected) return false;
	
		      var handled = false;
	
		      if (rowIdx > this.state.lastRowIdxUiSelected) {
		        var rowsSelected = [];
	
		        for (var i = this.state.lastRowIdxUiSelected + 1; i <= rowIdx; i++) {
		          rowsSelected.push({ rowIdx: i, row: this.props.rowGetter(i) });
		        }
	
		        if (typeof this.props.rowSelection.onRowsSelected === 'function') {
		          this.props.rowSelection.onRowsSelected(rowsSelected);
		        }
	
		        handled = true;
		      } else if (rowIdx < this.state.lastRowIdxUiSelected) {
		        var _rowsSelected = [];
	
		        for (var _i = rowIdx; _i <= this.state.lastRowIdxUiSelected - 1; _i++) {
		          _rowsSelected.push({ rowIdx: _i, row: this.props.rowGetter(_i) });
		        }
	
		        if (typeof this.props.rowSelection.onRowsSelected === 'function') {
		          this.props.rowSelection.onRowsSelected(_rowsSelected);
		        }
	
		        handled = true;
		      }
	
		      if (handled) {
		        this.setState({ lastRowIdxUiSelected: rowIdx });
		      }
	
		      return handled;
		    }
	
		    return false;
		  },
		  handleNewRowSelect: function handleNewRowSelect(rowIdx, rowData) {
		    if (this.selectAllCheckbox.checked === true) {
		      this.selectAllCheckbox.checked = false;
		    }
	
		    var _props$rowSelection$s2 = this.props.rowSelection.selectBy,
		        keys = _props$rowSelection$s2.keys,
		        indexes = _props$rowSelection$s2.indexes,
		        isSelectedKey = _props$rowSelection$s2.isSelectedKey;
	
		    var isPreviouslySelected = RowUtils.isRowSelected(keys, indexes, isSelectedKey, rowData, rowIdx);
	
		    this.setState({ lastRowIdxUiSelected: isPreviouslySelected ? -1 : rowIdx, selected: { rowIdx: rowIdx, idx: 0 } });
	
		    if (isPreviouslySelected && typeof this.props.rowSelection.onRowsDeselected === 'function') {
		      this.props.rowSelection.onRowsDeselected([{ rowIdx: rowIdx, row: rowData }]);
		    } else if (!isPreviouslySelected && typeof this.props.rowSelection.onRowsSelected === 'function') {
		      this.props.rowSelection.onRowsSelected([{ rowIdx: rowIdx, row: rowData }]);
		    }
		  },
	
		  // columnKey not used here as this function will select the whole row,
		  // but needed to match the function signature in the CheckboxEditor
		  handleRowSelect: function handleRowSelect(rowIdx, columnKey, rowData, e) {
		    e.stopPropagation();
	
		    if (this.useNewRowSelection()) {
		      if (this.props.rowSelection.enableShiftSelect === true) {
		        if (!this.handleShiftSelect(rowIdx)) {
		          this.handleNewRowSelect(rowIdx, rowData);
		        }
		      } else {
		        this.handleNewRowSelect(rowIdx, rowData);
		      }
		    } else {
		      // Fallback to old onRowSelect handler
		      var _selectedRows = this.props.enableRowSelect === 'single' ? [] : this.state.selectedRows.slice(0);
		      var selectedRow = this.getSelectedRow(_selectedRows, rowData[this.props.rowKey]);
		      if (selectedRow) {
		        selectedRow.isSelected = !selectedRow.isSelected;
		      } else {
		        rowData.isSelected = true;
		        _selectedRows.push(rowData);
		      }
		      this.setState({ selectedRows: _selectedRows, selected: { rowIdx: rowIdx, idx: 0 } });
		      if (this.props.onRowSelect) {
		        this.props.onRowSelect(_selectedRows.filter(function (r) {
		          return r.isSelected === true;
		        }));
		      }
		    }
		  },
	
	
		  handleCheckboxChange: function handleCheckboxChange(e) {
		    var allRowsSelected = void 0;
		    if (e.currentTarget instanceof HTMLInputElement && e.currentTarget.checked === true) {
		      allRowsSelected = true;
		    } else {
		      allRowsSelected = false;
		    }
		    if (this.useNewRowSelection()) {
		      var _props$rowSelection$s3 = this.props.rowSelection.selectBy,
		          keys = _props$rowSelection$s3.keys,
		          indexes = _props$rowSelection$s3.indexes,
		          isSelectedKey = _props$rowSelection$s3.isSelectedKey;
	
	
		      if (allRowsSelected && typeof this.props.rowSelection.onRowsSelected === 'function') {
		        var _selectedRows2 = [];
		        for (var i = 0; i < this.props.rowsCount; i++) {
		          var rowData = this.props.rowGetter(i);
		          if (!RowUtils.isRowSelected(keys, indexes, isSelectedKey, rowData, i)) {
		            _selectedRows2.push({ rowIdx: i, row: rowData });
		          }
		        }
	
		        if (_selectedRows2.length > 0) {
		          this.props.rowSelection.onRowsSelected(_selectedRows2);
		        }
		      } else if (!allRowsSelected && typeof this.props.rowSelection.onRowsDeselected === 'function') {
		        var deselectedRows = [];
		        for (var _i2 = 0; _i2 < this.props.rowsCount; _i2++) {
		          var _rowData = this.props.rowGetter(_i2);
		          if (RowUtils.isRowSelected(keys, indexes, isSelectedKey, _rowData, _i2)) {
		            deselectedRows.push({ rowIdx: _i2, row: _rowData });
		          }
		        }
	
		        if (deselectedRows.length > 0) {
		          this.props.rowSelection.onRowsDeselected(deselectedRows);
		        }
		      }
		    } else {
		      var _selectedRows3 = [];
		      for (var _i3 = 0; _i3 < this.props.rowsCount; _i3++) {
		        var row = Object.assign({}, this.props.rowGetter(_i3), { isSelected: allRowsSelected });
		        _selectedRows3.push(row);
		      }
		      this.setState({ selectedRows: _selectedRows3 });
		      if (typeof this.props.onRowSelect === 'function') {
		        this.props.onRowSelect(_selectedRows3.filter(function (r) {
		          return r.isSelected === true;
		        }));
		      }
		    }
		  },
	
		  getScrollOffSet: function getScrollOffSet() {
		    var scrollOffset = 0;
		    var canvas = ReactDOM.findDOMNode(this).querySelector('.react-grid-Canvas');
		    if (canvas) {
		      scrollOffset = canvas.offsetWidth - canvas.clientWidth;
		    }
		    this.setState({ scrollOffset: scrollOffset });
		  },
		  getRowOffsetHeight: function getRowOffsetHeight() {
		    var offsetHeight = 0;
		    this.getHeaderRows().forEach(function (row) {
		      return offsetHeight += parseFloat(row.height, 10);
		    });
		    return offsetHeight;
		  },
		  getHeaderRows: function getHeaderRows() {
		    var _this4 = this;
	
		    var rows = [{ ref: function ref(node) {
		        return _this4.row = node;
		      }, height: this.props.headerRowHeight || this.props.rowHeight, rowType: 'header' }];
		    if (this.state.canFilter === true) {
		      rows.push({
		        ref: function ref(node) {
		          return _this4.filterRow = node;
		        },
		        filterable: true,
		        onFilterChange: this.props.onAddFilter,
		        height: this.props.headerFiltersHeight,
		        rowType: 'filter'
		      });
		    }
		    return rows;
		  },
	
		  getInitialSelectedRows: function getInitialSelectedRows() {
		    var selectedRows = [];
		    for (var i = 0; i < this.props.rowsCount; i++) {
		      selectedRows.push(false);
		    }
		    return selectedRows;
		  },
		  getRowSelectionProps: function getRowSelectionProps() {
		    if (this.props.rowSelection) {
		      return this.props.rowSelection.selectBy;
		    }
	
		    return null;
		  },
		  getSelectedRows: function getSelectedRows() {
		    if (this.props.rowSelection) {
		      return null;
		    }
	
		    return this.state.selectedRows.filter(function (r) {
		      return r.isSelected === true;
		    });
		  },
		  getSelectedValue: function getSelectedValue() {
		    var rowIdx = this.state.selected.rowIdx;
		    var idx = this.state.selected.idx;
		    var cellKey = this.getColumn(idx).key;
		    var row = this.props.rowGetter(rowIdx);
		    return RowUtils.get(row, cellKey);
		  },
		  moveSelectedCell: function moveSelectedCell(e, rowDelta, cellDelta) {
		    // we need to prevent default as we control grid scroll
		    // otherwise it moves every time you left/right which is janky
		    e.preventDefault();
		    var rowIdx = void 0;
		    var idx = void 0;
		    var cellNavigationMode = this.props.cellNavigationMode;
	
		    if (cellNavigationMode !== 'none') {
		      var _calculateNextSelecti = this.calculateNextSelectionPosition(cellNavigationMode, cellDelta, rowDelta);
	
		      idx = _calculateNextSelecti.idx;
		      rowIdx = _calculateNextSelecti.rowIdx;
		    } else {
		      rowIdx = this.state.selected.rowIdx + rowDelta;
		      idx = this.state.selected.idx + cellDelta;
		    }
		    this.onSelect({ idx: idx, rowIdx: rowIdx });
		  },
		  getNbrColumns: function getNbrColumns() {
		    var _props = this.props,
		        columns = _props.columns,
		        enableRowSelect = _props.enableRowSelect;
	
		    return enableRowSelect ? columns.length + 1 : columns.length;
		  },
		  getDataGridDOMNode: function getDataGridDOMNode() {
		    if (!this._gridNode) {
		      this._gridNode = ReactDOM.findDOMNode(this);
		    }
		    return this._gridNode;
		  },
		  calculateNextSelectionPosition: function calculateNextSelectionPosition(cellNavigationMode, cellDelta, rowDelta) {
		    var _rowDelta = rowDelta;
		    var idx = this.state.selected.idx + cellDelta;
		    var nbrColumns = this.getNbrColumns();
		    if (cellDelta > 0) {
		      if (this.isAtLastCellInRow(nbrColumns)) {
		        if (cellNavigationMode === 'changeRow') {
		          _rowDelta = this.isAtLastRow() ? rowDelta : rowDelta + 1;
		          idx = this.isAtLastRow() ? idx : 0;
		        } else {
		          idx = 0;
		        }
		      }
		    } else if (cellDelta < 0) {
		      if (this.isAtFirstCellInRow()) {
		        if (cellNavigationMode === 'changeRow') {
		          _rowDelta = this.isAtFirstRow() ? rowDelta : rowDelta - 1;
		          idx = this.isAtFirstRow() ? 0 : nbrColumns - 1;
		        } else {
		          idx = nbrColumns - 1;
		        }
		      }
		    }
		    var rowIdx = this.state.selected.rowIdx + _rowDelta;
		    return { idx: idx, rowIdx: rowIdx };
		  },
		  isAtLastCellInRow: function isAtLastCellInRow(nbrColumns) {
		    return this.state.selected.idx === nbrColumns - 1;
		  },
		  isAtLastRow: function isAtLastRow() {
		    return this.state.selected.rowIdx === this.props.rowsCount - 1;
		  },
		  isAtFirstCellInRow: function isAtFirstCellInRow() {
		    return this.state.selected.idx === 0;
		  },
		  isAtFirstRow: function isAtFirstRow() {
		    return this.state.selected.rowIdx === 0;
		  },
		  openCellEditor: function openCellEditor(rowIdx, idx) {
		    var _this5 = this;
	
		    var row = this.props.rowGetter(rowIdx);
		    var col = this.getColumn(idx);
	
		    if (!ColumnUtils.canEdit(col, row, this.props.enableCellSelect)) {
		      return;
		    }
	
		    var selected = { rowIdx: rowIdx, idx: idx };
		    if (this.hasSelectedCellChanged(selected)) {
		      this.setState({ selected: selected }, function () {
		        _this5.setActive('Enter');
		      });
		    } else {
		      this.setActive('Enter');
		    }
		  },
		  scrollToColumn: function scrollToColumn(colIdx) {
		    var canvas = ReactDOM.findDOMNode(this).querySelector('.react-grid-Canvas');
		    if (canvas) {
		      var left = 0;
		      var locked = 0;
	
		      for (var i = 0; i < colIdx; i++) {
		        var column = this.getColumn(i);
		        if (column) {
		          if (column.width) {
		            left += column.width;
		          }
		          if (column.locked) {
		            locked += column.width;
		          }
		        }
		      }
	
		      var selectedColumn = this.getColumn(colIdx);
		      if (selectedColumn) {
		        var scrollLeft = left - locked - canvas.scrollLeft;
		        var scrollRight = left + selectedColumn.width - canvas.scrollLeft;
	
		        if (scrollLeft < 0) {
		          canvas.scrollLeft += scrollLeft;
		        } else if (scrollRight > canvas.clientWidth) {
		          var scrollAmount = scrollRight - canvas.clientWidth;
		          canvas.scrollLeft += scrollAmount;
		        }
		      }
		    }
		  },
		  setActive: function setActive(keyPressed) {
		    var rowIdx = this.state.selected.rowIdx;
		    var row = this.props.rowGetter(rowIdx);
	
		    var idx = this.state.selected.idx;
		    var column = this.getColumn(idx);
	
		    if (ColumnUtils.canEdit(column, row, this.props.enableCellSelect) && !this.isActive()) {
		      var _selected = Object.assign({}, this.state.selected, { idx: idx, rowIdx: rowIdx, active: true, initialKeyCode: keyPressed });
		      var showEditor = true;
		      if (typeof this.props.onCheckCellIsEditable === 'function') {
		        var args = Object.assign({}, { row: row, column: column }, _selected);
		        showEditor = this.props.onCheckCellIsEditable(args);
		      }
		      if (showEditor !== false) {
		        this.setState({ selected: _selected }, this.scrollToColumn(idx));
		        this.handleCancelCopy();
		      }
		    }
		  },
		  setInactive: function setInactive() {
		    var rowIdx = this.state.selected.rowIdx;
		    var row = this.props.rowGetter(rowIdx);
	
		    var idx = this.state.selected.idx;
		    var col = this.getColumn(idx);
	
		    if (ColumnUtils.canEdit(col, row, this.props.enableCellSelect) && this.isActive()) {
		      var _selected2 = Object.assign({}, this.state.selected, { idx: idx, rowIdx: rowIdx, active: false });
		      this.setState({ selected: _selected2 });
		    }
		  },
		  isActive: function isActive() {
		    return this.state.selected.active === true;
		  },
	
	
		  setupGridColumns: function setupGridColumns() {
		    var _this6 = this;
	
		    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
		    var columns = props.columns;
	
		    if (this._cachedColumns === columns) {
		      return this._cachedComputedColumns;
		    }
	
		    this._cachedColumns = columns;
	
		    var cols = columns.slice(0);
		    var unshiftedCols = {};
		    if (this.props.rowActionsCell || props.enableRowSelect && !this.props.rowSelection || props.rowSelection && props.rowSelection.showCheckbox !== false) {
		      var headerRenderer = props.enableRowSelect === 'single' ? null : React.createElement(
		        'div',
		        { className: 'react-grid-checkbox-container checkbox-align' },
		        React.createElement('input', { className: 'react-grid-checkbox', type: 'checkbox', name: 'select-all-checkbox', id: 'select-all-checkbox', ref: function ref(grid) {
		            return _this6.selectAllCheckbox = grid;
		          }, onChange: this.handleCheckboxChange }),
		        React.createElement('label', { htmlFor: 'select-all-checkbox', className: 'react-grid-checkbox-label' })
		      );
		      var Formatter = this.props.rowActionsCell ? this.props.rowActionsCell : CheckboxEditor;
		      var selectColumn = {
		        key: 'select-row',
		        name: '',
		        formatter: React.createElement(Formatter, { rowSelection: this.props.rowSelection }),
		        onCellChange: this.handleRowSelect,
		        filterable: false,
		        headerRenderer: headerRenderer,
		        width: 60,
		        locked: true,
		        getRowMetaData: function getRowMetaData(rowData) {
		          return rowData;
		        },
		        cellClass: this.props.rowActionsCell ? 'rdg-row-actions-cell' : ''
		      };
		      unshiftedCols = cols.unshift(selectColumn);
		      cols = unshiftedCols > 0 ? cols : unshiftedCols;
		    }
		    this._cachedComputedColumns = cols;
	
		    return this._cachedComputedColumns;
		  },
	
		  copyPasteEnabled: function copyPasteEnabled() {
		    return this.props.onCellCopyPaste !== null;
		  },
	
		  dragEnabled: function dragEnabled() {
		    return this.props.onGridRowsUpdated !== undefined || this.props.onCellsDragged !== undefined;
		  },
	
		  renderToolbar: function renderToolbar() {
		    var Toolbar = this.props.toolbar;
		    if (React.isValidElement(Toolbar)) {
		      return React.cloneElement(Toolbar, { columns: this.props.columns, onToggleFilter: this.onToggleFilter, numberOfRows: this.props.rowsCount });
		    }
		  },
		  render: function render() {
		    var _this7 = this;
	
		    var cellMetaData = {
		      selected: this.state.selected,
		      dragged: this.state.dragged,
		      hoveredRowIdx: this.state.hoveredRowIdx,
		      onCellClick: this.onCellClick,
		      onCellContextMenu: this.onCellContextMenu,
		      onCellDoubleClick: this.onCellDoubleClick,
		      onCommit: this.onCellCommit,
		      onCommitCancel: this.setInactive,
		      copied: this.state.copied,
		      handleDragEnterRow: this.handleDragEnter,
		      handleTerminateDrag: this.handleTerminateDrag,
		      enableCellSelect: this.props.enableCellSelect,
		      onColumnEvent: this.onColumnEvent,
		      openCellEditor: this.openCellEditor,
		      onDragHandleDoubleClick: this.onDragHandleDoubleClick,
		      onCellExpand: this.onCellExpand,
		      onRowExpandToggle: this.onRowExpandToggle,
		      onRowHover: this.onRowHover,
		      getDataGridDOMNode: this.getDataGridDOMNode,
		      isScrollingVerticallyWithKeyboard: this.isKeyDown(KeyCodes.DownArrow) || this.isKeyDown(KeyCodes.UpArrow),
		      isScrollingHorizontallyWithKeyboard: this.isKeyDown(KeyCodes.LeftArrow) || this.isKeyDown(KeyCodes.RightArrow) || this.isKeyDown(KeyCodes.Tab)
		    };
	
		    var toolbar = this.renderToolbar();
		    var containerWidth = this.props.minWidth || this.DOMMetrics.gridWidth();
		    var gridWidth = containerWidth - this.state.scrollOffset;
	
		    // depending on the current lifecycle stage, gridWidth() may not initialize correctly
		    // this also handles cases where it always returns undefined -- such as when inside a div with display:none
		    // eg Bootstrap tabs and collapses
		    if (typeof containerWidth === 'undefined' || isNaN(containerWidth) || containerWidth === 0) {
		      containerWidth = '100%';
		    }
		    if (typeof gridWidth === 'undefined' || isNaN(gridWidth) || gridWidth === 0) {
		      gridWidth = '100%';
		    }
		    return React.createElement(
		      'div',
		      { className: 'react-grid-Container', style: { width: containerWidth } },
		      toolbar,
		      React.createElement(
		        'div',
		        { className: 'react-grid-Main' },
		        React.createElement(BaseGrid, _extends({
		          ref: function ref(node) {
		            return _this7.base = node;
		          }
		        }, this.props, {
		          rowKey: this.props.rowKey,
		          headerRows: this.getHeaderRows(),
		          columnMetrics: this.state.columnMetrics,
		          rowGetter: this.props.rowGetter,
		          rowsCount: this.props.rowsCount,
		          rowHeight: this.props.rowHeight,
		          cellMetaData: cellMetaData,
		          selectedRows: this.getSelectedRows(),
		          rowSelection: this.getRowSelectionProps(),
		          expandedRows: this.state.expandedRows,
		          rowOffsetHeight: this.getRowOffsetHeight(),
		          sortColumn: this.state.sortColumn,
		          sortDirection: this.state.sortDirection,
		          onSort: this.handleSort,
		          minHeight: this.props.minHeight,
		          totalWidth: gridWidth,
		          onViewportKeydown: this.onKeyDown,
		          onViewportKeyup: this.onKeyUp,
		          onViewportDragStart: this.onDragStart,
		          onViewportDragEnd: this.handleDragEnd,
		          onViewportDoubleClick: this.onViewportDoubleClick,
		          onColumnResize: this.onColumnResize,
		          rowScrollTimeout: this.props.rowScrollTimeout,
		          contextMenu: this.props.contextMenu,
		          overScan: this.props.overScan }))
		      )
		    );
		  }
		});
	
		module.exports = ReactDataGrid;
	
	/***/ }),
	/* 174 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var Draggable = __webpack_require__(164);
		__webpack_require__(19);
	
		var ResizeHandle = React.createClass({
		  displayName: 'ResizeHandle',
	
		  style: {
		    position: 'absolute',
		    top: 0,
		    right: 0,
		    width: 6,
		    height: '100%'
		  },
	
		  render: function render() {
		    return React.createElement(Draggable, _extends({}, this.props, {
		      className: 'react-grid-HeaderCell__resizeHandle',
		      style: this.style
		    }));
		  }
		});
	
		module.exports = ResizeHandle;
	
	/***/ }),
	/* 175 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _classnames = __webpack_require__(9);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		__webpack_require__(27);
	
		var _utils = __webpack_require__(68);
	
		var _utils2 = _interopRequireDefault(_utils);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var RowGroup = function (_Component) {
		  _inherits(RowGroup, _Component);
	
		  function RowGroup() {
		    _classCallCheck(this, RowGroup);
	
		    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
		    _this.checkFocus = _this.checkFocus.bind(_this);
		    _this.isSelected = _this.isSelected.bind(_this);
		    _this.onClick = _this.onClick.bind(_this);
		    _this.onRowExpandToggle = _this.onRowExpandToggle.bind(_this);
		    _this.onKeyDown = _this.onKeyDown.bind(_this);
		    _this.onRowExpandClick = _this.onRowExpandClick.bind(_this);
		    return _this;
		  }
	
		  RowGroup.prototype.componentDidMount = function componentDidMount() {
		    this.checkFocus();
		  };
	
		  RowGroup.prototype.componentDidUpdate = function componentDidUpdate() {
		    this.checkFocus();
		  };
	
		  RowGroup.prototype.isSelected = function isSelected() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
	
		    return meta.selected && meta.selected.rowIdx === this.props.idx;
		  };
	
		  RowGroup.prototype.onClick = function onClick(e) {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellClick && typeof meta.onCellClick === 'function') {
		      meta.onCellClick({ rowIdx: this.props.idx, idx: 0 }, e);
		    }
		  };
	
		  RowGroup.prototype.onKeyDown = function onKeyDown(e) {
		    if (e.key === 'ArrowLeft') {
		      this.onRowExpandToggle(false);
		    }
		    if (e.key === 'ArrowRight') {
		      this.onRowExpandToggle(true);
		    }
		    if (e.key === 'Enter') {
		      this.onRowExpandToggle(!this.props.isExpanded);
		    }
		  };
	
		  RowGroup.prototype.onRowExpandClick = function onRowExpandClick() {
		    this.onRowExpandToggle(!this.props.isExpanded);
		  };
	
		  RowGroup.prototype.onRowExpandToggle = function onRowExpandToggle(expand) {
		    var shouldExpand = expand == null ? !this.props.isExpanded : expand;
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onRowExpandToggle && typeof meta.onRowExpandToggle === 'function') {
		      meta.onRowExpandToggle({ rowIdx: this.props.idx, shouldExpand: shouldExpand, columnGroupName: this.props.columnGroupName, name: this.props.name });
		    }
		  };
	
		  RowGroup.prototype.getClassName = function getClassName() {
		    return (0, _classnames2['default'])('react-grid-row-group', 'react-grid-Row', { 'row-selected': this.isSelected() });
		  };
	
		  RowGroup.prototype.checkFocus = function checkFocus() {
		    if (this.isSelected()) {
		      _reactDom2['default'].findDOMNode(this).focus();
		    }
		  };
	
		  RowGroup.prototype.render = function render() {
		    var lastColumn = _utils2['default'].last(this.props.columns);
	
		    var style = {
		      height: '50px',
		      overflow: 'hidden',
		      border: '1px solid #dddddd',
		      paddingTop: '15px',
		      paddingLeft: '5px',
		      width: lastColumn.left + lastColumn.width
		    };
		    var rowGroupRendererProps = Object.assign({ onRowExpandClick: this.onRowExpandClick }, this.props);
	
		    return _react2['default'].createElement(
		      'div',
		      { style: style, className: this.getClassName(), onClick: this.onClick, onKeyDown: this.onKeyDown, tabIndex: -1 },
		      _react2['default'].createElement(this.props.renderer, rowGroupRendererProps)
		    );
		  };
	
		  return RowGroup;
		}(_react.Component);
	
		RowGroup.propTypes = {
		  name: _react.PropTypes.string.isRequired,
		  columnGroupName: _react.PropTypes.string.isRequired,
		  isExpanded: _react.PropTypes.bool.isRequired,
		  treeDepth: _react.PropTypes.number.isRequired,
		  height: _react.PropTypes.number.isRequired,
		  cellMetaData: _react.PropTypes.object,
		  idx: _react.PropTypes.number.isRequired,
		  renderer: _react.PropTypes.func,
		  columns: _react.PropTypes.array.isRequired
		};
	
		var DefaultRowGroupRenderer = function DefaultRowGroupRenderer(props) {
		  var treeDepth = props.treeDepth || 0;
		  var marginLeft = treeDepth * 20;
	
		  return _react2['default'].createElement(
		    'div',
		    null,
		    _react2['default'].createElement(
		      'span',
		      { className: 'row-expand-icon', style: { float: 'left', marginLeft: marginLeft, cursor: 'pointer' }, onClick: props.onRowExpandClick },
		      props.isExpanded ? String.fromCharCode('9660') : String.fromCharCode('9658')
		    ),
		    _react2['default'].createElement(
		      'strong',
		      null,
		      props.columnGroupName,
		      ' : ',
		      props.name
		    )
		  );
		};
	
		DefaultRowGroupRenderer.propTypes = {
		  onRowExpandClick: _react.PropTypes.func.isRequired,
		  isExpanded: _react.PropTypes.bool.isRequired,
		  treeDepth: _react.PropTypes.number.isRequired,
		  name: _react.PropTypes.string.isRequired,
		  columnGroupName: _react.PropTypes.string.isRequired
		};
	
		RowGroup.defaultProps = {
		  renderer: DefaultRowGroupRenderer
		};
	
		exports['default'] = RowGroup;
	
	/***/ }),
	/* 176 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var ScrollShim = {
		  appendScrollShim: function appendScrollShim() {
		    if (!this._scrollShim) {
		      var size = this._scrollShimSize();
		      var shim = document.createElement('div');
		      if (shim.classList) {
		        shim.classList.add('react-grid-ScrollShim'); // flow - not compatible with HTMLElement
		      } else {
		        shim.className += ' react-grid-ScrollShim';
		      }
		      shim.style.position = 'absolute';
		      shim.style.top = 0;
		      shim.style.left = 0;
		      shim.style.width = size.width + 'px';
		      shim.style.height = size.height + 'px';
		      _reactDom2['default'].findDOMNode(this).appendChild(shim);
		      this._scrollShim = shim;
		    }
		    this._scheduleRemoveScrollShim();
		  },
		  _scrollShimSize: function _scrollShimSize() {
		    return {
		      width: this.props.width,
		      height: this.props.length * this.props.rowHeight
		    };
		  },
		  _scheduleRemoveScrollShim: function _scheduleRemoveScrollShim() {
		    if (this._scheduleRemoveScrollShimTimer) {
		      clearTimeout(this._scheduleRemoveScrollShimTimer);
		    }
		    this._scheduleRemoveScrollShimTimer = setTimeout(this._removeScrollShim, 200);
		  },
		  _removeScrollShim: function _removeScrollShim() {
		    if (this._scrollShim) {
		      this._scrollShim.parentNode.removeChild(this._scrollShim);
		      this._scrollShim = undefined;
		    }
		  }
		};
	
		module.exports = ScrollShim;
	
	/***/ }),
	/* 177 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var Canvas = __webpack_require__(161);
		var ViewportScroll = __webpack_require__(178);
		var cellMetaDataShape = __webpack_require__(14);
		var PropTypes = React.PropTypes;
	
		var Viewport = React.createClass({
		  displayName: 'Viewport',
	
		  mixins: [ViewportScroll],
	
		  propTypes: {
		    rowOffsetHeight: PropTypes.number.isRequired,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
		    columnMetrics: PropTypes.object.isRequired,
		    rowGetter: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
		    selectedRows: PropTypes.array,
		    rowSelection: React.PropTypes.oneOfType([React.PropTypes.shape({
		      indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		    }), React.PropTypes.shape({
		      isSelectedKey: React.PropTypes.string.isRequired
		    }), React.PropTypes.shape({
		      keys: React.PropTypes.shape({
		        values: React.PropTypes.array.isRequired,
		        rowKey: React.PropTypes.string.isRequired
		      }).isRequired
		    })]),
		    expandedRows: PropTypes.array,
		    rowRenderer: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
		    rowsCount: PropTypes.number.isRequired,
		    rowHeight: PropTypes.number.isRequired,
		    onRows: PropTypes.func,
		    onScroll: PropTypes.func,
		    minHeight: PropTypes.number,
		    cellMetaData: PropTypes.shape(cellMetaDataShape),
		    rowKey: PropTypes.string.isRequired,
		    rowScrollTimeout: PropTypes.number,
		    contextMenu: PropTypes.element,
		    getSubRowDetails: PropTypes.func,
		    rowGroupRenderer: PropTypes.func
		  },
	
		  onScroll: function onScroll(scroll) {
		    this.updateScroll(scroll.scrollTop, scroll.scrollLeft, this.state.height, this.props.rowHeight, this.props.rowsCount);
	
		    if (this.props.onScroll) {
		      this.props.onScroll({ scrollTop: scroll.scrollTop, scrollLeft: scroll.scrollLeft });
		    }
		  },
		  getScroll: function getScroll() {
		    return this.canvas.getScroll();
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    this.canvas.setScrollLeft(scrollLeft);
		  },
		  render: function render() {
		    var _this = this;
	
		    var style = {
		      padding: 0,
		      bottom: 0,
		      left: 0,
		      right: 0,
		      overflow: 'hidden',
		      position: 'absolute',
		      top: this.props.rowOffsetHeight
		    };
		    return React.createElement(
		      'div',
		      {
		        className: 'react-grid-Viewport',
		        style: style },
		      React.createElement(Canvas, {
		        ref: function ref(node) {
		          return _this.canvas = node;
		        },
		        rowKey: this.props.rowKey,
		        totalWidth: this.props.totalWidth,
		        width: this.props.columnMetrics.width,
		        rowGetter: this.props.rowGetter,
		        rowsCount: this.props.rowsCount,
		        selectedRows: this.props.selectedRows,
		        expandedRows: this.props.expandedRows,
		        columns: this.props.columnMetrics.columns,
		        rowRenderer: this.props.rowRenderer,
		        displayStart: this.state.displayStart,
		        displayEnd: this.state.displayEnd,
		        visibleStart: this.state.visibleStart,
		        visibleEnd: this.state.visibleEnd,
		        colVisibleStart: this.state.colVisibleStart,
		        colVisibleEnd: this.state.colVisibleEnd,
		        colDisplayStart: this.state.colDisplayStart,
		        colDisplayEnd: this.state.colDisplayEnd,
		        cellMetaData: this.props.cellMetaData,
		        height: this.state.height,
		        rowHeight: this.props.rowHeight,
		        onScroll: this.onScroll,
		        onRows: this.props.onRows,
		        rowScrollTimeout: this.props.rowScrollTimeout,
		        contextMenu: this.props.contextMenu,
		        rowSelection: this.props.rowSelection,
		        getSubRowDetails: this.props.getSubRowDetails,
		        rowGroupRenderer: this.props.rowGroupRenderer,
		        isScrolling: this.state.isScrolling || false
		      })
		    );
		  }
		});
	
		module.exports = Viewport;
	
	/***/ }),
	/* 178 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _ColumnUtils = __webpack_require__(10);
	
		var _ColumnUtils2 = _interopRequireDefault(_ColumnUtils);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var DOMMetrics = __webpack_require__(23);
		var min = Math.min;
		var max = Math.max;
		var floor = Math.floor;
		var ceil = Math.ceil;
	
		module.exports = {
		  mixins: [DOMMetrics.MetricsMixin],
	
		  DOMMetrics: {
		    viewportHeight: function viewportHeight() {
		      return ReactDOM.findDOMNode(this).offsetHeight;
		    },
		    viewportWidth: function viewportWidth() {
		      return ReactDOM.findDOMNode(this).offsetWidth;
		    }
		  },
	
		  propTypes: {
		    rowHeight: React.PropTypes.number,
		    rowsCount: React.PropTypes.number.isRequired
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      rowHeight: 30
		    };
		  },
		  getInitialState: function getInitialState() {
		    return this.getGridState(this.props);
		  },
		  getGridState: function getGridState(props) {
		    var totalNumberColumns = _ColumnUtils2['default'].getSize(props.columnMetrics.columns);
		    var canvasHeight = props.minHeight - props.rowOffsetHeight;
		    var renderedRowsCount = ceil((props.minHeight - props.rowHeight) / props.rowHeight);
		    var totalRowCount = min(renderedRowsCount * 4, props.rowsCount);
		    return {
		      displayStart: 0,
		      displayEnd: totalRowCount,
		      visibleStart: 0,
		      visibleEnd: totalRowCount,
		      height: canvasHeight,
		      scrollTop: 0,
		      scrollLeft: 0,
		      colVisibleStart: 0,
		      colVisibleEnd: totalNumberColumns,
		      colDisplayStart: 0,
		      colDisplayEnd: totalNumberColumns
		    };
		  },
		  getRenderedColumnCount: function getRenderedColumnCount(displayStart, width) {
		    var remainingWidth = width > 0 ? width : this.props.columnMetrics.totalWidth;
		    if (remainingWidth === 0) {
		      remainingWidth = ReactDOM.findDOMNode(this).offsetWidth;
		    }
		    var columnIndex = displayStart;
		    var columnCount = 0;
		    while (remainingWidth > 0) {
		      var column = _ColumnUtils2['default'].getColumn(this.props.columnMetrics.columns, columnIndex);
	
		      if (!column) {
		        break;
		      }
	
		      columnCount++;
		      columnIndex++;
		      remainingWidth -= column.width;
		    }
		    return columnCount;
		  },
		  getVisibleColStart: function getVisibleColStart(scrollLeft) {
		    var remainingScroll = scrollLeft;
		    var columnIndex = -1;
		    while (remainingScroll >= 0) {
		      columnIndex++;
		      remainingScroll -= _ColumnUtils2['default'].getColumn(this.props.columnMetrics.columns, columnIndex).width;
		    }
		    return columnIndex;
		  },
		  resetScrollStateAfterDelay: function resetScrollStateAfterDelay() {
		    if (this.resetScrollStateTimeoutId) {
		      clearTimeout(this.resetScrollStateTimeoutId);
		    }
	
		    this.resetScrollStateTimeoutId = setTimeout(this.resetScrollStateAfterDelayCallback, 500);
		  },
		  resetScrollStateAfterDelayCallback: function resetScrollStateAfterDelayCallback() {
		    this.resetScrollStateTimeoutId = null;
		    this.setState({
		      isScrolling: false
		    });
		  },
		  updateScroll: function updateScroll(scrollTop, scrollLeft, height, rowHeight, length, width) {
		    var isScrolling = true;
		    this.resetScrollStateAfterDelay();
	
		    var renderedRowsCount = ceil(height / rowHeight);
	
		    var visibleStart = max(0, floor(scrollTop / rowHeight));
	
		    var visibleEnd = min(visibleStart + renderedRowsCount, length);
	
		    var displayStart = max(0, visibleStart - this.props.overScan.rowsStart);
	
		    var displayEnd = min(visibleEnd + this.props.overScan.rowsEnd, length);
	
		    var totalNumberColumns = _ColumnUtils2['default'].getSize(this.props.columnMetrics.columns);
		    var colVisibleStart = totalNumberColumns > 0 ? max(0, this.getVisibleColStart(scrollLeft)) : 0;
		    var renderedColumnCount = this.getRenderedColumnCount(colVisibleStart, width);
		    var colVisibleEnd = renderedColumnCount !== 0 ? colVisibleStart + renderedColumnCount : totalNumberColumns;
		    var colDisplayStart = max(0, colVisibleStart - this.props.overScan.colsStart);
		    var colDisplayEnd = min(colVisibleEnd + this.props.overScan.colsEnd, totalNumberColumns);
	
		    var nextScrollState = {
		      visibleStart: visibleStart,
		      visibleEnd: visibleEnd,
		      displayStart: displayStart,
		      displayEnd: displayEnd,
		      height: height,
		      scrollTop: scrollTop,
		      scrollLeft: scrollLeft,
		      colVisibleStart: colVisibleStart,
		      colVisibleEnd: colVisibleEnd,
		      colDisplayStart: colDisplayStart,
		      colDisplayEnd: colDisplayEnd,
		      isScrolling: isScrolling
		    };
	
		    this.setState(nextScrollState);
		  },
		  metricsUpdated: function metricsUpdated() {
		    var height = this.DOMMetrics.viewportHeight();
		    var width = this.DOMMetrics.viewportWidth();
		    if (height) {
		      this.updateScroll(this.state.scrollTop, this.state.scrollLeft, height, this.props.rowHeight, this.props.rowsCount, width);
		    }
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (this.props.rowHeight !== nextProps.rowHeight || this.props.minHeight !== nextProps.minHeight || _ColumnUtils2['default'].getSize(this.props.columnMetrics.columns) !== _ColumnUtils2['default'].getSize(nextProps.columnMetrics.columns)) {
		      this.setState(this.getGridState(nextProps));
		    } else if (this.props.rowsCount !== nextProps.rowsCount) {
		      this.updateScroll(this.state.scrollTop, this.state.scrollLeft, this.state.height, nextProps.rowHeight, nextProps.rowsCount);
		      // Added to fix the hiding of the bottom scrollbar when showing the filters.
		    } else if (this.props.rowOffsetHeight !== nextProps.rowOffsetHeight) {
		      // The value of height can be positive or negative and will be added to the current height to cater for changes in the header height (due to the filer)
		      var _height = this.props.rowOffsetHeight - nextProps.rowOffsetHeight;
	
		      this.updateScroll(this.state.scrollTop, this.state.scrollLeft, this.state.height + _height, nextProps.rowHeight, nextProps.rowsCount);
		    }
		  }
		};
	
	/***/ }),
	/* 179 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var ExcelColumn = __webpack_require__(11);
	
		var FilterableHeaderCell = React.createClass({
		  displayName: 'FilterableHeaderCell',
	
	
		  propTypes: {
		    onChange: React.PropTypes.func.isRequired,
		    column: React.PropTypes.shape(ExcelColumn)
		  },
	
		  getInitialState: function getInitialState() {
		    return { filterTerm: '' };
		  },
		  handleChange: function handleChange(e) {
		    var val = e.target.value;
		    this.setState({ filterTerm: val });
		    this.props.onChange({ filterTerm: val, column: this.props.column });
		  },
	
	
		  renderInput: function renderInput() {
		    if (this.props.column.filterable === false) {
		      return React.createElement('span', null);
		    }
	
		    var inputKey = 'header-filter-' + this.props.column.key;
		    return React.createElement('input', { key: inputKey, type: 'text', className: 'form-control input-sm', placeholder: 'Search', value: this.state.filterTerm, onChange: this.handleChange });
		  },
	
		  render: function render() {
		    return React.createElement(
		      'div',
		      null,
		      React.createElement(
		        'div',
		        { className: 'form-group' },
		        this.renderInput()
		      )
		    );
		  }
		});
	
		module.exports = FilterableHeaderCell;
	
	/***/ }),
	/* 180 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var joinClasses = __webpack_require__(9);
		var DEFINE_SORT = {
		  ASC: 'ASC',
		  DESC: 'DESC',
		  NONE: 'NONE'
		};
	
		var SortableHeaderCell = React.createClass({
		  displayName: 'SortableHeaderCell',
	
		  propTypes: {
		    columnKey: React.PropTypes.string.isRequired,
		    column: React.PropTypes.shape({ name: React.PropTypes.node }),
		    onSort: React.PropTypes.func.isRequired,
		    sortDirection: React.PropTypes.oneOf(Object.keys(DEFINE_SORT))
		  },
	
		  onClick: function onClick() {
		    var direction = void 0;
		    switch (this.props.sortDirection) {
		      default:
		      case null:
		      case undefined:
		      case DEFINE_SORT.NONE:
		        direction = DEFINE_SORT.ASC;
		        break;
		      case DEFINE_SORT.ASC:
		        direction = DEFINE_SORT.DESC;
		        break;
		      case DEFINE_SORT.DESC:
		        direction = DEFINE_SORT.NONE;
		        break;
		    }
		    this.props.onSort(this.props.columnKey, direction);
		  },
	
		  getSortByText: function getSortByText() {
		    var unicodeKeys = {
		      ASC: '9650',
		      DESC: '9660'
		    };
		    return this.props.sortDirection === 'NONE' ? '' : String.fromCharCode(unicodeKeys[this.props.sortDirection]);
		  },
	
		  render: function render() {
		    var className = joinClasses({
		      'react-grid-HeaderCell-sortable': true,
		      'react-grid-HeaderCell-sortable--ascending': this.props.sortDirection === 'ASC',
		      'react-grid-HeaderCell-sortable--descending': this.props.sortDirection === 'DESC'
		    });
	
		    return React.createElement(
		      'div',
		      { className: className,
		        onClick: this.onClick,
		        style: { cursor: 'pointer' } },
		      React.createElement(
		        'span',
		        { className: 'pull-right' },
		        this.getSortByText()
		      ),
		      this.props.column.name
		    );
		  }
		});
	
		module.exports = SortableHeaderCell;
		module.exports.DEFINE_SORT = DEFINE_SORT;
	
	/***/ }),
	/* 181 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var joinClasses = __webpack_require__(9);
		var keyboardHandlerMixin = __webpack_require__(61);
		var SimpleTextEditor = __webpack_require__(67);
		var isFunction = __webpack_require__(37);
		__webpack_require__(26);
	
		var EditorContainer = React.createClass({
		  displayName: 'EditorContainer',
	
		  mixins: [keyboardHandlerMixin],
	
		  propTypes: {
		    rowIdx: React.PropTypes.number,
		    rowData: React.PropTypes.object.isRequired,
		    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number, React.PropTypes.object, React.PropTypes.bool]).isRequired,
		    cellMetaData: React.PropTypes.shape({
		      selected: React.PropTypes.object.isRequired,
		      copied: React.PropTypes.object,
		      dragged: React.PropTypes.object,
		      onCellClick: React.PropTypes.func,
		      onCellDoubleClick: React.PropTypes.func,
		      onCommitCancel: React.PropTypes.func,
		      onCommit: React.PropTypes.func
		    }).isRequired,
		    column: React.PropTypes.object.isRequired,
		    height: React.PropTypes.number.isRequired
		  },
	
		  changeCommitted: false,
	
		  getInitialState: function getInitialState() {
		    return { isInvalid: false };
		  },
	
	
		  componentDidMount: function componentDidMount() {
		    var inputNode = this.getInputNode();
		    if (inputNode !== undefined) {
		      this.setTextInputFocus();
		      if (!this.getEditor().disableContainerStyles) {
		        inputNode.className += ' editor-main';
		        inputNode.style.height = this.props.height - 1 + 'px';
		      }
		    }
		  },
	
		  componentWillUnmount: function componentWillUnmount() {
		    if (!this.changeCommitted && !this.hasEscapeBeenPressed()) {
		      this.commit({ key: 'Enter' });
		    }
		  },
	
		  createEditor: function createEditor() {
		    var _this = this;
	
		    var editorRef = function editorRef(c) {
		      return _this.editor = c;
		    };
		    var editorProps = {
		      ref: editorRef,
		      column: this.props.column,
		      value: this.getInitialValue(),
		      onCommit: this.commit,
		      rowMetaData: this.getRowMetaData(),
		      rowData: this.props.rowData,
		      height: this.props.height,
		      onBlur: this.commit,
		      onOverrideKeyDown: this.onKeyDown,
		      onCommitCancel: this.props.cellMetaData.onCommitCancel
		    };
	
		    var CustomEditor = this.props.column.editor;
		    // return custom column editor or SimpleEditor if none specified
		    if (React.isValidElement(CustomEditor)) {
		      return React.cloneElement(CustomEditor, editorProps);
		    }
		    if (isFunction(CustomEditor)) {
		      return React.createElement(CustomEditor, _extends({ ref: editorRef }, editorProps));
		    }
	
		    return React.createElement(SimpleTextEditor, { ref: editorRef, column: this.props.column, value: this.getInitialValue(), onBlur: this.commit, rowMetaData: this.getRowMetaData(), onKeyDown: function onKeyDown() {}, commit: function commit() {} });
		  },
		  onPressEnter: function onPressEnter() {
		    this.commit({ key: 'Enter' });
		  },
		  onPressTab: function onPressTab() {
		    this.commit({ key: 'Tab' });
		  },
		  onPressEscape: function onPressEscape(e) {
		    if (!this.editorIsSelectOpen()) {
		      this.props.cellMetaData.onCommitCancel();
		    } else {
		      // prevent event from bubbling if editor has results to select
		      e.stopPropagation();
		    }
		  },
		  onPressArrowDown: function onPressArrowDown(e) {
		    if (this.editorHasResults()) {
		      // dont want to propogate as that then moves us round the grid
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  onPressArrowUp: function onPressArrowUp(e) {
		    if (this.editorHasResults()) {
		      // dont want to propogate as that then moves us round the grid
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  onPressArrowLeft: function onPressArrowLeft(e) {
		    // prevent event propogation. this disables left cell navigation
		    if (!this.isCaretAtBeginningOfInput()) {
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  onPressArrowRight: function onPressArrowRight(e) {
		    // prevent event propogation. this disables right cell navigation
		    if (!this.isCaretAtEndOfInput()) {
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  editorHasResults: function editorHasResults() {
		    if (isFunction(this.getEditor().hasResults)) {
		      return this.getEditor().hasResults();
		    }
	
		    return false;
		  },
		  editorIsSelectOpen: function editorIsSelectOpen() {
		    if (isFunction(this.getEditor().isSelectOpen)) {
		      return this.getEditor().isSelectOpen();
		    }
	
		    return false;
		  },
		  getRowMetaData: function getRowMetaData() {
		    // clone row data so editor cannot actually change this
		    // convention based method to get corresponding Id or Name of any Name or Id property
		    if (typeof this.props.column.getRowMetaData === 'function') {
		      return this.props.column.getRowMetaData(this.props.rowData, this.props.column);
		    }
		  },
		  getEditor: function getEditor() {
		    return this.editor;
		  },
		  getInputNode: function getInputNode() {
		    return this.getEditor().getInputNode();
		  },
		  getInitialValue: function getInitialValue() {
		    var selected = this.props.cellMetaData.selected;
		    var keyCode = selected.initialKeyCode;
		    if (keyCode === 'Delete' || keyCode === 'Backspace') {
		      return '';
		    } else if (keyCode === 'Enter') {
		      return this.props.value;
		    }
	
		    var text = keyCode ? String.fromCharCode(keyCode) : this.props.value;
		    return text;
		  },
		  getContainerClass: function getContainerClass() {
		    return joinClasses({
		      'has-error': this.state.isInvalid === true
		    });
		  },
		  commit: function commit(args) {
		    var opts = args || {};
		    var updated = this.getEditor().getValue();
		    if (this.isNewValueValid(updated)) {
		      this.changeCommitted = true;
		      var cellKey = this.props.column.key;
		      this.props.cellMetaData.onCommit({ cellKey: cellKey, rowIdx: this.props.rowIdx, updated: updated, key: opts.key });
		    }
		  },
		  isNewValueValid: function isNewValueValid(value) {
		    if (isFunction(this.getEditor().validate)) {
		      var isValid = this.getEditor().validate(value);
		      this.setState({ isInvalid: !isValid });
		      return isValid;
		    }
	
		    return true;
		  },
		  setCaretAtEndOfInput: function setCaretAtEndOfInput() {
		    var input = this.getInputNode();
		    // taken from http://stackoverflow.com/questions/511088/use-javascript-to-place-cursor-at-end-of-text-in-text-input-element
		    var txtLength = input.value.length;
		    if (input.setSelectionRange) {
		      input.setSelectionRange(txtLength, txtLength);
		    } else if (input.createTextRange) {
		      var fieldRange = input.createTextRange();
		      fieldRange.moveStart('character', txtLength);
		      fieldRange.collapse();
		      fieldRange.select();
		    }
		  },
		  isCaretAtBeginningOfInput: function isCaretAtBeginningOfInput() {
		    var inputNode = this.getInputNode();
		    return inputNode.selectionStart === inputNode.selectionEnd && inputNode.selectionStart === 0;
		  },
		  isCaretAtEndOfInput: function isCaretAtEndOfInput() {
		    var inputNode = this.getInputNode();
		    return inputNode.selectionStart === inputNode.value.length;
		  },
		  isBodyClicked: function isBodyClicked(e) {
		    var relatedTarget = this.getRelatedTarget(e);
		    return relatedTarget === null;
		  },
		  isViewportClicked: function isViewportClicked(e) {
		    var relatedTarget = this.getRelatedTarget(e);
		    return relatedTarget.className.indexOf('react-grid-Viewport') > -1;
		  },
		  isClickInisdeEditor: function isClickInisdeEditor(e) {
		    var relatedTarget = this.getRelatedTarget(e);
		    return e.currentTarget.contains(relatedTarget) || relatedTarget.className.indexOf('editing') > -1 || relatedTarget.className.indexOf('react-grid-Cell') > -1;
		  },
		  getRelatedTarget: function getRelatedTarget(e) {
		    return e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
		  },
		  handleRightClick: function handleRightClick(e) {
		    e.stopPropagation();
		  },
		  handleBlur: function handleBlur(e) {
		    e.stopPropagation();
		    if (this.isBodyClicked(e)) {
		      this.commit(e);
		    }
	
		    if (!this.isBodyClicked(e)) {
		      // prevent null reference
		      if (this.isViewportClicked(e) || !this.isClickInisdeEditor(e)) {
		        this.commit(e);
		      }
		    }
		  },
		  setTextInputFocus: function setTextInputFocus() {
		    var selected = this.props.cellMetaData.selected;
		    var keyCode = selected.initialKeyCode;
		    var inputNode = this.getInputNode();
		    inputNode.focus();
		    if (inputNode.tagName === 'INPUT') {
		      if (!this.isKeyPrintable(keyCode)) {
		        inputNode.focus();
		        inputNode.select();
		      } else {
		        inputNode.select();
		      }
		    }
		  },
		  hasEscapeBeenPressed: function hasEscapeBeenPressed() {
		    var pressed = false;
		    var escapeKey = 27;
		    if (window.event) {
		      if (window.event.keyCode === escapeKey) {
		        pressed = true;
		      } else if (window.event.which === escapeKey) {
		        pressed = true;
		      }
		    }
		    return pressed;
		  },
		  renderStatusIcon: function renderStatusIcon() {
		    if (this.state.isInvalid === true) {
		      return React.createElement('span', { className: 'glyphicon glyphicon-remove form-control-feedback' });
		    }
		  },
		  render: function render() {
		    return React.createElement(
		      'div',
		      { className: this.getContainerClass(), onBlur: this.handleBlur, onKeyDown: this.onKeyDown, onContextMenu: this.handleRightClick },
		      this.createEditor(),
		      this.renderStatusIcon()
		    );
		  }
		});
	
		module.exports = EditorContainer;
	
	/***/ }),
	/* 182 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = {
		  CheckboxEditor: __webpack_require__(65),
		  EditorBase: __webpack_require__(66),
		  SimpleTextEditor: __webpack_require__(67)
		};
	
	/***/ }),
	/* 183 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */
	
	
		var focusableComponentWrapper = function focusableComponentWrapper(WrappedComponent) {
		  return function (_Component) {
		    _inherits(ComponentWrapper, _Component);
	
		    function ComponentWrapper() {
		      _classCallCheck(this, ComponentWrapper);
	
		      var _this = _possibleConstructorReturn(this, _Component.call(this));
	
		      _this.checkFocus = _this.checkFocus.bind(_this);
		      _this.state = { isScrolling: false };
		      return _this;
		    }
	
		    ComponentWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		      return WrappedComponent.isSelected(this.props) !== WrappedComponent.isSelected(nextProps);
		    };
	
		    ComponentWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		      var isScrolling = WrappedComponent.isScrolling(nextProps);
		      if (isScrolling && !this.state.isScrolling) {
		        this.setState({ isScrolling: isScrolling });
		      }
		    };
	
		    ComponentWrapper.prototype.componentDidMount = function componentDidMount() {
		      this.checkFocus();
		    };
	
		    ComponentWrapper.prototype.componentDidUpdate = function componentDidUpdate() {
		      this.checkFocus();
		    };
	
		    ComponentWrapper.prototype.checkFocus = function checkFocus() {
		      if (WrappedComponent.isSelected(this.props) && this.state.isScrolling) {
		        this.focus();
		        this.setState({ isScrolling: false });
		      }
		    };
	
		    ComponentWrapper.prototype.focus = function focus() {
		      _reactDom2['default'].findDOMNode(this).focus();
		    };
	
		    ComponentWrapper.prototype.render = function render() {
		      return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, this.state));
		    };
	
		    return ComponentWrapper;
		  }(_react.Component);
		};
	
		exports['default'] = focusableComponentWrapper;
	
	/***/ }),
	/* 184 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
	
		var SimpleCellFormatter = React.createClass({
		  displayName: 'SimpleCellFormatter',
	
		  propTypes: {
		    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number, React.PropTypes.object, React.PropTypes.bool]).isRequired
		  },
	
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    return nextProps.value !== this.props.value;
		  },
		  render: function render() {
		    return React.createElement(
		      'div',
		      { title: this.props.value },
		      this.props.value
		    );
		  }
		});
	
		module.exports = SimpleCellFormatter;
	
	/***/ }),
	/* 185 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _GridPropHelpers = __webpack_require__(186);
	
		var _GridPropHelpers2 = _interopRequireDefault(_GridPropHelpers);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		module.exports = {
		  test: { GridPropHelpers: _GridPropHelpers2['default'] }
		};
	
	/***/ }),
	/* 186 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var _rows = [];
		for (var i = 0; i < 1000; i++) {
		  _rows.push({
		    id: i,
		    title: 'Title ' + i,
		    count: i * 1000
		  });
		}
		module.exports = {
		  columns: [{
		    key: 'id',
		    name: 'ID',
		    width: 100
		  }, {
		    key: 'title',
		    name: 'Title',
		    width: 100
		  }, {
		    key: 'count',
		    name: 'Count',
		    width: 100
		  }],
		  rowGetter: function rowGetter(i) {
		    return _rows[i];
		  },
		  rowsCount: function rowsCount() {
		    return _rows.length;
		  },
		  cellMetaData: {
		    selected: { idx: 2, rowIdx: 3 },
		    dragged: null,
		    copied: null
		  }
		};
	
	/***/ }),
	/* 187 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _RowComparer = __webpack_require__(62);
	
		var _RowComparer2 = _interopRequireDefault(_RowComparer);
	
		var _RowsContainer = __webpack_require__(64);
	
		var _RowsContainer2 = _interopRequireDefault(_RowsContainer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var Grid = __webpack_require__(173);
	
	
		module.exports = Grid;
		module.exports.Row = __webpack_require__(34);
		module.exports.Cell = __webpack_require__(59);
		module.exports.HeaderCell = __webpack_require__(60);
		module.exports.RowComparer = _RowComparer2['default'];
		module.exports.RowsContainer = _RowsContainer2['default'];
		module.exports.editors = __webpack_require__(182);
		module.exports.utils = __webpack_require__(68);
		module.exports.shapes = __webpack_require__(172);
		module.exports._constants = __webpack_require__(58);
		module.exports._helpers = __webpack_require__(185);
	
	/***/ }),
	/* 188 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		var isEmptyArray = function isEmptyArray(obj) {
		  return Array.isArray(obj) && obj.length === 0;
		};
	
		module.exports = isEmptyArray;
	
	/***/ }),
	/* 189 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		function isEmpty(obj) {
		  return Object.keys(obj).length === 0 && obj.constructor === Object;
		}
	
		module.exports = isEmpty;
	
	/***/ }),
	/* 190 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _immutable = __webpack_require__(18);
	
		var isImmutableCollection = function isImmutableCollection(objToVerify) {
		  return _immutable.Iterable.isIterable(objToVerify);
		};
	
		module.exports = isImmutableCollection;
	
	/***/ }),
	/* 191 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _immutable = __webpack_require__(18);
	
		module.exports = _immutable.Map.isMap;
	
	/***/ }),
	/* 192 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		var getMixedTypeValueRetriever = function getMixedTypeValueRetriever(isImmutable) {
		  var retObj = {};
		  var retriever = function retriever(item, key) {
		    return item[key];
		  };
		  var immutableRetriever = function immutableRetriever(immutable, key) {
		    return immutable.get(key);
		  };
	
		  retObj.getValue = isImmutable ? immutableRetriever : retriever;
	
		  return retObj;
		};
	
		module.exports = getMixedTypeValueRetriever;
	
	/***/ }),
	/* 193 */
	/***/ (function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Cell{background-color:#fff;padding-left:8px;padding-right:8px;border-right:1px solid #eee;border-bottom:1px solid #ddd}.react-grid-Cell:focus{outline:2px solid #66afe9;outline-offset:-2px}.react-grid-Cell:focus .drag-handle{position:absolute;bottom:-5px;right:-4px;background:#66afe9;width:8px;height:8px;border:1px solid #fff;border-right:0;border-bottom:0;z-index:8;cursor:crosshair;cursor:-webkit-grab}.react-grid-Cell:not(.editing) .react-grid-Cell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;position:relative;top:50%;transform:translateY(-50%)}.react-grid-Cell.readonly{background-color:#000}.react-grid-Cell.copied{background:rgba(0,0,255,.2)!important}.react-grid-Cell--locked:last-of-type{border-right:1px solid #ddd;box-shadow:none;z-index:99}.react-grid-Cell:hover:focus .drag-handle .glyphicon-arrow-down{display:\"block\"}.react-grid-Cell.is-dragged-over-down{border-right:1px dashed #000;border-left:1px dashed #000;border-bottom:1px dashed #000}.react-grid-Cell.is-dragged-over-up{border-right:1px dashed #000;border-left:1px dashed #000;border-top:1px dashed #000}.react-grid-Cell.is-dragged-over-up .drag-handle{top:-5px}.react-grid-Cell:hover{background:#eee}.react-grid-cell .form-control-feedback{color:#a94442;position:absolute;top:0;right:10px;z-index:1000000;display:block;width:34px;height:34px}.react-grid-Cell.was-dragged-over{border-right:1px dashed #000;border-left:1px dashed #000}.react-grid-Cell:hover:focus .drag-handle{position:absolute;bottom:-8px;right:-7px;background:#fff;width:16px;height:16px;border:1px solid #66afe9;z-index:8;cursor:crosshair;cursor:-webkit-grab}.react-grid-Row.row-selected .react-grid-Cell{background-color:#dbecfa}.react-grid-Cell.editing{padding:0;overflow:visible!important}.react-grid-Cell.editing .has-error input{border:2px solid red!important;border-radius:2px!important}.react-grid-Cell__value ul{margin-top:0;margin-bottom:0;display:inline-block}.react-grid-Cell__value .btn-sm{padding:0}.cell-tooltip{position:relative;display:inline-block}.cell-tooltip .cell-tooltip-text{visibility:hidden;width:150px;background-color:#000;color:#fff;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;bottom:-150%;left:50%;margin-left:-60px;opacity:1s}.cell-tooltip:hover .cell-tooltip-text{visibility:visible;opacity:.8}.cell-tooltip .cell-tooltip-text:after{content:\" \";position:absolute;bottom:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent #000}.react-grid-Canvas.opaque .react-grid-Cell.cell-tooltip:hover .cell-tooltip-text{visibility:hidden}", ""]);
	
		// exports
	
	
	/***/ }),
	/* 194 */
	/***/ (function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".radio-custom,.react-grid-checkbox{opacity:0;position:absolute}.radio-custom,.radio-custom-label,.react-grid-checkbox,.react-grid-checkbox-label{display:inline-block;vertical-align:middle;margin:10px;cursor:pointer}.radio-custom-label,.react-grid-checkbox-label{position:relative}.radio-custom+.radio-custom-label:before,.react-grid-checkbox+.react-grid-checkbox-label:before{content:\"\";background:#fff;border:2px solid #ddd;display:inline-block;vertical-align:middle;width:20px;height:20px;text-align:center}.react-grid-checkbox:checked+.react-grid-checkbox-label:before{background:#005295;box-shadow:inset 0 0 0 4px #fff}.radio-custom:focus+.radio-custom-label,.react-grid-checkbox:focus+.react-grid-checkbox-label{outline:1px solid #ddd}.react-grid-HeaderCell input[type=checkbox]{z-index:99999}.react-grid-HeaderCell>.react-grid-checkbox-container{padding:0 10px;height:100%}.react-grid-HeaderCell>.react-grid-checkbox-container>.react-grid-checkbox-label{margin:0;margin-top:-.3em;position:relative;top:50%;transform:translateY(-50%)}.radio-custom+.radio-custom-label:before{border-radius:50%}.radio-custom:checked+.radio-custom-label:before{background:#ccc;box-shadow:inset 0 0 0 4px #fff}.checkbox-align{text-align:center}", ""]);
	
		// exports
	
	
	/***/ }),
	/* 195 */
	/***/ (function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Container{clear:both;margin-top:0;padding:0}.react-grid-Main{background-color:#fff;color:inherit;padding:0;outline:1px solid #e7eaec;clear:both}.react-grid-Grid{border:1px solid #ddd}.react-grid-Canvas,.react-grid-Grid{background-color:#fff}.react-grid-Cell input.editor-main,select.editor-main{display:block;width:100%;height:34px;padding:6px 12px;font-size:14px;line-height:1.42857143;color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}input.editor-main:focus,select.editor-main:focus{border-color:#66afe9;border:2px solid #66afe9;background:#eee;border-radius:4px}.react-grid-Cell input.editor-main::-moz-placeholder,select.editor-main::-moz-placeholder{color:#999;opacity:1}.react-grid-Cell input.editor-main:-ms-input-placeholder,select.editor-main:-ms-input-placeholder{color:#999}.react-grid-Cell input.editor-main::-webkit-input-placeholder,select.editor-main::-webkit-input-placeholder{color:#999}.react-grid-Cell input.editor-main[disabled],.react-grid-Cell input.editor-main[readonly],fieldset[disabled] .react-grid-Cell input.editor-main,fieldset[disabled] select.editor-main,select.editor-main[disabled],select.editor-main[readonly]{cursor:not-allowed;background-color:#eee;opacity:1}textarea.react-grid-Cell input.editor-main,textareaselect.editor-main{height:auto}.react-grid-ScrollShim{z-index:10002}", ""]);
	
		// exports
	
	
	/***/ }),
	/* 196 */
	/***/ (function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Header{box-shadow:0 0 4px 0 #ddd;background:#f9f9f9}.react-grid-Header--resizing{cursor:ew-resize}.react-grid-HeaderCell,.react-grid-HeaderRow{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.react-grid-HeaderCell{background:#f9f9f9;padding:8px;font-weight:700;border-right:1px solid #ddd;border-bottom:1px solid #ddd}.react-grid-HeaderCell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;position:relative;top:50%;transform:translateY(-50%)}.react-grid-HeaderCell__resizeHandle:hover{cursor:ew-resize;background:#ddd}.react-grid-HeaderCell--locked:last-of-type{box-shadow:none}.react-grid-HeaderCell--resizing .react-grid-HeaderCell__resizeHandle{background:#ddd}.react-grid-HeaderCell__draggable{cursor:col-resize}.rdg-can-drop>.react-grid-HeaderCell{background:#ececec}", ""]);
	
		// exports
	
	
	/***/ }),
	/* 197 */
	/***/ (function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Row.row-context-menu .react-grid-Cell,.react-grid-Row:hover .react-grid-Cell{background-color:#f2f2f2}.react-grid-Row:hover .rdg-row-index{display:none}.react-grid-Row:hover .rdg-actions-checkbox{display:block}.react-grid-Row:hover .rdg-drag-row-handle{cursor:move;cursor:grab;cursor:-moz-grab;cursor:-webkit-grab;width:12px;height:30px;margin-left:0;background-image:url(\"data:image/svg+xml;base64, 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\");background-repeat:no-repeat}.react-grid-Row.row-selected,.react-grid-Row .row-selected{background-color:#dbecfa}.react-grid-row-group .row-expand-icon:hover{color:#777}.react-grid-row-index{padding:0 18px}.rdg-row-index{display:block;text-align:center}.rdg-row-actions-cell{padding:0}.rdg-actions-checkbox{display:none;text-align:center}.rdg-actions-checkbox.selected{display:block}.rdg-dragging{cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}.rdg-dragged-row{border-bottom:1px solid #000}", ""]);
	
		// exports
	
	
	/***/ }),
	/* 198 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @providesModule invariant
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  if (false) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  }
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		module.exports = invariant;
	
	/***/ }),
	/* 199 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @providesModule keyMirror
		 * @typechecks static-only
		 */
	
		'use strict';
	
		var invariant = __webpack_require__(198);
	
		/**
		 * Constructs an enumeration with keys equal to their value.
		 *
		 * For example:
		 *
		 *   var COLORS = keyMirror({blue: null, red: null});
		 *   var myColor = COLORS.blue;
		 *   var isColorValid = !!COLORS[myColor];
		 *
		 * The last line could not be performed if the values of the generated enum were
		 * not equal to their keys.
		 *
		 *   Input:  {key1: val1, key2: val2}
		 *   Output: {key1: key1, key2: key2}
		 *
		 * @param {object} obj
		 * @return {object}
		 */
		var keyMirror = function (obj) {
		  var ret = {};
		  var key;
		  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
		  for (key in obj) {
		    if (!obj.hasOwnProperty(key)) {
		      continue;
		    }
		    ret[key] = key;
		  }
		  return ret;
		};
	
		module.exports = keyMirror;
	
	/***/ })
	/******/ ])
	});
	;

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1029);

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _I18n = __webpack_require__(226);
	
	Object.defineProperty(exports, 'I18n', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_I18n).default;
	  }
	});
	
	var _Translate = __webpack_require__(1033);
	
	Object.defineProperty(exports, 'Translate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Translate).default;
	  }
	});
	
	var _Localize = __webpack_require__(1032);
	
	Object.defineProperty(exports, 'Localize', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Localize).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _I18n = __webpack_require__(226);
	
	var _I18n2 = _interopRequireDefault(_I18n);
	
	var _Base = __webpack_require__(225);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-underscore-dangle: "off" */
	
	var Localize = function (_BaseComponent) {
	  _inherits(Localize, _BaseComponent);
	
	  function Localize() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Localize);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Localize.__proto__ || Object.getPrototypeOf(Localize)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _I18n2.default._localize(_this.props.value, _this.props.dateFormat ? { dateFormat: _this.props.dateFormat } : _this.props.options)
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return Localize;
	}(_Base2.default);
	
	Localize.propTypes = {
	  value: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number, _react2.default.PropTypes.object]).isRequired,
	  options: _react2.default.PropTypes.object,
	  dateFormat: _react2.default.PropTypes.string
	};
	exports.default = Localize;

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _I18n = __webpack_require__(226);
	
	var _I18n2 = _interopRequireDefault(_I18n);
	
	var _Base = __webpack_require__(225);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-underscore-dangle: "off" */
	
	var Translate = function (_BaseComponent) {
	  _inherits(Translate, _BaseComponent);
	
	  function Translate() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Translate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Translate.__proto__ || Object.getPrototypeOf(Translate)).call.apply(_ref, [this].concat(args))), _this), _this.otherProps = function () {
	      var result = _extends({}, _this.props);
	      delete result.value;
	      return result;
	    }, _this.render = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _I18n2.default._translate(_this.props.value, _this.otherProps())
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return Translate;
	}(_Base2.default);
	
	Translate.propTypes = {
	  value: _react2.default.PropTypes.string.isRequired
	};
	exports.default = Translate;

/***/ },
/* 1034 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatMissingTranslation;
	function formatMissingTranslation(text) {
	  var keys = text.split('.');
	  return keys[keys.length - 1].replace(/([a-z])([A-Z])/g, '$1 $2').replace(/[A-Z]/g, function (str) {
	    return str.toLowerCase();
	  }).replace(/_/g, ' ').replace(/\b./g, function (str) {
	    return str.toUpperCase();
	  });
	}

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__(482);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actions.LOAD_TRANSLATIONS:
	      return _extends({}, state, {
	        translations: action.translations
	      });
	    case _actions.SET_LOCALE:
	      return _extends({}, state, {
	        locale: action.locale
	      });
	    default:
	      return state;
	  }
	};

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(483);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(484);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react.Children.only(children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(483);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(1038);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(1039);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(484);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(117);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(145);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = undefined;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure;
	  var pure = _options$pure === undefined ? true : _options$pure;
	  var _options$withRef = options.withRef;
	  var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged;
	        var hasStoreStateChanged = this.hasStoreStateChanged;
	        var haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated;
	        var statePropsPrecalculationError = this.statePropsPrecalculationError;
	        var renderedElement = this.renderedElement;
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 1038 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(12);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(485);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload;
	        var method = _action$payload.method;
	        var args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(486);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  var _ref$selectLocationSt = _ref.selectLocationState;
	  var selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt;
	  var _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay;
	  var adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      listener(lastPublishedLocation);
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(487);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(488);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(72);
	
	var _InternalPropTypes = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(72);
	
	var _InternalPropTypes = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(320);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(144);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(229);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(90);
	
	var _RouterContext = __webpack_require__(158);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(72);
	
	var _RouterUtils = __webpack_require__(489);
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(158);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(227);
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(158);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(847);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(491);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(102);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(227);
	
	var _makeStateWithLocation = __webpack_require__(492);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(102);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(320);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(491);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(102);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(98);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(490);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(229);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(72);
	
	var _RouterUtils = __webpack_require__(489);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(227);
	
	var _makeStateWithLocation = __webpack_require__(492);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(102);
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(144);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(229);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(25);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(145);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(228);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _find = __webpack_require__(950);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _sortBy = __webpack_require__(961);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Manager = function () {
	  function Manager() {
	    _classCallCheck(this, Manager);
	
	    this.refs = {};
	  }
	
	  _createClass(Manager, [{
	    key: 'add',
	    value: function add(collection, ref) {
	      if (!this.refs[collection]) {
	        this.refs[collection] = [];
	      }
	
	      this.refs[collection].push(ref);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(collection, ref) {
	      var index = this.getIndex(collection, ref);
	
	      if (index !== -1) {
	        this.refs[collection].splice(index, 1);
	      }
	    }
	  }, {
	    key: 'getActive',
	    value: function getActive() {
	      var _this = this;
	
	      return (0, _find2.default)(this.refs[this.active.collection],
	      // eslint-disable-next-line eqeqeq
	      function (_ref) {
	        var node = _ref.node;
	        return node.sortableInfo.index == _this.active.index;
	      });
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(collection, ref) {
	      return this.refs[collection].indexOf(ref);
	    }
	  }, {
	    key: 'getOrderedRefs',
	    value: function getOrderedRefs() {
	      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
	
	      return (0, _sortBy2.default)(this.refs[collection], function (_ref2) {
	        var node = _ref2.node;
	        return node.sortableInfo.index;
	      });
	    }
	  }]);
	
	  return Manager;
	}();
	
	exports.default = Manager;

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = sortableContainer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(63);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Manager = __webpack_require__(1063);
	
	var _Manager2 = _interopRequireDefault(_Manager);
	
	var _utils = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Export Higher Order Sortable Container Component
	function sortableContainer(WrappedComponent) {
	  var _class, _temp;
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };
	
	  return _temp = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class(props) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	      _this.handleStart = function (e) {
	        var _this$props = _this.props,
	            distance = _this$props.distance,
	            shouldCancelStart = _this$props.shouldCancelStart;
	
	
	        if (e.button === 2 || shouldCancelStart(e)) {
	          return false;
	        }
	
	        _this._touched = true;
	        _this._pos = {
	          x: e.clientX,
	          y: e.clientY
	        };
	
	        var node = (0, _utils.closest)(e.target, function (el) {
	          return el.sortableInfo != null;
	        });
	
	        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
	          var useDragHandle = _this.props.useDragHandle;
	          var _node$sortableInfo = node.sortableInfo,
	              index = _node$sortableInfo.index,
	              collection = _node$sortableInfo.collection;
	
	
	          if (useDragHandle && !(0, _utils.closest)(e.target, function (el) {
	            return el.sortableHandle != null;
	          })) return;
	
	          _this.manager.active = { index: index, collection: collection };
	
	          /*
	          * Fixes a bug in Firefox where the :active state of anchor tags
	          * prevent subsequent 'mousemove' events from being fired
	          * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
	          */
	          if (e.target.tagName.toLowerCase() === 'a') {
	            e.preventDefault();
	          }
	
	          if (!distance) {
	            if (_this.props.pressDelay === 0) {
	              _this.handlePress(e);
	            } else {
	              _this.pressTimer = setTimeout(function () {
	                return _this.handlePress(e);
	              }, _this.props.pressDelay);
	            }
	          }
	        }
	      };
	
	      _this.nodeIsChild = function (node) {
	        return node.sortableInfo.manager === _this.manager;
	      };
	
	      _this.handleMove = function (e) {
	        var _this$props2 = _this.props,
	            distance = _this$props2.distance,
	            pressThreshold = _this$props2.pressThreshold;
	
	
	        if (!_this.state.sorting && _this._touched) {
	          _this._delta = {
	            x: _this._pos.x - e.clientX,
	            y: _this._pos.y - e.clientY
	          };
	          var delta = Math.abs(_this._delta.x) + Math.abs(_this._delta.y);
	
	          if (!distance && (!pressThreshold || pressThreshold && delta >= pressThreshold)) {
	            clearTimeout(_this.cancelTimer);
	            _this.cancelTimer = setTimeout(_this.cancel, 0);
	          } else if (distance && delta >= distance) {
	            _this.handlePress(e);
	          }
	        }
	      };
	
	      _this.handleEnd = function () {
	        var distance = _this.props.distance;
	
	
	        _this._touched = false;
	
	        if (!distance) {
	          _this.cancel();
	        }
	      };
	
	      _this.cancel = function () {
	        if (!_this.state.sorting) {
	          clearTimeout(_this.pressTimer);
	          _this.manager.active = null;
	        }
	      };
	
	      _this.handlePress = function (e) {
	        var active = _this.manager.getActive();
	
	        if (active) {
	          var _this$props3 = _this.props,
	              axis = _this$props3.axis,
	              getHelperDimensions = _this$props3.getHelperDimensions,
	              helperClass = _this$props3.helperClass,
	              hideSortableGhost = _this$props3.hideSortableGhost,
	              onSortStart = _this$props3.onSortStart,
	              useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
	          var node = active.node,
	              collection = active.collection;
	          var index = node.sortableInfo.index;
	
	          var margin = (0, _utils.getElementMargin)(node);
	
	          var containerBoundingRect = _this.container.getBoundingClientRect();
	          var dimensions = getHelperDimensions({ index: index, node: node, collection: collection });
	
	          _this.node = node;
	          _this.margin = margin;
	          _this.width = dimensions.width;
	          _this.height = dimensions.height;
	          _this.marginOffset = {
	            x: _this.margin.left + _this.margin.right,
	            y: Math.max(_this.margin.top, _this.margin.bottom)
	          };
	          _this.boundingClientRect = node.getBoundingClientRect();
	          _this.containerBoundingRect = containerBoundingRect;
	          _this.index = index;
	          _this.newIndex = index;
	
	          _this.axis = {
	            x: axis.indexOf('x') >= 0,
	            y: axis.indexOf('y') >= 0
	          };
	          _this.offsetEdge = _this.getEdgeOffset(node);
	          _this.initialOffset = _this.getOffset(e);
	          _this.initialScroll = {
	            top: _this.scrollContainer.scrollTop,
	            left: _this.scrollContainer.scrollLeft
	          };
	
	          var fields = node.querySelectorAll('input, textarea, select');
	          var clonedNode = node.cloneNode(true);
	          var clonedFields = [].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array
	
	          clonedFields.forEach(function (field, index) {
	            return field.value = fields[index] && fields[index].value;
	          });
	
	          _this.helper = _this.document.body.appendChild(clonedNode);
	
	          _this.helper.style.position = 'fixed';
	          _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
	          _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
	          _this.helper.style.width = _this.width + 'px';
	          _this.helper.style.height = _this.height + 'px';
	          _this.helper.style.boxSizing = 'border-box';
	
	          if (hideSortableGhost) {
	            _this.sortableGhost = node;
	            node.style.visibility = 'hidden';
	          }
	
	          _this.minTranslate = {};
	          _this.maxTranslate = {};
	          if (_this.axis.x) {
	            _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
	            _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
	          }
	          if (_this.axis.y) {
	            _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
	            _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
	          }
	
	          if (helperClass) {
	            var _this$helper$classLis;
	
	            (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, _toConsumableArray(helperClass.split(' ')));
	          }
	
	          _this.listenerNode = e.touches ? node : _this.contentWindow;
	          _utils.events.move.forEach(function (eventName) {
	            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
	          });
	          _utils.events.end.forEach(function (eventName) {
	            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
	          });
	
	          _this.setState({
	            sorting: true,
	            sortingIndex: index
	          });
	
	          if (onSortStart) onSortStart({ node: node, index: index, collection: collection }, e);
	        }
	      };
	
	      _this.handleSortMove = function (e) {
	        var onSortMove = _this.props.onSortMove;
	
	        e.preventDefault(); // Prevent scrolling on mobile
	
	        _this.updatePosition(e);
	        _this.animateNodes();
	        _this.autoscroll();
	
	        if (onSortMove) onSortMove(e);
	      };
	
	      _this.handleSortEnd = function (e) {
	        var _this$props4 = _this.props,
	            hideSortableGhost = _this$props4.hideSortableGhost,
	            onSortEnd = _this$props4.onSortEnd;
	        var collection = _this.manager.active.collection;
	
	        // Remove the event listeners if the node is still in the DOM
	
	        if (_this.listenerNode) {
	          _utils.events.move.forEach(function (eventName) {
	            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
	          });
	          _utils.events.end.forEach(function (eventName) {
	            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
	          });
	        }
	
	        // Remove the helper from the DOM
	        _this.helper.parentNode.removeChild(_this.helper);
	
	        if (hideSortableGhost && _this.sortableGhost) {
	          _this.sortableGhost.style.visibility = '';
	        }
	
	        var nodes = _this.manager.refs[collection];
	        for (var i = 0, len = nodes.length; i < len; i++) {
	          var node = nodes[i];
	          var el = node.node;
	
	          // Clear the cached offsetTop / offsetLeft value
	          node.edgeOffset = null;
	
	          // Remove the transforms / transitions
	          el.style[_utils.vendorPrefix + 'Transform'] = '';
	          el.style[_utils.vendorPrefix + 'TransitionDuration'] = '';
	        }
	
	        // Stop autoscroll
	        clearInterval(_this.autoscrollInterval);
	        _this.autoscrollInterval = null;
	
	        // Update state
	        _this.manager.active = null;
	
	        _this.setState({
	          sorting: false,
	          sortingIndex: null
	        });
	
	        if (typeof onSortEnd === 'function') {
	          onSortEnd({
	            oldIndex: _this.index,
	            newIndex: _this.newIndex,
	            collection: collection
	          }, e);
	        }
	
	        _this._touched = false;
	      };
	
	      _this.autoscroll = function () {
	        var translate = _this.translate;
	        var direction = {
	          x: 0,
	          y: 0
	        };
	        var speed = {
	          x: 1,
	          y: 1
	        };
	        var acceleration = {
	          x: 10,
	          y: 10
	        };
	
	        if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
	          direction.y = 1; // Scroll Down
	          speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
	        } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
	          direction.x = 1; // Scroll Right
	          speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
	        } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
	          direction.y = -1; // Scroll Up
	          speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
	        } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
	          direction.x = -1; // Scroll Left
	          speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
	        }
	
	        if (_this.autoscrollInterval) {
	          clearInterval(_this.autoscrollInterval);
	          _this.autoscrollInterval = null;
	          _this.isAutoScrolling = false;
	        }
	
	        if (direction.x !== 0 || direction.y !== 0) {
	          _this.autoscrollInterval = setInterval(function () {
	            _this.isAutoScrolling = true;
	            var offset = {
	              left: 1 * speed.x * direction.x,
	              top: 1 * speed.y * direction.y
	            };
	            _this.scrollContainer.scrollTop += offset.top;
	            _this.scrollContainer.scrollLeft += offset.left;
	            _this.translate.x += offset.left;
	            _this.translate.y += offset.top;
	            _this.animateNodes();
	          }, 5);
	        }
	      };
	
	      _this.manager = new _Manager2.default();
	      _this.events = {
	        start: _this.handleStart,
	        move: _this.handleMove,
	        end: _this.handleEnd
	      };
	
	      (0, _invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
	
	      _this.state = {};
	      return _this;
	    }
	
	    _createClass(_class, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        return {
	          manager: this.manager
	        };
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var _this2 = this;
	
	        var _props = this.props,
	            contentWindow = _props.contentWindow,
	            getContainer = _props.getContainer,
	            useWindowAsScrollContainer = _props.useWindowAsScrollContainer;
	
	
	        this.container = typeof getContainer === 'function' ? getContainer(this.getWrappedInstance()) : (0, _reactDom.findDOMNode)(this);
	        this.document = this.container.ownerDocument || document;
	        this.scrollContainer = useWindowAsScrollContainer ? this.document.body : this.container;
	        this.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
	
	        var _loop = function _loop(key) {
	          if (_this2.events.hasOwnProperty(key)) {
	            _utils.events[key].forEach(function (eventName) {
	              return _this2.container.addEventListener(eventName, _this2.events[key], false);
	            });
	          }
	        };
	
	        for (var key in this.events) {
	          _loop(key);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var _this3 = this;
	
	        var _loop2 = function _loop2(key) {
	          if (_this3.events.hasOwnProperty(key)) {
	            _utils.events[key].forEach(function (eventName) {
	              return _this3.container.removeEventListener(eventName, _this3.events[key]);
	            });
	          }
	        };
	
	        for (var key in this.events) {
	          _loop2(key);
	        }
	      }
	    }, {
	      key: 'getEdgeOffset',
	      value: function getEdgeOffset(node) {
	        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { top: 0, left: 0 };
	
	        // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
	        if (node) {
	          var nodeOffset = {
	            top: offset.top + node.offsetTop,
	            left: offset.left + node.offsetLeft
	          };
	          if (node.parentNode !== this.container) {
	            return this.getEdgeOffset(node.parentNode, nodeOffset);
	          } else {
	            return nodeOffset;
	          }
	        }
	      }
	    }, {
	      key: 'getOffset',
	      value: function getOffset(e) {
	        return {
	          x: e.touches ? e.touches[0].clientX : e.clientX,
	          y: e.touches ? e.touches[0].clientY : e.clientY
	        };
	      }
	    }, {
	      key: 'getLockPixelOffsets',
	      value: function getLockPixelOffsets() {
	        var lockOffset = this.props.lockOffset;
	
	
	        if (!Array.isArray(lockOffset)) {
	          lockOffset = [lockOffset, lockOffset];
	        }
	
	        (0, _invariant2.default)(lockOffset.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);
	
	        var _lockOffset = lockOffset,
	            _lockOffset2 = _slicedToArray(_lockOffset, 2),
	            minLockOffset = _lockOffset2[0],
	            maxLockOffset = _lockOffset2[1];
	
	        return [this.getLockPixelOffset(minLockOffset), this.getLockPixelOffset(maxLockOffset)];
	      }
	    }, {
	      key: 'getLockPixelOffset',
	      value: function getLockPixelOffset(lockOffset) {
	        var offsetX = lockOffset;
	        var offsetY = lockOffset;
	        var unit = 'px';
	
	        if (typeof lockOffset === 'string') {
	          var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
	
	          (0, _invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);
	
	          offsetX = offsetY = parseFloat(lockOffset);
	          unit = match[1];
	        }
	
	        (0, _invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);
	
	        if (unit === '%') {
	          offsetX = offsetX * this.width / 100;
	          offsetY = offsetY * this.height / 100;
	        }
	
	        return {
	          x: offsetX,
	          y: offsetY
	        };
	      }
	    }, {
	      key: 'updatePosition',
	      value: function updatePosition(e) {
	        var _props2 = this.props,
	            lockAxis = _props2.lockAxis,
	            lockToContainerEdges = _props2.lockToContainerEdges;
	
	        var offset = this.getOffset(e);
	        var translate = {
	          x: offset.x - this.initialOffset.x,
	          y: offset.y - this.initialOffset.y
	        };
	        this.translate = translate;
	
	        if (lockToContainerEdges) {
	          var _getLockPixelOffsets = this.getLockPixelOffsets(),
	              _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
	              minLockOffset = _getLockPixelOffsets2[0],
	              maxLockOffset = _getLockPixelOffsets2[1];
	
	          var minOffset = {
	            x: this.width / 2 - minLockOffset.x,
	            y: this.height / 2 - minLockOffset.y
	          };
	          var maxOffset = {
	            x: this.width / 2 - maxLockOffset.x,
	            y: this.height / 2 - maxLockOffset.y
	          };
	
	          translate.x = (0, _utils.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
	          translate.y = (0, _utils.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
	        }
	
	        if (lockAxis === 'x') {
	          translate.y = 0;
	        } else if (lockAxis === 'y') {
	          translate.x = 0;
	        }
	
	        this.helper.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
	      }
	    }, {
	      key: 'animateNodes',
	      value: function animateNodes() {
	        var _props3 = this.props,
	            transitionDuration = _props3.transitionDuration,
	            hideSortableGhost = _props3.hideSortableGhost;
	
	        var nodes = this.manager.getOrderedRefs();
	        var deltaScroll = {
	          left: this.scrollContainer.scrollLeft - this.initialScroll.left,
	          top: this.scrollContainer.scrollTop - this.initialScroll.top
	        };
	        var sortingOffset = {
	          left: this.offsetEdge.left + this.translate.x + deltaScroll.left,
	          top: this.offsetEdge.top + this.translate.y + deltaScroll.top
	        };
	        this.newIndex = null;
	
	        for (var i = 0, len = nodes.length; i < len; i++) {
	          var node = nodes[i].node;
	
	          var index = node.sortableInfo.index;
	          var width = node.offsetWidth;
	          var height = node.offsetHeight;
	          var offset = {
	            width: this.width > width ? width / 2 : this.width / 2,
	            height: this.height > height ? height / 2 : this.height / 2
	          };
	          var translate = {
	            x: 0,
	            y: 0
	          };
	          var edgeOffset = nodes[i].edgeOffset;
	
	          // If we haven't cached the node's offsetTop / offsetLeft value
	
	          if (!edgeOffset) {
	            nodes[i].edgeOffset = edgeOffset = this.getEdgeOffset(node);
	          }
	
	          // Get a reference to the next and previous node
	          var nextNode = i < nodes.length - 1 && nodes[i + 1];
	          var prevNode = i > 0 && nodes[i - 1];
	
	          // Also cache the next node's edge offset if needed.
	          // We need this for calculating the animation in a grid setup
	          if (nextNode && !nextNode.edgeOffset) {
	            nextNode.edgeOffset = this.getEdgeOffset(nextNode.node);
	          }
	
	          // If the node is the one we're currently animating, skip it
	          if (index === this.index) {
	            if (hideSortableGhost) {
	              /*
	              * With windowing libraries such as `react-virtualized`, the sortableGhost
	              * node may change while scrolling down and then back up (or vice-versa),
	              * so we need to update the reference to the new node just to be safe.
	              */
	              this.sortableGhost = node;
	              node.style.visibility = 'hidden';
	            }
	            continue;
	          }
	
	          if (transitionDuration) {
	            node.style[_utils.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
	          }
	
	          if (this.axis.x) {
	            if (this.axis.y) {
	              // Calculations for a grid setup
	              if (index < this.index && (sortingOffset.left - offset.width <= edgeOffset.left && sortingOffset.top <= edgeOffset.top + offset.height || sortingOffset.top + offset.height <= edgeOffset.top)) {
	                // If the current node is to the left on the same row, or above the node that's being dragged
	                // then move it to the right
	                translate.x = this.width + this.marginOffset.x;
	                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
	                  // If it moves passed the right bounds, then animate it to the first position of the next row.
	                  // We just use the offset of the next node to calculate where to move, because that node's original position
	                  // is exactly where we want to go
	                  translate.x = nextNode.edgeOffset.left - edgeOffset.left;
	                  translate.y = nextNode.edgeOffset.top - edgeOffset.top;
	                }
	                if (this.newIndex === null) {
	                  this.newIndex = index;
	                }
	              } else if (index > this.index && (sortingOffset.left + offset.width >= edgeOffset.left && sortingOffset.top + offset.height >= edgeOffset.top || sortingOffset.top + offset.height >= edgeOffset.top + height)) {
	                // If the current node is to the right on the same row, or below the node that's being dragged
	                // then move it to the left
	                translate.x = -(this.width + this.marginOffset.x);
	                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
	                  // If it moves passed the left bounds, then animate it to the last position of the previous row.
	                  // We just use the offset of the previous node to calculate where to move, because that node's original position
	                  // is exactly where we want to go
	                  translate.x = prevNode.edgeOffset.left - edgeOffset.left;
	                  translate.y = prevNode.edgeOffset.top - edgeOffset.top;
	                }
	                this.newIndex = index;
	              }
	            } else {
	              if (index > this.index && sortingOffset.left + offset.width >= edgeOffset.left) {
	                translate.x = -(this.width + this.marginOffset.x);
	                this.newIndex = index;
	              } else if (index < this.index && sortingOffset.left <= edgeOffset.left + offset.width) {
	                translate.x = this.width + this.marginOffset.x;
	                if (this.newIndex == null) {
	                  this.newIndex = index;
	                }
	              }
	            }
	          } else if (this.axis.y) {
	            if (index > this.index && sortingOffset.top + offset.height >= edgeOffset.top) {
	              translate.y = -(this.height + this.marginOffset.y);
	              this.newIndex = index;
	            } else if (index < this.index && sortingOffset.top <= edgeOffset.top + offset.height) {
	              translate.y = this.height + this.marginOffset.y;
	              if (this.newIndex == null) {
	                this.newIndex = index;
	              }
	            }
	          }
	          node.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
	        }
	
	        if (this.newIndex == null) {
	          this.newIndex = this.index;
	        }
	      }
	    }, {
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
	        return this.refs.wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var ref = config.withRef ? 'wrappedInstance' : null;
	
	        return _react2.default.createElement(WrappedComponent, _extends({
	          ref: ref
	        }, (0, _utils.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
	      }
	    }]);
	
	    return _class;
	  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
	    axis: 'y',
	    transitionDuration: 300,
	    pressDelay: 0,
	    pressThreshold: 5,
	    distance: 0,
	    useWindowAsScrollContainer: false,
	    hideSortableGhost: true,
	    contentWindow: typeof window !== 'undefined' ? window : null,
	    shouldCancelStart: function shouldCancelStart(e) {
	      // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
	      var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];
	
	      if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) {
	        return true; // Return true to cancel sorting
	      }
	    },
	    lockToContainerEdges: false,
	    lockOffset: '50%',
	    getHelperDimensions: function getHelperDimensions(_ref) {
	      var node = _ref.node;
	      return {
	        width: node.offsetWidth,
	        height: node.offsetHeight
	      };
	    }
	  }, _class.propTypes = {
	    axis: _react.PropTypes.oneOf(['x', 'y', 'xy']),
	    distance: _react.PropTypes.number,
	    lockAxis: _react.PropTypes.string,
	    helperClass: _react.PropTypes.string,
	    transitionDuration: _react.PropTypes.number,
	    contentWindow: _react.PropTypes.any,
	    onSortStart: _react.PropTypes.func,
	    onSortMove: _react.PropTypes.func,
	    onSortEnd: _react.PropTypes.func,
	    shouldCancelStart: _react.PropTypes.func,
	    pressDelay: _react.PropTypes.number,
	    useDragHandle: _react.PropTypes.bool,
	    useWindowAsScrollContainer: _react.PropTypes.bool,
	    hideSortableGhost: _react.PropTypes.bool,
	    lockToContainerEdges: _react.PropTypes.bool,
	    lockOffset: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]))]),
	    getContainer: _react.PropTypes.func,
	    getHelperDimensions: _react.PropTypes.func
	  }, _class.childContextTypes = {
	    manager: _react.PropTypes.object.isRequired
	  }, _temp;
	}

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = sortableElement;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(63);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Export Higher Order Sortable Element Component
	function sortableElement(WrappedComponent) {
	  var _class, _temp;
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };
	
	  return _temp = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var _props = this.props,
	            collection = _props.collection,
	            disabled = _props.disabled,
	            index = _props.index;
	
	
	        if (!disabled) {
	          this.setDraggable(collection, index);
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.index !== nextProps.index && this.node) {
	          this.node.sortableInfo.index = nextProps.index;
	        }
	        if (this.props.disabled !== nextProps.disabled) {
	          var collection = nextProps.collection,
	              disabled = nextProps.disabled,
	              index = nextProps.index;
	
	          if (disabled) {
	            this.removeDraggable(collection);
	          } else {
	            this.setDraggable(collection, index);
	          }
	        } else if (this.props.collection !== nextProps.collection) {
	          this.removeDraggable(this.props.collection);
	          this.setDraggable(nextProps.collection, nextProps.index);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var _props2 = this.props,
	            collection = _props2.collection,
	            disabled = _props2.disabled;
	
	
	        if (!disabled) this.removeDraggable(collection);
	      }
	    }, {
	      key: 'setDraggable',
	      value: function setDraggable(collection, index) {
	        var node = this.node = (0, _reactDom.findDOMNode)(this);
	
	        node.sortableInfo = {
	          index: index,
	          collection: collection,
	          manager: this.context.manager
	        };
	
	        this.ref = { node: node };
	        this.context.manager.add(collection, this.ref);
	      }
	    }, {
	      key: 'removeDraggable',
	      value: function removeDraggable(collection) {
	        this.context.manager.remove(collection, this.ref);
	      }
	    }, {
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
	        return this.refs.wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var ref = config.withRef ? 'wrappedInstance' : null;
	
	        return _react2.default.createElement(WrappedComponent, _extends({
	          ref: ref
	        }, (0, _utils.omit)(this.props, 'collection', 'disabled', 'index')));
	      }
	    }]);
	
	    return _class;
	  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
	    manager: _react.PropTypes.object.isRequired
	  }, _class.propTypes = {
	    index: _react.PropTypes.number.isRequired,
	    collection: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	    disabled: _react.PropTypes.bool
	  }, _class.defaultProps = {
	    collection: 0
	  }, _temp;
	}

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = sortableHandle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(63);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Export Higher Order Sortable Element Component
	function sortableHandle(WrappedComponent) {
	  var _class, _temp;
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };
	
	  return _temp = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var node = (0, _reactDom.findDOMNode)(this);
	        node.sortableHandle = true;
	      }
	    }, {
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
	        return this.refs.wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var ref = config.withRef ? 'wrappedInstance' : null;
	
	        return _react2.default.createElement(WrappedComponent, _extends({ ref: ref }, this.props));
	      }
	    }]);
	
	    return _class;
	  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
	}

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(23);
	
	var focusNode = __webpack_require__(316);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(64);
	var EventPropagators = __webpack_require__(119);
	var ExecutionEnvironment = __webpack_require__(30);
	var FallbackCompositionState = __webpack_require__(1074);
	var SyntheticCompositionEvent = __webpack_require__(1114);
	var SyntheticInputEvent = __webpack_require__(1117);
	
	var keyOf = __webpack_require__(69);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(495);
	var ExecutionEnvironment = __webpack_require__(30);
	var ReactInstrumentation = __webpack_require__(48);
	
	var camelizeStyleName = __webpack_require__(834);
	var dangerousStyleValue = __webpack_require__(1124);
	var hyphenateStyleName = __webpack_require__(841);
	var memoizeStringOnly = __webpack_require__(844);
	var warning = __webpack_require__(11);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(component._debugID, 'update styles', styles);
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(64);
	var EventPluginHub = __webpack_require__(118);
	var EventPropagators = __webpack_require__(119);
	var ExecutionEnvironment = __webpack_require__(30);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(55);
	var SyntheticEvent = __webpack_require__(65);
	
	var getEventTarget = __webpack_require__(248);
	var isEventSupported = __webpack_require__(249);
	var isTextInputElement = __webpack_require__(523);
	var keyOf = __webpack_require__(69);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMLazyTree = __webpack_require__(103);
	var ExecutionEnvironment = __webpack_require__(30);
	
	var createNodesFromMarkup = __webpack_require__(837);
	var emptyFunction = __webpack_require__(39);
	var invariant = __webpack_require__(6);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(69);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(64);
	var EventPropagators = __webpack_require__(119);
	var ReactDOMComponentTree = __webpack_require__(23);
	var SyntheticMouseEvent = __webpack_require__(164);
	
	var keyOf = __webpack_require__(69);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var PooledClass = __webpack_require__(73);
	
	var getTextContentAccessor = __webpack_require__(520);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(104);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCSSTransitionGroup
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var React = __webpack_require__(162);
	
	var ReactTransitionGroup = __webpack_require__(511);
	var ReactCSSTransitionGroupChild = __webpack_require__(1077);
	
	function createTransitionTimeoutPropValidator(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	        }
	    }
	  };
	}
	
	/**
	 * An easy way to perform CSS transitions and animations when a React component
	 * enters or leaves the DOM.
	 * See https://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup
	 */
	var ReactCSSTransitionGroup = React.createClass({
	  displayName: 'ReactCSSTransitionGroup',
	
	  propTypes: {
	    transitionName: ReactCSSTransitionGroupChild.propTypes.name,
	
	    transitionAppear: React.PropTypes.bool,
	    transitionEnter: React.PropTypes.bool,
	    transitionLeave: React.PropTypes.bool,
	    transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
	    transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
	    transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
	  },
	
	  getDefaultProps: function () {
	    return {
	      transitionAppear: false,
	      transitionEnter: true,
	      transitionLeave: true
	    };
	  },
	
	  _wrapChild: function (child) {
	    // We need to provide this childFactory so that
	    // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	    // leave while it is leaving.
	    return React.createElement(ReactCSSTransitionGroupChild, {
	      name: this.props.transitionName,
	      appear: this.props.transitionAppear,
	      enter: this.props.transitionEnter,
	      leave: this.props.transitionLeave,
	      appearTimeout: this.props.transitionAppearTimeout,
	      enterTimeout: this.props.transitionEnterTimeout,
	      leaveTimeout: this.props.transitionLeaveTimeout
	    }, child);
	  },
	
	  render: function () {
	    return React.createElement(ReactTransitionGroup, _assign({}, this.props, { childFactory: this._wrapChild }));
	  }
	});
	
	module.exports = ReactCSSTransitionGroup;

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCSSTransitionGroupChild
	 */
	
	'use strict';
	
	var React = __webpack_require__(162);
	var ReactDOM = __webpack_require__(500);
	
	var CSSCore = __webpack_require__(832);
	var ReactTransitionEvents = __webpack_require__(1108);
	
	var onlyChild = __webpack_require__(524);
	
	var TICK = 17;
	
	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',
	
	  propTypes: {
	    name: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      active: React.PropTypes.string
	    }), React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      enterActive: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      leaveActive: React.PropTypes.string,
	      appear: React.PropTypes.string,
	      appearActive: React.PropTypes.string
	    })]).isRequired,
	
	    // Once we require timeouts to be specified, we can remove the
	    // boolean flags (appear etc.) and just accept a number
	    // or a bool for the timeout flags (appearTimeout etc.)
	    appear: React.PropTypes.bool,
	    enter: React.PropTypes.bool,
	    leave: React.PropTypes.bool,
	    appearTimeout: React.PropTypes.number,
	    enterTimeout: React.PropTypes.number,
	    leaveTimeout: React.PropTypes.number
	  },
	
	  transition: function (animationType, finishCallback, userSpecifiedDelay) {
	    var node = ReactDOM.findDOMNode(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timeout = null;
	
	    var endListener = function (e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timeout);
	
	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);
	
	      ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    CSSCore.addClass(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // If the user specified a timeout delay.
	    if (userSpecifiedDelay) {
	      // Clean-up the animation after the specified delay
	      timeout = setTimeout(endListener, userSpecifiedDelay);
	      this.transitionTimeouts.push(timeout);
	    } else {
	      // DEPRECATED: this listener will be removed in a future version of react
	      ReactTransitionEvents.addEndEventListener(node, endListener);
	    }
	  },
	
	  queueClassAndNode: function (className, node) {
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameAndNodeQueue, TICK);
	    }
	  },
	
	  flushClassNameAndNodeQueue: function () {
	    if (this.isMounted()) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        CSSCore.addClass(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.timeout = null;
	  },
	
	  componentWillMount: function () {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  },
	
	  componentWillUnmount: function () {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  },
	
	  componentWillAppear: function (done) {
	    if (this.props.appear) {
	      this.transition('appear', done, this.props.appearTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillEnter: function (done) {
	    if (this.props.enter) {
	      this.transition('enter', done, this.props.enterTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillLeave: function (done) {
	    if (this.props.leave) {
	      this.transition('leave', done, this.props.leaveTimeout);
	    } else {
	      done();
	    }
	  },
	
	  render: function () {
	    return onlyChild(this.props.children);
	  }
	});
	
	module.exports = ReactCSSTransitionGroupChild;

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(106);
	
	var instantiateReactComponent = __webpack_require__(522);
	var KeyEscapeUtils = __webpack_require__(234);
	var shouldUpdateReactComponent = __webpack_require__(250);
	var traverseAllChildren = __webpack_require__(251);
	var warning = __webpack_require__(11);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(238);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('./ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(157)))

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(230);
	var ReactDOMIDOperations = __webpack_require__(1087);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(16);
	
	var ReactComponentEnvironment = __webpack_require__(237);
	var ReactCurrentOwner = __webpack_require__(74);
	var ReactElement = __webpack_require__(54);
	var ReactErrorUtils = __webpack_require__(239);
	var ReactInstanceMap = __webpack_require__(105);
	var ReactInstrumentation = __webpack_require__(48);
	var ReactNodeTypes = __webpack_require__(509);
	var ReactPropTypeLocations = __webpack_require__(242);
	var ReactReconciler = __webpack_require__(106);
	
	var checkReactTypeSpec = __webpack_require__(1123);
	var emptyObject = __webpack_require__(111);
	var invariant = __webpack_require__(6);
	var shallowEqual = __webpack_require__(201);
	var shouldUpdateReactComponent = __webpack_require__(250);
	var warning = __webpack_require__(11);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || ReactElement.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || ReactElement.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent;
	
	    if (false) {
	      renderedComponent = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedComponent = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedComponent === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var DisabledInputUtils = __webpack_require__(161);
	
	/**
	 * Implements a <button> host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getHostProps: DisabledInputUtils.getHostProps
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(16);
	
	var AutoFocusUtils = __webpack_require__(1067);
	var CSSPropertyOperations = __webpack_require__(1069);
	var DOMLazyTree = __webpack_require__(103);
	var DOMNamespaces = __webpack_require__(231);
	var DOMProperty = __webpack_require__(104);
	var DOMPropertyOperations = __webpack_require__(497);
	var EventConstants = __webpack_require__(64);
	var EventPluginHub = __webpack_require__(118);
	var EventPluginRegistry = __webpack_require__(232);
	var ReactBrowserEventEmitter = __webpack_require__(163);
	var ReactDOMButton = __webpack_require__(1081);
	var ReactDOMComponentFlags = __webpack_require__(501);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactDOMInput = __webpack_require__(1088);
	var ReactDOMOption = __webpack_require__(1089);
	var ReactDOMSelect = __webpack_require__(502);
	var ReactDOMTextarea = __webpack_require__(1092);
	var ReactInstrumentation = __webpack_require__(48);
	var ReactMultiChild = __webpack_require__(1100);
	var ReactServerRenderingTransaction = __webpack_require__(1105);
	
	var emptyFunction = __webpack_require__(39);
	var escapeTextContentForBrowser = __webpack_require__(165);
	var invariant = __webpack_require__(6);
	var isEventSupported = __webpack_require__(249);
	var keyOf = __webpack_require__(69);
	var shallowEqual = __webpack_require__(201);
	var validateDOMNesting = __webpack_require__(252);
	var warning = __webpack_require__(11);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topInvalid, 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getHostProps(this, props, hostParent);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getHostProps(this, lastProps);
	        nextProps = ReactDOMButton.getHostProps(this, nextProps);
	        break;
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMContainerInfo
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(252);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMEmptyComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var DOMLazyTree = __webpack_require__(103);
	var ReactDOMComponentTree = __webpack_require__(23);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(54);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1086 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(230);
	var ReactDOMComponentTree = __webpack_require__(23);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(16);
	
	var DisabledInputUtils = __webpack_require__(161);
	var DOMPropertyOperations = __webpack_require__(497);
	var LinkedValueUtils = __webpack_require__(235);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(55);
	
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(11);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, DisabledInputUtils.getHostProps(inst, props), {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactChildren = __webpack_require__(498);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactDOMSelect = __webpack_require__(502);
	
	var warning = __webpack_require__(11);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  ReactChildren.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var getNodeForCharacterOffset = __webpack_require__(1127);
	var getTextContentAccessor = __webpack_require__(520);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(16);
	
	var DOMChildrenOperations = __webpack_require__(230);
	var DOMLazyTree = __webpack_require__(103);
	var ReactDOMComponentTree = __webpack_require__(23);
	
	var escapeTextContentForBrowser = __webpack_require__(165);
	var invariant = __webpack_require__(6);
	var validateDOMNesting = __webpack_require__(252);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(16);
	
	var DisabledInputUtils = __webpack_require__(161);
	var LinkedValueUtils = __webpack_require__(235);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(55);
	
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(11);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTreeTraversal
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], false, arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], true, arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], true, argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], false, argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactUpdates = __webpack_require__(55);
	var Transaction = __webpack_require__(121);
	
	var emptyFunction = __webpack_require__(39);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(1068);
	var ChangeEventPlugin = __webpack_require__(1070);
	var DefaultEventPluginOrder = __webpack_require__(1072);
	var EnterLeaveEventPlugin = __webpack_require__(1073);
	var HTMLDOMPropertyConfig = __webpack_require__(1075);
	var ReactComponentBrowserEnvironment = __webpack_require__(1079);
	var ReactDOMComponent = __webpack_require__(1082);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactDOMEmptyComponent = __webpack_require__(1084);
	var ReactDOMTreeTraversal = __webpack_require__(1093);
	var ReactDOMTextComponent = __webpack_require__(1091);
	var ReactDefaultBatchingStrategy = __webpack_require__(1094);
	var ReactEventListener = __webpack_require__(1097);
	var ReactInjection = __webpack_require__(1098);
	var ReactReconcileTransaction = __webpack_require__(1103);
	var SVGDOMPropertyConfig = __webpack_require__(1109);
	var SelectEventPlugin = __webpack_require__(1110);
	var SimpleEventPlugin = __webpack_require__(1111);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(118);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var EventListener = __webpack_require__(315);
	var ExecutionEnvironment = __webpack_require__(30);
	var PooledClass = __webpack_require__(73);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(55);
	
	var getEventTarget = __webpack_require__(248);
	var getUnboundedScrollPosition = __webpack_require__(839);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(104);
	var EventPluginHub = __webpack_require__(118);
	var EventPluginUtils = __webpack_require__(233);
	var ReactComponentEnvironment = __webpack_require__(237);
	var ReactClass = __webpack_require__(499);
	var ReactEmptyComponent = __webpack_require__(503);
	var ReactBrowserEventEmitter = __webpack_require__(163);
	var ReactHostComponent = __webpack_require__(505);
	var ReactUpdates = __webpack_require__(55);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1122);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactComponentEnvironment = __webpack_require__(237);
	var ReactInstanceMap = __webpack_require__(105);
	var ReactInstrumentation = __webpack_require__(48);
	var ReactMultiChildUpdateTypes = __webpack_require__(508);
	
	var ReactCurrentOwner = __webpack_require__(74);
	var ReactReconciler = __webpack_require__(106);
	var ReactChildReconciler = __webpack_require__(1078);
	
	var emptyFunction = __webpack_require__(39);
	var flattenChildren = __webpack_require__(516);
	var invariant = __webpack_require__(6);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPureComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactComponent = __webpack_require__(236);
	var ReactNoopUpdateQueue = __webpack_require__(240);
	
	var emptyObject = __webpack_require__(111);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var CallbackQueue = __webpack_require__(496);
	var PooledClass = __webpack_require__(73);
	var ReactBrowserEventEmitter = __webpack_require__(163);
	var ReactInputSelection = __webpack_require__(506);
	var ReactInstrumentation = __webpack_require__(48);
	var Transaction = __webpack_require__(121);
	var ReactUpdateQueue = __webpack_require__(244);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1101);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return (
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement.ref !== prevElement.ref ||
	    // If owner changes but we have an unchanged function ref, don't update refs
	    typeof nextElement.ref === 'string' && nextElement._owner !== prevElement._owner
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var PooledClass = __webpack_require__(73);
	var Transaction = __webpack_require__(121);
	var ReactInstrumentation = __webpack_require__(48);
	var ReactServerUpdateQueue = __webpack_require__(1106);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerUpdateQueue
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(244);
	var Transaction = __webpack_require__(121);
	var warning = __webpack_require__(11);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  /* :: transaction: Transaction; */
	
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionChildMapping
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(516);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (false) {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionEvents
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var getVendorPrefixedEventName = __webpack_require__(521);
	
	var endEvents = [];
	
	function detectEvents() {
	  var animEnd = getVendorPrefixedEventName('animationend');
	  var transEnd = getVendorPrefixedEventName('transitionend');
	
	  if (animEnd) {
	    endEvents.push(animEnd);
	  }
	
	  if (transEnd) {
	    endEvents.push(transEnd);
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;

/***/ },
/* 1109 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(64);
	var EventPropagators = __webpack_require__(119);
	var ExecutionEnvironment = __webpack_require__(30);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactInputSelection = __webpack_require__(506);
	var SyntheticEvent = __webpack_require__(65);
	
	var getActiveElement = __webpack_require__(317);
	var isTextInputElement = __webpack_require__(523);
	var keyOf = __webpack_require__(69);
	var shallowEqual = __webpack_require__(201);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var EventConstants = __webpack_require__(64);
	var EventListener = __webpack_require__(315);
	var EventPropagators = __webpack_require__(119);
	var ReactDOMComponentTree = __webpack_require__(23);
	var SyntheticAnimationEvent = __webpack_require__(1112);
	var SyntheticClipboardEvent = __webpack_require__(1113);
	var SyntheticEvent = __webpack_require__(65);
	var SyntheticFocusEvent = __webpack_require__(1116);
	var SyntheticKeyboardEvent = __webpack_require__(1118);
	var SyntheticMouseEvent = __webpack_require__(164);
	var SyntheticDragEvent = __webpack_require__(1115);
	var SyntheticTouchEvent = __webpack_require__(1119);
	var SyntheticTransitionEvent = __webpack_require__(1120);
	var SyntheticUIEvent = __webpack_require__(120);
	var SyntheticWheelEvent = __webpack_require__(1121);
	
	var emptyFunction = __webpack_require__(39);
	var getEventCharCode = __webpack_require__(246);
	var invariant = __webpack_require__(6);
	var keyOf = __webpack_require__(69);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  animationEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationEnd: true }),
	      captured: keyOf({ onAnimationEndCapture: true })
	    }
	  },
	  animationIteration: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationIteration: true }),
	      captured: keyOf({ onAnimationIterationCapture: true })
	    }
	  },
	  animationStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationStart: true }),
	      captured: keyOf({ onAnimationStartCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  invalid: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInvalid: true }),
	      captured: keyOf({ onInvalidCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  transitionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTransitionEnd: true }),
	      captured: keyOf({ onTransitionEndCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topAnimationEnd: eventTypes.animationEnd,
	  topAnimationIteration: eventTypes.animationIteration,
	  topAnimationStart: eventTypes.animationStart,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topInvalid: eventTypes.invalid,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topTransitionEnd: eventTypes.transitionEnd,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topInvalid:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topAnimationEnd:
	      case topLevelTypes.topAnimationIteration:
	      case topLevelTypes.topAnimationStart:
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case topLevelTypes.topTransitionEnd:
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticAnimationEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(65);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(65);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(65);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(164);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(120);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(65);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(120);
	
	var getEventCharCode = __webpack_require__(246);
	var getEventKey = __webpack_require__(1126);
	var getEventModifierState = __webpack_require__(247);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(120);
	
	var getEventModifierState = __webpack_require__(247);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTransitionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(65);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(164);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 1122 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule checkReactTypeSpec
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactPropTypeLocationNames = __webpack_require__(241);
	var ReactPropTypesSecret = __webpack_require__(243);
	
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(11);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(238);
	}
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (false) {
	          if (!ReactComponentTreeHook) {
	            ReactComponentTreeHook = require('./ReactComponentTreeHook');
	          }
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
	          }
	        }
	
	         false ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(157)))

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(495);
	var warning = __webpack_require__(11);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(74);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactInstanceMap = __webpack_require__(105);
	
	var getHostComponentFromComposite = __webpack_require__(518);
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(11);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(246);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 1127 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(165);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(507);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.autoprefix = undefined;
	
	var _forOwn2 = __webpack_require__(218);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transforms = {
	  borderRadius: function borderRadius(value) {
	    return {
	      msBorderRadius: value,
	      MozBorderRadius: value,
	      OBorderRadius: value,
	      WebkitBorderRadius: value,
	      borderRadius: value
	    };
	  },
	  boxShadow: function boxShadow(value) {
	    return {
	      msBoxShadow: value,
	      MozBoxShadow: value,
	      OBoxShadow: value,
	      WebkitBoxShadow: value,
	      boxShadow: value
	    };
	  },
	  userSelect: function userSelect(value) {
	    return {
	      WebkitTouchCallout: value,
	      KhtmlUserSelect: value,
	      MozUserSelect: value,
	      msUserSelect: value,
	      WebkitUserSelect: value,
	      userSelect: value
	    };
	  },
	
	  flex: function flex(value) {
	    return {
	      WebkitBoxFlex: value,
	      MozBoxFlex: value,
	      WebkitFlex: value,
	      msFlex: value,
	      flex: value
	    };
	  },
	  flexBasis: function flexBasis(value) {
	    return {
	      WebkitFlexBasis: value,
	      flexBasis: value
	    };
	  },
	  justifyContent: function justifyContent(value) {
	    return {
	      WebkitJustifyContent: value,
	      justifyContent: value
	    };
	  },
	
	  transition: function transition(value) {
	    return {
	      msTransition: value,
	      MozTransition: value,
	      OTransition: value,
	      WebkitTransition: value,
	      transition: value
	    };
	  },
	
	  transform: function transform(value) {
	    return {
	      msTransform: value,
	      MozTransform: value,
	      OTransform: value,
	      WebkitTransform: value,
	      transform: value
	    };
	  },
	  absolute: function absolute(value) {
	    var direction = value && value.split(' ');
	    return {
	      position: 'absolute',
	      top: direction && direction[0],
	      right: direction && direction[1],
	      bottom: direction && direction[2],
	      left: direction && direction[3]
	    };
	  },
	  extend: function extend(name, otherElementStyles) {
	    var otherStyle = otherElementStyles[name];
	    if (otherStyle) {
	      return otherStyle;
	    }
	    return {
	      'extend': name
	    };
	  }
	};
	
	var autoprefix = exports.autoprefix = function autoprefix(elements) {
	  var prefixed = {};
	  (0, _forOwn3.default)(elements, function (styles, element) {
	    var expanded = {};
	    (0, _forOwn3.default)(styles, function (value, key) {
	      var transform = transforms[key];
	      if (transform) {
	        expanded = _extends({}, expanded, transform(value));
	      } else {
	        expanded[key] = value;
	      }
	    });
	    prefixed[element] = expanded;
	  });
	  return prefixed;
	};
	
	exports.default = autoprefix;

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.active = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var active = exports.active = function active(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Active, _React$Component);
	
	    function Active() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Active);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
	        return _this.setState({ active: true });
	      }, _this.handleMouseUp = function () {
	        return _this.setState({ active: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Active;
	  }(_react2.default.Component);
	};
	
	exports.default = active;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hover = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hover = exports.hover = function hover(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Hover, _React$Component);
	
	    function Hover() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Hover);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
	        return _this.setState({ hover: true });
	      }, _this.handleMouseOut = function () {
	        return _this.setState({ hover: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Hover;
	  }(_react2.default.Component);
	};
	
	exports.default = hover;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flattenNames = undefined;
	
	var _isString2 = __webpack_require__(221);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _forOwn2 = __webpack_require__(218);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _isPlainObject2 = __webpack_require__(117);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _map2 = __webpack_require__(71);
	
	var _map3 = _interopRequireDefault(_map2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var flattenNames = exports.flattenNames = function flattenNames() {
	  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var names = [];
	
	  (0, _map3.default)(things, function (thing) {
	    if (Array.isArray(thing)) {
	      flattenNames(thing).map(function (name) {
	        return names.push(name);
	      });
	    } else if ((0, _isPlainObject3.default)(thing)) {
	      (0, _forOwn3.default)(thing, function (value, key) {
	        value === true && names.push(key);
	        names.push(key + '-' + value);
	      });
	    } else if ((0, _isString3.default)(thing)) {
	      names.push(thing);
	    }
	  });
	
	  return names;
	};
	
	exports.default = flattenNames;

/***/ },
/* 1134 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var loopable = function loopable(i, length) {
	  var props = {};
	  var setProp = function setProp(name) {
	    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    props[name] = value;
	  };
	
	  i === 0 && setProp('first-child');
	  i === length - 1 && setProp('last-child');
	  (i === 0 || i % 2 === 0) && setProp('even');
	  Math.abs(i % 2) === 1 && setProp('odd');
	  setProp('nth-child', i);
	
	  return props;
	};
	
	exports.default = loopable;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mergeClasses = undefined;
	
	var _forOwn2 = __webpack_require__(218);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _cloneDeep2 = __webpack_require__(947);
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
	  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
	  activeNames.map(function (name) {
	    var toMerge = classes[name];
	    if (toMerge) {
	      (0, _forOwn3.default)(toMerge, function (value, key) {
	        if (!styles[key]) {
	          styles[key] = {};
	        }
	
	        styles[key] = _extends({}, styles[key], toMerge[key]);
	      });
	    }
	
	    return name;
	  });
	  return styles;
	};
	
	exports.default = mergeClasses;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserAuthWrapper = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(8);
	
	var _hoistNonReactStatics = __webpack_require__(145);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _lodash = __webpack_require__(853);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var defaults = {
	  LoadingComponent: function LoadingComponent() {
	    return null;
	  }, // dont render anything while authenticating
	  failureRedirectPath: '/login',
	  FailureComponent: undefined,
	  redirectQueryParamName: 'redirect',
	  wrapperDisplayName: 'AuthWrapper',
	  predicate: function predicate(x) {
	    return !(0, _lodash2.default)(x);
	  },
	  authenticatingSelector: function authenticatingSelector() {
	    return false;
	  },
	  allowRedirectBack: true,
	  propMapper: function propMapper(_ref) {
	    var redirect = _ref.redirect,
	        authData = _ref.authData,
	        isAuthenticating = _ref.isAuthenticating,
	        failureRedirectPath = _ref.failureRedirectPath,
	        otherProps = _objectWithoutProperties(_ref, ['redirect', 'authData', 'isAuthenticating', 'failureRedirectPath']);
	
	    return _extends({ authData: authData }, otherProps);
	  } // eslint-disable-line no-unused-vars
	};
	
	var UserAuthWrapper = exports.UserAuthWrapper = function UserAuthWrapper(args) {
	  var _defaults$args = _extends({}, defaults, args),
	      authSelector = _defaults$args.authSelector,
	      authenticatingSelector = _defaults$args.authenticatingSelector,
	      LoadingComponent = _defaults$args.LoadingComponent,
	      failureRedirectPath = _defaults$args.failureRedirectPath,
	      FailureComponent = _defaults$args.FailureComponent,
	      wrapperDisplayName = _defaults$args.wrapperDisplayName,
	      predicate = _defaults$args.predicate,
	      allowRedirectBack = _defaults$args.allowRedirectBack,
	      redirectAction = _defaults$args.redirectAction,
	      redirectQueryParamName = _defaults$args.redirectQueryParamName,
	      propMapper = _defaults$args.propMapper;
	
	  var isAuthorized = function isAuthorized(authData) {
	    return predicate(authData);
	  };
	
	  var createRedirect = function createRedirect(location, redirect, redirectPath) {
	    var query = void 0;
	    if (allowRedirectBack) {
	      query = _defineProperty({}, redirectQueryParamName, '' + location.pathname + location.search);
	    } else {
	      query = {};
	    }
	
	    redirect({
	      pathname: redirectPath,
	      query: query
	    });
	  };
	
	  var shouldRedirect = FailureComponent === undefined;
	  var locationShape = _react.PropTypes.shape({
	    pathname: _react.PropTypes.string.isRequired,
	    search: _react.PropTypes.string.isRequired
	  });
	
	  // Wraps the component that needs the auth enforcement
	  function wrapComponent(DecoratedComponent) {
	    var _dec, _class, _class2, _temp2;
	
	    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	      if (redirectAction !== undefined) {
	        return { redirect: function redirect(args) {
	            return dispatch(redirectAction(args));
	          } };
	      } else {
	        return {};
	      }
	    };
	
	    var UserAuthWrapper = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
	      return {
	        authData: authSelector(state, ownProps),
	        failureRedirectPath: typeof failureRedirectPath === 'function' ? failureRedirectPath(state, ownProps) : failureRedirectPath,
	        isAuthenticating: authenticatingSelector(state, ownProps)
	      };
	    }, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_Component) {
	      _inherits(UserAuthWrapper, _Component);
	
	      function UserAuthWrapper() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, UserAuthWrapper);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = UserAuthWrapper.__proto__ || Object.getPrototypeOf(UserAuthWrapper)).call.apply(_ref2, [this].concat(args))), _this), _this.getRedirectFunc = function (_ref3) {
	          var redirect = _ref3.redirect;
	
	          if (redirect) {
	            return redirect;
	          } else {
	            if (!_this.context.router.replace) {
	              /* istanbul ignore next sanity */
	              throw new Error('You must provide a router context (or use React-Router 2.x) if not passing a redirectAction to ' + wrapperDisplayName);
	            } else {
	              return _this.context.router.replace;
	            }
	          }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(UserAuthWrapper, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	          if (!this.props.isAuthenticating && !isAuthorized(this.props.authData) && shouldRedirect) {
	            createRedirect(this.props.location, this.getRedirectFunc(this.props), this.props.failureRedirectPath);
	          }
	        }
	      }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	          var willBeAuthorized = isAuthorized(nextProps.authData);
	          var willbeAuthenticating = nextProps.isAuthenticating;
	          var wasAuthorized = isAuthorized(this.props.authData);
	          var wasAuthenticating = this.props.isAuthenticating;
	
	          // Don't bother to redirect if:
	          // 1. currently authenticating or FailureComponent is set
	          if (willbeAuthenticating || !shouldRedirect) return;
	
	          // Redirect if:
	          if ( // 1. Was authorized, but no longer
	          wasAuthorized && !willBeAuthorized ||
	          // 2. Was not authorized and authenticating
	          wasAuthenticating && !willBeAuthorized) {
	            createRedirect(nextProps.location, this.getRedirectFunc(nextProps), nextProps.failureRedirectPath);
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          // Allow everything but the replace aciton creator to be passed down
	          // Includes route props from React-Router and authData
	          var _props = this.props,
	              authData = _props.authData,
	              isAuthenticating = _props.isAuthenticating;
	
	          if (isAuthorized(authData)) {
	            return _react2.default.createElement(DecoratedComponent, propMapper(this.props));
	          } else if (isAuthenticating) {
	            return _react2.default.createElement(LoadingComponent, propMapper(this.props));
	          } else {
	            // Display FailureComponent or nothing if FailureComponent is null
	            // If FailureComponent is undefined user will never see this because
	            // they will be redirected to failureRedirectPath
	            return FailureComponent ? _react2.default.createElement(FailureComponent, propMapper(this.props)) : null;
	          }
	        }
	      }]);
	
	      return UserAuthWrapper;
	    }(_react.Component), _class2.displayName = wrapperDisplayName + '(' + displayName + ')', _class2.propTypes = {
	      failureRedirectPath: _react.PropTypes.string.isRequired,
	      location: shouldRedirect ? locationShape.isRequired : locationShape,
	      redirect: _react.PropTypes.func,
	      authData: _react.PropTypes.object
	    }, _class2.contextTypes = {
	      // Only used if no redirectAction specified
	      router: _react.PropTypes.object
	    }, _temp2)) || _class);
	
	
	    return (0, _hoistNonReactStatics2.default)(UserAuthWrapper, DecoratedComponent);
	  }
	
	  if (shouldRedirect) {
	    wrapComponent.onEnter = function (store, nextState, replace) {
	      var authData = authSelector(store.getState(), nextState);
	      var isAuthenticating = authenticatingSelector(store.getState(), nextState);
	
	      if (!isAuthorized(authData) && !isAuthenticating) {
	        var redirectPath = typeof failureRedirectPath === 'function' ? failureRedirectPath(store.getState(), nextState) : failureRedirectPath;
	        createRedirect(nextState.location, replace, redirectPath);
	      }
	    };
	  }
	
	  return wrapComponent;
	};

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(8);
	
	var _createFieldProps2 = __webpack_require__(528);
	
	var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);
	
	var _plain = __webpack_require__(75);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _onChangeValue = __webpack_require__(530);
	
	var _onChangeValue2 = _interopRequireDefault(_onChangeValue);
	
	var _eventConsts = __webpack_require__(1176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var createConnectedField = function createConnectedField(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      toJS = _ref.toJS;
	
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    var error = _plain2.default.getIn(syncErrors, name);
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return error && error._error ? error._error : error;
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = _plain2.default.getIn(syncWarnings, name);
	    // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedField = function (_Component) {
	    _inherits(ConnectedField, _Component);
	
	    function ConnectedField(props) {
	      _classCallCheck(this, ConnectedField);
	
	      var _this = _possibleConstructorReturn(this, (ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call(this, props));
	
	      _this.handleChange = _this.handleChange.bind(_this);
	      _this.handleFocus = _this.handleFocus.bind(_this);
	      _this.handleBlur = _this.handleBlur.bind(_this);
	      _this.handleDragStart = _this.handleDragStart.bind(_this);
	      _this.handleDrop = _this.handleDrop.bind(_this);
	      return _this;
	    }
	
	    _createClass(ConnectedField, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this2 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	        });
	      }
	    }, {
	      key: 'isPristine',
	      value: function isPristine() {
	        return this.props.pristine;
	      }
	    }, {
	      key: 'getValue',
	      value: function getValue() {
	        return this.props.value;
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'handleChange',
	      value: function handleChange(event) {
	        var _props = this.props,
	            name = _props.name,
	            dispatch = _props.dispatch,
	            parse = _props.parse,
	            normalize = _props.normalize,
	            onChange = _props.onChange,
	            _reduxForm = _props._reduxForm,
	            previousValue = _props.value;
	
	        var newValue = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        var defaultPrevented = false;
	        if (onChange) {
	          onChange(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return event.preventDefault();
	            }
	          }), newValue, previousValue);
	        }
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	        }
	      }
	    }, {
	      key: 'handleFocus',
	      value: function handleFocus(event) {
	        var _props2 = this.props,
	            name = _props2.name,
	            dispatch = _props2.dispatch,
	            onFocus = _props2.onFocus,
	            _reduxForm = _props2._reduxForm;
	
	
	        var defaultPrevented = false;
	        if (onFocus) {
	          onFocus(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return event.preventDefault();
	            }
	          }));
	        }
	
	        if (!defaultPrevented) {
	          dispatch(_reduxForm.focus(name));
	        }
	      }
	    }, {
	      key: 'handleBlur',
	      value: function handleBlur(event) {
	        var _props3 = this.props,
	            name = _props3.name,
	            dispatch = _props3.dispatch,
	            parse = _props3.parse,
	            normalize = _props3.normalize,
	            onBlur = _props3.onBlur,
	            _reduxForm = _props3._reduxForm,
	            _value = _props3._value,
	            previousValue = _props3.value;
	
	        var newValue = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        // for checkbox and radio, if the value property of checkbox or radio equals
	        // the value passed by blur event, then fire blur action with previousValue.
	        if (newValue === _value && _value !== undefined) {
	          newValue = previousValue;
	        }
	
	        var defaultPrevented = false;
	        if (onBlur) {
	          onBlur(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return event.preventDefault();
	            }
	          }), newValue, previousValue);
	        }
	
	        if (!defaultPrevented) {
	          // dispatch blur action
	          dispatch(_reduxForm.blur(name, newValue));
	
	          // call post-blur callback
	          if (_reduxForm.asyncValidate) {
	            _reduxForm.asyncValidate(name, newValue);
	          }
	        }
	      }
	    }, {
	      key: 'handleDragStart',
	      value: function handleDragStart(event) {
	        var _props4 = this.props,
	            onDragStart = _props4.onDragStart,
	            value = _props4.value;
	
	        event.dataTransfer.setData(_eventConsts.dataKey, value == null ? '' : value);
	
	        if (onDragStart) {
	          onDragStart(event);
	        }
	      }
	    }, {
	      key: 'handleDrop',
	      value: function handleDrop(event) {
	        var _props5 = this.props,
	            name = _props5.name,
	            dispatch = _props5.dispatch,
	            onDrop = _props5.onDrop,
	            _reduxForm = _props5._reduxForm,
	            previousValue = _props5.value;
	
	        var newValue = event.dataTransfer.getData(_eventConsts.dataKey);
	
	        var defaultPrevented = false;
	        if (onDrop) {
	          onDrop(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return event.preventDefault();
	            }
	          }), newValue, previousValue);
	        }
	
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	          event.preventDefault();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props6 = this.props,
	            component = _props6.component,
	            withRef = _props6.withRef,
	            name = _props6.name,
	            _reduxForm = _props6._reduxForm,
	            normalize = _props6.normalize,
	            onBlur = _props6.onBlur,
	            onChange = _props6.onChange,
	            onFocus = _props6.onFocus,
	            onDragStart = _props6.onDragStart,
	            onDrop = _props6.onDrop,
	            rest = _objectWithoutProperties(_props6, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop']);
	
	        var _createFieldProps = (0, _createFieldProps3.default)({ getIn: getIn, toJS: toJS }, name, _extends({}, rest, {
	          form: _reduxForm.form,
	          onBlur: this.handleBlur,
	          onChange: this.handleChange,
	          onDrop: this.handleDrop,
	          onDragStart: this.handleDragStart,
	          onFocus: this.handleFocus
	        })),
	            custom = _createFieldProps.custom,
	            props = _objectWithoutProperties(_createFieldProps, ['custom']);
	
	        if (withRef) {
	          custom.ref = 'renderedComponent';
	        }
	        if (typeof component === 'string') {
	          var input = props.input,
	              meta = props.meta; // eslint-disable-line no-unused-vars
	          // flatten input into other props
	
	          return (0, _react.createElement)(component, _extends({}, input, custom));
	        } else {
	          return (0, _react.createElement)(component, _extends({}, props, custom));
	        }
	      }
	    }]);
	
	    return ConnectedField;
	  }(_react.Component);
	
	  ConnectedField.propTypes = {
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    props: _react.PropTypes.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    var initialState = getIn(formState, 'initial.' + name);
	    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	    var value = getIn(formState, 'values.' + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = value === initial;
	    return {
	      asyncError: getIn(formState, 'asyncErrors.' + name),
	      asyncValidating: getIn(formState, 'asyncValidating') === name,
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, 'fields.' + name),
	      submitError: getIn(formState, 'submitErrors.' + name),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      value: value,
	      _value: ownProps.value // save value passed in (for checkboxes)
	    };
	  }, undefined, undefined, { withRef: true });
	  return connector(ConnectedField);
	};
	
	exports.default = createConnectedField;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mapValues2 = __webpack_require__(357);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(8);
	
	var _redux = __webpack_require__(12);
	
	var _createFieldArrayProps = __webpack_require__(1147);
	
	var _createFieldArrayProps2 = _interopRequireDefault(_createFieldArrayProps);
	
	var _plain = __webpack_require__(75);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm', 'value'];
	
	var createConnectedFieldArray = function createConnectedFieldArray(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      size = _ref.size;
	
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // For an array, the error can _ONLY_ be under _error.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return _plain2.default.getIn(syncErrors, name + '._error');
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    // For an array, the warning can _ONLY_ be under _warning.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return _plain2.default.getIn(syncWarnings, name + '._warning');
	  };
	
	  var ConnectedFieldArray = function (_Component) {
	    _inherits(ConnectedFieldArray, _Component);
	
	    function ConnectedFieldArray() {
	      _classCallCheck(this, ConnectedFieldArray);
	
	      var _this = _possibleConstructorReturn(this, (ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call(this));
	
	      _this.getValue = _this.getValue.bind(_this);
	      return _this;
	    }
	
	    _createClass(ConnectedFieldArray, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this2 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          // useful to debug rerenders
	          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	          // }
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	        });
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'getValue',
	      value: function getValue(index) {
	        return this.props.value && getIn(this.props.value, index);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            component = _props.component,
	            withRef = _props.withRef,
	            name = _props.name,
	            _reduxForm = _props._reduxForm,
	            validate = _props.validate,
	            warn = _props.warn,
	            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn']);
	
	        var props = (0, _createFieldArrayProps2.default)(getIn, name, _reduxForm.sectionPrefix, this.getValue, rest);
	        if (withRef) {
	          props.ref = 'renderedComponent';
	        }
	        return (0, _react.createElement)(component, props);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.props.dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.props.pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.props.value;
	      }
	    }]);
	
	    return ConnectedFieldArray;
	  }(_react.Component);
	
	  ConnectedFieldArray.propTypes = {
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    props: _react.PropTypes.object
	  };
	
	  ConnectedFieldArray.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
	    var value = getIn(formState, 'values.' + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, 'fields.' + name),
	      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      value: value,
	      length: size(value)
	    };
	  }, function (dispatch, ownProps) {
	    var name = ownProps.name,
	        _reduxForm = ownProps._reduxForm;
	    var arrayInsert = _reduxForm.arrayInsert,
	        arrayMove = _reduxForm.arrayMove,
	        arrayPop = _reduxForm.arrayPop,
	        arrayPush = _reduxForm.arrayPush,
	        arrayRemove = _reduxForm.arrayRemove,
	        arrayRemoveAll = _reduxForm.arrayRemoveAll,
	        arrayShift = _reduxForm.arrayShift,
	        arraySplice = _reduxForm.arraySplice,
	        arraySwap = _reduxForm.arraySwap,
	        arrayUnshift = _reduxForm.arrayUnshift;
	
	    return (0, _mapValues3.default)({
	      arrayInsert: arrayInsert,
	      arrayMove: arrayMove,
	      arrayPop: arrayPop,
	      arrayPush: arrayPush,
	      arrayRemove: arrayRemove,
	      arrayRemoveAll: arrayRemoveAll,
	      arrayShift: arrayShift,
	      arraySplice: arraySplice,
	      arraySwap: arraySwap,
	      arrayUnshift: arrayUnshift
	    }, function (actionCreator) {
	      return (0, _redux.bindActionCreators)(actionCreator.bind(null, name), dispatch);
	    });
	  }, undefined, { withRef: true });
	  return connector(ConnectedFieldArray);
	};
	
	exports.default = createConnectedFieldArray;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(8);
	
	var _createFieldProps2 = __webpack_require__(528);
	
	var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);
	
	var _plain = __webpack_require__(75);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _onChangeValue = __webpack_require__(530);
	
	var _onChangeValue2 = _interopRequireDefault(_onChangeValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var createConnectedFields = function createConnectedFields(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      toJS = _ref.toJS,
	      size = _ref.size;
	
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    var error = _plain2.default.getIn(syncErrors, name);
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return error && error._error ? error._error : error;
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = _plain2.default.getIn(syncWarnings, name);
	    // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedFields = function (_Component) {
	    _inherits(ConnectedFields, _Component);
	
	    function ConnectedFields(props) {
	      _classCallCheck(this, ConnectedFields);
	
	      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));
	
	      _this.handleChange = _this.handleChange.bind(_this);
	      _this.handleFocus = _this.handleFocus.bind(_this);
	      _this.handleBlur = _this.handleBlur.bind(_this);
	
	      _this.onChangeFns = props.names.reduce(function (acc, name) {
	        acc[name] = function (event) {
	          return _this.handleChange(name, event);
	        };
	        return acc;
	      }, {});
	
	      _this.onFocusFns = props.names.reduce(function (acc, name) {
	        acc[name] = function () {
	          return _this.handleFocus(name);
	        };
	        return acc;
	      }, {});
	
	      _this.onBlurFns = props.names.reduce(function (acc, name) {
	        acc[name] = function (event) {
	          return _this.handleBlur(name, event);
	        };
	        return acc;
	      }, {});
	      return _this;
	    }
	
	    _createClass(ConnectedFields, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
	          return !_this2.props._fields[nextName];
	        }))) {
	
	          // names is changed. The cached event handlers need to be updated
	          this.onChangeFns = nextProps.names.reduce(function (acc, name) {
	            acc[name] = function (event) {
	              return _this2.handleChange(name, event);
	            };
	            return acc;
	          }, {});
	
	          this.onFocusFns = nextProps.names.reduce(function (acc, name) {
	            acc[name] = function () {
	              return _this2.handleFocus(name);
	            };
	            return acc;
	          }, {});
	
	          this.onBlurFns = nextProps.names.reduce(function (acc, name) {
	            acc[name] = function (event) {
	              return _this2.handleBlur(name, event);
	            };
	            return acc;
	          }, {});
	        }
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this3 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	        });
	      }
	    }, {
	      key: 'isDirty',
	      value: function isDirty() {
	        var _fields = this.props._fields;
	
	        return Object.keys(_fields).some(function (name) {
	          return _fields[name].dirty;
	        });
	      }
	    }, {
	      key: 'getValues',
	      value: function getValues() {
	        var _fields = this.props._fields;
	
	        return Object.keys(_fields).reduce(function (accumulator, name) {
	          return _plain2.default.setIn(accumulator, name, _fields[name].value);
	        }, {});
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'handleChange',
	      value: function handleChange(name, event) {
	        var _props = this.props,
	            dispatch = _props.dispatch,
	            parse = _props.parse,
	            normalize = _props.normalize,
	            _reduxForm = _props._reduxForm;
	
	        var value = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        dispatch(_reduxForm.change(name, value));
	      }
	    }, {
	      key: 'handleFocus',
	      value: function handleFocus(name) {
	        var _props2 = this.props,
	            dispatch = _props2.dispatch,
	            _reduxForm = _props2._reduxForm;
	
	        dispatch(_reduxForm.focus(name));
	      }
	    }, {
	      key: 'handleBlur',
	      value: function handleBlur(name, event) {
	        var _props3 = this.props,
	            dispatch = _props3.dispatch,
	            parse = _props3.parse,
	            normalize = _props3.normalize,
	            _reduxForm = _props3._reduxForm;
	
	        var value = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        // dispatch blur action
	        dispatch(_reduxForm.blur(name, value));
	
	        // call post-blur callback
	        if (_reduxForm.asyncValidate) {
	          _reduxForm.asyncValidate(name, value);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this4 = this;
	
	        var _props4 = this.props,
	            component = _props4.component,
	            withRef = _props4.withRef,
	            _fields = _props4._fields,
	            _reduxForm = _props4._reduxForm,
	            rest = _objectWithoutProperties(_props4, ['component', 'withRef', '_fields', '_reduxForm']);
	
	        var sectionPrefix = _reduxForm.sectionPrefix;
	
	        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
	          var connectedProps = _fields[name];
	
	          var _createFieldProps = (0, _createFieldProps3.default)({ getIn: getIn, toJS: toJS }, name, _extends({}, connectedProps, rest, {
	            onBlur: _this4.onBlurFns[name],
	            onChange: _this4.onChangeFns[name],
	            onFocus: _this4.onFocusFns[name]
	          })),
	              custom = _createFieldProps.custom,
	              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);
	
	          accumulator.custom = custom;
	          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
	          return _plain2.default.setIn(accumulator, fieldName, fieldProps);
	        }, {}),
	            custom = _Object$keys$reduce.custom,
	            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);
	
	        if (withRef) {
	          props.ref = 'renderedComponent';
	        }
	
	        return (0, _react.createElement)(component, _extends({}, props, custom));
	      }
	    }]);
	
	    return ConnectedFields;
	  }(_react.Component);
	
	  ConnectedFields.propTypes = {
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    _fields: _react.PropTypes.object.isRequired,
	    props: _react.PropTypes.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var names = ownProps.names,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    return {
	      _fields: names.reduce(function (accumulator, name) {
	        var initialState = getIn(formState, 'initial.' + name);
	        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	        var value = getIn(formState, 'values.' + name);
	        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	        var submitting = getIn(formState, 'submitting');
	        var pristine = value === initial;
	        accumulator[name] = {
	          asyncError: getIn(formState, 'asyncErrors.' + name),
	          asyncValidating: getIn(formState, 'asyncValidating') === name,
	          dirty: !pristine,
	          pristine: pristine,
	          state: getIn(formState, 'fields.' + name),
	          submitError: getIn(formState, 'submitErrors.' + name),
	          submitFailed: getIn(formState, 'submitFailed'),
	          submitting: submitting,
	          syncError: syncError,
	          syncWarning: syncWarning,
	          value: value,
	          _value: ownProps.value // save value passed in (for checkboxes)
	        };
	        return accumulator;
	      }, {})
	    };
	  }, undefined, undefined, { withRef: true });
	  return connector(ConnectedFields);
	};
	
	exports.default = createConnectedFields;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedField = __webpack_require__(1137);
	
	var _ConnectedField2 = _interopRequireDefault(_ConnectedField);
	
	var _shallowCompare = __webpack_require__(255);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _prefixName = __webpack_require__(167);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createField = function createField(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      setIn = _ref.setIn,
	      toJS = _ref.toJS;
	
	
	  var ConnectedField = (0, _ConnectedField2.default)({
	    deepEqual: deepEqual,
	    getIn: getIn,
	    toJS: toJS
	  });
	
	  var Field = function (_Component) {
	    _inherits(Field, _Component);
	
	    function Field(props, context) {
	      _classCallCheck(this, Field);
	
	      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('Field must be inside a component decorated with reduxForm()');
	      }
	
	      _this.normalize = _this.normalize.bind(_this);
	      return _this;
	    }
	
	    _createClass(Field, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _shallowCompare2.default)(this, nextProps, nextState);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _this2 = this;
	
	        this.context._reduxForm.register(this.name, 'Field', function () {
	          return _this2.props.validate;
	        }, function () {
	          return _this2.props.warn;
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.name !== nextProps.name) {
	          // unregister old name
	          this.context._reduxForm.unregister(this.name);
	          // register new name
	          this.context._reduxForm.register((0, _prefixName2.default)(this.context, nextProps.name), 'Field');
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'normalize',
	      value: function normalize(name, value) {
	        var normalize = this.props.normalize;
	
	        if (!normalize) {
	          return value;
	        }
	        var previousValues = this.context._reduxForm.getValues();
	        var previousValue = this.value;
	        var nextValues = setIn(previousValues, name, value);
	        return normalize(value, previousValue, nextValues, previousValues);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(ConnectedField, _extends({}, this.props, {
	          name: this.name,
	          normalize: this.normalize,
	          _reduxForm: this.context._reduxForm,
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return (0, _prefixName2.default)(this.context, this.props.name);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return !this.pristine;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().isPristine();
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.refs.connected && this.refs.connected.getWrappedInstance().getValue();
	      }
	    }]);
	
	    return Field;
	  }(_react.Component);
	
	  Field.propTypes = {
	    name: _react.PropTypes.string.isRequired,
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    format: _react.PropTypes.func,
	    normalize: _react.PropTypes.func,
	    onBlur: _react.PropTypes.func,
	    onChange: _react.PropTypes.func,
	    onFocus: _react.PropTypes.func,
	    onDragStart: _react.PropTypes.func,
	    onDrop: _react.PropTypes.func,
	    parse: _react.PropTypes.func,
	    props: _react.PropTypes.object
	  };
	  Field.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  return Field;
	};
	
	exports.default = createField;

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedFieldArray = __webpack_require__(1138);
	
	var _ConnectedFieldArray2 = _interopRequireDefault(_ConnectedFieldArray);
	
	var _shallowCompare = __webpack_require__(255);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _prefixName = __webpack_require__(167);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var wrapError = function wrapError(fn, key) {
	  return fn && function () {
	    var validators = toArray(fn);
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = validators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var validator = _step.value;
	
	        var result = validator.apply(undefined, arguments);
	        if (result) {
	          return _defineProperty({}, key, result);
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  };
	};
	
	var createFieldArray = function createFieldArray(_ref2) {
	  var deepEqual = _ref2.deepEqual,
	      getIn = _ref2.getIn,
	      size = _ref2.size;
	
	
	  var ConnectedFieldArray = (0, _ConnectedFieldArray2.default)({ deepEqual: deepEqual, getIn: getIn, size: size });
	
	  var FieldArray = function (_Component) {
	    _inherits(FieldArray, _Component);
	
	    function FieldArray(props, context) {
	      _classCallCheck(this, FieldArray);
	
	      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(FieldArray, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _shallowCompare2.default)(this, nextProps, nextState);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _this2 = this;
	
	        this.context._reduxForm.register(this.name, 'FieldArray', function () {
	          return wrapError(_this2.props.validate, '_error');
	        }, function () {
	          return wrapError(_this2.props.warn, '_warning');
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.name !== nextProps.name) {
	          // unregister old name
	          this.context._reduxForm.unregister(this.name);
	          // register new name
	          this.context._reduxForm.register((0, _prefixName2.default)(this.context, nextProps.name), 'FieldArray');
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(ConnectedFieldArray, _extends({}, this.props, {
	          name: this.name,
	          syncError: this.syncError,
	          syncWarning: this.syncWarning,
	          _reduxForm: this.context._reduxForm,
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return (0, _prefixName2.default)(this.context, this.props.name);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().value;
	      }
	    }]);
	
	    return FieldArray;
	  }(_react.Component);
	
	  FieldArray.propTypes = {
	    name: _react.PropTypes.string.isRequired,
	    component: _react.PropTypes.func.isRequired,
	    props: _react.PropTypes.object
	  };
	  FieldArray.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  return FieldArray;
	};
	
	exports.default = createFieldArray;

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedFields = __webpack_require__(1139);
	
	var _ConnectedFields2 = _interopRequireDefault(_ConnectedFields);
	
	var _shallowCompare = __webpack_require__(255);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _plain = __webpack_require__(75);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _prefixName = __webpack_require__(167);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validateNameProp = function validateNameProp(prop) {
	  if (!prop) {
	    return new Error('No "names" prop was specified <Fields/>');
	  }
	  if (!Array.isArray(prop) && !prop._isFieldArray) {
	    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
	  }
	};
	
	var createFields = function createFields(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      toJS = _ref.toJS,
	      size = _ref.size;
	
	
	  var ConnectedFields = (0, _ConnectedFields2.default)({
	    deepEqual: deepEqual,
	    getIn: getIn,
	    toJS: toJS,
	    size: size
	  });
	
	  var Fields = function (_Component) {
	    _inherits(Fields, _Component);
	
	    function Fields(props, context) {
	      _classCallCheck(this, Fields);
	
	      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('Fields must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(Fields, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _shallowCompare2.default)(this, nextProps, nextState);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var error = validateNameProp(this.props.names);
	        if (error) {
	          throw error;
	        }
	        var context = this.context;
	        var register = context._reduxForm.register;
	
	        this.names.forEach(function (name) {
	          return register(name, 'Field');
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        if (!_plain2.default.deepEqual(this.props.names, nextProps.names)) {
	          (function () {
	            var context = _this2.context;
	            var _context$_reduxForm = context._reduxForm,
	                register = _context$_reduxForm.register,
	                unregister = _context$_reduxForm.unregister;
	            // unregister old name
	
	            _this2.props.names.forEach(function (name) {
	              return unregister((0, _prefixName2.default)(context, name));
	            });
	            // register new name
	            nextProps.names.forEach(function (name) {
	              return register((0, _prefixName2.default)(context, name), 'Field');
	            });
	          })();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var context = this.context;
	        var unregister = context._reduxForm.unregister;
	
	        this.props.names.forEach(function (name) {
	          return unregister((0, _prefixName2.default)(context, name));
	        });
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var context = this.context;
	
	        return (0, _react.createElement)(ConnectedFields, _extends({}, this.props, {
	          names: this.props.names.map(function (name) {
	            return (0, _prefixName2.default)(context, name);
	          }),
	          _reduxForm: this.context._reduxForm,
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'names',
	      get: function get() {
	        var context = this.context;
	
	        return this.props.names.map(function (name) {
	          return (0, _prefixName2.default)(context, name);
	        });
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().isDirty();
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return !this.dirty;
	      }
	    }, {
	      key: 'values',
	      get: function get() {
	        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
	      }
	    }]);
	
	    return Fields;
	  }(_react.Component);
	
	  Fields.propTypes = {
	    names: function names(props, propName) {
	      return validateNameProp(props[propName]);
	    },
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    format: _react.PropTypes.func,
	    parse: _react.PropTypes.func,
	    props: _react.PropTypes.object
	  };
	  Fields.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  return Fields;
	};
	
	exports.default = createFields;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Form = function (_Component) {
	  _inherits(Form, _Component);
	
	  function Form(props, context) {
	    _classCallCheck(this, Form);
	
	    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));
	
	    if (!context._reduxForm) {
	      throw new Error('Form must be inside a component decorated with reduxForm()');
	    }
	    return _this;
	  }
	
	  _createClass(Form, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('form', this.props);
	    }
	  }]);
	
	  return Form;
	}(_react.Component);
	
	Form.propTypes = {
	  onSubmit: _react.PropTypes.func.isRequired
	};
	Form.contextTypes = {
	  _reduxForm: _react.PropTypes.object
	};
	
	exports.default = Form;

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _prefixName = __webpack_require__(167);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormSection = function (_Component) {
	  _inherits(FormSection, _Component);
	
	  function FormSection(props, context) {
	    _classCallCheck(this, FormSection);
	
	    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));
	
	    if (!context._reduxForm) {
	      throw new Error('FormSection must be inside a component decorated with reduxForm()');
	    }
	    return _this;
	  }
	
	  _createClass(FormSection, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var context = this.context,
	          name = this.props.name;
	
	      return {
	        _reduxForm: _extends({}, context._reduxForm, {
	          sectionPrefix: (0, _prefixName2.default)(context, name)
	        })
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          component = _props.component,
	          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);
	
	      if (_react2.default.isValidElement(children)) {
	        return children;
	      }
	
	      return (0, _react.createElement)(component, _extends({}, rest, {
	        children: children
	      }));
	    }
	  }]);
	
	  return FormSection;
	}(_react.Component);
	
	FormSection.propTypes = {
	  name: _react.PropTypes.string.isRequired,
	  component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string])
	};
	
	FormSection.defaultProps = {
	  component: 'div'
	};
	
	FormSection.childContextTypes = {
	  _reduxForm: _react.PropTypes.object.isRequired
	};
	
	FormSection.contextTypes = {
	  _reduxForm: _react.PropTypes.object
	};
	
	exports.default = FormSection;

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPromise = __webpack_require__(205);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	  if (!(0, _isPromise2.default)(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (errors && Object.keys(errors).length) {
	        stop(errors);
	        return errors;
	      } else if (rejected) {
	        stop();
	        throw new Error('Asynchronous validation promise was rejected without errors.');
	      }
	      stop();
	      return Promise.resolve();
	    };
	  };
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	exports.default = asyncValidation;

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reducer = __webpack_require__(1159);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reduxForm = __webpack_require__(1160);
	
	var _reduxForm2 = _interopRequireDefault(_reduxForm);
	
	var _Field = __webpack_require__(1140);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Fields = __webpack_require__(1142);
	
	var _Fields2 = _interopRequireDefault(_Fields);
	
	var _FieldArray = __webpack_require__(1141);
	
	var _FieldArray2 = _interopRequireDefault(_FieldArray);
	
	var _formValueSelector = __webpack_require__(1153);
	
	var _formValueSelector2 = _interopRequireDefault(_formValueSelector);
	
	var _values = __webpack_require__(1178);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _getFormValues = __webpack_require__(1165);
	
	var _getFormValues2 = _interopRequireDefault(_getFormValues);
	
	var _getFormInitialValues = __webpack_require__(1162);
	
	var _getFormInitialValues2 = _interopRequireDefault(_getFormInitialValues);
	
	var _getFormSyncErrors = __webpack_require__(1164);
	
	var _getFormSyncErrors2 = _interopRequireDefault(_getFormSyncErrors);
	
	var _getFormAsyncErrors = __webpack_require__(1161);
	
	var _getFormAsyncErrors2 = _interopRequireDefault(_getFormAsyncErrors);
	
	var _getFormSubmitErrors = __webpack_require__(1163);
	
	var _getFormSubmitErrors2 = _interopRequireDefault(_getFormSubmitErrors);
	
	var _isDirty = __webpack_require__(1168);
	
	var _isDirty2 = _interopRequireDefault(_isDirty);
	
	var _isInvalid = __webpack_require__(1169);
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _isPristine = __webpack_require__(532);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _isValid = __webpack_require__(254);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _isSubmitting = __webpack_require__(1170);
	
	var _isSubmitting2 = _interopRequireDefault(_isSubmitting);
	
	var _hasSubmitSucceeded = __webpack_require__(1167);
	
	var _hasSubmitSucceeded2 = _interopRequireDefault(_hasSubmitSucceeded);
	
	var _hasSubmitFailed = __webpack_require__(1166);
	
	var _hasSubmitFailed2 = _interopRequireDefault(_hasSubmitFailed);
	
	var _Form = __webpack_require__(1143);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormSection = __webpack_require__(1144);
	
	var _FormSection2 = _interopRequireDefault(_FormSection);
	
	var _SubmissionError = __webpack_require__(526);
	
	var _SubmissionError2 = _interopRequireDefault(_SubmissionError);
	
	var _propTypes = __webpack_require__(1158);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actions = __webpack_require__(527);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _actionTypes = __webpack_require__(253);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createAll = function createAll(structure) {
	  return _extends({
	    // separate out field actions
	    actionTypes: actionTypes
	  }, actions, {
	    Field: (0, _Field2.default)(structure),
	    Fields: (0, _Fields2.default)(structure),
	    FieldArray: (0, _FieldArray2.default)(structure),
	    Form: _Form2.default,
	    FormSection: _FormSection2.default,
	    formValueSelector: (0, _formValueSelector2.default)(structure),
	    getFormValues: (0, _getFormValues2.default)(structure),
	    getFormInitialValues: (0, _getFormInitialValues2.default)(structure),
	    getFormSyncErrors: (0, _getFormSyncErrors2.default)(structure),
	    getFormAsyncErrors: (0, _getFormAsyncErrors2.default)(structure),
	    getFormSubmitErrors: (0, _getFormSubmitErrors2.default)(structure),
	    isDirty: (0, _isDirty2.default)(structure),
	    isInvalid: (0, _isInvalid2.default)(structure),
	    isPristine: (0, _isPristine2.default)(structure),
	    isValid: (0, _isValid2.default)(structure),
	    isSubmitting: (0, _isSubmitting2.default)(structure),
	    hasSubmitSucceeded: (0, _hasSubmitSucceeded2.default)(structure),
	    hasSubmitFailed: (0, _hasSubmitFailed2.default)(structure),
	    propTypes: _propTypes2.default,
	    reduxForm: (0, _reduxForm2.default)(structure),
	    reducer: (0, _reducer2.default)(structure),
	    SubmissionError: _SubmissionError2.default,
	    values: (0, _values2.default)(structure)
	  });
	};
	
	exports.default = createAll;

/***/ },
/* 1147 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var createFieldArrayProps = function createFieldArrayProps(getIn, name, sectionPrefix, getValue, _ref) {
	  var arrayInsert = _ref.arrayInsert,
	      arrayMove = _ref.arrayMove,
	      arrayPop = _ref.arrayPop,
	      arrayPush = _ref.arrayPush,
	      arrayRemove = _ref.arrayRemove,
	      arrayRemoveAll = _ref.arrayRemoveAll,
	      arrayShift = _ref.arrayShift,
	      arraySplice = _ref.arraySplice,
	      arraySwap = _ref.arraySwap,
	      arrayUnshift = _ref.arrayUnshift,
	      asyncError = _ref.asyncError,
	      dirty = _ref.dirty,
	      length = _ref.length,
	      pristine = _ref.pristine,
	      submitError = _ref.submitError,
	      state = _ref.state,
	      submitFailed = _ref.submitFailed,
	      submitting = _ref.submitting,
	      syncError = _ref.syncError,
	      syncWarning = _ref.syncWarning,
	      value = _ref.value,
	      props = _ref.props,
	      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);
	
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
	  var finalProps = _extends({
	    fields: {
	      _isFieldArray: true,
	      forEach: function forEach(callback) {
	        return (value || []).forEach(function (item, index) {
	          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
	        });
	      },
	      get: getValue,
	      getAll: function getAll() {
	        return value;
	      },
	      insert: arrayInsert,
	      length: length,
	      map: function map(callback) {
	        return (value || []).map(function (item, index) {
	          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
	        });
	      },
	      move: arrayMove,
	      name: name,
	      pop: function pop() {
	        arrayPop();
	        return getIn(value, length - 1);
	      },
	      push: arrayPush,
	      reduce: function reduce(callback, initial) {
	        return (value || []).reduce(function (accumulator, item, index) {
	          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
	        }, initial);
	      },
	      remove: arrayRemove,
	      removeAll: arrayRemoveAll,
	      shift: function shift() {
	        arrayShift();
	        return getIn(value, 0);
	      },
	      swap: arraySwap,
	      unshift: arrayUnshift
	    },
	    meta: {
	      dirty: dirty,
	      error: error,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: submitting,
	      touched: !!(state && getIn(state, 'touched')),
	      valid: !error
	    }
	  }, props, rest);
	  return finalProps;
	};
	
	exports.default = createFieldArrayProps;

/***/ },
/* 1148 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
	  var initialized = _ref.initialized,
	      trigger = _ref.trigger,
	      pristine = _ref.pristine,
	      syncValidationPasses = _ref.syncValidationPasses;
	
	  if (!syncValidationPasses) {
	    return false;
	  }
	  switch (trigger) {
	    case 'blur':
	      // blurring
	      return true;
	    case 'submit':
	      // submitting, so only async validate if form is dirty or was never initialized
	      // conversely, DON'T async validate if the form is pristine just as it was initialized
	      return !pristine || !initialized;
	    default:
	      return false;
	  }
	};
	
	exports.default = defaultShouldAsyncValidate;

/***/ },
/* 1149 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultShouldValidate = function defaultShouldValidate(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	  return !structure.deepEqual(values, nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	
	exports.default = defaultShouldValidate;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(156);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createDeleteInWithCleanUp = function createDeleteInWithCleanUp(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn,
	      deleteIn = _ref.deleteIn,
	      setIn = _ref.setIn;
	
	
	  var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
	    if (path[path.length - 1] === ']') {
	      // array path
	      var pathTokens = (0, _toPath3.default)(path);
	      pathTokens.pop();
	      var parent = getIn(state, pathTokens.join('.'));
	      return parent ? setIn(state, path, undefined) : state;
	    }
	    var result = deleteIn(state, path);
	    var dotIndex = path.lastIndexOf('.');
	    if (dotIndex > 0) {
	      var parentPath = path.substring(0, dotIndex);
	      if (parentPath[parentPath.length - 1] !== ']') {
	        var _parent = getIn(result, parentPath);
	        if (deepEqual(_parent, empty)) {
	          return deleteInWithCleanUp(result, parentPath);
	        }
	      }
	    }
	    return result;
	  };
	
	  return deleteInWithCleanUp;
	};
	
	exports.default = createDeleteInWithCleanUp;

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(529);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent2.default)(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	    var _event$target = event.target,
	        type = _event$target.type,
	        value = _event$target.value,
	        checked = _event$target.checked,
	        files = _event$target.files,
	        dataTransfer = event.dataTransfer;
	
	    if (type === 'checkbox') {
	      return checked;
	    }
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	    return value;
	  }
	  return event;
	};
	
	exports.default = getValue;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _silenceEvent = __webpack_require__(531);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
	  };
	};
	
	exports.default = silenceEvents;

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _plain = __webpack_require__(75);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFormValueSelector = function createFormValueSelector(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	
	    (0, _invariant2.default)(form, 'Form value must be specified');
	    return function (state) {
	      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      (0, _invariant2.default)(fields.length, 'No fields specified');
	      return fields.length === 1 ?
	      // only selecting one field, so return its value
	      getIn(getFormState(state), form + '.values.' + fields[0]) :
	      // selecting many fields, so return an object of field values
	      fields.reduce(function (accumulator, field) {
	        var value = getIn(getFormState(state), form + '.values.' + field);
	        return value === undefined ? accumulator : _plain2.default.setIn(accumulator, field, value);
	      }, {});
	    };
	  };
	};
	
	exports.default = createFormValueSelector;

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _plain = __webpack_require__(75);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var getError = function getError(value, values, props, validators) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = toArray(validators)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var validator = _step.value;
	
	      var error = validator(value, values, props);
	      if (error) {
	        return error;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	};
	
	var generateValidator = function generateValidator(validators, _ref) {
	  var getIn = _ref.getIn;
	  return function (values, props) {
	    var errors = {};
	    Object.keys(validators).forEach(function (name) {
	      var value = getIn(values, name);
	      var error = getError(value, values, props, validators[name]);
	      if (error) {
	        errors = _plain2.default.setIn(errors, name, error);
	      }
	    });
	    return errors;
	  };
	};
	
	exports.default = generateValidator;

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _isPromise = __webpack_require__(205);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _SubmissionError = __webpack_require__(526);
	
	var _SubmissionError2 = _interopRequireDefault(_SubmissionError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
	  var dispatch = props.dispatch,
	      onSubmitFail = props.onSubmitFail,
	      onSubmitSuccess = props.onSubmitSuccess,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      setSubmitFailed = props.setSubmitFailed,
	      setSubmitSucceeded = props.setSubmitSucceeded,
	      syncErrors = props.syncErrors,
	      touch = props.touch,
	      values = props.values,
	      persistentSubmitErrors = props.persistentSubmitErrors;
	
	
	  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched
	
	  if (valid || persistentSubmitErrors) {
	    var _ret = function () {
	      var doSubmit = function doSubmit() {
	        var result = void 0;
	        try {
	          result = submit(values, dispatch, props);
	        } catch (submitError) {
	          var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
	          stopSubmit(error);
	          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	          if (onSubmitFail) {
	            onSubmitFail(error, dispatch, submitError, props);
	          }
	          if (error || onSubmitFail) {
	            // if you've provided an onSubmitFail callback, don't re-throw the error
	            return error;
	          } else {
	            throw submitError;
	          }
	        }
	        if ((0, _isPromise2.default)(result)) {
	          startSubmit();
	          return result.then(function (submitResult) {
	            stopSubmit();
	            setSubmitSucceeded();
	            if (onSubmitSuccess) {
	              onSubmitSuccess(submitResult, dispatch, props);
	            }
	            return submitResult;
	          }, function (submitError) {
	            var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
	            stopSubmit(error);
	            setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	            if (onSubmitFail) {
	              onSubmitFail(error, dispatch, submitError, props);
	            }
	            if (error || onSubmitFail) {
	              // if you've provided an onSubmitFail callback, don't re-throw the error
	              return error;
	            } else {
	              throw submitError;
	            }
	          });
	        } else {
	          setSubmitSucceeded();
	          if (onSubmitSuccess) {
	            onSubmitSuccess(result, dispatch, props);
	          }
	        }
	        return result;
	      };
	
	      var asyncValidateResult = asyncValidate && asyncValidate();
	      if (asyncValidateResult) {
	        return {
	          v: asyncValidateResult.then(function (asyncErrors) {
	            if (asyncErrors) {
	              throw asyncErrors;
	            }
	            return doSubmit();
	          }).catch(function (asyncErrors) {
	            setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	            if (onSubmitFail) {
	              onSubmitFail(asyncErrors, dispatch, null, props);
	            }
	            return Promise.reject(asyncErrors);
	          })
	        };
	      } else {
	        return {
	          v: doSubmit()
	        };
	      }
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  } else {
	    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	    if (onSubmitFail) {
	      onSubmitFail(syncErrors, dispatch, null, props);
	    }
	    return syncErrors;
	  }
	};
	
	exports.default = handleSubmit;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIn = __webpack_require__(533);
	
	var _getIn2 = _interopRequireDefault(_getIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getErrorKeys = function getErrorKeys(name, type) {
	  switch (type) {
	    case 'Field':
	      return [name, name + '._error'];
	    case 'FieldArray':
	      return [name + '._error'];
	  }
	};
	
	var createHasError = function createHasError(_ref) {
	  var getIn = _ref.getIn;
	
	  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
	    if (!syncErrors && !asyncErrors && !submitErrors) {
	      return false;
	    }
	
	    var name = getIn(field, 'name');
	    var type = getIn(field, 'type');
	    return getErrorKeys(name, type).some(function (key) {
	      return (0, _getIn2.default)(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
	    });
	  };
	  return hasError;
	};
	
	exports.default = createHasError;

/***/ },
/* 1157 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	exports.default = isReactNative;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var any = _react.PropTypes.any,
	    bool = _react.PropTypes.bool,
	    func = _react.PropTypes.func,
	    shape = _react.PropTypes.shape;
	
	
	var propTypes = {
	  // State:
	  asyncValidating: bool.isRequired, // true if async validation is running
	  dirty: bool.isRequired, // true if any values are different from initialValues
	  error: any, // form-wide error from '_error' key in validation result
	  warning: any, // form-wide warning from '_warning' key in validation result
	  invalid: bool.isRequired, // true if there are any validation errors
	  initialized: bool.isRequired, // true if the form has been initialized
	  pristine: bool.isRequired, // true if the values are the same as initialValues
	  submitting: bool.isRequired, // true if the form is in the process of being submitted
	  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
	  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
	  valid: bool.isRequired, // true if there are no validation errors
	  // Actions:
	  array: shape({
	    insert: func.isRequired, // function to insert a value into an array field
	    move: func.isRequired, // function to move a value within an array field
	    pop: func.isRequired, // function to pop a value off of an array field
	    push: func.isRequired, // function to push a value onto an array field
	    remove: func.isRequired, // function to remove a value from an array field
	    removeAll: func.isRequired, // function to remove all the values from an array field
	    shift: func.isRequired, // function to shift a value out of an array field
	    splice: func.isRequired, // function to splice a value into an array field
	    swap: func.isRequired, // function to swap values in an array field
	    unshift: func.isRequired // function to unshift a value into an array field
	  }),
	  asyncValidate: func.isRequired, // function to trigger async validation
	  blur: func.isRequired, // action to mark a field as blurred
	  change: func.isRequired, // action to change the value of a field
	  destroy: func.isRequired, // action to destroy the form's data in Redux
	  dispatch: func.isRequired, // the Redux dispatch action
	  handleSubmit: func.isRequired, // function to submit the form
	  initialize: func.isRequired, // action to initialize form data
	  reset: func.isRequired, // action to reset the form data to previously initialized values
	  touch: func.isRequired, // action to mark fields as touched
	  untouch: func.isRequired // action to mark fields as untouched
	};
	
	exports.default = propTypes;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionTypes = __webpack_require__(253);
	
	var _deleteInWithCleanUp = __webpack_require__(1150);
	
	var _deleteInWithCleanUp2 = _interopRequireDefault(_deleteInWithCleanUp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var createReducer = function createReducer(structure) {
	  var _behaviors;
	
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      deleteIn = structure.deleteIn,
	      fromJS = structure.fromJS,
	      keys = structure.keys,
	      size = structure.size,
	      splice = structure.splice;
	
	  var deleteInWithCleanUp = (0, _deleteInWithCleanUp2.default)(structure);
	  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
	    var existing = getIn(state, key + '.' + field);
	    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
	  };
	  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
	  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
	    var result = state;
	    var nonValuesValue = value != null ? empty : undefined;
	    result = doSplice(result, 'values', field, index, removeNum, value, true);
	    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
	    result = doSplice(result, 'submitErrors', field, index, removeNum, nonValuesValue);
	    result = doSplice(result, 'asyncErrors', field, index, removeNum, nonValuesValue);
	    return result;
	  };
	
	  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, _actionTypes.ARRAY_INSERT, function (state, _ref) {
	    var _ref$meta = _ref.meta,
	        field = _ref$meta.field,
	        index = _ref$meta.index,
	        payload = _ref.payload;
	
	    return arraySplice(state, field, index, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_MOVE, function (state, _ref2) {
	    var _ref2$meta = _ref2.meta,
	        field = _ref2$meta.field,
	        from = _ref2$meta.from,
	        to = _ref2$meta.to;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    var result = state;
	    if (length) {
	      rootKeys.forEach(function (key) {
	        var path = key + '.' + field;
	        if (getIn(result, path)) {
	          var value = getIn(result, path + '[' + from + ']');
	          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
	          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
	        }
	      });
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_POP, function (state, _ref3) {
	    var field = _ref3.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, length - 1, 1) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_PUSH, function (state, _ref4) {
	    var field = _ref4.meta.field,
	        payload = _ref4.payload;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return arraySplice(state, field, length, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE, function (state, _ref5) {
	    var _ref5$meta = _ref5.meta,
	        field = _ref5$meta.field,
	        index = _ref5$meta.index;
	
	    return arraySplice(state, field, index, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE_ALL, function (state, _ref6) {
	    var field = _ref6.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, 0, length) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SHIFT, function (state, _ref7) {
	    var field = _ref7.meta.field;
	
	    return arraySplice(state, field, 0, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SPLICE, function (state, _ref8) {
	    var _ref8$meta = _ref8.meta,
	        field = _ref8$meta.field,
	        index = _ref8$meta.index,
	        removeNum = _ref8$meta.removeNum,
	        payload = _ref8.payload;
	
	    return arraySplice(state, field, index, removeNum, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SWAP, function (state, _ref9) {
	    var _ref9$meta = _ref9.meta,
	        field = _ref9$meta.field,
	        indexA = _ref9$meta.indexA,
	        indexB = _ref9$meta.indexB;
	
	    var result = state;
	    rootKeys.forEach(function (key) {
	      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
	      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
	      if (valueA !== undefined || valueB !== undefined) {
	        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
	        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
	      }
	    });
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_UNSHIFT, function (state, _ref10) {
	    var field = _ref10.meta.field,
	        payload = _ref10.payload;
	
	    return arraySplice(state, field, 0, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.AUTOFILL, function (state, _ref11) {
	    var field = _ref11.meta.field,
	        payload = _ref11.payload;
	
	    var result = state;
	    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	    result = setIn(result, 'fields.' + field + '.autofilled', true);
	    result = setIn(result, 'values.' + field, payload);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.BLUR, function (state, _ref12) {
	    var _ref12$meta = _ref12.meta,
	        field = _ref12$meta.field,
	        touch = _ref12$meta.touch,
	        payload = _ref12.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    if (field === getIn(result, 'active')) {
	      result = deleteIn(result, 'active');
	    }
	    result = deleteIn(result, 'fields.' + field + '.active');
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CHANGE, function (state, _ref13) {
	    var _ref13$meta = _ref13.meta,
	        field = _ref13$meta.field,
	        touch = _ref13$meta.touch,
	        persistentSubmitErrors = _ref13$meta.persistentSubmitErrors,
	        payload = _ref13.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	    if (!persistentSubmitErrors) {
	      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	    }
	    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_SUBMIT, function (state) {
	    return deleteIn(state, 'triggerSubmit');
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_ASYNC_ERROR, function (state, _ref14) {
	    var field = _ref14.meta.field;
	
	    return deleteIn(state, 'asyncErrors.' + field);
	  }), _defineProperty(_behaviors, _actionTypes.FOCUS, function (state, _ref15) {
	    var field = _ref15.meta.field;
	
	    var result = state;
	    var previouslyActive = getIn(state, 'active');
	    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
	    result = setIn(result, 'fields.' + field + '.visited', true);
	    result = setIn(result, 'fields.' + field + '.active', true);
	    result = setIn(result, 'active', field);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.INITIALIZE, function (state, _ref16) {
	    var payload = _ref16.payload,
	        _ref16$meta = _ref16.meta,
	        keepDirty = _ref16$meta.keepDirty,
	        keepSubmitSucceeded = _ref16$meta.keepSubmitSucceeded;
	
	    var mapData = fromJS(payload);
	    var result = empty; // clean all field state
	
	    // persist old warnings, they will get recalculated if the new form values are different from the old values
	    var warning = getIn(state, 'warning');
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    }
	    var syncWarnings = getIn(state, 'syncWarnings');
	    if (syncWarnings) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    }
	
	    // persist old errors, they will get recalculated if the new form values are different from the old values
	    var error = getIn(state, 'error');
	    if (error) {
	      result = setIn(result, 'error', error);
	    }
	    var syncErrors = getIn(state, 'syncErrors');
	    if (syncErrors) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    }
	
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	    var newValues = mapData;
	    if (keepDirty && registeredFields) {
	      (function () {
	        //
	        // Keep the value of dirty fields while updating the value of
	        // pristine fields. This way, apps can reinitialize forms while
	        // avoiding stomping on user edits.
	        //
	        // Note 1: The initialize action replaces all initial values
	        // regardless of keepDirty.
	        //
	        // Note 2: When a field is dirty, keepDirty is enabled, and the field
	        // value is the same as the new initial value for the field, the
	        // initialize action causes the field to become pristine. That effect
	        // is what we want.
	        //
	        var previousValues = getIn(state, 'values');
	        var previousInitialValues = getIn(state, 'initial');
	        keys(registeredFields).forEach(function (name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	          var previousValue = getIn(previousValues, name);
	          if (!deepEqual(previousValue, previousInitialValue)) {
	            // This field was dirty. Restore the dirty value.
	            newValues = setIn(newValues, name, previousValue);
	          }
	        });
	      })();
	    }
	    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
	      result = setIn(result, 'submitSucceeded', true);
	    }
	    result = setIn(result, 'values', newValues);
	    result = setIn(result, 'initial', mapData);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.REGISTER_FIELD, function (state, _ref17) {
	    var _ref17$payload = _ref17.payload,
	        name = _ref17$payload.name,
	        type = _ref17$payload.type;
	
	    var key = 'registeredFields[\'' + name + '\']';
	    var field = getIn(state, key);
	    if (field) {
	      var count = getIn(field, 'count') + 1;
	      field = setIn(field, 'count', count);
	    } else {
	      field = fromJS({ name: name, type: type, count: 1 });
	    }
	    return setIn(state, key, field);
	  }), _defineProperty(_behaviors, _actionTypes.RESET, function (state) {
	    var result = empty;
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	    var values = getIn(state, 'initial');
	    if (values) {
	      result = setIn(result, 'values', values);
	      result = setIn(result, 'initial', values);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SUBMIT, function (state) {
	    return setIn(state, 'triggerSubmit', true);
	  }), _defineProperty(_behaviors, _actionTypes.START_ASYNC_VALIDATION, function (state, _ref18) {
	    var field = _ref18.meta.field;
	
	    return setIn(state, 'asyncValidating', field || true);
	  }), _defineProperty(_behaviors, _actionTypes.START_SUBMIT, function (state) {
	    return setIn(state, 'submitting', true);
	  }), _defineProperty(_behaviors, _actionTypes.STOP_ASYNC_VALIDATION, function (state, _ref19) {
	    var payload = _ref19.payload;
	
	    var result = state;
	    result = deleteIn(result, 'asyncValidating');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'asyncErrors');
	      }
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'asyncErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.STOP_SUBMIT, function (state, _ref20) {
	    var payload = _ref20.payload;
	
	    var result = state;
	    result = deleteIn(result, 'submitting');
	    result = deleteIn(result, 'submitFailed');
	    result = deleteIn(result, 'submitSucceeded');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      } else {
	        result = deleteIn(result, 'error');
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'submitErrors');
	      }
	      result = setIn(result, 'submitFailed', true);
	    } else {
	      result = setIn(result, 'submitSucceeded', true);
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'submitErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_FAILED, function (state, _ref21) {
	    var fields = _ref21.meta.fields;
	
	    var result = state;
	    result = setIn(result, 'submitFailed', true);
	    result = deleteIn(result, 'submitSucceeded');
	    result = deleteIn(result, 'submitting');
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    if (fields.length) {
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_SUCCEEDED, function (state) {
	    var result = state;
	    result = deleteIn(result, 'submitFailed');
	    result = setIn(result, 'submitSucceeded', true);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.TOUCH, function (state, _ref22) {
	    var fields = _ref22.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    result = setIn(result, 'anyTouched', true);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UNREGISTER_FIELD, function (state, _ref23) {
	    var _ref23$payload = _ref23.payload,
	        name = _ref23$payload.name,
	        destroyOnUnmount = _ref23$payload.destroyOnUnmount;
	
	    var result = state;
	    var key = 'registeredFields[\'' + name + '\']';
	    var field = getIn(result, key);
	    if (!field) {
	      return result;
	    }
	
	    var count = getIn(field, 'count') - 1;
	    if (count <= 0 && destroyOnUnmount) {
	      result = deleteIn(result, key);
	      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
	        result = deleteIn(result, 'registeredFields');
	      }
	    } else {
	      field = setIn(field, 'count', count);
	      result = setIn(result, key, field);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UNTOUCH, function (state, _ref24) {
	    var fields = _ref24.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = deleteIn(result, 'fields.' + field + '.touched');
	    });
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_ERRORS, function (state, _ref25) {
	    var _ref25$payload = _ref25.payload,
	        syncErrors = _ref25$payload.syncErrors,
	        error = _ref25$payload.error;
	
	    var result = state;
	    if (error) {
	      result = setIn(result, 'error', error);
	      result = setIn(result, 'syncError', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'syncError');
	    }
	    if (Object.keys(syncErrors).length) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    } else {
	      result = deleteIn(result, 'syncErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_WARNINGS, function (state, _ref26) {
	    var _ref26$payload = _ref26.payload,
	        syncWarnings = _ref26$payload.syncWarnings,
	        warning = _ref26$payload.warning;
	
	    var result = state;
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    } else {
	      result = deleteIn(result, 'warning');
	    }
	    if (Object.keys(syncWarnings).length) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    } else {
	      result = deleteIn(result, 'syncWarnings');
	    }
	    return result;
	  }), _behaviors);
	
	  var reducer = function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	    var action = arguments[1];
	
	    var behavior = behaviors[action.type];
	    return behavior ? behavior(state, action) : state;
	  };
	
	  var byForm = function byForm(reducer) {
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var form = action && action.meta && action.meta.form;
	      if (!form) {
	        return state;
	      }
	      if (action.type === _actionTypes.DESTROY) {
	        return action.meta.form.reduce(function (result, form) {
	          return deleteInWithCleanUp(result, form);
	        }, state);
	      }
	      var formState = getIn(state, form);
	      var result = reducer(formState, action);
	      return result === formState ? state : setIn(state, form, result);
	    };
	  };
	
	  /**
	   * Adds additional functionality to the reducer
	   */
	  function decorate(target) {
	    target.plugin = function plugin(reducers) {
	      var _this = this;
	
	      // use 'function' keyword to enable 'this'
	      return decorate(function () {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return Object.keys(reducers).reduce(function (accumulator, key) {
	          var previousState = getIn(accumulator, key);
	          var nextState = reducers[key](previousState, action, getIn(state, key));
	          return nextState === previousState ? accumulator : setIn(accumulator, key, nextState);
	        }, _this(state, action));
	      });
	    };
	
	    return target;
	  }
	
	  return decorate(byForm(reducer));
	};
	
	exports.default = createReducer;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge4 = __webpack_require__(958);
	
	var _merge5 = _interopRequireDefault(_merge4);
	
	var _mapValues2 = __webpack_require__(357);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _hoistNonReactStatics = __webpack_require__(145);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _reactRedux = __webpack_require__(8);
	
	var _redux = __webpack_require__(12);
	
	var _isPromise = __webpack_require__(205);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _getDisplayName = __webpack_require__(1177);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _actions = __webpack_require__(527);
	
	var importedActions = _interopRequireWildcard(_actions);
	
	var _handleSubmit = __webpack_require__(1155);
	
	var _handleSubmit2 = _interopRequireDefault(_handleSubmit);
	
	var _silenceEvent = __webpack_require__(531);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	var _silenceEvents = __webpack_require__(1152);
	
	var _silenceEvents2 = _interopRequireDefault(_silenceEvents);
	
	var _asyncValidation = __webpack_require__(1145);
	
	var _asyncValidation2 = _interopRequireDefault(_asyncValidation);
	
	var _defaultShouldAsyncValidate = __webpack_require__(1148);
	
	var _defaultShouldAsyncValidate2 = _interopRequireDefault(_defaultShouldAsyncValidate);
	
	var _defaultShouldValidate = __webpack_require__(1149);
	
	var _defaultShouldValidate2 = _interopRequireDefault(_defaultShouldValidate);
	
	var _plain = __webpack_require__(75);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _generateValidator2 = __webpack_require__(1154);
	
	var _generateValidator3 = _interopRequireDefault(_generateValidator2);
	
	var _isValid = __webpack_require__(254);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
	};
	
	// extract field-specific actions
	
	var arrayInsert = importedActions.arrayInsert,
	    arrayMove = importedActions.arrayMove,
	    arrayPop = importedActions.arrayPop,
	    arrayPush = importedActions.arrayPush,
	    arrayRemove = importedActions.arrayRemove,
	    arrayRemoveAll = importedActions.arrayRemoveAll,
	    arrayShift = importedActions.arrayShift,
	    arraySplice = importedActions.arraySplice,
	    arraySwap = importedActions.arraySwap,
	    arrayUnshift = importedActions.arrayUnshift,
	    blur = importedActions.blur,
	    change = importedActions.change,
	    focus = importedActions.focus,
	    formActions = _objectWithoutProperties(importedActions, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);
	
	var arrayActions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift
	};
	
	var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(importedActions)), ['array', 'asyncErrors', 'initialized', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);
	
	var checkSubmit = function checkSubmit(submit) {
	  if (!submit || typeof submit !== 'function') {
	    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	  }
	  return submit;
	};
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	var createReduxForm = function createReduxForm(structure) {
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      keys = structure.keys,
	      fromJS = structure.fromJS;
	
	  var isValid = (0, _isValid2.default)(structure);
	  return function (initialConfig) {
	    var config = _extends({
	      touchOnBlur: true,
	      touchOnChange: false,
	      persistentSubmitErrors: false,
	      destroyOnUnmount: true,
	      shouldAsyncValidate: _defaultShouldAsyncValidate2.default,
	      shouldValidate: _defaultShouldValidate2.default,
	      enableReinitialize: false,
	      keepDirtyOnReinitialize: false,
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      },
	      pure: true,
	      forceUnregisterOnUnmount: false
	    }, initialConfig);
	
	    return function (WrappedComponent) {
	      var Form = function (_Component) {
	        _inherits(Form, _Component);
	
	        function Form(props) {
	          _classCallCheck(this, Form);
	
	          var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
	
	          _this.submit = _this.submit.bind(_this);
	          _this.reset = _this.reset.bind(_this);
	          _this.asyncValidate = _this.asyncValidate.bind(_this);
	          _this.getValues = _this.getValues.bind(_this);
	          _this.register = _this.register.bind(_this);
	          _this.unregister = _this.unregister.bind(_this);
	          _this.submitCompleted = _this.submitCompleted.bind(_this);
	          _this.submitFailed = _this.submitFailed.bind(_this);
	          _this.fieldValidators = {};
	          _this.lastFieldValidatorKeys = [];
	          _this.fieldWarners = {};
	          _this.lastFieldWarnerKeys = [];
	          return _this;
	        }
	
	        _createClass(Form, [{
	          key: 'getChildContext',
	          value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	              _reduxForm: _extends({}, this.props, {
	                getFormState: function getFormState(state) {
	                  return getIn(_this2.props.getFormState(state), _this2.props.form);
	                },
	                asyncValidate: this.asyncValidate,
	                getValues: this.getValues,
	                sectionPrefix: undefined,
	                register: this.register,
	                unregister: this.unregister,
	                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
	                  return _this2.innerOnSubmit = innerOnSubmit;
	                }
	              })
	            };
	          }
	        }, {
	          key: 'initIfNeeded',
	          value: function initIfNeeded(nextProps) {
	            var enableReinitialize = this.props.enableReinitialize;
	
	            if (nextProps) {
	              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
	                var keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
	                this.props.initialize(nextProps.initialValues, keepDirty);
	              }
	            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
	              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize);
	            }
	          }
	        }, {
	          key: 'updateSyncErrorsIfNeeded',
	          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError) {
	            var _props = this.props,
	                error = _props.error,
	                syncErrors = _props.syncErrors,
	                updateSyncErrors = _props.updateSyncErrors;
	
	            var noErrors = (!syncErrors || !Object.keys(syncErrors).length) && !error;
	            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
	            if (!(noErrors && nextNoErrors) && (!_plain2.default.deepEqual(syncErrors, nextSyncErrors) || !_plain2.default.deepEqual(error, nextError))) {
	              updateSyncErrors(nextSyncErrors, nextError);
	            }
	          }
	        }, {
	          key: 'submitIfNeeded',
	          value: function submitIfNeeded(nextProps) {
	            var _props2 = this.props,
	                clearSubmit = _props2.clearSubmit,
	                triggerSubmit = _props2.triggerSubmit;
	
	            if (!triggerSubmit && nextProps.triggerSubmit) {
	              clearSubmit();
	              this.submit();
	            }
	          }
	        }, {
	          key: 'validateIfNeeded',
	          value: function validateIfNeeded(nextProps) {
	            var _props3 = this.props,
	                shouldValidate = _props3.shouldValidate,
	                validate = _props3.validate,
	                values = _props3.values;
	
	            var fieldLevelValidate = this.generateValidator();
	            if (validate || fieldLevelValidate) {
	              var initialRender = nextProps === undefined;
	              var fieldValidatorKeys = Object.keys(this.fieldValidators);
	              var shouldValidateResult = shouldValidate({
	                values: values,
	                nextProps: nextProps,
	                props: this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
	                fieldValidatorKeys: fieldValidatorKeys,
	                structure: structure
	              });
	
	              if (shouldValidateResult) {
	                var propsToValidate = initialRender ? this.props : nextProps;
	
	                var _merge2 = (0, _merge5.default)(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
	                    _error = _merge2._error,
	                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);
	
	                this.lastFieldValidatorKeys = fieldValidatorKeys;
	                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error);
	              }
	            }
	          }
	        }, {
	          key: 'updateSyncWarningsIfNeeded',
	          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning) {
	            var _props4 = this.props,
	                warning = _props4.warning,
	                syncWarnings = _props4.syncWarnings,
	                updateSyncWarnings = _props4.updateSyncWarnings;
	
	            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
	            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
	            if (!(noWarnings && nextNoWarnings) && (!_plain2.default.deepEqual(syncWarnings, nextSyncWarnings) || !_plain2.default.deepEqual(warning, nextWarning))) {
	              updateSyncWarnings(nextSyncWarnings, nextWarning);
	            }
	          }
	        }, {
	          key: 'warnIfNeeded',
	          value: function warnIfNeeded(nextProps) {
	            var _props5 = this.props,
	                shouldValidate = _props5.shouldValidate,
	                warn = _props5.warn,
	                values = _props5.values;
	
	            var fieldLevelWarn = this.generateWarner();
	            if (warn || fieldLevelWarn) {
	              var initialRender = nextProps === undefined;
	              var fieldWarnerKeys = Object.keys(this.fieldWarners);
	              var shouldWarnResult = shouldValidate({
	                values: values,
	                nextProps: nextProps,
	                props: this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
	                fieldValidatorKeys: fieldWarnerKeys,
	                structure: structure
	              });
	
	              if (shouldWarnResult) {
	                var propsToWarn = initialRender ? this.props : nextProps;
	
	                var _merge3 = (0, _merge5.default)(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
	                    _warning = _merge3._warning,
	                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);
	
	                this.lastFieldWarnerKeys = fieldWarnerKeys;
	                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning);
	              }
	            }
	          }
	        }, {
	          key: 'componentWillMount',
	          value: function componentWillMount() {
	            this.initIfNeeded();
	            this.validateIfNeeded();
	            this.warnIfNeeded();
	          }
	        }, {
	          key: 'componentWillReceiveProps',
	          value: function componentWillReceiveProps(nextProps) {
	            this.initIfNeeded(nextProps);
	            this.validateIfNeeded(nextProps);
	            this.warnIfNeeded(nextProps);
	            this.submitIfNeeded(nextProps);
	          }
	        }, {
	          key: 'shouldComponentUpdate',
	          value: function shouldComponentUpdate(nextProps) {
	            var _this3 = this;
	
	            if (!config.pure) return true;
	            return Object.keys(nextProps).some(function (prop) {
	              // useful to debug rerenders
	              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	              // }
	              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	            });
	          }
	        }, {
	          key: 'componentWillUnmount',
	          value: function componentWillUnmount() {
	            var _props6 = this.props,
	                destroyOnUnmount = _props6.destroyOnUnmount,
	                destroy = _props6.destroy;
	
	            if (destroyOnUnmount) {
	              this.destroyed = true;
	              destroy();
	            }
	          }
	        }, {
	          key: 'getValues',
	          value: function getValues() {
	            return this.props.values;
	          }
	        }, {
	          key: 'isValid',
	          value: function isValid() {
	            return this.props.valid;
	          }
	        }, {
	          key: 'isPristine',
	          value: function isPristine() {
	            return this.props.pristine;
	          }
	        }, {
	          key: 'register',
	          value: function register(name, type, getValidator, getWarner) {
	            this.props.registerField(name, type);
	            if (getValidator) {
	              this.fieldValidators[name] = getValidator;
	            }
	            if (getWarner) {
	              this.fieldWarners[name] = getWarner;
	            }
	          }
	        }, {
	          key: 'unregister',
	          value: function unregister(name) {
	            if (!this.destroyed) {
	              if (this.props.destroyOnUnmount || this.props.forceUnregisterOnUnmount) {
	                this.props.unregisterField(name);
	                delete this.fieldValidators[name];
	                delete this.fieldWarners[name];
	              } else {
	                this.props.unregisterField(name, false);
	              }
	            }
	          }
	        }, {
	          key: 'getFieldList',
	          value: function getFieldList(options) {
	            var registeredFields = this.props.registeredFields;
	            var list = [];
	            if (!registeredFields) {
	              return list;
	            }
	            var keySeq = keys(registeredFields);
	            if (options && options.excludeFieldArray) {
	              keySeq = keySeq.filter(function (name) {
	                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
	              });
	            }
	            return fromJS(keySeq.reduce(function (acc, key) {
	              acc.push(key);
	              return acc;
	            }, list));
	          }
	        }, {
	          key: 'generateValidator',
	          value: function generateValidator() {
	            var _this4 = this;
	
	            var validators = {};
	            Object.keys(this.fieldValidators).forEach(function (name) {
	              var validator = _this4.fieldValidators[name]();
	              if (validator) {
	                validators[name] = validator;
	              }
	            });
	            return Object.keys(validators).length ? (0, _generateValidator3.default)(validators, structure) : undefined;
	          }
	        }, {
	          key: 'generateWarner',
	          value: function generateWarner() {
	            var _this5 = this;
	
	            var warners = {};
	            Object.keys(this.fieldWarners).forEach(function (name) {
	              var warner = _this5.fieldWarners[name]();
	              if (warner) {
	                warners[name] = warner;
	              }
	            });
	            return Object.keys(warners).length ? (0, _generateValidator3.default)(warners, structure) : undefined;
	          }
	        }, {
	          key: 'asyncValidate',
	          value: function asyncValidate(name, value) {
	            var _this6 = this;
	
	            var _props7 = this.props,
	                asyncBlurFields = _props7.asyncBlurFields,
	                asyncErrors = _props7.asyncErrors,
	                asyncValidate = _props7.asyncValidate,
	                dispatch = _props7.dispatch,
	                initialized = _props7.initialized,
	                pristine = _props7.pristine,
	                shouldAsyncValidate = _props7.shouldAsyncValidate,
	                startAsyncValidation = _props7.startAsyncValidation,
	                stopAsyncValidation = _props7.stopAsyncValidation,
	                syncErrors = _props7.syncErrors,
	                values = _props7.values;
	
	            var submitting = !name;
	            if (asyncValidate) {
	              var _ret = function () {
	                var valuesToValidate = submitting ? values : setIn(values, name, value);
	                var syncValidationPasses = submitting || !getIn(syncErrors, name);
	                var isBlurredField = !submitting && (!asyncBlurFields || ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]')));
	                if ((isBlurredField || submitting) && shouldAsyncValidate({
	                  asyncErrors: asyncErrors,
	                  initialized: initialized,
	                  trigger: submitting ? 'submit' : 'blur',
	                  blurredField: name,
	                  pristine: pristine,
	                  syncValidationPasses: syncValidationPasses
	                })) {
	                  return {
	                    v: (0, _asyncValidation2.default)(function () {
	                      return asyncValidate(valuesToValidate, dispatch, _this6.props, name);
	                    }, startAsyncValidation, stopAsyncValidation, name)
	                  };
	                }
	              }();
	
	              if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	            }
	          }
	        }, {
	          key: 'submitCompleted',
	          value: function submitCompleted(result) {
	            delete this.submitPromise;
	            return result;
	          }
	        }, {
	          key: 'submitFailed',
	          value: function submitFailed(error) {
	            delete this.submitPromise;
	            throw error;
	          }
	        }, {
	          key: 'listenToSubmit',
	          value: function listenToSubmit(promise) {
	            if (!(0, _isPromise2.default)(promise)) {
	              return promise;
	            }
	            this.submitPromise = promise;
	            return promise.then(this.submitCompleted, this.submitFailed);
	          }
	        }, {
	          key: 'submit',
	          value: function submit(submitOrEvent) {
	            var _this7 = this;
	
	            var onSubmit = this.props.onSubmit;
	
	
	            if (!submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent)) {
	              // submitOrEvent is an event: fire submit if not already submitting
	              if (!this.submitPromise) {
	                if (this.innerOnSubmit) {
	                  // will call "submitOrEvent is the submit function" block below
	                  return this.innerOnSubmit();
	                } else {
	                  return this.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(onSubmit), this.props, this.props.validExceptSubmit, this.asyncValidate, this.getFieldList({ excludeFieldArray: true })));
	                }
	              }
	            } else {
	              // submitOrEvent is the submit function: return deferred submit thunk
	              return (0, _silenceEvents2.default)(function () {
	                return !_this7.submitPromise && _this7.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(submitOrEvent), _this7.props, _this7.props.validExceptSubmit, _this7.asyncValidate, _this7.getFieldList({ excludeFieldArray: true })));
	              });
	            }
	          }
	        }, {
	          key: 'reset',
	          value: function reset() {
	            this.props.reset();
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            // remove some redux-form config-only props
	            /* eslint-disable no-unused-vars */
	            var _props8 = this.props,
	                anyTouched = _props8.anyTouched,
	                arrayInsert = _props8.arrayInsert,
	                arrayMove = _props8.arrayMove,
	                arrayPop = _props8.arrayPop,
	                arrayPush = _props8.arrayPush,
	                arrayRemove = _props8.arrayRemove,
	                arrayRemoveAll = _props8.arrayRemoveAll,
	                arrayShift = _props8.arrayShift,
	                arraySplice = _props8.arraySplice,
	                arraySwap = _props8.arraySwap,
	                arrayUnshift = _props8.arrayUnshift,
	                asyncErrors = _props8.asyncErrors,
	                asyncValidate = _props8.asyncValidate,
	                asyncValidating = _props8.asyncValidating,
	                blur = _props8.blur,
	                change = _props8.change,
	                destroy = _props8.destroy,
	                destroyOnUnmount = _props8.destroyOnUnmount,
	                forceUnregisterOnUnmount = _props8.forceUnregisterOnUnmount,
	                dirty = _props8.dirty,
	                dispatch = _props8.dispatch,
	                enableReinitialize = _props8.enableReinitialize,
	                error = _props8.error,
	                focus = _props8.focus,
	                form = _props8.form,
	                getFormState = _props8.getFormState,
	                initialize = _props8.initialize,
	                initialized = _props8.initialized,
	                initialValues = _props8.initialValues,
	                invalid = _props8.invalid,
	                keepDirtyOnReinitialize = _props8.keepDirtyOnReinitialize,
	                pristine = _props8.pristine,
	                propNamespace = _props8.propNamespace,
	                registeredFields = _props8.registeredFields,
	                registerField = _props8.registerField,
	                reset = _props8.reset,
	                setSubmitFailed = _props8.setSubmitFailed,
	                setSubmitSucceeded = _props8.setSubmitSucceeded,
	                shouldAsyncValidate = _props8.shouldAsyncValidate,
	                shouldValidate = _props8.shouldValidate,
	                startAsyncValidation = _props8.startAsyncValidation,
	                startSubmit = _props8.startSubmit,
	                stopAsyncValidation = _props8.stopAsyncValidation,
	                stopSubmit = _props8.stopSubmit,
	                submitting = _props8.submitting,
	                submitFailed = _props8.submitFailed,
	                submitSucceeded = _props8.submitSucceeded,
	                touch = _props8.touch,
	                touchOnBlur = _props8.touchOnBlur,
	                touchOnChange = _props8.touchOnChange,
	                persistentSubmitErrors = _props8.persistentSubmitErrors,
	                syncErrors = _props8.syncErrors,
	                syncWarnings = _props8.syncWarnings,
	                unregisterField = _props8.unregisterField,
	                untouch = _props8.untouch,
	                updateSyncErrors = _props8.updateSyncErrors,
	                updateSyncWarnings = _props8.updateSyncWarnings,
	                valid = _props8.valid,
	                validExceptSubmit = _props8.validExceptSubmit,
	                values = _props8.values,
	                warning = _props8.warning,
	                rest = _objectWithoutProperties(_props8, ['anyTouched', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
	            /* eslint-enable no-unused-vars */
	
	
	            var reduxFormProps = _extends({
	              anyTouched: anyTouched,
	              asyncValidate: this.asyncValidate,
	              asyncValidating: asyncValidating
	            }, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch), {
	              destroy: destroy,
	              dirty: dirty,
	              dispatch: dispatch,
	              error: error,
	              form: form,
	              handleSubmit: this.submit,
	              initialize: initialize,
	              initialized: initialized,
	              initialValues: initialValues,
	              invalid: invalid,
	              pristine: pristine,
	              reset: reset,
	              submitting: submitting,
	              submitFailed: submitFailed,
	              submitSucceeded: submitSucceeded,
	              touch: touch,
	              untouch: untouch,
	              valid: valid,
	              warning: warning
	            });
	            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
	            if (isClassComponent(WrappedComponent)) {
	              propsToPass.ref = 'wrapped';
	            }
	            return (0, _react.createElement)(WrappedComponent, propsToPass);
	          }
	        }]);
	
	        return Form;
	      }(_react.Component);
	
	      Form.displayName = 'Form(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	      Form.WrappedComponent = WrappedComponent;
	      Form.childContextTypes = {
	        _reduxForm: _react.PropTypes.object.isRequired
	      };
	      Form.propTypes = {
	        destroyOnUnmount: _react.PropTypes.bool,
	        forceUnregisterOnUnmount: _react.PropTypes.bool,
	        form: _react.PropTypes.string.isRequired,
	        initialValues: _react.PropTypes.object,
	        getFormState: _react.PropTypes.func,
	        onSubmitFail: _react.PropTypes.func,
	        onSubmitSuccess: _react.PropTypes.func,
	        propNameSpace: _react.PropTypes.string,
	        validate: _react.PropTypes.func,
	        warn: _react.PropTypes.func,
	        touchOnBlur: _react.PropTypes.bool,
	        touchOnChange: _react.PropTypes.bool,
	        triggerSubmit: _react.PropTypes.bool,
	        persistentSubmitErrors: _react.PropTypes.bool,
	        registeredFields: _react.PropTypes.any
	      };
	
	      var connector = (0, _reactRedux.connect)(function (state, props) {
	        var form = props.form,
	            getFormState = props.getFormState,
	            initialValues = props.initialValues,
	            enableReinitialize = props.enableReinitialize,
	            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;
	
	        var formState = getIn(getFormState(state) || empty, form) || empty;
	        var stateInitial = getIn(formState, 'initial');
	        var initialized = !!stateInitial;
	
	        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
	        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;
	
	        var initial = initialValues || stateInitial || empty;
	
	        if (shouldUpdateInitialValues) {
	          initial = stateInitial || empty;
	        }
	
	        var values = getIn(formState, 'values') || initial;
	
	        if (shouldResetValues) {
	          values = initial;
	        }
	
	        var pristine = shouldResetValues || deepEqual(initial, values);
	        var asyncErrors = getIn(formState, 'asyncErrors');
	        var syncErrors = getIn(formState, 'syncErrors') || {};
	        var syncWarnings = getIn(formState, 'syncWarnings') || {};
	        var registeredFields = getIn(formState, 'registeredFields');
	        var valid = isValid(form, getFormState, false)(state);
	        var validExceptSubmit = isValid(form, getFormState, true)(state);
	        var anyTouched = !!getIn(formState, 'anyTouched');
	        var submitting = !!getIn(formState, 'submitting');
	        var submitFailed = !!getIn(formState, 'submitFailed');
	        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
	        var error = getIn(formState, 'error');
	        var warning = getIn(formState, 'warning');
	        var triggerSubmit = getIn(formState, 'triggerSubmit');
	        return {
	          anyTouched: anyTouched,
	          asyncErrors: asyncErrors,
	          asyncValidating: getIn(formState, 'asyncValidating') || false,
	          dirty: !pristine,
	          error: error,
	          initialized: initialized,
	          invalid: !valid,
	          pristine: pristine,
	          registeredFields: registeredFields,
	          submitting: submitting,
	          submitFailed: submitFailed,
	          submitSucceeded: submitSucceeded,
	          syncErrors: syncErrors,
	          syncWarnings: syncWarnings,
	          triggerSubmit: triggerSubmit,
	          values: values,
	          valid: valid,
	          validExceptSubmit: validExceptSubmit,
	          warning: warning
	        };
	      }, function (dispatch, initialProps) {
	        var bindForm = function bindForm(actionCreator) {
	          return actionCreator.bind(null, initialProps.form);
	        };
	
	        // Bind the first parameter on `props.form`
	        var boundFormACs = (0, _mapValues3.default)(formActions, bindForm);
	        var boundArrayACs = (0, _mapValues3.default)(arrayActions, bindForm);
	        var boundBlur = function boundBlur(field, value) {
	          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
	        };
	        var boundChange = function boundChange(field, value) {
	          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
	        };
	        var boundFocus = bindForm(focus);
	
	        // Wrap action creators with `dispatch`
	        var connectedFormACs = (0, _redux.bindActionCreators)(boundFormACs, dispatch);
	        var connectedArrayACs = {
	          insert: (0, _redux.bindActionCreators)(boundArrayACs.arrayInsert, dispatch),
	          move: (0, _redux.bindActionCreators)(boundArrayACs.arrayMove, dispatch),
	          pop: (0, _redux.bindActionCreators)(boundArrayACs.arrayPop, dispatch),
	          push: (0, _redux.bindActionCreators)(boundArrayACs.arrayPush, dispatch),
	          remove: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemove, dispatch),
	          removeAll: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemoveAll, dispatch),
	          shift: (0, _redux.bindActionCreators)(boundArrayACs.arrayShift, dispatch),
	          splice: (0, _redux.bindActionCreators)(boundArrayACs.arraySplice, dispatch),
	          swap: (0, _redux.bindActionCreators)(boundArrayACs.arraySwap, dispatch),
	          unshift: (0, _redux.bindActionCreators)(boundArrayACs.arrayUnshift, dispatch)
	        };
	
	        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
	          blur: boundBlur,
	          change: boundChange,
	          array: connectedArrayACs,
	          focus: boundFocus,
	          dispatch: dispatch
	        });
	
	        return function () {
	          return computedActions;
	        };
	      }, undefined, { withRef: true });
	      var ConnectedForm = (0, _hoistNonReactStatics2.default)(connector(Form), WrappedComponent);
	      ConnectedForm.defaultProps = config;
	
	      // build outer component to expose instance api
	      return function (_Component2) {
	        _inherits(ReduxForm, _Component2);
	
	        function ReduxForm() {
	          _classCallCheck(this, ReduxForm);
	
	          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
	        }
	
	        _createClass(ReduxForm, [{
	          key: 'submit',
	          value: function submit() {
	            return this.refs.wrapped.getWrappedInstance().submit();
	          }
	        }, {
	          key: 'reset',
	          value: function reset() {
	            return this.refs.wrapped.getWrappedInstance().reset();
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            var _props9 = this.props,
	                initialValues = _props9.initialValues,
	                rest = _objectWithoutProperties(_props9, ['initialValues']);
	
	            return (0, _react.createElement)(ConnectedForm, _extends({}, rest, {
	              ref: 'wrapped',
	              // convert initialValues if need to
	              initialValues: fromJS(initialValues)
	            }));
	          }
	        }, {
	          key: 'valid',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().isValid();
	          }
	        }, {
	          key: 'invalid',
	          get: function get() {
	            return !this.valid;
	          }
	        }, {
	          key: 'pristine',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().isPristine();
	          }
	        }, {
	          key: 'dirty',
	          get: function get() {
	            return !this.pristine;
	          }
	        }, {
	          key: 'values',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().getValues();
	          }
	        }, {
	          key: 'fieldList',
	          get: function get() {
	            // mainly provided for testing
	            return this.refs.wrapped.getWrappedInstance().getFieldList();
	          }
	        }, {
	          key: 'wrappedInstance',
	          get: function get() {
	            // for testine
	            return this.refs.wrapped.getWrappedInstance().refs.wrapped;
	          }
	        }]);
	
	        return ReduxForm;
	      }(_react.Component);
	    };
	  };
	};
	
	exports.default = createReduxForm;

/***/ },
/* 1161 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.asyncErrors');
	    };
	  };
	};
	
	exports.default = createGetFormAsyncErrors;

/***/ },
/* 1162 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.initial');
	    };
	  };
	};
	
	exports.default = createGetFormInitialValues;

/***/ },
/* 1163 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.submitErrors');
	    };
	  };
	};
	
	exports.default = createGetFormSubmitErrors;

/***/ },
/* 1164 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.syncErrors');
	    };
	  };
	};
	
	exports.default = createGetFormSyncErrors;

/***/ },
/* 1165 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormValues = function createGetFormValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.values');
	    };
	  };
	};
	
	exports.default = createGetFormValues;

/***/ },
/* 1166 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      var formState = getFormState(state);
	      return getIn(formState, form + '.submitFailed') || false;
	    };
	  };
	};
	
	exports.default = createHasSubmitFailed;

/***/ },
/* 1167 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      var formState = getFormState(state);
	      return getIn(formState, form + '.submitSucceeded') || false;
	    };
	  };
	};
	
	exports.default = createHasSubmitSucceeded;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPristine = __webpack_require__(532);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsDirty = function createIsDirty(structure) {
	  return function (form, getFormState) {
	    var isPristine = (0, _isPristine2.default)(structure)(form, getFormState);
	    return function (state) {
	      return !isPristine(state);
	    };
	  };
	};
	
	exports.default = createIsDirty;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isValid = __webpack_require__(254);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsInvalid = function createIsInvalid(structure) {
	  return function (form, getFormState) {
	    var isValid = (0, _isValid2.default)(structure)(form, getFormState);
	    return function (state) {
	      return !isValid(state);
	    };
	  };
	};
	
	exports.default = createIsInvalid;

/***/ },
/* 1170 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createIsSubmitting = function createIsSubmitting(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      var formState = getFormState(state);
	      return getIn(formState, form + '.submitting') || false;
	    };
	  };
	};
	
	exports.default = createIsSubmitting;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(356);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(obj, other) {
	  if (obj === other) return true;
	  if ((obj == null || obj === '' || obj === false) && (other == null || other === '' || other === false)) return true;
	
	  if (obj && other && obj._error !== other._error) return false;
	  if (obj && other && obj._warning !== other._warning) return false;
	};
	
	var deepEqual = function deepEqual(a, b) {
	  return (0, _isEqualWith3.default)(a, b, customizer);
	};
	
	exports.default = deepEqual;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(156);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var deleteInWithPath = function deleteInWithPath(state, first) {
	  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    rest[_key - 2] = arguments[_key];
	  }
	
	  if (state === undefined || first === undefined) {
	    return state;
	  }
	  if (rest.length) {
	    if (Array.isArray(state)) {
	      if (first < state.length) {
	        var result = deleteInWithPath.apply(undefined, [state && state[first]].concat(rest));
	        if (result !== state[first]) {
	          var copy = [].concat(_toConsumableArray(state));
	          copy[first] = result;
	          return copy;
	        }
	      }
	      return state;
	    }
	    if (first in state) {
	      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(rest));
	      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
	    }
	    return state;
	  }
	  if (Array.isArray(state)) {
	    if (isNaN(first)) {
	      throw new Error('Cannot delete non-numerical index from an array');
	    }
	    if (first < state.length) {
	      var _copy = [].concat(_toConsumableArray(state));
	      _copy.splice(first, 1);
	      return _copy;
	    }
	    return state;
	  }
	  if (first in state) {
	    var _copy2 = _extends({}, state);
	    delete _copy2[first];
	    return _copy2;
	  }
	  return state;
	};
	
	var deleteIn = function deleteIn(state, field) {
	  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray((0, _toPath3.default)(field))));
	};
	
	exports.default = deleteIn;

/***/ },
/* 1173 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var keys = function keys(value) {
	  return value ? Object.keys(value) : [];
	};
	
	exports.default = keys;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(156);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
	  if (pathIndex >= path.length) {
	    return value;
	  }
	
	  var first = path[pathIndex];
	  var next = setInWithPath(state && state[first], value, path, pathIndex + 1);
	
	  if (!state) {
	    var initialized = isNaN(first) ? {} : [];
	    initialized[first] = next;
	    return initialized;
	  }
	
	  if (Array.isArray(state)) {
	    var copy = [].concat(state);
	    copy[first] = next;
	    return copy;
	  }
	
	  return _extends({}, state, _defineProperty({}, first, next));
	};
	
	var setIn = function setIn(state, field, value) {
	  return setInWithPath(state, value, (0, _toPath3.default)(field), 0);
	};
	
	exports.default = setIn;

/***/ },
/* 1175 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var splice = function splice(array, index, removeNum, value) {
	  array = array || [];
	
	  if (index < array.length) {
	    if (value === undefined && !removeNum) {
	      // inserting undefined
	      var _copy2 = [].concat(_toConsumableArray(array));
	      _copy2.splice(index, 0, null);
	      _copy2[index] = undefined;
	      return _copy2;
	    }
	    if (value != null) {
	      var _copy3 = [].concat(_toConsumableArray(array));
	      _copy3.splice(index, removeNum, value); // removing and adding
	      return _copy3;
	    }
	    var _copy = [].concat(_toConsumableArray(array));
	    _copy.splice(index, removeNum); // removing
	    return _copy;
	  }
	  if (removeNum) {
	    // trying to remove non-existant item: return original array
	    return array;
	  }
	  // trying to add outside of range: just set value
	  var copy = [].concat(_toConsumableArray(array));
	  copy[index] = value;
	  return copy;
	};
	
	exports.default = splice;

/***/ },
/* 1176 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var dataKey = exports.dataKey = 'text';

/***/ },
/* 1177 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDisplayName = function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__(8);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var createValues = function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (config) {
	    var _prop$getFormState$co = _extends({
	      prop: 'values',
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      }
	    }, config),
	        form = _prop$getFormState$co.form,
	        prop = _prop$getFormState$co.prop,
	        getFormState = _prop$getFormState$co.getFormState;
	
	    return (0, _reactRedux.connect)(function (state) {
	      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
	    }, function () {
	      return {};
	    } // ignore dispatch
	    );
	  };
	};
	
	exports.default = createValues;

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = immutableStateInvariantMiddleware;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _jsonStringifySafe = __webpack_require__(852);
	
	var _jsonStringifySafe2 = _interopRequireDefault(_jsonStringifySafe);
	
	var _isImmutable = __webpack_require__(1180);
	
	var _isImmutable2 = _interopRequireDefault(_isImmutable);
	
	var _trackForMutations = __webpack_require__(1181);
	
	var _trackForMutations2 = _interopRequireDefault(_trackForMutations);
	
	var BETWEEN_DISPATCHES_MESSAGE = ['A state mutation was detected between dispatches, in the path `%s`.', 'This may cause incorrect behavior.', '(http://redux.js.org/docs/Troubleshooting.html#never-mutate-reducer-arguments)'].join(' ');
	
	var INSIDE_DISPATCH_MESSAGE = ['A state mutation was detected inside a dispatch, in the path: `%s`.', 'Take a look at the reducer(s) handling the action %s.', '(http://redux.js.org/docs/Troubleshooting.html#never-mutate-reducer-arguments)'].join(' ');
	
	function immutableStateInvariantMiddleware() {
	  var isImmutable = arguments.length <= 0 || arguments[0] === undefined ? _isImmutable2['default'] : arguments[0];
	
	  var track = _trackForMutations2['default'].bind(null, isImmutable);
	
	  return function (_ref) {
	    var getState = _ref.getState;
	
	    var state = getState();
	    var tracker = track(state);
	
	    var result = undefined;
	    return function (next) {
	      return function (action) {
	        state = getState();
	
	        result = tracker.detectMutations();
	        // Track before potentially not meeting the invariant
	        tracker = track(state);
	
	        (0, _invariant2['default'])(!result.wasMutated, BETWEEN_DISPATCHES_MESSAGE, (result.path || []).join('.'));
	
	        var dispatchedAction = next(action);
	        state = getState();
	
	        result = tracker.detectMutations();
	        // Track before potentially not meeting the invariant
	        tracker = track(state);
	
	        (0, _invariant2['default'])(!result.wasMutated, INSIDE_DISPATCH_MESSAGE, (result.path || []).join('.'), (0, _jsonStringifySafe2['default'])(action));
	
	        return dispatchedAction;
	      };
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 1180 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = isImmutableDefault;
	
	function isImmutableDefault(value) {
	  return typeof value !== 'object' || value === null || typeof value === 'undefined';
	}
	
	module.exports = exports['default'];

/***/ },
/* 1181 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = trackForMutations;
	
	function trackForMutations(isImmutable, obj) {
	  var trackedProperties = trackProperties(isImmutable, obj);
	  return {
	    detectMutations: function detectMutations() {
	      return _detectMutations(isImmutable, trackedProperties, obj);
	    }
	  };
	}
	
	function trackProperties(isImmutable, obj) {
	  var tracked = { value: obj };
	
	  if (!isImmutable(obj)) {
	    tracked.children = {};
	
	    for (var key in obj) {
	      tracked.children[key] = trackProperties(isImmutable, obj[key]);
	    }
	  }
	  return tracked;
	}
	
	function _detectMutations(isImmutable, trackedProperty, obj) {
	  var sameParentRef = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	  var path = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	
	  var prevObj = trackedProperty ? trackedProperty.value : undefined;
	
	  var sameRef = prevObj === obj;
	
	  if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
	    return { wasMutated: true, path: path };
	  }
	
	  if (isImmutable(prevObj) || isImmutable(obj)) {
	    return { wasMutated: false };
	  }
	
	  // Gather all keys from prev (tracked) and after objs
	  var keysToDetect = {};
	  Object.keys(trackedProperty.children).forEach(function (key) {
	    keysToDetect[key] = true;
	  });
	  Object.keys(obj).forEach(function (key) {
	    keysToDetect[key] = true;
	  });
	
	  var keys = Object.keys(keysToDetect);
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var result = _detectMutations(isImmutable, trackedProperty.children[key], obj[key], sameRef, path.concat(key));
	
	    if (result.wasMutated) {
	      return result;
	    }
	  }
	  return { wasMutated: false };
	}
	module.exports = exports["default"];

/***/ },
/* 1182 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch;
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(534);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 1184 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(535);
	
	var _isPlainObject = __webpack_require__(117);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(536);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  if (false) {
	    var unexpectedKeyCache = {};
	  }
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 1186 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1187 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1189);


/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1190);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(92)(module)))

/***/ },
/* 1190 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 1191 */
/***/ function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  return  bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	module.exports = bytesToUuid;


/***/ },
/* 1192 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	var rng;
	
	var crypto = global.crypto || global.msCrypto; // for IE 11
	if (crypto && crypto.getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16);
	  rng = function whatwgRNG() {
	    crypto.getRandomValues(rnds8);
	    return rnds8;
	  };
	}
	
	if (!rng) {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var  rnds = new Array(16);
	  rng = function() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}
	
	module.exports = rng;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(1192);
	var bytesToUuid = __webpack_require__(1191);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options == 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ },
/* 1194 */
53,
/* 1195 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(__webpack_module_template_argument_0__);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _components = __webpack_require__(__webpack_module_template_argument_1__);
	
	var components = _interopRequireWildcard(_components);
	
	var _constants = __webpack_require__(__webpack_module_template_argument_2__);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _reducer = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _selectors = __webpack_require__(__webpack_module_template_argument_4__);
	
	var selectors = _interopRequireWildcard(_selectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = { actions: actions, components: components, constants: constants, reducer: _reducer2.default, selectors: selectors };

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _components = __webpack_require__(__webpack_module_template_argument_0__);
	
	var components = _interopRequireWildcard(_components);
	
	var _constants = __webpack_require__(__webpack_module_template_argument_1__);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _reducer = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = { components: components, constants: constants, reducer: _reducer2.default };

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** main.1b22f42eedf800aa367f.js
 **/